var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

/*! For license information please see zoomus-websdk-embedded.umd.min.js.LICENSE.txt */
!function (e, t) {
  "object" === typeof exports && "object" === typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" === typeof define && define.amd ? define(["react", "react-dom"], t) : "object" === typeof exports ? exports["@zoomus/websdk"] = t(require("react"), require("react-dom")) : e["@zoomus/websdk"] = t(e[void 0], e[void 0]);
}(self, function (__WEBPACK_EXTERNAL_MODULE__45840__, __WEBPACK_EXTERNAL_MODULE__78768__) {
  return function () {
    var __webpack_modules__ = {
      35859: function _(e, t, n) {
        var r = n(48764).Buffer;

        e.exports = function (e, t) {
          "use strict";

          var _oa, _ya, _Sa, _Ea, _Ia, _ts, _is, _ss, _ls, _fs, _ys, _Ss, _ur, _ur2, _ur3, _ur4, _ur5, _ur6, _ur7, _ur8, _ur9, _ur10, _ur11, _ur12, _ur13, _xH;

          function i(e) {
            return e && "object" == typeof e && "default" in e ? e : {
              default: e
            };
          }

          function o(e) {
            if (e && e.__esModule) return e;
            var t = Object.create(null);
            return e && Object.keys(e).forEach(function (n) {
              if ("default" !== n) {
                var r = Object.getOwnPropertyDescriptor(e, n);
                Object.defineProperty(t, n, r.get ? r : {
                  enumerable: !0,
                  get: function get() {
                    return e[n];
                  }
                });
              }
            }), t.default = e, Object.freeze(t);
          }

          var a = i(e),
              s = o(e),
              c = o(t),
              l = i(t);

          function d(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function u(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? d(Object(n), !0).forEach(function (t) {
                p(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function p(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          function h(e, t) {
            if (null == e) return {};

            var n,
                r,
                i = function (e, t) {
              if (null == e) return {};
              var n,
                  r,
                  i = {},
                  o = Object.keys(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
              }

              return i;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
              }
            }

            return i;
          }

          function _(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function f(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? _(Object(n), !0).forEach(function (t) {
                m(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function m(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          function g(e, t) {
            if (null == e) return {};

            var n,
                r,
                i = function (e, t) {
              if (null == e) return {};
              var n,
                  r,
                  i = {},
                  o = Object.keys(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
              }

              return i;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
              }
            }

            return i;
          }

          function v(e, t, n, r, i) {
            var o = {};
            return Object.keys(r).forEach(function (e) {
              o[e] = r[e];
            }), o.enumerable = !!o.enumerable, o.configurable = !!o.configurable, ("value" in o || o.initializer) && (o.writable = !0), o = n.slice().reverse().reduce(function (n, r) {
              return r(e, t, n) || n;
            }, o), i && void 0 !== o.initializer && (o.value = o.initializer ? o.initializer.call(i) : void 0, o.initializer = void 0), void 0 === o.initializer && (Object.defineProperty(e, t, o), o = null), o;
          }

          function b(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          function y(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function w(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? y(Object(n), !0).forEach(function (t) {
                b(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function S(e) {
            return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
          }

          var x = "function" == typeof Symbol && Symbol.observable || "@@observable",
              E = function E() {
            return Math.random().toString(36).substring(7).split("").join(".");
          },
              C = {
            INIT: "@@redux/INIT" + E(),
            REPLACE: "@@redux/REPLACE" + E(),
            PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
              return "@@redux/PROBE_UNKNOWN_ACTION" + E();
            }
          };

          function k(e) {
            if ("object" != typeof e || null === e) return !1;

            for (var t = e; null !== Object.getPrototypeOf(t);) {
              t = Object.getPrototypeOf(t);
            }

            return Object.getPrototypeOf(e) === t;
          }

          function A(e, t, n) {
            var r;
            if ("function" == typeof t && "function" == typeof n || "function" == typeof n && "function" == typeof arguments[3]) throw new Error(S(0));

            if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
              if ("function" != typeof n) throw new Error(S(1));
              return n(A)(e, t);
            }

            if ("function" != typeof e) throw new Error(S(2));
            var i = e,
                o = t,
                a = [],
                s = a,
                c = !1;

            function l() {
              s === a && (s = a.slice());
            }

            function d() {
              if (c) throw new Error(S(3));
              return o;
            }

            function u(e) {
              if ("function" != typeof e) throw new Error(S(4));
              if (c) throw new Error(S(5));
              var t = !0;
              return l(), s.push(e), function () {
                if (t) {
                  if (c) throw new Error(S(6));
                  t = !1, l();
                  var n = s.indexOf(e);
                  s.splice(n, 1), a = null;
                }
              };
            }

            function p(e) {
              if (!k(e)) throw new Error(S(7));
              if (void 0 === e.type) throw new Error(S(8));
              if (c) throw new Error(S(9));

              try {
                c = !0, o = i(o, e);
              } finally {
                c = !1;
              }

              for (var t = a = s, n = 0; n < t.length; n++) {
                (0, t[n])();
              }

              return e;
            }

            function h(e) {
              if ("function" != typeof e) throw new Error(S(10));
              i = e, p({
                type: C.REPLACE
              });
            }

            function _() {
              var e,
                  t = u;
              return (e = {
                subscribe: function subscribe(e) {
                  if ("object" != typeof e || null === e) throw new Error(S(11));

                  function n() {
                    e.next && e.next(d());
                  }

                  return n(), {
                    unsubscribe: t(n)
                  };
                }
              })[x] = function () {
                return this;
              }, e;
            }

            return p({
              type: C.INIT
            }), (r = {
              dispatch: p,
              subscribe: u,
              getState: d,
              replaceReducer: h
            })[x] = _, r;
          }

          function I() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return 0 === t.length ? function (e) {
              return e;
            } : 1 === t.length ? t[0] : t.reduce(function (e, t) {
              return function () {
                return e(t.apply(void 0, arguments));
              };
            });
          }

          var _T2 = function T(e, t) {
            return (_T2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) {
                t.hasOwnProperty(n) && (e[n] = t[n]);
              }
            })(e, t);
          };

          function O(e, t) {
            function n() {
              this.constructor = e;
            }

            _T2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }

          function R(e) {
            return "function" == typeof e;
          }

          var N = !1,
              P = {
            Promise: void 0,

            set useDeprecatedSynchronousErrorHandling(e) {
              if (e) {
                var t = new Error();
                console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + t.stack);
              } else N && console.log("RxJS: Back to a better error behavior. Thank you. <3");

              N = e;
            },

            get useDeprecatedSynchronousErrorHandling() {
              return N;
            }

          };

          function j(e) {
            setTimeout(function () {
              throw e;
            }, 0);
          }

          var D = {
            closed: !0,
            next: function next(e) {},
            error: function error(e) {
              if (P.useDeprecatedSynchronousErrorHandling) throw e;
              j(e);
            },
            complete: function complete() {}
          },
              z = Array.isArray || function (e) {
            return e && "number" == typeof e.length;
          };

          function M(e) {
            return null !== e && "object" == typeof e;
          }

          var L = function () {
            function e(e) {
              return Error.call(this), this.message = e ? e.length + " errors occurred during unsubscription:\n" + e.map(function (e, t) {
                return t + 1 + ") " + e.toString();
              }).join("\n  ") : "", this.name = "UnsubscriptionError", this.errors = e, this;
            }

            return e.prototype = Object.create(Error.prototype), e;
          }(),
              U = function () {
            function e(e) {
              this.closed = !1, this._parentOrParents = null, this._subscriptions = null, e && (this._ctorUnsubscribe = !0, this._unsubscribe = e);
            }

            return e.prototype.unsubscribe = function () {
              var t;

              if (!this.closed) {
                var n = this._parentOrParents,
                    r = this._ctorUnsubscribe,
                    i = this._unsubscribe,
                    o = this._subscriptions;
                if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, n instanceof e) n.remove(this);else if (null !== n) for (var a = 0; a < n.length; ++a) {
                  n[a].remove(this);
                }

                if (R(i)) {
                  r && (this._unsubscribe = void 0);

                  try {
                    i.call(this);
                  } catch (e) {
                    t = e instanceof L ? B(e.errors) : [e];
                  }
                }

                if (z(o)) {
                  a = -1;

                  for (var s = o.length; ++a < s;) {
                    var c = o[a];
                    if (M(c)) try {
                      c.unsubscribe();
                    } catch (e) {
                      t = t || [], e instanceof L ? t = t.concat(B(e.errors)) : t.push(e);
                    }
                  }
                }

                if (t) throw new L(t);
              }
            }, e.prototype.add = function (t) {
              var n = t;
              if (!t) return e.EMPTY;

              switch (typeof t) {
                case "function":
                  n = new e(t);

                case "object":
                  if (n === this || n.closed || "function" != typeof n.unsubscribe) return n;
                  if (this.closed) return n.unsubscribe(), n;

                  if (!(n instanceof e)) {
                    var r = n;
                    (n = new e())._subscriptions = [r];
                  }

                  break;

                default:
                  throw new Error("unrecognized teardown " + t + " added to Subscription.");
              }

              var i = n._parentOrParents;
              if (null === i) n._parentOrParents = this;else if (i instanceof e) {
                if (i === this) return n;
                n._parentOrParents = [i, this];
              } else {
                if (-1 !== i.indexOf(this)) return n;
                i.push(this);
              }
              var o = this._subscriptions;
              return null === o ? this._subscriptions = [n] : o.push(n), n;
            }, e.prototype.remove = function (e) {
              var t = this._subscriptions;

              if (t) {
                var n = t.indexOf(e);
                -1 !== n && t.splice(n, 1);
              }
            }, e.EMPTY = function (e) {
              return e.closed = !0, e;
            }(new e()), e;
          }();

          function B(e) {
            return e.reduce(function (e, t) {
              return e.concat(t instanceof L ? t.errors : t);
            }, []);
          }

          var H = "function" == typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random(),
              V = function (e) {
            function t(n, r, i) {
              var o = e.call(this) || this;

              switch (o.syncErrorValue = null, o.syncErrorThrown = !1, o.syncErrorThrowable = !1, o.isStopped = !1, arguments.length) {
                case 0:
                  o.destination = D;
                  break;

                case 1:
                  if (!n) {
                    o.destination = D;
                    break;
                  }

                  if ("object" == typeof n) {
                    n instanceof t ? (o.syncErrorThrowable = n.syncErrorThrowable, o.destination = n, n.add(o)) : (o.syncErrorThrowable = !0, o.destination = new q(o, n));
                    break;
                  }

                default:
                  o.syncErrorThrowable = !0, o.destination = new q(o, n, r, i);
              }

              return o;
            }

            return O(t, e), t.prototype[H] = function () {
              return this;
            }, t.create = function (e, n, r) {
              var i = new t(e, n, r);
              return i.syncErrorThrowable = !1, i;
            }, t.prototype.next = function (e) {
              this.isStopped || this._next(e);
            }, t.prototype.error = function (e) {
              this.isStopped || (this.isStopped = !0, this._error(e));
            }, t.prototype.complete = function () {
              this.isStopped || (this.isStopped = !0, this._complete());
            }, t.prototype.unsubscribe = function () {
              this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this));
            }, t.prototype._next = function (e) {
              this.destination.next(e);
            }, t.prototype._error = function (e) {
              this.destination.error(e), this.unsubscribe();
            }, t.prototype._complete = function () {
              this.destination.complete(), this.unsubscribe();
            }, t.prototype._unsubscribeAndRecycle = function () {
              var e = this._parentOrParents;
              return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = e, this;
            }, t;
          }(U),
              q = function (e) {
            function t(t, n, r, i) {
              var o,
                  a = e.call(this) || this;
              a._parentSubscriber = t;
              var s = a;
              return R(n) ? o = n : n && (o = n.next, r = n.error, i = n.complete, n !== D && (R((s = Object.create(n)).unsubscribe) && a.add(s.unsubscribe.bind(s)), s.unsubscribe = a.unsubscribe.bind(a))), a._context = s, a._next = o, a._error = r, a._complete = i, a;
            }

            return O(t, e), t.prototype.next = function (e) {
              if (!this.isStopped && this._next) {
                var t = this._parentSubscriber;
                P.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? this.__tryOrSetError(t, this._next, e) && this.unsubscribe() : this.__tryOrUnsub(this._next, e);
              }
            }, t.prototype.error = function (e) {
              if (!this.isStopped) {
                var t = this._parentSubscriber,
                    n = P.useDeprecatedSynchronousErrorHandling;
                if (this._error) n && t.syncErrorThrowable ? (this.__tryOrSetError(t, this._error, e), this.unsubscribe()) : (this.__tryOrUnsub(this._error, e), this.unsubscribe());else if (t.syncErrorThrowable) n ? (t.syncErrorValue = e, t.syncErrorThrown = !0) : j(e), this.unsubscribe();else {
                  if (this.unsubscribe(), n) throw e;
                  j(e);
                }
              }
            }, t.prototype.complete = function () {
              var e = this;

              if (!this.isStopped) {
                var t = this._parentSubscriber;

                if (this._complete) {
                  var n = function n() {
                    return e._complete.call(e._context);
                  };

                  P.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? (this.__tryOrSetError(t, n), this.unsubscribe()) : (this.__tryOrUnsub(n), this.unsubscribe());
                } else this.unsubscribe();
              }
            }, t.prototype.__tryOrUnsub = function (e, t) {
              try {
                e.call(this._context, t);
              } catch (e) {
                if (this.unsubscribe(), P.useDeprecatedSynchronousErrorHandling) throw e;
                j(e);
              }
            }, t.prototype.__tryOrSetError = function (e, t, n) {
              if (!P.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");

              try {
                t.call(this._context, n);
              } catch (t) {
                return P.useDeprecatedSynchronousErrorHandling ? (e.syncErrorValue = t, e.syncErrorThrown = !0, !0) : (j(t), !0);
              }

              return !1;
            }, t.prototype._unsubscribe = function () {
              var e = this._parentSubscriber;
              this._context = null, this._parentSubscriber = null, e.unsubscribe();
            }, t;
          }(V),
              F = "function" == typeof Symbol && Symbol.observable || "@@observable";

          function W(e) {
            return e;
          }

          function G() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            return K(e);
          }

          function K(e) {
            return 0 === e.length ? W : 1 === e.length ? e[0] : function (t) {
              return e.reduce(function (e, t) {
                return t(e);
              }, t);
            };
          }

          var Q = function () {
            function e(e) {
              this._isScalar = !1, e && (this._subscribe = e);
            }

            return e.prototype.lift = function (t) {
              var n = new e();
              return n.source = this, n.operator = t, n;
            }, e.prototype.subscribe = function (e, t, n) {
              var r = this.operator,
                  i = function (e, t, n) {
                if (e) {
                  if (e instanceof V) return e;
                  if (e[H]) return e[H]();
                }

                return e || t || n ? new V(e, t, n) : new V(D);
              }(e, t, n);

              if (r ? i.add(r.call(i, this.source)) : i.add(this.source || P.useDeprecatedSynchronousErrorHandling && !i.syncErrorThrowable ? this._subscribe(i) : this._trySubscribe(i)), P.useDeprecatedSynchronousErrorHandling && i.syncErrorThrowable && (i.syncErrorThrowable = !1, i.syncErrorThrown)) throw i.syncErrorValue;
              return i;
            }, e.prototype._trySubscribe = function (e) {
              try {
                return this._subscribe(e);
              } catch (t) {
                P.useDeprecatedSynchronousErrorHandling && (e.syncErrorThrown = !0, e.syncErrorValue = t), function (e) {
                  for (; e;) {
                    var t = e,
                        n = t.closed,
                        r = t.destination,
                        i = t.isStopped;
                    if (n || i) return !1;
                    e = r && r instanceof V ? r : null;
                  }

                  return !0;
                }(e) ? e.error(t) : console.warn(t);
              }
            }, e.prototype.forEach = function (e, t) {
              var n = this;
              return new (t = Z(t))(function (t, r) {
                var i;
                i = n.subscribe(function (t) {
                  try {
                    e(t);
                  } catch (e) {
                    r(e), i && i.unsubscribe();
                  }
                }, r, t);
              });
            }, e.prototype._subscribe = function (e) {
              var t = this.source;
              return t && t.subscribe(e);
            }, e.prototype[F] = function () {
              return this;
            }, e.prototype.pipe = function () {
              for (var e = [], t = 0; t < arguments.length; t++) {
                e[t] = arguments[t];
              }

              return 0 === e.length ? this : K(e)(this);
            }, e.prototype.toPromise = function (e) {
              var t = this;
              return new (e = Z(e))(function (e, n) {
                var r;
                t.subscribe(function (e) {
                  return r = e;
                }, function (e) {
                  return n(e);
                }, function () {
                  return e(r);
                });
              });
            }, e.create = function (t) {
              return new e(t);
            }, e;
          }();

          function Z(e) {
            if (e || (e = Promise), !e) throw new Error("no Promise impl found");
            return e;
          }

          var Y = function () {
            function e() {
              return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
            }

            return e.prototype = Object.create(Error.prototype), e;
          }(),
              J = function (e) {
            function t(t, n) {
              var r = e.call(this) || this;
              return r.subject = t, r.subscriber = n, r.closed = !1, r;
            }

            return O(t, e), t.prototype.unsubscribe = function () {
              if (!this.closed) {
                this.closed = !0;
                var e = this.subject,
                    t = e.observers;

                if (this.subject = null, t && 0 !== t.length && !e.isStopped && !e.closed) {
                  var n = t.indexOf(this.subscriber);
                  -1 !== n && t.splice(n, 1);
                }
              }
            }, t;
          }(U),
              $ = function (e) {
            function t(t) {
              var n = e.call(this, t) || this;
              return n.destination = t, n;
            }

            return O(t, e), t;
          }(V),
              X = function (e) {
            function t() {
              var t = e.call(this) || this;
              return t.observers = [], t.closed = !1, t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
            }

            return O(t, e), t.prototype[H] = function () {
              return new $(this);
            }, t.prototype.lift = function (e) {
              var t = new ee(this, this);
              return t.operator = e, t;
            }, t.prototype.next = function (e) {
              if (this.closed) throw new Y();
              if (!this.isStopped) for (var t = this.observers, n = t.length, r = t.slice(), i = 0; i < n; i++) {
                r[i].next(e);
              }
            }, t.prototype.error = function (e) {
              if (this.closed) throw new Y();
              this.hasError = !0, this.thrownError = e, this.isStopped = !0;

              for (var t = this.observers, n = t.length, r = t.slice(), i = 0; i < n; i++) {
                r[i].error(e);
              }

              this.observers.length = 0;
            }, t.prototype.complete = function () {
              if (this.closed) throw new Y();
              this.isStopped = !0;

              for (var e = this.observers, t = e.length, n = e.slice(), r = 0; r < t; r++) {
                n[r].complete();
              }

              this.observers.length = 0;
            }, t.prototype.unsubscribe = function () {
              this.isStopped = !0, this.closed = !0, this.observers = null;
            }, t.prototype._trySubscribe = function (t) {
              if (this.closed) throw new Y();
              return e.prototype._trySubscribe.call(this, t);
            }, t.prototype._subscribe = function (e) {
              if (this.closed) throw new Y();
              return this.hasError ? (e.error(this.thrownError), U.EMPTY) : this.isStopped ? (e.complete(), U.EMPTY) : (this.observers.push(e), new J(this, e));
            }, t.prototype.asObservable = function () {
              var e = new Q();
              return e.source = this, e;
            }, t.create = function (e, t) {
              return new ee(e, t);
            }, t;
          }(Q),
              ee = function (e) {
            function t(t, n) {
              var r = e.call(this) || this;
              return r.destination = t, r.source = n, r;
            }

            return O(t, e), t.prototype.next = function (e) {
              var t = this.destination;
              t && t.next && t.next(e);
            }, t.prototype.error = function (e) {
              var t = this.destination;
              t && t.error && this.destination.error(e);
            }, t.prototype.complete = function () {
              var e = this.destination;
              e && e.complete && this.destination.complete();
            }, t.prototype._subscribe = function (e) {
              return this.source ? this.source.subscribe(e) : U.EMPTY;
            }, t;
          }(X),
              te = function (e) {
            function t(t) {
              var n = e.call(this) || this;
              return n._value = t, n;
            }

            return O(t, e), Object.defineProperty(t.prototype, "value", {
              get: function get() {
                return this.getValue();
              },
              enumerable: !0,
              configurable: !0
            }), t.prototype._subscribe = function (t) {
              var n = e.prototype._subscribe.call(this, t);

              return n && !n.closed && t.next(this._value), n;
            }, t.prototype.getValue = function () {
              if (this.hasError) throw this.thrownError;
              if (this.closed) throw new Y();
              return this._value;
            }, t.prototype.next = function (t) {
              e.prototype.next.call(this, this._value = t);
            }, t;
          }(X),
              ne = function (e) {
            function t(t, n) {
              var r = e.call(this, t, n) || this;
              return r.scheduler = t, r.work = n, r.pending = !1, r;
            }

            return O(t, e), t.prototype.schedule = function (e, t) {
              if (void 0 === t && (t = 0), this.closed) return this;
              this.state = e;
              var n = this.id,
                  r = this.scheduler;
              return null != n && (this.id = this.recycleAsyncId(r, n, t)), this.pending = !0, this.delay = t, this.id = this.id || this.requestAsyncId(r, this.id, t), this;
            }, t.prototype.requestAsyncId = function (e, t, n) {
              return void 0 === n && (n = 0), setInterval(e.flush.bind(e, this), n);
            }, t.prototype.recycleAsyncId = function (e, t, n) {
              if (void 0 === n && (n = 0), null !== n && this.delay === n && !1 === this.pending) return t;
              clearInterval(t);
            }, t.prototype.execute = function (e, t) {
              if (this.closed) return new Error("executing a cancelled action");
              this.pending = !1;

              var n = this._execute(e, t);

              if (n) return n;
              !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
            }, t.prototype._execute = function (e, t) {
              var n = !1,
                  r = void 0;

              try {
                this.work(e);
              } catch (e) {
                n = !0, r = !!e && e || new Error(e);
              }

              if (n) return this.unsubscribe(), r;
            }, t.prototype._unsubscribe = function () {
              var e = this.id,
                  t = this.scheduler,
                  n = t.actions,
                  r = n.indexOf(this);
              this.work = null, this.state = null, this.pending = !1, this.scheduler = null, -1 !== r && n.splice(r, 1), null != e && (this.id = this.recycleAsyncId(t, e, null)), this.delay = null;
            }, t;
          }(function (e) {
            function t(t, n) {
              return e.call(this) || this;
            }

            return O(t, e), t.prototype.schedule = function (e, t) {
              return this;
            }, t;
          }(U)),
              re = function (e) {
            function t(t, n) {
              var r = e.call(this, t, n) || this;
              return r.scheduler = t, r.work = n, r;
            }

            return O(t, e), t.prototype.schedule = function (t, n) {
              return void 0 === n && (n = 0), n > 0 ? e.prototype.schedule.call(this, t, n) : (this.delay = n, this.state = t, this.scheduler.flush(this), this);
            }, t.prototype.execute = function (t, n) {
              return n > 0 || this.closed ? e.prototype.execute.call(this, t, n) : this._execute(t, n);
            }, t.prototype.requestAsyncId = function (t, n, r) {
              return void 0 === r && (r = 0), null !== r && r > 0 || null === r && this.delay > 0 ? e.prototype.requestAsyncId.call(this, t, n, r) : t.flush(this);
            }, t;
          }(ne),
              ie = function () {
            function e(t, n) {
              void 0 === n && (n = e.now), this.SchedulerAction = t, this.now = n;
            }

            return e.prototype.schedule = function (e, t, n) {
              return void 0 === t && (t = 0), new this.SchedulerAction(this, e).schedule(n, t);
            }, e.now = function () {
              return Date.now();
            }, e;
          }(),
              oe = function (e) {
            function t(n, r) {
              void 0 === r && (r = ie.now);
              var i = e.call(this, n, function () {
                return t.delegate && t.delegate !== i ? t.delegate.now() : r();
              }) || this;
              return i.actions = [], i.active = !1, i.scheduled = void 0, i;
            }

            return O(t, e), t.prototype.schedule = function (n, r, i) {
              return void 0 === r && (r = 0), t.delegate && t.delegate !== this ? t.delegate.schedule(n, r, i) : e.prototype.schedule.call(this, n, r, i);
            }, t.prototype.flush = function (e) {
              var t = this.actions;
              if (this.active) t.push(e);else {
                var n;
                this.active = !0;

                do {
                  if (n = e.execute(e.state, e.delay)) break;
                } while (e = t.shift());

                if (this.active = !1, n) {
                  for (; e = t.shift();) {
                    e.unsubscribe();
                  }

                  throw n;
                }
              }
            }, t;
          }(ie),
              ae = new (function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return O(t, e), t;
          }(oe))(re),
              se = ae,
              ce = new Q(function (e) {
            return e.complete();
          });

          function le(e) {
            return e ? function (e) {
              return new Q(function (t) {
                return e.schedule(function () {
                  return t.complete();
                });
              });
            }(e) : ce;
          }

          function de(e) {
            return e && "function" == typeof e.schedule;
          }

          var ue,
              pe = function pe(e) {
            return function (t) {
              for (var n = 0, r = e.length; n < r && !t.closed; n++) {
                t.next(e[n]);
              }

              t.complete();
            };
          };

          function he(e, t) {
            return new Q(function (n) {
              var r = new U(),
                  i = 0;
              return r.add(t.schedule(function () {
                i !== e.length ? (n.next(e[i++]), n.closed || r.add(this.schedule())) : n.complete();
              })), r;
            });
          }

          function _e(e, t) {
            return t ? he(e, t) : new Q(pe(e));
          }

          function fe() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            var n = e[e.length - 1];
            return de(n) ? (e.pop(), he(e, n)) : _e(e);
          }

          function me(e, t) {
            return new Q(t ? function (n) {
              return t.schedule(ge, 0, {
                error: e,
                subscriber: n
              });
            } : function (t) {
              return t.error(e);
            });
          }

          function ge(e) {
            var t = e.error;
            e.subscriber.error(t);
          }

          !function (e) {
            e.NEXT = "N", e.ERROR = "E", e.COMPLETE = "C";
          }(ue || (ue = {}));

          var ve = function () {
            function e(e, t, n) {
              this.kind = e, this.value = t, this.error = n, this.hasValue = "N" === e;
            }

            return e.prototype.observe = function (e) {
              switch (this.kind) {
                case "N":
                  return e.next && e.next(this.value);

                case "E":
                  return e.error && e.error(this.error);

                case "C":
                  return e.complete && e.complete();
              }
            }, e.prototype.do = function (e, t, n) {
              switch (this.kind) {
                case "N":
                  return e && e(this.value);

                case "E":
                  return t && t(this.error);

                case "C":
                  return n && n();
              }
            }, e.prototype.accept = function (e, t, n) {
              return e && "function" == typeof e.next ? this.observe(e) : this.do(e, t, n);
            }, e.prototype.toObservable = function () {
              switch (this.kind) {
                case "N":
                  return fe(this.value);

                case "E":
                  return me(this.error);

                case "C":
                  return le();
              }

              throw new Error("unexpected notification kind value");
            }, e.createNext = function (t) {
              return void 0 !== t ? new e("N", t) : e.undefinedValueNotification;
            }, e.createError = function (t) {
              return new e("E", void 0, t);
            }, e.createComplete = function () {
              return e.completeNotification;
            }, e.completeNotification = new e("C"), e.undefinedValueNotification = new e("N", void 0), e;
          }();

          function be(e, t) {
            return void 0 === t && (t = 0), function (n) {
              return n.lift(new ye(e, t));
            };
          }

          var ye = function () {
            function e(e, t) {
              void 0 === t && (t = 0), this.scheduler = e, this.delay = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new we(e, this.scheduler, this.delay));
            }, e;
          }(),
              we = function (e) {
            function t(t, n, r) {
              void 0 === r && (r = 0);
              var i = e.call(this, t) || this;
              return i.scheduler = n, i.delay = r, i;
            }

            return O(t, e), t.dispatch = function (e) {
              var t = e.notification,
                  n = e.destination;
              t.observe(n), this.unsubscribe();
            }, t.prototype.scheduleMessage = function (e) {
              this.destination.add(this.scheduler.schedule(t.dispatch, this.delay, new Se(e, this.destination)));
            }, t.prototype._next = function (e) {
              this.scheduleMessage(ve.createNext(e));
            }, t.prototype._error = function (e) {
              this.scheduleMessage(ve.createError(e)), this.unsubscribe();
            }, t.prototype._complete = function () {
              this.scheduleMessage(ve.createComplete()), this.unsubscribe();
            }, t;
          }(V),
              Se = function Se(e, t) {
            this.notification = e, this.destination = t;
          },
              xe = function (e) {
            function t(t, n, r) {
              void 0 === t && (t = Number.POSITIVE_INFINITY), void 0 === n && (n = Number.POSITIVE_INFINITY);
              var i = e.call(this) || this;
              return i.scheduler = r, i._events = [], i._infiniteTimeWindow = !1, i._bufferSize = t < 1 ? 1 : t, i._windowTime = n < 1 ? 1 : n, n === Number.POSITIVE_INFINITY ? (i._infiniteTimeWindow = !0, i.next = i.nextInfiniteTimeWindow) : i.next = i.nextTimeWindow, i;
            }

            return O(t, e), t.prototype.nextInfiniteTimeWindow = function (t) {
              if (!this.isStopped) {
                var n = this._events;
                n.push(t), n.length > this._bufferSize && n.shift();
              }

              e.prototype.next.call(this, t);
            }, t.prototype.nextTimeWindow = function (t) {
              this.isStopped || (this._events.push(new Ee(this._getNow(), t)), this._trimBufferThenGetEvents()), e.prototype.next.call(this, t);
            }, t.prototype._subscribe = function (e) {
              var t,
                  n = this._infiniteTimeWindow,
                  r = n ? this._events : this._trimBufferThenGetEvents(),
                  i = this.scheduler,
                  o = r.length;
              if (this.closed) throw new Y();
              if (this.isStopped || this.hasError ? t = U.EMPTY : (this.observers.push(e), t = new J(this, e)), i && e.add(e = new we(e, i)), n) for (var a = 0; a < o && !e.closed; a++) {
                e.next(r[a]);
              } else for (a = 0; a < o && !e.closed; a++) {
                e.next(r[a].value);
              }
              return this.hasError ? e.error(this.thrownError) : this.isStopped && e.complete(), t;
            }, t.prototype._getNow = function () {
              return (this.scheduler || se).now();
            }, t.prototype._trimBufferThenGetEvents = function () {
              for (var e = this._getNow(), t = this._bufferSize, n = this._windowTime, r = this._events, i = r.length, o = 0; o < i && !(e - r[o].time < n);) {
                o++;
              }

              return i > t && (o = Math.max(o, i - t)), o > 0 && r.splice(0, o), r;
            }, t;
          }(X),
              Ee = function Ee(e, t) {
            this.time = e, this.value = t;
          },
              Ce = 1,
              ke = Promise.resolve(),
              Ae = {};

          function Ie(e) {
            return e in Ae && (delete Ae[e], !0);
          }

          var Te = function (e) {
            function t(t, n) {
              var r = e.call(this, t, n) || this;
              return r.scheduler = t, r.work = n, r;
            }

            return O(t, e), t.prototype.requestAsyncId = function (t, n, r) {
              return void 0 === r && (r = 0), null !== r && r > 0 ? e.prototype.requestAsyncId.call(this, t, n, r) : (t.actions.push(this), t.scheduled || (t.scheduled = function (e) {
                var t = Ce++;
                return Ae[t] = !0, ke.then(function () {
                  return Ie(t) && e();
                }), t;
              }(t.flush.bind(t, null))));
            }, t.prototype.recycleAsyncId = function (t, n, r) {
              if (void 0 === r && (r = 0), null !== r && r > 0 || null === r && this.delay > 0) return e.prototype.recycleAsyncId.call(this, t, n, r);
              0 === t.actions.length && (function (e) {
                Ie(e);
              }(n), t.scheduled = void 0);
            }, t;
          }(ne),
              Oe = new (function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return O(t, e), t.prototype.flush = function (e) {
              this.active = !0, this.scheduled = void 0;
              var t,
                  n = this.actions,
                  r = -1,
                  i = n.length;
              e = e || n.shift();

              do {
                if (t = e.execute(e.state, e.delay)) break;
              } while (++r < i && (e = n.shift()));

              if (this.active = !1, t) {
                for (; ++r < i && (e = n.shift());) {
                  e.unsubscribe();
                }

                throw t;
              }
            }, t;
          }(oe))(Te),
              Re = Oe,
              Ne = new oe(ne),
              Pe = Ne;

          function je() {}

          var De = function () {
            function e() {
              return Error.call(this), this.message = "argument out of range", this.name = "ArgumentOutOfRangeError", this;
            }

            return e.prototype = Object.create(Error.prototype), e;
          }(),
              ze = function () {
            function e() {
              return Error.call(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this;
            }

            return e.prototype = Object.create(Error.prototype), e;
          }();

          function Me(e, t) {
            return function (n) {
              if ("function" != typeof e) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
              return n.lift(new Le(e, t));
            };
          }

          var Le = function () {
            function e(e, t) {
              this.project = e, this.thisArg = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new Ue(e, this.project, this.thisArg));
            }, e;
          }(),
              Ue = function (e) {
            function t(t, n, r) {
              var i = e.call(this, t) || this;
              return i.project = n, i.count = 0, i.thisArg = r || i, i;
            }

            return O(t, e), t.prototype._next = function (e) {
              var t;

              try {
                t = this.project.call(this.thisArg, e, this.count++);
              } catch (e) {
                return void this.destination.error(e);
              }

              this.destination.next(t);
            }, t;
          }(V),
              Be = function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return O(t, e), t.prototype.notifyNext = function (e, t, n, r, i) {
              this.destination.next(t);
            }, t.prototype.notifyError = function (e, t) {
              this.destination.error(e);
            }, t.prototype.notifyComplete = function (e) {
              this.destination.complete();
            }, t;
          }(V),
              He = function (e) {
            function t(t, n, r) {
              var i = e.call(this) || this;
              return i.parent = t, i.outerValue = n, i.outerIndex = r, i.index = 0, i;
            }

            return O(t, e), t.prototype._next = function (e) {
              this.parent.notifyNext(this.outerValue, e, this.outerIndex, this.index++, this);
            }, t.prototype._error = function (e) {
              this.parent.notifyError(e, this), this.unsubscribe();
            }, t.prototype._complete = function () {
              this.parent.notifyComplete(this), this.unsubscribe();
            }, t;
          }(V),
              Ve = "function" == typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator",
              qe = function qe(e) {
            return e && "number" == typeof e.length && "function" != typeof e;
          };

          function Fe(e) {
            return !!e && "function" != typeof e.subscribe && "function" == typeof e.then;
          }

          var We = function We(e) {
            if (e && "function" == typeof e[F]) return r = e, function (e) {
              var t = r[F]();
              if ("function" != typeof t.subscribe) throw new TypeError("Provided object does not correctly implement Symbol.observable");
              return t.subscribe(e);
            };
            if (qe(e)) return pe(e);
            if (Fe(e)) return n = e, function (e) {
              return n.then(function (t) {
                e.closed || (e.next(t), e.complete());
              }, function (t) {
                return e.error(t);
              }).then(null, j), e;
            };
            if (e && "function" == typeof e[Ve]) return t = e, function (e) {
              for (var n = t[Ve]();;) {
                var r = void 0;

                try {
                  r = n.next();
                } catch (t) {
                  return e.error(t), e;
                }

                if (r.done) {
                  e.complete();
                  break;
                }

                if (e.next(r.value), e.closed) break;
              }

              return "function" == typeof n.return && e.add(function () {
                n.return && n.return();
              }), e;
            };
            var t,
                n,
                r,
                i = M(e) ? "an invalid object" : "'" + e + "'";
            throw new TypeError("You provided " + i + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.");
          };

          function Ge(e, t, n, r, i) {
            if (void 0 === i && (i = new He(e, n, r)), !i.closed) return t instanceof Q ? t.subscribe(i) : We(t)(i);
          }

          function Ke(e, t) {
            return t ? function (e, t) {
              if (null != e) {
                if (function (e) {
                  return e && "function" == typeof e[F];
                }(e)) return function (e, t) {
                  return new Q(function (n) {
                    var r = new U();
                    return r.add(t.schedule(function () {
                      var i = e[F]();
                      r.add(i.subscribe({
                        next: function next(e) {
                          r.add(t.schedule(function () {
                            return n.next(e);
                          }));
                        },
                        error: function error(e) {
                          r.add(t.schedule(function () {
                            return n.error(e);
                          }));
                        },
                        complete: function complete() {
                          r.add(t.schedule(function () {
                            return n.complete();
                          }));
                        }
                      }));
                    })), r;
                  });
                }(e, t);
                if (Fe(e)) return function (e, t) {
                  return new Q(function (n) {
                    var r = new U();
                    return r.add(t.schedule(function () {
                      return e.then(function (e) {
                        r.add(t.schedule(function () {
                          n.next(e), r.add(t.schedule(function () {
                            return n.complete();
                          }));
                        }));
                      }, function (e) {
                        r.add(t.schedule(function () {
                          return n.error(e);
                        }));
                      });
                    })), r;
                  });
                }(e, t);
                if (qe(e)) return he(e, t);
                if (function (e) {
                  return e && "function" == typeof e[Ve];
                }(e) || "string" == typeof e) return function (e, t) {
                  if (!e) throw new Error("Iterable cannot be null");
                  return new Q(function (n) {
                    var r,
                        i = new U();
                    return i.add(function () {
                      r && "function" == typeof r.return && r.return();
                    }), i.add(t.schedule(function () {
                      r = e[Ve](), i.add(t.schedule(function () {
                        if (!n.closed) {
                          var e, t;

                          try {
                            var i = r.next();
                            e = i.value, t = i.done;
                          } catch (e) {
                            return void n.error(e);
                          }

                          t ? n.complete() : (n.next(e), this.schedule());
                        }
                      }));
                    })), i;
                  });
                }(e, t);
              }

              throw new TypeError((null !== e && typeof e || e) + " is not observable");
            }(e, t) : e instanceof Q ? e : new Q(We(e));
          }

          var Qe = function (e) {
            function t(t) {
              var n = e.call(this) || this;
              return n.parent = t, n;
            }

            return O(t, e), t.prototype._next = function (e) {
              this.parent.notifyNext(e);
            }, t.prototype._error = function (e) {
              this.parent.notifyError(e), this.unsubscribe();
            }, t.prototype._complete = function () {
              this.parent.notifyComplete(), this.unsubscribe();
            }, t;
          }(V);

          !function (e) {
            function t(t, n, r) {
              var i = e.call(this) || this;
              return i.parent = t, i.outerValue = n, i.outerIndex = r, i;
            }

            O(t, e), t.prototype._next = function (e) {
              this.parent.notifyNext(this.outerValue, e, this.outerIndex, this);
            }, t.prototype._error = function (e) {
              this.parent.notifyError(e), this.unsubscribe();
            }, t.prototype._complete = function () {
              this.parent.notifyComplete(this), this.unsubscribe();
            };
          }(V);

          var Ze = function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return O(t, e), t.prototype.notifyNext = function (e) {
              this.destination.next(e);
            }, t.prototype.notifyError = function (e) {
              this.destination.error(e);
            }, t.prototype.notifyComplete = function () {
              this.destination.complete();
            }, t;
          }(V);

          function Ye(e, t) {
            if (!t.closed) {
              if (e instanceof Q) return e.subscribe(t);
              var n;

              try {
                n = We(e)(t);
              } catch (e) {
                t.error(e);
              }

              return n;
            }
          }

          function Je(e, t, n) {
            return void 0 === n && (n = Number.POSITIVE_INFINITY), "function" == typeof t ? function (r) {
              return r.pipe(Je(function (n, r) {
                return Ke(e(n, r)).pipe(Me(function (e, i) {
                  return t(n, e, r, i);
                }));
              }, n));
            } : ("number" == typeof t && (n = t), function (t) {
              return t.lift(new $e(e, n));
            });
          }

          !function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            O(t, e), t.prototype.notifyNext = function (e, t, n, r) {
              this.destination.next(t);
            }, t.prototype.notifyError = function (e) {
              this.destination.error(e);
            }, t.prototype.notifyComplete = function (e) {
              this.destination.complete();
            };
          }(V);

          var $e = function () {
            function e(e, t) {
              void 0 === t && (t = Number.POSITIVE_INFINITY), this.project = e, this.concurrent = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new Xe(e, this.project, this.concurrent));
            }, e;
          }(),
              Xe = function (e) {
            function t(t, n, r) {
              void 0 === r && (r = Number.POSITIVE_INFINITY);
              var i = e.call(this, t) || this;
              return i.project = n, i.concurrent = r, i.hasCompleted = !1, i.buffer = [], i.active = 0, i.index = 0, i;
            }

            return O(t, e), t.prototype._next = function (e) {
              this.active < this.concurrent ? this._tryNext(e) : this.buffer.push(e);
            }, t.prototype._tryNext = function (e) {
              var t,
                  n = this.index++;

              try {
                t = this.project(e, n);
              } catch (e) {
                return void this.destination.error(e);
              }

              this.active++, this._innerSub(t);
            }, t.prototype._innerSub = function (e) {
              var t = new Qe(this),
                  n = this.destination;
              n.add(t);
              var r = Ye(e, t);
              r !== t && n.add(r);
            }, t.prototype._complete = function () {
              this.hasCompleted = !0, 0 === this.active && 0 === this.buffer.length && this.destination.complete(), this.unsubscribe();
            }, t.prototype.notifyNext = function (e) {
              this.destination.next(e);
            }, t.prototype.notifyComplete = function () {
              var e = this.buffer;
              this.active--, e.length > 0 ? this._next(e.shift()) : 0 === this.active && this.hasCompleted && this.destination.complete();
            }, t;
          }(Ze);

          function et(e) {
            return void 0 === e && (e = Number.POSITIVE_INFINITY), Je(W, e);
          }

          function tt() {
            return et(1);
          }

          function nt() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            return tt()(fe.apply(void 0, e));
          }

          function rt() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            if (1 === e.length) {
              var n = e[0];
              if (z(n)) return it(n, null);

              if (M(n) && Object.getPrototypeOf(n) === Object.prototype) {
                var r = Object.keys(n);
                return it(r.map(function (e) {
                  return n[e];
                }), r);
              }
            }

            if ("function" == typeof e[e.length - 1]) {
              var i = e.pop();
              return it(e = 1 === e.length && z(e[0]) ? e[0] : e, null).pipe(Me(function (e) {
                return i.apply(void 0, e);
              }));
            }

            return it(e, null);
          }

          function it(e, t) {
            return new Q(function (n) {
              var r = e.length;
              if (0 !== r) for (var i = new Array(r), o = 0, a = 0, s = function s(_s2) {
                var c = Ke(e[_s2]),
                    l = !1;
                n.add(c.subscribe({
                  next: function next(e) {
                    l || (l = !0, a++), i[_s2] = e;
                  },
                  error: function error(e) {
                    return n.error(e);
                  },
                  complete: function complete() {
                    ++o !== r && l || (a === r && n.next(t ? t.reduce(function (e, t, n) {
                      return e[t] = i[n], e;
                    }, {}) : i), n.complete());
                  }
                }));
              }, c = 0; c < r; c++) {
                s(c);
              } else n.complete();
            });
          }

          function ot(e, t, n, r) {
            return R(n) && (r = n, n = void 0), r ? ot(e, t, n).pipe(Me(function (e) {
              return z(e) ? r.apply(void 0, e) : r(e);
            })) : new Q(function (r) {
              !function e(t, n, r, i, o) {
                var a;

                if (function (e) {
                  return e && "function" == typeof e.addEventListener && "function" == typeof e.removeEventListener;
                }(t)) {
                  var s = t;
                  t.addEventListener(n, r, o), a = function a() {
                    return s.removeEventListener(n, r, o);
                  };
                } else if (function (e) {
                  return e && "function" == typeof e.on && "function" == typeof e.off;
                }(t)) {
                  var c = t;
                  t.on(n, r), a = function a() {
                    return c.off(n, r);
                  };
                } else if (function (e) {
                  return e && "function" == typeof e.addListener && "function" == typeof e.removeListener;
                }(t)) {
                  var l = t;
                  t.addListener(n, r), a = function a() {
                    return l.removeListener(n, r);
                  };
                } else {
                  if (!t || !t.length) throw new TypeError("Invalid event target");

                  for (var d = 0, u = t.length; d < u; d++) {
                    e(t[d], n, r, i, o);
                  }
                }

                i.add(a);
              }(e, t, function (e) {
                arguments.length > 1 ? r.next(Array.prototype.slice.call(arguments)) : r.next(e);
              }, r, n);
            });
          }

          function at(e, t, n) {
            return n ? at(e, t).pipe(Me(function (e) {
              return z(e) ? n.apply(void 0, e) : n(e);
            })) : new Q(function (n) {
              var r,
                  i = function i() {
                for (var e = [], t = 0; t < arguments.length; t++) {
                  e[t] = arguments[t];
                }

                return n.next(1 === e.length ? e[0] : e);
              };

              try {
                r = e(i);
              } catch (e) {
                return void n.error(e);
              }

              if (R(t)) return function () {
                return t(i, r);
              };
            });
          }

          function st(e) {
            return !z(e) && e - parseFloat(e) + 1 >= 0;
          }

          function ct(e, t) {
            return void 0 === e && (e = 0), void 0 === t && (t = Pe), (!st(e) || e < 0) && (e = 0), t && "function" == typeof t.schedule || (t = Pe), new Q(function (n) {
              return n.add(t.schedule(lt, e, {
                subscriber: n,
                counter: 0,
                period: e
              })), n;
            });
          }

          function lt(e) {
            var t = e.subscriber,
                n = e.counter,
                r = e.period;
            t.next(n), this.schedule({
              subscriber: t,
              counter: n + 1,
              period: r
            }, r);
          }

          function dt() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            var n = Number.POSITIVE_INFINITY,
                r = null,
                i = e[e.length - 1];
            return de(i) ? (r = e.pop(), e.length > 1 && "number" == typeof e[e.length - 1] && (n = e.pop())) : "number" == typeof i && (n = e.pop()), null === r && 1 === e.length && e[0] instanceof Q ? e[0] : et(n)(_e(e, r));
          }

          function ut(e, t) {
            function n() {
              return !n.pred.apply(n.thisArg, arguments);
            }

            return n.pred = e, n.thisArg = t, n;
          }

          function pt(e, t) {
            return function (n) {
              return n.lift(new ht(e, t));
            };
          }

          var ht = function () {
            function e(e, t) {
              this.predicate = e, this.thisArg = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new _t(e, this.predicate, this.thisArg));
            }, e;
          }(),
              _t = function (e) {
            function t(t, n, r) {
              var i = e.call(this, t) || this;
              return i.predicate = n, i.thisArg = r, i.count = 0, i;
            }

            return O(t, e), t.prototype._next = function (e) {
              var t;

              try {
                t = this.predicate.call(this.thisArg, e, this.count++);
              } catch (e) {
                return void this.destination.error(e);
              }

              t && this.destination.next(e);
            }, t;
          }(V);

          function ft(e, t, n) {
            return [pt(t, n)(new Q(We(e))), pt(ut(t, n))(new Q(We(e)))];
          }

          function mt() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            if (1 === e.length) {
              if (!z(e[0])) return e[0];
              e = e[0];
            }

            return _e(e, void 0).lift(new gt());
          }

          var gt = function () {
            function e() {}

            return e.prototype.call = function (e, t) {
              return t.subscribe(new vt(e));
            }, e;
          }(),
              vt = function (e) {
            function t(t) {
              var n = e.call(this, t) || this;
              return n.hasFirst = !1, n.observables = [], n.subscriptions = [], n;
            }

            return O(t, e), t.prototype._next = function (e) {
              this.observables.push(e);
            }, t.prototype._complete = function () {
              var e = this.observables,
                  t = e.length;
              if (0 === t) this.destination.complete();else {
                for (var n = 0; n < t && !this.hasFirst; n++) {
                  var r = Ge(this, e[n], void 0, n);
                  this.subscriptions && this.subscriptions.push(r), this.add(r);
                }

                this.observables = null;
              }
            }, t.prototype.notifyNext = function (e, t, n) {
              if (!this.hasFirst) {
                this.hasFirst = !0;

                for (var r = 0; r < this.subscriptions.length; r++) {
                  if (r !== n) {
                    var i = this.subscriptions[r];
                    i.unsubscribe(), this.remove(i);
                  }
                }

                this.subscriptions = null;
              }

              this.destination.next(t);
            }, t;
          }(Be);

          function bt(e, t, n) {
            void 0 === e && (e = 0);
            var r = -1;
            return st(t) ? r = Number(t) < 1 ? 1 : Number(t) : de(t) && (n = t), de(n) || (n = Pe), new Q(function (t) {
              var i = st(e) ? e : +e - n.now();
              return n.schedule(yt, i, {
                index: 0,
                period: r,
                subscriber: t
              });
            });
          }

          function yt(e) {
            var t = e.index,
                n = e.period,
                r = e.subscriber;

            if (r.next(t), !r.closed) {
              if (-1 === n) return r.complete();
              e.index = t + 1, this.schedule(e, n);
            }
          }

          function wt(e) {
            return function (t) {
              var n = new St(e),
                  r = t.lift(n);
              return n.caught = r;
            };
          }

          var St = function () {
            function e(e) {
              this.selector = e;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new xt(e, this.selector, this.caught));
            }, e;
          }(),
              xt = function (e) {
            function t(t, n, r) {
              var i = e.call(this, t) || this;
              return i.selector = n, i.caught = r, i;
            }

            return O(t, e), t.prototype.error = function (t) {
              if (!this.isStopped) {
                var n = void 0;

                try {
                  n = this.selector(t, this.caught);
                } catch (t) {
                  return void e.prototype.error.call(this, t);
                }

                this._unsubscribeAndRecycle();

                var r = new Qe(this);
                this.add(r);
                var i = Ye(n, r);
                i !== r && this.add(i);
              }
            }, t;
          }(Ze),
              Et = function () {
            function e(e, t) {
              this.dueTime = e, this.scheduler = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new Ct(e, this.dueTime, this.scheduler));
            }, e;
          }(),
              Ct = function (e) {
            function t(t, n, r) {
              var i = e.call(this, t) || this;
              return i.dueTime = n, i.scheduler = r, i.debouncedSubscription = null, i.lastValue = null, i.hasValue = !1, i;
            }

            return O(t, e), t.prototype._next = function (e) {
              this.clearDebounce(), this.lastValue = e, this.hasValue = !0, this.add(this.debouncedSubscription = this.scheduler.schedule(kt, this.dueTime, this));
            }, t.prototype._complete = function () {
              this.debouncedNext(), this.destination.complete();
            }, t.prototype.debouncedNext = function () {
              if (this.clearDebounce(), this.hasValue) {
                var e = this.lastValue;
                this.lastValue = null, this.hasValue = !1, this.destination.next(e);
              }
            }, t.prototype.clearDebounce = function () {
              var e = this.debouncedSubscription;
              null !== e && (this.remove(e), e.unsubscribe(), this.debouncedSubscription = null);
            }, t;
          }(V);

          function kt(e) {
            e.debouncedNext();
          }

          function At(e) {
            return e instanceof Date && !isNaN(+e);
          }

          function It(e, t) {
            void 0 === t && (t = Pe);
            var n = At(e) ? +e - t.now() : Math.abs(e);
            return function (e) {
              return e.lift(new Tt(n, t));
            };
          }

          var Tt = function () {
            function e(e, t) {
              this.delay = e, this.scheduler = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new Ot(e, this.delay, this.scheduler));
            }, e;
          }(),
              Ot = function (e) {
            function t(t, n, r) {
              var i = e.call(this, t) || this;
              return i.delay = n, i.scheduler = r, i.queue = [], i.active = !1, i.errored = !1, i;
            }

            return O(t, e), t.dispatch = function (e) {
              for (var t = e.source, n = t.queue, r = e.scheduler, i = e.destination; n.length > 0 && n[0].time - r.now() <= 0;) {
                n.shift().notification.observe(i);
              }

              if (n.length > 0) {
                var o = Math.max(0, n[0].time - r.now());
                this.schedule(e, o);
              } else this.unsubscribe(), t.active = !1;
            }, t.prototype._schedule = function (e) {
              this.active = !0, this.destination.add(e.schedule(t.dispatch, this.delay, {
                source: this,
                destination: this.destination,
                scheduler: e
              }));
            }, t.prototype.scheduleNotification = function (e) {
              if (!0 !== this.errored) {
                var t = this.scheduler,
                    n = new Rt(t.now() + this.delay, e);
                this.queue.push(n), !1 === this.active && this._schedule(t);
              }
            }, t.prototype._next = function (e) {
              this.scheduleNotification(ve.createNext(e));
            }, t.prototype._error = function (e) {
              this.errored = !0, this.queue = [], this.destination.error(e), this.unsubscribe();
            }, t.prototype._complete = function () {
              this.scheduleNotification(ve.createComplete()), this.unsubscribe();
            }, t;
          }(V),
              Rt = function Rt(e, t) {
            this.time = e, this.notification = t;
          };

          function Nt(e) {
            return function (t) {
              return 0 === e ? le() : t.lift(new Pt(e));
            };
          }

          var Pt = function () {
            function e(e) {
              if (this.total = e, this.total < 0) throw new De();
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new jt(e, this.total));
            }, e;
          }(),
              jt = function (e) {
            function t(t, n) {
              var r = e.call(this, t) || this;
              return r.total = n, r.count = 0, r;
            }

            return O(t, e), t.prototype._next = function (e) {
              var t = this.total,
                  n = ++this.count;
              n <= t && (this.destination.next(e), n === t && (this.destination.complete(), this.unsubscribe()));
            }, t;
          }(V),
              Dt = function () {
            function e(e) {
              if (this.total = e, this.total < 0) throw new De();
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new zt(e, this.total));
            }, e;
          }(),
              zt = function (e) {
            function t(t, n) {
              var r = e.call(this, t) || this;
              return r.total = n, r.ring = new Array(), r.count = 0, r;
            }

            return O(t, e), t.prototype._next = function (e) {
              var t = this.ring,
                  n = this.total,
                  r = this.count++;
              t.length < n ? t.push(e) : t[r % n] = e;
            }, t.prototype._complete = function () {
              var e = this.destination,
                  t = this.count;
              if (t > 0) for (var n = this.count >= this.total ? this.total : this.count, r = this.ring, i = 0; i < n; i++) {
                var o = t++ % n;
                e.next(r[o]);
              }
              e.complete();
            }, t;
          }(V);

          function Mt(e) {
            return function (t) {
              return t.lift(new Lt(e));
            };
          }

          var Lt = function () {
            function e(e) {
              this.value = e;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new Ut(e, this.value));
            }, e;
          }(),
              Ut = function (e) {
            function t(t, n) {
              var r = e.call(this, t) || this;
              return r.value = n, r;
            }

            return O(t, e), t.prototype._next = function (e) {
              this.destination.next(this.value);
            }, t;
          }(V);

          function Bt(e, t) {
            var n = !1;
            return arguments.length >= 2 && (n = !0), function (r) {
              return r.lift(new Ht(e, t, n));
            };
          }

          var Ht = function () {
            function e(e, t, n) {
              void 0 === n && (n = !1), this.accumulator = e, this.seed = t, this.hasSeed = n;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new Vt(e, this.accumulator, this.seed, this.hasSeed));
            }, e;
          }(),
              Vt = function (e) {
            function t(t, n, r, i) {
              var o = e.call(this, t) || this;
              return o.accumulator = n, o._seed = r, o.hasSeed = i, o.index = 0, o;
            }

            return O(t, e), Object.defineProperty(t.prototype, "seed", {
              get: function get() {
                return this._seed;
              },
              set: function set(e) {
                this.hasSeed = !0, this._seed = e;
              },
              enumerable: !0,
              configurable: !0
            }), t.prototype._next = function (e) {
              if (this.hasSeed) return this._tryNext(e);
              this.seed = e, this.destination.next(e);
            }, t.prototype._tryNext = function (e) {
              var t,
                  n = this.index++;

              try {
                t = this.accumulator(this.seed, e, n);
              } catch (e) {
                this.destination.error(e);
              }

              this.seed = t, this.destination.next(t);
            }, t;
          }(V);

          function qt(e, t, n) {
            return void 0 === n && (n = Number.POSITIVE_INFINITY), "function" == typeof t ? Je(function () {
              return e;
            }, t, n) : ("number" == typeof t && (n = t), Je(function () {
              return e;
            }, n));
          }

          var Ft = function () {
            function e(e) {
              this.predicate = e;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new Wt(e, this.predicate));
            }, e;
          }(),
              Wt = function (e) {
            function t(t, n) {
              var r = e.call(this, t) || this;
              return r.predicate = n, r.skipping = !0, r.index = 0, r;
            }

            return O(t, e), t.prototype._next = function (e) {
              var t = this.destination;
              this.skipping && this.tryCallPredicate(e), this.skipping || t.next(e);
            }, t.prototype.tryCallPredicate = function (e) {
              try {
                var t = this.predicate(e, this.index++);
                this.skipping = Boolean(t);
              } catch (e) {
                this.destination.error(e);
              }
            }, t;
          }(V);

          function Gt() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            var n = e[e.length - 1];
            return de(n) ? (e.pop(), function (t) {
              return nt(e, t, n);
            }) : function (t) {
              return nt(e, t);
            };
          }

          var Kt = function (e) {
            function t(t, n, r) {
              void 0 === n && (n = 0), void 0 === r && (r = Re);
              var i = e.call(this) || this;
              return i.source = t, i.delayTime = n, i.scheduler = r, (!st(n) || n < 0) && (i.delayTime = 0), r && "function" == typeof r.schedule || (i.scheduler = Re), i;
            }

            return O(t, e), t.create = function (e, n, r) {
              return void 0 === n && (n = 0), void 0 === r && (r = Re), new t(e, n, r);
            }, t.dispatch = function (e) {
              var t = e.source,
                  n = e.subscriber;
              return this.add(t.subscribe(n));
            }, t.prototype._subscribe = function (e) {
              var n = this.delayTime,
                  r = this.source;
              return this.scheduler.schedule(t.dispatch, n, {
                source: r,
                subscriber: e
              });
            }, t;
          }(Q);

          function Qt(e, t) {
            return void 0 === t && (t = 0), function (n) {
              return n.lift(new Zt(e, t));
            };
          }

          var Zt = function () {
            function e(e, t) {
              this.scheduler = e, this.delay = t;
            }

            return e.prototype.call = function (e, t) {
              return new Kt(t, this.delay, this.scheduler).subscribe(e);
            }, e;
          }();

          function Yt(e, t) {
            return "function" == typeof t ? function (n) {
              return n.pipe(Yt(function (n, r) {
                return Ke(e(n, r)).pipe(Me(function (e, i) {
                  return t(n, e, r, i);
                }));
              }));
            } : function (t) {
              return t.lift(new Jt(e));
            };
          }

          var Jt = function () {
            function e(e) {
              this.project = e;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new $t(e, this.project));
            }, e;
          }(),
              $t = function (e) {
            function t(t, n) {
              var r = e.call(this, t) || this;
              return r.project = n, r.index = 0, r;
            }

            return O(t, e), t.prototype._next = function (e) {
              var t,
                  n = this.index++;

              try {
                t = this.project(e, n);
              } catch (e) {
                return void this.destination.error(e);
              }

              this._innerSub(t);
            }, t.prototype._innerSub = function (e) {
              var t = this.innerSubscription;
              t && t.unsubscribe();
              var n = new Qe(this),
                  r = this.destination;
              r.add(n), this.innerSubscription = Ye(e, n), this.innerSubscription !== n && r.add(this.innerSubscription);
            }, t.prototype._complete = function () {
              var t = this.innerSubscription;
              t && !t.closed || e.prototype._complete.call(this), this.unsubscribe();
            }, t.prototype._unsubscribe = function () {
              this.innerSubscription = void 0;
            }, t.prototype.notifyComplete = function () {
              this.innerSubscription = void 0, this.isStopped && e.prototype._complete.call(this);
            }, t.prototype.notifyNext = function (e) {
              this.destination.next(e);
            }, t;
          }(Ze);

          function Xt(e, t) {
            return void 0 === t && (t = !1), function (n) {
              return n.lift(new en(e, t));
            };
          }

          var en = function () {
            function e(e, t) {
              this.predicate = e, this.inclusive = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new tn(e, this.predicate, this.inclusive));
            }, e;
          }(),
              tn = function (e) {
            function t(t, n, r) {
              var i = e.call(this, t) || this;
              return i.predicate = n, i.inclusive = r, i.index = 0, i;
            }

            return O(t, e), t.prototype._next = function (e) {
              var t,
                  n = this.destination;

              try {
                t = this.predicate(e, this.index++);
              } catch (e) {
                return void n.error(e);
              }

              this.nextOrComplete(e, t);
            }, t.prototype.nextOrComplete = function (e, t) {
              var n = this.destination;
              Boolean(t) ? n.next(e) : (this.inclusive && n.next(e), n.complete());
            }, t;
          }(V);

          function nn(e, t, n) {
            return function (r) {
              return r.lift(new rn(e, t, n));
            };
          }

          var rn = function () {
            function e(e, t, n) {
              this.nextOrObserver = e, this.error = t, this.complete = n;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new on(e, this.nextOrObserver, this.error, this.complete));
            }, e;
          }(),
              on = function (e) {
            function t(t, n, r, i) {
              var o = e.call(this, t) || this;
              return o._tapNext = je, o._tapError = je, o._tapComplete = je, o._tapError = r || je, o._tapComplete = i || je, R(n) ? (o._context = o, o._tapNext = n) : n && (o._context = n, o._tapNext = n.next || je, o._tapError = n.error || je, o._tapComplete = n.complete || je), o;
            }

            return O(t, e), t.prototype._next = function (e) {
              try {
                this._tapNext.call(this._context, e);
              } catch (e) {
                return void this.destination.error(e);
              }

              this.destination.next(e);
            }, t.prototype._error = function (e) {
              try {
                this._tapError.call(this._context, e);
              } catch (e) {
                return void this.destination.error(e);
              }

              this.destination.error(e);
            }, t.prototype._complete = function () {
              try {
                this._tapComplete.call(this._context);
              } catch (e) {
                return void this.destination.error(e);
              }

              return this.destination.complete();
            }, t;
          }(V),
              an = function () {
            function e(e, t, n, r) {
              this.waitFor = e, this.absoluteTimeout = t, this.withObservable = n, this.scheduler = r;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new sn(e, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
            }, e;
          }(),
              sn = function (e) {
            function t(t, n, r, i, o) {
              var a = e.call(this, t) || this;
              return a.absoluteTimeout = n, a.waitFor = r, a.withObservable = i, a.scheduler = o, a.scheduleTimeout(), a;
            }

            return O(t, e), t.dispatchTimeout = function (e) {
              var t = e.withObservable;
              e._unsubscribeAndRecycle(), e.add(Ye(t, new Qe(e)));
            }, t.prototype.scheduleTimeout = function () {
              var e = this.action;
              e ? this.action = e.schedule(this, this.waitFor) : this.add(this.action = this.scheduler.schedule(t.dispatchTimeout, this.waitFor, this));
            }, t.prototype._next = function (t) {
              this.absoluteTimeout || this.scheduleTimeout(), e.prototype._next.call(this, t);
            }, t.prototype._unsubscribe = function () {
              this.action = void 0, this.scheduler = null, this.withObservable = null;
            }, t;
          }(Ze);

          function cn(e, t) {
            return void 0 === t && (t = Pe), function (e, t, n) {
              return void 0 === n && (n = Pe), function (r) {
                var i = At(e),
                    o = i ? +e - n.now() : Math.abs(e);
                return r.lift(new an(o, i, t, n));
              };
            }(e, me(new ze()), t);
          }

          function ln() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            return function (t) {
              var n;
              "function" == typeof e[e.length - 1] && (n = e.pop());
              var r = e;
              return t.lift(new pn(r, n));
            };
          }

          var dn,
              un,
              pn = function () {
            function e(e, t) {
              this.observables = e, this.project = t;
            }

            return e.prototype.call = function (e, t) {
              return t.subscribe(new hn(e, this.observables, this.project));
            }, e;
          }(),
              hn = function (e) {
            function t(t, n, r) {
              var i = e.call(this, t) || this;
              i.observables = n, i.project = r, i.toRespond = [];
              var o = n.length;
              i.values = new Array(o);

              for (var a = 0; a < o; a++) {
                i.toRespond.push(a);
              }

              for (a = 0; a < o; a++) {
                var s = n[a];
                i.add(Ge(i, s, void 0, a));
              }

              return i;
            }

            return O(t, e), t.prototype.notifyNext = function (e, t, n) {
              this.values[n] = t;
              var r = this.toRespond;

              if (r.length > 0) {
                var i = r.indexOf(n);
                -1 !== i && r.splice(i, 1);
              }
            }, t.prototype.notifyComplete = function () {}, t.prototype._next = function (e) {
              if (0 === this.toRespond.length) {
                var t = [e].concat(this.values);
                this.project ? this._tryProject(t) : this.destination.next(t);
              }
            }, t.prototype._tryProject = function (e) {
              var t;

              try {
                t = this.project.apply(this, e);
              } catch (e) {
                return void this.destination.error(e);
              }

              this.destination.next(t);
            }, t;
          }(Be),
              _n = function _n(e, t) {
            return e === t || "function" == typeof t && e === t.toString();
          },
              fn = function fn() {
            for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return function (e) {
              return e.pipe(pt(function (e) {
                var n = e.type,
                    r = t.length;
                if (1 === r) return _n(n, t[0]);

                for (var i = 0; i < r; i++) {
                  if (_n(n, t[i])) return !0;
                }

                return !1;
              }));
            };
          },
              mn = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
              }
            }

            return function (t, n, r) {
              return n && e(t.prototype, n), r && e(t, r), t;
            };
          }(),
              gn = function (e) {
            function t(e) {
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, t);

              var n = function (e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
              }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

              return n.source = e, n;
            }

            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(t, Q), mn(t, null, [{
              key: "of",
              value: function value() {
                return new this(fe.apply(void 0, arguments));
              }
            }, {
              key: "from",
              value: function value(e, t) {
                return new this(Ke(e, t));
              }
            }]), mn(t, [{
              key: "lift",
              value: function value(e) {
                var n = new t(this);
                return n.operator = e, n;
              }
            }, {
              key: "ofType",
              value: function value() {
                return fn.apply(void 0, arguments)(this);
              }
            }]), t;
          }(),
              vn = function (e) {
            function t(e, n) {
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, t);

              var r = function (e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
              }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, function (e) {
                var t = r.__notifier.subscribe(e);

                return t && !t.closed && e.next(r.value), t;
              }));

              return r.value = n, r.__notifier = new X(), r.__subscription = e.subscribe(function (e) {
                e !== r.value && (r.value = e, r.__notifier.next(e));
              }), r;
            }

            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(t, Q), t;
          }(),
              bn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              yn = [];

          function wn(e, t) {
            e.super_ = t, e.prototype = Object.create(t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            });
          }

          function Sn(e, t) {
            Object.defineProperty(this, "kind", {
              value: e,
              enumerable: !0
            }), t && t.length && Object.defineProperty(this, "path", {
              value: t,
              enumerable: !0
            });
          }

          function xn(e, t, n) {
            xn.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
              value: t,
              enumerable: !0
            }), Object.defineProperty(this, "rhs", {
              value: n,
              enumerable: !0
            });
          }

          function En(e, t) {
            En.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
              value: t,
              enumerable: !0
            });
          }

          function Cn(e, t) {
            Cn.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
              value: t,
              enumerable: !0
            });
          }

          function kn(e, t, n) {
            kn.super_.call(this, "A", e), Object.defineProperty(this, "index", {
              value: t,
              enumerable: !0
            }), Object.defineProperty(this, "item", {
              value: n,
              enumerable: !0
            });
          }

          function An(e, t, n) {
            var r = e.slice((n || t) + 1 || e.length);
            return e.length = t < 0 ? e.length + t : t, e.push.apply(e, r), e;
          }

          function In(e) {
            var t = void 0 === e ? "undefined" : bn(e);
            return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
          }

          function Tn(e, t, n, r, i, o, a) {
            a = a || [];
            var s = (i = i || []).slice(0);

            if (void 0 !== o) {
              if (r) {
                if ("function" == typeof r && r(s, o)) return;

                if ("object" === (void 0 === r ? "undefined" : bn(r))) {
                  if (r.prefilter && r.prefilter(s, o)) return;

                  if (r.normalize) {
                    var c = r.normalize(s, o, e, t);
                    c && (e = c[0], t = c[1]);
                  }
                }
              }

              s.push(o);
            }

            "regexp" === In(e) && "regexp" === In(t) && (e = e.toString(), t = t.toString());
            var l = void 0 === e ? "undefined" : bn(e),
                d = void 0 === t ? "undefined" : bn(t),
                u = "undefined" !== l || a && a[a.length - 1].lhs && a[a.length - 1].lhs.hasOwnProperty(o),
                p = "undefined" !== d || a && a[a.length - 1].rhs && a[a.length - 1].rhs.hasOwnProperty(o);
            if (!u && p) n(new En(s, t));else if (!p && u) n(new Cn(s, e));else if (In(e) !== In(t)) n(new xn(s, e, t));else if ("date" === In(e) && e - t != 0) n(new xn(s, e, t));else if ("object" === l && null !== e && null !== t) {
              if (a.filter(function (t) {
                return t.lhs === e;
              }).length) e !== t && n(new xn(s, e, t));else {
                if (a.push({
                  lhs: e,
                  rhs: t
                }), Array.isArray(e)) {
                  var h;

                  for (e.length, h = 0; h < e.length; h++) {
                    h >= t.length ? n(new kn(s, h, new Cn(void 0, e[h]))) : Tn(e[h], t[h], n, r, s, h, a);
                  }

                  for (; h < t.length;) {
                    n(new kn(s, h, new En(void 0, t[h++])));
                  }
                } else {
                  var _ = Object.keys(e),
                      f = Object.keys(t);

                  _.forEach(function (i, o) {
                    var c = f.indexOf(i);
                    c >= 0 ? (Tn(e[i], t[i], n, r, s, i, a), f = An(f, c)) : Tn(e[i], void 0, n, r, s, i, a);
                  }), f.forEach(function (e) {
                    Tn(void 0, t[e], n, r, s, e, a);
                  });
                }

                a.length = a.length - 1;
              }
            } else e !== t && ("number" === l && isNaN(e) && isNaN(t) || n(new xn(s, e, t)));
          }

          function On(e, t, n, r) {
            return r = r || [], Tn(e, t, function (e) {
              e && r.push(e);
            }, n), r.length ? r : void 0;
          }

          function Rn(e, t, n) {
            if (e && t && n && n.kind) {
              for (var r = e, i = -1, o = n.path ? n.path.length - 1 : 0; ++i < o;) {
                void 0 === r[n.path[i]] && (r[n.path[i]] = "number" == typeof n.path[i] ? [] : {}), r = r[n.path[i]];
              }

              switch (n.kind) {
                case "A":
                  !function e(t, n, r) {
                    if (r.path && r.path.length) {
                      var i,
                          o = t[n],
                          a = r.path.length - 1;

                      for (i = 0; i < a; i++) {
                        o = o[r.path[i]];
                      }

                      switch (r.kind) {
                        case "A":
                          e(o[r.path[i]], r.index, r.item);
                          break;

                        case "D":
                          delete o[r.path[i]];
                          break;

                        case "E":
                        case "N":
                          o[r.path[i]] = r.rhs;
                      }
                    } else switch (r.kind) {
                      case "A":
                        e(t[n], r.index, r.item);
                        break;

                      case "D":
                        t = An(t, n);
                        break;

                      case "E":
                      case "N":
                        t[n] = r.rhs;
                    }

                    return t;
                  }(n.path ? r[n.path[i]] : r, n.index, n.item);
                  break;

                case "D":
                  delete r[n.path[i]];
                  break;

                case "E":
                case "N":
                  r[n.path[i]] = n.rhs;
              }
            }
          }

          dn = "object" === ("undefined" == typeof n.g ? "undefined" : bn(n.g)) && n.g ? n.g : "undefined" != typeof window ? window : {}, (un = dn.DeepDiff) && yn.push(function () {
            void 0 !== un && dn.DeepDiff === On && (dn.DeepDiff = un, un = void 0);
          }), wn(xn, Sn), wn(En, Sn), wn(Cn, Sn), wn(kn, Sn), Object.defineProperties(On, {
            diff: {
              value: On,
              enumerable: !0
            },
            observableDiff: {
              value: Tn,
              enumerable: !0
            },
            applyDiff: {
              value: function value(e, t, n) {
                e && t && Tn(e, t, function (r) {
                  n && !n(e, t, r) || Rn(e, t, r);
                });
              },
              enumerable: !0
            },
            applyChange: {
              value: Rn,
              enumerable: !0
            },
            revertChange: {
              value: function value(e, t, n) {
                if (e && t && n && n.kind) {
                  var r,
                      i,
                      o = e;

                  for (i = n.path.length - 1, r = 0; r < i; r++) {
                    void 0 === o[n.path[r]] && (o[n.path[r]] = {}), o = o[n.path[r]];
                  }

                  switch (n.kind) {
                    case "A":
                      !function e(t, n, r) {
                        if (r.path && r.path.length) {
                          var i,
                              o = t[n],
                              a = r.path.length - 1;

                          for (i = 0; i < a; i++) {
                            o = o[r.path[i]];
                          }

                          switch (r.kind) {
                            case "A":
                              e(o[r.path[i]], r.index, r.item);
                              break;

                            case "D":
                            case "E":
                              o[r.path[i]] = r.lhs;
                              break;

                            case "N":
                              delete o[r.path[i]];
                          }
                        } else switch (r.kind) {
                          case "A":
                            e(t[n], r.index, r.item);
                            break;

                          case "D":
                          case "E":
                            t[n] = r.lhs;
                            break;

                          case "N":
                            t = An(t, n);
                        }

                        return t;
                      }(o[n.path[r]], n.index, n.item);
                      break;

                    case "D":
                    case "E":
                      o[n.path[r]] = n.lhs;
                      break;

                    case "N":
                      delete o[n.path[r]];
                  }
                }
              },
              enumerable: !0
            },
            isConflict: {
              value: function value() {
                return void 0 !== un;
              },
              enumerable: !0
            },
            noConflict: {
              value: function value() {
                return yn && (yn.forEach(function (e) {
                  e();
                }), yn = null), On;
              },
              enumerable: !0
            }
          });

          var Nn = function Nn(e, t, n, r, i, o, a, s) {
            if (!e) {
              var c;
              if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
                var l = [n, r, i, o, a, s],
                    d = 0;
                (c = new Error(t.replace(/%s/g, function () {
                  return l[d++];
                }))).name = "Invariant Violation";
              }
              throw c.framesToPop = 1, c;
            }
          },
              Pn = function Pn(e) {
            return "function" == typeof e;
          },
              jn = function jn(e) {
            return e.toString();
          },
              Dn = function Dn(e) {
            return "string" == typeof e;
          },
              zn = function zn(e) {
            return e;
          },
              Mn = function Mn(e) {
            return null === e;
          };

          function Ln(e, t, n) {
            void 0 === t && (t = zn), Nn(Pn(t) || Mn(t), "Expected payloadCreator to be a function, undefined or null");

            var r = Mn(t) || t === zn ? zn : function (e) {
              for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
                r[i - 1] = arguments[i];
              }

              return e instanceof Error ? e : t.apply(void 0, [e].concat(r));
            },
                i = Pn(n),
                o = e.toString(),
                a = function a() {
              var t = r.apply(void 0, arguments),
                  o = {
                type: e
              };
              return t instanceof Error && (o.error = !0), void 0 !== t && (o.payload = t), i && (o.meta = n.apply(void 0, arguments)), o;
            };

            return a.toString = function () {
              return o;
            }, a;
          }

          var Un = function Un(e) {
            if ("object" != typeof e || null === e) return !1;

            for (var t = e; null !== Object.getPrototypeOf(t);) {
              t = Object.getPrototypeOf(t);
            }

            return Object.getPrototypeOf(e) === t;
          },
              Bn = function Bn(e) {
            return Array.isArray(e);
          },
              Hn = function Hn(e) {
            return null == e;
          },
              Vn = function Vn(e) {
            return e[e.length - 1];
          },
              qn = /\s/,
              Fn = /(_|-|\.|:)/,
              Wn = /([a-z][A-Z]|[A-Z][a-z])/,
              Gn = /[\W_]+(.|$)/g,
              Kn = /(.)([A-Z]+)/g,
              Qn = function Qn(e) {
            return function (e) {
              return qn.test(e) ? e.toLowerCase() : Fn.test(e) ? (function (e) {
                return e.replace(Gn, function (e, t) {
                  return t ? " " + t : "";
                });
              }(e) || e).toLowerCase() : Wn.test(e) ? function (e) {
                return e.replace(Kn, function (e, t, n) {
                  return t + " " + n.toLowerCase().split("").join(" ");
                });
              }(e).toLowerCase() : e.toLowerCase();
            }(e).replace(/[\W_]+(.|$)/g, function (e, t) {
              return t ? " " + t : "";
            }).trim();
          },
              Zn = function Zn(e) {
            return Qn(e).replace(/\s(\w)/g, function (e, t) {
              return t.toUpperCase();
            });
          },
              Yn = function Yn(e) {
            return -1 === e.indexOf("/") ? Zn(e) : e.split("/").map(Zn).join("/");
          },
              Jn = function Jn(e, t) {
            return e.reduce(function (e, n) {
              return t(e, n);
            }, {});
          },
              $n = function $n(e) {
            return "undefined" != typeof Map && e instanceof Map;
          };

          function Xn(e) {
            if ($n(e)) return Array.from(e.keys());
            if ("undefined" != typeof Reflect && "function" == typeof Reflect.ownKeys) return Reflect.ownKeys(e);
            var t = Object.getOwnPropertyNames(e);
            return "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(e))), t;
          }

          function er(e, t) {
            return $n(t) ? t.get(e) : t[e];
          }

          var tr = function tr(e) {
            return function t(n, r, i, o) {
              var a = void 0 === r ? {} : r,
                  s = a.namespace,
                  c = void 0 === s ? "/" : s,
                  l = a.prefix;
              return void 0 === i && (i = {}), void 0 === o && (o = ""), Xn(n).forEach(function (r) {
                var a = function (e) {
                  return o || !l || l && new RegExp("^" + l + c).test(e) ? e : "" + l + c + e;
                }(function (e) {
                  var t;
                  if (!o) return e;
                  var n = e.toString().split("||"),
                      r = o.split("||");
                  return (t = []).concat.apply(t, r.map(function (e) {
                    return n.map(function (t) {
                      return "" + e + c + t;
                    });
                  })).join("||");
                }(r)),
                    s = er(r, n);

                e(s) ? t(s, {
                  namespace: c,
                  prefix: l
                }, i, a) : i[a] = s;
              }), i;
            };
          },
              nr = tr(Un);

          function rr(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {},
                  r = Object.keys(n);
              "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                return Object.getOwnPropertyDescriptor(n, e).enumerable;
              }))), r.forEach(function (t) {
                ir(e, t, n[t]);
              });
            }

            return e;
          }

          function ir(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          function or(e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            var i = Un(Vn(n)) ? n.pop() : {};
            return Nn(n.every(Dn) && (Dn(e) || Un(e)), "Expected optional object followed by string action types"), Dn(e) ? cr([e].concat(n), i) : rr({}, ar(e, i), cr(n, i));
          }

          function ar(e, t) {
            return function (e, t) {
              var n = void 0 === t ? {} : t,
                  r = n.namespace,
                  i = void 0 === r ? "/" : r,
                  o = n.prefix,
                  a = {};
              return Object.getOwnPropertyNames(e).forEach(function (t) {
                var n = o ? t.replace("" + o + i, "") : t;
                return function t(n, r, i) {
                  var o = Yn(i.shift());
                  0 === i.length ? r[o] = e[n] : (r[o] || (r[o] = {}), t(n, r[o], i));
                }(t, a, n.split(i));
              }), a;
            }(sr(nr(e, t)), t);
          }

          function sr(e, t) {
            var n = void 0 === t ? {} : t,
                r = n.prefix,
                i = n.namespace,
                o = void 0 === i ? "/" : i;
            return Jn(Object.keys(e), function (t, n) {
              var i,
                  a = e[n];
              Nn(function (e) {
                if (Pn(e) || Hn(e)) return !0;

                if (Bn(e)) {
                  var t = e[0],
                      n = void 0 === t ? zn : t,
                      r = e[1];
                  return Pn(n) && Pn(r);
                }

                return !1;
              }(a), "Expected function, undefined, null, or array with payload and meta functions for " + n);
              var s = r ? "" + r + o + n : n,
                  c = Bn(a) ? Ln.apply(void 0, [s].concat(a)) : Ln(s, a);
              return rr({}, t, ((i = {})[n] = c, i));
            });
          }

          function cr(e, t) {
            var n = sr(Jn(e, function (e, t) {
              var n;
              return rr({}, e, ((n = {})[t] = zn, n));
            }), t);
            return Jn(Object.keys(n), function (e, t) {
              var r;
              return rr({}, e, ((r = {})[Yn(t)] = n[t], r));
            });
          }

          var lr = function lr() {
            for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            var r = "function" != typeof t[t.length - 1] && t.pop(),
                i = t;
            if (void 0 === r) throw new TypeError("The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.");
            return function (e, t) {
              for (var n = arguments.length, o = Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++) {
                o[a - 2] = arguments[a];
              }

              var s = void 0 === e,
                  c = void 0 === t;
              return s && c && r ? r : i.reduce(function (e, n) {
                return n.apply(void 0, [e, t].concat(o));
              }, s && !c && r ? r : e);
            };
          },
              dr = tr(function (e) {
            return (Un(e) || $n(e)) && (n = (t = Xn(e)).every(function (e) {
              return "next" === e || "throw" === e;
            }), !(t.length && t.length <= 2 && n));
            var t, n;
          });

          function ur(e, t, n) {
            void 0 === n && (n = {}), Nn(Un(e) || $n(e), "Expected handlers to be a plain object.");
            var r = dr(e, n),
                i = Xn(r).map(function (e) {
              return function (e, t, n) {
                void 0 === t && (t = zn);
                var r = jn(e).split("||");
                Nn(!(void 0 === n), "defaultState for reducer handling " + r.join(", ") + " should be defined"), Nn(Pn(t) || Un(t), "Expected reducer to be a function or object with next and throw reducers");
                var i = Pn(t) ? [t, t] : [t.next, t.throw].map(function (e) {
                  return Hn(e) ? zn : e;
                }),
                    o = i[0],
                    a = i[1];
                return function (e, t) {
                  void 0 === e && (e = n);
                  var i = t.type;
                  return i && -1 !== r.indexOf(jn(i)) ? (!0 === t.error ? a : o)(e, t) : e;
                };
              }(e, er(e, r), t);
            }),
                o = lr.apply(void 0, i.concat([t]));
            return function (e, n) {
              return void 0 === e && (e = t), o(e, n);
            };
          }

          var pr = Ln("CONNECT_ZOOM_SOCKET"),
              hr = Ln("CONNECT_XMPP_SOCKET"),
              _r = Ln("CLOSE_ZOOM_SOCKET"),
              fr = Ln("CLOSE_XMPP_SOCKET"),
              mr = Ln("RECEIVE_MESSAGE_FROM_ZOOM_SOCKET"),
              gr = Ln("RECEIVE_SHARING_PAYLOAD_FROM_ZOOM_SOCKET"),
              vr = Ln("RECEIVE_MESSAGE_FROM_XMPP_SOCKET"),
              br = Ln("CONNECT_MAIN_SESSION_SOCKET"),
              yr = Ln("CLOSE_MAIN_SESSION_SOCKET"),
              wr = Ln("RECEIVE_MESSAGE_FROM_MAIN_SESSION_SOCKET"),
              _or = or("SET_ZOOM_SOCKET_STATUS", "SET_RWG_SERVERS_LIST", "SET_RWG_RETRY_COUNT", "SET_XMPP_SOCKET_STATUS", "SET_MAIN_SESSION_SOCKET_STATUS", "RESET_SOCKET"),
              Sr = _or.setZoomSocketStatus,
              xr = _or.setRwgServersList,
              Er = _or.setRwgRetryCount,
              Cr = _or.setXmppSocketStatus,
              kr = _or.setMainSessionSocketStatus,
              Ar = _or.resetSocket,
              Ir = Ln("CONNECT_TO_MEDIA_STREAM"),
              Tr = Ln("RECEIVE_PAYLOAD_FROM_MEDIA_SDK"),
              _or2 = or("SET_AUDIO_ENCODE_STATUS", "SET_AUDIO_DECODE_STATUS", "SET_VIDEO_ENCODE_STATUS", "SET_VIDEO_DECODE_STATUS", "SET_SHARING_ENCODE_STATUS", "SET_SHARING_DECODE_STATUS", "SET_MEDIA_CONSTRAINTS", "SET_MEDIA_ENCRYPT_KEY", "RESET_MEDIA"),
              Or = _or2.setAudioEncodeStatus,
              Rr = _or2.setAudioDecodeStatus,
              Nr = _or2.setVideoEncodeStatus,
              Pr = _or2.setVideoDecodeStatus,
              jr = _or2.setSharingEncodeStatus,
              Dr = _or2.setSharingDecodeStatus,
              zr = _or2.setMediaConstraints,
              Mr = _or2.setMediaEncryptKey,
              Lr = _or2.resetMedia;

          function Ur(e, t) {
            for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++) {
              r[i - 2] = arguments[i];
            }

            return e(gn.of.apply(gn, _toConsumableArray(r || [])), t, null);
          }

          function Br() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            var r = function r() {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
                n[r] = arguments[r];
              }

              return dt.apply(void 0, _toConsumableArray(t.map(function (e) {
                var t = e.apply(void 0, n);
                if (!t) throw new TypeError('combineEpics: one of the provided Epics "'.concat(e.name || "<anonymous>", "\" does not return a stream. Double check you're not missing a return statement!"));
                return t.pipe(wt(function (e, t) {
                  return setTimeout(function () {
                    throw e;
                  }, 0), t;
                }));
              })));
            };

            try {
              Object.defineProperty(r, "name", {
                value: "combineEpics(".concat(t.map(function (e) {
                  return e.name || "<anonymous>";
                }).join(", "), ")")
              });
            } catch (e) {}

            return r;
          }

          function Hr() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            var r = t.flatMap(function (e) {
              return Object.values(e);
            });
            return Br.apply(void 0, _toConsumableArray(r));
          }

          function Vr(e, t) {
            return e.pipe(fn("".concat(mr)), pt(function (e) {
              return e.payload.evt === t;
            }));
          }

          function qr(e, t) {
            return e.pipe(fn("".concat(wr)), pt(function (e) {
              return e.payload.evt === t;
            }));
          }

          function Fr(e, t) {
            return e.pipe(fn("".concat(vr)), pt(function (e) {
              return e.payload.evt === t;
            }));
          }

          function Wr(e, t) {
            return e.pipe(fn("".concat(mr), "".concat(wr)), pt(function (e) {
              return e.payload.evt === t;
            }));
          }

          function Gr(e, t) {
            return e.pipe(fn("".concat(Tr)), pt(function (e) {
              return Array.isArray(t) ? t.indexOf(e.payload.type) > -1 : e.payload.type === t;
            }));
          }

          var Kr = {
            default: {
              "apac.errorcodes_success": "Successfully joined the meeting.",
              "apac.errorcodes_fail": "Fail to join the meeting.",
              "apac.errorcodes_not_init": "Meeting not initialized.",
              "apac.errorcodes_register": "This webinar requires registration.",
              "apac.errorcodes_email_require": "Email is missing to attend webinar.",
              "apac.errorcodes_not_exist": "Meeting does not exist.",
              "apac.errorcodes_not_host": "You are not the meeting host.",
              "apac.errorcodes_wrong_pass": "Meeting Passcode wrong.",
              "apac.errorcodes_role_type": "Role type is required.",
              "apac.errorcodes_not_start": "Meeting has not started",
              "apac.errorcodes_re_connect": "Meeting is reconnecting.",
              "apac.errorcodes_be_removed": "Be removed.",
              "apac.errorcodes_disconnect": "Meeting has been disconnected.",
              "apac.errorcodes_denied_register_with_panelist": "Denied register use panelist email.",
              "apac.errorcodes_web_has_in_progress": "Already has other meetings in progress.",
              "apac.errorcodes_web_require_email": "User email is required.",
              "apac.errorcodes_web_not_support_webinar_pac": "Not support webinar and personal audio conference",
              "apac.errorcodes_web_host_not_exit": "The meeting host does not exist.",
              "apac.errorcodes_web_not_support_webclient": "Not support start or join meeting from web.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "The current sdk version doesn't support webinar, please upgrade to the latest version.",
              "apac.errorcodes_web_invalid_id": "Invalid meeting ID.",
              "apac.errorcodes_web_not_support_registration_webinar": "Not support registration webinar",
              "apac.errorcodes_web_not_support_tsp": "Not support start or join meeting from web, when you chose TSP as his audio in a meeting.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "Not allow to start webinar from web.",
              "apac.errorcodes_pac_api_wrong": "The accounts API Key is not valid.",
              "apac.errorcodes_pac_signature_expired": "The signature has expired.",
              "apac.errorcodes_pac_mn_wrong": "The meeting number is wrong.",
              "apac.errorcodes_pac_mn_not_fount": "The meeting number is not found.",
              "apac.errorcodes_pac_role_error": "Incorrect role.",
              "apac.errorcodes_pac_host_not_found": "The meeting host is not found.",
              "apac.errorcodes_pac_api_disabled": "The accounts API Key is deactivated.",
              "apac.errorcodes_pac_cant_host_other_mn": "Cannot not host another meeting concurrently.",
              "apac.errorcodes_pac_invalid_signature": "Signature is invalid.",
              "apac.errorcodes_pac_no_permission": "No permission.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "Unable join from browser, please join using the Zoom desktop client or mobile app.",
              "apac.errorcodes_rwc_empty": "Could not get a response from the web server.",
              "apac.errorcodes_rwc_error": "Could not connect to Web Server error.",
              "apac.errorcodes_frequent_call": "You have reached the API limit for this call.",
              "apac.errorcodes_frequent_join": "You be limit by zoom, need to check recaptcha.",
              "apac.errorcodes_offline": "The service is temporarily offline.",
              "apac.errorcodes_wasm_fail": "Download wasm files error, please check your network and firewall.",
              "apac.errorcodes_denied_email": "Email is blocked by Administrator.",
              "apac.errorcodes_tk_expired": "Token has expired.",
              "apac.invalid_parameter": "Invalid Parameter",
              "apac.errorcodes_login_required": "Require login",
              "apac.errorcodes_upgrade": "Your sdk version needs to be {0} or higher to join the meeting"
            },
            "de-DE": {
              "apac.errorcodes_web_has_in_progress": "Hat bereits andere laufende Meetings.",
              "apac.errorcodes_web_require_email": "E-Mail-Adresse von Benutzer erforderlich.",
              "apac.errorcodes_web_not_support_webinar_pac": "Unterst\xfctzen Webinar und pers\xf6nliche Audiokonferenz nicht",
              "apac.errorcodes_web_host_not_exit": "Der Meeting-Host ist nicht vorhanden.",
              "apac.errorcodes_web_not_support_webclient": "Start nicht unterst\xfctzt bzw. starten Sie das Meeting aus dem Web.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "Ihre aktuelle SDK-Version unterst\xfctzt keine Webinare. Aktualisieren Sie bitte auf die neueste Version.",
              "apac.errorcodes_web_invalid_id": "Ung\xfcltige Meeting-ID.",
              "apac.errorcodes_web_not_support_registration_webinar": "Registrierung f\xfcr Webinar wird nicht unterst\xfctzt",
              "apac.errorcodes_web_not_support_tsp": "Sie unterst\xfctzen nicht den Start oder die Teilnahme an einem Meeting aus dem Web, wenn Sie den Telefonieanbieter als seinen Audiobeitrag in einem Meeting gew\xe4hlt haben.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "Das Starten eines Webinars vom Internet aus ist nicht zul\xe4ssig.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "Unf\xe4hig beitreten aus Browser, verbinden Sie bitte den Zoom-Desktop-Client oder mobile App."
            },
            "es-ES": {
              "apac.errorcodes_web_has_in_progress": "Ya posee otras reuniones en curso.",
              "apac.errorcodes_web_require_email": "Se requiere correo electr\xf3nico del usuario.",
              "apac.errorcodes_web_not_support_webinar_pac": "No soporta seminario web o conferencia de audio personal",
              "apac.errorcodes_web_host_not_exit": "El anfitri\xf3n de la reuni\xf3n no existe.",
              "apac.errorcodes_web_not_support_webclient": "No se puede iniciar ni entrar a una reuni\xf3n desde la web.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "La versi\xf3n actual de sdk no es compatible con el seminario web, actualice a la \xfaltima versi\xf3n.",
              "apac.errorcodes_web_invalid_id": "ID de reuni\xf3n no v\xe1lida.",
              "apac.errorcodes_web_not_support_registration_webinar": "Seminario web que no es compatible con la inscripci\xf3n",
              "apac.errorcodes_web_not_support_tsp": "Cuando eligi\xf3 el proveedor de servicios telef\xf3nicos como audio en una reuni\xf3n, no se puede iniciar o unirse una reuni\xf3n desde el sitio web.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "No se permite comenzar un seminario web desde la web.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "No puede unirse desde el navegador, por favor unirse usando el cliente de escritorio Zoom o aplicaci\xf3n m\xf3vil."
            },
            "fr-FR": {
              "apac.errorcodes_web_has_in_progress": "Il a d\xE9j\xE0 d\u2019autres r\xE9unions en cours.",
              "apac.errorcodes_web_require_email": "Le courriel de l\u2019utilisateur est requis.",
              "apac.errorcodes_web_not_support_webinar_pac": "Ne prend pas en charge le webinaire ni la conf\xe9rence audio personnelle",
              "apac.errorcodes_web_host_not_exit": "L\u2019animateur de la r\xE9union n\u2019existe pas.",
              "apac.errorcodes_web_not_support_webclient": "Ne supporte pas d\xe9marrer ou rejoindre une r\xe9union \xe0 partir du web.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "La version actuelle du SDK ne prend pas en charge le webinaire, veuillez passer \xe0 la derni\xe8re version.",
              "apac.errorcodes_web_invalid_id": "N\xba de r\xe9union non valide.",
              "apac.errorcodes_web_not_support_registration_webinar": "Ne prend pas en charge le webinaire d\u2019inscription",
              "apac.errorcodes_web_not_support_tsp": "Ne peut pas d\xe9marrer ou rejoindre la r\xe9union depuis Internet, lorsque vous s\xe9lectionnez le fournisseur de service en t\xe9l\xe9phonie comma sa sortie audio dans une r\xe9union.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "Ne pas permettre de d\xe9marrer des webinaires \xe0 partir du Web.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "Impossible de rejoindre le navigateur, s'il vous pla\xeet rejoindre en utilisant le client de bureau Zoom ou une application mobile."
            },
            "jp-JP": {
              "apac.errorcodes_web_has_in_progress": "\u3059\u3067\u306B\u4ED6\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u304C\u59CB\u307E\u3063\u3066\u3044\u307E\u3059\u3002",
              "apac.errorcodes_web_require_email": "\u30E6\u30FC\u30B6\u30FC\u30E1\u30FC\u30EB\u306F\u5FC5\u8981\u3067\u3059\u3002",
              "apac.errorcodes_web_not_support_webinar_pac": "\u30A6\u30A7\u30D3\u30CA\u30FC\u3068\u30D1\u30FC\u30BD\u30CA\u30EB\u97F3\u58F0\u4F1A\u8B70\u304C\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
              "apac.errorcodes_web_host_not_exit": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30DB\u30B9\u30C8\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
              "apac.errorcodes_web_not_support_webclient": "\u30A6\u30A7\u30D6\u304B\u3089\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u958B\u59CB/\u53C2\u52A0\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u307E\u305B\u3093\u3002",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "\u73FE\u5728\u306ESDK\u30D0\u30FC\u30B8\u30E7\u30F3\u306F\u30A6\u30A7\u30D3\u30CA\u30FC\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u6700\u65B0\u30D0\u30FC\u30B8\u30E7\u30F3\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
              "apac.errorcodes_web_invalid_id": "\u7121\u52B9\u306A\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0ID\u3067\u3059\u3002",
              "apac.errorcodes_web_not_support_registration_webinar": "\u767B\u9332\u30A6\u30A7\u30D3\u30CA\u30FC\u975E\u5BFE\u5FDC",
              "apac.errorcodes_web_not_support_tsp": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30AA\u30FC\u30C7\u30A3\u30AA\u306B\u30C6\u30EC\u30D5\u30A9\u30CB\u30FC\u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0\u3092\u9078\u629E\u3057\u305F\u5834\u5408\u3001\u30A6\u30A7\u30D6\u304B\u3089\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u958B\u59CB\u3057\u305F\u308A\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u53C2\u52A0\u3057\u305F\u308A\u3067\u304D\u307E\u305B\u3093\u3002",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "\u30A6\u30A7\u30D3\u30CA\u30FC\u3092\u30A6\u30A7\u30D6\u304B\u3089\u958B\u59CB\u3067\u304D\u307E\u305B\u3093\u3002",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "\u3067\u304D\u307E\u305B\u3093\u304C\u3001\u30D6\u30E9\u30A6\u30B6\u304B\u3089\u53C2\u52A0\u3057\u3001\u30BA\u30FC\u30E0\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3084\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066\u53C2\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
            },
            "pt-PT": {
              "apac.errorcodes_web_has_in_progress": "J\xe1 h\xe1 outras reuni\xf5es em andamento.",
              "apac.errorcodes_web_require_email": "O e-mail do usu\xe1rio \xe9 obrigat\xf3rio.",
              "apac.errorcodes_web_not_support_webinar_pac": "N\xe3o h\xe1 suporte para webinar e audioconfer\xeancia pessoal",
              "apac.errorcodes_web_host_not_exit": "O anfitri\xe3o da reuni\xe3o n\xe3o existe.",
              "apac.errorcodes_web_not_support_webclient": "N\xe3o h\xe1 suporte para iniciar ou entrar na reuni\xe3o pela web.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "A vers\xe3o sdk atual n\xe3o oferece suporte para webinar. Atualize para a vers\xe3o mais recente.",
              "apac.errorcodes_web_invalid_id": "ID da reuni\xe3o inv\xe1lido.",
              "apac.errorcodes_web_not_support_registration_webinar": "O registro do webinar n\xe3o \xe9 compat\xedvel",
              "apac.errorcodes_web_not_support_tsp": "N\xe3o \xe9 compat\xedvel iniciar ou ingressar na reuni\xe3o pela web ao escolher o \xe1udio do provedor de servi\xe7os de telefonia em uma reuni\xe3o.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "N\xe3o \xe9 permitido iniciar o webinar na web.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "Incapaz juntar-se a partir do navegador, por favor, junte-se usando o cliente de desktop Zoom ou aplicativo m\xf3vel."
            },
            "ru-RU": {
              "apac.errorcodes_web_has_in_progress": "\u0423\u0436\u0435 \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044F\u0445.",
              "apac.errorcodes_web_require_email": "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0447\u0442\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.",
              "apac.errorcodes_web_not_support_webinar_pac": "\u041D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440 \u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0430\u0443\u0434\u0438\u043E\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E",
              "apac.errorcodes_web_host_not_exit": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442.",
              "apac.errorcodes_web_not_support_webclient": "\u0417\u0430\u043F\u0443\u0441\u043A \u0438\u043B\u0438 \u0432\u0445\u043E\u0434 \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0442\u044C \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u043F\u0430\u043A\u0435\u0442\u0430 SDK \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u044B. \u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0439 \u0432\u0435\u0440\u0441\u0438\u0438.",
              "apac.errorcodes_web_invalid_id": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438.",
              "apac.errorcodes_web_not_support_registration_webinar": "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0430 \u0432\u0435\u0431\u0438\u043D\u0430\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F",
              "apac.errorcodes_web_not_support_tsp": "\u0415\u0441\u043B\u0438 \u0434\u043B\u044F \u0430\u0443\u0434\u0438\u043E\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A \u0441\u043B\u0443\u0436\u0431\u044B \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0438, \u0442\u0430\u043A\u0443\u044E \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0447\u0430\u0442\u044C \u0438\u043B\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u043D\u0435\u0439 \u0447\u0435\u0440\u0435\u0437 \u0431\u0440\u0430\u0443\u0437\u0435\u0440.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "\u0417\u0430\u043F\u0443\u0441\u043A \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440\u0430 \u0447\u0435\u0440\u0435\u0437 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u0438\u0437 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u0438\u043B\u0438 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435."
            },
            "zh-CN": {
              "apac.errorcodes_web_has_in_progress": "\u5DF2\u7ECF\u6709\u53E6\u4E00\u573A\u4F1A\u8BAE\u6B63\u5728\u8FDB\u884C\u3002",
              "apac.errorcodes_web_require_email": "\u5FC5\u987B\u63D0\u4F9B\u7528\u6237\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002",
              "apac.errorcodes_web_not_support_webinar_pac": "\u975E\u652F\u6301\u7684\u7F51\u7EDC\u7814\u8BA8\u4F1A\u548C\u4E2A\u4EBA\u97F3\u9891\u4F1A\u8BAE",
              "apac.errorcodes_web_host_not_exit": "\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u4E0D\u5B58\u5728\u3002",
              "apac.errorcodes_web_not_support_webclient": "\u4E0D\u652F\u6301\u4ECE Web \u5F00\u59CB\u6216\u52A0\u5165\u4F1A\u8BAE\u3002",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "\u5F53\u524D sdk \u7248\u672C\u4E0D\u652F\u6301\u7F51\u7EDC\u7814\u8BA8\u4F1A\uFF0C\u8BF7\u5347\u7EA7\u5230\u6700\u65B0\u7248\u672C\u3002",
              "apac.errorcodes_web_invalid_id": "\u65E0\u6548\u7684\u4F1A\u8BAEID\u3002",
              "apac.errorcodes_web_not_support_registration_webinar": "\u4E0D\u652F\u6301\u6CE8\u518C\u7F51\u7EDC\u7814\u8BA8\u4F1A",
              "apac.errorcodes_web_not_support_tsp": "\u5982\u679C\u9009\u62E9\u7535\u8BDD\u8BED\u97F3\u670D\u52A1\u63D0\u4F9B\u5546\u4F5C\u4E3A\u4F1A\u8BAE\u97F3\u9891\uFF0C\u5219\u4E0D\u652F\u6301\u901A\u8FC7\u7F51\u7EDC\u5F00\u59CB\u6216\u52A0\u5165\u4F1A\u8BAE\u3002",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "\u4E0D\u5141\u8BB8\u901A\u8FC7\u7F51\u7EDC\u5F00\u59CB\u7F51\u7EDC\u7814\u8BA8\u4F1A",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "\u4ECE\u6D4F\u89C8\u5668\u65E0\u6CD5\u52A0\u5165\uFF0C\u8BF7\u52A0\u5165\u4F7F\u7528\u7F29\u653E\u684C\u9762\u5BA2\u6237\u7AEF\u6216\u79FB\u52A8\u5E94\u7528\u7A0B\u5E8F\u3002"
            },
            "zh-TW": {
              "apac.errorcodes_web_has_in_progress": "\u5DF2\u6709\u5176\u4ED6\u6703\u8B70\u6B63\u5728\u9032\u884C\u4E2D\u3002",
              "apac.errorcodes_web_require_email": "\u5FC5\u9808\u63D0\u4F9B\u4F7F\u7528\u8005\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002",
              "apac.errorcodes_web_not_support_webinar_pac": "\u4E0D\u652F\u63F4\u7DB2\u8DEF\u7814\u8A0E\u6703\u548C\u500B\u4EBA\u97F3\u8A0A\u6703\u8B70",
              "apac.errorcodes_web_host_not_exit": "\u6703\u8B70\u4E3B\u6301\u4EBA\u4E0D\u5B58\u5728\u3002",
              "apac.errorcodes_web_not_support_webclient": "\u4E0D\u652F\u63F4\u5F9E Web \u958B\u59CB\u6216\u52A0\u5165\u6703\u8B70\u3002",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "\u76EE\u524D\u7684 SDK \u7248\u672C\u4E0D\u652F\u63F4\u7DB2\u8DEF\u7814\u8A0E\u6703\uFF0C\u8ACB\u5347\u7D1A\u81F3\u6700\u65B0\u7248\u672C\u3002",
              "apac.errorcodes_web_invalid_id": "\u7121\u6548\u7684\u6703\u8B70 ID \u3002",
              "apac.errorcodes_web_not_support_registration_webinar": "\u4E0D\u652F\u63F4\u8A3B\u518A\u7DB2\u8DEF\u7814\u8A0E\u6703",
              "apac.errorcodes_web_not_support_tsp": "\u7576\u60A8\u9078\u64C7\u96FB\u8A71\u8A9E\u97F3\u670D\u52D9\u4F9B\u61C9\u5546\u505A\u70BA\u6703\u8B70\u8A9E\u97F3\u4F7F\u7528\u6642\uFF0C\u4E0D\u652F\u63F4\u7D93\u7531\u7DB2\u9801\u53EC\u958B\u6216\u52A0\u5165\u6703\u8B70\u3002",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "\u4E0D\u5141\u8A31\u5F9E Web \u958B\u59CB\u7DB2\u8DEF\u7814\u8A0E\u6703\u3002",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "\u5F9E\u700F\u89BD\u5668\u7121\u6CD5\u52A0\u5165\uFF0C\u8ACB\u52A0\u5165\u4F7F\u7528\u7E2E\u653E\u684C\u9762\u5BA2\u6236\u7AEF\u6216\u79FB\u52D5\u61C9\u7528\u7A0B\u5E8F\u3002"
            },
            "ko-KO": {
              "apac.errorcodes_web_has_in_progress": "\uC774\uBBF8 \uB2E4\uB978 \uD68C\uC758\uAC00 \uC9C4\uD589 \uC911\uC785\uB2C8\uB2E4.",
              "apac.errorcodes_web_require_email": "\uC0AC\uC6A9\uC790 \uC774\uBA54\uC77C\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.",
              "apac.errorcodes_web_not_support_webinar_pac": "\uC6E8\uBE44\uB098 \uBC0F \uAC1C\uC778 \uC624\uB514\uC624 \uC804\uD654 \uD68C\uC758\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC74C",
              "apac.errorcodes_web_host_not_exit": "\uD68C\uC758 \uD638\uC2A4\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
              "apac.errorcodes_web_not_support_webclient": "\uC6F9\uC5D0\uC11C \uD68C\uC758\uB97C \uC2DC\uC791\uD558\uAC70\uB098 \uCC38\uC5EC\uD558\uB294 \uAC83\uC740 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "\uD604\uC7AC SDK \uBC84\uC804\uC740 \uC6E8\uBE44\uB098\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uCD5C\uC2E0 \uBC84\uC804\uC73C\uB85C \uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uC2ED\uC2DC\uC624.",
              "apac.errorcodes_web_invalid_id": "\uD68C\uC758 ID\uAC00 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
              "apac.errorcodes_web_not_support_registration_webinar": "\uB4F1\uB85D \uC6E8\uBE44\uB098\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC74C",
              "apac.errorcodes_web_not_support_tsp": "\uD68C\uC758\uC5D0\uC11C Telephony Service Provider\uB97C \uC624\uB514\uC624\uB85C \uC120\uD0DD\uD55C \uACBD\uC6B0 \uC6F9\uC5D0\uC11C \uD68C\uC758\uB97C \uC2DC\uC791\uD558\uAC70\uB098 \uD68C\uC758\uC5D0 \uCC38\uAC00\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "\uC6F9\uC5D0\uC11C \uC6E8\uBE44\uB098\uB97C \uC2DC\uC791\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "\uC218 \uC5C6\uC2B5\uB2C8\uB2E4 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uC870\uC778 \uC90C \uB370\uC2A4\uD06C\uD1B1 \uD074\uB77C\uC774\uC5B8\uD2B8 \uB610\uB294 \uBAA8\uBC14\uC77C \uC571\uC744 \uC0AC\uC6A9\uD558\uC5EC \uAC00\uC785\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4."
            },
            "vi-VN": {
              "apac.errorcodes_web_has_in_progress": "\u0110\xE3 c\xF3 cu\u1ED9c h\u1ECDp kh\xE1c \u0111ang di\u1EC5n ra.",
              "apac.errorcodes_web_require_email": "Email ng\u01B0\u1EDDi d\xF9ng l\xE0 b\u1EAFt bu\u1ED9c.",
              "apac.errorcodes_web_not_support_webinar_pac": "Kh\xF4ng h\u1ED7 tr\u1EE3 h\u1ED9i th\u1EA3ovideo v\xE0 h\u1ED9i ngh\u1ECB \xE2m thanh c\xE1 nh\xE2n",
              "apac.errorcodes_web_host_not_exit": "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC cu\u1ED9c h\u1ECDp kh\xF4ng t\u1ED3n t\u1EA1i.",
              "apac.errorcodes_web_not_support_webclient": "Kh\xF4ng h\u1ED7 tr\u1EE3 b\u1EAFt \u0111\u1EA7u ho\u1EB7c v\xE0o cu\u1ED9c h\u1ECDp t\u1EEB web.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "Phi\xEAn b\u1EA3n sdk hi\u1EC7n t\u1EA1i kh\xF4ng h\u1ED7 tr\u1EE3 h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn, h\xE3y n\xE2ng c\u1EA5p l\xEAn phi\xEAn b\u1EA3n m\u1EDBi nh\u1EA5t.",
              "apac.errorcodes_web_invalid_id": "ID cu\u1ED9c h\u1ECDp kh\xF4ng h\u1EE3p l\u1EC7.",
              "apac.errorcodes_web_not_support_registration_webinar": "Kh\xF4ng h\u1ED7 tr\u1EE3 \u0111\u0103ng k\xFD h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn",
              "apac.errorcodes_web_not_support_tsp": "Kh\xF4ng h\u1ED7 tr\u1EE3 b\u1EAFt \u0111\u1EA7u ho\u1EB7c v\xE0o cu\u1ED9c h\u1ECDp t\u1EEB web, khi b\u1EA1n ch\u1ECDn Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111i\u1EC7n tho\u1EA1i l\xE0m ngu\u1ED3n \xE2m thanh trong cu\u1ED9c h\u1ECDp.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "Kh\xF4ng cho ph\xE9p b\u1EAFt \u0111\u1EA7u h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn t\u1EEB web.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "Kh\xF4ng th\u1EC3 tham gia t\u1EEB tr\xECnh duy\u1EC7t, h\xE3y tham gia b\u1EB1ng c\xE1ch s\u1EED d\u1EE5ng client desktop Ph\xF3ng to ho\u1EB7c \u1EE9ng d\u1EE5ng di \u0111\u1ED9ng."
            },
            "it-IT": {
              "apac.errorcodes_web_has_in_progress": "Sta partecipando a un\u2019altra riunione in corso.",
              "apac.errorcodes_web_require_email": "\xC8 richiesta l\u2019email dell\u2019utente.",
              "apac.errorcodes_web_not_support_webinar_pac": "Non supporta webinar e conferenza audio personale",
              "apac.errorcodes_web_host_not_exit": "L\u2019ospite della riunione non esiste.",
              "apac.errorcodes_web_not_support_webclient": "Non supporta l\u2019avvio o la partecipazione alla riunione dal Web.",
              "apac.errorcodes_web_should_support_webinar_with_latest_version": "La versione sdk corrente non supporta i webinar. Effettua l\u2019aggiornamento alla versione pi\xF9 recente.",
              "apac.errorcodes_web_invalid_id": "ID riunione non valido.",
              "apac.errorcodes_web_not_support_registration_webinar": "Non supporta webinar con iscrizione",
              "apac.errorcodes_web_not_support_tsp": "In caso che hai selezionato il fornitore di servizio telefonico come l\u2019audio in riunione, non supporta l\u2019avvio o la partecipazione alla riunione dal Web.",
              "apac.errorcodes_web_not_allow_start_webinar_from_web": "Non \xe8 consentito avviare il webinar dal Web.",
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": "Impossibile unirsi dal browser, si prega di unirsi con il client desktop Zoom o app mobile."
            }
          },
              Qr = Kr.default,
              Zr = 3051,
              Yr = 3052,
              Jr = 6024,
              $r = 3110,
              Xr = 3099;
          var ei, ti, ni;

          function ri(e, t) {
            return t in Qr ? Qr[t] : e;
          }

          !function (e) {
            e[e.CONF_SUCCESS = 0] = "CONF_SUCCESS", e[e.CONF_FAIL_MEETING_OVER = 6] = "CONF_FAIL_MEETING_OVER", e[e.CONF_FAIL_CONF_USER_FULL = 9] = "CONF_FAIL_CONF_USER_FULL", e[e.CONF_FAIL_CONFLOCKED = 12] = "CONF_FAIL_CONFLOCKED", e[e.CONF_FAIL_WEBINAR_DENIED_EMAIL = 3033] = "CONF_FAIL_WEBINAR_DENIED_EMAIL", e[e.CONF_FAIL_MEETING_HAS_CLOSED = 103003] = "CONF_FAIL_MEETING_HAS_CLOSED", e[e.CONF_FAIL_HAS_BEEN_REMOVED = 103039] = "CONF_FAIL_HAS_BEEN_REMOVED", e[e.CONF_RESULT_MMR_IB_REJECT = 103043] = "CONF_RESULT_MMR_IB_REJECT", e[e.CONF_FAIL_RESULT_MMR_CONF_PARTICIPANT_EXISTS = 103044] = "CONF_FAIL_RESULT_MMR_CONF_PARTICIPANT_EXISTS";
          }(ei || (ei = {})), function (e) {
            e[e.LEAVEREASON_RECONNECT = 5] = "LEAVEREASON_RECONNECT", e[e.LEAVEREASON_KICKEDBYHOST = 7] = "LEAVEREASON_KICKEDBYHOST", e[e.LEAVEREASON_ENDBYHOST = 8] = "LEAVEREASON_ENDBYHOST", e[e.LEAVEREASON_ENDBYHOSTSTARTANOTHERMEETING = 9] = "LEAVEREASON_ENDBYHOSTSTARTANOTHERMEETING", e[e.LEAVEREASON_NORMAL = 1] = "LEAVEREASON_NORMAL";
          }(ti || (ti = {})), function (e) {
            e[e.LEAVESUBREASON_WAITINGROOMFAILOVER = 1] = "LEAVESUBREASON_WAITINGROOMFAILOVER";
          }(ni || (ni = {}));
          var ii = {
            ANOTHER_MEETING_RUNNING: 3e3,
            ERROR_NOT_EXIST: 3001,
            ERROR_NOT_HOST: 3003,
            WRONG_MEETING_PASSWORD: 3004,
            ROLE_TYPE_IS_REQUIRE: 3010,
            EMAIL_REQUIRED: 3005,
            MEETING_NOT_START: 3008,
            BE_REMOVED: 3009,
            ERROR_WEBINAR_ENFORCE_LOGIN: 3034,
            NEED_REAL_NAME: 3082,
            REGISTER_REQUIRED: Xr,
            SSO_LOGIN_WINDOW: Jr,
            ZOOM_LOGIN_WINDOW: Zr,
            ZOOM_SPECIFIC_LOGIN_WINDOW: Yr,
            LOGIN_REQUIRED: 3100,
            RE_CONNECTING: 4e3,
            DISCONNECT: 4001,
            INVALID_PARAMETER: 4003,
            DENIED_REGISTER_WITH_PANELIST: 3032,
            SERVICE_OFFLINE: 403,
            RWC_EMPTY: 3621,
            RWC_ERROR: 3622,
            FREQUENT_CALL: 3633,
            FREQUENT_JOIN: 3634,
            WASM_FAIL: 3635,
            COMMON_ERROR: 200,
            COMMON_SUCCESS: 0,
            UPGRADE: 1e3
          },
              oi = {
            SUCCESS: "apac.errorcodes_success",
            FAIL: "apac.errorcodes_fail",
            MEETING_NOT_INIT: "apac.errorcodes_not_init",
            REGISTER_REQUIRED: "apac.errorcodes_register",
            LOGIN_REQUIRED: "apac.errorcodes_login_required",
            SSO_LOGIN_WINDOW: "apac.errorcodes_login_required",
            ZOOM_LOGIN_WINDOW: "apac.errorcodes_login_required",
            ZOOM_SPECIFIC_LOGIN_WINDOW: "apac.errorcodes_login_required",
            EMAIL_REQUIRED: "apac.errorcodes_email_require",
            ERROR_NOT_EXIST: "apac.errorcodes_not_exist",
            ERROR_NOT_HOST: "apac.errorcodes_not_host",
            WRONG_MEETING_PASSWORD: "apac.errorcodes_wrong_pass",
            ROLE_TYPE_IS_REQUIRE: "apac.errorcodes_role_type",
            ANOTHER_MEETING_RUNNING: "apac.errorcodes_meeting_has_in_progress",
            MEETING_NOT_START: "apac.errorcodes_not_start",
            INVALID_PARAMETER: "apac.invalid_parameter",
            RE_CONNECTING: "apac.errorcodes_re_connect",
            BE_REMOVED: "apac.errorcodes_be_removed",
            ERROR_WEBINAR_ENFORCE_LOGIN: "apac.errorcodes_webinar_enforce_login",
            DISCONNECT: "apac.errorcodes_disconnect",
            DENIED_REGISTER_WITH_PANELIST: "apac.errorcodes_denied_register_with_panelist",
            RWC_EMPTY: "apac.errorcodes_rwc_empty",
            RWC_ERROR: "apac.errorcodes_rwc_error",
            FREQUENT_CALL: "apac.errorcodes_frequent_call",
            FREQUENT_JOIN: "apac.errorcodes_frequent_join",
            WASM_FAIL: "apac.errorcodes_wasm_fail",
            UPGRADE: "apac.errorcodes_upgrade"
          },
              ai = {
            3e3: {
              "apac.errorcodes_web_has_in_progress": 3e3,
              "apac.errorcodes_web_require_email": 3005,
              "apac.errorcodes_web_not_support_webinar_pac": 3701,
              "apac.errorcodes_web_host_not_exit": 3702,
              "apac.errorcodes_web_not_support_webclient": 3603,
              "apac.errorcodes_web_should_support_webinar_with_latest_version": 3604,
              "apac.errorcodes_web_invalid_id": 3703,
              "apac.errorcodes_web_not_support_registration_webinar": 3606,
              "apac.errorcodes_web_not_support_tsp": 3608,
              "apac.errorcodes_web_not_allow_start_webinar_from_web": 3609,
              "apac.errorcodes_need_use_zoom_desktop_or_mobile": 3611
            },
            3001: {
              "apac.errorcodes_not_exist": 3610
            },
            200: {
              "apac.errorcodes_pac_api_wrong": 3704,
              "apac.errorcodes_pac_signature_expired": 3705,
              "apac.errorcodes_pac_mn_wrong": 3706,
              "apac.errorcodes_pac_mn_not_fount": 3707,
              "apac.errorcodes_pac_role_error": 3708,
              "apac.errorcodes_pac_host_not_found": 3709,
              "apac.errorcodes_pac_api_disabled": 3710,
              "apac.errorcodes_pac_cant_host_other_mn": 3711,
              "apac.errorcodes_pac_invalid_signature": 3712,
              "apac.errorcodes_pac_no_permission": 3713
            },
            3099: {
              "apac.errorcodes_register": 3099
            },
            3100: {
              "apac.errorcodes_login_required": 3100
            },
            3003: {
              "apac.errorcodes_not_host": 3003
            },
            3004: {
              "apac.errorcodes_wrong_pass": 3004
            },
            3008: {
              "apac.errorcodes_not_start": 3008
            },
            3009: {
              "apac.errorcodes_be_removed": 3009
            },
            3501: {
              "apac.errorcodes_login_required": 3082
            },
            3502: {
              "apac.errorcodes_login_required": 3082
            },
            3032: {
              "apac.errorcodes_denied_register_with_panelist": 3100
            },
            3033: {
              "apac.errorcodes_denied_email": 3620
            },
            3059: {
              "apac.errorcodes_not_support_simulive": 3630
            },
            3082: {
              "apac.errorcodes_real_name": 3082
            },
            403: {
              "apac.errorcodes_offline": 403
            },
            404: {
              "apac.errorcodes_offline": 403
            },
            4003: {
              "apac.invalid_parameter": 4003
            },
            124: {
              "apac.errorcodes_tk_expired": 3610
            },
            3136: {
              "apac.errorcodes_require_host": 3709
            }
          },
              si = {
            3004: {
              "apac.errorcodes_pac_mn_wrong": 3714
            },
            3005: {
              "apac.errorcodes_web_has_in_progress": 3e3
            },
            3008: {
              "apac.errorcodes_not_start": 3008
            },
            3033: {
              "apac.errorcodes_denied_email": 3620
            },
            1005: {
              "apac.errorcodes_denied_email": 3620
            },
            103039: {
              "apac.errorcodes_be_removed": 3009
            },
            6: {
              "meeting ended": 4004
            },
            9: {
              "meeting is at capacity": 4005
            },
            12: {
              "meeting locked": 4006
            },
            103043: {
              "reject for information barriers": 4007
            },
            103044: {
              "participant exist": 4008
            }
          };

          function ci(e, t) {
            return Object.keys(e).find(function (n) {
              return e[n] === t;
            });
          }

          var li;

          function di(e, t) {
            var _ref = function (e, t) {
              var n = !1;
              if (-1 === e) return {
                key: "apac.errorcodes_offline",
                value: 403
              };

              if (3e3 === e) {
                var _r2 = ["en-US", "de-DE", "es-ES", "en-US", "fr-FR", "jp-JP", "pt-PT", "ru-RU", "zh-CN", "zh-TW", "ko_KO", "vi-VN", "it-IT"];
                var _i2 = {};
                if (li) _i2 = li;else {
                  var _e2 = Object.keys(ai[3e3]);

                  _r2.forEach(function (t) {
                    var n = function (e) {
                      return "en-US" === e && (e = "default"), Kr[e] || Kr.default;
                    }(t);

                    _i2[t] = {}, _e2.forEach(function (e) {
                      _i2[t][e] = n[e];
                    });
                  }), li = _i2;
                }
                return _r2.forEach(function (r) {
                  if (n) return;
                  var o = ci(_i2[r], t);
                  o && (n = {
                    key: o,
                    value: ai[e][o]
                  });
                }), n || (n = {
                  key: "apac.errorcodes_fail",
                  value: 200
                }), n;
              }

              if (200 === e) {
                var _r3 = ci({
                  "apac.errorcodes_pac_api_wrong": "The api key is wrong.",
                  "apac.errorcodes_pac_signature_expired": "The signature has expired.",
                  "apac.errorcodes_pac_mn_wrong": "The meeting number is wrong.",
                  "apac.errorcodes_pac_mn_not_fount": "The meeting number is not found.",
                  "apac.errorcodes_pac_role_error": "The role is not applicable.",
                  "apac.errorcodes_pac_host_not_found": "The meeting host is not found.",
                  "apac.errorcodes_pac_api_disabled": "The account don't enable API.",
                  "apac.errorcodes_pac_cant_host_other_mn": "Can not be host in other account's meeting.",
                  "apac.errorcodes_pac_invalid_signature": "Invalid signature.",
                  "apac.errorcodes_pac_no_permission": "No permission"
                }, t);

                return n = _r3 ? {
                  key: _r3,
                  value: ai[e][_r3]
                } : {
                  key: "apac.errorcodes_fail",
                  value: 200
                }, n;
              }

              if (void 0 !== ai[e]) {
                var _t2 = ai[e],
                    _r4 = Object.keys(_t2)[0];
                n = {
                  key: _r4,
                  value: _t2[_r4]
                };
              }

              if (n) return n;
              var r = ci(ii, e),
                  i = oi[r];
              return i ? {
                key: i,
                value: e
              } : {
                key: "apac.errorcodes_fail",
                value: 200
              };
            }(e, t),
                n = _ref.key,
                r = _ref.value,
                i = ri(n, n);

            return n !== i ? {
              reason: i,
              errorCode: r
            } : {
              reason: Qr[n],
              errorCode: r
            };
          }

          function ui(e) {
            var t = !1;
            var n = "number" == typeof e ? e : e.body.res;

            if (void 0 !== si[n]) {
              var _e3 = si[n],
                  _r5 = Object.keys(_e3)[0];
              t = {
                key: _r5,
                value: _e3[_r5]
              };
            }

            if (t) {
              var _t3 = t,
                  _n2 = _t3.key,
                  _r6 = _t3.value,
                  _i3 = ri(_n2, _n2);

              return _n2 !== _i3 ? Object.assign({}, e, {
                reason: _i3,
                errorCode: _r6
              }) : Object.assign({}, e, {
                reason: Qr[_n2],
                errorCode: _r6
              });
            }

            var r = di(n);
            return Object.assign({}, e, {
              reason: r.reason,
              errorCode: r.errorCode
            });
          }

          var pi = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof n.g ? n.g : "undefined" != typeof self ? self : {};

          function hi(e) {
            return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
          }

          function _i(e, t, n) {
            return e(n = {
              path: t,
              exports: {},
              require: function require(e, t) {
                return function () {
                  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
                }(null == t && n.path);
              }
            }, n.exports), n.exports;
          }

          var fi = _i(function (e, t) {
            !function (t, n) {
              e.exports = function (t) {
                var n,
                    r = (t = t || {}).Base64,
                    i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                    o = function (e) {
                  for (var t = {}, n = 0, r = e.length; n < r; n++) {
                    t[e.charAt(n)] = n;
                  }

                  return t;
                }(i),
                    a = String.fromCharCode,
                    s = function s(e) {
                  if (e.length < 2) return (t = e.charCodeAt(0)) < 128 ? e : t < 2048 ? a(192 | t >>> 6) + a(128 | 63 & t) : a(224 | t >>> 12 & 15) + a(128 | t >>> 6 & 63) + a(128 | 63 & t);
                  var t = 65536 + 1024 * (e.charCodeAt(0) - 55296) + (e.charCodeAt(1) - 56320);
                  return a(240 | t >>> 18 & 7) + a(128 | t >>> 12 & 63) + a(128 | t >>> 6 & 63) + a(128 | 63 & t);
                },
                    c = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g,
                    l = function l(e) {
                  return e.replace(c, s);
                },
                    d = function d(e) {
                  var t = [0, 2, 1][e.length % 3],
                      n = e.charCodeAt(0) << 16 | (e.length > 1 ? e.charCodeAt(1) : 0) << 8 | (e.length > 2 ? e.charCodeAt(2) : 0);
                  return [i.charAt(n >>> 18), i.charAt(n >>> 12 & 63), t >= 2 ? "=" : i.charAt(n >>> 6 & 63), t >= 1 ? "=" : i.charAt(63 & n)].join("");
                },
                    u = t.btoa && "function" == typeof t.btoa ? function (e) {
                  return t.btoa(e);
                } : function (e) {
                  if (e.match(/[^\x00-\xFF]/)) throw new RangeError("The string contains invalid characters.");
                  return e.replace(/[\s\S]{1,3}/g, d);
                },
                    p = function p(e) {
                  return u(l(String(e)));
                },
                    h = function h(e) {
                  return e.replace(/[+\/]/g, function (e) {
                    return "+" == e ? "-" : "_";
                  }).replace(/=/g, "");
                },
                    _ = function _(e, t) {
                  return t ? h(p(e)) : p(e);
                };

                t.Uint8Array && (n = function n(e, t) {
                  for (var n = "", r = 0, o = e.length; r < o; r += 3) {
                    var a = e[r],
                        s = e[r + 1],
                        c = e[r + 2],
                        l = a << 16 | s << 8 | c;
                    n += i.charAt(l >>> 18) + i.charAt(l >>> 12 & 63) + (void 0 !== s ? i.charAt(l >>> 6 & 63) : "=") + (void 0 !== c ? i.charAt(63 & l) : "=");
                  }

                  return t ? h(n) : n;
                });

                var f,
                    m = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g,
                    g = function g(e) {
                  switch (e.length) {
                    case 4:
                      var t = ((7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3)) - 65536;
                      return a(55296 + (t >>> 10)) + a(56320 + (1023 & t));

                    case 3:
                      return a((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));

                    default:
                      return a((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
                  }
                },
                    v = function v(e) {
                  return e.replace(m, g);
                },
                    b = function b(e) {
                  var t = e.length,
                      n = t % 4,
                      r = (t > 0 ? o[e.charAt(0)] << 18 : 0) | (t > 1 ? o[e.charAt(1)] << 12 : 0) | (t > 2 ? o[e.charAt(2)] << 6 : 0) | (t > 3 ? o[e.charAt(3)] : 0),
                      i = [a(r >>> 16), a(r >>> 8 & 255), a(255 & r)];
                  return i.length -= [0, 0, 2, 1][n], i.join("");
                },
                    y = t.atob && "function" == typeof t.atob ? function (e) {
                  return t.atob(e);
                } : function (e) {
                  return e.replace(/\S{1,4}/g, b);
                },
                    w = function w(e) {
                  return y(String(e).replace(/[^A-Za-z0-9\+\/]/g, ""));
                },
                    S = function S(e) {
                  return String(e).replace(/[-_]/g, function (e) {
                    return "-" == e ? "+" : "/";
                  }).replace(/[^A-Za-z0-9\+\/]/g, "");
                },
                    x = function x(e) {
                  return function (e) {
                    return v(y(e));
                  }(S(e));
                };

                if (t.Uint8Array && (f = function f(e) {
                  return Uint8Array.from(w(S(e)), function (e) {
                    return e.charCodeAt(0);
                  });
                }), t.Base64 = {
                  VERSION: "2.6.4",
                  atob: w,
                  btoa: u,
                  fromBase64: x,
                  toBase64: _,
                  utob: l,
                  encode: _,
                  encodeURI: function encodeURI(e) {
                    return _(e, !0);
                  },
                  btou: v,
                  decode: x,
                  noConflict: function noConflict() {
                    var e = t.Base64;
                    return t.Base64 = r, e;
                  },
                  fromUint8Array: n,
                  toUint8Array: f
                }, "function" == typeof Object.defineProperty) {
                  var E = function E(e) {
                    return {
                      value: e,
                      enumerable: !1,
                      writable: !0,
                      configurable: !0
                    };
                  };

                  t.Base64.extendString = function () {
                    Object.defineProperty(String.prototype, "fromBase64", E(function () {
                      return x(this);
                    })), Object.defineProperty(String.prototype, "toBase64", E(function (e) {
                      return _(this, e);
                    })), Object.defineProperty(String.prototype, "toBase64URI", E(function () {
                      return _(this, !0);
                    }));
                  };
                }

                return t.Meteor && (Base64 = t.Base64), e.exports && (e.exports.Base64 = t.Base64), {
                  Base64: t.Base64
                };
              }(t);
            }("undefined" != typeof self ? self : "undefined" != typeof window ? window : pi);
          });

          function mi(e) {
            return fi.Base64.encode(e, !0);
          }

          function gi(e) {
            return fi.Base64.decode(e);
          }

          var vi = {
            "-": "+",
            _: "/",
            ".": "="
          };

          function bi(e) {
            var t = e.replace(/[-_.]/g, function (e) {
              return vi[e];
            });
            return Uint8Array.from(atob(t), function (e) {
              return e.charCodeAt(0);
            });
          }

          function yi(e) {
            if ("" === e || void 0 === e) return 0;
            var t = 0;

            for (var _n3 = 0; _n3 < e.length; _n3++) {
              e.charCodeAt(_n3) <= parseInt("0x7F", 16) ? t += 1 : e.charCodeAt(_n3) <= parseInt("0x7FF", 16) ? t += 2 : e.charCodeAt(_n3) <= parseInt("0xFFFF", 16) ? t += 3 : e.charCodeAt(_n3) <= parseInt("0x1FFFFF", 16) ? t += 4 : e.charCodeAt(_n3) <= parseInt("0x3FFFFFF", 16) ? t += 5 : t += 6;
            }

            return t;
          }

          var wi = function wi(e) {
            var t = e.charCodeAt(0);
            return t <= parseInt("0x7F", 16) ? 1 : t <= parseInt("0x7FF", 16) ? 2 : t <= parseInt("0xFFFF", 16) ? 3 : t <= parseInt("0x1FFFFF", 16) ? 4 : t <= parseInt("0x3FFFFFF", 16) ? 5 : 6;
          },
              Si = function Si(e, t) {
            var n = e.split(".").map(function (e) {
              return Number(e);
            }).slice(0, 3),
                r = t.split(".").map(function (e) {
              return Number(e);
            }).slice(0, 3);
            var i = 0;

            for (var _o2 = 0; _o2 < 3; _o2++) {
              var _e4 = _o2 < n.length ? n[_o2] : 0,
                  _t4 = _o2 < r.length ? r[_o2] : 0;

              if (_e4 < _t4) {
                i = -1;
                break;
              }

              if (_e4 > _t4) {
                i = 1;
                break;
              }
            }

            return i;
          },
              xi = ["bLock", "bHoldUponEntry", "viewOnly", "listenOnlyPhone", "bAllowRaiseHand", "bAllowAttendeeRename", "bBroadcast", "bAllowPlayChimeForEnterOrExit", "bIbDisableShare", "bIbDisableChat", "encryptKey", "bNoHostTimeOut", "bAllowShowCount", "bHasAST", "bHasRMC"],
              Ei = {
            bChime: "bAllowPlayChimeForEnterOrExit",
            bHasAST: "hasAst",
            bHasRMC: "hasRmc",
            topic: function topic(e) {
              return {
                meetingTopic: gi(e)
              };
            }
          },
              Ci = Ln("GET_MEETING_INFO"),
              ki = Ln("GET_INSTANT_MEETING_INFO"),
              Ai = Ln("LOGON_ZOOM_DOMAIN"),
              Ii = Ln("VERIFY_ZOOM_RECAPTCHA"),
              Ti = Ln("LOGON_THIRD_PARTY_DOMAIN"),
              Oi = Ln("PING_RWC_SERVER"),
              Ri = Ln("MEETING_FAILOVER"),
              Ni = Ln("LEAVE_MEETING"),
              Pi = Ln("END_MEETING"),
              ji = Ln("REGISTER_WEBINAR");

          Ln("TRIGGER_IDLE_CHECK");

          var _or3 = or({
            SET_MEETING_INFO: function SET_MEETING_INFO(e) {
              return e;
            },
            SET_WINDOWN_OPEN: function SET_WINDOWN_OPEN(e) {
              return e;
            },
            SET_APPID_SIGNATURE: function SET_APPID_SIGNATURE(e) {
              return e;
            },
            SET_ZTK: function SET_ZTK(e) {
              return e;
            },
            SET_ZSK: function SET_ZSK(e) {
              return e;
            },
            SET_TK_MTKGUID: function SET_TK_MTKGUID(e) {
              return e;
            },
            SET_PING_RWC_TIMESTAMP: function SET_PING_RWC_TIMESTAMP(e) {
              return e;
            },
            SET_IN_MEETING_INFO: function SET_IN_MEETING_INFO(e) {
              return e;
            },
            SET_MEETING_ATTRIBUTE: function SET_MEETING_ATTRIBUTE(e) {
              if (xi.some(function (t) {
                return e && void 0 !== e[t];
              })) {
                var _t5 = e;
                return Object.keys(Ei).some(function (t) {
                  return void 0 !== e[t];
                }) && (_t5 = Object.keys(e).reduce(function (t, n) {
                  var r = Ei[n];
                  return "function" == typeof r ? Object.assign(t, r(e[n])) : "string" == typeof r ? t[r] = e[n] : (t[n], e[n]), t;
                }, {})), _t5;
              }

              return {};
            },
            SET_IS_HOST: function SET_IS_HOST(e) {
              return e && e.bHost;
            },
            SET_IS_COHOST: function SET_IS_COHOST(e) {
              return e && e.bCoHost;
            },
            RESET_MEETING: function RESET_MEETING(e) {
              return e;
            },
            SET_MEETING_IS_ON_HOLD: function SET_MEETING_IS_ON_HOLD(e) {
              return e;
            },
            SET_IS_MEETING_RESET: function SET_IS_MEETING_RESET(e) {
              return e;
            },
            SET_AUDIO_VIDEO_BEFORE_ON_HOLD: function SET_AUDIO_VIDEO_BEFORE_ON_HOLD(e) {
              return e;
            },
            SET_CURRENT_USER_AUDIO_BEFORE_RESET: function SET_CURRENT_USER_AUDIO_BEFORE_RESET(e) {
              return e;
            },
            SET_IS_CURRENT_USER_MUTED_BEFORE_RESET: function SET_IS_CURRENT_USER_MUTED_BEFORE_RESET(e) {
              return e;
            },
            SET_MEETING_STATUS: function SET_MEETING_STATUS(e) {
              return e;
            },
            SET_MEETING_REGION: function SET_MEETING_REGION(e) {
              return e;
            },
            SET_IS_CURRENT_USER_START_VIDEO_BEFORE_RESET: function SET_IS_CURRENT_USER_START_VIDEO_BEFORE_RESET(e) {
              return e;
            },
            SET_JOIN_MEETING_TIME_STAMP: function SET_JOIN_MEETING_TIME_STAMP(e) {
              return e;
            },
            SET_IS_ENABLE_QOS: function SET_IS_ENABLE_QOS(e) {
              return e;
            },
            SET_ACTIVE_APP_INFO: function SET_ACTIVE_APP_INFO(e) {
              return e;
            },
            SET_MEETING_IDLE_START_TIME: function SET_MEETING_IDLE_START_TIME(e) {
              return e;
            },
            SET_SESSION_IDLE_TIMEOUT_MINUTES: function SET_SESSION_IDLE_TIMEOUT_MINUTES(e) {
              return e;
            },
            SET_IS_AUDIO_BRIDGE_ENABLED: function SET_IS_AUDIO_BRIDGE_ENABLED(e) {
              return e;
            },
            ADD_DISCARDED_RWC_HOST: function ADD_DISCARDED_RWC_HOST(e) {
              return e;
            },
            SET_SHARE_PRONOUN_TYPE: function SET_SHARE_PRONOUN_TYPE(e) {
              return e;
            },
            SET_IS_STAY_AWAKE_DURING_THE_SESSION: function SET_IS_STAY_AWAKE_DURING_THE_SESSION(e) {
              return e;
            }
          }),
              Di = _or3.setMeetingInfo,
              zi = _or3.setWindownOpen,
              Mi = _or3.setAppidSignature,
              Li = _or3.setZtk,
              Ui = _or3.setZsk,
              Bi = _or3.setTkMtkguid,
              Hi = _or3.setPingRwcTimestamp,
              Vi = _or3.setInMeetingInfo,
              qi = _or3.setMeetingAttribute,
              Fi = _or3.resetMeeting,
              Wi = _or3.setIsHost,
              Gi = _or3.setIsCohost,
              Ki = _or3.setMeetingIsOnHold,
              Qi = _or3.setIsMeetingReset,
              Zi = _or3.setAudioVideoBeforeOnHold,
              Yi = _or3.setCurrentUserAudioBeforeReset,
              Ji = _or3.setIsCurrentUserMutedBeforeReset,
              $i = _or3.setMeetingStatus,
              Xi = _or3.setMeetingRegion,
              eo = _or3.setIsCurrentUserStartVideoBeforeReset,
              to = _or3.setJoinMeetingTimeStamp,
              no = _or3.setIsEnableQos,
              ro = _or3.setActiveAppInfo,
              io = _or3.setMeetingIdleStartTime,
              oo = _or3.setSessionIdleTimeoutMinutes,
              ao = _or3.setIsAudioBridgeEnabled,
              so = _or3.addDiscardedRwcHost,
              co = _or3.setSharePronounType,
              lo = _or3.setIsStayAwakeDuringTheSession;

          var uo, po, ho, _o, fo, mo, go, vo, bo;

          !function (e) {
            e[e.None = 0] = "None", e[e.Hand = 1] = "Hand", e[e.Yes = 2] = "Yes", e[e.No = 3] = "No", e[e.Fast = 4] = "Fast", e[e.Slow = 5] = "Slow", e[e.Bad = 6] = "Bad", e[e.Good = 7] = "Good", e[e.Clap = 8] = "Clap", e[e.Coffee = 9] = "Coffee", e[e.Clock = 10] = "Clock", e[e.Emoji = 11] = "Emoji";
          }(uo || (uo = {})), function (e) {
            e.LoginSuccess = "zoomLoginSuccess", e.LoginFail = "zoomLoginFail", e.CaptchaSuccess = "captchaSuccess", e.CaptchaFail = "captchaFail", e.SSOLoginSuccess = "ssoLoginSuccess", e.SSOLoginFail = "ssoLoginFail", e.JoinSuccess = "joinSuccess", e.RegisterSuccess = "registerSuccess";
          }(po || (po = {})), function (e) {
            e.Failover = "failover", e.OnHold = "on hold", e.Promote = "promote", e.Depromote = "depromote", e.JoinBreakoutRoom = "join breakout room", e.MoveToBreakoutRoom = "move to breakout room", e.BackToMainSession = "back to main session";
          }(ho || (ho = {})), function (e) {
            e.CDN = "CDN", e.Global = "Global", e.CN = "CN";
          }(_o || (_o = {})), function (e) {
            e.Connected = "Connected", e.Reconnecting = "Reconnecting", e.Closed = "Closed", e.Fail = "Fail";
          }(fo || (fo = {})), function (e) {
            e.Loading = "loading", e.Success = "success", e.Fail = "fail";
          }(mo || (mo = {})), function (e) {
            e.Initial = "initial", e.Joined = "joined", e.Closed = "closed";
          }(go || (go = {})), function (e) {
            e.AudioBridgeEnable = "1,2";
          }(vo || (vo = {})), function (e) {
            e.LocalStorage = "LocalStorage", e.SessionStorage = "SessionStorage", e.Memory = "Memory";
          }(bo || (bo = {}));
          var yo = mi("{}");

          var wo = /*#__PURE__*/function () {
            function wo(e) {
              _classCallCheck(this, wo);

              this.sessionStorageKey = void 0, this.localStorageKey = void 0, this.sessionCache = void 0, this.localCache = void 0, this.memoryCache = void 0, this.sessionStorageKey = mi("zoom-storage-".concat(e)), this.localStorageKey = mi("zoom-local-storage"), this.memoryCache = {}, this.sessionCache = JSON.parse(gi(sessionStorage.getItem(this.sessionStorageKey) || yo)), this.localCache = JSON.parse(gi(localStorage.getItem(this.localStorageKey) || yo));
            }

            _createClass(wo, [{
              key: "getValue",
              value: function getValue(e) {
                return this.sessionCache.hasOwnProperty(e) ? {
                  value: this.sessionCache[e],
                  type: bo.SessionStorage
                } : this.localCache.hasOwnProperty(e) ? {
                  value: this.localCache[e],
                  type: bo.LocalStorage
                } : {
                  value: this.memoryCache[e],
                  type: bo.Memory
                };
              }
            }, {
              key: "setValue",
              value: function setValue(e, t, n) {
                if (!e) throw new Error("key is null");

                switch (n) {
                  case bo.SessionStorage:
                    {
                      var _n4 = this.sessionCache[e];
                      var _r7 = t;
                      return "function" == typeof t && (_r7 = t(_n4)), _n4 !== _r7 && (this.sessionCache[e] = _r7, this.flushValue(bo.SessionStorage)), _r7;
                    }

                  case bo.LocalStorage:
                    {
                      var _n5 = this.localCache[e];
                      var _r8 = t;
                      return "function" == typeof t && (_r8 = t(_n5)), _n5 !== _r8 && (this.localCache[e] = _r8, this.flushValue(bo.LocalStorage)), _r8;
                    }

                  case bo.Memory:
                    {
                      var _n6 = this.memoryCache[e];
                      var _r9 = t;
                      return "function" == typeof t && (_r9 = t(_n6)), this.memoryCache[e] = _r9, _r9;
                    }

                  default:
                    return null;
                }
              }
            }, {
              key: "removeValue",
              value: function removeValue(e) {
                var _this$getValue = this.getValue(e),
                    t = _this$getValue.type;

                switch (t) {
                  case bo.SessionStorage:
                    delete this.sessionCache[e], this.flushValue(bo.SessionStorage);
                    break;

                  case bo.LocalStorage:
                    delete this.localCache[e], this.flushValue(bo.LocalStorage);
                    break;

                  case bo.Memory:
                    delete this.memoryCache[e];
                }
              }
            }, {
              key: "flushValue",
              value: function flushValue(e) {
                e === bo.SessionStorage ? sessionStorage.setItem(this.sessionStorageKey, mi(JSON.stringify(this.sessionCache))) : e === bo.LocalStorage && localStorage.setItem(this.localStorageKey, mi(JSON.stringify(this.localCache)));
              }
            }], [{
              key: "init",
              value: function init(e) {
                this.instance = new wo(e);
              }
            }, {
              key: "get",
              value: function get(e) {
                if (void 0 === this.instance) throw new Error("read before initial");
                return this.instance.getValue(e).value;
              }
            }, {
              key: "set",
              value: function set(e, t, n) {
                if (void 0 === this.instance) throw new Error("set before initial");
                return this.instance.setValue(e, t, n);
              }
            }, {
              key: "remove",
              value: function remove(e) {
                if (void 0 === this.instance) throw new Error("remove before initial");
                return this.instance.removeValue(e);
              }
            }, {
              key: "clearSession",
              value: function clearSession() {
                if (void 0 === this.instance) throw new Error("clear before initial");
                return this.instance.memoryCache = {}, this.instance.sessionCache = {}, this.instance.localCache = {}, sessionStorage.removeItem(this.instance.sessionStorageKey);
              }
            }]);

            return wo;
          }();

          function So() {
            var e = navigator.userAgent;
            var t,
                n = e.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            return /trident/i.test(n[1]) ? (t = /\brv[ :]+(\d+)/g.exec(e) || [], "IE ".concat(t[1] || "")) : "Chrome" === n[1] && (t = e.match(/\b(OPR|Edge)\/(\d+)/), t && t.length) ? t.slice(1).join(" ").replace("OPR", "Opera") : (n = n[2] ? [n[1], n[2]] : [navigator.appName, navigator.appVersion, "-?"], (t = e.match(/version\/(\d+)/i)) && n.splice(1, 1, t[1]), To() && (n[0] = "ios-safari"), n.join(""));
          }

          function xo() {
            var e = navigator.userAgent.toLowerCase();
            return !/opera|opr\/[\d]+/.test(e) && /(msie|trident)/.test(e);
          }

          function Eo() {
            return "object" == typeof WebAssembly && "function" == typeof Worker;
          }

          wo.instance = void 0;

          var Co = function Co() {
            return "function" == typeof AudioWorklet;
          },
              ko = function ko() {
            return xo();
          },
              Ao = function Ao() {
            return !xo() && !Eo();
          },
              Io = function Io() {
            var _navigator = navigator,
                e = _navigator.userAgent;
            return !/opera|opr\/[\d]+/i.test(navigator.userAgent) && !/edge\/(\d+)/i.test(navigator.userAgent) && /chrome/i.test(e) && /webkit/i.test(e);
          },
              To = function To() {
            var _navigator2 = navigator,
                e = _navigator2.userAgent;
            return /iPad|iPhone|iPod/i.test(e) || /MacIntel/i.test(navigator.platform) && (null === (t = navigator) || void 0 === t ? void 0 : t.maxTouchPoints) > 2;
            var t;
          },
              Oo = function Oo() {
            return /arm/i.test(navigator.userAgent);
          },
              Ro = function Ro() {
            return /\bCrOS\b/.test(navigator.userAgent);
          };

          function No() {
            return Mo() || To();
          }

          var Po = function Po() {
            var e;
            return !(null === (e = navigator) || void 0 === e || !e.hardwareConcurrency || No() || "function" != typeof window.OffscreenCanvas || "function" != typeof window.requestAnimationFrame || "function" != typeof window.SharedArrayBuffer);
          };

          function jo() {
            return "function" == typeof window.MediaStreamTrackProcessor;
          }

          function Do() {
            return "function" == typeof window.OffscreenCanvas;
          }

          var zo = function zo(e) {
            var t;
            return Po() ? Ro() && Oo() || Ro() && !Oo() ? navigator.hardwareConcurrency >= 4 ? 9 : 4 : (null === (t = navigator) || void 0 === t ? void 0 : t.hardwareConcurrency) < 4 ? 9 : 25 : e && jo() && Do() ? 4 : 1;
          };

          function Mo() {
            return /android/i.test(navigator.userAgent);
          }

          function Lo() {
            return !navigator.mediaDevices.getSupportedConstraints().aspectRatio || /firefox/i.test(navigator.userAgent) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          }

          var Uo, Bo;
          !function (e) {
            e.VIDEO_ENCODE = "0", e.VIDEO_DECODE = "1", e.AUDIO_ENCODE = "2", e.AUDIO_DECODE = "3", e.SHARING_ENCODE = "4", e.SHARING_DECODE = "5";
          }(Uo || (Uo = {})), function (e) {
            e[e.NONE = 0] = "NONE", e[e.AES_256 = 1] = "AES_256", e[e.AES_GCM = 2] = "AES_GCM";
          }(Bo || (Bo = {}));
          var Ho = Object.freeze({
            RWG_CHAT: {
              gcmType: 1,
              sessionType: "RWG_CHAT"
            },
            XMPP_CHAT: {
              gcmType: 1,
              sessionType: "XMPP_CHAT"
            },
            CC_MESSAGE: {
              gcmType: 3,
              sessionType: "CC_MESSAGE"
            },
            BO_BROADCAST: {
              gcmType: 1,
              sessionType: "BO_BROADCAST"
            }
          });
          var Vo, qo;
          !function (e) {
            e.WebclientOpt = "WEB_CLIENT_OPT", e.WebclientWebinarToken = "WEB_CLIENT_WEBINAR_TOKEN", e.WebclientMeetingToken = "WEB_CLIENT_MEETING_TOKEN", e.WebclientZtk = "WEB_CLIENT_ZTK", e.WebclientZsk = "WEB_CLIENT_ZSK", e.WebclientTk = "WEB_CLIENT_TK", e.WebclientIVState = "WEB_CLIENT_IV_STATE", e.WebclientIsOnHold = "WEB_CLIENT_IS_ON_HOLD", e.WebclientUserId = "WEB_CLIENT_USER_ID", e.WebclientParticipantId = "WEB_CLIENT_PARTICIPANT_ID", e.WebclientZoomId = "WEB_CLIENT_ZOOM_ID", e.WebclientUserName = "WEB_CLIENT_USER_NAME", e.WebclientUserEmail = "WEB_CLIENT_USER_EMAIL", e.WebclientBreakoutRoomAttendeeStatus = "WEB_CLIENT_BO_ATTENDEE_STATUS", e.WebclientBreakoutRoomCommand = "WEB_CLIENT_BO_COMMAND", e.WebclientAudioEncryptKey = "WEB_CLIENT_AUDIO_ENCRYPT_KEY", e.WebclientVideoEncryptKey = "WEB_CLIENT_VIDEO_ENCRYPT_KEY", e.WebclientSharingEncryptKey = "WEB_CLIENT_SHARING_ENCRYPT_KEY";
          }(Vo || (Vo = {})), function (e) {
            e.WebclientDeviceId = "WEBCLIENT_DEVICE_ID";
          }(qo || (qo = {}));
          var Fo = (window.crypto || window.msCrypto).subtle,
              Wo = Vo.WebclientIVState,
              Go = Object.keys(Ho).map(function (e) {
            return Ho[e].sessionType;
          });

          var Ko = /*#__PURE__*/function () {
            function Ko(e, t, n) {
              _classCallCheck(this, Ko);

              this.isGCMEnabled = void 0, this.gcmSessionKey = void 0, this.gcmMainSessionKey = void 0, this.zoomId = void 0, this.resetParameters(e, t, n), wo.set(Wo, {}, bo.SessionStorage);
            }

            _createClass(Ko, [{
              key: "resetParameters",
              value: function resetParameters(e, t, n) {
                this.isGCMEnabled = !(xo() || !Eo()) && n === Bo.AES_GCM, this.gcmSessionKey = bi(t), this.gcmMainSessionKey || (this.gcmMainSessionKey = this.gcmSessionKey), this.zoomId = String(e);
              }
            }, {
              key: "beginCrypto",
              value: function beginCrypto(e, t, n) {
                var r = new Uint32Array(1);
                r[0] = 9, r[0] += Number(n);
                var i = new Uint8Array(r.buffer);
                var o = new Uint8Array(132);
                var a = bi(t);
                return o.set(a, 0), o.set(i, a.length), o = o.subarray(0, a.length + 4), Fo.importKey("raw", e, {
                  name: "HMAC",
                  hash: "SHA-256"
                }, !0, ["sign"]).then(function (e) {
                  return Fo.sign({
                    name: "HMAC"
                  }, e, o);
                }).then(function (e) {
                  return Fo.importKey("raw", e, {
                    name: "AES-GCM",
                    length: 256
                  }, !0, ["encrypt", "decrypt"]);
                });
              }
            }, {
              key: "getNextIV",
              value: function getNextIV(e) {
                var t = wo.get(Wo);
                return void 0 === t[e] ? (t[e] = 0, wo.set(Wo, t, bo.SessionStorage)) : wo.set(Wo, function (t) {
                  return f(f({}, t), {}, _defineProperty({}, e, t[e] + 1));
                }, bo.SessionStorage);
              }
            }, {
              key: "resetIVState",
              value: function resetIVState() {
                var e = wo.get(Wo);
                if (void 0 === e) ;else {
                  var _t6 = Object.keys(e).filter(function (e) {
                    return Go.indexOf(e) > -1;
                  });

                  _t6.length > 0 && (_t6.forEach(function (t) {
                    e[t] += 1e6;
                  }), wo.set(Wo, e, bo.SessionStorage));
                }
              }
            }], [{
              key: "init",
              value: function init(e, t, n) {
                this.instance ? this.instance.resetParameters(e, t, n) : this.instance = new Ko(e, t, n);
              }
            }, {
              key: "destroy",
              value: function destroy() {
                this.instance && (this.instance = void 0);
              }
            }, {
              key: "resetIV",
              value: function resetIV() {
                if (void 0 === this.instance) throw new Error("reset before intialize");
                this.instance.resetIVState();
              }
            }, {
              key: "beginEncrypt",
              value: function beginEncrypt(e) {
                var t = e.text,
                    n = e.type;
                var r = new Uint8Array(0);

                if (this.instance && this.instance.isGCMEnabled) {
                  var _e5 = 16,
                      _i4 = this.instance.getNextIV(n.sessionType),
                      _o3 = new ArrayBuffer(16),
                      _a2 = new Uint8Array(_o3);

                  new DataView(_o3).setUint32(0, _i4, !0);
                  var _s3 = null;
                  return _s3 = "BO_BROADCAST" === n.sessionType ? this.instance.gcmMainSessionKey : this.instance.gcmSessionKey, this.instance.beginCrypto(_s3, this.instance.zoomId, n.gcmType).then(function (n) {
                    var i = new TextEncoder().encode(t);
                    return Fo.encrypt({
                      name: "AES-GCM",
                      iv: _a2,
                      additionalData: r,
                      tagLength: 8 * _e5
                    }, n, i);
                  }).then(function (t) {
                    var n = 1 + _a2.byteLength + 2 + r.byteLength + 4 + t.byteLength,
                        i = new ArrayBuffer(n);
                    new Uint8Array(i)[0] = _a2.length, new Uint8Array(i, 1, _a2.byteLength).set(_a2), new DataView(i).setUint16(1 + _a2.byteLength, r.length, !0), new Uint8Array(i, 3 + _a2.byteLength).set(r), new DataView(i).setUint32(1 + _a2.byteLength + 2 + r.byteLength, t.byteLength - _e5, !0), new Uint8Array(i, 1 + _a2.byteLength + 2 + r.byteLength + 4).set(new Uint8Array(t));
                    var o = new Uint8Array(i).reduce(function (e, t) {
                      return e + String.fromCharCode(t);
                    }, "");
                    return window.btoa(o).replace(/_/g, "/").replace(/-/g, "+").replace(/\=/g, "");
                  });
                }

                return Promise.resolve(mi(t));
              }
            }, {
              key: "beginDecrypt",
              value: function beginDecrypt(e) {
                var t = e.decryptedText,
                    n = e.type,
                    r = e.zoomId;

                if (this.instance && this.instance.isGCMEnabled) {
                  var _e6 = function (e) {
                    var t;
                    var n = e.length,
                        r = new Array(n);

                    for (t = 0; t < n; ++t) {
                      r[t] = 255 & e.charCodeAt(t);
                    }

                    return new Uint8Array(r);
                  }(atob(t.replace(/_/g, "/").replace(/-/g, "+"))),
                      _i5 = _e6[0],
                      _o4 = _e6.slice(1, _i5 + 1),
                      _a3 = _e6.slice(1 + _i5, 3 + _i5),
                      _s4 = new DataView(_a3.buffer).getUint16(0, !0),
                      _c2 = _e6.slice(1 + _i5 + 2, 1 + _i5 + 2 + _s4),
                      _l2 = _e6.slice(1 + _i5 + 2 + _s4, 1 + _i5 + 2 + _s4 + 4),
                      _d2 = new DataView(_l2.buffer).getUint32(0, !0),
                      _u2 = _e6.slice(1 + _i5 + 2 + _s4 + 4, 1 + _i5 + 2 + _s4 + 4 + _d2),
                      _p2 = _e6.slice(1 + _i5 + 2 + _s4 + 4 + _d2);

                  var _h2 = null;
                  return _h2 = "BO_BROADCAST" === n.sessionType ? this.instance.gcmMainSessionKey : this.instance.gcmSessionKey, this.instance.beginCrypto(_h2, r, n.gcmType).then(function (e) {
                    var t = function (e, t) {
                      e = new Uint8Array(e), t = new Uint8Array(t);
                      var n = new Uint8Array(e.length + t.length);
                      return n.set(e), n.set(t, e.length), n;
                    }(_u2, _p2);

                    return Fo.decrypt({
                      name: "AES-GCM",
                      iv: _o4,
                      additionalData: _c2,
                      tagLength: 8 * _p2.length
                    }, e, t.buffer);
                  }).then(function (e) {
                    return {
                      message: new TextDecoder().decode(e),
                      iv: _o4,
                      aad: _c2
                    };
                  }).catch(function (e) {
                    return {
                      message: "[".concat("This is an encrypted message", "]"),
                      iv: _o4,
                      aad: _c2
                    };
                  });
                }

                {
                  var _e7 = new TextDecoder("utf-8");

                  return Promise.resolve({
                    message: _e7.decode(bi(t))
                  });
                }
              }
            }]);

            return Ko;
          }();

          Ko.instance = void 0;
          var Qo = 20234,
              Zo = 12039,
              Yo = 16138;
          var Jo, $o, Xo, ea, ta;
          !function (e) {
            e[e.NoAttendee = 0] = "NoAttendee", e[e.All = 1] = "All", e[e.AllPanelist = 2] = "AllPanelist", e[e.Host = 3] = "Host", e[e.NoOne = 4] = "NoOne", e[e.EveryonePublicly = 5] = "EveryonePublicly";
          }(Jo || (Jo = {})), function (e) {
            e[e.AllPanelist = 1] = "AllPanelist", e[e.Everyone = 2] = "Everyone", e[e.Invalid = 0] = "Invalid";
          }($o || ($o = {})), function (e) {
            e[e.All = 0] = "All", e[e.Panelist = 1] = "Panelist", e[e.IndividualCcPanelist = 2] = "IndividualCcPanelist", e[e.Individual = 3] = "Individual", e[e.SilentModeUsers = 4] = "SilentModeUsers";
          }(Xo || (Xo = {})), function (e) {
            e[e.None = 0] = "None", e[e.Delete = 1] = "Delete", e[e.Modify = 2] = "Modify";
          }(ea || (ea = {})), function (e) {
            e[e.Success = 0] = "Success", e[e.Delete = 1] = "Delete", e[e.Block = 3] = "Block";
          }(ta || (ta = {}));
          var na = [Jo.All, Jo.Host, Jo.NoOne, Jo.EveryonePublicly],
              ra = [Jo.NoOne, Jo.All, Jo.AllPanelist],
              ia = {
            AllPanelist: 11,
            Everyone: 12
          },
              oa = (_oa = {}, _defineProperty(_oa, ia.AllPanelist, $o.AllPanelist), _defineProperty(_oa, ia.Everyone, $o.Everyone), _oa),
              aa = {
            userId: Xo.All,
            displayName: "Everyone",
            isHost: !1,
            isCoHost: !1
          },
              sa = {
            userId: Xo.Panelist,
            displayName: "All panelists"
          },
              ca = {
            userId: Xo.SilentModeUsers,
            displayName: "Everyone (in Waiting Room)",
            isHost: !1,
            isCoHost: !1
          };
          var la;
          !function (e) {
            e.Open = "open", e.Message = "message", e.Error = "error", e.Close = "close";
          }(la || (la = {}));

          var da = /*#__PURE__*/function () {
            function da() {
              _classCallCheck(this, da);

              this.eventHandlers = void 0, this.websocket = void 0, this.seq = void 0, this.intervalsToBeCleardWhenSocketClose = [], this.heartBeatInterval = 6e4, this.eventHandlers = new Map(), this.websocket = null, this.seq = 1;
            }

            _createClass(da, [{
              key: "on",
              value: function on(e, t) {
                var n = this.eventHandlers.get(e);
                n || (n = []), n.push(t), this.eventHandlers.set(e, n);
              }
            }, {
              key: "off",
              value: function off(e, t) {
                var n = this.eventHandlers.get(e);

                if (n) {
                  var _r10 = n.filter(function (e) {
                    return e !== t;
                  });

                  this.eventHandlers.set(e, _r10);
                }
              }
            }, {
              key: "emit",
              value: function emit(e, t) {
                var n = this.eventHandlers.get(e);
                n && n instanceof Array && n.slice(0).forEach(function (e) {
                  try {
                    e(t);
                  } catch (e) {
                    console.error(e);
                  }
                });
              }
            }, {
              key: "sendMessageToRwg",
              value: function sendMessageToRwg(e) {
                this.seq += 1;
                var t = this.seq;
                return this.websocket && this.websocket.readyState === WebSocket.OPEN && this.websocket.send(JSON.stringify(Object.assign(e, {
                  seq: t
                }))), t;
              }
            }, {
              key: "connect",
              value: function connect(e) {
                this.websocket = new WebSocket(e), this.websocket.binaryType = "arraybuffer", this.addWebSocketEventListeners();
              }
            }, {
              key: "close",
              value: function close() {
                var e;
                null === (e = this.websocket) || void 0 === e || e.close();
              }
            }, {
              key: "addHeartBeat",
              value: function addHeartBeat() {
                var _this = this;

                var e = setInterval(function () {
                  _this.sendMessageToRwg({
                    evt: 0
                  });
                }, this.heartBeatInterval);
                this.intervalsToBeCleardWhenSocketClose.push(e);
              }
            }, {
              key: "clearIntervals",
              value: function clearIntervals() {
                this.intervalsToBeCleardWhenSocketClose.forEach(function (e) {
                  return clearInterval(e);
                });
              }
            }, {
              key: "addWebSocketEventListeners",
              value: function addWebSocketEventListeners() {
                var _this2 = this;

                this.websocket && (this.websocket.addEventListener("open", function (e) {
                  _this2.addHeartBeat(), _this2.emit("open", e);
                }), this.websocket.addEventListener("message", function (e) {
                  _this2.emit("message", e);
                }), this.websocket.addEventListener("close", function (e) {
                  _this2.clearIntervals(), _this2.emit("close", e);
                }), this.websocket.addEventListener("error", function (e) {
                  _this2.emit("error", e);
                }));
              }
            }, {
              key: "joinMeeting",
              value: function joinMeeting(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4097,
                    body: {
                      meetingtoken: e
                    }
                  })
                };
              }
            }, {
              key: "lockMeeting",
              value: function lockMeeting(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4099,
                    body: {
                      bLock: e
                    }
                  })
                };
              }
            }, {
              key: "endMeeting",
              value: function endMeeting() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4101,
                    body: {}
                  })
                };
              }
            }, {
              key: "leaveMeeting",
              value: function leaveMeeting() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4103,
                    body: {}
                  })
                };
              }
            }, {
              key: "recordMeeting",
              value: function recordMeeting(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4105,
                    body: {
                      bRecord: e,
                      bPause: t
                    }
                  })
                };
              }
            }, {
              key: "expel",
              value: function expel(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4107,
                    body: {
                      id: e
                    }
                  })
                };
              }
            }, {
              key: "expelAttendee",
              value: function expelAttendee(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4205,
                    body: {
                      jid: e
                    }
                  })
                };
              }
            }, {
              key: "rename",
              value: function rename(e, t, n) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4109,
                    body: {
                      id: e,
                      dn2: t,
                      olddn2: n
                    }
                  })
                };
              }
            }, {
              key: "assignHost",
              value: function assignHost(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4111,
                    body: {
                      id: e,
                      bCoHost: t
                    }
                  })
                };
              }
            }, {
              key: "reclaimHost",
              value: function reclaimHost(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4133,
                    body: {
                      id: e,
                      bCoHost: t
                    }
                  })
                };
              }
            }, {
              key: "revokeCoHost",
              value: function revokeCoHost(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4195,
                    body: {
                      id: e
                    }
                  })
                };
              }
            }, {
              key: "putOnHold",
              value: function putOnHold(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4113,
                    body: {
                      id: e,
                      bHold: t
                    }
                  })
                };
              }
            }, {
              key: "setMuteOnEntry",
              value: function setMuteOnEntry(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4115,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "setHoldOnEntry",
              value: function setHoldOnEntry(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4117,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "inviteCRCDevice",
              value: function inviteCRCDevice(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4119,
                    body: {
                      ip: e,
                      type: t,
                      encrypt: n
                    }
                  })
                };
              }
            }, {
              key: "cancelInviteCRCDevice",
              value: function cancelInviteCRCDevice(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4121,
                    body: {
                      transID: e
                    }
                  })
                };
              }
            }, {
              key: "sendCloseCaption",
              value: function sendCloseCaption(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4125,
                    body: f({}, e)
                  })
                };
              }
            }, {
              key: "allowViewParticipantNumber",
              value: function allowViewParticipantNumber(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4127,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "lowerAllHands",
              value: function lowerAllHands() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4129,
                    body: {}
                  })
                };
              }
            }, {
              key: "raiseLowerHand",
              value: function raiseLowerHand(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4131,
                    body: {
                      id: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "chat",
              value: function chat(e, t, n, r) {
                var i = {
                  text: e,
                  destNodeID: t
                };
                return n && Object.assign(i, {
                  sn: n
                }), r && Object.assign(i, {
                  attendeeNodeID: r
                }), {
                  seq: this.sendMessageToRwg({
                    evt: 4135,
                    body: i
                  })
                };
              }
            }, {
              key: "assignCC",
              value: function assignCC(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4137,
                    body: {
                      id: e,
                      bCCEditor: t
                    }
                  })
                };
              }
            }, {
              key: "enableLT",
              value: function enableLT(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4227,
                    body: {
                      op: e ? 2 : 4
                    }
                  })
                };
              }
            }, {
              key: "allowAskLT",
              value: function allowAskLT(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4263,
                    body: {
                      bAnonymous: e
                    }
                  })
                };
              }
            }, {
              key: "approveLT",
              value: function approveLT() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4262,
                    body: {
                      bApproved: !0
                    }
                  })
                };
              }
            }, {
              key: "askLT",
              value: function askLT(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4261,
                    body: {
                      bAnonymous: e
                    }
                  })
                };
              }
            }, {
              key: "setChatPriviledge",
              value: function setChatPriviledge(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4141,
                    body: {
                      chatPriviledge: e
                    }
                  })
                };
              }
            }, {
              key: "setPanelistChatPrivilege",
              value: function setPanelistChatPrivilege(e) {
                if (!Object.values(ia).includes(e)) throw Error("Invalid panelist chat privilege req value");
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4141,
                    body: {
                      chatPriviledge: e
                    }
                  })
                };
              }
            }, {
              key: "sendFeedback",
              value: function sendFeedback(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4143,
                    body: {
                      feedback: e
                    }
                  })
                };
              }
            }, {
              key: "clearFeedback",
              value: function clearFeedback() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4145,
                    body: {}
                  })
                };
              }
            }, {
              key: "allowUnmuteVideo",
              value: function allowUnmuteVideo(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4147,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "allowUnmuteAudio",
              value: function allowUnmuteAudio(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4149,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "allowRaiseHand",
              value: function allowRaiseHand(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4151,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "boToken",
              value: function boToken(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4173,
                    body: {
                      topic: e
                    }
                  })
                };
              }
            }, {
              key: "startBO",
              value: function startBO(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4175,
                    body: {
                      proto: e
                    }
                  })
                };
              }
            }, {
              key: "stopBO",
              value: function stopBO(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4177,
                    body: {
                      status: e
                    }
                  })
                };
              }
            }, {
              key: "assignToBO",
              value: function assignToBO(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4179,
                    body: {
                      targetID: e,
                      targetBID: t
                    }
                  })
                };
              }
            }, {
              key: "switchBO",
              value: function switchBO(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4181,
                    body: {
                      targetID: e,
                      targetBID: t
                    }
                  })
                };
              }
            }, {
              key: "wantJoinBO",
              value: function wantJoinBO(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4183,
                    body: {
                      targetID: e,
                      targetBID: t
                    }
                  })
                };
              }
            }, {
              key: "joinBO",
              value: function joinBO(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4193,
                    body: {
                      targetBID: e
                    }
                  })
                };
              }
            }, {
              key: "leaveBO",
              value: function leaveBO() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4185,
                    body: {
                      reason: e
                    }
                  })
                };
              }
            }, {
              key: "broadcastBO",
              value: function broadcastBO(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4187,
                    body: {
                      textContent: e
                    }
                  })
                };
              }
            }, {
              key: "askForHelpBO",
              value: function askForHelpBO(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4189,
                    body: {
                      targetID: e
                    }
                  })
                };
              }
            }, {
              key: "askForHelpResultBO",
              value: function askForHelpResultBO(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4191,
                    body: {
                      targetID: e,
                      helpResult: t
                    }
                  })
                };
              }
            }, {
              key: "allowParticipantRename",
              value: function allowParticipantRename(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4163,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "allowMessageFeedbackNotify",
              value: function allowMessageFeedbackNotify(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4171,
                    body: {
                      bOn: e,
                      id: t
                    }
                  })
                };
              }
            }, {
              key: "setPlayChime",
              value: function setPlayChime(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4197,
                    body: {
                      bOn: e,
                      id: t
                    }
                  })
                };
              }
            }, {
              key: "admitAllSilentUsers",
              value: function admitAllSilentUsers() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4199,
                    body: {}
                  })
                };
              }
            }, {
              key: "bindTeleUser",
              value: function bindTeleUser(e, t, n) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4201,
                    body: {
                      teleUserID: e,
                      targetUserID: t,
                      bBind: n
                    }
                  })
                };
              }
            }, {
              key: "practiceSession",
              value: function practiceSession() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4207,
                    body: null
                  })
                };
              }
            }, {
              key: "roleChangeWebinar",
              value: function roleChangeWebinar(e, t, n, r) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4209,
                    body: {
                      jid: t,
                      userID: n,
                      clientCap: r,
                      bPromote: e
                    }
                  })
                };
              }
            }, {
              key: "sendPromoteConsent",
              value: function sendPromoteConsent(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4254,
                    body: {
                      agreed: e,
                      req_id: t
                    }
                  })
                };
              }
            }, {
              key: "batchCreateBOToken",
              value: function batchCreateBOToken(e) {
                var t = e.map(function (e, t) {
                  return {
                    topic: e,
                    index: t
                  };
                });
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4211,
                    body: t
                  })
                };
              }
            }, {
              key: "mute",
              value: function mute(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8193,
                    body: {
                      bMute: t,
                      id: e
                    }
                  })
                };
              }
            }, {
              key: "audioDrop",
              value: function audioDrop(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8195,
                    body: {
                      id: e
                    }
                  })
                };
              }
            }, {
              key: "audioDialout",
              value: function audioDialout(e, t, n, r, i) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8197,
                    body: {
                      pn: e,
                      dn2: mi(t),
                      bCallme: n,
                      bPressOne: r,
                      bGreeting: i
                    }
                  })
                };
              }
            }, {
              key: "audioCancelDialout",
              value: function audioCancelDialout(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8199,
                    body: {
                      pn: e,
                      bCallme: t
                    }
                  })
                };
              }
            }, {
              key: "audioMuteAll",
              value: function audioMuteAll(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8201,
                    body: {
                      bMute: e
                    }
                  })
                };
              }
            }, {
              key: "allowToTalk",
              value: function allowToTalk(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8204,
                    body: {
                      id: e,
                      bAllowTalk: t
                    }
                  })
                };
              }
            }, {
              key: "subscribeVideo",
              value: function subscribeVideo() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                    t = arguments.length > 1 ? arguments[1] : void 0,
                    n = arguments.length > 2 ? arguments[2] : void 0;
                return {
                  seq: this.sendMessageToRwg({
                    evt: 12289,
                    body: {
                      id: e,
                      size: t,
                      bOn: n
                    }
                  })
                };
              }
            }, {
              key: "unsubscribeVideo",
              value: function unsubscribeVideo() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
                return {
                  seq: this.sendMessageToRwg({
                    evt: 12291,
                    body: {
                      id: e
                    }
                  })
                };
              }
            }, {
              key: "muteAttendeeVideo",
              value: function muteAttendeeVideo(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 12297,
                    body: {
                      id: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "notifyRwgIsMuteVideo",
              value: function notifyRwgIsMuteVideo(e, t) {
                return this.muteAttendeeVideo(e, t);
              }
            }, {
              key: "pauseSharing",
              value: function pauseSharing() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16385,
                    body: {}
                  })
                };
              }
            }, {
              key: "resumeSharing",
              value: function resumeSharing() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16387,
                    body: {}
                  })
                };
              }
            }, {
              key: "allowAnonymousQuestion",
              value: function allowAnonymousQuestion(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4155,
                    body: {
                      userId: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "allowViewAll",
              value: function allowViewAll(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4157,
                    body: {
                      userId: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "allowVote",
              value: function allowVote(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4159,
                    body: {
                      userId: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "allowComment",
              value: function allowComment(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4161,
                    body: {
                      userId: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "sharingRequestRemoteControl",
              value: function sharingRequestRemoteControl(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16389,
                    body: {
                      id: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "subscribeGrabRemoteControl",
              value: function subscribeGrabRemoteControl(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16393,
                    body: {
                      id: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "subscribeSharing",
              value: function subscribeSharing(e, t, n) {
                var r = {
                  id: e,
                  size: t
                };
                return n && Object.assign(r, {
                  bShareToBO: !0
                }), {
                  seq: this.sendMessageToRwg({
                    evt: 16415,
                    body: r
                  })
                };
              }
            }, {
              key: "unsubscribeSharing",
              value: function unsubscribeSharing(e, t) {
                var n = {
                  id: e
                };
                return t && Object.assign(n, {
                  bShareToBO: !0
                }), {
                  seq: this.sendMessageToRwg({
                    evt: 16417,
                    body: n
                  })
                };
              }
            }, {
              key: "sendRWGConnectionPerformance",
              value: function sendRWGConnectionPerformance(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4167,
                    body: {
                      data: e
                    }
                  })
                };
              }
            }, {
              key: "sendSdkKeyToMonitor",
              value: function sendSdkKeyToMonitor(e, t, n) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4167,
                    body: {
                      data: "ZoomConferenceClient,videoapp_HTML5_sdk_web_join,".concat(n, ",2,").concat(t, ",").concat(e)
                    }
                  })
                };
              }
            }, {
              key: "sendDatachannelOffer",
              value: function sendDatachannelOffer(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24321,
                    offer: e
                  })
                };
              }
            }, {
              key: "joinOrLeaveVoip",
              value: function joinOrLeaveVoip(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8203,
                    body: {
                      bOn: e
                    }
                  })
                };
              }
            }, {
              key: "startSharing",
              value: function startSharing(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16409,
                    body: f({
                      id: e,
                      boOn: !1
                    }, null != t ? t : {})
                  })
                };
              }
            }, {
              key: "stopSharing",
              value: function stopSharing(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16409,
                    body: {
                      id: e,
                      bOn: !0
                    }
                  })
                };
              }
            }, {
              key: "lockSharing",
              value: function lockSharing(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4169,
                    body: {
                      lockShare: e
                    }
                  })
                };
              }
            }, {
              key: "startShareToBreakoutRoom",
              value: function startShareToBreakoutRoom(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16425,
                    body: {
                      id: e,
                      bShareToBO: !0
                    }
                  })
                };
              }
            }, {
              key: "stopShareToBreakoutRoom",
              value: function stopShareToBreakoutRoom(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16425,
                    body: {
                      id: e,
                      bShareToBO: !1
                    }
                  })
                };
              }
            }, {
              key: "preAssignBreakoutRoom",
              value: function preAssignBreakoutRoom() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4213,
                    body: {}
                  })
                };
              }
            }, {
              key: "claimHost",
              value: function claimHost(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4215,
                    body: {
                      hostKey: e
                    }
                  })
                };
              }
            }, {
              key: "allowMultiplePin",
              value: function allowMultiplePin(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4217,
                    body: {
                      userID: e,
                      bOn: t
                    }
                  })
                };
              }
            }, {
              key: "spotlightVideo",
              value: function spotlightVideo(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4219,
                    body: f({
                      id: e
                    }, t)
                  })
                };
              }
            }, {
              key: "followHostLayout",
              value: function followHostLayout(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4223,
                    body: {
                      bFollowHostVideo: e
                    }
                  })
                };
              }
            }, {
              key: "setVideoDragLayout",
              value: function setVideoDragLayout(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4218,
                    body: {
                      drag_list: e
                    }
                  })
                };
              }
            }, {
              key: "chatCmdReq",
              value: function chatCmdReq(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4237,
                    body: {
                      msgID: e,
                      cmd: t
                    }
                  })
                };
              }
            }, {
              key: "activeAppLinkReq",
              value: function activeAppLinkReq(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4257,
                    body: {
                      appId: e
                    }
                  })
                };
              }
            }, {
              key: "activeAppInfoReq",
              value: function activeAppInfoReq() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4255,
                    body: {}
                  })
                };
              }
            }, {
              key: "muteShareAudio",
              value: function muteShareAudio(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 16423,
                    body: {
                      bOn: !0,
                      bShareAudio: !e
                    }
                  })
                };
              }
            }, {
              key: "localMuteAudio",
              value: function localMuteAudio(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 8209,
                    body: {
                      id: e,
                      bMute: t
                    }
                  })
                };
              }
            }, {
              key: "changeSharePronoun",
              value: function changeSharePronoun(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 4264,
                    body: {
                      bPronoun: e,
                      strPronoun: t
                    }
                  })
                };
              }
            }]);

            return da;
          }();

          var ua = /*#__PURE__*/function (_da) {
            _inherits(ua, _da);

            var _super = _createSuper(ua);

            function ua() {
              _classCallCheck(this, ua);

              return _super.apply(this, arguments);
            }

            _createClass(ua, null, [{
              key: "createAgent",
              value: function createAgent() {
                return this.rwgInstance || (this.rwgInstance = new ua()), this.rwgInstance;
              }
            }]);

            return ua;
          }(da);

          ua.rwgInstance = null;

          var pa = /*#__PURE__*/function (_da2) {
            _inherits(pa, _da2);

            var _super2 = _createSuper(pa);

            function pa() {
              _classCallCheck(this, pa);

              return _super2.apply(this, arguments);
            }

            _createClass(pa, null, [{
              key: "getInstance",
              value: function getInstance() {
                return this.instance || (this.instance = new pa()), this.instance;
              }
            }]);

            return pa;
          }(da);

          pa.instance = null;
          var ha = [{
            name: "audio_simd.min.js",
            category: "audio",
            type: "worker",
            tag: "simd",
            alias: "audioSIMDWorkletPath"
          }, {
            name: "audio.simd.wasm",
            category: "audio",
            type: "wasm",
            tag: "simd",
            alias: "audioSIMDWasm"
          }, {
            name: "js_audio_process.min.js",
            category: "audio",
            type: "worker",
            tag: "",
            alias: "audioWorkerPath"
          }, {
            name: "audio.encode.wasm",
            category: "audio",
            type: "wasm",
            tag: "",
            alias: "audioWasm"
          }, {
            name: "js_audio_worklet.min.js",
            category: "audio",
            type: "worklet",
            tag: "",
            alias: "audioWorkletPath"
          }, {
            name: "video_mtsimd.min.js",
            category: "video",
            type: "worker",
            tag: "simd,thread",
            alias: "videoMSIMDWorkerPath"
          }, {
            name: "video.mtsimd.wasm",
            category: "video",
            type: "wasm",
            tag: "simd,thread",
            alias: "videoMSIMDWasm"
          }, {
            name: "video_m.min.js",
            category: "video",
            type: "worker",
            tag: "thread",
            alias: "videoMtWorkerPath"
          }, {
            name: "video.mt.wasm",
            category: "video",
            type: "wasm",
            tag: "thread",
            alias: "videoMtWasm"
          }, {
            name: "video_simd.min.js",
            category: "video",
            type: "worker",
            tag: "simd",
            alias: "videoSIMDWorkerPath"
          }, {
            name: "video.simd.wasm",
            category: "video",
            type: "wasm",
            tag: "simd",
            alias: "videoSIMDWasm"
          }, {
            name: "video_s.min.js",
            category: "video",
            type: "worker",
            tag: "",
            alias: "videoWorkerPath"
          }, {
            name: "video.decode.wasm",
            category: "video",
            type: "wasm",
            tag: "",
            alias: "videoWasm"
          }, {
            name: "sharing_mtsimd.min.js",
            category: "sharing",
            type: "worker",
            tag: "simd,thread",
            alias: "sharingMSIMDWorkerPath"
          }, {
            name: "sharing_m.min.js",
            category: "sharing",
            type: "worker",
            tag: "thread",
            alias: "sharingMtWorkerPath"
          }, {
            name: "sharing_simd.min.js",
            category: "sharing",
            type: "worker",
            tag: "simd",
            alias: "sharingSIMDWorkerPath"
          }, {
            name: "sharing_s.min.js",
            category: "sharing",
            type: "worker",
            tag: "",
            alias: "sharingWorkerPath"
          }];

          var _a;

          !function (e) {
            e.VideoEncode = "0", e.VideoDecode = "1", e.AudioEncode = "2", e.AudioDecode = "3", e.SharingEncode = "4", e.SharingDecode = "5";
          }(_a || (_a = {}));
          var fa = Vo.WebclientIVState;

          var ma = /*#__PURE__*/function () {
            _createClass(ma, null, [{
              key: "getInstance",
              value: function getInstance() {
                return void 0 === this.agentInstance && (this.agentInstance = new ma()), this.agentInstance;
              }
            }]);

            function ma() {
              _classCallCheck(this, ma);

              this.assetsPath = void 0, this.instance = void 0, this.callbackList = void 0, this.mediaWorkersPath = void 0, this.constraints = void 0, this.svcUrl = void 0, this.meetingNumber = void 0, this.confId = void 0, this.mediaSocketAddress = void 0, this.currentUserId = void 0, this.receivedSharingCanvas = void 0, this.sharingCanvas = void 0, this.mediaOptions = void 0, this.callbackList = [];
            }

            _createClass(ma, [{
              key: "init",
              value: function init() {
                if (!this.instance) {
                  var _ivObj;

                  var _e8 = {
                    ivObj: (_ivObj = {}, _defineProperty(_ivObj, Uo.AUDIO_ENCODE, wo.get(fa) && wo.get(fa)[Uo.AUDIO_ENCODE]), _defineProperty(_ivObj, Uo.VIDEO_ENCODE, wo.get(fa) && wo.get(fa)[Uo.VIDEO_ENCODE]), _defineProperty(_ivObj, Uo.SHARING_ENCODE, wo.get(fa) && wo.get(fa)[Uo.SHARING_ENCODE]), _ivObj)
                  };
                  this.instance = new JsMediaSDK_Instance(_e8), this.instance.setRWGAgent(ua.createAgent());
                }
              }
            }, {
              key: "setAssetsAndConstraint",
              value: function setAssetsAndConstraint(e, t, n, r) {
                var i;
                this.assetsPath = e, this.constraints = t, this.mediaWorkersPath = function (e, t) {
                  return ha.reduce(function (n, r) {
                    var i = r.name,
                        o = r.alias;
                    return Object.assign(n, _defineProperty({}, "".concat(o), "".concat(e, "/").concat(t ? "".concat("1501", "_") : "").concat(i))), n;
                  }, {});
                }(this.assetsPath, !!n), this.onMediaSDKCallback = this.onMediaSDKCallback.bind(this), this.mediaOptions = r, null === (i = this.instance) || void 0 === i || i.JsMediaSDK_PreLoad(this.mediaWorkersPath, this.onMediaSDKCallback, r);
              }
            }, {
              key: "onMediaSDKCallback",
              value: function onMediaSDKCallback(e, t) {
                this.callbackList.length > 0 && this.callbackList.forEach(function (n) {
                  return n(e, t);
                });
              }
            }, {
              key: "registerCallback",
              value: function registerCallback(e) {
                this.callbackList.push(e);
              }
            }, {
              key: "unregisterCallback",
              value: function unregisterCallback(e) {
                this.callbackList = this.callbackList.filter(function (t) {
                  return t !== e;
                });
              }
            }, {
              key: "connect",
              value: function connect(e) {
                var t, n, r, i, o, a;
                var s = e.svcUrl,
                    c = e.meetingNumber,
                    l = e.conId,
                    d = e.e2eEncrypt,
                    u = e.isViewOnly,
                    p = e.currentUserId,
                    h = e.isWebinar,
                    _ = e.enableAudioQos,
                    _e$enableVideoQos = e.enableVideoQos,
                    f = _e$enableVideoQos === void 0 ? !1 : _e$enableVideoQos;
                this.svcUrl = s, this.meetingNumber = c, this.confId = l;

                var m = function (e, t, n) {
                  return {
                    videoSocketAddress: "wss://".concat(e, "/wc/media/").concat(t, "?type=v&cid=").concat(n),
                    audioSocketAddress: "wss://".concat(e, "/wc/media/").concat(t, "?type=a&cid=").concat(n),
                    sharingSocketAddress: "wss://".concat(e, "/wc/media/").concat(t, "?type=").concat(ko() ? "j" : "s", "&cid=").concat(n)
                  };
                }(s, c, l);

                this.mediaSocketAddress = m, this.currentUserId = p;
                var g = zo(null === (t = this.mediaOptions) || void 0 === t ? void 0 : t.enableMultiDecodeVideoWithoutSAB);
                var v, b, y, w, S, x, E;
                null === (n = this.instance) || void 0 === n || n.setPropsBeforeInit({
                  callback: this.onMediaSDKCallback,
                  audioWorkletPath: Eo() ? null === (r = this.mediaWorkersPath) || void 0 === r ? void 0 : r.audioWorkletPath : void 0,
                  e2eEncrypt: d,
                  isEnableListenInitEvent: !0
                }), !0 === (null === (i = this.constraints) || void 0 === i ? void 0 : i.audio) && Eo() && !No() && ((h || Co()) && (null === (v = this.instance) || void 0 === v || v.initAudioDecode(this.mediaWorkersPath, m.audioSocketAddress, p, !1, l, c, g, _)), !Co() || h && u || null === (b = this.instance) || void 0 === b || b.initAudioEncode(this.mediaWorkersPath, m.audioSocketAddress, p, !1, l, c, g, _)), !0 === (null === (o = this.constraints) || void 0 === o ? void 0 : o.video) && Eo() && (null === (y = this.instance) || void 0 === y || y.initVideoDecode(this.mediaWorkersPath, m.videoSocketAddress, p, !1, l, c, g), h && u || null === (w = this.instance) || void 0 === w || w.initVideoEncode(this.mediaWorkersPath, m.videoSocketAddress, p, !1, l, c, g, !1, f, !0, !0)), !0 === (null === (a = this.constraints) || void 0 === a ? void 0 : a.screen) && (Eo() ? (null === (S = this.instance) || void 0 === S || S.initSharingDecode(this.mediaWorkersPath, m.sharingSocketAddress, p, !1, l, c, g), h && u || null === (x = this.instance) || void 0 === x || x.initSharingEncode(this.mediaWorkersPath, m.sharingSocketAddress, p, !1, l, c, g)) : null === (E = this.instance) || void 0 === E || E.initSharingDecode(m.sharingSocketAddress));
              }
            }, {
              key: "destroy",
              value: function destroy() {
                var _this3 = this;

                var e;
                null === (e = this.instance) || void 0 === e || e.destroy(), this.instance = null, this.callbackList = [], [_a.AudioDecode, _a.AudioEncode, _a.VideoDecode, _a.VideoEncode].forEach(function (e) {
                  var t;
                  null === (t = _this3.instance) || void 0 === t || t.updateQosSubscription(!1, e);
                });
              }
            }, {
              key: "disconnect",
              value: function disconnect() {
                var e, t;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(17, {}), null === (t = this.instance) || void 0 === t || t.JsMediaSDK_UnInit();
              }
            }, {
              key: "muteAudio",
              value: function muteAudio() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(8, {
                  ssrc: 0
                });
              }
            }, {
              key: "unmuteAudio",
              value: function unmuteAudio() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(7, {
                  ssrc: 0,
                  AudioSelectValue: 0
                });
              }
            }, {
              key: "joinComputerAudio",
              value: function joinComputerAudio(e, t, n, r, i) {
                var o;
                return null === (o = this.instance) || void 0 === o ? void 0 : o.Notify_MeidaSDK(22, f({
                  CaptureAudio: r,
                  CaptureAudioInfo: {
                    ssrc: e,
                    AudioSelectValue: "default" === t ? null : t
                  },
                  speakerInfo: {
                    defaultDeviceId: n
                  }
                }, i ? {
                  useAudioBridge: !0,
                  audioBridge: i
                } : {}));
              }
            }, {
              key: "leaveComputerAudio",
              value: function leaveComputerAudio() {
                var e;
                return null === (e = this.instance) || void 0 === e ? void 0 : e.Notify_MeidaSDK(21, null);
              }
            }, {
              key: "joinSharingAudio",
              value: function joinSharingAudio(e) {
                var t;
                var n = e.ssrc,
                    r = e.microphoneDeviceId,
                    i = e.speakerDeviceId,
                    o = e.isCaptureAudio;
                return null === (t = this.instance) || void 0 === t ? void 0 : t.Notify_MeidaSDK(72, {
                  CaptureAudio: o,
                  CaptureAudioInfo: {
                    ssrc: n,
                    AudioSelectValue: "default" === r ? null : r
                  },
                  speakerInfo: {
                    defaultDeviceId: i
                  },
                  checkAutoplay: !1
                });
              }
            }, {
              key: "leaveSharingAudio",
              value: function leaveSharingAudio(e) {
                var t;
                return null === (t = this.instance) || void 0 === t ? void 0 : t.Notify_MeidaSDK(73, {
                  isPause: e ? 1 : 0
                });
              }
            }, {
              key: "changeSpeaker",
              value: function changeSpeaker(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(11, {
                  ssrc: 0,
                  AudioSelectValue: e
                });
              }
            }, {
              key: "changeMicrophone",
              value: function changeMicrophone(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(18, {
                  ssrc: 0,
                  AudioSelectValue: "default" === e ? null : e
                });
              }
            }, {
              key: "restoreWebRTC",
              value: function restoreWebRTC(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(19, {
                  ssrc: 0,
                  AudioSelectValue: "default" === e ? null : e
                });
              }
            }, {
              key: "renderVideo",
              value: function renderVideo(e, t, n, r, i, o, a, s, c, l, d) {
                var u;
                null === (u = this.instance) || void 0 === u || u.Notify_MeidaSDK(1, {
                  userId: t,
                  width: r,
                  height: i,
                  x: o,
                  y: a,
                  quality: s,
                  isMyself: c,
                  canvas: e,
                  enableWaterMark: d,
                  waterMarkText: l,
                  zone: n
                });
              }
            }, {
              key: "stopRenderVideo",
              value: function stopRenderVideo(e, t, n, r) {
                var i;
                var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                null === (i = this.instance) || void 0 === i || i.Notify_MeidaSDK(2, {
                  canvas: e,
                  userId: t,
                  RGBA: r,
                  doNotClean: o,
                  zone: n
                });
              }
            }, {
              key: "startCaptureVideo",
              value: function startCaptureVideo(e, t, n, r, i, o) {
                var a;
                var s = arguments.length > 6 && void 0 !== arguments[6] && arguments[6];
                null === (a = this.instance) || void 0 === a || a.Notify_MeidaSDK(3, {
                  ssid: e,
                  width: n,
                  height: r,
                  fps: 24,
                  video: i,
                  usingFacingMode: o,
                  VideoSelectValue: "default" === t ? null : t,
                  disableOriginalRatio: s
                });
              }
            }, {
              key: "stopCaptureVideo",
              value: function stopCaptureVideo() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(4, {
                  ssrc: 0
                });
              }
            }, {
              key: "changeCamera",
              value: function changeCamera(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(12, {
                  VideoSelectValue: "default" === e ? null : e
                });
              }
            }, {
              key: "switchCanvasForVideoCapture",
              value: function switchCanvasForVideoCapture(e) {
                var t;
                var n = e;
                Array.isArray(e) || (n = [e]), null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(25, n);
              }
            }, {
              key: "renderSharing",
              value: function renderSharing(e, t) {
                var n;
                var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                    i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "",
                    o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                this.receivedSharingCanvas = t, null === (n = this.instance) || void 0 === n || n.Notify_MeidaSDK(23, {
                  width: 0,
                  height: 0,
                  ssrc: e,
                  canvas: t,
                  enableWaterMark: r,
                  waterMarkText: i,
                  isFromMainSession: o
                });
              }
            }, {
              key: "stopRenderSharing",
              value: function stopRenderSharing() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(24, {});
              }
            }, {
              key: "switchSharingSource",
              value: function switchSharingSource(e) {
                var t;
                var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(36, {
                  ssrc: e,
                  isFromMainSession: Number(n)
                });
              }
            }, {
              key: "ajustmentReceivedSharingCanvas",
              value: function ajustmentReceivedSharingCanvas(e, t) {
                if (this.receivedSharingCanvas) try {
                  this.receivedSharingCanvas.width = e, this.receivedSharingCanvas.height = t;
                } catch (e) {}
              }
            }, {
              key: "startRemoteControl",
              value: function startRemoteControl(e, t, n) {
                var r;
                null === (r = this.instance) || void 0 === r || r.Notify_MeidaSDK(26, f({
                  socketURL: "wss://".concat(this.svcUrl),
                  meetingID: this.meetingNumber,
                  condID: this.confId,
                  os: t,
                  dom: e
                }, n));
              }
            }, {
              key: "stopRemoteControl",
              value: function stopRemoteControl() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(28);
              }
            }, {
              key: "resendRemoteControlPositionPDU",
              value: function resendRemoteControlPositionPDU() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(41);
              }
            }, {
              key: "updateRemoteControlProperties",
              value: function updateRemoteControlProperties(e) {
                var t;
                var n = e.dimension,
                    r = g(e, ["dimension"]);
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(27, f(f({}, n), r));
              }
            }, {
              key: "startDesktopSharing",
              value: function startDesktopSharing(e, t, n, r) {
                var i;
                var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                    a = !(arguments.length > 5 && void 0 !== arguments[5]) || arguments[5];
                this.sharingCanvas = document.querySelector("#".concat(t));
                var s = {};
                r && (s = {
                  share2ndCamera: !0,
                  share2ndCameraParams: {
                    VideoSelectValue: "default" === r.cameraId ? null : r.cameraId,
                    width: r.width,
                    height: r.height
                  }
                }), null === (i = this.instance) || void 0 === i || i.Notify_MeidaSDK(30, f(f({
                  mode: a,
                  ssid: e,
                  canvas: t,
                  video: n
                }, s), {}, {
                  showShareAudioOption: o
                }));
              }
            }, {
              key: "stopDesktopSharing",
              value: function stopDesktopSharing() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(31, {});
              }
            }, {
              key: "pauseDesktopSharing",
              value: function pauseDesktopSharing() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(32, {});
              }
            }, {
              key: "resumeDesktopSharing",
              value: function resumeDesktopSharing() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(33, {});
              }
            }, {
              key: "changeSharingSecondCamera",
              value: function changeSharingSecondCamera(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(49, {
                  VideoSelectValue: e
                });
              }
            }, {
              key: "ajustmentSharingCanvas",
              value: function ajustmentSharingCanvas(e, t) {
                if (this.sharingCanvas) try {
                  this.sharingCanvas.width = e, this.sharingCanvas.height = t;
                } catch (e) {}
              }
            }, {
              key: "checkChromeSharingExtension",
              value: function checkChromeSharingExtension() {
                var e;
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(34, {});
              }
            }, {
              key: "enableAudioEncode",
              value: function enableAudioEncode() {
                var e, t;
                null === (e = this.instance) || void 0 === e || e.initAudioEncode(this.mediaWorkersPath, this.mediaSocketAddress.audioSocketAddress, this.currentUserId, !1, this.confId, this.meetingNumber, zo(null === (t = this.mediaOptions) || void 0 === t ? void 0 : t.enableMultiDecodeVideoWithoutSAB));
              }
            }, {
              key: "sendUserNodeList",
              value: function sendUserNodeList(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(43, e);
              }
            }, {
              key: "updateRenderedSharingDimension",
              value: function updateRenderedSharingDimension(e, t) {
                var n;
                null === (n = this.instance) || void 0 === n || n.Notify_MeidaSDK(44, {
                  width: e,
                  height: t
                });
              }
            }, {
              key: "pauseOrResumeAudio",
              value: function pauseOrResumeAudio(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(45, {
                  bPause: e
                });
              }
            }, {
              key: "updateRenderedVideoCanvasDimension",
              value: function updateRenderedVideoCanvasDimension(e, t, n) {
                var r;
                null === (r = this.instance) || void 0 === r || r.Notify_MeidaSDK(46, {
                  canvas: e,
                  width: t,
                  height: n
                });
              }
            }, {
              key: "clearVideoCanvas",
              value: function clearVideoCanvas(e, t) {
                var n;
                null === (n = this.instance) || void 0 === n || n.Notify_MeidaSDK(47, {
                  id: e,
                  RGBA: t
                });
              }
            }, {
              key: "adjustRenderedVideoPosition",
              value: function adjustRenderedVideoPosition(e, t, n, r, i, o, a, s) {
                var c;
                null === (c = this.instance) || void 0 === c || c.Notify_MeidaSDK(48, {
                  userId: t,
                  x: r,
                  y: i,
                  width: o,
                  height: a,
                  canvas: e,
                  zone: n,
                  RGBA: s
                });
              }
            }, {
              key: "mirrorVideo",
              value: function mirrorVideo(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(75, {
                  isMirrorMyVideo: e
                });
              }
            }, {
              key: "updateUserMediaSN",
              value: function updateUserMediaSN(e) {
                var t, n, r;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(80, {
                  isFromMainSession: Number(e.isFromMainSession),
                  mediaActionType: e.iVType,
                  body: {
                    add: null !== (n = e.added) && void 0 !== n ? n : [],
                    remove: null !== (r = e.removed) && void 0 !== r ? r : []
                  }
                });
              }
            }, {
              key: "updateMediaParams",
              value: function updateMediaParams(e) {
                var t;
                var n = e.iVType,
                    r = e.isFromMainSession,
                    i = e.updateParams;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(81, {
                  mediaActionType: n,
                  isFromMainSession: Number(r),
                  updateParams: i
                });
              }
            }, {
              key: "createMainSessionChannel",
              value: function createMainSessionChannel(e, t) {
                var n, r;
                "sharing" === e ? null === (n = this.instance) || void 0 === n || n.Notify_MeidaSDK(84, t) : null === (r = this.instance) || void 0 === r || r.Notify_MeidaSDK(85, t);
              }
            }, {
              key: "addReceivedSharingChannelType",
              value: function addReceivedSharingChannelType(e) {
                var t;
                var n = e.isFromMainSession,
                    r = g(e, ["isFromMainSession"]);
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(82, f({
                  isFromMainSession: Number(n)
                }, r));
              }
            }, {
              key: "removeReceivedSharingChannelType",
              value: function removeReceivedSharingChannelType(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(83, {
                  isFromMainSession: Number(e.isFromMainSession),
                  ssrc: e.ssrc
                });
              }
            }, {
              key: "enableHardwareAccelerationForVideoDecode",
              value: function enableHardwareAccelerationForVideoDecode(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(70, {
                  enable: e
                });
              }
            }, {
              key: "enableHardwareAccelerationForVideoEncode",
              value: function enableHardwareAccelerationForVideoEncode(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(71, {
                  enable: e
                });
              }
            }, {
              key: "setSharingAudioVolume",
              value: function setSharingAudioVolume(e, t, n) {
                var r;
                null === (r = this.instance) || void 0 === r || r.Notify_MeidaSDK(74, {
                  userid: e >> 10,
                  shareVolume: t ? 0 : 100,
                  isFromMainSession: n
                });
              }
            }, {
              key: "subscribeToQos",
              value: function subscribeToQos(e, t) {
                var _this4 = this;

                e.forEach(function (e) {
                  var n;
                  null === (n = _this4.instance) || void 0 === n || n.updateQosSubscription(!0, e, t);
                });
              }
            }, {
              key: "unsubscribeFromQos",
              value: function unsubscribeFromQos(e) {
                var _this5 = this;

                e.forEach(function (e) {
                  var t;
                  null === (t = _this5.instance) || void 0 === t || t.updateQosSubscription(!1, e);
                });
              }
            }, {
              key: "passThroughRWGMessage",
              value: function passThroughRWGMessage(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(40, e);
              }
            }, {
              key: "startVirtualBackgroundSetting",
              value: function startVirtualBackgroundSetting(e, t, n, r, i, o) {
                var a;
                var s = arguments.length > 6 && void 0 !== arguments[6] && arguments[6];
                null === (a = this.instance) || void 0 === a || a.Notify_MeidaSDK(91, {
                  canvas: e,
                  bgdom: t,
                  width: i,
                  height: o,
                  ssid: n,
                  VideoSelectValue: "default" === r ? null : r,
                  disableOriginalRatio: s
                });
              }
            }, {
              key: "updateVirtualBackgroundImage",
              value: function updateVirtualBackgroundImage(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(92, {
                  bgdom: e
                });
              }
            }, {
              key: "stopVirtualBackgroundSetting",
              value: function stopVirtualBackgroundSetting() {
                var e;
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                null === (e = this.instance) || void 0 === e || e.Notify_MeidaSDK(93, {
                  isSwitch: t
                });
              }
            }, {
              key: "enableVideoObserver",
              value: function enableVideoObserver(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(99, {
                  enable: e
                });
              }
            }, {
              key: "enableShareAudioToBreakoutRoom",
              value: function enableShareAudioToBreakoutRoom(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(86, {
                  enable: e
                });
              }
            }, {
              key: "sendUserAudioStatus",
              value: function sendUserAudioStatus(e) {
                var t;
                null === (t = this.instance) || void 0 === t || t.Notify_MeidaSDK(51, e);
              }
            }, {
              key: "muteOrUnmuteOtherAudio",
              value: function muteOrUnmuteOtherAudio(e, t) {
                var n;
                null === (n = this.instance) || void 0 === n || n.Notify_MeidaSDK(50, {
                  userId: e,
                  muted: t
                });
              }
            }], [{
              key: "isSupportVideoEncodeHardwareAcceleration",
              value: function isSupportVideoEncodeHardwareAcceleration() {
                return JsMediaSDK_Instance.util.IsSupportVideoEncodeHardwareAcceleration();
              }
            }, {
              key: "isSupportVideoDecodeHardwareAcceleration",
              value: function isSupportVideoDecodeHardwareAcceleration() {
                return JsMediaSDK_Instance.util.IsSupportVideoDecodeHardwareAcceleration();
              }
            }, {
              key: "isCompatibleHardwareForEncode",
              value: function isCompatibleHardwareForEncode() {
                return "function" == typeof window.OffscreenCanvas && 0 == JsMediaSDK_Instance.util.AdapterWhiteListCheckForEncoder();
              }
            }]);

            return ma;
          }();

          ma.agentInstance = void 0;
          var ga = "JOIN_MEETING_FAILED";
          var va;
          !function (e) {
            e.ConnectionChange = "connection-change", e.OnHoldChange = "on-hold-change", e.UserAdd = "user-added", e.UserUpdate = "user-updated", e.UserRemove = "user-removed", e.AttendeeUpdate = "attendee-updated", e.MeetingAttributeUpdate = "meeting-attribute-updated", e.PromoteAttendeeConsent = "promote-attendee-consent", e.ActiveAppsUpdate = "active-apps-updated", e.SharePronounTypeUpdate = "share-pronoun-type-update";
          }(va || (va = {}));
          var ba = {
            JoinMeeting: {
              success: "ADD_CURRENT_USER_PARTICIPANT_ATTRIBUTE",
              fail: [ga]
            }
          },
              ya = (_ya = {}, _defineProperty(_ya, va.ConnectionChange, [{
            event: "JOIN_MEETING_SUCCESS",
            payload: function payload() {
              return {
                state: fo.Connected
              };
            }
          }, {
            event: ga,
            payload: function payload(e) {
              return f({
                state: fo.Fail
              }, e);
            }
          }, {
            event: "RECONNECTING_MEETING",
            payload: function payload(e) {
              return f({
                state: fo.Reconnecting
              }, e);
            }
          }, {
            event: "LEAVING_MEETING",
            payload: function payload(e) {
              return f({
                state: fo.Closed
              }, e);
            }
          }]), _defineProperty(_ya, va.OnHoldChange, [{
            event: "MEETING_IN_WAITING_ROOM",
            payload: function payload(e) {
              return {
                isOnHold: e
              };
            }
          }]), _defineProperty(_ya, va.UserAdd, [{
            event: "ADD_CURRENT_USER_PARTICIPANT_ATTRIBUTE",
            payload: function payload(e) {
              return [e];
            }
          }, {
            event: "ADD_USER_PARTICIPANT_ATTRIBUTE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ya, va.UserUpdate, [{
            event: "UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE",
            payload: function payload(e) {
              return [e];
            }
          }, {
            event: "UPDATE_USER_PARTICIPANT_ATTRIBUTE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ya, va.UserRemove, [{
            event: "REMOVE_USER_PARTICIPANT_ATTRIBUTE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ya, va.AttendeeUpdate, [{
            event: "UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE",
            payload: function payload(e) {
              return e;
            }
          }, {
            event: "REMOVE_WEBINAR_ATTENDEE_ATTRIBUTE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ya, va.MeetingAttributeUpdate, [{
            event: "UPDATE_MEETING_ATTRIBUTE",
            payload: function payload() {}
          }]), _defineProperty(_ya, va.PromoteAttendeeConsent, [{
            event: "MEETING_WEBINAR_PROMOTE_CONSENT_REQ",
            payload: function payload(e) {
              var t = e.req_id,
                  n = e.sender_id;
              return {
                reqId: t,
                senderId: n
              };
            }
          }]), _defineProperty(_ya, va.ActiveAppsUpdate, [{
            event: "ACTIVE_APPS_UPDATE",
            payload: function payload() {}
          }]), _defineProperty(_ya, va.SharePronounTypeUpdate, [{
            event: "SHARE_PRONOUN_TYPE_UPDATE",
            payload: function payload(e) {
              return e;
            }
          }]), _ya);
          var wa;
          !function (e) {
            e.ChatOnMessage = "chat-on-message", e.ChatPrivilegeChange = "chat-privilege-change", e.ChatDeleteMessage = "chat-delete-message";
          }(wa || (wa = {}));
          var Sa = (_Sa = {}, _defineProperty(_Sa, wa.ChatOnMessage, [{
            event: "CHAT_RECEIVE_MESSAGE_EVENTS",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_Sa, wa.ChatPrivilegeChange, [{
            event: "CHAT_PRIVILEGE_CHANGE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_Sa, wa.ChatDeleteMessage, [{
            event: "CHAT_DELETE_MESSAGE_REPONSE",
            payload: function payload(e) {
              return e;
            }
          }]), _Sa);
          var xa;
          !function (e) {
            e.CommandChannelStatus = "command-channel-status", e.CommandChannelMessage = "command-channel-message";
          }(xa || (xa = {}));
          var Ea = (_Ea = {}, _defineProperty(_Ea, xa.CommandChannelStatus, [{
            event: "COMMAND_STATUS_EVENTS",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_Ea, xa.CommandChannelMessage, [{
            event: "COMMAND_RECEIVE_MESSAGE_EVENTS",
            payload: function payload(e) {
              return e;
            }
          }]), _Ea);
          var Ca, ka, Aa;
          !function (e) {
            e.Recording = "Recording", e.Paused = "Paused", e.Stopped = "Stopped";
          }(Ca || (Ca = {})), function (e) {
            e[e.None = 0] = "None", e[e.Init = 1] = "Init", e[e.Start = 2] = "Start", e[e.Pause = 3] = "Pause", e[e.Stop = 4] = "Stop";
          }(ka || (ka = {})), function (e) {
            e.RecordingChange = "recording-change", e.LocalRecordingChange = "local-recording-change";
          }(Aa || (Aa = {}));
          var Ia = (_Ia = {}, _defineProperty(_Ia, Aa.RecordingChange, [{
            event: "CLOUD_RECORDING_STATUS_CHANGE",
            payload: function payload(e) {
              var t = e.cmrServerStatus;
              return t === ka.Start ? Ca.Recording : t === ka.Pause ? Ca.Paused : Ca.Stopped;
            }
          }]), _defineProperty(_Ia, Aa.LocalRecordingChange, [{
            event: "LOCAL_RECORDING_CHANGE",
            payload: function payload(e) {
              return e;
            }
          }]), _Ia);
          var Ta, Oa, Ra, Na, Pa, ja;
          !function (e) {
            e[e.InitSuccess = 1] = "InitSuccess", e[e.InitSuccessVideo = 1.1] = "InitSuccessVideo", e[e.InitSuccessAudio = 1.2] = "InitSuccessAudio", e[e.InitSuccessSharing = 1.3] = "InitSuccessSharing", e[e.UserGrantCaptureAudio = 2] = "UserGrantCaptureAudio", e[e.CurrentVideoResolution = 3] = "CurrentVideoResolution", e[e.JpegDecThreadOk = 4] = "JpegDecThreadOk", e[e.JpegData = 5] = "JpegData", e[e.SharingPara = 6] = "SharingPara", e[e.VideoDecodeMaxSize = 7] = "VideoDecodeMaxSize", e[e.CurrentCaptureVideoWidthHeight = 8] = "CurrentCaptureVideoWidthHeight", e[e.StartVideoCaptureSuccess = 9] = "StartVideoCaptureSuccess", e[e.StopVideoCaptureSuccess = 10] = "StopVideoCaptureSuccess", e[e.StartRemoteControlSuccess = 11] = "StartRemoteControlSuccess", e[e.CancelRemoteControlSuccess = 12] = "CancelRemoteControlSuccess", e[e.RemoteControlCopiedTextNotify = 13] = "RemoteControlCopiedTextNotify", e[e.MonitorLog = 14] = "MonitorLog", e[e.CurrentDesktopSharingWidthHeight = 15] = "CurrentDesktopSharingWidthHeight", e[e.DesktopSharingCaptureSuccess = 16] = "DesktopSharingCaptureSuccess", e[e.CheckChromeSharingExtensionResponse = 17] = "CheckChromeSharingExtensionResponse", e[e.SharingDecodeMaxSize = 18] = "SharingDecodeMaxSize", e[e.DataChannelOffer = 19] = "DataChannelOffer", e[e.AesGcmIvResponse = 21] = "AesGcmIvResponse", e[e.SharingDesktopStreamHaveAudio = 23] = "SharingDesktopStreamHaveAudio", e[e.JoinComputerAudioComplete = 24] = "JoinComputerAudioComplete", e[e.JoinSharingAudioComplete = 25] = "JoinSharingAudioComplete", e[e.LeaveComputerAudioComplete = 26] = "LeaveComputerAudioComplete", e[e.LeaveSharingAudioComplete = 27] = "LeaveSharingAudioComplete", e[e.StartVideoStreamInVbSettingSuccess = 94] = "StartVideoStreamInVbSettingSuccess", e[e.VbModelPreloading_3S = 96] = "VbModelPreloading_3S", e[e.VbModelPreloading_10S = 97] = "VbModelPreloading_10S", e[e.VbModelPreloadingOk = 98] = "VbModelPreloadingOk", e[e.InitFailed = -1] = "InitFailed", e[e.InitFailedVideo = -1.1] = "InitFailedVideo", e[e.InitFailedAudio = -1.2] = "InitFailedAudio", e[e.InitFailedSharing = -1.3] = "InitFailedSharing", e[e.UserForbiddedCaptureAudio = -2] = "UserForbiddedCaptureAudio", e[e.AudioWebsocketBroken = -3] = "AudioWebsocketBroken", e[e.VideoWebsocketBroken = -4] = "VideoWebsocketBroken", e[e.SharingDecThreadFailed = -5] = "SharingDecThreadFailed", e[e.AudioZeroData = -6] = "AudioZeroData", e[e.AudioCtxSamplerate = -7] = "AudioCtxSamplerate", e[e.UserForbiddedCaptureVideo = -8] = "UserForbiddedCaptureVideo", e[e.UserCameraIsTakenByOtherPrograms = -9] = "UserCameraIsTakenByOtherPrograms", e[e.StopVideoCaptureFailed = -10] = "StopVideoCaptureFailed", e[e.StartRemoteControlFailed = -11] = "StartRemoteControlFailed", e[e.CancelRemoteControlFailed = -12] = "CancelRemoteControlFailed", e[e.RemoteControlPasteTextLengthOverflow = -14] = "RemoteControlPasteTextLengthOverflow", e[e.UserStopDesktopSharing = -15] = "UserStopDesktopSharing", e[e.UserCancelPermissionRequest = -16] = "UserCancelPermissionRequest", e[e.DesktopSharingChromeExtensionUninstalled = -17] = "DesktopSharingChromeExtensionUninstalled", e[e.DesktopSharingPermissionDenied = -18] = "DesktopSharingPermissionDenied", e[e.DesktopSharingTimeOut = -19] = "DesktopSharingTimeOut", e[e.DesktopSharingError = -20] = "DesktopSharingError", e[e.DesktopSharingSystemError = -22] = "DesktopSharingSystemError", e[e.SharingDesktopStreamHaveNoAudio = -27] = "SharingDesktopStreamHaveNoAudio", e.audioQosData = "AUDIO_QOS_DATA", e.videoQosData = "VIDEO_QOS_DATA", e[e.AudioBridgeReconnectStart = -29] = "AudioBridgeReconnectStart", e[e.AudioBridgeReconnectEnd = -31] = "AudioBridgeReconnectEnd", e[e.VbSettingParaError = -34] = "VbSettingParaError", e[e.NotifyUIFailover = -35] = "NotifyUIFailover";
          }(Ta || (Ta = {})), function (e) {
            e[e.EncodeSuccess = 1] = "EncodeSuccess", e[e.DecodeSuccess = 2] = "DecodeSuccess", e[e.EncodeFailed = -1] = "EncodeFailed", e[e.DecodeFailed = -2] = "DecodeFailed";
          }(Oa || (Oa = {})), function (e) {
            e.Spotlight = "Spotlight", e.Unmute = "Unmute", e.AllowToTalk = "Allow to talk";
          }(Ra || (Ra = {})), function (e) {
            e.Active = "active", e.PassiveByMuteOne = "passive(mute one)", e.PassiveByMuteAll = "passive(mute all)", e.SharingAudio = "sharing audio";
          }(Na || (Na = {})), function (e) {
            e.Join = "join", e.Leave = "leave", e.Muted = "muted", e.Unmuted = "unmuted";
          }(Pa || (Pa = {})), function (e) {
            e[e.Calling = 1] = "Calling", e[e.Ringing = 2] = "Ringing", e[e.Accepted = 3] = "Accepted", e[e.Busy = 4] = "Busy", e[e.NotAvailable = 5] = "NotAvailable", e[e.HangUp = 6] = "HangUp", e[e.Fail = 7] = "Fail", e[e.Success = 8] = "Success", e[e.Timeout = 9] = "Timeout", e[e.Canceling = 10] = "Canceling", e[e.Canceled = 11] = "Canceled", e[e.CancelFailed = 12] = "CancelFailed";
          }(ja || (ja = {}));
          var Da = new Blob([new Uint8Array([255, 227, 24, 196, 0, 0, 0, 3, 72, 1, 64, 0, 0, 4, 132, 16, 31, 227, 192, 225, 76, 255, 67, 12, 255, 221, 27, 255, 228, 97, 73, 63, 255, 195, 131, 69, 192, 232, 223, 255, 255, 207, 102, 239, 255, 255, 255, 101, 158, 206, 70, 20, 59, 255, 254, 95, 70, 149, 66, 4, 16, 128, 0, 2, 2, 32, 240, 138, 255, 36, 106, 183, 255, 227, 24, 196, 59, 11, 34, 62, 80, 49, 135, 40, 0, 253, 29, 191, 209, 200, 141, 71, 7, 255, 252, 152, 74, 15, 130, 33, 185, 6, 63, 255, 252, 195, 70, 203, 86, 53, 15, 255, 255, 247, 103, 76, 121, 64, 32, 47, 255, 34, 227, 194, 209, 138, 76, 65, 77, 69, 51, 46, 57, 55, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 255, 227, 24, 196, 73, 13, 153, 210, 100, 81, 135, 56, 0, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170, 170])], {
            type: "audio/mpeg"
          }),
              za = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 5, 4, 1, 3, 1, 1, 10, 11, 1, 9, 0, 65, 0, 254, 16, 2, 0, 26, 11]),
              Ma = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
          var La, Ua, Ba, Ha, Va, qa, Fa, Wa, Ga, Ka, Qa, Za, Ya, Ja;
          !function (e) {
            e[e.HostGrab = 0] = "HostGrab", e[e.OnlyHost = 1] = "OnlyHost", e[e.AnyoneGrab = 2] = "AnyoneGrab", e[e.MultipleShare = 3] = "MultipleShare";
          }(La || (La = {})), function (e) {
            e.Sharing = "sharing", e.Paused = "paused", e.End = "ended";
          }(Ua || (Ua = {})), function (e) {
            e[e.Video_90P = 0] = "Video_90P", e[e.Video_180P = 1] = "Video_180P", e[e.Video_360P = 2] = "Video_360P", e[e.Video_720P = 3] = "Video_720P";
          }(Ba || (Ba = {})), function (e) {
            e.Active = "Active", e.Inactive = "Inactive";
          }(Ha || (Ha = {})), function (e) {
            e.Muted = "Muted", e.Unmuted = "Unmuted";
          }(Va || (Va = {})), function (e) {
            e.Active = "Active", e.Inactive = "Inactive";
          }(qa || (qa = {})), function (e) {
            e.Success = "Success", e.Failed = "Failed", e.Initial = "Initial";
          }(Fa || (Fa = {})), function (e) {
            e.Started = "Started", e.Stopped = "Stopped", e.Failed = "Failed";
          }(Wa || (Wa = {})), function (e) {
            e.Approved = "Approved", e.Rejected = "Rejected";
          }(Ga || (Ga = {})), function (e) {
            e.PrivilegeChange = "PrivilegeChange", e.StopScreenCapture = "StopScreenCapture", e.ShareFromMainSession = "ShareFromMainSession";
          }(Ka || (Ka = {})), function (e) {
            e.Muted = "Muted", e.Unmuted = "Unmuted", e.NoAudio = "NoAudio", e.Phone = "Phone";
          }(Qa || (Qa = {})), function (e) {
            e[e.ImageNotMatch = 2] = "ImageNotMatch", e[e.CanvasNotMatch = 3] = "CanvasNotMatch", e[e.VBModelNotMatch = 4] = "VBModelNotMatch";
          }(Za || (Za = {})), function (e) {
            e[e.NotConnect = 0] = "NotConnect", e[e.Connecting = 1] = "Connecting", e[e.ConnectSuccess = 2] = "ConnectSuccess", e[e.ConnectFail = 3] = "ConnectFail";
          }(Ya || (Ya = {})), function (e) {
            e.User = "user", e.Environment = "environment", e.Left = "left", e.Right = "right";
          }(Ja || (Ja = {}));
          var $a = {
            data: {
              sample_rate: 0,
              rtt: 0,
              jitter: 0,
              avg_loss: 0,
              max_loss: 0
            }
          },
              Xa = {
            data: {
              sample_rate: 0,
              rtt: 0,
              jitter: 0,
              avg_loss: 0,
              max_loss: 0,
              width: 0,
              height: 0,
              fps: 0
            }
          };
          var es;
          !function (e) {
            e.DeviceChange = "device-change", e.MediaSDKChange = "media-sdk-change";
          }(es || (es = {}));
          var ts = (_ts = {}, _defineProperty(_ts, es.DeviceChange, [{
            event: "MEDIA_DEVICE_CHANGE",
            payload: function payload() {
              return {};
            }
          }]), _defineProperty(_ts, es.MediaSDKChange, [{
            event: "AUDIO_ENCODE_SUCCESS",
            payload: function payload() {
              return {
                type: "audio",
                action: "encode",
                result: "success"
              };
            }
          }, {
            event: "AUDIO_ENCODE_FAIL",
            payload: function payload() {
              return {
                type: "audio",
                action: "encode",
                result: "fail"
              };
            }
          }, {
            event: "AUDIO_DECODE_SUCCESS",
            payload: function payload() {
              return {
                type: "audio",
                action: "decode",
                result: "success"
              };
            }
          }, {
            event: "AUDIO_DECODE_FAIL",
            payload: function payload() {
              return {
                type: "audio",
                action: "decode",
                result: "fail"
              };
            }
          }, {
            event: "VIDEO_ENCODE_SUCCESS",
            payload: function payload() {
              return {
                type: "video",
                action: "encode",
                result: "success"
              };
            }
          }, {
            event: "VIDEO_ENCODE_FAIL",
            payload: function payload() {
              return {
                type: "video",
                action: "encode",
                result: "fail"
              };
            }
          }, {
            event: "VIDEO_DECODE_SUCCESS",
            payload: function payload() {
              return {
                type: "video",
                action: "decode",
                result: "success"
              };
            }
          }, {
            event: "VIDEO_DECODE_FAIL",
            payload: function payload() {
              return {
                type: "video",
                action: "decode",
                result: "fail"
              };
            }
          }, {
            event: "SHARING_ENCODE_SUCCESS",
            payload: function payload() {
              return {
                type: "share",
                action: "encode",
                result: "success"
              };
            }
          }, {
            event: "SHARING_ENCODE_FAIL",
            payload: function payload() {
              return {
                type: "share",
                action: "encode",
                result: "fail"
              };
            }
          }, {
            event: "SHARING_DECODE_SUCCESS",
            payload: function payload() {
              return {
                type: "share",
                action: "decode",
                result: "success"
              };
            }
          }, {
            event: "SHARING_DECODE_FAIL",
            payload: function payload() {
              return {
                type: "share",
                action: "decode",
                result: "fail"
              };
            }
          }]), _ts),
              ns = {
            success: "VIDEO_CAPTURE_START_SUCCESS",
            fail: ["CAN_NOT_DETECT_CAMERA", "CAN_NOT_FIND_CAMERA", "VIDEO_USER_FORBIDDEN_CAPTURE", "VIDEO_ESTABLISH_STREAM_ERROR", "VIDEO_CAMERA_IS_TAKEN", "VIDEO_VITRUAL_BACKGROUND_FAILED"]
          };
          var rs;
          !function (e) {
            e.VideoActiveChange = "video-active-change", e.PeerVideoStateChange = "peer-video-state-change", e.VideoSpotlightChange = "video-spotlight-change", e.VideoMutedChange = "video-muted-change", e.VideoCapturingChange = "video-capturing-change", e.AskForStartVideoConsent = "ask-for-start-video-consent", e.VideoDimensionChange = "video-dimension-change", e.VideoFollowHostOrder = "video-follow-host-order-change", e.VideoHostLayoutChange = "video-host-layout-change", e.VideoVBPreloadChange = "video-virtual-background-preload-change", e.VideoStatisticDataChange = "video-statistic-data-change", e.VideoDetailedDataChange = "video-detailed-data-change";
          }(rs || (rs = {}));
          var is = (_is = {}, _defineProperty(_is, rs.VideoActiveChange, [{
            event: "RECEIVE_VIDEO_ACTIVE_INDICATION",
            payload: function payload(e) {
              return {
                state: e.bVideoOn ? Ha.Active : Ha.Inactive,
                userId: e.userId
              };
            }
          }]), _defineProperty(_is, rs.VideoCapturingChange, [{
            event: "VIDEO_CAPTURE_START_SUCCESS",
            payload: function payload() {
              return {
                state: Wa.Started
              };
            }
          }, {
            event: "VIDEO_CAPTURE_STOP_RESULT",
            payload: function payload(e) {
              return {
                state: null != e && e.failed ? Wa.Failed : Wa.Stopped
              };
            }
          }]), _defineProperty(_is, rs.VideoMutedChange, [{
            event: "RECEIVE_VIDEO_MUTE_INDICATION",
            payload: function payload(e) {
              return {
                state: e.isVideoMuted ? Va.Muted : Va.Unmuted,
                userId: e.id
              };
            }
          }]), _defineProperty(_is, rs.AskForStartVideoConsent, [{
            event: "ASK_FOR_START_VIDEO_CONSENT",
            payload: function payload(e) {
              return {
                state: e.isVideoMuted ? Va.Muted : Va.Unmuted,
                userId: e.id
              };
            }
          }]), _defineProperty(_is, rs.VideoSpotlightChange, [{
            event: "VIDEO_SPOTLIGHT_CHANGE",
            payload: function payload(e) {
              return {
                spotlightList: e.spotlightList && e.spotlightList.map(function (e) {
                  return {
                    userId: e
                  };
                })
              };
            }
          }]), _defineProperty(_is, rs.VideoDimensionChange, [{
            event: "RECEIVE_VIDEO_DIMENSION_CHANGE",
            payload: function payload(e) {
              return {
                type: "received",
                width: e.width,
                height: e.height
              };
            }
          }]), _defineProperty(_is, rs.VideoFollowHostOrder, [{
            event: "VIDEO_FOLLOW_HOST_ORDER_CHANGE",
            payload: function payload(e) {
              return {
                isFollowHostOrder: e.bOn
              };
            }
          }]), _defineProperty(_is, rs.VideoHostLayoutChange, [{
            event: "VIDEO_HOST_DRAG_LAYOUT_CHANGE",
            payload: function payload(e) {
              return Array.isArray(e.layout) ? e.layout.map(function (e) {
                return {
                  userId: e
                };
              }) : [];
            }
          }]), _defineProperty(_is, rs.PeerVideoStateChange, [{
            event: "VIDEO_NEW_USER_START",
            payload: function payload(e) {
              return f({
                action: "Start"
              }, e);
            }
          }, {
            event: "VIDEO_OLD_USER_STOP",
            payload: function payload(e) {
              return f({
                action: "Stop"
              }, e);
            }
          }]), _defineProperty(_is, rs.VideoVBPreloadChange, [{
            event: "VIDEO_VIRTUAL_BACKGROUND_PRELOAD_READY",
            payload: function payload(e) {
              return {
                isReady: e
              };
            }
          }]), _defineProperty(_is, rs.VideoStatisticDataChange, [{
            event: "VIDEO_STATISTIC_DATA",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_is, rs.VideoDetailedDataChange, [{
            event: "VIDEO_CELL_DETAILED_DATA",
            payload: function payload(e) {
              return e;
            }
          }]), _is);
          var os;
          !function (e) {
            e.ActiveSpeaker = "active-speaker", e.UnmuteAudioConsent = "unmute-audio-consent", e.CurrentAudioChange = "current-audio-change", e.DialoutStateChange = "dialout-state-change", e.MergeAudio = "merged-audio", e.AutoPlayFailed = "auto-play-audio-failed", e.AllowTalkChange = "allow-talk-change", e.ShareAudioChange = "share-audio-change", e.AudioStatisticDataChange = "audio-statistic-data-change";
          }(os || (os = {}));
          var as = {
            JoinComputerAudio: {
              success: "AUDIO_CURRENT_USER_JOIN_BY_VOIP",
              fail: ["USER_FORBIDDEN_MICROPHONE", "ESTABLISH_AUDIO_STREAM_ERROR"]
            },
            LeaveComputerAudio: {
              success: "AUDIO_CURRENT_USER_LEAVE_AUDIO"
            },
            JoinAudioByCallMe: {
              success: "AUDIO_DIALOUT_RESULT_SUCCESS",
              fail: ["DIALOUT_FAIL"]
            },
            cancelDialOut: {
              success: "AUDIO_DIALOUT_CANCEL_SUCCESS",
              fail: ["DIALOUT_CANCEL_FAIL"]
            },
            hangup: {
              success: "AUDIO_CURRENT_USER_LEAVE_AUDIO"
            }
          },
              ss = (_ss = {}, _defineProperty(_ss, os.ActiveSpeaker, [{
            event: "AUDIO_ACTIVE_SPEAKER",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ss, os.UnmuteAudioConsent, [{
            event: "AUDIO_UNMUTE_CONSENT",
            payload: function payload(e) {
              return {
                reason: e
              };
            }
          }]), _defineProperty(_ss, os.CurrentAudioChange, [{
            event: "AUDIO_CURRENT_USER_JOIN_BY_PHONE",
            payload: function payload() {
              return {
                action: Pa.Join,
                type: "phone"
              };
            }
          }, {
            event: "AUDIO_CURRENT_USER_JOIN_BY_VOIP",
            payload: function payload() {
              return {
                action: Pa.Join,
                type: "computer"
              };
            }
          }, {
            event: "AUDIO_CURRENT_USER_LEAVE_AUDIO",
            payload: function payload() {
              return {
                action: Pa.Leave
              };
            }
          }, {
            event: "AUDIO_CURRENT_USER_MUTED",
            payload: function payload(e) {
              var t = e.source;
              return {
                action: Pa.Muted,
                source: t
              };
            }
          }, {
            event: "AUDIO_CURRENT_USER_UNMUTED",
            payload: function payload(e) {
              var t = e.source;
              return {
                action: Pa.Unmuted,
                source: t
              };
            }
          }]), _defineProperty(_ss, os.DialoutStateChange, [{
            event: "AUDIO_DIALOUT_RESULT_CODE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ss, os.MergeAudio, [{
            event: "AUDIO_MERGE_AUDIO_INDICATION",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ss, os.AutoPlayFailed, [{
            event: "AUDIO_AUTO_PLAY_FAILED",
            payload: function payload() {}
          }]), _defineProperty(_ss, os.AllowTalkChange, [{
            event: "AUDIO_ALLOW_TALK_CHANGE",
            payload: function payload(e) {
              return {
                enabled: e
              };
            }
          }]), _defineProperty(_ss, os.ShareAudioChange, [{
            event: "SHARE_AUDIO_STATE_CHANGE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ss, os.AudioStatisticDataChange, [{
            event: "AUDIO_STATISTIC_DATA",
            payload: function payload(e) {
              return e;
            }
          }]), _ss);
          var cs;
          !function (e) {
            e.ShareActiveChange = "active-share-change", e.ShareDimensionChange = "share-content-dimension-change", e.SharePassiveStop = "passively-stop-share", e.SharePeerStateChange = "peer-share-state-change", e.ShareContentChange = "share-content-change", e.SharePrivilegeChange = "share-privilege-change", e.RemoteControlApprovedChange = "remote-control-approved-change", e.RemoteControlInControlChange = "remote-control-in-control-change", e.RemoteControlClipboardChange = "remote-control-clipboard-change";
          }(cs || (cs = {}));
          var ls = (_ls = {}, _defineProperty(_ls, cs.ShareActiveChange, [{
            event: "SHARE_ACTIVE_INDICATION",
            payload: function payload(e) {
              var t = e.isActive,
                  n = e.activeUserId;
              return f({
                state: t ? "Active" : "Inactive",
                userId: n
              }, g(e, ["isActive", "activeUserId"]));
            }
          }]), _defineProperty(_ls, cs.ShareDimensionChange, [{
            event: "SHARE_DIMENSION_CHANGE",
            payload: function payload(e) {
              return {
                type: "sended",
                width: e.width,
                height: e.height
              };
            }
          }, {
            event: "SHARE_RECEIVED_DIMENSION_CHANGE",
            payload: function payload(e) {
              return {
                type: "received",
                width: e.width,
                height: e.height
              };
            }
          }]), _defineProperty(_ls, cs.SharePassiveStop, [{
            event: "SHARE_VIDEO_STREAMS_END",
            payload: function payload() {
              return {
                reason: Ka.StopScreenCapture
              };
            }
          }, {
            event: "SHARE_PASSIVE_STOP_SHARE",
            payload: function payload() {
              return {
                reason: Ka.PrivilegeChange
              };
            }
          }, {
            event: "SHARE_PASSIVE_BO_STOP",
            payload: function payload() {
              return {
                reason: Ka.ShareFromMainSession
              };
            }
          }]), _defineProperty(_ls, cs.SharePeerStateChange, [{
            event: "SHARE_NEW_USER_ADD",
            payload: function payload(e) {
              return {
                userId: e.id,
                action: "Start"
              };
            }
          }, {
            event: "SHARE_USER_REMOVE",
            payload: function payload(e) {
              return {
                userId: e.id,
                action: "Stop"
              };
            }
          }]), _defineProperty(_ls, cs.ShareContentChange, [{
            event: "SHARE_AUTO_CHANGE_SOURCE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ls, cs.RemoteControlApprovedChange, [{
            event: "SHARE_REMOTE_CONTROL_APPROVE",
            payload: function payload(e) {
              return {
                state: e ? Ga.Approved : Ga.Rejected
              };
            }
          }]), _defineProperty(_ls, cs.RemoteControlInControlChange, [{
            event: "SHARE_GRAB_REMOTE_CONTROL_CHANGE",
            payload: function payload(e) {
              return {
                isControlling: e
              };
            }
          }]), _defineProperty(_ls, cs.RemoteControlClipboardChange, [{
            event: "SHARE_REMOTE_CONTROL_CLIPBOARD_CHANGE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ls, cs.SharePrivilegeChange, [{
            event: "SHARE_PRIVILEGE_CHANGE",
            payload: function payload(e) {
              return {
                privilege: e
              };
            }
          }]), _ls);

          var ds, us, ps, hs, _s;

          !function (e) {
            e.LiveStart = "liveStart", e.LiveEnd = "liveEnd";
          }(ds || (ds = {})), function (e) {
            e.MakePublicView = "make_question_public_view", e.Comment = "comment", e.PrivateView = "private", e.DeleteComment = "deletecomment", e.DeleteQuestion = "deletequestion", e.Reopen = "reopen", e.Dismiss = "dismiss", e.Upvote = "upvote", e.RevokeUpvote = "revokeupvote";
          }(us || (us = {})), function (e) {
            e.Question = "question";
          }(ps || (ps = {})), function (e) {
            e.Question = "question", e.UpdateQuestion = "updateQuestion", e.Answer = "answer", e.DeleteComment = "deleteComment", e.DeleteQuestion = "deleteQuestion", e.Dismiss = "dismiss", e.Reopen = "reopen", e.Upvote = "upvote", e.AnswerLive = "answerLive";
          }(hs || (hs = {})), function (e) {
            e.QaSettingChange = "qa-setting-change", e.QaActionChange = "qa-action-change";
          }(_s || (_s = {}));
          var fs = (_fs = {}, _defineProperty(_fs, _s.QaSettingChange, [{
            event: "QA_SETTING_OPTION_CHANGE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_fs, _s.QaActionChange, [{
            event: "QA_NEW_ASK_QUESTION",
            payload: function payload(e) {
              return {
                action: hs.Question,
                data: e
              };
            }
          }, {
            event: "QA_UPDATE_ANONYMOUS_QUESTION",
            payload: function payload(e) {
              return {
                action: hs.UpdateQuestion,
                data: e
              };
            }
          }, {
            event: "QA_ANSWER_QUESTION",
            payload: function payload(e) {
              return {
                action: hs.Answer,
                data: e
              };
            }
          }, {
            event: "QA_ANSWER_REMOVE_COMMENT",
            payload: function payload(e) {
              return {
                action: hs.DeleteComment,
                data: e
              };
            }
          }, {
            event: "QA_ANSWER_REMOVE_QUESTION",
            payload: function payload(e) {
              return {
                action: hs.DeleteQuestion,
                data: e
              };
            }
          }, {
            event: "QA_ANSWER_DISMISS_QUESTION",
            payload: function payload(e) {
              return {
                action: hs.Dismiss,
                data: e
              };
            }
          }, {
            event: "QA_ANSWER_REOPEN_QUESTION",
            payload: function payload(e) {
              return {
                action: hs.Reopen,
                data: e
              };
            }
          }, {
            event: "QA_ANSWER_VOTE_QUESTION",
            payload: function payload(e) {
              return {
                action: hs.Upvote,
                data: e
              };
            }
          }, {
            event: "QA_ANSWER_QUESTION_LIVE",
            payload: function payload(e) {
              return {
                action: hs.AnswerLive,
                data: e
              };
            }
          }]), _fs),
              ms = "INVALID_OPERATION",
              gs = "INSUFFICIENT_PRIVILEGES",
              vs = "INVALID_PARAMETERS";
          var bs;
          !function (e) {
            e.InviteToJoin = "invite-to-join", e.RoomCountdown = "room-countdown", e.RoomTimeUp = "room-time-up", e.ClosingRoomCountdown = "closing-room-countdown", e.BroadcastMessage = "broadcast-message", e.AskForHelp = "ask-for-help", e.AskForHelpResponse = "ask-for-help-response", e.RoomStateChange = "room-state-change", e.MainSessionUserUpdate = "main-session-user-updated";
          }(bs || (bs = {}));
          var ys = (_ys = {}, _defineProperty(_ys, bs.InviteToJoin, [{
            event: "BREAKOUT_ROOM_INVITE_TO_JOIN_NOTIFICATION",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ys, bs.RoomCountdown, [{
            event: "BREAKOUT_ROOM_ROOM_COUTDOWN",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ys, bs.RoomTimeUp, [{
            event: "BREAKOUT_ROOM_ROOM_COUNTDOWN_TIME_UP",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ys, bs.ClosingRoomCountdown, [{
            event: "BREAKOUT_ROOM_ROOM_CLOSING_COUNTDOWN",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ys, bs.BroadcastMessage, [{
            event: "BREAKOUT_ROOM_BROADCAST_MESSAGE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ys, bs.AskForHelp, [{
            event: "BREAKOUT_ROOM_ASK_HELP_REQUEST",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ys, bs.AskForHelpResponse, [{
            event: "BREAKOUT_ROOM_ASK_HELP_RESPONSE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_ys, bs.RoomStateChange, [{
            event: "BREAKOUT_ROOM_ATTRIBUTE_INDICATION",
            payload: function payload(e) {
              return {
                status: e.controlStatus
              };
            }
          }]), _defineProperty(_ys, bs.MainSessionUserUpdate, [{
            event: "BREAKOUT_ROOM_MAIN_SESSION_USER_UPDATE",
            payload: function payload() {
              return {};
            }
          }]), _ys);
          var ws;
          !function (e) {
            e.StatusUpdate = "archiving-status-update", e.OptionsUpdate = "archiving-options-update";
          }(ws || (ws = {}));

          var Ss = (_Ss = {}, _defineProperty(_Ss, ws.StatusUpdate, [{
            event: "ARCHIVING_STATUS_UPDATE",
            payload: function payload(e) {
              return e;
            }
          }]), _defineProperty(_Ss, ws.OptionsUpdate, [{
            event: "ARCHIVING_OPTIONS_UPDATE",
            payload: function payload(e) {
              return e;
            }
          }]), _Ss),
              xs = f(f(f(f(f(f(f(f(f(f(f(f({}, ya), {
            "closed-caption-message": [{
              event: "CC_RECEIVE_MESSAGE",
              payload: function payload(e) {
                return e;
              }
            }],
            "closed-caption-lt-status": [{
              event: "LT_STATUS_CHANGE",
              payload: function payload(e) {
                return e;
              }
            }],
            "closed-caption-lt-message": [{
              event: "LT_RECEIVE_MESSAGE",
              payload: function payload(e) {
                return e;
              }
            }],
            "closed-caption-status": [{
              event: "CC_ASSIGN_CC_EDITOR_SUCCESS",
              payload: function payload(e) {
                return e;
              }
            }, {
              event: "CC_STATUS_CHANGE",
              payload: function payload(e) {
                return e;
              }
            }]
          }), Sa), Ea), Ia), ss), is), fs), ls), ts), ys), Ss),
              Es = function (e) {
            return {
              all: e = e || new Map(),
              on: function on(t, n) {
                var r = e.get(t);
                r ? r.push(n) : e.set(t, [n]);
              },
              off: function off(t, n) {
                var r = e.get(t);
                r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
              },
              emit: function emit(t, n) {
                var r = e.get(t);
                r && r.slice().map(function (e) {
                  e(n);
                }), (r = e.get("*")) && r.slice().map(function (e) {
                  e(t, n);
                });
              }
            };
          }(),
              Cs = new Map(),
              ks = new Array(),
              As = function As(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
            Es.emit(e, t);
          },
              Is = function Is(e) {
            return new Promise(function (t, n) {
              e.fail && e.fail.length > 0 ? mt(ot(Es, e.success).pipe(Nt(1)), dt.apply(void 0, _toConsumableArray(e.fail.map(function (e) {
                return ot(Es, e).pipe(Nt(1), Je(function (t) {
                  return me({
                    type: e,
                    payload: t
                  });
                }));
              })))).subscribe(function (e) {
                return t(e);
              }, function (e) {
                "object" == typeof e.payload ? n(f({
                  type: e.type
                }, e.payload)) : void 0 === e.payload ? n({
                  type: e.type
                }) : n(e);
              }) : ot(Es, e.success).pipe(Nt(1)).subscribe(function (e) {
                return t(e);
              });
            });
          },
              Ts = function Ts(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e4;
            return new Promise(function (r, i) {
              var o = ce;
              "string" == typeof e ? o = ot(Es, e).pipe(Nt(1)) : (o = ot(Es, e.event), e.operations && (o = e.operations.reduce(function (e, t) {
                return e.pipe(t);
              }, o))), mt(o, bt(n).pipe(qt(me("timeout")))).subscribe(function (e) {
                if (t) {
                  var _n7 = t(e);

                  "boolean" == typeof _n7 ? _n7 ? r("") : i({
                    type: "INTERNAL_ERROR"
                  }) : 0 === _n7.ret ? r(_n7.body) : i({
                    type: "INTERNAL_ERROR",
                    reason: _n7.body
                  });
                } else r(e);
              }, function () {
                i({
                  type: "OPERATION_TIMEOUT"
                });
              });
            });
          },
              Os = function Os(e, t) {
            return void 0 !== t ? ot(Es, e).pipe(Nt(t)) : ot(Es, e);
          },
              Rs = function Rs() {
            ks.forEach(function (e) {
              e.unsubscribe();
            }), ks.length = 0, Cs.clear();
          },
              _or4 = or({
            SET_ATTENDEES_LIST: function SET_ATTENDEES_LIST(e) {
              return e;
            },
            SET_ASSISTANT_LIST: function SET_ASSISTANT_LIST(e) {
              return e;
            },
            UPDATE_XMPP_ATTENDEE_LIST: function UPDATE_XMPP_ATTENDEE_LIST(e) {
              return e;
            },
            RESET_PARTICIPANTS: function RESET_PARTICIPANTS() {
              return {};
            },
            SET_IS_ADMIT_ALL_SILENT_USERS: function SET_IS_ADMIT_ALL_SILENT_USERS(e) {
              return e;
            },
            REMOVE_FAILOVER_ATTENDEES: function REMOVE_FAILOVER_ATTENDEES(e) {
              return e;
            },
            ADD_FAILOVER_ATTENDEES: function ADD_FAILOVER_ATTENDEES(e) {
              return e;
            },
            SET_CLEAR_RAISE_HAND: function SET_CLEAR_RAISE_HAND() {
              return {};
            },
            SET_CLEAR_ATTENDEE_FEEDBACK: function SET_CLEAR_ATTENDEE_FEEDBACK() {
              return {};
            },
            UPDATE_ATTENDEE_DISPLAY_NAME: function UPDATE_ATTENDEE_DISPLAY_NAME(e) {
              return e;
            },
            REMOVE_XMPP_ATTENDEE_USER: function REMOVE_XMPP_ATTENDEE_USER(e) {
              return e;
            }
          }),
              Ns = _or4.setAttendeesList,
              Ps = _or4.setAssistantList,
              js = _or4.setIsAdmitAllSilentUsers,
              Ds = _or4.resetParticipants,
              zs = _or4.addFailoverAttendees,
              Ms = _or4.removeFailoverAttendees,
              Ls = _or4.setClearRaiseHand,
              Us = _or4.setClearAttendeeFeedback,
              Bs = _or4.updateAttendeeDisplayName,
              Hs = _or4.removeXmppAttendeeUser,
              Vs = _or4.updateXmppAttendeeList;

          var qs = function qs(e, t) {
            return e === t;
          };

          function Fs(e) {
            var t = Array.isArray(e[0]) ? e[0] : e;

            if (!t.every(function (e) {
              return "function" == typeof e;
            })) {
              var n = t.map(function (e) {
                return "function" == typeof e ? "function " + (e.name || "unnamed") + "()" : typeof e;
              }).join(", ");
              throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + n + "]");
            }

            return t;
          }

          var Ws = function (e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            var i = function i() {
              for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
                r[i] = arguments[i];
              }

              var o,
                  a = 0,
                  s = {
                memoizeOptions: void 0
              },
                  c = r.pop();
              if ("object" == typeof c && (s = c, c = r.pop()), "function" != typeof c) throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof c + "]");

              var l = s.memoizeOptions,
                  d = void 0 === l ? n : l,
                  u = Array.isArray(d) ? d : [d],
                  p = Fs(r),
                  h = e.apply(void 0, [function () {
                return a++, c.apply(null, arguments);
              }].concat(u)),
                  _ = e(function () {
                for (var e = [], t = p.length, n = 0; n < t; n++) {
                  e.push(p[n].apply(null, arguments));
                }

                return o = h.apply(null, e);
              });

              return Object.assign(_, {
                resultFunc: c,
                memoizedResultFunc: h,
                dependencies: p,
                lastResult: function lastResult() {
                  return o;
                },
                recomputations: function recomputations() {
                  return a;
                },
                resetRecomputations: function resetRecomputations() {
                  return a = 0;
                }
              }), _;
            };

            return i;
          }(function (e, t) {
            var n,
                r,
                i = "object" == typeof t ? t : {
              equalityCheck: t
            },
                o = i.equalityCheck,
                a = void 0 === o ? qs : o,
                s = i.maxSize,
                c = void 0 === s ? 1 : s,
                l = i.resultEqualityCheck,
                d = function (e) {
              return function (t, n) {
                if (null === t || null === n || t.length !== n.length) return !1;

                for (var r = t.length, i = 0; i < r; i++) {
                  if (!e(t[i], n[i])) return !1;
                }

                return !0;
              };
            }(a),
                u = 1 === c ? (n = d, {
              get: function get(e) {
                return r && n(r.key, e) ? r.value : "NOT_FOUND";
              },
              put: function put(e, t) {
                r = {
                  key: e,
                  value: t
                };
              },
              getEntries: function getEntries() {
                return r ? [r] : [];
              },
              clear: function clear() {
                r = void 0;
              }
            }) : function (e, t) {
              var n = [];

              function r(e) {
                var r = n.findIndex(function (n) {
                  return t(e, n.key);
                });

                if (r > -1) {
                  var i = n[r];
                  return r > 0 && (n.splice(r, 1), n.unshift(i)), i.value;
                }

                return "NOT_FOUND";
              }

              return {
                get: r,
                put: function put(t, i) {
                  "NOT_FOUND" === r(t) && (n.unshift({
                    key: t,
                    value: i
                  }), n.length > e && n.pop());
                },
                getEntries: function getEntries() {
                  return n;
                },
                clear: function clear() {
                  n = [];
                }
              };
            }(c, d);

            function p() {
              var t = u.get(arguments);

              if ("NOT_FOUND" === t) {
                if (t = e.apply(null, arguments), l) {
                  var n = u.getEntries().find(function (e) {
                    return l(e.value, t);
                  });
                  n && (t = n.value);
                }

                u.put(arguments, t);
              }

              return t;
            }

            return p.clearCache = function () {
              return u.clear();
            }, p;
          });

          var Gs = function Gs(e) {
            var t = e.participants.attendeesList;
            return t;
          },
              Ks = function Ks(e) {
            var t = e.participants.xmppAttendeeList;
            return t;
          };

          var Qs, Zs, Ys;
          !function (e) {
            e[e.Attendee = 0] = "Attendee", e[e.Host = 1] = "Host", e[e.Owner = 4] = "Owner", e[e.ViewOnly = 8] = "ViewOnly", e[e.HostOwner = 5] = "HostOwner", e[e.ViewOnlyCanTalk = 24] = "ViewOnlyCanTalk";
          }(Qs || (Qs = {})), function (e) {
            e[e.Host = 10] = "Host", e[e.Panelist = 20] = "Panelist", e[e.Attendee = 30] = "Attendee";
          }(Zs || (Zs = {})), function (e) {
            e[e.Client = 9] = "Client", e[e.Phone = 5] = "Phone", e[e.H323 = 15] = "H323";
          }(Ys || (Ys = {}));

          var Js = function Js(e) {
            return (e & Qs.Host) === Qs.Host;
          },
              $s = function $s(e) {
            return (e & Ys.Phone) === Ys.Phone;
          },
              Xs = function Xs(e) {
            return e === Qs.ViewOnlyCanTalk;
          },
              ec = function ec(e) {
            return (e & Qs.ViewOnly) === Qs.ViewOnly;
          };

          var tc, nc, rc, ic, oc, ac;
          !function (e) {
            e[e.Automatically = 1] = "Automatically", e[e.Manually = 2] = "Manually";
          }(tc || (tc = {})), function (e) {
            e[e.NotStarted = 1] = "NotStarted", e[e.InProgress = 2] = "InProgress", e[e.Closing = 3] = "Closing", e[e.Closed = 4] = "Closed";
          }(nc || (nc = {})), function (e) {
            e[e.NoToken = 1] = "NoToken", e[e.GotToken = 2] = "GotToken", e[e.Started = 3] = "Started", e[e.Closing = 4] = "Closing", e[e.Closed = 5] = "Closed";
          }(rc || (rc = {})), function (e) {
            e.Initial = "initial", e.Invited = "invited", e.Joining = "joining", e.InRoom = "in room", e.Leaving = "leaving", e.TimeUp = "time up", e.MainSession = "main session";
          }(ic || (ic = {})), function (e) {
            e.Join = "joinRequest", e.Switch = "switchRequest", e.Leave = "leaveRequest", e.Broadcast = "messageText", e.HelpReq = "helpRequest", e.HelpRes = "helpResponse", e.CoHostWantJoinThisBo = "wantJoinThisBO";
          }(oc || (oc = {})), function (e) {
            e[e.Received = 0] = "Received", e[e.Busy = 1] = "Busy", e[e.Ignore = 2] = "Ignore", e[e.AlreadyInRoom = 3] = "AlreadyInRoom";
          }(ac || (ac = {}));

          var sc = Ws([function (e) {
            var t = e.meeting.userId;
            return t;
          }, Gs], function (e, t) {
            return t.find(function (t) {
              return t.userId === e;
            });
          }),
              cc = Ws([sc], function (e) {
            return (null == e ? void 0 : e.isHost) || (null == e ? void 0 : e.bCoHost);
          }),
              lc = Ws([sc], function (e) {
            return null == e ? void 0 : e.isHost;
          }),
              dc = Ws([Ks], function (e) {
            return e.filter(function (e) {
              return e.userRole === Zs.Attendee;
            });
          }),
              uc = Ws([Gs], function (e) {
            return e.filter(function (e) {
              return e.bHold && !e.bid;
            });
          }),
              pc = Ws([Gs, function (e) {
            var t = e.breakoutRoom;
            return t && t.controlStatus;
          }, function (e) {
            var t = e.breakoutRoom;
            return t && t.currentRoom.status;
          }], function (e, t, n) {
            return t !== nc.InProgress && t !== nc.Closing || n !== ic.InRoom ? e.filter(function (e) {
              return !e.bHold && !e.bid;
            }) : e.filter(function (e) {
              return !e.bHold;
            });
          }),
              hc = Ws([function (e) {
            var t = e.participants.assistantList;
            return t;
          }], function (e) {
            return e;
          }),
              _c = Ws([pc], function (e) {
            return e.find(function (e) {
              return e.isHost;
            });
          }),
              fc = Ws([pc], function (e) {
            return e.filter(function (e) {
              return e.bCoHost;
            });
          }),
              mc = Ws([sc, pc], function (e, t) {
            return t.filter(function (t) {
              return t.userId !== (null == e ? void 0 : e.userId);
            });
          }),
              gc = Ws([Ks], function (e) {
            return e.reduce(function (e, t) {
              var n = t.jid;
              return Object.assign(e, _defineProperty({}, n, t)), e;
            }, {});
          }),
              vc = Ws([Ks, function (e) {
            var t = e.meeting.jid;
            return t;
          }], function (e, t) {
            var n;
            return null === (n = e.find(function (e) {
              return e.jid === t;
            })) || void 0 === n ? void 0 : n.userId;
          });

          var bc;
          !function (e) {
            e.Closed = "closed", e.Connecting = "connecting", e.Connected = "connected";
          }(bc || (bc = {}));

          var _or5 = or("SET_ASN_IDS", "SET_IS_CAN_UNMUTE", "SET_DIALOUT_SEQUENCE", "SET_DIALOUT_RESULT_CODE", "SET_IS_ALLOW_TO_TALK", "SET_IS_HOST_MUTE_ALL", "SET_IS_ACTIVE_OPERATION", "SET_AUDIO_SSRC", "SET_IS_MUTED_UPON_ENTRY", "SET_IS_USER_GRANT_CAPTURE_AUDIO", "SET_IS_MICROPHONE_FORBIDDEN", "SET_WEBRTC_RESTART_COUNT", "SET_MICROPHONE_LIST", "SET_SPEAKER_LIST", "SET_ACTIVE_MICROPHONE", "SET_ACTIVE_SPEAKER", "SET_CAN_PLAY_AUDIO", "RESET_AUDIO", "SET_IS_COMPUTER_AUDIO_LOADING", "SET_IS_SPEAKER_ONLY", "SET_IS_ALLOW_TO_TALK_ATTENDEE_CONNECTED", "SET_IS_MUTE_BEFORE_SHARING_AUDIO", "SET_IS_SHARING_AUDIO", "ADD_LOCAL_SHARE_AUDIO_USER", "UPDATE_LOCAL_SHARE_AUDIO_USER", "SET_IS_JOIN_COMPUTER_AUDIO_BEFORE_SHARING_AUDIO", "SET_IS_SHARE_AUDIO_ENABLED", "SET_IS_SHARE_AUDIO_MUTED", "SET_AUDIO_DATA_ENCODING", "SET_AUDIO_DATA_DECODING", "ADD_LOCALLY_MUTED_AUDIO", "REMOVE_LOCALLY_MUTED_AUDIO"),
              yc = _or5.setAsnIds,
              wc = _or5.setIsCanUnmute,
              Sc = _or5.setDialoutSequence,
              xc = _or5.setDialoutResultCode,
              Ec = _or5.setIsAllowToTalk,
              Cc = _or5.setIsHostMuteAll,
              kc = _or5.setIsActiveOperation,
              Ac = _or5.setAudioSsrc,
              Ic = _or5.setIsMutedUponEntry,
              Tc = _or5.setIsUserGrantCaptureAudio,
              Oc = _or5.setIsMicrophoneForbidden,
              Rc = _or5.setWebrtcRestartCount,
              Nc = _or5.setMicrophoneList,
              Pc = _or5.setSpeakerList,
              jc = _or5.setActiveMicrophone,
              Dc = _or5.setActiveSpeaker,
              zc = _or5.setCanPlayAudio,
              Mc = _or5.resetAudio,
              Lc = _or5.setIsComputerAudioLoading,
              Uc = _or5.setIsSpeakerOnly,
              Bc = _or5.setIsAllowToTalkAttendeeConnected,
              Hc = _or5.setIsMuteBeforeSharingAudio,
              Vc = _or5.addLocalShareAudioUser,
              qc = _or5.updateLocalShareAudioUser,
              Fc = _or5.setIsJoinComputerAudioBeforeSharingAudio,
              Wc = _or5.setIsShareAudioEnabled,
              Gc = _or5.setIsShareAudioMuted,
              Kc = _or5.setIsSharingAudio,
              Qc = _or5.setAudioDataEncoding,
              Zc = _or5.setAudioDataDecoding,
              Yc = _or5.addLocallyMutedAudio,
              Jc = _or5.removeLocallyMutedAudio,
              _or6 = or("SET_SHARE_PRIVILEGE", "SET_SHARE_ACTIVE_NODE", "SET_IS_RECEIVE_SHARING", "SET_IS_CHROME_EXTENSION_INSTALLED", "SET_IS_SCREEN_SHARE_FORBIDDEN", "SET_SHARE_DIMENSION", "SET_SHARE_STATUS", "SET_SHARE_SSRC", "SET_SHARE_QUALITY", "SET_RECEIVED_SHARE_DIMENSION", "SET_IS_REMOTE_CONTROL_APPROVED", "SET_IS_GRAB_REMOTE_CONTROL", "SET_IS_VERIFIED_SHARING_RENDER_CANVAS_AFTER_FAILOVER", "SET_IS_VERIFIED_SHARING_CAPTURE_CANVAS_AFTER_FAILOVER", "SET_IS_SDK_GRAB_CONTROL", "SET_IS_RECEIVE_SHARING_FROM_MAIN_SESSION", "SET_IS_SHARING_TO_BREAKOUT_ROOM", "SET_IS_SHARING_WITH_SECOND_CAMERA", "SET_SHRING_SECOND_CAMERA_ID", "RESET_SHARE"),
              $c = _or6.setSharePrivilege,
              Xc = _or6.setShareActiveNode,
              el = _or6.setIsReceiveSharing,
              tl = _or6.setIsChromeExtensionInstalled,
              nl = _or6.setIsScreenShareForbidden,
              rl = _or6.setShareDimension,
              il = _or6.setShareStatus,
              ol = _or6.setShareSsrc,
              al = _or6.setShareQuality,
              sl = _or6.setReceivedShareDimension,
              cl = _or6.setIsRemoteControlApproved,
              ll = _or6.setIsGrabRemoteControl,
              dl = _or6.setIsVerifiedSharingRenderCanvasAfterFailover,
              ul = _or6.setIsVerifiedSharingCaptureCanvasAfterFailover,
              pl = _or6.setIsSdkGrabControl,
              hl = _or6.setIsReceiveSharingFromMainSession,
              _l = _or6.setIsSharingToBreakoutRoom,
              fl = _or6.setIsSharingWithSecondCamera,
              ml = _or6.setShringSecondCameraId,
              gl = _or6.resetShare,
              _or7 = or("SET_VIDEO_SSRC", "SET_ACTIVE_VIDEO_ID", "SET_CAMERA_LIST", "SET_ACTIVE_CAMERA", "SET_IS_CURRENT_USER_STARTED_VIDEO", "SET_SPOTLIGHT_VIDEO", "SET_IS_CAPTURE_FORBIDDEN", "SET_VIDEO_MAX_QUALITY", "SET_CAPTURE_CANVAS_LIST", "SET_IS_VIDEO_MUTED", "SET_IS_CAPTURE_CAMERA_LOADING", "SET_IS_CAMERA_TAKEN", "SET_IS_VERIFIED_VIDEO_RENDER_CANVAS_AFTER_FAILOVER", "SET_IS_VERIFIED_VIDEO_CAPTURE_CANVAS_AFTER_FAILOVER", "RESET_VIDEO", "SET_RECEIVED_VIDEO_DIMENSION", "ADD_SUBSCRIBED_VIDEO_ID", "REMOVE_SUBSCRIBED_VIDEO_ID", "SET_IS_FOLLOW_HOST_VIDEO_LAYOUT", "SET_HOST_DRAG_LAYOUT", "ADD_RENDERED_VIDEO_ID", "REMOVE_RENDERED_VIDEO_ID", "SET_IS_SUPPORT_HD_VIDEO", "SET_HIGH_DEFINITION_VIDEO_ID", "SET_IS_CAN_UNMUTE_VIDEO", "SET_IS_VB_PRELOAD_READY", "SET_IS_VB_CONFIGED", "SET_VB_IMAGE_SRC", "SET_VIDEO_DATA_ENCODING", "SET_VIDEO_DATA_DECODING", "SET_HARDWARE_ACCELERATION_STATE", "SET_VIDEO_CAPTURE_CUSTOMIZED_OPTION"),
              vl = _or7.setVideoSsrc,
              bl = _or7.setActiveVideoId,
              yl = _or7.setCameraList,
              wl = _or7.setActiveCamera,
              Sl = _or7.setIsCurrentUserStartedVideo,
              xl = _or7.setSpotlightVideo,
              El = _or7.setIsCaptureForbidden,
              Cl = _or7.setVideoMaxQuality,
              kl = _or7.setCaptureCanvasList,
              Al = _or7.setIsVideoMuted,
              Il = _or7.setIsCaptureCameraLoading,
              Tl = _or7.setIsCameraTaken,
              Ol = _or7.setIsVerifiedVideoRenderCanvasAfterFailover,
              Rl = _or7.setIsVerifiedVideoCaptureCanvasAfterFailover,
              Nl = _or7.resetVideo,
              Pl = _or7.setReceivedVideoDimension,
              jl = _or7.addSubscribedVideoId,
              Dl = _or7.removeSubscribedVideoId,
              zl = _or7.setIsFollowHostVideoLayout,
              Ml = _or7.setHostDragLayout,
              Ll = _or7.addRenderedVideoId,
              Ul = _or7.removeRenderedVideoId,
              Bl = _or7.setIsSupportHdVideo,
              Hl = _or7.setHighDefinitionVideoId,
              Vl = _or7.setIsCanUnmuteVideo,
              ql = _or7.setIsVbPreloadReady,
              Fl = _or7.setIsVbConfiged,
              Wl = _or7.setVbImageSrc,
              Gl = _or7.setVideoDataEncoding,
              Kl = _or7.setVideoDataDecoding,
              Ql = _or7.setHardwareAccelerationState,
              Zl = _or7.setVideoCaptureCustomizedOption,
              _or8 = or("SET_QA_SETTING", "ADD_QA_QUESTION", "ADD_QA_ANSWER", "REMOVE_QA_COMMENT", "REMOVE_QA_QUESTION", "DISMISS_QA_QUESTION", "REOPEN_QA_QUESTION", "VOTE_QA_QUESTION", "ANSWER_QA_QUESTION_LIVE", "UPDATE_ATTENDEE_ANONYMOUS_QUESTION", "SET_QA_ENABLED", "RESET_QA"),
              Yl = _or8.setQaSetting,
              Jl = _or8.addQaQuestion,
              $l = _or8.addQaAnswer,
              Xl = _or8.removeQaComment,
              ed = _or8.removeQaQuestion,
              td = _or8.dismissQaQuestion,
              nd = _or8.reopenQaQuestion,
              rd = _or8.voteQaQuestion,
              id = _or8.answerQaQuestionLive,
              od = _or8.updateAttendeeAnonymousQuestion,
              ad = _or8.setQaEnabled,
              sd = _or8.resetQa,
              _or9 = or("SET_CHAT_PRIVILEGE", "SET_PANELIST_CHAT_PRIVILEGE", "ADD_CHAT_MESSAGE_HISTORY", "RESET_CHAT", "SET_IS_ALLOW_ATTENDEE_CHAT", "SET_LATEST_CHAT_MESSAGE_ID", "REMOVE_CHAT_MESSAGE"),
              cd = _or9.setChatPrivilege,
              ld = _or9.setPanelistChatPrivilege,
              dd = _or9.addChatMessageHistory,
              ud = _or9.resetChat,
              pd = _or9.setIsAllowAttendeeChat,
              hd = _or9.setLatestChatMessageId,
              _d = _or9.removeChatMessage,
              _or10 = or("SET_CC_EDITOR_INFO", "SET_CC_LT_MESSAGE", "SET_TEMP_SEND_CC_TEXT", "SET_TEMP_RECEIVE_LT_TEXT", "SET_TEMP_RECEIVE_CC_TEXT", "SET_GATEWAY_INFO_LIST", "SET_LT_ENABLE", "SET_IS_LISTEN_CLOSED_CAPTION", "SET_CC_ENABLE", "ALLOW_PARTICIPANT_ASK_LT", "RECEIVE_ASK_START_LT", "SET_MEETING_ENABLED_LT_FEATURE", "UPDATE_LT_STATUS", "DELETE_MESSAGE", "UPDATE_MESSAGE", "RESET_CLOSED_CAPTION"),
              fd = _or10.setCcEditorInfo,
              md = _or10.setTempSendCcText,
              gd = _or10.setCcLtMessage,
              vd = _or10.setTempReceiveLtText,
              bd = _or10.setTempReceiveCcText,
              yd = _or10.setGatewayInfoList,
              wd = _or10.setLtEnable,
              Sd = _or10.setIsListenClosedCaption,
              xd = _or10.setCcEnable,
              Ed = _or10.allowParticipantAskLt,
              Cd = _or10.receiveAskStartLt,
              kd = _or10.setMeetingEnabledLtFeature,
              Ad = _or10.updateLtStatus,
              Id = _or10.deleteMessage,
              Td = _or10.updateMessage,
              Od = _or10.resetClosedCaption,
              _or11 = or("ADD_BREAKOUT_ROOMS", "SET_BREAKOUT_ROOM_ALLOCATION_PATTERN", "SET_BREAKOUT_ROOM_SEQUENCE_ID", "SET_MEETING_ELAPSED_TIME", "SET_START_ROOM_ELAPSED_TIME", "SET_BREAKOUT_ROOM_OPTIONS", "SET_BREAKOUT_ROOM_CONTROL_STATUS", "SET_BREAKOUT_ROOMS", "SET_CURRENT_BREAKOUT_ROOM", "SET_BREAKOUT_ROOM_ATTENDEE_STATUS", "SET_BREAKOUT_ROOM_CONF_ID", "SET_BREAKOUT_ROOM_TOKEN", "RESET_BREAKOUT_ROOM", "SET_BREAKOUT_ROOM_CLOSING_ROOM_TIME", "SET_BREAKOUT_ROOM_BROADCAST_MESSAGE", "SET_BREAKOUT_ROOM_HOST_REPLY_TYPE", "SET_BREAKOUT_ROOM_HOST_REPLY_REQUEST_ID", "SET_MAIN_SESSION_ATTENDEE_LIST", "SET_IS_HUGE_BREAKOUT_ROOM", "SET_BREAKOUT_ROOM_PRE_ASSIGNED_ROOM_LIST", "SET_BREAKOUT_ROOM_USER_ROLE_UPDATED", "SET_BREAKOUT_ROOM_MEETING_OPTIONS"),
              Rd = _or11.addBreakoutRooms,
              Nd = _or11.setBreakoutRoomAllocationPattern,
              Pd = _or11.setBreakoutRoomSequenceId,
              jd = _or11.setMeetingElapsedTime,
              Dd = _or11.setStartRoomElapsedTime,
              zd = _or11.setBreakoutRoomOptions,
              Md = _or11.setBreakoutRoomControlStatus,
              Ld = _or11.setBreakoutRooms,
              Ud = _or11.setCurrentBreakoutRoom,
              Bd = _or11.setBreakoutRoomAttendeeStatus,
              Hd = _or11.setBreakoutRoomConfId,
              Vd = _or11.setBreakoutRoomToken,
              qd = _or11.resetBreakoutRoom,
              Fd = _or11.setBreakoutRoomClosingRoomTime,
              Wd = _or11.setBreakoutRoomBroadcastMessage,
              Gd = _or11.setBreakoutRoomHostReplyType,
              Kd = _or11.setBreakoutRoomHostReplyRequestId,
              Qd = _or11.setMainSessionAttendeeList,
              Zd = _or11.setIsHugeBreakoutRoom,
              Yd = _or11.setBreakoutRoomPreAssignedRoomList,
              Jd = _or11.setBreakoutRoomUserRoleUpdated,
              $d = _or11.setBreakoutRoomMeetingOptions,
              _or12 = or("SET_CLOUD_RECORDING_STATUS", "SET_CLOUD_RECORDING_ENABLE", "SET_ALLOW_STOP_AUTO_RECORDING", "SET_AUTOMATIC_CLOUD_RECORDING_ENABLE", "RESET_RECORDING"),
              Xd = _or12.setCloudRecordingStatus,
              eu = _or12.setCloudRecordingEnable,
              tu = _or12.setAllowStopAutoRecording,
              nu = _or12.setAutomaticCloudRecordingEnable,
              ru = _or12.resetRecording,
              _or13 = or("UPDATE_CMD_JID", "REMOVE_CMD_JID", "SET_CMD_CHANNEL_CONNECTION_STATUS", "RESET_CMD_CHANNEL"),
              iu = _or13.updateCmdJid,
              ou = _or13.removeCmdJid,
              au = _or13.setCmdChannelConnectionStatus,
              su = _or13.resetCmdChannel,
              _or14 = or({
            SET_ARCHIVING_STATUS: function SET_ARCHIVING_STATUS(e) {
              return e;
            },
            SET_ARCHIVING_SESSION_READY: function SET_ARCHIVING_SESSION_READY(e) {
              return e;
            },
            SET_ARCHIVING_OPTIONS: function SET_ARCHIVING_OPTIONS(e) {
              return e;
            },
            RESET_ARCHIVING: function RESET_ARCHIVING() {}
          }),
              cu = _or14.setArchivingStatus,
              lu = _or14.setArchivingSessionReady,
              du = _or14.setArchivingOptions,
              uu = _or14.resetArchiving;

          function pu(e) {
            var _e$meeting = e.meeting,
                t = _e$meeting.apiKey,
                n = _e$meeting.signature,
                r = _e$meeting.signatureType,
                i = _e$meeting.meetingNumber,
                o = _e$meeting.userName,
                a = _e$meeting.lang,
                s = _e$meeting.passWord,
                c = _e$meeting.userEmail,
                l = _e$meeting.sdkUrl,
                d = _e$meeting.sdkOrigin,
                u = _e$meeting.proxy,
                p = _e$meeting.cv,
                h = _e$meeting.ztk,
                _ = _e$meeting.zsk,
                f = _e$meeting.tk,
                m = h || sessionStorage.getItem(Vo.WebclientZtk),
                g = _ || sessionStorage.getItem(Vo.WebclientZsk);

            return {
              apiKey: t,
              signature: n,
              signatureType: r,
              meetingNumber: i,
              userName: o,
              lang: a,
              passWord: s,
              userEmail: c,
              sdkUrl: l,
              sdkOrigin: d,
              proxy: u,
              cv: p,
              ztk: m,
              zsk: g,
              tk: f || sessionStorage.getItem(Vo.WebclientTk),
              ulsm: g ? 1 : 0
            };
          }

          var hu = function hu(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            var _e$socket = e.socket,
                n = _e$socket.zoomSocketStatus,
                r = _e$socket.xmppSocketStatus,
                i = _e$socket.mainSessionSocketStatus,
                o = e.meeting.meetingStatus,
                a = [];

            if (o === go.Joined) {
              var _t7 = ma.getInstance(),
                  _n8 = ua.createAgent();

              if (_t7.disconnect(), _t7.destroy(), e.video && (e.video.subscribedVideoList.length > 0 && e.video.subscribedVideoList.forEach(function (e) {
                _n8.unsubscribeVideo(e);
              }), e.video.isCurrentUserStartedVideo && As("VIDEO_CAPTURE_STOP_RESULT")), e.share && e.share.isReceiveSharing) {
                var _t8 = e.share.activeNodeId;
                e.share.isRemoteControlApproved && _n8.sharingRequestRemoteControl(_t8, !1), _n8.unsubscribeSharing(_t8);
              }
            }

            if (t || (wo.clearSession(), [Vo.WebclientTk, Vo.WebclientZsk, Vo.WebclientZtk].forEach(function (e) {
              sessionStorage.removeItem(e);
            }), Ko.destroy()), n !== bc.Closed && a.push(_r()), r !== bc.Closed && a.push(fr()), i !== bc.Closed && a.push(yr()), t) {
              var _t9 = sc(e);

              a.push(Fi({
                audio: null == _t9 ? void 0 : _t9.audio,
                muted: null == _t9 ? void 0 : _t9.muted,
                video: null == _t9 ? void 0 : _t9.bVideoOn
              }));
            } else a.push(Fi({
              audio: !1,
              muted: void 0,
              video: !1
            }));

            return a.push(Ar(), Lr(), Ds(), Mc(t), gl(), Nl(), sd(), ud(), ru(), Od(), qd(), su(), uu(), $i(go.Closed)), a;
          },
              _u = function _u(e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            return Ts.apply(void 0, [{
              event: "UPDATE_USER_PARTICIPANT_ATTRIBUTE",
              operations: [Me(function (t) {
                return t.find(function (t) {
                  return t.userId === e;
                });
              }), pt(function (e) {
                return !!e;
              }), Nt(1)]
            }].concat(n));
          };

          function fu(e) {
            return G(Me(function (t, n) {
              return e(t, n);
            }), pt(function (e) {
              return null != e;
            }));
          }

          function mu(e) {
            return G(Je(function (t, n) {
              return e(t, n) || ce;
            }));
          }

          function gu(e) {
            return G(Yt(function (t, n) {
              return e(t, n) || ce;
            }));
          }

          function vu(e) {
            return G(Je(function (t, n) {
              return e(t, n);
            }), Je(function (e) {
              return Array.isArray(e) ? Ke(e) : fe(e);
            }));
          }

          var bu = function bu(e, t) {
            var n = performance.now();
            var r = 0,
                i = !1;
            return setTimeout(function o() {
              r += t, e();
              var a = performance.now() - n - r,
                  s = setTimeout(o, Math.max(t - a, 0));
              i && clearTimeout(s);
            }, t), function () {
              i = !0;
            };
          },
              yu = {
            period: 500,
            rules: [{
              peak: 50,
              throttle: 300
            }, {
              peak: 60,
              throttle: 400
            }]
          },
              wu = _defineProperty({}, "".concat(7937), function () {
            return {
              payloads: {
                add: [],
                update: [],
                remove: []
              },
              onThrottle: function onThrottle(e) {
                var _this$payloads$add, _this$payloads$update, _this$payloads$remove;

                e.add && (_this$payloads$add = this.payloads.add).push.apply(_this$payloads$add, _toConsumableArray(e.add)), e.update && (_this$payloads$update = this.payloads.update).push.apply(_this$payloads$update, _toConsumableArray(e.update)), e.remove && (_this$payloads$remove = this.payloads.remove).push.apply(_this$payloads$remove, _toConsumableArray(e.remove));
              }
            };
          });

          function Su() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : yu;
            return function (t) {
              return new Q(function (n) {
                var r = new Map();
                var i = 0,
                    o = null;
                var a = e.period,
                    s = e.rules;
                var c = null;
                o || (o = bu(function () {
                  i = 0;
                }, a));
                var l = Object.keys(wu),
                    d = t.subscribe({
                  next: function next(e) {
                    if (e && e.evt && null !== o) {
                      i += 1;

                      var _t10 = e.evt,
                          _o5 = e.body,
                          _a4 = String(_t10);

                      if (l.indexOf(_a4) >= 0) {
                        if (c) {
                          var _e9 = r.get(_a4);

                          if (_e9) _e9.onThrottle(_o5);else {
                            var _e10 = wu[_a4]();

                            _e10.onThrottle(_o5), r.set(_a4, _e10);
                          }
                        } else {
                          var _t11 = 0;

                          if (s.forEach(function (e) {
                            i > e.peak && (_t11 = e.throttle);
                          }), _t11 > 0) {
                            var _e11 = wu[_a4]();

                            _e11.onThrottle(_o5), r.set(_a4, _e11), c = setTimeout(function () {
                              r.forEach(function (e, t) {
                                var r = {
                                  evt: Number(t),
                                  body: e.payloads
                                };
                                n.next(r);
                              }), r.clear(), c = null;
                            }, _t11);
                          } else n.next(e);
                        }
                      } else n.next(e);
                    } else n.next(e);
                  },
                  error: function error(e) {
                    n.error(e);
                  },
                  complete: function complete() {
                    n.complete();
                  }
                });
                return function () {
                  d.unsubscribe(), o && (o(), o = null), i = 0;
                };
              });
            };
          }

          var xu = Ws([pc, function (e) {
            var t = e.share.isReceiveSharing;
            return t;
          }, function (e) {
            var t = e.share.activeNodeId;
            return t;
          }], function () {
            var e = arguments.length > 2 ? arguments[2] : void 0;
            return (arguments.length > 1 ? arguments[1] : void 0) ? (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).find(function (t) {
              return t.userId === e && !0 === t.sharerOn;
            }) : null;
          }),
              Eu = Ws([pc], function (e) {
            return e.filter(function (e) {
              return e.sharerOn || e.sharerPause;
            });
          });

          var Cu = /*#__PURE__*/function () {
            function Cu(e) {
              _classCallCheck(this, Cu);

              this._cancelError = new Error("request for lock canceled"), this._locked = void 0, this._queue = [], this._waiters = [], this._currentReleaser = void 0, e && (this._cancelError = e), this._locked = !1;
            }

            _createClass(Cu, [{
              key: "acquire",
              value: function acquire() {
                var _this6 = this;

                var e = this.isLocked(),
                    t = new Promise(function (e, t) {
                  _this6._queue.push({
                    resolve: e,
                    reject: t
                  });
                });
                return e || this._dispatch(), t;
              }
            }, {
              key: "runExclusive",
              value: function () {
                var _runExclusive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                  var t;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return this.acquire();

                        case 2:
                          t = _context.sent;
                          _context.prev = 3;
                          _context.next = 6;
                          return e();

                        case 6:
                          return _context.abrupt("return", _context.sent);

                        case 7:
                          _context.prev = 7;
                          t();
                          return _context.finish(7);

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this, [[3,, 7, 10]]);
                }));

                function runExclusive(_x2) {
                  return _runExclusive.apply(this, arguments);
                }

                return runExclusive;
              }()
            }, {
              key: "waitForUnlock",
              value: function () {
                var _waitForUnlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var _this7 = this;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          return _context2.abrupt("return", this.isLocked() ? new Promise(function (e) {
                            return _this7._waiters.push({
                              resolve: e
                            });
                          }) : Promise.resolve());

                        case 1:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));

                function waitForUnlock() {
                  return _waitForUnlock.apply(this, arguments);
                }

                return waitForUnlock;
              }()
            }, {
              key: "isLocked",
              value: function isLocked() {
                return this._locked;
              }
            }, {
              key: "release",
              value: function release() {
                if (this._currentReleaser) {
                  var _e12 = this._currentReleaser;
                  this._currentReleaser = void 0, _e12();
                }
              }
            }, {
              key: "cancel",
              value: function cancel() {
                var _this8 = this;

                this._queue.forEach(function (e) {
                  return e.reject(_this8._cancelError);
                }), this._queue = [];
              }
            }, {
              key: "_dispatch",
              value: function _dispatch() {
                var _this9 = this;

                var e = this._queue.shift();

                if (!e) return;
                var t = !1;
                this._currentReleaser = function () {
                  t || (t = !0, _this9._locked = !1, _this9._resolveWaiters(), _this9._dispatch());
                }, this._locked = !0, e.resolve(this._currentReleaser);
              }
            }, {
              key: "_resolveWaiters",
              value: function _resolveWaiters() {
                this._waiters.forEach(function (e) {
                  return e.resolve();
                }), this._waiters = [];
              }
            }]);

            return Cu;
          }();

          var ku = "zoom.us",
              Au = "applications.zoom.us";

          var Iu = "https://dmogdx0jrul3u.cloudfront.net/".concat("2.8.0", "/lib/av"),
              Tu = "https://source.zoom.us/".concat("2.8.0", "/lib/av"),
              Ou = "https://jssdk.zoomus.cn/".concat("2.8.0", "/lib/av"),
              Ru = function Ru() {
            return "https://".concat(Au, "/sdkhelper/auth?sdkToken=");
          },
              Nu = function Nu(e, t, n) {
            return rt.apply(void 0, _toConsumableArray([t, n].map(function (t, n) {
              if ("initial" !== t) return Ke(Promise.resolve("success" === t));
              {
                var _t12 = 0 === n ? "ENCODE" : "DECODE";

                return mt(Os("".concat(e.toUpperCase(), "_").concat(_t12, "_SUCCESS"), 1).pipe(Mt(!0)), Os("".concat(e.toUpperCase(), "_").concat(_t12, "_FAIL"), 1).pipe(Mt(!1)));
              }
            })));
          },
              Pu = function Pu(e) {
            var t = sc(e.value);
            return t ? fe(t) : Os("ADD_CURRENT_USER_PARTICIPANT_ATTRIBUTE", 1).pipe(be(Oe), ln(e), Me(function (e) {
              var _e13 = _slicedToArray(e, 2),
                  t = _e13[1];

              return sc(t);
            }));
          },
              ju = function ju() {
            return Ke(navigator.mediaDevices.enumerateDevices()).pipe(Me(function (e) {
              var t = [],
                  n = [],
                  r = [];
              return e.forEach(function (e) {
                var i = e.kind,
                    o = e.deviceId,
                    a = e.label;

                switch (i) {
                  case "audioinput":
                    "communications" === o || /ZoomAudioDevice/i.test(a) || /Zoom-\S*/.test(a) || /CubebAggregateDevice\S*/.test(a) || t.push({
                      deviceId: o,
                      label: a
                    });
                    break;

                  case "audiooutput":
                    "communications" === o || /ZoomAudioDevice/i.test(a) || n.push({
                      deviceId: o,
                      label: a
                    });
                    break;

                  case "videoinput":
                    r.push({
                      deviceId: o,
                      label: a
                    });
                }
              }), {
                microphones: t,
                speakers: n,
                cameras: r
              };
            }));
          };

          function Du(e) {
            var _e$getBoundingClientR = e.getBoundingClientRect(),
                t = _e$getBoundingClientR.x,
                n = _e$getBoundingClientR.y,
                r = _e$getBoundingClientR.width,
                i = _e$getBoundingClientR.height;

            return {
              scaleWidth: r,
              scaleHeight: i,
              srcOffsetX: t,
              srcOffsetY: n
            };
          }

          function zu(e) {
            if (e) {
              var _n9 = e;

              try {
                var _t13 = e.width;
                e.width = _t13;
              } catch (o) {
                var t;
                _n9 = e.cloneNode(!0), null === (t = e.parentNode) || void 0 === t || t.replaceChild(_n9, e);
              }

              return _n9;
            }

            return e;
          }

          function Mu() {
            try {
              return "undefined" != typeof MessageChannel && new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)), WebAssembly.validate(za);
            } catch (e) {
              return !1;
            }
          }

          function Lu() {
            var e;
            return null === (e = WebAssembly) || void 0 === e ? void 0 : e.validate(Ma);
          }

          function Uu() {
            return To() || Mo();
          }

          var Bu = function () {
            var e = new Cu();
            return {
              withAudioAction: function withAudioAction(t) {
                return function () {
                  for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
                    r[i] = arguments[i];
                  }

                  return new Promise( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(n, i) {
                      var o, a, _i6;

                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              o = !1;
                              a = setTimeout(function () {
                                o = !0, i(new Error("Operation Timeout!"));
                              }, 3e4);
                              _context3.prev = 2;
                              _context3.next = 5;
                              return e.acquire();

                            case 5:
                              _i6 = _context3.sent;
                              o ? _i6() : (clearTimeout(a), n(t.apply(void 0, r)));
                              _context3.next = 12;
                              break;

                            case 9:
                              _context3.prev = 9;
                              _context3.t0 = _context3["catch"](2);
                              o || (clearTimeout(a), i(_context3.t0));

                            case 12:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, null, [[2, 9]]);
                    }));

                    return function (_x3, _x4) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                };
              },
              processAudioAction: function processAudioAction(t) {
                return e.acquire().then(function () {
                  return t();
                });
              },
              completeAudioAction: function completeAudioAction() {
                e.release();
              },
              cancelAllAudioAction: function cancelAllAudioAction() {
                e.cancel();
              }
            };
          }();

          function Hu(e) {
            var t = ["joinComputerAudio", "joinSharingAudio", "leaveComputerAudio", "leaveSharingAudio"];
            return new Proxy(e, {
              get: function get(e, n) {
                return "string" == typeof n && t.includes(n) ? function () {
                  return Bu.withAudioAction(e[n].bind(e)).apply(void 0, arguments);
                } : Reflect.get(e, n);
              }
            });
          }

          function Vu() {
            var e, t;
            var n = Io() && Number(null === (e = So()) || void 0 === e || null === (t = e.match(/\d+$/)) || void 0 === t ? void 0 : t[0]) >= 91,
                r = navigator.hardwareConcurrency > 2;
            return !Mo() && jo() && Po() && n && r;
          }

          var qu = function qu(e, t) {
            var n = document.createElement("link");
            return n.rel = "preload", n.href = e, n.as = t, n.crossOrigin = "anonymous", n;
          },
              Fu = function Fu(e, t, n) {
            var r = [],
                i = [],
                o = Array.isArray(e) ? e : [e];
            return ha.filter(function (e) {
              return o.includes(e.category) && e.tag === t;
            }).forEach(function (e) {
              "worker" === e.type ? r.push("".concat(n).concat(e.name)) : "wasm" === e.type && i.push("".concat(n).concat(e.name));
            }), {
              workers: r,
              wasms: i
            };
          },
              Wu = ua.createAgent();

          var Gu = Object.freeze({
            __proto__: null,
            sharePrivilegeChangeEpic: function sharePrivilegeChangeEpic(e, t) {
              return Vr(e, 7938).pipe(pt(function (e) {
                var t;
                return void 0 !== (null === (t = e.payload.body) || void 0 === t ? void 0 : t.lockShare);
              }), ln(t), nn(function (e) {
                var _e14 = _slicedToArray(e, 2),
                    t = _e14[0],
                    n = _e14[1];

                var r = n.share.sharePrivilege,
                    i = t.payload.body.lockShare;
                r !== i && As("SHARE_PRIVILEGE_CHANGE", i);
              }), Me(function (e) {
                var _e15 = _slicedToArray(e, 1),
                    t = _e15[0];

                return $c(t.payload.body.lockShare);
              }));
            },
            shareSSrcEpic: function shareSSrcEpic(e) {
              return Vr(e, 20227).pipe(Me(function (e) {
                return ol(e.payload.body.ssrc);
              }));
            },
            shareStatusChangeEpic: function shareStatusChangeEpic(e, t) {
              return Vr(e, 20225).pipe(ln(t), pt(function (e) {
                var _e16 = _slicedToArray(e, 2),
                    t = _e16[0],
                    n = _e16[1];

                var r = t.payload.body,
                    i = n.share.isReceiveSharingFromMainSession;
                return !i || i && r.fromMainSession;
              }), Me(function (e) {
                var _e17 = _slicedToArray(e, 2),
                    t = _e17[0],
                    n = _e17[1];

                var _n$share = n.share,
                    r = _n$share.isReceiveSharing,
                    i = _n$share.activeNodeId,
                    o = _n$share.shareQuality,
                    a = _n$share.isReceiveSharingFromMainSession,
                    s = n.breakoutRoom,
                    c = t.payload.body;

                if (r && 1 === c.bStatus) {
                  var _e18 = !1;

                  (null == s ? void 0 : s.currentRoom.status) === ic.InRoom && s.mainSessionAttendeeList.length > 0 && (_e18 = s.mainSessionAttendeeList.findIndex(function (e) {
                    return e.userId === i;
                  }) > -1), Wu.unsubscribeSharing(i, _e18), Wu.subscribeSharing(c.activeNodeID, o, a), ma.getInstance().switchSharingSource(c.ssrc, a), As("SHARE_AUTO_CHANGE_SOURCE", {
                    userId: c.activeNodeID
                  });
                } else if (1 === c.bStatus) {
                  var _e19 = {
                    activeUserId: c.activeNodeID,
                    isActive: !0
                  };
                  a && Object.assign(_e19, {
                    isFromMainSession: !0
                  }), As("SHARE_ACTIVE_INDICATION", _e19);
                } else if (r) {
                  var _e20 = {
                    activeUserId: c.activeNodeID,
                    isActive: !1
                  };
                  a && Object.assign(_e20, {
                    isFromMainSession: !0
                  }), As("SHARE_ACTIVE_INDICATION", _e20);
                }

                return Xc(c);
              }));
            },
            handleChromeExtensionEpic: function handleChromeExtensionEpic(e) {
              return Gr(e, Ta.CheckChromeSharingExtensionResponse).pipe(Me(function (e) {
                return As("SHARE_CHECK_CHROME_SHARING_EXTENSION", e.payload.data), tl(e.payload.data);
              }));
            },
            handleSDKShareSuccessEpic: function handleSDKShareSuccessEpic(e, t) {
              return Gr(e, [Ta.SharingDesktopStreamHaveAudio, Ta.SharingDesktopStreamHaveNoAudio]).pipe(ln(t), Me(function (e) {
                var _e21 = _slicedToArray(e, 2),
                    t = _e21[0],
                    n = _e21[1];

                var r = n.meeting.userId,
                    i = n.share.isSharingToBreakoutRoom,
                    o = t.payload.type,
                    a = o === Ta.SharingDesktopStreamHaveAudio;
                return Wu.startSharing(r, {
                  bShareToBO: i,
                  bShareAudio: a
                }), nl(!1);
              }));
            },
            handleSDKShareErrorEpic: function handleSDKShareErrorEpic(e) {
              return Gr(e, [Ta.DesktopSharingError, Ta.DesktopSharingChromeExtensionUninstalled, Ta.DesktopSharingPermissionDenied, Ta.DesktopSharingSystemError]).pipe(Je(function (e) {
                var t = [];
                var n = "";
                return [Ta.DesktopSharingPermissionDenied, Ta.DesktopSharingSystemError].includes(e.payload.type) && (t.push(nl(!0)), e.payload.type === Ta.DesktopSharingSystemError ? /mac/i.test(navigator.platform) && (n = "To use screen share on Chrome, please allow screen recording access in system setting.") : n = "To use screen share, please allow the permission request."), As("SHARE_START_DESKTOP_SHARE_FAILED", {
                  reason: n
                }), Ke(t);
              }));
            },
            handleSDKShareDimensionChangeEpic: function handleSDKShareDimensionChangeEpic(e) {
              return Gr(e, Ta.CurrentDesktopSharingWidthHeight).pipe(pt(function (e) {
                return !!e.payload.data;
              }), Me(function (e) {
                As("SHARE_DIMENSION_CHANGE", e.payload.data);
                var _e$payload$data = e.payload.data,
                    t = _e$payload$data.width,
                    n = _e$payload$data.height;
                return ma.getInstance().ajustmentSharingCanvas(t, n), rl(e.payload.data);
              }));
            },
            handleSDKReceivedShareSizeChangeEpic: function handleSDKReceivedShareSizeChangeEpic(e, t) {
              return Gr(e, Ta.SharingDecodeMaxSize).pipe(pt(function (e) {
                return !!e.payload.data;
              }), ln(t), fu(function (e) {
                var _e22 = _slicedToArray(e, 2),
                    t = _e22[0],
                    n = _e22[1];

                var _n$share2 = n.share,
                    r = _n$share2.shareQuality,
                    i = _n$share2.activeNodeId,
                    o = _n$share2.isReceiveSharingFromMainSession,
                    a = t.payload.data.size,
                    s = Number(a);
                if (r !== s) return Wu.subscribeSharing(i, s, o), al(s);
              }));
            },
            handleRWGShareOriginalDimensionEpic: function handleRWGShareOriginalDimensionEpic(e) {
              return Vr(e, 20226).pipe(nn(function (e) {
                var t, n;

                if (As("SHARE_RECEIVED_DIMENSION_CHANGE", null === (t = e.payload) || void 0 === t ? void 0 : t.body), null !== (n = e.payload) && void 0 !== n && n.body) {
                  var _e$payload$body = e.payload.body,
                      _t14 = _e$payload$body.width,
                      _n10 = _e$payload$body.height;
                  ma.getInstance().ajustmentReceivedSharingCanvas(_t14, _n10);
                }
              }), Me(function (e) {
                return sl(e.payload.body);
              }));
            },
            handleSDKShareOriginalDimensionEpic: function handleSDKShareOriginalDimensionEpic(e) {
              return Gr(e, Ta.SharingPara).pipe(nn(function (e) {
                var t, n;

                if (As("SHARE_RECEIVED_DIMENSION_CHANGE", null === (t = e.payload.data) || void 0 === t ? void 0 : t.body), null !== (n = e.payload.data) && void 0 !== n && n.body) {
                  var _e$payload$data$body = e.payload.data.body,
                      _t15 = _e$payload$data$body.width,
                      _n11 = _e$payload$data$body.height;
                  ma.getInstance().ajustmentReceivedSharingCanvas(_t15, _n11);
                }
              }), Me(function (e) {
                var t;
                return sl(null === (t = e.payload.data) || void 0 === t ? void 0 : t.body);
              }));
            },
            handleSDKStopShareEpic: function handleSDKStopShareEpic(e, t) {
              return Gr(e, Ta.UserStopDesktopSharing).pipe(ln(t), Me(function (e) {
                var _e23 = _slicedToArray(e, 2),
                    t = _e23[1];

                var n = t.meeting.userId,
                    r = t.share.status;
                return r !== Ua.End && (Wu.stopSharing(n), As("SHARE_VIDEO_STREAMS_END")), il(Ua.End);
              }));
            },
            handleRWGCurrentUserShareChangeEpic: function handleRWGCurrentUserShareChangeEpic(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e24 = _slicedToArray(e, 2),
                    t = _e24[0],
                    n = _e24[1];

                var r = n.meeting.userId,
                    i = t.payload.body.update;
                return i && i.length > 0 && i.findIndex(function (e) {
                  return e.id === r && void 0 !== e.bShareOn;
                }) > -1;
              }), Je(function (e) {
                var _e25 = _slicedToArray(e, 2),
                    t = _e25[0],
                    n = _e25[1];

                var r = n.meeting.userId,
                    _n$share3 = n.share,
                    i = _n$share3.status,
                    o = _n$share3.isReceiveSharing,
                    a = _n$share3.activeNodeId,
                    s = t.payload.body.update,
                    c = s.find(function (e) {
                  return e.id === r && !1 === e.bShareOn;
                }),
                    l = s.find(function (e) {
                  return e.id === r && !0 === e.bShareOn;
                }),
                    d = [],
                    u = ma.getInstance();
                return c && i !== Ua.End && (Wu.stopSharing(r), u.stopDesktopSharing(), d.push(il(Ua.End)), As("SHARE_PASSIVE_STOP_SHARE")), l && i === Ua.End && (o && (u.stopRenderSharing(), Wu.unsubscribeSharing(a), d.push(el(!1))), d.push(il(Ua.Sharing))), Ke(d);
              }));
            },
            handleMultipleShareChangeEpic: function handleMultipleShareChangeEpic(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e26 = _slicedToArray(e, 2),
                    t = _e26[0],
                    n = _e26[1];

                var r = n.meeting.userId,
                    i = t.payload.body.update;
                return i && i.length > 0 && i.findIndex(function (e) {
                  return e.id !== r && void 0 !== e.bShareOn;
                }) > -1;
              }), Je(function (n) {
                var _n12 = _slicedToArray(n, 2),
                    r = _n12[0],
                    i = _n12[1];

                var o = r.payload.body.update,
                    _i$share = i.share,
                    a = _i$share.activeNodeId,
                    s = _i$share.isReceiveSharing,
                    c = Eu(i),
                    l = o.filter(function (e) {
                  return !0 === e.bShareOn && !1 === e.bSharePause;
                }),
                    d = o.filter(function (e) {
                  return !1 === e.bShareOn;
                });
                return l.length > 0 && l.forEach(function (e) {
                  -1 === c.findIndex(function (t) {
                    return t.userId === e.id;
                  }) && As("SHARE_NEW_USER_ADD", e);
                }), d.length > 0 && (d.forEach(function (e) {
                  As("SHARE_USER_REMOVE", e);
                }), s && d.some(function (e) {
                  return e.id === a;
                })) ? mt(Vr(e, 20225).pipe(Nt(1), qt(ce)), bt(50).pipe(qt(me("timeout")))).pipe(wt(function () {
                  var _t$value = t.value,
                      _t$value$share = _t$value.share,
                      e = _t$value$share.activeNodeId,
                      n = _t$value$share.isReceiveSharingFromMainSession,
                      r = _t$value$share.shareQuality,
                      i = _t$value.audio,
                      o = c.filter(function (t) {
                    return t.userId !== e;
                  });

                  if (o.length > 0) {
                    var _t16 = o[0],
                        _a5 = _t16.userId;
                    Wu.unsubscribeSharing(e, n), Wu.subscribeSharing(_a5, r, n);

                    var _s5 = ma.getInstance();

                    return _s5.switchSharingSource(_a5, n), null == i || i.localShareAudioUserMutedList.forEach(function (e) {
                      _s5.setSharingAudioVolume(_a5, e.userId !== _a5 || e.muted, e.isFromMainSession);
                    }), As("SHARE_AUTO_CHANGE_SOURCE", {
                      userId: _a5
                    }), fe(Xc({
                      activeNodeID: _a5,
                      bStatus: 1,
                      ssrc: _a5
                    }));
                  }

                  return ce;
                })) : ce;
              }));
            },
            handleSharingEncryptIndication: function handleSharingEncryptIndication(e, t) {
              return Vr(e, Qo).pipe(ln(t), Yt(function (e) {
                var _e27 = _slicedToArray(e, 2),
                    n = _e27[0],
                    r = _e27[1];

                var _n$payload$body = n.payload.body,
                    i = _n$payload$body.encryptKey,
                    o = _n$payload$body.additionalType,
                    _r$media = r.media,
                    a = _r$media.sharingDecodeStatus,
                    s = _r$media.sharingEncodeStatus,
                    _r$meeting = r.meeting,
                    c = _r$meeting.confId,
                    l = _r$meeting.userId,
                    d = _r$meeting.zoomId,
                    u = _r$meeting.meetingId,
                    p = _r$meeting.meetingNumber,
                    h = _r$meeting.isWebinar;
                return Pu(t).pipe(Yt(function (e) {
                  var n = s;
                  return h && e && ec(e.userRole) && (n = "failed"), Nu("sharing", n, a).pipe(nn(function (e) {
                    var _e28 = _slicedToArray(e, 2),
                        n = _e28[0],
                        r = _e28[1];

                    var a = ma.getInstance(),
                        s = {
                      userId: l,
                      sn: bi(d),
                      confId: c,
                      encryptKey: bi(i),
                      encryptType: o,
                      meetingId: u,
                      meetingNumber: p
                    };

                    if (n && (null == a || a.updateMediaParams({
                      iVType: Uo.SHARING_ENCODE,
                      isFromMainSession: !1,
                      updateParams: s
                    })), r) {
                      a.updateMediaParams({
                        iVType: Uo.SHARING_DECODE,
                        isFromMainSession: !1,
                        updateParams: s
                      });
                      var _e29 = t.value.participants.attendeesList;

                      if (_e29.length > 0) {
                        var _t17 = _e29.map(function (e) {
                          return {
                            userid: e.userId,
                            sn: e.zoomID && bi(e.zoomID)
                          };
                        });

                        a.updateUserMediaSN({
                          added: _t17,
                          isFromMainSession: !1,
                          iVType: Uo.SHARING_DECODE
                        });
                      }
                    }
                  }), qt(ce));
                }));
              }));
            },
            handleSharingReceivingChannelReadyEpic: function handleSharingReceivingChannelReadyEpic(e, t) {
              return Wr(e, 20235).pipe(ln(t), nn(function (e) {
                var _e30 = _slicedToArray(e, 2),
                    t = _e30[0],
                    n = _e30[1];

                var r = n.media.sharingDecodeStatus,
                    i = t.type,
                    o = t.payload.body,
                    a = i === "".concat(wr);
                Nu("sharing", "success", r).subscribe(function (e) {
                  var _e31 = _slicedToArray(e, 2),
                      t = _e31[1];

                  t && ma.getInstance().addReceivedSharingChannelType(f({
                    isFromMainSession: a
                  }, o));
                });
              }), qt(ce));
            },
            handleSharingReceivingChannelCloseEpic: function handleSharingReceivingChannelCloseEpic(e, t) {
              return Wr(e, 20236).pipe(ln(t), nn(function (e) {
                var _e32 = _slicedToArray(e, 2),
                    t = _e32[0],
                    n = _e32[1];

                var r = n.media.sharingDecodeStatus,
                    i = t.type,
                    o = t.payload.body.ssrc,
                    a = i === "".concat(wr);
                Nu("sharing", "success", r).subscribe(function (e) {
                  var _e33 = _slicedToArray(e, 2),
                      t = _e33[1];

                  t && ma.getInstance().removeReceivedSharingChannelType({
                    isFromMainSession: a,
                    ssrc: o
                  });
                });
              }), qt(ce));
            }
          }),
              Ku = Object.freeze({
            __proto__: null,
            handleRequestRemoteControlEpic: function handleRequestRemoteControlEpic(e, t) {
              return Vr(e, 16391).pipe(ln(t), pt(function (e) {
                var _e34 = _slicedToArray(e, 2),
                    t = _e34[0],
                    n = _e34[1];

                var r = n.meeting.userId;
                return t.payload.body.id === r;
              }), Me(function (e) {
                var _e35 = _slicedToArray(e, 1),
                    t = _e35[0];

                var n = t.payload.body.bOn;
                return As("SHARE_REMOTE_CONTROL_APPROVE", n), cl(n);
              }));
            },
            handleGrabRemoteControlEpic: function handleGrabRemoteControlEpic(e, t) {
              return Vr(e, 16395).pipe(ln(t), pt(function (e) {
                var _e36 = _slicedToArray(e, 2),
                    t = _e36[0],
                    n = _e36[1];

                return t.payload.body.id === n.meeting.userId;
              }), Me(function (e) {
                var _e37 = _slicedToArray(e, 1),
                    t = _e37[0];

                var n = t.payload.body.bOn;
                return ma.getInstance().updateRemoteControlProperties({
                  isControllerNow: n
                }), As("SHARE_GRAB_REMOTE_CONTROL_CHANGE", n), ll(n);
              }));
            },
            handleSDKRemoteControlEpic: function handleSDKRemoteControlEpic(e) {
              return Gr(e, [Ta.StartRemoteControlSuccess, Ta.StartRemoteControlFailed, Ta.CancelRemoteControlSuccess]).pipe(fu(function (e) {
                return e.payload.type === Ta.StartRemoteControlSuccess ? (As("SHARE_REMOTE_CONTROL_SUCCESS"), pl(!0)) : e.payload.type === Ta.CancelRemoteControlSuccess ? pl(!1) : void (e.payload.type === Ta.StartRemoteControlFailed && As("SHARE_REMOTE_CONTROL_FAILED"));
              }));
            },
            handleRemoteControlClipboardEpic: function handleRemoteControlClipboardEpic(e) {
              return Gr(e, [Ta.RemoteControlCopiedTextNotify, Ta.RemoteControlPasteTextLengthOverflow]).pipe(nn(function (e) {
                if (e.payload.type === Ta.RemoteControlCopiedTextNotify) {
                  var _t18 = e.payload.data;
                  As("SHARE_REMOTE_CONTROL_CLIPBOARD_CHANGE", {
                    content: _t18.data,
                    x: _t18.x,
                    y: _t18.y
                  });
                } else As("SHARE_REMOTE_CONTROL_CLIPBOARD_CHANGE", {
                  error: "length of pasted text is too long"
                });
              }), qt(ce));
            }
          });

          function Qu(e) {
            for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function (e) {
              return "'" + e + "'";
            }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
          }

          function Zu(e) {
            return !!e && !!e[Pp];
          }

          function Yu(e) {
            return !!e && (function (e) {
              if (!e || "object" != typeof e) return !1;
              var t = Object.getPrototypeOf(e);
              if (null === t) return !0;
              var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
              return n === Object || "function" == typeof n && Function.toString.call(n) === jp;
            }(e) || Array.isArray(e) || !!e[Np] || !!e.constructor[Np] || tp(e) || np(e));
          }

          function Ju(e, t, n) {
            void 0 === n && (n = !1), 0 === $u(e) ? (n ? Object.keys : Dp)(e).forEach(function (r) {
              n && "symbol" == typeof r || t(r, e[r], e);
            }) : e.forEach(function (n, r) {
              return t(r, n, e);
            });
          }

          function $u(e) {
            var t = e[Pp];
            return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : tp(e) ? 2 : np(e) ? 3 : 0;
          }

          function Xu(e, t) {
            return 2 === $u(e) ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
          }

          function ep(e, t, n) {
            var r = $u(e);
            2 === r ? e.set(t, n) : 3 === r ? (e.delete(t), e.add(n)) : e[t] = n;
          }

          function tp(e) {
            return Ip && e instanceof Map;
          }

          function np(e) {
            return Tp && e instanceof Set;
          }

          function rp(e) {
            return e.o || e.t;
          }

          function ip(e) {
            if (Array.isArray(e)) return Array.prototype.slice.call(e);
            var t = zp(e);
            delete t[Pp];

            for (var n = Dp(t), r = 0; r < n.length; r++) {
              var i = n[r],
                  o = t[i];
              !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: e[i]
              });
            }

            return Object.create(Object.getPrototypeOf(e), t);
          }

          function op(e, t) {
            return void 0 === t && (t = !1), sp(e) || Zu(e) || !Yu(e) || ($u(e) > 1 && (e.set = e.add = e.clear = e.delete = ap), Object.freeze(e), t && Ju(e, function (e, t) {
              return op(t, !0);
            }, !0)), e;
          }

          function ap() {
            Qu(2);
          }

          function sp(e) {
            return null == e || "object" != typeof e || Object.isFrozen(e);
          }

          function cp(e) {
            var t = Mp[e];
            return t || Qu(18, e), t;
          }

          function lp() {
            return kp;
          }

          function dp(e, t) {
            t && (cp("Patches"), e.u = [], e.s = [], e.v = t);
          }

          function up(e) {
            pp(e), e.p.forEach(_p), e.p = null;
          }

          function pp(e) {
            e === kp && (kp = e.l);
          }

          function hp(e) {
            return kp = {
              p: [],
              l: kp,
              h: e,
              m: !0,
              _: 0
            };
          }

          function _p(e) {
            var t = e[Pp];
            0 === t.i || 1 === t.i ? t.j() : t.O = !0;
          }

          function fp(e, t) {
            t._ = t.p.length;
            var n = t.p[0],
                r = void 0 !== e && e !== n;
            return t.h.g || cp("ES5").S(t, e, r), r ? (n[Pp].P && (up(t), Qu(4)), Yu(e) && (e = mp(t, e), t.l || vp(t, e)), t.u && cp("Patches").M(n[Pp], e, t.u, t.s)) : e = mp(t, n, []), up(t), t.u && t.v(t.u, t.s), e !== Rp ? e : void 0;
          }

          function mp(e, t, n) {
            if (sp(t)) return t;
            var r = t[Pp];
            if (!r) return Ju(t, function (i, o) {
              return gp(e, r, t, i, o, n);
            }, !0), t;
            if (r.A !== e) return t;
            if (!r.P) return vp(e, r.t, !0), r.t;

            if (!r.I) {
              r.I = !0, r.A._--;
              var i = 4 === r.i || 5 === r.i ? r.o = ip(r.k) : r.o;
              Ju(3 === r.i ? new Set(i) : i, function (t, o) {
                return gp(e, r, i, t, o, n);
              }), vp(e, i, !1), n && e.u && cp("Patches").R(r, n, e.u, e.s);
            }

            return r.o;
          }

          function gp(e, t, n, r, i, o) {
            if (Zu(i)) {
              var a = mp(e, i, o && t && 3 !== t.i && !Xu(t.D, r) ? o.concat(r) : void 0);
              if (ep(n, r, a), !Zu(a)) return;
              e.m = !1;
            }

            if (Yu(i) && !sp(i)) {
              if (!e.h.F && e._ < 1) return;
              mp(e, i), t && t.A.l || vp(e, i);
            }
          }

          function vp(e, t, n) {
            void 0 === n && (n = !1), e.h.F && e.m && op(t, n);
          }

          function bp(e, t) {
            var n = e[Pp];
            return (n ? rp(n) : e)[t];
          }

          function yp(e, t) {
            if (t in e) for (var n = Object.getPrototypeOf(e); n;) {
              var r = Object.getOwnPropertyDescriptor(n, t);
              if (r) return r;
              n = Object.getPrototypeOf(n);
            }
          }

          function wp(e) {
            e.P || (e.P = !0, e.l && wp(e.l));
          }

          function Sp(e) {
            e.o || (e.o = ip(e.t));
          }

          function xp(e, t, n) {
            var r = tp(t) ? cp("MapSet").N(t, n) : np(t) ? cp("MapSet").T(t, n) : e.g ? function (e, t) {
              var n = Array.isArray(e),
                  r = {
                i: n ? 1 : 0,
                A: t ? t.A : lp(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: e,
                k: null,
                o: null,
                j: null,
                C: !1
              },
                  i = r,
                  o = Lp;
              n && (i = [r], o = Up);
              var a = Proxy.revocable(i, o),
                  s = a.revoke,
                  c = a.proxy;
              return r.k = c, r.j = s, c;
            }(t, n) : cp("ES5").J(t, n);
            return (n ? n.A : lp()).p.push(r), r;
          }

          function Ep(e, t) {
            switch (t) {
              case 2:
                return new Map(e);

              case 3:
                return Array.from(e);
            }

            return ip(e);
          }

          var Cp,
              kp,
              Ap = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
              Ip = "undefined" != typeof Map,
              Tp = "undefined" != typeof Set,
              Op = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
              Rp = Ap ? Symbol.for("immer-nothing") : ((Cp = {})["immer-nothing"] = !0, Cp),
              Np = Ap ? Symbol.for("immer-draftable") : "__$immer_draftable",
              Pp = Ap ? Symbol.for("immer-state") : "__$immer_state",
              jp = "" + Object.prototype.constructor,
              Dp = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (e) {
            return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
          } : Object.getOwnPropertyNames,
              zp = Object.getOwnPropertyDescriptors || function (e) {
            var t = {};
            return Dp(e).forEach(function (n) {
              t[n] = Object.getOwnPropertyDescriptor(e, n);
            }), t;
          },
              Mp = {},
              Lp = {
            get: function get(e, t) {
              if (t === Pp) return e;
              var n = rp(e);
              if (!Xu(n, t)) return function (e, t, n) {
                var r,
                    i = yp(t, n);
                return i ? "value" in i ? i.value : null === (r = i.get) || void 0 === r ? void 0 : r.call(e.k) : void 0;
              }(e, n, t);
              var r = n[t];
              return e.I || !Yu(r) ? r : r === bp(e.t, t) ? (Sp(e), e.o[t] = xp(e.A.h, r, e)) : r;
            },
            has: function has(e, t) {
              return t in rp(e);
            },
            ownKeys: function ownKeys(e) {
              return Reflect.ownKeys(rp(e));
            },
            set: function set(e, t, n) {
              var r = yp(rp(e), t);
              if (null == r ? void 0 : r.set) return r.set.call(e.k, n), !0;

              if (!e.P) {
                var i = bp(rp(e), t),
                    o = null == i ? void 0 : i[Pp];
                if (o && o.t === n) return e.o[t] = n, e.D[t] = !1, !0;
                if (function (e, t) {
                  return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
                }(n, i) && (void 0 !== n || Xu(e.t, t))) return !0;
                Sp(e), wp(e);
              }

              return e.o[t] === n && "number" != typeof n && (void 0 !== n || t in e.o) || (e.o[t] = n, e.D[t] = !0, !0);
            },
            deleteProperty: function deleteProperty(e, t) {
              return void 0 !== bp(e.t, t) || t in e.t ? (e.D[t] = !1, Sp(e), wp(e)) : delete e.D[t], e.o && delete e.o[t], !0;
            },
            getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
              var n = rp(e),
                  r = Reflect.getOwnPropertyDescriptor(n, t);
              return r ? {
                writable: !0,
                configurable: 1 !== e.i || "length" !== t,
                enumerable: r.enumerable,
                value: n[t]
              } : r;
            },
            defineProperty: function defineProperty() {
              Qu(11);
            },
            getPrototypeOf: function getPrototypeOf(e) {
              return Object.getPrototypeOf(e.t);
            },
            setPrototypeOf: function setPrototypeOf() {
              Qu(12);
            }
          },
              Up = {};

          Ju(Lp, function (e, t) {
            Up[e] = function () {
              return arguments[0] = arguments[0][0], t.apply(this, arguments);
            };
          }), Up.deleteProperty = function (e, t) {
            return Lp.deleteProperty.call(this, e[0], t);
          }, Up.set = function (e, t, n) {
            return Lp.set.call(this, e[0], t, n, e[0]);
          };
          var Bp = new (function () {
            function e(e) {
              var t = this;
              this.g = Op, this.F = !0, this.produce = function (e, n, r) {
                if ("function" == typeof e && "function" != typeof n) {
                  var i = n;
                  n = e;
                  var o = t;
                  return function (e) {
                    var t = this;
                    void 0 === e && (e = i);

                    for (var r = arguments.length, a = Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++) {
                      a[s - 1] = arguments[s];
                    }

                    return o.produce(e, function (e) {
                      var r;
                      return (r = n).call.apply(r, [t, e].concat(a));
                    });
                  };
                }

                var a;

                if ("function" != typeof n && Qu(6), void 0 !== r && "function" != typeof r && Qu(7), Yu(e)) {
                  var s = hp(t),
                      c = xp(t, e, void 0),
                      l = !0;

                  try {
                    a = n(c), l = !1;
                  } finally {
                    l ? up(s) : pp(s);
                  }

                  return "undefined" != typeof Promise && a instanceof Promise ? a.then(function (e) {
                    return dp(s, r), fp(e, s);
                  }, function (e) {
                    throw up(s), e;
                  }) : (dp(s, r), fp(a, s));
                }

                if (!e || "object" != typeof e) {
                  if ((a = n(e)) === Rp) return;
                  return void 0 === a && (a = e), t.F && op(a, !0), a;
                }

                Qu(21, e);
              }, this.produceWithPatches = function (e, n) {
                return "function" == typeof e ? function (n) {
                  for (var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
                    i[o - 1] = arguments[o];
                  }

                  return t.produceWithPatches(n, function (t) {
                    return e.apply(void 0, [t].concat(i));
                  });
                } : [t.produce(e, n, function (e, t) {
                  r = e, i = t;
                }), r, i];
                var r, i;
              }, "boolean" == typeof (null == e ? void 0 : e.useProxies) && this.setUseProxies(e.useProxies), "boolean" == typeof (null == e ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze);
            }

            var t = e.prototype;
            return t.createDraft = function (e) {
              Yu(e) || Qu(8), Zu(e) && (e = function (e) {
                return Zu(e) || Qu(22, e), function e(t) {
                  if (!Yu(t)) return t;
                  var n,
                      r = t[Pp],
                      i = $u(t);

                  if (r) {
                    if (!r.P && (r.i < 4 || !cp("ES5").K(r))) return r.t;
                    r.I = !0, n = Ep(t, i), r.I = !1;
                  } else n = Ep(t, i);

                  return Ju(n, function (t, i) {
                    r && function (e, t) {
                      return 2 === $u(e) ? e.get(t) : e[t];
                    }(r.t, t) === i || ep(n, t, e(i));
                  }), 3 === i ? new Set(n) : n;
                }(e);
              }(e));
              var t = hp(this),
                  n = xp(this, e, void 0);
              return n[Pp].C = !0, pp(t), n;
            }, t.finishDraft = function (e, t) {
              var n = (e && e[Pp]).A;
              return dp(n, t), fp(void 0, n);
            }, t.setAutoFreeze = function (e) {
              this.F = e;
            }, t.setUseProxies = function (e) {
              e && !Op && Qu(20), this.g = e;
            }, t.applyPatches = function (e, t) {
              var n;

              for (n = t.length - 1; n >= 0; n--) {
                var r = t[n];

                if (0 === r.path.length && "replace" === r.op) {
                  e = r.value;
                  break;
                }
              }

              n > -1 && (t = t.slice(n + 1));
              var i = cp("Patches").$;
              return Zu(e) ? i(e, t) : this.produce(e, function (e) {
                return i(e, t);
              });
            }, e;
          }())(),
              Hp = Bp.produce;
          Bp.produceWithPatches.bind(Bp), Bp.setAutoFreeze.bind(Bp), Bp.setUseProxies.bind(Bp), Bp.applyPatches.bind(Bp), Bp.createDraft.bind(Bp), Bp.finishDraft.bind(Bp);
          var Vp = {
            ssrc: 0,
            status: Ua.End,
            shareDimension: {
              width: 0,
              height: 0
            },
            receivedShareDimension: {
              width: 1920,
              height: 1080,
              logicWidth: 1920,
              logicHeight: 1080
            },
            sharePrivilege: La.OnlyHost,
            activeNodeId: 0,
            activeSsrc: 0,
            shareQuality: 1,
            isRemoteSharingActive: !1,
            isReceiveSharing: !1,
            isRemoteControlApproved: !1,
            isGrabRemoteControl: !1,
            isSDKGrabControl: !1,
            isChromeExtensionInstalled: !1,
            isScreenShareForbidden: !1,
            isReceiveSharingFromMainSession: !1,
            isSharingToBreakoutRoom: !1,
            isSharingWithSecondCamera: !1,
            secondCameraId: "default"
          },
              qp = ur((_ur = {}, _defineProperty(_ur, "".concat($c), Hp(function (e, t) {
            var n = t.payload;
            e.sharePrivilege = n;
          })), _defineProperty(_ur, "".concat(Xc), Hp(function (e, t) {
            var n = t.payload;
            e.isRemoteSharingActive = 1 === n.bStatus, e.activeNodeId = n.activeNodeID, e.activeSsrc = n.ssrc;
          })), _defineProperty(_ur, "".concat(el), Hp(function (e, t) {
            var n = t.payload;
            e.isReceiveSharing = n;
          })), _defineProperty(_ur, "".concat(tl), Hp(function (e, t) {
            var n = t.payload;
            e.isChromeExtensionInstalled = n;
          })), _defineProperty(_ur, "".concat(rl), Hp(function (e, t) {
            var n = t.payload;
            e.shareDimension = f({}, n);
          })), _defineProperty(_ur, "".concat(il), Hp(function (e, t) {
            var n = t.payload;
            e.status = n;
          })), _defineProperty(_ur, "".concat(ol), Hp(function (e, t) {
            var n = t.payload;
            e.ssrc = n;
          })), _defineProperty(_ur, "".concat(al), Hp(function (e, t) {
            var n = t.payload;
            e.shareQuality = n;
          })), _defineProperty(_ur, "".concat(sl), Hp(function (e, t) {
            var n = t.payload;
            e.receivedShareDimension = f({}, n);
          })), _defineProperty(_ur, "".concat(cl), Hp(function (e, t) {
            var n = t.payload;
            e.isRemoteControlApproved = n;
          })), _defineProperty(_ur, "".concat(ll), Hp(function (e, t) {
            var n = t.payload;
            e.isGrabRemoteControl = n;
          })), _defineProperty(_ur, "".concat(dl), Hp(function (e, t) {
            var n = t.payload;
            e.isVerifiedRenderCanvasAfterFailover = n;
          })), _defineProperty(_ur, "".concat(ul), Hp(function (e, t) {
            var n = t.payload;
            e.isVerifiedCaptureCanvasAfterFailover = n;
          })), _defineProperty(_ur, "".concat(pl), Hp(function (e, t) {
            var n = t.payload;
            e.isSDKGrabControl = n;
          })), _defineProperty(_ur, "".concat(hl), Hp(function (e, t) {
            var n = t.payload;
            e.isReceiveSharingFromMainSession = n;
          })), _defineProperty(_ur, "".concat(_l), Hp(function (e, t) {
            var n = t.payload;
            e.isSharingToBreakoutRoom = n;
          })), _defineProperty(_ur, "".concat(fl), Hp(function (e, t) {
            var n = t.payload;
            e.isSharingWithSecondCamera = n;
          })), _defineProperty(_ur, "".concat(ml), Hp(function (e, t) {
            var n = t.payload;
            e.secondCameraId = n;
          })), _defineProperty(_ur, "".concat(gl), function () {
            return f(f({}, Vp), {}, {
              isVerifiedRenderCanvasAfterFailover: !1,
              isVerifiedCaptureCanvasAfterFailover: !1
            });
          }), _ur), Vp),
              Fp = Hr(Gu, Ku),
              Wp = ua.createAgent();
          var Gp = Object.freeze({
            __proto__: null,
            joinMeetingWelcomeEpic: function joinMeetingWelcomeEpic(e) {
              return Vr(e, 0).pipe(nn(function (e) {
                var t;

                if ("READY" === (null === (t = e.payload.body) || void 0 === t ? void 0 : t.status)) {
                  var _e38 = wo.get(Vo.WebclientMeetingToken);

                  _e38 && Wp.joinMeeting(_e38);
                }
              }), qt(ce));
            },
            joinMeetingSuccessfulEpic: function joinMeetingSuccessfulEpic(e, t) {
              return Vr(e, 4098).pipe(ln(t), gu(function (e) {
                var _e39 = _slicedToArray(e, 2),
                    t = _e39[0],
                    n = _e39[1];

                var _t$payload$body = t.payload.body,
                    r = _t$payload$body.res,
                    i = _t$payload$body.userID,
                    o = _t$payload$body.zoomID,
                    a = _t$payload$body.mn,
                    s = _t$payload$body.participantID,
                    c = _t$payload$body.hugeBO,
                    l = _t$payload$body.elapsed,
                    d = _t$payload$body.disableAqos,
                    u = _t$payload$body.disableVqos,
                    p = _t$payload$body.meetingtoken,
                    h = _t$payload$body.role,
                    _n$meeting = n.meeting,
                    _ = _n$meeting.pingRWCTimestamp,
                    f = _n$meeting.isWebinar,
                    m = _n$meeting.userEmail,
                    g = _n$meeting.userName,
                    v = _n$meeting.isMeetingReset,
                    b = _n$meeting.meetingOptions,
                    y = _n$meeting.zlkJwtToken,
                    w = _n$meeting.cv,
                    S = _n$meeting.apiKey,
                    x = _n$meeting.zsk,
                    E = _n$meeting.signatureType,
                    _n$media = n.media,
                    C = _n$media.mediaConstraints,
                    k = _n$media.assetsPath,
                    A = n.breakoutRoom;

                if (ei.CONF_SUCCESS === r) {
                  var _Vo = Vo,
                      _e40 = _Vo.WebclientParticipantId,
                      _n13 = _Vo.WebclientUserId,
                      _r11 = _Vo.WebclientZoomId,
                      _I2 = _Vo.WebclientUserEmail,
                      T = _Vo.WebclientUserName,
                      _O2 = _Vo.WebclientMeetingToken;
                  wo.set(_n13, i, bo.SessionStorage), wo.set(_r11, o, bo.SessionStorage), wo.set(_e40, s, bo.SessionStorage), m && wo.set(_I2, m, bo.SessionStorage), wo.set(T, g, bo.SessionStorage), p && wo.set(_O2, p, bo.SessionStorage), Wp.sendRWGConnectionPerformance("WCL_M, JMCT(".concat(performance.now() - _, ")")), x && Wp.sendSdkKeyToMonitor(E, S, i);
                  var _R2 = [Vi(t.payload.body), to(performance.now())];
                  ma.getInstance().init(), v && (_R2.push(Qi(!1)), void 0 !== C && void 0 !== k && _R2.push(Ir())), (y || f) && _R2.push(hr()), A && (b && (_R2.push(Zd(c && !0 === b.isBO100Enabled)), _R2.push($d({
                    isEnableBreakoutRoom: b.isEnableBreakoutRoom,
                    isEnableBOBroadcast: b.isEnableBOBroadcast
                  }))), A.currentRoom.boConfId && _R2.push(br()), void 0 !== l && _R2.push(jd(l)));

                  var _N2 = !u;

                  var _P2 = !d;

                  return y && Si(w, "1.3.0") < 0 && (_N2 = !1), _R2.unshift(no({
                    audioQos: _P2,
                    videoQos: _N2
                  })), (h & Qs.Owner) === Qs.Owner && (As(ga, {
                    reason: "dont support assisnt join through widget",
                    errorCode: -1
                  }), Wp.leaveMeeting()), As("JOIN_MEETING_SUCCESS", {
                    meetingNumber: a
                  }), Ke(_R2);
                }

                return ei.CONF_FAIL_CONFLOCKED === r ? As(ga, ui(r)) : ei.CONF_FAIL_CONF_USER_FULL === r ? As(ga, Object.assign({}, ui(r), {
                  lmUrl: t.payload.body.lmURL
                })) : (ei.CONF_FAIL_MEETING_OVER === r || ei.CONF_RESULT_MMR_IB_REJECT === r || ei.CONF_FAIL_RESULT_MMR_CONF_PARTICIPANT_EXISTS === r || [ei.CONF_FAIL_HAS_BEEN_REMOVED, ei.CONF_FAIL_WEBINAR_DENIED_EMAIL].includes(r), As(ga, ui(r))), Ke(hu(n, !1));
              }));
            },
            handleMeetingAttributeChangeEpic: function handleMeetingAttributeChangeEpic(e, t) {
              return Vr(e, 7938).pipe(ln(t), Me(function (e) {
                var _e41 = _slicedToArray(e, 2),
                    t = _e41[0],
                    n = _e41[1];

                var r = t.payload.body,
                    _n$meeting2 = n.meeting,
                    i = _n$meeting2.zoomId,
                    o = _n$meeting2.encType;

                if (void 0 !== (null == r ? void 0 : r.encryptKey) && Ko.init(i, r.encryptKey, o), void 0 !== (null == r ? void 0 : r.gatewayKey)) {
                  var _e42 = ma.getInstance(),
                      _r$gatewayKey$split = r.gatewayKey.split("."),
                      _r$gatewayKey$split2 = _slicedToArray(_r$gatewayKey$split, 3),
                      _t19 = _r$gatewayKey$split2[1],
                      _n14 = _r$gatewayKey$split2[2];

                  _e42.sendUserNodeList([{
                    userid: Number(_t19),
                    sn: _n14 && bi(_n14)
                  }]);
                }

                return As("UPDATE_MEETING_ATTRIBUTE", r), qi(r);
              }));
            },
            handleMeetingEndEpic: function handleMeetingEndEpic(e, t) {
              return Vr(e, 7939).pipe(ln(t), Je(function (e) {
                var _e43 = _slicedToArray(e, 2),
                    t = _e43[0],
                    n = _e43[1];

                var r = t.payload.body;

                if (void 0 !== r.reason) {
                  if (ti.LEAVEREASON_RECONNECT === r.reason) return ni.LEAVESUBREASON_WAITINGROOMFAILOVER === r.subReason ? As("RECONNECTING_MEETING", {
                    reason: ho.OnHold
                  }) : As("RECONNECTING_MEETING", {
                    reason: ho.Failover
                  }), fe(Ri());
                  ti.LEAVEREASON_KICKEDBYHOST === r.reason ? As("LEAVING_MEETING", {
                    reason: "kicked by host"
                  }) : ti.LEAVEREASON_ENDBYHOST !== r.reason && ti.LEAVEREASON_ENDBYHOSTSTARTANOTHERMEETING !== r.reason || As("LEAVING_MEETING", {
                    reason: "ended by host"
                  });
                }

                return n.meeting.isMeetingReset ? ce : Ke(hu(n, !1));
              }));
            },
            meetingFailoverEpic: function meetingFailoverEpic(e, t) {
              return e.pipe(fn("".concat(Ri)), ln(t), Je(function (e) {
                var _e44 = _slicedToArray(e, 2),
                    t = _e44[1];

                var n = hu(t, !0);
                var r;

                if (t.meeting.zlkJwtToken) {
                  var _e45 = function (e) {
                    if (e) {
                      var _e$meeting2 = e.meeting,
                          _t20 = _e$meeting2.topic,
                          _n16 = _e$meeting2.passWord,
                          _r12 = _e$meeting2.userName,
                          _i7 = _e$meeting2.zlkJwtToken,
                          _o6 = _e$meeting2.lang,
                          _a6 = _e$meeting2.cv,
                          _s6 = _e$meeting2.customerKey;
                      return {
                        topic: _t20,
                        passWord: _n16,
                        userName: _r12,
                        zlkJwtToken: _i7,
                        lang: _o6,
                        cv: _a6,
                        customerKey: _s6
                      };
                    }

                    return null;
                  }(t),
                      _n15 = {
                    topic: null == _e45 ? void 0 : _e45.topic,
                    password: null == _e45 ? void 0 : _e45.passWord,
                    userName: null == _e45 ? void 0 : _e45.userName,
                    zlk: null == _e45 ? void 0 : _e45.zlkJwtToken,
                    lang: null == _e45 ? void 0 : _e45.lang,
                    cv: null == _e45 ? void 0 : _e45.cv,
                    customerKey: null == _e45 ? void 0 : _e45.customerKey
                  };

                  r = fe(ki(_n15)).pipe(It(1e3));
                } else {
                  var _e46 = pu(t);

                  r = fe(Ci(_e46)).pipe(It(1e3));
                }

                return nt(Ke(n), r);
              }));
            },
            hostChangeEpic: function hostChangeEpic(e) {
              return Wr(e, 7940).pipe(nn(function (e) {
                As("MEETING_HOST_CHANGE_INDICATION", e.payload.body.bHost);
              }), Me(function (e) {
                return Wi(e.payload.body);
              }));
            },
            cohostChangeEpic: function cohostChangeEpic(e) {
              return Wr(e, 7941).pipe(nn(function (e) {
                As("MEETING_COHOST_CHANGE_INDICATION", e.payload.body.bCoHost);
              }), Me(function (e) {
                return Gi(e.payload.body);
              }));
            },
            setMeetingOptEpic: function setMeetingOptEpic(e) {
              return Wr(e, 7945).pipe(nn(function (e) {
                var t = e.payload.body.opt;
                wo.set(Vo.WebclientOpt, t, bo.SessionStorage);
              }), qt(ce));
            },
            setMeetingOnHoldEpic: function setMeetingOnHoldEpic(e, t) {
              return Vr(e, 7942).pipe(nn(function (e) {
                var t = e.payload.body.bHold;
                wo.set(Vo.WebclientIsOnHold, t ? 1 : 0, bo.SessionStorage), As("MEETING_IN_WAITING_ROOM", t);
              }), ln(t), Je(function (e) {
                var _e47 = _slicedToArray(e, 2),
                    t = _e47[0],
                    n = _e47[1];

                var r = [Ki(t.payload.body.bHold)];

                if (t.payload.body.bHold) {
                  var _e48 = sc(n);

                  if (_e48) {
                    r.push(Zi({
                      audio: _e48.audio,
                      video: _e48.bVideoOn,
                      muted: _e48.muted
                    }));

                    var _t21 = ma.getInstance();

                    if ("computer" === _e48.audio && (_t21.leaveComputerAudio(), Wp.joinOrLeaveVoip(!1)), _e48.bVideoOn && _t21.stopCaptureVideo(), _e48.sharerOn && (Wp.stopSharing(_e48.userId), _t21.stopDesktopSharing(), r.push(il(Ua.End))), n.video && n.video.subscribedVideoList.length > 0 && n.video.subscribedVideoList.forEach(function (e) {
                      Wp.unsubscribeVideo(e);
                    }), n.share && n.share.isReceiveSharing) {
                      var _e49 = n.share.activeNodeId;
                      n.share.isRemoteControlApproved && (Wp.sharingRequestRemoteControl(_e49, !1), _t21.stopRemoteControl()), Wp.unsubscribeSharing(_e49), _t21.stopRenderSharing();
                    }
                  }
                }

                return Ke(r);
              }));
            },
            setMeetingDataCenterRegionEpic: function setMeetingDataCenterRegionEpic(e) {
              return Vr(e, 7954).pipe(Me(function (e) {
                return Xi(e.payload.body);
              }));
            },
            claimHostResponseEpic: function claimHostResponseEpic(e) {
              return Vr(e, 4216).pipe(nn(function (e) {
                As("MEETING_CLAIM_HOST_KEY_RESPONSE", e.payload.body.bresult);
              }), qt(ce));
            },
            leaveMeetingEpic: function leaveMeetingEpic(e, t) {
              return e.pipe(fn("".concat(Ni), "".concat(Pi)), ln(t), Je(function (e) {
                var _e50 = _slicedToArray(e, 2),
                    t = _e50[0],
                    n = _e50[1];

                return t.type === "".concat(Ni) ? (Wp.leaveMeeting(), As("LEAVING_MEETING", {})) : t.type === "".concat(Pi) && (Wp.endMeeting(), As("LEAVING_MEETING", {})), Ke(hu(n, !1));
              }));
            },
            versionUpgradeEpic: function versionUpgradeEpic(e) {
              return Vr(e, 2).pipe(nn(function () {
                console.warn("Upgrade to latest version to optimize meeting experience");
              }), qt(ce));
            },
            versionBlockEpic: function versionBlockEpic(e) {
              return Vr(e, 1).pipe(nn(function (e) {
                var t = e.payload.body.upgradeVersion,
                    n = ui(1e3);

                if (n && n.reason) {
                  var _e51 = n.reason.replace(/{(\d+)}/g, function () {
                    return t;
                  });

                  n.reason = _e51;
                }

                As(ga, n);
              }), qt(ce));
            },
            handleSharePronounChangeEpic: function handleSharePronounChangeEpic(e) {
              return Vr(e, 4265).pipe(Me(function (e) {
                var t = e.payload.body,
                    n = t.nShareType;
                return As("SHARE_PRONOUN_TYPE_UPDATE", {
                  userSharePronounType: n
                }), co(n);
              }));
            }
          });
          var Kp;

          function Qp(e, t, n, r) {
            var i = document.createElement("div"),
                o = "\n    #".concat("__zoom-overlayer__", "{\n      position: fixed;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      z-index: 9999;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n      background: rgba(0,0,0,0.8);\n    }\n    .").concat("__zoom-overlayer-section__", "{\n      width:360px;\n      display:flex;\n      flex-direction:column;\n      align-items:center;\n    }\n    .").concat("__zoom-overlayer-title__", "{\n      font-size:24px;\n      margin:20px 0;\n      text-align:center;\n      color:#fff;\n    }\n    .").concat("__zoom-overlayer-button__", "{\n      display:inline-block;\n      height:40px;\n      border-radius:8px;\n      border: 1px solid #babacc;\n      background: #fff;\n      line-height:40px;\n      text-align:center;\n      min-width:200px;\n      padding:0 15px;\n    }\n    .").concat("__zoom-overlayer-button__", ":hover{\n      background: #e7f1fd;\n      color: #295ebd;\n      border-color: #cfe3fb;\n    }\n    .").concat("__zoom-overlayer-loading__", "{\n      font-size:14px;\n      color:#fff;\n    }\n    .").concat("__zoom-overlayer-loading-dots__", "{\n      display:inline-block;\n      height:12px;\n      overflow:hidden;\n      width:15px;\n    }\n    @keyframes ellipsis {\n      to {\n        width: 1.25em;    \n      }\n    }\n    .").concat("__zoom-overlayer-loading-dots__", "::after{\n      margin-left:3px;\n      overflow: hidden;\n      display: inline-block;\n      vertical-align: bottom;\n      animation: ellipsis steps(4,end) 900ms infinite;\n      content: \"\u2026\";\n      width: 0px;\n    }\n  ");
            i.style.cssText = "", i.id = "__zoom-overlayer__";
            var a = document.createElement("div");
            a.classList.add("__zoom-overlayer-section__");
            var s = document.createElement("style");
            s.styleSheet ? s.styleSheet.cssText = o : s.appendChild(document.createTextNode(o));
            var c = document.createElement("h1");
            c.textContent = t, c.classList.add("__zoom-overlayer-title__");
            var l = document.createElement("button");
            return l.textContent = n, l.classList.add("__zoom-overlayer-button__"), a.appendChild(c), a.appendChild(l), i.appendChild(s), i.appendChild(a), document.body.appendChild(i), ot(l, "click").pipe((void 0 === d && (d = Pe), function (e) {
              return e.lift(new Et(300, d));
            }), nn(function () {
              if (!1 === r.meeting.isWindowOpen) {
                Kp = function (e, t, n, r) {
                  var _window$screen = window.screen,
                      i = _window$screen.width,
                      o = _window$screen.height,
                      a = window.screenX + (i - 400) / 2,
                      s = window.screenY + (o - 380) / 2;
                  return window.open(e, t, "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no,\n   copyhistory=no, width=".concat(400, ", height=").concat(380, ", top=").concat(s, ", left=").concat(a));
                }(e, t), i.querySelector(".".concat("__zoom-overlayer-section__")).style.display = "none";

                var _n17 = i.querySelector(".".concat("__zoom-overlayer-loading__"));

                if (_n17) _n17.style.display = "block";else {
                  _n17 = document.createElement("div"), _n17.classList.add("__zoom-overlayer-loading__");

                  var _e52 = document.createElement("p");

                  _e52.textContent = "Try to ".concat(t);

                  var _r13 = document.createElement("span");

                  _r13.classList.add("__zoom-overlayer-loading-dots__"), _e52.appendChild(_r13), _n17.appendChild(_e52), i.appendChild(_n17);
                }
              }
            }));
            var d;
          }

          function Zp() {
            return ot(window, "message").pipe(pt(function (e) {
              return Object.values(po).includes(e.data.type);
            }), nn(function (e) {
              var t = e.data;

              if (t && t.type) {
                var _e53 = t.type;

                if ([po.CaptchaSuccess, po.LoginSuccess, po.SSOLoginSuccess, po.JoinSuccess, po.RegisterSuccess].includes(_e53)) {
                  var n, r;

                  var _e54 = document.getElementById("__zoom-overlayer__");

                  null == _e54 || null === (n = _e54.parentNode) || void 0 === n || n.removeChild(_e54), null === (r = Kp) || void 0 === r || r.close();
                }
              }
            }), Me(function (e) {
              var t = e.data;
              return t;
            }));
          }

          var Yp = Object.freeze({
            __proto__: null,
            logonZoomDomainEpic: function logonZoomDomainEpic(e, t) {
              return e.pipe(fn("".concat(Ai)), ln(t), Yt(function (e) {
                var _e55 = _slicedToArray(e, 2),
                    t = _e55[0],
                    n = _e55[1];

                var r = t.payload.token;
                return dt(Qp(Ru() + r, "Sign in", "Sign in", n).pipe(Me(function () {
                  return zi(!0);
                })), Zp().pipe(Nt(1), mu(function (e) {
                  if (e.type === po.LoginSuccess) {
                    var _t22 = e.zak;
                    sessionStorage.setItem(Vo.WebclientZtk, _t22);

                    var _r14 = pu(n);

                    return Object.assign(_r14, {
                      ztk: _t22
                    }), fe(Li(_t22), Ci(_r14));
                  }
                })));
              }));
            },
            verifyZoomRecaptchaEpic: function verifyZoomRecaptchaEpic(e, t) {
              return e.pipe(fn("".concat(Ii)), ln(t), Yt(function (e) {
                var _e56 = _slicedToArray(e, 2),
                    t = _e56[0],
                    n = _e56[1];

                var r = t.payload.url;
                return dt(Qp(r, "Check captcha", "Check Capcha", n).pipe(Me(function () {
                  return zi(!0);
                })), Zp().pipe(Nt(1), fu(function (e) {
                  if (e.type === po.CaptchaSuccess) {
                    var _t23 = e.captcha,
                        _r15 = e.captchaName,
                        _i8 = pu(n);

                    return Object.assign(_i8, {
                      captcha: _t23,
                      captchaName: _r15
                    }), Ci(_i8);
                  }
                })));
              }));
            },
            logonSSODomainEpic: function logonSSODomainEpic(e, t) {
              return e.pipe(fn("".concat(Ti)), ln(t), Yt(function (e) {
                var _e57 = _slicedToArray(e, 2),
                    t = _e57[0],
                    n = _e57[1];

                var r = t.payload.url;
                return dt(Qp(r, "Sign in", "Sign in SSO", n).pipe(Me(function () {
                  return zi(!0);
                })), Zp().pipe(Nt(1), mu(function (e) {
                  if (e.type === po.SSOLoginSuccess) {
                    var _t24 = e.tk,
                        _r16 = e.mtkGuid,
                        _i9 = pu(n);

                    return Object.assign(_i9, {
                      tk: _t24
                    }), fe(Bi({
                      tk: _t24,
                      mtkGuid: _r16
                    }), Ci(_i9));
                  }
                })));
              }));
            },
            registerWebinarEpic: function registerWebinarEpic(e, t) {
              return e.pipe(fn("".concat(ji)), ln(t), Yt(function (e) {
                var _e58 = _slicedToArray(e, 2),
                    t = _e58[0],
                    n = _e58[1];

                var r = t.payload.url,
                    i = {
                  callback: location.origin,
                  fm: "WebSDK",
                  lang: n.meeting.lang,
                  email: n.meeting.userEmail
                };
                return dt(Qp("".concat(r, "?").concat(new URLSearchParams(i).toString()), "Join", "Register on webinar", n).pipe(Me(function () {
                  return zi(!0);
                })), Zp().pipe(Nt(1), mu(function (e) {
                  if (e.type === po.JoinSuccess || e.type === po.RegisterSuccess) {
                    zi(!1);

                    var _e59 = pu(n);

                    return fe(Ci(_e59));
                  }
                })));
              }));
            },
            checkWindowIsOpenEpic: function checkWindowIsOpenEpic(e) {
              return e.pipe(fn("".concat(zi)), gu(function (e) {
                if (!0 === e.payload) return ct(500).pipe(pt(function () {
                  var e;
                  return !(null === (e = Kp) || void 0 === e || !e.closed);
                }), Nt(1), nn(function () {
                  Kp = null;
                  var e = document.getElementById("__zoom-overlayer__");
                  e && (e.querySelector(".".concat("__zoom-overlayer-section__")).style.display = "flex", e.querySelector(".".concat("__zoom-overlayer-loading__")).style.display = "none");
                })).pipe(Me(function () {
                  return zi(!1);
                }));
              }));
            }
          });
          var Jp, $p, Xp, eh;
          !function (e) {
            e[e.AttendeeToAllPanelist = 1] = "AttendeeToAllPanelist", e[e.PanelistToAttendee = 3] = "PanelistToAttendee";
          }(Jp || (Jp = {})), function (e) {
            e.Add = "add", e.List = "list", e.Remove = "memberremove", e.rename = "rename", e.update = "UPDATE";
          }($p || ($p = {})), function (e) {
            e.PutDownHands = "putdownhands", e.LowerHand = "lowerhand";
          }(Xp || (Xp = {})), function (e) {
            e.Open = "open", e.Message = "message", e.Error = "error", e.Close = "close";
          }(eh || (eh = {}));

          var th = /*#__PURE__*/function () {
            function th() {
              _classCallCheck(this, th);

              this.eventHandlers = void 0, this.websocket = void 0, this.seq = void 0, this.eventHandlers = new Map(), this.websocket = null, this.seq = 1;
            }

            _createClass(th, [{
              key: "on",
              value: function on(e, t) {
                var n = this.eventHandlers.get(e);
                n || (n = []), n.push(t), this.eventHandlers.set(e, n);
              }
            }, {
              key: "off",
              value: function off(e, t) {
                var n = this.eventHandlers.get(e);

                if (n) {
                  var _r17 = n.filter(function (e) {
                    return e !== t;
                  });

                  this.eventHandlers.set(e, _r17);
                }
              }
            }, {
              key: "emit",
              value: function emit(e, t) {
                var n = this.eventHandlers.get(e);
                n && n instanceof Array && n.slice(0).forEach(function (e) {
                  try {
                    e(t);
                  } catch (e) {
                    console.error(e);
                  }
                });
              }
            }, {
              key: "sendMessageToRwg",
              value: function sendMessageToRwg(e) {
                this.seq += 1;
                var t = this.seq;
                return this.websocket && this.websocket.readyState === WebSocket.OPEN && this.websocket.send(JSON.stringify(Object.assign(e, {
                  seq: t
                }))), t;
              }
            }, {
              key: "connect",
              value: function connect(e) {
                this.websocket = new WebSocket(e), this.websocket.binaryType = "arraybuffer", this.addWebSocketEventListeners();
              }
            }, {
              key: "close",
              value: function close() {
                var e;
                null === (e = this.websocket) || void 0 === e || e.close();
              }
            }, {
              key: "addWebSocketEventListeners",
              value: function addWebSocketEventListeners() {
                var _this10 = this;

                this.websocket && (this.websocket.addEventListener("open", function (e) {
                  _this10.emit(eh.Open, e);
                }), this.websocket.addEventListener("message", function (e) {
                  var t = e.data;
                  var n;
                  if (t instanceof ArrayBuffer) 0 === new Uint8Array(t)[0] && (null === (n = _this10.websocket) || void 0 === n || n.send(t));else try {
                    _this10.emit(eh.Message, JSON.parse(t));
                  } catch (e) {
                    console.warn("Unsupported format", t);
                  }
                }), this.websocket.addEventListener("close", function (e) {
                  _this10.emit(eh.Close, e);
                }), this.websocket.addEventListener("error", function (e) {
                  _this10.emit(eh.Error, e);
                }));
              }
            }, {
              key: "join",
              value: function join(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24576,
                    body: {
                      clientCap: e
                    }
                  })
                };
              }
            }, {
              key: "raiseHand",
              value: function raiseHand() {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24580,
                    body: null
                  })
                };
              }
            }, {
              key: "lowerHand",
              value: function lowerHand(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24578,
                    jids: e || []
                  })
                };
              }
            }, {
              key: "sendWebinarMseeage",
              value: function sendWebinarMseeage(e, t, n) {
                var r = {
                  msg: e,
                  jid: t ? [t] : [],
                  type: n,
                  bcm: arguments.length > 3 && void 0 !== arguments[3] && arguments[3]
                };
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24582,
                    body: r
                  })
                };
              }
            }, {
              key: "sendAnswer",
              value: function sendAnswer(e, t, n) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24584,
                    body: {
                      question_attendeejid: t.jid,
                      question_attendeename: t.displayName,
                      question_text: t.questionText,
                      question_id: t.questionId,
                      question_anonymous: t.isAnonymous,
                      question_time: t.questionTime,
                      text: e,
                      isPrivate: n
                    }
                  })
                };
              }
            }, {
              key: "answerOnline",
              value: function answerOnline(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24586,
                    body: {
                      question_attendeejid: e.jid,
                      question_attendeename: e.displayName,
                      question_text: e.questionText,
                      question_id: e.questionId,
                      question_anonymous: e.isAnonymous,
                      question_time: e.questionTime,
                      isLiveStart: t
                    }
                  })
                };
              }
            }, {
              key: "dismissQuestion",
              value: function dismissQuestion(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24590,
                    body: {
                      question_attendeejid: e.jid,
                      question_attendeename: e.displayName,
                      question_text: e.questionText,
                      question_id: e.questionId,
                      question_anonymous: e.isAnonymous,
                      question_time: e.questionTime,
                      bOpen: !1
                    }
                  })
                };
              }
            }, {
              key: "deleteQuestion",
              value: function deleteQuestion(e) {
                return {
                  seq: this.sendMessageToRwg({
                    evt: 24614,
                    body: {
                      question_id: e,
                      bDelete: !0
                    }
                  })
                };
              }
            }, {
              key: "deleteComment",
              value: function deleteComment(e) {
                return {
                  seq: this.sendMessageToRwg({
                    body: {
                      comment_id: e,
                      bDelete: !0
                    },
                    evt: 24616
                  })
                };
              }
            }, {
              key: "reopenQuestion",
              value: function reopenQuestion(e) {
                return {
                  seq: this.sendMessageToRwg({
                    body: {
                      question_attendeejid: e.jid,
                      question_attendeename: e.displayName,
                      question_text: e.questionText,
                      question_id: e.questionId,
                      question_anonymous: e.isAnonymous,
                      question_time: e.questionTime,
                      bOpen: !0
                    },
                    evt: 24590
                  })
                };
              }
            }, {
              key: "askQuestion",
              value: function askQuestion(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                    r = arguments.length > 3 ? arguments[3] : void 0;

                var i = function (e) {
                  var t = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
                    var t = 16 * Math.random() | 0;
                    return ("x" == e ? t : 3 & t | 8).toString(16);
                  });
                  return t + "";
                }();

                return {
                  seq: this.sendMessageToRwg({
                    body: {
                      id: i,
                      text: e,
                      isAnonymous: n,
                      bAllowAttendeeViewAllQuestion: r,
                      name: t
                    },
                    evt: 24592
                  }),
                  questionId: i
                };
              }
            }, {
              key: "upOrDownVote",
              value: function upOrDownVote(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    body: {
                      question_attendeejid: e.jid,
                      question_attendeename: e.displayName,
                      question_text: e.questionText,
                      question_id: e.questionId,
                      question_anonymous: e.isAnonymous,
                      question_time: e.questionTime,
                      bUpVote: t
                    },
                    evt: 24598
                  })
                };
              }
            }, {
              key: "rename",
              value: function rename(e, t) {
                return {
                  seq: this.sendMessageToRwg({
                    body: {
                      jid: e,
                      displayName: t
                    },
                    evt: 24600
                  })
                };
              }
            }, {
              key: "setSkinTome",
              value: function setSkinTome(e) {
                return {
                  seq: this.sendMessageToRwg({
                    body: {
                      skinTone: e
                    },
                    evt: 24618
                  })
                };
              }
            }], [{
              key: "getInstance",
              value: function getInstance() {
                return this.xmppInstance || (this.xmppInstance = new th()), this.xmppInstance;
              }
            }]);

            return th;
          }();

          th.xmppInstance = null;
          var nh = Object.freeze({
            __proto__: null,
            handleXmppConnectionStateEpic: function handleXmppConnectionStateEpic(e) {
              return Fr(e, 24577).pipe(Je(function (e) {
                var t = e.payload.body.isConflict;
                return t ? (As(ga, {
                  reason: "Unable to connect the server due to the conflict connection"
                }), Ke([fr()])) : ce;
              }));
            },
            handlePromoteOrDepromoteResponseEpic: function handlePromoteOrDepromoteResponseEpic(e) {
              return Vr(e, 4210).pipe(nn(function (e) {
                As("MEETING_WEBINAR_ROLE_CHANGE", e.payload.body);
              }), qt(ce));
            },
            handleAttendeePromoteDepromoteEpic: function handleAttendeePromoteDepromoteEpic(e) {
              return Fr(e, 24597).pipe(Me(function (e) {
                var _e$payload$body2 = e.payload.body,
                    t = _e$payload$body2.bPromote,
                    n = _e$payload$body2.token,
                    r = _e$payload$body2.meetingtoken;
                return As("RECONNECTING_MEETING", {
                  reason: t ? ho.Promote : ho.Depromote
                }), wo.set(Vo.WebclientWebinarToken, n, bo.SessionStorage), n && sessionStorage.setItem(Vo.WebclientTk, n), wo.set(Vo.WebclientMeetingToken, r, bo.SessionStorage), Ri();
              }));
            },
            handleAttendeeExpelEpic: function handleAttendeeExpelEpic(e, t) {
              return Fr(e, 24603).pipe(ln(t), Je(function (e) {
                var _e60 = _slicedToArray(e, 2),
                    t = _e60[1];

                return As("LEAVING_MEETING", {
                  reason: "expeled by host"
                }), Ke(hu(t));
              }));
            },
            handleAttendeePutDownHandEpic: function handleAttendeePutDownHandEpic(e, t) {
              return Fr(e, 24579).pipe(nn(function (e) {
                var _e$payload$body3 = e.payload.body,
                    n = _e$payload$body3.action,
                    r = _e$payload$body3.data,
                    i = t.value.meeting.jid;
                n === Xp.PutDownHands && (null == r ? void 0 : r.jid) === i && th.getInstance().lowerHand();
              }), qt(ce));
            },
            handlePromoteConsentRequest: function handlePromoteConsentRequest(e) {
              return Vr(e, 7963).pipe(nn(function (e) {
                As("MEETING_WEBINAR_PROMOTE_CONSENT_REQ", e.payload.body);
              }), qt(ce));
            }
          }),
              rh = Object.freeze({
            __proto__: null,
            setWebhookOrZoomAppExistEpic: function setWebhookOrZoomAppExistEpic(e, t) {
              return Vr(e, 7964).pipe(ln(t), Me(function (e) {
                var _e61 = _slicedToArray(e, 2),
                    t = _e61[1];

                var n = f(f({}, t.meeting.activeAppInfo), {}, {
                  isWebhookOrZoomAppExist: !0,
                  status: mo.Loading
                });
                return As("ACTIVE_APPS_UPDATE"), ro(n);
              }));
            },
            setActiveAppInfoEpic: function setActiveAppInfoEpic(e, t) {
              return Vr(e, 4256).pipe(ln(t), Me(function (e) {
                var _e62 = _slicedToArray(e, 2),
                    t = _e62[0],
                    n = _e62[1];

                var _t$payload$body2 = t.payload.body,
                    r = _t$payload$body2.domain,
                    i = _t$payload$body2.list,
                    o = _t$payload$body2.result,
                    a = _t$payload$body2.title,
                    s = _t$payload$body2.summary,
                    c = f(f({}, n.meeting.activeAppInfo), {}, {
                  title: null != a ? a : "",
                  summary: null != s ? s : "",
                  list: null == i ? void 0 : i.map(function (e) {
                    return f(f({}, e), {}, {
                      link: r && e.link ? r + e.link : void 0,
                      icon: r && e.icon ? r + e.icon : void 0
                    });
                  }),
                  status: o ? mo.Success : mo.Fail
                });
                return As("ACTIVE_APPS_UPDATE"), ro(c);
              }));
            },
            setActiveAppLinkInfoEpic: function setActiveAppLinkInfoEpic(e, t) {
              return Vr(e, 4258).pipe(ln(t), Me(function (e) {
                var t, n, r;

                var _e63 = _slicedToArray(e, 2),
                    i = _e63[0],
                    o = _e63[1];

                var _i$payload$body = i.payload.body,
                    a = _i$payload$body.appId,
                    s = _i$payload$body.link,
                    c = _i$payload$body.result,
                    l = _i$payload$body.domain,
                    d = l && s && l + s,
                    u = f(f({}, o.meeting.activeAppInfo), {}, {
                  list: null === (t = o.meeting) || void 0 === t || null === (n = t.activeAppInfo) || void 0 === n || null === (r = n.list) || void 0 === r ? void 0 : r.map(function (e) {
                    return e.appId !== a ? e : f(f({}, e), {}, {
                      appId: a,
                      result: c,
                      link: d
                    });
                  })
                });
                return As("ACTIVE_APP_DETAIL_UPDATE", {
                  result: c
                }), As("ACTIVE_APPS_UPDATE"), ro(u);
              }));
            },
            setActiveAppOnAttendeeUpdateEpic: function setActiveAppOnAttendeeUpdateEpic(e, t) {
              return Wr(e, 7937).pipe(pt(function (e) {
                var t, n, r, i;
                return (null === (t = e.payload.body) || void 0 === t || null === (n = t.add) || void 0 === n ? void 0 : n.length) > 0 || (null === (r = e.payload.body) || void 0 === r || null === (i = r.remove) || void 0 === i ? void 0 : i.length) > 0;
              }), ln(t), fu(function (e) {
                var _e64 = _slicedToArray(e, 2),
                    t = _e64[0],
                    n = _e64[1];

                var r = n.meeting.activeAppInfo,
                    i = n.breakoutRoom,
                    o = n.participants.attendeesList,
                    a = t.type,
                    _t$payload$body3 = t.payload.body,
                    s = _t$payload$body3.add,
                    c = _t$payload$body3.remove,
                    l = a === "".concat(wr),
                    d = (null == i ? void 0 : i.currentRoom.status) === ic.InRoom;

                if (l && d || !l && !d) {
                  var _e65 = null == s ? void 0 : s.some(function (e) {
                    return void 0 !== e.sdkKey;
                  }),
                      _t25 = null == c ? void 0 : c.some(function (e) {
                    if (d) {
                      var _t26 = i.mainSessionAttendeeList;
                      return _t26.findIndex(function (t) {
                        return t.userId === e.id && void 0 !== t.sdkKey;
                      }) >= 0;
                    }

                    return o.findIndex(function (t) {
                      return t.userId === e.id && void 0 !== t.sdkKey;
                    }) >= 0;
                  });

                  if (_e65 || _t25) return As("ACTIVE_APPS_UPDATE"), ro(f(f({}, r), {}, {
                    status: mo.Loading
                  }));
                }
              }));
            },
            setActiveAppOnXMPPUserUpdateEpic: function setActiveAppOnXMPPUserUpdateEpic(e, t) {
              return Fr(e, 24595).pipe(pt(function (e) {
                return [$p.Add, $p.List, $p.update, $p.Remove].includes(e.payload.body.action);
              }), Me(function () {
                return t.value.participants.xmppAttendeeList;
              }), be(Ne), fu(function (e) {
                var _t$value2 = t.value,
                    n = _t$value2.participants.xmppAttendeeList,
                    r = _t$value2.meeting.activeAppInfo;
                if (n.filter(function (e) {
                  return !!e.sdkKey;
                }).length !== e.filter(function (e) {
                  return !!e.sdkKey;
                }).length) return As("ACTIVE_APPS_UPDATE"), ro(f(f({}, r), {}, {
                  status: mo.Loading
                }));
              }));
            }
          });
          var ih = null;
          var oh = Object.freeze({
            __proto__: null,
            startStayAwakeEpic: function startStayAwakeEpic(e, t) {
              return e.pipe(fn("".concat(Vi)), ln(t), pt(function (e) {
                var _e66 = _slicedToArray(e, 2),
                    t = _e66[1];

                return !!t.meeting.stayAwake;
              }), nn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.prev = 0;
                        ih && ih.release().then(function () {
                          ih = null;
                        });
                        _context4.next = 4;
                        return navigator.wakeLock.request("screen");

                      case 4:
                        ih = _context4.sent;
                        ih.addEventListener("release", function () {});
                        _context4.next = 10;
                        break;

                      case 8:
                        _context4.prev = 8;
                        _context4.t0 = _context4["catch"](0);

                      case 10:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[0, 8]]);
              }))), Yt(function () {
                return ot(document, "visibilitychange").pipe(Je( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if (!("visible" === document.visibilityState)) {
                            _context5.next = 7;
                            break;
                          }

                          ih && ih.release().then(function () {
                            ih = null;
                          });
                          _context5.next = 4;
                          return navigator.wakeLock.request("screen");

                        case 4:
                          ih = _context5.sent;
                          _context5.next = 8;
                          break;

                        case 7:
                          ih && ih.release().then(function () {
                            ih = null;
                          });

                        case 8:
                          return _context5.abrupt("return", ce);

                        case 9:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }))));
              }));
            },
            cancelStayAwakeEpic: function cancelStayAwakeEpic(e) {
              return e.pipe(fn("".concat(_r))).pipe(nn(function () {
                ih && ih.release().then(function () {
                  ih = null;
                });
              }), qt(ce));
            }
          }),
              ah = "undefined" != typeof window && window,
              sh = "undefined" != typeof self && "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && self,
              ch = "undefined" != typeof n.g && n.g,
              lh = ah || ch || sh;

          function dh(e, t) {
            return void 0 === t && (t = null), new gh({
              method: "GET",
              url: e,
              headers: t
            });
          }

          function uh(e, t, n) {
            return new gh({
              method: "POST",
              url: e,
              body: t,
              headers: n
            });
          }

          function ph(e, t) {
            return new gh({
              method: "DELETE",
              url: e,
              headers: t
            });
          }

          function hh(e, t, n) {
            return new gh({
              method: "PUT",
              url: e,
              body: t,
              headers: n
            });
          }

          function _h(e, t, n) {
            return new gh({
              method: "PATCH",
              url: e,
              body: t,
              headers: n
            });
          }

          !function () {
            if (!lh) throw new Error("RxJS could not find any global context (window, self, global)");
          }();
          var fh = Me(function (e, t) {
            return e.response;
          });

          function mh(e, t) {
            return fh(new gh({
              method: "GET",
              url: e,
              responseType: "json",
              headers: t
            }));
          }

          var gh = function (e) {
            function t(t) {
              var n = e.call(this) || this,
                  r = {
                async: !0,
                createXHR: function createXHR() {
                  return this.crossDomain ? function () {
                    if (lh.XMLHttpRequest) return new lh.XMLHttpRequest();
                    if (lh.XDomainRequest) return new lh.XDomainRequest();
                    throw new Error("CORS is not supported by your browser");
                  }() : function () {
                    if (lh.XMLHttpRequest) return new lh.XMLHttpRequest();
                    var e = void 0;

                    try {
                      for (var t = ["Msxml2.XMLHTTP", "Microsoft.XMLHTTP", "Msxml2.XMLHTTP.4.0"], n = 0; n < 3; n++) {
                        try {
                          if (e = t[n], new lh.ActiveXObject(e)) break;
                        } catch (e) {}
                      }

                      return new lh.ActiveXObject(e);
                    } catch (e) {
                      throw new Error("XMLHttpRequest is not supported by your browser");
                    }
                  }();
                },
                crossDomain: !0,
                withCredentials: !1,
                headers: {},
                method: "GET",
                responseType: "json",
                timeout: 0
              };
              if ("string" == typeof t) r.url = t;else for (var i in t) {
                t.hasOwnProperty(i) && (r[i] = t[i]);
              }
              return n.request = r, n;
            }

            var n;
            return O(t, e), t.prototype._subscribe = function (e) {
              return new vh(e, this.request);
            }, t.create = ((n = function n(e) {
              return new t(e);
            }).get = dh, n.post = uh, n.delete = ph, n.put = hh, n.patch = _h, n.getJSON = mh, n), t;
          }(Q),
              vh = function (e) {
            function t(t, n) {
              var r = e.call(this, t) || this;
              r.request = n, r.done = !1;
              var i = n.headers = n.headers || {};
              return n.crossDomain || r.getHeader(i, "X-Requested-With") || (i["X-Requested-With"] = "XMLHttpRequest"), r.getHeader(i, "Content-Type") || lh.FormData && n.body instanceof lh.FormData || void 0 === n.body || (i["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8"), n.body = r.serializeBody(n.body, r.getHeader(n.headers, "Content-Type")), r.send(), r;
            }

            return O(t, e), t.prototype.next = function (e) {
              this.done = !0;
              var t,
                  n = this.xhr,
                  r = this.request,
                  i = this.destination;

              try {
                t = new bh(e, n, r);
              } catch (e) {
                return i.error(e);
              }

              i.next(t);
            }, t.prototype.send = function () {
              var e = this.request,
                  t = this.request,
                  n = t.user,
                  r = t.method,
                  i = t.url,
                  o = t.async,
                  a = t.password,
                  s = t.headers,
                  c = t.body;

              try {
                var l = this.xhr = e.createXHR();
                this.setupEvents(l, e), n ? l.open(r, i, o, n, a) : l.open(r, i, o), o && (l.timeout = e.timeout, l.responseType = e.responseType), "withCredentials" in l && (l.withCredentials = !!e.withCredentials), this.setHeaders(l, s), c ? l.send(c) : l.send();
              } catch (e) {
                this.error(e);
              }
            }, t.prototype.serializeBody = function (e, t) {
              if (!e || "string" == typeof e) return e;
              if (lh.FormData && e instanceof lh.FormData) return e;

              if (t) {
                var n = t.indexOf(";");
                -1 !== n && (t = t.substring(0, n));
              }

              switch (t) {
                case "application/x-www-form-urlencoded":
                  return Object.keys(e).map(function (t) {
                    return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
                  }).join("&");

                case "application/json":
                  return JSON.stringify(e);

                default:
                  return e;
              }
            }, t.prototype.setHeaders = function (e, t) {
              for (var n in t) {
                t.hasOwnProperty(n) && e.setRequestHeader(n, t[n]);
              }
            }, t.prototype.getHeader = function (e, t) {
              for (var n in e) {
                if (n.toLowerCase() === t.toLowerCase()) return e[n];
              }
            }, t.prototype.setupEvents = function (e, t) {
              var _n18,
                  _r18,
                  i = t.progressSubscriber;

              function o(e) {
                var t,
                    n = o,
                    r = n.subscriber,
                    i = n.progressSubscriber,
                    a = n.request;
                i && i.error(e);

                try {
                  t = new Sh(this, a);
                } catch (e) {
                  t = e;
                }

                r.error(t);
              }

              function a(e) {}

              function s(e) {
                var t = s,
                    n = t.subscriber,
                    r = t.progressSubscriber,
                    i = t.request;

                if (4 === this.readyState) {
                  var o = 1223 === this.status ? 204 : this.status,
                      a = "text" === this.responseType ? this.response || this.responseText : this.response;
                  if (0 === o && (o = a ? 200 : 0), o < 400) r && r.complete(), n.next(e), n.complete();else {
                    r && r.error(e);
                    var c = void 0;

                    try {
                      c = new yh("ajax error " + o, this, i);
                    } catch (e) {
                      c = e;
                    }

                    n.error(c);
                  }
                }
              }

              e.ontimeout = o, o.request = t, o.subscriber = this, o.progressSubscriber = i, e.upload && "withCredentials" in e && (i && (_n18 = function n(e) {
                _n18.progressSubscriber.next(e);
              }, lh.XDomainRequest ? e.onprogress = _n18 : e.upload.onprogress = _n18, _n18.progressSubscriber = i), _r18 = function r(e) {
                var t,
                    n = _r18,
                    i = n.progressSubscriber,
                    o = n.subscriber,
                    a = n.request;
                i && i.error(e);

                try {
                  t = new yh("ajax error", this, a);
                } catch (e) {
                  t = e;
                }

                o.error(t);
              }, e.onerror = _r18, _r18.request = t, _r18.subscriber = this, _r18.progressSubscriber = i), e.onreadystatechange = a, a.subscriber = this, a.progressSubscriber = i, a.request = t, e.onload = s, s.subscriber = this, s.progressSubscriber = i, s.request = t;
            }, t.prototype.unsubscribe = function () {
              var t = this.done,
                  n = this.xhr;
              !t && n && 4 !== n.readyState && "function" == typeof n.abort && n.abort(), e.prototype.unsubscribe.call(this);
            }, t;
          }(V),
              bh = function bh(e, t, n) {
            this.originalEvent = e, this.xhr = t, this.request = n, this.status = t.status, this.responseType = t.responseType || n.responseType, this.response = wh(this.responseType, t);
          },
              yh = function () {
            function e(e, t, n) {
              return Error.call(this), this.message = e, this.name = "AjaxError", this.xhr = t, this.request = n, this.status = t.status, this.responseType = t.responseType || n.responseType, this.response = wh(this.responseType, t), this;
            }

            return e.prototype = Object.create(Error.prototype), e;
          }();

          function wh(e, t) {
            switch (e) {
              case "json":
                return function (e) {
                  return "response" in e ? e.responseType ? e.response : JSON.parse(e.response || e.responseText || "null") : JSON.parse(e.responseText || "null");
                }(t);

              case "xml":
                return t.responseXML;

              default:
                return "response" in t ? t.response : t.responseText;
            }
          }

          var Sh = function Sh(e, t) {
            return yh.call(this, "ajax timeout", e, t), this.name = "AjaxTimeoutError", this;
          },
              xh = gh.create;

          var Eh = function Eh(e) {
            var _e$meeting3 = e.meeting,
                t = _e$meeting3.encryptedRWC,
                n = _e$meeting3.encryptedGEORWC,
                r = _e$meeting3.discardedRwcList,
                i = _e$meeting3.meetingOptions;
            var o = [];
            return (null == i ? void 0 : i.isEnableGeoFenceRWC) && n && (null == n ? void 0 : n.length) > 0 ? o = n.filter(function (e) {
              return !r.includes(e.rwc);
            }).reduce(function (e, t) {
              var n = t.dl,
                  r = t.rwc,
                  i = t.rwcToken,
                  o = e.find(function (e) {
                return e.dl === n;
              });
              if (o) o.items.push({
                rwc: r,
                rwcToken: i
              });else {
                var _t27 = {
                  dl: n,
                  items: []
                };
                _t27.items.push({
                  rwc: r,
                  rwcToken: i
                }), e.push(_t27);
              }
              return e;
            }, []) : t && (o = [{
              dl: 0,
              items: Object.keys(t).map(function (e) {
                return {
                  rwc: e,
                  rwcToken: t[e]
                };
              })
            }]), o;
          },
              Ch = function Ch(e) {
            return dt.apply(void 0, _toConsumableArray(e.map(function (e) {
              return 0 === e.dl ? Ke(e.items) : bt(e.dl).pipe(Je(function () {
                return Ke(e.items);
              }));
            })));
          },
              kh = function kh(e, t) {
            return e.pipe(fn("".concat(Oi)), ln(t), pt(function (e) {
              var _e67 = _slicedToArray(e, 2),
                  t = _e67[1];

              return void 0 !== t.meeting.encryptedRWC || void 0 !== t.meeting.encryptedGEORWC && t.meeting.encryptedGEORWC.length > 0;
            }), Yt(function (e) {
              var _e68 = _slicedToArray(e, 2),
                  n = _e68[1];

              var _n$meeting3 = n.meeting,
                  r = _n$meeting3.ts,
                  i = _n$meeting3.auth,
                  o = _n$meeting3.meetingNumber,
                  a = _n$meeting3.meetingOptions,
                  s = n.breakoutRoom,
                  c = null == a ? void 0 : a.isEnableGeoFenceRWC,
                  l = Eh(n);

              if (l.length > 0) {
                var _e69 = {
                  serversLength: l.reduce(function (e, t) {
                    return e + t.items.length;
                  }, 0),
                  pingFailedServerList: [],
                  pingRwcServerCounts: 0,
                  retryCounts: 0
                };

                var _n19;

                return c && (_n19 = new xe(), Ch(l).subscribe(function (e) {
                  var t;
                  return null === (t = _n19) || void 0 === t ? void 0 : t.next(e);
                })), (c ? _n19 : Ch(l)).pipe(Xt(function () {
                  var r = t.value.meeting.meetingStatus,
                      i = r === go.Initial && _e69.pingFailedServerList.length < _e69.serversLength && _e69.serversLength > 0;
                  return !i && _n19 && _n19.complete(), i;
                }), nn(function () {
                  if (_e69.pingRwcServerCounts = _e69.pingRwcServerCounts + 1, c && _e69.pingRwcServerCounts === _e69.serversLength) {
                    var _r19 = 1e3 * Math.floor(5 * Math.pow(2, _e69.retryCounts));

                    _e69.retryCounts = _e69.retryCounts + 1, bt(_r19).pipe(Me(function () {
                      var n = Eh(t.value);
                      return Object.assign(_e69, {
                        serversLength: n.reduce(function (e, t) {
                          return e + t.items.length;
                        }, 0),
                        pingFailedServerList: [],
                        pingRwcServerCounts: 0
                      }), n;
                    })).subscribe(function (e) {
                      Ch(e).subscribe(function (e) {
                        _n19.next(e);
                      });
                    });
                  }
                }), Je(function (t) {
                  var a = t.rwc,
                      l = t.rwcToken,
                      d = function (e, t, n, r, i, o) {
                    var a = {
                      ts: r,
                      auth: i,
                      rwcToken: n,
                      dmz: 1
                    };
                    return o && Object.assign(a, {
                      confID: o
                    }), "https://".concat(e, "/wc/ping/").concat(t, "?").concat(new URLSearchParams(a).toString());
                  }(a, o, l, r, i, null == s ? void 0 : s.currentRoom.boConfId);

                  return xh(d).pipe(Je(function (e) {
                    var t = {};
                    return t = e.response ? f(f({}, e.response), {}, {
                      rwc: a,
                      fromNginx: !1
                    }) : {
                      rwc: a,
                      rwg: a,
                      rwcToken: l,
                      fromNginx: !0
                    }, Ke([xr(t), pr()]);
                  }), wt(function () {
                    var t = _e69.pingFailedServerList,
                        r = _e69.serversLength;
                    return t.push(d), t.length === r && (c && _n19 && _n19.complete(), As(ga, {
                      reason: "connection error",
                      errorCode: -3e3
                    })), ce;
                  }));
                }), Gt(Hi(performance.now())));
              }

              return ce;
            }));
          };

          var Ah = 0;
          var Ih = {
            meetingStatus: go.Initial,
            isWindowOpen: !1,
            apiKey: "",
            signature: "",
            signatureType: "",
            lang: "en-US",
            tk: "",
            customerKey: "",
            mtkGuid: "",
            pingRWCTimestamp: 0,
            passWord: "",
            meetingNumber: 0,
            userName: "",
            userEmail: "",
            sdkUrl: "",
            sdkOrigin: "",
            proxy: 1,
            cv: "",
            meetingId: "",
            tid: "",
            ts: "",
            auth: "",
            sign: "",
            isSupportCallOut: !1,
            tollNumbers: void 0,
            recordingEnable: !1,
            callOutCountry: void 0,
            inviteEmail: "",
            xmppConfig: null,
            isSupportH323: !1,
            h323GatewayInfo: "",
            h323Password: "",
            trackAuth: "",
            isOriginHost: !1,
            isWebinar: !1,
            encryptedRWC: void 0,
            meetingOptions: {},
            meetingTopic: "",
            bLock: !1,
            bHoldUponEntry: !1,
            viewOnly: 0,
            listenOnlyPhone: 0,
            bAllowRaiseHand: !1,
            bAllowAttendeeRename: !1,
            bBroadcast: void 0,
            bAllowPlayChimeForEnterOrExit: !1,
            bIbDisableShare: !1,
            bIbDisableChat: !1,
            bAllowShowCount: !1,
            encryptKey: "",
            bNoHostTimeOut: !1,
            confId: "",
            conId: "",
            e2eEncrypt: !1,
            zoomId: "",
            jid: "",
            xtoken: "",
            groups: void 0,
            svcUrl: "",
            encType: NaN,
            userGUID: "",
            userId: NaN,
            isHost: !1,
            isCoHost: !1,
            participantID: 0,
            isOnHold: !1,
            isMeetingReset: !1,
            bRecord: !1,
            audioVideoBeforeOnHold: void 0,
            region: void 0,
            network: void 0,
            joinMeetingTimeStamp: 0,
            enableAudioQos: !0,
            enableVideoQos: !0,
            activeAppInfo: void 0,
            recordingDisclaimerForRecorder: {},
            recordingDisclaimer: {},
            ccUrl: "",
            sessionIdleTimeoutMins: 40,
            reportDomain: "",
            isAudioBridgeEnabled: !0,
            discardedRwcList: [],
            sharePronounType: void 0,
            stayAwake: !1,
            wrInfo: {}
          },
              Th = ur((_ur2 = {}, _defineProperty(_ur2, "".concat(Di), Hp(function (e, t) {
            var n = t.payload;
            n.customerKey = e.customerKey || n.customerKey || "", Object.assign(e, n), e.meetingStatus = go.Initial;
          })), _defineProperty(_ur2, "".concat(zi), Hp(function (e, t) {
            var n = t.payload;
            e.isWindowOpen = n;
          })), _defineProperty(_ur2, "".concat(Mi), Hp(function (e, t) {
            var n = t.payload;
            n.useSDK ? e.signatureType = "sdk" : e.signatureType = "api", e.apiKey = n.apiKey, e.signature = n.signature, e.lang = n.language;
          })), _defineProperty(_ur2, "".concat(Li), Hp(function (e, t) {
            var n = t.payload;
            e.ztk = n;
          })), _defineProperty(_ur2, "".concat(Ui), Hp(function (e, t) {
            var n = t.payload;
            e.zsk = n;
          })), _defineProperty(_ur2, "".concat(Bi), Hp(function (e, t) {
            var n = t.payload;
            e.tk = n.tk, e.mtkGuid = n.mtkGuid;
          })), _defineProperty(_ur2, "".concat(Hi), Hp(function (e, t) {
            var n = t.payload;
            e.pingRWCTimestamp = n;
          })), _defineProperty(_ur2, "".concat(Vi), Hp(function (e, t) {
            var n = t.payload;
            e.confId = n.confID, e.conId = n.conID, e.e2eEncrypt = n.e2eEncrypt, e.meetingNumber = parseInt(n.mn, 10), e.zoomId = n.zoomID, e.meetingStatus = go.Joined, e.jid = n.jid, e.xtoken = n.xtoken, e.groups = n.groups, e.svcUrl = n.svcUrl, e.encType = n.encType, e.userGUID = n.userGUID, e.userId = n.userID, e.role = n.role, e.participantID = n.participantID, e.reportDomain = n.reportDomain;
          })), _defineProperty(_ur2, "".concat(qi), Hp(function (e, t) {
            var n = t.payload;
            Object.assign(e, n);
          })), _defineProperty(_ur2, "".concat(Wi), Hp(function (e, t) {
            var n = t.payload;
            e.isHost = n;
          })), _defineProperty(_ur2, "".concat(Gi), Hp(function (e, t) {
            var n = t.payload;
            e.isCoHost = n;
          })), _defineProperty(_ur2, "".concat(Ki), Hp(function (e, t) {
            var n = t.payload;
            e.isOnHold = n;
          })), _defineProperty(_ur2, "".concat(Qi), Hp(function (e, t) {
            var n = t.payload;
            e.isMeetingReset = n;
          })), _defineProperty(_ur2, "".concat(Zi), Hp(function (e, t) {
            var n = t.payload;
            e.audioVideoBeforeOnHold = n;
          })), _defineProperty(_ur2, "".concat(Yi), Hp(function (e, t) {
            var n = t.payload;
            e.currentUserAudioBeforeReset = n;
          })), _defineProperty(_ur2, "".concat(Ji), Hp(function (e, t) {
            var n = t.payload;
            e.isCurrentUserMutedBeforeReset = n;
          })), _defineProperty(_ur2, "".concat($i), Hp(function (e, t) {
            var n = t.payload;
            e.meetingStatus = n;
          })), _defineProperty(_ur2, "".concat(Xi), Hp(function (e, t) {
            var n = t.payload;
            e.region = n.region, e.network = n.network;
          })), _defineProperty(_ur2, "".concat(eo), Hp(function (e, t) {
            var n = t.payload;
            e.isCurrentUserStartVideoBeforeReset = n;
          })), _defineProperty(_ur2, "".concat(to), Hp(function (e, t) {
            var n = t.payload;
            e.joinMeetingTimeStamp = n;
          })), _defineProperty(_ur2, "".concat(no), Hp(function (e, t) {
            var n = t.payload;
            e.enableAudioQos = n.audioQos, e.enableVideoQos = n.videoQos;
          })), _defineProperty(_ur2, "".concat(ro), Hp(function (e, t) {
            var n = t.payload;
            e.activeAppInfo = n;
          })), _defineProperty(_ur2, "".concat(io), Hp(function (e, t) {
            var n = t.payload;
            e.idleStartTime = n;
          })), _defineProperty(_ur2, "".concat(oo), Hp(function (e, t) {
            var n = t.payload;
            e.sessionIdleTimeoutMins = n;
          })), _defineProperty(_ur2, "".concat(ao), Hp(function (e, t) {
            var n = t.payload;
            e.isAudioBridgeEnabled = n;
          })), _defineProperty(_ur2, "".concat(so), Hp(function (e, t) {
            var n, r;
            var i = t.payload;
            var o = null === (n = e.encryptedGEORWC) || void 0 === n || null === (r = n.find(function (e) {
              return e.rwc === i;
            })) || void 0 === r ? void 0 : r.dc;

            if (o) {
              var _e$discardedRwcList;

              var a;

              var _t28 = null === (a = e.encryptedGEORWC) || void 0 === a ? void 0 : a.filter(function (e) {
                return e.dc === o;
              });

              _t28 && e.discardedRwcList.some(function (e) {
                return (null == _t28 ? void 0 : _t28.findIndex(function (t) {
                  return t.rwc === e;
                })) >= 0;
              }) && (_e$discardedRwcList = e.discardedRwcList).push.apply(_e$discardedRwcList, _toConsumableArray(_t28.map(function (e) {
                return e.rwc;
              }))), e.discardedRwcList.push(i);
            }
          })), _defineProperty(_ur2, "".concat(co), Hp(function (e, t) {
            var n = t.payload;
            e.sharePronounType = n;
          })), _defineProperty(_ur2, "".concat(lo), Hp(function (e, t) {
            var n = t.payload;
            e.stayAwake = n;
          })), _defineProperty(_ur2, "".concat(Fi), Hp(function (e, t) {
            var n = t.payload;
            Object.assign(e, f(f({}, Ih), {}, {
              isMeetingReset: !0,
              currentUserAudioBeforeReset: e.audioVideoBeforeOnHold ? e.audioVideoBeforeOnHold.audio : n.audio,
              isCurrentUserMutedBeforeReset: e.audioVideoBeforeOnHold ? e.audioVideoBeforeOnHold.muted : n.muted,
              isCurrentUserStartVideoBeforeReset: e.audioVideoBeforeOnHold ? e.audioVideoBeforeOnHold.video : n.video,
              apiKey: e.apiKey,
              signatureType: e.signatureType,
              signature: e.signature,
              meetingNumber: e.meetingNumber,
              userName: e.userName,
              lang: e.lang,
              passWord: e.passWord,
              userEmail: e.userEmail,
              sdkUrl: e.sdkUrl,
              sdkOrigin: e.sdkOrigin,
              proxy: 1,
              cv: e.cv,
              zsk: e.zsk,
              ztk: e.ztk,
              idleStartTime: e.idleStartTime,
              sessionIdleTimeoutMins: e.sessionIdleTimeoutMins,
              customerKey: e.customerKey,
              stayAwake: e.stayAwake
            }));
          })), _ur2), Ih),
              Oh = Hr(Gp, Yp, nh, rh, oh, {
            meetingInfoEpic: function meetingInfoEpic(e, t) {
              return e.pipe(fn("".concat(Ci)), Yt(function (e) {
                var n = e.payload,
                    _meetingSDKUrl$videoS = {
                  meetingSDKUrl: "https://".concat(ku, "/api/v1/wc/info"),
                  videoSDKUrl: "https://".concat(ku, "/wc/lsdk")
                },
                    r = _meetingSDKUrl$videoS.meetingSDKUrl;
                return function (e, t) {
                  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "zoomsdkjsonpcallback";
                  return new Q(function (r) {
                    Ah++;
                    var i = "".concat(n).concat(Ah),
                        o = document.createElement("script");
                    Object.keys(t).forEach(function (e) {
                      return (void 0 === t[e] || null === t[e]) && delete t[e];
                    }), o.src = "".concat(e, "?").concat(new URLSearchParams(Object.assign(t, {
                      callback: i
                    })).toString()), o.async = !0, o.onerror = function (e) {
                      return r.error(e);
                    }, document.getElementsByTagName("head")[0].appendChild(o), window[i] = function (e) {
                      o.parentNode && o.parentNode.removeChild(o), delete window[i], r.next(e), r.complete();
                    };
                  });
                }(r, n).pipe(wt(function (e) {
                  return fe({
                    status: !1,
                    result: e.toString(),
                    errorCode: -3e3
                  });
                }), Je(function (n) {
                  var _ft = ft(fe(n), function (e) {
                    return !0 === e.status && void 0 !== e.result || [Zr, Yr, Jr, $r, Xr].includes(e.errorCode);
                  }),
                      _ft2 = _slicedToArray(_ft, 2),
                      r = _ft2[0],
                      i = _ft2[1];

                  return i.subscribe(function (e) {
                    if (3004 === e.errorCode) As(ga, di(3004));else if (3008 === e.errorCode) As(ga, di(3008));else if (-3e3 === e.errorCode) As(ga, {
                      reason: "connection error",
                      errorCode: -3e3
                    });else if (200 === e.errorCode) As(ga, di(e.errorCode, e.errorMessage));else if (3e3 === e.errorCode) sessionStorage.removeItem(Vo.WebclientTk), sessionStorage.removeItem(mi(Vo.WebclientTk)), As(ga, di(e.errorCode, e.errorMessage));else if (3139 === e.errorCode) {
                      var _t29 = JSON.parse(e.errorMessage) || {
                        msg: "",
                        scheduleTime: "",
                        topic: ""
                      };

                      delete _t29.msg;

                      var _n20 = Object.assign({
                        result: _t29
                      }, di(3008));

                      As(ga, _n20);
                    } else As(ga, {
                      reason: e.errorMessage,
                      errorCode: 200
                    });
                  }), r.pipe(mu(function (n) {
                    if (!0 === n.status) {
                      var _n$result = n.result,
                          _r20 = _n$result.mid,
                          _i10 = _n$result.websdkClientFeatureOptions;
                      wo.init(_r20);

                      var _o7 = function (e, t) {
                        if (e.result) {
                          var _e$result = e.result,
                              _n21 = _e$result.meetingNumber,
                              _r21 = _e$result.userName,
                              _i11 = _e$result.userEmail,
                              _o8 = _e$result.passWord,
                              _a8 = _e$result.support_call_out,
                              _s8 = _e$result.toll_numbers_json,
                              _c3 = _e$result.can_recording,
                              _l3 = _e$result.call_out_country_json,
                              _d3 = _e$result.invite_email,
                              _u3 = _e$result.wcXMPPConfig,
                              _p3 = _e$result.ts,
                              _h3 = _e$result.auth,
                              _2 = _e$result.sign,
                              _f3 = _e$result.supportH323,
                              _m2 = _e$result.h323GatewayInfo,
                              _g2 = _e$result.h323Password,
                              _v2 = _e$result.otherTelInfo,
                              _b2 = _e$result.track_auth,
                              _y2 = _e$result.mid,
                              _w2 = _e$result.tid,
                              _S2 = _e$result.isSupportQA,
                              _x5 = _e$result.encryptedRWC,
                              _E2 = _e$result.encryptedGEORWC,
                              _C2 = _e$result.meetingTopic,
                              _k2 = _e$result.ccUrl,
                              _A2 = _e$result.meetingOptions,
                              _I3 = _e$result.isWebinar,
                              T = _e$result.optionAudioType,
                              _O3 = _e$result.isOriginHost,
                              _R3 = _e$result.recordingDisclaimer,
                              _N3 = _e$result.recordingDisclaimerForRecorder,
                              _P3 = _e$result.wrInfo;
                          return {
                            meetingNumber: _n21,
                            userName: wo.get(Vo.WebclientUserName) || _r21,
                            userEmail: _i11,
                            meetingId: _y2,
                            tid: _w2,
                            ts: _p3,
                            auth: _h3,
                            sign: _2,
                            passWord: _o8,
                            isSupportCallOut: "1" === _a8,
                            tollNumbers: JSON.parse(_s8 || "{}"),
                            recordingEnable: "1" === _c3,
                            callOutCountry: JSON.parse(_l3 || "{}"),
                            inviteEmail: _d3,
                            xmppConfig: JSON.parse(_u3 || "{}"),
                            isSupportH323: _f3,
                            h323GatewayInfo: _m2,
                            h323Password: _g2,
                            trackAuth: _b2,
                            isOriginHost: "true" === _O3,
                            isWebinar: "1" === _I3,
                            encryptedRWC: JSON.parse(_x5 || "{}"),
                            encryptedGEORWC: JSON.parse(_E2 || "{}"),
                            meetingOptions: JSON.parse(_A2 || "{}"),
                            meetingTopic: _C2,
                            isSupportQA: "true" === _S2,
                            otherTelInfo: _v2,
                            optionAudioType: T,
                            customerKey: t.customerKey,
                            ccUrl: _k2,
                            cv: t.cv,
                            sdkOrigin: t.sdkOrigin,
                            sdkUrl: t.sdkUrl,
                            proxy: t.proxy,
                            recordingDisclaimer: JSON.parse(_R3 || "{}"),
                            recordingDisclaimerForRecorder: JSON.parse(_N3 || "{}"),
                            wrInfo: JSON.parse(_P3 || "{}")
                          };
                        }

                        return e;
                      }(n, e.payload),
                          _a7 = [fe(Di(_o7)), fe(kd(null == _o7 ? void 0 : _o7.meetingOptions)), Ur(kh, t, Oi())],
                          _s7 = function (e) {
                        var t = _defineProperty({}, "".concat(vo.AudioBridgeEnable), {
                          mask: 240,
                          action: ao
                        }),
                            n = [];

                        if (e) {
                          var _r22 = e.split("").reverse();

                          Object.keys(vo).filter(function (e) {
                            return /\d(,\d)?/.test(vo[e]);
                          }).forEach(function (e) {
                            var i = vo[e],
                                o = i.split(",").map(function (e) {
                              return _r22[Number(e) - 1];
                            }).reverse().join(""),
                                a = parseInt(o, 16),
                                s = t[i];

                            if (s) {
                              var _e70 = (a & s.mask) > 0;

                              n.push(fe(s.action(_e70)));
                            }
                          });
                        }

                        return n;
                      }(_i10);

                      return _s7.length > 0 && _a7.unshift.apply(_a7, _toConsumableArray(_s7)), "1" === n.result.isWebinar && n.result.tk && wo.set(Vo.WebclientWebinarToken, n.result.tk, bo.SessionStorage), nt.apply(void 0, _a7);
                    }

                    return [Zr, Yr].includes(n.errorCode) ? (As(ga, Object.assign({}, di(n.errorCode), {
                      url: "".concat(Ru()).concat(n.errorMessage)
                    })), ce) : n.errorCode === Jr ? (As(ga, Object.assign({}, di(Jr), {
                      url: n.errorMessage
                    })), ce) : n.errorCode === $r || n.errorCode === Xr ? (As(ga, Object.assign({}, di(n.errorCode), {
                      url: n.errorMessage
                    })), ce) : void 0;
                  }));
                }));
              }));
            },
            pingRWCEpic: kh
          });

          var Rh,
              Nh = _i(function (e, t) {
            var n;
            n = function n() {
              function e() {
                for (var e = 0, t = {}; e < arguments.length; e++) {
                  var n = arguments[e];

                  for (var r in n) {
                    t[r] = n[r];
                  }
                }

                return t;
              }

              function t(e) {
                return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
              }

              return function n(r) {
                function i() {}

                function o(t, n, o) {
                  if ("undefined" != typeof document) {
                    "number" == typeof (o = e({
                      path: "/"
                    }, i.defaults, o)).expires && (o.expires = new Date(1 * new Date() + 864e5 * o.expires)), o.expires = o.expires ? o.expires.toUTCString() : "";

                    try {
                      var a = JSON.stringify(n);
                      /^[\{\[]/.test(a) && (n = a);
                    } catch (e) {}

                    n = r.write ? r.write(n, t) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                    var s = "";

                    for (var c in o) {
                      o[c] && (s += "; " + c, !0 !== o[c] && (s += "=" + o[c].split(";")[0]));
                    }

                    return document.cookie = t + "=" + n + s;
                  }
                }

                function a(e, n) {
                  if ("undefined" != typeof document) {
                    for (var i = {}, o = document.cookie ? document.cookie.split("; ") : [], a = 0; a < o.length; a++) {
                      var s = o[a].split("="),
                          c = s.slice(1).join("=");
                      n || '"' !== c.charAt(0) || (c = c.slice(1, -1));

                      try {
                        var l = t(s[0]);
                        if (c = (r.read || r)(c, l) || t(c), n) try {
                          c = JSON.parse(c);
                        } catch (e) {}
                        if (i[l] = c, e === l) break;
                      } catch (e) {}
                    }

                    return e ? i[e] : i;
                  }
                }

                return i.set = o, i.get = function (e) {
                  return a(e, !1);
                }, i.getJSON = function (e) {
                  return a(e, !0);
                }, i.remove = function (t, n) {
                  o(t, "", e(n, {
                    expires: -1
                  }));
                }, i.defaults = {}, i.withConverter = n, i;
              }(function () {});
            }, e.exports = n();
          }),
              Ph = new Uint8Array(16);

          function jh() {
            if (!Rh && !(Rh = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
            return Rh(Ph);
          }

          var Dh = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

          function zh(e) {
            return "string" == typeof e && Dh.test(e);
          }

          for (var Mh = [], Lh = 0; Lh < 256; ++Lh) {
            Mh.push((Lh + 256).toString(16).substr(1));
          }

          function Uh(e, t, n) {
            var r = (e = e || {}).random || (e.rng || jh)();

            if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
              n = n || 0;

              for (var i = 0; i < 16; ++i) {
                t[n + i] = r[i];
              }

              return t;
            }

            return function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                  n = (Mh[e[t + 0]] + Mh[e[t + 1]] + Mh[e[t + 2]] + Mh[e[t + 3]] + "-" + Mh[e[t + 4]] + Mh[e[t + 5]] + "-" + Mh[e[t + 6]] + Mh[e[t + 7]] + "-" + Mh[e[t + 8]] + Mh[e[t + 9]] + "-" + Mh[e[t + 10]] + Mh[e[t + 11]] + Mh[e[t + 12]] + Mh[e[t + 13]] + Mh[e[t + 14]] + Mh[e[t + 15]]).toLowerCase();
              if (!zh(n)) throw TypeError("Stringified UUID is invalid");
              return n;
            }(r);
          }

          var Bh;
          !function (e) {
            e[e.Unknown = 0] = "Unknown", e[e.Windows = 1] = "Windows", e[e.Mac = 2] = "Mac", e[e.Pad = 3] = "Pad", e[e.Mobile = 4] = "Mobile", e[e.CallIn = 5] = "CallIn", e[e.Linux = 6] = "Linux", e[e.WebClient = 7] = "WebClient", e[e.ChromeOs = 8] = "ChromeOs";
          }(Bh || (Bh = {}));
          var _Vo2 = Vo,
              Hh = _Vo2.WebclientIsOnHold,
              Vh = _Vo2.WebclientOpt,
              qh = _Vo2.WebclientParticipantId,
              Fh = _Vo2.WebclientZoomId,
              Wh = _Vo2.WebclientWebinarToken,
              Gh = _Vo2.WebclientMeetingToken,
              _qo = qo,
              Kh = _qo.WebclientDeviceId,
              Qh = ua.createAgent();
          var Zh;
          var Yh = Object.freeze({
            __proto__: null,
            connectZoomSocketEpic: function connectZoomSocketEpic(e, t) {
              return e.pipe(fn("".concat(pr)), ln(t), pt(function (e) {
                var _e71 = _slicedToArray(e, 2),
                    t = _e71[1];

                return t.socket.zoomSocketStatus === bc.Closed;
              }), Yt(function (e) {
                var _e72 = _slicedToArray(e, 2),
                    t = _e72[1];

                var _t$socket = t.socket,
                    n = _t$socket.retryCount,
                    r = _t$socket.rwgServerList,
                    i = t.meeting,
                    o = t.breakoutRoom;
                var a,
                    s = f(f({}, i), {}, {
                  retryCount: n,
                  rwgServerList: r
                });

                if (o && o.currentRoom.status === ic.Joining) {
                  var _o$currentRoom = o.currentRoom,
                      _e73 = _o$currentRoom.boId,
                      _t31 = _o$currentRoom.boConfId,
                      _n22 = _o$currentRoom.boToken;
                  s = f(f({}, s), {}, {
                    bid: _e73,
                    botk: _n22,
                    confID: _t31
                  });
                }

                if (a = i.zlkJwtToken ? function (e) {
                  var t = e.passWord,
                      n = e.meetingNumber,
                      r = e.userName,
                      i = e.topic,
                      o = e.trackAuth,
                      a = e.tid,
                      s = e.meetingId,
                      c = e.ts,
                      l = e.auth,
                      d = e.lang,
                      u = e.retryCount,
                      p = e.rwgServerList,
                      h = e.cv,
                      _ = e.bid,
                      f = e.botk,
                      m = e.confID,
                      g = e.customerKey,
                      v = e.zlkJwtToken,
                      b = e.isAudioBridgeEnabled;
                  var y = Nh.get("_zm_mtk_guid");
                  var w = wo.get(Kh);

                  if (w || (w = Uh(), wo.set(Kh, w, bo.LocalStorage)), p.length > u) {
                    var _e74 = So(),
                        _S3 = p[u];

                    var _x6 = {
                      dn2: mi(r),
                      topic: mi(i),
                      auth: l,
                      browser: _e74,
                      trackAuth: o,
                      mid: s,
                      tid: a,
                      lang: d,
                      ts: c,
                      "ZM-CID": w,
                      _ZM_MTG_TRACK_ID: y || "",
                      iccv: h,
                      customer_key: mi(g),
                      cfs: 0,
                      zlkJwtToken: v
                    };
                    "" !== t && (_x6 = Object.assign(_x6, {
                      mpwd: mi(t)
                    })), _S3.rwcAuth ? _x6 = Object.assign(_x6, {
                      rwcAuth: _S3.rwcAuth
                    }) : _S3.rwcToken && (_x6 = Object.assign(_x6, {
                      rwcToken: _S3.rwcToken
                    }));
                    var _E3 = 2;
                    return ko() ? _E3 = 1 : Ao() && (_E3 = 0), _x6 = Object.assign(_x6, {
                      as_type: _E3
                    }), [{
                      key: Vh,
                      queryKey: "opt"
                    }, {
                      key: qh,
                      queryKey: "participantID"
                    }, {
                      key: Fh,
                      queryKey: "zoomid"
                    }].forEach(function (e) {
                      var t = wo.get(e.key);
                      void 0 !== t && (_x6[e.queryKey] = t);
                    }), _ && f && m && Object.assign(_x6, {
                      bid: mi(_),
                      botk: f,
                      confID: m
                    }), wo.get(Gh) && Object.assign(_x6, {
                      isdj: 1
                    }), No() && (Object.assign(_x6, {
                      from: Mo() ? "android" : "ios"
                    }), b && Object.assign(_x6, {
                      useABAudio: 1
                    })), "wss://".concat(_S3.rwg, "/instantsdk/").concat(n, "?").concat(new URLSearchParams(_x6).toString());
                  }

                  return null;
                }(s) : function (e) {
                  var t = e.isHost,
                      n = e.isOriginHost,
                      r = e.passWord,
                      i = e.meetingNumber,
                      o = e.userName,
                      a = e.zsk,
                      s = e.ztk,
                      c = e.trackAuth,
                      l = e.tid,
                      d = e.sign,
                      u = e.signatureType,
                      p = e.meetingId,
                      h = e.ts,
                      _ = e.auth,
                      f = e.lang,
                      m = e.tk,
                      g = e.retryCount,
                      v = e.rwgServerList,
                      b = e.userEmail,
                      y = e.cv,
                      w = e.bid,
                      S = e.botk,
                      x = e.confID,
                      E = e.customerKey,
                      C = e.isAudioBridgeEnabled;
                  var k = Nh.get("_zm_mtk_guid");
                  var A = wo.get(Kh);

                  if (A || (A = Uh(), wo.set(Kh, A, bo.LocalStorage)), v.length > g) {
                    var _e75 = So(),
                        _I4 = v[g];

                    var T = {
                      dn2: mi(o),
                      auth: _,
                      signType: u,
                      browser: _e75,
                      trackAuth: c,
                      mid: p,
                      tid: l,
                      email: b,
                      lang: f,
                      zak: s || "",
                      tk: m || "",
                      customer_key: mi(E),
                      ts: h,
                      "ZM-CID": A,
                      _ZM_MTG_TRACK_ID: k || "",
                      jscv: y,
                      cfs: 0
                    };

                    var _O4 = sessionStorage.getItem(Vo.WebclientZsk) || a;

                    T = _O4 ? Object.assign(T, {
                      zak: a
                    }) : Object.assign(T, {
                      sign: d
                    }), t && n || "" === r || (T = Object.assign(T, {
                      mpwd: r
                    })), _I4.rwcAuth ? T = Object.assign(T, {
                      rwcAuth: _I4.rwcAuth
                    }) : _I4.rwcToken && (T = Object.assign(T, {
                      rwcToken: _I4.rwcToken
                    }));
                    var _R4 = 2;
                    return ko() ? _R4 = 1 : Ao() && (_R4 = 0), T = Object.assign(T, {
                      as_type: _R4
                    }), [{
                      key: Hh,
                      queryKey: "cfs"
                    }, {
                      key: Vh,
                      queryKey: "opt"
                    }, {
                      key: qh,
                      queryKey: "participantID"
                    }, {
                      key: Fh,
                      queryKey: "zoomid"
                    }, {
                      key: Wh,
                      queryKey: "tk"
                    }].forEach(function (e) {
                      var t = wo.get(e.key);
                      void 0 !== t && (T[e.queryKey] = t);
                    }), w && S && x && Object.assign(T, {
                      bid: mi(w),
                      botk: S,
                      confID: x
                    }), wo.get(Gh) && Object.assign(T, {
                      isdj: 1
                    }), No() && (Object.assign(T, {
                      from: Mo() ? "android" : "ios"
                    }), C && Object.assign(T, {
                      useABAudio: 1
                    })), "wss://".concat(_I4.rwg, "/wc/api/").concat(i, "?").concat(new URLSearchParams(T).toString());
                  }

                  return null;
                }(s), a) {
                  var _e76 = (c = a, Qh.connect(c), Zh = new X(), at(function (e) {
                    return Qh.on(la.Message, e);
                  }, function (e) {
                    return Qh.off(la.Message, e);
                  }, function (e) {
                    return e.data;
                  }).subscribe(Zh), Zh);

                  return dt(_e76.pipe(pt(function (e) {
                    return "string" == typeof e;
                  }), Me(function (e) {
                    return JSON.parse(e);
                  }), Su(), fu(function (e) {
                    if (0 !== e.evt || !e.body || "invalid parameters!" !== e.body.test) return mr(e);
                    As(ga, di(ii.INVALID_PARAMETER));
                  }), Gt(Sr(bc.Connecting))), _e76.pipe(pt(function (e) {
                    return e instanceof ArrayBuffer;
                  }), Me(function (e) {
                    return gr(e);
                  })));
                }

                var c;
                return ce;
              }));
            },
            connectedZoomSocketEpic: function connectedZoomSocketEpic(e, t) {
              return e.pipe(fn("".concat(pr)), ln(t), pt(function (e) {
                var _e77 = _slicedToArray(e, 2),
                    t = _e77[1];

                return t.socket.zoomSocketStatus === bc.Closed;
              }), Yt(function () {
                var _map = [la.Open, la.Close, la.Error].map(function (e) {
                  return at(function (t) {
                    return Qh.on(e, t);
                  }, function (t) {
                    return Qh.on(e, t);
                  });
                }),
                    _map2 = _slicedToArray(_map, 3),
                    e = _map2[0],
                    n = _map2[1],
                    r = _map2[2];

                return dt(e.pipe(Je(function () {
                  return dt(fe(Sr(bc.Connected)), bt(6e4).pipe(ln(t), pt(function (e) {
                    var _e78 = _slicedToArray(e, 2),
                        t = _e78[1];

                    return t.meeting.meetingStatus === go.Initial && !t.meeting.isMeetingReset;
                  }), Me(function () {
                    return As("RECONNECTING_MEETING", {
                      reason: ho.Failover
                    }), Ri();
                  })));
                })), n.pipe(ln(t), pt(function (e) {
                  var _e79 = _slicedToArray(e, 2),
                      t = _e79[1];

                  return t.socket.zoomSocketStatus !== bc.Closed && t.meeting.meetingStatus === go.Joined && !t.meeting.isMeetingReset;
                }), Me(function () {
                  return As("RECONNECTING_MEETING", {
                    reason: ho.Failover
                  }), Ri();
                })), r.pipe(ln(t), Je(function (e) {
                  var _e80 = _slicedToArray(e, 2),
                      n = _e80[1];

                  var _n$meeting4 = n.meeting,
                      r = _n$meeting4.meetingStatus,
                      i = _n$meeting4.isMeetingReset,
                      _n$socket = n.socket,
                      o = _n$socket.rwgServerList,
                      a = _n$socket.retryCount,
                      s = [];

                  if (r === go.Initial && null != o && o.length) {
                    var _e81 = o[a];
                    return bt(5e3).pipe(pt(function () {
                      return t.value.meeting.meetingStatus === go.Initial;
                    }), Je(function () {
                      var _t$value$socket = t.value.socket,
                          e = _t$value$socket.rwgServerList,
                          n = _t$value$socket.retryCount,
                          r = [];
                      return e.length > n + 1 ? r.push(Er(n + 1), _r({
                        retry: !0
                      })) : (As(ga, {
                        reason: "connection error",
                        errorCode: -3e3
                      }), r.push.apply(r, _toConsumableArray(hu(t.value)))), Ke(r);
                    }), Gt(so(null == _e81 ? void 0 : _e81.rwc)));
                  }

                  return i || r !== go.Joined || (As("RECONNECTING_MEETING", {
                    reason: ho.Failover
                  }), s.push(Ri())), Ke(s);
                })));
              }));
            },
            disconnectZoomSocketEpic: function disconnectZoomSocketEpic(e, t) {
              return e.pipe(fn("".concat(_r)), Yt(function (e) {
                return e.payload && e.payload.retry ? fe(pr()).pipe(It(1e3), Gt(Sr(bc.Closed))) : fe(Sr(bc.Closed));
              }), It(100), nn(function () {
                var e;
                t.value.socket.zoomSocketStatus === bc.Closed && (Qh.close(), null === (e = Zh) || void 0 === e || e.complete());
              }));
            }
          });
          var Jh = th.getInstance();
          var $h;
          var Xh = Object.freeze({
            __proto__: null,
            connectXmppSocketEpic: function connectXmppSocketEpic(e, t) {
              return e.pipe(fn("".concat(hr)), ln(t), pt(function (e) {
                var _e82 = _slicedToArray(e, 2),
                    t = _e82[1];

                return "closed" === t.socket.xmppSocketStatus;
              }), Yt(function (e) {
                var _e83 = _slicedToArray(e, 2),
                    t = _e83[1];

                var _t$meeting = t.meeting,
                    n = _t$meeting.svcUrl,
                    r = _t$meeting.meetingNumber,
                    i = _t$meeting.conId;
                return function (e) {
                  return Jh.connect(e), $h = new X(), at(function (e) {
                    return Jh.on(eh.Message, e);
                  }, function (e) {
                    return Jh.off(eh.Message, e);
                  }).subscribe($h), $h;
                }(function (e, t, n) {
                  return "wss://".concat(e, "/wc/media/").concat(t, "?type=x&cid=").concat(n);
                }(n, r, i)).pipe(pt(function (e) {
                  return void 0 !== (null == e ? void 0 : e.evt);
                }), Me(function (e) {
                  return vr(e);
                }), Gt(Cr(bc.Connecting)));
              }));
            },
            connectedXmppSocketEpic: function connectedXmppSocketEpic(e, t) {
              return e.pipe(fn("".concat(hr)), Yt(function () {
                var _map3 = [eh.Open, eh.Close, eh.Error].map(function (e) {
                  return at(function (t) {
                    return Jh.on(e, t);
                  }, function (t) {
                    return Jh.on(e, t);
                  });
                }),
                    _map4 = _slicedToArray(_map3, 3),
                    e = _map4[0],
                    n = _map4[1],
                    r = _map4[2];

                return dt(e.pipe(nn(function () {
                  var e = Eo() && Co() ? 11 : 10;
                  Jh.join(e);
                }), Mt(Cr(bc.Connected))), n.pipe(It(1e3), ln(t), pt(function (e) {
                  var _e84 = _slicedToArray(e, 2),
                      t = _e84[1];

                  return "closed" !== t.socket.xmppSocketStatus && t.meeting.meetingStatus === go.Joined && !t.meeting.isMeetingReset;
                }), Me(function () {
                  return As("RECONNECTING_MEETING", {
                    reason: ho.Failover
                  }), Ri();
                })), r.pipe(It(1e3), ln(t), pt(function (e) {
                  var _e85 = _slicedToArray(e, 2),
                      t = _e85[1];

                  return "closed" !== t.socket.xmppSocketStatus && t.meeting.meetingStatus === go.Joined && !t.meeting.isMeetingReset;
                }), Me(function () {
                  return As("RECONNECTING_MEETING", {
                    reason: ho.Failover
                  }), Ri();
                })));
              }));
            },
            disconnectCmdChannelSocketEpic: function disconnectCmdChannelSocketEpic(e) {
              return e.pipe(fn("".concat(fr)), Mt(Cr(bc.Closed)), It(100), nn(function () {
                var e;
                Jh.close(), null === (e = $h) || void 0 === e || e.complete();
              }));
            }
          });
          var e_ = pa.getInstance();
          var t_;
          var n_ = Object.freeze({
            __proto__: null,
            connectMainSessionSocketEpic: function connectMainSessionSocketEpic(e, t) {
              return e.pipe(fn("".concat(br)), ln(t), pt(function (e) {
                var _e86 = _slicedToArray(e, 2),
                    t = _e86[1];

                return "closed" === t.socket.mainSessionSocketStatus;
              }), Yt(function (e) {
                var _e87 = _slicedToArray(e, 2),
                    t = _e87[1];

                var _t$meeting2 = t.meeting,
                    n = _t$meeting2.svcUrl,
                    r = _t$meeting2.meetingNumber,
                    i = _t$meeting2.conId;
                return function (e) {
                  return e_.connect(e), t_ = new X(), at(function (e) {
                    return e_.on(la.Message, e);
                  }, function (e) {
                    return e_.off(la.Message, e);
                  }).pipe(Me(function (e) {
                    return e.data;
                  })).subscribe(t_), t_;
                }(function (e, t, n) {
                  return "wss://".concat(e, "/wc/media/").concat(t, "?type=m&cid=").concat(n, "&mode=2");
                }(n, r, i)).pipe(Me(function (e) {
                  return JSON.parse(e);
                }), pt(function (e) {
                  return 0 !== e.evt;
                }), Su(), Me(function (e) {
                  return wr(e);
                }), Gt(kr(bc.Connecting)));
              }));
            },
            connectedMainSessionSocketEpic: function connectedMainSessionSocketEpic(e, t) {
              return e.pipe(fn("".concat(br)), Yt(function () {
                var _map5 = [la.Open, la.Close, la.Error].map(function (e) {
                  return at(function (t) {
                    return e_.on(e, t);
                  }, function (t) {
                    return e_.on(e, t);
                  });
                }),
                    _map6 = _slicedToArray(_map5, 3),
                    e = _map6[0],
                    n = _map6[1],
                    r = _map6[2];

                return dt(e.pipe(Mt(kr(bc.Connected))), n.pipe(ln(t), pt(function (e) {
                  var _e88 = _slicedToArray(e, 2),
                      t = _e88[1];

                  return "closed" !== t.socket.zoomSocketStatus && t.meeting.meetingStatus === go.Joined;
                }), Me(function () {
                  return As("RECONNECTING_MEETING", {
                    reason: ho.Failover
                  }), Ri();
                })), r.pipe(Me(function () {
                  return As("RECONNECTING_MEETING", {
                    reason: ho.Failover
                  }), Ri();
                })));
              }));
            },
            disconnectMainSessionSocketEpic: function disconnectMainSessionSocketEpic(e) {
              return e.pipe(fn("".concat(yr)), Mt(kr(bc.Closed)), nn(function () {
                var e;
                e_.close(), null === (e = t_) || void 0 === e || e.complete();
              }));
            }
          });

          var r_ = {
            zoomSocketStatus: bc.Closed,
            xmppSocketStatus: bc.Closed,
            mainSessionSocketStatus: bc.Closed,
            retryCount: 0,
            rwgServerList: []
          },
              i_ = ur((_ur3 = {}, _defineProperty(_ur3, "".concat(Sr), Hp(function (e, t) {
            var n = t.payload;
            e.zoomSocketStatus = n;
          })), _defineProperty(_ur3, "".concat(xr), Hp(function (e, t) {
            var n = t.payload;
            var r = e.rwgServerList;
            r.find(function (e) {
              return e.rwg === n.rwg;
            }) || r.push(n);
          })), _defineProperty(_ur3, "".concat(Er), Hp(function (e, t) {
            var n = t.payload;
            e.retryCount = n;
          })), _defineProperty(_ur3, "".concat(Cr), Hp(function (e, t) {
            var n = t.payload;
            e.xmppSocketStatus = n;
          })), _defineProperty(_ur3, "".concat(kr), Hp(function (e, t) {
            var n = t.payload;
            e.mainSessionSocketStatus = n;
          })), _defineProperty(_ur3, "".concat(Ar), function () {
            return r_;
          }), _ur3), r_),
              o_ = Hr(Yh, Xh, n_),
              a_ = {
            id: "userId",
            type: function type(e) {
              return $s(e) ? {
                userType: e,
                avatarBackgroundType: Math.floor(8 * Math.random()) + 1
              } : {
                userType: e
              };
            },
            role: function role(e) {
              return {
                userRole: e,
                isHost: Js(e)
              };
            },
            dn2: function dn2(e) {
              return {
                displayName: gi(e)
              };
            },
            bShareOn: "sharerOn",
            bSharePause: "sharerPause",
            bLocalRecordStatus: function bLocalRecordStatus(e) {
              return {
                bLocalRecord: 1 === e
              };
            },
            bGuest: "isGuest",
            bCapsRequestLT: "isRequestLT"
          },
              s_ = function s_(e) {
            var t = {};
            return ["add", "remove", "update"].forEach(function (n) {
              null !== e[n] && void 0 !== e[n] && (t[n] = e[n].reduce(function (e, t) {
                var n = Object.keys(t).reduce(function (e, n) {
                  var r = a_[n];
                  return "function" == typeof r ? Object.assign(e, r(t[n])) : "string" == typeof r ? e[r] = t[n] : e[n] = t[n], e;
                }, {}),
                    r = e.find(function (e) {
                  return e.userId === n.userId;
                });
                return void 0 !== r ? Object.assign(r, n) : e.push(n), e;
              }, []));
            }), t;
          },
              c_ = {
            name: "displayName",
            node: function node(e) {
              return {
                userId: Number(e)
              };
            },
            role: function role(e) {
              return {
                userRole: Number(e)
              };
            }
          },
              l_ = function l_(e) {
            return Object.keys(e).reduce(function (t, n) {
              var r = c_[n];
              return "function" == typeof r ? Object.assign(t, r(e[n])) : "string" == typeof r ? t[r] = e[n] : t[n] = e[n], t;
            }, {});
          };

          var d_ = Object.freeze({
            __proto__: null,
            updateAttendeesEpic: function updateAttendeesEpic(e, t) {
              return Vr(e, 7937).pipe(Me(function (e) {
                return s_(e.payload.body);
              }), ln(t), Je(function (e) {
                var _e89 = _slicedToArray(e, 2),
                    t = _e89[0],
                    n = _e89[1],
                    r = [Ns(t)];

                var _n$meeting5 = n.meeting,
                    i = _n$meeting5.userId,
                    o = _n$meeting5.isWebinar,
                    a = _n$meeting5.isOnHold,
                    _n$participants = n.participants,
                    s = _n$participants.attendeesList,
                    c = _n$participants.failoverAttendeesList,
                    l = _n$participants.allowTalkAttendeesList,
                    d = l.map(function (e) {
                  return e.userId;
                });

                if (t.add) {
                  var _e90 = t.add.find(function (e) {
                    return e.userId === i;
                  });

                  void 0 !== _e90 && (As("ADD_CURRENT_USER_PARTICIPANT_ATTRIBUTE", _e90), void 0 !== _e90.bHold && r.push(Ki(_e90.bHold)));

                  var _n23 = t.add.filter(function (e) {
                    return e.userId !== i;
                  });

                  if (_n23.length > 0) {
                    var _e91 = _n23.filter(function (e) {
                      return !Xs(e.userRole);
                    }).map(function (e) {
                      var t = c.find(function (t) {
                        return t.zoomID === e.zoomID;
                      });
                      return t ? f(f({}, e), {}, {
                        source: t.isOnHold ? "on hold" : "failover"
                      }) : e;
                    }),
                        _t32 = _e91.filter(function (e) {
                      return !!e.source;
                    }).map(function (e) {
                      return {
                        zoomID: e.zoomID
                      };
                    });

                    if (r.push(Ms(_t32)), As("ADD_USER_PARTICIPANT_ATTRIBUTE", _e91), o) {
                      var _e92 = _n23.filter(function (e) {
                        return Xs(e.userRole);
                      });

                      _e92.length > 0 && As("UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", _e92.map(function (e) {
                        return {
                          userId: e.userId,
                          isAllowToTalk: !0
                        };
                      }));
                    }
                  }
                }

                if (t.update) {
                  var _e93 = t.update.find(function (e) {
                    return e.userId === i;
                  });

                  void 0 !== _e93 && (As("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", _e93), void 0 !== _e93.bHold && r.push(Ki(_e93.bHold)));

                  var _n24 = t.update.filter(function (e) {
                    return !(e.userId === i || d.includes(e.userId));
                  });

                  if (_n24.length > 0 && As("UPDATE_USER_PARTICIPANT_ATTRIBUTE", _n24), o) {
                    var _e94 = t.update.filter(function (e) {
                      return e.userId !== i && d.includes(e.userId);
                    });

                    _e94.length > 0 && As("UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", _e94);
                  }
                }

                if (t.remove) {
                  var _e95 = t.remove.map(function (e) {
                    var t = s.find(function (t) {
                      return t.userId === e.userId;
                    });
                    return t ? 2 === e.action && 1 === e.nUserStatus ? t.bHold ? (r.push(zs({
                      zoomID: t.zoomID,
                      isOnHold: !0
                    })), f(f({}, e), {}, {
                      reason: "on hold"
                    })) : (r.push(zs({
                      zoomID: t.zoomID,
                      isOnHold: !1
                    })), f(f({}, e), {}, {
                      reason: "failover"
                    })) : e : null;
                  }).filter(function (e) {
                    return !!e;
                  });

                  if (As("REMOVE_USER_PARTICIPANT_ATTRIBUTE", _e95), o) {
                    var _e96 = t.remove.filter(function (e) {
                      return d.includes(e.userId);
                    });

                    _e96.length > 0 && As("UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", _e96.map(function (e) {
                      return {
                        userId: e.userId,
                        isAllowToTalk: !1
                      };
                    }));
                  }
                }

                var u = r.filter(function (e) {
                  return e.type === "".concat(Ki);
                });

                if (u.length > 0) {
                  var _e97 = u[u.length - 1];
                  r = r.filter(function (e) {
                    return e.type !== "".concat(Ki);
                  }), _e97.payload !== a && (r.push(_e97), As("MEETING_IN_WAITING_ROOM", !a));
                }

                return Ke(r);
              }));
            },
            receiveUserListFromXMPPEpic: function receiveUserListFromXMPPEpic(e, t) {
              return Fr(e, 24595).pipe(Je(function (e) {
                var _e$payload$body4 = e.payload.body,
                    n = _e$payload$body4.action,
                    r = _e$payload$body4.data,
                    _t$value3 = t.value,
                    i = _t$value3.meeting.jid,
                    o = _t$value3.participants.xmppAttendeeList,
                    a = [];

                if (n === $p.rename) {
                  r.forEach(function (e) {
                    a.push(Bs(e));
                  });

                  var _e98 = r.map(function (e) {
                    return l_(e);
                  });

                  As("UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", _e98);
                }

                if (n === $p.Remove) {
                  r.forEach(function (e) {
                    a.push(Hs(e));
                  });

                  var _e99 = r.map(function (e) {
                    return f(f({}, l_(e)), {}, {
                      removed: !0
                    });
                  });

                  As("REMOVE_WEBINAR_ATTENDEE_ATTRIBUTE", _e99);
                }

                if ([$p.Add, $p.List, $p.update].includes(n)) {
                  var _e100 = r.map(function (e) {
                    var t = l_(e);
                    return Object.keys(t).reduce(function (e, n) {
                      return "" !== t[n] && Object.assign(e, _defineProperty({}, n, t[n])), e;
                    }, {});
                  });

                  if (As("UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", _e100), a.push(Vs(_e100)), n === $p.update) {
                    var _e101 = r.find(function (e) {
                      return e.jid === i;
                    });

                    if (_e101 && void 0 !== _e101.bRaiseHand) {
                      var _t33 = o.find(function (e) {
                        return e.jid === i;
                      });

                      (null == _t33 ? void 0 : _t33.bRaiseHand) !== _e101.bRaiseHand && As("MEETING_WEBINAR_ATTENDEE_RAISE_HAND", {
                        bRaiseHand: _e101.bRaiseHand
                      });
                    }
                  }
                }

                return Ke(a);
              }));
            },
            handleAdmitAllSilentUsersEpic: function handleAdmitAllSilentUsersEpic(e) {
              return Vr(e, 7951).pipe(nn(function (e) {
                !1 === e.payload.body.bStarted && As("ADMIT_ALL_SILENT_USERS_END", e.payload.body.bStarted);
              }), Me(function (e) {
                return js(e.payload.body.bStarted);
              }));
            },
            handleKVUpdateIndicationEpic: function handleKVUpdateIndicationEpic(e) {
              return Vr(e, 7946).pipe(pt(function (e) {
                var t;
                return ["bRaiseHand", "feedback"].includes(null === (t = e.payload.body) || void 0 === t ? void 0 : t.key) && 0 === e.payload.body.value;
              }), Me(function (e) {
                return As("UPDATE_USER_PARTICIPANT_ATTRIBUTE", {}), "bRaiseHand" === e.payload.body.key ? Ls() : Us();
              }));
            }
          });
          var u_ = {
            attendeesList: [],
            assistantList: [],
            xmppAttendeeList: [],
            allowTalkAttendeesList: [],
            failoverAttendeesList: [],
            isAdmitAllSilentUsers: !1
          },
              p_ = ur((_ur4 = {}, _defineProperty(_ur4, "".concat(Ns), Hp(function (e, t) {
            var n = t.payload;
            void 0 !== n.add && n.add.length > 0 && n.add.forEach(function (t) {
              var n = e.attendeesList.find(function (e) {
                return e.userId === t.userId && 51 !== t.userType;
              });
              if (void 0 !== n) Object.assign(n, t);else if (51 !== t.userType) {
                var _n25 = e.allowTalkAttendeesList.find(function (e) {
                  return e.userId === t.userId;
                });

                void 0 !== _n25 ? Object.assign(_n25, t) : Xs(t.userRole) ? e.allowTalkAttendeesList.push(t) : e.attendeesList.push(t);
              }
              var r = e.assistantList.find(function (e) {
                return e.userId === t.userId && 51 === t.userType;
              });
              void 0 !== r ? Object.assign(r, t) : 51 === t.userType && e.assistantList.push(t);
            }), void 0 !== n.update && n.update.length > 0 && n.update.forEach(function (t) {
              var n = e.attendeesList.find(function (e) {
                return e.userId === t.userId && 51 !== t.userType;
              });
              if (void 0 !== n) Object.assign(n, t);else if (51 !== t.userType) {
                var _n26 = e.allowTalkAttendeesList.find(function (e) {
                  return e.userId === t.userId;
                });

                void 0 !== _n26 && Object.assign(_n26, t);
              }
              var r = e.assistantList.find(function (e) {
                return e.userId === t.userId && 51 !== t.userType;
              });
              void 0 !== r && Object.assign(r, t);
            }), void 0 !== n.remove && n.remove.length > 0 && n.remove.forEach(function (t) {
              var n = e.attendeesList.findIndex(function (e) {
                return e.userId === t.userId && 51 !== t.userType;
              });
              if (-1 !== n) e.attendeesList.splice(n, 1);else if (51 !== t.userType) {
                var _n27 = e.allowTalkAttendeesList.findIndex(function (e) {
                  return e.userId === t.userId;
                });

                -1 !== _n27 && e.allowTalkAttendeesList.splice(_n27, 1);
              }
              var r = e.assistantList.findIndex(function (e) {
                return e.userId === t.userId;
              });
              -1 !== r && e.assistantList.splice(r, 1);
            });
          })), _defineProperty(_ur4, "".concat(Vs), Hp(function (e, t) {
            var n = t.payload;
            var r = e.xmppAttendeeList,
                i = r.map(function (e) {
              return e.jid;
            });
            n.forEach(function (e) {
              var t = e.jid,
                  n = i.indexOf(t);
              -1 !== n ? Object.assign(r[n], e) : r.push(e);
            });
          })), _defineProperty(_ur4, "".concat(js), Hp(function (e, t) {
            var n = t.payload;
            e.isAdmitAllSilentUsers = n;
          })), _defineProperty(_ur4, "".concat(Ls), Hp(function (e) {
            e.attendeesList.forEach(function (e) {
              e.bRaiseHand && (e.bRaiseHand = !1);
            });
          })), _defineProperty(_ur4, "".concat(Us), Hp(function (e) {
            e.attendeesList.forEach(function (e) {
              e.feedback > 0 && (e.feedback = 0);
            });
          })), _defineProperty(_ur4, "".concat(zs), Hp(function (e, t) {
            var n = t.payload;
            e.failoverAttendeesList.push(n);
          })), _defineProperty(_ur4, "".concat(Ms), Hp(function (e, t) {
            var n = t.payload;
            n.forEach(function (t) {
              var n = e.failoverAttendeesList.findIndex(function (e) {
                return e.zoomID === t.zoomID;
              });
              -1 !== n && e.failoverAttendeesList.splice(n, 1);
            });
          })), _defineProperty(_ur4, "".concat(Bs), Hp(function (e, t) {
            var n = t.payload;
            var r = n.jid,
                i = n.name,
                o = e.xmppAttendeeList.find(function (e) {
              return e.jid === r;
            });
            o && (o.displayName = i);
          })), _defineProperty(_ur4, "".concat(Hs), Hp(function (e, t) {
            var n = t.payload;
            var r = n.jid,
                i = e.xmppAttendeeList.findIndex(function (e) {
              return e.jid === r;
            });
            -1 !== r && e.xmppAttendeeList.splice(i, 1);
          })), _defineProperty(_ur4, "".concat(Ds), function () {
            return u_;
          }), _ur4), u_),
              h_ = Hr(d_),
              __ = {
            audioEncodeStatus: "initial",
            audioDecodeStatus: "initial",
            videoEncodeStatus: "initial",
            videoDecodeStatus: "initial",
            sharingEncodeStatus: "initial",
            sharingDecodeStatus: "initial",
            assetsPath: "",
            mediaConstraints: void 0,
            fileWithVersion: !1,
            enforceMultipleVideos: !1
          },
              f_ = ur((_ur5 = {}, _defineProperty(_ur5, "".concat(Rr), Hp(function (e, t) {
            var n = t.payload;
            e.audioDecodeStatus = n;
          })), _defineProperty(_ur5, "".concat(Or), Hp(function (e, t) {
            var n = t.payload;
            e.audioEncodeStatus = n;
          })), _defineProperty(_ur5, "".concat(Dr), Hp(function (e, t) {
            var n = t.payload;
            e.sharingDecodeStatus = n;
          })), _defineProperty(_ur5, "".concat(jr), Hp(function (e, t) {
            var n = t.payload;
            e.sharingEncodeStatus = n;
          })), _defineProperty(_ur5, "".concat(Pr), Hp(function (e, t) {
            var n = t.payload;
            e.videoDecodeStatus = n;
          })), _defineProperty(_ur5, "".concat(Nr), Hp(function (e, t) {
            var n = t.payload;
            e.videoEncodeStatus = n;
          })), _defineProperty(_ur5, "".concat(zr), Hp(function (e, t) {
            var n = t.payload;
            e.mediaConstraints = n.mediaConstraints, e.assetsPath = n.assetsPath, e.fileWithVersion = n.fileWithVersion, e.enforceMultipleVideos = n.enforceMultipleVideos;
          })), _defineProperty(_ur5, "".concat(Mr), Hp(function (e, t) {
            var n = t.payload;
            var r = n.type,
                i = n.encrypeKey,
                o = n.additionalType,
                a = {
              encrypeKey: i,
              additionalType: o
            };
            "audio" === r ? e.audioEncrypt = a : "video" === r ? e.videoEncrypt = a : "sharing" === r && (e.sharingEncrypt = a);
          })), _defineProperty(_ur5, "".concat(Lr), function (e) {
            return f(f({}, __), {}, {
              mediaConstraints: e.mediaConstraints,
              assetsPath: e.assetsPath,
              fileWithVersion: e.fileWithVersion
            });
          }), _ur5), __);

          var m_ = function (e) {
            return e && e.default || e;
          }(Object.freeze({
            __proto__: null,
            default: {}
          })),
              g_ = _i(function (e, t) {
            !function (e, t) {
              var _n28 = function n(e, t) {
                return (_n28 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (e, t) {
                  e.__proto__ = t;
                } || function (e, t) {
                  for (var n in t) {
                    t.hasOwnProperty(n) && (e[n] = t[n]);
                  }
                })(e, t);
              };

              function r(e, t) {
                function r() {
                  this.constructor = e;
                }

                _n28(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
              }

              var i,
                  _o9 = function o() {
                return (_o9 = Object.assign || function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++) {
                    for (var i in t = arguments[n]) {
                      Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }
                  }

                  return e;
                }).apply(this, arguments);
              },
                  a = function a(e, t) {
                var n = new Uint8Array(e.byteLength + t.byteLength);
                return n.set(new Uint8Array(e), 0), n.set(new Uint8Array(t), e.byteLength), n.buffer;
              };

              (i = e.TransformDataFormat || (e.TransformDataFormat = {})).STRING = "string", i.BLOB = "blob", i.ARRAY_BUFFER = "arraybuffer";

              var s = function s(e) {
                return Blob && e instanceof Blob ? "blob" : ArrayBuffer && e instanceof ArrayBuffer ? "arrayBuffer" : typeof e;
              },
                  c = [],
                  l = function l() {
                for (var e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], t = "", n = 0; n < 32; n++) {
                  t += e[Math.round(61 * Math.random())];
                }

                return -1 !== c.indexOf(t) ? l() : (c.push(t), t);
              },
                  d = function d(e) {
                return e.arrayBuffer ? e.arrayBuffer() : new Promise(function (t, n) {
                  var r = new FileReader();
                  r.readAsArrayBuffer(e), r.onload = function (e) {
                    t(e.target && e.target.result);
                  }, r.onerror = function (e) {
                    n(e);
                  };
                });
              },
                  u = function u(e) {
                return e.text ? e.text() : new Promise(function (t, n) {
                  var r = new FileReader();
                  r.readAsText(e), r.onload = function (e) {
                    t(e.target && e.target.result);
                  }, r.onerror = function (e) {
                    n(e);
                  };
                });
              },
                  p = function p(e, t) {
                return Promise.resolve(new Blob([new Uint8Array(e)], {
                  type: t
                }));
              },
                  h = function h(e, t) {
                var n = new Blob([e], {
                  type: t || "text/plain"
                });
                return u(n);
              },
                  _ = function _(e, t) {
                return Promise.resolve(new Blob([e], {
                  type: t || "text/plain"
                }));
              },
                  f = function f(e, t) {
                return d(new Blob([e], {
                  type: t || "text/plain"
                }));
              };

              function m(e) {
                var t = (e || "").split(".");
                return t[t.length - 1] || "";
              }

              function g(e) {
                var t = (e || "").lastIndexOf("/");
                return t < 0 ? "" : e.slice(0, t);
              }

              function v(e) {
                var t = (e || "").lastIndexOf("/"),
                    n = t < 0 ? e : e.slice(t + 1),
                    r = (n || "").lastIndexOf(".");
                return r < 0 ? n : n.slice(0, r);
              }

              function b(e) {
                return ["png", "jpg", "jpeg", "svg"].includes(m(e));
              }

              function y(e) {
                return "json" === m(e);
              }

              function w(e) {
                return "version" === m(e);
              }

              function S(e, n) {
                return t.loadAsync(e).then(function (e) {
                  return Promise.all(e.filter(function (e, t) {
                    return !t.dir;
                  }).map(function (e) {
                    var t = function (e) {
                      return y(e.name) ? "string" : b(e.name) ? "base64" : w(e.name) ? "text" : "blob";
                    }(e);

                    return (null == n ? void 0 : n.setUnZipFormat) && (t = n.setUnZipFormat(e) || t), e.async(t).then(function (n) {
                      var r = n,
                          i = m(e.name),
                          o = "svg" === i ? "svg+xml" : i;
                      return "base64" === t && b(e.name) && !n.startsWith("data") && (r = "data:image/" + o + ";base64," + r), {
                        data: r,
                        file: e
                      };
                    });
                  }));
                }).then(function (e) {
                  return function (e, t) {
                    return e.reduce(function (e, n) {
                      var r,
                          i = n.data,
                          o = n.file,
                          a = m(o.name),
                          s = g(o.name),
                          c = v(o.name),
                          l = ((null == t ? void 0 : t.combineExtNames) || []).includes(a) && "string" == typeof i,
                          d = l ? "" + (s ? s + "/" + a : a) : o.name;
                      return l && e.some(function (e) {
                        return e.path === d && (e.data[c] = i, !0);
                      }) || e.push({
                        path: d,
                        extName: a,
                        data: l ? (r = {}, r[c] = i, r) : i,
                        shouldCombine: l
                      }), e;
                    }, []).map(function (e) {
                      var t = e.data,
                          n = e.shouldCombine,
                          r = function (e, t) {
                        var n = {};

                        for (var r in e) {
                          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                        }

                        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                          var i = 0;

                          for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) {
                            t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
                          }
                        }

                        return n;
                      }(e, ["data", "shouldCombine"]);

                      return _o9(_o9({}, r), {
                        data: n ? JSON.stringify(t) : t
                      });
                    });
                  }(e, n);
                });
              }

              function x(t, n) {
                var r = n || {},
                    i = r.encoding,
                    o = r.blobType,
                    a = r.unZipOptions;
                if (function (e) {
                  return "blob" === s(e) && (e.type.includes("compressed") || e.type.includes("zip"));
                }(t) && !(null == a ? void 0 : a.disableUnZip)) return S(t, a);
                if (!i) return Promise.resolve(t);
                var c = s(t),
                    l = "string" === c,
                    m = "blob" === c,
                    g = "arrayBuffer" === c;

                if (i === e.TransformDataFormat.BLOB) {
                  var v = t;
                  if (l) return u(v);
                  if (g) return d(v);
                } else if (i === e.TransformDataFormat.ARRAY_BUFFER) {
                  var b = t;
                  if (l) return h(b, o);
                  if (m) return p(b, o);
                } else if (i === e.TransformDataFormat.STRING) {
                  var y = t;
                  if (m) return _(y, o);
                  if (g) return f(y, o);
                }

                return Promise.resolve(t);
              }

              function E(e) {
                var t = 0,
                    n = !1,
                    r = function r() {
                  t > 90 || n || (e(t += (100 - t) / 50), requestAnimationFrame(r));
                };

                return r(), {
                  finish: function finish() {
                    100 === t || n || (t = 100, e(100));
                  },
                  abort: function abort() {
                    100 === t || n || (n = !0);
                  },

                  get curProgress() {
                    return t;
                  }

                };
              }

              function C() {}

              function k() {
                k.init.call(this);
              }

              function A(e) {
                return void 0 === e._maxListeners ? k.defaultMaxListeners : e._maxListeners;
              }

              function I(e, t, n) {
                if (t) e.call(n);else for (var r = e.length, i = z(e, r), o = 0; o < r; ++o) {
                  i[o].call(n);
                }
              }

              function T(e, t, n, r) {
                if (t) e.call(n, r);else for (var i = e.length, o = z(e, i), a = 0; a < i; ++a) {
                  o[a].call(n, r);
                }
              }

              function O(e, t, n, r, i) {
                if (t) e.call(n, r, i);else for (var o = e.length, a = z(e, o), s = 0; s < o; ++s) {
                  a[s].call(n, r, i);
                }
              }

              function R(e, t, n, r, i, o) {
                if (t) e.call(n, r, i, o);else for (var a = e.length, s = z(e, a), c = 0; c < a; ++c) {
                  s[c].call(n, r, i, o);
                }
              }

              function N(e, t, n, r) {
                if (t) e.apply(n, r);else for (var i = e.length, o = z(e, i), a = 0; a < i; ++a) {
                  o[a].apply(n, r);
                }
              }

              function P(e, t, n, r) {
                var i, o, a, s;
                if ("function" != typeof n) throw new TypeError('"listener" argument must be a function');

                if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), a = o[t]) : (o = e._events = new C(), e._eventsCount = 0), a) {
                  if ("function" == typeof a ? a = o[t] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), !a.warned && (i = A(e)) && i > 0 && a.length > i) {
                    a.warned = !0;
                    var c = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
                    c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = a.length, s = c, "function" == typeof console.warn ? console.warn(s) : console.log(s);
                  }
                } else a = o[t] = n, ++e._eventsCount;

                return e;
              }

              function j(e, t, n) {
                var r = !1;

                function i() {
                  e.removeListener(t, i), r || (r = !0, n.apply(e, arguments));
                }

                return i.listener = n, i;
              }

              function D(e) {
                var t = this._events;

                if (t) {
                  var n = t[e];
                  if ("function" == typeof n) return 1;
                  if (n) return n.length;
                }

                return 0;
              }

              function z(e, t) {
                for (var n = new Array(t); t--;) {
                  n[t] = e[t];
                }

                return n;
              }

              C.prototype = Object.create(null), k.EventEmitter = k, k.usingDomains = !1, k.prototype.domain = void 0, k.prototype._events = void 0, k.prototype._maxListeners = void 0, k.defaultMaxListeners = 10, k.init = function () {
                this.domain = null, k.usingDomains && (void 0).active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new C(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
              }, k.prototype.setMaxListeners = function (e) {
                if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                return this._maxListeners = e, this;
              }, k.prototype.getMaxListeners = function () {
                return A(this);
              }, k.prototype.emit = function (e) {
                var t,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    c = "error" === e;
                if (a = this._events) c = c && null == a.error;else if (!c) return !1;

                if (s = this.domain, c) {
                  if (t = arguments[1], !s) {
                    if (t instanceof Error) throw t;
                    var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
                    throw l.context = t, l;
                  }

                  return t || (t = new Error('Uncaught, unspecified "error" event')), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t), !1;
                }

                if (!(n = a[e])) return !1;
                var d = "function" == typeof n;

                switch (r = arguments.length) {
                  case 1:
                    I(n, d, this);
                    break;

                  case 2:
                    T(n, d, this, arguments[1]);
                    break;

                  case 3:
                    O(n, d, this, arguments[1], arguments[2]);
                    break;

                  case 4:
                    R(n, d, this, arguments[1], arguments[2], arguments[3]);
                    break;

                  default:
                    for (i = new Array(r - 1), o = 1; o < r; o++) {
                      i[o - 1] = arguments[o];
                    }

                    N(n, d, this, i);
                }

                return !0;
              }, k.prototype.addListener = function (e, t) {
                return P(this, e, t, !1);
              }, k.prototype.on = k.prototype.addListener, k.prototype.prependListener = function (e, t) {
                return P(this, e, t, !0);
              }, k.prototype.once = function (e, t) {
                if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                return this.on(e, j(this, e, t)), this;
              }, k.prototype.prependOnceListener = function (e, t) {
                if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                return this.prependListener(e, j(this, e, t)), this;
              }, k.prototype.removeListener = function (e, t) {
                var n, r, i, o, a;
                if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                if (!(r = this._events)) return this;
                if (!(n = r[e])) return this;
                if (n === t || n.listener && n.listener === t) 0 == --this._eventsCount ? this._events = new C() : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
                  for (i = -1, o = n.length; o-- > 0;) {
                    if (n[o] === t || n[o].listener && n[o].listener === t) {
                      a = n[o].listener, i = o;
                      break;
                    }
                  }

                  if (i < 0) return this;

                  if (1 === n.length) {
                    if (n[0] = void 0, 0 == --this._eventsCount) return this._events = new C(), this;
                    delete r[e];
                  } else !function (e, t) {
                    for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) {
                      e[n] = e[r];
                    }

                    e.pop();
                  }(n, i);

                  r.removeListener && this.emit("removeListener", e, a || t);
                }
                return this;
              }, k.prototype.removeAllListeners = function (e) {
                var t, n;
                if (!(n = this._events)) return this;
                if (!n.removeListener) return 0 === arguments.length ? (this._events = new C(), this._eventsCount = 0) : n[e] && (0 == --this._eventsCount ? this._events = new C() : delete n[e]), this;

                if (0 === arguments.length) {
                  for (var r, i = Object.keys(n), o = 0; o < i.length; ++o) {
                    "removeListener" !== (r = i[o]) && this.removeAllListeners(r);
                  }

                  return this.removeAllListeners("removeListener"), this._events = new C(), this._eventsCount = 0, this;
                }

                if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (t) do {
                  this.removeListener(e, t[t.length - 1]);
                } while (t[0]);
                return this;
              }, k.prototype.listeners = function (e) {
                var t,
                    n = this._events;
                return n && (t = n[e]) ? "function" == typeof t ? [t.listener || t] : function (e) {
                  for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
                    t[n] = e[n].listener || e[n];
                  }

                  return t;
                }(t) : [];
              }, k.listenerCount = function (e, t) {
                return "function" == typeof e.listenerCount ? e.listenerCount(t) : D.call(e, t);
              }, k.prototype.listenerCount = D, k.prototype.eventNames = function () {
                return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
              };

              var M,
                  L = function (e) {
                function t(t) {
                  var n = e.call(this) || this;
                  return n.timeout = (null == t ? void 0 : t.timeout) || 3e4, n;
                }

                return r(t, e), t.prototype.clearTimeoutCheck = function () {
                  this.timeoutTimer && (clearTimeout(this.timeoutTimer), this.timeoutTimer = null);
                }, t.prototype.startTimeoutCheck = function () {
                  var e = this;
                  !this.timeoutTimer && !this.finished && this.timeout > 0 && (this.timeoutTimer = setTimeout(function () {
                    e.finished || (e.finished = !0, e.data = null, e.emit("timeout")), e.clearTimeoutCheck();
                  }, this.timeout));
                }, t;
              }(k),
                  U = function (e) {
                function t(t) {
                  var n = e.call(this, t) || this;
                  return n.uuid = l(), n.domParams = t || {}, n;
                }

                return r(t, e), t.prototype.jsonp = function () {
                  var e = this;

                  if (!this.finished) {
                    var t = this.domParams,
                        n = t.url,
                        r = t.jsonpCallbackName,
                        i = void 0 === r ? "callback" : r,
                        o = t.body,
                        a = t.integrity;
                    this.script = document.createElement("script"), a && (this.script.integrity = a, this.script.crossOrigin = "anonymous");
                    var s = "";
                    o && Object.entries(o).forEach(function (e) {
                      var t = e[0],
                          n = e[1];
                      s += (s ? "&" : "") + t + "=" + n;
                    }), s += (s ? "&" : "") + i + "=" + this.uuid, this.script.src = n + (n.includes("?") ? "" : "?") + s, this.jsonpCallback(), this.progressMonitory = E(function (t) {
                      e.finished || e.emit("progressUpdated", t);
                    }), document.body.appendChild(this.script);
                  }
                }, t.prototype.clearSideEffect = function (e) {
                  if (void 0 === e && (e = !1), document.body.removeChild(this.script), e) {
                    var t = this.uuid;

                    window[this.uuid] = function () {
                      window[t] && delete window[t];
                    };
                  } else delete window[this.uuid];

                  this.script = null, this.uuid = null, this.finished = !0, this.data = null, this.clearTimeoutCheck();
                }, t.prototype.jsonpCallback = function () {
                  var e = this;
                  this.script.onerror = function (t) {
                    var n;
                    e.finished || (e.clearSideEffect(), null === (n = e.progressMonitory) || void 0 === n || n.abort(), e.emit("error", new Error("string" == typeof t ? t : "load jsonp script failed")));
                  }, window[this.uuid] = function (t) {
                    var n;

                    if (!e.finished) {
                      var r = e.domParams,
                          i = r.encoding,
                          o = r.blobType,
                          a = r.unZipOptions,
                          s = r.beforeTransformData,
                          c = r.afterTransformData;
                      null === (n = e.progressMonitory) || void 0 === n || n.finish(), e.clearSideEffect(), (s ? s(t || "") : Promise.resolve(t || "")).then(function (t) {
                        return x(t, {
                          encoding: i,
                          blobType: o,
                          unZipOptions: a
                        }).then(function (t) {
                          return (c ? c(t) : Promise.resolve(t)).then(function (t) {
                            return e.emit("finished", t);
                          });
                        });
                      }).catch(function (t) {
                        return e.emit("error", t);
                      });
                    }
                  };
                }, t.prototype.abort = function () {
                  this.clearSideEffect(!0);
                }, t;
              }(L),
                  B = function (e) {
                function t(t) {
                  var n = e.call(this, t) || this;
                  return n.socketParams = t || {}, n;
                }

                return r(t, e), t.prototype.write = function (e, t) {
                  e && !this.finished && (e instanceof Error ? this.handleError(e) : (this.data ? this.appendData(e) : this.data = e, this.handlePerCentUpdate(t)));
                }, t.prototype.handlePerCentUpdate = function (e) {
                  void 0 === e || this.finished || this.emit("progressUpdated", e);
                }, t.prototype.handleError = function (e) {
                  this.data = null, this.finished = !0, this.clearTimeoutCheck(), this.emit("error", e);
                }, t.prototype.appendData = function (e) {
                  s(e) === s(this.data) ? "string" == typeof e ? this.data += e : Blob && e instanceof Blob ? this.data = new Blob([this.data, e], {
                    type: e.type
                  }) : ArrayBuffer && e instanceof ArrayBuffer && (this.data = a(this.data, e)) : this.handleError(new Error("every piece of the data format must be the same"));
                }, t.prototype.end = function (e) {
                  var t = this;

                  if (!this.finished) {
                    this.handlePerCentUpdate(100), e && this.write(e);
                    var n = this.socketParams,
                        r = n.encoding,
                        i = n.blobType,
                        o = n.unZipOptions,
                        a = n.beforeTransformData,
                        s = n.afterTransformData;
                    (a ? a(this.data) : Promise.resolve(this.data)).then(function (e) {
                      return x(e, {
                        encoding: r,
                        blobType: i,
                        unZipOptions: o
                      }).then(function (e) {
                        return (s ? s(e) : Promise.resolve(e)).then(function (e) {
                          return t.emit("finished", e);
                        });
                      });
                    }).catch(function (e) {
                      return t.emit("error", e);
                    }), this.data = null, this.finished = !0, this.clearTimeoutCheck();
                  }
                }, t.prototype.abort = function () {
                  this.data = null, this.finished = !0, this.clearTimeoutCheck();
                }, t;
              }(L),
                  H = function (t) {
                function n(e) {
                  var n = t.call(this, e) || this;
                  return n.xhrParams = e || {}, n.xhrParams.headers = _o9({}, n.xhrParams.headers || {}), n;
                }

                return r(n, t), n.prototype.supportFetch = function () {
                  return !!window.fetch && window.AbortController && window.Request;
                }, n.prototype.ajax = function () {
                  var t = this;
                  if (!this.finished) if (this.xhrParams.url) {
                    var n = this.xhrParams,
                        r = n.headers,
                        i = void 0 === r ? {} : r,
                        a = n.url,
                        s = n.body,
                        c = void 0 === s ? {} : s,
                        l = n.method,
                        d = void 0 === l ? "POST" : l,
                        u = n.encoding,
                        p = n.integrity;
                    this.controller = this.supportFetch() ? new AbortController() : new XMLHttpRequest();
                    var h = this.supportFetch() ? E(function (e) {
                      t.finished || t.emit("progressUpdated", e);
                    }) : null;
                    (this.supportFetch() ? fetch(new Request(a, _o9({
                      method: d,
                      headers: i,
                      body: "GET" === d ? void 0 : JSON.stringify(c),
                      signal: this.controller.signal
                    }, p ? {
                      integrity: p,
                      mode: "cors"
                    } : {}))).then(function (t) {
                      return t.ok ? u === e.TransformDataFormat.STRING ? t.text() : u === e.TransformDataFormat.ARRAY_BUFFER ? t.arrayBuffer() : t.blob() : Promise.reject(new Error("xhr download " + a + " failed!"));
                    }) : new Promise(function (n, r) {
                      var o = new XMLHttpRequest();
                      t.controller = o, o.open(d, a), o.responseType = u === e.TransformDataFormat.STRING ? "text" : u === e.TransformDataFormat.ARRAY_BUFFER ? "arraybuffer" : "blob", Object.entries(i).forEach(function (e) {
                        var t = e[0],
                            n = e[1];
                        o.setRequestHeader(t, n);
                      }), o.onload = function () {
                        var e = o.status,
                            t = o.response,
                            i = o.statusText;
                        e >= 200 && e < 300 || 304 === e ? n(t) : r(new Error(e + ": " + i));
                      }, o.onprogress = function (e) {
                        var n = e || {},
                            r = n.total,
                            i = n.loaded;
                        void 0 === i || t.finished || (r ? t.emit("progressUpdated", i / r * 100) : i && !h && (h = E(function (e) {
                          t.finished || t.emit("progressUpdated", e);
                        })));
                      }, o.onerror = function () {
                        r(new Error("xhr download " + a + " failed!"));
                      }, o.send(JSON.stringify(c));
                    })).then(function (e) {
                      if (!t.finished) {
                        var n = t.xhrParams,
                            r = n.encoding,
                            i = n.blobType,
                            o = n.unZipOptions,
                            a = n.beforeTransformData,
                            s = n.afterTransformData;
                        null == h || h.finish(), t.finished = !0, t.clearTimeoutCheck(), (a ? a(e) : Promise.resolve(e)).then(function (e) {
                          return x(e, {
                            encoding: r,
                            blobType: i,
                            unZipOptions: o
                          }).then(function (e) {
                            return (s ? s(e) : Promise.resolve(e)).then(function (e) {
                              return t.emit("finished", e);
                            });
                          });
                        }).catch(function (e) {
                          return t.emit("error", e);
                        });
                      }
                    }).catch(function (e) {
                      t.finished || (t.finished = !0, t.clearTimeoutCheck(), null == h || h.abort(), t.emit("error", e));
                    });
                  } else this.emit("error", new Error("xhrDownloader url params invalid!"));
                }, n.prototype.abort = function () {
                  this.data = null, this.finished = !0, this.clearTimeoutCheck(), this.controller.abort();
                }, n;
              }(L),
                  V = 0,
                  q = new k(),
                  F = function F() {
                V -= 1, q.emit("ThreadPoolReady");
              };

              (M = e.DownloaderType || (e.DownloaderType = {})).XHR = "xhr", M.DOM = "dom", M.SOCKET = "socket";

              var W = function (t) {
                function n(n) {
                  var r = t.call(this) || this;
                  return r.aborted = !1, r.downloadParmas = _o9({
                    type: e.DownloaderType.XHR
                  }, n), r.id = l(), r;
                }

                return r(n, t), n.prototype.start = function () {
                  var t = this;
                  V += 1, this.progress = 0, this.emit("downloadStart"), this.onDownloadStartCallback && this.onDownloadStartCallback();
                  var n = this.downloadParmas,
                      r = n.type,
                      i = n.xhrParams,
                      o = n.domParams,
                      a = n.socketParams;

                  switch (r) {
                    case e.DownloaderType.DOM:
                      this.downloader = new U(o), this.downloader.jsonp();
                      break;

                    case e.DownloaderType.SOCKET:
                      this.downloader = new B(a);
                      break;

                    default:
                      this.downloader = new H(i), this.downloader.ajax();
                  }

                  return this.downloader.startTimeoutCheck(), this.downloader.on("error", function (e) {
                    t.emit("error", e), t.onErrorCallback && t.onErrorCallback(e), F();
                  }).on("finished", function (e) {
                    t.emit("complete", e), t.onCompleteCallback && t.onCompleteCallback(e), F();
                  }).on("progressUpdated", function (e) {
                    t.progress = e, t.emit("progressUpdated", e), t.onProgressUpdatedCallback && t.onProgressUpdatedCallback(e);
                  }).on("timeout", function () {
                    t.emit("timeout"), t.onTimeoutCallback && t.onTimeoutCallback(), F();
                  }), this;
                }, n.prototype.abort = function () {
                  if (this.aborted) return this;
                  this.aborted = !0, this.downloader && !this.downloader.finished && this.downloader.abort();
                  var e = new Error("file download has been aborted");
                  return this.emit("abort", e), this.onAbortCallback && this.onAbortCallback(e), F(), this;
                }, n.prototype.onDownloadStart = function (e) {
                  return this.onDownloadStartCallback = e, this;
                }, n.prototype.onProgressUpdated = function (e) {
                  return this.onProgressUpdatedCallback = e, this;
                }, n.prototype.onError = function (e) {
                  return this.onErrorCallback = e, this;
                }, n.prototype.onComplete = function (e) {
                  return this.onCompleteCallback = e, this;
                }, n.prototype.onAbort = function (e) {
                  return this.onAbortCallback = e, this;
                }, n.prototype.onTimeout = function (e) {
                  return this.onTimeoutCallback = e, this;
                }, n.prototype.isInProgress = function () {
                  return void 0 !== this.progress;
                }, n.prototype.isFinished = function () {
                  return 100 === this.progress;
                }, n;
              }(k),
                  G = function () {
                function e(e) {
                  this.taskList = [], this.options = e || {};
                  var t = this.options.threadLimit;
                  if ((void 0 === t ? 6 : t) > 6) throw new Error("threadLimit must be lower than 6");
                  q.on("ThreadPoolReady", this.startNextTask.bind(this));
                }

                return e.prototype.download = function (e) {
                  var t = new W(e),
                      n = this.removeTask.bind(this, t);
                  return t.on("abort", n), this.taskList.push(t), this.checkTaskReady(t), t;
                }, e.prototype.startNextTask = function () {
                  var e = this.taskList.find(function (e) {
                    return !e.isInProgress();
                  });
                  e && this.checkTaskReady(e);
                }, e.prototype.checkTaskReady = function (e) {
                  var t = this.options.threadLimit,
                      n = void 0 === t ? 6 : t;

                  if (!(this.taskList.findIndex(function (e) {
                    return !e.isInProgress();
                  }) >= n || V + 1 > 6)) {
                    var r = this.removeTask.bind(this, e);
                    e.on("complete", r), e.on("error", r), e.on("timeout", r), setTimeout(function () {
                      return e.start();
                    }, 0);
                  }
                }, e.prototype.removeTask = function (e) {
                  var t = this;
                  this.taskList.some(function (n, r) {
                    return n === e && (setTimeout(function () {
                      return e.removeAllListeners();
                    }, 0), t.taskList.splice(r, 1), !0);
                  });
                }, e;
              }();

              e.DownloadTask = W, e.IDownloadManager = G, e.appendBuffer = a, e.arrayBufferToBlob = p, e.arrayBufferToString = h, e.blobToArrayBuffer = d, e.blobToText = u, e.genUuid = l, e.getDataFormat = s, e.getExtName = m, e.getFileName = v, e.getFullPathName = g, e.isImgFile = b, e.isJsonFile = y, e.isVersionFile = w, e.monitorProgress = E, e.sep = "/", e.stringToArrayBuffer = f, e.stringToBlob = _, e.transformData = x, Object.defineProperty(e, "__esModule", {
                value: !0
              });
            }(t, m_);
          });

          hi(g_);
          var v_ = hi(_i(function (e, t) {
            !function (e, t) {
              var _n29 = function n(e, t) {
                return (_n29 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (e, t) {
                  e.__proto__ = t;
                } || function (e, t) {
                  for (var n in t) {
                    t.hasOwnProperty(n) && (e[n] = t[n]);
                  }
                })(e, t);
              };

              function r(e, t) {
                function r() {
                  this.constructor = e;
                }

                _n29(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
              }

              var _i12 = function i() {
                return (_i12 = Object.assign || function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++) {
                    for (var i in t = arguments[n]) {
                      Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }
                  }

                  return e;
                }).apply(this, arguments);
              };

              function o() {}

              function a() {
                a.init.call(this);
              }

              function s(e) {
                return void 0 === e._maxListeners ? a.defaultMaxListeners : e._maxListeners;
              }

              function c(e, t, n) {
                if (t) e.call(n);else for (var r = e.length, i = m(e, r), o = 0; o < r; ++o) {
                  i[o].call(n);
                }
              }

              function l(e, t, n, r) {
                if (t) e.call(n, r);else for (var i = e.length, o = m(e, i), a = 0; a < i; ++a) {
                  o[a].call(n, r);
                }
              }

              function d(e, t, n, r, i) {
                if (t) e.call(n, r, i);else for (var o = e.length, a = m(e, o), s = 0; s < o; ++s) {
                  a[s].call(n, r, i);
                }
              }

              function u(e, t, n, r, i, o) {
                if (t) e.call(n, r, i, o);else for (var a = e.length, s = m(e, a), c = 0; c < a; ++c) {
                  s[c].call(n, r, i, o);
                }
              }

              function p(e, t, n, r) {
                if (t) e.apply(n, r);else for (var i = e.length, o = m(e, i), a = 0; a < i; ++a) {
                  o[a].apply(n, r);
                }
              }

              function h(e, t, n, r) {
                var i, a, c, l;
                if ("function" != typeof n) throw new TypeError('"listener" argument must be a function');

                if ((a = e._events) ? (a.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), a = e._events), c = a[t]) : (a = e._events = new o(), e._eventsCount = 0), c) {
                  if ("function" == typeof c ? c = a[t] = r ? [n, c] : [c, n] : r ? c.unshift(n) : c.push(n), !c.warned && (i = s(e)) && i > 0 && c.length > i) {
                    c.warned = !0;
                    var d = new Error("Possible EventEmitter memory leak detected. " + c.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
                    d.name = "MaxListenersExceededWarning", d.emitter = e, d.type = t, d.count = c.length, l = d, "function" == typeof console.warn ? console.warn(l) : console.log(l);
                  }
                } else c = a[t] = n, ++e._eventsCount;

                return e;
              }

              function _(e, t, n) {
                var r = !1;

                function i() {
                  e.removeListener(t, i), r || (r = !0, n.apply(e, arguments));
                }

                return i.listener = n, i;
              }

              function f(e) {
                var t = this._events;

                if (t) {
                  var n = t[e];
                  if ("function" == typeof n) return 1;
                  if (n) return n.length;
                }

                return 0;
              }

              function m(e, t) {
                for (var n = new Array(t); t--;) {
                  n[t] = e[t];
                }

                return n;
              }

              function g(e) {
                var t;
                return null === (t = null == e ? void 0 : e.path) || void 0 === t ? void 0 : t.startsWith("ZipInfo:");
              }

              function v(e) {
                return "string" == typeof e && e.startsWith("ZipInfo:");
              }

              function b(e, t) {
                return (Array.isArray(e) ? e : [e]).some(function (e) {
                  if ("number" != typeof e.version) throw new Error("file version must be an int number");
                  return e.version < t;
                });
              }

              function y(e, t) {
                return e.reduce(function (e, n) {
                  return e.then(function (e) {
                    return t(e, n);
                  }).catch(function () {
                    return t(void 0, n);
                  });
                }, Promise.resolve(void 0));
              }

              o.prototype = Object.create(null), a.EventEmitter = a, a.usingDomains = !1, a.prototype.domain = void 0, a.prototype._events = void 0, a.prototype._maxListeners = void 0, a.defaultMaxListeners = 10, a.init = function () {
                this.domain = null, a.usingDomains && (void 0).active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new o(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
              }, a.prototype.setMaxListeners = function (e) {
                if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                return this._maxListeners = e, this;
              }, a.prototype.getMaxListeners = function () {
                return s(this);
              }, a.prototype.emit = function (e) {
                var t,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    h = "error" === e;
                if (a = this._events) h = h && null == a.error;else if (!h) return !1;

                if (s = this.domain, h) {
                  if (t = arguments[1], !s) {
                    if (t instanceof Error) throw t;

                    var _ = new Error('Uncaught, unspecified "error" event. (' + t + ")");

                    throw _.context = t, _;
                  }

                  return t || (t = new Error('Uncaught, unspecified "error" event')), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t), !1;
                }

                if (!(n = a[e])) return !1;
                var f = "function" == typeof n;

                switch (r = arguments.length) {
                  case 1:
                    c(n, f, this);
                    break;

                  case 2:
                    l(n, f, this, arguments[1]);
                    break;

                  case 3:
                    d(n, f, this, arguments[1], arguments[2]);
                    break;

                  case 4:
                    u(n, f, this, arguments[1], arguments[2], arguments[3]);
                    break;

                  default:
                    for (i = new Array(r - 1), o = 1; o < r; o++) {
                      i[o - 1] = arguments[o];
                    }

                    p(n, f, this, i);
                }

                return !0;
              }, a.prototype.addListener = function (e, t) {
                return h(this, e, t, !1);
              }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (e, t) {
                return h(this, e, t, !0);
              }, a.prototype.once = function (e, t) {
                if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                return this.on(e, _(this, e, t)), this;
              }, a.prototype.prependOnceListener = function (e, t) {
                if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                return this.prependListener(e, _(this, e, t)), this;
              }, a.prototype.removeListener = function (e, t) {
                var n, r, i, a, s;
                if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                if (!(r = this._events)) return this;
                if (!(n = r[e])) return this;
                if (n === t || n.listener && n.listener === t) 0 == --this._eventsCount ? this._events = new o() : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
                  for (i = -1, a = n.length; a-- > 0;) {
                    if (n[a] === t || n[a].listener && n[a].listener === t) {
                      s = n[a].listener, i = a;
                      break;
                    }
                  }

                  if (i < 0) return this;

                  if (1 === n.length) {
                    if (n[0] = void 0, 0 == --this._eventsCount) return this._events = new o(), this;
                    delete r[e];
                  } else !function (e, t) {
                    for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) {
                      e[n] = e[r];
                    }

                    e.pop();
                  }(n, i);

                  r.removeListener && this.emit("removeListener", e, s || t);
                }
                return this;
              }, a.prototype.removeAllListeners = function (e) {
                var t, n;
                if (!(n = this._events)) return this;
                if (!n.removeListener) return 0 === arguments.length ? (this._events = new o(), this._eventsCount = 0) : n[e] && (0 == --this._eventsCount ? this._events = new o() : delete n[e]), this;

                if (0 === arguments.length) {
                  for (var r, i = Object.keys(n), a = 0; a < i.length; ++a) {
                    "removeListener" !== (r = i[a]) && this.removeAllListeners(r);
                  }

                  return this.removeAllListeners("removeListener"), this._events = new o(), this._eventsCount = 0, this;
                }

                if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (t) do {
                  this.removeListener(e, t[t.length - 1]);
                } while (t[0]);
                return this;
              }, a.prototype.listeners = function (e) {
                var t,
                    n = this._events;
                return n && (t = n[e]) ? "function" == typeof t ? [t.listener || t] : function (e) {
                  for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
                    t[n] = e[n].listener || e[n];
                  }

                  return t;
                }(t) : [];
              }, a.listenerCount = function (e, t) {
                return "function" == typeof e.listenerCount ? e.listenerCount(t) : f.call(e, t);
              }, a.prototype.listenerCount = f, a.prototype.eventNames = function () {
                return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
              };

              var w,
                  S = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }

                return r(t, e), t;
              }(a),
                  x = function (e) {
                function n(t) {
                  var n = e.call(this) || this;

                  if (n.ready = !1, n.openError = !1, n.isEnable()) {
                    var r = t || {},
                        i = r.nameSpaceId,
                        o = r.indexDbVersion;

                    n.dbName = function (e) {
                      return "resource-manager" + (e ? "-" + e : "");
                    }(i);

                    var a = indexedDB.open(n.dbName, o || 1);
                    a.addEventListener("error", function () {
                      n.openError = !0, n.checkReady(), n.emit("error", new Error("failed to open indexedDB"));
                    }), a.addEventListener("success", function () {
                      n.db = a.result, n.checkReady();
                    }), a.addEventListener("upgradeneeded", function () {
                      n.db = a.result, n.handleSuccess();
                    }), setTimeout(function () {
                      n.checkReady();
                    }, 5e3);
                  } else n.checkReady();

                  return n;
                }

                return r(n, e), n.prototype.checkReady = function () {
                  this.ready || (this.ready = !0, this.emit("ready"));
                }, n.prototype.handleSuccess = function () {
                  if (!this.db.objectStoreNames || 0 === this.db.objectStoreNames.length || !this.db.objectStoreNames.contains("resource")) {
                    var e = this.db.createObjectStore("resource", {
                      keyPath: "path",
                      autoIncrement: !1
                    });
                    e.createIndex("path", "path"), e.createIndex("sourceURL", "sourceURL", {
                      unique: !1
                    });
                  }
                }, n.prototype.createAction = function (e) {
                  var t = this.db.transaction(["resource"], e || "readonly");
                  return {
                    trans: t,
                    store: t.objectStore("resource")
                  };
                }, n.prototype.handleAction = function (e, t) {
                  return new Promise(function (n, r) {
                    var i = t();
                    e.addEventListener("complete", function () {
                      n(i.result);
                    }), e.addEventListener("error", function () {
                      r(e.error || new Error("transaction error"));
                    }), e.addEventListener("abort", function () {
                      r(e.error || new Error("transaction aborted"));
                    });
                  });
                }, n.prototype.put = function () {
                  for (var e = [], t = 0; t < arguments.length; t++) {
                    e[t] = arguments[t];
                  }

                  var n = this.createAction("readwrite"),
                      r = n.trans,
                      i = n.store;
                  return this.handleAction(r, function () {
                    return i.put.apply(i, e);
                  });
                }, n.prototype.getAllKeysFromIndex = function (e) {
                  for (var t = [], n = 1; n < arguments.length; n++) {
                    t[n - 1] = arguments[n];
                  }

                  if (IDBObjectStore.prototype.getAllKeys) {
                    var r = this.createAction(),
                        i = r.trans,
                        o = r.store;
                    return this.handleAction(i, function () {
                      var n;
                      return (n = o.index(e)).getAllKeys.apply(n, t);
                    });
                  }

                  return this.openKeyCursor(e);
                }, n.prototype.getAllFromIndex = function (e) {
                  for (var t = [], n = 1; n < arguments.length; n++) {
                    t[n - 1] = arguments[n];
                  }

                  var r = this.createAction(),
                      i = r.trans,
                      o = r.store;
                  return IDBObjectStore.prototype.getAll ? this.handleAction(i, function () {
                    var n;
                    return (n = o.index(e)).getAll.apply(n, t);
                  }) : this.openCursor(e);
                }, n.prototype.getFromIndex = function (e) {
                  for (var t = [], n = 1; n < arguments.length; n++) {
                    t[n - 1] = arguments[n];
                  }

                  var r = this.createAction(),
                      i = r.trans,
                      o = r.store;
                  return this.handleAction(i, function () {
                    var n;
                    return (n = o.index(e)).get.apply(n, t);
                  });
                }, n.prototype.deleteKey = function () {
                  for (var e = [], t = 0; t < arguments.length; t++) {
                    e[t] = arguments[t];
                  }

                  var n = this.createAction("readwrite"),
                      r = n.trans,
                      i = n.store;
                  return this.handleAction(r, function () {
                    return i.delete.apply(i, e);
                  });
                }, n.prototype.handleCursorAction = function (e, t, n, r) {
                  return new Promise(function (i, o) {
                    t.addEventListener("success", function () {
                      t.result ? (n(r, t.result), t.result.continue()) : i(r);
                    }), t.addEventListener("error", function () {
                      o(e.error || new Error("transaction error"));
                    });
                  });
                }, n.prototype.openKeyCursor = function (e) {
                  for (var t, n = [], r = 1; r < arguments.length; r++) {
                    n[r - 1] = arguments[r];
                  }

                  var i = this.createAction("readwrite"),
                      o = i.trans,
                      a = i.store;
                  return this.handleCursorAction(o, (t = a.index(e)).openKeyCursor.apply(t, n), function (e, t) {
                    return e.push(t.key), e;
                  }, []);
                }, n.prototype.openCursor = function (e) {
                  for (var t, n = [], r = 1; r < arguments.length; r++) {
                    n[r - 1] = arguments[r];
                  }

                  var i = this.createAction("readwrite"),
                      o = i.trans,
                      a = i.store;
                  return this.handleCursorAction(o, (t = a.index(e)).openCursor.apply(t, n), function (e, t) {
                    return e.push(t.value), e;
                  }, []);
                }, n.prototype.isEnable = function () {
                  return !!window.indexedDB && !this.openError;
                }, n.prototype.saveFile = function (e) {
                  return this.db ? this.put(e).then(function () {
                    return !0;
                  }) : Promise.resolve(!1);
                }, n.prototype.removeFile = function (e) {
                  var n = this;
                  return this.db ? "string" == typeof e ? this.getAllKeysFromIndex("path").then(function (r) {
                    var i = (r || []).filter(function (n) {
                      return n === e || n.startsWith("" + e + t.sep);
                    });
                    return Promise.all(i.map(function (e) {
                      return n.deleteKey(e);
                    }));
                  }).then(function () {
                    return !0;
                  }) : this.deleteKey(e.path).then(function () {
                    return !0;
                  }) : Promise.resolve(!1);
                }, n.prototype.clear = function () {
                  if (!this.db) return Promise.resolve(!1);
                  var e = this.createAction("readwrite"),
                      t = e.trans,
                      n = e.store;
                  return this.handleAction(t, function () {
                    return n.clear();
                  }).then(function () {
                    return !0;
                  });
                }, n.prototype.findFileByPath = function (e) {
                  return this.db && e ? this.getFromIndex("path", e) : Promise.resolve(void 0);
                }, n.prototype.findFileBySourceURL = function (e) {
                  return this.db && e ? this.getAllFromIndex("sourceURL", e) : Promise.resolve([]);
                }, n.prototype.isDirectory = function (e) {
                  var n = this;
                  return this.db ? new Promise(function (r) {
                    v(e) ? r(!1) : n.getAllKeysFromIndex("path").then(function (n) {
                      return (n || []).some(function (n) {
                        return n.startsWith("" + e + t.sep);
                      });
                    }).then(r).catch(function () {
                      return r(!1);
                    });
                  }) : Promise.resolve(!1);
                }, n.prototype.ls = function (e) {
                  var n = this;
                  return this.db ? this.getAllKeysFromIndex("path").then(function (r) {
                    var i = [];
                    return Promise.all((r || []).map(function (r) {
                      if (v(r)) return Promise.resolve(void 0);

                      if (e) {
                        if (r.startsWith("" + e + t.sep)) {
                          var o = r.split("" + e + t.sep)[1] || "";

                          if (o.includes(t.sep)) {
                            var a = "" + e + t.sep + o.split(t.sep)[0];
                            return a && !i.includes(a) ? (i.push(a), Promise.resolve(a)) : Promise.resolve(void 0);
                          }

                          return n.getFromIndex("path", r);
                        }

                        return Promise.resolve(void 0);
                      }

                      if (r.includes(t.sep)) {
                        var s = r.split(t.sep)[0] || "";
                        return s && !i.includes(s) ? (i.push(s), Promise.resolve(s)) : Promise.resolve(void 0);
                      }

                      return n.getFromIndex("path", r);
                    })).then(function (e) {
                      return e.filter(function (e) {
                        return !!e;
                      });
                    });
                  }) : Promise.resolve([]);
                }, n;
              }(S),
                  E = function (e) {
                function n() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.memoryFiles = [], t;
                }

                return r(n, e), n.prototype.isEnable = function () {
                  return !0;
                }, n.prototype.saveFile = function (e) {
                  var t = this;
                  return new Promise(function (n) {
                    t.memoryFiles.some(function (n, r) {
                      return n.path === e.path && (t.memoryFiles.splice(r, 1, e), !0);
                    }) || t.memoryFiles.push(e), n(!0);
                  });
                }, n.prototype.removeFile = function (e) {
                  var n = this;
                  return new Promise(function (r) {
                    for (var i = n.memoryFiles.length - 1; i >= 0; i--) {
                      var o = n.memoryFiles[i];
                      ("string" == typeof e && (o.path === e || o.path.startsWith("" + e + t.sep)) || e.path === o.path) && n.memoryFiles.splice(i, 1);
                    }

                    r(!0);
                  });
                }, n.prototype.clear = function () {
                  var e = this;
                  return new Promise(function (t) {
                    e.memoryFiles = [], t(!0);
                  });
                }, n.prototype.findFileByPath = function (e) {
                  var t = this;
                  return new Promise(function (n) {
                    n(t.memoryFiles.filter(function (t) {
                      return t.path === e;
                    })[0]);
                  });
                }, n.prototype.findFileBySourceURL = function (e) {
                  var t = this;
                  return new Promise(function (n) {
                    n(t.memoryFiles.filter(function (t) {
                      return t.sourceURL === e;
                    }));
                  });
                }, n.prototype.isDirectory = function (e) {
                  var n = this;
                  return new Promise(function (r) {
                    v(e) ? r(!1) : r(n.memoryFiles.some(function (n) {
                      return n.path.startsWith("" + e + t.sep);
                    }));
                  });
                }, n.prototype.ls = function (e) {
                  var n = this;
                  return new Promise(function (r) {
                    var i = [];
                    n.memoryFiles.forEach(function (n) {
                      if (!g(n)) if (e) {
                        if (n.path.startsWith("" + e + t.sep)) {
                          var r = n.path.split("" + e + t.sep)[1] || "";

                          if (r.includes(t.sep)) {
                            var o = "" + e + t.sep + r.split(t.sep)[0];
                            return void (o && !i.includes(o) && i.push(o));
                          }

                          i.push(n);
                        }
                      } else if (n.path.includes(t.sep)) {
                        var a = n.path.split(t.sep)[0] || "";
                        a && !i.includes(a) && i.push(a);
                      } else i.push(n);
                    }), r(i);
                  });
                }, n;
              }(S),
                  C = function (e) {
                function n(t) {
                  var n = e.call(this) || this;

                  if (n.isLocalAvaliable = void 0, n.isEnable()) {
                    var r = (t || {}).nameSpaceId;

                    n.storageName = function (e) {
                      return "resource-manager" + (e ? "-" + e : "");
                    }(r);
                  }

                  return n;
                }

                return r(n, e), n.prototype.isEnable = function () {
                  if (void 0 !== this.isLocalAvaliable) return this.isLocalAvaliable;

                  try {
                    this.isLocalAvaliable = !0, localStorage.setItem("privateTest", "");
                  } catch (e) {
                    this.isLocalAvaliable = !1;
                  }

                  return this.isLocalAvaliable;
                }, n.prototype.saveFile = function (e) {
                  var t = this;
                  return this.isEnable() ? new Promise(function (n) {
                    var r = t.getLocalFile();
                    r.some(function (t, n) {
                      return t.path === e.path && (r.splice(n, 1, e), !0);
                    }) || r.push(e), localStorage.setItem(t.storageName, JSON.stringify(r)), n(!0);
                  }) : Promise.resolve(!1);
                }, n.prototype.getLocalFile = function () {
                  var e = localStorage.getItem(this.storageName),
                      t = [];
                  if (e) try {
                    t = JSON.parse(e) || "[]";
                  } catch (e) {
                    console.log(e);
                  }
                  return t;
                }, n.prototype.removeFile = function (e) {
                  var n = this;
                  return this.isEnable() ? new Promise(function (r) {
                    for (var i = n.getLocalFile(), o = i.length - 1; o >= 0; o--) {
                      var a = i[o];
                      ("string" == typeof e && (a.path === e || a.path.startsWith("" + e + t.sep)) || e.path === a.path) && i.splice(o, 1);
                    }

                    localStorage.setItem(n.storageName, JSON.stringify(i)), r(!0);
                  }) : Promise.resolve(!1);
                }, n.prototype.clear = function () {
                  var e = this;
                  return this.isEnable() ? new Promise(function (t) {
                    localStorage.removeItem(e.storageName), t(!0);
                  }) : Promise.resolve(!1);
                }, n.prototype.findFileByPath = function (e) {
                  var t = this;
                  return this.isEnable() ? new Promise(function (n) {
                    n(t.getLocalFile().filter(function (t) {
                      return t.path === e;
                    })[0]);
                  }) : Promise.resolve(void 0);
                }, n.prototype.findFileBySourceURL = function (e) {
                  var t = this;
                  return this.isEnable() ? new Promise(function (n) {
                    n(t.getLocalFile().filter(function (t) {
                      return t.sourceURL === e;
                    }));
                  }) : Promise.resolve([]);
                }, n.prototype.isDirectory = function (e) {
                  var n = this;
                  return this.isEnable() ? new Promise(function (r) {
                    v(e) ? r(!1) : r(n.getLocalFile().some(function (n) {
                      return n.path.startsWith("" + e + t.sep);
                    }));
                  }) : Promise.resolve(!1);
                }, n.prototype.ls = function (e) {
                  var n = this;
                  return this.isEnable() ? new Promise(function (r) {
                    var i = [];
                    n.getLocalFile().forEach(function (n) {
                      if (!g(n)) if (e) {
                        if (n.path.startsWith("" + e + t.sep)) {
                          var r = n.path.split("" + e + t.sep)[1] || "";

                          if (r.includes(t.sep)) {
                            var o = "" + e + t.sep + r.split(t.sep)[0];
                            return void (o && !i.includes(o) && i.push(o));
                          }

                          i.push(n);
                        }
                      } else if (n.path.includes(t.sep)) {
                        var a = n.path.split(t.sep)[0] || "";
                        a && !i.includes(a) && i.push(a);
                      } else i.push(n);
                    }), r(i);
                  }) : Promise.resolve([]);
                }, n;
              }(S);

              (w = e.FileStoreEnum || (e.FileStoreEnum = {})).MEMORY = "memoryStore", w.INDEX_DB = "indexedDBStore", w.STORAGE = "storageStore";

              var k = function (n) {
                function o(e) {
                  var t = n.call(this) || this;
                  return t.indexedDBStore = new x(e), t.memoryStore = new E(), t.storageStore = new C(e), t;
                }

                return r(o, n), o.prototype.saveFile = function (t, n, r) {
                  var o = this;
                  void 0 === n && (n = !0);
                  var a = (r || {}).forceSpecifyStore;
                  return (n ? this.findFileByPath(t.path, r) : Promise.resolve(void 0)).then(function (n) {
                    if ((null == n ? void 0 : n.version) && b(t, n.version)) throw new Error("there is an higher version file existed already");

                    var r = _i12(_i12({}, t), {
                      createTime: n && n.createTime || Date.now(),
                      updateTime: Date.now()
                    });

                    return a && o[a] && o[a].isEnable() && (a !== e.FileStoreEnum.STORAGE || o.isLocalStorageAvaliable(r)) ? o[a].saveFile(r) : o[o.saveToTargetStoreRule(r)].saveFile(r);
                  });
                }, o.prototype.isLocalStorageAvaliable = function (e) {
                  var n = e.data;
                  return "string" === t.getDataFormat(n) && n.length <= 102400 && this.storageStore.isEnable();
                }, o.prototype.saveToTargetStoreRule = function (t) {
                  return this.indexedDBStore.isEnable() ? e.FileStoreEnum.INDEX_DB : this.isLocalStorageAvaliable(t) ? e.FileStoreEnum.STORAGE : e.FileStoreEnum.MEMORY;
                }, o.prototype.removeFile = function (e, t) {
                  var n = (t || {}).forceSpecifyStore;
                  return n && this[n] ? this[n].removeFile(e) : Promise.all([this.indexedDBStore.removeFile(e), this.storageStore.removeFile(e), this.memoryStore.removeFile(e)]).then(function () {
                    return !0;
                  });
                }, o.prototype.clear = function (e) {
                  var t = (e || {}).forceSpecifyStore;
                  return t && this[t] ? this[t].clear() : Promise.all([this.indexedDBStore.clear(), this.storageStore.clear(), this.memoryStore.clear()]).then(function () {
                    return !0;
                  });
                }, o.prototype.findFileByPath = function (e, t) {
                  var n = this,
                      r = (t || {}).forceSpecifyStore;
                  return r && this[r] ? this[r].findFileByPath(e) : y(this.searchInTargetStoreRule(), function (t, r) {
                    return t ? Promise.resolve(t) : n[r].findFileByPath(e);
                  });
                }, o.prototype.findFileBySourceURL = function (e, t) {
                  var n = this,
                      r = (t || {}).forceSpecifyStore;
                  return r && this[r] ? this[r].findFileBySourceURL(e) : y(this.searchInTargetStoreRule(), function (t, r) {
                    return n[r].findFileBySourceURL(e).then(function (e) {
                      return t ? t.filter(function (t) {
                        return !e.some(function (e) {
                          return e.path === t.path;
                        });
                      }).concat(e || []) : e || [];
                    });
                  });
                }, o.prototype.searchInTargetStoreRule = function () {
                  return [e.FileStoreEnum.INDEX_DB, e.FileStoreEnum.STORAGE, e.FileStoreEnum.MEMORY];
                }, o.prototype.isDirectory = function (e) {
                  var t = this;
                  return e ? y(this.searchInTargetStoreRule(), function (n, r) {
                    return n ? Promise.resolve(!0) : t[r].isDirectory(e);
                  }) : Promise.resolve(!0);
                }, o.prototype.ls = function (e) {
                  var t = this;
                  return this.isDirectory(e).then(function (n) {
                    if (!n) throw new Error("path: " + e + " is an invalid directory path");
                    return y(t.searchInTargetStoreRule(), function (n, r) {
                      return t[r].ls(e).then(function (e) {
                        return n ? (e || []).concat(n.filter(function (t) {
                          return !e.some(function (e) {
                            return "string" == typeof t ? e === t : "string" != typeof e && e.path === t.path;
                          });
                        })) : e;
                      });
                    });
                  });
                }, o;
              }(a),
                  A = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }

                return r(t, e), t;
              }(a),
                  I = function (e) {
                function n(n) {
                  var r = e.call(this) || this,
                      i = n || {},
                      o = i.storeOptions,
                      a = i.downloadManagerOptions;
                  return r.downloadManager = new t.IDownloadManager(a), r.store = new k(o), r.store.indexedDBStore.on("ready", function () {
                    return r.emit("ready");
                  }), r;
                }

                return r(n, e), n.prototype.getFile = function (e, t, n) {
                  var r = this,
                      i = new A(),
                      o = Promise.resolve(void 0),
                      a = t || {},
                      s = a.downloadOptions,
                      c = a.forceDownload,
                      l = a.saveRootPath;
                  c ? o = Promise.resolve(void 0) : "string" == typeof e ? o = this.store.findFileByPath(e, n) : (null == e ? void 0 : e.sourceURL) ? o = this.store.findFileBySourceURL(e.sourceURL) : s && (s.domParams || s.socketParams || s.xhrParams) && (o = this.store.findFileBySourceURL(this.genSourceURL(s)));
                  var d = null,
                      u = new Promise(function (e) {
                    d = e;
                  });
                  return i.getDownloadTask = function () {
                    return u;
                  }, o = o.then(function (e) {
                    if (e && (!Array.isArray(e) || e.length)) {
                      var t = e;

                      if (Array.isArray(t)) {
                        var r = t.find(function (e) {
                          return g(e);
                        });
                        if (!r) return;
                        t = t.filter(function (e) {
                          return !g(e);
                        });
                        var o = r.data;
                        if ("string" != typeof o) return;
                        if (!JSON.parse(o || "[]").every(function (e) {
                          return t.some(function (t) {
                            return t.path === e;
                          });
                        })) return;
                      }

                      if (!(null == n ? void 0 : n.targetVersion) || !b(t, n.targetVersion)) return i.emit("checkExpire", !1), t;
                      i.emit("checkExpire", !0);
                    }
                  }).then(function (t) {
                    if (!t && s) {
                      var o = r.downloadManager.download(s);
                      return d(o), new Promise(function (t, a) {
                        o.on("complete", function (o) {
                          setTimeout(function () {
                            var a = Array.isArray(o) ? o.map(function (e) {
                              var t = e.data,
                                  i = e.path,
                                  o = e.extName;
                              return {
                                path: r.genFilePath(l, i),
                                sourceURL: r.genSourceURL(s),
                                data: t,
                                fileFormat: o || r.getFileFormat(s),
                                version: (null == n ? void 0 : n.targetVersion) || 1
                              };
                            }) : {
                              path: r.genFilePath(l, void 0),
                              sourceURL: r.genSourceURL(s),
                              data: o,
                              fileFormat: r.getFileFormat(s),
                              version: (null == n ? void 0 : n.targetVersion) || 1
                            };

                            if (Array.isArray(a) && "string" == typeof e && e) {
                              var c = a.find(function (t) {
                                return t.path === e;
                              });
                              t(c || a);
                            } else t(a);

                            i.emit("beforeSet", a), r.beforeWrite(a, n).then(function () {
                              i.emit("afterSet");
                            }).catch(function (e) {
                              return i.emit("afterSet", e);
                            });
                          }, 0);
                        }), o.on("abort", a), o.on("error", a), o.on("timeout", function () {
                          return a(new Error("download timeout"));
                        });
                      });
                    }

                    return d(void 0), t;
                  }).catch(function (e) {
                    return d(void 0), Promise.reject(e);
                  }), i.getResult = function () {
                    return o;
                  }, i;
                }, n.prototype.genSourceURL = function (e) {
                  var n = e.domParams,
                      r = e.type,
                      i = e.xhrParams;
                  if (r === t.DownloaderType.SOCKET) return null;
                  var o = (r === t.DownloaderType.DOM ? n : i) || {},
                      a = o.url,
                      s = void 0 === a ? "" : a,
                      c = o.body;
                  return c && Object.keys(c).length ? s + (s.includes("?") ? "&" : "?") + "downloadBodyParams=" + JSON.stringify(c) : s;
                }, n.prototype.updateFile = function (e, t) {
                  return this.saveStore(e, !0, t);
                }, n.prototype.beforeWrite = function (e, t) {
                  var n,
                      r,
                      i = this;
                  return Array.isArray(e) ? Promise.all(e.concat((n = e, r = n[0].sourceURL || "", {
                    path: "ZipInfo:" + r,
                    sourceURL: r,
                    data: JSON.stringify(n.map(function (e) {
                      return e.path;
                    }))
                  })).map(function (e) {
                    return i.saveStore(e, !1, t);
                  })).then(function (e) {
                    return e.filter(function (e) {
                      return !g(e);
                    });
                  }) : this.saveStore(e, !0, t);
                }, n.prototype.getFileFormat = function (e) {
                  var n = e || {},
                      r = n.xhrParams,
                      i = n.domParams,
                      o = n.socketParams,
                      a = n.type;
                  return a === t.DownloaderType.DOM && (null == i ? void 0 : i.fileFormat) ? i.fileFormat : a === t.DownloaderType.SOCKET && (null == o ? void 0 : o.fileFormat) ? o.fileFormat : (null == r ? void 0 : r.fileFormat) ? r.fileFormat : "unknow";
                }, n.prototype.genFilePath = function (e, n) {
                  return n ? "" + (e || "") + (e ? t.sep : "") + n : e || "";
                }, n.prototype.saveStore = function (e, t, n) {
                  return void 0 === t && (t = !0), this.store.saveFile(e, t, n).then(function (t) {
                    if (t) return e;
                    throw new Error("fail to save file in local store");
                  });
                }, n.prototype.remove = function (e, t) {
                  return this.store.removeFile(e, t);
                }, n.prototype.clear = function (e) {
                  return this.store.clear(e);
                }, n.prototype.list = function (e) {
                  return this.store.ls(e);
                }, n.prototype.updateVersion = function (e, t) {
                  var n = this;
                  return this.store.findFileByPath(e).then(function (r) {
                    if (r) return n.saveStore(_i12(_i12({}, r), {
                      version: t
                    })).then(function () {});
                    throw new Error("the target path: " + e + " isn't existed");
                  });
                }, n.prototype.updateSourceURL = function (e, t) {
                  var n = this;
                  return this.store.findFileByPath(e).then(function (r) {
                    if (r) return n.saveStore(_i12(_i12({}, r), {
                      sourceURL: t
                    })).then(function () {});
                    throw new Error("the target path: " + e + " isn't existed");
                  });
                }, n;
              }(a);

              e.IResourceManager = I, Object.defineProperty(e, "__esModule", {
                value: !0
              });
            }(t, g_);
          }));

          function b_(e, t, n, r) {
            var i = r.meeting.userId,
                o = r.audio.localShareAudioUserMutedList,
                a = r.share.isReceiveSharingFromMainSession;
            return o.filter(function (e) {
              return e.userId !== t;
            }).forEach(function (t) {
              e.setSharingAudioVolume(t.userId, !0, t.isFromMainSession);
            }), e.setSharingAudioVolume(t, n, !!a), t === i ? Gc(n) : qc({
              userId: t,
              muted: n
            });
          }

          function y_(e, t, n) {
            var _t$audio = t.audio,
                r = _t$audio.audioSsrc,
                i = _t$audio.activeMicrophone,
                o = _t$audio.activeSpeaker,
                a = _t$audio.isAllowToTalk,
                s = _t$audio.isSpeakerOnly,
                _t$meeting3 = t.meeting,
                c = _t$meeting3.svcUrl,
                l = _t$meeting3.conId,
                d = _t$meeting3.reportDomain,
                u = _t$meeting3.isAudioBridgeEnabled,
                p = sc(t),
                h = s || ec(p.userRole) && !a,
                _ = null != n ? n : !h;

            return Uu() && !u && console.warn("Cannot start audio due to the service is not ready."), e.joinComputerAudio(r, i, o, _, Uu() ? {
              rwgHost: c,
              cid: l,
              nginxHost: d
            } : void 0);
          }

          function w_(_x7, _x8, _x9) {
            return _w_.apply(this, arguments);
          }

          function _w_() {
            _w_ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(e, t, n) {
              var r, _n$audio4, i, o, a;

              return _regeneratorRuntime.wrap(function _callee69$(_context69) {
                while (1) {
                  switch (_context69.prev = _context69.next) {
                    case 0:
                      r = [], _n$audio4 = n.audio, i = _n$audio4.isJoinComputerAudioBeforeSharingAudio, o = _n$audio4.mutedBeforeSharingAudio, a = sc(n);
                      _context69.t0 = !0 === i;

                      if (!_context69.t0) {
                        _context69.next = 8;
                        break;
                      }

                      _context69.next = 5;
                      return y_(e, n);

                    case 5:
                      r.push(Fc(void 0));
                      !1 === o && (r.push(kc(!0)), t.mute(a.userId, !1));
                      r.push(Hc(void 0));

                    case 8:
                      return _context69.abrupt("return", r);

                    case 9:
                    case "end":
                      return _context69.stop();
                  }
                }
              }, _callee69);
            }));
            return _w_.apply(this, arguments);
          }

          function S_(_x10, _x11, _x12) {
            return _S_.apply(this, arguments);
          }

          function _S_() {
            _S_ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(e, t, n) {
              var r, i, o, _r74;

              return _regeneratorRuntime.wrap(function _callee70$(_context70) {
                while (1) {
                  switch (_context70.prev = _context70.next) {
                    case 0:
                      r = n.audio.isSharingAudio, i = n.meeting.userId, o = [];

                      if (!(o.push(b_(e, i, !0, n)), r)) {
                        _context70.next = 9;
                        break;
                      }

                      _context70.next = 4;
                      return e.leaveSharingAudio(!1);

                    case 4:
                      o.push(Kc(!1));
                      _context70.next = 7;
                      return w_(e, t, n);

                    case 7:
                      _r74 = _context70.sent;
                      o.push.apply(o, _toConsumableArray(_r74)), setTimeout(function () {
                        As("SHARE_AUDIO_STATE_CHANGE", {
                          state: "off"
                        });
                      }, 0);

                    case 9:
                      return _context70.abrupt("return", (o.push(Wc(!1)), o));

                    case 10:
                    case "end":
                      return _context70.stop();
                  }
                }
              }, _callee70);
            }));
            return _S_.apply(this, arguments);
          }

          function x_(_x13, _x14, _x15) {
            return _x_.apply(this, arguments);
          }

          function _x_() {
            _x_ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(e, t, n) {
              var _n$audio5, r, i, o, a, s;

              return _regeneratorRuntime.wrap(function _callee72$(_context72) {
                while (1) {
                  switch (_context72.prev = _context72.next) {
                    case 0:
                      _n$audio5 = n.audio;
                      r = _n$audio5.audioSsrc;
                      i = _n$audio5.activeMicrophone;
                      o = _n$audio5.activeSpeaker;
                      a = sc(n);
                      _context72.next = 7;
                      return function () {
                        var _ref96 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(e, t) {
                          var n, r, i;
                          return _regeneratorRuntime.wrap(function _callee71$(_context71) {
                            while (1) {
                              switch (_context71.prev = _context71.next) {
                                case 0:
                                  n = [], r = sc(t), i = t.audio.isMicrophoneForbidden;
                                  _context71.t0 = "computer" === (null == r ? void 0 : r.audio);

                                  if (!_context71.t0) {
                                    _context71.next = 9;
                                    break;
                                  }

                                  n.push(Fc(!0));
                                  n.push(Hc(r.muted));
                                  _context71.next = 7;
                                  return e.leaveComputerAudio();

                                case 7:
                                  n.push(Rc(0));
                                  i && n.push(Oc(!1));

                                case 9:
                                  return _context71.abrupt("return", n);

                                case 10:
                                case "end":
                                  return _context71.stop();
                              }
                            }
                          }, _callee71);
                        }));

                        return function (_x74, _x75) {
                          return _ref96.apply(this, arguments);
                        };
                      }()(e, n);

                    case 7:
                      s = _context72.sent;
                      _context72.next = 10;
                      return e.leaveSharingAudio(!0);

                    case 10:
                      _context72.next = 12;
                      return e.joinSharingAudio({
                        ssrc: r,
                        microphoneDeviceId: i,
                        speakerDeviceId: o,
                        isCaptureAudio: ec(a.userRole)
                      });

                    case 12:
                      s.push(Wc(!0));
                      s.push(Kc(!0));
                      s.push(b_(e, a.userId, !1, n));
                      s.findIndex(function (e) {
                        return e.type === "".concat(Fc) && !0 === e.payload;
                      }) > -1 && (s.push(kc(!0)), t.mute(n.meeting.userId, !0), As("AUDIO_CURRENT_USER_MUTED", {
                        source: Na.SharingAudio
                      }));
                      setTimeout(function () {
                        As("SHARE_AUDIO_STATE_CHANGE", {
                          state: "on"
                        });
                      }, 0);
                      return _context72.abrupt("return", s);

                    case 18:
                    case "end":
                      return _context72.stop();
                  }
                }
              }, _callee72);
            }));
            return _x_.apply(this, arguments);
          }

          var E_ = function E_() {
            var e;
            var t = null === (e = So()) || void 0 === e ? void 0 : e.toLocaleLowerCase();

            if (t.indexOf("safari") > -1 && -1 === t.indexOf("ios-safari")) {
              var n;

              var _e102 = null === (n = navigator.userAgent.match(/version\/(\d+\.?\d+)/i)) || void 0 === n ? void 0 : n[1];

              return Si(_e102 || "", "15.2") >= 0;
            }

            return !1;
          },
              C_ = ua.createAgent(),
              k_ = Hu(ma.getInstance()),
              A_ = function A_(e) {
            return !e.muted;
          };

          var I_ = Object.freeze({
            __proto__: null,
            audioAsnsEpic: function audioAsnsEpic(e, t) {
              return Vr(e, 12033).pipe(ln(t), Me(function (e) {
                var _e103 = _slicedToArray(e, 2),
                    t = _e103[0],
                    n = _e103[1];

                var _n$participants2 = n.participants,
                    r = _n$participants2.attendeesList,
                    i = _n$participants2.allowTalkAttendeesList,
                    o = t.payload.body,
                    a = {};
                return o && ([].concat(_toConsumableArray(r), _toConsumableArray(i)).forEach(function (e) {
                  for (var _t34 = 1; _t34 <= 3; _t34++) {
                    var _n30 = "asn".concat(_t34),
                        _r23 = e.userId,
                        _i13 = e.displayName;

                    if (void 0 !== o[_n30] && _r23 === o[_n30]) {
                      a[_n30] = {
                        userId: _r23,
                        displayName: _i13
                      };
                      break;
                    }
                  }
                }), As("AUDIO_ACTIVE_SPEAKER", Object.values(a))), yc(a);
              }));
            },
            unmuteConsentAfterSpotlighted: function unmuteConsentAfterSpotlighted(e, t) {
              return Vr(e, 16135).pipe(ln(t), nn(function (e) {
                var _e104 = _slicedToArray(e, 2),
                    t = _e104[0],
                    n = _e104[1];

                var _t$payload$body4 = t.payload.body,
                    r = _t$payload$body4.id,
                    i = _t$payload$body4.bLeadershipOn,
                    o = n.audio.bCanUnmute,
                    a = sc(n);

                if (a) {
                  var _e105 = a.isHost,
                      _t35 = a.bCoHost,
                      _n31 = a.userId,
                      _s9 = a.audio,
                      _c4 = a.muted,
                      _l4 = _e105 || _t35;

                  i && _n31 >> 10 == r >> 10 && (null !== _s9 && "" !== _s9 && !0 !== _c4 || !_l4 && !o || As("AUDIO_UNMUTE_CONSENT", Ra.Spotlight));
                }
              }), qt(ce));
            },
            unmuteConsentEpic: function unmuteConsentEpic(e, t) {
              return Vr(e, 12037).pipe(ln(t), nn(function (e) {
                var _e106 = _slicedToArray(e, 2),
                    t = _e106[1];

                var n = sc(t);
                null !== (null == n ? void 0 : n.audio) && "" !== (null == n ? void 0 : n.audio) && 1 == (null == n ? void 0 : n.muted) && As("AUDIO_UNMUTE_CONSENT", Ra.Unmute);
              }), qt(ce));
            },
            setAudioAttributeEpic: function setAudioAttributeEpic(e, t) {
              return Vr(e, 7938).pipe(pt(function (e) {
                return e.payload.body && ["bCanUnmute", "bMutedAll", "bMutedUponEntry"].some(function (t) {
                  return void 0 !== e.payload.body[t];
                });
              }), fu(function (e) {
                if (void 0 !== e.payload.body.bCanUnmute) return wc(e.payload.body.bCanUnmute);

                if (void 0 !== e.payload.body.bMutedAll) {
                  var _n32 = sc(t.value);

                  if (("computer" === (null == _n32 ? void 0 : _n32.audio) || "phone" === (null == _n32 ? void 0 : _n32.audio)) && 0 == _n32.muted) return Cc(e.payload.body.bMutedAll);
                }

                return void 0 !== e.payload.body.bMutedUponEntry ? Ic(e.payload.body.bMutedUponEntry) : void 0;
              }));
            },
            currentUserAudioChangeEpic: function currentUserAudioChangeEpic(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e107 = _slicedToArray(e, 2),
                    t = _e107[1];

                return t.socket.zoomSocketStatus === bc.Connected;
              }), Je(function (e) {
                var _e108 = _slicedToArray(e, 2),
                    t = _e108[0],
                    n = _e108[1];

                if (t.payload.body.update && t.payload.body.update.some(function (e) {
                  return void 0 !== e.audio || void 0 !== e.muted;
                })) {
                  var _e109 = n.meeting.userId,
                      _r24 = t.payload.body.update,
                      _ft3 = ft(Ke(_r24), function (t) {
                    return t.id === _e109;
                  }),
                      _ft4 = _slicedToArray(_ft3, 2),
                      _i14 = _ft4[0],
                      _o10 = _ft4[1];

                  _o10.subscribe(function (e) {
                    As("AUDIO_PARTICIPANT_AUDIO_UPDATE", e);
                  });

                  var _n$audio = n.audio,
                      _a9 = _n$audio.isActiveOperation,
                      _s10 = _n$audio.isMutedAll,
                      _c5 = _n$audio.isSpeakerOnly,
                      _l5 = _n$audio.isAllowToTalk,
                      _d4 = _n$audio.isShareAudioEnabled,
                      _u4 = _n$audio.isSharingAudio;

                  var _p4 = sc(n);

                  !_p4 && t.payload.body.add && t.payload.body.add.length > 0 && (_p4 = t.payload.body.add.find(function (t) {
                    return t.id === _e109;
                  }), _p4 && (_p4.userRole = _p4.role));

                  var _h4 = ec(_p4.userRole);

                  return _i14.pipe(nn( /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
                      var t, n, r, i, _e110, o, _e111;

                      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              if (!(e.audio !== (null === (t = _p4) || void 0 === t ? void 0 : t.audio))) {
                                _context6.next = 17;
                                break;
                              }

                              if (!("" === e.audio)) {
                                _context6.next = 5;
                                break;
                              }

                              As("AUDIO_CURRENT_USER_LEAVE_AUDIO");
                              _context6.next = 17;
                              break;

                            case 5:
                              if (!("computer" === e.audio)) {
                                _context6.next = 10;
                                break;
                              }

                              _e110 = _h4 && !_l5 || _c5;
                              _u4 && As("AUDIO_CURRENT_USER_JOIN_BY_VOIP"), _e110 && As("AUDIO_CURRENT_USER_JOIN_BY_VOIP");
                              _context6.next = 17;
                              break;

                            case 10:
                              if (!("phone" === e.audio)) {
                                _context6.next = 17;
                                break;
                              }

                              _context6.t0 = "computer" === (null === (o = _p4) || void 0 === o ? void 0 : o.audio);

                              if (!_context6.t0) {
                                _context6.next = 16;
                                break;
                              }

                              _context6.next = 15;
                              return k_.leaveComputerAudio();

                            case 15:
                              C_.joinOrLeaveVoip(!1);

                            case 16:
                              As("AUDIO_CURRENT_USER_JOIN_BY_PHONE");

                            case 17:
                              if (null !== (n = _p4) && void 0 !== n && n.audio && "" !== (null === (r = _p4) || void 0 === r ? void 0 : r.audio) && e.muted !== (null === (i = _p4) || void 0 === i ? void 0 : i.muted)) if (!0 === e.muted) {
                                _e111 = _a9 ? Na.Active : _s10 ? Na.PassiveByMuteAll : Na.PassiveByMuteOne;
                                As("AUDIO_CURRENT_USER_MUTED", {
                                  source: _e111
                                }), _d4 || k_.muteAudio();
                              } else !1 === e.muted && (As("AUDIO_CURRENT_USER_UNMUTED", {
                                source: _a9 ? "active" : "passive"
                              }), k_.unmuteAudio());

                            case 18:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    return function (_x16) {
                      return _ref5.apply(this, arguments);
                    };
                  }()), pt(function (e) {
                    var t, n;
                    return "" !== (null === (t = _p4) || void 0 === t ? void 0 : t.audio) && e.muted !== (null === (n = _p4) || void 0 === n ? void 0 : n.muted);
                  }), qt(fe(kc(!1), Cc(!1))));
                }

                return ce;
              }));
            },
            handleDialOutEpic: function handleDialOutEpic(e, t) {
              return Vr(e, 8198).pipe(ln(t), pt(function (e) {
                var _e112 = _slicedToArray(e, 2),
                    t = _e112[0],
                    n = _e112[1];

                return t.payload.seq == n.audio.dialout.sequence;
              }), nn(function (e) {
                var _e113 = _slicedToArray(e, 1),
                    t = _e113[0];

                var n = t.payload.body.result;
                As("AUDIO_DIALOUT_RESULT_CODE", {
                  code: n
                }), n === ja.Success ? As("AUDIO_DIALOUT_RESULT_SUCCESS") : -1 === [ja.Calling, ja.Ringing, ja.Accepted, ja.Success].indexOf(n) && As("DIALOUT_FAIL");
              }), Me(function (e) {
                var _e114 = _slicedToArray(e, 1),
                    t = _e114[0];

                return xc(t.payload.body.result);
              }));
            },
            handleDialouCancelEpic: function handleDialouCancelEpic(e) {
              return Vr(e, 8198).pipe(pt(function (e) {
                var t;
                return [ja.Canceling, ja.Canceled, ja.CancelFailed].includes(null === (t = e.payload.body) || void 0 === t ? void 0 : t.result);
              }), nn(function (e) {
                var t;
                var n = null === (t = e.payload.body) || void 0 === t ? void 0 : t.result;
                As("AUDIO_DIALOUT_RESULT_CODE", {
                  code: n
                }), n === ja.Canceled ? As("AUDIO_DIALOUT_CANCEL_SUCCESS") : n === ja.CancelFailed && As("DIALOUT_CANCEL_FAIL");
              }), Me(function (e) {
                return xc(e.payload.body.result);
              }));
            },
            handleAllowToTalkEpic: function handleAllowToTalkEpic(e, t) {
              return Vr(e, 12036).pipe(ln(t), Je(function (e) {
                var _e115 = _slicedToArray(e, 2),
                    t = _e115[0],
                    n = _e115[1];

                var r = sc(n),
                    i = n.media.audioEncodeStatus,
                    _t$payload$body5 = t.payload.body,
                    o = _t$payload$body5.promoterID,
                    a = _t$payload$body5.bAllowTalk;

                if ((null == r ? void 0 : r.userId) === o) {
                  if (As("AUDIO_ALLOW_TALK_CHANGE", a), a) {
                    var _e116 = fe(!0);

                    return "success" !== i && (k_.enableAudioEncode(), _e116 = mt(Os("AUDIO_ENCODE_SUCCESS", 1).pipe(Mt(!0)), Os("AUDIO_ENCODE_FAIL", 1).pipe(Mt(!1)))), _e116.pipe(Je(function (e) {
                      return e && As("AUDIO_UNMUTE_CONSENT", Ra.AllowToTalk), ce;
                    }), Gt(Ec(!0)));
                  }

                  if (C_.mute(o, !0), "computer" === (null == r ? void 0 : r.audio)) return k_.leaveComputerAudio(), bt(300).pipe(nn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            (E_() ? mt(ot(document, "click").pipe(Nt(1)), ot(document, "touchend").pipe(Nt(1))).toPromise() : Promise.resolve(!0)).then(function () {
                              y_(k_, n, !1);
                            });

                          case 1:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }))), qt(ce), Gt(Ec(!1)));
                }

                return ce;
              }));
            },
            handleAllowToTalkResponseEpic: function handleAllowToTalkResponseEpic(e) {
              return Vr(e, 8205).pipe(nn(function (e) {
                As("AUDIO_ALLOW_TO_TALK_RESPONSE", e.payload.body);
              }), qt(ce));
            },
            handleAttendeePromoteDepromote: function handleAttendeePromoteDepromote(e, t) {
              return Fr(e, 24597).pipe(ln(t), nn(function (e) {
                var _e117 = _slicedToArray(e, 2),
                    t = _e117[0],
                    n = _e117[1];

                var r = sc(n);
                "phone" === (null == r ? void 0 : r.audio) ? C_.audioDrop(r.userId) : "computer" === (null == r ? void 0 : r.audio) && t.payload.body.bPromote;
              }), qt(ce));
            },
            setAudioSSRCEpic: function setAudioSSRCEpic(e, t) {
              return Vr(e, 12035).pipe(ln(t), Je(function (e) {
                var _e118 = _slicedToArray(e, 2),
                    n = _e118[0],
                    r = _e118[1];

                var i = r.meeting.currentUserAudioBeforeReset,
                    _r$media2 = r.media,
                    o = _r$media2.audioDecodeStatus,
                    a = _r$media2.audioEncodeStatus,
                    s = n.payload.body.ssrc,
                    c = Pu(t).pipe(Je(function (e) {
                  if ("computer" === i && (null == e || !e.audio)) {
                    var _n33 = ec(e.userRole);

                    return Nu("audio", _n33 ? "success" : a, o).pipe(pt(function (e) {
                      var _e119 = _slicedToArray(e, 2),
                          t = _e119[0],
                          n = _e119[1];

                      return t && n;
                    }), nn(function () {
                      (E_() ? mt(ot(document, "click").pipe(Nt(1)), ot(document, "touchend").pipe(Nt(1))).toPromise() : Promise.resolve(!0)).then(function () {
                        C_.joinOrLeaveVoip(!0), y_(k_, t.value);
                      });
                      var e = t.value.audio.locallyMutedAudioList;
                      e.length > 0 && e.forEach(function (e) {
                        k_.muteOrUnmuteOtherAudio(e, !0);
                      });
                    }), Mt(Yi(void 0)));
                  }

                  return ce;
                }));
                return dt(fe(Ac(s)), c);
              }));
            },
            handleMergeAudioEpic: function handleMergeAudioEpic(e, t) {
              return Vr(e, 7952).pipe(Yt(function (e) {
                return Os("AUDIO_CURRENT_USER_JOIN_BY_PHONE", 1).pipe(ln(t), nn(function (t) {
                  var _t36 = _slicedToArray(t, 2),
                      n = _t36[1];

                  var _e$payload$body5 = e.payload.body,
                      r = _e$payload$body5.BindStatus,
                      i = _e$payload$body5.nOperatorUserId,
                      o = n.participants.attendeesList.find(function (e) {
                    return e.userId === i;
                  });
                  !0 === r && As("AUDIO_MERGE_AUDIO_INDICATION", {
                    operatorName: null == o ? void 0 : o.displayName,
                    operatorUserId: i,
                    operatorRole: null == o ? void 0 : o.userRole
                  });
                }));
              }));
            },
            handleUserGrantAudioCaptureEpic: function handleUserGrantAudioCaptureEpic(e, t) {
              return Gr(e, Ta.UserGrantCaptureAudio).pipe(ln(t), Je(function (e) {
                var _e120 = _slicedToArray(e, 2),
                    t = _e120[1];

                As("AUDIO_CURRENT_USER_JOIN_BY_VOIP");
                var n = sc(t),
                    r = t.meeting.isCurrentUserMutedBeforeReset,
                    _t$audio2 = t.audio,
                    i = _t$audio2.bMutedUponEntry,
                    o = _t$audio2.isUserGrantCaptureAudio,
                    a = _t$audio2.isAllowToTalk,
                    s = [Tc(!0)];

                if (n) {
                  !0 === n.muted && !1 === a && C_.mute(n.userId, !0);

                  var _e121 = o || n.isHost || a;

                  (!0 === r || !_e121 && i) && (C_.mute(n.userId, !0), r && s.push(Ji(void 0)));
                }

                return Ke(s);
              }));
            },
            handleUserForbiddenMicrophoneEpic: function handleUserForbiddenMicrophoneEpic(e) {
              return Gr(e, Ta.UserForbiddedCaptureAudio).pipe(nn(function () {
                As("USER_FORBIDDEN_MICROPHONE");
              }), Mt(Oc(!0)));
            },
            handleAudioSocketErrorEpic: function handleAudioSocketErrorEpic(e) {
              return Gr(e, Ta.AudioWebsocketBroken).pipe(nn(function () {
                As("ESTABLISH_AUDIO_STREAM_ERROR");
              }), qt(ce));
            },
            handleAudioZeroDataEpic: function handleAudioZeroDataEpic(e, t) {
              return Gr(e, Ta.AudioZeroData).pipe(ln(t), fu(function (e) {
                var _e122 = _slicedToArray(e, 2),
                    t = _e122[1];

                var _t$audio3 = t.audio,
                    n = _t$audio3.webrtcRestartCount,
                    r = _t$audio3.activeMicrophone;
                if (n < 3) return k_.restoreWebRTC(r), Rc(n + 1);
              }));
            },
            handleAutoPlayEpic: function handleAutoPlayEpic(e, t) {
              return e.pipe(fn("".concat(zc)), pt(function (e) {
                return !1 === e.payload;
              }), Je(function () {
                return As("AUDIO_AUTO_PLAY_FAILED"), mt(ot(document, "click").pipe(Nt(1)), ot(document, "touchend").pipe(Nt(1))).pipe(nn(function () {
                  C_.joinOrLeaveVoip(!0), y_(k_, t.value);
                }), Mt(zc(!0)));
              }));
            },
            handleAudioActionCompleteEpic: function handleAudioActionCompleteEpic(e) {
              return Gr(e, [Ta.JoinComputerAudioComplete, Ta.JoinSharingAudioComplete, Ta.LeaveComputerAudioComplete, Ta.LeaveSharingAudioComplete]).pipe(nn(function () {
                Bu.completeAudioAction();
              }), qt(ce));
            },
            handleAudioQosDataEpic: function handleAudioQosDataEpic(e, t) {
              return Gr(e, Ta.audioQosData).pipe(ln(t), Me(function (e) {
                var _e123 = _slicedToArray(e, 2),
                    t = _e123[0],
                    n = _e123[1];

                var r = n.meeting.isWebinar,
                    _n$media2 = n.media,
                    i = _n$media2.audioEncodeStatus,
                    o = _n$media2.audioDecodeStatus,
                    _n$participants3 = n.participants,
                    a = _n$participants3.xmppAttendeeList,
                    s = _n$participants3.allowTalkAttendeesList,
                    c = sc(n),
                    l = mc(n);
                var d = l.length > 0,
                    u = l.some(A_);
                r && (d = d || Boolean(a.length), u = u || s.some(A_));
                var p = ("computer" === (null == c ? void 0 : c.audio) || "phone" === (null == c ? void 0 : c.audio)) && i && !(null != c && c.muted) && d,
                    h = ("computer" === (null == c ? void 0 : c.audio) || "phone" === (null == c ? void 0 : c.audio)) && o && d && u;
                return t.payload.data.encoding ? p ? (As("AUDIO_STATISTIC_DATA", t.payload), Qc(t.payload)) : Qc($a) : h ? (As("AUDIO_STATISTIC_DATA", t.payload), Zc(t.payload)) : Zc($a);
              }));
            },
            handleResetLocalMuteStateAfterUserLeaveEpic: function handleResetLocalMuteStateAfterUserLeaveEpic(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e124 = _slicedToArray(e, 2),
                    t = _e124[0],
                    n = _e124[1];

                var r = t.payload.body,
                    i = n.audio.locallyMutedAudioList;
                return i.length > 0 && (null == r ? void 0 : r.remove) && r.remove.length > 0;
              }), Je(function (e) {
                var _e125 = _slicedToArray(e, 2),
                    t = _e125[0],
                    n = _e125[1];

                var r = t.payload.body.remove,
                    i = n.audio.locallyMutedAudioList,
                    o = i.filter(function (e) {
                  return -1 !== r.indexOf(function (t) {
                    return t.id === e;
                  });
                });
                return o.length > 0 ? (o.forEach(function (e) {
                  k_.muteOrUnmuteOtherAudio(e, !1);
                }), Ke(o.map(function (e) {
                  return Jc(e);
                }))) : ce;
              }));
            }
          });
          var T_ = ua.createAgent(),
              O_ = Hu(ma.getInstance());
          var R_ = Object.freeze({
            __proto__: null,
            handleAddLocalShareAudioUserEpic: function handleAddLocalShareAudioUserEpic(e, t) {
              return Wr(e, 7937).pipe(pt(function (e) {
                var t = e.payload.body.update;
                return t && t.length > 0 && t.findIndex(function (e) {
                  return void 0 !== e.bShareOn;
                }) > -1;
              }), ln(t), Je(function (e) {
                var _e126 = _slicedToArray(e, 2),
                    t = _e126[0],
                    n = _e126[1];

                var r = t.payload.body.update,
                    i = n.audio.localShareAudioUserMutedList,
                    o = r.filter(function (e) {
                  return !0 === e.bShareOn && !0 === e.bShareAudioOn;
                }),
                    a = [];
                return o.length > 0 && o.forEach(function (e) {
                  -1 === i.findIndex(function (t) {
                    return t.userId === e.id;
                  }) && a.push(Vc({
                    userId: e.id,
                    isFromMainSession: !!e.bShareToBORooms
                  }));
                }), Ke(a);
              }));
            },
            handleShareWithAudioEpic: function handleShareWithAudioEpic(e, t) {
              return Gr(e, Ta.SharingDesktopStreamHaveAudio).pipe(Yt(function () {
                return Vr(e, 7937).pipe(pt(function (e) {
                  var n;
                  var r = e.payload.body,
                      i = t.value.meeting.userId;
                  return (null == r || null === (n = r.update) || void 0 === n ? void 0 : n.findIndex(function (e) {
                    return e.id === i && !0 === e.bShareOn;
                  })) > -1;
                }), Nt(1), vu( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                  var e;
                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          e = t.value;
                          _context8.next = 3;
                          return x_(O_, T_, e);

                        case 3:
                          return _context8.abrupt("return", _context8.sent);

                        case 4:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }))), Gt(Wc(!0)));
              }));
            },
            handleMediaSDKLeaveShareAudioEpic: function handleMediaSDKLeaveShareAudioEpic(e, t) {
              return Gr(e, Ta.SharingDesktopStreamHaveNoAudio).pipe(ln(t), pt(function (e) {
                var t;

                var _e127 = _slicedToArray(e, 2),
                    n = _e127[1];

                return !0 === (null === (t = n.audio) || void 0 === t ? void 0 : t.isShareAudioEnabled);
              }), vu( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
                  var _e128, t;

                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _e128 = _slicedToArray(e, 2), t = _e128[1];
                          _context9.next = 3;
                          return S_(O_, T_, t);

                        case 3:
                          return _context9.abrupt("return", _context9.sent);

                        case 4:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));

                return function (_x17) {
                  return _ref8.apply(this, arguments);
                };
              }()));
            },
            handleJoinComputerAudioAfterShareAudioEpic: function handleJoinComputerAudioAfterShareAudioEpic(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e129 = _slicedToArray(e, 2),
                    t = _e129[1];

                return t.socket.zoomSocketStatus === bc.Connected && !0 === t.audio.isSharingAudio;
              }), Je(function (e) {
                var n;

                var _e130 = _slicedToArray(e, 2),
                    r = _e130[0],
                    i = _e130[1];

                if (null !== (n = r.payload.body.update) && void 0 !== n && n.some(function (e) {
                  return void 0 !== e.audio || void 0 !== e.muted;
                })) {
                  var _e131 = i.meeting.userId,
                      _n34 = r.payload.body.update.filter(function (t) {
                    return t.id === _e131;
                  });

                  return Pu(t).pipe(Je(function (e) {
                    var t = [];
                    return _n34.findIndex(function (e) {
                      return "computer" === e.audio;
                    }) > -1 && "computer" !== (null == e ? void 0 : e.audio) && (t.push(Fc(!0)), t.push(Hc(!0))), Ke(t);
                  }));
                }

                return ce;
              }));
            },
            handleShareAudioWithCurrentShareStatusChangeEpic: function handleShareAudioWithCurrentShareStatusChangeEpic(e, t) {
              return e.pipe(fn("".concat(il)), be(Ne), ln(t), pt(function (e) {
                var t;

                var _e132 = _slicedToArray(e, 2),
                    n = _e132[1];

                return !0 === (null === (t = n.audio) || void 0 === t ? void 0 : t.isShareAudioEnabled);
              }), vu( /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
                  var _e133, t, n, r, _n$audio2, i, o, a, _e134, _e135, _e136;

                  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _e133 = _slicedToArray(e, 2), t = _e133[0], n = _e133[1];
                          r = t.payload, _n$audio2 = n.audio, i = _n$audio2.isShareAudioMuted, o = _n$audio2.isSharingAudio, a = [];

                          if (!(r === Ua.End)) {
                            _context10.next = 9;
                            break;
                          }

                          _context10.next = 5;
                          return S_(O_, T_, n);

                        case 5:
                          _e134 = _context10.sent;
                          a.push.apply(a, _toConsumableArray(_e134));
                          _context10.next = 25;
                          break;

                        case 9:
                          if (!(r === Ua.Paused)) {
                            _context10.next = 20;
                            break;
                          }

                          if (!(!1 === i && !0 === o)) {
                            _context10.next = 18;
                            break;
                          }

                          _context10.next = 13;
                          return O_.leaveSharingAudio(!0);

                        case 13:
                          a.push(Kc(!1));
                          _context10.next = 16;
                          return w_(O_, T_, n);

                        case 16:
                          _e135 = _context10.sent;
                          a.push.apply(a, _toConsumableArray(_e135)), setTimeout(function () {
                            As("SHARE_AUDIO_STATE_CHANGE", {
                              state: "off"
                            });
                          }, 0);

                        case 18:
                          _context10.next = 25;
                          break;

                        case 20:
                          if (!(r === Ua.Sharing && !1 === i && !1 === o)) {
                            _context10.next = 25;
                            break;
                          }

                          _context10.next = 23;
                          return x_(O_, T_, n);

                        case 23:
                          _e136 = _context10.sent;
                          a.push.apply(a, _toConsumableArray(_e136));

                        case 25:
                          return _context10.abrupt("return", a);

                        case 26:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                }));

                return function (_x18) {
                  return _ref9.apply(this, arguments);
                };
              }()));
            }
          });
          var N_ = ua.createAgent(),
              P_ = ma.getInstance();
          var j_ = Object.freeze({
            __proto__: null,
            handleAudioBridgeTokenEpic: function handleAudioBridgeTokenEpic(e) {
              return Vr(e, 4299).pipe(nn(function (e) {
                var t = e.payload;
                P_.passThroughRWGMessage(t);
              }), qt(ce));
            },
            handleAudioBridgeReconnectEpic: function handleAudioBridgeReconnectEpic(e) {
              return Gr(e, Ta.AudioBridgeReconnectStart).pipe(nn(function () {
                N_.joinOrLeaveVoip(!1);
              }), qt(ce));
            },
            handleAudioBridgeReconnectSuccessEpic: function handleAudioBridgeReconnectSuccessEpic(e) {
              return Gr(e, Ta.AudioBridgeReconnectEnd).pipe(nn(function () {
                N_.joinOrLeaveVoip(!0);
              }), qt(ce));
            },
            handleSendNodeAudioStatusEpic: function handleSendNodeAudioStatusEpic(e) {
              return Vr(e, 7937).pipe(pt(function (e) {
                var t, n;
                return Uu() && ((null === (t = e.payload.body.update) || void 0 === t ? void 0 : t.some(function (e) {
                  return void 0 !== e.muted;
                })) || (null === (n = e.payload.body.remove) || void 0 === n ? void 0 : n.length) > 0);
              }), nn(function (e) {
                var _e$payload$body6 = e.payload.body,
                    t = _e$payload$body6.update,
                    n = _e$payload$body6.remove;
                P_.sendUserAudioStatus({
                  update: (t || []).filter(function (e) {
                    return void 0 !== e.muted;
                  }).map(function (e) {
                    return {
                      userId: e.id,
                      muted: e.muted
                    };
                  }),
                  remove: (n || []).map(function (e) {
                    return {
                      userId: e.id
                    };
                  })
                });
              }), qt(ce));
            },
            handleAudioBridgeFailoverEpic: function handleAudioBridgeFailoverEpic(e) {
              return Gr(e, Ta.NotifyUIFailover).pipe(Me(function () {
                return As("RECONNECTING_MEETING", {
                  reason: ho.Failover
                }), Ri();
              }));
            }
          });

          var D_ = {
            asnIds: {
              asn1: {
                userId: 0,
                displayName: null
              },
              asn2: {
                userId: 0,
                displayName: null
              },
              asn3: {
                userId: 0,
                displayName: null
              }
            },
            microphoneDevicesList: [],
            speakerDevicesList: [],
            activeMicrophone: "default",
            activeSpeaker: "default",
            isMicrophoneForbidden: !1,
            audioSsrc: 0,
            bCanUnmute: !1,
            bMutedUponEntry: !1,
            isAllowToTalk: void 0,
            dialout: {
              sequence: 0,
              returnCode: -1
            },
            canPlayAudio: !1,
            isActiveOperation: !1,
            isMutedAll: !1,
            isUserGrantCaptureAudio: !1,
            webrtcRestartCount: 0,
            isComputerAudioLoading: !1,
            isSpeakerOnly: !1,
            localShareAudioUserMutedList: [],
            locallyMutedAudioList: [],
            statistic: {
              encode: {
                sample_rate: 0,
                rtt: 0,
                jitter: 0,
                avg_loss: 0,
                max_loss: 0
              },
              decode: {
                sample_rate: 0,
                rtt: 0,
                jitter: 0,
                avg_loss: 0,
                max_loss: 0
              }
            }
          },
              z_ = ur((_ur6 = {}, _defineProperty(_ur6, "".concat(yc), Hp(function (e, t) {
            var n = t.payload;
            e.asnIds = f({}, n);
          })), _defineProperty(_ur6, "".concat(wc), Hp(function (e, t) {
            var n = t.payload;
            e.bCanUnmute = n;
          })), _defineProperty(_ur6, "".concat(Sc), Hp(function (e, t) {
            var n = t.payload;
            var r = e.dialout;
            r.sequence = n;
          })), _defineProperty(_ur6, "".concat(xc), Hp(function (e, t) {
            var n = t.payload;
            var r = e.dialout;
            r.returnCode = n;
          })), _defineProperty(_ur6, "".concat(Ec), Hp(function (e, t) {
            var n = t.payload;
            e.isAllowToTalk = n, e.isAllowToTalkAttendeeConnected = !1;
          })), _defineProperty(_ur6, "".concat(kc), Hp(function (e, t) {
            var n = t.payload;
            e.isActiveOperation = n;
          })), _defineProperty(_ur6, "".concat(Cc), Hp(function (e, t) {
            var n = t.payload;
            e.isMutedAll = n;
          })), _defineProperty(_ur6, "".concat(Ac), Hp(function (e, t) {
            var n = t.payload;
            e.audioSsrc = n;
          })), _defineProperty(_ur6, "".concat(Ic), Hp(function (e, t) {
            var n = t.payload;
            e.bMutedUponEntry = n;
          })), _defineProperty(_ur6, "".concat(Tc), Hp(function (e, t) {
            var n = t.payload;
            e.isUserGrantCaptureAudio = n;
          })), _defineProperty(_ur6, "".concat(Oc), Hp(function (e, t) {
            var n = t.payload;
            e.isMicrophoneForbidden = n;
          })), _defineProperty(_ur6, "".concat(Rc), Hp(function (e, t) {
            var n = t.payload;
            e.webrtcRestartCount = n;
          })), _defineProperty(_ur6, "".concat(Nc), Hp(function (e, t) {
            var n = t.payload;
            e.microphoneDevicesList = n;
          })), _defineProperty(_ur6, "".concat(Pc), Hp(function (e, t) {
            var n = t.payload;
            e.speakerDevicesList = n;
          })), _defineProperty(_ur6, "".concat(jc), Hp(function (e, t) {
            var n = t.payload;
            e.activeMicrophone = n;
          })), _defineProperty(_ur6, "".concat(Dc), Hp(function (e, t) {
            var n = t.payload;
            e.activeSpeaker = n;
          })), _defineProperty(_ur6, "".concat(zc), Hp(function (e, t) {
            var n = t.payload;
            e.canPlayAudio = n;
          })), _defineProperty(_ur6, "".concat(Mc), function (e, t) {
            var n = e.dialout.returnCode,
                r = e.locallyMutedAudioList,
                i = t.payload;
            return i ? f(f({}, D_), {}, {
              dialout: f(f({}, D_.dialout), {}, {
                returnCode: n
              }),
              locallyMutedAudioList: r
            }) : f({}, D_);
          }), _defineProperty(_ur6, "".concat(Lc), Hp(function (e, t) {
            var n = t.payload;
            e.isComputerAudioLoading = n;
          })), _defineProperty(_ur6, "".concat(Uc), Hp(function (e, t) {
            var n = t.payload;
            e.isSpeakerOnly = n;
          })), _defineProperty(_ur6, "".concat(Bc), Hp(function (e, t) {
            var n = t.payload;
            e.isAllowToTalkAttendeeConnected = n;
          })), _defineProperty(_ur6, "".concat(Hc), Hp(function (e, t) {
            var n = t.payload;
            e.mutedBeforeSharingAudio = n;
          })), _defineProperty(_ur6, "".concat(Kc), Hp(function (e, t) {
            var n = t.payload;
            e.isSharingAudio = n;
          })), _defineProperty(_ur6, "".concat(Gc), Hp(function (e, t) {
            var n = t.payload;
            e.isShareAudioMuted = n;
          })), _defineProperty(_ur6, "".concat(Vc), Hp(function (e, t) {
            var n = t.payload;
            var r = n.userId,
                i = n.isFromMainSession;
            -1 === e.localShareAudioUserMutedList.findIndex(function (e) {
              return e.userId === r;
            }) && e.localShareAudioUserMutedList.push({
              userId: r,
              isFromMainSession: i,
              muted: !1
            });
          })), _defineProperty(_ur6, "".concat(qc), Hp(function (e, t) {
            var n = t.payload;
            var r = e.localShareAudioUserMutedList.find(function (e) {
              return e.userId === n.userId;
            });
            r && (r.muted = n.muted);
          })), _defineProperty(_ur6, "".concat(Fc), Hp(function (e, t) {
            var n = t.payload;
            e.isJoinComputerAudioBeforeSharingAudio = n;
          })), _defineProperty(_ur6, "".concat(Wc), Hp(function (e, t) {
            var n = t.payload;
            e.isShareAudioEnabled = n;
          })), _defineProperty(_ur6, "".concat(Qc), Hp(function (e, t) {
            var n = t.payload;
            e.statistic.encode = n.data;
          })), _defineProperty(_ur6, "".concat(Zc), Hp(function (e, t) {
            var n = t.payload;
            e.statistic.decode = n.data;
          })), _defineProperty(_ur6, "".concat(Yc), Hp(function (e, t) {
            var n = t.payload;
            -1 === e.locallyMutedAudioList.findIndex(function (e) {
              return e === n;
            }) && e.locallyMutedAudioList.push(n);
          })), _defineProperty(_ur6, "".concat(Jc), Hp(function (e, t) {
            var n = t.payload;
            var r = e.locallyMutedAudioList.findIndex(function (e) {
              return e === n;
            });
            -1 !== r && e.locallyMutedAudioList.splice(r, 1);
          })), _ur6), D_),
              M_ = Hr(I_, R_, j_),
              L_ = function L_(e) {
            return 4294966272 & e;
          },
              U_ = function U_(e) {
            var t = {
              R: 0,
              G: 0,
              B: 0,
              A: 0
            };

            if ("string" == typeof e && e.startsWith("#")) {
              var _s11 = e.slice(1);

              try {
                if (3 === _s11.length) {
                  var _e137 = Array.from(_s11).map(function (e) {
                    return e.repeat(2);
                  }).map(function (e) {
                    return parseInt(e, 16);
                  });

                  t = {
                    R: _e137[0] / 255,
                    G: _e137[1] / 255,
                    B: _e137[2] / 255,
                    A: 1
                  };
                } else if (6 === _s11.length || 8 === _s11.length) {
                  var n, r, i, o, a;

                  var _e138 = null === (n = _s11.match(/\S{2}/g)) || void 0 === n ? void 0 : n.map(function (e) {
                    return parseInt(e, 16);
                  });

                  t = {
                    R: (null !== (r = null == _e138 ? void 0 : _e138[0]) && void 0 !== r ? r : 0) / 255,
                    G: (null !== (i = null == _e138 ? void 0 : _e138[1]) && void 0 !== i ? i : 0) / 255,
                    B: (null !== (o = null == _e138 ? void 0 : _e138[2]) && void 0 !== o ? o : 0) / 255,
                    A: null != _e138 && _e138[3] ? (null !== (a = null == _e138 ? void 0 : _e138[3]) && void 0 !== a ? a : 0) / 255 : 1
                  };
                }
              } catch (t) {
                console.warn("error color representation:", e);
              }
            } else "object" == typeof e && (t = {
              R: e.R / 255,
              G: e.G / 255,
              B: e.B / 255,
              A: e.A || 1
            });

            return t;
          };

          function B_(e) {
            return void 0 !== e ? Ke(Promise.resolve(e)) : Os("VIDEO_VIRTUAL_BACKGROUND_PRELOAD_READY", 1).pipe(Me(function (e) {
              return e;
            }));
          }

          function H_(_x19, _x20, _x21) {
            return _H_.apply(this, arguments);
          }

          function _H_() {
            _H_ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(e, t, n) {
              var r, _t164, _e318, i, o;

              return _regeneratorRuntime.wrap(function _callee73$(_context73) {
                while (1) {
                  switch (_context73.prev = _context73.next) {
                    case 0:
                      if (!("blur" === e)) {
                        _context73.next = 2;
                        break;
                      }

                      return _context73.abrupt("return", "blur");

                    case 2:
                      r = e;

                      if (!t) {
                        _context73.next = 8;
                        break;
                      }

                      _context73.next = 6;
                      return function (e) {
                        return new Promise(function (t, n) {
                          try {
                            var _n107 = document.createElement("canvas"),
                                _r75 = _n107.getContext("2d"),
                                i = new Image();

                            i.src = e;

                            var o = 16 / 9,
                                _a22 = 1280,
                                _s26 = Math.floor(_a22 / o);

                            _n107.width = _a22, _n107.height = _s26, i.onload = function () {
                              var e = i.width,
                                  c = i.height,
                                  l = c * o;

                              if (l > _a22) {
                                var _t165 = e,
                                    _n108 = Math.floor(e / o),
                                    _l13 = 0,
                                    _d12 = (c - _n108) / 2;

                                null == _r75 || _r75.drawImage(i, _l13, _d12, _t165, _n108, 0, 0, _a22, _s26);
                              } else {
                                var _t166 = l,
                                    _n109 = c,
                                    _o21 = (e - _t166) / 2,
                                    _d13 = 0;

                                null == _r75 || _r75.drawImage(i, _o21, _d13, _t166, _n109, 0, 0, _a22, _s26);
                              }

                              _n107.toBlob(function (e) {
                                t(e);
                              });
                            };
                          } catch (e) {
                            e instanceof DOMException && e.code === DOMException.SECURITY_ERR && console.error("Image is not from the same origin, add CORS header to solve this issue"), n(e);
                          }
                        });
                      }(e);

                    case 6:
                      _t164 = _context73.sent;
                      r = URL.createObjectURL(_t164);

                    case 8:
                      if (!r) {
                        _context73.next = 11;
                        break;
                      }

                      _e318 = Math.floor(100 * Math.random()), i = "".concat("__ZOOM_SDK_VIRTUAL_BACKGROUND_IMAGE_@__").concat(_e318), o = document.createElement("img");
                      return _context73.abrupt("return", (o.src = r, o.id = i, o.style.display = "none", o.onload = function () {
                        t && URL.revokeObjectURL(r);
                      }, o.onerror = function (e) {
                        t && URL.revokeObjectURL(r), console.error("Cannot load virtual background image.", e);
                      }, (null != n ? n : document.body).appendChild(o), new Promise(function (e) {
                        o.onload = function () {
                          t && URL.revokeObjectURL(r), e(i);
                        }, o.onerror = function (n) {
                          t && URL.revokeObjectURL(r), console.error("Cannot load virtual background image.", n), e(null);
                        };
                      })));

                    case 11:
                      return _context73.abrupt("return", null);

                    case 12:
                    case "end":
                      return _context73.stop();
                  }
                }
              }, _callee73);
            }));
            return _H_.apply(this, arguments);
          }

          function V_(_x22, _x23, _x24, _x25) {
            return _V_.apply(this, arguments);
          }

          function _V_() {
            _V_ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(e, t, n, r) {
              var i, o, a, s, c, l, d, u, p, h, _, _e319, _e320, f;

              return _regeneratorRuntime.wrap(function _callee74$(_context74) {
                while (1) {
                  switch (_context74.prev = _context74.next) {
                    case 0:
                      o = null !== (i = r && r.parentNode) && void 0 !== i ? i : document.body, a = e.imageUrl, s = e.cropped, c = e.captureHeight, l = e.captureWidth, d = e.cameraId, u = document.createElement("div");
                      u.style.display = "none";

                      if (!a) {
                        _context74.next = 8;
                        break;
                      }

                      _context74.next = 5;
                      return H_(a, s, u);

                    case 5:
                      _context74.t0 = _context74.sent;
                      _context74.next = 9;
                      break;

                    case 8:
                      _context74.t0 = null;

                    case 9:
                      p = _context74.t0;
                      h = Math.floor(100 * Math.random());
                      _ = "".concat("__ZOOM_SDK_VIRTUAL_BACKGROUND_CANVAS_@__").concat(h);

                      if (r) {
                        _e319 = zu(r);
                        _e319.id ? _ = _e319.id : _e319.id = _;
                      } else {
                        _e320 = document.createElement("canvas");
                        _e320.width = 380, _e320.height = 214, _e320.id = _, u.appendChild(_e320);
                      }

                      null == o || o.appendChild(u);
                      f = n.video.videoSsrc;
                      return _context74.abrupt("return", (t.startVirtualBackgroundSetting(_, p, f, d, l, c), u));

                    case 16:
                    case "end":
                      return _context74.stop();
                  }
                }
              }, _callee74);
            }));
            return _V_.apply(this, arguments);
          }

          function q_(_x26, _x27, _x28) {
            return _q_.apply(this, arguments);
          }

          function _q_() {
            _q_ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(e, t, n) {
              var r;
              return _regeneratorRuntime.wrap(function _callee75$(_context75) {
                while (1) {
                  switch (_context75.prev = _context75.next) {
                    case 0:
                      if (!e) {
                        _context75.next = 7;
                        break;
                      }

                      _context75.next = 3;
                      return H_(e, t);

                    case 3:
                      r = _context75.sent;
                      r && (n.updateVirtualBackgroundImage(r), "blur" !== r && setTimeout(function () {
                        var e;
                        var t = document.getElementById(r);
                        null == t || null === (e = t.parentNode) || void 0 === e || e.removeChild(t);
                      }, 0));
                      _context75.next = 8;
                      break;

                    case 7:
                      n.updateVirtualBackgroundImage(null);

                    case 8:
                    case "end":
                      return _context75.stop();
                  }
                }
              }, _callee75);
            }));
            return _q_.apply(this, arguments);
          }

          function F_(e, t) {
            return "default" === e || t.some(function (t) {
              return t.deviceId === e;
            }) || [Ja.Environment, Ja.User, Ja.Left, Ja.Right].includes(e);
          }

          var W_ = ua.createAgent(),
              G_ = ma.getInstance();
          var K_ = Object.freeze({
            __proto__: null,
            handleStartCaptureVideoSuccessEpic: function handleStartCaptureVideoSuccessEpic(e, t) {
              return Gr(e, Ta.StartVideoCaptureSuccess).pipe(ln(t), fu(function (e) {
                var _e139 = _slicedToArray(e, 2),
                    t = _e139[1];

                var _t$video = t.video,
                    n = _t$video.cameraDevicesList,
                    r = _t$video.activeCamera,
                    i = t.meeting.userId;
                return n.length < 1 ? (As("CAN_NOT_DETECT_CAMERA", {
                  reason: "Cannot detect camera devices"
                }), void G_.stopCaptureVideo()) : F_(r, n) ? void W_.muteAttendeeVideo(i, !1) : (As("CAN_NOT_FIND_CAMERA", {
                  reason: "cannot find target camera"
                }), void G_.stopCaptureVideo());
              }));
            },
            startVideoResponse: function startVideoResponse(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var t, n, r, i;

                var _e140 = _slicedToArray(e, 2),
                    o = _e140[0],
                    a = _e140[1];

                var s = a.meeting.userId;
                return (null == o || null === (t = o.payload) || void 0 === t || null === (n = t.body) || void 0 === n || null === (r = n.update) || void 0 === r || null === (i = r[0]) || void 0 === i ? void 0 : i.id) === s;
              }), pt(function (e) {
                var t, n, r, i;

                var _e141 = _slicedToArray(e, 1),
                    o = _e141[0];

                return !0 === (null == o || null === (t = o.payload) || void 0 === t || null === (n = t.body) || void 0 === n || null === (r = n.update) || void 0 === r || null === (i = r[0]) || void 0 === i ? void 0 : i.bVideoOn);
              }), fu(function () {
                return As("VIDEO_CAPTURE_START_SUCCESS"), Sl(!0);
              }));
            },
            handleForbiddenCaptureVideoEpic: function handleForbiddenCaptureVideoEpic(e) {
              return Gr(e, Ta.UserForbiddedCaptureVideo).pipe(nn(function () {
                return As("VIDEO_USER_FORBIDDEN_CAPTURE");
              }), Mt(El(!0)));
            },
            handleCameraIsTakenByOtherProgramsEpic: function handleCameraIsTakenByOtherProgramsEpic(e) {
              return Gr(e, Ta.UserCameraIsTakenByOtherPrograms).pipe(nn(function () {
                return As("VIDEO_CAMERA_IS_TAKEN", {
                  reason: "User camera is taken by other programs."
                });
              }), Mt(Tl(!0)));
            },
            handleVideoSocketErrorEpic: function handleVideoSocketErrorEpic(e) {
              return Gr(e, Ta.VideoWebsocketBroken).pipe(nn(function () {
                As("VIDEO_ESTABLISH_STREAM_ERROR", {
                  reason: "Video websocket broken."
                });
              }), qt(ce));
            },
            handleStopVideoCaptureFailedEpic: function handleStopVideoCaptureFailedEpic(e) {
              return Gr(e, Ta.StopVideoCaptureFailed).pipe(nn(function () {
                As("VIDEO_CAPTURE_STOP_RESULT", {
                  failed: !0,
                  reason: "Unknown."
                });
              }), qt(ce));
            },
            handleStopVideoCaptureSuccessEpic: function handleStopVideoCaptureSuccessEpic(e, t) {
              return Gr(e, Ta.StopVideoCaptureSuccess).pipe(ln(t), fu(function (e) {
                var _e142 = _slicedToArray(e, 2),
                    t = _e142[1];

                var n = t.meeting.userId,
                    r = t.video.isCurrentUserStartedVideo;
                r || As("VIDEO_CAPTURE_STOP_RESULT"), W_.muteAttendeeVideo(n, !0);
              }));
            },
            stopVideoResponse: function stopVideoResponse(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var t, n, r, i;

                var _e143 = _slicedToArray(e, 2),
                    o = _e143[0],
                    a = _e143[1];

                var s = a.meeting.userId;
                return (null == o || null === (t = o.payload) || void 0 === t || null === (n = t.body) || void 0 === n || null === (r = n.update) || void 0 === r || null === (i = r[0]) || void 0 === i ? void 0 : i.id) === s;
              }), pt(function (e) {
                var t, n, r, i;

                var _e144 = _slicedToArray(e, 1),
                    o = _e144[0];

                return !1 === (null == o || null === (t = o.payload) || void 0 === t || null === (n = t.body) || void 0 === n || null === (r = n.update) || void 0 === r || null === (i = r[0]) || void 0 === i ? void 0 : i.bVideoOn);
              }), fu(function () {
                return As("VIDEO_CAPTURE_STOP_RESULT"), Sl(!1);
              }));
            },
            receiveVideoMuteIndication: function receiveVideoMuteIndication(e, t) {
              return Vr(e, 16133).pipe(ln(t), pt(function (e) {
                var t, n;

                var _e145 = _slicedToArray(e, 2),
                    r = _e145[0],
                    i = _e145[1];

                return (null == r || null === (t = r.payload) || void 0 === t || null === (n = t.body) || void 0 === n ? void 0 : n.id) === i.meeting.userId;
              }), fu(function (e) {
                var _e146 = _slicedToArray(e, 1),
                    t = _e146[0];

                var _t$payload$body6 = t.payload.body,
                    n = _t$payload$body6.id,
                    r = _t$payload$body6.bVideoMute;
                return As("RECEIVE_VIDEO_MUTE_INDICATION", {
                  id: n,
                  isVideoMuted: r
                }), !0 === r && G_.stopCaptureVideo(), !1 === r && As("ASK_FOR_START_VIDEO_CONSENT", {
                  id: n,
                  isVideoMuted: r
                }), Al(r);
              }));
            },
            receiveVideoActiveIndication: function receiveVideoActiveIndication(e) {
              return Vr(e, 16129).pipe(Me(function (e) {
                var _e$payload$body7 = e.payload.body,
                    t = _e$payload$body7.id,
                    n = _e$payload$body7.bVideoOn,
                    r = L_(t);
                return As("RECEIVE_VIDEO_ACTIVE_INDICATION", {
                  bVideoOn: n,
                  userId: r
                }), bl({
                  bVideoOn: n,
                  userId: r
                });
              }));
            },
            receiveVideoSsrcIndication: function receiveVideoSsrcIndication(e, t) {
              return Vr(e, 16131).pipe(pt(function (e) {
                return void 0 !== e.payload.body.ssrc;
              }), ln(t), Yt(function (e) {
                var _e147 = _slicedToArray(e, 2),
                    n = _e147[0],
                    r = _e147[1];

                var i = r.meeting.isCurrentUserStartVideoBeforeReset,
                    o = r.media.videoEncodeStatus,
                    a = r.video.isVerifiedVideoCaptureCanvasAfterFailover,
                    s = n.payload.body.ssrc,
                    c = Pu(t).pipe(Je(function (e) {
                  return e && !0 === i && !0 !== e.bVideoOn ? Nu("video", o, "success").pipe(pt(function (e) {
                    var _e148 = _slicedToArray(e, 2),
                        t = _e148[0],
                        n = _e148[1];

                    return t && n;
                  }), Je(function () {
                    var e = [Sl(void 0)],
                        _t$value$video = t.value.video,
                        n = _t$value$video.captureCanvasList,
                        r = _t$value$video.activeCamera,
                        i = _t$value$video.customizedVideoOption;
                    return !1 === a && (Array.isArray(n) ? n.forEach(function (e) {
                      zu(document.querySelector("#".concat(e)));
                    }) : zu(document.querySelector("#".concat(n))), e.push(Rl(!0))), ma.getInstance().startCaptureVideo(s, r, (null == i ? void 0 : i.captureWidth) || 0, (null == i ? void 0 : i.captureHeight) || 0, null == i ? void 0 : i.videoDOMId, No(), Lo()), Ke(e);
                  })) : ce;
                }));
                return dt(fe(vl(s)), c);
              }));
            },
            receiveVideoDecodeMaxSizeEpic: function receiveVideoDecodeMaxSizeEpic(e, t) {
              return Gr(e, Ta.VideoDecodeMaxSize).pipe(pt(function (e) {
                var t;
                return null == e || null === (t = e.payload) || void 0 === t ? void 0 : t.data;
              }), Me(function (e) {
                var n = e.payload.data.size,
                    _t$value$video2 = t.value.video,
                    r = _t$value$video2.renderedVideoList,
                    i = _t$value$video2.receivedVideoMaxQuality,
                    o = r.filter(function (e) {
                  return e.videoQuality === Ba.Video_720P;
                });
                return i !== n && o.length > 0 && (n !== Ba.Video_720P && i !== Ba.Video_720P || o.forEach(function (e) {
                  W_.subscribeVideo(e.userId, n, !1);
                })), Cl(n);
              }));
            },
            spotlightVideoResponseEpic: function spotlightVideoResponseEpic(e) {
              return Vr(e, 16135).pipe(Me(function (e) {
                var _e$payload$body8 = e.payload.body,
                    t = _e$payload$body8.bLeadershipOn,
                    n = _e$payload$body8.id,
                    r = [];
                return t && r.push(L_(n)), As("VIDEO_SPOTLIGHT_CHANGE", {
                  spotlightList: r
                }), xl(r);
              }));
            },
            handleGroupLayoutIndicationEpic: function handleGroupLayoutIndicationEpic(e, t) {
              return Vr(e, 7958).pipe(ln(t), Me(function (e) {
                var _e149 = _slicedToArray(e, 2),
                    t = _e149[0],
                    n = _e149[1];

                var r = t.payload.body;
                var i = [];
                r && r.group_list && r.group_list[0] && (i = r.group_list[0].map(function (e) {
                  return e.id;
                }));
                var o = pc(n);
                return i = i.filter(function (e) {
                  return o.findIndex(function (t) {
                    return t.userId === e;
                  }) >= 0;
                }), As("VIDEO_SPOTLIGHT_CHANGE", {
                  spotlightList: i
                }), xl(i);
              }));
            },
            handleCurrentVideoResolution: function handleCurrentVideoResolution(e) {
              return Gr(e, Ta.CurrentVideoResolution).pipe(fu(function (e) {
                return As("VIDEO_RENDER_START_SUCCESS"), As("RECEIVE_VIDEO_DIMENSION_CHANGE", e.payload.data), Pl(e.payload.data);
              }));
            },
            handleMeetingVideoAttributeEpic: function handleMeetingVideoAttributeEpic(e) {
              return Vr(e, 7938).pipe(pt(function (e) {
                var t = e.payload.body;
                return void 0 !== (null == t ? void 0 : t.bFollowHostVideo) || void 0 !== (null == t ? void 0 : t.VideoHd) || void 0 !== (null == t ? void 0 : t.bCanUnmuteVideo);
              }), Me(function (e) {
                var _e$payload$body9 = e.payload.body,
                    t = _e$payload$body9.bFollowHostVideo,
                    n = _e$payload$body9.VideoHd,
                    r = _e$payload$body9.bCanUnmuteVideo;
                return void 0 !== t ? (As("VIDEO_FOLLOW_HOST_ORDER_CHANGE", {
                  bOn: t
                }), zl(t)) : void 0 !== r ? Vl(r) : (G_.enableHardwareAccelerationForVideoEncode(!1), Bl(1 === n));
              }));
            },
            handleHostDragLayoutIndicationEpic: function handleHostDragLayoutIndicationEpic(e, t) {
              return Vr(e, 7957).pipe(ln(t), Me(function (e) {
                var _e150 = _slicedToArray(e, 2),
                    t = _e150[0],
                    n = _e150[1];

                var r = n.video.isFollowHostVideoLayout,
                    i = t.payload.body,
                    o = i && i.drag_list && i.drag_list.map(function (e) {
                  return e.id;
                });
                return r && As("VIDEO_HOST_DRAG_LAYOUT_CHANGE", {
                  layout: o
                }), Ml(o);
              }));
            },
            handlePeerVideoStateChangeEpic: function handlePeerVideoStateChangeEpic(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e151 = _slicedToArray(e, 2),
                    t = _e151[0],
                    n = _e151[1];

                var r = n.meeting.userId,
                    i = n.video.subscribedVideoList,
                    o = t.payload.body.update,
                    a = t.payload.body.remove;
                return o && o.length > 0 && o.findIndex(function (e) {
                  return e.id !== r && (void 0 !== e.bVideoOn || e.bHold);
                }) > -1 || a && a.some(function (e) {
                  return i.includes(e.id);
                });
              }), nn(function (e) {
                var _e152 = _slicedToArray(e, 2),
                    t = _e152[0],
                    n = _e152[1];

                var _t$payload$body7 = t.payload.body,
                    r = _t$payload$body7.remove,
                    i = _t$payload$body7.update,
                    o = n.video.subscribedVideoList,
                    a = uc(n);

                if (r && r.length > 0 && r.filter(function (e) {
                  return o.includes(e.id);
                }).forEach(function (e) {
                  As("VIDEO_OLD_USER_STOP", {
                    userId: e.id
                  });
                }), i && i.length > 0) {
                  var _e153 = i.filter(function (e) {
                    return void 0 !== e.bVideoOn;
                  }).filter(function (e) {
                    return -1 === a.findIndex(function (t) {
                      return t.userId === e.id;
                    });
                  }),
                      _t37 = i.filter(function (e) {
                    return !0 === e.bHold;
                  });

                  _t37.length > 0 && _t37.filter(function (e) {
                    return o.includes(e.id);
                  }).forEach(function (e) {
                    As("VIDEO_OLD_USER_STOP", {
                      userId: e.id
                    });
                  }), _e153.forEach(function (e) {
                    e.bVideoOn ? As("VIDEO_NEW_USER_START", {
                      userId: e.id
                    }) : As("VIDEO_OLD_USER_STOP", {
                      userId: e.id
                    });
                  });
                }
              }), qt(ce));
            },
            handleVideoQosDataEpic: function handleVideoQosDataEpic(e, t) {
              return Gr(e, Ta.videoQosData).pipe(ln(t), Me(function (e) {
                var _e154 = _slicedToArray(e, 2),
                    t = _e154[0],
                    n = _e154[1];

                var _n$video = n.video,
                    r = _n$video.isCaptureForbidden,
                    i = _n$video.isCameraTaken,
                    _n$media3 = n.media,
                    o = _n$media3.videoEncodeStatus,
                    a = _n$media3.videoDecodeStatus,
                    s = sc(n),
                    c = mc(n),
                    l = c.length > 0,
                    d = (null == s ? void 0 : s.bVideoOn) && !r && !i,
                    u = c.some(function (e) {
                  return e.bVideoOn;
                }),
                    p = o && d && l,
                    h = a && l && u;
                return t.payload.data.encoding ? p ? (As("VIDEO_STATISTIC_DATA", t.payload), Gl(t.payload)) : Gl(Xa) : h ? (As("VIDEO_STATISTIC_DATA", t.payload), Kl(t.payload)) : Kl(Xa);
              }));
            },
            handleVideoCellChangeEpic: function handleVideoCellChangeEpic(e) {
              return Gr(e, [66.5, 66.6]).pipe(nn(function (e) {
                var _e$payload = e.payload,
                    t = _e$payload.type,
                    n = _e$payload.data;

                if (66.5 === t) {
                  var _e155 = n.ssrc,
                      _t38 = n.width,
                      r = n.height,
                      i = n.quality;
                  As("VIDEO_CELL_DETAILED_DATA", {
                    userId: _e155,
                    width: _t38,
                    height: r,
                    quality: i
                  });
                } else if (66.6 === t) {
                  var _e156 = n.ssrc,
                      _t39 = n.fps;
                  As("VIDEO_CELL_DETAILED_DATA", {
                    userId: _e156,
                    fps: _t39
                  });
                }
              }), qt(ce));
            }
          }),
              Q_ = Object.freeze({
            __proto__: null,
            handleVBPreloadEpic: function handleVBPreloadEpic(e) {
              return Gr(e, [Ta.VbModelPreloadingOk, Ta.VbModelPreloading_3S, Ta.VbModelPreloading_10S, Ta.VbSettingParaError]).pipe(Je(function (e) {
                var _e$payload2 = e.payload,
                    t = _e$payload2.type,
                    n = _e$payload2.data,
                    r = [];
                return [Ta.VbModelPreloadingOk, Ta.VbModelPreloading_3S, Ta.VbModelPreloading_10S].includes(t) ? (r.push(ql(!0)), As("VIDEO_VIRTUAL_BACKGROUND_PRELOAD_READY", !0), t === Ta.VbModelPreloading_10S && console.warn("Virtual Background is taking longer than expected to load.")) : t === Ta.VbSettingParaError && (n === Za.VBModelNotMatch ? (As("VIDEO_VIRTUAL_BACKGROUND_PRELOAD_READY", !1), r.push(ql(!1))) : (As("VIDEO_VIRTUAL_BACKGROUND_SETTING_SUCCESS", !1), r.push(Fl(!1)))), Ke(r);
              }));
            },
            handleVBSettingSuccessEpic: function handleVBSettingSuccessEpic(e) {
              return Gr(e, Ta.StartVideoStreamInVbSettingSuccess).pipe(Me(function () {
                return As("VIDEO_VIRTUAL_BACKGROUND_SETTING_SUCCESS", !0), Fl(!0);
              }));
            }
          });
          var Z_ = {
            videoSsrc: 0,
            cameraDevicesList: [],
            activeCamera: No() ? Ja.User : "default",
            activeVideoId: 0,
            isCurrentUserStartedVideo: !1,
            spotlightUserList: [],
            isCaptureForbidden: !1,
            receivedVideoMaxQuality: Ba.Video_360P,
            captureCanvasList: [],
            subscribedVideoList: [],
            renderedVideoList: [],
            isVideoMuted: !1,
            isCaptureCameraLoading: !1,
            isCameraTaken: !1,
            receivedVideoDimension: {
              width: 0,
              height: 0
            },
            isFollowHostVideoLayout: !1,
            hostDragLayout: [],
            isSupportHDVideo: !1,
            highDefinitionVideoId: void 0,
            bCanUnmuteVideo: !1,
            virtualBackground: {
              isVBConfigured: !1,
              isVBPreloadReady: void 0,
              imageSrc: void 0,
              cropped: void 0
            },
            statistic: {
              encode: {
                sample_rate: 0,
                rtt: 0,
                jitter: 0,
                avg_loss: 0,
                max_loss: 0,
                width: 0,
                height: 0,
                fps: 0
              },
              decode: {
                sample_rate: 0,
                rtt: 0,
                jitter: 0,
                avg_loss: 0,
                max_loss: 0,
                width: 0,
                height: 0,
                fps: 0
              }
            },
            hardwareAcceleration: {
              encode: !1,
              decode: !1
            }
          },
              Y_ = ur((_ur7 = {}, _defineProperty(_ur7, "".concat(vl), Hp(function (e, t) {
            var n = t.payload;
            e.videoSsrc = n;
          })), _defineProperty(_ur7, "".concat(yl), Hp(function (e, t) {
            var n = t.payload;
            e.cameraDevicesList = n;
          })), _defineProperty(_ur7, "".concat(wl), Hp(function (e, t) {
            var n = t.payload;
            e.activeCamera = n;
          })), _defineProperty(_ur7, "".concat(bl), Hp(function (e, t) {
            var n = t.payload;
            e.activeVideoId = n.userId;
          })), _defineProperty(_ur7, "".concat(Sl), Hp(function (e, t) {
            var n = t.payload;
            e.isCurrentUserStartedVideo = n;
          })), _defineProperty(_ur7, "".concat(xl), Hp(function (e, t) {
            var n = t.payload;
            e.spotlightUserList = n;
          })), _defineProperty(_ur7, "".concat(El), Hp(function (e, t) {
            var n = t.payload;
            e.isCaptureForbidden = n;
          })), _defineProperty(_ur7, "".concat(Cl), Hp(function (e, t) {
            var n = t.payload;
            e.receivedVideoMaxQuality = n;
          })), _defineProperty(_ur7, "".concat(kl), Hp(function (e, t) {
            var n = t.payload,
                r = n;
            Array.isArray(n) || (r = [n]), e.captureCanvasList = r;
          })), _defineProperty(_ur7, "".concat(Al), Hp(function (e, t) {
            var n = t.payload;
            e.isVideoMuted = n;
          })), _defineProperty(_ur7, "".concat(Il), Hp(function (e, t) {
            var n = t.payload;
            e.isCaptureCameraLoading = n;
          })), _defineProperty(_ur7, "".concat(Tl), Hp(function (e, t) {
            var n = t.payload;
            e.isCameraTaken = n;
          })), _defineProperty(_ur7, "".concat(Rl), Hp(function (e, t) {
            var n = t.payload;
            e.isVerifiedVideoCaptureCanvasAfterFailover = n;
          })), _defineProperty(_ur7, "".concat(Ol), Hp(function (e, t) {
            var n = t.payload;
            e.isVerifiedVideoRenderCanvasAfterFailover = n;
          })), _defineProperty(_ur7, "".concat(Pl), Hp(function (e, t) {
            var n = t.payload;
            e.receivedVideoDimension = n;
          })), _defineProperty(_ur7, "".concat(jl), Hp(function (e, t) {
            var n = t.payload;
            e.subscribedVideoList.includes(n) || e.subscribedVideoList.push(n);
          })), _defineProperty(_ur7, "".concat(Dl), Hp(function (e, t) {
            var n = t.payload;
            var r = e.subscribedVideoList.indexOf(n);
            r >= 0 && e.subscribedVideoList.splice(r, 1);
          })), _defineProperty(_ur7, "".concat(Ll), Hp(function (e, t) {
            var n = t.payload;
            var r = e.renderedVideoList.find(function (e) {
              return e.userId === n.userId && e.key === n.key && e.canvasId === n.canvasId;
            });
            r ? r.videoQuality = n.videoQuality : e.renderedVideoList.push(f({}, n));
          })), _defineProperty(_ur7, "".concat(Ul), Hp(function (e, t) {
            var n = t.payload;
            var r = e.renderedVideoList.findIndex(function (e) {
              return e.userId === n.userId && e.key === n.key && e.canvasId === n.canvasId;
            });
            r >= 0 && e.renderedVideoList.splice(r, 1);
          })), _defineProperty(_ur7, "".concat(zl), Hp(function (e, t) {
            var n = t.payload;
            e.isFollowHostVideoLayout = n;
          })), _defineProperty(_ur7, "".concat(Ml), Hp(function (e, t) {
            var n = t.payload;
            e.hostDragLayout = n;
          })), _defineProperty(_ur7, "".concat(Bl), Hp(function (e, t) {
            var n = t.payload;
            e.isSupportHDVideo = n;
          })), _defineProperty(_ur7, "".concat(Hl), Hp(function (e, t) {
            var n = t.payload;
            e.highDefinitionVideoId = n;
          })), _defineProperty(_ur7, "".concat(Vl), Hp(function (e, t) {
            var n = t.payload;
            e.bCanUnmuteVideo = n;
          })), _defineProperty(_ur7, "".concat(ql), Hp(function (e, t) {
            var n = t.payload;
            e.virtualBackground.isVBPreloadReady = n;
          })), _defineProperty(_ur7, "".concat(Fl), Hp(function (e, t) {
            var n = t.payload;
            e.virtualBackground.isVBConfigured = n;
          })), _defineProperty(_ur7, "".concat(Wl), Hp(function (e, t) {
            var n = t.payload;
            e.virtualBackground.imageSrc = n.imageSrc, e.virtualBackground.cropped = n.cropped;
          })), _defineProperty(_ur7, "".concat(Ql), Hp(function (e, t) {
            var n = t.payload;
            var r = n.encode,
                i = n.decode;
            void 0 !== r && (e.hardwareAcceleration.encode = r), void 0 !== i && (e.hardwareAcceleration.decode = i);
          })), _defineProperty(_ur7, "".concat(Gl), Hp(function (e, t) {
            var n = t.payload;
            e.statistic.encode = n.data;
          })), _defineProperty(_ur7, "".concat(Kl), Hp(function (e, t) {
            var n = t.payload;
            e.statistic.decode = n.data;
          })), _defineProperty(_ur7, "".concat(Zl), Hp(function (e, t) {
            var n = t.payload;
            var r = n.cameraId,
                i = n.captureWidth,
                o = n.captureHeight,
                a = n.videoDOMId;
            e.activeCamera = r, e.customizedVideoOption = {
              captureWidth: i,
              captureHeight: o,
              videoDOMId: a
            };
          })), _defineProperty(_ur7, "".concat(Nl), function (e) {
            return f(f({}, Z_), {}, {
              captureCanvasList: e.captureCanvasList,
              activeCamera: e.activeCamera,
              isVerifiedVideoCaptureCanvasAfterFailover: !1,
              isVerifiedVideoRenderCanvasAfterFailover: !1,
              customizedVideoOption: e.customizedVideoOption
            });
          }), _ur7), Z_),
              J_ = Hr(K_, Q_),
              _Ta = Ta,
              $_ = _Ta.InitSuccessVideo,
              X_ = _Ta.InitSuccessAudio,
              ef = _Ta.InitSuccessSharing,
              tf = _Ta.InitFailedVideo,
              nf = _Ta.InitFailedAudio,
              rf = _Ta.InitFailedSharing;
          var of;

          var af = new te(Br(Oh, o_, h_, Hr(Object.freeze({
            __proto__: null,
            connectToMediaStreamEpic: function connectToMediaStreamEpic(e, t) {
              return e.pipe(fn("".concat(Ir)), ln(t), pt(function (e) {
                var _e157 = _slicedToArray(e, 2),
                    t = _e157[1];

                return void 0 !== t.media.assetsPath && void 0 !== t.media.mediaConstraints;
              }), nn(function (e) {
                var _e158 = _slicedToArray(e, 2),
                    n = _e158[1];

                var _n$media4 = n.media,
                    r = _n$media4.assetsPath,
                    i = _n$media4.mediaConstraints,
                    o = _n$media4.fileWithVersion,
                    a = _n$media4.enforceMultipleVideos,
                    _n$meeting6 = n.meeting,
                    s = _n$meeting6.enableAudioQos,
                    c = _n$meeting6.enableVideoQos;

                if (of = ma.getInstance(), r && i) {
                  var _e159 = {};
                  Do() && Object.assign(_e159, {
                    enableMultiDecodeVideoWithoutSAB: !!a
                  }), Vu() && Object.assign(_e159, {
                    resourceManager: v_.IResourceManager,
                    file: [{
                      path: "".concat(r, "/vb-resources/vbbuffer.bin"),
                      type: "bin"
                    }, {
                      path: "".concat(r, "/vb-resources/tf.min.js"),
                      type: "js"
                    }]
                  }), of.setAssetsAndConstraint(r, i, o, _e159);
                }

                Pu(t).pipe(ln(t)).subscribe(function (e) {
                  var _e160 = _slicedToArray(e, 2),
                      t = _e160[0],
                      n = _e160[1];

                  var _n$meeting7 = n.meeting,
                      r = _n$meeting7.svcUrl,
                      i = _n$meeting7.meetingNumber,
                      o = _n$meeting7.conId,
                      a = _n$meeting7.e2eEncrypt,
                      l = _n$meeting7.userId,
                      d = _n$meeting7.isWebinar;
                  var u;
                  t && (null === (u = of) || void 0 === u || u.connect({
                    svcUrl: r,
                    meetingNumber: i,
                    conId: o,
                    e2eEncrypt: a,
                    isViewOnly: ec(t.userRole),
                    currentUserId: l,
                    isWebinar: d,
                    enableAudioQos: s,
                    enableVideoQos: c
                  }));
                });
              }), Yt(function () {
                return at(function (e) {
                  var t;
                  return null === (t = of) || void 0 === t ? void 0 : t.registerCallback(e);
                }, function (e) {
                  var t;
                  return null === (t = of) || void 0 === t ? void 0 : t.unregisterCallback(e);
                }, function (e, t) {
                  return {
                    type: e,
                    data: t
                  };
                }).pipe(Me(function (e) {
                  return Tr(e);
                }));
              }));
            },
            connectedMediaStreamEpic: function connectedMediaStreamEpic(e) {
              return Gr(e, [$_, X_, ef, tf, nf, rf]).pipe(mu(function (e) {
                var _e$payload3 = e.payload,
                    t = _e$payload3.type,
                    n = _e$payload3.data;

                if (t === X_ || t === nf) {
                  if (n === Oa.EncodeSuccess) return As("AUDIO_ENCODE_SUCCESS"), fe(Or("success"));
                  if (n === Oa.DecodeSuccess) return As("AUDIO_DECODE_SUCCESS"), fe(Rr("success"));
                  if (n === Oa.EncodeFailed) return As("AUDIO_ENCODE_FAIL"), fe(Or("failed"));
                  if (n === Oa.DecodeFailed) return As("AUDIO_DECODE_FAIL"), fe(Rr("failed"));
                } else if (t === $_ || t === tf) {
                  if (n === Oa.EncodeSuccess) return As("VIDEO_ENCODE_SUCCESS"), fe(Nr("success"));
                  if (n === Oa.DecodeSuccess) return As("VIDEO_DECODE_SUCCESS"), fe(Pr("success"));
                  if (n === Oa.EncodeFailed) return As("VIDEO_ENCODE_FAIL"), fe(Nr("failed"));
                  if (n === Oa.DecodeFailed) return As("VIDEO_DECODE_FAIL"), fe(Pr("failed"));
                } else if (t === ef || t === rf) {
                  if (n === Oa.EncodeSuccess) return As("SHARING_ENCODE_SUCCESS"), fe(jr("success"));
                  if (n === Oa.DecodeSuccess) return As("SHARING_DECODE_SUCCESS"), fe(Dr("success"));
                  if (n === Oa.EncodeFailed) return As("SHARING_ENCODE_FAIL"), fe(jr("failed"));
                  if (n === Oa.DecodeFailed) return As("SHARING_DECODE_FAIL"), fe(Dr("failed"));
                  if (t === ef && void 0 === n) return As("SHARING_DECODE_SUCCESS"), fe(Dr("success"));
                }
              }));
            },
            mediaDeviceUpdateEpic: function mediaDeviceUpdateEpic(e, t) {
              return Gr(e, [$_, X_]).pipe(gu(function () {
                if ("object" == typeof navigator.mediaDevices) return dt(ju(), dt(Gr(e, Ta.StartVideoCaptureSuccess), ot(navigator.mediaDevices, "devicechange"), Gr(e, Ta.UserGrantCaptureAudio).pipe(pt(function () {
                  return !t.value.audio.isUserGrantCaptureAudio;
                }))).pipe(Je(function () {
                  return ju().pipe(nn(function () {
                    As("MEDIA_DEVICE_CHANGE");
                  }));
                }))).pipe(ln(t), Je(function (e) {
                  var _e161 = _slicedToArray(e, 2),
                      t = _e161[0],
                      n = _e161[1];

                  var r = [Nc(t.microphones), Pc(t.speakers), yl(t.cameras)];

                  if (n.audio) {
                    var _n$audio3 = n.audio,
                        _e162 = _n$audio3.activeMicrophone,
                        _a10 = _n$audio3.activeSpeaker,
                        _s12 = _n$audio3.microphoneDevicesList,
                        _c6 = _n$audio3.speakerDevicesList,
                        _l6 = t.microphones,
                        _d5 = t.speakers,
                        _u5 = _s12.filter(function (e) {
                      return -1 === _l6.findIndex(function (t) {
                        return t.deviceId === e.deviceId;
                      });
                    }),
                        _p5 = _c6.filter(function (e) {
                      return -1 === _d5.findIndex(function (t) {
                        return t.deviceId === e.deviceId;
                      });
                    });

                    var i, o;
                    _u5.length > 0 && _u5[0].deviceId === _e162 && (null === (i = of) || void 0 === i || i.changeMicrophone("default"), r.push(jc("default"))), _p5.length > 0 && _p5[0].deviceId === _a10 && (null === (o = of) || void 0 === o || o.changeSpeaker("default"), r.push(Dc("default")));
                  }

                  return Ke(r);
                }));
              }));
            },
            sendUserNodeListToMediaSDKEpic: function sendUserNodeListToMediaSDKEpic(e) {
              return Wr(e, 7937).pipe(nn(function (e) {
                var t = e.type,
                    n = e.payload.body,
                    r = ma.getInstance(),
                    i = t === "".concat(wr);

                if (n.add) {
                  var _e163 = n.add.map(function (e) {
                    return {
                      userid: e.id,
                      sn: e.zoomID && bi(e.zoomID)
                    };
                  });

                  i || r.sendUserNodeList(_e163), r.updateUserMediaSN({
                    added: _e163,
                    isFromMainSession: i,
                    iVType: Uo.SHARING_DECODE
                  }), i && r.updateUserMediaSN({
                    added: _e163,
                    isFromMainSession: i,
                    iVType: Uo.AUDIO_DECODE
                  });
                }

                n.remove && (i || r.sendUserNodeList(n.remove.map(function (e) {
                  return {
                    userid: e.id,
                    bremove: !0
                  };
                })), r.updateUserMediaSN({
                  removed: n.remove.map(function (e) {
                    return e.id;
                  }),
                  isFromMainSession: i,
                  iVType: Uo.SHARING_DECODE
                }), i && r.updateUserMediaSN({
                  removed: n.remove.map(function (e) {
                    return e.id;
                  }),
                  isFromMainSession: i,
                  iVType: Uo.AUDIO_DECODE
                }));
              }), qt(ce));
            },
            handleMediaSdkGcmIVResponseEpic: function handleMediaSdkGcmIVResponseEpic(e) {
              return Gr(e, Ta.AesGcmIvResponse).pipe(nn(function (e) {
                var _e$payload$data2 = e.payload.data,
                    t = _e$payload$data2.workerType,
                    n = _e$payload$data2.iv,
                    r = wo.get(Vo.WebclientIVState);

                if (r) {
                  var _e164 = f(f({}, r), {}, _defineProperty({}, t, n));

                  wo.set(Vo.WebclientIVState, _e164, bo.SessionStorage);
                }
              }), qt(ce));
            },
            handleMediaEncryptIndication: function handleMediaEncryptIndication(e) {
              return e.pipe(fn("".concat(mr)), pt(function (e) {
                return [Zo, Yo, Qo].includes(e.payload.evt);
              }), Me(function (e) {
                var _e$payload4 = e.payload,
                    t = _e$payload4.evt,
                    _e$payload4$body = _e$payload4.body,
                    n = _e$payload4$body.encryptKey,
                    r = _e$payload4$body.additionalType;
                return Mr({
                  type: t === Zo ? "audio" : t === Yo ? "video" : "sharing",
                  encryptKey: n,
                  additionalType: r
                });
              }));
            }
          })))),
              sf = function sf(e, t, n) {
            return af.pipe(Je(function (r) {
              return r(e, t, n);
            }));
          },
              cf = {
            meeting: Th,
            socket: i_,
            participants: p_,
            media: f_
          },
              lf = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = new (0, ae.constructor)(ae.SchedulerAction),
                n = new X(),
                r = void 0,
                i = function i(_i15) {
              r = _i15;
              var o = new X().pipe(be(t)),
                  a = new X().pipe(be(t)),
                  s = new gn(o),
                  c = new vn(a, r.getState());
              return n.pipe(Me(function (t) {
                var n = "dependencies" in e ? t(s, c, e.dependencies) : t(s, c);
                if (!n) throw new TypeError('Your root Epic "' + (t.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
                return n;
              }), Je(function (e) {
                return Ke(e).pipe(Qt(t), be(t));
              })).subscribe(r.dispatch), function (e) {
                return function (t) {
                  var n = e(t);
                  return a.next(r.getState()), o.next(t), n;
                };
              };
            };

            return i.run = function (e) {
              n.next(e);
            }, i;
          }(),
              df = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || I;

          function uf(e) {
            return function (e) {
              for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
                var i = t[r];
                "function" == typeof e[i] && (n[i] = e[i]);
              }

              var o,
                  a = Object.keys(n);

              try {
                !function (e) {
                  Object.keys(e).forEach(function (t) {
                    var n = e[t];
                    if (void 0 === n(void 0, {
                      type: C.INIT
                    })) throw new Error(S(12));
                    if (void 0 === n(void 0, {
                      type: C.PROBE_UNKNOWN_ACTION()
                    })) throw new Error(S(13));
                  });
                }(n);
              } catch (e) {
                o = e;
              }

              return function (e, t) {
                if (void 0 === e && (e = {}), o) throw o;

                for (var r = !1, i = {}, s = 0; s < a.length; s++) {
                  var c = a[s],
                      l = n[c],
                      d = e[c],
                      u = l(d, t);
                  if (void 0 === u) throw t && t.type, new Error(S(14));
                  i[c] = u, r = r || u !== d;
                }

                return (r = r || a.length !== Object.keys(e).length) ? i : e;
              };
            }(f(f({}, cf), e));
          }

          var pf = Symbol("store"),
              hf = Symbol("getState"),
              _f = Symbol("dispatch"),
              ff = Symbol("additionFeatures"),
              mf = Symbol("mediaContext");

          function gf(e, t, n) {
            var r = n.value;

            n.value = function () {
              var e = this[pf];

              if (e) {
                var _e$getState = e.getState(),
                    _e$getState$meeting = _e$getState.meeting,
                    _t40 = _e$getState$meeting.isOnHold,
                    _n35 = _e$getState$meeting.isMeetingReset,
                    _r25 = _e$getState$meeting.meetingStatus;

                if (_r25 !== go.Joined) return Promise.reject({
                  type: "IMPROPER_MEETING_STATE",
                  reason: "closed"
                });
                if (_n35) return Promise.reject({
                  type: "IMPROPER_MEETING_STATE",
                  reason: "reconnecting"
                });
                if (_t40) return Promise.reject({
                  type: "IMPROPER_MEETING_STATE",
                  reason: "on hold"
                });
              }

              for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
                n[i] = arguments[i];
              }

              return r.apply(this, n);
            };
          }

          function vf(e, t, n) {
            var r = n.value;

            n.value = function () {
              var e = this[pf];

              if (e) {
                var _e$getState2 = e.getState(),
                    _t41 = _e$getState2.meeting.isWebinar;

                if (!_t41) return Promise.reject({
                  type: "IMPROPER_MEETING_STATE",
                  reason: "non-webinar"
                });
              }

              for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
                n[i] = arguments[i];
              }

              return r.apply(this, n);
            };
          }

          function bf(e, t, n) {
            var r = n.value;

            n.value = function () {
              var e = this[pf];

              if (e) {
                var _t42 = e.getState();

                if (!cc(_t42)) return Promise.reject({
                  type: gs,
                  reason: "only host or co-host can do the operation"
                });
              }

              for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
                n[i] = arguments[i];
              }

              return r.apply(this, n);
            };
          }

          function yf(e, t, n) {
            var r = n.value;

            n.value = function () {
              var e = this[pf];

              if (e) {
                var _t43 = e.getState();

                if (!lc(_t43)) return Promise.reject({
                  type: gs,
                  reason: "only host can do the operation"
                });
              }

              for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
                n[i] = arguments[i];
              }

              return r.apply(this, n);
            };
          }

          function wf(e, t, n) {
            var r = n.value;

            n.value = function () {
              var e = this[pf];

              if (e) {
                var _t44 = e.getState(),
                    _n36 = _t44.meeting.isWebinar,
                    _r26 = sc(_t44);

                if (!_n36 || !ec(_r26.userRole)) return Promise.reject({
                  type: gs,
                  reason: "operation is only for attendee"
                });
              }

              for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
                n[i] = arguments[i];
              }

              return r.apply(this, n);
            };
          }

          function Sf(e, t, n) {
            var r = n.value;

            n.value = function () {
              var e = this[pf];

              if (e) {
                var _t45 = e.getState(),
                    _n37 = _t45.meeting.isWebinar,
                    _r27 = sc(_t45);

                if (!_n37 || ec(_r27.userRole)) return Promise.reject({
                  type: gs,
                  reason: "operation is only for panelist"
                });
              }

              for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
                n[i] = arguments[i];
              }

              return r.apply(this, n);
            };
          }

          function xf(e) {
            return function (t, n, r) {
              var i = r.value;

              r.value = function () {
                var t = this[pf];
                if (t && void 0 === t.getState()[e]) return Promise.reject({
                  type: ms,
                  reason: "Module:".concat(e, " is not enabled")
                });

                for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                  r[o] = arguments[o];
                }

                return i.apply(this, r);
              };
            };
          }

          function Ef(e) {
            return function (t, n, r) {
              var i = r.value;

              r.value = function () {
                var t = this[pf];

                if (t) {
                  var _t$getState = t.getState(),
                      _n38 = _t$getState.meeting.meetingOptions;

                  if (!0 === _n38[e]) return Promise.reject({
                    type: "OPERATION_LOCKED",
                    reason: "".concat(e, " is locked")
                  });
                }

                for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                  r[o] = arguments[o];
                }

                return i.apply(this, r);
              };
            };
          }

          var Cf;

          function kf(e) {
            return function (t, n, r) {
              var i = r.value;

              r.value = function (t) {
                var n = this[pf];

                if (n) {
                  var _r28 = n.getState(),
                      _i16 = Array.isArray(e) ? e : [e];

                  var _o11 = pc(_r28).find(function (e) {
                    return e.userId === t;
                  });

                  if (_i16.findIndex(function (e) {
                    return e === Cf.Attendee;
                  }) > -1 && (_o11 = dc(_r28).find(function (e) {
                    return e.userId === t;
                  })), !_o11) return Promise.reject({
                    type: vs,
                    reason: "no matching user"
                  });
                  {
                    var _n$getState = n.getState(),
                        _e165 = _n$getState.meeting.userId;

                    for (var _n39 = 0; _n39 < _i16.length; _n39++) {
                      var _r29 = _i16[_n39];
                      if (_r29 === Cf.Other && t === _e165) return Promise.reject({
                        type: ms,
                        reason: "operation is not applicable to self"
                      });
                      if (_r29 === Cf.Self && t !== _e165) return Promise.reject({
                        type: ms,
                        reason: "operation is only applicable to self "
                      });
                      if (_r29 === Cf.Client && $s(_o11.userType) || _r29 === Cf.Phone && !$s(_o11.userType)) return Promise.reject({
                        types: ms,
                        reason: "improper target client"
                      });
                    }
                  }
                }

                for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
                  o[a - 1] = arguments[a];
                }

                var s = [t].concat(o);
                return i.apply(this, s);
              };
            };
          }

          !function (e) {
            e.Self = "Self", e.Other = "Other", e.Client = "Client", e.Phone = "Phone", e.Attendee = "Attendee";
          }(Cf || (Cf = {}));

          var Af = function Af(e, t, n, r) {
            var i = n.getState,
                o = n.dispatch,
                a = i(),
                s = a.participants.attendeesList,
                c = a.audio.localShareAudioUserMutedList,
                l = a.share.isReceiveSharingFromMainSession,
                d = a.breakoutRoom,
                u = (l ? null == d ? void 0 : d.mainSessionAttendeeList : s).find(function (t) {
              return t.userId == e;
            });

            if (u) {
              if (u.bShareAudioOn) {
                var _n40 = c.find(function (t) {
                  return t.userId === e;
                });

                return _n40 && _n40.muted === !t && o(b_(r, e, t, a)), Promise.resolve("");
              }

              return Promise.reject({
                type: ms,
                reason: "Cannot ".concat(t ? "mute" : "unmute", " share audio when the user's share audio is not enable.")
              });
            }

            return Promise.reject({
              type: vs,
              reason: "Cannot find the user"
            });
          },
              If = function If(e, t) {
            var n = e.store.getState,
                r = e.rwgAgent,
                _n41 = n(),
                i = _n41.share.sharePrivilege;

            return i === t ? Promise.resolve("") : Object.values(La).includes(t) ? (r.lockSharing(t), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
              return e.lockShare === t;
            })) : Promise.reject({
              type: vs
            });
          },
              Tf = function Tf(e, t) {
            var n = e.store.getState(),
                r = Eu(n).find(function (e) {
              return e.userId === t;
            });

            if (r) {
              var _e166 = r.os;
              return !function (e) {
                return e === Bh.WebClient;
              }(_e166);
            }

            return !1;
          },
              Of = function Of(e) {
            var t = e.store.getState,
                n = t();
            return !!n.share && n.share.sharePrivilege === La.OnlyHost;
          },
              Rf = Ws([pc], function (e) {
            return e.filter(function (e) {
              return e.bVideoOn;
            });
          }),
              Nf = function Nf(e, t) {
            var _e$store = e.store,
                n = _e$store.getState,
                r = _e$store.dispatch,
                i = e.mediaAgent,
                o = n(),
                _o$media = o.media,
                a = _o$media.videoDecodeStatus,
                s = _o$media.videoEncodeStatus,
                _o$video = o.video,
                c = _o$video.isCaptureCameraLoading,
                l = _o$video.isCurrentUserStartedVideo,
                d = _o$video.isVideoMuted;
            return l ? Promise.reject({
              type: ms,
              reason: "Video is started"
            }) : c ? Promise.reject({
              type: ms,
              reason: "Camera is starting,please wait."
            }) : d && !cc(o) ? Promise.reject({
              type: ms,
              reason: "Video is muted by the host"
            }) : !(!jf() && Do() || Mo()) || null != t && t.videoElement ? !Vu() && null != t && t.virtualBackground ? Promise.reject({
              type: vs,
              reason: "Virtual background only compatible with Chrome and Edge with SharedArrayBuffer enabled."
            }) : (r(Il(!0)), Nu("video", s, a).subscribe(function (e) {
              var _e167 = _slicedToArray(e, 1),
                  o = _e167[0];

              if (o) {
                var _e168 = n(),
                    _e168$video = _e168.video,
                    _o12 = _e168$video.activeCamera,
                    _a11 = _e168$video.isSupportHDVideo,
                    _s13 = _e168$video.videoSsrc,
                    _e168$video$virtualBa = _e168$video.virtualBackground,
                    _c7 = _e168$video$virtualBa.isVBConfigured,
                    _l7 = _e168$video$virtualBa.isVBPreloadReady,
                    _d6 = _e168$video$virtualBa.imageSrc,
                    _ref10 = t || {},
                    _ref10$cameraId = _ref10.cameraId,
                    _u6 = _ref10$cameraId === void 0 ? _o12 : _ref10$cameraId,
                    _ref10$captureWidth = _ref10.captureWidth,
                    _p6 = _ref10$captureWidth === void 0 ? 0 : _ref10$captureWidth,
                    _ref10$captureHeight = _ref10.captureHeight,
                    _h5 = _ref10$captureHeight === void 0 ? 0 : _ref10$captureHeight,
                    _3 = _ref10.videoElement,
                    _m3 = _ref10.mirrored,
                    _g3 = _ref10.hd,
                    _v3 = _ref10.virtualBackground;

                var _b3;

                if (_m3 && i.mirrorVideo(_m3), _3 && (_3.id ? _b3 = _3.id : (_b3 = "__ZOOM_SDK_SELF_VIDEO_@__".replace("@", "".concat(Math.floor(1e4 * Math.random()))), _3.id = _b3)), _g3 && (console.log("HD support is currently limited, and comes with a number of restrictions and limitations. Please visit https://marketplace.zoom.us/docs/sdk/overview/720p for more details"), _a11 && ma.isCompatibleHardwareForEncode() ? ma.isSupportVideoEncodeHardwareAcceleration().then(function (e) {
                  e ? (i.enableHardwareAccelerationForVideoEncode(!0), r(Ql({
                    encode: e
                  }))) : console.warn("Cannot capture HD video due to hardware limitation");
                }) : console.warn("Cannot capture HD video due to either account restriction and/or hardware limitation")), _v3 || void 0 === _v3 && _d6) {
                  var _t46 = _v3 || {
                    imageUrl: void 0,
                    cropped: void 0
                  };

                  B_(_l7).subscribe(function (n) {
                    if (n) {
                      var _n42;

                      _n42 = _c7 ? _t46.imageUrl !== _d6 ? q_(_t46.imageUrl, _t46.cropped, i) : Promise.resolve() : V_(f(f({}, _t46), {}, {
                        captureWidth: _p6,
                        captureHeight: _h5,
                        cameraId: _u6
                      }), i, _e168).then(function (e) {
                        return Os("VIDEO_VIRTUAL_BACKGROUND_SETTING_SUCCESS", 1).toPromise().then(function (t) {
                          var n;
                          return i.stopVirtualBackgroundSetting(), t ? (null == e || null === (n = e.parentNode) || void 0 === n || n.removeChild(e), !0) : Promise.reject("vb setting error");
                        });
                      }), _n42.then(function () {
                        i.startCaptureVideo(_s13, _u6, _p6, _h5, _b3), r(Zl({
                          cameraId: _u6,
                          captureWidth: _p6,
                          captureHeight: _h5,
                          videoDOMId: _b3
                        })), r(Wl({
                          imageSrc: _t46.imageUrl,
                          cropped: _t46.cropped
                        }));
                      }).catch(function () {
                        As("VIDEO_VITRUAL_BACKGROUND_FAILED", {
                          reason: "Cannot access the virtual background image."
                        });
                      });
                    } else As("VIDEO_VITRUAL_BACKGROUND_FAILED", {
                      reason: "Cannot load virtual background model."
                    });
                  });
                } else _o12 !== _u6 && r(wl(_u6)), i.startCaptureVideo(_s13, _u6, _p6, _h5, _b3, No(), Lo()), r(Zl({
                  cameraId: _u6,
                  captureWidth: _p6,
                  captureHeight: _h5,
                  videoDOMId: _b3
                }));
              } else r(Il(!1));
            }), Is(ns).then(function () {
              r(Tl(!1)), r(El(!1));
            }).finally(function () {
              r(Il(!1));
            })) : Promise.reject({
              type: vs,
              reason: "You must pass a <video> element to start video capture for Chromium browser, Android browser, and Chrome without SharedArrayBuffer support."
            });
          },
              Pf = function Pf(e) {
            var t = e.store.getState,
                n = e.mediaAgent,
                _t47 = t(),
                _t47$video = _t47.video,
                r = _t47$video.isCaptureCameraLoading,
                i = _t47$video.isCurrentUserStartedVideo;

            return r ? Promise.reject({
              type: ms,
              reason: "Camera is starting,please wait."
            }) : i ? (n.stopCaptureVideo(), Ts("VIDEO_CAPTURE_STOP_RESULT", function (e) {
              return !0 !== (null == e ? void 0 : e.failed);
            })) : Promise.reject({
              type: ms,
              reason: "camera is closed"
            });
          },
              jf = function jf() {
            return !No() && "function" == typeof window.OffscreenCanvas && ("function" == typeof window.ImageCapture || "function" == typeof window.MediaStreamTrackProcessor) && Mu();
          };

          var Df = function Df(e) {
            _classCallCheck(this, Df);

            this[pf] = void 0, this[_f] = void 0, this[hf] = void 0, this[ff] = void 0, this[pf] = e, this[_f] = e.dispatch, this[hf] = e.getState;
          };

          var zf, Mf, Lf, Uf, Bf, Hf, Vf, qf, Ff, Wf, Gf, Kf, Qf, Zf, Yf, Jf, $f, Xf, em, tm, nm, rm, im, om, am, sm, cm, lm, dm, um, pm, hm, _m, fm, mm, gm, vm, bm, ym, wm, Sm, xm, Em;

          var Cm = (zf = xf("audio"), Mf = xf("audio"), Lf = xf("audio"), Uf = xf("audio"), Bf = xf("audio"), Hf = xf("audio"), Vf = xf("audio"), qf = xf("audio"), Ff = xf("audio"), Wf = xf("audio"), Gf = xf("share"), Kf = xf("audio"), Qf = xf("share"), Zf = xf("audio"), Yf = xf("audio"), Jf = xf("video"), $f = xf("video"), Xf = xf("video"), em = xf("video"), tm = xf("video"), nm = xf("video"), rm = xf("video"), im = xf("video"), om = xf("video"), am = xf("video"), sm = xf("video"), cm = xf("video"), lm = xf("video"), dm = xf("video"), um = xf("video"), pm = xf("share"), hm = xf("share"), _m = xf("share"), fm = xf("share"), mm = xf("share"), gm = xf("share"), vm = xf("share"), bm = xf("share"), ym = Ef("isShareOptionLocked"), wm = Ef("isShareOptionLocked"), Sm = xf("share"), xm = xf("share"), v((Em = /*#__PURE__*/function (_Df) {
            _inherits(Em, _Df);

            var _super3 = _createSuper(Em);

            function Em(e) {
              var _this11;

              _classCallCheck(this, Em);

              _this11 = _super3.call(this, e), _this11[pf].dispatch(Ir()), _this11[mf] = {
                store: e,
                mediaAgent: Hu(ma.getInstance()),
                rwgAgent: ua.createAgent()
              };
              return _this11;
            }

            _createClass(Em, [{
              key: "startAudio",
              value: function startAudio(e) {
                return function (e, t) {
                  var _e$store2 = e.store,
                      n = _e$store2.getState,
                      r = _e$store2.dispatch,
                      i = e.rwgAgent,
                      o = e.mediaAgent,
                      a = n(),
                      _ref11 = t || {},
                      s = _ref11.speakerOnly,
                      c = _ref11.autoStartAudioInSafari,
                      l = sc(a);

                  if ("computer" === (null == l ? void 0 : l.audio)) return Promise.resolve();
                  if ("phone" === (null == l ? void 0 : l.audio)) return Promise.reject({
                    type: ms,
                    reason: "joined by phone"
                  });
                  {
                    var _a$audio = a.audio,
                        _e169 = _a$audio.isAllowToTalk,
                        _t48 = _a$audio.isComputerAudioLoading,
                        _d7 = _a$audio.canPlayAudio,
                        _u7 = _a$audio.isSpeakerOnly,
                        _a$media = a.media,
                        _p7 = _a$media.audioDecodeStatus,
                        _h6 = _a$media.audioEncodeStatus;
                    if (_t48) return Promise.reject({
                      type: ms,
                      reason: "Computer audio has been loading, please wait."
                    });
                    if (_u7 !== !!s && r(Uc(!!s)), !l) return Promise.reject({
                      type: ms,
                      reason: "Please call `startAudio` method after the `join` has been resolved"
                    });
                    {
                      var _t49 = l.userRole,
                          _a12 = ec(_t49),
                          _u8 = _a12 && !_e169 || s || Uu() ? "success" : _h6,
                          _4 = Uu() ? "success" : _p7;

                      if (E_() && ("success" !== _4 || "success" !== _u8)) return Promise.reject({
                        type: ms,
                        reason: "It is required to wait for the audio encoding and decoding to be ready before calling `startAudio` method"
                      });
                      r(Lc(!0)), Nu("audio", _u8, _4).subscribe(function (t) {
                        var _t50 = _slicedToArray(t, 2),
                            l = _t50[0],
                            u = _t50[1];

                        if (l && u) {
                          var _t51 = _d7 || E_() && !c ? Promise.resolve() : function () {
                            var e = URL.createObjectURL(Da),
                                t = new Audio(e);
                            return t.muted = !1, To() ? new Promise(function (n, r) {
                              var i;
                              t.addEventListener("canplaythrough", function () {
                                t.play().then(function () {
                                  n(!0);
                                }).catch(function (e) {
                                  r(e);
                                }).finally(function () {
                                  URL.revokeObjectURL(e);
                                });
                              }), null === (i = t.load) || void 0 === i || i.call(t);
                            }) : Promise.race([t.play(), new Promise(function (e, t) {
                              window.setTimeout(function () {
                                t();
                              }, 3e3);
                            })]).finally(function () {
                              URL.revokeObjectURL(e);
                            });
                          }();

                          void 0 === _t51 && (_t51 = Promise.resolve()), _t51.then(function () {
                            var t = n(),
                                c = t.audio.isSharingAudio;
                            i.joinOrLeaveVoip(!0), c || y_(o, t, !(_a12 && !_e169 || s)), _a12 && _e169 && r(Bc(!0)), r(zc(!0));
                          }).catch(function () {
                            r(zc(!1)), r(Lc(!1));
                          });
                        } else r(Lc(!1));
                      });
                    }
                    return "failed" === _h6 || "failed" === _p7 ? (r(Lc(!1)), Promise.reject({
                      type: "INTERNAL_ERROR",
                      reason: "audio encode or decode error"
                    })) : new Promise(function (e, t) {
                      mt(Os(as.JoinComputerAudio.success, 1), dt.apply(void 0, _toConsumableArray(as.JoinComputerAudio.fail.map(function (e) {
                        return Os(e, 1).pipe(Je(function () {
                          return me({
                            type: gs,
                            reason: e
                          });
                        }));
                      }))), bt(45e3).pipe(Je(function () {
                        return me({
                          type: "OPERATION_TIMEOUT"
                        });
                      }))).subscribe(function () {
                        r(Lc(!1)), e("");
                      }, function (e) {
                        (e.type === gs || n().audio.canPlayAudio) && i.joinOrLeaveVoip(!1), r(Lc(!1)), t(e);
                      });
                    });
                  }
                }(this[mf], e);
              }
            }, {
              key: "stopAudio",
              value: function stopAudio() {
                return function () {
                  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
                    var _e$store3, t, n, r, i, o, _o$audio, a, s, c, l;

                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _e$store3 = e.store, t = _e$store3.getState, n = _e$store3.dispatch, r = e.mediaAgent, i = e.rwgAgent, o = t(), _o$audio = o.audio, a = _o$audio.isComputerAudioLoading, s = _o$audio.isShareAudioEnabled, c = _o$audio.isSharingAudio, l = sc(o);

                            if (!a) {
                              _context11.next = 3;
                              break;
                            }

                            return _context11.abrupt("return", Promise.reject({
                              type: ms,
                              reason: "Computer audio has not finished joining, please wait."
                            }));

                          case 3:
                            if (!s) {
                              _context11.next = 7;
                              break;
                            }

                            if (!c) {
                              _context11.next = 6;
                              break;
                            }

                            return _context11.abrupt("return", Promise.reject({
                              type: ms,
                              reason: "Cannot stop audio during sharing with audio"
                            }));

                          case 6:
                            n(Fc(void 0)), n(Hc(void 0));

                          case 7:
                            if (!("computer" === (null == l ? void 0 : l.audio))) {
                              _context11.next = 15;
                              break;
                            }

                            _context11.next = 10;
                            return r.leaveComputerAudio();

                          case 10:
                            i.joinOrLeaveVoip(!1);
                            n(Rc(0));
                            _context11.t0 = Ts("AUDIO_CURRENT_USER_LEAVE_AUDIO");
                            _context11.next = 16;
                            break;

                          case 15:
                            _context11.t0 = Promise.resolve("");

                          case 16:
                            return _context11.abrupt("return", _context11.t0);

                          case 17:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11);
                  }));

                  return function (_x29) {
                    return _ref12.apply(this, arguments);
                  };
                }()(this[mf]);
              }
            }, {
              key: "muteAudio",
              value: function muteAudio(e) {
                return function (e, t) {
                  var _e$store4 = e.store,
                      n = _e$store4.getState,
                      r = _e$store4.dispatch,
                      i = e.rwgAgent,
                      o = n(),
                      a = sc(o);
                  if (null == t || t === (null == a ? void 0 : a.userId)) return "" === (null == a ? void 0 : a.audio) || null === (null == a ? void 0 : a.audio) ? Promise.reject({
                    type: ms,
                    reason: "no audio joined"
                  }) : !0 === (null == a ? void 0 : a.muted) ? Promise.resolve("") : (o.audio.isShareAudioEnabled && r(Hc(!0)), r(kc(!0)), i.mute(a.userId, !0), Ts("AUDIO_CURRENT_USER_MUTED").then(function () {
                    return "";
                  }));

                  if (cc(o)) {
                    var _o$participants = o.participants,
                        _e170 = _o$participants.allowTalkAttendeesList,
                        _n43 = _o$participants.attendeesList,
                        _r30 = _e170.concat(_n43).find(function (e) {
                      return e.userId === t;
                    });

                    return _r30 ? "" === _r30.audio || null === _r30 ? Promise.reject({
                      type: ms,
                      reason: "no audio joined"
                    }) : !1 === _r30.muted ? (i.mute(t, !0), Ts("AUDIO_PARTICIPANT_AUDIO_UPDATE", function (e) {
                      return e.id === t && 1 == e.muted;
                    })) : Promise.resolve("") : Promise.reject({
                      type: vs,
                      reason: "no matching user"
                    });
                  }

                  return Promise.reject({
                    type: gs
                  });
                }(this[mf], e);
              }
            }, {
              key: "unmuteAudio",
              value: function unmuteAudio(e) {
                return function () {
                  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e, t) {
                    var _e$store5, n, r, i, o, a, s, _a$audio2, _e171, _t52, _a$participants, _e172, _n44, _r31;

                    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _e$store5 = e.store, n = _e$store5.getState, r = _e$store5.dispatch, i = e.rwgAgent, o = e.mediaAgent, a = n(), s = sc(a);

                            if (!(void 0 === t || t === (null == s ? void 0 : s.userId))) {
                              _context12.next = 26;
                              break;
                            }

                            if (!("" === (null == s ? void 0 : s.audio) || null === (null == s ? void 0 : s.audio))) {
                              _context12.next = 4;
                              break;
                            }

                            return _context12.abrupt("return", Promise.reject({
                              type: ms,
                              reason: "no audio joined"
                            }));

                          case 4:
                            if (!(!1 === (null == s ? void 0 : s.muted))) {
                              _context12.next = 6;
                              break;
                            }

                            return _context12.abrupt("return", Promise.resolve(""));

                          case 6:
                            if (!a.audio.isShareAudioEnabled) {
                              _context12.next = 10;
                              break;
                            }

                            if (!a.audio.isSharingAudio) {
                              _context12.next = 9;
                              break;
                            }

                            return _context12.abrupt("return", Promise.reject({
                              type: ms,
                              reason: "Cannot unmute audio during sharing with audio"
                            }));

                          case 9:
                            r(Hc(!1));

                          case 10:
                            if (!(r(kc(!0)), a.audio.bCanUnmute || null != s && s.isHost || null != s && s.bCoHost)) {
                              _context12.next = 25;
                              break;
                            }

                            if (!ec(s.userRole)) {
                              _context12.next = 24;
                              break;
                            }

                            _a$audio2 = a.audio, _e171 = _a$audio2.isAllowToTalk, _t52 = _a$audio2.isAllowToTalkAttendeeConnected;

                            if (!_e171) {
                              _context12.next = 23;
                              break;
                            }

                            _context12.t0 = _t52;

                            if (_context12.t0) {
                              _context12.next = 21;
                              break;
                            }

                            _context12.next = 18;
                            return o.leaveComputerAudio();

                          case 18:
                            _context12.next = 20;
                            return y_(o, a, !0);

                          case 20:
                            r(Bc(!0));

                          case 21:
                            _context12.next = 24;
                            break;

                          case 23:
                            Promise.reject({
                              type: ms,
                              reason: "Webinar attendee cannot unmute self audio."
                            });

                          case 24:
                            return _context12.abrupt("return", (i.mute(s.userId, !1), Ts("AUDIO_CURRENT_USER_UNMUTED").then(function () {
                              return "";
                            })));

                          case 25:
                            return _context12.abrupt("return", Promise.reject({
                              type: gs,
                              reason: "host not allow unmute themselves"
                            }));

                          case 26:
                            if (!cc(a)) {
                              _context12.next = 29;
                              break;
                            }

                            _a$participants = a.participants, _e172 = _a$participants.allowTalkAttendeesList, _n44 = _a$participants.attendeesList, _r31 = _e172.concat(_n44).find(function (e) {
                              return e.userId === t;
                            });
                            return _context12.abrupt("return", _r31 ? "" === _r31.audio || null === _r31 ? Promise.reject({
                              type: ms,
                              reason: "no audio joined"
                            }) : (!0 === _r31.muted && i.mute(t, !1), Promise.resolve("")) : Promise.reject({
                              type: vs,
                              reason: "no matching user"
                            }));

                          case 29:
                            return _context12.abrupt("return", Promise.reject({
                              type: gs
                            }));

                          case 30:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  }));

                  return function (_x30, _x31) {
                    return _ref13.apply(this, arguments);
                  };
                }()(this[mf], e);
              }
            }, {
              key: "dialOut",
              value: function dialOut(e, t, n, r) {
                return function (e, t, n, r, i) {
                  var _e$store6 = e.store,
                      o = _e$store6.getState,
                      a = _e$store6.dispatch,
                      s = e.rwgAgent,
                      c = o(),
                      _c$meeting = c.meeting,
                      l = _c$meeting.callOutCountry,
                      d = _c$meeting.isSupportCallOut;

                  if (d && Array.isArray(l) && l.findIndex(function (e) {
                    return e.code === t;
                  }) > -1) {
                    var _s$audioDialout = s.audioDialout(t + n, r, !(null == i || !i.callMe), !(null == i || !i.pressingOne), !(null == i || !i.greeting)),
                        _e173 = _s$audioDialout.seq;

                    return a(Sc(_e173)), Is(as.JoinAudioByCallMe);
                  }

                  return Promise.reject({
                    type: vs,
                    reason: "no matching country code"
                  });
                }(this[mf], e, t, n, r);
              }
            }, {
              key: "cancelDialOut",
              value: function cancelDialOut(e, t, n) {
                return function (e, t, n, r) {
                  var i = e.rwgAgent;
                  return i.audioCancelDialout(t + n, !(null == r || !r.callMe)), Is(as.cancelDialOut);
                }(this[mf], e, t, n);
              }
            }, {
              key: "hangup",
              value: function hangup() {
                return function (e) {
                  var t = e.store.getState,
                      n = e.rwgAgent,
                      r = t(),
                      i = sc(r);
                  return "phone" === (null == i ? void 0 : i.audio) && null !== i.userId ? (n.audioDrop(i.userId), Is(as.hangup)) : Promise.reject({
                    type: ms,
                    reason: "not joined audio by phone"
                  });
                }(this[mf]);
              }
            }, {
              key: "switchMicrophone",
              value: function switchMicrophone(e) {
                return function (e, t) {
                  var _e$store7 = e.store,
                      n = _e$store7.getState,
                      r = _e$store7.dispatch,
                      i = e.mediaAgent,
                      _n45 = n(),
                      _n45$audio = _n45.audio,
                      o = _n45$audio.microphoneDevicesList,
                      a = _n45$audio.activeMicrophone;

                  return "default" !== t && -1 == o.findIndex(function (e) {
                    return e.deviceId === t;
                  }) ? Promise.reject({
                    type: "INVALID_DEVICE_ID"
                  }) : (t !== a && (i.changeMicrophone(t), r(jc(t))), Promise.resolve(""));
                }(this[mf], e);
              }
            }, {
              key: "switchSpeaker",
              value: function switchSpeaker(e) {
                return function (e, t) {
                  var _e$store8 = e.store,
                      n = _e$store8.getState,
                      r = _e$store8.dispatch,
                      i = e.mediaAgent,
                      _n46 = n(),
                      _n46$audio = _n46.audio,
                      o = _n46$audio.speakerDevicesList,
                      a = _n46$audio.activeSpeaker;

                  return "default" !== t && -1 == o.findIndex(function (e) {
                    return e.deviceId === t;
                  }) ? Promise.reject({
                    type: "INVALID_DEVICE_ID"
                  }) : (t !== a && (i.changeSpeaker(t), r(Dc(t))), Promise.resolve(""));
                }(this[mf], e);
              }
            }, {
              key: "muteShareAudio",
              value: function muteShareAudio(e) {
                return function (e, t) {
                  var n = e.mediaAgent,
                      r = e.rwgAgent,
                      _e$store9 = e.store,
                      i = _e$store9.getState,
                      o = _e$store9.dispatch,
                      a = i(),
                      s = a.meeting.userId;
                  if (t && t !== s) return Af(t, !0, e.store, n);
                  {
                    var _a$audio3 = a.audio,
                        _e174 = _a$audio3.isSharingAudio,
                        _t53 = _a$audio3.isShareAudioEnabled,
                        _i17 = _a$audio3.isShareAudioMuted;
                    if (!_t53) return Promise.reject({
                      type: ms,
                      reason: "Cannot mute sharing audio when sharing audio is not enable"
                    });
                    if (_i17) return Promise.resolve("");
                    {
                      r.muteShareAudio(!0);

                      var _t54 = Promise.resolve();

                      var c;
                      return _e174 && (_t54 = null === (c = n.leaveSharingAudio(!0)) || void 0 === c ? void 0 : c.then(function () {
                        return w_(n, r, a).then(function (e) {
                          e.forEach(function (e) {
                            return o(e);
                          });
                        });
                      })), b_(n, s, !0, a), Promise.all([Ts({
                        event: "UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE",
                        operations: [pt(function (e) {
                          return void 0 !== e.bShareAudioOn;
                        }), Nt(1)]
                      }, function (e) {
                        return !1 === e.bShareAudioOn;
                      }), _t54]).then(function () {
                        return o(Gc(!0)), _e174 && (o(Kc(!1)), As("SHARE_AUDIO_STATE_CHANGE", {
                          state: "off"
                        })), "";
                      });
                    }
                  }
                }(this[mf], e);
              }
            }, {
              key: "unmuteShareAudio",
              value: function unmuteShareAudio(e) {
                return function (e, t) {
                  var n = e.mediaAgent,
                      r = e.rwgAgent,
                      _e$store10 = e.store,
                      i = _e$store10.getState,
                      o = _e$store10.dispatch,
                      a = i(),
                      s = a.meeting.userId;
                  if (t && t !== s) return Af(t, !1, e.store, n);
                  {
                    var _a$audio4 = a.audio,
                        _e175 = _a$audio4.isSharingAudio,
                        _t55 = _a$audio4.isShareAudioEnabled,
                        _i18 = _a$audio4.isShareAudioMuted,
                        _c8 = a.share.status;
                    if (!_t55) return Promise.reject({
                      type: ms,
                      reason: "Cannot unmute sharing audio when sharing audio is not enable"
                    });
                    if (!1 === _i18) return Promise.resolve("");
                    {
                      r.muteShareAudio(!1);

                      var _t56 = Promise.resolve();

                      return !1 === _e175 && _c8 === Ua.Sharing && (_t56 = x_(n, r, a).then(function (e) {
                        e.forEach(function (e) {
                          return o(e);
                        });
                      })), b_(n, s, !1, a), Promise.all([Ts({
                        event: "UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE",
                        operations: [pt(function (e) {
                          return void 0 !== e.bShareAudioOn;
                        }), Nt(1)]
                      }, function (e) {
                        return !0 === e.bShareAudioOn;
                      }), _t56]).then(function () {
                        return o(Gc(!1)), !1 === _e175 && _c8 === Ua.Sharing && (o(Kc(!0)), As("SHARE_AUDIO_STATE_CHANGE", {
                          state: "on"
                        })), "";
                      });
                    }
                  }
                }(this[mf], e);
              }
            }, {
              key: "subscribeAudioStatisticData",
              value: function subscribeAudioStatisticData(e) {
                return function () {
                  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(e, t) {
                    var n, r, i, _r32, _r32$media, o, a, s, c, l, d, _e176, _t57, _r33;

                    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            n = e.mediaAgent, r = e.store.getState, i = r(), _r32 = r(), _r32$media = _r32.media, o = _r32$media.audioDecodeStatus, a = _r32$media.audioEncodeStatus, s = _r32.audio.isAllowToTalk, c = sc(i), l = !t || t.decode, d = !t || t.encode;

                            if (c) {
                              _context13.next = 3;
                              break;
                            }

                            return _context13.abrupt("return", Promise.reject({
                              type: ms,
                              reason: "Call this function after the 'join' method resolved."
                            }));

                          case 3:
                            _e176 = c.userRole, _t57 = ec(_e176) && !s || Uu() ? "success" : a, _r33 = Uu() ? "success" : o;
                            Nu("audio", _t57, _r33).subscribe(function (e) {
                              var _e177 = _slicedToArray(e, 2),
                                  t = _e177[0],
                                  r = _e177[1];

                              t && r && (l && n.subscribeToQos([_a.AudioDecode], 1e3), d && n.subscribeToQos([_a.AudioEncode], 1e3));
                            });
                            return _context13.abrupt("return", "");

                          case 6:
                          case "end":
                            return _context13.stop();
                        }
                      }
                    }, _callee13);
                  }));

                  return function (_x32, _x33) {
                    return _ref14.apply(this, arguments);
                  };
                }()(this[mf], e);
              }
            }, {
              key: "unsubscribeAudioStatisticData",
              value: function unsubscribeAudioStatisticData(e) {
                return function () {
                  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e, t) {
                    var n, r, i, o;
                    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            n = e.mediaAgent, r = e.store.dispatch, i = !t || t.decode, o = !t || t.encode;
                            return _context14.abrupt("return", (i && (n.unsubscribeFromQos([_a.AudioDecode]), r(Qc($a))), o && (n.unsubscribeFromQos([_a.AudioEncode]), r(Zc($a))), null));

                          case 2:
                          case "end":
                            return _context14.stop();
                        }
                      }
                    }, _callee14);
                  }));

                  return function (_x34, _x35) {
                    return _ref15.apply(this, arguments);
                  };
                }()(this[mf], e);
              }
            }, {
              key: "getMicList",
              value: function getMicList() {
                return function (e) {
                  var t = e.store.getState;
                  var n = t();
                  return n.audio ? _toConsumableArray(n.audio.microphoneDevicesList) : [];
                }(this[mf]);
              }
            }, {
              key: "getSpeakerList",
              value: function getSpeakerList() {
                return function (e) {
                  var t = e.store.getState;
                  var n = t();
                  return n.audio ? _toConsumableArray(n.audio.speakerDevicesList) : [];
                }(this[mf]);
              }
            }, {
              key: "getAudioState",
              value: function getAudioState(e) {
                return function (e, t) {
                  var n = e.store.getState;
                  var r = n(),
                      i = r.meeting.isWebinar;
                  var o = null;
                  return null == t ? o = sc(r) : (o = r.participants.attendeesList.find(function (e) {
                    return e.userId === t;
                  }), i && !o && (o = r.participants.xmppAttendeeList.find(function (e) {
                    return e.userId === t;
                  }))), o ? o.audio : null;
                }(this[mf], e);
              }
            }, {
              key: "isAudioMuted",
              value: function isAudioMuted(e) {
                return function (e, t) {
                  var n = e.store.getState;
                  var r = n(),
                      i = r.meeting.isWebinar;
                  var o = null;
                  return void 0 === t ? o = sc(r) : (o = r.participants.attendeesList.find(function (e) {
                    return e.userId === t;
                  }), i && !o && (o = r.participants.xmppAttendeeList.find(function (e) {
                    return e.userId === t;
                  }))), !!o && !!o.muted;
                }(this[mf], e);
              }
            }, {
              key: "getActiveMicrophone",
              value: function getActiveMicrophone() {
                return function (e) {
                  var t = e.store.getState;
                  var n = t();
                  return n.audio ? n.audio.activeMicrophone : null;
                }(this[mf]);
              }
            }, {
              key: "getActiveSpeaker",
              value: function getActiveSpeaker() {
                return function (e) {
                  var t = e.store.getState;
                  var n = t();
                  return n.audio ? n.audio.activeSpeaker : null;
                }(this[mf]);
              }
            }, {
              key: "isSupportCallOut",
              value: function isSupportCallOut() {
                return function (e) {
                  var t = e.store.getState;

                  var _t58 = t(),
                      _t58$meeting = _t58.meeting,
                      n = _t58$meeting.isSupportCallOut,
                      r = _t58$meeting.callOutCountry;

                  return n && Array.isArray(r) && (null == r ? void 0 : r.length) > 0;
                }(this[mf]);
              }
            }, {
              key: "getDialOutStatus",
              value: function getDialOutStatus() {
                return function (e) {
                  var t = e.store.getState;

                  var _t59 = t(),
                      n = _t59.audio;

                  return null == n ? void 0 : n.dialout.returnCode;
                }(this[mf]);
              }
            }, {
              key: "getDialOutCountries",
              value: function getDialOutCountries() {
                return function (e) {
                  var t = e.store.getState;

                  var _t60 = t(),
                      n = _t60.meeting.callOutCountry;

                  return Array.isArray(n) ? n : [];
                }(this[mf]);
              }
            }, {
              key: "getShareAudioStatus",
              value: function getShareAudioStatus() {
                return function (e) {
                  var t = e.store.getState;

                  var _t61 = t(),
                      _t61$audio = _t61.audio,
                      n = _t61$audio.isShareAudioEnabled,
                      r = _t61$audio.isShareAudioMuted,
                      i = _t61$audio.isSharingAudio;

                  return {
                    isShareAudioEnabled: n,
                    isShareAudioMuted: r,
                    isSharingAudio: i
                  };
                }(this[mf]);
              }
            }, {
              key: "isOthersShareAudioMutedLocally",
              value: function isOthersShareAudioMutedLocally(e) {
                return function (e, t) {
                  var n;
                  var r = e.store.getState;

                  var _r34 = r(),
                      i = _r34.audio.localShareAudioUserMutedList;

                  return null === (n = i.find(function (e) {
                    return e.userId === t;
                  })) || void 0 === n ? void 0 : n.muted;
                }(this[mf], e);
              }
            }, {
              key: "getAudioStatisticData",
              value: function getAudioStatisticData() {
                return function (e) {
                  var t = e.store.getState;

                  var _t62 = t(),
                      n = _t62.audio.statistic;

                  return f({}, n);
                }(this[mf]);
              }
            }, {
              key: "startVideo",
              value: function startVideo(e) {
                return Nf(this[mf], e);
              }
            }, {
              key: "stopVideo",
              value: function stopVideo() {
                return Pf(this[mf]);
              }
            }, {
              key: "switchCamera",
              value: function switchCamera(e) {
                return function (e, t) {
                  var _e$store11 = e.store,
                      n = _e$store11.getState,
                      r = _e$store11.dispatch,
                      i = e.mediaAgent,
                      o = n(),
                      _o$video2 = o.video,
                      a = _o$video2.cameraDevicesList,
                      s = _o$video2.isCurrentUserStartedVideo,
                      c = _o$video2.virtualBackground;
                  return F_(t, a) ? ((s || null != c && c.isVBConfigured) && i.changeCamera(t), r(wl(t)), Promise.resolve()) : Promise.reject({
                    type: vs,
                    reason: "Cannot find cameraDeviceId in camera devices list."
                  });
                }(this[mf], e);
              }
            }, {
              key: "renderVideo",
              value: function renderVideo(e, t, n, r, i, o, a, s, c) {
                return function (e, t, n, r, i, o, a, s, c, l) {
                  var _e$store12 = e.store,
                      d = _e$store12.getState,
                      u = _e$store12.dispatch,
                      p = e.mediaAgent,
                      h = e.rwgAgent,
                      _ = d(),
                      f = _.meeting.userId,
                      m = _.media.enforceMultipleVideos,
                      _$video = _.video,
                      g = _$video.subscribedVideoList,
                      v = _$video.renderedVideoList;

                  if (!t) return Promise.reject({
                    type: vs,
                    reason: "Received canvas is falsy"
                  });
                  var b = zo(!!m);
                  if (!g.includes(n) && g.length >= b && new Set(v.map(function (e) {
                    return e.canvasId;
                  })).has(t.id)) return Promise.reject({
                    type: ms,
                    reason: "subscribe video counts greater than maximum size (".concat(b, ")")
                  });
                  if (-1 === Rf(_).findIndex(function (e) {
                    return e.userId === n;
                  })) return Promise.reject({
                    type: vs,
                    reason: "user is not send video"
                  });
                  var y = !!l,
                      w = _.media.videoDecodeStatus;
                  return t.id || (t.id = "__ZOOM_SDK_VIDEO_CANVAS_@__".replace("@", "".concat(Math.floor(1e4 * Math.random())))), Nu("video", "success", w).subscribe(function (e) {
                    var _e178 = _slicedToArray(e, 1),
                        _ = _e178[0];

                    if (_) {
                      var _d8 = d(),
                          _d8$video = _d8.video,
                          _e179 = _d8$video.isVerifiedVideoRenderCanvasAfterFailover,
                          _5 = _d8$video.highDefinitionVideoId,
                          _m4 = _d8$video.isSupportHDVideo,
                          _v4 = _d8$video.renderedVideoList,
                          _b4 = _d8$video.receivedVideoMaxQuality;

                      var _w3 = t;
                      !1 === _e179 && (_w3 = zu(t), u(Ol(!0)));

                      var _S4 = n === f,
                          _x36 = c || "__ZOOM_SDK_VIDEO_ZONE__";

                      var _E4 = s;
                      if (s === Ba.Video_720P && (_m4 ? _5 ? _5 !== n && (_S4 || console.warn("Warning: Web Video SDK currently only supports subscribing to one 720p video stream, so quality has been downgraded to 360p"), _E4 = Ba.Video_360P) : u(Hl(n)) : (console.warn("Can not subscribe 720P video stream,will downgrade to 360P stream"), _E4 = Ba.Video_360P)), _v4.some(function (e) {
                        return e.userId === n && e.key === _x36 && e.canvasId === _w3.id;
                      }) || p.renderVideo(_w3.id, n, _x36, r, i, o, a, _E4, _S4, l || "", y), n === _5 && _E4 === Ba.Video_720P) ;else {
                        var _e180 = Math.max(_b4, Ba.Video_360P),
                            _t63 = Math.min(_E4, _e180);

                        h.subscribeVideo(n, _t63, !1);
                      }
                      g.includes(n) || u(jl(n)), _5 === n && _E4 !== Ba.Video_720P && u(Hl(void 0)), u(Ll({
                        userId: n,
                        key: _x36,
                        canvasId: _w3.id,
                        videoQuality: _E4
                      }));
                    }
                  }), "failed" === w ? Promise.reject({
                    type: "INTERNAL_ERROR",
                    reason: "Video  decode status is failed"
                  }) : Promise.resolve("");
                }(this[mf], e, t, n, r, i, o, a, s, c);
              }
            }, {
              key: "stopRenderVideo",
              value: function stopRenderVideo(e, t, n, r) {
                var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return function (e, t, n, r, i) {
                  var o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
                  var _e$store13 = e.store,
                      a = _e$store13.getState,
                      s = _e$store13.dispatch,
                      c = e.mediaAgent,
                      l = e.rwgAgent,
                      d = a(),
                      _d$video = d.video,
                      u = _d$video.subscribedVideoList,
                      p = _d$video.renderedVideoList,
                      h = _d$video.highDefinitionVideoId;
                  if (!t || !t.id) return Promise.reject({
                    type: vs,
                    reason: "canvas is falsy"
                  });

                  if (u.includes(n)) {
                    var _e181 = r || "__ZOOM_SDK_VIDEO_ZONE__";

                    p.find(function (t) {
                      return t.userId === n && t.key === _e181;
                    }) && (c.stopRenderVideo(t.id, n, _e181, U_(i), o), 1 == p.filter(function (e) {
                      return e.userId === n;
                    }).length && (l.unsubscribeVideo(n), s(Dl(n)), h === n && s(Hl(void 0))), s(Ul({
                      userId: n,
                      key: _e181,
                      canvasId: t.id
                    })));
                  }

                  return Promise.resolve("");
                }(this[mf], e, t, n, r, i);
              }
            }, {
              key: "updateVideoCanvasDimension",
              value: function updateVideoCanvasDimension(e, t, n) {
                return function (e, t, n, r) {
                  var i = e.mediaAgent;
                  return t && t.id ? (i.updateRenderedVideoCanvasDimension(t.id, n, r), Promise.resolve("")) : Promise.reject({
                    type: vs,
                    reason: "canvas is falsy"
                  });
                }(this[mf], e, t, n);
              }
            }, {
              key: "adjustRenderedVideoPosition",
              value: function adjustRenderedVideoPosition(e, t, n, r, i, o, a) {
                return function (e, t, n, r, i, o, a, s) {
                  var c = e.store.getState,
                      l = e.mediaAgent;
                  if (!t || !t.id) return Promise.reject({
                    type: vs,
                    reason: "canvas is falsy"
                  });

                  var _c9 = c(),
                      d = _c9.video.subscribedVideoList;

                  return d.includes(n) ? (l.adjustRenderedVideoPosition(t.id, n, s || "__ZOOM_SDK_VIDEO_ZONE__", o, a, r, i, U_("#000")), Promise.resolve("")) : Promise.reject({
                    type: vs,
                    reason: "userId is not correct"
                  });
                }(this[mf], e, t, n, r, i, o, a);
              }
            }, {
              key: "clearVideoCanvas",
              value: function clearVideoCanvas(e, t) {
                return function (e, t, n) {
                  var r = e.mediaAgent;
                  return t && t.id ? (r.clearVideoCanvas(t.id, U_(n)), Promise.resolve("")) : Promise.reject({
                    type: vs,
                    reason: "canvas is falsy"
                  });
                }(this[mf], e, t);
              }
            }, {
              key: "mirrorVideo",
              value: function mirrorVideo(e) {
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.mediaAgent,
                      _n47 = n(),
                      _n47$video = _n47.video,
                      i = _n47$video.isCurrentUserStartedVideo,
                      o = _n47$video.virtualBackground;

                  return (i || null != o && o.isVBConfigured) && r.mirrorVideo(t), Promise.resolve("");
                }(this[mf], e);
              }
            }, {
              key: "enableHardwareAcceleration",
              value: function enableHardwareAcceleration(e) {
                return function (e, t) {
                  var _e$store14 = e.store,
                      n = _e$store14.getState,
                      r = _e$store14.dispatch,
                      i = e.mediaAgent,
                      _n48 = n(),
                      o = _n48.video.isSupportHDVideo;

                  if ("boolean" == typeof t || void 0 !== t.decode) {
                    var _e182 = "boolean" == typeof t ? t : !!t.decode;

                    return _e182 ? ma.isSupportVideoDecodeHardwareAcceleration().then(function (e) {
                      return e && i.enableHardwareAccelerationForVideoDecode(e), r(Ql({
                        decode: e
                      })), e;
                    }) : (i.enableHardwareAccelerationForVideoDecode(_e182), r(Ql({
                      decode: _e182
                    })), Promise.resolve(!0));
                  }

                  if ("boolean" == typeof t || void 0 !== t.encode) {
                    var _e183 = "boolean" == typeof t ? t : !!t.encode;

                    if (o) {
                      if (!_e183) return i.enableHardwareAccelerationForVideoEncode(!1), r(Ql({
                        encode: !1
                      })), Promise.resolve(!0);
                      if (ma.isCompatibleHardwareForEncode()) return ma.isSupportVideoEncodeHardwareAcceleration().then(function (e) {
                        return e && i.enableHardwareAccelerationForVideoEncode(e), r(Ql({
                          encode: e
                        })), e;
                      });
                      console.warn("Can not turn on hardware acceleration with your graphic card due to the technical limitation");
                    } else "boolean" != typeof t && null != t && t.encode && console.warn("Can not use the hardware acceleration for video encoding due to the account restriction");
                  }

                  return Promise.resolve(!1);
                }(this[mf], e);
              }
            }, {
              key: "subscribeVideoStatisticData",
              value: function subscribeVideoStatisticData(e) {
                return function () {
                  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(e, t) {
                    var n, r, _r35, _r35$media, i, o, a, s;

                    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            n = e.mediaAgent, r = e.store.getState, _r35 = r(), _r35$media = _r35.media, i = _r35$media.videoDecodeStatus, o = _r35$media.videoEncodeStatus, a = !t || t.decode, s = !t || t.encode;
                            return _context15.abrupt("return", (Nu("video", o, i).subscribe(function (e) {
                              var _e184 = _slicedToArray(e, 2),
                                  r = _e184[0],
                                  i = _e184[1];

                              a && i && n.subscribeToQos([_a.VideoDecode], 1e3), s && r && n.subscribeToQos([_a.VideoEncode], 1e3), null != t && t.detailed && i && n.enableVideoObserver(!0);
                            }), null));

                          case 2:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15);
                  }));

                  return function (_x37, _x38) {
                    return _ref16.apply(this, arguments);
                  };
                }()(this[mf], e);
              }
            }, {
              key: "unsubscribeVideoStatisticData",
              value: function unsubscribeVideoStatisticData(e) {
                return function () {
                  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e, t) {
                    var n, r, i, o;
                    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            n = e.mediaAgent, r = e.store.dispatch, i = !t || t.decode, o = !t || t.encode;
                            return _context16.abrupt("return", (i && (n.unsubscribeFromQos([_a.VideoDecode]), r(Gl(Xa))), o && (n.unsubscribeFromQos([_a.VideoEncode]), r(Kl(Xa))), null != t && t.detailed && n.enableVideoObserver(!1), null));

                          case 2:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16);
                  }));

                  return function (_x39, _x40) {
                    return _ref17.apply(this, arguments);
                  };
                }()(this[mf], e);
              }
            }, {
              key: "previewVirtualBackground",
              value: function previewVirtualBackground(e, t, n) {
                return function (e, t, n, r) {
                  var _e$store15 = e.store,
                      i = _e$store15.getState,
                      o = _e$store15.dispatch,
                      a = e.mediaAgent,
                      s = i(),
                      _s$video = s.video,
                      c = _s$video.activeCamera,
                      l = _s$video.virtualBackground.isVBPreloadReady,
                      d = _s$video.isCurrentUserStartedVideo;
                  var u;
                  return B_(l).subscribe(function (e) {
                    e && V_({
                      imageUrl: n,
                      cropped: r,
                      captureWidth: 0,
                      captureHeight: 0,
                      cameraId: c
                    }, a, s, t).then(function (e) {
                      u = e;
                    });
                  }), (d ? Promise.resolve(!0).then(function () {
                    return o(Fl(!0)), !0;
                  }) : Os("VIDEO_VIRTUAL_BACKGROUND_SETTING_SUCCESS", 1).toPromise()).then(function (e) {
                    var t, i;
                    return null === (t = u) || void 0 === t || null === (i = t.parentNode) || void 0 === i || i.removeChild(u), e ? (o(Wl({
                      imageSrc: n,
                      cropped: r
                    })), !0) : Promise.reject({
                      type: ms,
                      reason: "Cannot preview virtual background"
                    });
                  });
                }(this[mf], e, t, n);
              }
            }, {
              key: "updateVirtualBackgroundImage",
              value: function updateVirtualBackgroundImage(e, t) {
                return function (e, t, n) {
                  var _e$store16 = e.store,
                      r = _e$store16.getState,
                      i = _e$store16.dispatch,
                      o = e.mediaAgent,
                      a = r(),
                      _a$video$virtualBackg = a.video.virtualBackground,
                      s = _a$video$virtualBackg.isVBConfigured,
                      c = _a$video$virtualBackg.imageSrc,
                      l = _a$video$virtualBackg.cropped;
                  return s ? t === c && n === l ? Promise.resolve(!0) : q_(t, n, o).then(function () {
                    return i(Wl({
                      imageSrc: t,
                      cropped: n
                    })), !0;
                  }).catch(function () {
                    return Promise.reject({
                      type: vs,
                      reason: "Cannot load the image"
                    });
                  }) : Promise.reject({
                    type: ms,
                    reason: "Cannot update vitrual background image, please preview or start video with virtual background first."
                  });
                }(this[mf], e, t);
              }
            }, {
              key: "stopPreviewVirtualBackground",
              value: function stopPreviewVirtualBackground() {
                return function (e) {
                  var t = e.store.getState,
                      n = e.mediaAgent,
                      _t64 = t(),
                      r = _t64.video.virtualBackground.isVBConfigured;

                  return r ? (n.stopVirtualBackgroundSetting(), Promise.resolve(!0)) : Promise.reject({
                    type: ms,
                    reason: "Cannot stop preview virtual background before start"
                  });
                }(this[mf]);
              }
            }, {
              key: "isCapturingVideo",
              value: function isCapturingVideo() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.video && n.video.isCurrentUserStartedVideo;
                }(this[mf]);
              }
            }, {
              key: "isCameraTaken",
              value: function isCameraTaken() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.video && n.video.isCameraTaken;
                }(this[mf]);
              }
            }, {
              key: "isCaptureForbidden",
              value: function isCaptureForbidden() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.video && n.video.isCaptureForbidden;
                }(this[mf]);
              }
            }, {
              key: "getCameraList",
              value: function getCameraList() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  if (!n.video) return [];
                  var r = n.video.cameraDevicesList;
                  return r.map(function (e) {
                    return Object.assign({}, e);
                  });
                }(this[mf]);
              }
            }, {
              key: "getActiveCamera",
              value: function getActiveCamera() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return n.video ? n.video.activeCamera : "";
                }(this[mf]);
              }
            }, {
              key: "getActiveVideoId",
              value: function getActiveVideoId() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return n.video ? n.video.activeVideoId : 0;
                }(this[mf]);
              }
            }, {
              key: "getVideoMaxQuality",
              value: function getVideoMaxQuality() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return n.video ? n.video.receivedVideoMaxQuality : Ba.Video_90P;
                }(this[mf]);
              }
            }, {
              key: "getReceivedVideoDimension",
              value: function getReceivedVideoDimension() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return n.video ? n.video.receivedVideoDimension : null;
                }(this[mf]);
              }
            }, {
              key: "isSupportMultipleVideos",
              value: function isSupportMultipleVideos() {
                return jf();
              }
            }, {
              key: "isSupportHDVideo",
              value: function isSupportHDVideo() {
                return function (e) {
                  var t;
                  var n = e.store.getState;
                  return null === (t = n().video) || void 0 === t ? void 0 : t.isSupportHDVideo;
                }(this[mf]);
              }
            }, {
              key: "getHardwareAccelerationStatus",
              value: function getHardwareAccelerationStatus() {
                return function (e) {
                  var t;
                  var n = e.store.getState;
                  return null === (t = n().video) || void 0 === t ? void 0 : t.hardwareAcceleration;
                }(this[mf]);
              }
            }, {
              key: "getVideoStatisticData",
              value: function getVideoStatisticData() {
                return function (e) {
                  var t = e.store.getState;

                  var _t65 = t(),
                      n = _t65.video.statistic;

                  return f({}, n);
                }(this[mf]);
              }
            }, {
              key: "isSupportVirtualBackground",
              value: function isSupportVirtualBackground() {
                return Vu();
              }
            }, {
              key: "getVirtualbackgroundStatus",
              value: function getVirtualbackgroundStatus() {
                return function (e) {
                  var t = e.store.getState;
                  return f({}, t().video.virtualBackground);
                }(this[mf]);
              }
            }, {
              key: "startShareView",
              value: function startShareView(e, t, n) {
                return function (e, t, n, r) {
                  var _e$store17 = e.store,
                      i = _e$store17.getState,
                      o = _e$store17.dispatch,
                      a = e.mediaAgent,
                      s = e.rwgAgent,
                      _i19 = i(),
                      _i19$share = _i19.share,
                      c = _i19$share.isReceiveSharing,
                      l = _i19$share.isRemoteSharingActive,
                      d = _i19$share.activeNodeId,
                      u = _i19$share.activeSsrc,
                      p = _i19$share.shareQuality,
                      h = _i19$share.status,
                      _ = _i19$share.isVerifiedRenderCanvasAfterFailover,
                      f = _i19$share.isReceiveSharingFromMainSession,
                      m = _i19.media.sharingDecodeStatus;

                  if (!t || n !== d) return Promise.reject({
                    type: vs,
                    reason: ""
                  });
                  if (!l || c || h !== Ua.End) return Promise.reject({
                    type: ms,
                    reason: ""
                  });
                  var g = !!r;
                  return Nu("sharing", "success", m).subscribe(function (e) {
                    var _e185 = _slicedToArray(e, 2),
                        c = _e185[1];

                    if (c) {
                      var _e186 = t;
                      !1 === _ && (_e186 = zu(t), o(dl(!0))), o(el(!0)), s.subscribeSharing(n, p, f), a.renderSharing(u, _e186, g, r, f);

                      var _i20 = i(),
                          _c10 = _i20.audio;

                      if (null != _c10 && _c10.localShareAudioUserMutedList) {
                        var _e187 = _c10.localShareAudioUserMutedList.find(function (e) {
                          return e.userId === n;
                        });

                        _e187 && a.setSharingAudioVolume(n, _e187.muted, _e187.isFromMainSession);
                      }
                    }
                  }), "failed" === m ? Promise.reject({
                    type: "INTERNAL_ERROR",
                    reason: ""
                  }) : Ts("SHARE_RECEIVED_DIMENSION_CHANGE", function (e) {
                    return !!e;
                  }, 6e4);
                }(this[mf], e, t, n);
              }
            }, {
              key: "stopShareView",
              value: function stopShareView() {
                return function (e) {
                  var _e$store18 = e.store,
                      t = _e$store18.dispatch,
                      n = _e$store18.getState,
                      r = e.rwgAgent,
                      i = e.mediaAgent,
                      _n49 = n(),
                      _n49$share = _n49.share,
                      o = _n49$share.isReceiveSharing,
                      a = _n49$share.activeNodeId,
                      s = _n49.breakoutRoom;

                  if (!o) return Promise.resolve("");
                  var c = !1;
                  return (null == s ? void 0 : s.currentRoom.status) === ic.InRoom && s.mainSessionAttendeeList.length > 0 && (c = s.mainSessionAttendeeList.findIndex(function (e) {
                    return e.userId === a;
                  }) > -1), i.stopRenderSharing(), r.unsubscribeSharing(a, c), t(el(!1)), Promise.resolve("");
                }(this[mf]);
              }
            }, {
              key: "switchShareView",
              value: function switchShareView(e) {
                return function (e, t) {
                  var _e$store19 = e.store,
                      n = _e$store19.getState,
                      r = _e$store19.dispatch,
                      i = e.rwgAgent,
                      o = e.mediaAgent,
                      a = n(),
                      _a$share = a.share,
                      s = _a$share.isReceiveSharing,
                      c = _a$share.activeNodeId,
                      l = _a$share.isRemoteControlApproved,
                      d = _a$share.isGrabRemoteControl,
                      u = _a$share.shareQuality,
                      p = _a$share.isReceiveSharingFromMainSession,
                      h = a.audio,
                      _ = a.breakoutRoom;
                  if (!s) return Promise.reject({
                    type: ms
                  });
                  if (t === c) return Promise.resolve("");
                  var f = [];
                  return f = p ? _.mainSessionAttendeeList.filter(function (e) {
                    return e.bShareToBORooms && e.sharerOn;
                  }) : Eu(a), f.findIndex(function (e) {
                    return e.userId === c;
                  }) > -1 ? (l && (d && i.subscribeGrabRemoteControl(c, !1), i.sharingRequestRemoteControl(c, !1)), i.unsubscribeSharing(c, p), i.subscribeSharing(t, u, p), o.switchSharingSource(t, p), null == h || h.localShareAudioUserMutedList.forEach(function (e) {
                    o.setSharingAudioVolume(t, e.userId !== t || e.muted, e.isFromMainSession);
                  }), r(Xc({
                    bStatus: 1,
                    activeNodeID: t,
                    ssrc: t
                  })), Promise.resolve("")) : Promise.reject({
                    type: vs,
                    reason: "no matching user id"
                  });
                }(this[mf], e);
              }
            }, {
              key: "updateSharingCanvasDimension",
              value: function updateSharingCanvasDimension(e, t) {
                return function (e, t, n) {
                  var r = e.store.getState,
                      i = e.mediaAgent,
                      o = r(),
                      a = o.share.isReceiveSharing;
                  return a && i.updateRenderedSharingDimension(t, n), Promise.resolve("");
                }(this[mf], e, t);
              }
            }, {
              key: "startShareScreen",
              value: function startShareScreen(e, t) {
                return function (e, t, n) {
                  var r;
                  var _e$store20 = e.store,
                      i = _e$store20.getState,
                      o = _e$store20.dispatch,
                      a = e.mediaAgent,
                      s = i(),
                      _s$meeting = s.meeting,
                      c = _s$meeting.bIbDisableShare,
                      l = _s$meeting.meetingOptions,
                      _s$share = s.share,
                      d = _s$share.sharePrivilege,
                      u = _s$share.ssrc,
                      p = _s$share.isChromeExtensionInstalled,
                      h = _s$share.isVerifiedCaptureCanvasAfterFailover,
                      _ = _s$share.isReceiveSharingFromMainSession,
                      m = s.media.sharingEncodeStatus,
                      g = s.breakoutRoom;
                  if (c) return Promise.reject({
                    type: ms,
                    reason: "information barrier"
                  });
                  if ("function" != typeof (null === (r = navigator.mediaDevices) || void 0 === r ? void 0 : r.getDisplayMedia)) return Promise.reject({
                    type: ms,
                    reason: "Unable to share your screen due to the technical limitation"
                  });
                  if (_) return Promise.reject({
                    type: ms,
                    reason: "Unable to share your screen while someone is sharing from the main session"
                  });
                  if (jo() && !(t instanceof HTMLVideoElement)) return Promise.reject({
                    type: vs,
                    reason: "Use Video element instead of Canvas element when WebCodecs enabled"
                  });
                  var v = cc(s);

                  if (null != n && n.broadcastToBreakoutRoom) {
                    if (!v || (null == g ? void 0 : g.currentRoom.status) === ic.InRoom) return v ? Promise.reject({
                      type: ms,
                      reason: "Unable to share screen to breakout room when in the room"
                    }) : Promise.reject({
                      type: gs
                    });
                    o(_l(!0));
                  } else o(_l(!1));

                  var b = Eu(s);
                  if (d === La.OnlyHost && !v) return Promise.reject({
                    type: gs,
                    reason: "only host can start screen share"
                  });
                  if (d === La.HostGrab && !v && b.length > 0) return Promise.reject({
                    type: gs,
                    reason: "only host can grab screen share"
                  });
                  var y = sc(s);
                  if (!0 === (null == y ? void 0 : y.sharerOn)) return Promise.reject({
                    type: ms,
                    reason: "you have already started screen share."
                  });
                  var w = fe(!0);
                  return function () {
                    var e;
                    return Io() && "function" != typeof (null === (e = navigator.mediaDevices) || void 0 === e ? void 0 : e.getDisplayMedia);
                  }() && !p && (a.checkChromeSharingExtension(), w = Os("SHARE_CHECK_CHROME_SHARING_EXTENSION", 1)), t.id || (t.id = "__ZOOM_SDK_SHARE_CANVAS_@__".replace("@", "".concat(Math.floor(1e4 * Math.random())))), rt([Nu("sharing", m, "success"), w]).subscribe(function (e) {
                    var _e188 = _slicedToArray(e, 2),
                        r = _e188[0],
                        i = _e188[1];

                    var _r36 = _slicedToArray(r, 1),
                        s = _r36[0];

                    if (s && i) {
                      !1 === h && (zu(t), o(ul(!0)));

                      var _e189 = document.querySelector("#".concat("__ZOOM_SDK_SHARING_VIDEO__"));

                      _e189 && "VIDEO" === _e189.tagName || (_e189 = document.createElement("video"), _e189.id = "__ZOOM_SDK_SHARING_VIDEO__", _e189.style.display = "none", document.body.appendChild(_e189));

                      var _r37 = null != n && n.secondaryCameraId ? {
                        cameraId: n.secondaryCameraId,
                        width: n.captureWidth,
                        height: n.captureHeight
                      } : void 0;

                      a.startDesktopSharing(u, t.id, "__ZOOM_SDK_SHARING_VIDEO__", _r37, null == l || !l.isDisableShareAudioIntoBo || !(null != n && n.broadcastToBreakoutRoom)), o(fl(!!_r37));
                    }
                  }), new Promise(function (e, t) {
                    mt(Os("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", 1), Os("SHARE_CHECK_CHROME_SHARING_EXTENSION").pipe(pt(function (e) {
                      return !e;
                    }), Nt(1), qt(me({
                      reason: "required extension",
                      extensionUrl: "https://chrome.google.com/webstore/detail/zoom-scheduler/kgjfgplpablkjnlkjmjdecgdpfankdle"
                    }))), Os("SHARE_START_DESKTOP_SHARE_FAILED", 1).pipe(Je(function (e) {
                      return me({
                        reason: e.reason || "user deny screen share"
                      });
                    }))).subscribe(function (n) {
                      if (!0 === n.sharerOn) {
                        var _i21 = i(),
                            _t66 = _i21.share.isSharingToBreakoutRoom,
                            _n50 = _i21.meeting.meetingOptions,
                            _r38 = !(null != _n50 && _n50.isDisableShareAudioIntoBo || !_t66);

                        a.enableShareAudioToBreakoutRoom(_r38), e("");
                      } else t({
                        type: "INTERNAL_ERROR"
                      });
                    }, function (e) {
                      t(f({
                        type: ms
                      }, e));
                    });
                  });
                }(this[mf], e, t);
              }
            }, {
              key: "stopShareScreen",
              value: function stopShareScreen() {
                return function (e) {
                  var _e$store21 = e.store,
                      t = _e$store21.getState,
                      n = _e$store21.dispatch,
                      r = e.rwgAgent,
                      i = e.mediaAgent,
                      _t67 = t(),
                      o = _t67.share.status,
                      a = _t67.meeting.userId;

                  return o === Ua.End ? Promise.resolve("") : (n(il(Ua.End)), r.stopSharing(a), i.stopDesktopSharing(), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (e) {
                    return !1 === e.sharerOn;
                  }));
                }(this[mf]);
              }
            }, {
              key: "pauseShareScreen",
              value: function pauseShareScreen() {
                return function (e) {
                  var _e$store22 = e.store,
                      t = _e$store22.getState,
                      n = _e$store22.dispatch,
                      r = e.rwgAgent,
                      i = e.mediaAgent,
                      _t68 = t(),
                      o = _t68.share.status;

                  return o === Ua.Sharing ? (r.pauseSharing(), i.pauseDesktopSharing(), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (e) {
                    return !0 === e.sharerPause;
                  }).then(function () {
                    return n(il(Ua.Paused)), "";
                  })) : Promise.reject({
                    type: ms
                  });
                }(this[mf]);
              }
            }, {
              key: "resumeShareScreen",
              value: function resumeShareScreen() {
                return function (e) {
                  var _e$store23 = e.store,
                      t = _e$store23.getState,
                      n = _e$store23.dispatch,
                      r = e.rwgAgent,
                      i = e.mediaAgent,
                      _t69 = t(),
                      o = _t69.share.status;

                  return o === Ua.Paused ? (r.resumeSharing(), i.resumeDesktopSharing(), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (e) {
                    return !0 === e.sharerOn && !1 === e.sharerPause;
                  }).then(function () {
                    return n(il(Ua.Sharing)), "";
                  })) : Promise.reject({
                    type: ms
                  });
                }(this[mf]);
              }
            }, {
              key: "setSharePrivilege",
              value: function setSharePrivilege(e) {
                return If(this[mf], e);
              }
            }, {
              key: "lockShare",
              value: function lockShare(e) {
                return function (e, t) {
                  return If(e, t ? La.OnlyHost : La.HostGrab);
                }(this[mf], e);
              }
            }, {
              key: "shareToBreakoutRoom",
              value: function shareToBreakoutRoom() {
                return function (e) {
                  var _e$store24 = e.store,
                      t = _e$store24.getState,
                      n = _e$store24.dispatch,
                      r = e.rwgAgent,
                      i = e.mediaAgent,
                      _t70 = t(),
                      o = _t70.meeting.userId,
                      a = _t70.breakoutRoom,
                      _t70$share = _t70.share,
                      s = _t70$share.isSharingToBreakoutRoom,
                      c = _t70$share.status;

                  return c === Ua.End ? Promise.reject({
                    type: ms,
                    reason: "Invalid sharing status"
                  }) : s ? Promise.resolve("") : a.currentRoom.status === ic.InRoom ? Promise.reject({
                    type: ms,
                    reason: "Unable to share screen to breakout room when in the room"
                  }) : (r.startShareToBreakoutRoom(o), n(_l(!0)), i.enableShareAudioToBreakoutRoom(!0), Promise.resolve(""));
                }(this[mf]);
              }
            }, {
              key: "stopShareToBreakoutRoom",
              value: function stopShareToBreakoutRoom() {
                return function (e) {
                  var _e$store25 = e.store,
                      t = _e$store25.getState,
                      n = _e$store25.dispatch,
                      r = e.rwgAgent,
                      i = e.mediaAgent,
                      _t71 = t(),
                      o = _t71.meeting.userId,
                      a = _t71.share.isSharingToBreakoutRoom;

                  return a && (r.stopShareToBreakoutRoom(o), n(_l(!1)), i.enableShareAudioToBreakoutRoom(!1)), Promise.resolve("");
                }(this[mf]);
              }
            }, {
              key: "getShareUserList",
              value: function getShareUserList() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  if (!n.share) return [];
                  var r = n.share.isReceiveSharingFromMainSession;

                  if (r) {
                    var _e190 = n.breakoutRoom.mainSessionAttendeeList;
                    return _e190.filter(function (e) {
                      return e.bShareToBORooms && (e.sharerOn || e.sharerPause);
                    }).map(function (e) {
                      return {
                        userId: e.userId,
                        displayName: e.displayName,
                        audio: e.audio,
                        muted: e.muted,
                        isHost: e.isHost,
                        isCoHost: e.bCoHost,
                        avatar: e.avatar,
                        bVideoOn: e.bVideoOn,
                        sharerOn: e.sharerOn,
                        sharePause: e.sharerPause,
                        shareToBORooms: e.bShareToBORooms
                      };
                    });
                  }

                  return Eu(n).map(function (e) {
                    return {
                      userId: e.userId,
                      displayName: e.displayName,
                      audio: e.audio,
                      muted: e.muted,
                      isHost: e.isHost,
                      isCoHost: e.bCoHost,
                      avatar: e.avatar,
                      bVideoOn: e.bVideoOn,
                      sharerOn: e.sharerOn,
                      sharePause: e.sharerPause
                    };
                  });
                }(this[mf]);
              }
            }, {
              key: "getActiveShareUserId",
              value: function getActiveShareUserId() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return n.share && n.share.isRemoteSharingActive ? n.share.activeNodeId : 0;
                }(this[mf]);
              }
            }, {
              key: "isReceiveSharing",
              value: function isReceiveSharing() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.share && n.share.isReceiveSharing;
                }(this[mf]);
              }
            }, {
              key: "getShareViewDimension",
              value: function getShareViewDimension() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();

                  if (n.share) {
                    if (n.share.status !== Ua.End) return f({}, n.share.shareDimension);
                    {
                      var _e191 = n.share.receivedShareDimension;
                      return {
                        width: _e191.width,
                        height: _e191.height
                      };
                    }
                  }

                  return null;
                }(this[mf]);
              }
            }, {
              key: "getShareStatus",
              value: function getShareStatus() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return n.share ? n.share.status : null;
                }(this[mf]);
              }
            }, {
              key: "isShareLocked",
              value: function isShareLocked() {
                return Of(this[mf]);
              }
            }, {
              key: "isReceiveSharingFromMainSession",
              value: function isReceiveSharingFromMainSession() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.share && n.share.isReceiveSharingFromMainSession;
                }(this[mf]);
              }
            }]);

            return Em;
          }(Df)).prototype, "startAudio", [gf, zf], Object.getOwnPropertyDescriptor(Em.prototype, "startAudio"), Em.prototype), v(Em.prototype, "stopAudio", [gf, Mf], Object.getOwnPropertyDescriptor(Em.prototype, "stopAudio"), Em.prototype), v(Em.prototype, "muteAudio", [gf, Lf], Object.getOwnPropertyDescriptor(Em.prototype, "muteAudio"), Em.prototype), v(Em.prototype, "unmuteAudio", [gf, Uf], Object.getOwnPropertyDescriptor(Em.prototype, "unmuteAudio"), Em.prototype), v(Em.prototype, "dialOut", [gf, Bf], Object.getOwnPropertyDescriptor(Em.prototype, "dialOut"), Em.prototype), v(Em.prototype, "cancelDialOut", [gf, Hf], Object.getOwnPropertyDescriptor(Em.prototype, "cancelDialOut"), Em.prototype), v(Em.prototype, "hangup", [gf, Vf], Object.getOwnPropertyDescriptor(Em.prototype, "hangup"), Em.prototype), v(Em.prototype, "switchMicrophone", [gf, qf], Object.getOwnPropertyDescriptor(Em.prototype, "switchMicrophone"), Em.prototype), v(Em.prototype, "switchSpeaker", [gf, Ff], Object.getOwnPropertyDescriptor(Em.prototype, "switchSpeaker"), Em.prototype), v(Em.prototype, "muteShareAudio", [gf, Wf, Gf], Object.getOwnPropertyDescriptor(Em.prototype, "muteShareAudio"), Em.prototype), v(Em.prototype, "unmuteShareAudio", [gf, Kf, Qf], Object.getOwnPropertyDescriptor(Em.prototype, "unmuteShareAudio"), Em.prototype), v(Em.prototype, "subscribeAudioStatisticData", [gf, Zf], Object.getOwnPropertyDescriptor(Em.prototype, "subscribeAudioStatisticData"), Em.prototype), v(Em.prototype, "unsubscribeAudioStatisticData", [gf, Yf], Object.getOwnPropertyDescriptor(Em.prototype, "unsubscribeAudioStatisticData"), Em.prototype), v(Em.prototype, "startVideo", [gf, Jf], Object.getOwnPropertyDescriptor(Em.prototype, "startVideo"), Em.prototype), v(Em.prototype, "stopVideo", [gf, $f], Object.getOwnPropertyDescriptor(Em.prototype, "stopVideo"), Em.prototype), v(Em.prototype, "switchCamera", [gf, Xf], Object.getOwnPropertyDescriptor(Em.prototype, "switchCamera"), Em.prototype), v(Em.prototype, "renderVideo", [gf, em], Object.getOwnPropertyDescriptor(Em.prototype, "renderVideo"), Em.prototype), v(Em.prototype, "stopRenderVideo", [gf, tm], Object.getOwnPropertyDescriptor(Em.prototype, "stopRenderVideo"), Em.prototype), v(Em.prototype, "updateVideoCanvasDimension", [gf, nm], Object.getOwnPropertyDescriptor(Em.prototype, "updateVideoCanvasDimension"), Em.prototype), v(Em.prototype, "adjustRenderedVideoPosition", [gf, rm], Object.getOwnPropertyDescriptor(Em.prototype, "adjustRenderedVideoPosition"), Em.prototype), v(Em.prototype, "clearVideoCanvas", [gf, im], Object.getOwnPropertyDescriptor(Em.prototype, "clearVideoCanvas"), Em.prototype), v(Em.prototype, "mirrorVideo", [gf, om], Object.getOwnPropertyDescriptor(Em.prototype, "mirrorVideo"), Em.prototype), v(Em.prototype, "enableHardwareAcceleration", [gf, am], Object.getOwnPropertyDescriptor(Em.prototype, "enableHardwareAcceleration"), Em.prototype), v(Em.prototype, "subscribeVideoStatisticData", [gf, sm], Object.getOwnPropertyDescriptor(Em.prototype, "subscribeVideoStatisticData"), Em.prototype), v(Em.prototype, "unsubscribeVideoStatisticData", [gf, cm], Object.getOwnPropertyDescriptor(Em.prototype, "unsubscribeVideoStatisticData"), Em.prototype), v(Em.prototype, "previewVirtualBackground", [gf, lm], Object.getOwnPropertyDescriptor(Em.prototype, "previewVirtualBackground"), Em.prototype), v(Em.prototype, "updateVirtualBackgroundImage", [gf, dm], Object.getOwnPropertyDescriptor(Em.prototype, "updateVirtualBackgroundImage"), Em.prototype), v(Em.prototype, "stopPreviewVirtualBackground", [gf, um], Object.getOwnPropertyDescriptor(Em.prototype, "stopPreviewVirtualBackground"), Em.prototype), v(Em.prototype, "startShareView", [gf, pm], Object.getOwnPropertyDescriptor(Em.prototype, "startShareView"), Em.prototype), v(Em.prototype, "stopShareView", [gf, hm], Object.getOwnPropertyDescriptor(Em.prototype, "stopShareView"), Em.prototype), v(Em.prototype, "switchShareView", [gf, _m], Object.getOwnPropertyDescriptor(Em.prototype, "switchShareView"), Em.prototype), v(Em.prototype, "updateSharingCanvasDimension", [gf, fm], Object.getOwnPropertyDescriptor(Em.prototype, "updateSharingCanvasDimension"), Em.prototype), v(Em.prototype, "startShareScreen", [gf, mm], Object.getOwnPropertyDescriptor(Em.prototype, "startShareScreen"), Em.prototype), v(Em.prototype, "stopShareScreen", [gf, gm], Object.getOwnPropertyDescriptor(Em.prototype, "stopShareScreen"), Em.prototype), v(Em.prototype, "pauseShareScreen", [gf, vm], Object.getOwnPropertyDescriptor(Em.prototype, "pauseShareScreen"), Em.prototype), v(Em.prototype, "resumeShareScreen", [gf, bm], Object.getOwnPropertyDescriptor(Em.prototype, "resumeShareScreen"), Em.prototype), v(Em.prototype, "setSharePrivilege", [bf, ym, gf], Object.getOwnPropertyDescriptor(Em.prototype, "setSharePrivilege"), Em.prototype), v(Em.prototype, "lockShare", [bf, wm, gf], Object.getOwnPropertyDescriptor(Em.prototype, "lockShare"), Em.prototype), v(Em.prototype, "shareToBreakoutRoom", [gf, bf, Sm], Object.getOwnPropertyDescriptor(Em.prototype, "shareToBreakoutRoom"), Em.prototype), v(Em.prototype, "stopShareToBreakoutRoom", [gf, bf, xm], Object.getOwnPropertyDescriptor(Em.prototype, "stopShareToBreakoutRoom"), Em.prototype), Em);
          var km, Am, Im, Tm, Om, Rm, Nm, Pm, jm, Dm, zm, Mm, Lm, Um, Bm, Hm, Vm, qm, Fm, Wm, Gm;
          var Km = (km = xf("audio"), Am = kf(Cf.Attendee), Im = xf("audio"), Tm = xf("audio"), Om = xf("audio"), Rm = xf("audio"), Nm = xf("audio"), Pm = xf("video"), jm = xf("video"), Dm = xf("video"), zm = xf("video"), Mm = xf("video"), Lm = xf("video"), Um = xf("video"), Bm = xf("video"), Hm = xf("share"), Vm = xf("share"), qm = xf("share"), Fm = xf("share"), Wm = xf("share"), v((Gm = /*#__PURE__*/function (_Cm) {
            _inherits(Gm, _Cm);

            var _super4 = _createSuper(Gm);

            function Gm() {
              _classCallCheck(this, Gm);

              return _super4.apply(this, arguments);
            }

            _createClass(Gm, [{
              key: "mergeAudio",
              value: function mergeAudio(e, t) {
                return function (e, t, n) {
                  var r = e.store.getState,
                      i = e.rwgAgent,
                      o = pc(r()),
                      a = o.find(function (e) {
                    return e.userId === t;
                  }),
                      s = o.find(function (e) {
                    return e.userId === n;
                  });
                  return a && s && "" === a.audio && "phone" === s.audio && $s(s.userType) ? (i.bindTeleUser(n, t, !0), Ts("AUDIO_PARTICIPANT_AUDIO_UPDATE", function (e) {
                    return e.id === t && "phone" === e.audio;
                  })) : Promise.reject({
                    type: vs
                  });
                }(this[mf], e, t);
              }
            }, {
              key: "allowAttendeeToTalk",
              value: function allowAttendeeToTalk(e, t) {
                return function (e, t, n) {
                  var r = e.store.getState,
                      i = e.rwgAgent,
                      o = r(),
                      a = dc(o).find(function (e) {
                    return e.userId === t;
                  }),
                      s = o.participants.allowTalkAttendeesList;

                  if (n) {
                    if (s.findIndex(function (e) {
                      return e.userId === t;
                    }) > -1) return Promise.reject({
                      type: vs,
                      reason: "attendee is talking"
                    });
                    if (1 != (1 & a.clientCap)) return Promise.reject({
                      type: ms,
                      reason: "improper target client"
                    });
                  } else if (-1 === s.findIndex(function (e) {
                    return e.userId === t;
                  })) return Promise.reject({
                    type: vs,
                    reason: "attendee is not talking"
                  });

                  return i.allowToTalk(t, n), Ts("AUDIO_ALLOW_TO_TALK_RESPONSE", function (e) {
                    return !0 === e.bSuccess && e.id === t;
                  });
                }(this[mf], e, t);
              }
            }, {
              key: "muteAudioUponEntry",
              value: function muteAudioUponEntry() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return function (e) {
                  var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

                  var n = e.store.getState,
                      r = e.rwgAgent,
                      _n51 = n(),
                      i = _n51.audio.bMutedUponEntry;

                  return i === t ? Promise.resolve("") : (r.setMuteOnEntry(t), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                    return e.bMutedUponEntry === t;
                  }));
                }(this[mf], e);
              }
            }, {
              key: "muteAllAudio",
              value: function muteAllAudio() {
                return function (e) {
                  var t = e.rwgAgent;
                  return t.audioMuteAll(!0), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                    return !0 === e.bMutedAll;
                  });
                }(this[mf]);
              }
            }, {
              key: "unmuteAllAudio",
              value: function unmuteAllAudio() {
                return function (e) {
                  var t = e.rwgAgent;
                  return t.audioMuteAll(!1), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                    return !1 === e.bMutedAll;
                  });
                }(this[mf]);
              }
            }, {
              key: "allowUnmuteAudioThemselves",
              value: function allowUnmuteAudioThemselves() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return function (e) {
                  var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

                  var n = e.store.getState,
                      r = e.rwgAgent,
                      _n52 = n(),
                      i = _n52.audio.bCanUnmute;

                  return i === t ? Promise.resolve("") : (r.allowUnmuteAudio(t), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                    return e.bCanUnmute === t;
                  }));
                }(this[mf], e);
              }
            }, {
              key: "getDialInTollNumbers",
              value: function getDialInTollNumbers() {
                return function (e) {
                  var t = e.store.getState;

                  var _t72 = t(),
                      n = _t72.meeting.tollNumbers;

                  return Array.isArray(n) ? n : [];
                }(this[mf]);
              }
            }, {
              key: "isAllowToUnmute",
              value: function isAllowToUnmute() {
                return function (e) {
                  var t = e.store.getState;
                  var n = t();
                  return !!n.audio && n.audio.bCanUnmute;
                }(this[mf]);
              }
            }, {
              key: "isAttendeeAllowToTalk",
              value: function isAttendeeAllowToTalk() {
                return function (e) {
                  var t = e.store.getState;
                  var n = t();
                  return n.audio ? n.audio.isAllowToTalk : null;
                }(this[mf]);
              }
            }, {
              key: "spotlight",
              value: function spotlight(e, t) {
                return function (e, t, n) {
                  var r = e.store.getState,
                      i = e.rwgAgent,
                      o = r(),
                      a = o.video.spotlightUserList;
                  return a.includes(t) ? Promise.reject({
                    type: vs,
                    reason: "userId:".concat(t, " has already spotlighted")
                  }) : -1 === Rf(o).findIndex(function (e) {
                    return e.userId === t;
                  }) ? Promise.reject({
                    type: vs,
                    reason: "userId:".concat(t, " has not started video")
                  }) : (i.spotlightVideo(t, {
                    bReplace: n,
                    bSpotlight: !0,
                    bUnSpotlightAll: !1
                  }), Ts("VIDEO_SPOTLIGHT_CHANGE", function (e) {
                    var n = e.spotlightList;
                    return n.includes(t);
                  }));
                }(this[mf], e, t);
              }
            }, {
              key: "removeSpotlight",
              value: function removeSpotlight(e) {
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.rwgAgent,
                      i = n(),
                      o = i.meeting.userId,
                      a = i.video.spotlightUserList,
                      s = t || o,
                      c = pc(i);
                  return a.includes(s) && -1 !== c.findIndex(function (e) {
                    return e.userId === s;
                  }) ? s === o || cc(i) ? (r.spotlightVideo(s, {
                    bReplace: !1,
                    bSpotlight: !1,
                    bUnSpotlightAll: !1
                  }), Ts("VIDEO_SPOTLIGHT_CHANGE", function (e) {
                    var t = e.spotlightList;
                    return !t.includes(s);
                  })) : Promise.reject({
                    type: gs,
                    reason: "only host or co-host can cancel others spotlight"
                  }) : Promise.reject({
                    type: vs,
                    reason: "userId:".concat(t, " is not spotlighted")
                  });
                }(this[mf], e);
              }
            }, {
              key: "removeAllSpotlights",
              value: function removeAllSpotlights() {
                return function (e) {
                  var t = e.store.getState,
                      n = e.rwgAgent,
                      _t73 = t(),
                      r = _t73.video.spotlightUserList;

                  return 0 === r.length ? Promise.resolve("") : (n.spotlightVideo(null, {
                    bUnSpotlightAll: !0
                  }), Ts("VIDEO_SPOTLIGHT_CHANGE", function (e) {
                    var t = e.spotlightList;
                    return 0 === t.length;
                  }));
                }(this[mf]);
              }
            }, {
              key: "muteVideo",
              value: function muteVideo(e) {
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.rwgAgent,
                      i = n(),
                      o = i.meeting.userId,
                      a = i.video.isCurrentUserStartedVideo;
                  if (t === o && a) Pf(e);else {
                    if (!(Rf(i).findIndex(function (e) {
                      return e.userId === t;
                    }) >= 0)) return Promise.reject({
                      type: vs,
                      reason: "userId:".concat(t, " is not correct")
                    });
                    r.notifyRwgIsMuteVideo(t, !0);
                  }
                  return Promise.resolve("");
                }(this[mf], e);
              }
            }, {
              key: "unmuteVideo",
              value: function unmuteVideo(e) {
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.rwgAgent,
                      i = n(),
                      o = i.meeting.userId,
                      a = i.video.isCurrentUserStartedVideo;

                  if (t !== o || a) {
                    var _e192 = Rf(i),
                        _n53 = pc(i);

                    if (!(-1 === _e192.findIndex(function (e) {
                      return e.userId === t;
                    }) && _n53.findIndex(function (e) {
                      return e.userId === t;
                    }) >= 0)) return Promise.reject({
                      type: vs,
                      reason: "userId:".concat(t, " is not correct")
                    });
                    r.notifyRwgIsMuteVideo(t, !1);
                  } else Nf(e);

                  return Promise.resolve("");
                }(this[mf], e);
              }
            }, {
              key: "setFollowHostVideoOrder",
              value: function setFollowHostVideoOrder(e) {
                return function (e, t) {
                  var n = e.rwgAgent;
                  return n.followHostLayout(t), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                    return e.bFollowHostVideo === t;
                  });
                }(this[mf], e);
              }
            }, {
              key: "pushHostVideoLayout",
              value: function pushHostVideoLayout(e) {
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.rwgAgent,
                      i = n(),
                      o = pc(i),
                      a = t.filter(function (e) {
                    return o.findIndex(function (t) {
                      return t.userId === e;
                    }) >= 0;
                  }).map(function (e) {
                    return {
                      id: e
                    };
                  });
                  return 0 === a.length ? r.setVideoDragLayout(null) : r.setVideoDragLayout(a), Promise.resolve("");
                }(this[mf], e);
              }
            }, {
              key: "allowUnmuteVideo",
              value: function allowUnmuteVideo() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.rwgAgent,
                      _n54 = n(),
                      i = _n54.video.bCanUnmuteVideo;

                  return i === t ? Promise.resolve("") : (r.allowUnmuteVideo(t), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                    return e.bCanUnmuteVideo === t;
                  }));
                }(this[mf], e);
              }
            }, {
              key: "getSpotlightedUserList",
              value: function getSpotlightedUserList() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  if (!n.video) return [];
                  var r = n.video.spotlightUserList;
                  return r.map(function (e) {
                    return {
                      userId: e
                    };
                  });
                }(this[mf]);
              }
            }, {
              key: "getSubscribedVideoUserList",
              value: function getSubscribedVideoUserList() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  if (!n.video) return [];
                  var r = n.video.subscribedVideoList;
                  return r.map(function (e) {
                    return {
                      userId: e
                    };
                  });
                }(this[mf]);
              }
            }, {
              key: "isFollowHostVideoLayout",
              value: function isFollowHostVideoLayout() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.video && n.video.isFollowHostVideoLayout;
                }(this[mf]);
              }
            }, {
              key: "getHostVideoLayout",
              value: function getHostVideoLayout() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  if (!n.video) return [];
                  var r = n.video.hostDragLayout;
                  return r.map(function (e) {
                    return {
                      userId: e
                    };
                  });
                }(this[mf]);
              }
            }, {
              key: "isEnableUnmuteVideo",
              value: function isEnableUnmuteVideo() {
                return function (e) {
                  var t;
                  var n = e.store.getState;
                  return null === (t = n().video) || void 0 === t ? void 0 : t.bCanUnmuteVideo;
                }(this[mf]);
              }
            }, {
              key: "requestRemoteControl",
              value: function requestRemoteControl() {
                return function (e) {
                  var t = e.store.getState,
                      n = e.rwgAgent,
                      _t74 = t(),
                      _t74$share = _t74.share,
                      r = _t74$share.isReceiveSharing,
                      i = _t74$share.isRemoteControlApproved,
                      o = _t74$share.activeNodeId;

                  return Tf(e, o) ? r ? i ? Promise.reject({
                    type: ms,
                    reason: "already be approved"
                  }) : (n.sharingRequestRemoteControl(o, !0), new Promise(function (e) {
                    Os("SHARE_REMOTE_CONTROL_APPROVE", 1).subscribe(function (t) {
                      e(t);
                    });
                  })) : Promise.reject({
                    type: ms,
                    reason: "no render screen share"
                  }) : Promise.reject({
                    type: vs
                  });
                }(this[mf]);
              }
            }, {
              key: "giveUpRemoteControl",
              value: function giveUpRemoteControl() {
                return function (e) {
                  var t = e.store.getState,
                      n = e.rwgAgent,
                      _t75 = t(),
                      _t75$share = _t75.share,
                      r = _t75$share.isRemoteControlApproved,
                      i = _t75$share.isGrabRemoteControl,
                      o = _t75$share.activeNodeId;

                  return r ? (i && n.subscribeGrabRemoteControl(o, !1), n.sharingRequestRemoteControl(o, !1), Ts("SHARE_REMOTE_CONTROL_APPROVE", function (e) {
                    return !1 === e;
                  })) : Promise.reject({
                    type: ms
                  });
                }(this[mf]);
              }
            }, {
              key: "startRemoteControl",
              value: function startRemoteControl(e) {
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.mediaAgent,
                      i = e.rwgAgent,
                      _n55 = n(),
                      _n55$share = _n55.share,
                      o = _n55$share.isSDKGrabControl,
                      a = _n55$share.isGrabRemoteControl,
                      s = _n55$share.isRemoteControlApproved,
                      c = _n55$share.activeNodeId;

                  if (!s) return Promise.reject({
                    type: ms,
                    reason: "required to be approved"
                  });
                  var l = fe(a);
                  return a || (i.subscribeGrabRemoteControl(c, !0), l = Os("SHARE_GRAB_REMOTE_CONTROL_CHANGE", 1).pipe(pt(function (e) {
                    return !!e;
                  }))), l.subscribe(function () {
                    var e = n(),
                        i = xu(e);
                    i && (o ? (r.resendRemoteControlPositionPDU(), r.updateRemoteControlProperties({
                      os: i.os,
                      isControllerNow: !0,
                      dimension: Du(t)
                    })) : r.startRemoteControl(t, i.os, Du(t)));
                  }), o ? Ts("SHARE_GRAB_REMOTE_CONTROL_CHANGE", function (e) {
                    return !!e;
                  }) : Is({
                    success: "SHARE_REMOTE_CONTROL_SUCCESS",
                    fail: ["SHARE_REMOTE_CONTROL_FAILED"]
                  });
                }(this[mf], e);
              }
            }, {
              key: "grabRemotoControl",
              value: function grabRemotoControl() {
                return function (e) {
                  var t = e.store.getState,
                      n = e.rwgAgent,
                      _t76 = t(),
                      _t76$share = _t76.share,
                      r = _t76$share.isGrabRemoteControl,
                      i = _t76$share.isRemoteControlApproved,
                      o = _t76$share.activeNodeId;

                  return i ? r ? Promise.resolve("") : (n.subscribeGrabRemoteControl(o, !0), Ts("SHARE_GRAB_REMOTE_CONTROL_CHANGE", function (e) {
                    return !!e;
                  })) : Promise.reject({
                    type: ms,
                    reason: "should be approved before grab"
                  });
                }(this[mf]);
              }
            }, {
              key: "updateRemoteControlViewportDimension",
              value: function updateRemoteControlViewportDimension(e) {
                return function (e, t) {
                  var n = e.store.getState,
                      r = e.mediaAgent,
                      _n56 = n(),
                      i = _n56.share.isRemoteControlApproved;

                  return i && r.updateRemoteControlProperties({
                    dimension: {
                      scaleWidth: t.width,
                      scaleHeight: t.height,
                      srcOffsetX: t.left,
                      srcOffsetY: t.top
                    }
                  }), Promise.resolve("");
                }(this[mf], e);
              }
            }, {
              key: "isTargetShareSupportRemoteControl",
              value: function isTargetShareSupportRemoteControl(e) {
                return Tf(this[mf], e);
              }
            }, {
              key: "isRemoteControlApproved",
              value: function isRemoteControlApproved() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.share && n.share.isRemoteControlApproved;
                }(this[mf]);
              }
            }, {
              key: "isRemotelyControlling",
              value: function isRemotelyControlling() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return !!n.share && n.share.isGrabRemoteControl;
                }(this[mf]);
              }
            }, {
              key: "isShareLocked",
              value: function isShareLocked() {
                return Of(this[mf]);
              }
            }, {
              key: "getSharePrivilege",
              value: function getSharePrivilege() {
                return function (e) {
                  var t = e.store.getState,
                      n = t();
                  return n.share ? n.share.sharePrivilege : null;
                }(this[mf]);
              }
            }]);

            return Gm;
          }(Cm)).prototype, "mergeAudio", [bf, gf, km], Object.getOwnPropertyDescriptor(Gm.prototype, "mergeAudio"), Gm.prototype), v(Gm.prototype, "allowAttendeeToTalk", [Am, bf, vf, gf, Im], Object.getOwnPropertyDescriptor(Gm.prototype, "allowAttendeeToTalk"), Gm.prototype), v(Gm.prototype, "muteAudioUponEntry", [bf, gf, Tm], Object.getOwnPropertyDescriptor(Gm.prototype, "muteAudioUponEntry"), Gm.prototype), v(Gm.prototype, "muteAllAudio", [bf, gf, Om], Object.getOwnPropertyDescriptor(Gm.prototype, "muteAllAudio"), Gm.prototype), v(Gm.prototype, "unmuteAllAudio", [bf, gf, Rm], Object.getOwnPropertyDescriptor(Gm.prototype, "unmuteAllAudio"), Gm.prototype), v(Gm.prototype, "allowUnmuteAudioThemselves", [bf, gf, Nm], Object.getOwnPropertyDescriptor(Gm.prototype, "allowUnmuteAudioThemselves"), Gm.prototype), v(Gm.prototype, "spotlight", [bf, gf, Pm], Object.getOwnPropertyDescriptor(Gm.prototype, "spotlight"), Gm.prototype), v(Gm.prototype, "removeSpotlight", [gf, jm], Object.getOwnPropertyDescriptor(Gm.prototype, "removeSpotlight"), Gm.prototype), v(Gm.prototype, "removeAllSpotlights", [yf, gf, Dm], Object.getOwnPropertyDescriptor(Gm.prototype, "removeAllSpotlights"), Gm.prototype), v(Gm.prototype, "muteVideo", [bf, gf, zm], Object.getOwnPropertyDescriptor(Gm.prototype, "muteVideo"), Gm.prototype), v(Gm.prototype, "unmuteVideo", [bf, gf, Mm], Object.getOwnPropertyDescriptor(Gm.prototype, "unmuteVideo"), Gm.prototype), v(Gm.prototype, "setFollowHostVideoOrder", [yf, gf, Lm], Object.getOwnPropertyDescriptor(Gm.prototype, "setFollowHostVideoOrder"), Gm.prototype), v(Gm.prototype, "pushHostVideoLayout", [yf, gf, Um], Object.getOwnPropertyDescriptor(Gm.prototype, "pushHostVideoLayout"), Gm.prototype), v(Gm.prototype, "allowUnmuteVideo", [bf, gf, Bm], Object.getOwnPropertyDescriptor(Gm.prototype, "allowUnmuteVideo"), Gm.prototype), v(Gm.prototype, "requestRemoteControl", [gf, Hm], Object.getOwnPropertyDescriptor(Gm.prototype, "requestRemoteControl"), Gm.prototype), v(Gm.prototype, "giveUpRemoteControl", [gf, Vm], Object.getOwnPropertyDescriptor(Gm.prototype, "giveUpRemoteControl"), Gm.prototype), v(Gm.prototype, "startRemoteControl", [gf, qm], Object.getOwnPropertyDescriptor(Gm.prototype, "startRemoteControl"), Gm.prototype), v(Gm.prototype, "grabRemotoControl", [gf, Fm], Object.getOwnPropertyDescriptor(Gm.prototype, "grabRemotoControl"), Gm.prototype), v(Gm.prototype, "updateRemoteControlViewportDimension", [gf, Wm], Object.getOwnPropertyDescriptor(Gm.prototype, "updateRemoteControlViewportDimension"), Gm.prototype), Gm);

          var Qm = function Qm(e, t, n, r) {
            var i = e;

            switch (n) {
              case "start":
              case "replace":
                i = t;
                break;

              case "insert":
                i += t;
                break;

              case "delete":
                i = function (e, t) {
                  if (!e || 0 === t) return "";
                  var n = 0;

                  for (var _r39 = 0; _r39 < e.length; _r39++) {
                    if (n += wi(e[_r39]), n === t) return e.slice(0, _r39 + 1);
                  }

                  return e;
                }(i, r);

            }

            return i.replace(/[\r\n]/g, "");
          };

          var Zm = Object.freeze({
            __proto__: null,
            assignCcEditorResponse: function assignCcEditorResponse(e, t) {
              return Vr(e, 7937).pipe(Me(function (e) {
                var t, n, r, i;
                return (null === (t = e.payload.body) || void 0 === t || null === (n = t.add) || void 0 === n ? void 0 : n.find(function (e) {
                  return e.bCCEditor;
                })) || (null === (r = e.payload.body) || void 0 === r || null === (i = r.update) || void 0 === i ? void 0 : i.find(function (e) {
                  return "bCCEditor" in e;
                }));
              }), pt(function (e) {
                return e;
              }), mu(function (e) {
                var n = e.id;
                As("CC_ASSIGN_CC_EDITOR_SUCCESS", {
                  userId: n,
                  isEditor: e.bCCEditor
                });
                var r = t.value.meeting.userId === n && e.bCCEditor;
                var i = e.zoomID;

                if (!e.zoomID) {
                  var _e193 = t.value.participants.attendeesList.find(function (e) {
                    return e.userId === n;
                  });

                  i = null == _e193 ? void 0 : _e193.zoomID;
                }

                return e.bCCEditor && As("CC_ASSIGN_CC_EDITOR_SUCCESS_RESPONSE", {
                  userId: n
                }), Ke([fd({
                  editorId: n,
                  isEditor: r,
                  editorZoomId: i
                }), md({
                  text: "",
                  finished: !1
                }), bd({
                  text: "",
                  finished: !1
                })]);
              }));
            },
            sendCcTextResponse: function sendCcTextResponse(e, t) {
              return Vr(e, 4126).pipe(mu(function (e) {
                if (0 === e.payload.body.res) {
                  As("CC_RECEIVE_MESSAGE", t.value.closedCaption.sendBody);
                  var _t$value$closedCaptio = t.value.closedCaption,
                      _e194 = _t$value$closedCaptio.isCCEnable,
                      _n57 = _t$value$closedCaptio.tempSendCcText;
                  return _e194 ? Ke([md({
                    text: "",
                    finished: !1
                  }), bd({
                    text: _n57,
                    finished: !1
                  })]) : (As("CC_STATUS_CHANGE", {
                    isCCEnable: !0
                  }), Ke([xd(!0), md({
                    text: "",
                    finished: !1
                  }), bd({
                    text: _n57,
                    finished: !1
                  })]));
                }

                return ce;
              }));
            },
            receiveCcText: function receiveCcText(e, t) {
              return Vr(e, 7943).pipe(ln(t), Je(function (e) {
                var _e195 = _slicedToArray(e, 2),
                    n = _e195[0],
                    r = _e195[1];

                var _r$closedCaption = r.closedCaption,
                    i = _r$closedCaption.tempReceiveCcText,
                    o = _r$closedCaption.isListenClosedCaption,
                    a = pc(r),
                    _n$payload$body2 = n.payload.body,
                    s = _n$payload$body2.changedContent,
                    c = _n$payload$body2.operation,
                    l = _n$payload$body2.where,
                    d = _n$payload$body2.text,
                    u = _n$payload$body2.type,
                    p = _n$payload$body2.destNodeID,
                    h = s || d;
                return h && o && 3 !== u ? Ko.beginDecrypt({
                  decryptedText: h,
                  type: Ho.CC_MESSAGE,
                  zoomId: t.value.closedCaption.editorZoomId
                }).then(function (e) {
                  var t = e.message;

                  if (s) {
                    var n;
                    var _e196 = {
                      text: Qm(i, t, c, l),
                      finished: !1,
                      sender: {
                        userId: p,
                        name: null === (n = a.find(function (e) {
                          return e.userId === p;
                        })) || void 0 === n ? void 0 : n.displayName
                      }
                    };
                    return As("CC_RECEIVE_MESSAGE", _e196), bd(_e196);
                  }

                  if (d) {
                    var r;
                    var _e197 = {
                      text: t,
                      timeStamp: new Date().valueOf(),
                      finished: !0,
                      sender: {
                        userId: p,
                        name: null === (r = a.find(function (e) {
                          return e.userId === p;
                        })) || void 0 === r ? void 0 : r.displayName
                      }
                    };
                    return As("CC_RECEIVE_MESSAGE", _e197), bd(_e197);
                  }

                  return ce;
                }) : ce;
              }));
            },
            receiveLtText: function receiveLtText(e, t) {
              return Vr(e, 7943).pipe(ln(t), Je(function (e) {
                var t, n;

                var _e198 = _slicedToArray(e, 2),
                    r = _e198[0],
                    i = _e198[1];

                var _i$closedCaption = i.closedCaption,
                    o = _i$closedCaption.gatewayInfoList,
                    a = _i$closedCaption.messagesOrder,
                    s = _i$closedCaption.allMessages,
                    c = _i$closedCaption.isListenClosedCaption,
                    l = pc(i),
                    d = r.payload,
                    _d$body = d.body,
                    u = _d$body.changedContent,
                    p = _d$body.where,
                    h = _d$body.operation,
                    _ = _d$body.count,
                    f = _d$body.type;

                if (0 !== (null === (t = d.body) || void 0 === t ? void 0 : t.destNodeID) && null !== (n = d.body) && void 0 !== n && n.srcMsgID && u && c && 3 === f) {
                  var m;
                  if (!o.length) return ce;

                  var _e199 = null === (m = o.find(function (e) {
                    return (null == e ? void 0 : e.userId) === d.body.LtGwID;
                  })) || void 0 === m ? void 0 : m.sn;

                  if (!_e199) return ce;

                  var _t77 = s[d.body.srcMsgID] ? s[d.body.srcMsgID].text : "";

                  return Ko.beginDecrypt({
                    decryptedText: void 0 !== u ? u : "",
                    type: Ho.CC_MESSAGE,
                    zoomId: _e199
                  }).then(function (e) {
                    var n, r;
                    var i = e.message,
                        o = _t77,
                        c = !1;

                    switch (h) {
                      case "add":
                        o = i, c = !0;
                        break;

                      case "replace":
                        if (c = !0, (-1 === _ || _ > yi(o)) && "" === i && 0 === p) {
                          o = "";
                          break;
                        }

                        if (p < 0 || _ < -1) break;

                        o = function (e, t, n, r) {
                          var i = 0,
                              o = "",
                              a = r,
                              s = n;
                          var c = yi(e);
                          if ("" === e) return t;
                          if (n >= c && 0 === a) return e + t;
                          if (0 === s && 0 === a) return t;
                          (-1 === r || n + r > c) && (a = c - n), 0 === a && n === c && n > 0 && (s = n - 1);

                          for (var _l8 = 0; _l8 < e.length && (i === s && (o = e.slice(0, _l8) + t), i !== c - 1); _l8++) {
                            if (i === s + a) {
                              o += e.slice(_l8);
                              break;
                            }

                            i += wi(e[_l8]);
                          }

                          return o;
                        }(o, i, p, _);

                    }

                    var u = [];

                    if (!1 === o) {
                      u.push({
                        key: "deleteMessage",
                        value: d.body.srcMsgID
                      });

                      for (var _e200 = a.length - 1; _e200 >= 0; _e200--) {
                        if (!1 === s[a[_e200]].isFinished) {
                          var f, m;
                          var _t78 = {
                            text: s[a[_e200]].message,
                            timeStamp: new Date().valueOf(),
                            finished: !0,
                            srcMsgID: d.body.srcMsgID,
                            sender: {
                              userId: null == d || null === (f = d.body) || void 0 === f ? void 0 : f.destNodeID,
                              name: null === (m = l.find(function (e) {
                                var t;
                                return e.userId === (null == d || null === (t = d.body) || void 0 === t ? void 0 : t.destNodeID);
                              })) || void 0 === m ? void 0 : m.displayName
                            }
                          };
                          u.push({
                            key: "setTempReceiveLtText",
                            value: _t78
                          });
                        } else 0 === _e200 && u.push({
                          key: "setTempReceiveLtText",
                          value: ""
                        });
                      }

                      As("LT_RECEIVE_MESSAGE", {
                        new: !1
                      });
                    } else {
                      var g, v, b, y;
                      u.push({
                        key: "updateMessage",
                        value: {
                          ccType: d.body.type,
                          text: o,
                          finished: !1,
                          srcMsgID: d.body.srcMsgID,
                          sender: {
                            userId: null == d || null === (g = d.body) || void 0 === g ? void 0 : g.destNodeID,
                            name: null === (v = l.find(function (e) {
                              var t;
                              return e.userId === (null == d || null === (t = d.body) || void 0 === t ? void 0 : t.destNodeID);
                            })) || void 0 === v ? void 0 : v.displayName
                          }
                        }
                      }), "." !== o && (u.push({
                        key: "setTempReceiveLtText",
                        value: {
                          text: o,
                          timeStamp: new Date().valueOf(),
                          finished: !0,
                          sender: {
                            userId: null == d || null === (b = d.body) || void 0 === b ? void 0 : b.destNodeID,
                            name: null === (y = l.find(function (e) {
                              var t;
                              return e.userId === (null == d || null === (t = d.body) || void 0 === t ? void 0 : t.destNodeID);
                            })) || void 0 === y ? void 0 : y.displayName
                          },
                          srcMsgID: d.body.srcMsgID
                        }
                      }), As("LT_RECEIVE_MESSAGE", {
                        new: !0,
                        messageNow: o
                      }));
                    }

                    return u.push({
                      key: "setTempReceiveLtText",
                      value: {
                        text: o,
                        isFinish: c,
                        timeStamp: new Date().valueOf(),
                        sender: {
                          userId: null == d || null === (n = d.body) || void 0 === n ? void 0 : n.destNodeID,
                          name: null === (r = l.find(function (e) {
                            var t;
                            return e.userId === (null == d || null === (t = d.body) || void 0 === t ? void 0 : t.destNodeID);
                          })) || void 0 === r ? void 0 : r.displayName
                        },
                        srcMsgID: d.body.srcMsgID
                      }
                    }), gd(u);
                  });
                }

                return ce;
              }));
            },
            receiveLtFinalText: function receiveLtFinalText(e, t) {
              return Vr(e, 7943).pipe(ln(t), Je(function (e) {
                var t;

                var _e201 = _slicedToArray(e, 2),
                    n = _e201[0],
                    r = _e201[1];

                var i = r.closedCaption.gatewayInfoList,
                    o = pc(r),
                    a = n.payload;

                if (a.body.changedContent && 3 === a.body.type && 0 === (null == a || null === (t = a.body) || void 0 === t ? void 0 : t.destNodeID) && a.body.srcMsgID && !a.body.operation) {
                  var s;

                  var _e202 = null === (s = i.find(function (e) {
                    return e.userid === a.body.LtGwID;
                  })) || void 0 === s ? void 0 : s.sn;

                  return _e202 ? Ko.beginDecrypt({
                    decryptedText: a.body.changedContent,
                    type: Ho.CC_MESSAGE,
                    zoomId: _e202
                  }).then(function (e) {
                    var t, n;
                    var r = e.message;
                    return Td({
                      text: r,
                      timeStamp: new Date().valueOf(),
                      sender: {
                        userId: null == a || null === (t = a.body) || void 0 === t ? void 0 : t.destNodeID,
                        name: null === (n = o.find(function (e) {
                          var t;
                          return e.userId === (null == a || null === (t = a.body) || void 0 === t ? void 0 : t.destNodeID);
                        })) || void 0 === n ? void 0 : n.displayName
                      },
                      srcMsgID: a.body.srcMsgID,
                      isFinished: !0
                    });
                  }) : ce;
                }

                return ce;
              }));
            },
            receiveCCFirstText: function receiveCCFirstText(e, t) {
              return Vr(e, 7943).pipe(ln(t), Je(function (e) {
                var _e203 = _slicedToArray(e, 2),
                    t = _e203[1];

                var _t$closedCaption = t.closedCaption,
                    n = _t$closedCaption.isCCEnable,
                    r = _t$closedCaption.isLTEnable,
                    i = _t$closedCaption.liveTranscriptionStatus,
                    o = [];
                return n ? ce : (o.push(xd(!0)), As("CC_STATUS_CHANGE", {
                  isCCEnable: !0
                }), 1 !== i || r || (As("LT_STATUS_CHANGE", {
                  isLTEnable: !0
                }), o.push(wd(!0))), Ke(o));
              }));
            },
            receiveGatewayInfoList: function receiveGatewayInfoList(e) {
              return Vr(e, 7938).pipe(fu(function (e) {
                var t, n;
                if (null != e && null !== (t = e.payload) && void 0 !== t && null !== (n = t.body) && void 0 !== n && n.bCCEditorAssigned) return As("CC_STATUS_CHANGE", {
                  isCCEnable: !0
                }), xd(!0);
                if (!e.payload.body.gatewayKey) return;

                var _e$payload$body$gatew = e.payload.body.gatewayKey.split("."),
                    _e$payload$body$gatew2 = _slicedToArray(_e$payload$body$gatew, 3),
                    r = _e$payload$body$gatew2[1],
                    i = _e$payload$body$gatew2[2];

                return yd({
                  newInfo: {
                    userId: Number(r),
                    sn: i
                  }
                });
              }));
            },
            setIsLiveTranscriptionEnabled: function setIsLiveTranscriptionEnabled(e, t) {
              return Vr(e, 4228).pipe(fu(function (e) {
                var n, r, i, o;
                var a = t.value.closedCaption.isLTEnable;
                var s = a;
                var c = null == e ? void 0 : e.payload;

                if ("object" == typeof c && null !== c) {
                  var _c$body = c.body,
                      _t79 = _c$body.op,
                      _a13 = _c$body.bSuccess;

                  switch (_t79) {
                    case 2:
                      s = _a13, As("LT_STATUS_CHANGE_RESPONSE", {
                        bSuccess: null === (n = e.payload) || void 0 === n || null === (r = n.body) || void 0 === r ? void 0 : r.bSuccess
                      });
                      break;

                    case 4:
                      As("LT_STATUS_CHANGE_RESPONSE", {
                        bSuccess: null === (i = e.payload) || void 0 === i || null === (o = i.body) || void 0 === o ? void 0 : o.bSuccess
                      }), s = !_a13;
                  }
                }

                if (s !== a) return As("LT_STATUS_CHANGE", {
                  isLTEnable: s
                }), wd(s);
              }));
            },
            onReceiveLiveTranscriptionStatus: function onReceiveLiveTranscriptionStatus(e) {
              return Vr(e, 7959).pipe(fu(function (e) {
                var t, n;
                return Ad(null === (t = e.payload) || void 0 === t || null === (n = t.body) || void 0 === n ? void 0 : n.status);
              }));
            },
            onReceiveAllowLiveTranscription: function onReceiveAllowLiveTranscription(e) {
              return Vr(e, 7969).pipe(fu(function (e) {
                var t, n;
                var r = null === (t = e.payload) || void 0 === t || null === (n = t.body) || void 0 === n ? void 0 : n.enable;
                return As("LT_STATUS_CHANGE", {
                  isAllow: r
                }), Ed({
                  isAllow: r
                });
              }));
            },
            onHostReceiveLtRequests: function onHostReceiveLtRequests(e) {
              return Vr(e, 7968).pipe(fu(function (e) {
                return As("LT_STATUS_CHANGE", {
                  asking: !0,
                  payload: e
                }), Cd({
                  asking: !0
                });
              }));
            }
          });
          var Ym = {
            editorId: NaN,
            isEditor: !1,
            tempSendCcText: "",
            tempReceiveCcText: "",
            gatewayInfoList: [],
            editorZoomId: "",
            allMessages: [],
            sendBody: {},
            messagesOrder: [],
            isLTEnable: !1,
            isCCEnable: !1,
            isListenClosedCaption: !1,
            allowRequestLt: !1,
            askingStartLt: !1,
            liveTranscriptionStatus: 0,
            isMeetingEnableClosedCaption: !1,
            isMeetingEnableAllowThirdPartyCCToken: !1,
            isMeetingEnabledLiveTranscriptionFeature: !1,
            isMeetingEnableViewFullTranscript: !1
          },
              Jm = ur((_ur8 = {}, _defineProperty(_ur8, "".concat(kd), Hp(function (e, t) {
            var n = t.payload;
            var r = n.isEnableLiveTranscription,
                i = n.isEnableAllowThirdPartyCCToken,
                o = n.isEnableViewFullTranscript,
                a = n.isEnableClosedCaption;
            e.isMeetingEnabledLiveTranscriptionFeature = r, e.isMeetingEnableAllowThirdPartyCCToken = i, e.isMeetingEnableViewFullTranscript = o, e.isMeetingEnableClosedCaption = a;
          })), _defineProperty(_ur8, "".concat(wd), Hp(function (e, t) {
            var n = t.payload;
            e.isLTEnable = n;
          })), _defineProperty(_ur8, "".concat(Sd), Hp(function (e, t) {
            var n = t.payload;
            e.isListenClosedCaption = n;
          })), _defineProperty(_ur8, "".concat(xd), Hp(function (e, t) {
            var n = t.payload;
            e.isCCEnable = n;
          })), _defineProperty(_ur8, "".concat(Ed), Hp(function (e, t) {
            var n = t.payload;
            e.allowRequestLt = n.isAllow;
          })), _defineProperty(_ur8, "".concat(Cd), Hp(function (e, t) {
            var n = t.payload;
            e.askingStartLt = n.asking;
          })), _defineProperty(_ur8, "".concat(Ad), Hp(function (e, t) {
            var n = t.payload;
            0 === n && (e.isLTEnable = !1), 1 === n && (e.isLTEnable = !0), e.liveTranscriptionStatus = n;
          })), _defineProperty(_ur8, "".concat(fd), Hp(function (e, t) {
            var n = t.payload;
            e.editorId = n.editorId, e.isEditor = n.isEditor, e.editorZoomId = n.editorZoomId;
          })), _defineProperty(_ur8, "".concat(md), Hp(function (e, t) {
            var n = t.payload;

            if (e.sendBody = n, e.tempSendCcText = n.finished ? "" : n.text, n.finished) {
              var _t80 = Uh(),
                  r = f({}, e.allMessages);

              r[_t80] = n, r[_t80].id = _t80, e.allMessages = r;
              var i = e.messagesOrder.filter(function (e) {
                return e !== _t80;
              });
              i.push(_t80), e.messagesOrder = i;
            }
          })), _defineProperty(_ur8, "".concat(bd), Hp(function (e, t) {
            var n = t.payload;

            if (n.finished) {
              var _t81 = Uh(),
                  r = f({}, e.allMessages);

              r[_t81] = n, r[_t81].id = _t81, e.allMessages = r;
              var i = e.messagesOrder.filter(function (e) {
                return e !== _t81;
              });
              i.push(_t81), e.messagesOrder = i;
            }

            e.tempReceiveCcText = n.finished ? "" : n.text, As("CC_RECEIVE_MESSAGE", n);
          })), _defineProperty(_ur8, "".concat(vd), Hp(function (e, t) {
            var n = t.payload;

            if (n.finished) {
              var _t82 = f({}, e.allMessages);

              _t82[n.srcMsgID] = n, e.allMessages = _t82;
              var r = e.messagesOrder.filter(function (e) {
                return e !== n.srcMsgID;
              });
              r.push(n.srcMsgID), e.messagesOrder = r;
            }

            e.tempReceiveCcText = n.text;
          })), _defineProperty(_ur8, "".concat(yd), Hp(function (e, t) {
            var n = t.payload;
            e.gatewayInfoList.push(n.newInfo);
          })), _defineProperty(_ur8, "".concat(Id), Hp(function (e, t) {
            var n = t.payload;
            var r = f({}, e.allMessages);
            delete r[n];
            var i = e.messagesOrder.filter(function (e) {
              return e !== n;
            });
            e.allMessages = r, e.messagesOrder = i;
          })), _defineProperty(_ur8, "".concat(Td), Hp(function (e, t) {
            var n = t.payload;
            var r = void 0 === e.allMessages[n.srcMsgID],
                i = f({}, e.allMessages);

            if (i[n.srcMsgID] = n, i[n.srcMsgID].timeStamp = new Date().getTime(), r) {
              var _t83 = e.messagesOrder.filter(function (e) {
                return e !== n.srcMsgID;
              });

              _t83.push(n.srcMsgID), e.messagesOrder = _t83;
            }

            e.allMessages = i;
          })), _defineProperty(_ur8, "".concat(Od), function (e) {
            return f(f({}, Ym), {}, {
              allMessages: e.allMessages
            });
          }), _defineProperty(_ur8, "".concat(gd), Hp(function (e, t) {
            var n = t.payload;
            null == n || n.forEach(function (t) {
              var n = t.key,
                  r = t.value;

              switch (_n58) {
                case "setTempReceiveLtText":
                  if (r.finished && r.text) {
                    var _t85 = f({}, e.allMessages);

                    _t85[r.srcMsgID] = r, e.allMessages = _t85;

                    var _n59 = e.messagesOrder.filter(function (e) {
                      return e !== r.srcMsgID;
                    });

                    _n59.push(null == r ? void 0 : r.srcMsgID), e.messagesOrder = _n59;
                  }

                  e.tempReceiveCcText = r.text;
                  break;

                case "updateMessage":
                  var _t84 = void 0 === e.allMessages[r.srcMsgID],
                      _n58 = f({}, e.allMessages);

                  if (_n58[r.srcMsgID] = r, _n58[r.srcMsgID].timeStamp = new Date().getTime(), _t84) {
                    var _t86 = e.messagesOrder.filter(function (e) {
                      return e !== r.srcMsgID;
                    });

                    _t86.push(r.srcMsgID), e.messagesOrder = _t86;
                  }

                  e.allMessages = _n58;
                  break;

                case "deleteMessage":
                  var i = f({}, e.allMessages);
                  delete i[r];
                  var o = e.messagesOrder.filter(function (e) {
                    return e !== r;
                  });
                  e.allMessages = i, e.messagesOrder = o;
              }
            });
          })), _ur8), Ym),
              $m = {
            userId: 0,
            displayName: "everyone",
            zoomID: "",
            isHost: !1,
            bCoHost: !1
          },
              Xm = {
            userId: 1,
            displayName: "All panelists",
            zoomID: "",
            isHost: !1,
            bCoHost: !1
          };
          var eg;
          var tg = ua.createAgent();
          var ng = (v((eg = /*#__PURE__*/function (_Df2) {
            _inherits(eg, _Df2);

            var _super5 = _createSuper(eg);

            function eg() {
              _classCallCheck(this, eg);

              return _super5.apply(this, arguments);
            }

            _createClass(eg, [{
              key: "assignClosedCaptionEditor",
              value: function assignClosedCaptionEditor(e) {
                var t = this[hf],
                    n = t(),
                    r = n.closedCaption.editorId,
                    i = n.participants.attendeesList;
                return r === e ? Promise.resolve({
                  userId: e
                }) : i.find(function (t) {
                  return t.userId === e;
                }) ? (tg.assignCC(e, !0), Ts("CC_ASSIGN_CC_EDITOR_SUCCESS_RESPONSE", function (t) {
                  return e === (null == t ? void 0 : t.userId);
                })) : new Promise(function (t, n) {
                  n({
                    type: vs,
                    reason: "cant find user by userId: ".concat(e)
                  });
                });
              }
            }, {
              key: "startLiveTranscription",
              value: function startLiveTranscription(e) {
                var t = this[hf],
                    n = t(),
                    _n$closedCaption = n.closedCaption,
                    r = _n$closedCaption.isLTEnable,
                    i = _n$closedCaption.isMeetingEnabledLiveTranscriptionFeature;
                if (!i) return new Promise(function (e, t) {
                  t({
                    type: "FEATURE_MISS",
                    reason: "please make suer enable Live Transcription in https://zoom.us/profile/setting"
                  });
                });

                if (!0 !== e || r) {
                  if (!1 !== e || !r) return new Promise(!0 === e && r ? function (e, t) {
                    t({
                      type: "OPERATION_LOCKED",
                      reason: "LT has been enabled"
                    });
                  } : !1 !== e || r ? function (e, t) {
                    t({
                      type: vs,
                      reason: "parameter should be boolean"
                    });
                  } : function (e, t) {
                    t({
                      type: "OPERATION_LOCKED",
                      reason: "LT has been disabled"
                    });
                  });
                  tg.enableLT(!1);
                } else tg.enableLT(!0);

                return Ts("LT_STATUS_CHANGE_RESPONSE", function (e) {
                  var t = e.bSuccess;
                  return t;
                }, 2e4);
              }
            }, {
              key: "allowAskLiveTranscription",
              value: function allowAskLiveTranscription(e) {
                var t = this[hf],
                    n = t(),
                    r = n.closedCaption.isMeetingEnabledLiveTranscriptionFeature;
                return r ? (tg.allowAskLT(!!e), Ts("LT_STATUS_CHANGE", function (t) {
                  var n = t.isAllow;
                  return n === e;
                })) : new Promise(function (e, t) {
                  t({
                    type: "FEATURE_MISS",
                    reason: "please make suer enable Live Transcription in https://zoom.us/profile/setting"
                  });
                });
              }
            }, {
              key: "sendClosedCaptionText",
              value: function sendClosedCaptionText(e, t) {
                var _this12 = this;

                var n = this[hf],
                    r = this[_f],
                    i = n(),
                    _i$closedCaption2 = i.closedCaption,
                    o = _i$closedCaption2.editorId,
                    a = _i$closedCaption2.tempSendCcText,
                    s = i.meeting.userName;
                return Promise.resolve(sc(i)).then(function (e) {
                  if (null != e && e.isHost && !o) return _this12.assignClosedCaptionEditor(e.userId);
                }).then(function () {
                  return n().closedCaption.isEditor ? function (e, t, n) {
                    var r,
                        i = null;
                    return n ? (r = function (e, t) {
                      var n = null,
                          r = 0;
                      var i = t.length,
                          o = e.length;
                      if (0 === i && o > 0) return {
                        operation: "start",
                        changedContent: e,
                        where: 0,
                        count: -1
                      };
                      if (0 === o && i > 0) return {
                        operation: "delete",
                        changedContent: t,
                        where: 0,
                        count: yi(t)
                      };
                      if (0 === o && 0 === i) return {
                        operation: "same"
                      };

                      for (var _a14 = 0; _a14 < o && e[_a14] === t[_a14]; _a14++) {
                        n = _a14, r += wi(e[_a14]);
                      }

                      return null === n ? {
                        operation: "replace",
                        changedContent: e,
                        where: 0,
                        count: -1
                      } : (n += 1, n === i && n < o ? {
                        operation: "insert",
                        changedContent: e.slice(n),
                        where: r,
                        count: -1
                      } : n < i && n === o ? {
                        operation: "delete",
                        changedContent: t.slice(n),
                        where: r,
                        count: yi(t.slice(n))
                      } : n === i && n === o ? {
                        operation: "same"
                      } : {
                        operation: "replace",
                        changedContent: e,
                        where: 0,
                        count: -1
                      });
                    }(e, t), "same" !== r.operation && (i = r.changedContent)) : (i = e, r = {
                      text: e,
                      seq: 1
                    }), Promise.resolve(i).then(function (e) {
                      return e ? Ko.beginEncrypt({
                        text: e,
                        type: Ho.CC_MESSAGE
                      }).then(function (e) {
                        return f(f({}, r), {}, n ? {
                          changedContent: e
                        } : {
                          text: e
                        });
                      }) : null;
                    });
                  }(e, a, t) : Promise.reject({
                    type: gs,
                    reason: "no permission"
                  });
                }).then(function (n) {
                  if (!n) return "";
                  tg.sendCloseCaption(n);
                  var i = {
                    text: e,
                    finished: !t,
                    sender: {
                      userId: o,
                      sender: s
                    }
                  };
                  return t || Object.assign(i, {
                    timeStamp: new Date().valueOf()
                  }), r(md(i)), Ts("CC_RECEIVE_MESSAGE", function () {
                    return {
                      ret: 0,
                      body: i
                    };
                  });
                });
              }
            }, {
              key: "getCCStatus",
              value: function getCCStatus() {
                var e = this[hf],
                    t = e(),
                    _t$closedCaption2 = t.closedCaption,
                    n = _t$closedCaption2.liveTranscriptionStatus,
                    r = _t$closedCaption2.isLTEnable,
                    i = _t$closedCaption2.isCCEnable,
                    o = _t$closedCaption2.isListenClosedCaption,
                    a = _t$closedCaption2.allowRequestLt,
                    s = _t$closedCaption2.askingStartLt,
                    c = _t$closedCaption2.isMeetingEnableClosedCaption,
                    l = _t$closedCaption2.isMeetingEnableAllowThirdPartyCCToken,
                    d = _t$closedCaption2.isMeetingEnabledLiveTranscriptionFeature,
                    u = _t$closedCaption2.isMeetingEnableViewFullTranscript;
                return {
                  liveTranscriptionStatus: n,
                  isLTEnable: r,
                  isCCEnable: i,
                  isListenClosedCaption: o,
                  allowRequestLt: a,
                  askingStartLt: s,
                  isMeetingEnableClosedCaption: c,
                  isMeetingEnableAllowThirdPartyCCToken: l,
                  isMeetingEnabledLiveTranscriptionFeature: d,
                  isMeetingEnableViewFullTranscript: u
                };
              }
            }, {
              key: "getCCUrl",
              value: function getCCUrl() {
                var e = this[hf],
                    t = e(),
                    n = t.meeting.ccUrl;
                return n;
              }
            }, {
              key: "getHistory",
              value: function getHistory() {
                var e = this[hf],
                    t = e(),
                    _t$closedCaption3 = t.closedCaption,
                    n = _t$closedCaption3.allMessages,
                    r = _t$closedCaption3.messagesOrder;
                return {
                  allMessages: n,
                  messagesOrder: r
                };
              }
            }, {
              key: "getLatest",
              value: function getLatest() {
                var e = this[hf],
                    t = e(),
                    n = t.closedCaption.tempReceiveCcText;
                return n;
              }
            }, {
              key: "setListenClosedCaption",
              value: function setListenClosedCaption(e) {
                var t = this[hf],
                    n = this[_f],
                    r = t(),
                    _r$closedCaption2 = r.closedCaption,
                    i = _r$closedCaption2.isListenClosedCaption,
                    o = _r$closedCaption2.isMeetingEnableClosedCaption,
                    a = _r$closedCaption2.isMeetingEnabledLiveTranscriptionFeature;
                return o || a ? e === i ? Promise.resolve({
                  reason: "you have ".concat(e ? "enabled" : "disabled", " listenClosedCaption")
                }) : Promise.resolve().then(function () {
                  n(Sd(e));
                }) : Promise.reject({
                  type: gs,
                  reason: "you need go to setting enable CC & LT feature"
                });
              }
            }, {
              key: "getEditor",
              value: function getEditor() {
                var e = this[hf],
                    t = e(),
                    n = t.closedCaption.editorId;
                var r;
                if (!n) return {};
                if (r = function (e, t) {
                  var n;
                  if ("string" == typeof t) n = e.participants.xmppAttendeeList.find(function (e) {
                    return e.jid === t;
                  });else {
                    if (t === Xo.All) return $m;
                    if (t === Xo.Panelist) return Xm;
                    n = e.participants.attendeesList.find(function (e) {
                      return e.userId === t;
                    }) || e.participants.xmppAttendeeList.find(function (e) {
                      return e.userId === t;
                    });
                  }
                  return n || {};
                }(t, n), !r) return {};
                var _r40 = r,
                    i = _r40.userId,
                    o = _r40.isHost,
                    a = _r40.displayName,
                    s = _r40.avatar,
                    c = _r40.bCoHost,
                    l = _r40.zoomID;
                return {
                  userId: i,
                  isHost: o,
                  displayName: a,
                  avatar: s,
                  bCoHost: c,
                  zoomID: l
                };
              }
            }]);

            return eg;
          }(Df)).prototype, "assignClosedCaptionEditor", [gf, yf], Object.getOwnPropertyDescriptor(eg.prototype, "assignClosedCaptionEditor"), eg.prototype), v(eg.prototype, "startLiveTranscription", [gf, yf], Object.getOwnPropertyDescriptor(eg.prototype, "startLiveTranscription"), eg.prototype), v(eg.prototype, "allowAskLiveTranscription", [gf, yf], Object.getOwnPropertyDescriptor(eg.prototype, "allowAskLiveTranscription"), eg.prototype), v(eg.prototype, "sendClosedCaptionText", [gf], Object.getOwnPropertyDescriptor(eg.prototype, "sendClosedCaptionText"), eg.prototype), v(eg.prototype, "getCCStatus", [gf], Object.getOwnPropertyDescriptor(eg.prototype, "getCCStatus"), eg.prototype), v(eg.prototype, "getCCUrl", [gf, yf], Object.getOwnPropertyDescriptor(eg.prototype, "getCCUrl"), eg.prototype), v(eg.prototype, "getHistory", [gf], Object.getOwnPropertyDescriptor(eg.prototype, "getHistory"), eg.prototype), v(eg.prototype, "getLatest", [gf], Object.getOwnPropertyDescriptor(eg.prototype, "getLatest"), eg.prototype), v(eg.prototype, "setListenClosedCaption", [gf], Object.getOwnPropertyDescriptor(eg.prototype, "setListenClosedCaption"), eg.prototype), eg);
          var rg = Hr(Zm);
          var ig = Object.freeze({
            __proto__: null,
            receiveChatMessageFromXMPPEpic: function receiveChatMessageFromXMPPEpic(e, t) {
              return Fr(e, 24583).pipe(ln(t), Je(function (e) {
                var _e204 = _slicedToArray(e, 2),
                    t = _e204[0],
                    n = _e204[1];

                if (n.meeting.zlkJwtToken) return ce;
                var _t$payload$body8 = t.payload.body,
                    r = _t$payload$body8.sn,
                    i = _t$payload$body8.senderName,
                    o = _t$payload$body8.senderJid,
                    a = _t$payload$body8.receiver,
                    s = _t$payload$body8.text,
                    c = _t$payload$body8.type,
                    l = sc(n),
                    d = dc(n),
                    _n$meeting8 = n.meeting,
                    u = _n$meeting8.jid,
                    p = _n$meeting8.userId,
                    h = n.participants.xmppAttendeeList;
                return Ko.beginDecrypt({
                  decryptedText: s,
                  type: Ho.XMPP_CHAT,
                  zoomId: r
                }).then(function (e) {
                  var t;
                  var n = e.message,
                      r = null,
                      s = 0,
                      _ = "";
                  l && ec(l.userRole) && u === a ? (r = h.find(function (e) {
                    return e.jid === o;
                  }), s = p, _ = l.displayName) : c === Xo.Panelist && (r = d.find(function (e) {
                    return e.jid === o;
                  }), s = Xo.Panelist, _ = sa.displayName);
                  var f = {
                    message: n,
                    sender: {
                      name: i,
                      userId: (null === (t = r) || void 0 === t ? void 0 : t.userId) || 0,
                      avatar: ""
                    },
                    receiver: {
                      name: _,
                      userId: s
                    },
                    timestamp: new Date().getTime()
                  };
                  return As("CHAT_RECEIVE_MESSAGE_EVENTS", f), dd(f);
                });
              }));
            },
            receiveChatMessageFromRWGEpic: function receiveChatMessageFromRWGEpic(e, t) {
              return Vr(e, 7944).pipe(ln(t), Je(function (e) {
                var _e205 = _slicedToArray(e, 2),
                    t = _e205[0],
                    n = _e205[1];

                var _n$meeting9 = n.meeting,
                    r = _n$meeting9.bIbDisableChat,
                    i = _n$meeting9.isWebinar,
                    o = n.participants.attendeesList,
                    _t$payload$body9 = t.payload.body,
                    a = _t$payload$body9.attendeeNodeID,
                    s = _t$payload$body9.sn,
                    c = _t$payload$body9.destNodeID,
                    l = _t$payload$body9.text,
                    d = _t$payload$body9.senderName,
                    u = _t$payload$body9.msgID,
                    p = sc(n),
                    h = dc(n);

                if (p) {
                  var _e206 = ec(null == p ? void 0 : p.userRole) && a === p.userId && !u;

                  if (!r && !_e206) {
                    var _e207,
                        _t87 = s;

                    if (!s) {
                      var _e208 = o.find(function (e) {
                        return e.userId === c;
                      });

                      _e208 && (_t87 = _e208.zoomID);
                    }

                    if (a === Xo.SilentModeUsers) {
                      var _t88 = gi(l),
                          _n60 = {
                        id: u,
                        message: _t88,
                        sender: {
                          name: "Host",
                          userId: c
                        },
                        receiver: {
                          name: "Everyone (in Waiting Room)",
                          userId: a
                        },
                        timestamp: new Date().getTime()
                      };

                      _e207 = Promise.resolve(_n60);
                    } else _e207 = Ko.beginDecrypt({
                      decryptedText: l,
                      zoomId: _t87,
                      type: Ho.RWG_CHAT
                    }).then(function (e) {
                      var t = e.message;
                      var n = o.find(function (e) {
                        return e.userId === c;
                      }),
                          r = d ? gi(d) : null == n ? void 0 : n.displayName;
                      var s = "";
                      if (a === Xo.All) s = i ? "All panelists and attendees" : "Everyone";else if (a === Xo.Panelist) s = "All panelists";else if (i && h.findIndex(function (e) {
                        return e.userId === a;
                      }) > -1) s = h.find(function (e) {
                        return e.userId === a;
                      }).displayName;else {
                        var _e209 = o.find(function (e) {
                          return e.userId === a;
                        });

                        _e209 && (s = _e209.displayName);
                      }
                      return {
                        id: u,
                        message: t,
                        sender: {
                          name: r,
                          userId: c,
                          avatar: null == n ? void 0 : n.avatar
                        },
                        receiver: {
                          name: s,
                          userId: a
                        },
                        timestamp: new Date().getTime()
                      };
                    });

                    return _e207.then(function (e) {
                      return As("CHAT_RECEIVE_MESSAGE_EVENTS", e), dd(e);
                    });
                  }
                }

                return ce;
              }));
            },
            changeAttendeePrivilegeResponse: function changeAttendeePrivilegeResponse(e, t) {
              return Vr(e, 7938).pipe(pt(function (e) {
                var t, n;
                return void 0 !== (null === (t = e.payload.body) || void 0 === t ? void 0 : t.chatPriviledge) || void 0 !== (null === (n = e.payload.body) || void 0 === n ? void 0 : n.bAllowAttendeeChat);
              }), ln(t), Me(function (e) {
                var _e210 = _slicedToArray(e, 2),
                    t = _e210[0],
                    n = _e210[1];

                var _t$payload$body10 = t.payload.body,
                    r = _t$payload$body10.chatPriviledge,
                    i = _t$payload$body10.bAllowAttendeeChat,
                    o = n.chat.chatPrivilege;
                return void 0 !== i ? (As("CHAT_PRIVILEGE_CHANGE", !0 === i ? {
                  chatPrivilege: o
                } : {
                  chatPrivilege: Jo.NoAttendee
                }), pd(i)) : (As("CHAT_PRIVILEGE_CHANGE", {
                  chatPrivilege: r
                }), cd(r));
              }));
            },
            changePanelistPrivilegeResponse: function changePanelistPrivilegeResponse(e) {
              return Vr(e, 7938).pipe(pt(function (e) {
                var t;
                return void 0 !== (null === (t = e.payload.body) || void 0 === t ? void 0 : t.panelistChatPriviledge);
              }), Me(function (e) {
                var t = e.payload.body.panelistChatPriviledge;
                return As("CHAT_PRIVILEGE_CHANGE", {
                  panelistChatPrivilege: t
                }), ld(t);
              }));
            },
            chatResponseEpic: function chatResponseEpic(e, t) {
              return Vr(e, 4136).pipe(ln(t), Je(function (e) {
                var _e211 = _slicedToArray(e, 2),
                    t = _e211[0],
                    n = _e211[1];

                var _t$payload$body11 = t.payload.body,
                    r = _t$payload$body11.result,
                    i = _t$payload$body11.destNodeID,
                    o = _t$payload$body11.msgID,
                    a = n.meeting.userId,
                    s = n.chat.chatHistory;

                if (r === ta.Success) {
                  var c, l;
                  var _e212 = [];

                  for (var _n61 = s.length - 1; _n61 >= 0; _n61--) {
                    var _t90 = s[_n61];
                    if (!_t90.id && _t90.sender.userId === a && [Xo.All, Xo.Panelist, Xo.IndividualCcPanelist, i].includes(_t90.receiver.userId) && _e212.unshift(_t90), _t90.id) break;
                  }

                  var _t89 = _e212.length > 0 && null !== (c = null === (l = _e212[0]) || void 0 === l ? void 0 : l.highResTimeStampForIdentification) && void 0 !== c ? c : 0;

                  return As("CHAT_MESSAGE_RESPONSE", {
                    msgId: o,
                    receiverId: i,
                    identification: _t89
                  }), fe(hd({
                    destNodeID: i,
                    msgID: o,
                    userId: a
                  }));
                }

                return r === ta.Delete || r === ta.Block ? fe(_d({
                  msgId: o
                })) : ce;
              }));
            },
            chatCmdResponseEpic: function chatCmdResponseEpic(e) {
              return Vr(e, 4238).pipe(Je(function (e) {
                var _e$payload$body10 = e.payload.body,
                    t = _e$payload$body10.bSuccess,
                    n = _e$payload$body10.cmd,
                    r = _e$payload$body10.msgID,
                    i = [];
                return t && n === ea.Delete && (i.push(_d({
                  msgId: r
                })), As("CHAT_DELETE_MESSAGE_REPONSE", {
                  id: r
                })), Ke(i);
              }));
            },
            chatCmdIndicationEpic: function chatCmdIndicationEpic(e) {
              return Vr(e, 7960).pipe(Je(function (e) {
                var _e$payload$body11 = e.payload.body,
                    t = _e$payload$body11.cmd,
                    n = _e$payload$body11.msgID,
                    r = [];
                return t === ea.Delete && (r.push(_d({
                  msgId: n
                })), As("CHAT_DELETE_MESSAGE_REPONSE", {
                  id: n
                })), Ke(r);
              }));
            }
          });
          var og = {
            chatHistory: [],
            chatPrivilege: Jo.All,
            panelistChatPrivilege: $o.AllPanelist,
            isAllowAttendeeChat: !0
          },
              ag = ur((_ur9 = {}, _defineProperty(_ur9, "".concat(dd), Hp(function (e, t) {
            var n = t.payload;
            e.chatHistory.push(n);
          })), _defineProperty(_ur9, "".concat(cd), Hp(function (e, t) {
            var n = t.payload;
            e.chatPrivilege = n;
          })), _defineProperty(_ur9, "".concat(ld), Hp(function (e, t) {
            var n = t.payload;
            e.panelistChatPrivilege = n;
          })), _defineProperty(_ur9, "".concat(pd), Hp(function (e, t) {
            var n = t.payload;
            e.isAllowAttendeeChat = n;
          })), _defineProperty(_ur9, "".concat(hd), Hp(function (e, t) {
            var n = t.payload;
            var r = n.destNodeID,
                i = n.msgID,
                o = n.userId,
                a = [];

            for (var _s14 = e.chatHistory.length - 1; _s14 >= 0; _s14--) {
              var _t91 = e.chatHistory[_s14];
              if (!_t91.id && _t91.sender.userId === o && [Xo.All, Xo.Panelist, r].includes(_t91.receiver.userId) && a.unshift(_t91), _t91.id) break;
            }

            a.length > 0 && (a[0].id = i);
          })), _defineProperty(_ur9, "".concat(_d), Hp(function (e, t) {
            var n = t.payload;
            var r = n.msgId,
                i = e.chatHistory.findIndex(function (e) {
              return e.id === r;
            });
            i >= 0 && e.chatHistory.splice(i, 1);
          })), _defineProperty(_ur9, "".concat(ud), function () {
            return f({}, og);
          }), _ur9), og);

          function sg(e, t, n) {
            if (null != n && n.host) return [_c(e)].concat(_toConsumableArray(fc(e))).filter(function (e) {
              return (null == e ? void 0 : e.userId) !== t;
            }).map(function (e) {
              return {
                userId: null == e ? void 0 : e.userId,
                displayName: null == e ? void 0 : e.displayName,
                isHost: null == e ? void 0 : e.isHost,
                isCoHost: null == e ? void 0 : e.bCoHost
              };
            });
            {
              var r = [_c(e)].concat(_toConsumableArray(fc(e)), _toConsumableArray(e.participants.attendeesList.filter(function (e) {
                return !(e.bCoHost || e.isHost || e.bHold);
              })));

              if (null != n && n.includeAttendee) {
                var _t92 = dc(e).filter(function (e) {
                  return !$s(e.userType);
                });

                r = [].concat(_toConsumableArray(r), _toConsumableArray(_t92));
              }

              return r.filter(function (e) {
                return (null == e ? void 0 : e.userId) !== t;
              }).map(function (e) {
                return {
                  userId: null == e ? void 0 : e.userId,
                  displayName: null == e ? void 0 : e.displayName,
                  isHost: null == e ? void 0 : e.isHost,
                  isCoHost: null == e ? void 0 : e.bCoHost
                };
              });
            }
          }

          var cg;

          var lg = ua.createAgent(),
              dg = th.getInstance(),
              ug = function ug(e) {
            var t = e.text,
                n = e.destId,
                r = e.sn,
                i = e.attendeeId;
            return Ko.beginEncrypt({
              text: t,
              type: Ho.RWG_CHAT
            }).then(function (e) {
              lg.chat(e, n, r, i);
            });
          };

          var pg = (v((cg = /*#__PURE__*/function (_Df3) {
            _inherits(cg, _Df3);

            var _super6 = _createSuper(cg);

            function cg() {
              _classCallCheck(this, cg);

              return _super6.apply(this, arguments);
            }

            _createClass(cg, [{
              key: "send",
              value: function send(e, t) {
                if (!e) return Promise.reject({
                  type: vs,
                  reason: "Text is empty"
                });

                var n = this[hf],
                    r = this[_f],
                    i = n(),
                    o = sc(i),
                    a = function (e, t) {
                  if (t === Xo.All) return aa;
                  if (t === Xo.Panelist) return sa;
                  if (t === Xo.SilentModeUsers) return ca;
                  {
                    var _n62 = e.meeting.isWebinar,
                        _e$participants = e.participants,
                        _r41 = _e$participants.xmppAttendeeList,
                        _i22 = _e$participants.attendeesList;
                    return _n62 ? _i22.find(function (e) {
                      return e.userId === t;
                    }) || _r41.find(function (e) {
                      return e.userId === t;
                    }) : _i22.find(function (e) {
                      return e.userId === t;
                    });
                  }
                }(i, t),
                    s = function (e, t, n) {
                  var r = null == t ? void 0 : t.userId;
                  if (null == e || !e.zoomID || null == t || !t.displayName || r === e.userId) return {
                    type: vs,
                    reason: "invalid target user"
                  };
                  var _n$chat = n.chat,
                      i = _n$chat.chatPrivilege,
                      o = _n$chat.panelistChatPrivilege,
                      a = n.meeting.isWebinar,
                      s = cc(n),
                      c = t.isHost || t.bCoHost;
                  var l = !1;

                  if (!s) {
                    if (a) {
                      if (ec(e.userRole)) (i === Jo.NoAttendee || i === Jo.AllPanelist && r !== Xo.Panelist || i === Jo.All && r !== Xo.All && r !== Xo.Panelist) && (l = !0);else {
                        var _e213 = ec(null == t ? void 0 : t.userRole);

                        (o === $o.Invalid || o === $o.AllPanelist && (_e213 || r === Xo.All)) && (l = !0);
                      }
                    } else (i === Jo.NoAttendee || i === Jo.Host && !c || r === Xo.SilentModeUsers || i === Jo.EveryonePublicly && r !== Xo.All && !c) && (l = !0);
                    if (l) return {
                      type: gs,
                      reason: "Insufficient chat privilege"
                    };
                  }

                  return null;
                }(o, a, i);

                if (s) return Promise.reject(s);
                var _i$meeting = i.meeting,
                    c = _i$meeting.isWebinar,
                    l = _i$meeting.encType,
                    d = l === Bo.AES_GCM;
                var u = Promise.resolve(),
                    p = !1;
                var h = c && ec(a.userRole);
                return t === Xo.SilentModeUsers ? lg.chat(mi(e), t) : c ? h ? 8 == (8 & a.clientCap) ? u = ug({
                  text: e,
                  destId: Xo.IndividualCcPanelist,
                  sn: null == o ? void 0 : o.zoomID,
                  attendeeId: t
                }) : (u = ug({
                  text: e,
                  destId: Xo.Panelist,
                  sn: null == o ? void 0 : o.zoomID,
                  attendeeId: t
                }).then(function () {
                  return function (e) {
                    var t = e.text,
                        n = e.jid,
                        r = e.isGCMEnabled;
                    return Ko.beginEncrypt({
                      text: t,
                      type: Ho.XMPP_CHAT
                    }).then(function (e) {
                      dg.sendWebinarMseeage(e, n, Xo.IndividualCcPanelist, r);
                    });
                  }({
                    text: e,
                    jid: a.jid,
                    isGCMEnabled: d
                  });
                }), p = !0) : a && (u = ug({
                  text: e,
                  destId: a.userId,
                  sn: null == o ? void 0 : o.zoomID
                })) : u = ug({
                  text: e,
                  destId: a.userId,
                  sn: null == o ? void 0 : o.zoomID
                }), u.then(function () {
                  var n = new Date().getTime(),
                      i = performance.now(),
                      s = {
                    message: e,
                    sender: {
                      name: null == o ? void 0 : o.displayName,
                      userId: null == o ? void 0 : o.userId,
                      avatar: null == o ? void 0 : o.avatar
                    },
                    receiver: {
                      name: null == a ? void 0 : a.displayName,
                      userId: h ? Xo.IndividualCcPanelist : null == a ? void 0 : a.userId
                    },
                    timestamp: n,
                    highResTimeStampForIdentification: i
                  };
                  return r(dd(s)), p ? (As("CHAT_RECEIVE_MESSAGE_EVENTS", s), s) : new Promise(function (e, n) {
                    var r;
                    Os("CHAT_MESSAGE_RESPONSE").pipe(cn(5e3), (r = function r(e) {
                      return i !== e.identification || !([e.receiverId, Xo.All, Xo.Panelist].includes(t) || e.receiverId === Xo.IndividualCcPanelist);
                    }, function (e) {
                      return e.lift(new Ft(r));
                    }), Nt(1)).subscribe(function (t) {
                      var n = t.msgId,
                          r = f(f({
                        id: n
                      }, g(s, ["highResTimeStampForIdentification"])), h && {
                        receiver: {
                          name: null == a ? void 0 : a.displayName,
                          userId: null == a ? void 0 : a.userId
                        }
                      });
                      As("CHAT_RECEIVE_MESSAGE_EVENTS", r), e(r);
                    }, function () {
                      n({
                        type: "OPERATION_TIMEOUT"
                      });
                    });
                  });
                });
              }
            }, {
              key: "setPrivilege",
              value: function setPrivilege(e) {
                var t = this[hf](),
                    n = t.meeting.isWebinar,
                    r = t.chat.chatPrivilege;
                return r === e ? Promise.resolve("") : !n && !na.includes(e) || n && !ra.includes(e) ? Promise.reject({
                  type: vs,
                  reason: "invalid privilege value of parameter"
                }) : (lg.setChatPriviledge(e), Ts("CHAT_PRIVILEGE_CHANGE", function (t) {
                  return t.chatPrivilege === e;
                }));
              }
            }, {
              key: "setPanelistPrivilege",
              value: function setPanelistPrivilege(e) {
                var t = this[hf](),
                    n = t.chat.panelistChatPrivilege,
                    r = oa[e];
                return n === r ? Promise.resolve("") : Object.values(ia).includes(e) ? (lg.setPanelistChatPrivilege(e), Ts("CHAT_PRIVILEGE_CHANGE", function (e) {
                  return e.panelistChatPrivilege === r;
                })) : Promise.reject({
                  type: vs,
                  reason: "Panelist privilege value is invalid"
                });
              }
            }, {
              key: "deleteMessage",
              value: function deleteMessage(e) {
                var t = this[hf](),
                    n = t.chat.chatHistory,
                    _t$meeting4 = t.meeting,
                    r = _t$meeting4.meetingOptions,
                    i = _t$meeting4.userId;

                if (null != r && r.isEnableDeleteChatMsg) {
                  var _r42 = cc(t),
                      o = n.find(function (t) {
                    return t.id === e;
                  });

                  if (o) {
                    var _t93 = o.sender;
                    if (_r42) lg.chatCmdReq(e, ea.Delete);else {
                      if (_t93.userId !== i) return Promise.reject({
                        type: gs,
                        reason: "can not delete message"
                      });
                      lg.chatCmdReq(e, ea.Delete);
                    }
                    return Ts("CHAT_DELETE_MESSAGE_REPONSE", function (t) {
                      return t.id === e;
                    }).then(function () {
                      return {
                        id: e
                      };
                    });
                  }

                  return Promise.reject({
                    type: vs,
                    reason: "msgId is wrong"
                  });
                }

                return Promise.reject({
                  type: ms,
                  reason: "can not delete messages"
                });
              }
            }, {
              key: "lockChat",
              value: function lockChat(e) {
                var t = this[hf](),
                    n = t.meeting.meetingOptions,
                    r = null != n && n.isPrivateChatEnabled ? Jo.All : Jo.EveryonePublicly;
                return this.setPrivilege(e ? Jo.NoOne : r);
              }
            }, {
              key: "getPrivilege",
              value: function getPrivilege() {
                var _this$hf = this[hf](),
                    _this$hf$chat = _this$hf.chat,
                    e = _this$hf$chat.chatPrivilege,
                    t = _this$hf$chat.isAllowAttendeeChat;

                return t ? e : Jo.NoAttendee;
              }
            }, {
              key: "getReceivers",
              value: function getReceivers() {
                var e = this[hf](),
                    _e$chat = e.chat,
                    t = _e$chat.chatPrivilege,
                    n = _e$chat.panelistChatPrivilege,
                    r = _e$chat.isAllowAttendeeChat,
                    i = e.meeting.isWebinar;
                if (!i && !r) return [];
                var o = sc(e),
                    a = cc(e);
                if (o) if (i) {
                  if (ec(o.userRole)) {
                    if (!r) return [];
                    if (t === Jo.All) return [sa, aa];
                    if (t === Jo.AllPanelist) return [sa];
                    if (t === Jo.NoOne) return [];
                  } else {
                    if (a || n === $o.Everyone) {
                      var _t94 = sg(e, o.userId, {
                        includeAttendee: !0
                      });

                      return [sa, aa].concat(_toConsumableArray(_t94));
                    }

                    if (n === $o.AllPanelist) {
                      var _t95 = sg(e, o.userId);

                      return [sa].concat(_toConsumableArray(_t95));
                    }
                  }
                } else {
                  var _n63 = cc(e);

                  if (t === Jo.All || _n63) {
                    var _t96 = sg(e, o.userId);

                    return [aa].concat(_toConsumableArray(_t96));
                  }

                  if (t === Jo.Host) return sg(e, o.userId, {
                    host: !0
                  });

                  if (t === Jo.EveryonePublicly) {
                    var _t97 = sg(e, o.userId, {
                      host: !0
                    });

                    return [aa].concat(_toConsumableArray(_t97));
                  }

                  if (t === Jo.NoOne) return [];
                }
                return [];
              }
            }, {
              key: "getHistory",
              value: function getHistory() {
                return this[hf]().chat.chatHistory.map(function (e) {
                  return g(e, ["highResTimeStampForIdentification"]);
                });
              }
            }, {
              key: "isAllowToDeleteMessages",
              value: function isAllowToDeleteMessages() {
                var e = this[hf](),
                    t = e.meeting.meetingOptions;
                return null == t ? void 0 : t.isEnableDeleteChatMsg;
              }
            }]);

            return cg;
          }(Df)).prototype, "send", [gf], Object.getOwnPropertyDescriptor(cg.prototype, "send"), cg.prototype), v(cg.prototype, "setPrivilege", [bf, gf], Object.getOwnPropertyDescriptor(cg.prototype, "setPrivilege"), cg.prototype), v(cg.prototype, "setPanelistPrivilege", [bf, gf, vf], Object.getOwnPropertyDescriptor(cg.prototype, "setPanelistPrivilege"), cg.prototype), v(cg.prototype, "deleteMessage", [gf], Object.getOwnPropertyDescriptor(cg.prototype, "deleteMessage"), cg.prototype), v(cg.prototype, "lockChat", [bf, gf], Object.getOwnPropertyDescriptor(cg.prototype, "lockChat"), cg.prototype), cg);
          var hg = Hr(ig);

          var _g = Object.freeze({
            __proto__: null,
            handleRecordingEnableEpic: function handleRecordingEnableEpic(e) {
              return e.pipe(fn("".concat(Di)), Me(function (e) {
                var t = e.payload.recordingEnable;
                return eu(t);
              }));
            },
            receiveCloudRecordIndication: function receiveCloudRecordIndication(e) {
              return Vr(e, 7938).pipe(pt(function (e) {
                var t, n, r;
                return void 0 !== (null === (t = e.payload.body) || void 0 === t ? void 0 : t.cmrServerStatus) || void 0 !== (null === (n = e.payload.body) || void 0 === n ? void 0 : n.disAllowClientStopAutoCmr) || void 0 !== (null === (r = e.payload.body) || void 0 === r ? void 0 : r.enableAutomicRecordingCloud);
              }), Je(function (e) {
                var _e$payload$body12 = e.payload.body,
                    t = _e$payload$body12.cmrServerStatus,
                    n = _e$payload$body12.disAllowClientStopAutoCmr,
                    r = _e$payload$body12.enableAutomicRecordingCloud,
                    i = [];
                return void 0 !== t && (t !== ka.Init && As("CLOUD_RECORDING_STATUS_CHANGE", {
                  cmrServerStatus: t
                }), i.push(Xd(t))), void 0 !== n && i.push(tu(!n)), void 0 !== r && i.push(nu(r)), Ke(i);
              }));
            },
            receiveLocalRecordingIndicationEpic: function receiveLocalRecordingIndicationEpic(e) {
              return Vr(e, 7937).pipe(pt(function (e) {
                var t = e.payload.body.update;
                return null == t ? void 0 : t.some(function (e) {
                  return void 0 !== e.bLocalRecordStatus;
                });
              }), nn(function (e) {
                var t = e.payload.body.update;
                t.filter(function (e) {
                  return void 0 !== e.bLocalRecordStatus;
                }).forEach(function (e) {
                  As("LOCAL_RECORDING_CHANGE", {
                    userId: e.id,
                    bLocalRecord: 1 === e.bLocalRecordStatus
                  });
                });
              }), qt(ce));
            }
          });

          var fg = {
            cmrStatus: ka.Stop,
            recordingEnable: !1,
            allowStopAutoRecording: !1,
            automaticCloudRecordingEnable: !1
          },
              mg = ur((_ur10 = {}, _defineProperty(_ur10, "".concat(Xd), Hp(function (e, t) {
            var n = t.payload;
            e.cmrStatus = n;
          })), _defineProperty(_ur10, "".concat(eu), Hp(function (e, t) {
            var n = t.payload;
            e.recordingEnable = n;
          })), _defineProperty(_ur10, "".concat(tu), Hp(function (e, t) {
            var n = t.payload;
            e.allowStopAutoRecording = n;
          })), _defineProperty(_ur10, "".concat(nu), Hp(function (e, t) {
            var n = t.payload;
            e.automaticCloudRecordingEnable = n;
          })), _defineProperty(_ur10, "".concat(ru), function () {
            return f({}, fg);
          }), _ur10), fg);
          var gg, vg, bg, yg;
          var wg = ua.createAgent();
          var Sg = (gg = xf("recording"), vg = xf("recording"), bg = xf("recording"), v((yg = /*#__PURE__*/function (_Df4) {
            _inherits(yg, _Df4);

            var _super7 = _createSuper(yg);

            function yg() {
              _classCallCheck(this, yg);

              return _super7.apply(this, arguments);
            }

            _createClass(yg, [{
              key: "startRecording",
              value: function startRecording() {
                var e = this[hf](),
                    _e$meeting4 = e.meeting,
                    t = _e$meeting4.bIbDisableRecording,
                    n = _e$meeting4.recordingEnable,
                    r = e.recording.cmrStatus;
                return t ? Promise.reject({
                  type: ms,
                  reason: "Rejected by Information Barrier"
                }) : n ? r === ka.Start ? Promise.resolve("") : (wg.recordMeeting(!0, !1), Ts("CLOUD_RECORDING_STATUS_CHANGE", function (e) {
                  return e.cmrServerStatus === ka.Start;
                })) : Promise.reject({
                  type: ms,
                  reason: "The account of the meeting disabled the cloud recording"
                });
              }
            }, {
              key: "pauseRecording",
              value: function pauseRecording() {
                var e = this[hf](),
                    t = e.recording.cmrStatus;
                return t === ka.Pause ? Promise.resolve("") : t !== ka.Start ? Promise.reject({
                  type: ms,
                  reason: "Recording is not started"
                }) : (wg.recordMeeting(!1, !0), Ts("CLOUD_RECORDING_STATUS_CHANGE", function (e) {
                  return e.cmrServerStatus === ka.Pause;
                }));
              }
            }, {
              key: "stopRecording",
              value: function stopRecording() {
                var e = this[hf](),
                    t = e.recording.cmrStatus;
                return t === ka.Stop ? Promise.resolve("") : (wg.recordMeeting(!1, !1), Ts("CLOUD_RECORDING_STATUS_CHANGE", function (e) {
                  return e.cmrServerStatus === ka.Stop;
                }));
              }
            }, {
              key: "getRecordingStatus",
              value: function getRecordingStatus() {
                var e = this[hf](),
                    t = e.recording.cmrStatus;
                return t === ka.Start ? Ca.Recording : t === ka.Pause ? Ca.Paused : Ca.Stopped;
              }
            }, {
              key: "isRecordingEnabled",
              value: function isRecordingEnabled() {
                var e = this[hf](),
                    t = e.recording.recordingEnable;
                return t;
              }
            }, {
              key: "isAllowedToStopAutoRecording",
              value: function isAllowedToStopAutoRecording() {
                var e = this[hf](),
                    t = e.recording.allowStopAutoRecording;
                return t;
              }
            }, {
              key: "isAutomaticCloudRecordingEnabled",
              value: function isAutomaticCloudRecordingEnabled() {
                var e = this[hf](),
                    t = e.recording.automaticCloudRecordingEnable;
                return t;
              }
            }]);

            return yg;
          }(Df)).prototype, "startRecording", [bf, gf, gg], Object.getOwnPropertyDescriptor(yg.prototype, "startRecording"), yg.prototype), v(yg.prototype, "pauseRecording", [bf, gf, vg], Object.getOwnPropertyDescriptor(yg.prototype, "pauseRecording"), yg.prototype), v(yg.prototype, "stopRecording", [bf, gf, bg], Object.getOwnPropertyDescriptor(yg.prototype, "stopRecording"), yg.prototype), yg);
          var xg = Hr(_g),
              Eg = ua.createAgent();
          var Cg = Object.freeze({
            __proto__: null,
            handleQAEnableEpic: function handleQAEnableEpic(e) {
              return e.pipe(fn("".concat(Di)), Me(function (e) {
                var t = e.payload.isSupportQA;
                return ad(t);
              }));
            },
            handleQASettingEpic: function handleQASettingEpic(e, t) {
              return Vr(e, 7938).pipe(pt(function (e) {
                return ["bAllowAnonymousQuestion", "bAllowAttendeeViewAllQuestion", "bAllowAttendeeUpvoteQuestion", "bAllowAttendeeCommentQuestion"].some(function (t) {
                  return e.payload.body.hasOwnProperty(t);
                });
              }), Je(function (e) {
                var _e$payload$body13 = e.payload.body,
                    n = _e$payload$body13.bAllowAnonymousQuestion,
                    r = _e$payload$body13.bAllowAttendeeViewAllQuestion,
                    i = _e$payload$body13.bAllowAttendeeUpvoteQuestion,
                    o = _e$payload$body13.bAllowAttendeeCommentQuestion,
                    _t$value4 = t.value,
                    a = _t$value4.meeting.userId,
                    s = _t$value4.QA.setting,
                    c = [];
                return void 0 !== n && (c.push(Yl({
                  allowAnonymousQuestion: n
                })), As("QA_SETTING_OPTION_CHANGE", {
                  allowAnonymousQuestion: n
                })), void 0 !== r && (c.push(Yl({
                  allowAttendeeViewAllQuestion: r
                })), As("QA_SETTING_OPTION_CHANGE", {
                  allowAttendeeViewAllQuestion: r
                }), r || (s.allowAttendeeVote && Eg.allowVote(a, !1), s.allowAttendeeComment && Eg.allowComment(a, !1))), void 0 !== i && (c.push(Yl({
                  allowAttendeeVote: i
                })), As("QA_SETTING_OPTION_CHANGE", {
                  allowAttendeeVote: i
                })), void 0 !== o && (c.push(Yl({
                  allowAttendeeComment: o
                })), As("QA_SETTING_OPTION_CHANGE", {
                  allowAttendeeComment: o
                })), Ke(c);
              }));
            },
            handleQAResponseEpic: function handleQAResponseEpic(e, t) {
              return Fr(e, 24593).pipe(pt(function (e) {
                var _e$payload$body14 = e.payload.body,
                    t = _e$payload$body14.answer,
                    n = _e$payload$body14.question;
                return null == t || !t.id || (null == t ? void 0 : t.command) === us.DeleteComment || "" !== (null == n ? void 0 : n.id);
              }), Je(function (e) {
                var _e$payload$body15 = e.payload.body,
                    n = _e$payload$body15.answer,
                    r = _e$payload$body15.question,
                    i = t.value,
                    o = i.QA.questionsAnswers,
                    a = i.participants.xmppAttendeeList,
                    s = i.meeting.jid,
                    c = sc(i),
                    l = gc(i),
                    d = [],
                    u = r.id,
                    p = r.jid,
                    h = r.command,
                    _ = n.command,
                    m = o.findIndex(function (e) {
                  return e.id === u;
                });
                var g, v;

                if (u && -1 === m) {
                  if (h === ps.Question && "" === _) d.push(Jl(r)), As("QA_NEW_ASK_QUESTION", {
                    questionId: u,
                    questionText: r.text,
                    userId: null === (g = l[r.jid]) || void 0 === g ? void 0 : g.userId,
                    displayName: r.name,
                    time: Number(r.time)
                  });else if (h === ps.Question && _ === us.MakePublicView) {
                    var b;
                    p !== s && c && ec(null == c ? void 0 : c.userRole) && (d.push(Jl(r)), As("QA_NEW_ASK_QUESTION", {
                      questionId: u,
                      questionText: r.text,
                      userId: null === (b = l[r.jid]) || void 0 === b ? void 0 : b.userId,
                      displayName: r.name,
                      time: Number(r.time)
                    }));
                  }
                } else if (u && "" === _ && c && ec(null == c ? void 0 : c.userRole) && r.anony && (d.push(od(r)), As("QA_UPDATE_ANONYMOUS_QUESTION", {
                  questionId: u,
                  questionText: r.text,
                  userId: null === (v = l[r.jid]) || void 0 === v ? void 0 : v.userId,
                  displayName: r.name,
                  time: Number(r.time)
                })), _ === us.Comment) {
                  var y;

                  var _e214 = n.jid,
                      _t98 = a.find(function (t) {
                    return t.jid === _e214;
                  });

                  var _r43 = !1;

                  _t98 && (_r43 = _t98.userRole !== Zs.Attendee), d.push($l(f(f({}, n), {}, {
                    privately: !1,
                    isFromHostOrPanelist: _r43,
                    qId: u,
                    name: n.name || (null == _t98 ? void 0 : _t98.displayName)
                  }))), As("QA_ANSWER_QUESTION", {
                    questionId: u,
                    id: n.id,
                    userId: null === (y = l[n.jid]) || void 0 === y ? void 0 : y.userId,
                    displayName: n.name || (null == _t98 ? void 0 : _t98.displayName),
                    text: n.text,
                    time: Number(n.time),
                    isFromHostOrPanelist: ec(c.userRole) ? void 0 : _r43
                  });
                } else if (_ === us.PrivateView) {
                  var w;
                  "" !== n.text && (d.push($l(f(f({}, n), {}, {
                    privately: !0,
                    isFromHostOrPanelist: !0,
                    qId: u,
                    name: n.name
                  }))), As("QA_ANSWER_QUESTION", {
                    questionId: u,
                    id: n.id,
                    userId: null === (w = l[n.jid]) || void 0 === w ? void 0 : w.userId,
                    displayName: n.name,
                    text: n.text,
                    time: Number(n.time),
                    privately: !0,
                    isFromHostOrPanelist: !0
                  }));
                } else if (_ === us.DeleteComment) {
                  var _e215 = o.length;
                  var _t99 = "";

                  for (var _r44 = 0; _r44 < _e215; _r44++) {
                    var _e216 = o[_r44];

                    if (_e216.answers && -1 !== _e216.answers.findIndex(function (e) {
                      return e.id === n.id;
                    })) {
                      _t99 = _e216.id;
                      break;
                    }
                  }

                  _t99 && (d.push(Xl({
                    qId: _t99,
                    id: n.id
                  })), As("QA_ANSWER_REMOVE_COMMENT", {
                    questionId: _t99,
                    id: n.id
                  }));
                } else if (_ === us.DeleteQuestion && "" !== u) d.push(ed({
                  qId: u,
                  currentJid: s
                })), As("QA_ANSWER_REMOVE_QUESTION", {
                  questionId: u
                });else if (_ === us.Dismiss) {
                  var S;
                  -1 !== o.findIndex(function (e) {
                    return e.id === u;
                  }) && (d.push(td({
                    qId: u
                  })), As("QA_ANSWER_DISMISS_QUESTION", {
                    questionId: u,
                    userId: null === (S = l[n.jid]) || void 0 === S ? void 0 : S.userId,
                    displayName: n.name,
                    time: Number(n.time)
                  }));
                } else if (_ === us.Reopen) {
                  var x;
                  -1 !== o.findIndex(function (e) {
                    return e.id === u;
                  }) && (d.push(nd({
                    qId: u
                  })), As("QA_ANSWER_REOPEN_QUESTION", {
                    questionId: u,
                    userId: null === (x = l[n.jid]) || void 0 === x ? void 0 : x.userId,
                    displayName: n.name,
                    time: Number(n.time)
                  }));
                } else if ((_ === us.Upvote || _ === us.RevokeUpvote) && -1 !== o.findIndex(function (e) {
                  return e.id === u;
                })) {
                  var E;

                  var _e217 = s === n.jid,
                      _t100 = {
                    qId: u,
                    isUpVoted: _ === us.Upvote
                  };

                  _e217 && Object.assign(_t100, {
                    voted: _ === us.Upvote
                  }), d.push(rd(_t100)), As("QA_ANSWER_VOTE_QUESTION", {
                    questionId: u,
                    userId: null === (E = l[n.jid]) || void 0 === E ? void 0 : E.userId,
                    displayName: n.name,
                    time: Number(n.time),
                    isUpVoted: _ === us.Upvote
                  });
                }

                return Ke(d);
              }));
            },
            handleAnswerLiveEpic: function handleAnswerLiveEpic(e, t) {
              return Fr(e, 24587).pipe(Je(function (e) {
                var _e$payload$body16 = e.payload.body,
                    n = _e$payload$body16.question_id,
                    r = _e$payload$body16.isLiveStart,
                    i = t.value.QA.questionsAnswers,
                    o = [];
                return -1 !== i.findIndex(function (e) {
                  return e.id === n;
                }) && (o.push(id({
                  qId: n,
                  isStarting: !!r
                })), As("QA_ANSWER_QUESTION_LIVE", {
                  questionId: n,
                  liveStatus: r ? ds.LiveStart : ds.LiveEnd
                })), Ke(o);
              }));
            }
          });
          var kg = {
            isQAEnabled: !1,
            setting: {
              allowAnonymousQuestion: !1,
              allowAttendeeComment: !1,
              allowAttendeeViewAllQuestion: !1,
              allowAttendeeVote: !1
            },
            questionsAnswers: []
          },
              Ag = ur((_ur11 = {}, _defineProperty(_ur11, "".concat(Yl), Hp(function (e, t) {
            var n = t.payload;
            Object.assign(e.setting, n);
          })), _defineProperty(_ur11, "".concat(Jl), Hp(function (e, t) {
            var n = t.payload;
            e.questionsAnswers.push({
              isAnonymous: n.anony,
              id: n.id,
              displayName: n.name,
              jid: n.jid,
              text: n.text,
              time: Number(n.time)
            });
          })), _defineProperty(_ur11, "".concat($l), Hp(function (e, t) {
            var n = t.payload;
            var r = n.qId,
                i = e.questionsAnswers.find(function (e) {
              return e.id === r;
            });

            if (i) {
              var _e218 = {
                privately: n.privately,
                id: n.id,
                displayName: n.name,
                text: n.text,
                jid: n.jid,
                time: Number(n.time),
                isFromHostOrPanelist: n.isFromHostOrPanelist
              };
              i.answers ? i.answers.push(_e218) : i.answers = [_e218];
            }
          })), _defineProperty(_ur11, "".concat(Xl), Hp(function (e, t) {
            var n = t.payload;
            var r = n.qId,
                i = n.id,
                o = e.questionsAnswers.find(function (e) {
              return e.id === r;
            });

            if (null != o && o.answers) {
              var _e219 = o.answers.findIndex(function (e) {
                return e.id = i;
              });

              -1 !== _e219 && o.answers.splice(_e219, 1);
            }
          })), _defineProperty(_ur11, "".concat(ed), Hp(function (e, t) {
            var n = t.payload;
            var r = n.qId,
                i = n.currentJid,
                o = e.questionsAnswers.findIndex(function (e) {
              return e.id === r;
            });

            if (-1 !== o) {
              var _t101 = e.questionsAnswers[o];
              _t101.jid === i ? _t101.deleted = !0 : e.questionsAnswers.splice(o, 1);
            }
          })), _defineProperty(_ur11, "".concat(td), Hp(function (e, t) {
            var n = t.payload;
            var r = n.qId,
                i = e.questionsAnswers.find(function (e) {
              return e.id === r;
            });
            i && (i.dismissed = !0);
          })), _defineProperty(_ur11, "".concat(nd), Hp(function (e, t) {
            var n = t.payload;
            var r = n.qId,
                i = e.questionsAnswers.find(function (e) {
              return e.id === r;
            });
            i && (i.dismissed = !1);
          })), _defineProperty(_ur11, "".concat(rd), Hp(function (e, t) {
            var n = t.payload;
            var r = n.qId,
                i = n.voted,
                o = n.isUpVoted,
                a = e.questionsAnswers.find(function (e) {
              return e.id === r;
            });
            var s;
            a && (a.voteCount = (null !== (s = a.voteCount) && void 0 !== s ? s : 0) + (o ? 1 : -1), void 0 !== i && (a.voted = i));
          })), _defineProperty(_ur11, "".concat(id), Hp(function (e, t) {
            var n = t.payload;
            var r = n.qId,
                i = n.isStarting,
                o = e.questionsAnswers.find(function (e) {
              return e.id === r;
            });
            o && (o.liveAnswerStatus = i ? ds.LiveStart : ds.LiveEnd);
          })), _defineProperty(_ur11, "".concat(od), Hp(function (e, t) {
            var n = t.payload;
            var r = n.id,
                i = e.questionsAnswers.find(function (e) {
              return e.id === r;
            });
            i && Object.assign(i, {
              isAnonymous: n.anony,
              displayName: n.name,
              jid: n.jid,
              text: n.text
            });
          })), _defineProperty(_ur11, "".concat(ad), Hp(function (e, t) {
            var n = t.payload;
            e.isQAEnabled = n;
          })), _defineProperty(_ur11, "".concat(sd), function () {
            return f({}, kg);
          }), _ur11), kg);
          var Ig;
          var Tg = ua.createAgent(),
              Og = th.getInstance();
          var Rg = (v((Ig = /*#__PURE__*/function (_Df5) {
            _inherits(Ig, _Df5);

            var _super8 = _createSuper(Ig);

            function Ig() {
              _classCallCheck(this, Ig);

              return _super8.apply(this, arguments);
            }

            _createClass(Ig, [{
              key: "configureQASetting",
              value: function configureQASetting(e) {
                var t = e.allowAnonymousQuestion,
                    n = e.allowAttendeeComment,
                    r = e.allowAttendeeViewAllQuestion,
                    i = e.allowAttendeeVote,
                    o = this[hf],
                    _o13 = o(),
                    a = _o13.meeting.userId,
                    s = _o13.QA.setting;

                void 0 !== t && t !== s.allowAnonymousQuestion && Tg.allowAnonymousQuestion(a, t), void 0 !== r && r !== s.allowAttendeeViewAllQuestion && Tg.allowViewAll(a, r);
                var c = null != r ? r : s.allowAttendeeViewAllQuestion;
                return void 0 !== n && n !== s.allowAttendeeComment && (n ? c ? Tg.allowComment(a, n) : console.warn("Cannot allow attendee to comment due to unable to view questions") : Tg.allowComment(a, n)), void 0 !== i && i !== s.allowAttendeeVote && (i ? c ? Tg.allowVote(a, i) : console.warn("Cannot allow attendee to vote due to unable to view questions") : Tg.allowVote(a, i)), Ts("QA_SETTING_OPTION_CHANGE", function (t) {
                  return Object.keys(t).every(function (n) {
                    return e[n] === t[n];
                  });
                });
              }
            }, {
              key: "askQuestion",
              value: function askQuestion(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                var n = this[hf],
                    r = n(),
                    _r$QA$setting = r.QA.setting,
                    i = _r$QA$setting.allowAnonymousQuestion,
                    o = _r$QA$setting.allowAttendeeViewAllQuestion,
                    a = vc(r);
                if (t && !i) return Promise.reject({
                  type: vs,
                  reason: "Cannot ask qusetion anonymously"
                });
                var s = sc(r);
                return s && Og.askQuestion(e, s.displayName, t, !!o), Ts("QA_NEW_ASK_QUESTION", function (e) {
                  return t || e.userId === a;
                });
              }
            }, {
              key: "answerQuestion",
              value: function answerQuestion(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                var r = this[hf],
                    i = r(),
                    o = i.QA.questionsAnswers,
                    a = vc(i),
                    s = o.find(function (t) {
                  return t.id === e;
                });
                return s && "" !== t ? (Og.sendAnswer(t, {
                  questionId: e,
                  displayName: s.displayName,
                  jid: s.jid,
                  questionText: s.text,
                  isAnonymous: s.isAnonymous,
                  questionTime: "".concat(s.time)
                }, n), Ts("QA_ANSWER_QUESTION", function (t) {
                  return t.questionId === e && t.userId === a;
                })) : "" === t ? Promise.reject({
                  type: vs,
                  reason: "Answer cannot be empty"
                }) : Promise.reject({
                  type: vs,
                  reason: "Cannot find the question"
                });
              }
            }, {
              key: "commentQuestion",
              value: function commentQuestion(e, t) {
                var n = this[hf],
                    r = n(),
                    _r$QA = r.QA,
                    i = _r$QA.setting.allowAttendeeComment,
                    o = _r$QA.questionsAnswers,
                    a = vc(r);
                if (!i) return Promise.reject({
                  type: ms,
                  reason: "Cannot comment the question due to the setting"
                });
                var s = o.find(function (t) {
                  return t.id === e;
                });
                return s ? (Og.sendAnswer(t, {
                  questionId: e,
                  displayName: s.displayName,
                  jid: s.jid,
                  questionText: s.text,
                  isAnonymous: s.isAnonymous,
                  questionTime: "".concat(s.time)
                }, !1), Ts("QA_ANSWER_QUESTION", function (t) {
                  return t.questionId === e && t.userId === a;
                })) : Promise.reject({
                  type: vs,
                  reason: "Cannot find the question"
                });
              }
            }, {
              key: "dismissQuestion",
              value: function dismissQuestion(e) {
                var t = this[hf],
                    n = t(),
                    r = n.QA.questionsAnswers,
                    i = vc(n),
                    o = r.find(function (t) {
                  return t.id === e;
                });
                return o ? (Og.dismissQuestion({
                  questionId: e,
                  displayName: o.displayName,
                  jid: o.jid,
                  questionText: o.text,
                  isAnonymous: o.isAnonymous,
                  questionTime: "".concat(o.time)
                }), Ts("QA_ANSWER_DISMISS_QUESTION", function (t) {
                  return t.questionId === e && t.userId === i;
                })) : Promise.reject({
                  type: vs,
                  reason: "Cannot find the question"
                });
              }
            }, {
              key: "deleteComment",
              value: function deleteComment(e, t) {
                var n = this[hf],
                    r = n(),
                    i = r.QA.questionsAnswers,
                    o = i.find(function (t) {
                  return t.id === e;
                });
                return o ? (-1 !== (null === (a = o.answers) || void 0 === a ? void 0 : a.findIndex(function (e) {
                  return e.id === t;
                })) ? Og.deleteComment(t) : Promise.reject({
                  type: vs,
                  reason: "Cannot find the comment"
                }), Ts("QA_ANSWER_REMOVE_COMMENT", function (n) {
                  return n.questionId === e && n.id === t;
                })) : Promise.reject({
                  type: vs,
                  reason: "Cannot find the question"
                });
                var a;
              }
            }, {
              key: "deleteQuestion",
              value: function deleteQuestion(e) {
                var t = this[hf],
                    n = t(),
                    r = n.QA.questionsAnswers;
                return r.find(function (t) {
                  return t.id === e;
                }) ? (Og.deleteQuestion(e), Ts("QA_ANSWER_REMOVE_QUESTION", function (t) {
                  return t.questionId === e;
                })) : Promise.reject({
                  type: vs,
                  reason: "Cannot find the question"
                });
              }
            }, {
              key: "answerLive",
              value: function answerLive(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                var n = this[hf],
                    r = n(),
                    i = r.QA.questionsAnswers,
                    o = i.find(function (t) {
                  return t.id === e;
                }),
                    a = t ? ds.LiveEnd : ds.LiveStart;
                return o ? o.liveAnswerStatus === a ? Promise.resolve("") : (Og.answerOnline({
                  questionId: e,
                  displayName: o.displayName,
                  jid: o.jid,
                  questionText: o.text,
                  isAnonymous: o.isAnonymous,
                  questionTime: "".concat(o.time)
                }, !t), Ts("QA_ANSWER_QUESTION_LIVE", function (t) {
                  return t.questionId === e && t.liveStatus === a;
                })) : Promise.reject({
                  type: vs,
                  reason: "Cannot find the question"
                });
              }
            }, {
              key: "upvoteQuestion",
              value: function upvoteQuestion(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                var n = this[hf],
                    r = n(),
                    _r$QA2 = r.QA,
                    i = _r$QA2.questionsAnswers,
                    o = _r$QA2.setting.allowAttendeeVote,
                    a = vc(r),
                    s = sc(r);

                if (s) {
                  if (ec(s.userRole) && !o) return Promise.reject({
                    type: ms,
                    reason: "Cannot vote due to the setting"
                  });

                  var _n64 = i.find(function (t) {
                    return t.id === e;
                  });

                  if (_n64) {
                    if (_n64.voted === t) return Promise.resolve("");
                    Og.upOrDownVote({
                      questionId: e,
                      displayName: _n64.displayName,
                      jid: _n64.jid,
                      questionText: _n64.text,
                      isAnonymous: _n64.isAnonymous,
                      questionTime: "".concat(_n64.time)
                    }, t);
                  }
                }

                return Ts("QA_ANSWER_VOTE_QUESTION", function (n) {
                  return n.questionId === e && n.userId === a && n.isUpVoted === t;
                });
              }
            }, {
              key: "reopenQuestion",
              value: function reopenQuestion(e) {
                var t = this[hf],
                    n = t(),
                    r = n.QA.questionsAnswers,
                    i = vc(n),
                    o = r.find(function (t) {
                  return t.id === e;
                });
                return o && (o.dismissed ? Og.reopenQuestion({
                  questionId: e,
                  displayName: o.displayName,
                  jid: o.jid,
                  questionText: o.text,
                  isAnonymous: o.isAnonymous,
                  questionTime: "".concat(o.time)
                }) : Promise.resolve("")), Ts("QA_ANSWER_REOPEN_QUESTION", function (t) {
                  return t.questionId === e && t.userId === i;
                });
              }
            }, {
              key: "getQuestionsList",
              value: function getQuestionsList() {
                var e = this[hf],
                    t = e(),
                    _t$QA = t.QA,
                    n = _t$QA.setting.allowAttendeeViewAllQuestion,
                    r = _t$QA.questionsAnswers,
                    i = t.meeting.jid,
                    o = sc(t),
                    a = gc(t);

                if (o) {
                  var _e220 = r;
                  return ec(o.userRole) && (n || (_e220 = r.filter(function (e) {
                    var t;
                    return e.jid === i || (null === (t = e.answers) || void 0 === t ? void 0 : t.some(function (e) {
                      return e.isFromHostOrPanelist;
                    }));
                  }))), _e220.map(function (e) {
                    var t;
                    var n = e.answers,
                        r = e.jid,
                        i = g(e, ["answers", "jid"]),
                        s = null == n ? void 0 : n.map(function (e) {
                      var t;
                      var n = e.jid,
                          r = e.isFromHostOrPanelist;
                      return f(f({}, g(e, ["jid", "isFromHostOrPanelist"])), {}, {
                        userId: null === (t = a[n]) || void 0 === t ? void 0 : t.userId,
                        isFromHostOrPanelist: ec(o.userRole) ? void 0 : r
                      });
                    });
                    return f(f({}, i), {}, {
                      userId: null === (t = a[r]) || void 0 === t ? void 0 : t.userId,
                      answers: s
                    });
                  });
                }

                return [];
              }
            }, {
              key: "getQASetting",
              value: function getQASetting() {
                var e = this[hf],
                    _e221 = e(),
                    t = _e221.QA.setting;

                return f({}, t);
              }
            }, {
              key: "isQAEnabled",
              value: function isQAEnabled() {
                var e = this[hf],
                    _e222 = e(),
                    t = _e222.QA.isQAEnabled;

                return t;
              }
            }]);

            return Ig;
          }(Df)).prototype, "configureQASetting", [bf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "configureQASetting"), Ig.prototype), v(Ig.prototype, "askQuestion", [wf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "askQuestion"), Ig.prototype), v(Ig.prototype, "answerQuestion", [Sf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "answerQuestion"), Ig.prototype), v(Ig.prototype, "commentQuestion", [wf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "commentQuestion"), Ig.prototype), v(Ig.prototype, "dismissQuestion", [Sf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "dismissQuestion"), Ig.prototype), v(Ig.prototype, "deleteComment", [Sf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "deleteComment"), Ig.prototype), v(Ig.prototype, "deleteQuestion", [Sf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "deleteQuestion"), Ig.prototype), v(Ig.prototype, "answerLive", [Sf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "answerLive"), Ig.prototype), v(Ig.prototype, "upvoteQuestion", [vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "upvoteQuestion"), Ig.prototype), v(Ig.prototype, "reopenQuestion", [Sf, vf, gf], Object.getOwnPropertyDescriptor(Ig.prototype, "reopenQuestion"), Ig.prototype), Ig);
          var Ng = Hr(Cg),
              Pg = {
            controlStatus: nc.NotStarted,
            sequenceId: 1,
            rooms: [],
            isHugeBO: !1,
            allocationPattern: tc.Automatically,
            currentRoom: {
              status: ic.Initial,
              boStatus: rc.NoToken,
              boConfId: "",
              boId: "",
              name: "",
              boToken: ""
            },
            options: {
              isAutoJoinRoom: !1,
              isBackToMainSessionEnabled: !0,
              isTimerEnabled: !1,
              timerDuration: 1800,
              isTimerAutoEnabled: !1,
              waitSeconds: 60
            },
            mainSessionAttendeeList: [],
            preAssignedRooms: [],
            meetingElapsedTime: 0,
            startRoomElapsedTime: 0,
            closingRoomTime: 0,
            broadcastMessage: "",
            hostReplyToQuestionerType: void 0,
            hostReplyToRequestId: void 0,
            isUserRoleUpdated: !1,
            mainSessionConfId: "",
            isEnableBOBroadcast: !1,
            isEnableBreakoutRoom: !1
          },
              jg = ur((_ur12 = {}, _defineProperty(_ur12, "".concat(Rd), Hp(function (e, t) {
            var _e$rooms;

            var n = t.payload;
            Array.isArray(n) ? (_e$rooms = e.rooms).push.apply(_e$rooms, _toConsumableArray(n)) : e.rooms.push(n);
          })), _defineProperty(_ur12, "".concat(Nd), Hp(function (e, t) {
            var n = t.payload;
            e.allocationPattern = n;
          })), _defineProperty(_ur12, "".concat(Pd), Hp(function (e, t) {
            var n = t.payload;
            e.sequenceId = n;
          })), _defineProperty(_ur12, "".concat(jd), Hp(function (e, t) {
            var n = t.payload;
            e.meetingElapsedTime = n;
          })), _defineProperty(_ur12, "".concat(Dd), Hp(function (e, t) {
            var n = t.payload;
            e.startRoomElapsedTime = n;
          })), _defineProperty(_ur12, "".concat(zd), Hp(function (e, t) {
            var n = t.payload;
            var r = e.options;
            Object.assign(r, n);
          })), _defineProperty(_ur12, "".concat(Md), Hp(function (e, t) {
            var n = t.payload;
            e.controlStatus = n;
          })), _defineProperty(_ur12, "".concat(Ld), Hp(function (e, t) {
            var n = t.payload;
            e.rooms = n;
          })), _defineProperty(_ur12, "".concat(Ud), Hp(function (e, t) {
            var n = t.payload;
            var r = e.currentRoom;
            Object.assign(r, n);
          })), _defineProperty(_ur12, "".concat(Bd), Hp(function (e, t) {
            var n = t.payload;
            var r = e.currentRoom;
            r.status = n;
          })), _defineProperty(_ur12, "".concat(Hd), Hp(function (e, t) {
            var n = t.payload;
            var r = e.currentRoom;
            r.boConfId = n;
          })), _defineProperty(_ur12, "".concat(Vd), Hp(function (e, t) {
            var n = t.payload;
            var r = e.currentRoom;
            r.boToken = n;
          })), _defineProperty(_ur12, "".concat(Fd), Hp(function (e, t) {
            var n = t.payload;
            e.closingRoomTime = n;
          })), _defineProperty(_ur12, "".concat(Wd), Hp(function (e, t) {
            var n = t.payload;
            e.broadcastMessage = n;
          })), _defineProperty(_ur12, "".concat(Gd), Hp(function (e, t) {
            var n = t.payload;
            e.hostReplyToQuestionerType = n;
          })), _defineProperty(_ur12, "".concat(Kd), Hp(function (e, t) {
            var n = t.payload;
            e.hostReplyToRequestId = n;
          })), _defineProperty(_ur12, "".concat(Qd), Hp(function (e, t) {
            var n = t.payload;
            void 0 !== n.add && n.add.length > 0 && n.add.forEach(function (t) {
              var n = e.mainSessionAttendeeList.find(function (e) {
                return e.userId === t.userId;
              });
              void 0 !== n ? Object.assign(n, t) : Xs(t.userRole) || e.mainSessionAttendeeList.push(t);
            }), void 0 !== n.update && n.update.length > 0 && n.update.forEach(function (t) {
              var n = e.mainSessionAttendeeList.find(function (e) {
                return e.userId === t.userId;
              });
              void 0 !== n && Object.assign(n, t);
            }), void 0 !== n.remove && n.remove.length > 0 && n.remove.forEach(function (t) {
              var n = e.mainSessionAttendeeList.findIndex(function (e) {
                return e.userId === t.userId;
              });
              -1 !== n && e.mainSessionAttendeeList.splice(n, 1);
            });
          })), _defineProperty(_ur12, "".concat(Zd), Hp(function (e, t) {
            var n = t.payload;
            e.isHugeBO = n;
          })), _defineProperty(_ur12, "".concat(Jd), Hp(function (e, t) {
            var n = t.payload;
            e.isUserRoleUpdated = n;
          })), _defineProperty(_ur12, "".concat(Yd), Hp(function (e, t) {
            var n = t.payload;
            e.preAssignedRooms = n;
          })), _defineProperty(_ur12, "".concat($d), Hp(function (e, t) {
            var n = t.payload;
            e.isEnableBreakoutRoom = n.isEnableBreakoutRoom, e.isEnableBOBroadcast = n.isEnableBOBroadcast;
          })), _defineProperty(_ur12, "".concat(qd), function (e) {
            var t = e.currentRoom.status;
            return t === ic.Joining ? f(f({}, Pg), {}, {
              preAssignedRooms: e.preAssignedRooms,
              currentRoom: e.currentRoom,
              closingRoomTime: e.closingRoomTime
            }) : t === ic.Leaving ? f(f({}, Pg), {}, {
              preAssignedRooms: e.preAssignedRooms,
              closingRoomTime: e.closingRoomTime
            }) : f(f({}, Pg), {}, {
              preAssignedRooms: e.preAssignedRooms
            });
          }), _ur12), Pg);

          var Dg = _i(function (e, t) {
            var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

            function r(e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }

            t.assign = function (e) {
              for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
                var n = t.shift();

                if (n) {
                  if ("object" != typeof n) throw new TypeError(n + "must be non-object");

                  for (var i in n) {
                    r(n, i) && (e[i] = n[i]);
                  }
                }
              }

              return e;
            }, t.shrinkBuf = function (e, t) {
              return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
            };
            var i = {
              arraySet: function arraySet(e, t, n, r, i) {
                if (t.subarray && e.subarray) e.set(t.subarray(n, n + r), i);else for (var o = 0; o < r; o++) {
                  e[i + o] = t[n + o];
                }
              },
              flattenChunks: function flattenChunks(e) {
                var t, n, r, i, o, a;

                for (r = 0, t = 0, n = e.length; t < n; t++) {
                  r += e[t].length;
                }

                for (a = new Uint8Array(r), i = 0, t = 0, n = e.length; t < n; t++) {
                  o = e[t], a.set(o, i), i += o.length;
                }

                return a;
              }
            },
                o = {
              arraySet: function arraySet(e, t, n, r, i) {
                for (var o = 0; o < r; o++) {
                  e[i + o] = t[n + o];
                }
              },
              flattenChunks: function flattenChunks(e) {
                return [].concat.apply([], e);
              }
            };
            t.setTyped = function (e) {
              e ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, i)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, o));
            }, t.setTyped(n);
          });

          function zg(e) {
            for (var t = e.length; --t >= 0;) {
              e[t] = 0;
            }
          }

          var Mg = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
              Lg = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
              Ug = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
              Bg = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
              Hg = new Array(576);
          zg(Hg);
          var Vg = new Array(60);
          zg(Vg);
          var qg = new Array(512);
          zg(qg);
          var Fg = new Array(256);
          zg(Fg);
          var Wg = new Array(29);
          zg(Wg);
          var Gg,
              Kg,
              Qg,
              Zg = new Array(30);

          function Yg(e, t, n, r, i) {
            this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
          }

          function Jg(e, t) {
            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
          }

          function $g(e) {
            return e < 256 ? qg[e] : qg[256 + (e >>> 7)];
          }

          function Xg(e, t) {
            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
          }

          function ev(e, t, n) {
            e.bi_valid > 16 - n ? (e.bi_buf |= t << e.bi_valid & 65535, Xg(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += n - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
          }

          function tv(e, t, n) {
            ev(e, n[2 * t], n[2 * t + 1]);
          }

          function nv(e, t) {
            var n = 0;

            do {
              n |= 1 & e, e >>>= 1, n <<= 1;
            } while (--t > 0);

            return n >>> 1;
          }

          function rv(e, t, n) {
            var r,
                i,
                o = new Array(16),
                a = 0;

            for (r = 1; r <= 15; r++) {
              o[r] = a = a + n[r - 1] << 1;
            }

            for (i = 0; i <= t; i++) {
              var s = e[2 * i + 1];
              0 !== s && (e[2 * i] = nv(o[s]++, s));
            }
          }

          function iv(e) {
            var t;

            for (t = 0; t < 286; t++) {
              e.dyn_ltree[2 * t] = 0;
            }

            for (t = 0; t < 30; t++) {
              e.dyn_dtree[2 * t] = 0;
            }

            for (t = 0; t < 19; t++) {
              e.bl_tree[2 * t] = 0;
            }

            e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
          }

          function ov(e) {
            e.bi_valid > 8 ? Xg(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
          }

          function av(e, t, n, r) {
            var i = 2 * t,
                o = 2 * n;
            return e[i] < e[o] || e[i] === e[o] && r[t] <= r[n];
          }

          function sv(e, t, n) {
            for (var r = e.heap[n], i = n << 1; i <= e.heap_len && (i < e.heap_len && av(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !av(t, r, e.heap[i], e.depth));) {
              e.heap[n] = e.heap[i], n = i, i <<= 1;
            }

            e.heap[n] = r;
          }

          function cv(e, t, n) {
            var r,
                i,
                o,
                a,
                s = 0;
            if (0 !== e.last_lit) do {
              r = e.pending_buf[e.d_buf + 2 * s] << 8 | e.pending_buf[e.d_buf + 2 * s + 1], i = e.pending_buf[e.l_buf + s], s++, 0 === r ? tv(e, i, t) : (tv(e, (o = Fg[i]) + 256 + 1, t), 0 !== (a = Mg[o]) && ev(e, i -= Wg[o], a), tv(e, o = $g(--r), n), 0 !== (a = Lg[o]) && ev(e, r -= Zg[o], a));
            } while (s < e.last_lit);
            tv(e, 256, t);
          }

          function lv(e, t) {
            var n,
                r,
                i,
                o = t.dyn_tree,
                a = t.stat_desc.static_tree,
                s = t.stat_desc.has_stree,
                c = t.stat_desc.elems,
                l = -1;

            for (e.heap_len = 0, e.heap_max = 573, n = 0; n < c; n++) {
              0 !== o[2 * n] ? (e.heap[++e.heap_len] = l = n, e.depth[n] = 0) : o[2 * n + 1] = 0;
            }

            for (; e.heap_len < 2;) {
              o[2 * (i = e.heap[++e.heap_len] = l < 2 ? ++l : 0)] = 1, e.depth[i] = 0, e.opt_len--, s && (e.static_len -= a[2 * i + 1]);
            }

            for (t.max_code = l, n = e.heap_len >> 1; n >= 1; n--) {
              sv(e, o, n);
            }

            i = c;

            do {
              n = e.heap[1], e.heap[1] = e.heap[e.heap_len--], sv(e, o, 1), r = e.heap[1], e.heap[--e.heap_max] = n, e.heap[--e.heap_max] = r, o[2 * i] = o[2 * n] + o[2 * r], e.depth[i] = (e.depth[n] >= e.depth[r] ? e.depth[n] : e.depth[r]) + 1, o[2 * n + 1] = o[2 * r + 1] = i, e.heap[1] = i++, sv(e, o, 1);
            } while (e.heap_len >= 2);

            e.heap[--e.heap_max] = e.heap[1], function (e, t) {
              var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  c = t.dyn_tree,
                  l = t.max_code,
                  d = t.stat_desc.static_tree,
                  u = t.stat_desc.has_stree,
                  p = t.stat_desc.extra_bits,
                  h = t.stat_desc.extra_base,
                  _ = t.stat_desc.max_length,
                  f = 0;

              for (o = 0; o <= 15; o++) {
                e.bl_count[o] = 0;
              }

              for (c[2 * e.heap[e.heap_max] + 1] = 0, n = e.heap_max + 1; n < 573; n++) {
                (o = c[2 * c[2 * (r = e.heap[n]) + 1] + 1] + 1) > _ && (o = _, f++), c[2 * r + 1] = o, r > l || (e.bl_count[o]++, a = 0, r >= h && (a = p[r - h]), s = c[2 * r], e.opt_len += s * (o + a), u && (e.static_len += s * (d[2 * r + 1] + a)));
              }

              if (0 !== f) {
                do {
                  for (o = _ - 1; 0 === e.bl_count[o];) {
                    o--;
                  }

                  e.bl_count[o]--, e.bl_count[o + 1] += 2, e.bl_count[_]--, f -= 2;
                } while (f > 0);

                for (o = _; 0 !== o; o--) {
                  for (r = e.bl_count[o]; 0 !== r;) {
                    (i = e.heap[--n]) > l || (c[2 * i + 1] !== o && (e.opt_len += (o - c[2 * i + 1]) * c[2 * i], c[2 * i + 1] = o), r--);
                  }
                }
              }
            }(e, t), rv(o, l, e.bl_count);
          }

          function dv(e, t, n) {
            var r,
                i,
                o = -1,
                a = t[1],
                s = 0,
                c = 7,
                l = 4;

            for (0 === a && (c = 138, l = 3), t[2 * (n + 1) + 1] = 65535, r = 0; r <= n; r++) {
              i = a, a = t[2 * (r + 1) + 1], ++s < c && i === a || (s < l ? e.bl_tree[2 * i] += s : 0 !== i ? (i !== o && e.bl_tree[2 * i]++, e.bl_tree[32]++) : s <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, s = 0, o = i, 0 === a ? (c = 138, l = 3) : i === a ? (c = 6, l = 3) : (c = 7, l = 4));
            }
          }

          function uv(e, t, n) {
            var r,
                i,
                o = -1,
                a = t[1],
                s = 0,
                c = 7,
                l = 4;

            for (0 === a && (c = 138, l = 3), r = 0; r <= n; r++) {
              if (i = a, a = t[2 * (r + 1) + 1], !(++s < c && i === a)) {
                if (s < l) do {
                  tv(e, i, e.bl_tree);
                } while (0 != --s);else 0 !== i ? (i !== o && (tv(e, i, e.bl_tree), s--), tv(e, 16, e.bl_tree), ev(e, s - 3, 2)) : s <= 10 ? (tv(e, 17, e.bl_tree), ev(e, s - 3, 3)) : (tv(e, 18, e.bl_tree), ev(e, s - 11, 7));
                s = 0, o = i, 0 === a ? (c = 138, l = 3) : i === a ? (c = 6, l = 3) : (c = 7, l = 4);
              }
            }
          }

          zg(Zg);
          var pv = !1;

          function hv(e, t, n, r) {
            ev(e, 0 + (r ? 1 : 0), 3), function (e, t, n, r) {
              ov(e), Xg(e, n), Xg(e, ~n), Dg.arraySet(e.pending_buf, e.window, t, n, e.pending), e.pending += n;
            }(e, t, n);
          }

          var _v,
              fv = {
            _tr_init: function _tr_init(e) {
              pv || (function () {
                var e,
                    t,
                    n,
                    r,
                    i,
                    o = new Array(16);

                for (n = 0, r = 0; r < 28; r++) {
                  for (Wg[r] = n, e = 0; e < 1 << Mg[r]; e++) {
                    Fg[n++] = r;
                  }
                }

                for (Fg[n - 1] = r, i = 0, r = 0; r < 16; r++) {
                  for (Zg[r] = i, e = 0; e < 1 << Lg[r]; e++) {
                    qg[i++] = r;
                  }
                }

                for (i >>= 7; r < 30; r++) {
                  for (Zg[r] = i << 7, e = 0; e < 1 << Lg[r] - 7; e++) {
                    qg[256 + i++] = r;
                  }
                }

                for (t = 0; t <= 15; t++) {
                  o[t] = 0;
                }

                for (e = 0; e <= 143;) {
                  Hg[2 * e + 1] = 8, e++, o[8]++;
                }

                for (; e <= 255;) {
                  Hg[2 * e + 1] = 9, e++, o[9]++;
                }

                for (; e <= 279;) {
                  Hg[2 * e + 1] = 7, e++, o[7]++;
                }

                for (; e <= 287;) {
                  Hg[2 * e + 1] = 8, e++, o[8]++;
                }

                for (rv(Hg, 287, o), e = 0; e < 30; e++) {
                  Vg[2 * e + 1] = 5, Vg[2 * e] = nv(e, 5);
                }

                Gg = new Yg(Hg, Mg, 257, 286, 15), Kg = new Yg(Vg, Lg, 0, 30, 15), Qg = new Yg(new Array(0), Ug, 0, 19, 7);
              }(), pv = !0), e.l_desc = new Jg(e.dyn_ltree, Gg), e.d_desc = new Jg(e.dyn_dtree, Kg), e.bl_desc = new Jg(e.bl_tree, Qg), e.bi_buf = 0, e.bi_valid = 0, iv(e);
            },
            _tr_stored_block: hv,
            _tr_flush_block: function _tr_flush_block(e, t, n, r) {
              var i,
                  o,
                  a = 0;
              e.level > 0 ? (2 === e.strm.data_type && (e.strm.data_type = function (e) {
                var t,
                    n = 4093624447;

                for (t = 0; t <= 31; t++, n >>>= 1) {
                  if (1 & n && 0 !== e.dyn_ltree[2 * t]) return 0;
                }

                if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;

                for (t = 32; t < 256; t++) {
                  if (0 !== e.dyn_ltree[2 * t]) return 1;
                }

                return 0;
              }(e)), lv(e, e.l_desc), lv(e, e.d_desc), a = function (e) {
                var t;

                for (dv(e, e.dyn_ltree, e.l_desc.max_code), dv(e, e.dyn_dtree, e.d_desc.max_code), lv(e, e.bl_desc), t = 18; t >= 3 && 0 === e.bl_tree[2 * Bg[t] + 1]; t--) {
                  ;
                }

                return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
              }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = n + 5, n + 4 <= i && -1 !== t ? hv(e, t, n, r) : 4 === e.strategy || o === i ? (ev(e, 2 + (r ? 1 : 0), 3), cv(e, Hg, Vg)) : (ev(e, 4 + (r ? 1 : 0), 3), function (e, t, n, r) {
                var i;

                for (ev(e, t - 257, 5), ev(e, n - 1, 5), ev(e, r - 4, 4), i = 0; i < r; i++) {
                  ev(e, e.bl_tree[2 * Bg[i] + 1], 3);
                }

                uv(e, e.dyn_ltree, t - 1), uv(e, e.dyn_dtree, n - 1);
              }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), cv(e, e.dyn_ltree, e.dyn_dtree)), iv(e), r && ov(e);
            },
            _tr_tally: function _tr_tally(e, t, n) {
              return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & n, e.last_lit++, 0 === t ? e.dyn_ltree[2 * n]++ : (e.matches++, t--, e.dyn_ltree[2 * (Fg[n] + 256 + 1)]++, e.dyn_dtree[2 * $g(t)]++), e.last_lit === e.lit_bufsize - 1;
            },
            _tr_align: function _tr_align(e) {
              ev(e, 2, 3), tv(e, 256, Hg), function (e) {
                16 === e.bi_valid ? (Xg(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
              }(e);
            }
          },
              mv = function mv(e, t, n, r) {
            for (var i = 65535 & e | 0, o = e >>> 16 & 65535 | 0, a = 0; 0 !== n;) {
              n -= a = n > 2e3 ? 2e3 : n;

              do {
                o = o + (i = i + t[r++] | 0) | 0;
              } while (--a);

              i %= 65521, o %= 65521;
            }

            return i | o << 16 | 0;
          },
              gv = function () {
            for (var e, t = [], n = 0; n < 256; n++) {
              e = n;

              for (var r = 0; r < 8; r++) {
                e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
              }

              t[n] = e;
            }

            return t;
          }(),
              vv = function vv(e, t, n, r) {
            var i = gv,
                o = r + n;
            e ^= -1;

            for (var a = r; a < o; a++) {
              e = e >>> 8 ^ i[255 & (e ^ t[a])];
            }

            return -1 ^ e;
          },
              bv = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version"
          };

          function yv(e, t) {
            return e.msg = bv[t], t;
          }

          function wv(e) {
            return (e << 1) - (e > 4 ? 9 : 0);
          }

          function Sv(e) {
            for (var t = e.length; --t >= 0;) {
              e[t] = 0;
            }
          }

          function xv(e) {
            var t = e.state,
                n = t.pending;
            n > e.avail_out && (n = e.avail_out), 0 !== n && (Dg.arraySet(e.output, t.pending_buf, t.pending_out, n, e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, 0 === t.pending && (t.pending_out = 0));
          }

          function Ev(e, t) {
            fv._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, xv(e.strm);
          }

          function Cv(e, t) {
            e.pending_buf[e.pending++] = t;
          }

          function kv(e, t) {
            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
          }

          function Av(e, t) {
            var n,
                r,
                i = e.max_chain_length,
                o = e.strstart,
                a = e.prev_length,
                s = e.nice_match,
                c = e.strstart > e.w_size - 262 ? e.strstart - (e.w_size - 262) : 0,
                l = e.window,
                d = e.w_mask,
                u = e.prev,
                p = e.strstart + 258,
                h = l[o + a - 1],
                _ = l[o + a];
            e.prev_length >= e.good_match && (i >>= 2), s > e.lookahead && (s = e.lookahead);

            do {
              if (l[(n = t) + a] === _ && l[n + a - 1] === h && l[n] === l[o] && l[++n] === l[o + 1]) {
                o += 2, n++;

                do {} while (l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && o < p);

                if (r = 258 - (p - o), o = p - 258, r > a) {
                  if (e.match_start = t, a = r, r >= s) break;
                  h = l[o + a - 1], _ = l[o + a];
                }
              }
            } while ((t = u[t & d]) > c && 0 != --i);

            return a <= e.lookahead ? a : e.lookahead;
          }

          function Iv(e) {
            var t,
                n,
                r,
                i,
                o,
                a,
                s,
                c,
                l,
                d,
                u = e.w_size;

            do {
              if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= u + (u - 262)) {
                Dg.arraySet(e.window, e.window, u, u, 0), e.match_start -= u, e.strstart -= u, e.block_start -= u, t = n = e.hash_size;

                do {
                  r = e.head[--t], e.head[t] = r >= u ? r - u : 0;
                } while (--n);

                t = n = u;

                do {
                  r = e.prev[--t], e.prev[t] = r >= u ? r - u : 0;
                } while (--n);

                i += u;
              }

              if (0 === e.strm.avail_in) break;
              if (a = e.strm, s = e.window, c = e.strstart + e.lookahead, l = i, d = void 0, (d = a.avail_in) > l && (d = l), n = 0 === d ? 0 : (a.avail_in -= d, Dg.arraySet(s, a.input, a.next_in, d, c), 1 === a.state.wrap ? a.adler = mv(a.adler, s, d, c) : 2 === a.state.wrap && (a.adler = vv(a.adler, s, d, c)), a.next_in += d, a.total_in += d, d), e.lookahead += n, e.lookahead + e.insert >= 3) for (o = e.strstart - e.insert, e.ins_h = e.window[o], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[o + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[o + 3 - 1]) & e.hash_mask, e.prev[o & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = o, o++, e.insert--, !(e.lookahead + e.insert < 3));) {
                ;
              }
            } while (e.lookahead < 262 && 0 !== e.strm.avail_in);
          }

          function Tv(e, t) {
            for (var n, r;;) {
              if (e.lookahead < 262) {
                if (Iv(e), e.lookahead < 262 && 0 === t) return 1;
                if (0 === e.lookahead) break;
              }

              if (n = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== n && e.strstart - n <= e.w_size - 262 && (e.match_length = Av(e, n)), e.match_length >= 3) {
                if (r = fv._tr_tally(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
                  e.match_length--;

                  do {
                    e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
                  } while (0 != --e.match_length);

                  e.strstart++;
                } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
              } else r = fv._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
              if (r && (Ev(e, !1), 0 === e.strm.avail_out)) return 1;
            }

            return e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (Ev(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Ev(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
          }

          function Ov(e, t) {
            for (var n, r, i;;) {
              if (e.lookahead < 262) {
                if (Iv(e), e.lookahead < 262 && 0 === t) return 1;
                if (0 === e.lookahead) break;
              }

              if (n = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== n && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - 262 && (e.match_length = Av(e, n), e.match_length <= 5 && (1 === e.strategy || 3 === e.match_length && e.strstart - e.match_start > 4096) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
                i = e.strstart + e.lookahead - 3, r = fv._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;

                do {
                  ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
                } while (0 != --e.prev_length);

                if (e.match_available = 0, e.match_length = 2, e.strstart++, r && (Ev(e, !1), 0 === e.strm.avail_out)) return 1;
              } else if (e.match_available) {
                if ((r = fv._tr_tally(e, 0, e.window[e.strstart - 1])) && Ev(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
              } else e.match_available = 1, e.strstart++, e.lookahead--;
            }

            return e.match_available && (r = fv._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (Ev(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Ev(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
          }

          function Rv(e, t, n, r, i) {
            this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
          }

          function Nv() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Dg.Buf16(1146), this.dyn_dtree = new Dg.Buf16(122), this.bl_tree = new Dg.Buf16(78), Sv(this.dyn_ltree), Sv(this.dyn_dtree), Sv(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Dg.Buf16(16), this.heap = new Dg.Buf16(573), Sv(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Dg.Buf16(573), Sv(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }

          function Pv(e) {
            var t;
            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = 2, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? 42 : 113, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = 0, fv._tr_init(t), 0) : yv(e, -2);
          }

          function jv(e) {
            var t = Pv(e);
            return 0 === t && function (e) {
              e.window_size = 2 * e.w_size, Sv(e.head), e.max_lazy_match = _v[e.level].max_lazy, e.good_match = _v[e.level].good_length, e.nice_match = _v[e.level].nice_length, e.max_chain_length = _v[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0;
            }(e.state), t;
          }

          function Dv(e, t, n, r, i, o) {
            if (!e) return -2;
            var a = 1;
            if (-1 === t && (t = 6), r < 0 ? (a = 0, r = -r) : r > 15 && (a = 2, r -= 16), i < 1 || i > 9 || 8 !== n || r < 8 || r > 15 || t < 0 || t > 9 || o < 0 || o > 4) return yv(e, -2);
            8 === r && (r = 9);
            var s = new Nv();
            return e.state = s, s.strm = e, s.wrap = a, s.gzhead = null, s.w_bits = r, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + 3 - 1) / 3), s.window = new Dg.Buf8(2 * s.w_size), s.head = new Dg.Buf16(s.hash_size), s.prev = new Dg.Buf16(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = 4 * s.lit_bufsize, s.pending_buf = new Dg.Buf8(s.pending_buf_size), s.d_buf = 1 * s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = t, s.strategy = o, s.method = n, jv(e);
          }

          _v = [new Rv(0, 0, 0, 0, function (e, t) {
            var n = 65535;

            for (n > e.pending_buf_size - 5 && (n = e.pending_buf_size - 5);;) {
              if (e.lookahead <= 1) {
                if (Iv(e), 0 === e.lookahead && 0 === t) return 1;
                if (0 === e.lookahead) break;
              }

              e.strstart += e.lookahead, e.lookahead = 0;
              var r = e.block_start + n;
              if ((0 === e.strstart || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, Ev(e, !1), 0 === e.strm.avail_out)) return 1;
              if (e.strstart - e.block_start >= e.w_size - 262 && (Ev(e, !1), 0 === e.strm.avail_out)) return 1;
            }

            return e.insert = 0, 4 === t ? (Ev(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (Ev(e, !1), e.strm.avail_out), 1);
          }), new Rv(4, 4, 8, 4, Tv), new Rv(4, 5, 16, 8, Tv), new Rv(4, 6, 32, 32, Tv), new Rv(4, 4, 16, 16, Ov), new Rv(8, 16, 32, 32, Ov), new Rv(8, 16, 128, 128, Ov), new Rv(8, 32, 128, 256, Ov), new Rv(32, 128, 258, 1024, Ov), new Rv(32, 258, 258, 4096, Ov)];
          var zv = {
            deflateInit: function deflateInit(e, t) {
              return Dv(e, t, 8, 15, 8, 0);
            },
            deflateInit2: Dv,
            deflateReset: jv,
            deflateResetKeep: Pv,
            deflateSetHeader: function deflateSetHeader(e, t) {
              return e && e.state ? 2 !== e.state.wrap ? -2 : (e.state.gzhead = t, 0) : -2;
            },
            deflate: function deflate(e, t) {
              var n, r, i, o;
              if (!e || !e.state || t > 5 || t < 0) return e ? yv(e, -2) : -2;
              if (r = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === r.status && 4 !== t) return yv(e, 0 === e.avail_out ? -5 : -2);
              if (r.strm = e, n = r.last_flush, r.last_flush = t, 42 === r.status) if (2 === r.wrap) e.adler = 0, Cv(r, 31), Cv(r, 139), Cv(r, 8), r.gzhead ? (Cv(r, (r.gzhead.text ? 1 : 0) + (r.gzhead.hcrc ? 2 : 0) + (r.gzhead.extra ? 4 : 0) + (r.gzhead.name ? 8 : 0) + (r.gzhead.comment ? 16 : 0)), Cv(r, 255 & r.gzhead.time), Cv(r, r.gzhead.time >> 8 & 255), Cv(r, r.gzhead.time >> 16 & 255), Cv(r, r.gzhead.time >> 24 & 255), Cv(r, 9 === r.level ? 2 : r.strategy >= 2 || r.level < 2 ? 4 : 0), Cv(r, 255 & r.gzhead.os), r.gzhead.extra && r.gzhead.extra.length && (Cv(r, 255 & r.gzhead.extra.length), Cv(r, r.gzhead.extra.length >> 8 & 255)), r.gzhead.hcrc && (e.adler = vv(e.adler, r.pending_buf, r.pending, 0)), r.gzindex = 0, r.status = 69) : (Cv(r, 0), Cv(r, 0), Cv(r, 0), Cv(r, 0), Cv(r, 0), Cv(r, 9 === r.level ? 2 : r.strategy >= 2 || r.level < 2 ? 4 : 0), Cv(r, 3), r.status = 113);else {
                var a = 8 + (r.w_bits - 8 << 4) << 8;
                a |= (r.strategy >= 2 || r.level < 2 ? 0 : r.level < 6 ? 1 : 6 === r.level ? 2 : 3) << 6, 0 !== r.strstart && (a |= 32), a += 31 - a % 31, r.status = 113, kv(r, a), 0 !== r.strstart && (kv(r, e.adler >>> 16), kv(r, 65535 & e.adler)), e.adler = 1;
              }
              if (69 === r.status) if (r.gzhead.extra) {
                for (i = r.pending; r.gzindex < (65535 & r.gzhead.extra.length) && (r.pending !== r.pending_buf_size || (r.gzhead.hcrc && r.pending > i && (e.adler = vv(e.adler, r.pending_buf, r.pending - i, i)), xv(e), i = r.pending, r.pending !== r.pending_buf_size));) {
                  Cv(r, 255 & r.gzhead.extra[r.gzindex]), r.gzindex++;
                }

                r.gzhead.hcrc && r.pending > i && (e.adler = vv(e.adler, r.pending_buf, r.pending - i, i)), r.gzindex === r.gzhead.extra.length && (r.gzindex = 0, r.status = 73);
              } else r.status = 73;
              if (73 === r.status) if (r.gzhead.name) {
                i = r.pending;

                do {
                  if (r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > i && (e.adler = vv(e.adler, r.pending_buf, r.pending - i, i)), xv(e), i = r.pending, r.pending === r.pending_buf_size)) {
                    o = 1;
                    break;
                  }

                  o = r.gzindex < r.gzhead.name.length ? 255 & r.gzhead.name.charCodeAt(r.gzindex++) : 0, Cv(r, o);
                } while (0 !== o);

                r.gzhead.hcrc && r.pending > i && (e.adler = vv(e.adler, r.pending_buf, r.pending - i, i)), 0 === o && (r.gzindex = 0, r.status = 91);
              } else r.status = 91;
              if (91 === r.status) if (r.gzhead.comment) {
                i = r.pending;

                do {
                  if (r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > i && (e.adler = vv(e.adler, r.pending_buf, r.pending - i, i)), xv(e), i = r.pending, r.pending === r.pending_buf_size)) {
                    o = 1;
                    break;
                  }

                  o = r.gzindex < r.gzhead.comment.length ? 255 & r.gzhead.comment.charCodeAt(r.gzindex++) : 0, Cv(r, o);
                } while (0 !== o);

                r.gzhead.hcrc && r.pending > i && (e.adler = vv(e.adler, r.pending_buf, r.pending - i, i)), 0 === o && (r.status = 103);
              } else r.status = 103;

              if (103 === r.status && (r.gzhead.hcrc ? (r.pending + 2 > r.pending_buf_size && xv(e), r.pending + 2 <= r.pending_buf_size && (Cv(r, 255 & e.adler), Cv(r, e.adler >> 8 & 255), e.adler = 0, r.status = 113)) : r.status = 113), 0 !== r.pending) {
                if (xv(e), 0 === e.avail_out) return r.last_flush = -1, 0;
              } else if (0 === e.avail_in && wv(t) <= wv(n) && 4 !== t) return yv(e, -5);

              if (666 === r.status && 0 !== e.avail_in) return yv(e, -5);

              if (0 !== e.avail_in || 0 !== r.lookahead || 0 !== t && 666 !== r.status) {
                var s = 2 === r.strategy ? function (e, t) {
                  for (var n;;) {
                    if (0 === e.lookahead && (Iv(e), 0 === e.lookahead)) {
                      if (0 === t) return 1;
                      break;
                    }

                    if (e.match_length = 0, n = fv._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (Ev(e, !1), 0 === e.strm.avail_out)) return 1;
                  }

                  return e.insert = 0, 4 === t ? (Ev(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Ev(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                }(r, t) : 3 === r.strategy ? function (e, t) {
                  for (var n, r, i, o, a = e.window;;) {
                    if (e.lookahead <= 258) {
                      if (Iv(e), e.lookahead <= 258 && 0 === t) return 1;
                      if (0 === e.lookahead) break;
                    }

                    if (e.match_length = 0, e.lookahead >= 3 && e.strstart > 0 && (r = a[i = e.strstart - 1]) === a[++i] && r === a[++i] && r === a[++i]) {
                      o = e.strstart + 258;

                      do {} while (r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && i < o);

                      e.match_length = 258 - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                    }

                    if (e.match_length >= 3 ? (n = fv._tr_tally(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = fv._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (Ev(e, !1), 0 === e.strm.avail_out)) return 1;
                  }

                  return e.insert = 0, 4 === t ? (Ev(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Ev(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                }(r, t) : _v[r.level].func(r, t);
                if (3 !== s && 4 !== s || (r.status = 666), 1 === s || 3 === s) return 0 === e.avail_out && (r.last_flush = -1), 0;
                if (2 === s && (1 === t ? fv._tr_align(r) : 5 !== t && (fv._tr_stored_block(r, 0, 0, !1), 3 === t && (Sv(r.head), 0 === r.lookahead && (r.strstart = 0, r.block_start = 0, r.insert = 0))), xv(e), 0 === e.avail_out)) return r.last_flush = -1, 0;
              }

              return 4 !== t ? 0 : r.wrap <= 0 ? 1 : (2 === r.wrap ? (Cv(r, 255 & e.adler), Cv(r, e.adler >> 8 & 255), Cv(r, e.adler >> 16 & 255), Cv(r, e.adler >> 24 & 255), Cv(r, 255 & e.total_in), Cv(r, e.total_in >> 8 & 255), Cv(r, e.total_in >> 16 & 255), Cv(r, e.total_in >> 24 & 255)) : (kv(r, e.adler >>> 16), kv(r, 65535 & e.adler)), xv(e), r.wrap > 0 && (r.wrap = -r.wrap), 0 !== r.pending ? 0 : 1);
            },
            deflateEnd: function deflateEnd(e) {
              var t;
              return e && e.state ? 42 !== (t = e.state.status) && 69 !== t && 73 !== t && 91 !== t && 103 !== t && 113 !== t && 666 !== t ? yv(e, -2) : (e.state = null, 113 === t ? yv(e, -3) : 0) : -2;
            },
            deflateSetDictionary: function deflateSetDictionary(e, t) {
              var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  c,
                  l,
                  d = t.length;
              if (!e || !e.state) return -2;
              if (2 === (o = (n = e.state).wrap) || 1 === o && 42 !== n.status || n.lookahead) return -2;

              for (1 === o && (e.adler = mv(e.adler, t, d, 0)), n.wrap = 0, d >= n.w_size && (0 === o && (Sv(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), l = new Dg.Buf8(n.w_size), Dg.arraySet(l, t, d - n.w_size, n.w_size, 0), t = l, d = n.w_size), a = e.avail_in, s = e.next_in, c = e.input, e.avail_in = d, e.next_in = 0, e.input = t, Iv(n); n.lookahead >= 3;) {
                r = n.strstart, i = n.lookahead - 2;

                do {
                  n.ins_h = (n.ins_h << n.hash_shift ^ n.window[r + 3 - 1]) & n.hash_mask, n.prev[r & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = r, r++;
                } while (--i);

                n.strstart = r, n.lookahead = 2, Iv(n);
              }

              return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = 2, n.match_available = 0, e.next_in = s, e.input = c, e.avail_in = a, n.wrap = o, 0;
            },
            deflateInfo: "pako deflate (from Nodeca project)"
          },
              Mv = !0,
              Lv = !0;

          try {
            String.fromCharCode.apply(null, [0]);
          } catch (ZC) {
            Mv = !1;
          }

          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (ZC) {
            Lv = !1;
          }

          for (var Uv = new Dg.Buf8(256), Bv = 0; Bv < 256; Bv++) {
            Uv[Bv] = Bv >= 252 ? 6 : Bv >= 248 ? 5 : Bv >= 240 ? 4 : Bv >= 224 ? 3 : Bv >= 192 ? 2 : 1;
          }

          function Hv(e, t) {
            if (t < 65534 && (e.subarray && Lv || !e.subarray && Mv)) return String.fromCharCode.apply(null, Dg.shrinkBuf(e, t));

            for (var n = "", r = 0; r < t; r++) {
              n += String.fromCharCode(e[r]);
            }

            return n;
          }

          Uv[254] = Uv[254] = 1;

          var Vv = function Vv(e) {
            var t,
                n,
                r,
                i,
                o,
                a = e.length,
                s = 0;

            for (i = 0; i < a; i++) {
              55296 == (64512 & (n = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (r = e.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++), s += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
            }

            for (t = new Dg.Buf8(s), o = 0, i = 0; o < s; i++) {
              55296 == (64512 & (n = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (r = e.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++), n < 128 ? t[o++] = n : n < 2048 ? (t[o++] = 192 | n >>> 6, t[o++] = 128 | 63 & n) : n < 65536 ? (t[o++] = 224 | n >>> 12, t[o++] = 128 | n >>> 6 & 63, t[o++] = 128 | 63 & n) : (t[o++] = 240 | n >>> 18, t[o++] = 128 | n >>> 12 & 63, t[o++] = 128 | n >>> 6 & 63, t[o++] = 128 | 63 & n);
            }

            return t;
          },
              qv = function qv(e) {
            return Hv(e, e.length);
          },
              Fv = function Fv(e, t) {
            var n,
                r,
                i,
                o,
                a = t || e.length,
                s = new Array(2 * a);

            for (r = 0, n = 0; n < a;) {
              if ((i = e[n++]) < 128) s[r++] = i;else if ((o = Uv[i]) > 4) s[r++] = 65533, n += o - 1;else {
                for (i &= 2 === o ? 31 : 3 === o ? 15 : 7; o > 1 && n < a;) {
                  i = i << 6 | 63 & e[n++], o--;
                }

                o > 1 ? s[r++] = 65533 : i < 65536 ? s[r++] = i : (i -= 65536, s[r++] = 55296 | i >> 10 & 1023, s[r++] = 56320 | 1023 & i);
              }
            }

            return Hv(s, r);
          },
              Wv = function Wv(e, t) {
            var n;

            for ((t = t || e.length) > e.length && (t = e.length), n = t - 1; n >= 0 && 128 == (192 & e[n]);) {
              n--;
            }

            return n < 0 || 0 === n ? t : n + Uv[e[n]] > t ? n : t;
          },
              Gv = function Gv() {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          },
              Kv = Object.prototype.toString;

          function Qv(e) {
            if (!(this instanceof Qv)) return new Qv(e);
            this.options = Dg.assign({
              level: -1,
              method: 8,
              chunkSize: 16384,
              windowBits: 15,
              memLevel: 8,
              strategy: 0,
              to: ""
            }, e || {});
            var t = this.options;
            t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Gv(), this.strm.avail_out = 0;
            var n = zv.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
            if (0 !== n) throw new Error(bv[n]);

            if (t.header && zv.deflateSetHeader(this.strm, t.header), t.dictionary) {
              var r;
              if (r = "string" == typeof t.dictionary ? Vv(t.dictionary) : "[object ArrayBuffer]" === Kv.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, 0 !== (n = zv.deflateSetDictionary(this.strm, r))) throw new Error(bv[n]);
              this._dict_set = !0;
            }
          }

          function Zv(e, t) {
            var n = new Qv(t);
            if (n.push(e, !0), n.err) throw n.msg || bv[n.err];
            return n.result;
          }

          Qv.prototype.push = function (e, t) {
            var n,
                r,
                i = this.strm,
                o = this.options.chunkSize;
            if (this.ended) return !1;
            r = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = Vv(e) : "[object ArrayBuffer]" === Kv.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;

            do {
              if (0 === i.avail_out && (i.output = new Dg.Buf8(o), i.next_out = 0, i.avail_out = o), 1 !== (n = zv.deflate(i, r)) && 0 !== n) return this.onEnd(n), this.ended = !0, !1;
              0 !== i.avail_out && (0 !== i.avail_in || 4 !== r && 2 !== r) || ("string" === this.options.to ? this.onData(qv(Dg.shrinkBuf(i.output, i.next_out))) : this.onData(Dg.shrinkBuf(i.output, i.next_out)));
            } while ((i.avail_in > 0 || 0 === i.avail_out) && 1 !== n);

            return 4 === r ? (n = zv.deflateEnd(this.strm), this.onEnd(n), this.ended = !0, 0 === n) : 2 !== r || (this.onEnd(0), i.avail_out = 0, !0);
          }, Qv.prototype.onData = function (e) {
            this.chunks.push(e);
          }, Qv.prototype.onEnd = function (e) {
            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = Dg.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
          };

          var Yv = {
            Deflate: Qv,
            deflate: Zv,
            deflateRaw: function deflateRaw(e, t) {
              return (t = t || {}).raw = !0, Zv(e, t);
            },
            gzip: function gzip(e, t) {
              return (t = t || {}).gzip = !0, Zv(e, t);
            }
          },
              Jv = function Jv(e, t) {
            var n, r, i, o, a, s, c, l, d, u, p, h, _, f, m, g, v, b, y, w, S, x, E, C, k;

            n = e.state, r = e.next_in, C = e.input, i = r + (e.avail_in - 5), o = e.next_out, k = e.output, a = o - (t - e.avail_out), s = o + (e.avail_out - 257), c = n.dmax, l = n.wsize, d = n.whave, u = n.wnext, p = n.window, h = n.hold, _ = n.bits, f = n.lencode, m = n.distcode, g = (1 << n.lenbits) - 1, v = (1 << n.distbits) - 1;

            e: do {
              _ < 15 && (h += C[r++] << _, _ += 8, h += C[r++] << _, _ += 8), b = f[h & g];

              t: for (;;) {
                if (h >>>= y = b >>> 24, _ -= y, 0 == (y = b >>> 16 & 255)) k[o++] = 65535 & b;else {
                  if (!(16 & y)) {
                    if (0 == (64 & y)) {
                      b = f[(65535 & b) + (h & (1 << y) - 1)];
                      continue t;
                    }

                    if (32 & y) {
                      n.mode = 12;
                      break e;
                    }

                    e.msg = "invalid literal/length code", n.mode = 30;
                    break e;
                  }

                  w = 65535 & b, (y &= 15) && (_ < y && (h += C[r++] << _, _ += 8), w += h & (1 << y) - 1, h >>>= y, _ -= y), _ < 15 && (h += C[r++] << _, _ += 8, h += C[r++] << _, _ += 8), b = m[h & v];

                  n: for (;;) {
                    if (h >>>= y = b >>> 24, _ -= y, !(16 & (y = b >>> 16 & 255))) {
                      if (0 == (64 & y)) {
                        b = m[(65535 & b) + (h & (1 << y) - 1)];
                        continue n;
                      }

                      e.msg = "invalid distance code", n.mode = 30;
                      break e;
                    }

                    if (S = 65535 & b, _ < (y &= 15) && (h += C[r++] << _, (_ += 8) < y && (h += C[r++] << _, _ += 8)), (S += h & (1 << y) - 1) > c) {
                      e.msg = "invalid distance too far back", n.mode = 30;
                      break e;
                    }

                    if (h >>>= y, _ -= y, S > (y = o - a)) {
                      if ((y = S - y) > d && n.sane) {
                        e.msg = "invalid distance too far back", n.mode = 30;
                        break e;
                      }

                      if (x = 0, E = p, 0 === u) {
                        if (x += l - y, y < w) {
                          w -= y;

                          do {
                            k[o++] = p[x++];
                          } while (--y);

                          x = o - S, E = k;
                        }
                      } else if (u < y) {
                        if (x += l + u - y, (y -= u) < w) {
                          w -= y;

                          do {
                            k[o++] = p[x++];
                          } while (--y);

                          if (x = 0, u < w) {
                            w -= y = u;

                            do {
                              k[o++] = p[x++];
                            } while (--y);

                            x = o - S, E = k;
                          }
                        }
                      } else if (x += u - y, y < w) {
                        w -= y;

                        do {
                          k[o++] = p[x++];
                        } while (--y);

                        x = o - S, E = k;
                      }

                      for (; w > 2;) {
                        k[o++] = E[x++], k[o++] = E[x++], k[o++] = E[x++], w -= 3;
                      }

                      w && (k[o++] = E[x++], w > 1 && (k[o++] = E[x++]));
                    } else {
                      x = o - S;

                      do {
                        k[o++] = k[x++], k[o++] = k[x++], k[o++] = k[x++], w -= 3;
                      } while (w > 2);

                      w && (k[o++] = k[x++], w > 1 && (k[o++] = k[x++]));
                    }

                    break;
                  }
                }
                break;
              }
            } while (r < i && o < s);

            r -= w = _ >> 3, h &= (1 << (_ -= w << 3)) - 1, e.next_in = r, e.next_out = o, e.avail_in = r < i ? i - r + 5 : 5 - (r - i), e.avail_out = o < s ? s - o + 257 : 257 - (o - s), n.hold = h, n.bits = _;
          },
              $v = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
              Xv = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
              eb = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
              tb = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64],
              nb = function nb(e, t, n, r, i, o, a, s) {
            var c,
                l,
                d,
                u,
                p,
                h,
                _,
                f,
                m,
                g = s.bits,
                v = 0,
                b = 0,
                y = 0,
                w = 0,
                S = 0,
                x = 0,
                E = 0,
                C = 0,
                k = 0,
                A = 0,
                I = null,
                T = 0,
                O = new Dg.Buf16(16),
                R = new Dg.Buf16(16),
                N = null,
                P = 0;

            for (v = 0; v <= 15; v++) {
              O[v] = 0;
            }

            for (b = 0; b < r; b++) {
              O[t[n + b]]++;
            }

            for (S = g, w = 15; w >= 1 && 0 === O[w]; w--) {
              ;
            }

            if (S > w && (S = w), 0 === w) return i[o++] = 20971520, i[o++] = 20971520, s.bits = 1, 0;

            for (y = 1; y < w && 0 === O[y]; y++) {
              ;
            }

            for (S < y && (S = y), C = 1, v = 1; v <= 15; v++) {
              if (C <<= 1, (C -= O[v]) < 0) return -1;
            }

            if (C > 0 && (0 === e || 1 !== w)) return -1;

            for (R[1] = 0, v = 1; v < 15; v++) {
              R[v + 1] = R[v] + O[v];
            }

            for (b = 0; b < r; b++) {
              0 !== t[n + b] && (a[R[t[n + b]]++] = b);
            }

            if (0 === e ? (I = N = a, h = 19) : 1 === e ? (I = $v, T -= 257, N = Xv, P -= 257, h = 256) : (I = eb, N = tb, h = -1), A = 0, b = 0, v = y, p = o, x = S, E = 0, d = -1, u = (k = 1 << S) - 1, 1 === e && k > 852 || 2 === e && k > 592) return 1;

            for (;;) {
              _ = v - E, a[b] < h ? (f = 0, m = a[b]) : a[b] > h ? (f = N[P + a[b]], m = I[T + a[b]]) : (f = 96, m = 0), c = 1 << v - E, y = l = 1 << x;

              do {
                i[p + (A >> E) + (l -= c)] = _ << 24 | f << 16 | m | 0;
              } while (0 !== l);

              for (c = 1 << v - 1; A & c;) {
                c >>= 1;
              }

              if (0 !== c ? (A &= c - 1, A += c) : A = 0, b++, 0 == --O[v]) {
                if (v === w) break;
                v = t[n + a[b]];
              }

              if (v > S && (A & u) !== d) {
                for (0 === E && (E = S), p += y, C = 1 << (x = v - E); x + E < w && !((C -= O[x + E]) <= 0);) {
                  x++, C <<= 1;
                }

                if (k += 1 << x, 1 === e && k > 852 || 2 === e && k > 592) return 1;
                i[d = A & u] = S << 24 | x << 16 | p - o | 0;
              }
            }

            return 0 !== A && (i[p + A] = v - E << 24 | 64 << 16 | 0), s.bits = S, 0;
          };

          function rb(e) {
            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
          }

          function ib() {
            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Dg.Buf16(320), this.work = new Dg.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
          }

          function ob(e) {
            var t;
            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = 1, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Dg.Buf32(852), t.distcode = t.distdyn = new Dg.Buf32(592), t.sane = 1, t.back = -1, 0) : -2;
          }

          function ab(e) {
            var t;
            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, ob(e)) : -2;
          }

          function sb(e, t) {
            var n, r;
            return e && e.state ? (r = e.state, t < 0 ? (n = 0, t = -t) : (n = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? -2 : (null !== r.window && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, ab(e))) : -2;
          }

          function cb(e, t) {
            var n, r;
            return e ? (r = new ib(), e.state = r, r.window = null, 0 !== (n = sb(e, t)) && (e.state = null), n) : -2;
          }

          var lb,
              db,
              ub = !0;

          function pb(e) {
            if (ub) {
              var t;

              for (lb = new Dg.Buf32(512), db = new Dg.Buf32(32), t = 0; t < 144;) {
                e.lens[t++] = 8;
              }

              for (; t < 256;) {
                e.lens[t++] = 9;
              }

              for (; t < 280;) {
                e.lens[t++] = 7;
              }

              for (; t < 288;) {
                e.lens[t++] = 8;
              }

              for (nb(1, e.lens, 0, 288, lb, 0, e.work, {
                bits: 9
              }), t = 0; t < 32;) {
                e.lens[t++] = 5;
              }

              nb(2, e.lens, 0, 32, db, 0, e.work, {
                bits: 5
              }), ub = !1;
            }

            e.lencode = lb, e.lenbits = 9, e.distcode = db, e.distbits = 5;
          }

          function hb(e, t, n, r) {
            var i,
                o = e.state;
            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Dg.Buf8(o.wsize)), r >= o.wsize ? (Dg.arraySet(o.window, t, n - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : ((i = o.wsize - o.wnext) > r && (i = r), Dg.arraySet(o.window, t, n - r, i, o.wnext), (r -= i) ? (Dg.arraySet(o.window, t, n - r, r, 0), o.wnext = r, o.whave = o.wsize) : (o.wnext += i, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += i))), 0;
          }

          var _b = {
            inflateReset: ab,
            inflateReset2: sb,
            inflateResetKeep: ob,
            inflateInit: function inflateInit(e) {
              return cb(e, 15);
            },
            inflateInit2: cb,
            inflate: function inflate(e, t) {
              var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  c,
                  l,
                  d,
                  u,
                  p,
                  h,
                  _,
                  f,
                  m,
                  g,
                  v,
                  b,
                  y,
                  w,
                  S,
                  x,
                  E,
                  C,
                  k = 0,
                  A = new Dg.Buf8(4),
                  I = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

              if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return -2;
              12 === (n = e.state).mode && (n.mode = 13), a = e.next_out, i = e.output, c = e.avail_out, o = e.next_in, r = e.input, s = e.avail_in, l = n.hold, d = n.bits, u = s, p = c, x = 0;

              e: for (;;) {
                switch (n.mode) {
                  case 1:
                    if (0 === n.wrap) {
                      n.mode = 13;
                      break;
                    }

                    for (; d < 16;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    if (2 & n.wrap && 35615 === l) {
                      n.check = 0, A[0] = 255 & l, A[1] = l >>> 8 & 255, n.check = vv(n.check, A, 2, 0), l = 0, d = 0, n.mode = 2;
                      break;
                    }

                    if (n.flags = 0, n.head && (n.head.done = !1), !(1 & n.wrap) || (((255 & l) << 8) + (l >> 8)) % 31) {
                      e.msg = "incorrect header check", n.mode = 30;
                      break;
                    }

                    if (8 != (15 & l)) {
                      e.msg = "unknown compression method", n.mode = 30;
                      break;
                    }

                    if (d -= 4, S = 8 + (15 & (l >>>= 4)), 0 === n.wbits) n.wbits = S;else if (S > n.wbits) {
                      e.msg = "invalid window size", n.mode = 30;
                      break;
                    }
                    n.dmax = 1 << S, e.adler = n.check = 1, n.mode = 512 & l ? 10 : 12, l = 0, d = 0;
                    break;

                  case 2:
                    for (; d < 16;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    if (n.flags = l, 8 != (255 & n.flags)) {
                      e.msg = "unknown compression method", n.mode = 30;
                      break;
                    }

                    if (57344 & n.flags) {
                      e.msg = "unknown header flags set", n.mode = 30;
                      break;
                    }

                    n.head && (n.head.text = l >> 8 & 1), 512 & n.flags && (A[0] = 255 & l, A[1] = l >>> 8 & 255, n.check = vv(n.check, A, 2, 0)), l = 0, d = 0, n.mode = 3;

                  case 3:
                    for (; d < 32;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    n.head && (n.head.time = l), 512 & n.flags && (A[0] = 255 & l, A[1] = l >>> 8 & 255, A[2] = l >>> 16 & 255, A[3] = l >>> 24 & 255, n.check = vv(n.check, A, 4, 0)), l = 0, d = 0, n.mode = 4;

                  case 4:
                    for (; d < 16;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    n.head && (n.head.xflags = 255 & l, n.head.os = l >> 8), 512 & n.flags && (A[0] = 255 & l, A[1] = l >>> 8 & 255, n.check = vv(n.check, A, 2, 0)), l = 0, d = 0, n.mode = 5;

                  case 5:
                    if (1024 & n.flags) {
                      for (; d < 16;) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      n.length = l, n.head && (n.head.extra_len = l), 512 & n.flags && (A[0] = 255 & l, A[1] = l >>> 8 & 255, n.check = vv(n.check, A, 2, 0)), l = 0, d = 0;
                    } else n.head && (n.head.extra = null);

                    n.mode = 6;

                  case 6:
                    if (1024 & n.flags && ((h = n.length) > s && (h = s), h && (n.head && (S = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Array(n.head.extra_len)), Dg.arraySet(n.head.extra, r, o, h, S)), 512 & n.flags && (n.check = vv(n.check, r, h, o)), s -= h, o += h, n.length -= h), n.length)) break e;
                    n.length = 0, n.mode = 7;

                  case 7:
                    if (2048 & n.flags) {
                      if (0 === s) break e;
                      h = 0;

                      do {
                        S = r[o + h++], n.head && S && n.length < 65536 && (n.head.name += String.fromCharCode(S));
                      } while (S && h < s);

                      if (512 & n.flags && (n.check = vv(n.check, r, h, o)), s -= h, o += h, S) break e;
                    } else n.head && (n.head.name = null);

                    n.length = 0, n.mode = 8;

                  case 8:
                    if (4096 & n.flags) {
                      if (0 === s) break e;
                      h = 0;

                      do {
                        S = r[o + h++], n.head && S && n.length < 65536 && (n.head.comment += String.fromCharCode(S));
                      } while (S && h < s);

                      if (512 & n.flags && (n.check = vv(n.check, r, h, o)), s -= h, o += h, S) break e;
                    } else n.head && (n.head.comment = null);

                    n.mode = 9;

                  case 9:
                    if (512 & n.flags) {
                      for (; d < 16;) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      if (l !== (65535 & n.check)) {
                        e.msg = "header crc mismatch", n.mode = 30;
                        break;
                      }

                      l = 0, d = 0;
                    }

                    n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = 12;
                    break;

                  case 10:
                    for (; d < 32;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    e.adler = n.check = rb(l), l = 0, d = 0, n.mode = 11;

                  case 11:
                    if (0 === n.havedict) return e.next_out = a, e.avail_out = c, e.next_in = o, e.avail_in = s, n.hold = l, n.bits = d, 2;
                    e.adler = n.check = 1, n.mode = 12;

                  case 12:
                    if (5 === t || 6 === t) break e;

                  case 13:
                    if (n.last) {
                      l >>>= 7 & d, d -= 7 & d, n.mode = 27;
                      break;
                    }

                    for (; d < 3;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    switch (n.last = 1 & l, d -= 1, 3 & (l >>>= 1)) {
                      case 0:
                        n.mode = 14;
                        break;

                      case 1:
                        if (pb(n), n.mode = 20, 6 === t) {
                          l >>>= 2, d -= 2;
                          break e;
                        }

                        break;

                      case 2:
                        n.mode = 17;
                        break;

                      case 3:
                        e.msg = "invalid block type", n.mode = 30;
                    }

                    l >>>= 2, d -= 2;
                    break;

                  case 14:
                    for (l >>>= 7 & d, d -= 7 & d; d < 32;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    if ((65535 & l) != (l >>> 16 ^ 65535)) {
                      e.msg = "invalid stored block lengths", n.mode = 30;
                      break;
                    }

                    if (n.length = 65535 & l, l = 0, d = 0, n.mode = 15, 6 === t) break e;

                  case 15:
                    n.mode = 16;

                  case 16:
                    if (h = n.length) {
                      if (h > s && (h = s), h > c && (h = c), 0 === h) break e;
                      Dg.arraySet(i, r, o, h, a), s -= h, o += h, c -= h, a += h, n.length -= h;
                      break;
                    }

                    n.mode = 12;
                    break;

                  case 17:
                    for (; d < 14;) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    if (n.nlen = 257 + (31 & l), l >>>= 5, d -= 5, n.ndist = 1 + (31 & l), l >>>= 5, d -= 5, n.ncode = 4 + (15 & l), l >>>= 4, d -= 4, n.nlen > 286 || n.ndist > 30) {
                      e.msg = "too many length or distance symbols", n.mode = 30;
                      break;
                    }

                    n.have = 0, n.mode = 18;

                  case 18:
                    for (; n.have < n.ncode;) {
                      for (; d < 3;) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      n.lens[I[n.have++]] = 7 & l, l >>>= 3, d -= 3;
                    }

                    for (; n.have < 19;) {
                      n.lens[I[n.have++]] = 0;
                    }

                    if (n.lencode = n.lendyn, n.lenbits = 7, E = {
                      bits: n.lenbits
                    }, x = nb(0, n.lens, 0, 19, n.lencode, 0, n.work, E), n.lenbits = E.bits, x) {
                      e.msg = "invalid code lengths set", n.mode = 30;
                      break;
                    }

                    n.have = 0, n.mode = 19;

                  case 19:
                    for (; n.have < n.nlen + n.ndist;) {
                      for (; g = (k = n.lencode[l & (1 << n.lenbits) - 1]) >>> 16 & 255, v = 65535 & k, !((m = k >>> 24) <= d);) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      if (v < 16) l >>>= m, d -= m, n.lens[n.have++] = v;else {
                        if (16 === v) {
                          for (C = m + 2; d < C;) {
                            if (0 === s) break e;
                            s--, l += r[o++] << d, d += 8;
                          }

                          if (l >>>= m, d -= m, 0 === n.have) {
                            e.msg = "invalid bit length repeat", n.mode = 30;
                            break;
                          }

                          S = n.lens[n.have - 1], h = 3 + (3 & l), l >>>= 2, d -= 2;
                        } else if (17 === v) {
                          for (C = m + 3; d < C;) {
                            if (0 === s) break e;
                            s--, l += r[o++] << d, d += 8;
                          }

                          d -= m, S = 0, h = 3 + (7 & (l >>>= m)), l >>>= 3, d -= 3;
                        } else {
                          for (C = m + 7; d < C;) {
                            if (0 === s) break e;
                            s--, l += r[o++] << d, d += 8;
                          }

                          d -= m, S = 0, h = 11 + (127 & (l >>>= m)), l >>>= 7, d -= 7;
                        }

                        if (n.have + h > n.nlen + n.ndist) {
                          e.msg = "invalid bit length repeat", n.mode = 30;
                          break;
                        }

                        for (; h--;) {
                          n.lens[n.have++] = S;
                        }
                      }
                    }

                    if (30 === n.mode) break;

                    if (0 === n.lens[256]) {
                      e.msg = "invalid code -- missing end-of-block", n.mode = 30;
                      break;
                    }

                    if (n.lenbits = 9, E = {
                      bits: n.lenbits
                    }, x = nb(1, n.lens, 0, n.nlen, n.lencode, 0, n.work, E), n.lenbits = E.bits, x) {
                      e.msg = "invalid literal/lengths set", n.mode = 30;
                      break;
                    }

                    if (n.distbits = 6, n.distcode = n.distdyn, E = {
                      bits: n.distbits
                    }, x = nb(2, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, E), n.distbits = E.bits, x) {
                      e.msg = "invalid distances set", n.mode = 30;
                      break;
                    }

                    if (n.mode = 20, 6 === t) break e;

                  case 20:
                    n.mode = 21;

                  case 21:
                    if (s >= 6 && c >= 258) {
                      e.next_out = a, e.avail_out = c, e.next_in = o, e.avail_in = s, n.hold = l, n.bits = d, Jv(e, p), a = e.next_out, i = e.output, c = e.avail_out, o = e.next_in, r = e.input, s = e.avail_in, l = n.hold, d = n.bits, 12 === n.mode && (n.back = -1);
                      break;
                    }

                    for (n.back = 0; g = (k = n.lencode[l & (1 << n.lenbits) - 1]) >>> 16 & 255, v = 65535 & k, !((m = k >>> 24) <= d);) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    if (g && 0 == (240 & g)) {
                      for (b = m, y = g, w = v; g = (k = n.lencode[w + ((l & (1 << b + y) - 1) >> b)]) >>> 16 & 255, v = 65535 & k, !(b + (m = k >>> 24) <= d);) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      l >>>= b, d -= b, n.back += b;
                    }

                    if (l >>>= m, d -= m, n.back += m, n.length = v, 0 === g) {
                      n.mode = 26;
                      break;
                    }

                    if (32 & g) {
                      n.back = -1, n.mode = 12;
                      break;
                    }

                    if (64 & g) {
                      e.msg = "invalid literal/length code", n.mode = 30;
                      break;
                    }

                    n.extra = 15 & g, n.mode = 22;

                  case 22:
                    if (n.extra) {
                      for (C = n.extra; d < C;) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      n.length += l & (1 << n.extra) - 1, l >>>= n.extra, d -= n.extra, n.back += n.extra;
                    }

                    n.was = n.length, n.mode = 23;

                  case 23:
                    for (; g = (k = n.distcode[l & (1 << n.distbits) - 1]) >>> 16 & 255, v = 65535 & k, !((m = k >>> 24) <= d);) {
                      if (0 === s) break e;
                      s--, l += r[o++] << d, d += 8;
                    }

                    if (0 == (240 & g)) {
                      for (b = m, y = g, w = v; g = (k = n.distcode[w + ((l & (1 << b + y) - 1) >> b)]) >>> 16 & 255, v = 65535 & k, !(b + (m = k >>> 24) <= d);) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      l >>>= b, d -= b, n.back += b;
                    }

                    if (l >>>= m, d -= m, n.back += m, 64 & g) {
                      e.msg = "invalid distance code", n.mode = 30;
                      break;
                    }

                    n.offset = v, n.extra = 15 & g, n.mode = 24;

                  case 24:
                    if (n.extra) {
                      for (C = n.extra; d < C;) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      n.offset += l & (1 << n.extra) - 1, l >>>= n.extra, d -= n.extra, n.back += n.extra;
                    }

                    if (n.offset > n.dmax) {
                      e.msg = "invalid distance too far back", n.mode = 30;
                      break;
                    }

                    n.mode = 25;

                  case 25:
                    if (0 === c) break e;

                    if (h = p - c, n.offset > h) {
                      if ((h = n.offset - h) > n.whave && n.sane) {
                        e.msg = "invalid distance too far back", n.mode = 30;
                        break;
                      }

                      h > n.wnext ? (h -= n.wnext, _ = n.wsize - h) : _ = n.wnext - h, h > n.length && (h = n.length), f = n.window;
                    } else f = i, _ = a - n.offset, h = n.length;

                    h > c && (h = c), c -= h, n.length -= h;

                    do {
                      i[a++] = f[_++];
                    } while (--h);

                    0 === n.length && (n.mode = 21);
                    break;

                  case 26:
                    if (0 === c) break e;
                    i[a++] = n.length, c--, n.mode = 21;
                    break;

                  case 27:
                    if (n.wrap) {
                      for (; d < 32;) {
                        if (0 === s) break e;
                        s--, l |= r[o++] << d, d += 8;
                      }

                      if (p -= c, e.total_out += p, n.total += p, p && (e.adler = n.check = n.flags ? vv(n.check, i, p, a - p) : mv(n.check, i, p, a - p)), p = c, (n.flags ? l : rb(l)) !== n.check) {
                        e.msg = "incorrect data check", n.mode = 30;
                        break;
                      }

                      l = 0, d = 0;
                    }

                    n.mode = 28;

                  case 28:
                    if (n.wrap && n.flags) {
                      for (; d < 32;) {
                        if (0 === s) break e;
                        s--, l += r[o++] << d, d += 8;
                      }

                      if (l !== (4294967295 & n.total)) {
                        e.msg = "incorrect length check", n.mode = 30;
                        break;
                      }

                      l = 0, d = 0;
                    }

                    n.mode = 29;

                  case 29:
                    x = 1;
                    break e;

                  case 30:
                    x = -3;
                    break e;

                  case 31:
                    return -4;

                  default:
                    return -2;
                }
              }

              return e.next_out = a, e.avail_out = c, e.next_in = o, e.avail_in = s, n.hold = l, n.bits = d, (n.wsize || p !== e.avail_out && n.mode < 30 && (n.mode < 27 || 4 !== t)) && hb(e, e.output, e.next_out, p - e.avail_out), u -= e.avail_in, p -= e.avail_out, e.total_in += u, e.total_out += p, n.total += p, n.wrap && p && (e.adler = n.check = n.flags ? vv(n.check, i, p, e.next_out - p) : mv(n.check, i, p, e.next_out - p)), e.data_type = n.bits + (n.last ? 64 : 0) + (12 === n.mode ? 128 : 0) + (20 === n.mode || 15 === n.mode ? 256 : 0), (0 === u && 0 === p || 4 === t) && 0 === x && (x = -5), x;
            },
            inflateEnd: function inflateEnd(e) {
              if (!e || !e.state) return -2;
              var t = e.state;
              return t.window && (t.window = null), e.state = null, 0;
            },
            inflateGetHeader: function inflateGetHeader(e, t) {
              var n;
              return e && e.state ? 0 == (2 & (n = e.state).wrap) ? -2 : (n.head = t, t.done = !1, 0) : -2;
            },
            inflateSetDictionary: function inflateSetDictionary(e, t) {
              var n,
                  r = t.length;
              return e && e.state ? 0 !== (n = e.state).wrap && 11 !== n.mode ? -2 : 11 === n.mode && mv(1, t, r, 0) !== n.check ? -3 : hb(e, t, r, r) ? (n.mode = 31, -4) : (n.havedict = 1, 0) : -2;
            },
            inflateInfo: "pako inflate (from Nodeca project)"
          },
              fb = {
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_BUF_ERROR: -5,
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            Z_BINARY: 0,
            Z_TEXT: 1,
            Z_UNKNOWN: 2,
            Z_DEFLATED: 8
          },
              mb = function mb() {
            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
          },
              gb = Object.prototype.toString;

          function vb(e) {
            if (!(this instanceof vb)) return new vb(e);
            this.options = Dg.assign({
              chunkSize: 16384,
              windowBits: 0,
              to: ""
            }, e || {});
            var t = this.options;
            t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(t.windowBits >= 0 && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Gv(), this.strm.avail_out = 0;

            var n = _b.inflateInit2(this.strm, t.windowBits);

            if (n !== fb.Z_OK) throw new Error(bv[n]);
            if (this.header = new mb(), _b.inflateGetHeader(this.strm, this.header), t.dictionary && ("string" == typeof t.dictionary ? t.dictionary = Vv(t.dictionary) : "[object ArrayBuffer]" === gb.call(t.dictionary) && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (n = _b.inflateSetDictionary(this.strm, t.dictionary)) !== fb.Z_OK)) throw new Error(bv[n]);
          }

          function bb(e, t) {
            var n = new vb(t);
            if (n.push(e, !0), n.err) throw n.msg || bv[n.err];
            return n.result;
          }

          vb.prototype.push = function (e, t) {
            var n,
                r,
                i,
                o,
                a,
                s = this.strm,
                c = this.options.chunkSize,
                l = this.options.dictionary,
                d = !1;
            if (this.ended) return !1;
            r = t === ~~t ? t : !0 === t ? fb.Z_FINISH : fb.Z_NO_FLUSH, "string" == typeof e ? s.input = function (e) {
              for (var t = new Dg.Buf8(e.length), n = 0, r = t.length; n < r; n++) {
                t[n] = e.charCodeAt(n);
              }

              return t;
            }(e) : "[object ArrayBuffer]" === gb.call(e) ? s.input = new Uint8Array(e) : s.input = e, s.next_in = 0, s.avail_in = s.input.length;

            do {
              if (0 === s.avail_out && (s.output = new Dg.Buf8(c), s.next_out = 0, s.avail_out = c), (n = _b.inflate(s, fb.Z_NO_FLUSH)) === fb.Z_NEED_DICT && l && (n = _b.inflateSetDictionary(this.strm, l)), n === fb.Z_BUF_ERROR && !0 === d && (n = fb.Z_OK, d = !1), n !== fb.Z_STREAM_END && n !== fb.Z_OK) return this.onEnd(n), this.ended = !0, !1;
              s.next_out && (0 !== s.avail_out && n !== fb.Z_STREAM_END && (0 !== s.avail_in || r !== fb.Z_FINISH && r !== fb.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = Wv(s.output, s.next_out), o = s.next_out - i, a = Fv(s.output, i), s.next_out = o, s.avail_out = c - o, o && Dg.arraySet(s.output, s.output, i, o, 0), this.onData(a)) : this.onData(Dg.shrinkBuf(s.output, s.next_out)))), 0 === s.avail_in && 0 === s.avail_out && (d = !0);
            } while ((s.avail_in > 0 || 0 === s.avail_out) && n !== fb.Z_STREAM_END);

            return n === fb.Z_STREAM_END && (r = fb.Z_FINISH), r === fb.Z_FINISH ? (n = _b.inflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === fb.Z_OK) : r !== fb.Z_SYNC_FLUSH || (this.onEnd(fb.Z_OK), s.avail_out = 0, !0);
          }, vb.prototype.onData = function (e) {
            this.chunks.push(e);
          }, vb.prototype.onEnd = function (e) {
            e === fb.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = Dg.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
          };
          var yb = {
            Inflate: vb,
            inflate: bb,
            inflateRaw: function inflateRaw(e, t) {
              return (t = t || {}).raw = !0, bb(e, t);
            },
            ungzip: bb
          },
              wb = {};
          (0, Dg.assign)(wb, Yv, yb, fb);
          var Sb = wb;
          var _Vo3 = Vo,
              xb = _Vo3.WebclientBreakoutRoomAttendeeStatus,
              Eb = _Vo3.WebclientBreakoutRoomCommand;

          function Cb(e, t) {
            var n = 0;

            for (; n < e.length; n++) {
              var r = e[n],
                  i = r.attendeeGuidList;
              if (null != i && i.includes(t)) break;
            }

            return n < e.length ? e[n] : void 0;
          }

          function kb() {
            wo.remove(xb), wo.remove(Eb);
          }

          function Ab() {
            return ua.createAgent().leaveBO(1), As("RECONNECTING_MEETING", {
              reason: ho.BackToMainSession
            }), kb(), [Bd(ic.Leaving), Ri()];
          }

          function Ib(e, t) {
            return As("RECONNECTING_MEETING", {
              reason: ho.JoinBreakoutRoom,
              roomName: e
            }), t === ic.InRoom && ua.createAgent().leaveBO(1), [Bd(ic.Joining), Ri()];
          }

          function Tb(e) {
            return As("RECONNECTING_MEETING", {
              reason: ho.MoveToBreakoutRoom,
              roomName: e
            }), ua.createAgent().leaveBO(1), [Bd(ic.Joining), Ri()];
          }

          function Ob(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? ic.InRoom : ic.Invited;
            return wo.set(xb, JSON.stringify({
              status: t,
              boId: e.boId
            }), bo.SessionStorage), Ud({
              status: t,
              boId: e.boId,
              name: e.name,
              boStatus: e.boStatus
            });
          }

          function Rb(e) {
            var _e$value$breakoutRoom = e.value.breakoutRoom,
                t = _e$value$breakoutRoom.isUserRoleUpdated,
                n = _e$value$breakoutRoom.currentRoom.boConfId,
                r = sc(e.value);
            return r && (!n || n && t) ? fe(r.isHost) : (n ? Os("BREAKOUT_ROOM_CURRENT_USER_PARTICIPANT_ROLE", 1) : Os("ADD_CURRENT_USER_PARTICIPANT_ATTRIBUTE", 2).pipe(function (e) {
              return e.lift(new Dt(1));
            })).pipe(be(Oe), ln(e), Me(function (e) {
              var _e223 = _slicedToArray(e, 2),
                  t = _e223[1];

              return sc(t).isHost;
            }));
          }

          function Nb(e) {
            return rt({
              boIdList: Os("BREAKOUT_ROOM_ADD_TOKEN").pipe(Bt(function (e, t) {
                return [].concat(_toConsumableArray(e), [t]);
              }, []), Nt(e))
            }).pipe(cn(1e4));
          }

          var Pb = ua.createAgent();
          var jb = Object.freeze({
            __proto__: null,
            addRoomEpic: function addRoomEpic(e) {
              return Vr(e, 4174).pipe(nn(function (e) {
                As("BREAKOUT_ROOM_ADD_TOKEN", e.payload.body.bid);
              }), qt(ce));
            },
            handleBoAttributeIndicationEpic: function handleBoAttributeIndicationEpic(e, t) {
              return Wr(e, 7950).pipe(ln(t), Yt(function (e) {
                var _e224 = _slicedToArray(e, 2),
                    n = _e224[0],
                    r = _e224[1];

                var i = n.payload.body.proto,
                    _r$breakoutRoom = r.breakoutRoom,
                    o = _r$breakoutRoom.isHugeBO,
                    _r$breakoutRoom$curre = _r$breakoutRoom.currentRoom,
                    a = _r$breakoutRoom$curre.status,
                    s = _r$breakoutRoom$curre.boId,
                    c = r.meeting.userGUID;
                var l = i;
                var d;
                o && (d = i, l = Sb.ungzip(bi(d), {
                  to: "string"
                }));
                var u = JSON.parse(gi(l)),
                    p = [];
                var h;
                var _ = u.ControlStatus,
                    f = u.NameIndex,
                    m = u.IsAutoJoinEnabled,
                    g = u.IsBackToMainSessionEnabled,
                    v = u.IsTimerEnabled,
                    b = u.TimerDuration,
                    y = u.IsTimerAutoEndEnabled,
                    w = u.WaitSeconds,
                    S = u.StartTimeOnMMR,
                    x = u.ItemList,
                    E = {
                  isAutoJoinRoom: m,
                  isBackToMainSessionEnabled: g,
                  isTimerEnabled: v,
                  timerDuration: b,
                  isTimerAutoEnabled: y,
                  waitSeconds: w
                };
                p.push(zd(E)), p.push(Dd(S)), p.push(Pd(f)), p.push(Md(_));
                var C = x && x.map(function (e) {
                  return {
                    boId: e.BID,
                    name: e.MeetingTitle,
                    boStatus: e.Status,
                    hostId: e.HostID,
                    attendeeGuidList: e.ParticipantList || []
                  };
                }) || [];

                switch (p.push(Ld(C)), As("BREAKOUT_ROOM_ATTRIBUTE_INDICATION", {
                  controlStatus: _,
                  roomList: C
                }), _) {
                  case nc.InProgress:
                    if (a !== ic.InRoom && a !== ic.Joining) {
                      var _e225 = function (e, t) {
                        var _t$value$meeting = t.value.meeting,
                            n = _t$value$meeting.isHost,
                            r = _t$value$meeting.userGUID,
                            i = wo.get(xb),
                            o = [];

                        if (i) {
                          var _JSON$parse = JSON.parse(i),
                              _a15 = _JSON$parse.status,
                              _s15 = _JSON$parse.boId;

                          if (_a15 === ic.Invited) {
                            if (n) kb();else {
                              var _t102 = Cb(e, r);

                              _t102 && (o.push(Ob(_t102)), As("BREAKOUT_ROOM_INVITE_TO_JOIN_NOTIFICATION", {
                                roomId: _t102.boId,
                                name: _t102.name
                              }));
                            }
                          } else if (_a15 === ic.InRoom) {
                            var _i23;

                            if (_i23 = n ? e.find(function (e) {
                              return e.boId === _s15;
                            }) : Cb(e, r), _i23) {
                              o.push(Ob(_i23));
                              var _e226 = _i23.boId;
                              Pu(t).subscribe(function () {
                                ua.createAgent().joinBO(_e226);
                              });
                            }

                            kb();
                          }
                        }

                        return o;
                      }(C, t);

                      if (0 === _e225.length) {
                        var _e227 = Cb(C, c);

                        _e227 && p.push(Ob(_e227));
                      } else p.push.apply(p, _toConsumableArray(_e225));
                    } else if (a === ic.InRoom && n.type === "".concat(wr)) {
                      var _e228 = Cb(C, c);

                      _e228 && Rb(t).subscribe(function (t) {
                        s === _e228.boId || t || Pb.joinBO(_e228.boId);
                      });
                    }

                    E.isTimerEnabled && E.timerDuration > 0 && (h = function (e, t, n) {
                      return Rb(e).pipe(ln(e), Yt(function (r) {
                        var _r45 = _slicedToArray(r, 2),
                            i = _r45[0],
                            o = _r45[1];

                        var _o$breakoutRoom = o.breakoutRoom,
                            a = _o$breakoutRoom.currentRoom.status,
                            s = _o$breakoutRoom.meetingElapsedTime,
                            c = o.meeting.joinMeetingTimeStamp,
                            l = c - 1e3 * s + 1e3 * n + 1e3 * t;

                        if (performance.now() < l) {
                          if (i) return ct(1e3).pipe(Me(function () {
                            return Math.floor((l - performance.now()) / 1e3);
                          }), ln(e), Xt(function (e) {
                            var _e229 = _slicedToArray(e, 2),
                                t = _e229[0],
                                n = _e229[1];

                            var _n$breakoutRoom = n.breakoutRoom,
                                r = _n$breakoutRoom.controlStatus,
                                i = _n$breakoutRoom.currentRoom.status,
                                o = n.socket.zoomSocketStatus,
                                a = n.meeting.isHost;
                            return t >= 0 && a && r === nc.InProgress && (i === ic.InRoom || i === ic.MainSession || i === ic.Initial) && o === bc.Connected;
                          }), nn(function (e) {
                            var _e230 = _slicedToArray(e, 1),
                                t = _e230[0];

                            As("BREAKOUT_ROOM_ROOM_COUTDOWN", {
                              countdown: t
                            });
                          }), pt(function (e) {
                            var _e231 = _slicedToArray(e, 1),
                                t = _e231[0];

                            return 0 === t;
                          }), nn(function (e) {
                            var _e232 = _slicedToArray(e, 2),
                                t = _e232[1];

                            var n = t.breakoutRoom.options;
                            n.isTimerAutoEnabled ? ua.createAgent().stopBO(nc.Closing) : As("BREAKOUT_ROOM_ROOM_COUNTDOWN_TIME_UP");
                          }), qt(ce));
                          if (a === ic.InRoom) return ct(1e3).pipe(Me(function () {
                            return Math.floor((l - performance.now()) / 1e3);
                          }), ln(e), Xt(function (e) {
                            var _e233 = _slicedToArray(e, 2),
                                t = _e233[0],
                                n = _e233[1];

                            var r = n.breakoutRoom.currentRoom.status,
                                i = n.meeting.isHost,
                                o = n.socket.zoomSocketStatus;
                            return t >= 0 && r === ic.InRoom && !i && o === bc.Connected;
                          }), nn(function (e) {
                            var _e234 = _slicedToArray(e, 1),
                                t = _e234[0];

                            As("BREAKOUT_ROOM_ROOM_COUTDOWN", {
                              countdown: t
                            });
                          }), qt(ce));
                        }

                        return ce;
                      }));
                    }(t, E.timerDuration, S));
                    break;

                  case nc.Closing:
                    h = Rb(t).pipe(pt(function (e) {
                      return e;
                    }), Je(function () {
                      var e = [],
                          _r$breakoutRoom2 = r.breakoutRoom,
                          n = _r$breakoutRoom2.closingRoomTime,
                          i = _r$breakoutRoom2.currentRoom.status,
                          o = r.participants.attendeesList;
                      var a = E.waitSeconds;

                      if (0 !== n && E.waitSeconds > 0) {
                        var _e235 = Math.floor((performance.now() - n) / 1e3);

                        a = Math.max(E.waitSeconds - _e235, 0);
                      }

                      if (0 === a) return Pb.stopBO(nc.Closed), ce;
                      {
                        if (i !== ic.InRoom && o.length > 1 && o.every(function (e) {
                          return !e.bid;
                        })) return Pb.stopBO(nc.Closed), ce;
                        n || e.push(Fd(performance.now()));

                        var _r46 = performance.now() + 1e3 * a;

                        return dt(Ke(e), ct(1e3).pipe(Me(function () {
                          return Math.floor((_r46 - performance.now()) / 1e3);
                        }), ln(t), Xt(function (e) {
                          var _e236 = _slicedToArray(e, 2),
                              t = _e236[0],
                              n = _e236[1];

                          var r = n.breakoutRoom.controlStatus,
                              i = n.meeting.isHost,
                              o = n.socket.zoomSocketStatus;
                          return t >= 0 && r === nc.Closing && o === bc.Connected && i;
                        }), nn(function (e) {
                          var _e237 = _slicedToArray(e, 1),
                              t = _e237[0];

                          t >= 0 && As("BREAKOUT_ROOM_ROOM_CLOSING_COUNTDOWN", {
                            countdown: t
                          });
                        }), pt(function (e) {
                          var _e238 = _slicedToArray(e, 1),
                              t = _e238[0];

                          return 0 === t;
                        }), nn(function () {
                          Pb.stopBO(nc.Closed);
                        }), qt(ce)));
                      }
                    }));
                    break;

                  case nc.Closed:
                    p.push(Fd(0)), a === ic.Leaving ? p.push(Bd(ic.MainSession)) : a === ic.Invited ? p.push(Bd(ic.Initial)) : a !== ic.InRoom && a !== ic.Joining || p.push.apply(p, _toConsumableArray(Ab())), kb();
                }

                return h ? dt(Ke(p), h) : Ke(p);
              }));
            },
            handleBoJoinResponseEpic: function handleBoJoinResponseEpic(e, t) {
              return Wr(e, 4194).pipe(ln(t), Yt(function (e) {
                var _e239 = _slicedToArray(e, 2),
                    t = _e239[0],
                    n = _e239[1];

                var _t$payload$body12 = t.payload.body,
                    r = _t$payload$body12.bid,
                    i = _t$payload$body12.botoken,
                    o = _t$payload$body12.confID,
                    a = n.meeting.isHost,
                    _n$breakoutRoom2 = n.breakoutRoom,
                    s = _n$breakoutRoom2.rooms,
                    c = _n$breakoutRoom2.currentRoom.status,
                    l = [],
                    d = s.find(function (e) {
                  return e.boId === r;
                });
                return d && (l.push(Ob(d, a)), l.push(Hd(o)), l.push(Vd(i)), a || c !== ic.InRoom ? l.push.apply(l, _toConsumableArray(Ib(d.name, c))) : l.push.apply(l, _toConsumableArray(Tb(d.name)))), As("BREAKOUT_ROOM_JOIN_BO_RESPONSE", {
                  boId: r
                }), Ke(l);
              }));
            },
            handleBoCommandIndicationEpic: function handleBoCommandIndicationEpic(e, t) {
              return e.pipe(fn("".concat(mr), "".concat(wr)), pt(function (e) {
                return 7949 === e.payload.evt;
              }), ln(t), Je(function (e) {
                var _e240 = _slicedToArray(e, 2),
                    n = _e240[0],
                    r = _e240[1];

                var i = n.payload.body,
                    o = r.meeting.userGUID,
                    _r$breakoutRoom3 = r.breakoutRoom,
                    a = _r$breakoutRoom3.rooms,
                    s = _r$breakoutRoom3.options.isAutoJoinRoom,
                    c = _r$breakoutRoom3.currentRoom.status,
                    l = i.commandType,
                    d = [];
                var u;

                switch (l) {
                  case oc.Join:
                    {
                      var _e241 = i.targetBID,
                          _t103 = i.botoken,
                          _n65 = i.confID,
                          _r47 = Cb(a, o);

                      _r47 && _r47.boId === _e241 && (d.push(Hd(_n65)), d.push(Vd(_t103)), s ? d.push.apply(d, _toConsumableArray(Ib(_r47.name))) : (wo.set(Vo.WebclientBreakoutRoomCommand, l, bo.SessionStorage), As("BREAKOUT_ROOM_INVITE_TO_JOIN_NOTIFICATION", {
                        roomId: _e241,
                        name: _r47.name
                      })));
                      break;
                    }

                  case oc.Switch:
                    {
                      var _e242 = i.targetBID,
                          _t104 = i.botoken,
                          _n66 = i.confID,
                          _r48 = Cb(a, o);

                      _r48 && _r48.boId === _e242 && (d.push(Ud({
                        boId: _r48.boId,
                        boToken: _t104,
                        boConfId: _n66,
                        name: _r48.name
                      })), c === ic.Invited ? (wo.set(Vo.WebclientBreakoutRoomCommand, l, bo.SessionStorage), s ? d.push.apply(d, _toConsumableArray(Ib(_r48.name))) : As("BREAKOUT_ROOM_INVITE_TO_JOIN_NOTIFICATION", {
                        roomId: _e242,
                        name: _r48.name
                      })) : d.push.apply(d, _toConsumableArray(Tb(_r48.name))));
                      break;
                    }

                  case oc.Leave:
                    {
                      var _e243 = i.waitTime;
                      if ((p = c) !== ic.InRoom && p !== ic.Joining && p !== ic.Leaving) d.push(Ud({
                        boId: "",
                        boToken: "",
                        boConfId: "",
                        status: ic.Initial
                      }));else {
                        var _n67 = Number(_e243);

                        if (_n67 > 0) {
                          var _e244 = performance.now() + 1e3 * _n67;

                          u = ct(1e3).pipe(Me(function () {
                            return Math.floor((_e244 - performance.now()) / 1e3);
                          }), ln(t), Xt(function (e) {
                            var _e245 = _slicedToArray(e, 2),
                                t = _e245[0],
                                n = _e245[1];

                            var _n$breakoutRoom3 = n.breakoutRoom,
                                r = _n$breakoutRoom3.controlStatus,
                                i = _n$breakoutRoom3.currentRoom.status,
                                o = n.meeting.isHost,
                                a = n.socket.zoomSocketStatus;
                            return t >= 0 && a === bc.Connected && r === nc.Closing && i === ic.InRoom && !o;
                          }), nn(function (e) {
                            var _e246 = _slicedToArray(e, 1),
                                t = _e246[0];

                            t >= 0 && As("BREAKOUT_ROOM_ROOM_CLOSING_COUNTDOWN", {
                              countdown: t
                            });
                          }), qt(ce));
                        } else d.push.apply(d, _toConsumableArray(Ab()));

                        kb();
                      }
                      break;
                    }

                  case oc.Broadcast:
                    {
                      var _e247 = i.textContent;

                      if (_e247) {
                        var _t105 = r.meeting.encType,
                            _n68 = r.participants.attendeesList,
                            _i24 = r.breakoutRoom.mainSessionAttendeeList;
                        var _o14 = "";

                        if (_t105 === Bo.AES_GCM) {
                          var _e248 = _n68.concat(_i24).find(function (e) {
                            return Js(e.userRole);
                          });

                          _e248 && (_o14 = _e248.zoomID);
                        }

                        u = Ke(Ko.beginDecrypt({
                          decryptedText: _e247,
                          type: Ho.BO_BROADCAST,
                          zoomId: _o14
                        }).then(function (e) {
                          var t = e.message;
                          return As("BREAKOUT_ROOM_BROADCAST_MESSAGE", {
                            message: t
                          }), Wd(t);
                        }));
                      }

                      break;
                    }

                  case oc.HelpReq:
                    {
                      var _e249 = i.requestID,
                          _r$breakoutRoom4 = r.breakoutRoom,
                          _t106 = _r$breakoutRoom4.mainSessionAttendeeList,
                          _n69 = _r$breakoutRoom4.rooms,
                          _o15 = _r$breakoutRoom4.currentRoom.boId,
                          _a16 = _r$breakoutRoom4.hostReplyToQuestionerType,
                          _s16 = _r$breakoutRoom4.hostReplyToRequestId,
                          _l9 = r.participants.attendeesList;

                      if (_e249) {
                        if (c === ic.InRoom) {
                          var _n70 = _t106.find(function (t) {
                            return t.userId === _e249;
                          });

                          if (_n70 && _n70.bid === _o15) {
                            Pb.askForHelpResultBO(_e249, ac.AlreadyInRoom);
                            break;
                          }
                        }

                        if (_a16 === ac.Received && _s16 !== _e249) Pb.askForHelpResultBO(_e249, ac.Busy);else {
                          Pb.askForHelpResultBO(_e249, ac.Received), d.push(Gd(ac.Received), Kd(_e249));

                          var _r49 = (c === ic.InRoom ? _t106 : _l9).find(function (t) {
                            return t.userId === _e249;
                          });

                          if (_r49) {
                            var _t107 = _r49.bid,
                                _i25 = _n69.find(function (e) {
                              return e.boId === _t107;
                            });

                            _i25 && As("BREAKOUT_ROOM_ASK_HELP_REQUEST", {
                              userId: _e249,
                              displayName: _r49.displayName,
                              roomName: _i25.name,
                              roomId: _i25.boId
                            });
                          }
                        }
                      }

                      break;
                    }

                  case oc.HelpRes:
                    {
                      var _e250 = i.helpResult;
                      As("BREAKOUT_ROOM_ASK_HELP_RESPONSE", {
                        result: Number(_e250)
                      });
                      break;
                    }
                }

                var p;
                return u ? dt(Ke(d), u) : Ke(d);
              }));
            },
            handleMainSessionJoinResponseEpic: function handleMainSessionJoinResponseEpic(e, t) {
              return qr(e, 4098).pipe(ln(t), Yt(function (e) {
                var _e251 = _slicedToArray(e, 2),
                    t = _e251[0],
                    n = _e251[1];

                var _t$payload$body13 = t.payload.body,
                    r = _t$payload$body13.res,
                    i = _t$payload$body13.elapsed,
                    o = [];
                return r === ei.CONF_FAIL_MEETING_HAS_CLOSED || r === ei.CONF_FAIL_HAS_BEEN_REMOVED ? (kb(), o.push.apply(o, _toConsumableArray(hu(n, !1)))) : r === ei.CONF_SUCCESS && (o.push(jd(i)), o.push(Bd(ic.InRoom)), wo.set(Vo.WebclientBreakoutRoomAttendeeStatus, JSON.stringify({
                  status: ic.InRoom,
                  boId: n.breakoutRoom.currentRoom.boId
                }), bo.SessionStorage)), Ke(o);
              }));
            },
            handleMainSessionRosterUpdateResponse: function handleMainSessionRosterUpdateResponse(e, t) {
              return qr(e, 7937).pipe(Me(function (e) {
                return s_(e.payload.body);
              }), ln(t), Je(function (e) {
                var _e252 = _slicedToArray(e, 2),
                    t = _e252[0],
                    n = _e252[1];

                var r = [Qd(t)],
                    i = ["userRole", "bCoHost", "bCCEditor", "bHold"],
                    o = n.participants.attendeesList,
                    _n$breakoutRoom4 = n.breakoutRoom,
                    a = _n$breakoutRoom4.mainSessionAttendeeList,
                    s = _n$breakoutRoom4.isUserRoleUpdated,
                    c = n.meeting.userId;
                var l = [];
                return ["add", "update"].forEach(function (e) {
                  var _l10;

                  return t[e] && (_l10 = l).push.apply(_l10, _toConsumableArray(t[e]));
                }), l = l.filter(function (e) {
                  return i.some(function (t) {
                    return void 0 !== e[t];
                  });
                }).map(function (e) {
                  var t = a.find(function (t) {
                    return t.userId === e.userId;
                  });

                  if (t) {
                    var _n71 = o.find(function (e) {
                      return e.zoomID === t.zoomID;
                    });

                    if (_n71) return void 0 === e.userRole || s || _n71.userId !== c || (r.push(Jd(!0)), As("BREAKOUT_ROOM_CURRENT_USER_PARTICIPANT_ROLE", e)), void 0 !== e.bCCEditor && r.push(fd({
                      editorId: _n71.userId,
                      isEditor: !!e.bCCEditor,
                      editorZoomId: _n71.zoomID
                    })), delete e.bRaiseHand, f(f({}, e), {}, {
                      userId: _n71.userId
                    });
                  }

                  return null;
                }).filter(function (e) {
                  return !!e;
                }), l.length > 0 && (As("UPDATE_USER_PARTICIPANT_ATTRIBUTE", l), r.push(Ns({
                  update: l
                }))), As("BREAKOUT_ROOM_MAIN_SESSION_USER_UPDATE"), Ke(r);
              }));
            },
            handleMainSessionMeetingAttributeEpic: function handleMainSessionMeetingAttributeEpic(e) {
              return qr(e, 7938).pipe(pt(function (e) {
                var t = e.payload.body;
                return void 0 !== (null == t ? void 0 : t.bAllowAttendeeRename) || void 0 !== (null == t ? void 0 : t.chatPriviledge) || void 0 !== (null == t ? void 0 : t.lockShare);
              }), Me(function (e) {
                var t = e.payload.body;
                return void 0 !== t.bAllowAttendeeRename ? qi(e.payload.body) : void 0 !== t.chatPriviledge ? cd(t.chatPriviledge) : void 0 !== t.lockShare ? $c(t.lockShare) : void 0;
              }));
            },
            handleClosingRoomAttendeeUpdateEpic: function handleClosingRoomAttendeeUpdateEpic(e, t) {
              return Vr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e253 = _slicedToArray(e, 2),
                    t = _e253[1];

                var n = t.meeting.isHost,
                    _t$breakoutRoom = t.breakoutRoom,
                    r = _t$breakoutRoom.controlStatus,
                    i = _t$breakoutRoom.currentRoom.status;
                return n && r === nc.Closing && i !== ic.InRoom;
              }), be(Oe), nn(function () {
                var e = t.value.participants.attendeesList;
                e.every(function (e) {
                  return !e.bid;
                }) && e.length > 1 && Pb.stopBO(nc.Closed);
              }), qt(ce));
            },
            handlePreAssignedRoomRespEpic: function handlePreAssignedRoomRespEpic(e, t) {
              return Vr(e, 4214).pipe(ln(t), Yt(function (e) {
                var _e254 = _slicedToArray(e, 2),
                    n = _e254[0],
                    r = _e254[1];

                var i = n.payload.body.proto,
                    _r$breakoutRoom5 = r.breakoutRoom,
                    o = _r$breakoutRoom5.rooms,
                    a = _r$breakoutRoom5.isHugeBO;

                try {
                  var _e255 = JSON.parse(gi(i)),
                      _n72 = [];

                  if (_e255 && _e255.PreAssignBoList && Array.isArray(_e255.PreAssignBoList)) {
                    var _r50 = _e255.PreAssignBoList.map(function (e) {
                      return {
                        name: e.BoName,
                        emails: e.email
                      };
                    });

                    _n72.push(Yd(_r50));

                    var _i26 = a ? 100 : 50;

                    if (o.length + _r50.length < _i26) {
                      var _e256 = _r50.map(function (e) {
                        return e.name;
                      });

                      return Pb.batchCreateBOToken(_e256), dt(Ke(_n72), Nb(_e256.length).pipe(ln(t), Je(function (e) {
                        var _e257 = _slicedToArray(e, 2),
                            t = _e257[0].boIdList,
                            n = _e257[1];

                        var i = pc(n),
                            o = _r50.map(function (e, n) {
                          var r = e.emails,
                              o = e.name;
                          var a = [];
                          return r && Array.isArray(r) && (a = r.map(function (e) {
                            return i.filter(function (t) {
                              return t.userEmail === e;
                            }).map(function (e) {
                              return e.userGUID;
                            });
                          }).reduce(function (e, t) {
                            return [].concat(_toConsumableArray(e), _toConsumableArray(t));
                          }, [])), {
                            boId: t[n],
                            name: o,
                            attendeeGuidList: a
                          };
                        }),
                            a = o.map(function (e, t) {
                          return {
                            roomId: e.boId,
                            name: e.name,
                            emails: _r50[t].emails
                          };
                        });

                        return As("BREAKOUT_ROOM_LOAD_PRE_ASSIGNED_ROOMS", {
                          rooms: a
                        }), Ke([Ld(o), Yd(a)]);
                      })));
                    }

                    return Ke(_n72);
                  }
                } catch (e) {
                  console.error("pre assign proto is not valid");
                }

                return ce;
              }));
            },
            handlePreAssignedUserJoinMeetingEpic: function handlePreAssignedUserJoinMeetingEpic(e, t) {
              return Wr(e, 7937).pipe(ln(t), pt(function (e) {
                var _e258 = _slicedToArray(e, 2),
                    t = _e258[0],
                    n = _e258[1];

                var _n$meeting10 = n.meeting,
                    r = _n$meeting10.isHost,
                    i = _n$meeting10.meetingStatus,
                    o = _n$meeting10.meetingOptions,
                    a = n.breakoutRoom.controlStatus,
                    s = t.payload.body;
                return i === go.Joined && (null == o ? void 0 : o.isAllowBreakoutRoomPreAssign) && r && (a === nc.NotStarted || a === nc.InProgress) && Array.isArray(s.add);
              }), Je(function (e) {
                var _e259 = _slicedToArray(e, 2),
                    t = _e259[0],
                    n = _e259[1];

                var _n$breakoutRoom5 = n.breakoutRoom,
                    r = _n$breakoutRoom5.controlStatus,
                    i = _n$breakoutRoom5.rooms,
                    o = _n$breakoutRoom5.preAssignedRooms,
                    a = _n$breakoutRoom5.currentRoom.status,
                    s = n.participants.failoverAttendeesList,
                    c = null == o ? void 0 : o.filter(function (e) {
                  return i.findIndex(function (t) {
                    return t.boId === e.roomId;
                  }) > -1;
                }),
                    l = t.payload.body.add,
                    d = [];
                return c.length > 0 && l.filter(function (e) {
                  return e.userEmail && e.userGUID;
                }).filter(function (e) {
                  return -1 === s.findIndex(function (t) {
                    return t.zoomID === e.zoomID;
                  });
                }).forEach(function (e) {
                  if (!Cb(i, e.userGUID)) {
                    var _loop = function _loop(_n73) {
                      var o = c[_n73];

                      if (o.emails.includes(e.userEmail)) {
                        if (r === nc.NotStarted) {
                          var _t108 = Hp(i, function (t) {
                            var n = t.find(function (e) {
                              return e.boId === o.roomId;
                            });
                            null == n || n.attendeeGuidList.push(e.userGUID);
                          });

                          d.push(Ld(_t108));
                        } else r === nc.InProgress && (a === ic.InRoom && t.type === "".concat(wr) ? Pb.assignToBO(e.id, String(o.roomId)) : a !== ic.Initial && a !== ic.MainSession || Pb.assignToBO(e.id, String(o.roomId)));

                        return "break";
                      }
                    };

                    for (var _n73 = 0; _n73 < (null == c ? void 0 : c.length); _n73++) {
                      var _ret = _loop(_n73);

                      if (_ret === "break") break;
                    }
                  }
                }), Ke(d);
              }));
            }
          });
          var Db = ua.createAgent();
          var zb = Object.freeze({
            __proto__: null,
            handleMainSessionReceivingSharingEpic: function handleMainSessionReceivingSharingEpic(e, t) {
              return qr(e, 7937).pipe(pt(function (e) {
                var t;
                var n = e.payload.body;
                return null == n || null === (t = n.update) || void 0 === t ? void 0 : t.some(function (e) {
                  return void 0 !== e.bShareToBORooms || void 0 !== e.bShareOn;
                });
              }), ln(t), Me(function (e) {
                var _e260 = _slicedToArray(e, 2),
                    t = _e260[0],
                    n = _e260[1];

                var r = t.payload.body.update,
                    i = n.breakoutRoom.mainSessionAttendeeList,
                    o = r.filter(function (e) {
                  return e.bShareOn && e.bShareToBORooms;
                }),
                    a = r.filter(function (e) {
                  return !e.bShareOn || !e.bShareToBORooms;
                }),
                    s = i.filter(function (e) {
                  return e.sharerOn && e.bShareToBORooms;
                });
                return o.length > 0 && o.forEach(function (e) {
                  -1 === s.findIndex(function (t) {
                    return t.userId === e.id;
                  }) && As("SHARE_NEW_USER_ADD", f(f({}, e), {}, {
                    isFromMainSession: !0
                  }));
                }), a.length > 0 && a.forEach(function (e) {
                  As("SHARE_USER_REMOVE", f(f({}, e), {}, {
                    isFromMainSession: !0
                  }));
                }), r.map(function (e) {
                  if (e.bShareOn && e.bShareToBORooms) {
                    if (0 === i.filter(function (t) {
                      return t.sharerOn && t.bShareToBORooms && t.userId !== e.id;
                    }).length) return {
                      activeNodeID: e.id,
                      bStatus: 1,
                      ssrc: e.shareSsrc
                    };
                    {
                      var _t109 = i.find(function (t) {
                        return t.userId === e.id;
                      });

                      if (null != _t109 && _t109.isHost) return {
                        activeNodeID: e.id,
                        bStatus: 1,
                        ssrc: e.shareSsrc
                      };
                    }
                  } else if (!e.bShareOn || !e.bShareToBORooms) {
                    var _t110 = i.filter(function (e) {
                      return e.bShareToBORooms && e.sharerOn;
                    });

                    if (1 === _t110.length && _t110[0].userId === e.id) return {
                      activeNodeID: e.id,
                      bStatus: 0,
                      ssrc: 0
                    };
                    {
                      var _n74 = _t110.filter(function (t) {
                        return t.userId !== e.id;
                      }),
                          _r51 = _n74.find(function (e) {
                        return e.isHost;
                      });

                      if (_r51) return {
                        activeNodeID: _r51.userId,
                        bStatus: 1,
                        ssrc: _r51.shareSsrc
                      };
                      {
                        var _e261 = _n74[0];
                        if (_e261) return {
                          activeNodeID: _e261.userId,
                          bStatus: 1,
                          ssrc: _e261.shareSsrc
                        };
                      }
                    }
                  }
                }).filter(Boolean);
              }), Je(function (e) {
                var _t$value5 = t.value,
                    n = _t$value5.share.status,
                    r = _t$value5.meeting.userId,
                    i = ma.getInstance(),
                    o = [];
                return e.map(function (e) {
                  var a = e.activeNodeID,
                      s = e.bStatus,
                      c = e.ssrc,
                      l = 1 === s;
                  o.push(hl(l)), l && n !== Ua.End && (Db.stopSharing(r), i.stopDesktopSharing(), o.push(il(Ua.End)), As("SHARE_PASSIVE_BO_STOP"));
                  var d = {
                    activeNodeID: a,
                    bStatus: s,
                    ssrc: c,
                    fromMainSession: !0
                  };

                  if (!l) {
                    var _e262 = t.value.participants.attendeesList,
                        _n75 = _e262.filter(function (e) {
                      return e.sharerOn;
                    });

                    if (_n75.length > 0) {
                      var _e263 = _n75[0];
                      d = {
                        activeNodeID: _e263.userId,
                        bStatus: 1,
                        ssrc: _e263.shareSsrc || 0
                      };
                    }
                  }

                  o.push(mr({
                    evt: 20225,
                    body: d
                  }));
                }), Ke(o);
              }));
            },
            handleMainSessionCreateExtraChannelEpic: function handleMainSessionCreateExtraChannelEpic(e, t) {
              return qr(e, 4098).pipe(Yt(function (n) {
                var _n$payload$body3 = n.payload.body,
                    r = _n$payload$body3.userID,
                    i = _n$payload$body3.confID;
                return dt.apply(void 0, _toConsumableArray(["sharing", "audio"].map(function (n) {
                  return function (e, t, n, r, i) {
                    return qr(t, "audio" === e ? Zo : Qo).pipe(Nt(1), nn(function (t) {
                      var _t$payload$body14 = t.payload.body,
                          o = _t$payload$body14.encryptKey,
                          a = _t$payload$body14.additionalType,
                          _n$value = n.value,
                          _n$value$media = _n$value.media,
                          s = _n$value$media.sharingDecodeStatus,
                          c = _n$value$media.audioDecodeStatus,
                          _n$value$meeting = _n$value.meeting,
                          l = _n$value$meeting.svcUrl,
                          d = _n$value$meeting.meetingNumber,
                          u = _n$value$meeting.conId,
                          p = _n$value$meeting.zoomId,
                          h = _n$value$meeting.meetingId;
                      Nu(e, "success", "audio" === e ? c : s).subscribe(function (t) {
                        var _t111 = _slicedToArray(t, 2),
                            s = _t111[1];

                        var c = ma.getInstance();

                        if (s) {
                          var _t112 = "wss://".concat(l, "/wc/media/").concat(d, "?type=").concat("audio" === e ? "ma" : "ms", "&cid=").concat(u, "&mode=1");

                          c.createMainSessionChannel(e, _t112), c.updateMediaParams({
                            iVType: "audio" === e ? Uo.AUDIO_DECODE : Uo.SHARING_DECODE,
                            isFromMainSession: !0,
                            updateParams: {
                              userId: r,
                              sn: bi(p),
                              confId: i,
                              encryptType: a,
                              encryptKey: bi(o),
                              meetingId: h,
                              meetingNumber: d
                            }
                          });
                          var _s17 = n.value.breakoutRoom.mainSessionAttendeeList;

                          if ((null == _s17 ? void 0 : _s17.length) > 0) {
                            var _t113 = _s17.map(function (e) {
                              return {
                                userid: e.userId,
                                sn: e.zoomID && bi(e.zoomID)
                              };
                            });

                            c.updateUserMediaSN({
                              added: _t113,
                              isFromMainSession: !0,
                              iVType: "audio" === e ? Uo.AUDIO_DECODE : Uo.SHARING_DECODE
                            });
                          }
                        }
                      });
                    }), qt(ce));
                  }(n, e, t, r, i);
                })));
              }));
            }
          });
          var Mb = Ws([function (e) {
            var t = e.breakoutRoom.controlStatus;
            return t;
          }, function (e) {
            var t = e.breakoutRoom.currentRoom.status;
            return t;
          }, function (e) {
            var t = e.breakoutRoom.currentRoom.boId;
            return t;
          }], function (e, t, n) {
            return !(e !== nc.InProgress && e !== nc.Closing || t !== ic.InRoom && t !== ic.TimeUp || !n);
          }),
              Lb = Ws([function (e) {
            var t = e.breakoutRoom.rooms;
            return t;
          }, Gs, function (e) {
            var t = e.meeting.zoomId;
            return t;
          }, function (e) {
            var t = e.breakoutRoom.mainSessionAttendeeList;
            return t;
          }, Mb, function (e) {
            var t = e.breakoutRoom.isHugeBO;
            return t;
          }], function (e, t, n, r, i, o) {
            var a = e.reduce(function (e, t) {
              var n = t.attendeeGuidList;
              return e.concat(n);
            }, []);
            return (i ? r : t).filter(function (e) {
              return !(e.bHold || e.isHost || e.zoomID === n || e.bid || a.includes(e.userGUID) || o && (t = e.caps, 4 != (4 & t)));
              var t;
            });
          });
          var Ub;
          var Bb = ua.createAgent();
          var Hb = (v((Ub = /*#__PURE__*/function (_Df6) {
            _inherits(Ub, _Df6);

            var _super9 = _createSuper(Ub);

            function Ub() {
              _classCallCheck(this, Ub);

              return _super9.apply(this, arguments);
            }

            _createClass(Ub, [{
              key: "createRooms",
              value: function createRooms(e, t) {
                var n = this[hf](),
                    r = this[_f],
                    _n$breakoutRoom6 = n.breakoutRoom,
                    i = _n$breakoutRoom6.isHugeBO,
                    o = _n$breakoutRoom6.sequenceId,
                    a = _n$breakoutRoom6.rooms,
                    s = _n$breakoutRoom6.controlStatus,
                    c = _n$breakoutRoom6.isEnableBreakoutRoom;
                if (!c) return Promise.reject({
                  type: ms,
                  reason: "Breakout room feature is not enabled."
                });
                if (s === nc.InProgress || s === nc.Closing) return Promise.resolve({
                  type: ms,
                  reason: "breakout room has started!"
                });
                var l;
                l = "string" == typeof e ? [e] : "number" == typeof e ? Array.from({
                  length: e
                }).map(function (e, t) {
                  return "".concat("Room", " ").concat(t + o);
                }) : e;
                var d = i ? 100 : 50;
                return l.length < 1 || a.length + l.length > d ? Promise.reject({
                  type: vs,
                  reason: "exceed maximum size"
                }) : (Bb.batchCreateBOToken(l), new Promise(function (e, i) {
                  Nb(l.length).subscribe(function (i) {
                    var a = i.boIdList,
                        s = a.map(function (e, t) {
                      return {
                        boId: e,
                        name: l[t]
                      };
                    });

                    if (t === tc.Automatically) {
                      var _e264 = Lb(n),
                          _t114 = s.length,
                          _r52 = _e264.length;

                      s = s.map(function (n, i) {
                        var o = [];
                        var a = i;

                        for (; a < _r52;) {
                          o.push(_e264[a]), a += _t114;
                        }

                        return f(f({}, n), {}, {
                          attendeeList: o
                        });
                      });
                    }

                    var c = s.map(function (e) {
                      var t = e.boId,
                          n = e.name,
                          r = e.attendeeList;
                      return {
                        boId: t,
                        name: n,
                        attendeeGuidList: r && r.map(function (e) {
                          return e.userGUID;
                        })
                      };
                    });

                    if (r(Rd(c)), r(Nd(t)), r(Pd(o + s.length)), t === tc.Automatically) {
                      var _t115 = s.map(function (e) {
                        return {
                          roomId: e.boId,
                          name: e.name,
                          attendeeList: e.attendeeList.map(function (e) {
                            return {
                              userId: e.userId,
                              avatar: e.avatar,
                              displayName: e.displayName
                            };
                          })
                        };
                      });

                      e(_t115);
                    } else e(s.map(function (e) {
                      return {
                        roomId: e.boId,
                        name: e.name,
                        attendeeList: []
                      };
                    }));
                  }, function () {
                    i({
                      type: "INTERNAL_ERROR"
                    });
                  });
                }));
              }
            }, {
              key: "openRooms",
              value: function openRooms(e, t) {
                var n = this[hf](),
                    r = {
                  isAutoJoinRoom: !1,
                  isBackToMainSessionEnabled: !0,
                  isTimerEnabled: !1,
                  timerDuration: 1800,
                  isTimerAutoEnabled: !1,
                  waitSeconds: 60
                },
                    _n$breakoutRoom7 = n.breakoutRoom,
                    i = _n$breakoutRoom7.controlStatus,
                    o = _n$breakoutRoom7.rooms,
                    a = _n$breakoutRoom7.sequenceId,
                    s = _n$breakoutRoom7.isHugeBO;
                if (i === nc.InProgress || i === nc.Closing) return Promise.resolve({
                  type: ms,
                  reason: "breakout room has started!"
                });
                if (e.some(function (e) {
                  return -1 === o.findIndex(function (t) {
                    return t.boId === e.roomId;
                  });
                })) return Promise.reject({
                  type: vs,
                  reason: "roomId is wrong"
                });
                var c = pc(n);
                if (e.reduce(function (e, t) {
                  return e.concat(t.attendeeList);
                }, []).some(function (e) {
                  return -1 === c.findIndex(function (t) {
                    return t.userId === e.userId;
                  });
                })) return Promise.reject({
                  type: vs,
                  reason: "bad user"
                });
                var l = e.map(function (e) {
                  var t = e.attendeeList,
                      n = t.map(function (e) {
                    var t = c.find(function (t) {
                      return t.userId === e.userId;
                    });
                    return null == t ? void 0 : t.userGUID;
                  });
                  return {
                    BID: e.roomId,
                    MeetingTitle: e.name,
                    MeetingToken: void 0,
                    Status: rc.Started,
                    HostID: "",
                    ParticipantList: n
                  };
                }),
                    d = t ? f(f({}, r), t) : r,
                    u = {
                  ControlStatus: nc.InProgress,
                  NameIndex: a,
                  IsAutoJoinEnabled: +d.isAutoJoinRoom,
                  IsBackToMainSessionEnabled: +d.isBackToMainSessionEnabled,
                  IsTimerEnabled: +d.isTimerEnabled,
                  TimerDuration: d.timerDuration,
                  IsTimerAutoEndEnabled: +d.isTimerAutoEnabled,
                  WaitSeconds: d.waitSeconds < 0 ? 0 : d.waitSeconds,
                  StartTimeOnMMR: void 0,
                  ItemList: l
                };
                var p = (h = JSON.stringify(u), fi.Base64.encode(h, !1));

                var h, _;

                return s && (_ = p, p = Base64.fromUint8Array(Sb.gzip(_))), Bb.startBO(p), Ts("BREAKOUT_ROOM_ATTRIBUTE_INDICATION", function (e) {
                  return e.controlStatus === nc.InProgress;
                });
              }
            }, {
              key: "joinRoom",
              value: function joinRoom(e) {
                var t = this[hf](),
                    n = sc(t),
                    _t$breakoutRoom2 = t.breakoutRoom,
                    r = _t$breakoutRoom2.controlStatus,
                    i = _t$breakoutRoom2.rooms,
                    o = _t$breakoutRoom2.mainSessionAttendeeList,
                    _t$breakoutRoom2$curr = _t$breakoutRoom2.currentRoom,
                    a = _t$breakoutRoom2$curr.status,
                    s = _t$breakoutRoom2$curr.boId,
                    c = t.meeting.userGUID;
                if (r !== nc.InProgress) return Promise.reject({
                  type: "IMPROPER_MEETING_STATE",
                  reason: "breakout room is not started"
                });

                if (null != n && n.isHost) {
                  var _t116 = i.find(function (t) {
                    return t.boId === e;
                  });

                  if (!_t116) return Promise.reject({
                    type: vs,
                    reason: "room id is not correct"
                  });
                  Bb.joinBO(_t116.boId);
                } else if (null != n && n.bCoHost && a === ic.InRoom) {
                  if (!i.find(function (t) {
                    return t.boId === e;
                  })) return Promise.reject({
                    type: vs,
                    reason: "room id is not correct"
                  });
                  {
                    var _t117 = o.find(function (e) {
                      return e.isHost;
                    });

                    _t117 && Bb.wantJoinBO(null == _t117 ? void 0 : _t117.userId, e);
                  }
                } else {
                  if (a === ic.InRoom && s === e) return Promise.reject({
                    type: ms,
                    reason: "You are in room"
                  });
                  {
                    var _t118 = Cb(i, c);

                    if (!_t118 || _t118.boId !== e) return Promise.reject({
                      type: vs,
                      reason: "room id is not correct"
                    });
                    Bb.joinBO(_t118.boId);
                  }
                }

                return Ts("BREAKOUT_ROOM_JOIN_BO_RESPONSE", function (t) {
                  return t.boId === e;
                });
              }
            }, {
              key: "leaveRoom",
              value: function leaveRoom() {
                var e = this[hf](),
                    t = this[_f],
                    _e$breakoutRoom = e.breakoutRoom,
                    n = _e$breakoutRoom.controlStatus,
                    r = _e$breakoutRoom.options,
                    i = _e$breakoutRoom.currentRoom.status;
                if (n !== nc.InProgress && n !== nc.Closing || i !== ic.InRoom) return Promise.reject({
                  type: ms
                });
                {
                  var _n76 = cc(e);

                  if (!r.isBackToMainSessionEnabled && !_n76) return Promise.reject({
                    type: gs,
                    reason: "can not return main session during the breakout room"
                  });
                  Ab().forEach(function (e) {
                    return t(e);
                  });
                }
                return Promise.resolve("");
              }
            }, {
              key: "askForHelp",
              value: function askForHelp() {
                var e = this[hf](),
                    _e$breakoutRoom2 = e.breakoutRoom,
                    t = _e$breakoutRoom2.controlStatus,
                    n = _e$breakoutRoom2.mainSessionAttendeeList,
                    r = _e$breakoutRoom2.currentRoom.status,
                    i = e.participants.attendeesList,
                    o = cc(e);
                if (t !== nc.InProgress || r !== ic.InRoom) return Promise.reject({
                  type: ms,
                  reason: "you are not in breakout room"
                });
                if (o) return Promise.reject({
                  type: ms,
                  reason: "host or co-host can not ask for help"
                });
                {
                  var _e265 = n.find(function (e) {
                    return e.isHost;
                  });

                  if (_e265) {
                    if (i.findIndex(function (t) {
                      return t.zoomID === _e265.zoomID;
                    }) > -1) return Promise.reject({
                      type: ms,
                      reason: "host is in room"
                    });
                    Bb.askForHelpBO(_e265.userId);
                  }
                }
                return Ts("BREAKOUT_ROOM_ASK_HELP_RESPONSE", function (e) {
                  return e.result === ac.Received;
                });
              }
            }, {
              key: "postponeHelping",
              value: function postponeHelping(e) {
                var t = this[hf](),
                    n = this[_f],
                    _t$breakoutRoom3 = t.breakoutRoom,
                    r = _t$breakoutRoom3.mainSessionAttendeeList,
                    i = _t$breakoutRoom3.currentRoom.status,
                    o = t.participants.attendeesList;
                var a = o;
                return i === ic.InRoom && (a = r), a.findIndex(function (t) {
                  return t.userId === e;
                }) > -1 ? (Bb.askForHelpResultBO(e, ac.Ignore), n(Gd(ac.Ignore)), Promise.resolve("")) : Promise.reject({
                  type: vs,
                  reason: "user id is not correct"
                });
              }
            }, {
              key: "broadcast",
              value: function broadcast(e) {
                var _this$hf2 = this[hf](),
                    t = _this$hf2.breakoutRoom.isEnableBOBroadcast;

                return t ? e ? Ko.beginEncrypt({
                  text: e,
                  type: Ho.BO_BROADCAST
                }).then(function (e) {
                  return Bb.broadcastBO(e), Promise.resolve("");
                }) : Promise.reject({
                  type: vs,
                  reason: "content empty"
                }) : Promise.reject({
                  type: ms,
                  reason: "Cannot broadcast message due to the feature is not enable"
                });
              }
            }, {
              key: "assignUserToRoom",
              value: function assignUserToRoom(e, t) {
                var n = this[hf](),
                    r = n.breakoutRoom.rooms,
                    i = Lb(n).find(function (t) {
                  return t.userId === e;
                });
                return i && r.findIndex(function (e) {
                  return e.boId === t;
                }) > -1 ? (Bb.assignToBO(e, t), Ts("BREAKOUT_ROOM_ATTRIBUTE_INDICATION", function (e) {
                  var n = e.controlStatus,
                      r = e.roomList,
                      o = r.find(function (e) {
                    return e.boId === t;
                  });
                  return n === nc.InProgress && o && o.attendeeGuidList.includes(i.userGUID);
                })) : Promise.reject({
                  type: vs,
                  reason: ""
                });
              }
            }, {
              key: "moveUserToRoom",
              value: function moveUserToRoom(e, t) {
                var n = this[hf](),
                    _n$breakoutRoom8 = n.breakoutRoom,
                    r = _n$breakoutRoom8.rooms,
                    i = _n$breakoutRoom8.mainSessionAttendeeList,
                    o = n.participants.attendeesList,
                    a = (Mb(n) ? i : o).find(function (t) {
                  return t.userId === e;
                });
                if (!a) return Promise.reject({
                  type: vs,
                  reason: "user id not correct"
                });
                {
                  var _n77 = Cb(r, a.userGUID);

                  if (!_n77) return Promise.reject({
                    type: ms,
                    reason: "user not in a room"
                  });
                  if (_n77.boId === t) return Promise.reject({
                    type: ms,
                    reason: "user already in the target room"
                  });
                  {
                    var _n78 = r.find(function (e) {
                      return e.boId === t;
                    });

                    if (!_n78) return Promise.reject({
                      type: vs,
                      reason: "invalid room id"
                    });
                    Bb.switchBO(e, _n78.boId);
                  }
                }
                return Ts("BREAKOUT_ROOM_ATTRIBUTE_INDICATION", function (e) {
                  var n = e.controlStatus,
                      r = e.roomList,
                      i = r.find(function (e) {
                    return e.boId === t;
                  });
                  return n === nc.InProgress && i && i.attendeeGuidList.includes(a.userGUID);
                });
              }
            }, {
              key: "closeRoom",
              value: function closeRoom() {
                var e = this[hf](),
                    t = e.breakoutRoom.controlStatus;
                return t !== nc.InProgress ? Promise.reject({
                  type: ms,
                  reason: "room is not started"
                }) : (Bb.stopBO(nc.Closing), Ts("BREAKOUT_ROOM_ATTRIBUTE_INDICATION", function (e) {
                  return e.controlStatus === nc.Closing;
                }));
              }
            }, {
              key: "loadPreAssignedRooms",
              value: function loadPreAssignedRooms() {
                var e = this[hf](),
                    t = e.meeting.meetingOptions,
                    n = e.breakoutRoom.controlStatus;
                return !t.isAllowBreakoutRoomPreAssign || n !== nc.NotStarted && n !== nc.Closed ? Promise.reject({
                  type: ms
                }) : (Bb.preAssignBreakoutRoom(), Ts("BREAKOUT_ROOM_LOAD_PRE_ASSIGNED_ROOMS"));
              }
            }, {
              key: "getUnassignedAttendeeList",
              value: function getUnassignedAttendeeList() {
                var e = this[hf](),
                    t = e.meeting.isHost;
                return t ? Lb(e) : [];
              }
            }, {
              key: "getRoomList",
              value: function getRoomList() {
                var e = this[hf](),
                    _e$breakoutRoom3 = e.breakoutRoom,
                    t = _e$breakoutRoom3.rooms,
                    _e$breakoutRoom3$curr = _e$breakoutRoom3.currentRoom,
                    n = _e$breakoutRoom3$curr.status,
                    r = _e$breakoutRoom3$curr.boId,
                    i = _e$breakoutRoom3.mainSessionAttendeeList,
                    o = e.participants.attendeesList,
                    a = sc(e);

                if (a && (a.isHost || n === ic.InRoom && a.bCoHost)) {
                  var _e266 = n === ic.InRoom,
                      _s18 = _e266 ? i : o;

                  return t.map(function (t) {
                    var n = t.attendeeGuidList,
                        i = t.boId,
                        o = t.name,
                        c = (n || []).map(function (e) {
                      return _s18.find(function (t) {
                        return t.userGUID === e;
                      });
                    }).filter(function (e) {
                      return !!e && e.userGUID !== a.userGUID;
                    });
                    return _e266 && a.isHost && i === r && c.unshift(a), {
                      roomId: i,
                      name: o,
                      attendeeList: c.filter(function (e) {
                        return !!e;
                      }).map(function (e) {
                        return {
                          userId: e.userId,
                          displayName: e.displayName,
                          avatar: e.avatar,
                          isInRoom: e.bid === i
                        };
                      })
                    };
                  });
                }

                return e.breakoutRoom.rooms.map(function (e) {
                  var t = e.boId,
                      n = e.name;
                  return {
                    roomId: t,
                    name: n,
                    attendeeList: []
                  };
                });
              }
            }, {
              key: "getAttendeeStatus",
              value: function getAttendeeStatus() {
                return this[hf]().breakoutRoom.currentRoom.status;
              }
            }, {
              key: "getRoomStatus",
              value: function getRoomStatus() {
                return this[hf]().breakoutRoom.controlStatus;
              }
            }, {
              key: "getCurrentRoom",
              value: function getCurrentRoom() {
                var e = this[hf](),
                    _e$breakoutRoom$curre = e.breakoutRoom.currentRoom,
                    t = _e$breakoutRoom$curre.status,
                    n = _e$breakoutRoom$curre.name,
                    r = _e$breakoutRoom$curre.boId;
                return {
                  attendeeStatus: t,
                  name: n,
                  roomId: r
                };
              }
            }, {
              key: "getRoomOptions",
              value: function getRoomOptions() {
                var e = this[hf](),
                    t = e.breakoutRoom.options;
                return f({}, t);
              }
            }]);

            return Ub;
          }(Df)).prototype, "createRooms", [gf, yf], Object.getOwnPropertyDescriptor(Ub.prototype, "createRooms"), Ub.prototype), v(Ub.prototype, "openRooms", [gf, yf], Object.getOwnPropertyDescriptor(Ub.prototype, "openRooms"), Ub.prototype), v(Ub.prototype, "joinRoom", [gf], Object.getOwnPropertyDescriptor(Ub.prototype, "joinRoom"), Ub.prototype), v(Ub.prototype, "leaveRoom", [gf], Object.getOwnPropertyDescriptor(Ub.prototype, "leaveRoom"), Ub.prototype), v(Ub.prototype, "askForHelp", [gf], Object.getOwnPropertyDescriptor(Ub.prototype, "askForHelp"), Ub.prototype), v(Ub.prototype, "postponeHelping", [yf, gf], Object.getOwnPropertyDescriptor(Ub.prototype, "postponeHelping"), Ub.prototype), v(Ub.prototype, "broadcast", [yf, gf], Object.getOwnPropertyDescriptor(Ub.prototype, "broadcast"), Ub.prototype), v(Ub.prototype, "assignUserToRoom", [yf, gf], Object.getOwnPropertyDescriptor(Ub.prototype, "assignUserToRoom"), Ub.prototype), v(Ub.prototype, "moveUserToRoom", [yf, gf], Object.getOwnPropertyDescriptor(Ub.prototype, "moveUserToRoom"), Ub.prototype), v(Ub.prototype, "closeRoom", [yf, gf], Object.getOwnPropertyDescriptor(Ub.prototype, "closeRoom"), Ub.prototype), v(Ub.prototype, "loadPreAssignedRooms", [yf, gf], Object.getOwnPropertyDescriptor(Ub.prototype, "loadPreAssignedRooms"), Ub.prototype), Ub);
          var Vb = Hr(jb, zb);
          var qb = Object.freeze({
            __proto__: null,
            updateArchivingStatus: function updateArchivingStatus(e, t) {
              return Vr(e, 7961).pipe(ln(t), Je(function (e) {
                var _e267 = _slicedToArray(e, 2),
                    t = _e267[0],
                    n = _e267[1];

                var _t$payload$body15 = t.payload.body,
                    r = _t$payload$body15.status,
                    i = _t$payload$body15.sessionReady,
                    o = n.meeting.isOnHold,
                    a = n.archiving.status,
                    s = n.breakoutRoom,
                    c = [],
                    l = (null == s ? void 0 : s.currentRoom.status) === ic.InRoom;
                return o || l || r === a || (c.push(cu(r)), As("ARCHIVING_STATUS_UPDATE", {
                  status: r,
                  sessionReady: i
                })), c.push(lu(i)), Ke(c);
              }));
            },
            updateArchivingOptions: function updateArchivingOptions(e) {
              return Vr(e, 7962).pipe(Me(function (e) {
                var _e$payload$body17 = e.payload.body,
                    t = _e$payload$body17.options,
                    n = _e$payload$body17.DisclaimerPrivacy,
                    r = _e$payload$body17.ConsentDisabled,
                    i = _e$payload$body17.VoiceDisabled,
                    _ref18 = function (e) {
                  var t = !!(1 & e),
                      n = t && !(32 & e);
                  return {
                    isEnabled: t,
                    isVideoArchiveEnabled: t && !!(8 & e),
                    isAudioArchiveEnabled: t && !(16 & e),
                    isChatArchiveEnabled: n,
                    isPrivateChatArchiveEnabled: n && !(2 & e),
                    isCCArchiveEnabled: t && !!(16777216 & e),
                    isUserCanStay: !(67108864 & e),
                    isMeetingChatDisabledWhenArchiveFail: t && !!(512 & e)
                  };
                }(t),
                    o = _ref18.isEnabled,
                    a = _ref18.isVideoArchiveEnabled,
                    s = _ref18.isAudioArchiveEnabled,
                    c = _ref18.isChatArchiveEnabled,
                    l = _ref18.isPrivateChatArchiveEnabled,
                    d = _ref18.isCCArchiveEnabled,
                    u = _ref18.isUserCanStay,
                    p = _ref18.isMeetingChatDisabledWhenArchiveFail,
                    h = a || s,
                    _ = {
                  isEnabled: o,
                  isVideoArchiveEnabled: a,
                  isAudioArchiveEnabled: s,
                  isChatArchiveEnabled: c,
                  isPrivateChatArchiveEnabled: l,
                  isCCArchiveEnabled: d,
                  isUserCanStay: u,
                  isMeetingChatDisabledWhenArchiveFail: p,
                  showArchivingNotice: h && !r,
                  promptArchiveVoice: h && !i,
                  disclaimerPrivacy: n
                };

                return As("ARCHIVING_OPTIONS_UPDATE", {
                  archivingOptions: _
                }), du(_);
              }));
            }
          });
          var Fb;
          !function (e) {
            e[e.Success = 1] = "Success", e[e.Fail = 0] = "Fail";
          }(Fb || (Fb = {}));
          var Wb = {
            status: null,
            sessionReady: null,
            archivingOptions: null
          },
              Gb = ur((_ur13 = {}, _defineProperty(_ur13, "".concat(cu), Hp(function (e, t) {
            var n = t.payload;
            e.status = n;
          })), _defineProperty(_ur13, "".concat(lu), Hp(function (e, t) {
            var n = t.payload;
            e.sessionReady = n;
          })), _defineProperty(_ur13, "".concat(du), Hp(function (e, t) {
            var n = t.payload;
            e.archivingOptions = n;
          })), _defineProperty(_ur13, "".concat(uu), function () {
            return f({}, Wb);
          }), _ur13), Wb),
              Kb = {
            closedCaption: {
              epic: rg,
              reducer: Jm,
              Client: ng
            },
            chat: {
              epic: hg,
              reducer: ag,
              Client: pg
            },
            recording: {
              epic: xg,
              reducer: mg,
              Client: Sg
            },
            QA: {
              epic: Ng,
              reducer: Ag,
              Client: Rg
            },
            breakoutRoom: {
              epic: Vb,
              reducer: jg,
              Client: Hb
            },
            archiving: {
              epic: Hr(qb),
              reducer: Gb,
              Client: /*#__PURE__*/function (_Df7) {
                _inherits(Client, _Df7);

                var _super10 = _createSuper(Client);

                function Client() {
                  _classCallCheck(this, Client);

                  return _super10.apply(this, arguments);
                }

                return Client;
              }(Df)
            }
          };
          var Qb, Zb, Yb, Jb;
          var $b = ua.createAgent();
          var Xb = (Qb = kf(Cf.Other), Zb = kf(Cf.Other), Yb = kf(Cf.Other), v((Jb = /*#__PURE__*/function (_Df8) {
            _inherits(Jb, _Df8);

            var _super11 = _createSuper(Jb);

            function Jb(e) {
              var _this13;

              _classCallCheck(this, Jb);

              _this13 = _super11.call(this, e), _this13.modules = void 0, _this13.useSDK = void 0, _this13.useSDK = !1, _this13.modules = new Map();
              return _this13;
            }

            _createClass(Jb, [{
              key: "initWithSDK",
              value: function initWithSDK(e, t, n) {
                return this.useSDK = !0, this.init(e, t, n);
              }
            }, {
              key: "init",
              value: function init(e, t, n) {
                var _this14 = this;

                var r = this[_f],
                    i = this[pf];
                var o = Tu,
                    a = (null == n ? void 0 : n.fileWithVersion) || !1,
                    s = "en-US",
                    c = "".concat(Tu, "/").concat("1501_js_media.min.js");

                if (n) {
                  var _e268 = n.dependentAssets,
                      _t119 = n.additionalFeatures,
                      _r53 = n.constraints,
                      _l11 = n.language,
                      _d9 = n.webEndpoint;
                  if (_l11 && (s = _l11), _d9 && function (e) {
                    ku = function (e, t) {
                      var n = e;
                      /^https?:\/\//.test(n) || (n = "https://".concat(e));

                      try {
                        var _e269 = new URL(n);

                        if (!t) return _e269.href;
                        if (t.hostname) return _e269.hostname;
                        if (t.path) return _e269.pathname;
                      } catch (e) {
                        return "";
                      }

                      return "";
                    }(e, {
                      hostname: !0
                    }), Au = "zoomdev.us" === ku || "zoomdev.com.cn" === ku || "deva.zoomdev.us" === ku || "local.zoom.us" === ku ? "devapps.zoomdev.us" : "devep.zoomdev.us" === ku ? "devepapps.zoomdev.us" : "applications.zoom.us";
                  }(_d9), _e268 === _o.CDN || _e268 === Iu) o = Iu, c = "".concat(Iu, "/").concat("1501_js_media.min.js"), a = !0;else if (_e268 === _o.Global || _e268 === Tu) o = Tu, c = "".concat(Tu, "/").concat("1501_js_media.min.js"), a = !0;else if (_e268 === _o.CN || _e268 === Ou) o = Ou, c = "".concat(Ou, "/").concat("1501_js_media.min.js"), a = !0;else if (_e268 && /^https?:\/\//.test(_e268)) {
                    var _t120 = _e268;
                    "/" === _t120[_t120.length - 1] && (_t120 = _t120.slice(0, length - 2)), o = _t120, c = a ? "".concat(_t120, "/").concat("1501_js_media.min.js") : "".concat(_t120, "/").concat("js_media.min.js");
                  }
                  _t119 && Array.isArray(_t119) && _t119.forEach(function (e) {
                    if (_this14[ff][e] && void 0 === i.getState()[e]) {
                      var _this14$ff$e = _this14[ff][e],
                          _t121 = _this14$ff$e.epic,
                          _n79 = _this14$ff$e.reducer,
                          _r54 = _this14$ff$e.Client;
                      i.injectReducer(e, _n79), i.injectEpic(_t121);

                      var _o16 = new _r54(i);

                      _this14.modules.set(e, _o16);
                    }
                  }), null != _r53 && _r53.audio && void 0 === i.getState().audio && (i.injectReducer("audio", z_), i.injectEpic(M_)), null != _r53 && _r53.video && void 0 === i.getState().video && (i.injectReducer("video", Y_), i.injectEpic(J_)), null != _r53 && _r53.screen && void 0 === i.getState().share && (i.injectReducer("share", qp), i.injectEpic(Fp));
                }

                return r(Mi({
                  apiKey: e,
                  signature: t,
                  language: s,
                  useSDK: this.useSDK
                })), r(zr({
                  mediaConstraints: n && n.constraints || {},
                  assetsPath: o,
                  fileWithVersion: a,
                  enforceMultipleVideos: null == n ? void 0 : n.enforceMultipleVideos
                })), void 0 !== (null == n ? void 0 : n.stayAwake) && r(lo(n.stayAwake)), new Promise(function (e, t) {
                  null != n && n.skipJsMedia ? e("") : function (e, t, n) {
                    var r = document.createElement("script");
                    r.type = "text/javascript", r.readyState ? r.onreadystatechange = function () {
                      "loaded" !== r.readyState && "complete" !== r.readyState || (r.onreadystatechange = null, t());
                    } : (r.onload = function () {
                      t();
                    }, r.onerror = function () {
                      n();
                    }), r.src = e, "function" == typeof document.body.append ? document.getElementsByTagName("head")[0].append(r) : document.getElementsByTagName("head")[0].appendChild(r);
                  }(c, function () {
                    e("");
                  }, function () {
                    t({
                      type: vs,
                      reason: "dependent assets are not accessible"
                    });
                  });
                });
              }
            }, {
              key: "on",
              value: function on(e, t) {
                (function (e, t) {
                  var n = xs[e];

                  if (n) {
                    var r = Cs.get(e);
                    if (r) r.push(t), Cs.set(e, r);else {
                      var _r55 = [t];
                      Cs.set(e, _r55);
                      var i = dt.apply(void 0, _toConsumableArray(n.map(function (e) {
                        var t = e.event,
                            n = e.payload;
                        return ot(Es, t).pipe(Me(function (e) {
                          return n(e);
                        }), be(Oe));
                      }))).subscribe(function (t) {
                        var n = Cs.get(e);
                        n && n.forEach(function (e) {
                          e(t);
                        });
                      });
                      ks.push(i);
                    }
                  }
                })(e, t);
              }
            }, {
              key: "off",
              value: function off(e, t) {
                (function (e, t) {
                  if (xs[e]) {
                    var _n80 = Cs.get(e);

                    if (Array.isArray(_n80)) {
                      var r = _n80.filter(function (e) {
                        return e !== t;
                      });

                      Cs.set(e, r);
                    }
                  }
                })(e, t);
              }
            }, {
              key: "getFeatureModule",
              value: function getFeatureModule(e) {
                return this.modules.get(e);
              }
            }, {
              key: "leave",
              value: function leave() {
                var e = this[hf],
                    t = this[_f];
                return "connected" === e().socket.zoomSocketStatus ? (t(Ni()), bt(500).pipe(Mt("")).toPromise()) : Promise.resolve("");
              }
            }, {
              key: "end",
              value: function end() {
                var e = this[hf],
                    t = this[_f];
                return "connected" === e().socket.zoomSocketStatus ? (t(Pi()), bt(500).pipe(nn(function () {
                  Rs();
                }), Mt("")).toPromise()) : Promise.resolve("");
              }
            }, {
              key: "changeName",
              value: function changeName(e, t) {
                var n = this[pf].getState(),
                    r = n.meeting.bAllowAttendeeRename,
                    i = sc(n),
                    o = ec(i.userRole),
                    a = cc(n);
                if (o) return Promise.reject({
                  type: gs
                });

                if (t && t !== (null == i ? void 0 : i.userId)) {
                  if (a) {
                    var _r56 = n.participants.attendeesList,
                        _i27 = _r56.find(function (e) {
                      return e.userId === t;
                    });

                    if (_i27) return $b.rename(t, mi(e), mi(_i27.displayName)), _u(t, function (t) {
                      return t.displayName === e;
                    });
                    {
                      var _r57 = dc(n).find(function (e) {
                        return e.userId === t;
                      });

                      if (_r57) {
                        var _t122 = th.getInstance();

                        return $b.rename(_r57.userId, mi(e), mi(_r57.displayName)), _t122.rename(_r57.jid, e), Ts("UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", function (t) {
                          var n = t.find(function (e) {
                            return e.jid === _r57.jid;
                          });
                          return n && n.displayName === e;
                        });
                      }

                      return Promise.reject({
                        type: vs,
                        reason: "no matching user"
                      });
                    }
                  }

                  return Promise.reject({
                    type: gs
                  });
                }

                return e === i.displayName ? Promise.resolve() : a || r ? ($b.rename(i.userId, mi(e), mi(i.displayName)), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (t) {
                  return t.displayName === e;
                })) : Promise.reject({
                  type: gs,
                  reason: "host disallow rename themselves"
                });
              }
            }, {
              key: "makeHost",
              value: function makeHost(e) {
                return $b.assignHost(e, !1), _u(e, function (e) {
                  return !0 === e.isHost;
                });
              }
            }, {
              key: "makeCoHost",
              value: function makeCoHost(e) {
                var t = this[pf].getState(),
                    n = pc(t).find(function (t) {
                  return t.userId === e;
                });
                return !0 === (null == n ? void 0 : n.bCoHost) ? Promise.reject({
                  type: vs,
                  reason: "user:[".concat(e, "] is already co-host ")
                }) : ($b.assignHost(e, !0), _u(e, function (e) {
                  return !0 === e.bCoHost;
                }));
              }
            }, {
              key: "revokeCoHost",
              value: function revokeCoHost(e) {
                var t = this[pf].getState(),
                    n = pc(t).find(function (t) {
                  return t.userId === e;
                });
                return !1 === (null == n ? void 0 : n.bCoHost) ? Promise.reject({
                  type: vs,
                  reason: "user:[".concat(e, "] is not a co-host")
                }) : ($b.revokeCoHost(e), _u(e, function (e) {
                  return !1 === e.bCoHost;
                }));
              }
            }, {
              key: "isHost",
              value: function isHost() {
                var e = this[pf].getState(),
                    t = sc(e);
                return !!t && t.isHost;
              }
            }, {
              key: "isCoHost",
              value: function isCoHost() {
                var e = this[pf].getState(),
                    t = sc(e);
                return !!t && !!t.bCoHost;
              }
            }, {
              key: "isOriginHost",
              value: function isOriginHost() {
                var _this$hf3 = this[hf](),
                    e = _this$hf3.meeting.isOriginHost;

                return e;
              }
            }, {
              key: "getCurrentUserInfo",
              value: function getCurrentUserInfo() {
                var e = this[pf].getState(),
                    t = sc(e);

                if (t) {
                  var _n81 = {
                    userId: t.userId,
                    displayName: t.displayName,
                    audio: t.audio,
                    muted: t.muted,
                    isHost: t.isHost,
                    isCoHost: t.bCoHost,
                    isGuest: t.bGuest,
                    avatar: t.avatar,
                    isPhoneUser: $s(t.userType),
                    bRaiseHand: t.bRaiseHand,
                    bHold: t.bHold,
                    bVideoOn: t.bVideoOn,
                    sharerOn: t.sharerOn,
                    sharePause: t.sharerPause,
                    feedback: t.feedback,
                    caps: t.caps
                  };

                  if (e.meeting.isWebinar && ec(t.userRole)) {
                    var _t123 = e.audio,
                        r = null == _t123 ? void 0 : _t123.isAllowToTalk;
                    Object.assign(_n81, {
                      isAllowToTalk: r
                    });
                  }

                  return _n81;
                }

                return null;
              }
            }, {
              key: "getParticipantsList",
              value: function getParticipantsList() {
                var e = this[pf].getState(),
                    t = e.meeting.meetingStatus,
                    n = sc(e);
                return t === go.Joined && n && !n.bHold ? pc(e).map(function (e) {
                  return {
                    userId: e.userId,
                    displayName: e.displayName,
                    audio: e.audio,
                    muted: e.muted,
                    isHost: e.isHost,
                    isCoHost: e.bCoHost,
                    isGuest: e.bGuest,
                    avatar: e.avatar,
                    isPhoneUser: $s(e.userType),
                    bRaiseHand: e.bRaiseHand,
                    bHold: e.bHold,
                    bVideoOn: e.bVideoOn,
                    sharerOn: e.sharerOn,
                    sharePause: e.sharerPause,
                    feedback: e.feedback,
                    bLocalRecord: e.bLocalRecord,
                    strPronoun: e.strPronoun,
                    sdkKey: e.sdkKey,
                    audioConnectionStatus: e.audioConnectionStatus,
                    caps: e.caps
                  };
                }) : [];
              }
            }, {
              key: "getAssistantsList",
              value: function getAssistantsList() {
                var e = this[pf].getState(),
                    t = e.meeting.meetingStatus,
                    n = sc(e);
                return t === go.Joined && n ? hc(e).map(function (e) {
                  return {
                    userId: e.userId,
                    displayName: e.displayName,
                    isNewAst: !0
                  };
                }) : [];
              }
            }, {
              key: "getMeetingHost",
              value: function getMeetingHost() {
                var e;
                var t = this[hf]();

                var n = _c(t);

                return n || (null === (e = t.breakoutRoom) || void 0 === e ? void 0 : e.currentRoom.status) !== ic.InRoom || (n = t.breakoutRoom.mainSessionAttendeeList.find(function (e) {
                  return e.isHost;
                })), n ? {
                  userId: n.userId,
                  displayName: n.displayName,
                  audio: n.audio,
                  muted: n.muted,
                  isHost: n.isHost,
                  isCoHost: n.bCoHost,
                  avatar: n.avatar,
                  isPhoneUser: $s(n.userType),
                  bRaiseHand: n.bRaiseHand,
                  bHold: n.bHold,
                  bVideoOn: n.bVideoOn,
                  sharerOn: n.sharerOn,
                  feedback: n.feedback
                } : null;
              }
            }, {
              key: "getMeetingInfo",
              value: function getMeetingInfo() {
                var _this$hf4 = this[hf](),
                    _this$hf4$meeting = _this$hf4.meeting,
                    e = _this$hf4$meeting.meetingStatus,
                    t = _this$hf4$meeting.isOnHold,
                    n = _this$hf4$meeting.meetingNumber,
                    r = _this$hf4$meeting.passWord,
                    i = _this$hf4$meeting.userName,
                    o = _this$hf4$meeting.userEmail,
                    a = _this$hf4$meeting.meetingTopic,
                    s = _this$hf4$meeting.meetingOptions,
                    c = _this$hf4$meeting.encType,
                    l = _this$hf4$meeting.region,
                    d = _this$hf4$meeting.network,
                    u = _this$hf4$meeting.topic,
                    p = _this$hf4$meeting.zlkJwtToken,
                    h = _this$hf4$meeting.userId,
                    _ = _this$hf4$meeting.lang,
                    f = _this$hf4$meeting.inviteEmail,
                    m = _this$hf4$meeting.meetingId,
                    g = _this$hf4$meeting.participantID,
                    v = _this$hf4$meeting.h323Password,
                    b = _this$hf4$meeting.recordingDisclaimer,
                    y = _this$hf4$meeting.recordingDisclaimerForRecorder,
                    w = _this$hf4$meeting.wrInfo,
                    S = e === go.Joined && !t;

                if (p) return {
                  topic: u,
                  password: r,
                  userName: i,
                  isInMeeting: S,
                  userId: h,
                  meetingId: m
                };
                {
                  var _e270 = "";
                  return 0 === c ? _e270 = "None" : 1 === c ? _e270 = "AES ECB" : 2 === c && (_e270 = "AES GCM"), {
                    meetingNumber: n,
                    password: r,
                    userName: i,
                    userEmail: o,
                    inviteEmail: f,
                    meetingTopic: a,
                    encryptionType: _e270,
                    region: l,
                    network: d,
                    isInMeeting: S,
                    userId: h,
                    lang: _,
                    webEndpoint: ku,
                    meetingId: m,
                    participantId: g,
                    telPwd: v,
                    recordingInfo: {
                      recordingDisclaimer: b,
                      recordingDisclaimerForRecorder: y,
                      isUserEnableRecordingReminder: null == s ? void 0 : s.isUserEnableRecordingReminder
                    },
                    wrInfo: w
                  };
                }
              }
            }]);

            return Jb;
          }(Df)).prototype, "end", [yf, gf], Object.getOwnPropertyDescriptor(Jb.prototype, "end"), Jb.prototype), v(Jb.prototype, "changeName", [gf], Object.getOwnPropertyDescriptor(Jb.prototype, "changeName"), Jb.prototype), v(Jb.prototype, "makeHost", [Qb, yf, gf], Object.getOwnPropertyDescriptor(Jb.prototype, "makeHost"), Jb.prototype), v(Jb.prototype, "makeCoHost", [Zb, yf, gf], Object.getOwnPropertyDescriptor(Jb.prototype, "makeCoHost"), Jb.prototype), v(Jb.prototype, "revokeCoHost", [Yb, yf, gf], Object.getOwnPropertyDescriptor(Jb.prototype, "revokeCoHost"), Jb.prototype), Jb);
          var ey, ty, ny, ry, iy, oy;
          var ay = ua.createAgent();
          var sy = (ey = kf(Cf.Other), ty = kf(Cf.Attendee), ny = kf(Cf.Other), ry = Ef("isWaitingRoomLocked"), iy = Ef("allowParticipantsRenameLocked"), v((oy = /*#__PURE__*/function (_Xb) {
            _inherits(oy, _Xb);

            var _super12 = _createSuper(oy);

            function oy(e) {
              var _this15;

              _classCallCheck(this, oy);

              _this15 = _super12.call(this, e), _this15.mediaStream = void 0, _this15[ff] = Kb;
              return _this15;
            }

            _createClass(oy, [{
              key: "getMediaStream",
              value: function getMediaStream() {
                return void 0 === this.mediaStream && (this.mediaStream = new Km(this[pf])), this.mediaStream;
              }
            }, {
              key: "join",
              value: function join(e, t, n, r, i, o, a) {
                var s = this[hf],
                    c = this[_f],
                    _s19 = s(),
                    _s19$meeting = _s19.meeting,
                    l = _s19$meeting.apiKey,
                    d = _s19$meeting.signatureType,
                    u = _s19$meeting.signature,
                    p = _s19$meeting.lang,
                    h = _s19$meeting.meetingStatus,
                    _ = _s19$meeting.ztk,
                    f = _s19$meeting.zsk,
                    m = _s19.socket.zoomSocketStatus;

                if (l && u) {
                  if (h !== go.Joined && m === bc.Closed) {
                    var _s20 = {
                      apiKey: l,
                      signatureType: d,
                      signature: u,
                      meetingNumber: e,
                      userName: t,
                      lang: p,
                      passWord: n,
                      userEmail: r,
                      customerKey: i ? null == i ? void 0 : i.substring(0, 36) : "",
                      sdkUrl: mi("".concat(location.origin).concat(location.pathname)),
                      sdkOrigin: mi(location.origin),
                      proxy: 1,
                      ulsm: 0,
                      cv: "2.8.0"
                    };
                    o && sessionStorage.setItem(Vo.WebclientTk, o);

                    var _h7 = sessionStorage.getItem(Vo.WebclientTk);

                    _h7 && Object.assign(_s20, {
                      tk: _h7
                    });

                    var _m5 = sessionStorage.getItem(Vo.WebclientZtk) || _;

                    _m5 && Object.assign(_s20, {
                      ztk: _m5
                    });

                    var _g4 = a || f;

                    return _g4 && (Object.assign(_s20, {
                      zsk: _g4,
                      ulsm: 1
                    }), c(Ui(_g4)), sessionStorage.setItem(Vo.WebclientZsk, _g4)), c(Ci(_s20)), Is(ba.JoinMeeting);
                  }

                  return Promise.reject({
                    type: ms,
                    reason: "Duplicated join operation"
                  });
                }

                return Promise.reject({
                  type: ms,
                  reason: "Invalid apiKey/sdkKey and/or signature"
                });
              }
            }, {
              key: "lockMeeting",
              value: function lockMeeting() {
                var _this$pf$getState = this[pf].getState(),
                    e = _this$pf$getState.meeting.bLock;

                return !0 === e ? Promise.resolve("") : (ay.lockMeeting(!0), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                  return !0 === e.bLock;
                }));
              }
            }, {
              key: "unlockMeeting",
              value: function unlockMeeting() {
                var _this$pf$getState2 = this[pf].getState(),
                    e = _this$pf$getState2.meeting.bLock;

                return !1 === e ? Promise.resolve("") : (ay.lockMeeting(!1), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                  return !1 === e.bLock;
                }));
              }
            }, {
              key: "removeUser",
              value: function removeUser(e) {
                var t = this[pf].getState(),
                    n = t.participants.attendeesList;
                if (n.find(function (t) {
                  return t.userId === e;
                })) return ay.expel(e), Ts("REMOVE_USER_PARTICIPANT_ATTRIBUTE", function (t) {
                  return t.some(function (t) {
                    return t.userId === e;
                  });
                });
                {
                  var _n82 = dc(t).find(function (t) {
                    return t.userId === e;
                  });

                  return _n82 ? (ay.expelAttendee(_n82.jid), Ts("REMOVE_WEBINAR_ATTENDEE_ATTRIBUTE", function (e) {
                    return -1 !== e.findIndex(function (e) {
                      return e.jid === _n82.jid && !0 === e.removed;
                    });
                  })) : Promise.reject({
                    type: vs,
                    reason: "no matched user"
                  });
                }
              }
            }, {
              key: "admit",
              value: function admit(e) {
                var t = this[pf].getState();
                return uc(t).find(function (t) {
                  return t.userId === e;
                }) ? (ay.putOnHold(e, !1), Ts("REMOVE_USER_PARTICIPANT_ATTRIBUTE", function (t) {
                  return t.some(function (t) {
                    return t.userId === e && 1 === t.nUserStatus;
                  });
                })) : Promise.reject({
                  type: vs,
                  reason: "no matching user"
                });
              }
            }, {
              key: "admitAll",
              value: function admitAll() {
                var _this$pf$getState3 = this[pf].getState(),
                    e = _this$pf$getState3.participants.isAdmitAllSilentUsers;

                return !0 === e ? Promise.reject({
                  type: ms,
                  reason: "already admit all"
                }) : (ay.admitAllSilentUsers(), new Promise(function (e) {
                  mt(Os("ADMIT_ALL_SILENT_USERS_END", 1).pipe(Mt("")), Os("MEETING_HOST_CHANGE_INDICATION", 1).pipe(Me(function (e) {
                    return !1 === e ? "host changed" : "";
                  })), Os("MEETING_COHOST_CHANGE_INDICATION", 1).pipe(Me(function (e) {
                    return !1 === e ? "co-host changed" : "";
                  }))).subscribe(function (t) {
                    return e(t);
                  });
                }));
              }
            }, {
              key: "putOnHold",
              value: function putOnHold(e) {
                return ay.putOnHold(e, !0), _u(e, function (e) {
                  return !0 === e.bHold;
                });
              }
            }, {
              key: "promoteToPanelist",
              value: function promoteToPanelist(e) {
                var t = dc(this[pf].getState()).find(function (t) {
                  return t.userId === e;
                });
                return ay.roleChangeWebinar(!0, t.jid, t.userId, t.clientCap), Ts("MEETING_WEBINAR_ROLE_CHANGE", function (e) {
                  return 0 === e.ret && e.jid === (null == t ? void 0 : t.jid) && !0 === e.bPromote;
                });
              }
            }, {
              key: "givePromoteConsent",
              value: function givePromoteConsent(e, t) {
                return ay.sendPromoteConsent(e, t), Promise.resolve("");
              }
            }, {
              key: "changeToAttendee",
              value: function changeToAttendee(e) {
                var t = this[pf].getState(),
                    n = pc(t).find(function (t) {
                  return t.userId === e;
                });
                if (null != n && n.isHost || null != n && n.bCoHost) return Promise.reject({
                  type: vs,
                  reason: "can not change host or co-host to attendee"
                });
                var r = t.participants.xmppAttendeeList.find(function (t) {
                  return t.userId === e;
                });
                return ay.roleChangeWebinar(!1, r.jid, r.userId, r.clientCap), Ts("MEETING_WEBINAR_ROLE_CHANGE", function (e) {
                  return 0 === e.ret && e.jid === (null == r ? void 0 : r.jid) && !1 === e.bPromote;
                });
              }
            }, {
              key: "raiseOrLowerHand",
              value: function raiseOrLowerHand(e) {
                var t = this[pf].getState(),
                    _t$meeting5 = t.meeting,
                    n = _t$meeting5.bAllowRaiseHand,
                    r = _t$meeting5.userId,
                    i = _t$meeting5.isWebinar;

                if (n) {
                  var _n83 = sc(t);

                  if (i && ec(_n83.userRole)) {
                    var _n84 = dc(t).find(function (e) {
                      return e.userId === r;
                    });

                    if ((null == _n84 ? void 0 : _n84.bRaiseHand) !== e) {
                      var _t124 = th.getInstance();

                      return e ? _t124.raiseHand() : _t124.lowerHand(), Ts("MEETING_WEBINAR_ATTENDEE_RAISE_HAND", function (t) {
                        return t.bRaiseHand === e;
                      });
                    }

                    return Promise.resolve("");
                  }

                  return cc(t) ? Promise.reject({
                    type: ms,
                    reason: "host or co-host can not raise or lower hand"
                  }) : (null == _n83 ? void 0 : _n83.bRaiseHand) !== e ? (ay.raiseLowerHand(_n83.userId, e), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (t) {
                    return t.bRaiseHand === e;
                  })) : Promise.resolve("");
                }

                return Promise.reject({
                  type: gs,
                  reason: "host disallow raise or lower hand"
                });
              }
            }, {
              key: "raiseHand",
              value: function raiseHand() {
                return this.raiseOrLowerHand(!0);
              }
            }, {
              key: "lowerHand",
              value: function lowerHand() {
                return this.raiseOrLowerHand(!1);
              }
            }, {
              key: "putDownHand",
              value: function putDownHand(e) {
                var t = this[pf].getState(),
                    n = t.meeting.isWebinar;

                if (n) {
                  var _n85 = dc(t),
                      r = Array.isArray(e) ? e : [e],
                      i = _n85.filter(function (e) {
                    return r.includes(e.userId) && !0 === e.bRaiseHand;
                  }).map(function (e) {
                    return e.jid;
                  });

                  if (i && i.length > 0) return th.getInstance().lowerHand(i), Ts("UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", function (e) {
                    return i.includes(e.jid) && !1 === e.bRaiseHand;
                  });
                } else {
                  var _n86 = Array.isArray(e) ? e[0] : e,
                      _r58 = pc(t).find(function (e) {
                    return e.userId === _n86;
                  });

                  if (_r58 && !0 === _r58.bRaiseHand) return ay.raiseLowerHand(_n86, !1), _u(_n86, function (e) {
                    return !1 === e.bRaiseHand;
                  });
                }

                return Promise.reject({
                  type: vs,
                  reason: "no matching user"
                });
              }
            }, {
              key: "sendNonverbalFeedback",
              value: function sendNonverbalFeedback(e) {
                var t = sc(this[pf].getState());
                var n = e;
                return t.feedback === e && (n = uo.None), ay.sendFeedback(n), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (e) {
                  return e.feedback === n;
                });
              }
            }, {
              key: "clearNonverbalFeedback",
              value: function clearNonverbalFeedback() {
                return ay.clearFeedback(), Promise.resolve("");
              }
            }, {
              key: "lowerAllHands",
              value: function lowerAllHands() {
                return ay.lowerAllHands(), Promise.resolve("");
              }
            }, {
              key: "enableWaitingRoom",
              value: function enableWaitingRoom() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];

                var _this$pf$getState4 = this[pf].getState(),
                    t = _this$pf$getState4.meeting.bHoldUponEntry;

                return t === e ? Promise.resolve("") : (ay.setHoldOnEntry(e), Ts("UPDATE_MEETING_ATTRIBUTE", function (t) {
                  return t.bHoldUponEntry === e;
                }));
              }
            }, {
              key: "allowRenameThemselves",
              value: function allowRenameThemselves() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];

                var _this$pf$getState5 = this[pf].getState(),
                    t = _this$pf$getState5.meeting.bAllowAttendeeRename;

                return t == e ? Promise.resolve("") : (ay.allowParticipantRename(e), Ts("UPDATE_MEETING_ATTRIBUTE", function (t) {
                  return t.bAllowAttendeeRename === e;
                }));
              }
            }, {
              key: "allowRaiseHand",
              value: function allowRaiseHand() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];

                var _this$pf$getState6 = this[pf].getState(),
                    t = _this$pf$getState6.meeting.bAllowRaiseHand;

                return t === e ? Promise.resolve("") : (ay.allowRaiseHand(e), Ts("UPDATE_MEETING_ATTRIBUTE", function (t) {
                  return t.bAllowRaiseHand === e;
                }));
              }
            }, {
              key: "allowAttendeeViewParticipantCounts",
              value: function allowAttendeeViewParticipantCounts() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];

                var _this$pf$getState7 = this[pf].getState(),
                    t = _this$pf$getState7.meeting.bAllowShowCount;

                return t === e ? Promise.resolve("") : (ay.allowViewParticipantNumber(e), Ts("UPDATE_MEETING_ATTRIBUTE", function (t) {
                  return t.bAllowShowCount === e;
                }));
              }
            }, {
              key: "broadcastInPracticeSession",
              value: function broadcastInPracticeSession() {
                var _this$hf5 = this[hf](),
                    e = _this$hf5.meeting.bBroadcast;

                return !1 === e ? (ay.practiceSession(), Ts("UPDATE_MEETING_ATTRIBUTE", function (e) {
                  return !0 === e.bBroadcast;
                })) : Promise.reject({
                  type: ms
                });
              }
            }, {
              key: "reclaimHost",
              value: function reclaimHost() {
                var e = this[hf](),
                    t = e.meeting.isOriginHost,
                    n = sc(e);
                return null != n && n.isHost ? Promise.reject({
                  type: ms,
                  reason: "You are already host now"
                }) : t ? (ay.reclaimHost(n.userId, !1), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (e) {
                  return !0 === e.isHost;
                })) : Promise.reject({
                  type: gs,
                  reason: "You are not the origin host"
                });
              }
            }, {
              key: "claimHost",
              value: function claimHost(e) {
                var t = this[hf]();
                return _c(t) ? Promise.reject({
                  type: ms,
                  reason: "host already in the meeting"
                }) : (ay.claimHost(e), Ts("MEETING_CLAIM_HOST_KEY_RESPONSE", function (e) {
                  return 0 === e || (3036 === e ? {
                    ret: 3036,
                    body: "Invalid host key"
                  } : {
                    ret: -1,
                    body: "Network error"
                  });
                }));
              }
            }, {
              key: "refreshActiveAppInfo",
              value: function refreshActiveAppInfo() {
                var e;

                var t = this[hf](),
                    n = this[_f],
                    r = null === (e = t.meeting) || void 0 === e ? void 0 : e.activeAppInfo,
                    _ref19 = r || {},
                    i = _ref19.status;

                return i && i !== mo.Loading || (n(ro(f(f({}, r), {}, {
                  status: mo.Loading
                }))), ay.activeAppInfoReq()), Ts("ACTIVE_APPS_UPDATE", function () {
                  return !0;
                });
              }
            }, {
              key: "getActiveAppLink",
              value: function getActiveAppLink(e) {
                return ay.activeAppLinkReq(e), Ts("ACTIVE_APP_DETAIL_UPDATE", function (e) {
                  return e.result;
                });
              }
            }, {
              key: "isWebinar",
              value: function isWebinar() {
                var _this$hf6 = this[hf](),
                    e = _this$hf6.meeting.isWebinar;

                return e;
              }
            }, {
              key: "isOnHold",
              value: function isOnHold() {
                var e = this[hf](),
                    _e$meeting5 = e.meeting,
                    t = _e$meeting5.isOnHold,
                    n = _e$meeting5.userEmail;
                return sc(e) ? t : n ? n === wo.get(Vo.WebclientUserEmail) && 1 === wo.get(Vo.WebclientIsOnHold) : !!wo.get(Vo.WebclientUserName) && 1 === wo.get(Vo.WebclientIsOnHold);
              }
            }, {
              key: "isAttendee",
              value: function isAttendee() {
                var e = this[hf](),
                    t = sc(e);
                return !!t && ec(t.userRole);
              }
            }, {
              key: "getOnHoldParticipantsList",
              value: function getOnHoldParticipantsList() {
                var e = this[pf].getState(),
                    t = sc(e),
                    n = e.meeting.meetingStatus;
                return n === go.Joined && t && (t.isHost || t.bCoHost) ? uc(e).map(function (e) {
                  return {
                    userId: e.userId,
                    displayName: e.displayName,
                    bHold: e.bHold
                  };
                }) : [];
              }
            }, {
              key: "getWebinarAttendeesList",
              value: function getWebinarAttendeesList() {
                var e = this[pf].getState(),
                    _e$meeting6 = e.meeting,
                    t = _e$meeting6.isWebinar,
                    n = _e$meeting6.meetingStatus,
                    r = e.participants.allowTalkAttendeesList;
                return t && n === go.Joined ? dc(e).map(function (e) {
                  var t = e.userId,
                      n = r.find(function (e) {
                    return e.userId === t;
                  });
                  return n ? {
                    userId: e.userId,
                    displayName: e.displayName,
                    bRaiseHand: e.bRaiseHand,
                    sdkKey: e.sdkKey,
                    avatar: e.avatar,
                    isAllowToTalk: !0,
                    audio: n.audio,
                    muted: n.muted
                  } : {
                    userId: e.userId,
                    displayName: e.displayName,
                    bRaiseHand: e.bRaiseHand,
                    sdkKey: e.sdkKey,
                    avatar: e.avatar,
                    isAllowToTalk: !1
                  };
                }) : [];
              }
            }, {
              key: "isEnableWaitingRoom",
              value: function isEnableWaitingRoom() {
                var _this$hf7 = this[hf](),
                    e = _this$hf7.meeting.bHoldUponEntry;

                return e;
              }
            }, {
              key: "isAllowToRaiseHand",
              value: function isAllowToRaiseHand() {
                var _this$hf8 = this[hf](),
                    e = _this$hf8.meeting.bAllowRaiseHand;

                return e;
              }
            }, {
              key: "isAllowToRename",
              value: function isAllowToRename() {
                var _this$hf9 = this[hf](),
                    e = _this$hf9.meeting.bAllowAttendeeRename;

                return e;
              }
            }, {
              key: "isInPracticeSession",
              value: function isInPracticeSession() {
                var _this$hf10 = this[hf](),
                    e = _this$hf10.meeting.bBroadcast;

                return !1 === e;
              }
            }, {
              key: "isMeetingLocked",
              value: function isMeetingLocked() {
                var _this$hf11 = this[hf](),
                    e = _this$hf11.meeting.bLock;

                return e;
              }
            }, {
              key: "hasAssistant",
              value: function hasAssistant() {
                var _this$hf12 = this[hf](),
                    e = _this$hf12.meeting.hasAst;

                return e;
              }
            }, {
              key: "hasRemoteAdmin",
              value: function hasRemoteAdmin() {
                var _this$hf13 = this[hf](),
                    e = _this$hf13.meeting.hasRmc;

                return e;
              }
            }, {
              key: "getActiveAppInfo",
              value: function getActiveAppInfo() {
                var _this$hf14 = this[hf](),
                    e = _this$hf14.meeting.activeAppInfo;

                return e;
              }
            }, {
              key: "getMeetingOptions",
              value: function getMeetingOptions() {
                var _this$hf15 = this[hf](),
                    _this$hf15$meeting$me = _this$hf15.meeting.meetingOptions,
                    e = _this$hf15$meeting$me.isCOHostEnabled,
                    t = _this$hf15$meeting$me.isEnableClientSDKCustomizeInviteUrl,
                    n = _this$hf15$meeting$me.isChatEnabled,
                    r = _this$hf15.recording,
                    i = _this$hf15.breakoutRoom;

                return {
                  isCOHostEnabled: e,
                  allowStopAutoRecording: null == r ? void 0 : r.allowStopAutoRecording,
                  recordingEnable: null == r ? void 0 : r.recordingEnable,
                  isEnableCustomizeInviteUrl: t,
                  isEnableBreakoutRoom: null == i ? void 0 : i.isEnableBreakoutRoom,
                  isChatEnabled: n
                };
              }
            }, {
              key: "shareUserPronoun",
              value: function shareUserPronoun(e) {
                var t = this[hf](),
                    n = sc(t),
                    r = null == n ? void 0 : n.strPronoun;
                return ay.changeSharePronoun(e, r), Ts("UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", function (t) {
                  return e ? void 0 !== t.strPronoun && "" !== t.strPronoun : void 0 !== t.strPronoun && "" === t.strPronoun;
                });
              }
            }]);

            return oy;
          }(Xb)).prototype, "lockMeeting", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "lockMeeting"), oy.prototype), v(oy.prototype, "unlockMeeting", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "unlockMeeting"), oy.prototype), v(oy.prototype, "removeUser", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "removeUser"), oy.prototype), v(oy.prototype, "admit", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "admit"), oy.prototype), v(oy.prototype, "admitAll", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "admitAll"), oy.prototype), v(oy.prototype, "putOnHold", [ey, bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "putOnHold"), oy.prototype), v(oy.prototype, "promoteToPanelist", [ty, bf, vf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "promoteToPanelist"), oy.prototype), v(oy.prototype, "givePromoteConsent", [vf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "givePromoteConsent"), oy.prototype), v(oy.prototype, "changeToAttendee", [ny, bf, vf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "changeToAttendee"), oy.prototype), v(oy.prototype, "raiseHand", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "raiseHand"), oy.prototype), v(oy.prototype, "lowerHand", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "lowerHand"), oy.prototype), v(oy.prototype, "putDownHand", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "putDownHand"), oy.prototype), v(oy.prototype, "sendNonverbalFeedback", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "sendNonverbalFeedback"), oy.prototype), v(oy.prototype, "clearNonverbalFeedback", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "clearNonverbalFeedback"), oy.prototype), v(oy.prototype, "lowerAllHands", [bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "lowerAllHands"), oy.prototype), v(oy.prototype, "enableWaitingRoom", [ry, bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "enableWaitingRoom"), oy.prototype), v(oy.prototype, "allowRenameThemselves", [iy, bf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "allowRenameThemselves"), oy.prototype), v(oy.prototype, "allowRaiseHand", [bf, vf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "allowRaiseHand"), oy.prototype), v(oy.prototype, "allowAttendeeViewParticipantCounts", [bf, vf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "allowAttendeeViewParticipantCounts"), oy.prototype), v(oy.prototype, "broadcastInPracticeSession", [bf, vf, gf], Object.getOwnPropertyDescriptor(oy.prototype, "broadcastInPracticeSession"), oy.prototype), v(oy.prototype, "reclaimHost", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "reclaimHost"), oy.prototype), v(oy.prototype, "claimHost", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "claimHost"), oy.prototype), v(oy.prototype, "refreshActiveAppInfo", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "refreshActiveAppInfo"), oy.prototype), v(oy.prototype, "getActiveAppLink", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "getActiveAppLink"), oy.prototype), v(oy.prototype, "shareUserPronoun", [gf], Object.getOwnPropertyDescriptor(oy.prototype, "shareUserPronoun"), oy.prototype), oy);

          var cy = /*#__PURE__*/function () {
            function cy(e) {
              var _this16 = this;

              _classCallCheck(this, cy);

              this.instant = void 0, this.context = void 0, this.script = void 0, this.mic = void 0, this.instant = 0, this.context = e, this.mic = null, this.script = e.createScriptProcessor(2048, 1, 1), this.script.onaudioprocess = function (e) {
                var t = e.inputBuffer.getChannelData(0);
                var n,
                    r = 0;

                for (n = 0; n < t.length; ++n) {
                  r += t[n] * t[n];
                }

                _this16.instant = Math.sqrt(r / t.length);
              };
            }

            _createClass(cy, [{
              key: "connectToSource",
              value: function connectToSource(e) {
                console.log("InputMicDetector is listening");

                try {
                  var t;
                  this.mic = this.context.createMediaStreamSource(e), this.mic.connect(this.script), null === (t = this.script) || void 0 === t || t.connect(this.context.destination);
                } catch (e) {
                  console.error(e);
                }
              }
            }, {
              key: "stop",
              value: function stop() {
                var e, t;
                console.log("Audio Previewer stopped"), null === (e = this.mic) || void 0 === e || e.disconnect(), this.mic = null, null === (t = this.script) || void 0 === t || t.disconnect(), this.script = null;
              }
            }, {
              key: "getMicVolume",
              value: function getMicVolume() {
                return this.instant;
              }
            }]);

            return cy;
          }();

          var ly = "https://st1.zoom.us/web_client/4qu8baa/audio/ring.mp3";

          var dy = /*#__PURE__*/function () {
            function dy() {
              _classCallCheck(this, dy);

              this.sampleAudio = void 0, this.audioCtx = void 0, this.destinationNode = void 0, this.audioPlayer = void 0, this.analyzserInterval = void 0, this.analyserNode = void 0, this.analyserNodeBufferDataArray = void 0, this.analyserCallback = void 0, this.sourceNode = void 0, this.mAudioStream = void 0, this.mSourceNode = void 0, this.mediaRecorder = void 0, this.isRecording = void 0, this.recorderChunks = [], this.recorderObjUrl = void 0, this.recorderPlayer = void 0, this.maximumRecordingTimer = void 0, this.shouldPlayAfterRecording = !0, this.isRunning = !1;
            }

            _createClass(dy, [{
              key: "testSpeaker",
              value: function testSpeaker(e) {
                var _this17 = this;

                var t;
                if ("function" != typeof AudioContext || "function" != typeof MediaStreamAudioDestinationNode || !AudioContext.prototype.decodeAudioData) return void console.warn("Cannot test the speaker due to the browser capability");

                var _ref20 = e || {},
                    n = _ref20.speakerId,
                    _ref20$sampleAudioUrl = _ref20.sampleAudioUrl,
                    r = _ref20$sampleAudioUrl === void 0 ? ly : _ref20$sampleAudioUrl,
                    i = _ref20.onAnalyseFrequency;

                if (this.isRunning) return void console.warn("A tester is running,please stop it first");
                this.isRunning = !0, this.initAudioContext(), ((null === (t = this.sampleAudio) || void 0 === t ? void 0 : t.url) === r && this.sampleAudio.data ? Promise.resolve(this.sampleAudio.data) : window.fetch(r).then(function (e) {
                  return e.arrayBuffer();
                }).then(function (e) {
                  return _this17.audioCtx.decodeAudioData(e);
                }).then(function (e) {
                  return _this17.sampleAudio = {
                    url: r,
                    data: e
                  }, e;
                })).then(function (e) {
                  var t, r, o;
                  _this17.sourceNode = _this17.audioCtx.createBufferSource(), _this17.sourceNode.buffer = e, _this17.sourceNode.loop = !0, n && null !== (t = _this17.audioPlayer) && void 0 !== t && t.setSinkId && _this17.audioPlayer.setSinkId(n), i ? "function" == typeof AudioContext.prototype.createAnalyser ? (_this17.analyzserInterval && window.clearInterval(_this17.analyzserInterval), _this17.analyserCallback = i, _this17.initAnalyserNode(), _this17.analyserNode && _this17.sourceNode.connect(_this17.analyserNode)) : (_this17.sourceNode.connect(_this17.destinationNode), console.warn("Cannot analyze the stream due to the browser capability")) : (_this17.analyserCallback = void 0, _this17.sourceNode.connect(_this17.destinationNode)), _this17.sourceNode.start(0), "running" !== (null === (r = _this17.audioCtx) || void 0 === r ? void 0 : r.state) && (null === (o = _this17.audioCtx) || void 0 === o || o.resume()), _this17.audioPlayer && (_this17.audioPlayer.muted = !1, _this17.audioPlayer.currentTime = 0, _this17.audioPlayer.play());
                });

                var o = function o() {
                  var e;
                  _this17.isRunning = !1, _this17.audioPlayer && (_this17.audioPlayer.currentTime = 0, _this17.audioPlayer.pause()), _this17.analyserNode && _this17.analyzserInterval && (window.clearInterval(_this17.analyzserInterval), _this17.analyzserInterval = void 0, _this17.analyserNodeBufferDataArray = void 0), _this17.sourceNode && (_this17.sourceNode.stop(0), _this17.sourceNode.disconnect(), _this17.sourceNode.buffer = null, _this17.sourceNode = void 0), null !== (e = _this17.destinationNode) && void 0 !== e && e.stream && (_this17.destinationNode.stream.getAudioTracks().forEach(function (e) {
                    e.stop();
                  }), _this17.destinationNode = void 0);
                };

                return {
                  stop: o,
                  destroy: function destroy() {
                    var e;
                    o(), _this17.analyserNode && _this17.destinationNode && (_this17.analyserNode.disconnect(_this17.destinationNode), _this17.analyserNode = void 0), null === (e = _this17.audioCtx) || void 0 === e || e.close(), _this17.audioCtx = void 0;
                  }
                };
              }
            }, {
              key: "testMicrophone",
              value: function testMicrophone(e) {
                var _this18 = this;

                var t;
                if ("function" != typeof AudioContext || "function" != typeof MediaStreamAudioDestinationNode || "function" != typeof AudioContext.prototype.createMediaStreamSource || "function" != typeof (null === (t = navigator.mediaDevices) || void 0 === t ? void 0 : t.getUserMedia)) return void console.warn("Cannot test the microphone due to the browser capability");

                var _ref21 = e || {},
                    n = _ref21.microphoneId,
                    r = _ref21.speakerId,
                    i = _ref21.recordAndPlay,
                    o = _ref21.maxRecordDuration,
                    a = _ref21.onAnalyseFrequency,
                    s = _ref21.onStartRecording,
                    c = _ref21.onStopRecording,
                    l = _ref21.onStartPlayRecording,
                    d = _ref21.onStopPlayRecording;

                if (this.isRunning) return void console.warn("A tester is running,please stop it first");
                this.isRunning = !0, this.initAudioContext();

                var u = function u() {
                  i && _this18.mediaRecorder && _this18.isRecording && (_this18.shouldPlayAfterRecording = !0, "inactive" !== _this18.mediaRecorder.state && _this18.mediaRecorder.stop());
                };

                window.navigator.mediaDevices.getUserMedia({
                  audio: !n || {
                    deviceId: n
                  }
                }).then(function (e) {
                  var t, n, p, h;
                  _this18.mAudioStream = e, _this18.mSourceNode = null === (t = _this18.audioCtx) || void 0 === t ? void 0 : t.createMediaStreamSource(e), _this18.audioPlayer.muted = !0, a ? (_this18.analyzserInterval && window.clearInterval(_this18.analyzserInterval), _this18.analyserCallback = a, _this18.initAnalyserNode(), _this18.analyserNode && (null === (p = _this18.mSourceNode) || void 0 === p || p.connect(_this18.analyserNode))) : _this18.analyserCallback = void 0, i && ("function" == typeof MediaRecorder ? (_this18.recorderObjUrl && window.URL.revokeObjectURL(_this18.recorderObjUrl), _this18.mediaRecorder = new MediaRecorder(_this18.mAudioStream), _this18.mediaRecorder.ondataavailable = function (e) {
                    e.data && _this18.recorderChunks.push(e.data);
                  }, _this18.mediaRecorder.onstop = function () {
                    if (_this18.isRecording = !1, _this18.maximumRecordingTimer && (window.clearTimeout(_this18.maximumRecordingTimer), _this18.maximumRecordingTimer = void 0), null == c || c(), _this18.recorderChunks.length > 0) {
                      var e;

                      var _t125 = new Blob(_this18.recorderChunks, {
                        type: (null === (e = _this18.recorderChunks[0]) || void 0 === e ? void 0 : e.type) || "audio/ogg; codecs=opus"
                      });

                      _this18.recorderObjUrl = window.URL.createObjectURL(_t125), _this18.shouldPlayAfterRecording && _this18.playRecording(_this18.recorderObjUrl, r, l, d), _this18.recorderChunks = [], _this18.mediaRecorder && (_this18.mediaRecorder.ondataavailable = null, _this18.mediaRecorder.onstop = null, _this18.mediaRecorder = void 0);
                    }
                  }, _this18.mediaRecorder.start(), _this18.isRecording = !0, null == s || s(), _this18.maximumRecordingTimer = window.setTimeout(function () {
                    u();
                  }, o || 1e4)) : console.warn("Cannot record the sound due to the browser capability")), "running" !== (null === (n = _this18.audioCtx) || void 0 === n ? void 0 : n.state) && (null === (h = _this18.audioCtx) || void 0 === h || h.resume()), _this18.audioPlayer && (_this18.audioPlayer.currentTime = 0, _this18.audioPlayer.play());
                });

                var p = function p() {
                  _this18.isRunning = !1, _this18.maximumRecordingTimer && (window.clearTimeout(_this18.maximumRecordingTimer), _this18.maximumRecordingTimer = void 0), _this18.audioPlayer && (_this18.audioPlayer.currentTime = 0, _this18.audioPlayer.pause()), _this18.analyserNode && _this18.analyzserInterval && (window.clearInterval(_this18.analyzserInterval), _this18.analyzserInterval = void 0, _this18.analyserNodeBufferDataArray = void 0), _this18.mSourceNode && (a && _this18.analyserNode && _this18.mSourceNode.disconnect(_this18.analyserNode), _this18.mSourceNode = void 0), _this18.mAudioStream && (_this18.mAudioStream.getAudioTracks().forEach(function (e) {
                    e.stop();
                  }), _this18.mAudioStream = void 0), _this18.mediaRecorder && (_this18.shouldPlayAfterRecording = !1, _this18.mediaRecorder.ondataavailable = null, _this18.mediaRecorder.onstop = null, "inactive" !== _this18.mediaRecorder.state && _this18.mediaRecorder.stop(), _this18.isRecording = !1, _this18.mediaRecorder = void 0, _this18.recorderChunks = []), _this18.recorderPlayer && (_this18.recorderPlayer.currentTime = 0, _this18.recorderPlayer.pause());
                };

                return {
                  stop: p,
                  stopRecording: u,
                  destroy: function destroy() {
                    var e;
                    p(), _this18.analyserNode && _this18.destinationNode && (_this18.analyserNode.disconnect(_this18.destinationNode), _this18.analyserNode = void 0), null === (e = _this18.audioCtx) || void 0 === e || e.close(), _this18.audioCtx = void 0;
                  }
                };
              }
            }, {
              key: "initAudioContext",
              value: function initAudioContext() {
                this.audioCtx && this.audioPlayer || (this.audioCtx = new AudioContext(), this.destinationNode = new MediaStreamAudioDestinationNode(this.audioCtx), this.audioPlayer = new Audio(), this.audioPlayer.loop = !0, this.audioPlayer.srcObject = this.destinationNode.stream);
              }
            }, {
              key: "initAnalyserNode",
              value: function initAnalyserNode() {
                this.analyserNode || (this.analyserNode = this.audioCtx.createAnalyser(), this.analyserNode.connect(this.destinationNode), this.analyserNode.fftSize = 1024);
                var e = this.analyserNode.frequencyBinCount;
                this.analyserNodeBufferDataArray = new Uint8Array(e), this.analyzserInterval = window.setInterval(this.audioAnalyserCallback.bind(this), 20);
              }
            }, {
              key: "audioAnalyserCallback",
              value: function audioAnalyserCallback() {
                if (this.analyserNodeBufferDataArray && this.analyserNode && this.analyserCallback) {
                  this.analyserNode.getByteFrequencyData(this.analyserNodeBufferDataArray);
                  var _e271 = 0;

                  var _iterator = _createForOfIteratorHelper(this.analyserNodeBufferDataArray),
                      _step;

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var _n87 = _step.value;
                      _e271 += _n87;
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  var _t126 = _e271 / this.analyserNodeBufferDataArray.length;

                  this.analyserCallback(_t126);
                }
              }
            }, {
              key: "playRecording",
              value: function playRecording(e, t, n, r) {
                var _this19 = this;

                this.recorderPlayer = new Audio(), this.recorderPlayer.src = e, this.recorderPlayer.currentTime = 0, this.recorderPlayer.setSinkId && t && this.recorderPlayer.setSinkId(t);

                var i = function i() {
                  null == r || r(), _this19.recorderPlayer && (_this19.recorderPlayer.onpause = null, _this19.recorderPlayer.onended = null, _this19.recorderPlayer = void 0, _this19.isRunning = !1);
                };

                this.recorderPlayer.onpause = function () {
                  i();
                }, this.recorderPlayer.onended = function () {
                  i();
                }, null == n || n(), this.recorderPlayer.play().finally(function () {
                  window.URL.revokeObjectURL(e);
                });
              }
            }]);

            return dy;
          }();

          var uy = /*#__PURE__*/function () {
            function uy() {
              _classCallCheck(this, uy);

              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
              this.audioContext = void 0, this.inputMicDetector = void 0, this.isMicUnmuted = void 0, this.isAudioStarted = void 0, this.audioStream = void 0, this.deviceId = void 0, this.tester = void 0, this.audioContext = null, this.inputMicDetector = null, this.isMicUnmuted = !1, this.isAudioStarted = !1, this.audioStream = null, this.deviceId = e, this.tester = new dy();
            }

            _createClass(uy, [{
              key: "start",
              value: function () {
                var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
                  var _e272;

                  return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                      switch (_context17.prev = _context17.next) {
                        case 0:
                          if (!(this.audioStream || this.isAudioStarted)) {
                            _context17.next = 2;
                            break;
                          }

                          throw new Error("AudioAlreadyStartedError");

                        case 2:
                          _context17.prev = 2;
                          _context17.next = 5;
                          return navigator.mediaDevices.getUserMedia(this.getAudioConstraints());

                        case 5:
                          _e272 = _context17.sent;
                          this.audioStream = _e272, this.isAudioStarted = !0;
                          _context17.next = 12;
                          break;

                        case 9:
                          _context17.prev = 9;
                          _context17.t0 = _context17["catch"](2);
                          throw _context17.t0;

                        case 12:
                        case "end":
                          return _context17.stop();
                      }
                    }
                  }, _callee17, this, [[2, 9]]);
                }));

                function start() {
                  return _start.apply(this, arguments);
                }

                return start;
              }()
            }, {
              key: "unmute",
              value: function () {
                var _unmute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
                  return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          if (!(!this.audioStream || !this.isAudioStarted)) {
                            _context18.next = 2;
                            break;
                          }

                          throw new Error("AudioNotStartedError");

                        case 2:
                          if (!this.isMicUnmuted) {
                            _context18.next = 4;
                            break;
                          }

                          throw new Error("AudioAlreadyUnmutedError");

                        case 4:
                          return _context18.abrupt("return", this.toggleMicIsMuted(!0));

                        case 5:
                        case "end":
                          return _context18.stop();
                      }
                    }
                  }, _callee18, this);
                }));

                function unmute() {
                  return _unmute.apply(this, arguments);
                }

                return unmute;
              }()
            }, {
              key: "mute",
              value: function () {
                var _mute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                  return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          if (!(!this.audioStream || !this.isAudioStarted)) {
                            _context19.next = 2;
                            break;
                          }

                          throw new Error("AudioNotStartedError");

                        case 2:
                          if (this.isMicUnmuted) {
                            _context19.next = 4;
                            break;
                          }

                          throw new Error("AudioAlreadyMutedError");

                        case 4:
                          return _context19.abrupt("return", this.toggleMicIsMuted(!1));

                        case 5:
                        case "end":
                          return _context19.stop();
                      }
                    }
                  }, _callee19, this);
                }));

                function mute() {
                  return _mute.apply(this, arguments);
                }

                return mute;
              }()
            }, {
              key: "getCurrentVolume",
              value: function getCurrentVolume() {
                return this.inputMicDetector ? this.inputMicDetector.getMicVolume() : 0;
              }
            }, {
              key: "stop",
              value: function () {
                var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                  return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          if (!(!this.audioStream || !this.isAudioStarted)) {
                            _context20.next = 2;
                            break;
                          }

                          throw new Error("AudioNotStartedError");

                        case 2:
                          this.audioStream.getAudioTracks().forEach(function (e) {
                            return e.stop();
                          }), this.audioStream = null, this.isAudioStarted = !1;

                        case 3:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee20, this);
                }));

                function stop() {
                  return _stop.apply(this, arguments);
                }

                return stop;
              }()
            }, {
              key: "toggleMicIsMuted",
              value: function () {
                var _toggleMicIsMuted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(e) {
                  var _e273;

                  return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                      switch (_context21.prev = _context21.next) {
                        case 0:
                          if (e) {
                            if (!this.audioContext) {
                              _e273 = window.AudioContext || window.webkitAudioContext;
                              this.audioContext = new _e273();
                            }

                            this.inputMicDetector = new cy(this.audioContext), this.inputMicDetector.connectToSource(this.audioStream);
                          } else this.inputMicDetector && this.inputMicDetector.stop(), this.inputMicDetector = null;

                          this.isMicUnmuted = e;

                        case 2:
                        case "end":
                          return _context21.stop();
                      }
                    }
                  }, _callee21, this);
                }));

                function toggleMicIsMuted(_x41) {
                  return _toggleMicIsMuted.apply(this, arguments);
                }

                return toggleMicIsMuted;
              }()
            }, {
              key: "getAudioConstraints",
              value: function getAudioConstraints() {
                return {
                  audio: "" === this.deviceId || {
                    deviceId: this.deviceId
                  },
                  video: !1
                };
              }
            }, {
              key: "testSpeaker",
              value: function testSpeaker(e) {
                return this.tester.testSpeaker(e);
              }
            }, {
              key: "testMicrophone",
              value: function testMicrophone(e) {
                return this.tester.testMicrophone(e);
              }
            }]);

            return uy;
          }();

          var py = {
            width: {
              min: 1024,
              ideal: 1280,
              max: 1920
            },
            height: {
              min: 576,
              ideal: 720,
              max: 1080
            },
            aspectRatio: {
              ideal: 1.777777778
            }
          };

          var hy = /*#__PURE__*/function () {
            function hy() {
              _classCallCheck(this, hy);

              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
              this.isVideoStarted = void 0, this.videoStream = void 0, this.deviceId = void 0, this.isVideoStarted = !1, this.videoStream = null, this.deviceId = e;
            }

            _createClass(hy, [{
              key: "start",
              value: function () {
                var _start2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(e) {
                  var _this20 = this;

                  var t, _t129;

                  return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                    while (1) {
                      switch (_context23.prev = _context23.next) {
                        case 0:
                          if (e) {
                            _context23.next = 2;
                            break;
                          }

                          throw new Error("Video DOM element is falsy");

                        case 2:
                          if (!(this.isVideoStarted || this.videoStream)) {
                            _context23.next = 4;
                            break;
                          }

                          throw new Error("VideoAlreadyStartedError");

                        case 4:
                          t = /*#__PURE__*/function () {
                            var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_t127) {
                              var _t128;

                              return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                                while (1) {
                                  switch (_context22.prev = _context22.next) {
                                    case 0:
                                      if (!(!_t127 || "OverconstrainedError" !== _t127.name && "ConstraintNotSatisfiedError" !== _t127.name)) {
                                        _context22.next = 2;
                                        break;
                                      }

                                      throw _t127;

                                    case 2:
                                      console.log("Warning: detected ".concat(_t127.name, " -- trying to fall back to lower aspect ratio"));
                                      _context22.prev = 3;
                                      _context22.next = 6;
                                      return navigator.mediaDevices.getUserMedia(_this20.getVideoConstraints(!0));

                                    case 6:
                                      _t128 = _context22.sent;
                                      return _context22.abrupt("return", _this20.tryPlayVideo(e, _t128));

                                    case 10:
                                      _context22.prev = 10;
                                      _context22.t0 = _context22["catch"](3);
                                      throw _context22.t0;

                                    case 13:
                                    case "end":
                                      return _context22.stop();
                                  }
                                }
                              }, _callee22, null, [[3, 10]]);
                            }));

                            return function t(_x43) {
                              return _ref22.apply(this, arguments);
                            };
                          }();

                          _context23.prev = 5;
                          _context23.next = 8;
                          return navigator.mediaDevices.getUserMedia(this.getVideoConstraints());

                        case 8:
                          _t129 = _context23.sent;
                          return _context23.abrupt("return", this.tryPlayVideo(e, _t129));

                        case 12:
                          _context23.prev = 12;
                          _context23.t0 = _context23["catch"](5);
                          return _context23.abrupt("return", t(_context23.t0));

                        case 15:
                        case "end":
                          return _context23.stop();
                      }
                    }
                  }, _callee23, this, [[5, 12]]);
                }));

                function start(_x42) {
                  return _start2.apply(this, arguments);
                }

                return start;
              }()
            }, {
              key: "stop",
              value: function () {
                var _stop2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
                  return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                    while (1) {
                      switch (_context24.prev = _context24.next) {
                        case 0:
                          if (!(!this.videoStream || !this.isVideoStarted)) {
                            _context24.next = 2;
                            break;
                          }

                          throw new Error("VideoNotStartedError");

                        case 2:
                          this.videoStream.getVideoTracks().forEach(function (e) {
                            return e.stop();
                          }), this.videoStream = null, this.isVideoStarted = !1;

                        case 3:
                        case "end":
                          return _context24.stop();
                      }
                    }
                  }, _callee24, this);
                }));

                function stop() {
                  return _stop2.apply(this, arguments);
                }

                return stop;
              }()
            }, {
              key: "getVideoConstraints",
              value: function getVideoConstraints() {
                var e = py;
                return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? e = "" === this.deviceId || {
                  deviceId: this.deviceId
                } : "" !== this.deviceId && (e.deviceId = this.deviceId), {
                  audio: !1,
                  video: e
                };
              }
            }, {
              key: "tryPlayVideo",
              value: function () {
                var _tryPlayVideo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e, t) {
                  return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                      switch (_context25.prev = _context25.next) {
                        case 0:
                          if (e) {
                            _context25.next = 2;
                            break;
                          }

                          throw new Error("Video DOM element is falsy");

                        case 2:
                          _context25.prev = 2;
                          this.videoStream = t;
                          e.srcObject = this.videoStream;
                          _context25.next = 7;
                          return e.play();

                        case 7:
                          this.isVideoStarted = !0;
                          _context25.next = 13;
                          break;

                        case 10:
                          _context25.prev = 10;
                          _context25.t0 = _context25["catch"](2);
                          throw _context25.t0;

                        case 13:
                        case "end":
                          return _context25.stop();
                      }
                    }
                  }, _callee25, this, [[2, 10]]);
                }));

                function tryPlayVideo(_x44, _x45) {
                  return _tryPlayVideo.apply(this, arguments);
                }

                return tryPlayVideo;
              }()
            }]);

            return hy;
          }();

          var _y = /*#__PURE__*/function () {
            function _y() {
              _classCallCheck(this, _y);
            }

            _createClass(_y, null, [{
              key: "createClient",
              value: function createClient() {
                if (!this.meetingClient) {
                  var _e274 = function () {
                    var e = [lf],
                        t = A(uf(), df(function () {
                      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                        t[n] = arguments[n];
                      }

                      return function (e) {
                        return function () {
                          var n = e.apply(void 0, arguments),
                              r = function r() {
                            throw new Error(S(15));
                          },
                              i = {
                            getState: n.getState,
                            dispatch: function dispatch() {
                              return r.apply(void 0, arguments);
                            }
                          },
                              o = t.map(function (e) {
                            return e(i);
                          });

                          return r = I.apply(void 0, o)(n.dispatch), w(w({}, n), {}, {
                            dispatch: r
                          });
                        };
                      };
                    }.apply(void 0, e)));
                    return t.asyncReducers = {}, t.injectReducer = function (e, n) {
                      void 0 === t.asyncReducers[e] && (t.asyncReducers[e] = n, t.replaceReducer(uf(t.asyncReducers)));
                    }, t.injectEpic = function (e) {
                      af.next(e);
                    }, lf.run(sf), t;
                  }();

                  this.meetingClient = new sy(_e274);
                }

                return this.meetingClient;
              }
            }, {
              key: "destroyClient",
              value: function destroyClient() {
                this.meetingClient && (this.meetingClient.leave().then(function () {
                  bt(500).subscribe(function () {
                    Rs();
                  });
                }), this.meetingClient = null);
              }
            }, {
              key: "checkSystemRequirements",
              value: function checkSystemRequirements() {
                var e;
                return {
                  audio: Eo() && Co() || Uu(),
                  video: Eo() && void 0 !== navigator.mediaDevices,
                  screen: Eo() && "function" == typeof (null === (e = navigator.mediaDevices) || void 0 === e ? void 0 : e.getDisplayMedia)
                };
              }
            }, {
              key: "getDevices",
              value: function getDevices(e) {
                return e ? navigator.mediaDevices.enumerateDevices() : navigator.mediaDevices.getUserMedia({
                  audio: !0,
                  video: !0
                }).then(function (e) {
                  return e.getTracks().forEach(function (e) {
                    return e.stop();
                  }), navigator.mediaDevices.enumerateDevices();
                });
              }
            }, {
              key: "createLocalAudioTrack",
              value: function createLocalAudioTrack() {
                return new uy(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "");
              }
            }, {
              key: "createLocalVideoTrack",
              value: function createLocalVideoTrack() {
                return new hy(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "");
              }
            }, {
              key: "preloadDependentAssets",
              value: function preloadDependentAssets(e) {
                (function () {
                  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(e) {
                    var t, n, r, i, o, a, s, _Fu, _e275, _t130, _Fu2, _e276, _t131, _Fu3, _e277, _t132, _Fu4, _e278, _t133, _Fu5, _e279, _t134, _Fu6, _e280, _t135, c, l, _e281, _t136, _document$head;

                    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
                      while (1) {
                        switch (_context26.prev = _context26.next) {
                          case 0:
                            n = e || Tu, r = [Tu, Iu, Ou].some(function (e) {
                              return new URL(e).hostname == new URL(n).hostname;
                            }), i = "".concat(n, "/").concat(r ? "1501_js_media.min.js" : "js_media.min.js"), o = [], a = [], s = r ? "".concat(n, "/", "1501", "_") : "".concat(n, "/");

                            if (Lu()) {
                              _Fu = Fu("audio", "simd", s), _e275 = _Fu.workers, _t130 = _Fu.wasms;
                              o.push.apply(o, _toConsumableArray(_e275)), a.push.apply(a, _toConsumableArray(_t130));
                            } else {
                              _Fu2 = Fu("audio", "", s), _e276 = _Fu2.workers, _t131 = _Fu2.wasms;
                              o.push.apply(o, _toConsumableArray(_e276)), a.push.apply(a, _toConsumableArray(_t131));
                            }

                            if (Lu() && Mu()) {
                              _Fu3 = Fu(["video", "sharing"], "simd,thread", s), _e277 = _Fu3.workers, _t132 = _Fu3.wasms;
                              o.push.apply(o, _toConsumableArray(_e277)), a.push.apply(a, _toConsumableArray(_t132));
                            } else if (Mu()) {
                              _Fu4 = Fu(["video", "sharing"], "thread", s), _e278 = _Fu4.workers, _t133 = _Fu4.wasms;
                              o.push.apply(o, _toConsumableArray(_e278)), a.push.apply(a, _toConsumableArray(_t133));
                            } else if (Lu()) {
                              _Fu5 = Fu(["video", "sharing"], "simd", s), _e279 = _Fu5.workers, _t134 = _Fu5.wasms;
                              o.push.apply(o, _toConsumableArray(_e279)), a.push.apply(a, _toConsumableArray(_t134));
                            } else {
                              _Fu6 = Fu(["video", "sharing"], "", s), _e280 = _Fu6.workers, _t135 = _Fu6.wasms;
                              o.push.apply(o, _toConsumableArray(_e280)), a.push.apply(a, _toConsumableArray(_t135));
                            }

                            c = [qu(i, "script")];
                            o.forEach(function (e) {
                              c.push(qu(e, "fetch"));
                            });
                            l = !1;

                            if (!(null !== (t = window.indexedDB) && void 0 !== t && t.databases)) {
                              _context26.next = 17;
                              break;
                            }

                            _context26.prev = 7;
                            _context26.next = 10;
                            return window.indexedDB.databases();

                          case 10:
                            _e281 = _context26.sent;
                            _t136 = '"audio:1035;video:1327"'.split(";").map(function (e) {
                              var _e$split = e.split(":"),
                                  _e$split2 = _slicedToArray(_e$split, 2),
                                  t = _e$split2[0],
                                  n = _e$split2[1];

                              return _defineProperty({}, "".concat(t), Number(n));
                            }).reduce(function (e, t) {
                              return f(f({}, e), t);
                            }, {});
                            _t136 && (l = ["AUDIO_FILE", "VIDEO_FILE"].every(function (n) {
                              var r = "AUDIO_FILE" === n ? _t136.audio : _t136.video;
                              return -1 !== _e281.findIndex(function (e) {
                                return e.name === n && e.version === r;
                              });
                            }));
                            _context26.next = 17;
                            break;

                          case 15:
                            _context26.prev = 15;
                            _context26.t0 = _context26["catch"](7);

                          case 17:
                            l || a.forEach(function (e) {
                              c.push(qu(e, "fetch"));
                            });

                            try {
                              (_document$head = document.head).append.apply(_document$head, c);
                            } catch (e) {}

                          case 19:
                          case "end":
                            return _context26.stop();
                        }
                      }
                    }, _callee26, null, [[7, 15]]);
                  }));

                  return function (_x46) {
                    return _ref23.apply(this, arguments);
                  };
                })()(e);
              }
            }]);

            return _y;
          }();

          _y.meetingClient = void 0, _y.VERSION = "2.8.0";
          var fy = {
            black: "#000",
            white: "#fff"
          },
              my = {
            50: "#ffebee",
            100: "#ffcdd2",
            200: "#ef9a9a",
            300: "#e57373",
            400: "#ef5350",
            500: "#f44336",
            600: "#e53935",
            700: "#d32f2f",
            800: "#c62828",
            900: "#b71c1c",
            A100: "#ff8a80",
            A200: "#ff5252",
            A400: "#ff1744",
            A700: "#d50000"
          },
              gy = {
            50: "#fce4ec",
            100: "#f8bbd0",
            200: "#f48fb1",
            300: "#f06292",
            400: "#ec407a",
            500: "#e91e63",
            600: "#d81b60",
            700: "#c2185b",
            800: "#ad1457",
            900: "#880e4f",
            A100: "#ff80ab",
            A200: "#ff4081",
            A400: "#f50057",
            A700: "#c51162"
          },
              vy = {
            50: "#e8eaf6",
            100: "#c5cae9",
            200: "#9fa8da",
            300: "#7986cb",
            400: "#5c6bc0",
            500: "#3f51b5",
            600: "#3949ab",
            700: "#303f9f",
            800: "#283593",
            900: "#1a237e",
            A100: "#8c9eff",
            A200: "#536dfe",
            A400: "#3d5afe",
            A700: "#304ffe"
          },
              by = {
            50: "#e3f2fd",
            100: "#bbdefb",
            200: "#90caf9",
            300: "#64b5f6",
            400: "#42a5f5",
            500: "#2196f3",
            600: "#1e88e5",
            700: "#1976d2",
            800: "#1565c0",
            900: "#0d47a1",
            A100: "#82b1ff",
            A200: "#448aff",
            A400: "#2979ff",
            A700: "#2962ff"
          },
              yy = {
            50: "#e8f5e9",
            100: "#c8e6c9",
            200: "#a5d6a7",
            300: "#81c784",
            400: "#66bb6a",
            500: "#4caf50",
            600: "#43a047",
            700: "#388e3c",
            800: "#2e7d32",
            900: "#1b5e20",
            A100: "#b9f6ca",
            A200: "#69f0ae",
            A400: "#00e676",
            A700: "#00c853"
          },
              wy = {
            50: "#fff3e0",
            100: "#ffe0b2",
            200: "#ffcc80",
            300: "#ffb74d",
            400: "#ffa726",
            500: "#ff9800",
            600: "#fb8c00",
            700: "#f57c00",
            800: "#ef6c00",
            900: "#e65100",
            A100: "#ffd180",
            A200: "#ffab40",
            A400: "#ff9100",
            A700: "#ff6d00"
          },
              Sy = {
            50: "#fafafa",
            100: "#f5f5f5",
            200: "#eeeeee",
            300: "#e0e0e0",
            400: "#bdbdbd",
            500: "#9e9e9e",
            600: "#757575",
            700: "#616161",
            800: "#424242",
            900: "#212121",
            A100: "#d5d5d5",
            A200: "#aaaaaa",
            A400: "#303030",
            A700: "#616161"
          };

          function xy() {
            return xy = Object.assign ? Object.assign.bind() : function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, xy.apply(this, arguments);
          }

          function Ey(e) {
            return Ey = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, Ey(e);
          }

          function Cy(e) {
            return e && "object" === Ey(e) && e.constructor === Object;
          }

          function ky(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
              clone: !0
            },
                r = n.clone ? xy({}, e) : e;
            return Cy(e) && Cy(t) && Object.keys(t).forEach(function (i) {
              "__proto__" !== i && (Cy(t[i]) && i in e ? r[i] = ky(e[i], t[i], n) : r[i] = t[i]);
            }), r;
          }

          var Ay = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof n.g ? n.g : "undefined" != typeof self ? self : {};

          function Iy(e) {
            if (e.__esModule) return e;
            var t = Object.defineProperty({}, "__esModule", {
              value: !0
            });
            return Object.keys(e).forEach(function (n) {
              var r = Object.getOwnPropertyDescriptor(e, n);
              Object.defineProperty(t, n, r.get ? r : {
                enumerable: !0,
                get: function get() {
                  return e[n];
                }
              });
            }), t;
          }

          function Ty(e) {
            throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
          }

          var Oy = {
            exports: {}
          };

          function Ry() {}

          function Ny() {}

          function Py(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          function jy(e) {
            for (var t = "https://mui.com/production-error/?code=" + e, n = 1; n < arguments.length; n += 1) {
              t += "&args[]=" + encodeURIComponent(arguments[n]);
            }

            return "Minified Material-UI error #" + e + "; visit " + t + " for the full message.";
          }

          Ny.resetWarningCache = Ry, Oy.exports = function () {
            function e(e, t, n, r, i, o) {
              if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== o) {
                var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw a.name = "Invariant Violation", a;
              }
            }

            function t() {
              return e;
            }

            e.isRequired = e;
            var n = {
              array: e,
              bigint: e,
              bool: e,
              func: e,
              number: e,
              object: e,
              string: e,
              symbol: e,
              any: e,
              arrayOf: t,
              element: e,
              elementType: e,
              instanceOf: t,
              node: e,
              objectOf: t,
              oneOf: t,
              oneOfType: t,
              shape: t,
              exact: t,
              checkPropTypes: Ny,
              resetWarningCache: Ry
            };
            return n.PropTypes = n, n;
          }();
          var Dy = {},
              zy = 60103,
              My = 60106,
              Ly = 60107,
              Uy = 60108,
              By = 60114,
              Hy = 60109,
              Vy = 60110,
              qy = 60112,
              Fy = 60113,
              Wy = 60120,
              Gy = 60115,
              Ky = 60116,
              Qy = 60121,
              Zy = 60122,
              Yy = 60117,
              Jy = 60129,
              $y = 60131;

          if ("function" == typeof Symbol && Symbol.for) {
            var Xy = Symbol.for;
            zy = Xy("react.element"), My = Xy("react.portal"), Ly = Xy("react.fragment"), Uy = Xy("react.strict_mode"), By = Xy("react.profiler"), Hy = Xy("react.provider"), Vy = Xy("react.context"), qy = Xy("react.forward_ref"), Fy = Xy("react.suspense"), Wy = Xy("react.suspense_list"), Gy = Xy("react.memo"), Ky = Xy("react.lazy"), Qy = Xy("react.block"), Zy = Xy("react.server.block"), Yy = Xy("react.fundamental"), Jy = Xy("react.debug_trace_mode"), $y = Xy("react.legacy_hidden");
          }

          function ew(e) {
            if ("object" == typeof e && null !== e) {
              var t = e.$$typeof;

              switch (t) {
                case zy:
                  switch (e = e.type) {
                    case Ly:
                    case By:
                    case Uy:
                    case Fy:
                    case Wy:
                      return e;

                    default:
                      switch (e = e && e.$$typeof) {
                        case Vy:
                        case qy:
                        case Ky:
                        case Gy:
                        case Hy:
                          return e;

                        default:
                          return t;
                      }

                  }

                case My:
                  return t;
              }
            }
          }

          var tw = Hy,
              nw = zy,
              rw = qy,
              iw = Ly,
              ow = Ky,
              aw = Gy,
              sw = My,
              cw = By,
              lw = Uy,
              dw = Fy;

          function uw(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
            return Math.min(Math.max(t, e), n);
          }

          function pw(e) {
            if (e.type) return e;
            if ("#" === e.charAt(0)) return pw(function (e) {
              e = e.substr(1);
              var t = new RegExp(".{1,".concat(e.length >= 6 ? 2 : 1, "}"), "g"),
                  n = e.match(t);
              return n && 1 === n[0].length && (n = n.map(function (e) {
                return e + e;
              })), n ? "rgb".concat(4 === n.length ? "a" : "", "(").concat(n.map(function (e, t) {
                return t < 3 ? parseInt(e, 16) : Math.round(parseInt(e, 16) / 255 * 1e3) / 1e3;
              }).join(", "), ")") : "";
            }(e));
            var t = e.indexOf("("),
                n = e.substring(0, t);
            if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n)) throw new Error(jy(3, e));
            var r = e.substring(t + 1, e.length - 1).split(",");
            return {
              type: n,
              values: r = r.map(function (e) {
                return parseFloat(e);
              })
            };
          }

          function hw(e) {
            var t = e.type,
                n = e.values;
            return -1 !== t.indexOf("rgb") ? n = n.map(function (e, t) {
              return t < 3 ? parseInt(e, 10) : e;
            }) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(t, "(").concat(n.join(", "), ")");
          }

          function _w(e) {
            var t = "hsl" === (e = pw(e)).type ? pw(function (e) {
              var t = (e = pw(e)).values,
                  n = t[0],
                  r = t[1] / 100,
                  i = t[2] / 100,
                  o = r * Math.min(i, 1 - i),
                  a = function a(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + n / 30) % 12;
                return i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1);
              },
                  s = "rgb",
                  c = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];

              return "hsla" === e.type && (s += "a", c.push(t[3])), hw({
                type: s,
                values: c
              });
            }(e)).values : e.values;
            return t = t.map(function (e) {
              return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
            }), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3));
          }

          function fw(e, t) {
            return e = pw(e), t = uw(t), "rgb" !== e.type && "hsl" !== e.type || (e.type += "a"), e.values[3] = t, hw(e);
          }

          function mw(e, t) {
            if (e = pw(e), t = uw(t), -1 !== e.type.indexOf("hsl")) e.values[2] *= 1 - t;else if (-1 !== e.type.indexOf("rgb")) for (var n = 0; n < 3; n += 1) {
              e.values[n] *= 1 - t;
            }
            return hw(e);
          }

          function gw(e, t) {
            if (e = pw(e), t = uw(t), -1 !== e.type.indexOf("hsl")) e.values[2] += (100 - e.values[2]) * t;else if (-1 !== e.type.indexOf("rgb")) for (var n = 0; n < 3; n += 1) {
              e.values[n] += (255 - e.values[n]) * t;
            }
            return hw(e);
          }

          function vw(e, t) {
            if (null == e) return {};
            var n,
                r,
                i = {},
                o = Object.keys(e);

            for (r = 0; r < o.length; r++) {
              n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            }

            return i;
          }

          function bw(e, t) {
            if (null == e) return {};
            var n,
                r,
                i = vw(e, t);

            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
              }
            }

            return i;
          }

          Dy.ContextConsumer = Vy, Dy.ContextProvider = tw, Dy.Element = nw, Dy.ForwardRef = rw, Dy.Fragment = iw, Dy.Lazy = ow, Dy.Memo = aw, Dy.Portal = sw, Dy.Profiler = cw, Dy.StrictMode = lw, Dy.Suspense = dw, Dy.isAsyncMode = function () {
            return !1;
          }, Dy.isConcurrentMode = function () {
            return !1;
          }, Dy.isContextConsumer = function (e) {
            return ew(e) === Vy;
          }, Dy.isContextProvider = function (e) {
            return ew(e) === Hy;
          }, Dy.isElement = function (e) {
            return "object" == typeof e && null !== e && e.$$typeof === zy;
          }, Dy.isForwardRef = function (e) {
            return ew(e) === qy;
          }, Dy.isFragment = function (e) {
            return ew(e) === Ly;
          }, Dy.isLazy = function (e) {
            return ew(e) === Ky;
          }, Dy.isMemo = function (e) {
            return ew(e) === Gy;
          }, Dy.isPortal = function (e) {
            return ew(e) === My;
          }, Dy.isProfiler = function (e) {
            return ew(e) === By;
          }, Dy.isStrictMode = function (e) {
            return ew(e) === Uy;
          }, Dy.isSuspense = function (e) {
            return ew(e) === Fy;
          }, Dy.isValidElementType = function (e) {
            return "string" == typeof e || "function" == typeof e || e === Ly || e === By || e === Jy || e === Uy || e === Fy || e === Wy || e === $y || "object" == typeof e && null !== e && (e.$$typeof === Ky || e.$$typeof === Gy || e.$$typeof === Hy || e.$$typeof === Vy || e.$$typeof === qy || e.$$typeof === Yy || e.$$typeof === Qy || e[0] === Zy);
          }, Dy.typeOf = ew;
          var yw = ["xs", "sm", "md", "lg", "xl"];

          function ww(e) {
            var t = e.values,
                n = void 0 === t ? {
              xs: 0,
              sm: 600,
              md: 960,
              lg: 1280,
              xl: 1920
            } : t,
                r = e.unit,
                i = void 0 === r ? "px" : r,
                o = e.step,
                a = void 0 === o ? 5 : o,
                s = bw(e, ["values", "unit", "step"]);

            function c(e) {
              var t = "number" == typeof n[e] ? n[e] : e;
              return "@media (min-width:".concat(t).concat(i, ")");
            }

            function l(e, t) {
              var r = yw.indexOf(t);
              return r === yw.length - 1 ? c(e) : "@media (min-width:".concat("number" == typeof n[e] ? n[e] : e).concat(i, ") and ") + "(max-width:".concat((-1 !== r && "number" == typeof n[yw[r + 1]] ? n[yw[r + 1]] : t) - a / 100).concat(i, ")");
            }

            return xy({
              keys: yw,
              values: n,
              up: c,
              down: function down(e) {
                var t = yw.indexOf(e) + 1,
                    r = n[yw[t]];
                return t === yw.length ? c("xs") : "@media (max-width:".concat(("number" == typeof r && t > 0 ? r : e) - a / 100).concat(i, ")");
              },
              between: l,
              only: function only(e) {
                return l(e, e);
              },
              width: function width(e) {
                return n[e];
              }
            }, s);
          }

          function Sw(e, t, n) {
            var r;
            return xy({
              gutters: function gutters() {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join("\n")), xy({
                  paddingLeft: t(2),
                  paddingRight: t(2)
                }, n, Py({}, e.up("sm"), xy({
                  paddingLeft: t(3),
                  paddingRight: t(3)
                }, n[e.up("sm")])));
              },
              toolbar: (r = {
                minHeight: 56
              }, Py(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {
                minHeight: 48
              }), Py(r, e.up("sm"), {
                minHeight: 64
              }), r)
            }, n);
          }

          var xw = {
            text: {
              primary: "rgba(0, 0, 0, 0.87)",
              secondary: "rgba(0, 0, 0, 0.54)",
              disabled: "rgba(0, 0, 0, 0.38)",
              hint: "rgba(0, 0, 0, 0.38)"
            },
            divider: "rgba(0, 0, 0, 0.12)",
            background: {
              paper: fy.white,
              default: Sy[50]
            },
            action: {
              active: "rgba(0, 0, 0, 0.54)",
              hover: "rgba(0, 0, 0, 0.04)",
              hoverOpacity: .04,
              selected: "rgba(0, 0, 0, 0.08)",
              selectedOpacity: .08,
              disabled: "rgba(0, 0, 0, 0.26)",
              disabledBackground: "rgba(0, 0, 0, 0.12)",
              disabledOpacity: .38,
              focus: "rgba(0, 0, 0, 0.12)",
              focusOpacity: .12,
              activatedOpacity: .12
            }
          },
              Ew = {
            text: {
              primary: fy.white,
              secondary: "rgba(255, 255, 255, 0.7)",
              disabled: "rgba(255, 255, 255, 0.5)",
              hint: "rgba(255, 255, 255, 0.5)",
              icon: "rgba(255, 255, 255, 0.5)"
            },
            divider: "rgba(255, 255, 255, 0.12)",
            background: {
              paper: Sy[800],
              default: "#303030"
            },
            action: {
              active: fy.white,
              hover: "rgba(255, 255, 255, 0.08)",
              hoverOpacity: .08,
              selected: "rgba(255, 255, 255, 0.16)",
              selectedOpacity: .16,
              disabled: "rgba(255, 255, 255, 0.3)",
              disabledBackground: "rgba(255, 255, 255, 0.12)",
              disabledOpacity: .38,
              focus: "rgba(255, 255, 255, 0.12)",
              focusOpacity: .12,
              activatedOpacity: .24
            }
          };

          function Cw(e, t, n, r) {
            var i = r.light || r,
                o = r.dark || 1.5 * r;
            e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : "light" === t ? e.light = gw(e.main, i) : "dark" === t && (e.dark = mw(e.main, o)));
          }

          function kw(e) {
            var t = e.primary,
                n = void 0 === t ? {
              light: vy[300],
              main: vy[500],
              dark: vy[700]
            } : t,
                r = e.secondary,
                i = void 0 === r ? {
              light: gy.A200,
              main: gy.A400,
              dark: gy.A700
            } : r,
                o = e.error,
                a = void 0 === o ? {
              light: my[300],
              main: my[500],
              dark: my[700]
            } : o,
                s = e.warning,
                c = void 0 === s ? {
              light: wy[300],
              main: wy[500],
              dark: wy[700]
            } : s,
                l = e.info,
                d = void 0 === l ? {
              light: by[300],
              main: by[500],
              dark: by[700]
            } : l,
                u = e.success,
                p = void 0 === u ? {
              light: yy[300],
              main: yy[500],
              dark: yy[700]
            } : u,
                h = e.type,
                _ = void 0 === h ? "light" : h,
                f = e.contrastThreshold,
                m = void 0 === f ? 3 : f,
                g = e.tonalOffset,
                v = void 0 === g ? .2 : g,
                b = bw(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);

            function y(e) {
              var t = function (e, t) {
                var n = _w(e),
                    r = _w(t);

                return (Math.max(n, r) + .05) / (Math.min(n, r) + .05);
              }(e, Ew.text.primary) >= m ? Ew.text.primary : xw.text.primary;
              return t;
            }

            var w = function w(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                  n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300,
                  r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
              if (!(e = xy({}, e)).main && e[t] && (e.main = e[t]), !e.main) throw new Error(jy(4, t));
              if ("string" != typeof e.main) throw new Error(jy(5, JSON.stringify(e.main)));
              return Cw(e, "light", n, v), Cw(e, "dark", r, v), e.contrastText || (e.contrastText = y(e.main)), e;
            },
                S = {
              dark: Ew,
              light: xw
            };

            return ky(xy({
              common: fy,
              type: _,
              primary: w(n),
              secondary: w(i, "A400", "A200", "A700"),
              error: w(a),
              warning: w(c),
              info: w(d),
              success: w(p),
              grey: Sy,
              contrastThreshold: m,
              getContrastText: y,
              augmentColor: w,
              tonalOffset: v
            }, S[_]), b);
          }

          function Aw(e) {
            return Math.round(1e5 * e) / 1e5;
          }

          function Iw(e) {
            return Aw(e);
          }

          var Tw = {
            textTransform: "uppercase"
          },
              Ow = '"Roboto", "Helvetica", "Arial", sans-serif';

          function Rw(e, t) {
            var n = "function" == typeof t ? t(e) : t,
                r = n.fontFamily,
                i = void 0 === r ? Ow : r,
                o = n.fontSize,
                a = void 0 === o ? 14 : o,
                s = n.fontWeightLight,
                c = void 0 === s ? 300 : s,
                l = n.fontWeightRegular,
                d = void 0 === l ? 400 : l,
                u = n.fontWeightMedium,
                p = void 0 === u ? 500 : u,
                h = n.fontWeightBold,
                _ = void 0 === h ? 700 : h,
                f = n.htmlFontSize,
                m = void 0 === f ? 16 : f,
                g = n.allVariants,
                v = n.pxToRem,
                b = bw(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]),
                y = a / 14,
                w = v || function (e) {
              return "".concat(e / m * y, "rem");
            },
                S = function S(e, t, n, r, o) {
              return xy({
                fontFamily: i,
                fontWeight: e,
                fontSize: w(t),
                lineHeight: n
              }, i === Ow ? {
                letterSpacing: "".concat(Aw(r / t), "em")
              } : {}, o, g);
            },
                x = {
              h1: S(c, 96, 1.167, -1.5),
              h2: S(c, 60, 1.2, -.5),
              h3: S(d, 48, 1.167, 0),
              h4: S(d, 34, 1.235, .25),
              h5: S(d, 24, 1.334, 0),
              h6: S(p, 20, 1.6, .15),
              subtitle1: S(d, 16, 1.75, .15),
              subtitle2: S(p, 14, 1.57, .1),
              body1: S(d, 16, 1.5, .15),
              body2: S(d, 14, 1.43, .15),
              button: S(p, 14, 1.75, .4, Tw),
              caption: S(d, 12, 1.66, .4),
              overline: S(d, 12, 2.66, 1, Tw)
            };

            return ky(xy({
              htmlFontSize: m,
              pxToRem: w,
              round: Iw,
              fontFamily: i,
              fontSize: a,
              fontWeightLight: c,
              fontWeightRegular: d,
              fontWeightMedium: p,
              fontWeightBold: _
            }, x), b, {
              clone: !1
            });
          }

          function Nw() {
            return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",");
          }

          var Pw = ["none", Nw(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Nw(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Nw(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Nw(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Nw(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Nw(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Nw(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Nw(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Nw(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Nw(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Nw(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Nw(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Nw(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Nw(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Nw(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Nw(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Nw(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Nw(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Nw(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Nw(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Nw(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Nw(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Nw(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Nw(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)],
              jw = {
            borderRadius: 4
          };

          function Dw(e, t) {
            (null == t || t > e.length) && (t = e.length);

            for (var n = 0, r = new Array(t); n < t; n++) {
              r[n] = e[n];
            }

            return r;
          }

          function zw(e, t) {
            if (e) {
              if ("string" == typeof e) return Dw(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Dw(e, t) : void 0;
            }
          }

          function Mw(e) {
            return function (e) {
              if (Array.isArray(e)) return Dw(e);
            }(e) || function (e) {
              if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || zw(e) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }

          function Lw(e, t) {
            return t ? ky(e, t, {
              clone: !1
            }) : e;
          }

          var Uw = {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920
          },
              Bw = {
            keys: ["xs", "sm", "md", "lg", "xl"],
            up: function up(e) {
              return "@media (min-width:".concat(Uw[e], "px)");
            }
          };

          function Hw(e, t, n) {
            if (Array.isArray(t)) {
              var r = e.theme.breakpoints || Bw;
              return t.reduce(function (e, i, o) {
                return e[r.up(r.keys[o])] = n(t[o]), e;
              }, {});
            }

            if ("object" === Ey(t)) {
              var i = e.theme.breakpoints || Bw;
              return Object.keys(t).reduce(function (e, r) {
                return e[i.up(r)] = n(t[r]), e;
              }, {});
            }

            return n(t);
          }

          function Vw(e, t) {
            return t && "string" == typeof t ? t.split(".").reduce(function (e, t) {
              return e && e[t] ? e[t] : null;
            }, e) : null;
          }

          function qw(e) {
            var t = e.prop,
                n = e.cssProperty,
                r = void 0 === n ? e.prop : n,
                i = e.themeKey,
                o = e.transform,
                a = function a(e) {
              if (null == e[t]) return null;
              var n = e[t],
                  a = Vw(e.theme, i) || {};
              return Hw(e, n, function (e) {
                var t;
                return "function" == typeof a ? t = a(e) : Array.isArray(a) ? t = a[e] || e : (t = Vw(a, e) || e, o && (t = o(t))), !1 === r ? t : Py({}, r, t);
              });
            };

            return a.propTypes = {}, a.filterProps = [t], a;
          }

          function Fw() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            var r = function r(e) {
              return t.reduce(function (t, n) {
                var r = n(e);
                return r ? Lw(t, r) : t;
              }, {});
            };

            return r.propTypes = {}, r.filterProps = t.reduce(function (e, t) {
              return e.concat(t.filterProps);
            }, []), r;
          }

          function Ww(e) {
            return "number" != typeof e ? e : "".concat(e, "px solid");
          }

          var Gw = Fw(qw({
            prop: "border",
            themeKey: "borders",
            transform: Ww
          }), qw({
            prop: "borderTop",
            themeKey: "borders",
            transform: Ww
          }), qw({
            prop: "borderRight",
            themeKey: "borders",
            transform: Ww
          }), qw({
            prop: "borderBottom",
            themeKey: "borders",
            transform: Ww
          }), qw({
            prop: "borderLeft",
            themeKey: "borders",
            transform: Ww
          }), qw({
            prop: "borderColor",
            themeKey: "palette"
          }), qw({
            prop: "borderRadius",
            themeKey: "shape"
          }));

          function Kw(e, t) {
            var n = {};
            return Object.keys(e).forEach(function (r) {
              -1 === t.indexOf(r) && (n[r] = e[r]);
            }), n;
          }

          var Qw = Fw(qw({
            prop: "displayPrint",
            cssProperty: !1,
            transform: function transform(e) {
              return {
                "@media print": {
                  display: e
                }
              };
            }
          }), qw({
            prop: "display"
          }), qw({
            prop: "overflow"
          }), qw({
            prop: "textOverflow"
          }), qw({
            prop: "visibility"
          }), qw({
            prop: "whiteSpace"
          })),
              Zw = Fw(qw({
            prop: "flexBasis"
          }), qw({
            prop: "flexDirection"
          }), qw({
            prop: "flexWrap"
          }), qw({
            prop: "justifyContent"
          }), qw({
            prop: "alignItems"
          }), qw({
            prop: "alignContent"
          }), qw({
            prop: "order"
          }), qw({
            prop: "flex"
          }), qw({
            prop: "flexGrow"
          }), qw({
            prop: "flexShrink"
          }), qw({
            prop: "alignSelf"
          }), qw({
            prop: "justifyItems"
          }), qw({
            prop: "justifySelf"
          })),
              Yw = Fw(qw({
            prop: "gridGap"
          }), qw({
            prop: "gridColumnGap"
          }), qw({
            prop: "gridRowGap"
          }), qw({
            prop: "gridColumn"
          }), qw({
            prop: "gridRow"
          }), qw({
            prop: "gridAutoFlow"
          }), qw({
            prop: "gridAutoColumns"
          }), qw({
            prop: "gridAutoRows"
          }), qw({
            prop: "gridTemplateColumns"
          }), qw({
            prop: "gridTemplateRows"
          }), qw({
            prop: "gridTemplateAreas"
          }), qw({
            prop: "gridArea"
          })),
              Jw = Fw(qw({
            prop: "color",
            themeKey: "palette"
          }), qw({
            prop: "bgcolor",
            cssProperty: "backgroundColor",
            themeKey: "palette"
          })),
              $w = Fw(qw({
            prop: "position"
          }), qw({
            prop: "zIndex",
            themeKey: "zIndex"
          }), qw({
            prop: "top"
          }), qw({
            prop: "right"
          }), qw({
            prop: "bottom"
          }), qw({
            prop: "left"
          })),
              Xw = qw({
            prop: "boxShadow",
            themeKey: "shadows"
          });

          function eS(e) {
            return e <= 1 ? "".concat(100 * e, "%") : e;
          }

          var tS = qw({
            prop: "width",
            transform: eS
          }),
              nS = qw({
            prop: "maxWidth",
            transform: eS
          }),
              rS = qw({
            prop: "minWidth",
            transform: eS
          }),
              iS = qw({
            prop: "height",
            transform: eS
          }),
              oS = qw({
            prop: "maxHeight",
            transform: eS
          }),
              aS = qw({
            prop: "minHeight",
            transform: eS
          });
          qw({
            prop: "size",
            cssProperty: "width",
            transform: eS
          }), qw({
            prop: "size",
            cssProperty: "height",
            transform: eS
          });
          var sS = Fw(tS, nS, rS, iS, oS, aS, qw({
            prop: "boxSizing"
          }));

          function cS(e, t) {
            return function (e) {
              if (Array.isArray(e)) return e;
            }(e) || function (e, t) {
              var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

              if (null != n) {
                var r,
                    i,
                    o = [],
                    a = !0,
                    s = !1;

                try {
                  for (n = n.call(e); !(a = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); a = !0) {
                    ;
                  }
                } catch (e) {
                  s = !0, i = e;
                } finally {
                  try {
                    a || null == n.return || n.return();
                  } finally {
                    if (s) throw i;
                  }
                }

                return o;
              }
            }(e, t) || zw(e, t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }

          var lS = {
            m: "margin",
            p: "padding"
          },
              dS = {
            t: "Top",
            r: "Right",
            b: "Bottom",
            l: "Left",
            x: ["Left", "Right"],
            y: ["Top", "Bottom"]
          },
              uS = {
            marginX: "mx",
            marginY: "my",
            paddingX: "px",
            paddingY: "py"
          },
              pS = function (e) {
            var t = {};
            return function (n) {
              return void 0 === t[n] && (t[n] = e(n)), t[n];
            };
          }(function (e) {
            if (e.length > 2) {
              if (!uS[e]) return [e];
              e = uS[e];
            }

            var t = cS(e.split(""), 2),
                n = t[0],
                r = t[1],
                i = lS[n],
                o = dS[r] || "";
            return Array.isArray(o) ? o.map(function (e) {
              return i + e;
            }) : [i + o];
          }),
              hS = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];

          function _S(e) {
            var t = e.spacing || 8;
            return "number" == typeof t ? function (e) {
              return t * e;
            } : Array.isArray(t) ? function (e) {
              return t[e];
            } : "function" == typeof t ? t : function () {};
          }

          function fS(e, t) {
            return function (n) {
              return e.reduce(function (e, r) {
                return e[r] = function (e, t) {
                  if ("string" == typeof t || null == t) return t;
                  var n = e(Math.abs(t));
                  return t >= 0 ? n : "number" == typeof n ? -n : "-".concat(n);
                }(t, n), e;
              }, {});
            };
          }

          function mS(e) {
            var t = _S(e.theme);

            return Object.keys(e).map(function (n) {
              if (-1 === hS.indexOf(n)) return null;
              var r = fS(pS(n), t),
                  i = e[n];
              return Hw(e, i, r);
            }).reduce(Lw, {});
          }

          mS.propTypes = {}, mS.filterProps = hS;
          var gS = Fw(qw({
            prop: "fontFamily",
            themeKey: "typography"
          }), qw({
            prop: "fontSize",
            themeKey: "typography"
          }), qw({
            prop: "fontStyle",
            themeKey: "typography"
          }), qw({
            prop: "fontWeight",
            themeKey: "typography"
          }), qw({
            prop: "letterSpacing"
          }), qw({
            prop: "lineHeight"
          }), qw({
            prop: "textAlign"
          }));

          function vS() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
            if (e.mui) return e;

            var t = _S({
              spacing: e
            }),
                n = function n() {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
                n[r] = arguments[r];
              }

              return 0 === n.length ? t(1) : 1 === n.length ? t(n[0]) : n.map(function (e) {
                if ("string" == typeof e) return e;
                var n = t(e);
                return "number" == typeof n ? "".concat(n, "px") : n;
              }).join(" ");
            };

            return Object.defineProperty(n, "unit", {
              get: function get() {
                return e;
              }
            }), n.mui = !0, n;
          }

          var bS = {
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
            sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
          },
              yS = {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195
          };

          function wS(e) {
            return "".concat(Math.round(e), "ms");
          }

          var SS = {
            easing: bS,
            duration: yS,
            create: function create() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"],
                  t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  n = t.duration,
                  r = void 0 === n ? yS.standard : n,
                  i = t.easing,
                  o = void 0 === i ? bS.easeInOut : i,
                  a = t.delay,
                  s = void 0 === a ? 0 : a;
              return bw(t, ["duration", "easing", "delay"]), (Array.isArray(e) ? e : [e]).map(function (e) {
                return "".concat(e, " ").concat("string" == typeof r ? r : wS(r), " ").concat(o, " ").concat("string" == typeof s ? s : wS(s));
              }).join(",");
            },
            getAutoHeightDuration: function getAutoHeightDuration(e) {
              if (!e) return 0;
              var t = e / 36;
              return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5));
            }
          },
              xS = {
            mobileStepper: 1e3,
            speedDial: 1050,
            appBar: 1100,
            drawer: 1200,
            modal: 1300,
            snackbar: 1400,
            tooltip: 1500
          };

          function ES() {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, n = void 0 === t ? {} : t, r = e.mixins, i = void 0 === r ? {} : r, o = e.palette, a = void 0 === o ? {} : o, s = e.spacing, c = e.typography, l = void 0 === c ? {} : c, d = bw(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), u = kw(a), p = ww(n), h = vS(s), _ = ky({
              breakpoints: p,
              direction: "ltr",
              mixins: Sw(p, h, i),
              overrides: {},
              palette: u,
              props: {},
              shadows: Pw,
              typography: Rw(u, l),
              spacing: h,
              shape: jw,
              transitions: SS,
              zIndex: xS
            }, d), f = arguments.length, m = new Array(f > 1 ? f - 1 : 0), g = 1; g < f; g++) {
              m[g - 1] = arguments[g];
            }

            return m.reduce(function (e, t) {
              return ky(e, t);
            }, _);
          }

          var CS = "function" == typeof Symbol && Symbol.for ? Symbol.for("mui.nested") : "__THEME_NESTED__",
              kS = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];

          function AS(e) {
            var t = e.theme,
                n = e.name,
                r = e.props;
            if (!t || !t.props || !t.props[n]) return r;
            var i,
                o = t.props[n];

            for (i in o) {
              void 0 === r[i] && (r[i] = o[i]);
            }

            return r;
          }

          var IS = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              TS = "object" === ("undefined" == typeof window ? "undefined" : IS(window)) && "object" === ("undefined" == typeof document ? "undefined" : IS(document)) && 9 === document.nodeType;

          function OS(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          function RS(e, t, n) {
            return t && OS(e.prototype, t), n && OS(e, n), Object.defineProperty(e, "prototype", {
              writable: !1
            }), e;
          }

          function NS(e, t) {
            return NS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
              return e.__proto__ = t, e;
            }, NS(e, t);
          }

          function PS(e, t) {
            e.prototype = Object.create(t.prototype), e.prototype.constructor = e, NS(e, t);
          }

          function jS(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }

          var DS = {}.constructor;

          function zS(e) {
            if (null == e || "object" != typeof e) return e;
            if (Array.isArray(e)) return e.map(zS);
            if (e.constructor !== DS) return e;
            var t = {};

            for (var n in e) {
              t[n] = zS(e[n]);
            }

            return t;
          }

          function MS(e, t, n) {
            void 0 === e && (e = "unnamed");
            var r = n.jss,
                i = zS(t);
            return r.plugins.onCreateRule(e, i, n) || (e[0], null);
          }

          var LS = function LS(e, t) {
            for (var n = "", r = 0; r < e.length && "!important" !== e[r]; r++) {
              n && (n += t), n += e[r];
            }

            return n;
          },
              US = function US(e, t) {
            if (void 0 === t && (t = !1), !Array.isArray(e)) return e;
            var n = "";
            if (Array.isArray(e[0])) for (var r = 0; r < e.length && "!important" !== e[r]; r++) {
              n && (n += ", "), n += LS(e[r], " ");
            } else n = LS(e, ", ");
            return t || "!important" !== e[e.length - 1] || (n += " !important"), n;
          };

          function BS(e) {
            return e && !1 === e.format ? {
              linebreak: "",
              space: ""
            } : {
              linebreak: "\n",
              space: " "
            };
          }

          function HS(e, t) {
            for (var n = "", r = 0; r < t; r++) {
              n += "  ";
            }

            return n + e;
          }

          function VS(e, t, n) {
            void 0 === n && (n = {});
            var r = "";
            if (!t) return r;
            var i = n.indent,
                o = void 0 === i ? 0 : i,
                a = t.fallbacks;
            !1 === n.format && (o = -1 / 0);
            var s = BS(n),
                c = s.linebreak,
                l = s.space;
            if (e && o++, a) if (Array.isArray(a)) for (var d = 0; d < a.length; d++) {
              var u = a[d];

              for (var p in u) {
                var h = u[p];
                null != h && (r && (r += c), r += HS(p + ":" + l + US(h) + ";", o));
              }
            } else for (var _ in a) {
              var f = a[_];
              null != f && (r && (r += c), r += HS(_ + ":" + l + US(f) + ";", o));
            }

            for (var m in t) {
              var g = t[m];
              null != g && "fallbacks" !== m && (r && (r += c), r += HS(m + ":" + l + US(g) + ";", o));
            }

            return (r || n.allowEmpty) && e ? (r && (r = "" + c + r + c), HS("" + e + l + "{" + r, --o) + HS("}", o)) : r;
          }

          var qS = /([[\].#*$><+~=|^:(),"'`\s])/g,
              FS = "undefined" != typeof CSS && CSS.escape,
              WS = function WS(e) {
            return FS ? FS(e) : e.replace(qS, "\\$1");
          },
              GS = function () {
            function e(e, t, n) {
              this.type = "style", this.isProcessed = !1;
              var r = n.sheet,
                  i = n.Renderer;
              this.key = e, this.options = n, this.style = t, r ? this.renderer = r.renderer : i && (this.renderer = new i());
            }

            return e.prototype.prop = function (e, t, n) {
              if (void 0 === t) return this.style[e];
              var r = !!n && n.force;
              if (!r && this.style[e] === t) return this;
              var i = t;
              n && !1 === n.process || (i = this.options.jss.plugins.onChangeValue(t, e, this));
              var o = null == i || !1 === i,
                  a = (e in this.style);
              if (o && !a && !r) return this;
              var s = o && a;
              if (s ? delete this.style[e] : this.style[e] = i, this.renderable && this.renderer) return s ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, i), this;
              var c = this.options.sheet;
              return c && c.attached, this;
            }, e;
          }(),
              KS = function (e) {
            function t(t, n, r) {
              var i;
              i = e.call(this, t, n, r) || this;
              var o = r.selector,
                  a = r.scoped,
                  s = r.sheet,
                  c = r.generateId;
              return o ? i.selectorText = o : !1 !== a && (i.id = c(jS(jS(i)), s), i.selectorText = "." + WS(i.id)), i;
            }

            PS(t, e);
            var n = t.prototype;
            return n.applyTo = function (e) {
              var t = this.renderer;

              if (t) {
                var n = this.toJSON();

                for (var r in n) {
                  t.setProperty(e, r, n[r]);
                }
              }

              return this;
            }, n.toJSON = function () {
              var e = {};

              for (var t in this.style) {
                var n = this.style[t];
                "object" != typeof n ? e[t] = n : Array.isArray(n) && (e[t] = US(n));
              }

              return e;
            }, n.toString = function (e) {
              var t = this.options.sheet,
                  n = t && t.options.link ? xy({}, e, {
                allowEmpty: !0
              }) : e;
              return VS(this.selectorText, this.style, n);
            }, RS(t, [{
              key: "selector",
              set: function set(e) {
                if (e !== this.selectorText) {
                  this.selectorText = e;
                  var t = this.renderer,
                      n = this.renderable;
                  n && t && (t.setSelector(n, e) || t.replaceRule(n, this));
                }
              },
              get: function get() {
                return this.selectorText;
              }
            }]), t;
          }(GS),
              QS = {
            onCreateRule: function onCreateRule(e, t, n) {
              return "@" === e[0] || n.parent && "keyframes" === n.parent.type ? null : new KS(e, t, n);
            }
          },
              ZS = {
            indent: 1,
            children: !0
          },
              YS = /@([\w-]+)/,
              JS = function () {
            function e(e, t, n) {
              this.type = "conditional", this.isProcessed = !1, this.key = e;
              var r = e.match(YS);

              for (var i in this.at = r ? r[1] : "unknown", this.query = n.name || "@" + this.at, this.options = n, this.rules = new wx(xy({}, n, {
                parent: this
              })), t) {
                this.rules.add(i, t[i]);
              }

              this.rules.process();
            }

            var t = e.prototype;
            return t.getRule = function (e) {
              return this.rules.get(e);
            }, t.indexOf = function (e) {
              return this.rules.indexOf(e);
            }, t.addRule = function (e, t, n) {
              var r = this.rules.add(e, t, n);
              return r ? (this.options.jss.plugins.onProcessRule(r), r) : null;
            }, t.replaceRule = function (e, t, n) {
              var r = this.rules.replace(e, t, n);
              return r && this.options.jss.plugins.onProcessRule(r), r;
            }, t.toString = function (e) {
              void 0 === e && (e = ZS);
              var t = BS(e).linebreak;
              if (null == e.indent && (e.indent = ZS.indent), null == e.children && (e.children = ZS.children), !1 === e.children) return this.query + " {}";
              var n = this.rules.toString(e);
              return n ? this.query + " {" + t + n + t + "}" : "";
            }, e;
          }(),
              $S = /@media|@supports\s+/,
              XS = {
            onCreateRule: function onCreateRule(e, t, n) {
              return $S.test(e) ? new JS(e, t, n) : null;
            }
          },
              ex = {
            indent: 1,
            children: !0
          },
              tx = /@keyframes\s+([\w-]+)/,
              nx = function () {
            function e(e, t, n) {
              this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
              var r = e.match(tx);
              r && r[1] ? this.name = r[1] : this.name = "noname", this.key = this.type + "-" + this.name, this.options = n;
              var i = n.scoped,
                  o = n.sheet,
                  a = n.generateId;

              for (var s in this.id = !1 === i ? this.name : WS(a(this, o)), this.rules = new wx(xy({}, n, {
                parent: this
              })), t) {
                this.rules.add(s, t[s], xy({}, n, {
                  parent: this
                }));
              }

              this.rules.process();
            }

            return e.prototype.toString = function (e) {
              void 0 === e && (e = ex);
              var t = BS(e).linebreak;
              if (null == e.indent && (e.indent = ex.indent), null == e.children && (e.children = ex.children), !1 === e.children) return this.at + " " + this.id + " {}";
              var n = this.rules.toString(e);
              return n && (n = "" + t + n + t), this.at + " " + this.id + " {" + n + "}";
            }, e;
          }(),
              rx = /@keyframes\s+/,
              ix = /\$([\w-]+)/g,
              ox = function ox(e, t) {
            return "string" == typeof e ? e.replace(ix, function (e, n) {
              return n in t ? t[n] : e;
            }) : e;
          },
              ax = function ax(e, t, n) {
            var r = e[t],
                i = ox(r, n);
            i !== r && (e[t] = i);
          },
              sx = {
            onCreateRule: function onCreateRule(e, t, n) {
              return "string" == typeof e && rx.test(e) ? new nx(e, t, n) : null;
            },
            onProcessStyle: function onProcessStyle(e, t, n) {
              return "style" === t.type && n ? ("animation-name" in e && ax(e, "animation-name", n.keyframes), "animation" in e && ax(e, "animation", n.keyframes), e) : e;
            },
            onChangeValue: function onChangeValue(e, t, n) {
              var r = n.options.sheet;
              if (!r) return e;

              switch (t) {
                case "animation":
                case "animation-name":
                  return ox(e, r.keyframes);

                default:
                  return e;
              }
            }
          },
              cx = function (e) {
            function t() {
              return e.apply(this, arguments) || this;
            }

            return PS(t, e), t.prototype.toString = function (e) {
              var t = this.options.sheet,
                  n = t && t.options.link ? xy({}, e, {
                allowEmpty: !0
              }) : e;
              return VS(this.key, this.style, n);
            }, t;
          }(GS),
              lx = {
            onCreateRule: function onCreateRule(e, t, n) {
              return n.parent && "keyframes" === n.parent.type ? new cx(e, t, n) : null;
            }
          },
              dx = function () {
            function e(e, t, n) {
              this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = e, this.style = t, this.options = n;
            }

            return e.prototype.toString = function (e) {
              var t = BS(e).linebreak;

              if (Array.isArray(this.style)) {
                for (var n = "", r = 0; r < this.style.length; r++) {
                  n += VS(this.at, this.style[r]), this.style[r + 1] && (n += t);
                }

                return n;
              }

              return VS(this.at, this.style, e);
            }, e;
          }(),
              ux = /@font-face/,
              px = {
            onCreateRule: function onCreateRule(e, t, n) {
              return ux.test(e) ? new dx(e, t, n) : null;
            }
          },
              hx = function () {
            function e(e, t, n) {
              this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = e, this.style = t, this.options = n;
            }

            return e.prototype.toString = function (e) {
              return VS(this.key, this.style, e);
            }, e;
          }(),
              _x = {
            onCreateRule: function onCreateRule(e, t, n) {
              return "@viewport" === e || "@-ms-viewport" === e ? new hx(e, t, n) : null;
            }
          },
              fx = function () {
            function e(e, t, n) {
              this.type = "simple", this.isProcessed = !1, this.key = e, this.value = t, this.options = n;
            }

            return e.prototype.toString = function (e) {
              if (Array.isArray(this.value)) {
                for (var t = "", n = 0; n < this.value.length; n++) {
                  t += this.key + " " + this.value[n] + ";", this.value[n + 1] && (t += "\n");
                }

                return t;
              }

              return this.key + " " + this.value + ";";
            }, e;
          }(),
              mx = {
            "@charset": !0,
            "@import": !0,
            "@namespace": !0
          },
              gx = {
            onCreateRule: function onCreateRule(e, t, n) {
              return e in mx ? new fx(e, t, n) : null;
            }
          },
              vx = [QS, XS, sx, lx, px, _x, gx],
              bx = {
            process: !0
          },
              yx = {
            force: !0,
            process: !0
          },
              wx = function () {
            function e(e) {
              this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = e, this.classes = e.classes, this.keyframes = e.keyframes;
            }

            var t = e.prototype;
            return t.add = function (e, t, n) {
              var r = this.options,
                  i = r.parent,
                  o = r.sheet,
                  a = r.jss,
                  s = r.Renderer,
                  c = r.generateId,
                  l = r.scoped,
                  d = xy({
                classes: this.classes,
                parent: i,
                sheet: o,
                jss: a,
                Renderer: s,
                generateId: c,
                scoped: l,
                name: e,
                keyframes: this.keyframes,
                selector: void 0
              }, n),
                  u = e;
              e in this.raw && (u = e + "-d" + this.counter++), this.raw[u] = t, u in this.classes && (d.selector = "." + WS(this.classes[u]));
              var p = MS(u, t, d);
              if (!p) return null;
              this.register(p);
              var h = void 0 === d.index ? this.index.length : d.index;
              return this.index.splice(h, 0, p), p;
            }, t.replace = function (e, t, n) {
              var r = this.get(e),
                  i = this.index.indexOf(r);
              r && this.remove(r);
              var o = n;
              return -1 !== i && (o = xy({}, n, {
                index: i
              })), this.add(e, t, o);
            }, t.get = function (e) {
              return this.map[e];
            }, t.remove = function (e) {
              this.unregister(e), delete this.raw[e.key], this.index.splice(this.index.indexOf(e), 1);
            }, t.indexOf = function (e) {
              return this.index.indexOf(e);
            }, t.process = function () {
              var e = this.options.jss.plugins;
              this.index.slice(0).forEach(e.onProcessRule, e);
            }, t.register = function (e) {
              this.map[e.key] = e, e instanceof KS ? (this.map[e.selector] = e, e.id && (this.classes[e.key] = e.id)) : e instanceof nx && this.keyframes && (this.keyframes[e.name] = e.id);
            }, t.unregister = function (e) {
              delete this.map[e.key], e instanceof KS ? (delete this.map[e.selector], delete this.classes[e.key]) : e instanceof nx && delete this.keyframes[e.name];
            }, t.update = function () {
              var e, t, n;
              if ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (e = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1], n = arguments.length <= 2 ? void 0 : arguments[2]) : (t = arguments.length <= 0 ? void 0 : arguments[0], n = arguments.length <= 1 ? void 0 : arguments[1], e = null), e) this.updateOne(this.get(e), t, n);else for (var r = 0; r < this.index.length; r++) {
                this.updateOne(this.index[r], t, n);
              }
            }, t.updateOne = function (t, n, r) {
              void 0 === r && (r = bx);
              var i = this.options,
                  o = i.jss.plugins,
                  a = i.sheet;
              if (t.rules instanceof e) t.rules.update(n, r);else {
                var s = t.style;

                if (o.onUpdate(n, t, a, r), r.process && s && s !== t.style) {
                  for (var c in o.onProcessStyle(t.style, t, a), t.style) {
                    var l = t.style[c];
                    l !== s[c] && t.prop(c, l, yx);
                  }

                  for (var d in s) {
                    var u = t.style[d],
                        p = s[d];
                    null == u && u !== p && t.prop(d, null, yx);
                  }
                }
              }
            }, t.toString = function (e) {
              for (var t = "", n = this.options.sheet, r = !!n && n.options.link, i = BS(e).linebreak, o = 0; o < this.index.length; o++) {
                var a = this.index[o].toString(e);
                (a || r) && (t && (t += i), t += a);
              }

              return t;
            }, e;
          }(),
              Sx = function () {
            function e(e, t) {
              for (var n in this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = xy({}, t, {
                sheet: this,
                parent: this,
                classes: this.classes,
                keyframes: this.keyframes
              }), t.Renderer && (this.renderer = new t.Renderer(this)), this.rules = new wx(this.options), e) {
                this.rules.add(n, e[n]);
              }

              this.rules.process();
            }

            var t = e.prototype;
            return t.attach = function () {
              return this.attached || (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy()), this;
            }, t.detach = function () {
              return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
            }, t.addRule = function (e, t, n) {
              var r = this.queue;
              this.attached && !r && (this.queue = []);
              var i = this.rules.add(e, t, n);
              return i ? (this.options.jss.plugins.onProcessRule(i), this.attached ? this.deployed ? (r ? r.push(i) : (this.insertRule(i), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0)), i) : i : (this.deployed = !1, i)) : null;
            }, t.replaceRule = function (e, t, n) {
              var r = this.rules.get(e);
              if (!r) return this.addRule(e, t, n);
              var i = this.rules.replace(e, t, n);
              return i && this.options.jss.plugins.onProcessRule(i), this.attached ? this.deployed ? (this.renderer && (i ? r.renderable && this.renderer.replaceRule(r.renderable, i) : this.renderer.deleteRule(r)), i) : i : (this.deployed = !1, i);
            }, t.insertRule = function (e) {
              this.renderer && this.renderer.insertRule(e);
            }, t.addRules = function (e, t) {
              var n = [];

              for (var r in e) {
                var i = this.addRule(r, e[r], t);
                i && n.push(i);
              }

              return n;
            }, t.getRule = function (e) {
              return this.rules.get(e);
            }, t.deleteRule = function (e) {
              var t = "object" == typeof e ? e : this.rules.get(e);
              return !(!t || this.attached && !t.renderable) && (this.rules.remove(t), !(this.attached && t.renderable && this.renderer) || this.renderer.deleteRule(t.renderable));
            }, t.indexOf = function (e) {
              return this.rules.indexOf(e);
            }, t.deploy = function () {
              return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
            }, t.update = function () {
              var e;
              return (e = this.rules).update.apply(e, arguments), this;
            }, t.updateOne = function (e, t, n) {
              return this.rules.updateOne(e, t, n), this;
            }, t.toString = function (e) {
              return this.rules.toString(e);
            }, e;
          }(),
              xx = function () {
            function e() {
              this.plugins = {
                internal: [],
                external: []
              }, this.registry = {};
            }

            var t = e.prototype;
            return t.onCreateRule = function (e, t, n) {
              for (var r = 0; r < this.registry.onCreateRule.length; r++) {
                var i = this.registry.onCreateRule[r](e, t, n);
                if (i) return i;
              }

              return null;
            }, t.onProcessRule = function (e) {
              if (!e.isProcessed) {
                for (var t = e.options.sheet, n = 0; n < this.registry.onProcessRule.length; n++) {
                  this.registry.onProcessRule[n](e, t);
                }

                e.style && this.onProcessStyle(e.style, e, t), e.isProcessed = !0;
              }
            }, t.onProcessStyle = function (e, t, n) {
              for (var r = 0; r < this.registry.onProcessStyle.length; r++) {
                t.style = this.registry.onProcessStyle[r](t.style, t, n);
              }
            }, t.onProcessSheet = function (e) {
              for (var t = 0; t < this.registry.onProcessSheet.length; t++) {
                this.registry.onProcessSheet[t](e);
              }
            }, t.onUpdate = function (e, t, n, r) {
              for (var i = 0; i < this.registry.onUpdate.length; i++) {
                this.registry.onUpdate[i](e, t, n, r);
              }
            }, t.onChangeValue = function (e, t, n) {
              for (var r = e, i = 0; i < this.registry.onChangeValue.length; i++) {
                r = this.registry.onChangeValue[i](r, t, n);
              }

              return r;
            }, t.use = function (e, t) {
              void 0 === t && (t = {
                queue: "external"
              });
              var n = this.plugins[t.queue];
              -1 === n.indexOf(e) && (n.push(e), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (e, t) {
                for (var n in t) {
                  n in e && e[n].push(t[n]);
                }

                return e;
              }, {
                onCreateRule: [],
                onProcessRule: [],
                onProcessStyle: [],
                onProcessSheet: [],
                onChangeValue: [],
                onUpdate: []
              }));
            }, e;
          }(),
              Ex = function () {
            function e() {
              this.registry = [];
            }

            var t = e.prototype;
            return t.add = function (e) {
              var t = this.registry,
                  n = e.options.index;
              if (-1 === t.indexOf(e)) if (0 === t.length || n >= this.index) t.push(e);else for (var r = 0; r < t.length; r++) {
                if (t[r].options.index > n) return void t.splice(r, 0, e);
              }
            }, t.reset = function () {
              this.registry = [];
            }, t.remove = function (e) {
              var t = this.registry.indexOf(e);
              this.registry.splice(t, 1);
            }, t.toString = function (e) {
              for (var t = void 0 === e ? {} : e, n = t.attached, r = vw(t, ["attached"]), i = BS(r).linebreak, o = "", a = 0; a < this.registry.length; a++) {
                var s = this.registry[a];
                null != n && s.attached !== n || (o && (o += i), o += s.toString(r));
              }

              return o;
            }, RS(e, [{
              key: "index",
              get: function get() {
                return 0 === this.registry.length ? 0 : this.registry[this.registry.length - 1].options.index;
              }
            }]), e;
          }(),
              Cx = new Ex(),
              kx = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window && window.Math === Math ? window : "undefined" != typeof self && self.Math === Math ? self : Function("return this")(),
              Ax = "2f1acc6c3a606b082e5eef5e54414ffb";

          null == kx[Ax] && (kx[Ax] = 0);

          var Ix = kx[Ax]++,
              Tx = function Tx(e) {
            void 0 === e && (e = {});
            var t = 0;
            return function (n, r) {
              t += 1;
              var i = "",
                  o = "";
              return r && (r.options.classNamePrefix && (o = r.options.classNamePrefix), null != r.options.jss.id && (i = String(r.options.jss.id))), e.minify ? "" + (o || "c") + Ix + i + t : o + n.key + "-" + Ix + (i ? "-" + i : "") + "-" + t;
            };
          },
              Ox = function Ox(e) {
            var t;
            return function () {
              return t || (t = e()), t;
            };
          },
              Rx = function Rx(e, t) {
            try {
              return e.attributeStyleMap ? e.attributeStyleMap.get(t) : e.style.getPropertyValue(t);
            } catch (e) {
              return "";
            }
          },
              Nx = function Nx(e, t, n) {
            try {
              var r = n;
              if (Array.isArray(n) && (r = US(n, !0), "!important" === n[n.length - 1])) return e.style.setProperty(t, r, "important"), !0;
              e.attributeStyleMap ? e.attributeStyleMap.set(t, r) : e.style.setProperty(t, r);
            } catch (e) {
              return !1;
            }

            return !0;
          },
              Px = function Px(e, t) {
            try {
              e.attributeStyleMap ? e.attributeStyleMap.delete(t) : e.style.removeProperty(t);
            } catch (e) {}
          },
              jx = function jx(e, t) {
            return e.selectorText = t, e.selectorText === t;
          },
              Dx = Ox(function () {
            return document.querySelector("head");
          });

          function zx(e) {
            var t = Cx.registry;

            if (t.length > 0) {
              var n = function (e, t) {
                for (var n = 0; n < e.length; n++) {
                  var r = e[n];
                  if (r.attached && r.options.index > t.index && r.options.insertionPoint === t.insertionPoint) return r;
                }

                return null;
              }(t, e);

              if (n && n.renderer) return {
                parent: n.renderer.element.parentNode,
                node: n.renderer.element
              };
              if (n = function (e, t) {
                for (var n = e.length - 1; n >= 0; n--) {
                  var r = e[n];
                  if (r.attached && r.options.insertionPoint === t.insertionPoint) return r;
                }

                return null;
              }(t, e), n && n.renderer) return {
                parent: n.renderer.element.parentNode,
                node: n.renderer.element.nextSibling
              };
            }

            var r = e.insertionPoint;

            if (r && "string" == typeof r) {
              var i = function (e) {
                for (var t = Dx(), n = 0; n < t.childNodes.length; n++) {
                  var r = t.childNodes[n];
                  if (8 === r.nodeType && r.nodeValue.trim() === e) return r;
                }

                return null;
              }(r);

              if (i) return {
                parent: i.parentNode,
                node: i.nextSibling
              };
            }

            return !1;
          }

          var Mx = Ox(function () {
            var e = document.querySelector('meta[property="csp-nonce"]');
            return e ? e.getAttribute("content") : null;
          }),
              Lx = function Lx(e, t, n) {
            try {
              "insertRule" in e ? e.insertRule(t, n) : "appendRule" in e && e.appendRule(t);
            } catch (e) {
              return !1;
            }

            return e.cssRules[n];
          },
              Ux = function Ux(e, t) {
            var n = e.cssRules.length;
            return void 0 === t || t > n ? n : t;
          },
              Bx = function () {
            function e(e) {
              this.getPropertyValue = Rx, this.setProperty = Nx, this.removeProperty = Px, this.setSelector = jx, this.hasInsertedRules = !1, this.cssRules = [], e && Cx.add(e), this.sheet = e;
              var t = this.sheet ? this.sheet.options : {},
                  n = t.media,
                  r = t.meta,
                  i = t.element;
              this.element = i || function () {
                var e = document.createElement("style");
                return e.textContent = "\n", e;
              }(), this.element.setAttribute("data-jss", ""), n && this.element.setAttribute("media", n), r && this.element.setAttribute("data-meta", r);
              var o = Mx();
              o && this.element.setAttribute("nonce", o);
            }

            var t = e.prototype;
            return t.attach = function () {
              if (!this.element.parentNode && this.sheet) {
                !function (e, t) {
                  var n = t.insertionPoint,
                      r = zx(t);
                  if (!1 !== r && r.parent) r.parent.insertBefore(e, r.node);else if (n && "number" == typeof n.nodeType) {
                    var i = n,
                        o = i.parentNode;
                    o && o.insertBefore(e, i.nextSibling);
                  } else Dx().appendChild(e);
                }(this.element, this.sheet.options);
                var e = Boolean(this.sheet && this.sheet.deployed);
                this.hasInsertedRules && e && (this.hasInsertedRules = !1, this.deploy());
              }
            }, t.detach = function () {
              if (this.sheet) {
                var e = this.element.parentNode;
                e && e.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = "\n");
              }
            }, t.deploy = function () {
              var e = this.sheet;
              e && (e.options.link ? this.insertRules(e.rules) : this.element.textContent = "\n" + e.toString() + "\n");
            }, t.insertRules = function (e, t) {
              for (var n = 0; n < e.index.length; n++) {
                this.insertRule(e.index[n], n, t);
              }
            }, t.insertRule = function (e, t, n) {
              if (void 0 === n && (n = this.element.sheet), e.rules) {
                var r = e,
                    i = n;

                if ("conditional" === e.type || "keyframes" === e.type) {
                  var o = Ux(n, t);
                  if (!1 === (i = Lx(n, r.toString({
                    children: !1
                  }), o))) return !1;
                  this.refCssRule(e, o, i);
                }

                return this.insertRules(r.rules, i), i;
              }

              var a = e.toString();
              if (!a) return !1;
              var s = Ux(n, t),
                  c = Lx(n, a, s);
              return !1 !== c && (this.hasInsertedRules = !0, this.refCssRule(e, s, c), c);
            }, t.refCssRule = function (e, t, n) {
              e.renderable = n, e.options.parent instanceof Sx && this.cssRules.splice(t, 0, n);
            }, t.deleteRule = function (e) {
              var t = this.element.sheet,
                  n = this.indexOf(e);
              return -1 !== n && (t.deleteRule(n), this.cssRules.splice(n, 1), !0);
            }, t.indexOf = function (e) {
              return this.cssRules.indexOf(e);
            }, t.replaceRule = function (e, t) {
              var n = this.indexOf(e);
              return -1 !== n && (this.element.sheet.deleteRule(n), this.cssRules.splice(n, 1), this.insertRule(t, n));
            }, t.getRules = function () {
              return this.element.sheet.cssRules;
            }, e;
          }(),
              Hx = 0,
              Vx = function () {
            function e(e) {
              this.id = Hx++, this.version = "10.9.0", this.plugins = new xx(), this.options = {
                id: {
                  minify: !1
                },
                createGenerateId: Tx,
                Renderer: TS ? Bx : null,
                plugins: []
              }, this.generateId = Tx({
                minify: !1
              });

              for (var t = 0; t < vx.length; t++) {
                this.plugins.use(vx[t], {
                  queue: "internal"
                });
              }

              this.setup(e);
            }

            var t = e.prototype;
            return t.setup = function (e) {
              return void 0 === e && (e = {}), e.createGenerateId && (this.options.createGenerateId = e.createGenerateId), e.id && (this.options.id = xy({}, this.options.id, e.id)), (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)), null != e.insertionPoint && (this.options.insertionPoint = e.insertionPoint), "Renderer" in e && (this.options.Renderer = e.Renderer), e.plugins && this.use.apply(this, e.plugins), this;
            }, t.createStyleSheet = function (e, t) {
              void 0 === t && (t = {});
              var n = t.index;
              "number" != typeof n && (n = 0 === Cx.index ? 0 : Cx.index + 1);
              var r = new Sx(e, xy({}, t, {
                jss: this,
                generateId: t.generateId || this.generateId,
                insertionPoint: this.options.insertionPoint,
                Renderer: this.options.Renderer,
                index: n
              }));
              return this.plugins.onProcessSheet(r), r;
            }, t.removeStyleSheet = function (e) {
              return e.detach(), Cx.remove(e), this;
            }, t.createRule = function (e, t, n) {
              if (void 0 === t && (t = {}), void 0 === n && (n = {}), "object" == typeof e) return this.createRule(void 0, e, t);
              var r = xy({}, n, {
                name: e,
                jss: this,
                Renderer: this.options.Renderer
              });
              r.generateId || (r.generateId = this.generateId), r.classes || (r.classes = {}), r.keyframes || (r.keyframes = {});
              var i = MS(e, t, r);
              return i && this.plugins.onProcessRule(i), i;
            }, t.use = function () {
              for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              return n.forEach(function (t) {
                e.plugins.use(t);
              }), this;
            }, e;
          }(),
              qx = function qx(e) {
            return new Vx(e);
          },
              Fx = "object" == typeof CSS && null != CSS && "number" in CSS;

          function Wx(e) {
            var t = null;

            for (var n in e) {
              var r = e[n],
                  i = typeof r;
              if ("function" === i) t || (t = {}), t[n] = r;else if ("object" === i && null !== r && !Array.isArray(r)) {
                var o = Wx(r);
                o && (t || (t = {}), t[n] = o);
              }
            }

            return t;
          }

          qx();

          var Gx = Date.now(),
              Kx = "fnValues" + Gx,
              Qx = "fnStyle" + ++Gx,
              Zx = function Zx() {
            return {
              onCreateRule: function onCreateRule(e, t, n) {
                if ("function" != typeof t) return null;
                var r = MS(e, {}, n);
                return r[Qx] = t, r;
              },
              onProcessStyle: function onProcessStyle(e, t) {
                if (Kx in t || Qx in t) return e;
                var n = {};

                for (var r in e) {
                  var i = e[r];
                  "function" == typeof i && (delete e[r], n[r] = i);
                }

                return t[Kx] = n, e;
              },
              onUpdate: function onUpdate(e, t, n, r) {
                var i = t,
                    o = i[Qx];
                o && (i.style = o(e) || {});
                var a = i[Kx];
                if (a) for (var s in a) {
                  i.prop(s, a[s](e), r);
                }
              }
            };
          },
              Yx = "@global",
              Jx = "@global ",
              $x = function () {
            function e(e, t, n) {
              for (var r in this.type = "global", this.at = Yx, this.isProcessed = !1, this.key = e, this.options = n, this.rules = new wx(xy({}, n, {
                parent: this
              })), t) {
                this.rules.add(r, t[r]);
              }

              this.rules.process();
            }

            var t = e.prototype;
            return t.getRule = function (e) {
              return this.rules.get(e);
            }, t.addRule = function (e, t, n) {
              var r = this.rules.add(e, t, n);
              return r && this.options.jss.plugins.onProcessRule(r), r;
            }, t.replaceRule = function (e, t, n) {
              var r = this.rules.replace(e, t, n);
              return r && this.options.jss.plugins.onProcessRule(r), r;
            }, t.indexOf = function (e) {
              return this.rules.indexOf(e);
            }, t.toString = function (e) {
              return this.rules.toString(e);
            }, e;
          }(),
              Xx = function () {
            function e(e, t, n) {
              this.type = "global", this.at = Yx, this.isProcessed = !1, this.key = e, this.options = n;
              var r = e.substr(Jx.length);
              this.rule = n.jss.createRule(r, t, xy({}, n, {
                parent: this
              }));
            }

            return e.prototype.toString = function (e) {
              return this.rule ? this.rule.toString(e) : "";
            }, e;
          }(),
              eE = /\s*,\s*/g;

          function tE(e, t) {
            for (var n = e.split(eE), r = "", i = 0; i < n.length; i++) {
              r += t + " " + n[i].trim(), n[i + 1] && (r += ", ");
            }

            return r;
          }

          function nE() {
            return {
              onCreateRule: function onCreateRule(e, t, n) {
                if (!e) return null;
                if (e === Yx) return new $x(e, t, n);
                if ("@" === e[0] && e.substr(0, Jx.length) === Jx) return new Xx(e, t, n);
                var r = n.parent;
                return r && ("global" === r.type || r.options.parent && "global" === r.options.parent.type) && (n.scoped = !1), n.selector || !1 !== n.scoped || (n.selector = e), null;
              },
              onProcessRule: function onProcessRule(e, t) {
                "style" === e.type && t && (function (e, t) {
                  var n = e.options,
                      r = e.style,
                      i = r ? r[Yx] : null;

                  if (i) {
                    for (var o in i) {
                      t.addRule(o, i[o], xy({}, n, {
                        selector: tE(o, e.selector)
                      }));
                    }

                    delete r[Yx];
                  }
                }(e, t), function (e, t) {
                  var n = e.options,
                      r = e.style;

                  for (var i in r) {
                    if ("@" === i[0] && i.substr(0, Yx.length) === Yx) {
                      var o = tE(i.substr(Yx.length), e.selector);
                      t.addRule(o, r[i], xy({}, n, {
                        selector: o
                      })), delete r[i];
                    }
                  }
                }(e, t));
              }
            };
          }

          var rE = /\s*,\s*/g,
              iE = /&/g,
              oE = /\$([\w-]+)/g;

          function aE() {
            function e(e, t) {
              return function (n, r) {
                var i = e.getRule(r) || t && t.getRule(r);
                return i ? i.selector : r;
              };
            }

            function t(e, t) {
              for (var n = t.split(rE), r = e.split(rE), i = "", o = 0; o < n.length; o++) {
                for (var a = n[o], s = 0; s < r.length; s++) {
                  var c = r[s];
                  i && (i += ", "), i += -1 !== c.indexOf("&") ? c.replace(iE, a) : a + " " + c;
                }
              }

              return i;
            }

            function n(e, t, n) {
              if (n) return xy({}, n, {
                index: n.index + 1
              });
              var r = e.options.nestingLevel;
              r = void 0 === r ? 1 : r + 1;
              var i = xy({}, e.options, {
                nestingLevel: r,
                index: t.indexOf(e) + 1
              });
              return delete i.name, i;
            }

            return {
              onProcessStyle: function onProcessStyle(r, i, o) {
                if ("style" !== i.type) return r;
                var a,
                    s,
                    c = i,
                    l = c.options.parent;

                for (var d in r) {
                  var u = -1 !== d.indexOf("&"),
                      p = "@" === d[0];

                  if (u || p) {
                    if (a = n(c, l, a), u) {
                      var h = t(d, c.selector);
                      s || (s = e(l, o)), h = h.replace(oE, s);

                      var _ = c.key + "-" + d;

                      "replaceRule" in l ? l.replaceRule(_, r[d], xy({}, a, {
                        selector: h
                      })) : l.addRule(_, r[d], xy({}, a, {
                        selector: h
                      }));
                    } else p && l.addRule(d, {}, a).addRule(c.key, r[d], {
                      selector: c.selector
                    });

                    delete r[d];
                  }
                }

                return r;
              }
            };
          }

          var sE = /[A-Z]/g,
              cE = /^ms-/,
              lE = {};

          function dE(e) {
            return "-" + e.toLowerCase();
          }

          function uE(e) {
            if (lE.hasOwnProperty(e)) return lE[e];
            var t = e.replace(sE, dE);
            return lE[e] = cE.test(t) ? "-" + t : t;
          }

          function pE(e) {
            var t = {};

            for (var n in e) {
              t[0 === n.indexOf("--") ? n : uE(n)] = e[n];
            }

            return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(pE) : t.fallbacks = pE(e.fallbacks)), t;
          }

          var hE = Fx && CSS ? CSS.px : "px",
              _E = Fx && CSS ? CSS.ms : "ms",
              fE = Fx && CSS ? CSS.percent : "%";

          function mE(e) {
            var t = /(-[a-z])/g,
                n = function n(e) {
              return e[1].toUpperCase();
            },
                r = {};

            for (var i in e) {
              r[i] = e[i], r[i.replace(t, n)] = e[i];
            }

            return r;
          }

          var gE = mE({
            "animation-delay": _E,
            "animation-duration": _E,
            "background-position": hE,
            "background-position-x": hE,
            "background-position-y": hE,
            "background-size": hE,
            border: hE,
            "border-bottom": hE,
            "border-bottom-left-radius": hE,
            "border-bottom-right-radius": hE,
            "border-bottom-width": hE,
            "border-left": hE,
            "border-left-width": hE,
            "border-radius": hE,
            "border-right": hE,
            "border-right-width": hE,
            "border-top": hE,
            "border-top-left-radius": hE,
            "border-top-right-radius": hE,
            "border-top-width": hE,
            "border-width": hE,
            "border-block": hE,
            "border-block-end": hE,
            "border-block-end-width": hE,
            "border-block-start": hE,
            "border-block-start-width": hE,
            "border-block-width": hE,
            "border-inline": hE,
            "border-inline-end": hE,
            "border-inline-end-width": hE,
            "border-inline-start": hE,
            "border-inline-start-width": hE,
            "border-inline-width": hE,
            "border-start-start-radius": hE,
            "border-start-end-radius": hE,
            "border-end-start-radius": hE,
            "border-end-end-radius": hE,
            margin: hE,
            "margin-bottom": hE,
            "margin-left": hE,
            "margin-right": hE,
            "margin-top": hE,
            "margin-block": hE,
            "margin-block-end": hE,
            "margin-block-start": hE,
            "margin-inline": hE,
            "margin-inline-end": hE,
            "margin-inline-start": hE,
            padding: hE,
            "padding-bottom": hE,
            "padding-left": hE,
            "padding-right": hE,
            "padding-top": hE,
            "padding-block": hE,
            "padding-block-end": hE,
            "padding-block-start": hE,
            "padding-inline": hE,
            "padding-inline-end": hE,
            "padding-inline-start": hE,
            "mask-position-x": hE,
            "mask-position-y": hE,
            "mask-size": hE,
            height: hE,
            width: hE,
            "min-height": hE,
            "max-height": hE,
            "min-width": hE,
            "max-width": hE,
            bottom: hE,
            left: hE,
            top: hE,
            right: hE,
            inset: hE,
            "inset-block": hE,
            "inset-block-end": hE,
            "inset-block-start": hE,
            "inset-inline": hE,
            "inset-inline-end": hE,
            "inset-inline-start": hE,
            "box-shadow": hE,
            "text-shadow": hE,
            "column-gap": hE,
            "column-rule": hE,
            "column-rule-width": hE,
            "column-width": hE,
            "font-size": hE,
            "font-size-delta": hE,
            "letter-spacing": hE,
            "text-decoration-thickness": hE,
            "text-indent": hE,
            "text-stroke": hE,
            "text-stroke-width": hE,
            "word-spacing": hE,
            motion: hE,
            "motion-offset": hE,
            outline: hE,
            "outline-offset": hE,
            "outline-width": hE,
            perspective: hE,
            "perspective-origin-x": fE,
            "perspective-origin-y": fE,
            "transform-origin": fE,
            "transform-origin-x": fE,
            "transform-origin-y": fE,
            "transform-origin-z": fE,
            "transition-delay": _E,
            "transition-duration": _E,
            "vertical-align": hE,
            "flex-basis": hE,
            "shape-margin": hE,
            size: hE,
            gap: hE,
            grid: hE,
            "grid-gap": hE,
            "row-gap": hE,
            "grid-row-gap": hE,
            "grid-column-gap": hE,
            "grid-template-rows": hE,
            "grid-template-columns": hE,
            "grid-auto-rows": hE,
            "grid-auto-columns": hE,
            "box-shadow-x": hE,
            "box-shadow-y": hE,
            "box-shadow-blur": hE,
            "box-shadow-spread": hE,
            "font-line-height": hE,
            "text-shadow-x": hE,
            "text-shadow-y": hE,
            "text-shadow-blur": hE
          });

          function vE(e, t, n) {
            if (null == t) return t;
            if (Array.isArray(t)) for (var r = 0; r < t.length; r++) {
              t[r] = vE(e, t[r], n);
            } else if ("object" == typeof t) {
              if ("fallbacks" === e) for (var i in t) {
                t[i] = vE(i, t[i], n);
              } else for (var o in t) {
                t[o] = vE(e + "-" + o, t[o], n);
              }
            } else if ("number" == typeof t && !1 === isNaN(t)) {
              var a = n[e] || gE[e];
              return !a || 0 === t && a === hE ? t.toString() : "function" == typeof a ? a(t).toString() : "" + t + a;
            }
            return t;
          }

          function bE(e) {
            void 0 === e && (e = {});
            var t = mE(e);
            return {
              onProcessStyle: function onProcessStyle(e, n) {
                if ("style" !== n.type) return e;

                for (var r in e) {
                  e[r] = vE(r, e[r], t);
                }

                return e;
              },
              onChangeValue: function onChangeValue(e, n) {
                return vE(n, e, t);
              }
            };
          }

          var yE = "",
              wE = "",
              SE = "",
              xE = "",
              EE = TS && "ontouchstart" in document.documentElement;

          if (TS) {
            var CE = {
              Moz: "-moz-",
              ms: "-ms-",
              O: "-o-",
              Webkit: "-webkit-"
            },
                kE = document.createElement("p").style;

            for (var AE in CE) {
              if (AE + "Transform" in kE) {
                yE = AE, wE = CE[AE];
                break;
              }
            }

            "Webkit" === yE && "msHyphens" in kE && (yE = "ms", wE = CE.ms, xE = "edge"), "Webkit" === yE && "-apple-trailing-word" in kE && (SE = "apple");
          }

          var IE = yE,
              TE = wE,
              OE = SE,
              RE = xE,
              NE = EE,
              PE = {
            noPrefill: ["appearance"],
            supportedProperty: function supportedProperty(e) {
              return "appearance" === e && ("ms" === IE ? "-webkit-" + e : TE + e);
            }
          },
              jE = {
            noPrefill: ["color-adjust"],
            supportedProperty: function supportedProperty(e) {
              return "color-adjust" === e && ("Webkit" === IE ? TE + "print-" + e : e);
            }
          },
              DE = /[-\s]+(.)?/g;

          function zE(e, t) {
            return t ? t.toUpperCase() : "";
          }

          function ME(e) {
            return e.replace(DE, zE);
          }

          function LE(e) {
            return ME("-" + e);
          }

          var UE,
              BE = {
            noPrefill: ["mask"],
            supportedProperty: function supportedProperty(e, t) {
              if (!/^mask/.test(e)) return !1;

              if ("Webkit" === IE) {
                var n = "mask-image";
                if (ME(n) in t) return e;
                if (IE + LE(n) in t) return TE + e;
              }

              return e;
            }
          },
              HE = {
            noPrefill: ["text-orientation"],
            supportedProperty: function supportedProperty(e) {
              return "text-orientation" === e && ("apple" !== OE || NE ? e : TE + e);
            }
          },
              VE = {
            noPrefill: ["transform"],
            supportedProperty: function supportedProperty(e, t, n) {
              return "transform" === e && (n.transform ? e : TE + e);
            }
          },
              qE = {
            noPrefill: ["transition"],
            supportedProperty: function supportedProperty(e, t, n) {
              return "transition" === e && (n.transition ? e : TE + e);
            }
          },
              FE = {
            noPrefill: ["writing-mode"],
            supportedProperty: function supportedProperty(e) {
              return "writing-mode" === e && ("Webkit" === IE || "ms" === IE && "edge" !== RE ? TE + e : e);
            }
          },
              WE = {
            noPrefill: ["user-select"],
            supportedProperty: function supportedProperty(e) {
              return "user-select" === e && ("Moz" === IE || "ms" === IE || "apple" === OE ? TE + e : e);
            }
          },
              GE = {
            supportedProperty: function supportedProperty(e, t) {
              return !!/^break-/.test(e) && ("Webkit" === IE ? "WebkitColumn" + LE(e) in t && TE + "column-" + e : "Moz" === IE && "page" + LE(e) in t && "page-" + e);
            }
          },
              KE = {
            supportedProperty: function supportedProperty(e, t) {
              if (!/^(border|margin|padding)-inline/.test(e)) return !1;
              if ("Moz" === IE) return e;
              var n = e.replace("-inline", "");
              return IE + LE(n) in t && TE + n;
            }
          },
              QE = {
            supportedProperty: function supportedProperty(e, t) {
              return ME(e) in t && e;
            }
          },
              ZE = {
            supportedProperty: function supportedProperty(e, t) {
              var n = LE(e);
              return "-" === e[0] || "-" === e[0] && "-" === e[1] ? e : IE + n in t ? TE + e : "Webkit" !== IE && "Webkit" + n in t && "-webkit-" + e;
            }
          },
              YE = {
            supportedProperty: function supportedProperty(e) {
              return "scroll-snap" === e.substring(0, 11) && ("ms" === IE ? "" + TE + e : e);
            }
          },
              JE = {
            supportedProperty: function supportedProperty(e) {
              return "overscroll-behavior" === e && ("ms" === IE ? TE + "scroll-chaining" : e);
            }
          },
              $E = {
            "flex-grow": "flex-positive",
            "flex-shrink": "flex-negative",
            "flex-basis": "flex-preferred-size",
            "justify-content": "flex-pack",
            order: "flex-order",
            "align-items": "flex-align",
            "align-content": "flex-line-pack"
          },
              XE = {
            supportedProperty: function supportedProperty(e, t) {
              var n = $E[e];
              return !!n && IE + LE(n) in t && TE + n;
            }
          },
              eC = {
            flex: "box-flex",
            "flex-grow": "box-flex",
            "flex-direction": ["box-orient", "box-direction"],
            order: "box-ordinal-group",
            "align-items": "box-align",
            "flex-flow": ["box-orient", "box-direction"],
            "justify-content": "box-pack"
          },
              tC = Object.keys(eC),
              nC = function nC(e) {
            return TE + e;
          },
              rC = {
            supportedProperty: function supportedProperty(e, t, n) {
              var r = n.multiple;

              if (tC.indexOf(e) > -1) {
                var i = eC[e];
                if (!Array.isArray(i)) return IE + LE(i) in t && TE + i;
                if (!r) return !1;

                for (var o = 0; o < i.length; o++) {
                  if (!(IE + LE(i[0]) in t)) return !1;
                }

                return i.map(nC);
              }

              return !1;
            }
          },
              iC = [PE, jE, BE, HE, VE, qE, FE, WE, GE, KE, QE, ZE, YE, JE, XE, rC],
              oC = iC.filter(function (e) {
            return e.supportedProperty;
          }).map(function (e) {
            return e.supportedProperty;
          }),
              aC = iC.filter(function (e) {
            return e.noPrefill;
          }).reduce(function (e, t) {
            return e.push.apply(e, Mw(t.noPrefill)), e;
          }, []),
              sC = {};

          if (TS) {
            UE = document.createElement("p");
            var cC = window.getComputedStyle(document.documentElement, "");

            for (var lC in cC) {
              isNaN(lC) || (sC[cC[lC]] = cC[lC]);
            }

            aC.forEach(function (e) {
              return delete sC[e];
            });
          }

          function dC(e, t) {
            if (void 0 === t && (t = {}), !UE) return e;
            if (null != sC[e]) return sC[e];
            "transition" !== e && "transform" !== e || (t[e] = e in UE.style);

            for (var n = 0; n < oC.length && (sC[e] = oC[n](e, UE.style, t), !sC[e]); n++) {
              ;
            }

            try {
              UE.style[e] = "";
            } catch (e) {
              return !1;
            }

            return sC[e];
          }

          var uC,
              pC = {},
              hC = {
            transition: 1,
            "transition-property": 1,
            "-webkit-transition": 1,
            "-webkit-transition-property": 1
          },
              _C = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;

          function fC(e, t, n) {
            return "var" === t ? "var" : "all" === t ? "all" : "all" === n ? ", all" : (t ? dC(t) : ", " + dC(n)) || t || n;
          }

          function mC(e, t) {
            var n = t;
            if (!uC || "content" === e) return t;
            if ("string" != typeof n || !isNaN(parseInt(n, 10))) return n;
            var r = e + n;
            if (null != pC[r]) return pC[r];

            try {
              uC.style[e] = n;
            } catch (e) {
              return pC[r] = !1, !1;
            }

            if (hC[e]) n = n.replace(_C, fC);else if ("" === uC.style[e] && ("-ms-flex" === (n = TE + n) && (uC.style[e] = "-ms-flexbox"), uC.style[e] = n, "" === uC.style[e])) return pC[r] = !1, !1;
            return uC.style[e] = "", pC[r] = n, pC[r];
          }

          function gC() {
            function e(t) {
              for (var n in t) {
                var r = t[n];
                if ("fallbacks" === n && Array.isArray(r)) t[n] = r.map(e);else {
                  var i = !1,
                      o = dC(n);
                  o && o !== n && (i = !0);
                  var a = !1,
                      s = mC(o, US(r));
                  s && s !== r && (a = !0), (i || a) && (i && delete t[n], t[o || n] = s || r);
                }
              }

              return t;
            }

            return {
              onProcessRule: function onProcessRule(e) {
                if ("keyframes" === e.type) {
                  var t = e;

                  t.at = function (e) {
                    return "-" === e[1] || "ms" === IE ? e : "@" + TE + "keyframes" + e.substr(10);
                  }(t.at);
                }
              },
              onProcessStyle: function onProcessStyle(t, n) {
                return "style" !== n.type ? t : e(t);
              },
              onChangeValue: function onChangeValue(e, t) {
                return mC(t, US(e)) || e;
              }
            };
          }

          function vC() {
            return {
              plugins: [Zx(), nE(), aE(), {
                onProcessStyle: function onProcessStyle(e) {
                  if (Array.isArray(e)) {
                    for (var t = 0; t < e.length; t++) {
                      e[t] = pE(e[t]);
                    }

                    return e;
                  }

                  return pE(e);
                },
                onChangeValue: function onChangeValue(e, t, n) {
                  if (0 === t.indexOf("--")) return e;
                  var r = uE(t);
                  return t === r ? e : (n.prop(r, e), null);
                }
              }, bE(), "undefined" == typeof window ? null : gC(), (e = function e(_e282, t) {
                return _e282.length === t.length ? _e282 > t ? 1 : -1 : _e282.length - t.length;
              }, {
                onProcessStyle: function onProcessStyle(t, n) {
                  if ("style" !== n.type) return t;

                  for (var r = {}, i = Object.keys(t).sort(e), o = 0; o < i.length; o++) {
                    r[i[o]] = t[i[o]];
                  }

                  return r;
                }
              })]
            };
            var e;
          }

          function bC() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.baseClasses,
                n = e.newClasses;
            if (e.Component, !n) return t;
            var r = xy({}, t);
            return Object.keys(n).forEach(function (e) {
              n[e] && (r[e] = "".concat(t[e], " ").concat(n[e]));
            }), r;
          }

          TS && (uC = document.createElement("p"));
          var yC = {
            set: function set(e, t, n, r) {
              var i = e.get(t);
              i || (i = new Map(), e.set(t, i)), i.set(n, r);
            },
            get: function get(e, t, n) {
              var r = e.get(t);
              return r ? r.get(n) : void 0;
            },
            delete: function _delete(e, t, n) {
              e.get(t).delete(n);
            }
          },
              wC = yC,
              SC = a.default.createContext(null);

          function xC() {
            return a.default.useContext(SC);
          }

          var EC,
              CC = qx(vC()),
              kC = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.disableGlobal,
                n = void 0 !== t && t,
                r = e.productionPrefix,
                i = void 0 === r ? "jss" : r,
                o = e.seed,
                a = void 0 === o ? "" : o,
                s = "" === a ? "" : "".concat(a, "-"),
                c = 0,
                l = function l() {
              return c += 1;
            };

            return function (e, t) {
              var r = t.options.name;

              if (r && 0 === r.indexOf("Mui") && !t.options.link && !n) {
                if (-1 !== kS.indexOf(e.key)) return "Mui-".concat(e.key);
                var o = "".concat(s).concat(r, "-").concat(e.key);
                return t.options.theme[CS] && "" === a ? "".concat(o, "-").concat(l()) : o;
              }

              return "".concat(s).concat(i).concat(l());
            };
          }(),
              AC = {
            disableGeneration: !1,
            generateClassName: kC,
            jss: CC,
            sheetsCache: null,
            sheetsManager: new Map(),
            sheetsRegistry: null
          },
              IC = a.default.createContext(AC);

          function TC(e) {
            var t = e.children,
                n = e.injectFirst,
                r = void 0 !== n && n,
                i = e.disableGeneration,
                o = void 0 !== i && i,
                s = bw(e, ["children", "injectFirst", "disableGeneration"]),
                c = xy({}, a.default.useContext(IC), {
              disableGeneration: o
            }, s);

            if (!c.jss.options.insertionPoint && r && "undefined" != typeof window) {
              if (!EC) {
                var l = document.head;
                EC = document.createComment("mui-inject-first"), l.insertBefore(EC, l.firstChild);
              }

              c.jss = qx({
                plugins: vC().plugins,
                insertionPoint: EC
              });
            }

            return a.default.createElement(IC.Provider, {
              value: c
            }, t);
          }

          var OC = -1e9;

          function RC() {
            return OC += 1;
          }

          var NC = {};

          function PC(e) {
            var t = "function" == typeof e;
            return {
              create: function create(n, r) {
                var i;

                try {
                  i = t ? e(n) : e;
                } catch (e) {
                  throw e;
                }

                if (!r || !n.overrides || !n.overrides[r]) return i;
                var o = n.overrides[r],
                    a = xy({}, i);
                return Object.keys(o).forEach(function (e) {
                  a[e] = ky(a[e], o[e]);
                }), a;
              },
              options: {}
            };
          }

          function jC(e, t, n) {
            var r = e.state;
            if (e.stylesOptions.disableGeneration) return t || {};
            r.cacheClasses || (r.cacheClasses = {
              value: null,
              lastProp: null,
              lastJSS: {}
            });
            var i = !1;
            return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, i = !0), t !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = t, i = !0), i && (r.cacheClasses.value = bC({
              baseClasses: r.cacheClasses.lastJSS,
              newClasses: t,
              Component: n
            })), r.cacheClasses.value;
          }

          function DC(e, t) {
            var n = e.state,
                r = e.theme,
                i = e.stylesOptions,
                o = e.stylesCreator,
                a = e.name;

            if (!i.disableGeneration) {
              var s = wC.get(i.sheetsManager, o, r);
              s || (s = {
                refs: 0,
                staticSheet: null,
                dynamicStyles: null
              }, wC.set(i.sheetsManager, o, r, s));
              var c = xy({}, o.options, i, {
                theme: r,
                flip: "boolean" == typeof i.flip ? i.flip : "rtl" === r.direction
              });
              c.generateId = c.serverGenerateClassName || c.generateClassName;
              var l = i.sheetsRegistry;

              if (0 === s.refs) {
                var d;
                i.sheetsCache && (d = wC.get(i.sheetsCache, o, r));
                var u = o.create(r, a);
                d || ((d = i.jss.createStyleSheet(u, xy({
                  link: !1
                }, c))).attach(), i.sheetsCache && wC.set(i.sheetsCache, o, r, d)), l && l.add(d), s.staticSheet = d, s.dynamicStyles = Wx(u);
              }

              if (s.dynamicStyles) {
                var p = i.jss.createStyleSheet(s.dynamicStyles, xy({
                  link: !0
                }, c));
                p.update(t), p.attach(), n.dynamicSheet = p, n.classes = bC({
                  baseClasses: s.staticSheet.classes,
                  newClasses: p.classes
                }), l && l.add(p);
              } else n.classes = s.staticSheet.classes;

              s.refs += 1;
            }
          }

          function zC(e, t) {
            var n = e.state;
            n.dynamicSheet && n.dynamicSheet.update(t);
          }

          function MC(e) {
            var t = e.state,
                n = e.theme,
                r = e.stylesOptions,
                i = e.stylesCreator;

            if (!r.disableGeneration) {
              var o = wC.get(r.sheetsManager, i, n);
              o.refs -= 1;
              var a = r.sheetsRegistry;
              0 === o.refs && (wC.delete(r.sheetsManager, i, n), r.jss.removeStyleSheet(o.staticSheet), a && a.remove(o.staticSheet)), t.dynamicSheet && (r.jss.removeStyleSheet(t.dynamicSheet), a && a.remove(t.dynamicSheet));
            }
          }

          function LC(e, t) {
            var n,
                r = a.default.useRef([]),
                i = a.default.useMemo(function () {
              return {};
            }, t);
            r.current !== i && (r.current = i, n = e()), a.default.useEffect(function () {
              return function () {
                n && n();
              };
            }, [i]);
          }

          function UC(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = t.name,
                r = t.classNamePrefix,
                i = t.Component,
                o = t.defaultTheme,
                s = void 0 === o ? NC : o,
                c = bw(t, ["name", "classNamePrefix", "Component", "defaultTheme"]),
                l = PC(e),
                d = n || r || "makeStyles";
            l.options = {
              index: RC(),
              name: n,
              meta: d,
              classNamePrefix: d
            };

            var u = function u() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t = xC() || s,
                  r = xy({}, a.default.useContext(IC), c),
                  o = a.default.useRef(),
                  d = a.default.useRef();
              return LC(function () {
                var i = {
                  name: n,
                  state: {},
                  stylesCreator: l,
                  stylesOptions: r,
                  theme: t
                };
                return DC(i, e), d.current = !1, o.current = i, function () {
                  MC(i);
                };
              }, [t, l]), a.default.useEffect(function () {
                d.current && zC(o.current, e), d.current = !0;
              }), jC(o.current, e.classes, i);
            };

            return u;
          }

          function BC(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }

          function HC(e) {
            var t,
                n,
                r = "";
            if ("string" == typeof e || "number" == typeof e) r += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
              e[t] && (n = HC(e[t])) && (r && (r += " "), r += n);
            } else for (t in e) {
              e[t] && (r && (r += " "), r += t);
            }
            return r;
          }

          function VC() {
            for (var e, t, n = 0, r = ""; n < arguments.length;) {
              (e = arguments[n++]) && (t = HC(e)) && (r && (r += " "), r += t);
            }

            return r;
          }

          var qC = Object.freeze({
            __proto__: null,
            default: VC
          }),
              FC = {
            exports: {}
          },
              WC = {},
              GC = "function" == typeof Symbol && Symbol.for,
              KC = GC ? Symbol.for("react.element") : 60103,
              QC = GC ? Symbol.for("react.portal") : 60106,
              ZC = GC ? Symbol.for("react.fragment") : 60107,
              YC = GC ? Symbol.for("react.strict_mode") : 60108,
              JC = GC ? Symbol.for("react.profiler") : 60114,
              $C = GC ? Symbol.for("react.provider") : 60109,
              XC = GC ? Symbol.for("react.context") : 60110,
              ek = GC ? Symbol.for("react.async_mode") : 60111,
              tk = GC ? Symbol.for("react.concurrent_mode") : 60111,
              nk = GC ? Symbol.for("react.forward_ref") : 60112,
              rk = GC ? Symbol.for("react.suspense") : 60113,
              ik = GC ? Symbol.for("react.suspense_list") : 60120,
              ok = GC ? Symbol.for("react.memo") : 60115,
              ak = GC ? Symbol.for("react.lazy") : 60116,
              sk = GC ? Symbol.for("react.block") : 60121,
              ck = GC ? Symbol.for("react.fundamental") : 60117,
              lk = GC ? Symbol.for("react.responder") : 60118,
              dk = GC ? Symbol.for("react.scope") : 60119;

          function uk(e) {
            if ("object" == typeof e && null !== e) {
              var t = e.$$typeof;

              switch (t) {
                case KC:
                  switch (e = e.type) {
                    case ek:
                    case tk:
                    case ZC:
                    case JC:
                    case YC:
                    case rk:
                      return e;

                    default:
                      switch (e = e && e.$$typeof) {
                        case XC:
                        case nk:
                        case ak:
                        case ok:
                        case $C:
                          return e;

                        default:
                          return t;
                      }

                  }

                case QC:
                  return t;
              }
            }
          }

          function pk(e) {
            return uk(e) === tk;
          }

          WC.AsyncMode = ek, WC.ConcurrentMode = tk, WC.ContextConsumer = XC, WC.ContextProvider = $C, WC.Element = KC, WC.ForwardRef = nk, WC.Fragment = ZC, WC.Lazy = ak, WC.Memo = ok, WC.Portal = QC, WC.Profiler = JC, WC.StrictMode = YC, WC.Suspense = rk, WC.isAsyncMode = function (e) {
            return pk(e) || uk(e) === ek;
          }, WC.isConcurrentMode = pk, WC.isContextConsumer = function (e) {
            return uk(e) === XC;
          }, WC.isContextProvider = function (e) {
            return uk(e) === $C;
          }, WC.isElement = function (e) {
            return "object" == typeof e && null !== e && e.$$typeof === KC;
          }, WC.isForwardRef = function (e) {
            return uk(e) === nk;
          }, WC.isFragment = function (e) {
            return uk(e) === ZC;
          }, WC.isLazy = function (e) {
            return uk(e) === ak;
          }, WC.isMemo = function (e) {
            return uk(e) === ok;
          }, WC.isPortal = function (e) {
            return uk(e) === QC;
          }, WC.isProfiler = function (e) {
            return uk(e) === JC;
          }, WC.isStrictMode = function (e) {
            return uk(e) === YC;
          }, WC.isSuspense = function (e) {
            return uk(e) === rk;
          }, WC.isValidElementType = function (e) {
            return "string" == typeof e || "function" == typeof e || e === ZC || e === tk || e === JC || e === YC || e === rk || e === ik || "object" == typeof e && null !== e && (e.$$typeof === ak || e.$$typeof === ok || e.$$typeof === $C || e.$$typeof === XC || e.$$typeof === nk || e.$$typeof === ck || e.$$typeof === lk || e.$$typeof === dk || e.$$typeof === sk);
          }, WC.typeOf = uk, FC.exports = WC;
          var hk = FC.exports,
              _k = {
            childContextTypes: !0,
            contextType: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            getDerivedStateFromError: !0,
            getDerivedStateFromProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0
          },
              fk = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            callee: !0,
            arguments: !0,
            arity: !0
          },
              mk = {
            $$typeof: !0,
            compare: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0,
            type: !0
          },
              gk = {};

          function vk(e) {
            return hk.isMemo(e) ? mk : gk[e.$$typeof] || _k;
          }

          gk[hk.ForwardRef] = {
            $$typeof: !0,
            render: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0
          }, gk[hk.Memo] = mk;

          var bk = Object.defineProperty,
              yk = Object.getOwnPropertyNames,
              wk = Object.getOwnPropertySymbols,
              Sk = Object.getOwnPropertyDescriptor,
              xk = Object.getPrototypeOf,
              Ek = Object.prototype,
              Ck = function e(t, n, r) {
            if ("string" != typeof n) {
              if (Ek) {
                var i = xk(n);
                i && i !== Ek && e(t, i, r);
              }

              var o = yk(n);
              wk && (o = o.concat(wk(n)));

              for (var a = vk(t), s = vk(n), c = 0; c < o.length; ++c) {
                var l = o[c];

                if (!(fk[l] || r && r[l] || s && s[l] || a && a[l])) {
                  var d = Sk(n, l);

                  try {
                    bk(t, l, d);
                  } catch (e) {}
                }
              }
            }

            return t;
          };

          function kk(e, t) {
            var n = {};
            return Object.keys(e).forEach(function (r) {
              -1 === t.indexOf(r) && (n[r] = e[r]);
            }), n;
          }

          function Ak(e) {
            var t = e.children,
                n = e.theme,
                r = xC(),
                i = a.default.useMemo(function () {
              var e = null === r ? n : function (e, t) {
                return "function" == typeof t ? t(e) : xy({}, e, t);
              }(r, n);
              return null != e && (e[CS] = null !== r), e;
            }, [n, r]);
            return a.default.createElement(SC.Provider, {
              value: i
            }, t);
          }

          var Ik = function Ik(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return function (n) {
              var r = t.defaultTheme,
                  i = t.withTheme,
                  o = void 0 !== i && i,
                  s = t.name,
                  c = bw(t, ["defaultTheme", "withTheme", "name"]),
                  l = s,
                  d = UC(e, xy({
                defaultTheme: r,
                Component: n,
                name: s || n.displayName,
                classNamePrefix: l
              }, c)),
                  u = a.default.forwardRef(function (e, t) {
                e.classes;
                var i,
                    c = e.innerRef,
                    l = bw(e, ["classes", "innerRef"]),
                    u = d(xy({}, n.defaultProps, e)),
                    p = l;
                return ("string" == typeof s || o) && (i = xC() || r, s && (p = AS({
                  theme: i,
                  name: s,
                  props: l
                })), o && !p.theme && (p.theme = i)), a.default.createElement(n, xy({
                  ref: c || t,
                  classes: u
                }, p));
              });
              return Ck(u, n), u;
            };
          },
              Tk = ES();

          function Ok(e) {
            return UC(e, xy({
              defaultTheme: Tk
            }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}));
          }

          var Rk = function Rk(e) {
            var t = function (e) {
              return function (t) {
                var n,
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    i = r.name,
                    o = bw(r, ["name"]),
                    s = i,
                    c = "function" == typeof t ? function (e) {
                  return {
                    root: function root(n) {
                      return t(xy({
                        theme: e
                      }, n));
                    }
                  };
                } : {
                  root: t
                },
                    l = UC(c, xy({
                  Component: e,
                  name: i || e.displayName,
                  classNamePrefix: s
                }, o));
                t.filterProps && (n = t.filterProps, delete t.filterProps), t.propTypes && delete t.propTypes;
                var d = a.default.forwardRef(function (t, r) {
                  var i = t.children,
                      o = t.className,
                      s = t.clone,
                      c = t.component,
                      d = bw(t, ["children", "className", "clone", "component"]),
                      u = VC(l(t).root, o),
                      p = d;
                  if (n && (p = kk(p, n)), s) return a.default.cloneElement(i, xy({
                    className: VC(i.props.className, u)
                  }, p));
                  if ("function" == typeof i) return i(xy({
                    className: u
                  }, p));
                  var h = c || e;
                  return a.default.createElement(h, xy({
                    ref: r,
                    className: u
                  }, p), i);
                });
                return Ck(d, e), d;
              };
            }(e);

            return function (e, n) {
              return t(e, xy({
                defaultTheme: Tk
              }, n));
            };
          };

          function Nk() {
            return xC() || Tk;
          }

          function Pk(e, t) {
            return Ik(e, xy({
              defaultTheme: Tk
            }, t));
          }

          function jk(e) {
            if ("string" != typeof e) throw new Error(jy(7));
            return e.charAt(0).toUpperCase() + e.slice(1);
          }

          function Dk() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return t.reduce(function (e, t) {
              return null == t ? e : function () {
                for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
                  r[i] = arguments[i];
                }

                e.apply(this, r), t.apply(this, r);
              };
            }, function () {});
          }

          var zk = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.color,
                a = void 0 === o ? "inherit" : o,
                c = e.component,
                l = void 0 === c ? "svg" : c,
                d = e.fontSize,
                u = void 0 === d ? "medium" : d,
                p = e.htmlColor,
                h = e.titleAccess,
                _ = e.viewBox,
                f = void 0 === _ ? "0 0 24 24" : _,
                m = bw(e, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
            return s.createElement(l, xy({
              className: VC(r.root, i, "inherit" !== a && r["color".concat(jk(a))], "default" !== u && "medium" !== u && r["fontSize".concat(jk(u))]),
              focusable: "false",
              viewBox: f,
              color: p,
              "aria-hidden": !h || void 0,
              role: h ? "img" : void 0,
              ref: t
            }, m), n, h ? s.createElement("title", null, h) : null);
          });
          zk.muiName = "SvgIcon";
          var Mk = Pk(function (e) {
            return {
              root: {
                userSelect: "none",
                width: "1em",
                height: "1em",
                display: "inline-block",
                fill: "currentColor",
                flexShrink: 0,
                fontSize: e.typography.pxToRem(24),
                transition: e.transitions.create("fill", {
                  duration: e.transitions.duration.shorter
                })
              },
              colorPrimary: {
                color: e.palette.primary.main
              },
              colorSecondary: {
                color: e.palette.secondary.main
              },
              colorAction: {
                color: e.palette.action.active
              },
              colorError: {
                color: e.palette.error.main
              },
              colorDisabled: {
                color: e.palette.action.disabled
              },
              fontSizeInherit: {
                fontSize: "inherit"
              },
              fontSizeSmall: {
                fontSize: e.typography.pxToRem(20)
              },
              fontSizeLarge: {
                fontSize: e.typography.pxToRem(35)
              }
            };
          }, {
            name: "MuiSvgIcon"
          })(zk);

          function Lk(e, t) {
            var n = function n(t, _n88) {
              return a.default.createElement(Mk, xy({
                ref: _n88
              }, t), e);
            };

            return n.muiName = Mk.muiName, a.default.memo(a.default.forwardRef(n));
          }

          function Uk(e) {
            var t,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 166;

            function r() {
              for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
                i[o] = arguments[o];
              }

              var a = this,
                  s = function s() {
                e.apply(a, i);
              };

              clearTimeout(t), t = setTimeout(s, n);
            }

            return r.clear = function () {
              clearTimeout(t);
            }, r;
          }

          function Bk(e, t) {
            return s.isValidElement(e) && -1 !== t.indexOf(e.type.muiName);
          }

          function Hk(e) {
            return e && e.ownerDocument || document;
          }

          function Vk(e) {
            return Hk(e).defaultView || window;
          }

          function qk(e, t) {
            "function" == typeof e ? e(t) : e && (e.current = t);
          }

          function Fk(e) {
            var t = e.controlled,
                n = e.default;
            e.name, e.state;
            var r = s.useRef(void 0 !== t).current,
                i = s.useState(n),
                o = i[0],
                a = i[1];
            return [r ? t : o, s.useCallback(function (e) {
              r || a(e);
            }, [])];
          }

          var Wk = "undefined" != typeof window ? s.useLayoutEffect : s.useEffect;

          function Gk(e) {
            var t = s.useRef(e);
            return Wk(function () {
              t.current = e;
            }), s.useCallback(function () {
              return t.current.apply(void 0, arguments);
            }, []);
          }

          function Kk(e, t) {
            return s.useMemo(function () {
              return null == e && null == t ? null : function (n) {
                qk(e, n), qk(t, n);
              };
            }, [e, t]);
          }

          function Qk(e) {
            var t = s.useState(e),
                n = t[0],
                r = t[1],
                i = e || n;
            return s.useEffect(function () {
              null == n && r("mui-".concat(Math.round(1e5 * Math.random())));
            }, [n]), i;
          }

          var Zk = !0,
              Yk = !1,
              Jk = null,
              $k = {
            text: !0,
            search: !0,
            url: !0,
            tel: !0,
            email: !0,
            password: !0,
            number: !0,
            date: !0,
            month: !0,
            week: !0,
            time: !0,
            datetime: !0,
            "datetime-local": !0
          };

          function Xk(e) {
            e.metaKey || e.altKey || e.ctrlKey || (Zk = !0);
          }

          function eA() {
            Zk = !1;
          }

          function tA() {
            "hidden" === this.visibilityState && Yk && (Zk = !0);
          }

          function nA(e) {
            var t,
                n,
                r,
                i = e.target;

            try {
              return i.matches(":focus-visible");
            } catch (e) {}

            return Zk || (n = (t = i).type, !("INPUT" !== (r = t.tagName) || !$k[n] || t.readOnly) || "TEXTAREA" === r && !t.readOnly || !!t.isContentEditable);
          }

          function rA() {
            Yk = !0, window.clearTimeout(Jk), Jk = window.setTimeout(function () {
              Yk = !1;
            }, 100);
          }

          function iA() {
            return {
              isFocusVisible: nA,
              onBlurVisible: rA,
              ref: s.useCallback(function (e) {
                var t,
                    n = c.findDOMNode(e);
                null != n && ((t = n.ownerDocument).addEventListener("keydown", Xk, !0), t.addEventListener("mousedown", eA, !0), t.addEventListener("pointerdown", eA, !0), t.addEventListener("touchstart", eA, !0), t.addEventListener("visibilitychange", tA, !0));
              }, [])
            };
          }

          var oA = !1,
              aA = a.default.createContext(null),
              sA = "unmounted",
              cA = "exited",
              lA = "entering",
              dA = "entered",
              uA = "exiting",
              pA = function (e) {
            function t(t, n) {
              var r;
              r = e.call(this, t, n) || this;
              var i,
                  o = n && !n.isMounting ? t.enter : t.appear;
              return r.appearStatus = null, t.in ? o ? (i = cA, r.appearStatus = lA) : i = dA : i = t.unmountOnExit || t.mountOnEnter ? sA : cA, r.state = {
                status: i
              }, r.nextCallback = null, r;
            }

            PS(t, e), t.getDerivedStateFromProps = function (e, t) {
              return e.in && t.status === sA ? {
                status: cA
              } : null;
            };
            var n = t.prototype;
            return n.componentDidMount = function () {
              this.updateStatus(!0, this.appearStatus);
            }, n.componentDidUpdate = function (e) {
              var t = null;

              if (e !== this.props) {
                var n = this.state.status;
                this.props.in ? n !== lA && n !== dA && (t = lA) : n !== lA && n !== dA || (t = uA);
              }

              this.updateStatus(!1, t);
            }, n.componentWillUnmount = function () {
              this.cancelNextCallback();
            }, n.getTimeouts = function () {
              var e,
                  t,
                  n,
                  r = this.props.timeout;
              return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
                exit: e,
                enter: t,
                appear: n
              };
            }, n.updateStatus = function (e, t) {
              void 0 === e && (e = !1), null !== t ? (this.cancelNextCallback(), t === lA ? this.performEnter(e) : this.performExit()) : this.props.unmountOnExit && this.state.status === cA && this.setState({
                status: sA
              });
            }, n.performEnter = function (e) {
              var t = this,
                  n = this.props.enter,
                  r = this.context ? this.context.isMounting : e,
                  i = this.props.nodeRef ? [r] : [l.default.findDOMNode(this), r],
                  o = i[0],
                  a = i[1],
                  s = this.getTimeouts(),
                  c = r ? s.appear : s.enter;
              !e && !n || oA ? this.safeSetState({
                status: dA
              }, function () {
                t.props.onEntered(o);
              }) : (this.props.onEnter(o, a), this.safeSetState({
                status: lA
              }, function () {
                t.props.onEntering(o, a), t.onTransitionEnd(c, function () {
                  t.safeSetState({
                    status: dA
                  }, function () {
                    t.props.onEntered(o, a);
                  });
                });
              }));
            }, n.performExit = function () {
              var e = this,
                  t = this.props.exit,
                  n = this.getTimeouts(),
                  r = this.props.nodeRef ? void 0 : l.default.findDOMNode(this);
              t && !oA ? (this.props.onExit(r), this.safeSetState({
                status: uA
              }, function () {
                e.props.onExiting(r), e.onTransitionEnd(n.exit, function () {
                  e.safeSetState({
                    status: cA
                  }, function () {
                    e.props.onExited(r);
                  });
                });
              })) : this.safeSetState({
                status: cA
              }, function () {
                e.props.onExited(r);
              });
            }, n.cancelNextCallback = function () {
              null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
            }, n.safeSetState = function (e, t) {
              t = this.setNextCallback(t), this.setState(e, t);
            }, n.setNextCallback = function (e) {
              var t = this,
                  n = !0;
              return this.nextCallback = function (r) {
                n && (n = !1, t.nextCallback = null, e(r));
              }, this.nextCallback.cancel = function () {
                n = !1;
              }, this.nextCallback;
            }, n.onTransitionEnd = function (e, t) {
              this.setNextCallback(t);
              var n = this.props.nodeRef ? this.props.nodeRef.current : l.default.findDOMNode(this),
                  r = null == e && !this.props.addEndListener;

              if (n && !r) {
                if (this.props.addEndListener) {
                  var i = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback],
                      o = i[0],
                      a = i[1];
                  this.props.addEndListener(o, a);
                }

                null != e && setTimeout(this.nextCallback, e);
              } else setTimeout(this.nextCallback, 0);
            }, n.render = function () {
              var e = this.state.status;
              if (e === sA) return null;
              var t = this.props,
                  n = t.children;
              t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef;
              var r = vw(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
              return a.default.createElement(aA.Provider, {
                value: null
              }, "function" == typeof n ? n(e, r) : a.default.cloneElement(a.default.Children.only(n), r));
            }, t;
          }(a.default.Component);

          function hA() {}

          pA.contextType = aA, pA.propTypes = {}, pA.defaultProps = {
            in: !1,
            mountOnEnter: !1,
            unmountOnExit: !1,
            appear: !1,
            enter: !0,
            exit: !0,
            onEnter: hA,
            onEntering: hA,
            onEntered: hA,
            onExit: hA,
            onExiting: hA,
            onExited: hA
          }, pA.UNMOUNTED = sA, pA.EXITED = cA, pA.ENTERING = lA, pA.ENTERED = dA, pA.EXITING = uA;
          var _A = pA;

          function fA(t, n) {
            var r = Object.create(null);
            return t && e.Children.map(t, function (e) {
              return e;
            }).forEach(function (t) {
              r[t.key] = function (t) {
                return n && e.isValidElement(t) ? n(t) : t;
              }(t);
            }), r;
          }

          function mA(e, t, n) {
            return null != n[t] ? n[t] : e.props[t];
          }

          function gA(t, n, r) {
            var i = fA(t.children),
                o = function (e, t) {
              function n(n) {
                return n in t ? t[n] : e[n];
              }

              e = e || {}, t = t || {};
              var r,
                  i = Object.create(null),
                  o = [];

              for (var a in e) {
                a in t ? o.length && (i[a] = o, o = []) : o.push(a);
              }

              var s = {};

              for (var c in t) {
                if (i[c]) for (r = 0; r < i[c].length; r++) {
                  var l = i[c][r];
                  s[i[c][r]] = n(l);
                }
                s[c] = n(c);
              }

              for (r = 0; r < o.length; r++) {
                s[o[r]] = n(o[r]);
              }

              return s;
            }(n, i);

            return Object.keys(o).forEach(function (a) {
              var s = o[a];

              if (e.isValidElement(s)) {
                var c = (a in n),
                    l = (a in i),
                    d = n[a],
                    u = e.isValidElement(d) && !d.props.in;
                !l || c && !u ? l || !c || u ? l && c && e.isValidElement(d) && (o[a] = e.cloneElement(s, {
                  onExited: r.bind(null, s),
                  in: d.props.in,
                  exit: mA(s, "exit", t),
                  enter: mA(s, "enter", t)
                })) : o[a] = e.cloneElement(s, {
                  in: !1
                }) : o[a] = e.cloneElement(s, {
                  onExited: r.bind(null, s),
                  in: !0,
                  exit: mA(s, "exit", t),
                  enter: mA(s, "enter", t)
                });
              }
            }), o;
          }

          var vA = Object.values || function (e) {
            return Object.keys(e).map(function (t) {
              return e[t];
            });
          },
              bA = function (t) {
            function n(e, n) {
              var r,
                  i = (r = t.call(this, e, n) || this).handleExited.bind(jS(r));
              return r.state = {
                contextValue: {
                  isMounting: !0
                },
                handleExited: i,
                firstRender: !0
              }, r;
            }

            PS(n, t);
            var r = n.prototype;
            return r.componentDidMount = function () {
              this.mounted = !0, this.setState({
                contextValue: {
                  isMounting: !1
                }
              });
            }, r.componentWillUnmount = function () {
              this.mounted = !1;
            }, n.getDerivedStateFromProps = function (t, n) {
              var r,
                  i,
                  o = n.children,
                  a = n.handleExited;
              return {
                children: n.firstRender ? (r = t, i = a, fA(r.children, function (t) {
                  return e.cloneElement(t, {
                    onExited: i.bind(null, t),
                    in: !0,
                    appear: mA(t, "appear", r),
                    enter: mA(t, "enter", r),
                    exit: mA(t, "exit", r)
                  });
                })) : gA(t, o, a),
                firstRender: !1
              };
            }, r.handleExited = function (e, t) {
              var n = fA(this.props.children);
              e.key in n || (e.props.onExited && e.props.onExited(t), this.mounted && this.setState(function (t) {
                var n = xy({}, t.children);
                return delete n[e.key], {
                  children: n
                };
              }));
            }, r.render = function () {
              var e = this.props,
                  t = e.component,
                  n = e.childFactory,
                  r = vw(e, ["component", "childFactory"]),
                  i = this.state.contextValue,
                  o = vA(this.state.children).map(n);
              return delete r.appear, delete r.enter, delete r.exit, null === t ? a.default.createElement(aA.Provider, {
                value: i
              }, o) : a.default.createElement(aA.Provider, {
                value: i
              }, a.default.createElement(t, r, o));
            }, n;
          }(a.default.Component);

          bA.propTypes = {}, bA.defaultProps = {
            component: "div",
            childFactory: function childFactory(e) {
              return e;
            }
          };

          var yA = bA,
              wA = function wA(e) {
            return e.scrollTop;
          };

          function SA(e, t) {
            var n = e.timeout,
                r = e.style,
                i = void 0 === r ? {} : r;
            return {
              duration: i.transitionDuration || "number" == typeof n ? n : n[t.mode] || 0,
              delay: i.transitionDelay
            };
          }

          var xA = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.collapsedHeight,
                a = e.collapsedSize,
                c = void 0 === a ? "0px" : a,
                l = e.component,
                d = void 0 === l ? "div" : l,
                u = e.disableStrictModeCompat,
                p = void 0 !== u && u,
                h = e.in,
                _ = e.onEnter,
                f = e.onEntered,
                m = e.onEntering,
                g = e.onExit,
                v = e.onExited,
                b = e.onExiting,
                y = e.style,
                w = e.timeout,
                S = void 0 === w ? yS.standard : w,
                x = e.TransitionComponent,
                E = void 0 === x ? _A : x,
                C = bw(e, ["children", "classes", "className", "collapsedHeight", "collapsedSize", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]),
                k = Nk(),
                A = s.useRef(),
                I = s.useRef(null),
                T = s.useRef(),
                O = "number" == typeof (o || c) ? "".concat(o || c, "px") : o || c;
            s.useEffect(function () {
              return function () {
                clearTimeout(A.current);
              };
            }, []);

            var R = k.unstable_strictMode && !p,
                N = s.useRef(null),
                P = Kk(t, R ? N : void 0),
                j = function j(e) {
              return function (t, n) {
                if (e) {
                  var r = cS(R ? [N.current, t] : [t, n], 2),
                      i = r[0],
                      o = r[1];
                  void 0 === o ? e(i) : e(i, o);
                }
              };
            },
                D = j(function (e, t) {
              e.style.height = O, _ && _(e, t);
            }),
                z = j(function (e, t) {
              var n = I.current ? I.current.clientHeight : 0,
                  r = SA({
                style: y,
                timeout: S
              }, {
                mode: "enter"
              }).duration;

              if ("auto" === S) {
                var i = k.transitions.getAutoHeightDuration(n);
                e.style.transitionDuration = "".concat(i, "ms"), T.current = i;
              } else e.style.transitionDuration = "string" == typeof r ? r : "".concat(r, "ms");

              e.style.height = "".concat(n, "px"), m && m(e, t);
            }),
                M = j(function (e, t) {
              e.style.height = "auto", f && f(e, t);
            }),
                L = j(function (e) {
              var t = I.current ? I.current.clientHeight : 0;
              e.style.height = "".concat(t, "px"), g && g(e);
            }),
                U = j(v),
                B = j(function (e) {
              var t = I.current ? I.current.clientHeight : 0,
                  n = SA({
                style: y,
                timeout: S
              }, {
                mode: "exit"
              }).duration;

              if ("auto" === S) {
                var r = k.transitions.getAutoHeightDuration(t);
                e.style.transitionDuration = "".concat(r, "ms"), T.current = r;
              } else e.style.transitionDuration = "string" == typeof n ? n : "".concat(n, "ms");

              e.style.height = O, b && b(e);
            });

            return s.createElement(E, xy({
              in: h,
              onEnter: D,
              onEntered: M,
              onEntering: z,
              onExit: L,
              onExited: U,
              onExiting: B,
              addEndListener: function addEndListener(e, t) {
                var n = R ? e : t;
                "auto" === S && (A.current = setTimeout(n, T.current || 0));
              },
              nodeRef: R ? N : void 0,
              timeout: "auto" === S ? null : S
            }, C), function (e, t) {
              return s.createElement(d, xy({
                className: VC(r.root, r.container, i, {
                  entered: r.entered,
                  exited: !h && "0px" === O && r.hidden
                }[e]),
                style: xy({
                  minHeight: O
                }, y),
                ref: P
              }, t), s.createElement("div", {
                className: r.wrapper,
                ref: I
              }, s.createElement("div", {
                className: r.wrapperInner
              }, n)));
            });
          });
          xA.muiSupportAuto = !0;
          var EA = Pk(function (e) {
            return {
              root: {
                height: 0,
                overflow: "hidden",
                transition: e.transitions.create("height")
              },
              entered: {
                height: "auto",
                overflow: "visible"
              },
              hidden: {
                visibility: "hidden"
              },
              wrapper: {
                display: "flex"
              },
              wrapperInner: {
                width: "100%"
              }
            };
          }, {
            name: "MuiCollapse"
          })(xA),
              CA = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.component,
                o = void 0 === i ? "div" : i,
                a = e.square,
                c = void 0 !== a && a,
                l = e.elevation,
                d = void 0 === l ? 1 : l,
                u = e.variant,
                p = void 0 === u ? "elevation" : u,
                h = bw(e, ["classes", "className", "component", "square", "elevation", "variant"]);
            return s.createElement(o, xy({
              className: VC(n.root, r, "outlined" === p ? n.outlined : n["elevation".concat(d)], !c && n.rounded),
              ref: t
            }, h));
          }),
              kA = Pk(function (e) {
            var t = {};
            return e.shadows.forEach(function (e, n) {
              t["elevation".concat(n)] = {
                boxShadow: e
              };
            }), xy({
              root: {
                backgroundColor: e.palette.background.paper,
                color: e.palette.text.primary,
                transition: e.transitions.create("box-shadow")
              },
              rounded: {
                borderRadius: e.shape.borderRadius
              },
              outlined: {
                border: "1px solid ".concat(e.palette.divider)
              }
            }, t);
          }, {
            name: "MuiPaper"
          })(CA),
              AA = "undefined" == typeof window ? s.useEffect : s.useLayoutEffect;

          function IA(e) {
            var t = e.classes,
                n = e.pulsate,
                r = void 0 !== n && n,
                i = e.rippleX,
                o = e.rippleY,
                a = e.rippleSize,
                c = e.in,
                l = e.onExited,
                d = void 0 === l ? function () {} : l,
                u = e.timeout,
                p = s.useState(!1),
                h = p[0],
                _ = p[1],
                f = VC(t.ripple, t.rippleVisible, r && t.ripplePulsate),
                m = {
              width: a,
              height: a,
              top: -a / 2 + o,
              left: -a / 2 + i
            },
                g = VC(t.child, h && t.childLeaving, r && t.childPulsate),
                v = Gk(d);
            return AA(function () {
              if (!c) {
                _(!0);

                var e = setTimeout(v, u);
                return function () {
                  clearTimeout(e);
                };
              }
            }, [v, c, u]), s.createElement("span", {
              className: f,
              style: m
            }, s.createElement("span", {
              className: g
            }));
          }

          var TA = s.forwardRef(function (e, t) {
            var n = e.center,
                r = void 0 !== n && n,
                i = e.classes,
                o = e.className,
                a = bw(e, ["center", "classes", "className"]),
                c = s.useState([]),
                l = c[0],
                d = c[1],
                u = s.useRef(0),
                p = s.useRef(null);
            s.useEffect(function () {
              p.current && (p.current(), p.current = null);
            }, [l]);

            var h = s.useRef(!1),
                _ = s.useRef(null),
                f = s.useRef(null),
                m = s.useRef(null);

            s.useEffect(function () {
              return function () {
                clearTimeout(_.current);
              };
            }, []);
            var g = s.useCallback(function (e) {
              var t = e.pulsate,
                  n = e.rippleX,
                  r = e.rippleY,
                  o = e.rippleSize,
                  a = e.cb;
              d(function (e) {
                return [].concat(Mw(e), [s.createElement(IA, {
                  key: u.current,
                  classes: i,
                  timeout: 550,
                  pulsate: t,
                  rippleX: n,
                  rippleY: r,
                  rippleSize: o
                })]);
              }), u.current += 1, p.current = a;
            }, [i]),
                v = s.useCallback(function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  n = arguments.length > 2 ? arguments[2] : void 0,
                  i = t.pulsate,
                  o = void 0 !== i && i,
                  a = t.center,
                  s = void 0 === a ? r || t.pulsate : a,
                  c = t.fakeElement,
                  l = void 0 !== c && c;
              if ("mousedown" === e.type && h.current) h.current = !1;else {
                "touchstart" === e.type && (h.current = !0);
                var d,
                    u,
                    p,
                    v = l ? null : m.current,
                    b = v ? v.getBoundingClientRect() : {
                  width: 0,
                  height: 0,
                  left: 0,
                  top: 0
                };
                if (s || 0 === e.clientX && 0 === e.clientY || !e.clientX && !e.touches) d = Math.round(b.width / 2), u = Math.round(b.height / 2);else {
                  var y = e.touches ? e.touches[0] : e,
                      w = y.clientX,
                      S = y.clientY;
                  d = Math.round(w - b.left), u = Math.round(S - b.top);
                }
                if (s) (p = Math.sqrt((2 * Math.pow(b.width, 2) + Math.pow(b.height, 2)) / 3)) % 2 == 0 && (p += 1);else {
                  var x = 2 * Math.max(Math.abs((v ? v.clientWidth : 0) - d), d) + 2,
                      E = 2 * Math.max(Math.abs((v ? v.clientHeight : 0) - u), u) + 2;
                  p = Math.sqrt(Math.pow(x, 2) + Math.pow(E, 2));
                }
                e.touches ? null === f.current && (f.current = function () {
                  g({
                    pulsate: o,
                    rippleX: d,
                    rippleY: u,
                    rippleSize: p,
                    cb: n
                  });
                }, _.current = setTimeout(function () {
                  f.current && (f.current(), f.current = null);
                }, 80)) : g({
                  pulsate: o,
                  rippleX: d,
                  rippleY: u,
                  rippleSize: p,
                  cb: n
                });
              }
            }, [r, g]),
                b = s.useCallback(function () {
              v({}, {
                pulsate: !0
              });
            }, [v]),
                y = s.useCallback(function (e, t) {
              if (clearTimeout(_.current), "touchend" === e.type && f.current) return e.persist(), f.current(), f.current = null, void (_.current = setTimeout(function () {
                y(e, t);
              }));
              f.current = null, d(function (e) {
                return e.length > 0 ? e.slice(1) : e;
              }), p.current = t;
            }, []);
            return s.useImperativeHandle(t, function () {
              return {
                pulsate: b,
                start: v,
                stop: y
              };
            }, [b, v, y]), s.createElement("span", xy({
              className: VC(i.root, o),
              ref: m
            }, a), s.createElement(yA, {
              component: null,
              exit: !0
            }, l));
          }),
              OA = Pk(function (e) {
            return {
              root: {
                overflow: "hidden",
                pointerEvents: "none",
                position: "absolute",
                zIndex: 0,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                borderRadius: "inherit"
              },
              ripple: {
                opacity: 0,
                position: "absolute"
              },
              rippleVisible: {
                opacity: .3,
                transform: "scale(1)",
                animation: "$enter ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)
              },
              ripplePulsate: {
                animationDuration: "".concat(e.transitions.duration.shorter, "ms")
              },
              child: {
                opacity: 1,
                display: "block",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: "currentColor"
              },
              childLeaving: {
                opacity: 0,
                animation: "$exit ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)
              },
              childPulsate: {
                position: "absolute",
                left: 0,
                top: 0,
                animation: "$pulsate 2500ms ".concat(e.transitions.easing.easeInOut, " 200ms infinite")
              },
              "@keyframes enter": {
                "0%": {
                  transform: "scale(0)",
                  opacity: .1
                },
                "100%": {
                  transform: "scale(1)",
                  opacity: .3
                }
              },
              "@keyframes exit": {
                "0%": {
                  opacity: 1
                },
                "100%": {
                  opacity: 0
                }
              },
              "@keyframes pulsate": {
                "0%": {
                  transform: "scale(1)"
                },
                "50%": {
                  transform: "scale(0.92)"
                },
                "100%": {
                  transform: "scale(1)"
                }
              }
            };
          }, {
            flip: !1,
            name: "MuiTouchRipple"
          })(s.memo(TA)),
              RA = s.forwardRef(function (e, t) {
            var n = e.action,
                r = e.buttonRef,
                i = e.centerRipple,
                o = void 0 !== i && i,
                a = e.children,
                l = e.classes,
                d = e.className,
                u = e.component,
                p = void 0 === u ? "button" : u,
                h = e.disabled,
                _ = void 0 !== h && h,
                f = e.disableRipple,
                m = void 0 !== f && f,
                g = e.disableTouchRipple,
                v = void 0 !== g && g,
                b = e.focusRipple,
                y = void 0 !== b && b,
                w = e.focusVisibleClassName,
                S = e.onBlur,
                x = e.onClick,
                E = e.onFocus,
                C = e.onFocusVisible,
                k = e.onKeyDown,
                A = e.onKeyUp,
                I = e.onMouseDown,
                T = e.onMouseLeave,
                O = e.onMouseUp,
                R = e.onTouchEnd,
                N = e.onTouchMove,
                P = e.onTouchStart,
                j = e.onDragLeave,
                D = e.tabIndex,
                z = void 0 === D ? 0 : D,
                M = e.TouchRippleProps,
                L = e.type,
                U = void 0 === L ? "button" : L,
                B = bw(e, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]),
                H = s.useRef(null),
                V = s.useRef(null),
                q = s.useState(!1),
                F = q[0],
                W = q[1];

            _ && F && W(!1);
            var G = iA(),
                K = G.isFocusVisible,
                Q = G.onBlurVisible,
                Z = G.ref;

            function Y(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : v;
              return Gk(function (r) {
                return t && t(r), !n && V.current && V.current[e](r), !0;
              });
            }

            s.useImperativeHandle(n, function () {
              return {
                focusVisible: function focusVisible() {
                  W(!0), H.current.focus();
                }
              };
            }, []), s.useEffect(function () {
              F && y && !m && V.current.pulsate();
            }, [m, y, F]);

            var J = Y("start", I),
                $ = Y("stop", j),
                X = Y("stop", O),
                ee = Y("stop", function (e) {
              F && e.preventDefault(), T && T(e);
            }),
                te = Y("start", P),
                ne = Y("stop", R),
                re = Y("stop", N),
                ie = Y("stop", function (e) {
              F && (Q(e), W(!1)), S && S(e);
            }, !1),
                oe = Gk(function (e) {
              H.current || (H.current = e.currentTarget), K(e) && (W(!0), C && C(e)), E && E(e);
            }),
                ae = function ae() {
              var e = c.findDOMNode(H.current);
              return p && "button" !== p && !("A" === e.tagName && e.href);
            },
                se = s.useRef(!1),
                ce = Gk(function (e) {
              y && !se.current && F && V.current && " " === e.key && (se.current = !0, e.persist(), V.current.stop(e, function () {
                V.current.start(e);
              })), e.target === e.currentTarget && ae() && " " === e.key && e.preventDefault(), k && k(e), e.target === e.currentTarget && ae() && "Enter" === e.key && !_ && (e.preventDefault(), x && x(e));
            }),
                le = Gk(function (e) {
              y && " " === e.key && V.current && F && !e.defaultPrevented && (se.current = !1, e.persist(), V.current.stop(e, function () {
                V.current.pulsate(e);
              })), A && A(e), x && e.target === e.currentTarget && ae() && " " === e.key && !e.defaultPrevented && x(e);
            }),
                de = p;

            "button" === de && B.href && (de = "a");
            var ue = {};
            "button" === de ? (ue.type = U, ue.disabled = _) : ("a" === de && B.href || (ue.role = "button"), ue["aria-disabled"] = _);

            var pe = Kk(r, t),
                he = Kk(Z, H),
                _e = Kk(pe, he),
                fe = s.useState(!1),
                me = fe[0],
                ge = fe[1];

            s.useEffect(function () {
              ge(!0);
            }, []);
            var ve = me && !m && !_;
            return s.createElement(de, xy({
              className: VC(l.root, d, F && [l.focusVisible, w], _ && l.disabled),
              onBlur: ie,
              onClick: x,
              onFocus: oe,
              onKeyDown: ce,
              onKeyUp: le,
              onMouseDown: J,
              onMouseLeave: ee,
              onMouseUp: X,
              onDragLeave: $,
              onTouchEnd: ne,
              onTouchMove: re,
              onTouchStart: te,
              ref: _e,
              tabIndex: _ ? -1 : z
            }, ue, B), a, ve ? s.createElement(OA, xy({
              ref: V,
              center: o
            }, M)) : null);
          }),
              NA = Pk({
            root: {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              WebkitTapHighlightColor: "transparent",
              backgroundColor: "transparent",
              outline: 0,
              border: 0,
              margin: 0,
              borderRadius: 0,
              padding: 0,
              cursor: "pointer",
              userSelect: "none",
              verticalAlign: "middle",
              "-moz-appearance": "none",
              "-webkit-appearance": "none",
              textDecoration: "none",
              color: "inherit",
              "&::-moz-focus-inner": {
                borderStyle: "none"
              },
              "&$disabled": {
                pointerEvents: "none",
                cursor: "default"
              },
              "@media print": {
                colorAdjust: "exact"
              }
            },
            disabled: {},
            focusVisible: {}
          }, {
            name: "MuiButtonBase"
          })(RA),
              PA = s.forwardRef(function (e, t) {
            var n = e.edge,
                r = void 0 !== n && n,
                i = e.children,
                o = e.classes,
                a = e.className,
                c = e.color,
                l = void 0 === c ? "default" : c,
                d = e.disabled,
                u = void 0 !== d && d,
                p = e.disableFocusRipple,
                h = void 0 !== p && p,
                _ = e.size,
                f = void 0 === _ ? "medium" : _,
                m = bw(e, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
            return s.createElement(NA, xy({
              className: VC(o.root, a, "default" !== l && o["color".concat(jk(l))], u && o.disabled, "small" === f && o["size".concat(jk(f))], {
                start: o.edgeStart,
                end: o.edgeEnd
              }[r]),
              centerRipple: !0,
              focusRipple: !h,
              disabled: u,
              ref: t
            }, m), s.createElement("span", {
              className: o.label
            }, i));
          }),
              jA = Pk(function (e) {
            return {
              root: {
                textAlign: "center",
                flex: "0 0 auto",
                fontSize: e.typography.pxToRem(24),
                padding: 12,
                borderRadius: "50%",
                overflow: "visible",
                color: e.palette.action.active,
                transition: e.transitions.create("background-color", {
                  duration: e.transitions.duration.shortest
                }),
                "&:hover": {
                  backgroundColor: fw(e.palette.action.active, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                },
                "&$disabled": {
                  backgroundColor: "transparent",
                  color: e.palette.action.disabled
                }
              },
              edgeStart: {
                marginLeft: -12,
                "$sizeSmall&": {
                  marginLeft: -3
                }
              },
              edgeEnd: {
                marginRight: -12,
                "$sizeSmall&": {
                  marginRight: -3
                }
              },
              colorInherit: {
                color: "inherit"
              },
              colorPrimary: {
                color: e.palette.primary.main,
                "&:hover": {
                  backgroundColor: fw(e.palette.primary.main, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                }
              },
              colorSecondary: {
                color: e.palette.secondary.main,
                "&:hover": {
                  backgroundColor: fw(e.palette.secondary.main, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                }
              },
              disabled: {},
              sizeSmall: {
                padding: 3,
                fontSize: e.typography.pxToRem(18)
              },
              label: {
                width: "100%",
                display: "flex",
                alignItems: "inherit",
                justifyContent: "inherit"
              }
            };
          }, {
            name: "MuiIconButton"
          })(PA),
              DA = Lk(s.createElement("path", {
            d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
          })),
              zA = s.forwardRef(function (e, t) {
            var n = e.alt,
                r = e.children,
                i = e.classes,
                o = e.className,
                a = e.component,
                c = void 0 === a ? "div" : a,
                l = e.imgProps,
                d = e.sizes,
                u = e.src,
                p = e.srcSet,
                h = e.variant,
                _ = void 0 === h ? "circular" : h,
                f = bw(e, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]),
                m = null,
                g = function (e) {
              var t = e.src,
                  n = e.srcSet,
                  r = s.useState(!1),
                  i = r[0],
                  o = r[1];
              return s.useEffect(function () {
                if (t || n) {
                  o(!1);
                  var e = !0,
                      r = new Image();
                  return r.src = t, r.srcSet = n, r.onload = function () {
                    e && o("loaded");
                  }, r.onerror = function () {
                    e && o("error");
                  }, function () {
                    e = !1;
                  };
                }
              }, [t, n]), i;
            }({
              src: u,
              srcSet: p
            }),
                v = u || p,
                b = v && "error" !== g;

            return m = b ? s.createElement("img", xy({
              alt: n,
              src: u,
              srcSet: p,
              sizes: d,
              className: i.img
            }, l)) : null != r ? r : v && n ? n[0] : s.createElement(DA, {
              className: i.fallback
            }), s.createElement(c, xy({
              className: VC(i.root, i.system, i[_], o, !b && i.colorDefault),
              ref: t
            }, f), m);
          }),
              MA = Pk(function (e) {
            return {
              root: {
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                width: 40,
                height: 40,
                fontFamily: e.typography.fontFamily,
                fontSize: e.typography.pxToRem(20),
                lineHeight: 1,
                borderRadius: "50%",
                overflow: "hidden",
                userSelect: "none"
              },
              colorDefault: {
                color: e.palette.background.default,
                backgroundColor: "light" === e.palette.type ? e.palette.grey[400] : e.palette.grey[600]
              },
              circle: {},
              circular: {},
              rounded: {
                borderRadius: e.shape.borderRadius
              },
              square: {
                borderRadius: 0
              },
              img: {
                width: "100%",
                height: "100%",
                textAlign: "center",
                objectFit: "cover",
                color: "transparent",
                textIndent: 1e4
              },
              fallback: {
                width: "75%",
                height: "75%"
              }
            };
          }, {
            name: "MuiAvatar"
          })(zA),
              LA = {
            entering: {
              opacity: 1
            },
            entered: {
              opacity: 1
            }
          },
              UA = {
            enter: yS.enteringScreen,
            exit: yS.leavingScreen
          },
              BA = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.disableStrictModeCompat,
                i = void 0 !== r && r,
                o = e.in,
                a = e.onEnter,
                c = e.onEntered,
                l = e.onEntering,
                d = e.onExit,
                u = e.onExited,
                p = e.onExiting,
                h = e.style,
                _ = e.TransitionComponent,
                f = void 0 === _ ? _A : _,
                m = e.timeout,
                g = void 0 === m ? UA : m,
                v = bw(e, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]),
                b = Nk(),
                y = b.unstable_strictMode && !i,
                w = s.useRef(null),
                S = Kk(n.ref, t),
                x = Kk(y ? w : void 0, S),
                E = function E(e) {
              return function (t, n) {
                if (e) {
                  var r = cS(y ? [w.current, t] : [t, n], 2),
                      i = r[0],
                      o = r[1];
                  void 0 === o ? e(i) : e(i, o);
                }
              };
            },
                C = E(l),
                k = E(function (e, t) {
              wA(e);
              var n = SA({
                style: h,
                timeout: g
              }, {
                mode: "enter"
              });
              e.style.webkitTransition = b.transitions.create("opacity", n), e.style.transition = b.transitions.create("opacity", n), a && a(e, t);
            }),
                A = E(c),
                I = E(p),
                T = E(function (e) {
              var t = SA({
                style: h,
                timeout: g
              }, {
                mode: "exit"
              });
              e.style.webkitTransition = b.transitions.create("opacity", t), e.style.transition = b.transitions.create("opacity", t), d && d(e);
            }),
                O = E(u);

            return s.createElement(f, xy({
              appear: !0,
              in: o,
              nodeRef: y ? w : void 0,
              onEnter: k,
              onEntered: A,
              onEntering: C,
              onExit: T,
              onExited: O,
              onExiting: I,
              timeout: g
            }, v), function (e, t) {
              return s.cloneElement(n, xy({
                style: xy({
                  opacity: 0,
                  visibility: "exited" !== e || o ? void 0 : "hidden"
                }, LA[e], h, n.props.style),
                ref: x
              }, t));
            });
          }),
              HA = BA,
              VA = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.invisible,
                a = void 0 !== o && o,
                c = e.open,
                l = e.transitionDuration,
                d = e.TransitionComponent,
                u = void 0 === d ? HA : d,
                p = bw(e, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
            return s.createElement(u, xy({
              in: c,
              timeout: l
            }, p), s.createElement("div", {
              className: VC(r.root, i, a && r.invisible),
              "aria-hidden": !0,
              ref: t
            }, n));
          }),
              qA = Pk({
            root: {
              zIndex: -1,
              position: "fixed",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              right: 0,
              bottom: 0,
              top: 0,
              left: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              WebkitTapHighlightColor: "transparent"
            },
            invisible: {
              backgroundColor: "transparent"
            }
          }, {
            name: "MuiBackdrop"
          })(VA),
              FA = function (e) {
            var t = function t(_t137) {
              var n = e(_t137);
              return _t137.css ? xy({}, Lw(n, e(xy({
                theme: _t137.theme
              }, _t137.css))), Kw(_t137.css, [e.filterProps])) : _t137.sx ? xy({}, Lw(n, e(xy({
                theme: _t137.theme
              }, _t137.sx))), Kw(_t137.sx, [e.filterProps])) : n;
            };

            return t.propTypes = {}, t.filterProps = ["css", "sx"].concat(Mw(e.filterProps)), t;
          }(Fw(Gw, Qw, Zw, Yw, $w, Jw, Xw, sS, mS, gS)),
              WA = Rk("div")(FA, {
            name: "MuiBox"
          }),
              GA = {
            h1: "h1",
            h2: "h2",
            h3: "h3",
            h4: "h4",
            h5: "h5",
            h6: "h6",
            subtitle1: "h6",
            subtitle2: "h6",
            body1: "p",
            body2: "p"
          },
              KA = s.forwardRef(function (e, t) {
            var n = e.align,
                r = void 0 === n ? "inherit" : n,
                i = e.classes,
                o = e.className,
                a = e.color,
                c = void 0 === a ? "initial" : a,
                l = e.component,
                d = e.display,
                u = void 0 === d ? "initial" : d,
                p = e.gutterBottom,
                h = void 0 !== p && p,
                _ = e.noWrap,
                f = void 0 !== _ && _,
                m = e.paragraph,
                g = void 0 !== m && m,
                v = e.variant,
                b = void 0 === v ? "body1" : v,
                y = e.variantMapping,
                w = void 0 === y ? GA : y,
                S = bw(e, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]),
                x = l || (g ? "p" : w[b] || GA[b]) || "span";
            return s.createElement(x, xy({
              className: VC(i.root, o, "inherit" !== b && i[b], "initial" !== c && i["color".concat(jk(c))], f && i.noWrap, h && i.gutterBottom, g && i.paragraph, "inherit" !== r && i["align".concat(jk(r))], "initial" !== u && i["display".concat(jk(u))]),
              ref: t
            }, S));
          }),
              QA = Pk(function (e) {
            return {
              root: {
                margin: 0
              },
              body2: e.typography.body2,
              body1: e.typography.body1,
              caption: e.typography.caption,
              button: e.typography.button,
              h1: e.typography.h1,
              h2: e.typography.h2,
              h3: e.typography.h3,
              h4: e.typography.h4,
              h5: e.typography.h5,
              h6: e.typography.h6,
              subtitle1: e.typography.subtitle1,
              subtitle2: e.typography.subtitle2,
              overline: e.typography.overline,
              srOnly: {
                position: "absolute",
                height: 1,
                width: 1,
                overflow: "hidden"
              },
              alignLeft: {
                textAlign: "left"
              },
              alignCenter: {
                textAlign: "center"
              },
              alignRight: {
                textAlign: "right"
              },
              alignJustify: {
                textAlign: "justify"
              },
              noWrap: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              },
              gutterBottom: {
                marginBottom: "0.35em"
              },
              paragraph: {
                marginBottom: 16
              },
              colorInherit: {
                color: "inherit"
              },
              colorPrimary: {
                color: e.palette.primary.main
              },
              colorSecondary: {
                color: e.palette.secondary.main
              },
              colorTextPrimary: {
                color: e.palette.text.primary
              },
              colorTextSecondary: {
                color: e.palette.text.secondary
              },
              colorError: {
                color: e.palette.error.main
              },
              displayInline: {
                display: "inline"
              },
              displayBlock: {
                display: "block"
              }
            };
          }, {
            name: "MuiTypography"
          })(KA),
              ZA = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.color,
                a = void 0 === o ? "default" : o,
                c = e.component,
                l = void 0 === c ? "button" : c,
                d = e.disabled,
                u = void 0 !== d && d,
                p = e.disableElevation,
                h = void 0 !== p && p,
                _ = e.disableFocusRipple,
                f = void 0 !== _ && _,
                m = e.endIcon,
                g = e.focusVisibleClassName,
                v = e.fullWidth,
                b = void 0 !== v && v,
                y = e.size,
                w = void 0 === y ? "medium" : y,
                S = e.startIcon,
                x = e.type,
                E = void 0 === x ? "button" : x,
                C = e.variant,
                k = void 0 === C ? "text" : C,
                A = bw(e, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]),
                I = S && s.createElement("span", {
              className: VC(r.startIcon, r["iconSize".concat(jk(w))])
            }, S),
                T = m && s.createElement("span", {
              className: VC(r.endIcon, r["iconSize".concat(jk(w))])
            }, m);
            return s.createElement(NA, xy({
              className: VC(r.root, r[k], i, "inherit" === a ? r.colorInherit : "default" !== a && r["".concat(k).concat(jk(a))], "medium" !== w && [r["".concat(k, "Size").concat(jk(w))], r["size".concat(jk(w))]], h && r.disableElevation, u && r.disabled, b && r.fullWidth),
              component: l,
              disabled: u,
              focusRipple: !f,
              focusVisibleClassName: VC(r.focusVisible, g),
              ref: t,
              type: E
            }, A), s.createElement("span", {
              className: r.label
            }, I, n, T));
          }),
              YA = Pk(function (e) {
            return {
              root: xy({}, e.typography.button, {
                boxSizing: "border-box",
                minWidth: 64,
                padding: "6px 16px",
                borderRadius: e.shape.borderRadius,
                color: e.palette.text.primary,
                transition: e.transitions.create(["background-color", "box-shadow", "border"], {
                  duration: e.transitions.duration.short
                }),
                "&:hover": {
                  textDecoration: "none",
                  backgroundColor: fw(e.palette.text.primary, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  },
                  "&$disabled": {
                    backgroundColor: "transparent"
                  }
                },
                "&$disabled": {
                  color: e.palette.action.disabled
                }
              }),
              label: {
                width: "100%",
                display: "inherit",
                alignItems: "inherit",
                justifyContent: "inherit"
              },
              text: {
                padding: "6px 8px"
              },
              textPrimary: {
                color: e.palette.primary.main,
                "&:hover": {
                  backgroundColor: fw(e.palette.primary.main, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                }
              },
              textSecondary: {
                color: e.palette.secondary.main,
                "&:hover": {
                  backgroundColor: fw(e.palette.secondary.main, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                }
              },
              outlined: {
                padding: "5px 15px",
                border: "1px solid ".concat("light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
                "&$disabled": {
                  border: "1px solid ".concat(e.palette.action.disabledBackground)
                }
              },
              outlinedPrimary: {
                color: e.palette.primary.main,
                border: "1px solid ".concat(fw(e.palette.primary.main, .5)),
                "&:hover": {
                  border: "1px solid ".concat(e.palette.primary.main),
                  backgroundColor: fw(e.palette.primary.main, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                }
              },
              outlinedSecondary: {
                color: e.palette.secondary.main,
                border: "1px solid ".concat(fw(e.palette.secondary.main, .5)),
                "&:hover": {
                  border: "1px solid ".concat(e.palette.secondary.main),
                  backgroundColor: fw(e.palette.secondary.main, e.palette.action.hoverOpacity),
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                },
                "&$disabled": {
                  border: "1px solid ".concat(e.palette.action.disabled)
                }
              },
              contained: {
                color: e.palette.getContrastText(e.palette.grey[300]),
                backgroundColor: e.palette.grey[300],
                boxShadow: e.shadows[2],
                "&:hover": {
                  backgroundColor: e.palette.grey.A100,
                  boxShadow: e.shadows[4],
                  "@media (hover: none)": {
                    boxShadow: e.shadows[2],
                    backgroundColor: e.palette.grey[300]
                  },
                  "&$disabled": {
                    backgroundColor: e.palette.action.disabledBackground
                  }
                },
                "&$focusVisible": {
                  boxShadow: e.shadows[6]
                },
                "&:active": {
                  boxShadow: e.shadows[8]
                },
                "&$disabled": {
                  color: e.palette.action.disabled,
                  boxShadow: e.shadows[0],
                  backgroundColor: e.palette.action.disabledBackground
                }
              },
              containedPrimary: {
                color: e.palette.primary.contrastText,
                backgroundColor: e.palette.primary.main,
                "&:hover": {
                  backgroundColor: e.palette.primary.dark,
                  "@media (hover: none)": {
                    backgroundColor: e.palette.primary.main
                  }
                }
              },
              containedSecondary: {
                color: e.palette.secondary.contrastText,
                backgroundColor: e.palette.secondary.main,
                "&:hover": {
                  backgroundColor: e.palette.secondary.dark,
                  "@media (hover: none)": {
                    backgroundColor: e.palette.secondary.main
                  }
                }
              },
              disableElevation: {
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none"
                },
                "&$focusVisible": {
                  boxShadow: "none"
                },
                "&:active": {
                  boxShadow: "none"
                },
                "&$disabled": {
                  boxShadow: "none"
                }
              },
              focusVisible: {},
              disabled: {},
              colorInherit: {
                color: "inherit",
                borderColor: "currentColor"
              },
              textSizeSmall: {
                padding: "4px 5px",
                fontSize: e.typography.pxToRem(13)
              },
              textSizeLarge: {
                padding: "8px 11px",
                fontSize: e.typography.pxToRem(15)
              },
              outlinedSizeSmall: {
                padding: "3px 9px",
                fontSize: e.typography.pxToRem(13)
              },
              outlinedSizeLarge: {
                padding: "7px 21px",
                fontSize: e.typography.pxToRem(15)
              },
              containedSizeSmall: {
                padding: "4px 10px",
                fontSize: e.typography.pxToRem(13)
              },
              containedSizeLarge: {
                padding: "8px 22px",
                fontSize: e.typography.pxToRem(15)
              },
              sizeSmall: {},
              sizeLarge: {},
              fullWidth: {
                width: "100%"
              },
              startIcon: {
                display: "inherit",
                marginRight: 8,
                marginLeft: -4,
                "&$iconSizeSmall": {
                  marginLeft: -2
                }
              },
              endIcon: {
                display: "inherit",
                marginRight: -4,
                marginLeft: 8,
                "&$iconSizeSmall": {
                  marginRight: -2
                }
              },
              iconSizeSmall: {
                "& > *:first-child": {
                  fontSize: 18
                }
              },
              iconSizeMedium: {
                "& > *:first-child": {
                  fontSize: 20
                }
              },
              iconSizeLarge: {
                "& > *:first-child": {
                  fontSize: 22
                }
              }
            };
          }, {
            name: "MuiButton"
          })(ZA),
              JA = ["video", "audio", "picture", "iframe", "img"],
              $A = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.component,
                a = void 0 === o ? "div" : o,
                c = e.image,
                l = e.src,
                d = e.style,
                u = bw(e, ["children", "classes", "className", "component", "image", "src", "style"]),
                p = -1 !== JA.indexOf(a),
                h = !p && c ? xy({
              backgroundImage: 'url("'.concat(c, '")')
            }, d) : d;
            return s.createElement(a, xy({
              className: VC(r.root, i, p && r.media, -1 !== "picture img".indexOf(a) && r.img),
              ref: t,
              style: h,
              src: p ? c || l : void 0
            }, u), n);
          }),
              XA = Pk({
            root: {
              display: "block",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center"
            },
            media: {
              width: "100%"
            },
            img: {
              objectFit: "cover"
            }
          }, {
            name: "MuiCardMedia"
          })($A),
              eI = s.createContext();

          function tI() {
            return s.useContext(eI);
          }

          var nI = eI;

          function rI() {
            return s.useContext(nI);
          }

          var iI = s.forwardRef(function (e, t) {
            var n = e.autoFocus,
                r = e.checked,
                i = e.checkedIcon,
                o = e.classes,
                a = e.className,
                c = e.defaultChecked,
                l = e.disabled,
                d = e.icon,
                u = e.id,
                p = e.inputProps,
                h = e.inputRef,
                _ = e.name,
                f = e.onBlur,
                m = e.onChange,
                g = e.onFocus,
                v = e.readOnly,
                b = e.required,
                y = e.tabIndex,
                w = e.type,
                S = e.value,
                x = bw(e, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]),
                E = cS(Fk({
              controlled: r,
              default: Boolean(c),
              name: "SwitchBase",
              state: "checked"
            }), 2),
                C = E[0],
                k = E[1],
                A = rI(),
                I = l;
            A && void 0 === I && (I = A.disabled);
            var T = "checkbox" === w || "radio" === w;
            return s.createElement(jA, xy({
              component: "span",
              className: VC(o.root, a, C && o.checked, I && o.disabled),
              disabled: I,
              tabIndex: null,
              role: void 0,
              onFocus: function onFocus(e) {
                g && g(e), A && A.onFocus && A.onFocus(e);
              },
              onBlur: function onBlur(e) {
                f && f(e), A && A.onBlur && A.onBlur(e);
              },
              ref: t
            }, x), s.createElement("input", xy({
              autoFocus: n,
              checked: r,
              defaultChecked: c,
              className: o.input,
              disabled: I,
              id: T && u,
              name: _,
              onChange: function onChange(e) {
                var t = e.target.checked;
                k(t), m && m(e, t);
              },
              readOnly: v,
              ref: h,
              required: b,
              tabIndex: y,
              type: w,
              value: S
            }, p)), C ? i : d);
          }),
              oI = Pk({
            root: {
              padding: 9
            },
            checked: {},
            disabled: {},
            input: {
              cursor: "inherit",
              position: "absolute",
              opacity: 0,
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              margin: 0,
              padding: 0,
              zIndex: 1
            }
          }, {
            name: "PrivateSwitchBase"
          })(iI),
              aI = Lk(s.createElement("path", {
            d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
          })),
              sI = Lk(s.createElement("path", {
            d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
          })),
              cI = Lk(s.createElement("path", {
            d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
          })),
              lI = s.createElement(sI, null),
              dI = s.createElement(aI, null),
              uI = s.createElement(cI, null),
              pI = s.forwardRef(function (e, t) {
            var n = e.checkedIcon,
                r = void 0 === n ? lI : n,
                i = e.classes,
                o = e.color,
                a = void 0 === o ? "secondary" : o,
                c = e.icon,
                l = void 0 === c ? dI : c,
                d = e.indeterminate,
                u = void 0 !== d && d,
                p = e.indeterminateIcon,
                h = void 0 === p ? uI : p,
                _ = e.inputProps,
                f = e.size,
                m = void 0 === f ? "medium" : f,
                g = bw(e, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]),
                v = u ? h : l,
                b = u ? h : r;
            return s.createElement(oI, xy({
              type: "checkbox",
              classes: {
                root: VC(i.root, i["color".concat(jk(a))], u && i.indeterminate),
                checked: i.checked,
                disabled: i.disabled
              },
              color: a,
              inputProps: xy({
                "data-indeterminate": u
              }, _),
              icon: s.cloneElement(v, {
                fontSize: void 0 === v.props.fontSize && "small" === m ? m : v.props.fontSize
              }),
              checkedIcon: s.cloneElement(b, {
                fontSize: void 0 === b.props.fontSize && "small" === m ? m : b.props.fontSize
              }),
              ref: t
            }, g));
          }),
              hI = Pk(function (e) {
            return {
              root: {
                color: e.palette.text.secondary
              },
              checked: {},
              disabled: {},
              indeterminate: {},
              colorPrimary: {
                "&$checked": {
                  color: e.palette.primary.main,
                  "&:hover": {
                    backgroundColor: fw(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                      backgroundColor: "transparent"
                    }
                  }
                },
                "&$disabled": {
                  color: e.palette.action.disabled
                }
              },
              colorSecondary: {
                "&$checked": {
                  color: e.palette.secondary.main,
                  "&:hover": {
                    backgroundColor: fw(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                      backgroundColor: "transparent"
                    }
                  }
                },
                "&$disabled": {
                  color: e.palette.action.disabled
                }
              }
            };
          }, {
            name: "MuiCheckbox"
          })(pI);

          function _I(e) {
            return e.substring(2).toLowerCase();
          }

          function fI(e) {
            var t = e.children,
                n = e.disableReactTree,
                r = void 0 !== n && n,
                i = e.mouseEvent,
                o = void 0 === i ? "onClick" : i,
                a = e.onClickAway,
                l = e.touchEvent,
                d = void 0 === l ? "onTouchEnd" : l,
                u = s.useRef(!1),
                p = s.useRef(null),
                h = s.useRef(!1),
                _ = s.useRef(!1);

            s.useEffect(function () {
              return setTimeout(function () {
                h.current = !0;
              }, 0), function () {
                h.current = !1;
              };
            }, []);

            var f = s.useCallback(function (e) {
              p.current = c.findDOMNode(e);
            }, []),
                m = Kk(t.ref, f),
                g = Gk(function (e) {
              var t = _.current;
              _.current = !1, h.current && p.current && !function (e) {
                return document.documentElement.clientWidth < e.clientX || document.documentElement.clientHeight < e.clientY;
              }(e) && (u.current ? u.current = !1 : (e.composedPath ? e.composedPath().indexOf(p.current) > -1 : !Hk(p.current).documentElement.contains(e.target) || p.current.contains(e.target)) || !r && t || a(e));
            }),
                v = function v(e) {
              return function (n) {
                _.current = !0;
                var r = t.props[e];
                r && r(n);
              };
            },
                b = {
              ref: m
            };

            return !1 !== d && (b[d] = v(d)), s.useEffect(function () {
              if (!1 !== d) {
                var e = _I(d),
                    t = Hk(p.current),
                    n = function n() {
                  u.current = !0;
                };

                return t.addEventListener(e, g), t.addEventListener("touchmove", n), function () {
                  t.removeEventListener(e, g), t.removeEventListener("touchmove", n);
                };
              }
            }, [g, d]), !1 !== o && (b[o] = v(o)), s.useEffect(function () {
              if (!1 !== o) {
                var e = _I(o),
                    t = Hk(p.current);

                return t.addEventListener(e, g), function () {
                  t.removeEventListener(e, g);
                };
              }
            }, [g, o]), s.createElement(s.Fragment, null, s.cloneElement(t, b));
          }

          var mI = "undefined" != typeof window ? s.useLayoutEffect : s.useEffect,
              gI = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.container,
                i = e.disablePortal,
                o = void 0 !== i && i,
                a = e.onRendered,
                l = s.useState(null),
                d = l[0],
                u = l[1],
                p = Kk(s.isValidElement(n) ? n.ref : null, t);
            return mI(function () {
              o || u(function (e) {
                return e = "function" == typeof e ? e() : e, c.findDOMNode(e);
              }(r) || document.body);
            }, [r, o]), mI(function () {
              if (d && !o) return qk(t, d), function () {
                qk(t, null);
              };
            }, [t, d, o]), mI(function () {
              a && (d || o) && a();
            }, [a, d, o]), o ? s.isValidElement(n) ? s.cloneElement(n, {
              ref: p
            }) : n : d ? c.createPortal(n, d) : d;
          });

          function vI() {
            var e = document.createElement("div");
            e.style.width = "99px", e.style.height = "99px", e.style.position = "absolute", e.style.top = "-9999px", e.style.overflow = "scroll", document.body.appendChild(e);
            var t = e.offsetWidth - e.clientWidth;
            return document.body.removeChild(e), t;
          }

          function bI(e, t) {
            t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
          }

          function yI(e) {
            return parseInt(window.getComputedStyle(e)["padding-right"], 10) || 0;
          }

          function wI(e, t, n) {
            var r = arguments.length > 4 ? arguments[4] : void 0,
                i = [t, n].concat(Mw(arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [])),
                o = ["TEMPLATE", "SCRIPT", "STYLE"];
            [].forEach.call(e.children, function (e) {
              1 === e.nodeType && -1 === i.indexOf(e) && -1 === o.indexOf(e.tagName) && bI(e, r);
            });
          }

          function SI(e, t) {
            var n = -1;
            return e.some(function (e, r) {
              return !!t(e) && (n = r, !0);
            }), n;
          }

          function xI(e, t) {
            var n,
                r = [],
                i = [],
                o = e.container;

            if (!t.disableScrollLock) {
              if (function (e) {
                var t = Hk(e);
                return t.body === e ? Vk(t).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
              }(o)) {
                var a = vI();
                r.push({
                  value: o.style.paddingRight,
                  key: "padding-right",
                  el: o
                }), o.style["padding-right"] = "".concat(yI(o) + a, "px"), n = Hk(o).querySelectorAll(".mui-fixed"), [].forEach.call(n, function (e) {
                  i.push(e.style.paddingRight), e.style.paddingRight = "".concat(yI(e) + a, "px");
                });
              }

              var s = o.parentElement,
                  c = "HTML" === s.nodeName && "scroll" === window.getComputedStyle(s)["overflow-y"] ? s : o;
              r.push({
                value: c.style.overflow,
                key: "overflow",
                el: c
              }), c.style.overflow = "hidden";
            }

            return function () {
              n && [].forEach.call(n, function (e, t) {
                i[t] ? e.style.paddingRight = i[t] : e.style.removeProperty("padding-right");
              }), r.forEach(function (e) {
                var t = e.value,
                    n = e.el,
                    r = e.key;
                t ? n.style.setProperty(r, t) : n.style.removeProperty(r);
              });
            };
          }

          var EI = function () {
            function e() {
              BC(this, e), this.modals = [], this.containers = [];
            }

            return RS(e, [{
              key: "add",
              value: function value(e, t) {
                var n = this.modals.indexOf(e);
                if (-1 !== n) return n;
                n = this.modals.length, this.modals.push(e), e.modalRef && bI(e.modalRef, !1);

                var r = function (e) {
                  var t = [];
                  return [].forEach.call(e.children, function (e) {
                    e.getAttribute && "true" === e.getAttribute("aria-hidden") && t.push(e);
                  }), t;
                }(t);

                wI(t, e.mountNode, e.modalRef, r, !0);
                var i = SI(this.containers, function (e) {
                  return e.container === t;
                });
                return -1 !== i ? (this.containers[i].modals.push(e), n) : (this.containers.push({
                  modals: [e],
                  container: t,
                  restore: null,
                  hiddenSiblingNodes: r
                }), n);
              }
            }, {
              key: "mount",
              value: function value(e, t) {
                var n = SI(this.containers, function (t) {
                  return -1 !== t.modals.indexOf(e);
                }),
                    r = this.containers[n];
                r.restore || (r.restore = xI(r, t));
              }
            }, {
              key: "remove",
              value: function value(e) {
                var t = this.modals.indexOf(e);
                if (-1 === t) return t;
                var n = SI(this.containers, function (t) {
                  return -1 !== t.modals.indexOf(e);
                }),
                    r = this.containers[n];
                if (r.modals.splice(r.modals.indexOf(e), 1), this.modals.splice(t, 1), 0 === r.modals.length) r.restore && r.restore(), e.modalRef && bI(e.modalRef, !0), wI(r.container, e.mountNode, e.modalRef, r.hiddenSiblingNodes, !1), this.containers.splice(n, 1);else {
                  var i = r.modals[r.modals.length - 1];
                  i.modalRef && bI(i.modalRef, !1);
                }
                return t;
              }
            }, {
              key: "isTopModal",
              value: function value(e) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === e;
              }
            }]), e;
          }();

          function CI(e) {
            var t = e.children,
                n = e.disableAutoFocus,
                r = void 0 !== n && n,
                i = e.disableEnforceFocus,
                o = void 0 !== i && i,
                a = e.disableRestoreFocus,
                l = void 0 !== a && a,
                d = e.getDoc,
                u = e.isEnabled,
                p = e.open,
                h = s.useRef(),
                _ = s.useRef(null),
                f = s.useRef(null),
                m = s.useRef(),
                g = s.useRef(null),
                v = s.useCallback(function (e) {
              g.current = c.findDOMNode(e);
            }, []),
                b = Kk(t.ref, v),
                y = s.useRef();

            return s.useEffect(function () {
              y.current = p;
            }, [p]), !y.current && p && "undefined" != typeof window && (m.current = d().activeElement), s.useEffect(function () {
              if (p) {
                var e = Hk(g.current);
                r || !g.current || g.current.contains(e.activeElement) || (g.current.hasAttribute("tabIndex") || g.current.setAttribute("tabIndex", -1), g.current.focus());

                var t = function t() {
                  null !== g.current && (e.hasFocus() && !o && u() && !h.current ? g.current && !g.current.contains(e.activeElement) && g.current.focus() : h.current = !1);
                },
                    n = function n(t) {
                  !o && u() && 9 === t.keyCode && e.activeElement === g.current && (h.current = !0, t.shiftKey ? f.current.focus() : _.current.focus());
                };

                e.addEventListener("focus", t, !0), e.addEventListener("keydown", n, !0);
                var i = setInterval(function () {
                  t();
                }, 50);
                return function () {
                  clearInterval(i), e.removeEventListener("focus", t, !0), e.removeEventListener("keydown", n, !0), l || (m.current && m.current.focus && m.current.focus(), m.current = null);
                };
              }
            }, [r, o, l, u, p]), s.createElement(s.Fragment, null, s.createElement("div", {
              tabIndex: 0,
              ref: _,
              "data-test": "sentinelStart"
            }), s.cloneElement(t, {
              ref: b
            }), s.createElement("div", {
              tabIndex: 0,
              ref: f,
              "data-test": "sentinelEnd"
            }));
          }

          var kI = {
            root: {
              zIndex: -1,
              position: "fixed",
              right: 0,
              bottom: 0,
              top: 0,
              left: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              WebkitTapHighlightColor: "transparent"
            },
            invisible: {
              backgroundColor: "transparent"
            }
          },
              AI = s.forwardRef(function (e, t) {
            var n = e.invisible,
                r = void 0 !== n && n,
                i = e.open,
                o = bw(e, ["invisible", "open"]);
            return i ? s.createElement("div", xy({
              "aria-hidden": !0,
              ref: t
            }, o, {
              style: xy({}, kI.root, r ? kI.invisible : {}, o.style)
            })) : null;
          }),
              II = new EI(),
              TI = s.forwardRef(function (e, t) {
            var n = xC(),
                r = AS({
              name: "MuiModal",
              props: xy({}, e),
              theme: n
            }),
                i = r.BackdropComponent,
                o = void 0 === i ? AI : i,
                a = r.BackdropProps,
                l = r.children,
                d = r.closeAfterTransition,
                u = void 0 !== d && d,
                p = r.container,
                h = r.disableAutoFocus,
                _ = void 0 !== h && h,
                f = r.disableBackdropClick,
                m = void 0 !== f && f,
                g = r.disableEnforceFocus,
                v = void 0 !== g && g,
                b = r.disableEscapeKeyDown,
                y = void 0 !== b && b,
                w = r.disablePortal,
                S = void 0 !== w && w,
                x = r.disableRestoreFocus,
                E = void 0 !== x && x,
                C = r.disableScrollLock,
                k = void 0 !== C && C,
                A = r.hideBackdrop,
                I = void 0 !== A && A,
                T = r.keepMounted,
                O = void 0 !== T && T,
                R = r.manager,
                N = void 0 === R ? II : R,
                P = r.onBackdropClick,
                j = r.onClose,
                D = r.onEscapeKeyDown,
                z = r.onRendered,
                M = r.open,
                L = bw(r, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]),
                U = s.useState(!0),
                B = U[0],
                H = U[1],
                V = s.useRef({}),
                q = s.useRef(null),
                F = s.useRef(null),
                W = Kk(F, t),
                G = function (e) {
              return !!e.children && e.children.props.hasOwnProperty("in");
            }(r),
                K = function K() {
              return Hk(q.current);
            },
                Q = function Q() {
              return V.current.modalRef = F.current, V.current.mountNode = q.current, V.current;
            },
                Z = function Z() {
              N.mount(Q(), {
                disableScrollLock: k
              }), F.current.scrollTop = 0;
            },
                Y = Gk(function () {
              var e = function (e) {
                return e = "function" == typeof e ? e() : e, c.findDOMNode(e);
              }(p) || K().body;

              N.add(Q(), e), F.current && Z();
            }),
                J = s.useCallback(function () {
              return N.isTopModal(Q());
            }, [N]),
                $ = Gk(function (e) {
              q.current = e, e && (z && z(), M && J() ? Z() : bI(F.current, !0));
            }),
                X = s.useCallback(function () {
              N.remove(Q());
            }, [N]);

            if (s.useEffect(function () {
              return function () {
                X();
              };
            }, [X]), s.useEffect(function () {
              M ? Y() : G && u || X();
            }, [M, X, G, u, Y]), !O && !M && (!G || B)) return null;

            var ee = function (e) {
              return {
                root: {
                  position: "fixed",
                  zIndex: e.zIndex.modal,
                  right: 0,
                  bottom: 0,
                  top: 0,
                  left: 0
                },
                hidden: {
                  visibility: "hidden"
                }
              };
            }(n || {
              zIndex: xS
            }),
                te = {};

            return void 0 === l.props.tabIndex && (te.tabIndex = l.props.tabIndex || "-1"), G && (te.onEnter = Dk(function () {
              H(!1);
            }, l.props.onEnter), te.onExited = Dk(function () {
              H(!0), u && X();
            }, l.props.onExited)), s.createElement(gI, {
              ref: $,
              container: p,
              disablePortal: S
            }, s.createElement("div", xy({
              ref: W,
              onKeyDown: function onKeyDown(e) {
                "Escape" === e.key && J() && (D && D(e), y || (e.stopPropagation(), j && j(e, "escapeKeyDown")));
              },
              role: "presentation"
            }, L, {
              style: xy({}, ee.root, !M && B ? ee.hidden : {}, L.style)
            }), I ? null : s.createElement(o, xy({
              open: M,
              onClick: function onClick(e) {
                e.target === e.currentTarget && (P && P(e), !m && j && j(e, "backdropClick"));
              }
            }, a)), s.createElement(CI, {
              disableEnforceFocus: v,
              disableAutoFocus: _,
              disableRestoreFocus: E,
              getDoc: K,
              isEnabled: J,
              open: M
            }, s.cloneElement(l, te))));
          }),
              OI = TI,
              RI = {
            enter: yS.enteringScreen,
            exit: yS.leavingScreen
          },
              NI = s.forwardRef(function (e, t) {
            var n = e.BackdropProps,
                r = e.children,
                i = e.classes,
                o = e.className,
                a = e.disableBackdropClick,
                c = void 0 !== a && a,
                l = e.disableEscapeKeyDown,
                d = void 0 !== l && l,
                u = e.fullScreen,
                p = void 0 !== u && u,
                h = e.fullWidth,
                _ = void 0 !== h && h,
                f = e.maxWidth,
                m = void 0 === f ? "sm" : f,
                g = e.onBackdropClick,
                v = e.onClose,
                b = e.onEnter,
                y = e.onEntered,
                w = e.onEntering,
                S = e.onEscapeKeyDown,
                x = e.onExit,
                E = e.onExited,
                C = e.onExiting,
                k = e.open,
                A = e.PaperComponent,
                I = void 0 === A ? kA : A,
                T = e.PaperProps,
                O = void 0 === T ? {} : T,
                R = e.scroll,
                N = void 0 === R ? "paper" : R,
                P = e.TransitionComponent,
                j = void 0 === P ? HA : P,
                D = e.transitionDuration,
                z = void 0 === D ? RI : D,
                M = e.TransitionProps,
                L = e["aria-describedby"],
                U = e["aria-labelledby"],
                B = bw(e, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]),
                H = s.useRef();

            return s.createElement(OI, xy({
              className: VC(i.root, o),
              BackdropComponent: qA,
              BackdropProps: xy({
                transitionDuration: z
              }, n),
              closeAfterTransition: !0
            }, c ? {
              disableBackdropClick: c
            } : {}, {
              disableEscapeKeyDown: d,
              onEscapeKeyDown: S,
              onClose: v,
              open: k,
              ref: t
            }, B), s.createElement(j, xy({
              appear: !0,
              in: k,
              timeout: z,
              onEnter: b,
              onEntering: w,
              onEntered: y,
              onExit: x,
              onExiting: C,
              onExited: E,
              role: "none presentation"
            }, M), s.createElement("div", {
              className: VC(i.container, i["scroll".concat(jk(N))]),
              onMouseUp: function onMouseUp(e) {
                e.target === e.currentTarget && e.target === H.current && (H.current = null, g && g(e), !c && v && v(e, "backdropClick"));
              },
              onMouseDown: function onMouseDown(e) {
                H.current = e.target;
              }
            }, s.createElement(I, xy({
              elevation: 24,
              role: "dialog",
              "aria-describedby": L,
              "aria-labelledby": U
            }, O, {
              className: VC(i.paper, i["paperScroll".concat(jk(N))], i["paperWidth".concat(jk(String(m)))], O.className, p && i.paperFullScreen, _ && i.paperFullWidth)
            }), r))));
          }),
              PI = Pk(function (e) {
            return {
              root: {
                "@media print": {
                  position: "absolute !important"
                }
              },
              scrollPaper: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              },
              scrollBody: {
                overflowY: "auto",
                overflowX: "hidden",
                textAlign: "center",
                "&:after": {
                  content: '""',
                  display: "inline-block",
                  verticalAlign: "middle",
                  height: "100%",
                  width: "0"
                }
              },
              container: {
                height: "100%",
                "@media print": {
                  height: "auto"
                },
                outline: 0
              },
              paper: {
                margin: 32,
                position: "relative",
                overflowY: "auto",
                "@media print": {
                  overflowY: "visible",
                  boxShadow: "none"
                }
              },
              paperScrollPaper: {
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100% - 64px)"
              },
              paperScrollBody: {
                display: "inline-block",
                verticalAlign: "middle",
                textAlign: "left"
              },
              paperWidthFalse: {
                maxWidth: "calc(100% - 64px)"
              },
              paperWidthXs: {
                maxWidth: Math.max(e.breakpoints.values.xs, 444),
                "&$paperScrollBody": Py({}, e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 64), {
                  maxWidth: "calc(100% - 64px)"
                })
              },
              paperWidthSm: {
                maxWidth: e.breakpoints.values.sm,
                "&$paperScrollBody": Py({}, e.breakpoints.down(e.breakpoints.values.sm + 64), {
                  maxWidth: "calc(100% - 64px)"
                })
              },
              paperWidthMd: {
                maxWidth: e.breakpoints.values.md,
                "&$paperScrollBody": Py({}, e.breakpoints.down(e.breakpoints.values.md + 64), {
                  maxWidth: "calc(100% - 64px)"
                })
              },
              paperWidthLg: {
                maxWidth: e.breakpoints.values.lg,
                "&$paperScrollBody": Py({}, e.breakpoints.down(e.breakpoints.values.lg + 64), {
                  maxWidth: "calc(100% - 64px)"
                })
              },
              paperWidthXl: {
                maxWidth: e.breakpoints.values.xl,
                "&$paperScrollBody": Py({}, e.breakpoints.down(e.breakpoints.values.xl + 64), {
                  maxWidth: "calc(100% - 64px)"
                })
              },
              paperFullWidth: {
                width: "calc(100% - 64px)"
              },
              paperFullScreen: {
                margin: 0,
                width: "100%",
                maxWidth: "100%",
                height: "100%",
                maxHeight: "none",
                borderRadius: 0,
                "&$paperScrollBody": {
                  margin: 0,
                  maxWidth: "100%"
                }
              }
            };
          }, {
            name: "MuiDialog"
          })(NI),
              jI = s.forwardRef(function (e, t) {
            var n = e.disableSpacing,
                r = void 0 !== n && n,
                i = e.classes,
                o = e.className,
                a = bw(e, ["disableSpacing", "classes", "className"]);
            return s.createElement("div", xy({
              className: VC(i.root, o, !r && i.spacing),
              ref: t
            }, a));
          }),
              DI = Pk({
            root: {
              display: "flex",
              alignItems: "center",
              padding: 8,
              justifyContent: "flex-end",
              flex: "0 0 auto"
            },
            spacing: {
              "& > :not(:first-child)": {
                marginLeft: 8
              }
            }
          }, {
            name: "MuiDialogActions"
          })(jI),
              zI = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.dividers,
                o = void 0 !== i && i,
                a = bw(e, ["classes", "className", "dividers"]);
            return s.createElement("div", xy({
              className: VC(n.root, r, o && n.dividers),
              ref: t
            }, a));
          }),
              MI = Pk(function (e) {
            return {
              root: {
                flex: "1 1 auto",
                WebkitOverflowScrolling: "touch",
                overflowY: "auto",
                padding: "8px 24px",
                "&:first-child": {
                  paddingTop: 20
                }
              },
              dividers: {
                padding: "16px 24px",
                borderTop: "1px solid ".concat(e.palette.divider),
                borderBottom: "1px solid ".concat(e.palette.divider)
              }
            };
          }, {
            name: "MuiDialogContent"
          })(zI),
              LI = s.forwardRef(function (e, t) {
            return s.createElement(QA, xy({
              component: "p",
              variant: "body1",
              color: "textSecondary",
              ref: t
            }, e));
          }),
              UI = Pk({
            root: {
              marginBottom: 12
            }
          }, {
            name: "MuiDialogContentText"
          })(LI),
              BI = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.disableTypography,
                a = void 0 !== o && o,
                c = bw(e, ["children", "classes", "className", "disableTypography"]);
            return s.createElement("div", xy({
              className: VC(r.root, i),
              ref: t
            }, c), a ? n : s.createElement(QA, {
              component: "h2",
              variant: "h6"
            }, n));
          }),
              HI = Pk({
            root: {
              margin: 0,
              padding: "16px 24px",
              flex: "0 0 auto"
            }
          }, {
            name: "MuiDialogTitle"
          })(BI),
              VI = s.forwardRef(function (e, t) {
            var n = e.absolute,
                r = void 0 !== n && n,
                i = e.classes,
                o = e.className,
                a = e.component,
                c = void 0 === a ? "hr" : a,
                l = e.flexItem,
                d = void 0 !== l && l,
                u = e.light,
                p = void 0 !== u && u,
                h = e.orientation,
                _ = void 0 === h ? "horizontal" : h,
                f = e.role,
                m = void 0 === f ? "hr" !== c ? "separator" : void 0 : f,
                g = e.variant,
                v = void 0 === g ? "fullWidth" : g,
                b = bw(e, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

            return s.createElement(c, xy({
              className: VC(i.root, o, "fullWidth" !== v && i[v], r && i.absolute, d && i.flexItem, p && i.light, "vertical" === _ && i.vertical),
              role: m,
              ref: t
            }, b));
          }),
              qI = Pk(function (e) {
            return {
              root: {
                height: 1,
                margin: 0,
                border: "none",
                flexShrink: 0,
                backgroundColor: e.palette.divider
              },
              absolute: {
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%"
              },
              inset: {
                marginLeft: 72
              },
              light: {
                backgroundColor: fw(e.palette.divider, .08)
              },
              middle: {
                marginLeft: e.spacing(2),
                marginRight: e.spacing(2)
              },
              vertical: {
                height: "100%",
                width: 1
              },
              flexItem: {
                alignSelf: "stretch",
                height: "auto"
              }
            };
          }, {
            name: "MuiDivider"
          })(VI);

          function FI(e, t) {
            var n = function (e, t) {
              var n,
                  r = t.getBoundingClientRect();
              if (t.fakeTransform) n = t.fakeTransform;else {
                var i = window.getComputedStyle(t);
                n = i.getPropertyValue("-webkit-transform") || i.getPropertyValue("transform");
              }
              var o = 0,
                  a = 0;

              if (n && "none" !== n && "string" == typeof n) {
                var s = n.split("(")[1].split(")")[0].split(",");
                o = parseInt(s[4], 10), a = parseInt(s[5], 10);
              }

              return "left" === e ? "translateX(".concat(window.innerWidth, "px) translateX(").concat(o - r.left, "px)") : "right" === e ? "translateX(-".concat(r.left + r.width - o, "px)") : "up" === e ? "translateY(".concat(window.innerHeight, "px) translateY(").concat(a - r.top, "px)") : "translateY(-".concat(r.top + r.height - a, "px)");
            }(e, t);

            n && (t.style.webkitTransform = n, t.style.transform = n);
          }

          var WI = {
            enter: yS.enteringScreen,
            exit: yS.leavingScreen
          },
              GI = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.direction,
                i = void 0 === r ? "down" : r,
                o = e.in,
                a = e.onEnter,
                l = e.onEntered,
                d = e.onEntering,
                u = e.onExit,
                p = e.onExited,
                h = e.onExiting,
                _ = e.style,
                f = e.timeout,
                m = void 0 === f ? WI : f,
                g = e.TransitionComponent,
                v = void 0 === g ? _A : g,
                b = bw(e, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]),
                y = Nk(),
                w = s.useRef(null),
                S = s.useCallback(function (e) {
              w.current = c.findDOMNode(e);
            }, []),
                x = Kk(n.ref, S),
                E = Kk(x, t),
                C = function C(e) {
              return function (t) {
                e && (void 0 === t ? e(w.current) : e(w.current, t));
              };
            },
                k = C(function (e, t) {
              FI(i, e), wA(e), a && a(e, t);
            }),
                A = C(function (e, t) {
              var n = SA({
                timeout: m,
                style: _
              }, {
                mode: "enter"
              });
              e.style.webkitTransition = y.transitions.create("-webkit-transform", xy({}, n, {
                easing: y.transitions.easing.easeOut
              })), e.style.transition = y.transitions.create("transform", xy({}, n, {
                easing: y.transitions.easing.easeOut
              })), e.style.webkitTransform = "none", e.style.transform = "none", d && d(e, t);
            }),
                I = C(l),
                T = C(h),
                O = C(function (e) {
              var t = SA({
                timeout: m,
                style: _
              }, {
                mode: "exit"
              });
              e.style.webkitTransition = y.transitions.create("-webkit-transform", xy({}, t, {
                easing: y.transitions.easing.sharp
              })), e.style.transition = y.transitions.create("transform", xy({}, t, {
                easing: y.transitions.easing.sharp
              })), FI(i, e), u && u(e);
            }),
                R = C(function (e) {
              e.style.webkitTransition = "", e.style.transition = "", p && p(e);
            }),
                N = s.useCallback(function () {
              w.current && FI(i, w.current);
            }, [i]);

            return s.useEffect(function () {
              if (!o && "down" !== i && "right" !== i) {
                var e = Uk(function () {
                  w.current && FI(i, w.current);
                });
                return window.addEventListener("resize", e), function () {
                  e.clear(), window.removeEventListener("resize", e);
                };
              }
            }, [i, o]), s.useEffect(function () {
              o || N();
            }, [o, N]), s.createElement(v, xy({
              nodeRef: w,
              onEnter: k,
              onEntered: I,
              onEntering: A,
              onExit: O,
              onExited: R,
              onExiting: T,
              appear: !0,
              in: o,
              timeout: m
            }, b), function (e, t) {
              return s.cloneElement(n, xy({
                ref: E,
                style: xy({
                  visibility: "exited" !== e || o ? void 0 : "hidden"
                }, _, n.props.style)
              }, t));
            });
          }),
              KI = GI;

          function QI(e) {
            var t = e.props,
                n = e.states,
                r = e.muiFormControl;
            return n.reduce(function (e, n) {
              return e[n] = t[n], r && void 0 === t[n] && (e[n] = r[n]), e;
            }, {});
          }

          function ZI(e, t) {
            return parseInt(e[t], 10) || 0;
          }

          var YI = "undefined" != typeof window ? s.useLayoutEffect : s.useEffect,
              JI = {
            visibility: "hidden",
            position: "absolute",
            overflow: "hidden",
            height: 0,
            top: 0,
            left: 0,
            transform: "translateZ(0)"
          },
              $I = s.forwardRef(function (e, t) {
            var n = e.onChange,
                r = e.rows,
                i = e.rowsMax,
                o = e.rowsMin,
                a = e.maxRows,
                c = e.minRows,
                l = void 0 === c ? 1 : c,
                d = e.style,
                u = e.value,
                p = bw(e, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]),
                h = a || i,
                _ = r || o || l,
                f = s.useRef(null != u).current,
                m = s.useRef(null),
                g = Kk(t, m),
                v = s.useRef(null),
                b = s.useRef(0),
                y = s.useState({}),
                w = y[0],
                S = y[1],
                x = s.useCallback(function () {
              var t = m.current,
                  n = window.getComputedStyle(t),
                  r = v.current;
              r.style.width = n.width, r.value = t.value || e.placeholder || "x", "\n" === r.value.slice(-1) && (r.value += " ");
              var i = n["box-sizing"],
                  o = ZI(n, "padding-bottom") + ZI(n, "padding-top"),
                  a = ZI(n, "border-bottom-width") + ZI(n, "border-top-width"),
                  s = r.scrollHeight - o;
              r.value = "x";
              var c = r.scrollHeight - o,
                  l = s;
              _ && (l = Math.max(Number(_) * c, l)), h && (l = Math.min(Number(h) * c, l));
              var d = (l = Math.max(l, c)) + ("border-box" === i ? o + a : 0),
                  u = Math.abs(l - s) <= 1;
              S(function (e) {
                return b.current < 20 && (d > 0 && Math.abs((e.outerHeightStyle || 0) - d) > 1 || e.overflow !== u) ? (b.current += 1, {
                  overflow: u,
                  outerHeightStyle: d
                }) : e;
              });
            }, [h, _, e.placeholder]);

            return s.useEffect(function () {
              var e = Uk(function () {
                b.current = 0, x();
              });
              return window.addEventListener("resize", e), function () {
                e.clear(), window.removeEventListener("resize", e);
              };
            }, [x]), YI(function () {
              x();
            }), s.useEffect(function () {
              b.current = 0;
            }, [u]), s.createElement(s.Fragment, null, s.createElement("textarea", xy({
              value: u,
              onChange: function onChange(e) {
                b.current = 0, f || x(), n && n(e);
              },
              ref: g,
              rows: _,
              style: xy({
                height: w.outerHeightStyle,
                overflow: w.overflow ? "hidden" : null
              }, d)
            }, p)), s.createElement("textarea", {
              "aria-hidden": !0,
              className: e.className,
              readOnly: !0,
              ref: v,
              tabIndex: -1,
              style: xy({}, JI, d)
            }));
          }),
              XI = $I;

          function eT(e) {
            return null != e && !(Array.isArray(e) && 0 === e.length);
          }

          function tT(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return e && (eT(e.value) && "" !== e.value || t && eT(e.defaultValue) && "" !== e.defaultValue);
          }

          var nT = "undefined" == typeof window ? s.useEffect : s.useLayoutEffect,
              rT = s.forwardRef(function (e, t) {
            var n = e["aria-describedby"],
                r = e.autoComplete,
                i = e.autoFocus,
                o = e.classes,
                a = e.className;
            e.color;
            var c = e.defaultValue,
                l = e.disabled,
                d = e.endAdornment;
            e.error;
            var u = e.fullWidth,
                p = void 0 !== u && u,
                h = e.id,
                _ = e.inputComponent,
                f = void 0 === _ ? "input" : _,
                m = e.inputProps,
                g = void 0 === m ? {} : m,
                v = e.inputRef;
            e.margin;
            var b = e.multiline,
                y = void 0 !== b && b,
                w = e.name,
                S = e.onBlur,
                x = e.onChange,
                E = e.onClick,
                C = e.onFocus,
                k = e.onKeyDown,
                A = e.onKeyUp,
                I = e.placeholder,
                T = e.readOnly,
                O = e.renderSuffix,
                R = e.rows,
                N = e.rowsMax,
                P = e.rowsMin,
                j = e.maxRows,
                D = e.minRows,
                z = e.startAdornment,
                M = e.type,
                L = void 0 === M ? "text" : M,
                U = e.value,
                B = bw(e, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]),
                H = null != g.value ? g.value : U,
                V = s.useRef(null != H).current,
                q = s.useRef(),
                F = s.useCallback(function (e) {}, []),
                W = Kk(g.ref, F),
                G = Kk(v, W),
                K = Kk(q, G),
                Q = s.useState(!1),
                Z = Q[0],
                Y = Q[1],
                J = tI(),
                $ = QI({
              props: e,
              muiFormControl: J,
              states: ["color", "disabled", "error", "hiddenLabel", "margin", "required", "filled"]
            });
            $.focused = J ? J.focused : Z, s.useEffect(function () {
              !J && l && Z && (Y(!1), S && S());
            }, [J, l, Z, S]);
            var X = J && J.onFilled,
                ee = J && J.onEmpty,
                te = s.useCallback(function (e) {
              tT(e) ? X && X() : ee && ee();
            }, [X, ee]);
            nT(function () {
              V && te({
                value: H
              });
            }, [H, te, V]), s.useEffect(function () {
              te(q.current);
            }, []);
            var ne = f,
                re = xy({}, g, {
              ref: K
            });
            return "string" != typeof ne ? re = xy({
              inputRef: K,
              type: L
            }, re, {
              ref: null
            }) : y ? !R || j || D || N || P ? (re = xy({
              minRows: R || D,
              rowsMax: N,
              maxRows: j
            }, re), ne = XI) : ne = "textarea" : re = xy({
              type: L
            }, re), s.useEffect(function () {
              J && J.setAdornedStart(Boolean(z));
            }, [J, z]), s.createElement("div", xy({
              className: VC(o.root, o["color".concat(jk($.color || "primary"))], a, $.disabled && o.disabled, $.error && o.error, p && o.fullWidth, $.focused && o.focused, J && o.formControl, y && o.multiline, z && o.adornedStart, d && o.adornedEnd, "dense" === $.margin && o.marginDense),
              onClick: function onClick(e) {
                q.current && e.currentTarget === e.target && q.current.focus(), E && E(e);
              },
              ref: t
            }, B), z, s.createElement(nI.Provider, {
              value: null
            }, s.createElement(ne, xy({
              "aria-invalid": $.error,
              "aria-describedby": n,
              autoComplete: r,
              autoFocus: i,
              defaultValue: c,
              disabled: $.disabled,
              id: h,
              onAnimationStart: function onAnimationStart(e) {
                te("mui-auto-fill-cancel" === e.animationName ? q.current : {
                  value: "x"
                });
              },
              name: w,
              placeholder: I,
              readOnly: T,
              required: $.required,
              rows: R,
              value: H,
              onKeyDown: k,
              onKeyUp: A
            }, re, {
              className: VC(o.input, g.className, $.disabled && o.disabled, y && o.inputMultiline, $.hiddenLabel && o.inputHiddenLabel, z && o.inputAdornedStart, d && o.inputAdornedEnd, "search" === L && o.inputTypeSearch, "dense" === $.margin && o.inputMarginDense),
              onBlur: function onBlur(e) {
                S && S(e), g.onBlur && g.onBlur(e), J && J.onBlur ? J.onBlur(e) : Y(!1);
              },
              onChange: function onChange(e) {
                if (!V) {
                  var t = e.target || q.current;
                  if (null == t) throw new Error(jy(1));
                  te({
                    value: t.value
                  });
                }

                for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
                  r[i - 1] = arguments[i];
                }

                g.onChange && g.onChange.apply(g, [e].concat(r)), x && x.apply(void 0, [e].concat(r));
              },
              onFocus: function onFocus(e) {
                $.disabled ? e.stopPropagation() : (C && C(e), g.onFocus && g.onFocus(e), J && J.onFocus ? J.onFocus(e) : Y(!0));
              }
            }))), d, O ? O(xy({}, $, {
              startAdornment: z
            })) : null);
          }),
              iT = Pk(function (e) {
            var t = "light" === e.palette.type,
                n = {
              color: "currentColor",
              opacity: t ? .42 : .5,
              transition: e.transitions.create("opacity", {
                duration: e.transitions.duration.shorter
              })
            },
                r = {
              opacity: "0 !important"
            },
                i = {
              opacity: t ? .42 : .5
            };
            return {
              "@global": {
                "@keyframes mui-auto-fill": {},
                "@keyframes mui-auto-fill-cancel": {}
              },
              root: xy({}, e.typography.body1, {
                color: e.palette.text.primary,
                lineHeight: "1.1876em",
                boxSizing: "border-box",
                position: "relative",
                cursor: "text",
                display: "inline-flex",
                alignItems: "center",
                "&$disabled": {
                  color: e.palette.text.disabled,
                  cursor: "default"
                }
              }),
              formControl: {},
              focused: {},
              disabled: {},
              adornedStart: {},
              adornedEnd: {},
              error: {},
              marginDense: {},
              multiline: {
                padding: "".concat(6, "px 0 ").concat(7, "px"),
                "&$marginDense": {
                  paddingTop: 3
                }
              },
              colorSecondary: {},
              fullWidth: {
                width: "100%"
              },
              input: {
                font: "inherit",
                letterSpacing: "inherit",
                color: "currentColor",
                padding: "".concat(6, "px 0 ").concat(7, "px"),
                border: 0,
                boxSizing: "content-box",
                background: "none",
                height: "1.1876em",
                margin: 0,
                WebkitTapHighlightColor: "transparent",
                display: "block",
                minWidth: 0,
                width: "100%",
                animationName: "mui-auto-fill-cancel",
                animationDuration: "10ms",
                "&::-webkit-input-placeholder": n,
                "&::-moz-placeholder": n,
                "&:-ms-input-placeholder": n,
                "&::-ms-input-placeholder": n,
                "&:focus": {
                  outline: 0
                },
                "&:invalid": {
                  boxShadow: "none"
                },
                "&::-webkit-search-decoration": {
                  "-webkit-appearance": "none"
                },
                "label[data-shrink=false] + $formControl &": {
                  "&::-webkit-input-placeholder": r,
                  "&::-moz-placeholder": r,
                  "&:-ms-input-placeholder": r,
                  "&::-ms-input-placeholder": r,
                  "&:focus::-webkit-input-placeholder": i,
                  "&:focus::-moz-placeholder": i,
                  "&:focus:-ms-input-placeholder": i,
                  "&:focus::-ms-input-placeholder": i
                },
                "&$disabled": {
                  opacity: 1
                },
                "&:-webkit-autofill": {
                  animationDuration: "5000s",
                  animationName: "mui-auto-fill"
                }
              },
              inputMarginDense: {
                paddingTop: 3
              },
              inputMultiline: {
                height: "auto",
                resize: "none",
                padding: 0
              },
              inputTypeSearch: {
                "-moz-appearance": "textfield",
                "-webkit-appearance": "textfield"
              },
              inputAdornedStart: {},
              inputAdornedEnd: {},
              inputHiddenLabel: {}
            };
          }, {
            name: "MuiInputBase"
          })(rT),
              oT = s.forwardRef(function (e, t) {
            var n = e.disableUnderline,
                r = e.classes,
                i = e.fullWidth,
                o = void 0 !== i && i,
                a = e.inputComponent,
                c = void 0 === a ? "input" : a,
                l = e.multiline,
                d = void 0 !== l && l,
                u = e.type,
                p = void 0 === u ? "text" : u,
                h = bw(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
            return s.createElement(iT, xy({
              classes: xy({}, r, {
                root: VC(r.root, !n && r.underline),
                underline: null
              }),
              fullWidth: o,
              inputComponent: c,
              multiline: d,
              ref: t,
              type: p
            }, h));
          });
          oT.muiName = "Input";

          var aT = Pk(function (e) {
            var t = "light" === e.palette.type,
                n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)",
                r = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
            return {
              root: {
                position: "relative",
                backgroundColor: r,
                borderTopLeftRadius: e.shape.borderRadius,
                borderTopRightRadius: e.shape.borderRadius,
                transition: e.transitions.create("background-color", {
                  duration: e.transitions.duration.shorter,
                  easing: e.transitions.easing.easeOut
                }),
                "&:hover": {
                  backgroundColor: t ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                  "@media (hover: none)": {
                    backgroundColor: r
                  }
                },
                "&$focused": {
                  backgroundColor: t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
                },
                "&$disabled": {
                  backgroundColor: t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
                }
              },
              colorSecondary: {
                "&$underline:after": {
                  borderBottomColor: e.palette.secondary.main
                }
              },
              underline: {
                "&:after": {
                  borderBottom: "2px solid ".concat(e.palette.primary.main),
                  left: 0,
                  bottom: 0,
                  content: '""',
                  position: "absolute",
                  right: 0,
                  transform: "scaleX(0)",
                  transition: e.transitions.create("transform", {
                    duration: e.transitions.duration.shorter,
                    easing: e.transitions.easing.easeOut
                  }),
                  pointerEvents: "none"
                },
                "&$focused:after": {
                  transform: "scaleX(1)"
                },
                "&$error:after": {
                  borderBottomColor: e.palette.error.main,
                  transform: "scaleX(1)"
                },
                "&:before": {
                  borderBottom: "1px solid ".concat(n),
                  left: 0,
                  bottom: 0,
                  content: '"\\00a0"',
                  position: "absolute",
                  right: 0,
                  transition: e.transitions.create("border-bottom-color", {
                    duration: e.transitions.duration.shorter
                  }),
                  pointerEvents: "none"
                },
                "&:hover:before": {
                  borderBottom: "1px solid ".concat(e.palette.text.primary)
                },
                "&$disabled:before": {
                  borderBottomStyle: "dotted"
                }
              },
              focused: {},
              disabled: {},
              adornedStart: {
                paddingLeft: 12
              },
              adornedEnd: {
                paddingRight: 12
              },
              error: {},
              marginDense: {},
              multiline: {
                padding: "27px 12px 10px",
                "&$marginDense": {
                  paddingTop: 23,
                  paddingBottom: 6
                }
              },
              input: {
                padding: "27px 12px 10px",
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "light" === e.palette.type ? null : "0 0 0 100px #266798 inset",
                  WebkitTextFillColor: "light" === e.palette.type ? null : "#fff",
                  caretColor: "light" === e.palette.type ? null : "#fff",
                  borderTopLeftRadius: "inherit",
                  borderTopRightRadius: "inherit"
                }
              },
              inputMarginDense: {
                paddingTop: 23,
                paddingBottom: 6
              },
              inputHiddenLabel: {
                paddingTop: 18,
                paddingBottom: 19,
                "&$inputMarginDense": {
                  paddingTop: 10,
                  paddingBottom: 11
                }
              },
              inputMultiline: {
                padding: 0
              },
              inputAdornedStart: {
                paddingLeft: 0
              },
              inputAdornedEnd: {
                paddingRight: 0
              }
            };
          }, {
            name: "MuiFilledInput"
          })(oT),
              sT = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.color,
                a = void 0 === o ? "primary" : o,
                c = e.component,
                l = void 0 === c ? "div" : c,
                d = e.disabled,
                u = void 0 !== d && d,
                p = e.error,
                h = void 0 !== p && p,
                _ = e.fullWidth,
                f = void 0 !== _ && _,
                m = e.focused,
                g = e.hiddenLabel,
                v = void 0 !== g && g,
                b = e.margin,
                y = void 0 === b ? "none" : b,
                w = e.required,
                S = void 0 !== w && w,
                x = e.size,
                E = e.variant,
                C = void 0 === E ? "standard" : E,
                k = bw(e, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]),
                A = s.useState(function () {
              var e = !1;
              return n && s.Children.forEach(n, function (t) {
                if (Bk(t, ["Input", "Select"])) {
                  var n = Bk(t, ["Select"]) ? t.props.input : t;
                  n && n.props.startAdornment && (e = !0);
                }
              }), e;
            }),
                I = A[0],
                T = A[1],
                O = s.useState(function () {
              var e = !1;
              return n && s.Children.forEach(n, function (t) {
                Bk(t, ["Input", "Select"]) && tT(t.props, !0) && (e = !0);
              }), e;
            }),
                R = O[0],
                N = O[1],
                P = s.useState(!1),
                j = P[0],
                D = P[1],
                z = void 0 !== m ? m : j;
            u && z && D(!1);
            var M = s.useCallback(function () {
              N(!0);
            }, []),
                L = {
              adornedStart: I,
              setAdornedStart: T,
              color: a,
              disabled: u,
              error: h,
              filled: R,
              focused: z,
              fullWidth: f,
              hiddenLabel: v,
              margin: ("small" === x ? "dense" : void 0) || y,
              onBlur: function onBlur() {
                D(!1);
              },
              onEmpty: s.useCallback(function () {
                N(!1);
              }, []),
              onFilled: M,
              onFocus: function onFocus() {
                D(!0);
              },
              registerEffect: void 0,
              required: S,
              variant: C
            };
            return s.createElement(nI.Provider, {
              value: L
            }, s.createElement(l, xy({
              className: VC(r.root, i, "none" !== y && r["margin".concat(jk(y))], f && r.fullWidth),
              ref: t
            }, k), n));
          }),
              cT = Pk({
            root: {
              display: "inline-flex",
              flexDirection: "column",
              position: "relative",
              minWidth: 0,
              padding: 0,
              margin: 0,
              border: 0,
              verticalAlign: "top"
            },
            marginNormal: {
              marginTop: 16,
              marginBottom: 8
            },
            marginDense: {
              marginTop: 8,
              marginBottom: 4
            },
            fullWidth: {
              width: "100%"
            }
          }, {
            name: "MuiFormControl"
          })(sT),
              lT = s.forwardRef(function (e, t) {
            e.checked;
            var n = e.classes,
                r = e.className,
                i = e.control,
                o = e.disabled;
            e.inputRef;
            var a = e.label,
                c = e.labelPlacement,
                l = void 0 === c ? "end" : c;
            e.name, e.onChange, e.value;
            var d = bw(e, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]),
                u = rI(),
                p = o;
            void 0 === p && void 0 !== i.props.disabled && (p = i.props.disabled), void 0 === p && u && (p = u.disabled);
            var h = {
              disabled: p
            };
            return ["checked", "name", "onChange", "value", "inputRef"].forEach(function (t) {
              void 0 === i.props[t] && void 0 !== e[t] && (h[t] = e[t]);
            }), s.createElement("label", xy({
              className: VC(n.root, r, "end" !== l && n["labelPlacement".concat(jk(l))], p && n.disabled),
              ref: t
            }, d), s.cloneElement(i, h), s.createElement(QA, {
              component: "span",
              className: VC(n.label, p && n.disabled)
            }, a));
          }),
              dT = Pk(function (e) {
            return {
              root: {
                display: "inline-flex",
                alignItems: "center",
                cursor: "pointer",
                verticalAlign: "middle",
                WebkitTapHighlightColor: "transparent",
                marginLeft: -11,
                marginRight: 16,
                "&$disabled": {
                  cursor: "default"
                }
              },
              labelPlacementStart: {
                flexDirection: "row-reverse",
                marginLeft: 16,
                marginRight: -11
              },
              labelPlacementTop: {
                flexDirection: "column-reverse",
                marginLeft: 16
              },
              labelPlacementBottom: {
                flexDirection: "column",
                marginLeft: 16
              },
              disabled: {},
              label: {
                "&$disabled": {
                  color: e.palette.text.disabled
                }
              }
            };
          }, {
            name: "MuiFormControlLabel"
          })(lT),
              uT = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.row,
                o = void 0 !== i && i,
                a = bw(e, ["classes", "className", "row"]);
            return s.createElement("div", xy({
              className: VC(n.root, r, o && n.row),
              ref: t
            }, a));
          }),
              pT = Pk({
            root: {
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap"
            },
            row: {
              flexDirection: "row"
            }
          }, {
            name: "MuiFormGroup"
          })(uT),
              hT = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.component,
                a = void 0 === o ? "p" : o;
            e.disabled, e.error, e.filled, e.focused, e.margin, e.required, e.variant;
            var c = bw(e, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]),
                l = QI({
              props: e,
              muiFormControl: rI(),
              states: ["variant", "margin", "disabled", "error", "filled", "focused", "required"]
            });
            return s.createElement(a, xy({
              className: VC(r.root, ("filled" === l.variant || "outlined" === l.variant) && r.contained, i, l.disabled && r.disabled, l.error && r.error, l.filled && r.filled, l.focused && r.focused, l.required && r.required, "dense" === l.margin && r.marginDense),
              ref: t
            }, c), " " === n ? s.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: "&#8203;"
              }
            }) : n);
          }),
              _T = Pk(function (e) {
            return {
              root: xy({
                color: e.palette.text.secondary
              }, e.typography.caption, {
                textAlign: "left",
                marginTop: 3,
                margin: 0,
                "&$disabled": {
                  color: e.palette.text.disabled
                },
                "&$error": {
                  color: e.palette.error.main
                }
              }),
              error: {},
              disabled: {},
              marginDense: {
                marginTop: 4
              },
              contained: {
                marginLeft: 14,
                marginRight: 14
              },
              focused: {},
              filled: {},
              required: {}
            };
          }, {
            name: "MuiFormHelperText"
          })(hT),
              fT = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className;
            e.color;
            var o = e.component,
                a = void 0 === o ? "label" : o;
            e.disabled, e.error, e.filled, e.focused, e.required;
            var c = bw(e, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]),
                l = QI({
              props: e,
              muiFormControl: rI(),
              states: ["color", "required", "focused", "disabled", "error", "filled"]
            });
            return s.createElement(a, xy({
              className: VC(r.root, r["color".concat(jk(l.color || "primary"))], i, l.disabled && r.disabled, l.error && r.error, l.filled && r.filled, l.focused && r.focused, l.required && r.required),
              ref: t
            }, c), n, l.required && s.createElement("span", {
              "aria-hidden": !0,
              className: VC(r.asterisk, l.error && r.error)
            }, "\u2009", "*"));
          }),
              mT = Pk(function (e) {
            return {
              root: xy({
                color: e.palette.text.secondary
              }, e.typography.body1, {
                lineHeight: 1,
                padding: 0,
                "&$focused": {
                  color: e.palette.primary.main
                },
                "&$disabled": {
                  color: e.palette.text.disabled
                },
                "&$error": {
                  color: e.palette.error.main
                }
              }),
              colorSecondary: {
                "&$focused": {
                  color: e.palette.secondary.main
                }
              },
              focused: {},
              disabled: {},
              error: {},
              filled: {},
              required: {},
              asterisk: {
                "&$error": {
                  color: e.palette.error.main
                }
              }
            };
          }, {
            name: "MuiFormLabel"
          })(fT);

          function gT(e) {
            return "scale(".concat(e, ", ").concat(Math.pow(e, 2), ")");
          }

          var vT = {
            entering: {
              opacity: 1,
              transform: gT(1)
            },
            entered: {
              opacity: 1,
              transform: "none"
            }
          },
              bT = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.disableStrictModeCompat,
                i = void 0 !== r && r,
                o = e.in,
                a = e.onEnter,
                c = e.onEntered,
                l = e.onEntering,
                d = e.onExit,
                u = e.onExited,
                p = e.onExiting,
                h = e.style,
                _ = e.timeout,
                f = void 0 === _ ? "auto" : _,
                m = e.TransitionComponent,
                g = void 0 === m ? _A : m,
                v = bw(e, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]),
                b = s.useRef(),
                y = s.useRef(),
                w = Nk(),
                S = w.unstable_strictMode && !i,
                x = s.useRef(null),
                E = Kk(n.ref, t),
                C = Kk(S ? x : void 0, E),
                k = function k(e) {
              return function (t, n) {
                if (e) {
                  var r = cS(S ? [x.current, t] : [t, n], 2),
                      i = r[0],
                      o = r[1];
                  void 0 === o ? e(i) : e(i, o);
                }
              };
            },
                A = k(l),
                I = k(function (e, t) {
              wA(e);
              var n,
                  r = SA({
                style: h,
                timeout: f
              }, {
                mode: "enter"
              }),
                  i = r.duration,
                  o = r.delay;
              "auto" === f ? (n = w.transitions.getAutoHeightDuration(e.clientHeight), y.current = n) : n = i, e.style.transition = [w.transitions.create("opacity", {
                duration: n,
                delay: o
              }), w.transitions.create("transform", {
                duration: .666 * n,
                delay: o
              })].join(","), a && a(e, t);
            }),
                T = k(c),
                O = k(p),
                R = k(function (e) {
              var t,
                  n = SA({
                style: h,
                timeout: f
              }, {
                mode: "exit"
              }),
                  r = n.duration,
                  i = n.delay;
              "auto" === f ? (t = w.transitions.getAutoHeightDuration(e.clientHeight), y.current = t) : t = r, e.style.transition = [w.transitions.create("opacity", {
                duration: t,
                delay: i
              }), w.transitions.create("transform", {
                duration: .666 * t,
                delay: i || .333 * t
              })].join(","), e.style.opacity = "0", e.style.transform = gT(.75), d && d(e);
            }),
                N = k(u);

            return s.useEffect(function () {
              return function () {
                clearTimeout(b.current);
              };
            }, []), s.createElement(g, xy({
              appear: !0,
              in: o,
              nodeRef: S ? x : void 0,
              onEnter: I,
              onEntered: T,
              onEntering: A,
              onExit: R,
              onExited: N,
              onExiting: O,
              addEndListener: function addEndListener(e, t) {
                var n = S ? e : t;
                "auto" === f && (b.current = setTimeout(n, y.current || 0));
              },
              timeout: "auto" === f ? null : f
            }, v), function (e, t) {
              return s.cloneElement(n, xy({
                style: xy({
                  opacity: 0,
                  transform: gT(.75),
                  visibility: "exited" !== e || o ? void 0 : "hidden"
                }, vT[e], h, n.props.style),
                ref: C
              }, t));
            });
          });
          bT.muiSupportAuto = !0;
          var yT = bT,
              wT = s.forwardRef(function (e, t) {
            var n = e.disableUnderline,
                r = e.classes,
                i = e.fullWidth,
                o = void 0 !== i && i,
                a = e.inputComponent,
                c = void 0 === a ? "input" : a,
                l = e.multiline,
                d = void 0 !== l && l,
                u = e.type,
                p = void 0 === u ? "text" : u,
                h = bw(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
            return s.createElement(iT, xy({
              classes: xy({}, r, {
                root: VC(r.root, !n && r.underline),
                underline: null
              }),
              fullWidth: o,
              inputComponent: c,
              multiline: d,
              ref: t,
              type: p
            }, h));
          });
          wT.muiName = "Input";
          var ST = Pk(function (e) {
            var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
            return {
              root: {
                position: "relative"
              },
              formControl: {
                "label + &": {
                  marginTop: 16
                }
              },
              focused: {},
              disabled: {},
              colorSecondary: {
                "&$underline:after": {
                  borderBottomColor: e.palette.secondary.main
                }
              },
              underline: {
                "&:after": {
                  borderBottom: "2px solid ".concat(e.palette.primary.main),
                  left: 0,
                  bottom: 0,
                  content: '""',
                  position: "absolute",
                  right: 0,
                  transform: "scaleX(0)",
                  transition: e.transitions.create("transform", {
                    duration: e.transitions.duration.shorter,
                    easing: e.transitions.easing.easeOut
                  }),
                  pointerEvents: "none"
                },
                "&$focused:after": {
                  transform: "scaleX(1)"
                },
                "&$error:after": {
                  borderBottomColor: e.palette.error.main,
                  transform: "scaleX(1)"
                },
                "&:before": {
                  borderBottom: "1px solid ".concat(t),
                  left: 0,
                  bottom: 0,
                  content: '"\\00a0"',
                  position: "absolute",
                  right: 0,
                  transition: e.transitions.create("border-bottom-color", {
                    duration: e.transitions.duration.shorter
                  }),
                  pointerEvents: "none"
                },
                "&:hover:not($disabled):before": {
                  borderBottom: "2px solid ".concat(e.palette.text.primary),
                  "@media (hover: none)": {
                    borderBottom: "1px solid ".concat(t)
                  }
                },
                "&$disabled:before": {
                  borderBottomStyle: "dotted"
                }
              },
              error: {},
              marginDense: {},
              multiline: {},
              fullWidth: {},
              input: {},
              inputMarginDense: {},
              inputMultiline: {},
              inputTypeSearch: {}
            };
          }, {
            name: "MuiInput"
          })(wT),
              xT = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.component,
                a = void 0 === o ? "div" : o,
                c = e.disablePointerEvents,
                l = void 0 !== c && c,
                d = e.disableTypography,
                u = void 0 !== d && d,
                p = e.position,
                h = e.variant,
                _ = bw(e, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]),
                f = tI() || {},
                m = h;

            return h && f.variant, f && !m && (m = f.variant), s.createElement(nI.Provider, {
              value: null
            }, s.createElement(a, xy({
              className: VC(r.root, i, "end" === p ? r.positionEnd : r.positionStart, l && r.disablePointerEvents, f.hiddenLabel && r.hiddenLabel, "filled" === m && r.filled, "dense" === f.margin && r.marginDense),
              ref: t
            }, _), "string" != typeof n || u ? n : s.createElement(QA, {
              color: "textSecondary"
            }, n)));
          }),
              ET = Pk({
            root: {
              display: "flex",
              height: "0.01em",
              maxHeight: "2em",
              alignItems: "center",
              whiteSpace: "nowrap"
            },
            filled: {
              "&$positionStart:not($hiddenLabel)": {
                marginTop: 16
              }
            },
            positionStart: {
              marginRight: 8
            },
            positionEnd: {
              marginLeft: 8
            },
            disablePointerEvents: {
              pointerEvents: "none"
            },
            hiddenLabel: {},
            marginDense: {}
          }, {
            name: "MuiInputAdornment"
          })(xT),
              CT = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.disableAnimation,
                o = void 0 !== i && i;
            e.margin;
            var a = e.shrink;
            e.variant;
            var c = bw(e, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]),
                l = rI(),
                d = a;
            void 0 === d && l && (d = l.filled || l.focused || l.adornedStart);
            var u = QI({
              props: e,
              muiFormControl: l,
              states: ["margin", "variant"]
            });
            return s.createElement(mT, xy({
              "data-shrink": d,
              className: VC(n.root, r, l && n.formControl, !o && n.animated, d && n.shrink, "dense" === u.margin && n.marginDense, {
                filled: n.filled,
                outlined: n.outlined
              }[u.variant]),
              classes: {
                focused: n.focused,
                disabled: n.disabled,
                error: n.error,
                required: n.required,
                asterisk: n.asterisk
              },
              ref: t
            }, c));
          }),
              kT = Pk(function (e) {
            return {
              root: {
                display: "block",
                transformOrigin: "top left"
              },
              focused: {},
              disabled: {},
              error: {},
              required: {},
              asterisk: {},
              formControl: {
                position: "absolute",
                left: 0,
                top: 0,
                transform: "translate(0, 24px) scale(1)"
              },
              marginDense: {
                transform: "translate(0, 21px) scale(1)"
              },
              shrink: {
                transform: "translate(0, 1.5px) scale(0.75)",
                transformOrigin: "top left"
              },
              animated: {
                transition: e.transitions.create(["color", "transform"], {
                  duration: e.transitions.duration.shorter,
                  easing: e.transitions.easing.easeOut
                })
              },
              filled: {
                zIndex: 1,
                pointerEvents: "none",
                transform: "translate(12px, 20px) scale(1)",
                "&$marginDense": {
                  transform: "translate(12px, 17px) scale(1)"
                },
                "&$shrink": {
                  transform: "translate(12px, 10px) scale(0.75)",
                  "&$marginDense": {
                    transform: "translate(12px, 7px) scale(0.75)"
                  }
                }
              },
              outlined: {
                zIndex: 1,
                pointerEvents: "none",
                transform: "translate(14px, 20px) scale(1)",
                "&$marginDense": {
                  transform: "translate(14px, 12px) scale(1)"
                },
                "&$shrink": {
                  transform: "translate(14px, -6px) scale(0.75)"
                }
              }
            };
          }, {
            name: "MuiInputLabel"
          })(CT),
              AT = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.color,
                o = void 0 === i ? "primary" : i,
                a = e.value,
                c = e.valueBuffer,
                l = e.variant,
                d = void 0 === l ? "indeterminate" : l,
                u = bw(e, ["classes", "className", "color", "value", "valueBuffer", "variant"]),
                p = Nk(),
                h = {},
                _ = {
              bar1: {},
              bar2: {}
            };

            if (("determinate" === d || "buffer" === d) && void 0 !== a) {
              h["aria-valuenow"] = Math.round(a), h["aria-valuemin"] = 0, h["aria-valuemax"] = 100;
              var f = a - 100;
              "rtl" === p.direction && (f = -f), _.bar1.transform = "translateX(".concat(f, "%)");
            }

            if ("buffer" === d && void 0 !== c) {
              var m = (c || 0) - 100;
              "rtl" === p.direction && (m = -m), _.bar2.transform = "translateX(".concat(m, "%)");
            }

            return s.createElement("div", xy({
              className: VC(n.root, n["color".concat(jk(o))], r, {
                determinate: n.determinate,
                indeterminate: n.indeterminate,
                buffer: n.buffer,
                query: n.query
              }[d]),
              role: "progressbar"
            }, h, {
              ref: t
            }, u), "buffer" === d ? s.createElement("div", {
              className: VC(n.dashed, n["dashedColor".concat(jk(o))])
            }) : null, s.createElement("div", {
              className: VC(n.bar, n["barColor".concat(jk(o))], ("indeterminate" === d || "query" === d) && n.bar1Indeterminate, {
                determinate: n.bar1Determinate,
                buffer: n.bar1Buffer
              }[d]),
              style: _.bar1
            }), "determinate" === d ? null : s.createElement("div", {
              className: VC(n.bar, ("indeterminate" === d || "query" === d) && n.bar2Indeterminate, "buffer" === d ? [n["color".concat(jk(o))], n.bar2Buffer] : n["barColor".concat(jk(o))]),
              style: _.bar2
            }));
          }),
              IT = Pk(function (e) {
            var t = function t(_t138) {
              return "light" === e.palette.type ? gw(_t138, .62) : mw(_t138, .5);
            },
                n = t(e.palette.primary.main),
                r = t(e.palette.secondary.main);

            return {
              root: {
                position: "relative",
                overflow: "hidden",
                height: 4,
                "@media print": {
                  colorAdjust: "exact"
                }
              },
              colorPrimary: {
                backgroundColor: n
              },
              colorSecondary: {
                backgroundColor: r
              },
              determinate: {},
              indeterminate: {},
              buffer: {
                backgroundColor: "transparent"
              },
              query: {
                transform: "rotate(180deg)"
              },
              dashed: {
                position: "absolute",
                marginTop: 0,
                height: "100%",
                width: "100%",
                animation: "$buffer 3s infinite linear"
              },
              dashedColorPrimary: {
                backgroundImage: "radial-gradient(".concat(n, " 0%, ").concat(n, " 16%, transparent 42%)"),
                backgroundSize: "10px 10px",
                backgroundPosition: "0 -23px"
              },
              dashedColorSecondary: {
                backgroundImage: "radial-gradient(".concat(r, " 0%, ").concat(r, " 16%, transparent 42%)"),
                backgroundSize: "10px 10px",
                backgroundPosition: "0 -23px"
              },
              bar: {
                width: "100%",
                position: "absolute",
                left: 0,
                bottom: 0,
                top: 0,
                transition: "transform 0.2s linear",
                transformOrigin: "left"
              },
              barColorPrimary: {
                backgroundColor: e.palette.primary.main
              },
              barColorSecondary: {
                backgroundColor: e.palette.secondary.main
              },
              bar1Indeterminate: {
                width: "auto",
                animation: "$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite"
              },
              bar1Determinate: {
                transition: "transform .".concat(4, "s linear")
              },
              bar1Buffer: {
                zIndex: 1,
                transition: "transform .".concat(4, "s linear")
              },
              bar2Indeterminate: {
                width: "auto",
                animation: "$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite"
              },
              bar2Buffer: {
                transition: "transform .".concat(4, "s linear")
              },
              "@keyframes indeterminate1": {
                "0%": {
                  left: "-35%",
                  right: "100%"
                },
                "60%": {
                  left: "100%",
                  right: "-90%"
                },
                "100%": {
                  left: "100%",
                  right: "-90%"
                }
              },
              "@keyframes indeterminate2": {
                "0%": {
                  left: "-200%",
                  right: "100%"
                },
                "60%": {
                  left: "107%",
                  right: "-8%"
                },
                "100%": {
                  left: "107%",
                  right: "-8%"
                }
              },
              "@keyframes buffer": {
                "0%": {
                  opacity: 1,
                  backgroundPosition: "0 -23px"
                },
                "50%": {
                  opacity: 0,
                  backgroundPosition: "0 -23px"
                },
                "100%": {
                  opacity: 1,
                  backgroundPosition: "-200px -23px"
                }
              }
            };
          }, {
            name: "MuiLinearProgress"
          })(AT),
              TT = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.color,
                o = void 0 === i ? "primary" : i,
                a = e.component,
                c = void 0 === a ? "a" : a,
                l = e.onBlur,
                d = e.onFocus,
                u = e.TypographyClasses,
                p = e.underline,
                h = void 0 === p ? "hover" : p,
                _ = e.variant,
                f = void 0 === _ ? "inherit" : _,
                m = bw(e, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]),
                g = iA(),
                v = g.isFocusVisible,
                b = g.onBlurVisible,
                y = g.ref,
                w = s.useState(!1),
                S = w[0],
                x = w[1],
                E = Kk(t, y);
            return s.createElement(QA, xy({
              className: VC(n.root, n["underline".concat(jk(h))], r, S && n.focusVisible, "button" === c && n.button),
              classes: u,
              color: o,
              component: c,
              onBlur: function onBlur(e) {
                S && (b(), x(!1)), l && l(e);
              },
              onFocus: function onFocus(e) {
                v(e) && x(!0), d && d(e);
              },
              ref: E,
              variant: f
            }, m));
          }),
              OT = Pk({
            root: {},
            underlineNone: {
              textDecoration: "none"
            },
            underlineHover: {
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline"
              }
            },
            underlineAlways: {
              textDecoration: "underline"
            },
            button: {
              position: "relative",
              WebkitTapHighlightColor: "transparent",
              backgroundColor: "transparent",
              outline: 0,
              border: 0,
              margin: 0,
              borderRadius: 0,
              padding: 0,
              cursor: "pointer",
              userSelect: "none",
              verticalAlign: "middle",
              "-moz-appearance": "none",
              "-webkit-appearance": "none",
              "&::-moz-focus-inner": {
                borderStyle: "none"
              },
              "&$focusVisible": {
                outline: "auto"
              }
            },
            focusVisible: {}
          }, {
            name: "MuiLink"
          })(TT),
              RT = s.createContext({}),
              NT = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.component,
                a = void 0 === o ? "ul" : o,
                c = e.dense,
                l = void 0 !== c && c,
                d = e.disablePadding,
                u = void 0 !== d && d,
                p = e.subheader,
                h = bw(e, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]),
                _ = s.useMemo(function () {
              return {
                dense: l
              };
            }, [l]);

            return s.createElement(RT.Provider, {
              value: _
            }, s.createElement(a, xy({
              className: VC(r.root, i, l && r.dense, !u && r.padding, p && r.subheader),
              ref: t
            }, h), p, n));
          }),
              PT = Pk({
            root: {
              listStyle: "none",
              margin: 0,
              padding: 0,
              position: "relative"
            },
            padding: {
              paddingTop: 8,
              paddingBottom: 8
            },
            dense: {},
            subheader: {
              paddingTop: 0
            }
          }, {
            name: "MuiList"
          })(NT),
              jT = "undefined" == typeof window ? s.useEffect : s.useLayoutEffect,
              DT = s.forwardRef(function (e, t) {
            var n = e.alignItems,
                r = void 0 === n ? "center" : n,
                i = e.autoFocus,
                o = void 0 !== i && i,
                a = e.button,
                l = void 0 !== a && a,
                d = e.children,
                u = e.classes,
                p = e.className,
                h = e.component,
                _ = e.ContainerComponent,
                f = void 0 === _ ? "li" : _,
                m = e.ContainerProps,
                g = (m = void 0 === m ? {} : m).className,
                v = bw(m, ["className"]),
                b = e.dense,
                y = void 0 !== b && b,
                w = e.disabled,
                S = void 0 !== w && w,
                x = e.disableGutters,
                E = void 0 !== x && x,
                C = e.divider,
                k = void 0 !== C && C,
                A = e.focusVisibleClassName,
                I = e.selected,
                T = void 0 !== I && I,
                O = bw(e, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]),
                R = s.useContext(RT),
                N = {
              dense: y || R.dense || !1,
              alignItems: r
            },
                P = s.useRef(null);
            jT(function () {
              o && P.current && P.current.focus();
            }, [o]);
            var j = s.Children.toArray(d),
                D = j.length && Bk(j[j.length - 1], ["ListItemSecondaryAction"]),
                z = Kk(s.useCallback(function (e) {
              P.current = c.findDOMNode(e);
            }, []), t),
                M = xy({
              className: VC(u.root, p, N.dense && u.dense, !E && u.gutters, k && u.divider, S && u.disabled, l && u.button, "center" !== r && u.alignItemsFlexStart, D && u.secondaryAction, T && u.selected),
              disabled: S
            }, O),
                L = h || "li";
            return l && (M.component = h || "div", M.focusVisibleClassName = VC(u.focusVisible, A), L = NA), D ? (L = M.component || h ? L : "div", "li" === f && ("li" === L ? L = "div" : "li" === M.component && (M.component = "div")), s.createElement(RT.Provider, {
              value: N
            }, s.createElement(f, xy({
              className: VC(u.container, g),
              ref: z
            }, v), s.createElement(L, M, j), j.pop()))) : s.createElement(RT.Provider, {
              value: N
            }, s.createElement(L, xy({
              ref: z
            }, M), j));
          }),
              zT = Pk(function (e) {
            return {
              root: {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                position: "relative",
                textDecoration: "none",
                width: "100%",
                boxSizing: "border-box",
                textAlign: "left",
                paddingTop: 8,
                paddingBottom: 8,
                "&$focusVisible": {
                  backgroundColor: e.palette.action.selected
                },
                "&$selected, &$selected:hover": {
                  backgroundColor: e.palette.action.selected
                },
                "&$disabled": {
                  opacity: .5
                }
              },
              container: {
                position: "relative"
              },
              focusVisible: {},
              dense: {
                paddingTop: 4,
                paddingBottom: 4
              },
              alignItemsFlexStart: {
                alignItems: "flex-start"
              },
              disabled: {},
              divider: {
                borderBottom: "1px solid ".concat(e.palette.divider),
                backgroundClip: "padding-box"
              },
              gutters: {
                paddingLeft: 16,
                paddingRight: 16
              },
              button: {
                transition: e.transitions.create("background-color", {
                  duration: e.transitions.duration.shortest
                }),
                "&:hover": {
                  textDecoration: "none",
                  backgroundColor: e.palette.action.hover,
                  "@media (hover: none)": {
                    backgroundColor: "transparent"
                  }
                }
              },
              secondaryAction: {
                paddingRight: 48
              },
              selected: {}
            };
          }, {
            name: "MuiListItem"
          })(DT),
              MT = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = bw(e, ["classes", "className"]),
                o = s.useContext(RT);
            return s.createElement("div", xy({
              className: VC(n.root, r, "flex-start" === o.alignItems && n.alignItemsFlexStart),
              ref: t
            }, i));
          }),
              LT = Pk({
            root: {
              minWidth: 56,
              flexShrink: 0
            },
            alignItemsFlexStart: {
              marginTop: 8
            }
          }, {
            name: "MuiListItemAvatar"
          })(MT),
              UT = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = bw(e, ["classes", "className"]),
                o = s.useContext(RT);
            return s.createElement("div", xy({
              className: VC(n.root, r, "flex-start" === o.alignItems && n.alignItemsFlexStart),
              ref: t
            }, i));
          }),
              BT = Pk(function (e) {
            return {
              root: {
                minWidth: 56,
                color: e.palette.action.active,
                flexShrink: 0,
                display: "inline-flex"
              },
              alignItemsFlexStart: {
                marginTop: 8
              }
            };
          }, {
            name: "MuiListItemIcon"
          })(UT),
              HT = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.disableTypography,
                a = void 0 !== o && o,
                c = e.inset,
                l = void 0 !== c && c,
                d = e.primary,
                u = e.primaryTypographyProps,
                p = e.secondary,
                h = e.secondaryTypographyProps,
                _ = bw(e, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]),
                f = s.useContext(RT).dense,
                m = null != d ? d : n;

            null == m || m.type === QA || a || (m = s.createElement(QA, xy({
              variant: f ? "body2" : "body1",
              className: r.primary,
              component: "span",
              display: "block"
            }, u), m));
            var g = p;
            return null == g || g.type === QA || a || (g = s.createElement(QA, xy({
              variant: "body2",
              className: r.secondary,
              color: "textSecondary",
              display: "block"
            }, h), g)), s.createElement("div", xy({
              className: VC(r.root, i, f && r.dense, l && r.inset, m && g && r.multiline),
              ref: t
            }, _), m, g);
          }),
              VT = Pk({
            root: {
              flex: "1 1 auto",
              minWidth: 0,
              marginTop: 4,
              marginBottom: 4
            },
            multiline: {
              marginTop: 6,
              marginBottom: 6
            },
            dense: {},
            inset: {
              paddingLeft: 56
            },
            primary: {},
            secondary: {}
          }, {
            name: "MuiListItemText"
          })(HT),
              qT = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.color,
                o = void 0 === i ? "default" : i,
                a = e.component,
                c = void 0 === a ? "li" : a,
                l = e.disableGutters,
                d = void 0 !== l && l,
                u = e.disableSticky,
                p = void 0 !== u && u,
                h = e.inset,
                _ = void 0 !== h && h,
                f = bw(e, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

            return s.createElement(c, xy({
              className: VC(n.root, r, "default" !== o && n["color".concat(jk(o))], _ && n.inset, !p && n.sticky, !d && n.gutters),
              ref: t
            }, f));
          }),
              FT = Pk(function (e) {
            return {
              root: {
                boxSizing: "border-box",
                lineHeight: "48px",
                listStyle: "none",
                color: e.palette.text.secondary,
                fontFamily: e.typography.fontFamily,
                fontWeight: e.typography.fontWeightMedium,
                fontSize: e.typography.pxToRem(14)
              },
              colorPrimary: {
                color: e.palette.primary.main
              },
              colorInherit: {
                color: "inherit"
              },
              gutters: {
                paddingLeft: 16,
                paddingRight: 16
              },
              inset: {
                paddingLeft: 72
              },
              sticky: {
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "inherit"
              }
            };
          }, {
            name: "MuiListSubheader"
          })(qT);

          function WT(e, t) {
            var n = 0;
            return "number" == typeof t ? n = t : "center" === t ? n = e.height / 2 : "bottom" === t && (n = e.height), n;
          }

          function GT(e, t) {
            var n = 0;
            return "number" == typeof t ? n = t : "center" === t ? n = e.width / 2 : "right" === t && (n = e.width), n;
          }

          function KT(e) {
            return [e.horizontal, e.vertical].map(function (e) {
              return "number" == typeof e ? "".concat(e, "px") : e;
            }).join(" ");
          }

          function QT(e) {
            return "function" == typeof e ? e() : e;
          }

          var ZT = s.forwardRef(function (e, t) {
            var n = e.action,
                r = e.anchorEl,
                i = e.anchorOrigin,
                o = void 0 === i ? {
              vertical: "top",
              horizontal: "left"
            } : i,
                a = e.anchorPosition,
                l = e.anchorReference,
                d = void 0 === l ? "anchorEl" : l,
                u = e.children,
                p = e.classes,
                h = e.className,
                _ = e.container,
                f = e.elevation,
                m = void 0 === f ? 8 : f,
                g = e.getContentAnchorEl,
                v = e.marginThreshold,
                b = void 0 === v ? 16 : v,
                y = e.onEnter,
                w = e.onEntered,
                S = e.onEntering,
                x = e.onExit,
                E = e.onExited,
                C = e.onExiting,
                k = e.open,
                A = e.PaperProps,
                I = void 0 === A ? {} : A,
                T = e.transformOrigin,
                O = void 0 === T ? {
              vertical: "top",
              horizontal: "left"
            } : T,
                R = e.TransitionComponent,
                N = void 0 === R ? yT : R,
                P = e.transitionDuration,
                j = void 0 === P ? "auto" : P,
                D = e.TransitionProps,
                z = void 0 === D ? {} : D,
                M = bw(e, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]),
                L = s.useRef(),
                U = s.useCallback(function (e) {
              if ("anchorPosition" === d) return a;
              var t = QT(r),
                  n = (t && 1 === t.nodeType ? t : Hk(L.current).body).getBoundingClientRect(),
                  i = 0 === e ? o.vertical : "center";
              return {
                top: n.top + WT(n, i),
                left: n.left + GT(n, o.horizontal)
              };
            }, [r, o.horizontal, o.vertical, a, d]),
                B = s.useCallback(function (e) {
              var t = 0;

              if (g && "anchorEl" === d) {
                var n = g(e);

                if (n && e.contains(n)) {
                  var r = function (e, t) {
                    for (var n = t, r = 0; n && n !== e;) {
                      r += (n = n.parentElement).scrollTop;
                    }

                    return r;
                  }(e, n);

                  t = n.offsetTop + n.clientHeight / 2 - r || 0;
                }
              }

              return t;
            }, [o.vertical, d, g]),
                H = s.useCallback(function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
              return {
                vertical: WT(e, O.vertical) + t,
                horizontal: GT(e, O.horizontal)
              };
            }, [O.horizontal, O.vertical]),
                V = s.useCallback(function (e) {
              var t = B(e),
                  n = {
                width: e.offsetWidth,
                height: e.offsetHeight
              },
                  i = H(n, t);
              if ("none" === d) return {
                top: null,
                left: null,
                transformOrigin: KT(i)
              };
              var o = U(t),
                  a = o.top - i.vertical,
                  s = o.left - i.horizontal,
                  c = a + n.height,
                  l = s + n.width,
                  u = Vk(QT(r)),
                  p = u.innerHeight - b,
                  h = u.innerWidth - b;

              if (a < b) {
                var _ = a - b;

                a -= _, i.vertical += _;
              } else if (c > p) {
                var f = c - p;
                a -= f, i.vertical += f;
              }

              if (s < b) {
                var m = s - b;
                s -= m, i.horizontal += m;
              } else if (l > h) {
                var g = l - h;
                s -= g, i.horizontal += g;
              }

              return {
                top: "".concat(Math.round(a), "px"),
                left: "".concat(Math.round(s), "px"),
                transformOrigin: KT(i)
              };
            }, [r, d, U, B, H, b]),
                q = s.useCallback(function () {
              var e = L.current;

              if (e) {
                var t = V(e);
                null !== t.top && (e.style.top = t.top), null !== t.left && (e.style.left = t.left), e.style.transformOrigin = t.transformOrigin;
              }
            }, [V]),
                F = s.useCallback(function (e) {
              L.current = c.findDOMNode(e);
            }, []);
            s.useEffect(function () {
              k && q();
            }), s.useImperativeHandle(n, function () {
              return k ? {
                updatePosition: function updatePosition() {
                  q();
                }
              } : null;
            }, [k, q]), s.useEffect(function () {
              if (k) {
                var e = Uk(function () {
                  q();
                });
                return window.addEventListener("resize", e), function () {
                  e.clear(), window.removeEventListener("resize", e);
                };
              }
            }, [k, q]);
            var W = j;
            "auto" !== j || N.muiSupportAuto || (W = void 0);
            var G = _ || (r ? Hk(QT(r)).body : void 0);
            return s.createElement(OI, xy({
              container: G,
              open: k,
              ref: t,
              BackdropProps: {
                invisible: !0
              },
              className: VC(p.root, h)
            }, M), s.createElement(N, xy({
              appear: !0,
              in: k,
              onEnter: y,
              onEntered: w,
              onExit: x,
              onExited: E,
              onExiting: C,
              timeout: W
            }, z, {
              onEntering: Dk(function (e, t) {
                S && S(e, t), q();
              }, z.onEntering)
            }), s.createElement(kA, xy({
              elevation: m,
              ref: F
            }, I, {
              className: VC(p.paper, I.className)
            }), u)));
          }),
              YT = Pk({
            root: {},
            paper: {
              position: "absolute",
              overflowY: "auto",
              overflowX: "hidden",
              minWidth: 16,
              minHeight: 16,
              maxWidth: "calc(100% - 32px)",
              maxHeight: "calc(100% - 32px)",
              outline: 0
            }
          }, {
            name: "MuiPopover"
          })(ZT);

          function JT(e, t, n) {
            return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
          }

          function $T(e, t, n) {
            return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
          }

          function XT(e, t) {
            if (void 0 === t) return !0;
            var n = e.innerText;
            return void 0 === n && (n = e.textContent), 0 !== (n = n.trim().toLowerCase()).length && (t.repeating ? n[0] === t.keys[0] : 0 === n.indexOf(t.keys.join("")));
          }

          function eO(e, t, n, r, i, o) {
            for (var a = !1, s = i(e, t, !!t && n); s;) {
              if (s === e.firstChild) {
                if (a) return;
                a = !0;
              }

              var c = !r && (s.disabled || "true" === s.getAttribute("aria-disabled"));
              if (s.hasAttribute("tabindex") && XT(s, o) && !c) return void s.focus();
              s = i(e, s, n);
            }
          }

          var tO = "undefined" == typeof window ? s.useEffect : s.useLayoutEffect,
              nO = s.forwardRef(function (e, t) {
            var n = e.actions,
                r = e.autoFocus,
                i = void 0 !== r && r,
                o = e.autoFocusItem,
                a = void 0 !== o && o,
                l = e.children,
                d = e.className,
                u = e.disabledItemsFocusable,
                p = void 0 !== u && u,
                h = e.disableListWrap,
                _ = void 0 !== h && h,
                f = e.onKeyDown,
                m = e.variant,
                g = void 0 === m ? "selectedMenu" : m,
                v = bw(e, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]),
                b = s.useRef(null),
                y = s.useRef({
              keys: [],
              repeating: !0,
              previousKeyMatched: !0,
              lastTime: null
            });

            tO(function () {
              i && b.current.focus();
            }, [i]), s.useImperativeHandle(n, function () {
              return {
                adjustStyleForScrollbar: function adjustStyleForScrollbar(e, t) {
                  var n = !b.current.style.width;

                  if (e.clientHeight < b.current.clientHeight && n) {
                    var r = "".concat(vI(), "px");
                    b.current.style["rtl" === t.direction ? "paddingLeft" : "paddingRight"] = r, b.current.style.width = "calc(100% + ".concat(r, ")");
                  }

                  return b.current;
                }
              };
            }, []);
            var w = Kk(s.useCallback(function (e) {
              b.current = c.findDOMNode(e);
            }, []), t),
                S = -1;
            s.Children.forEach(l, function (e, t) {
              s.isValidElement(e) && (e.props.disabled || ("selectedMenu" === g && e.props.selected || -1 === S) && (S = t));
            });
            var x = s.Children.map(l, function (e, t) {
              if (t === S) {
                var n = {};
                return a && (n.autoFocus = !0), void 0 === e.props.tabIndex && "selectedMenu" === g && (n.tabIndex = 0), s.cloneElement(e, n);
              }

              return e;
            });
            return s.createElement(PT, xy({
              role: "menu",
              ref: w,
              className: d,
              onKeyDown: function onKeyDown(e) {
                var t = b.current,
                    n = e.key,
                    r = Hk(t).activeElement;
                if ("ArrowDown" === n) e.preventDefault(), eO(t, r, _, p, JT);else if ("ArrowUp" === n) e.preventDefault(), eO(t, r, _, p, $T);else if ("Home" === n) e.preventDefault(), eO(t, null, _, p, JT);else if ("End" === n) e.preventDefault(), eO(t, null, _, p, $T);else if (1 === n.length) {
                  var i = y.current,
                      o = n.toLowerCase(),
                      a = performance.now();
                  i.keys.length > 0 && (a - i.lastTime > 500 ? (i.keys = [], i.repeating = !0, i.previousKeyMatched = !0) : i.repeating && o !== i.keys[0] && (i.repeating = !1)), i.lastTime = a, i.keys.push(o);
                  var s = r && !i.repeating && XT(r, i);
                  i.previousKeyMatched && (s || eO(t, r, !1, p, JT, i)) ? e.preventDefault() : i.previousKeyMatched = !1;
                }
                f && f(e);
              },
              tabIndex: i ? 0 : -1
            }, v), x);
          }),
              rO = nO,
              iO = {
            vertical: "top",
            horizontal: "right"
          },
              oO = {
            vertical: "top",
            horizontal: "left"
          },
              aO = s.forwardRef(function (e, t) {
            var n = e.autoFocus,
                r = void 0 === n || n,
                i = e.children,
                o = e.classes,
                a = e.disableAutoFocusItem,
                l = void 0 !== a && a,
                d = e.MenuListProps,
                u = void 0 === d ? {} : d,
                p = e.onClose,
                h = e.onEntering,
                _ = e.open,
                f = e.PaperProps,
                m = void 0 === f ? {} : f,
                g = e.PopoverClasses,
                v = e.transitionDuration,
                b = void 0 === v ? "auto" : v,
                y = e.TransitionProps,
                w = (y = void 0 === y ? {} : y).onEntering,
                S = bw(y, ["onEntering"]),
                x = e.variant,
                E = void 0 === x ? "selectedMenu" : x,
                C = bw(e, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]),
                k = Nk(),
                A = r && !l && _,
                I = s.useRef(null),
                T = s.useRef(null),
                O = -1;
            s.Children.map(i, function (e, t) {
              s.isValidElement(e) && (e.props.disabled || ("menu" !== E && e.props.selected || -1 === O) && (O = t));
            });
            var R = s.Children.map(i, function (e, t) {
              return t === O ? s.cloneElement(e, {
                ref: function ref(t) {
                  T.current = c.findDOMNode(t), qk(e.ref, t);
                }
              }) : e;
            });
            return s.createElement(YT, xy({
              getContentAnchorEl: function getContentAnchorEl() {
                return T.current;
              },
              classes: g,
              onClose: p,
              TransitionProps: xy({
                onEntering: function onEntering(e, t) {
                  I.current && I.current.adjustStyleForScrollbar(e, k), h && h(e, t), w && w(e, t);
                }
              }, S),
              anchorOrigin: "rtl" === k.direction ? iO : oO,
              transformOrigin: "rtl" === k.direction ? iO : oO,
              PaperProps: xy({}, m, {
                classes: xy({}, m.classes, {
                  root: o.paper
                })
              }),
              open: _,
              ref: t,
              transitionDuration: b
            }, C), s.createElement(rO, xy({
              onKeyDown: function onKeyDown(e) {
                "Tab" === e.key && (e.preventDefault(), p && p(e, "tabKeyDown"));
              },
              actions: I,
              autoFocus: r && (-1 === O || l),
              autoFocusItem: A,
              variant: E
            }, u, {
              className: VC(o.list, u.className)
            }), R));
          }),
              sO = Pk({
            paper: {
              maxHeight: "calc(100% - 96px)",
              WebkitOverflowScrolling: "touch"
            },
            list: {
              outline: 0
            }
          }, {
            name: "MuiMenu"
          })(aO),
              cO = s.forwardRef(function (e, t) {
            var n,
                r = e.classes,
                i = e.className,
                o = e.component,
                a = void 0 === o ? "li" : o,
                c = e.disableGutters,
                l = void 0 !== c && c,
                d = e.ListItemClasses,
                u = e.role,
                p = void 0 === u ? "menuitem" : u,
                h = e.selected,
                _ = e.tabIndex,
                f = bw(e, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);
            return e.disabled || (n = void 0 !== _ ? _ : -1), s.createElement(zT, xy({
              button: !0,
              role: p,
              tabIndex: n,
              component: a,
              selected: h,
              disableGutters: l,
              classes: xy({
                dense: r.dense
              }, d),
              className: VC(r.root, i, h && r.selected, !l && r.gutters),
              ref: t
            }, f));
          }),
              lO = Pk(function (e) {
            return {
              root: xy({}, e.typography.body1, Py({
                minHeight: 48,
                paddingTop: 6,
                paddingBottom: 6,
                boxSizing: "border-box",
                width: "auto",
                overflow: "hidden",
                whiteSpace: "nowrap"
              }, e.breakpoints.up("sm"), {
                minHeight: "auto"
              })),
              gutters: {},
              selected: {},
              dense: xy({}, e.typography.body2, {
                minHeight: "auto"
              })
            };
          }, {
            name: "MuiMenuItem"
          })(cO),
              dO = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.disabled,
                o = e.IconComponent,
                a = e.inputRef,
                c = e.variant,
                l = void 0 === c ? "standard" : c,
                d = bw(e, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
            return s.createElement(s.Fragment, null, s.createElement("select", xy({
              className: VC(n.root, n.select, n[l], r, i && n.disabled),
              disabled: i,
              ref: a || t
            }, d)), e.multiple ? null : s.createElement(o, {
              className: VC(n.icon, n["icon".concat(jk(l))], i && n.disabled)
            }));
          }),
              uO = Lk(s.createElement("path", {
            d: "M7 10l5 5 5-5z"
          })),
              pO = function pO(e) {
            return {
              root: {},
              select: {
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                userSelect: "none",
                borderRadius: 0,
                minWidth: 16,
                cursor: "pointer",
                "&:focus": {
                  backgroundColor: "light" === e.palette.type ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                  borderRadius: 0
                },
                "&::-ms-expand": {
                  display: "none"
                },
                "&$disabled": {
                  cursor: "default"
                },
                "&[multiple]": {
                  height: "auto"
                },
                "&:not([multiple]) option, &:not([multiple]) optgroup": {
                  backgroundColor: e.palette.background.paper
                },
                "&&": {
                  paddingRight: 24
                }
              },
              filled: {
                "&&": {
                  paddingRight: 32
                }
              },
              outlined: {
                borderRadius: e.shape.borderRadius,
                "&&": {
                  paddingRight: 32
                }
              },
              selectMenu: {
                height: "auto",
                minHeight: "1.1876em",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden"
              },
              disabled: {},
              icon: {
                position: "absolute",
                right: 0,
                top: "calc(50% - 12px)",
                pointerEvents: "none",
                color: e.palette.action.active,
                "&$disabled": {
                  color: e.palette.action.disabled
                }
              },
              iconOpen: {
                transform: "rotate(180deg)"
              },
              iconFilled: {
                right: 7
              },
              iconOutlined: {
                right: 7
              },
              nativeInput: {
                bottom: 0,
                left: 0,
                position: "absolute",
                opacity: 0,
                pointerEvents: "none",
                width: "100%"
              }
            };
          },
              hO = s.createElement(ST, null),
              _O = s.forwardRef(function (e, t) {
            var n = e.children,
                r = e.classes,
                i = e.IconComponent,
                o = void 0 === i ? uO : i,
                a = e.input,
                c = void 0 === a ? hO : a,
                l = e.inputProps;
            e.variant;
            var d = bw(e, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]),
                u = QI({
              props: e,
              muiFormControl: rI(),
              states: ["variant"]
            });
            return s.cloneElement(c, xy({
              inputComponent: dO,
              inputProps: xy({
                children: n,
                classes: r,
                IconComponent: o,
                variant: u.variant,
                type: void 0
              }, l, c ? c.props.inputProps : {}),
              ref: t
            }, d));
          });

          _O.muiName = "Select", Pk(pO, {
            name: "MuiNativeSelect"
          })(_O);
          var fO = s.forwardRef(function (e, t) {
            e.children;
            var n = e.classes,
                r = e.className,
                i = e.label,
                o = e.labelWidth,
                a = e.notched,
                c = e.style,
                l = bw(e, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]),
                d = "rtl" === Nk().direction ? "right" : "left";
            if (void 0 !== i) return s.createElement("fieldset", xy({
              "aria-hidden": !0,
              className: VC(n.root, r),
              ref: t,
              style: c
            }, l), s.createElement("legend", {
              className: VC(n.legendLabelled, a && n.legendNotched)
            }, i ? s.createElement("span", null, i) : s.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: "&#8203;"
              }
            })));
            var u = o > 0 ? .75 * o + 8 : .01;
            return s.createElement("fieldset", xy({
              "aria-hidden": !0,
              style: xy(Py({}, "padding".concat(jk(d)), 8), c),
              className: VC(n.root, r),
              ref: t
            }, l), s.createElement("legend", {
              className: n.legend,
              style: {
                width: a ? u : .01
              }
            }, s.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: "&#8203;"
              }
            })));
          }),
              mO = Pk(function (e) {
            return {
              root: {
                position: "absolute",
                bottom: 0,
                right: 0,
                top: -5,
                left: 0,
                margin: 0,
                padding: "0 8px",
                pointerEvents: "none",
                borderRadius: "inherit",
                borderStyle: "solid",
                borderWidth: 1,
                overflow: "hidden"
              },
              legend: {
                textAlign: "left",
                padding: 0,
                lineHeight: "11px",
                transition: e.transitions.create("width", {
                  duration: 150,
                  easing: e.transitions.easing.easeOut
                })
              },
              legendLabelled: {
                display: "block",
                width: "auto",
                textAlign: "left",
                padding: 0,
                height: 11,
                fontSize: "0.75em",
                visibility: "hidden",
                maxWidth: .01,
                transition: e.transitions.create("max-width", {
                  duration: 50,
                  easing: e.transitions.easing.easeOut
                }),
                "& > span": {
                  paddingLeft: 5,
                  paddingRight: 5,
                  display: "inline-block"
                }
              },
              legendNotched: {
                maxWidth: 1e3,
                transition: e.transitions.create("max-width", {
                  duration: 100,
                  easing: e.transitions.easing.easeOut,
                  delay: 50
                })
              }
            };
          }, {
            name: "PrivateNotchedOutline"
          })(fO),
              gO = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.fullWidth,
                i = void 0 !== r && r,
                o = e.inputComponent,
                a = void 0 === o ? "input" : o,
                c = e.label,
                l = e.labelWidth,
                d = void 0 === l ? 0 : l,
                u = e.multiline,
                p = void 0 !== u && u,
                h = e.notched,
                _ = e.type,
                f = void 0 === _ ? "text" : _,
                m = bw(e, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
            return s.createElement(iT, xy({
              renderSuffix: function renderSuffix(e) {
                return s.createElement(mO, {
                  className: n.notchedOutline,
                  label: c,
                  labelWidth: d,
                  notched: void 0 !== h ? h : Boolean(e.startAdornment || e.filled || e.focused)
                });
              },
              classes: xy({}, n, {
                root: VC(n.root, n.underline),
                notchedOutline: null
              }),
              fullWidth: i,
              inputComponent: a,
              multiline: p,
              ref: t,
              type: f
            }, m));
          });
          gO.muiName = "Input";

          var vO = Pk(function (e) {
            var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
            return {
              root: {
                position: "relative",
                borderRadius: e.shape.borderRadius,
                "&:hover $notchedOutline": {
                  borderColor: e.palette.text.primary
                },
                "@media (hover: none)": {
                  "&:hover $notchedOutline": {
                    borderColor: t
                  }
                },
                "&$focused $notchedOutline": {
                  borderColor: e.palette.primary.main,
                  borderWidth: 2
                },
                "&$error $notchedOutline": {
                  borderColor: e.palette.error.main
                },
                "&$disabled $notchedOutline": {
                  borderColor: e.palette.action.disabled
                }
              },
              colorSecondary: {
                "&$focused $notchedOutline": {
                  borderColor: e.palette.secondary.main
                }
              },
              focused: {},
              disabled: {},
              adornedStart: {
                paddingLeft: 14
              },
              adornedEnd: {
                paddingRight: 14
              },
              error: {},
              marginDense: {},
              multiline: {
                padding: "18.5px 14px",
                "&$marginDense": {
                  paddingTop: 10.5,
                  paddingBottom: 10.5
                }
              },
              notchedOutline: {
                borderColor: t
              },
              input: {
                padding: "18.5px 14px",
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "light" === e.palette.type ? null : "0 0 0 100px #266798 inset",
                  WebkitTextFillColor: "light" === e.palette.type ? null : "#fff",
                  caretColor: "light" === e.palette.type ? null : "#fff",
                  borderRadius: "inherit"
                }
              },
              inputMarginDense: {
                paddingTop: 10.5,
                paddingBottom: 10.5
              },
              inputMultiline: {
                padding: 0
              },
              inputAdornedStart: {
                paddingLeft: 0
              },
              inputAdornedEnd: {
                paddingRight: 0
              }
            };
          }, {
            name: "MuiOutlinedInput"
          })(gO),
              bO = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
              yO = function () {
            for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1) {
              if (bO && navigator.userAgent.indexOf(e[t]) >= 0) return 1;
            }

            return 0;
          }(),
              wO = bO && window.Promise ? function (e) {
            var t = !1;
            return function () {
              t || (t = !0, window.Promise.resolve().then(function () {
                t = !1, e();
              }));
            };
          } : function (e) {
            var t = !1;
            return function () {
              t || (t = !0, setTimeout(function () {
                t = !1, e();
              }, yO));
            };
          };

          function SO(e) {
            return e && "[object Function]" === {}.toString.call(e);
          }

          function xO(e, t) {
            if (1 !== e.nodeType) return [];
            var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
            return t ? n[t] : n;
          }

          function EO(e) {
            return "HTML" === e.nodeName ? e : e.parentNode || e.host;
          }

          function CO(e) {
            if (!e) return document.body;

            switch (e.nodeName) {
              case "HTML":
              case "BODY":
                return e.ownerDocument.body;

              case "#document":
                return e.body;
            }

            var t = xO(e),
                n = t.overflow,
                r = t.overflowX,
                i = t.overflowY;
            return /(auto|scroll|overlay)/.test(n + i + r) ? e : CO(EO(e));
          }

          function kO(e) {
            return e && e.referenceNode ? e.referenceNode : e;
          }

          var AO = bO && !(!window.MSInputMethodContext || !document.documentMode),
              IO = bO && /MSIE 10/.test(navigator.userAgent);

          function TO(e) {
            return 11 === e ? AO : 10 === e ? IO : AO || IO;
          }

          function OO(e) {
            if (!e) return document.documentElement;

            for (var t = TO(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;) {
              n = (e = e.nextElementSibling).offsetParent;
            }

            var r = n && n.nodeName;
            return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === xO(n, "position") ? OO(n) : n : e ? e.ownerDocument.documentElement : document.documentElement;
          }

          function RO(e) {
            return null !== e.parentNode ? RO(e.parentNode) : e;
          }

          function NO(e, t) {
            if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement;
            var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
                r = n ? e : t,
                i = n ? t : e,
                o = document.createRange();
            o.setStart(r, 0), o.setEnd(i, 0);
            var a,
                s,
                c = o.commonAncestorContainer;
            if (e !== c && t !== c || r.contains(i)) return "BODY" === (s = (a = c).nodeName) || "HTML" !== s && OO(a.firstElementChild) !== a ? OO(c) : c;
            var l = RO(e);
            return l.host ? NO(l.host, t) : NO(e, RO(t).host);
          }

          function PO(e) {
            var t = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft",
                n = e.nodeName;

            if ("BODY" === n || "HTML" === n) {
              var r = e.ownerDocument.documentElement;
              return (e.ownerDocument.scrollingElement || r)[t];
            }

            return e[t];
          }

          function jO(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                r = PO(t, "top"),
                i = PO(t, "left"),
                o = n ? -1 : 1;
            return e.top += r * o, e.bottom += r * o, e.left += i * o, e.right += i * o, e;
          }

          function DO(e, t) {
            var n = "x" === t ? "Left" : "Top",
                r = "Left" === n ? "Right" : "Bottom";
            return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + r + "Width"]);
          }

          function zO(e, t, n, r) {
            return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], TO(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0);
          }

          function MO(e) {
            var t = e.body,
                n = e.documentElement,
                r = TO(10) && getComputedStyle(n);
            return {
              height: zO("Height", t, n, r),
              width: zO("Width", t, n, r)
            };
          }

          var LO = function LO(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          },
              UO = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
              }
            }

            return function (t, n, r) {
              return n && e(t.prototype, n), r && e(t, r), t;
            };
          }(),
              BO = function BO(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          },
              HO = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];

              for (var r in n) {
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
            }

            return e;
          };

          function VO(e) {
            return HO({}, e, {
              right: e.left + e.width,
              bottom: e.top + e.height
            });
          }

          function qO(e) {
            var t = {};

            try {
              if (TO(10)) {
                t = e.getBoundingClientRect();
                var n = PO(e, "top"),
                    r = PO(e, "left");
                t.top += n, t.left += r, t.bottom += n, t.right += r;
              } else t = e.getBoundingClientRect();
            } catch (e) {}

            var i = {
              left: t.left,
              top: t.top,
              width: t.right - t.left,
              height: t.bottom - t.top
            },
                o = "HTML" === e.nodeName ? MO(e.ownerDocument) : {},
                a = o.width || e.clientWidth || i.width,
                s = o.height || e.clientHeight || i.height,
                c = e.offsetWidth - a,
                l = e.offsetHeight - s;

            if (c || l) {
              var d = xO(e);
              c -= DO(d, "x"), l -= DO(d, "y"), i.width -= c, i.height -= l;
            }

            return VO(i);
          }

          function FO(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                r = TO(10),
                i = "HTML" === t.nodeName,
                o = qO(e),
                a = qO(t),
                s = CO(e),
                c = xO(t),
                l = parseFloat(c.borderTopWidth),
                d = parseFloat(c.borderLeftWidth);
            n && i && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0));
            var u = VO({
              top: o.top - a.top - l,
              left: o.left - a.left - d,
              width: o.width,
              height: o.height
            });

            if (u.marginTop = 0, u.marginLeft = 0, !r && i) {
              var p = parseFloat(c.marginTop),
                  h = parseFloat(c.marginLeft);
              u.top -= l - p, u.bottom -= l - p, u.left -= d - h, u.right -= d - h, u.marginTop = p, u.marginLeft = h;
            }

            return (r && !n ? t.contains(s) : t === s && "BODY" !== s.nodeName) && (u = jO(u, t)), u;
          }

          function WO(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = e.ownerDocument.documentElement,
                r = FO(e, n),
                i = Math.max(n.clientWidth, window.innerWidth || 0),
                o = Math.max(n.clientHeight, window.innerHeight || 0),
                a = t ? 0 : PO(n),
                s = t ? 0 : PO(n, "left");
            return VO({
              top: a - r.top + r.marginTop,
              left: s - r.left + r.marginLeft,
              width: i,
              height: o
            });
          }

          function GO(e) {
            var t = e.nodeName;
            if ("BODY" === t || "HTML" === t) return !1;
            if ("fixed" === xO(e, "position")) return !0;
            var n = EO(e);
            return !!n && GO(n);
          }

          function KO(e) {
            if (!e || !e.parentElement || TO()) return document.documentElement;

            for (var t = e.parentElement; t && "none" === xO(t, "transform");) {
              t = t.parentElement;
            }

            return t || document.documentElement;
          }

          function QO(e, t, n, r) {
            var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                o = {
              top: 0,
              left: 0
            },
                a = i ? KO(e) : NO(e, kO(t));
            if ("viewport" === r) o = WO(a, i);else {
              var s = void 0;
              "scrollParent" === r ? "BODY" === (s = CO(EO(t))).nodeName && (s = e.ownerDocument.documentElement) : s = "window" === r ? e.ownerDocument.documentElement : r;
              var c = FO(s, a, i);
              if ("HTML" !== s.nodeName || GO(a)) o = c;else {
                var l = MO(e.ownerDocument),
                    d = l.height,
                    u = l.width;
                o.top += c.top - c.marginTop, o.bottom = d + c.top, o.left += c.left - c.marginLeft, o.right = u + c.left;
              }
            }
            var p = "number" == typeof (n = n || 0);
            return o.left += p ? n : n.left || 0, o.top += p ? n : n.top || 0, o.right -= p ? n : n.right || 0, o.bottom -= p ? n : n.bottom || 0, o;
          }

          function ZO(e) {
            return e.width * e.height;
          }

          function YO(e, t, n, r, i) {
            var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
            if (-1 === e.indexOf("auto")) return e;
            var a = QO(n, r, o, i),
                s = {
              top: {
                width: a.width,
                height: t.top - a.top
              },
              right: {
                width: a.right - t.right,
                height: a.height
              },
              bottom: {
                width: a.width,
                height: a.bottom - t.bottom
              },
              left: {
                width: t.left - a.left,
                height: a.height
              }
            },
                c = Object.keys(s).map(function (e) {
              return HO({
                key: e
              }, s[e], {
                area: ZO(s[e])
              });
            }).sort(function (e, t) {
              return t.area - e.area;
            }),
                l = c.filter(function (e) {
              var t = e.width,
                  r = e.height;
              return t >= n.clientWidth && r >= n.clientHeight;
            }),
                d = l.length > 0 ? l[0].key : c[0].key,
                u = e.split("-")[1];
            return d + (u ? "-" + u : "");
          }

          function JO(e, t, n) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
            return FO(n, r ? KO(t) : NO(t, kO(n)), r);
          }

          function $O(e) {
            var t = e.ownerDocument.defaultView.getComputedStyle(e),
                n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
                r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
            return {
              width: e.offsetWidth + r,
              height: e.offsetHeight + n
            };
          }

          function XO(e) {
            var t = {
              left: "right",
              right: "left",
              bottom: "top",
              top: "bottom"
            };
            return e.replace(/left|right|bottom|top/g, function (e) {
              return t[e];
            });
          }

          function eR(e, t, n) {
            n = n.split("-")[0];
            var r = $O(e),
                i = {
              width: r.width,
              height: r.height
            },
                o = -1 !== ["right", "left"].indexOf(n),
                a = o ? "top" : "left",
                s = o ? "left" : "top",
                c = o ? "height" : "width",
                l = o ? "width" : "height";
            return i[a] = t[a] + t[c] / 2 - r[c] / 2, i[s] = n === s ? t[s] - r[l] : t[XO(s)], i;
          }

          function tR(e, t) {
            return Array.prototype.find ? e.find(t) : e.filter(t)[0];
          }

          function nR(e, t, n) {
            return (void 0 === n ? e : e.slice(0, function (e, t, n) {
              if (Array.prototype.findIndex) return e.findIndex(function (e) {
                return e[t] === n;
              });
              var r = tR(e, function (e) {
                return e[t] === n;
              });
              return e.indexOf(r);
            }(e, "name", n))).forEach(function (e) {
              e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
              var n = e.function || e.fn;
              e.enabled && SO(n) && (t.offsets.popper = VO(t.offsets.popper), t.offsets.reference = VO(t.offsets.reference), t = n(t, e));
            }), t;
          }

          function rR() {
            if (!this.state.isDestroyed) {
              var e = {
                instance: this,
                styles: {},
                arrowStyles: {},
                attributes: {},
                flipped: !1,
                offsets: {}
              };
              e.offsets.reference = JO(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = YO(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = eR(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = nR(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
            }
          }

          function iR(e, t) {
            return e.some(function (e) {
              var n = e.name;
              return e.enabled && n === t;
            });
          }

          function oR(e) {
            for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++) {
              var i = t[r],
                  o = i ? "" + i + n : e;
              if (void 0 !== document.body.style[o]) return o;
            }

            return null;
          }

          function aR() {
            return this.state.isDestroyed = !0, iR(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[oR("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
          }

          function sR(e) {
            var t = e.ownerDocument;
            return t ? t.defaultView : window;
          }

          function cR(e, t, n, r) {
            var i = "BODY" === e.nodeName,
                o = i ? e.ownerDocument.defaultView : e;
            o.addEventListener(t, n, {
              passive: !0
            }), i || cR(CO(o.parentNode), t, n, r), r.push(o);
          }

          function lR(e, t, n, r) {
            n.updateBound = r, sR(e).addEventListener("resize", n.updateBound, {
              passive: !0
            });
            var i = CO(e);
            return cR(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
          }

          function dR() {
            this.state.eventsEnabled || (this.state = lR(this.reference, this.options, this.state, this.scheduleUpdate));
          }

          function uR() {
            var e, t;
            this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, sR(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function (e) {
              e.removeEventListener("scroll", t.updateBound);
            }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t));
          }

          function pR(e) {
            return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
          }

          function hR(e, t) {
            Object.keys(t).forEach(function (n) {
              var r = "";
              -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && pR(t[n]) && (r = "px"), e.style[n] = t[n] + r;
            });
          }

          var _R = bO && /Firefox/i.test(navigator.userAgent);

          function fR(e, t, n) {
            var r = tR(e, function (e) {
              return e.name === t;
            }),
                i = !!r && e.some(function (e) {
              return e.name === n && e.enabled && e.order < r.order;
            });

            if (!i) {
              var o = "`" + t + "`",
                  a = "`" + n + "`";
              console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!");
            }

            return i;
          }

          var mR = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
              gR = mR.slice(3);

          function vR(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = gR.indexOf(e),
                r = gR.slice(n + 1).concat(gR.slice(0, n));
            return t ? r.reverse() : r;
          }

          var bR = "flip",
              yR = "clockwise",
              wR = "counterclockwise";

          function SR(e, t, n, r) {
            var i = [0, 0],
                o = -1 !== ["right", "left"].indexOf(r),
                a = e.split(/(\+|\-)/).map(function (e) {
              return e.trim();
            }),
                s = a.indexOf(tR(a, function (e) {
              return -1 !== e.search(/,|\s/);
            }));
            a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
            var c = /\s*,\s*|\s+/,
                l = -1 !== s ? [a.slice(0, s).concat([a[s].split(c)[0]]), [a[s].split(c)[1]].concat(a.slice(s + 1))] : [a];
            return l = l.map(function (e, r) {
              var i = (1 === r ? !o : o) ? "height" : "width",
                  a = !1;
              return e.reduce(function (e, t) {
                return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, a = !0, e) : a ? (e[e.length - 1] += t, a = !1, e) : e.concat(t);
              }, []).map(function (e) {
                return function (e, t, n, r) {
                  var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                      o = +i[1],
                      a = i[2];
                  return o ? 0 === a.indexOf("%") ? VO("%p" === a ? n : r)[t] / 100 * o : "vh" === a || "vw" === a ? ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o : o : e;
                }(e, i, t, n);
              });
            }), l.forEach(function (e, t) {
              e.forEach(function (n, r) {
                pR(n) && (i[t] += n * ("-" === e[r - 1] ? -1 : 1));
              });
            }), i;
          }

          var xR = {
            shift: {
              order: 100,
              enabled: !0,
              fn: function fn(e) {
                var t = e.placement,
                    n = t.split("-")[0],
                    r = t.split("-")[1];

                if (r) {
                  var i = e.offsets,
                      o = i.reference,
                      a = i.popper,
                      s = -1 !== ["bottom", "top"].indexOf(n),
                      c = s ? "left" : "top",
                      l = s ? "width" : "height",
                      d = {
                    start: BO({}, c, o[c]),
                    end: BO({}, c, o[c] + o[l] - a[l])
                  };
                  e.offsets.popper = HO({}, a, d[r]);
                }

                return e;
              }
            },
            offset: {
              order: 200,
              enabled: !0,
              fn: function fn(e, t) {
                var n = t.offset,
                    r = e.placement,
                    i = e.offsets,
                    o = i.popper,
                    a = i.reference,
                    s = r.split("-")[0],
                    c = void 0;
                return c = pR(+n) ? [+n, 0] : SR(n, o, a, s), "left" === s ? (o.top += c[0], o.left -= c[1]) : "right" === s ? (o.top += c[0], o.left += c[1]) : "top" === s ? (o.left += c[0], o.top -= c[1]) : "bottom" === s && (o.left += c[0], o.top += c[1]), e.popper = o, e;
              },
              offset: 0
            },
            preventOverflow: {
              order: 300,
              enabled: !0,
              fn: function fn(e, t) {
                var n = t.boundariesElement || OO(e.instance.popper);
                e.instance.reference === n && (n = OO(n));
                var r = oR("transform"),
                    i = e.instance.popper.style,
                    o = i.top,
                    a = i.left,
                    s = i[r];
                i.top = "", i.left = "", i[r] = "";
                var c = QO(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
                i.top = o, i.left = a, i[r] = s, t.boundaries = c;
                var l = t.priority,
                    d = e.offsets.popper,
                    u = {
                  primary: function primary(e) {
                    var n = d[e];
                    return d[e] < c[e] && !t.escapeWithReference && (n = Math.max(d[e], c[e])), BO({}, e, n);
                  },
                  secondary: function secondary(e) {
                    var n = "right" === e ? "left" : "top",
                        r = d[n];
                    return d[e] > c[e] && !t.escapeWithReference && (r = Math.min(d[n], c[e] - ("right" === e ? d.width : d.height))), BO({}, n, r);
                  }
                };
                return l.forEach(function (e) {
                  var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                  d = HO({}, d, u[t](e));
                }), e.offsets.popper = d, e;
              },
              priority: ["left", "right", "top", "bottom"],
              padding: 5,
              boundariesElement: "scrollParent"
            },
            keepTogether: {
              order: 400,
              enabled: !0,
              fn: function fn(e) {
                var t = e.offsets,
                    n = t.popper,
                    r = t.reference,
                    i = e.placement.split("-")[0],
                    o = Math.floor,
                    a = -1 !== ["top", "bottom"].indexOf(i),
                    s = a ? "right" : "bottom",
                    c = a ? "left" : "top",
                    l = a ? "width" : "height";
                return n[s] < o(r[c]) && (e.offsets.popper[c] = o(r[c]) - n[l]), n[c] > o(r[s]) && (e.offsets.popper[c] = o(r[s])), e;
              }
            },
            arrow: {
              order: 500,
              enabled: !0,
              fn: function fn(e, t) {
                var n;
                if (!fR(e.instance.modifiers, "arrow", "keepTogether")) return e;
                var r = t.element;

                if ("string" == typeof r) {
                  if (!(r = e.instance.popper.querySelector(r))) return e;
                } else if (!e.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;

                var i = e.placement.split("-")[0],
                    o = e.offsets,
                    a = o.popper,
                    s = o.reference,
                    c = -1 !== ["left", "right"].indexOf(i),
                    l = c ? "height" : "width",
                    d = c ? "Top" : "Left",
                    u = d.toLowerCase(),
                    p = c ? "left" : "top",
                    h = c ? "bottom" : "right",
                    _ = $O(r)[l];
                s[h] - _ < a[u] && (e.offsets.popper[u] -= a[u] - (s[h] - _)), s[u] + _ > a[h] && (e.offsets.popper[u] += s[u] + _ - a[h]), e.offsets.popper = VO(e.offsets.popper);
                var f = s[u] + s[l] / 2 - _ / 2,
                    m = xO(e.instance.popper),
                    g = parseFloat(m["margin" + d]),
                    v = parseFloat(m["border" + d + "Width"]),
                    b = f - e.offsets.popper[u] - g - v;
                return b = Math.max(Math.min(a[l] - _, b), 0), e.arrowElement = r, e.offsets.arrow = (BO(n = {}, u, Math.round(b)), BO(n, p, ""), n), e;
              },
              element: "[x-arrow]"
            },
            flip: {
              order: 600,
              enabled: !0,
              fn: function fn(e, t) {
                if (iR(e.instance.modifiers, "inner")) return e;
                if (e.flipped && e.placement === e.originalPlacement) return e;
                var n = QO(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed),
                    r = e.placement.split("-")[0],
                    i = XO(r),
                    o = e.placement.split("-")[1] || "",
                    a = [];

                switch (t.behavior) {
                  case bR:
                    a = [r, i];
                    break;

                  case yR:
                    a = vR(r);
                    break;

                  case wR:
                    a = vR(r, !0);
                    break;

                  default:
                    a = t.behavior;
                }

                return a.forEach(function (s, c) {
                  if (r !== s || a.length === c + 1) return e;
                  r = e.placement.split("-")[0], i = XO(r);

                  var l = e.offsets.popper,
                      d = e.offsets.reference,
                      u = Math.floor,
                      p = "left" === r && u(l.right) > u(d.left) || "right" === r && u(l.left) < u(d.right) || "top" === r && u(l.bottom) > u(d.top) || "bottom" === r && u(l.top) < u(d.bottom),
                      h = u(l.left) < u(n.left),
                      _ = u(l.right) > u(n.right),
                      f = u(l.top) < u(n.top),
                      m = u(l.bottom) > u(n.bottom),
                      g = "left" === r && h || "right" === r && _ || "top" === r && f || "bottom" === r && m,
                      v = -1 !== ["top", "bottom"].indexOf(r),
                      b = !!t.flipVariations && (v && "start" === o && h || v && "end" === o && _ || !v && "start" === o && f || !v && "end" === o && m),
                      y = !!t.flipVariationsByContent && (v && "start" === o && _ || v && "end" === o && h || !v && "start" === o && m || !v && "end" === o && f),
                      w = b || y;

                  (p || g || w) && (e.flipped = !0, (p || g) && (r = a[c + 1]), w && (o = function (e) {
                    return "end" === e ? "start" : "start" === e ? "end" : e;
                  }(o)), e.placement = r + (o ? "-" + o : ""), e.offsets.popper = HO({}, e.offsets.popper, eR(e.instance.popper, e.offsets.reference, e.placement)), e = nR(e.instance.modifiers, e, "flip"));
                }), e;
              },
              behavior: "flip",
              padding: 5,
              boundariesElement: "viewport",
              flipVariations: !1,
              flipVariationsByContent: !1
            },
            inner: {
              order: 700,
              enabled: !1,
              fn: function fn(e) {
                var t = e.placement,
                    n = t.split("-")[0],
                    r = e.offsets,
                    i = r.popper,
                    o = r.reference,
                    a = -1 !== ["left", "right"].indexOf(n),
                    s = -1 === ["top", "left"].indexOf(n);
                return i[a ? "left" : "top"] = o[n] - (s ? i[a ? "width" : "height"] : 0), e.placement = XO(t), e.offsets.popper = VO(i), e;
              }
            },
            hide: {
              order: 800,
              enabled: !0,
              fn: function fn(e) {
                if (!fR(e.instance.modifiers, "hide", "preventOverflow")) return e;
                var t = e.offsets.reference,
                    n = tR(e.instance.modifiers, function (e) {
                  return "preventOverflow" === e.name;
                }).boundaries;

                if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                  if (!0 === e.hide) return e;
                  e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
                } else {
                  if (!1 === e.hide) return e;
                  e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
                }

                return e;
              }
            },
            computeStyle: {
              order: 850,
              enabled: !0,
              fn: function fn(e, t) {
                var n = t.x,
                    r = t.y,
                    i = e.offsets.popper,
                    o = tR(e.instance.modifiers, function (e) {
                  return "applyStyle" === e.name;
                }).gpuAcceleration;
                void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");

                var a = void 0 !== o ? o : t.gpuAcceleration,
                    s = OO(e.instance.popper),
                    c = qO(s),
                    l = {
                  position: i.position
                },
                    d = function (e, t) {
                  var n = e.offsets,
                      r = n.popper,
                      i = n.reference,
                      o = Math.round,
                      a = Math.floor,
                      s = function s(e) {
                    return e;
                  },
                      c = o(i.width),
                      l = o(r.width),
                      d = -1 !== ["left", "right"].indexOf(e.placement),
                      u = -1 !== e.placement.indexOf("-"),
                      p = t ? d || u || c % 2 == l % 2 ? o : a : s,
                      h = t ? o : s;

                  return {
                    left: p(c % 2 == 1 && l % 2 == 1 && !u && t ? r.left - 1 : r.left),
                    top: h(r.top),
                    bottom: h(r.bottom),
                    right: p(r.right)
                  };
                }(e, window.devicePixelRatio < 2 || !_R),
                    u = "bottom" === n ? "top" : "bottom",
                    p = "right" === r ? "left" : "right",
                    h = oR("transform"),
                    _ = void 0,
                    f = void 0;

                if (f = "bottom" === u ? "HTML" === s.nodeName ? -s.clientHeight + d.bottom : -c.height + d.bottom : d.top, _ = "right" === p ? "HTML" === s.nodeName ? -s.clientWidth + d.right : -c.width + d.right : d.left, a && h) l[h] = "translate3d(" + _ + "px, " + f + "px, 0)", l[u] = 0, l[p] = 0, l.willChange = "transform";else {
                  var m = "bottom" === u ? -1 : 1,
                      g = "right" === p ? -1 : 1;
                  l[u] = f * m, l[p] = _ * g, l.willChange = u + ", " + p;
                }
                var v = {
                  "x-placement": e.placement
                };
                return e.attributes = HO({}, v, e.attributes), e.styles = HO({}, l, e.styles), e.arrowStyles = HO({}, e.offsets.arrow, e.arrowStyles), e;
              },
              gpuAcceleration: !0,
              x: "bottom",
              y: "right"
            },
            applyStyle: {
              order: 900,
              enabled: !0,
              fn: function fn(e) {
                var t, n;
                return hR(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach(function (e) {
                  !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e);
                }), e.arrowElement && Object.keys(e.arrowStyles).length && hR(e.arrowElement, e.arrowStyles), e;
              },
              onLoad: function onLoad(e, t, n, r, i) {
                var o = JO(i, t, e, n.positionFixed),
                    a = YO(n.placement, o, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                return t.setAttribute("x-placement", a), hR(t, {
                  position: n.positionFixed ? "fixed" : "absolute"
                }), n;
              },
              gpuAcceleration: void 0
            }
          },
              ER = {
            placement: "bottom",
            positionFixed: !1,
            eventsEnabled: !0,
            removeOnDestroy: !1,
            onCreate: function onCreate() {},
            onUpdate: function onUpdate() {},
            modifiers: xR
          },
              CR = function () {
            function e(t, n) {
              var r = this,
                  i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              LO(this, e), this.scheduleUpdate = function () {
                return requestAnimationFrame(r.update);
              }, this.update = wO(this.update.bind(this)), this.options = HO({}, e.Defaults, i), this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
              }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(HO({}, e.Defaults.modifiers, i.modifiers)).forEach(function (t) {
                r.options.modifiers[t] = HO({}, e.Defaults.modifiers[t] || {}, i.modifiers ? i.modifiers[t] : {});
              }), this.modifiers = Object.keys(this.options.modifiers).map(function (e) {
                return HO({
                  name: e
                }, r.options.modifiers[e]);
              }).sort(function (e, t) {
                return e.order - t.order;
              }), this.modifiers.forEach(function (e) {
                e.enabled && SO(e.onLoad) && e.onLoad(r.reference, r.popper, r.options, e, r.state);
              }), this.update();
              var o = this.options.eventsEnabled;
              o && this.enableEventListeners(), this.state.eventsEnabled = o;
            }

            return UO(e, [{
              key: "update",
              value: function value() {
                return rR.call(this);
              }
            }, {
              key: "destroy",
              value: function value() {
                return aR.call(this);
              }
            }, {
              key: "enableEventListeners",
              value: function value() {
                return dR.call(this);
              }
            }, {
              key: "disableEventListeners",
              value: function value() {
                return uR.call(this);
              }
            }]), e;
          }();

          CR.Utils = ("undefined" != typeof window ? window : n.g).PopperUtils, CR.placements = mR, CR.Defaults = ER;
          var kR = CR;

          function AR(e) {
            return "function" == typeof e ? e() : e;
          }

          var IR = "undefined" != typeof window ? s.useLayoutEffect : s.useEffect,
              TR = {},
              OR = s.forwardRef(function (e, t) {
            var n = e.anchorEl,
                r = e.children,
                i = e.container,
                o = e.disablePortal,
                a = void 0 !== o && o,
                c = e.keepMounted,
                l = void 0 !== c && c,
                d = e.modifiers,
                u = e.open,
                p = e.placement,
                h = void 0 === p ? "bottom" : p,
                _ = e.popperOptions,
                f = void 0 === _ ? TR : _,
                m = e.popperRef,
                g = e.style,
                v = e.transition,
                b = void 0 !== v && v,
                y = bw(e, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]),
                w = s.useRef(null),
                S = Kk(w, t),
                x = s.useRef(null),
                E = Kk(x, m),
                C = s.useRef(E);
            IR(function () {
              C.current = E;
            }, [E]), s.useImperativeHandle(m, function () {
              return x.current;
            }, []);

            var k = s.useState(!0),
                A = k[0],
                I = k[1],
                T = function (e, t) {
              if ("ltr" === (t && t.direction || "ltr")) return e;

              switch (e) {
                case "bottom-end":
                  return "bottom-start";

                case "bottom-start":
                  return "bottom-end";

                case "top-end":
                  return "top-start";

                case "top-start":
                  return "top-end";

                default:
                  return e;
              }
            }(h, xC()),
                O = s.useState(T),
                R = O[0],
                N = O[1];

            s.useEffect(function () {
              x.current && x.current.update();
            });

            var P = s.useCallback(function () {
              if (w.current && n && u) {
                x.current && (x.current.destroy(), C.current(null));

                var e = function e(_e283) {
                  N(_e283.placement);
                };

                AR(n);
                var t = new kR(AR(n), w.current, xy({
                  placement: T
                }, f, {
                  modifiers: xy({}, a ? {} : {
                    preventOverflow: {
                      boundariesElement: "window"
                    }
                  }, d, f.modifiers),
                  onCreate: Dk(e, f.onCreate),
                  onUpdate: Dk(e, f.onUpdate)
                }));
                C.current(t);
              }
            }, [n, a, d, u, T, f]),
                j = s.useCallback(function (e) {
              qk(S, e), P();
            }, [S, P]),
                D = function D() {
              x.current && (x.current.destroy(), C.current(null));
            };

            if (s.useEffect(function () {
              return function () {
                D();
              };
            }, []), s.useEffect(function () {
              u || b || D();
            }, [u, b]), !l && !u && (!b || A)) return null;
            var z = {
              placement: R
            };
            return b && (z.TransitionProps = {
              in: u,
              onEnter: function onEnter() {
                I(!1);
              },
              onExited: function onExited() {
                I(!0), D();
              }
            }), s.createElement(gI, {
              disablePortal: a,
              container: i
            }, s.createElement("div", xy({
              ref: j,
              role: "tooltip"
            }, y, {
              style: xy({
                position: "fixed",
                top: 0,
                left: 0,
                display: u || !l || b ? null : "none"
              }, g)
            }), "function" == typeof r ? r(z) : r));
          }),
              RR = OR,
              NR = Lk(s.createElement("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
          })),
              PR = Lk(s.createElement("path", {
            d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
          })),
              jR = Pk(function (e) {
            return {
              root: {
                position: "relative",
                display: "flex",
                "&$checked $layer": {
                  transform: "scale(1)",
                  transition: e.transitions.create("transform", {
                    easing: e.transitions.easing.easeOut,
                    duration: e.transitions.duration.shortest
                  })
                }
              },
              layer: {
                left: 0,
                position: "absolute",
                transform: "scale(0)",
                transition: e.transitions.create("transform", {
                  easing: e.transitions.easing.easeIn,
                  duration: e.transitions.duration.shortest
                })
              },
              checked: {}
            };
          }, {
            name: "PrivateRadioButtonIcon"
          })(function (e) {
            var t = e.checked,
                n = e.classes,
                r = e.fontSize;
            return s.createElement("div", {
              className: VC(n.root, t && n.checked)
            }, s.createElement(NR, {
              fontSize: r
            }), s.createElement(PR, {
              fontSize: r,
              className: n.layer
            }));
          }),
              DR = s.createContext(),
              zR = s.createElement(jR, {
            checked: !0
          }),
              MR = s.createElement(jR, null),
              LR = s.forwardRef(function (e, t) {
            var n = e.checked,
                r = e.classes,
                i = e.color,
                o = void 0 === i ? "secondary" : i,
                a = e.name,
                c = e.onChange,
                l = e.size,
                d = void 0 === l ? "medium" : l,
                u = bw(e, ["checked", "classes", "color", "name", "onChange", "size"]),
                p = s.useContext(DR),
                h = n,
                _ = Dk(c, p && p.onChange),
                f = a;

            return p && (void 0 === h && (h = p.value === e.value), void 0 === f && (f = p.name)), s.createElement(oI, xy({
              color: o,
              type: "radio",
              icon: s.cloneElement(MR, {
                fontSize: "small" === d ? "small" : "medium"
              }),
              checkedIcon: s.cloneElement(zR, {
                fontSize: "small" === d ? "small" : "medium"
              }),
              classes: {
                root: VC(r.root, r["color".concat(jk(o))]),
                checked: r.checked,
                disabled: r.disabled
              },
              name: f,
              checked: h,
              onChange: _,
              ref: t
            }, u));
          }),
              UR = Pk(function (e) {
            return {
              root: {
                color: e.palette.text.secondary
              },
              checked: {},
              disabled: {},
              colorPrimary: {
                "&$checked": {
                  color: e.palette.primary.main,
                  "&:hover": {
                    backgroundColor: fw(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                      backgroundColor: "transparent"
                    }
                  }
                },
                "&$disabled": {
                  color: e.palette.action.disabled
                }
              },
              colorSecondary: {
                "&$checked": {
                  color: e.palette.secondary.main,
                  "&:hover": {
                    backgroundColor: fw(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                      backgroundColor: "transparent"
                    }
                  }
                },
                "&$disabled": {
                  color: e.palette.action.disabled
                }
              }
            };
          }, {
            name: "MuiRadio"
          })(LR),
              BR = s.forwardRef(function (e, t) {
            var n = e.actions,
                r = e.children,
                i = e.name,
                o = e.value,
                a = e.onChange,
                c = bw(e, ["actions", "children", "name", "value", "onChange"]),
                l = s.useRef(null),
                d = cS(Fk({
              controlled: o,
              default: e.defaultValue,
              name: "RadioGroup"
            }), 2),
                u = d[0],
                p = d[1];
            s.useImperativeHandle(n, function () {
              return {
                focus: function focus() {
                  var e = l.current.querySelector("input:not(:disabled):checked");
                  e || (e = l.current.querySelector("input:not(:disabled)")), e && e.focus();
                }
              };
            }, []);

            var h = Kk(t, l),
                _ = Qk(i);

            return s.createElement(DR.Provider, {
              value: {
                name: _,
                onChange: function onChange(e) {
                  p(e.target.value), a && a(e, e.target.value);
                },
                value: u
              }
            }, s.createElement(pT, xy({
              role: "radiogroup",
              ref: h
            }, c), r));
          });

          function HR(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && NS(e, t);
          }

          function VR(e, t) {
            if (t && ("object" === Ey(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return jS(e);
          }

          function qR(e) {
            return qR = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, qR(e);
          }

          function FR(e, t) {
            return "object" === Ey(t) && null !== t ? e === t : String(e) === String(t);
          }

          var WR = s.forwardRef(function (e, t) {
            var n = e["aria-label"],
                r = e.autoFocus,
                i = e.autoWidth,
                o = e.children,
                a = e.classes,
                c = e.className,
                l = e.defaultValue,
                d = e.disabled,
                u = e.displayEmpty,
                p = e.IconComponent,
                h = e.inputRef,
                _ = e.labelId,
                f = e.MenuProps,
                m = void 0 === f ? {} : f,
                g = e.multiple,
                v = e.name,
                b = e.onBlur,
                y = e.onChange,
                w = e.onClose,
                S = e.onFocus,
                x = e.onOpen,
                E = e.open,
                C = e.readOnly,
                k = e.renderValue,
                A = e.SelectDisplayProps,
                I = void 0 === A ? {} : A,
                T = e.tabIndex;
            e.type;
            var O = e.value,
                R = e.variant,
                N = void 0 === R ? "standard" : R,
                P = bw(e, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]),
                j = cS(Fk({
              controlled: O,
              default: l,
              name: "Select"
            }), 2),
                D = j[0],
                z = j[1],
                M = s.useRef(null),
                L = s.useState(null),
                U = L[0],
                B = L[1],
                H = s.useRef(null != E).current,
                V = s.useState(),
                q = V[0],
                F = V[1],
                W = s.useState(!1),
                G = W[0],
                K = W[1],
                Q = Kk(t, h);
            s.useImperativeHandle(Q, function () {
              return {
                focus: function focus() {
                  U.focus();
                },
                node: M.current,
                value: D
              };
            }, [U, D]), s.useEffect(function () {
              r && U && U.focus();
            }, [r, U]), s.useEffect(function () {
              if (U) {
                var e = Hk(U).getElementById(_);

                if (e) {
                  var t = function t() {
                    getSelection().isCollapsed && U.focus();
                  };

                  return e.addEventListener("click", t), function () {
                    e.removeEventListener("click", t);
                  };
                }
              }
            }, [_, U]);

            var Z,
                Y,
                J = function J(e, t) {
              e ? x && x(t) : w && w(t), H || (F(i ? null : U.clientWidth), K(e));
            },
                $ = s.Children.toArray(o),
                X = function X(e) {
              return function (t) {
                var n;

                if (g || J(!1, t), g) {
                  n = Array.isArray(D) ? D.slice() : [];
                  var r = D.indexOf(e.props.value);
                  -1 === r ? n.push(e.props.value) : n.splice(r, 1);
                } else n = e.props.value;

                e.props.onClick && e.props.onClick(t), D !== n && (z(n), y && (t.persist(), Object.defineProperty(t, "target", {
                  writable: !0,
                  value: {
                    value: n,
                    name: v
                  }
                }), y(t, e)));
              };
            },
                ee = null !== U && (H ? E : G);

            delete P["aria-invalid"];
            var te = [],
                ne = !1;
            (tT({
              value: D
            }) || u) && (k ? Z = k(D) : ne = !0);
            var re = $.map(function (e) {
              if (!s.isValidElement(e)) return null;
              var t;

              if (g) {
                if (!Array.isArray(D)) throw new Error(jy(2));
                (t = D.some(function (t) {
                  return FR(t, e.props.value);
                })) && ne && te.push(e.props.children);
              } else (t = FR(D, e.props.value)) && ne && (Y = e.props.children);

              return s.cloneElement(e, {
                "aria-selected": t ? "true" : void 0,
                onClick: X(e),
                onKeyUp: function onKeyUp(t) {
                  " " === t.key && t.preventDefault(), e.props.onKeyUp && e.props.onKeyUp(t);
                },
                role: "option",
                selected: t,
                value: void 0,
                "data-value": e.props.value
              });
            });
            ne && (Z = g ? te.join(", ") : Y);
            var ie,
                oe = q;
            !i && H && U && (oe = U.clientWidth), ie = void 0 !== T ? T : d ? null : 0;
            var ae = I.id || (v ? "mui-component-select-".concat(v) : void 0);
            return s.createElement(s.Fragment, null, s.createElement("div", xy({
              className: VC(a.root, a.select, a.selectMenu, a[N], c, d && a.disabled),
              ref: B,
              tabIndex: ie,
              role: "button",
              "aria-disabled": d ? "true" : void 0,
              "aria-expanded": ee ? "true" : void 0,
              "aria-haspopup": "listbox",
              "aria-label": n,
              "aria-labelledby": [_, ae].filter(Boolean).join(" ") || void 0,
              onKeyDown: function onKeyDown(e) {
                C || -1 !== [" ", "ArrowUp", "ArrowDown", "Enter"].indexOf(e.key) && (e.preventDefault(), J(!0, e));
              },
              onMouseDown: d || C ? null : function (e) {
                0 === e.button && (e.preventDefault(), U.focus(), J(!0, e));
              },
              onBlur: function onBlur(e) {
                !ee && b && (e.persist(), Object.defineProperty(e, "target", {
                  writable: !0,
                  value: {
                    value: D,
                    name: v
                  }
                }), b(e));
              },
              onFocus: S
            }, I, {
              id: ae
            }), function (e) {
              return null == e || "string" == typeof e && !e.trim();
            }(Z) ? s.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: "&#8203;"
              }
            }) : Z), s.createElement("input", xy({
              value: Array.isArray(D) ? D.join(",") : D,
              name: v,
              ref: M,
              "aria-hidden": !0,
              onChange: function onChange(e) {
                var t = $.map(function (e) {
                  return e.props.value;
                }).indexOf(e.target.value);

                if (-1 !== t) {
                  var n = $[t];
                  z(n.props.value), y && y(e, n);
                }
              },
              tabIndex: -1,
              className: a.nativeInput,
              autoFocus: r
            }, P)), s.createElement(p, {
              className: VC(a.icon, a["icon".concat(jk(N))], ee && a.iconOpen, d && a.disabled)
            }), s.createElement(sO, xy({
              id: "menu-".concat(v || ""),
              anchorEl: U,
              open: ee,
              onClose: function onClose(e) {
                J(!1, e);
              }
            }, m, {
              MenuListProps: xy({
                "aria-labelledby": _,
                role: "listbox",
                disableListWrap: !0
              }, m.MenuListProps),
              PaperProps: xy({}, m.PaperProps, {
                style: xy({
                  minWidth: oe
                }, null != m.PaperProps ? m.PaperProps.style : null)
              })
            }), re));
          }),
              GR = WR,
              KR = pO,
              QR = s.createElement(ST, null),
              ZR = s.createElement(aT, null),
              YR = s.forwardRef(function e(t, n) {
            var r = t.autoWidth,
                i = void 0 !== r && r,
                o = t.children,
                a = t.classes,
                c = t.displayEmpty,
                l = void 0 !== c && c,
                d = t.IconComponent,
                u = void 0 === d ? uO : d,
                p = t.id,
                h = t.input,
                _ = t.inputProps,
                f = t.label,
                m = t.labelId,
                g = t.labelWidth,
                v = void 0 === g ? 0 : g,
                b = t.MenuProps,
                y = t.multiple,
                w = void 0 !== y && y,
                S = t.native,
                x = void 0 !== S && S,
                E = t.onClose,
                C = t.onOpen,
                k = t.open,
                A = t.renderValue,
                I = t.SelectDisplayProps,
                T = t.variant,
                O = void 0 === T ? "standard" : T,
                R = bw(t, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]),
                N = x ? dO : GR,
                P = QI({
              props: t,
              muiFormControl: rI(),
              states: ["variant"]
            }).variant || O,
                j = h || {
              standard: QR,
              outlined: s.createElement(vO, {
                label: f,
                labelWidth: v
              }),
              filled: ZR
            }[P];
            return s.cloneElement(j, xy({
              inputComponent: N,
              inputProps: xy({
                children: o,
                IconComponent: u,
                variant: P,
                type: void 0,
                multiple: w
              }, x ? {
                id: p
              } : {
                autoWidth: i,
                displayEmpty: l,
                labelId: m,
                MenuProps: b,
                onClose: E,
                onOpen: C,
                open: k,
                renderValue: A,
                SelectDisplayProps: xy({
                  id: p
                }, I)
              }, _, {
                classes: _ ? bC({
                  baseClasses: a,
                  newClasses: _.classes,
                  Component: e
                }) : a
              }, h ? h.props.inputProps : {}),
              ref: n
            }, R));
          });
          YR.muiName = "Select";

          var JR,
              $R = Pk(KR, {
            name: "MuiSelect"
          })(YR),
              XR = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.disabled,
                o = void 0 !== i && i,
                a = e.disableFocusRipple,
                c = void 0 !== a && a,
                l = e.fullWidth,
                d = e.icon,
                u = e.indicator,
                p = e.label,
                h = e.onChange,
                _ = e.onClick,
                f = e.onFocus,
                m = e.selected,
                g = e.selectionFollowsFocus,
                v = e.textColor,
                b = void 0 === v ? "inherit" : v,
                y = e.value,
                w = e.wrapped,
                S = void 0 !== w && w,
                x = bw(e, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]);
            return s.createElement(NA, xy({
              focusRipple: !c,
              className: VC(n.root, n["textColor".concat(jk(b))], r, o && n.disabled, m && n.selected, p && d && n.labelIcon, l && n.fullWidth, S && n.wrapped),
              ref: t,
              role: "tab",
              "aria-selected": m,
              disabled: o,
              onClick: function onClick(e) {
                h && h(e, y), _ && _(e);
              },
              onFocus: function onFocus(e) {
                g && !m && h && h(e, y), f && f(e);
              },
              tabIndex: m ? 0 : -1
            }, x), s.createElement("span", {
              className: n.wrapper
            }, d, p), u);
          }),
              eN = Pk(function (e) {
            var t;
            return {
              root: xy({}, e.typography.button, (t = {
                maxWidth: 264,
                minWidth: 72,
                position: "relative",
                boxSizing: "border-box",
                minHeight: 48,
                flexShrink: 0,
                padding: "6px 12px"
              }, Py(t, e.breakpoints.up("sm"), {
                padding: "6px 24px"
              }), Py(t, "overflow", "hidden"), Py(t, "whiteSpace", "normal"), Py(t, "textAlign", "center"), Py(t, e.breakpoints.up("sm"), {
                minWidth: 160
              }), t)),
              labelIcon: {
                minHeight: 72,
                paddingTop: 9,
                "& $wrapper > *:first-child": {
                  marginBottom: 6
                }
              },
              textColorInherit: {
                color: "inherit",
                opacity: .7,
                "&$selected": {
                  opacity: 1
                },
                "&$disabled": {
                  opacity: .5
                }
              },
              textColorPrimary: {
                color: e.palette.text.secondary,
                "&$selected": {
                  color: e.palette.primary.main
                },
                "&$disabled": {
                  color: e.palette.text.disabled
                }
              },
              textColorSecondary: {
                color: e.palette.text.secondary,
                "&$selected": {
                  color: e.palette.secondary.main
                },
                "&$disabled": {
                  color: e.palette.text.disabled
                }
              },
              selected: {},
              disabled: {},
              fullWidth: {
                flexShrink: 1,
                flexGrow: 1,
                flexBasis: 0,
                maxWidth: "none"
              },
              wrapped: {
                fontSize: e.typography.pxToRem(12),
                lineHeight: 1.5
              },
              wrapper: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                flexDirection: "column"
              }
            };
          }, {
            name: "MuiTab"
          })(XR),
              tN = s.createContext(),
              nN = "table",
              rN = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.component,
                o = void 0 === i ? nN : i,
                a = e.padding,
                c = void 0 === a ? "normal" : a,
                l = e.size,
                d = void 0 === l ? "medium" : l,
                u = e.stickyHeader,
                p = void 0 !== u && u,
                h = bw(e, ["classes", "className", "component", "padding", "size", "stickyHeader"]),
                _ = s.useMemo(function () {
              return {
                padding: c,
                size: d,
                stickyHeader: p
              };
            }, [c, d, p]);

            return s.createElement(tN.Provider, {
              value: _
            }, s.createElement(o, xy({
              role: o === nN ? null : "table",
              ref: t,
              className: VC(n.root, r, p && n.stickyHeader)
            }, h)));
          }),
              iN = Pk(function (e) {
            return {
              root: {
                display: "table",
                width: "100%",
                borderCollapse: "collapse",
                borderSpacing: 0,
                "& caption": xy({}, e.typography.body2, {
                  padding: e.spacing(2),
                  color: e.palette.text.secondary,
                  textAlign: "left",
                  captionSide: "bottom"
                })
              },
              stickyHeader: {
                borderCollapse: "separate"
              }
            };
          }, {
            name: "MuiTable"
          })(rN),
              oN = s.createContext(),
              aN = {
            variant: "body"
          },
              sN = "tbody",
              cN = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.component,
                o = void 0 === i ? sN : i,
                a = bw(e, ["classes", "className", "component"]);
            return s.createElement(oN.Provider, {
              value: aN
            }, s.createElement(o, xy({
              className: VC(n.root, r),
              ref: t,
              role: o === sN ? null : "rowgroup"
            }, a)));
          }),
              lN = Pk({
            root: {
              display: "table-row-group"
            }
          }, {
            name: "MuiTableBody"
          })(cN),
              dN = s.forwardRef(function (e, t) {
            var n,
                r,
                i = e.align,
                o = void 0 === i ? "inherit" : i,
                a = e.classes,
                c = e.className,
                l = e.component,
                d = e.padding,
                u = e.scope,
                p = e.size,
                h = e.sortDirection,
                _ = e.variant,
                f = bw(e, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]),
                m = s.useContext(tN),
                g = s.useContext(oN),
                v = g && "head" === g.variant;
            l ? (r = l, n = v ? "columnheader" : "cell") : r = v ? "th" : "td";
            var b = u;
            !b && v && (b = "col");
            var y = d || (m && m.padding ? m.padding : "normal"),
                w = p || (m && m.size ? m.size : "medium"),
                S = _ || g && g.variant,
                x = null;
            return h && (x = "asc" === h ? "ascending" : "descending"), s.createElement(r, xy({
              ref: t,
              className: VC(a.root, a[S], c, "inherit" !== o && a["align".concat(jk(o))], "normal" !== y && a["padding".concat(jk(y))], "medium" !== w && a["size".concat(jk(w))], "head" === S && m && m.stickyHeader && a.stickyHeader),
              "aria-sort": x,
              role: n,
              scope: b
            }, f));
          }),
              uN = Pk(function (e) {
            return {
              root: xy({}, e.typography.body2, {
                display: "table-cell",
                verticalAlign: "inherit",
                borderBottom: "1px solid\n    ".concat("light" === e.palette.type ? gw(fw(e.palette.divider, 1), .88) : mw(fw(e.palette.divider, 1), .68)),
                textAlign: "left",
                padding: 16
              }),
              head: {
                color: e.palette.text.primary,
                lineHeight: e.typography.pxToRem(24),
                fontWeight: e.typography.fontWeightMedium
              },
              body: {
                color: e.palette.text.primary
              },
              footer: {
                color: e.palette.text.secondary,
                lineHeight: e.typography.pxToRem(21),
                fontSize: e.typography.pxToRem(12)
              },
              sizeSmall: {
                padding: "6px 24px 6px 16px",
                "&:last-child": {
                  paddingRight: 16
                },
                "&$paddingCheckbox": {
                  width: 24,
                  padding: "0 12px 0 16px",
                  "&:last-child": {
                    paddingLeft: 12,
                    paddingRight: 16
                  },
                  "& > *": {
                    padding: 0
                  }
                }
              },
              paddingCheckbox: {
                width: 48,
                padding: "0 0 0 4px",
                "&:last-child": {
                  paddingLeft: 0,
                  paddingRight: 4
                }
              },
              paddingNone: {
                padding: 0,
                "&:last-child": {
                  padding: 0
                }
              },
              alignLeft: {
                textAlign: "left"
              },
              alignCenter: {
                textAlign: "center"
              },
              alignRight: {
                textAlign: "right",
                flexDirection: "row-reverse"
              },
              alignJustify: {
                textAlign: "justify"
              },
              stickyHeader: {
                position: "sticky",
                top: 0,
                left: 0,
                zIndex: 2,
                backgroundColor: e.palette.background.default
              }
            };
          }, {
            name: "MuiTableCell"
          })(dN),
              pN = {
            variant: "head"
          },
              hN = "thead",
              _N = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.component,
                o = void 0 === i ? hN : i,
                a = bw(e, ["classes", "className", "component"]);
            return s.createElement(oN.Provider, {
              value: pN
            }, s.createElement(o, xy({
              className: VC(n.root, r),
              ref: t,
              role: o === hN ? null : "rowgroup"
            }, a)));
          }),
              fN = Pk({
            root: {
              display: "table-header-group"
            }
          }, {
            name: "MuiTableHead"
          })(_N),
              mN = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.component,
                o = void 0 === i ? "div" : i,
                a = e.disableGutters,
                c = void 0 !== a && a,
                l = e.variant,
                d = void 0 === l ? "regular" : l,
                u = bw(e, ["classes", "className", "component", "disableGutters", "variant"]);
            return s.createElement(o, xy({
              className: VC(n.root, n[d], r, !c && n.gutters),
              ref: t
            }, u));
          }),
              gN = Pk(function (e) {
            return {
              root: {
                position: "relative",
                display: "flex",
                alignItems: "center"
              },
              gutters: Py({
                paddingLeft: e.spacing(2),
                paddingRight: e.spacing(2)
              }, e.breakpoints.up("sm"), {
                paddingLeft: e.spacing(3),
                paddingRight: e.spacing(3)
              }),
              regular: e.mixins.toolbar,
              dense: {
                minHeight: 48
              }
            };
          }, {
            name: "MuiToolbar"
          })(mN),
              vN = Lk(s.createElement("path", {
            d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
          })),
              bN = Lk(s.createElement("path", {
            d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
          })),
              yN = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.component,
                o = void 0 === i ? "tr" : i,
                a = e.hover,
                c = void 0 !== a && a,
                l = e.selected,
                d = void 0 !== l && l,
                u = bw(e, ["classes", "className", "component", "hover", "selected"]),
                p = s.useContext(oN);
            return s.createElement(o, xy({
              ref: t,
              className: VC(n.root, r, p && {
                head: n.head,
                footer: n.footer
              }[p.variant], c && n.hover, d && n.selected),
              role: "tr" === o ? null : "row"
            }, u));
          }),
              wN = Pk(function (e) {
            return {
              root: {
                color: "inherit",
                display: "table-row",
                verticalAlign: "middle",
                outline: 0,
                "&$hover:hover": {
                  backgroundColor: e.palette.action.hover
                },
                "&$selected, &$selected:hover": {
                  backgroundColor: fw(e.palette.secondary.main, e.palette.action.selectedOpacity)
                }
              },
              selected: {},
              hover: {},
              head: {},
              footer: {}
            };
          }, {
            name: "MuiTableRow"
          })(yN);

          function SN() {
            if (JR) return JR;
            var e = document.createElement("div"),
                t = document.createElement("div");
            return t.style.width = "10px", t.style.height = "1px", e.appendChild(t), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), JR = "reverse", e.scrollLeft > 0 ? JR = "default" : (e.scrollLeft = 1, 0 === e.scrollLeft && (JR = "negative")), document.body.removeChild(e), JR;
          }

          function xN(e, t) {
            var n = e.scrollLeft;
            if ("rtl" !== t) return n;

            switch (SN()) {
              case "negative":
                return e.scrollWidth - e.clientWidth + n;

              case "reverse":
                return e.scrollWidth - e.clientWidth - n;

              default:
                return n;
            }
          }

          function EN(e) {
            return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
          }

          var CN = {
            width: 99,
            height: 99,
            position: "absolute",
            top: -9999,
            overflow: "scroll"
          };

          function kN(e) {
            var t = e.onChange,
                n = bw(e, ["onChange"]),
                r = s.useRef(),
                i = s.useRef(null),
                o = function o() {
              r.current = i.current.offsetHeight - i.current.clientHeight;
            };

            return s.useEffect(function () {
              var e = Uk(function () {
                var e = r.current;
                o(), e !== r.current && t(r.current);
              });
              return window.addEventListener("resize", e), function () {
                e.clear(), window.removeEventListener("resize", e);
              };
            }, [t]), s.useEffect(function () {
              o(), t(r.current);
            }, [t]), s.createElement("div", xy({
              style: CN,
              ref: i
            }, n));
          }

          var AN = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.color,
                o = e.orientation,
                a = bw(e, ["classes", "className", "color", "orientation"]);
            return s.createElement("span", xy({
              className: VC(n.root, n["color".concat(jk(i))], r, "vertical" === o && n.vertical),
              ref: t
            }, a));
          }),
              IN = Pk(function (e) {
            return {
              root: {
                position: "absolute",
                height: 2,
                bottom: 0,
                width: "100%",
                transition: e.transitions.create()
              },
              colorPrimary: {
                backgroundColor: e.palette.primary.main
              },
              colorSecondary: {
                backgroundColor: e.palette.secondary.main
              },
              vertical: {
                height: "100%",
                width: 2,
                right: 0
              }
            };
          }, {
            name: "PrivateTabIndicator"
          })(AN),
              TN = s.createElement(vN, {
            fontSize: "small"
          }),
              ON = s.createElement(bN, {
            fontSize: "small"
          }),
              RN = s.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = e.direction,
                o = e.orientation,
                a = e.disabled,
                c = bw(e, ["classes", "className", "direction", "orientation", "disabled"]);
            return s.createElement(NA, xy({
              component: "div",
              className: VC(n.root, r, a && n.disabled, "vertical" === o && n.vertical),
              ref: t,
              role: null,
              tabIndex: null
            }, c), "left" === i ? TN : ON);
          }),
              NN = Pk({
            root: {
              width: 40,
              flexShrink: 0,
              opacity: .8,
              "&$disabled": {
                opacity: 0
              }
            },
            vertical: {
              width: "100%",
              height: 40,
              "& svg": {
                transform: "rotate(90deg)"
              }
            },
            disabled: {}
          }, {
            name: "MuiTabScrollButton"
          })(RN),
              PN = s.forwardRef(function (e, t) {
            var n = e["aria-label"],
                r = e["aria-labelledby"],
                i = e.action,
                o = e.centered,
                a = void 0 !== o && o,
                c = e.children,
                l = e.classes,
                d = e.className,
                u = e.component,
                p = void 0 === u ? "div" : u,
                h = e.indicatorColor,
                _ = void 0 === h ? "secondary" : h,
                f = e.onChange,
                m = e.orientation,
                g = void 0 === m ? "horizontal" : m,
                v = e.ScrollButtonComponent,
                b = void 0 === v ? NN : v,
                y = e.scrollButtons,
                w = void 0 === y ? "auto" : y,
                S = e.selectionFollowsFocus,
                x = e.TabIndicatorProps,
                E = void 0 === x ? {} : x,
                C = e.TabScrollButtonProps,
                k = e.textColor,
                A = void 0 === k ? "inherit" : k,
                I = e.value,
                T = e.variant,
                O = void 0 === T ? "standard" : T,
                R = bw(e, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]),
                N = Nk(),
                P = "scrollable" === O,
                j = "rtl" === N.direction,
                D = "vertical" === g,
                z = D ? "scrollTop" : "scrollLeft",
                M = D ? "top" : "left",
                L = D ? "bottom" : "right",
                U = D ? "clientHeight" : "clientWidth",
                B = D ? "height" : "width",
                H = s.useState(!1),
                V = H[0],
                q = H[1],
                F = s.useState({}),
                W = F[0],
                G = F[1],
                K = s.useState({
              start: !1,
              end: !1
            }),
                Q = K[0],
                Z = K[1],
                Y = s.useState({
              overflow: "hidden",
              marginBottom: null
            }),
                J = Y[0],
                $ = Y[1],
                X = new Map(),
                ee = s.useRef(null),
                te = s.useRef(null),
                ne = function ne() {
              var e,
                  t,
                  n = ee.current;

              if (n) {
                var r = n.getBoundingClientRect();
                e = {
                  clientWidth: n.clientWidth,
                  scrollLeft: n.scrollLeft,
                  scrollTop: n.scrollTop,
                  scrollLeftNormalized: xN(n, N.direction),
                  scrollWidth: n.scrollWidth,
                  top: r.top,
                  bottom: r.bottom,
                  left: r.left,
                  right: r.right
                };
              }

              if (n && !1 !== I) {
                var i = te.current.children;

                if (i.length > 0) {
                  var o = i[X.get(I)];
                  t = o ? o.getBoundingClientRect() : null;
                }
              }

              return {
                tabsMeta: e,
                tabMeta: t
              };
            },
                re = Gk(function () {
              var e,
                  t = ne(),
                  n = t.tabsMeta,
                  r = t.tabMeta,
                  i = 0;
              if (r && n) if (D) i = r.top - n.top + n.scrollTop;else {
                var o = j ? n.scrollLeftNormalized + n.clientWidth - n.scrollWidth : n.scrollLeft;
                i = r.left - n.left + o;
              }
              var a = (Py(e = {}, M, i), Py(e, B, r ? r[B] : 0), e);
              if (isNaN(W[M]) || isNaN(W[B])) G(a);else {
                var s = Math.abs(W[M] - a[M]),
                    c = Math.abs(W[B] - a[B]);
                (s >= 1 || c >= 1) && G(a);
              }
            }),
                ie = function ie(e) {
              !function (e, t, n) {
                var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                    i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : function () {},
                    o = r.ease,
                    a = void 0 === o ? EN : o,
                    s = r.duration,
                    c = void 0 === s ? 300 : s,
                    l = null,
                    d = t[e],
                    u = !1,
                    p = function r(o) {
                  if (u) i(new Error("Animation cancelled"));else {
                    null === l && (l = o);
                    var s = Math.min(1, (o - l) / c);
                    t[e] = a(s) * (n - d) + d, s >= 1 ? requestAnimationFrame(function () {
                      i(null);
                    }) : requestAnimationFrame(r);
                  }
                };

                d === n ? i(new Error("Element already at target position")) : requestAnimationFrame(p);
              }(z, ee.current, e);
            },
                oe = function oe(e) {
              var t = ee.current[z];
              D ? t += e : (t += e * (j ? -1 : 1), t *= j && "reverse" === SN() ? -1 : 1), ie(t);
            },
                ae = function ae() {
              oe(-ee.current[U]);
            },
                se = function se() {
              oe(ee.current[U]);
            },
                ce = s.useCallback(function (e) {
              $({
                overflow: null,
                marginBottom: -e
              });
            }, []),
                le = Gk(function () {
              var e = ne(),
                  t = e.tabsMeta,
                  n = e.tabMeta;
              if (n && t) if (n[M] < t[M]) {
                var r = t[z] + (n[M] - t[M]);
                ie(r);
              } else if (n[L] > t[L]) {
                var i = t[z] + (n[L] - t[L]);
                ie(i);
              }
            }),
                de = Gk(function () {
              if (P && "off" !== w) {
                var e,
                    t,
                    n = ee.current,
                    r = n.scrollTop,
                    i = n.scrollHeight,
                    o = n.clientHeight,
                    a = n.scrollWidth,
                    s = n.clientWidth;
                if (D) e = r > 1, t = r < i - o - 1;else {
                  var c = xN(ee.current, N.direction);
                  e = j ? c < a - s - 1 : c > 1, t = j ? c > 1 : c < a - s - 1;
                }
                e === Q.start && t === Q.end || Z({
                  start: e,
                  end: t
                });
              }
            });

            s.useEffect(function () {
              var e = Uk(function () {
                re(), de();
              }),
                  t = Vk(ee.current);
              return t.addEventListener("resize", e), function () {
                e.clear(), t.removeEventListener("resize", e);
              };
            }, [re, de]);
            var ue = s.useCallback(Uk(function () {
              de();
            }));
            s.useEffect(function () {
              return function () {
                ue.clear();
              };
            }, [ue]), s.useEffect(function () {
              q(!0);
            }, []), s.useEffect(function () {
              re(), de();
            }), s.useEffect(function () {
              le();
            }, [le, W]), s.useImperativeHandle(i, function () {
              return {
                updateIndicator: re,
                updateScrollButtons: de
              };
            }, [re, de]);

            var pe = s.createElement(IN, xy({
              className: l.indicator,
              orientation: g,
              color: _
            }, E, {
              style: xy({}, W, E.style)
            })),
                he = 0,
                _e = s.Children.map(c, function (e) {
              if (!s.isValidElement(e)) return null;
              var t = void 0 === e.props.value ? he : e.props.value;
              X.set(t, he);
              var n = t === I;
              return he += 1, s.cloneElement(e, {
                fullWidth: "fullWidth" === O,
                indicator: n && !V && pe,
                selected: n,
                selectionFollowsFocus: S,
                onChange: f,
                textColor: A,
                value: t
              });
            }),
                fe = function () {
              var e = {};
              e.scrollbarSizeListener = P ? s.createElement(kN, {
                className: l.scrollable,
                onChange: ce
              }) : null;
              var t = Q.start || Q.end,
                  n = P && ("auto" === w && t || "desktop" === w || "on" === w);
              return e.scrollButtonStart = n ? s.createElement(b, xy({
                orientation: g,
                direction: j ? "right" : "left",
                onClick: ae,
                disabled: !Q.start,
                className: VC(l.scrollButtons, "on" !== w && l.scrollButtonsDesktop)
              }, C)) : null, e.scrollButtonEnd = n ? s.createElement(b, xy({
                orientation: g,
                direction: j ? "left" : "right",
                onClick: se,
                disabled: !Q.end,
                className: VC(l.scrollButtons, "on" !== w && l.scrollButtonsDesktop)
              }, C)) : null, e;
            }();

            return s.createElement(p, xy({
              className: VC(l.root, d, D && l.vertical),
              ref: t
            }, R), fe.scrollButtonStart, fe.scrollbarSizeListener, s.createElement("div", {
              className: VC(l.scroller, P ? l.scrollable : l.fixed),
              style: J,
              ref: ee,
              onScroll: ue
            }, s.createElement("div", {
              "aria-label": n,
              "aria-labelledby": r,
              className: VC(l.flexContainer, D && l.flexContainerVertical, a && !P && l.centered),
              onKeyDown: function onKeyDown(e) {
                var t = e.target;

                if ("tab" === t.getAttribute("role")) {
                  var n = null,
                      r = "vertical" !== g ? "ArrowLeft" : "ArrowUp",
                      i = "vertical" !== g ? "ArrowRight" : "ArrowDown";

                  switch ("vertical" !== g && "rtl" === N.direction && (r = "ArrowRight", i = "ArrowLeft"), e.key) {
                    case r:
                      n = t.previousElementSibling || te.current.lastChild;
                      break;

                    case i:
                      n = t.nextElementSibling || te.current.firstChild;
                      break;

                    case "Home":
                      n = te.current.firstChild;
                      break;

                    case "End":
                      n = te.current.lastChild;
                  }

                  null !== n && (n.focus(), e.preventDefault());
                }
              },
              ref: te,
              role: "tablist"
            }, _e), V && pe), fe.scrollButtonEnd);
          }),
              jN = Pk(function (e) {
            return {
              root: {
                overflow: "hidden",
                minHeight: 48,
                WebkitOverflowScrolling: "touch",
                display: "flex"
              },
              vertical: {
                flexDirection: "column"
              },
              flexContainer: {
                display: "flex"
              },
              flexContainerVertical: {
                flexDirection: "column"
              },
              centered: {
                justifyContent: "center"
              },
              scroller: {
                position: "relative",
                display: "inline-block",
                flex: "1 1 auto",
                whiteSpace: "nowrap"
              },
              fixed: {
                overflowX: "hidden",
                width: "100%"
              },
              scrollable: {
                overflowX: "scroll",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none"
                }
              },
              scrollButtons: {},
              scrollButtonsDesktop: Py({}, e.breakpoints.down("xs"), {
                display: "none"
              }),
              indicator: {}
            };
          }, {
            name: "MuiTabs"
          })(PN),
              DN = {
            standard: ST,
            filled: aT,
            outlined: vO
          },
              zN = s.forwardRef(function (e, t) {
            var n = e.autoComplete,
                r = e.autoFocus,
                i = void 0 !== r && r,
                o = e.children,
                a = e.classes,
                c = e.className,
                l = e.color,
                d = void 0 === l ? "primary" : l,
                u = e.defaultValue,
                p = e.disabled,
                h = void 0 !== p && p,
                _ = e.error,
                f = void 0 !== _ && _,
                m = e.FormHelperTextProps,
                g = e.fullWidth,
                v = void 0 !== g && g,
                b = e.helperText,
                y = e.hiddenLabel,
                w = e.id,
                S = e.InputLabelProps,
                x = e.inputProps,
                E = e.InputProps,
                C = e.inputRef,
                k = e.label,
                A = e.multiline,
                I = void 0 !== A && A,
                T = e.name,
                O = e.onBlur,
                R = e.onChange,
                N = e.onFocus,
                P = e.placeholder,
                j = e.required,
                D = void 0 !== j && j,
                z = e.rows,
                M = e.rowsMax,
                L = e.maxRows,
                U = e.minRows,
                B = e.select,
                H = void 0 !== B && B,
                V = e.SelectProps,
                q = e.type,
                F = e.value,
                W = e.variant,
                G = void 0 === W ? "standard" : W,
                K = bw(e, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]),
                Q = {};

            if ("outlined" === G && (S && void 0 !== S.shrink && (Q.notched = S.shrink), k)) {
              var Z,
                  Y = null !== (Z = null == S ? void 0 : S.required) && void 0 !== Z ? Z : D;
              Q.label = s.createElement(s.Fragment, null, k, Y && "\xa0*");
            }

            H && (V && V.native || (Q.id = void 0), Q["aria-describedby"] = void 0);
            var J = b && w ? "".concat(w, "-helper-text") : void 0,
                $ = k && w ? "".concat(w, "-label") : void 0,
                X = DN[G],
                ee = s.createElement(X, xy({
              "aria-describedby": J,
              autoComplete: n,
              autoFocus: i,
              defaultValue: u,
              fullWidth: v,
              multiline: I,
              name: T,
              rows: z,
              rowsMax: M,
              maxRows: L,
              minRows: U,
              type: q,
              value: F,
              id: w,
              inputRef: C,
              onBlur: O,
              onChange: R,
              onFocus: N,
              placeholder: P,
              inputProps: x
            }, Q, E));
            return s.createElement(cT, xy({
              className: VC(a.root, c),
              disabled: h,
              error: f,
              fullWidth: v,
              hiddenLabel: y,
              ref: t,
              required: D,
              color: d,
              variant: G
            }, K), k && s.createElement(kT, xy({
              htmlFor: w,
              id: $
            }, S), k), H ? s.createElement($R, xy({
              "aria-describedby": J,
              id: w,
              labelId: $,
              value: F,
              input: ee
            }, V), o) : ee, b && s.createElement(_T, xy({
              id: J
            }, m), b));
          }),
              MN = Pk({
            root: {}
          }, {
            name: "MuiTextField"
          })(zN);

          function LN(e) {
            return Math.round(1e5 * e) / 1e5;
          }

          var UN = !1,
              BN = null,
              HN = s.forwardRef(function (e, t) {
            var n = e.arrow,
                r = void 0 !== n && n,
                i = e.children,
                o = e.classes,
                a = e.disableFocusListener,
                l = void 0 !== a && a,
                d = e.disableHoverListener,
                u = void 0 !== d && d,
                p = e.disableTouchListener,
                h = void 0 !== p && p,
                _ = e.enterDelay,
                f = void 0 === _ ? 100 : _,
                m = e.enterNextDelay,
                g = void 0 === m ? 0 : m,
                v = e.enterTouchDelay,
                b = void 0 === v ? 700 : v,
                y = e.id,
                w = e.interactive,
                S = void 0 !== w && w,
                x = e.leaveDelay,
                E = void 0 === x ? 0 : x,
                C = e.leaveTouchDelay,
                k = void 0 === C ? 1500 : C,
                A = e.onClose,
                I = e.onOpen,
                T = e.open,
                O = e.placement,
                R = void 0 === O ? "bottom" : O,
                N = e.PopperComponent,
                P = void 0 === N ? RR : N,
                j = e.PopperProps,
                D = e.title,
                z = e.TransitionComponent,
                M = void 0 === z ? yT : z,
                L = e.TransitionProps,
                U = bw(e, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]),
                B = Nk(),
                H = s.useState(),
                V = H[0],
                q = H[1],
                F = s.useState(null),
                W = F[0],
                G = F[1],
                K = s.useRef(!1),
                Q = s.useRef(),
                Z = s.useRef(),
                Y = s.useRef(),
                J = s.useRef(),
                $ = cS(Fk({
              controlled: T,
              default: !1,
              name: "Tooltip",
              state: "open"
            }), 2),
                X = $[0],
                ee = $[1],
                te = X,
                ne = Qk(y);
            s.useEffect(function () {
              return function () {
                clearTimeout(Q.current), clearTimeout(Z.current), clearTimeout(Y.current), clearTimeout(J.current);
              };
            }, []);

            var re = function re(e) {
              clearTimeout(BN), UN = !0, ee(!0), I && I(e);
            },
                ie = function ie() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              return function (t) {
                var n = i.props;
                "mouseover" === t.type && n.onMouseOver && e && n.onMouseOver(t), K.current && "touchstart" !== t.type || (V && V.removeAttribute("title"), clearTimeout(Z.current), clearTimeout(Y.current), f || UN && g ? (t.persist(), Z.current = setTimeout(function () {
                  re(t);
                }, UN ? g : f)) : re(t));
              };
            },
                oe = iA(),
                ae = oe.isFocusVisible,
                se = oe.onBlurVisible,
                ce = oe.ref,
                le = s.useState(!1),
                de = le[0],
                ue = le[1],
                pe = function pe() {
              de && (ue(!1), se());
            },
                he = function he() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              return function (t) {
                V || q(t.currentTarget), ae(t) && (ue(!0), ie()(t));
                var n = i.props;
                n.onFocus && e && n.onFocus(t);
              };
            },
                _e = function _e(e) {
              clearTimeout(BN), BN = setTimeout(function () {
                UN = !1;
              }, 800 + E), ee(!1), A && A(e), clearTimeout(Q.current), Q.current = setTimeout(function () {
                K.current = !1;
              }, B.transitions.duration.shortest);
            },
                fe = function fe() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              return function (t) {
                var n = i.props;
                "blur" === t.type && (n.onBlur && e && n.onBlur(t), pe()), "mouseleave" === t.type && n.onMouseLeave && t.currentTarget === V && n.onMouseLeave(t), clearTimeout(Z.current), clearTimeout(Y.current), t.persist(), Y.current = setTimeout(function () {
                  _e(t);
                }, E);
              };
            },
                me = function me(e) {
              K.current = !0;
              var t = i.props;
              t.onTouchStart && t.onTouchStart(e);
            },
                ge = Kk(q, t),
                ve = Kk(ce, ge),
                be = s.useCallback(function (e) {
              qk(ve, c.findDOMNode(e));
            }, [ve]),
                ye = Kk(i.ref, be);

            "" === D && (te = !1);
            var we = xy({
              "aria-describedby": te ? ne : null,
              title: te || u || "string" != typeof D ? null : D
            }, U, i.props, {
              className: VC(U.className, i.props.className),
              onTouchStart: me,
              ref: ye
            }),
                Se = {};
            h || (we.onTouchStart = function (e) {
              me(e), clearTimeout(Y.current), clearTimeout(Q.current), clearTimeout(J.current), e.persist(), J.current = setTimeout(function () {
                ie()(e);
              }, b);
            }, we.onTouchEnd = function (e) {
              i.props.onTouchEnd && i.props.onTouchEnd(e), clearTimeout(J.current), clearTimeout(Y.current), e.persist(), Y.current = setTimeout(function () {
                _e(e);
              }, k);
            }), u || (we.onMouseOver = ie(), we.onMouseLeave = fe(), S && (Se.onMouseOver = ie(!1), Se.onMouseLeave = fe(!1))), l || (we.onFocus = he(), we.onBlur = fe(), S && (Se.onFocus = he(!1), Se.onBlur = fe(!1)));
            var xe = s.useMemo(function () {
              return ky({
                popperOptions: {
                  modifiers: {
                    arrow: {
                      enabled: Boolean(W),
                      element: W
                    }
                  }
                }
              }, j);
            }, [W, j]);
            return s.createElement(s.Fragment, null, s.cloneElement(i, we), s.createElement(P, xy({
              className: VC(o.popper, S && o.popperInteractive, r && o.popperArrow),
              placement: R,
              anchorEl: V,
              open: !!V && te,
              id: we["aria-describedby"],
              transition: !0
            }, Se, xe), function (e) {
              var t = e.placement,
                  n = e.TransitionProps;
              return s.createElement(M, xy({
                timeout: B.transitions.duration.shorter
              }, n, L), s.createElement("div", {
                className: VC(o.tooltip, o["tooltipPlacement".concat(jk(t.split("-")[0]))], K.current && o.touch, r && o.tooltipArrow)
              }, D, r ? s.createElement("span", {
                className: o.arrow,
                ref: G
              }) : null));
            }));
          }),
              VN = Pk(function (e) {
            return {
              popper: {
                zIndex: e.zIndex.tooltip,
                pointerEvents: "none"
              },
              popperInteractive: {
                pointerEvents: "auto"
              },
              popperArrow: {
                '&[x-placement*="bottom"] $arrow': {
                  top: 0,
                  left: 0,
                  marginTop: "-0.71em",
                  marginLeft: 4,
                  marginRight: 4,
                  "&::before": {
                    transformOrigin: "0 100%"
                  }
                },
                '&[x-placement*="top"] $arrow': {
                  bottom: 0,
                  left: 0,
                  marginBottom: "-0.71em",
                  marginLeft: 4,
                  marginRight: 4,
                  "&::before": {
                    transformOrigin: "100% 0"
                  }
                },
                '&[x-placement*="right"] $arrow': {
                  left: 0,
                  marginLeft: "-0.71em",
                  height: "1em",
                  width: "0.71em",
                  marginTop: 4,
                  marginBottom: 4,
                  "&::before": {
                    transformOrigin: "100% 100%"
                  }
                },
                '&[x-placement*="left"] $arrow': {
                  right: 0,
                  marginRight: "-0.71em",
                  height: "1em",
                  width: "0.71em",
                  marginTop: 4,
                  marginBottom: 4,
                  "&::before": {
                    transformOrigin: "0 0"
                  }
                }
              },
              tooltip: {
                backgroundColor: fw(e.palette.grey[700], .9),
                borderRadius: e.shape.borderRadius,
                color: e.palette.common.white,
                fontFamily: e.typography.fontFamily,
                padding: "4px 8px",
                fontSize: e.typography.pxToRem(10),
                lineHeight: "".concat(LN(1.4), "em"),
                maxWidth: 300,
                wordWrap: "break-word",
                fontWeight: e.typography.fontWeightMedium
              },
              tooltipArrow: {
                position: "relative",
                margin: "0"
              },
              arrow: {
                overflow: "hidden",
                position: "absolute",
                width: "1em",
                height: "0.71em",
                boxSizing: "border-box",
                color: fw(e.palette.grey[700], .9),
                "&::before": {
                  content: '""',
                  margin: "auto",
                  display: "block",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "currentColor",
                  transform: "rotate(45deg)"
                }
              },
              touch: {
                padding: "8px 16px",
                fontSize: e.typography.pxToRem(14),
                lineHeight: "".concat(LN(16 / 14), "em"),
                fontWeight: e.typography.fontWeightRegular
              },
              tooltipPlacementLeft: Py({
                transformOrigin: "right center",
                margin: "0 24px "
              }, e.breakpoints.up("sm"), {
                margin: "0 14px"
              }),
              tooltipPlacementRight: Py({
                transformOrigin: "left center",
                margin: "0 24px"
              }, e.breakpoints.up("sm"), {
                margin: "0 14px"
              }),
              tooltipPlacementTop: Py({
                transformOrigin: "center bottom",
                margin: "24px 0"
              }, e.breakpoints.up("sm"), {
                margin: "14px 0"
              }),
              tooltipPlacementBottom: Py({
                transformOrigin: "center top",
                margin: "24px 0"
              }, e.breakpoints.up("sm"), {
                margin: "14px 0"
              })
            };
          }, {
            name: "MuiTooltip",
            flip: !1
          })(HN),
              qN = {
            exports: {}
          },
              FN = {},
              WN = Iy(qC),
              GN = {},
              KN = {};
          Object.defineProperty(KN, "__esModule", {
            value: !0
          }), KN.dontSetMe = function (e, t, n) {
            if (e[t]) return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
          }, KN.findInArray = function (e, t) {
            for (var n = 0, r = e.length; n < r; n++) {
              if (t.apply(t, [e[n], n, e])) return e[n];
            }
          }, KN.int = function (e) {
            return parseInt(e, 10);
          }, KN.isFunction = function (e) {
            return "function" == typeof e || "[object Function]" === Object.prototype.toString.call(e);
          }, KN.isNum = function (e) {
            return "number" == typeof e && !isNaN(e);
          };
          var QN = {};
          Object.defineProperty(QN, "__esModule", {
            value: !0
          }), QN.browserPrefixToKey = JN, QN.browserPrefixToStyle = function (e, t) {
            return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
          }, QN.default = void 0, QN.getPrefix = YN;
          var ZN = ["Moz", "Webkit", "O", "ms"];

          function YN() {
            var e,
                t,
                n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "transform";
            if ("undefined" == typeof window) return "";
            var r = null === (e = window.document) || void 0 === e || null === (t = e.documentElement) || void 0 === t ? void 0 : t.style;
            if (!r) return "";
            if (n in r) return "";

            for (var i = 0; i < ZN.length; i++) {
              if (JN(n, ZN[i]) in r) return ZN[i];
            }

            return "";
          }

          function JN(e, t) {
            return t ? "".concat(t).concat(function (e) {
              for (var t = "", n = !0, r = 0; r < e.length; r++) {
                n ? (t += e[r].toUpperCase(), n = !1) : "-" === e[r] ? n = !0 : t += e[r];
              }

              return t;
            }(e)) : e;
          }

          var $N = YN();

          function XN(e) {
            return XN = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, XN(e);
          }

          QN.default = $N, Object.defineProperty(GN, "__esModule", {
            value: !0
          }), GN.addClassName = lP, GN.addEvent = function (e, t, n, r) {
            if (e) {
              var i = iP({
                capture: !0
              }, r);
              e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
            }
          }, GN.addUserSelectStyles = function (e) {
            if (e) {
              var t = e.getElementById("react-draggable-style-el");
              t || ((t = e.createElement("style")).type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n", t.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n", e.getElementsByTagName("head")[0].appendChild(t)), e.body && lP(e.body, "react-draggable-transparent-selection");
            }
          }, GN.createCSSTransform = function (e, t) {
            var n = cP(e, t, "px");
            return oP({}, (0, tP.browserPrefixToKey)("transform", tP.default), n);
          }, GN.createSVGTransform = function (e, t) {
            return cP(e, t, "");
          }, GN.getTouch = function (e, t) {
            return e.targetTouches && (0, eP.findInArray)(e.targetTouches, function (e) {
              return t === e.identifier;
            }) || e.changedTouches && (0, eP.findInArray)(e.changedTouches, function (e) {
              return t === e.identifier;
            });
          }, GN.getTouchIdentifier = function (e) {
            return e.targetTouches && e.targetTouches[0] ? e.targetTouches[0].identifier : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].identifier : void 0;
          }, GN.getTranslation = cP, GN.innerHeight = function (e) {
            var t = e.clientHeight,
                n = e.ownerDocument.defaultView.getComputedStyle(e);
            return (t -= (0, eP.int)(n.paddingTop)) - (0, eP.int)(n.paddingBottom);
          }, GN.innerWidth = function (e) {
            var t = e.clientWidth,
                n = e.ownerDocument.defaultView.getComputedStyle(e);
            return (t -= (0, eP.int)(n.paddingLeft)) - (0, eP.int)(n.paddingRight);
          }, GN.matchesSelector = sP, GN.matchesSelectorAndParentsTo = function (e, t, n) {
            var r = e;

            do {
              if (sP(r, t)) return !0;
              if (r === n) return !1;
              r = r.parentNode;
            } while (r);

            return !1;
          }, GN.offsetXYFromParent = function (e, t, n) {
            var r = t === t.ownerDocument.body ? {
              left: 0,
              top: 0
            } : t.getBoundingClientRect();
            return {
              x: (e.clientX + t.scrollLeft - r.left) / n,
              y: (e.clientY + t.scrollTop - r.top) / n
            };
          }, GN.outerHeight = function (e) {
            var t = e.clientHeight,
                n = e.ownerDocument.defaultView.getComputedStyle(e);
            return (t += (0, eP.int)(n.borderTopWidth)) + (0, eP.int)(n.borderBottomWidth);
          }, GN.outerWidth = function (e) {
            var t = e.clientWidth,
                n = e.ownerDocument.defaultView.getComputedStyle(e);
            return (t += (0, eP.int)(n.borderLeftWidth)) + (0, eP.int)(n.borderRightWidth);
          }, GN.removeClassName = dP, GN.removeEvent = function (e, t, n, r) {
            if (e) {
              var i = iP({
                capture: !0
              }, r);
              e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
            }
          }, GN.removeUserSelectStyles = function (e) {
            if (e) try {
              if (e.body && dP(e.body, "react-draggable-transparent-selection"), e.selection) e.selection.empty();else {
                var t = (e.defaultView || window).getSelection();
                t && "Caret" !== t.type && t.removeAllRanges();
              }
            } catch (e) {}
          };

          var eP = KN,
              tP = function (e, t) {
            if (!t && e && e.__esModule) return e;
            if (null === e || "object" !== XN(e) && "function" != typeof e) return {
              default: e
            };
            var n = nP(t);
            if (n && n.has(e)) return n.get(e);
            var r = {},
                i = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var o in e) {
              if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
                a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
              }
            }

            return r.default = e, n && n.set(e, r), r;
          }(QN);

          function nP(e) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap(),
                n = new WeakMap();
            return (nP = function nP(e) {
              return e ? n : t;
            })(e);
          }

          function rP(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function iP(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? rP(Object(n), !0).forEach(function (t) {
                oP(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rP(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function oP(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          var aP = "";

          function sP(e, t) {
            return aP || (aP = (0, eP.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function (t) {
              return (0, eP.isFunction)(e[t]);
            })), !!(0, eP.isFunction)(e[aP]) && e[aP](t);
          }

          function cP(e, t, n) {
            var r = e.x,
                i = e.y,
                o = "translate(".concat(r).concat(n, ",").concat(i).concat(n, ")");

            if (t) {
              var a = "".concat("string" == typeof t.x ? t.x : t.x + n),
                  s = "".concat("string" == typeof t.y ? t.y : t.y + n);
              o = "translate(".concat(a, ", ").concat(s, ")") + o;
            }

            return o;
          }

          function lP(e, t) {
            e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
          }

          function dP(e, t) {
            e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
          }

          var uP = {};
          Object.defineProperty(uP, "__esModule", {
            value: !0
          }), uP.canDragX = function (e) {
            return "both" === e.props.axis || "x" === e.props.axis;
          }, uP.canDragY = function (e) {
            return "both" === e.props.axis || "y" === e.props.axis;
          }, uP.createCoreData = function (e, t, n) {
            var r = e.state,
                i = !(0, pP.isNum)(r.lastX),
                o = _P(e);

            return i ? {
              node: o,
              deltaX: 0,
              deltaY: 0,
              lastX: t,
              lastY: n,
              x: t,
              y: n
            } : {
              node: o,
              deltaX: t - r.lastX,
              deltaY: n - r.lastY,
              lastX: r.lastX,
              lastY: r.lastY,
              x: t,
              y: n
            };
          }, uP.createDraggableData = function (e, t) {
            var n = e.props.scale;
            return {
              node: t.node,
              x: e.state.x + t.deltaX / n,
              y: e.state.y + t.deltaY / n,
              deltaX: t.deltaX / n,
              deltaY: t.deltaY / n,
              lastX: e.state.x,
              lastY: e.state.y
            };
          }, uP.getBoundPosition = function (e, t, n) {
            if (!e.props.bounds) return [t, n];
            var r = e.props.bounds;
            r = "string" == typeof r ? r : function (e) {
              return {
                left: e.left,
                top: e.top,
                right: e.right,
                bottom: e.bottom
              };
            }(r);

            var i = _P(e);

            if ("string" == typeof r) {
              var o,
                  a = i.ownerDocument,
                  s = a.defaultView;
              if (!((o = "parent" === r ? i.parentNode : a.querySelector(r)) instanceof s.HTMLElement)) throw new Error('Bounds selector "' + r + '" could not find an element.');
              var c = o,
                  l = s.getComputedStyle(i),
                  d = s.getComputedStyle(c);
              r = {
                left: -i.offsetLeft + (0, pP.int)(d.paddingLeft) + (0, pP.int)(l.marginLeft),
                top: -i.offsetTop + (0, pP.int)(d.paddingTop) + (0, pP.int)(l.marginTop),
                right: (0, hP.innerWidth)(c) - (0, hP.outerWidth)(i) - i.offsetLeft + (0, pP.int)(d.paddingRight) - (0, pP.int)(l.marginRight),
                bottom: (0, hP.innerHeight)(c) - (0, hP.outerHeight)(i) - i.offsetTop + (0, pP.int)(d.paddingBottom) - (0, pP.int)(l.marginBottom)
              };
            }

            return (0, pP.isNum)(r.right) && (t = Math.min(t, r.right)), (0, pP.isNum)(r.bottom) && (n = Math.min(n, r.bottom)), (0, pP.isNum)(r.left) && (t = Math.max(t, r.left)), (0, pP.isNum)(r.top) && (n = Math.max(n, r.top)), [t, n];
          }, uP.getControlPosition = function (e, t, n) {
            var r = "number" == typeof t ? (0, hP.getTouch)(e, t) : null;
            if ("number" == typeof t && !r) return null;

            var i = _P(n),
                o = n.props.offsetParent || i.offsetParent || i.ownerDocument.body;

            return (0, hP.offsetXYFromParent)(r || e, o, n.props.scale);
          }, uP.snapToGrid = function (e, t, n) {
            return [Math.round(t / e[0]) * e[0], Math.round(n / e[1]) * e[1]];
          };
          var pP = KN,
              hP = GN;

          function _P(e) {
            var t = e.findDOMNode();
            if (!t) throw new Error("<DraggableCore>: Unmounted during event!");
            return t;
          }

          var fP = {},
              mP = {};

          function gP(e) {
            return gP = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, gP(e);
          }

          Object.defineProperty(mP, "__esModule", {
            value: !0
          }), mP.default = function () {}, Object.defineProperty(fP, "__esModule", {
            value: !0
          }), fP.default = void 0;

          var vP = function (e, t) {
            if (!t && e && e.__esModule) return e;
            if (null === e || "object" !== gP(e) && "function" != typeof e) return {
              default: e
            };
            var n = kP(t);
            if (n && n.has(e)) return n.get(e);
            var r = {},
                i = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var o in e) {
              if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
                a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
              }
            }

            return r.default = e, n && n.set(e, r), r;
          }(a.default),
              bP = CP(Oy.exports),
              yP = CP(l.default),
              wP = GN,
              SP = uP,
              xP = KN,
              EP = CP(mP);

          function CP(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          function kP(e) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap(),
                n = new WeakMap();
            return (kP = function kP(e) {
              return e ? n : t;
            })(e);
          }

          function AP(e, t) {
            return function (e) {
              if (Array.isArray(e)) return e;
            }(e) || function (e, t) {
              var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

              if (null != n) {
                var r,
                    i,
                    o = [],
                    a = !0,
                    s = !1;

                try {
                  for (n = n.call(e); !(a = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); a = !0) {
                    ;
                  }
                } catch (e) {
                  s = !0, i = e;
                } finally {
                  try {
                    a || null == n.return || n.return();
                  } finally {
                    if (s) throw i;
                  }
                }

                return o;
              }
            }(e, t) || function (e, t) {
              if (e) {
                if ("string" == typeof e) return IP(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? IP(e, t) : void 0;
              }
            }(e, t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }

          function IP(e, t) {
            (null == t || t > e.length) && (t = e.length);

            for (var n = 0, r = new Array(t); n < t; n++) {
              r[n] = e[n];
            }

            return r;
          }

          function TP(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }

          function OP(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          function RP(e, t) {
            return RP = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e;
            }, RP(e, t);
          }

          function NP(e) {
            var t = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;

              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }();

            return function () {
              var n,
                  r = DP(e);

              if (t) {
                var i = DP(this).constructor;
                n = Reflect.construct(r, arguments, i);
              } else n = r.apply(this, arguments);

              return PP(this, n);
            };
          }

          function PP(e, t) {
            if (t && ("object" === gP(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return jP(e);
          }

          function jP(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }

          function DP(e) {
            return DP = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, DP(e);
          }

          function zP(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          var MP = {
            start: "touchstart",
            move: "touchmove",
            stop: "touchend"
          },
              LP = {
            start: "mousedown",
            move: "mousemove",
            stop: "mouseup"
          },
              UP = LP,
              BP = function (e) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), Object.defineProperty(e, "prototype", {
                writable: !1
              }), t && RP(e, t);
            }(o, e);
            var t,
                n,
                r,
                i = NP(o);

            function o() {
              var e;
              TP(this, o);

              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              return zP(jP(e = i.call.apply(i, [this].concat(n))), "state", {
                dragging: !1,
                lastX: NaN,
                lastY: NaN,
                touchIdentifier: null
              }), zP(jP(e), "mounted", !1), zP(jP(e), "handleDragStart", function (t) {
                if (e.props.onMouseDown(t), !e.props.allowAnyClick && "number" == typeof t.button && 0 !== t.button) return !1;
                var n = e.findDOMNode();
                if (!n || !n.ownerDocument || !n.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
                var r = n.ownerDocument;

                if (!(e.props.disabled || !(t.target instanceof r.defaultView.Node) || e.props.handle && !(0, wP.matchesSelectorAndParentsTo)(t.target, e.props.handle, n) || e.props.cancel && (0, wP.matchesSelectorAndParentsTo)(t.target, e.props.cancel, n))) {
                  "touchstart" === t.type && t.preventDefault();
                  var i = (0, wP.getTouchIdentifier)(t);
                  e.setState({
                    touchIdentifier: i
                  });
                  var o = (0, SP.getControlPosition)(t, i, jP(e));

                  if (null != o) {
                    var a = o.x,
                        s = o.y,
                        c = (0, SP.createCoreData)(jP(e), a, s);
                    (0, EP.default)("DraggableCore: handleDragStart: %j", c), (0, EP.default)("calling", e.props.onStart), !1 !== e.props.onStart(t, c) && !1 !== e.mounted && (e.props.enableUserSelectHack && (0, wP.addUserSelectStyles)(r), e.setState({
                      dragging: !0,
                      lastX: a,
                      lastY: s
                    }), (0, wP.addEvent)(r, UP.move, e.handleDrag), (0, wP.addEvent)(r, UP.stop, e.handleDragStop));
                  }
                }
              }), zP(jP(e), "handleDrag", function (t) {
                var n = (0, SP.getControlPosition)(t, e.state.touchIdentifier, jP(e));

                if (null != n) {
                  var r = n.x,
                      i = n.y;

                  if (Array.isArray(e.props.grid)) {
                    var o = r - e.state.lastX,
                        a = i - e.state.lastY,
                        s = AP((0, SP.snapToGrid)(e.props.grid, o, a), 2);
                    if (o = s[0], a = s[1], !o && !a) return;
                    r = e.state.lastX + o, i = e.state.lastY + a;
                  }

                  var c = (0, SP.createCoreData)(jP(e), r, i);
                  if ((0, EP.default)("DraggableCore: handleDrag: %j", c), !1 !== e.props.onDrag(t, c) && !1 !== e.mounted) e.setState({
                    lastX: r,
                    lastY: i
                  });else try {
                    e.handleDragStop(new MouseEvent("mouseup"));
                  } catch (t) {
                    var l = document.createEvent("MouseEvents");
                    l.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), e.handleDragStop(l);
                  }
                }
              }), zP(jP(e), "handleDragStop", function (t) {
                if (e.state.dragging) {
                  var n = (0, SP.getControlPosition)(t, e.state.touchIdentifier, jP(e));

                  if (null != n) {
                    var r = n.x,
                        i = n.y;

                    if (Array.isArray(e.props.grid)) {
                      var o = r - e.state.lastX || 0,
                          a = i - e.state.lastY || 0,
                          s = AP((0, SP.snapToGrid)(e.props.grid, o, a), 2);
                      o = s[0], a = s[1], r = e.state.lastX + o, i = e.state.lastY + a;
                    }

                    var c = (0, SP.createCoreData)(jP(e), r, i);
                    if (!1 === e.props.onStop(t, c) || !1 === e.mounted) return !1;
                    var l = e.findDOMNode();
                    l && e.props.enableUserSelectHack && (0, wP.removeUserSelectStyles)(l.ownerDocument), (0, EP.default)("DraggableCore: handleDragStop: %j", c), e.setState({
                      dragging: !1,
                      lastX: NaN,
                      lastY: NaN
                    }), l && ((0, EP.default)("DraggableCore: Removing handlers"), (0, wP.removeEvent)(l.ownerDocument, UP.move, e.handleDrag), (0, wP.removeEvent)(l.ownerDocument, UP.stop, e.handleDragStop));
                  }
                }
              }), zP(jP(e), "onMouseDown", function (t) {
                return UP = LP, e.handleDragStart(t);
              }), zP(jP(e), "onMouseUp", function (t) {
                return UP = LP, e.handleDragStop(t);
              }), zP(jP(e), "onTouchStart", function (t) {
                return UP = MP, e.handleDragStart(t);
              }), zP(jP(e), "onTouchEnd", function (t) {
                return UP = MP, e.handleDragStop(t);
              }), e;
            }

            return t = o, n = [{
              key: "componentDidMount",
              value: function value() {
                this.mounted = !0;
                var e = this.findDOMNode();
                e && (0, wP.addEvent)(e, MP.start, this.onTouchStart, {
                  passive: !1
                });
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this.mounted = !1;
                var e = this.findDOMNode();

                if (e) {
                  var t = e.ownerDocument;
                  (0, wP.removeEvent)(t, LP.move, this.handleDrag), (0, wP.removeEvent)(t, MP.move, this.handleDrag), (0, wP.removeEvent)(t, LP.stop, this.handleDragStop), (0, wP.removeEvent)(t, MP.stop, this.handleDragStop), (0, wP.removeEvent)(e, MP.start, this.onTouchStart, {
                    passive: !1
                  }), this.props.enableUserSelectHack && (0, wP.removeUserSelectStyles)(t);
                }
              }
            }, {
              key: "findDOMNode",
              value: function value() {
                var e, t, n;
                return null !== (e = this.props) && void 0 !== e && e.nodeRef ? null === (t = this.props) || void 0 === t || null === (n = t.nodeRef) || void 0 === n ? void 0 : n.current : yP.default.findDOMNode(this);
              }
            }, {
              key: "render",
              value: function value() {
                return vP.cloneElement(vP.Children.only(this.props.children), {
                  onMouseDown: this.onMouseDown,
                  onMouseUp: this.onMouseUp,
                  onTouchEnd: this.onTouchEnd
                });
              }
            }], n && OP(t.prototype, n), r && OP(t, r), Object.defineProperty(t, "prototype", {
              writable: !1
            }), o;
          }(vP.Component);

          fP.default = BP, zP(BP, "displayName", "DraggableCore"), zP(BP, "propTypes", {
            allowAnyClick: bP.default.bool,
            disabled: bP.default.bool,
            enableUserSelectHack: bP.default.bool,
            offsetParent: function offsetParent(e, t) {
              if (e[t] && 1 !== e[t].nodeType) throw new Error("Draggable's offsetParent must be a DOM Node.");
            },
            grid: bP.default.arrayOf(bP.default.number),
            handle: bP.default.string,
            cancel: bP.default.string,
            nodeRef: bP.default.object,
            onStart: bP.default.func,
            onDrag: bP.default.func,
            onStop: bP.default.func,
            onMouseDown: bP.default.func,
            scale: bP.default.number,
            className: xP.dontSetMe,
            style: xP.dontSetMe,
            transform: xP.dontSetMe
          }), zP(BP, "defaultProps", {
            allowAnyClick: !1,
            disabled: !1,
            enableUserSelectHack: !0,
            onStart: function onStart() {},
            onDrag: function onDrag() {},
            onStop: function onStop() {},
            onMouseDown: function onMouseDown() {},
            scale: 1
          }), function (e) {
            function t(e) {
              return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                return typeof e;
              } : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
              }, t(e);
            }

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), Object.defineProperty(e, "DraggableCore", {
              enumerable: !0,
              get: function get() {
                return u.default;
              }
            }), e.default = void 0;

            var n = function (e, n) {
              if (!n && e && e.__esModule) return e;
              if (null === e || "object" !== t(e) && "function" != typeof e) return {
                default: e
              };
              var r = f(n);
              if (r && r.has(e)) return r.get(e);
              var i = {},
                  o = Object.defineProperty && Object.getOwnPropertyDescriptor;

              for (var a in e) {
                if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
                  var s = o ? Object.getOwnPropertyDescriptor(e, a) : null;
                  s && (s.get || s.set) ? Object.defineProperty(i, a, s) : i[a] = e[a];
                }
              }

              return i.default = e, r && r.set(e, i), i;
            }(a.default),
                r = _(Oy.exports),
                i = _(l.default),
                o = _(WN),
                s = GN,
                c = uP,
                d = KN,
                u = _(fP),
                p = _(mP),
                h = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];

            function _(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            function f(e) {
              if ("function" != typeof WeakMap) return null;
              var t = new WeakMap(),
                  n = new WeakMap();
              return (f = function f(e) {
                return e ? n : t;
              })(e);
            }

            function m() {
              return m = Object.assign || function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];

                  for (var r in n) {
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                  }
                }

                return e;
              }, m.apply(this, arguments);
            }

            function g(e, t) {
              if (null == e) return {};

              var n,
                  r,
                  i = function (e, t) {
                if (null == e) return {};
                var n,
                    r,
                    i = {},
                    o = Object.keys(e);

                for (r = 0; r < o.length; r++) {
                  n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
                }

                return i;
              }(e, t);

              if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);

                for (r = 0; r < o.length; r++) {
                  n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
                }
              }

              return i;
            }

            function v(e, t) {
              var n = Object.keys(e);

              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
              }

              return n;
            }

            function b(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? v(Object(n), !0).forEach(function (t) {
                  I(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }

              return e;
            }

            function y(e, t) {
              return function (e) {
                if (Array.isArray(e)) return e;
              }(e) || function (e, t) {
                var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

                if (null != n) {
                  var r,
                      i,
                      o = [],
                      a = !0,
                      s = !1;

                  try {
                    for (n = n.call(e); !(a = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); a = !0) {
                      ;
                    }
                  } catch (e) {
                    s = !0, i = e;
                  } finally {
                    try {
                      a || null == n.return || n.return();
                    } finally {
                      if (s) throw i;
                    }
                  }

                  return o;
                }
              }(e, t) || function (e, t) {
                if (e) {
                  if ("string" == typeof e) return w(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? w(e, t) : void 0;
                }
              }(e, t) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }();
            }

            function w(e, t) {
              (null == t || t > e.length) && (t = e.length);

              for (var n = 0, r = new Array(t); n < t; n++) {
                r[n] = e[n];
              }

              return r;
            }

            function S(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
              }
            }

            function x(e, t) {
              return x = Object.setPrototypeOf || function (e, t) {
                return e.__proto__ = t, e;
              }, x(e, t);
            }

            function E(e) {
              var t = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;

                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }();

              return function () {
                var n,
                    r = A(e);

                if (t) {
                  var i = A(this).constructor;
                  n = Reflect.construct(r, arguments, i);
                } else n = r.apply(this, arguments);

                return C(this, n);
              };
            }

            function C(e, n) {
              if (n && ("object" === t(n) || "function" == typeof n)) return n;
              if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
              return k(e);
            }

            function k(e) {
              if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return e;
            }

            function A(e) {
              return A = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
                return e.__proto__ || Object.getPrototypeOf(e);
              }, A(e);
            }

            function I(e, t, n) {
              return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : e[t] = n, e;
            }

            var T = function (e) {
              !function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                  }
                }), Object.defineProperty(e, "prototype", {
                  writable: !1
                }), t && x(e, t);
              }(d, e);
              var t,
                  r,
                  a,
                  l = E(d);

              function d(e) {
                var t;
                return function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, d), I(k(t = l.call(this, e)), "onDragStart", function (e, n) {
                  if ((0, p.default)("Draggable: onDragStart: %j", n), !1 === t.props.onStart(e, (0, c.createDraggableData)(k(t), n))) return !1;
                  t.setState({
                    dragging: !0,
                    dragged: !0
                  });
                }), I(k(t), "onDrag", function (e, n) {
                  if (!t.state.dragging) return !1;
                  (0, p.default)("Draggable: onDrag: %j", n);
                  var r = (0, c.createDraggableData)(k(t), n),
                      i = {
                    x: r.x,
                    y: r.y
                  };

                  if (t.props.bounds) {
                    var o = i.x,
                        a = i.y;
                    i.x += t.state.slackX, i.y += t.state.slackY;
                    var s = y((0, c.getBoundPosition)(k(t), i.x, i.y), 2),
                        l = s[0],
                        d = s[1];
                    i.x = l, i.y = d, i.slackX = t.state.slackX + (o - i.x), i.slackY = t.state.slackY + (a - i.y), r.x = i.x, r.y = i.y, r.deltaX = i.x - t.state.x, r.deltaY = i.y - t.state.y;
                  }

                  if (!1 === t.props.onDrag(e, r)) return !1;
                  t.setState(i);
                }), I(k(t), "onDragStop", function (e, n) {
                  if (!t.state.dragging) return !1;
                  if (!1 === t.props.onStop(e, (0, c.createDraggableData)(k(t), n))) return !1;
                  (0, p.default)("Draggable: onDragStop: %j", n);
                  var r = {
                    dragging: !1,
                    slackX: 0,
                    slackY: 0
                  };

                  if (Boolean(t.props.position)) {
                    var i = t.props.position,
                        o = i.x,
                        a = i.y;
                    r.x = o, r.y = a;
                  }

                  t.setState(r);
                }), t.state = {
                  dragging: !1,
                  dragged: !1,
                  x: e.position ? e.position.x : e.defaultPosition.x,
                  y: e.position ? e.position.y : e.defaultPosition.y,
                  prevPropsPosition: b({}, e.position),
                  slackX: 0,
                  slackY: 0,
                  isElementSVG: !1
                }, !e.position || e.onDrag || e.onStop || console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element."), t;
              }

              return t = d, r = [{
                key: "componentDidMount",
                value: function value() {
                  void 0 !== window.SVGElement && this.findDOMNode() instanceof window.SVGElement && this.setState({
                    isElementSVG: !0
                  });
                }
              }, {
                key: "componentWillUnmount",
                value: function value() {
                  this.setState({
                    dragging: !1
                  });
                }
              }, {
                key: "findDOMNode",
                value: function value() {
                  var e, t, n;
                  return null !== (e = null === (t = this.props) || void 0 === t || null === (n = t.nodeRef) || void 0 === n ? void 0 : n.current) && void 0 !== e ? e : i.default.findDOMNode(this);
                }
              }, {
                key: "render",
                value: function value() {
                  var e,
                      t = this.props;
                  t.axis, t.bounds;
                  var r = t.children,
                      i = t.defaultPosition,
                      a = t.defaultClassName,
                      l = t.defaultClassNameDragging,
                      d = t.defaultClassNameDragged,
                      p = t.position,
                      _ = t.positionOffset;
                  t.scale;
                  var f = g(t, h),
                      v = {},
                      y = null,
                      w = !Boolean(p) || this.state.dragging,
                      S = p || i,
                      x = {
                    x: (0, c.canDragX)(this) && w ? this.state.x : S.x,
                    y: (0, c.canDragY)(this) && w ? this.state.y : S.y
                  };
                  this.state.isElementSVG ? y = (0, s.createSVGTransform)(x, _) : v = (0, s.createCSSTransform)(x, _);
                  var E = (0, o.default)(r.props.className || "", a, (I(e = {}, l, this.state.dragging), I(e, d, this.state.dragged), e));
                  return n.createElement(u.default, m({}, f, {
                    onStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onStop: this.onDragStop
                  }), n.cloneElement(n.Children.only(r), {
                    className: E,
                    style: b(b({}, r.props.style), v),
                    transform: y
                  }));
                }
              }], a = [{
                key: "getDerivedStateFromProps",
                value: function value(e, t) {
                  var n = e.position,
                      r = t.prevPropsPosition;
                  return !n || r && n.x === r.x && n.y === r.y ? null : ((0, p.default)("Draggable: getDerivedStateFromProps %j", {
                    position: n,
                    prevPropsPosition: r
                  }), {
                    x: n.x,
                    y: n.y,
                    prevPropsPosition: b({}, n)
                  });
                }
              }], r && S(t.prototype, r), a && S(t, a), Object.defineProperty(t, "prototype", {
                writable: !1
              }), d;
            }(n.Component);

            e.default = T, I(T, "displayName", "Draggable"), I(T, "propTypes", b(b({}, u.default.propTypes), {}, {
              axis: r.default.oneOf(["both", "x", "y", "none"]),
              bounds: r.default.oneOfType([r.default.shape({
                left: r.default.number,
                right: r.default.number,
                top: r.default.number,
                bottom: r.default.number
              }), r.default.string, r.default.oneOf([!1])]),
              defaultClassName: r.default.string,
              defaultClassNameDragging: r.default.string,
              defaultClassNameDragged: r.default.string,
              defaultPosition: r.default.shape({
                x: r.default.number,
                y: r.default.number
              }),
              positionOffset: r.default.shape({
                x: r.default.oneOfType([r.default.number, r.default.string]),
                y: r.default.oneOfType([r.default.number, r.default.string])
              }),
              position: r.default.shape({
                x: r.default.number,
                y: r.default.number
              }),
              className: d.dontSetMe,
              style: d.dontSetMe,
              transform: d.dontSetMe
            })), I(T, "defaultProps", b(b({}, u.default.defaultProps), {}, {
              axis: "both",
              bounds: !1,
              defaultClassName: "react-draggable",
              defaultClassNameDragging: "react-draggable-dragging",
              defaultClassNameDragged: "react-draggable-dragged",
              defaultPosition: {
                x: 0,
                y: 0
              },
              scale: 1
            }));
          }(FN);
          var HP = FN.default,
              VP = FN.DraggableCore;
          qN.exports = HP, qN.exports.default = HP, qN.exports.DraggableCore = VP;
          var qP = qN.exports;

          function FP(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          function WP() {
            return WP = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, WP.apply(this, arguments);
          }

          function GP(e, t) {
            if (null == e) return {};
            var n,
                r,
                i = {},
                o = Object.keys(e);

            for (r = 0; r < o.length; r++) {
              n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            }

            return i;
          }

          var KP = a.default.createContext(),
              QP = {
            root: {},
            anchorOriginTopCenter: {},
            anchorOriginBottomCenter: {},
            anchorOriginTopRight: {},
            anchorOriginBottomRight: {},
            anchorOriginTopLeft: {},
            anchorOriginBottomLeft: {}
          },
              ZP = {
            containerRoot: {},
            containerAnchorOriginTopCenter: {},
            containerAnchorOriginBottomCenter: {},
            containerAnchorOriginTopRight: {},
            containerAnchorOriginBottomRight: {},
            containerAnchorOriginTopLeft: {},
            containerAnchorOriginBottomLeft: {}
          },
              YP = {
            default: 20,
            dense: 4
          },
              JP = {
            default: 6,
            dense: 2
          },
              $P = {
            maxSnack: 3,
            dense: !1,
            hideIconVariant: !1,
            variant: "default",
            autoHideDuration: 5e3,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            TransitionComponent: KI,
            transitionDuration: {
              enter: 225,
              exit: 195
            }
          },
              XP = function XP(e) {
            return e.charAt(0).toUpperCase() + e.slice(1);
          },
              ej = function ej(e) {
            return Object.keys(e).filter(function (e) {
              return !ZP[e];
            }).reduce(function (t, n) {
              var r;
              return WP({}, t, ((r = {})[n] = e[n], r));
            }, {});
          },
              tj = {
            TIMEOUT: "timeout",
            CLICKAWAY: "clickaway",
            MAXSNACK: "maxsnack",
            INSTRUCTED: "instructed"
          },
              nj = function nj(e) {
            return "containerAnchorOrigin" + e;
          },
              rj = function rj(e) {
            var t = e.vertical,
                n = e.horizontal;
            return "anchorOrigin" + XP(t) + XP(n);
          },
              ij = function ij(e) {
            return "variant" + XP(e);
          },
              oj = function oj(e) {
            return !!e || 0 === e;
          },
              aj = function aj(e) {
            return "number" == typeof e || null === e;
          };

          function sj(e, t, n) {
            return void 0 === e && (e = {}), void 0 === t && (t = {}), void 0 === n && (n = {}), WP({}, n, {}, t, {}, e);
          }

          var cj = function cj(e) {
            var t;
            return {
              root: (t = {
                display: "flex",
                flexWrap: "wrap",
                flexGrow: 1
              }, t[e.breakpoints.up("sm")] = {
                flexGrow: "initial",
                minWidth: 288
              }, t)
            };
          },
              lj = e.forwardRef(function (e, t) {
            var n = e.classes,
                r = e.className,
                i = GP(e, ["classes", "className"]);
            return a.default.createElement("div", Object.assign({
              ref: t,
              className: VC(n.root, r)
            }, i));
          }),
              dj = Pk(cj)(lj),
              uj = {
            right: "left",
            left: "right",
            bottom: "up",
            top: "down"
          },
              pj = function pj(e) {
            return "center" !== e.horizontal ? uj[e.horizontal] : uj[e.vertical];
          },
              hj = function hj(e) {
            return a.default.createElement(Mk, Object.assign({}, e), a.default.createElement("path", {
              d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
            }));
          },
              _j = function _j(e) {
            return a.default.createElement(Mk, Object.assign({}, e), a.default.createElement("path", {
              d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
            }));
          },
              fj = function fj(e) {
            return a.default.createElement(Mk, Object.assign({}, e), a.default.createElement("path", {
              d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
            }));
          },
              mj = function mj(e) {
            return a.default.createElement(Mk, Object.assign({}, e), a.default.createElement("path", {
              d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
            }));
          },
              gj = {
            fontSize: 20,
            marginInlineEnd: 8
          },
              vj = {
            default: void 0,
            success: a.default.createElement(hj, {
              style: gj
            }),
            warning: a.default.createElement(_j, {
              style: gj
            }),
            error: a.default.createElement(fj, {
              style: gj
            }),
            info: a.default.createElement(mj, {
              style: gj
            })
          };

          function bj(e, t) {
            return e.reduce(function (e, n) {
              return null == n ? e : function () {
                for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
                  i[o] = arguments[o];
                }

                var a = [].concat(i);
                t && -1 === a.indexOf(t) && a.push(t), e.apply(this, a), n.apply(this, a);
              };
            }, function () {});
          }

          var yj = "undefined" != typeof window ? e.useLayoutEffect : e.useEffect;

          function wj(t) {
            var n = e.useRef(t);
            return yj(function () {
              n.current = t;
            }), e.useCallback(function () {
              return n.current.apply(void 0, arguments);
            }, []);
          }

          var Sj = e.forwardRef(function (t, n) {
            var r = t.children,
                i = t.autoHideDuration,
                o = t.ClickAwayListenerProps,
                a = t.disableWindowBlurListener,
                s = void 0 !== a && a,
                c = t.onClose,
                l = t.onMouseEnter,
                d = t.onMouseLeave,
                u = t.open,
                p = t.resumeHideDuration,
                h = GP(t, ["children", "autoHideDuration", "ClickAwayListenerProps", "disableWindowBlurListener", "onClose", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration"]),
                _ = e.useRef(),
                f = wj(function () {
              c && c.apply(void 0, arguments);
            }),
                m = wj(function (e) {
              c && null != e && (clearTimeout(_.current), _.current = setTimeout(function () {
                f(null, tj.TIMEOUT);
              }, e));
            });

            e.useEffect(function () {
              return u && m(i), function () {
                clearTimeout(_.current);
              };
            }, [u, i, m]);

            var g = function g() {
              clearTimeout(_.current);
            },
                v = e.useCallback(function () {
              null != i && m(null != p ? p : .5 * i);
            }, [i, p, m]);

            return e.useEffect(function () {
              if (!s && u) return window.addEventListener("focus", v), window.addEventListener("blur", g), function () {
                window.removeEventListener("focus", v), window.removeEventListener("blur", g);
              };
            }, [s, v, u]), e.createElement(fI, WP({
              onClickAway: function onClickAway(e) {
                c && c(e, tj.CLICKAWAY);
              }
            }, o), e.createElement("div", WP({
              onMouseEnter: function onMouseEnter(e) {
                l && l(e), g();
              },
              onMouseLeave: function onMouseLeave(e) {
                d && d(e), v();
              },
              ref: n
            }, h), r));
          }),
              xj = function xj(e) {
            var t = e.palette.mode || e.palette.type,
                n = function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .15;
              return _w(e) > .5 ? mw(e, t) : gw(e, t);
            }(e.palette.background.default, "light" === t ? .8 : .98);

            return WP({}, QP, {
              contentRoot: WP({}, e.typography.body2, {
                backgroundColor: n,
                color: e.palette.getContrastText(n),
                alignItems: "center",
                padding: "6px 16px",
                borderRadius: "4px",
                boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
              }),
              lessPadding: {
                paddingLeft: 20
              },
              variantSuccess: {
                backgroundColor: "#43a047",
                color: "#fff"
              },
              variantError: {
                backgroundColor: "#d32f2f",
                color: "#fff"
              },
              variantInfo: {
                backgroundColor: "#2196f3",
                color: "#fff"
              },
              variantWarning: {
                backgroundColor: "#ff9800",
                color: "#fff"
              },
              message: {
                display: "flex",
                alignItems: "center",
                padding: "8px 0"
              },
              action: {
                display: "flex",
                alignItems: "center",
                marginLeft: "auto",
                paddingLeft: 16,
                marginRight: -8
              },
              wrappedRoot: {
                position: "relative",
                transform: "translateX(0)",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            });
          },
              Ej = function Ej(t) {
            var n = t.classes,
                r = GP(t, ["classes"]),
                i = e.useRef(),
                o = e.useState(!0),
                s = o[0],
                c = o[1];
            e.useEffect(function () {
              return function () {
                i.current && clearTimeout(i.current);
              };
            }, []);
            var l = bj([r.snack.onClose, r.onClose], r.snack.key),
                d = r.style,
                u = r.ariaAttributes,
                p = r.className,
                h = r.hideIconVariant,
                _ = r.iconVariant,
                f = r.snack,
                m = r.action,
                g = r.content,
                v = r.TransitionComponent,
                b = r.TransitionProps,
                y = r.transitionDuration,
                w = GP(r, ["style", "dense", "ariaAttributes", "className", "hideIconVariant", "iconVariant", "snack", "action", "content", "TransitionComponent", "TransitionProps", "transitionDuration", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting"]),
                S = f.key,
                x = f.open,
                E = f.className,
                C = f.variant,
                k = f.content,
                A = f.action,
                I = f.ariaAttributes,
                T = f.anchorOrigin,
                O = f.message,
                R = f.TransitionComponent,
                N = f.TransitionProps,
                P = f.transitionDuration,
                j = GP(f, ["persist", "key", "open", "entered", "requestClose", "className", "variant", "content", "action", "ariaAttributes", "anchorOrigin", "message", "TransitionComponent", "TransitionProps", "transitionDuration", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting"]),
                D = WP({}, vj, {}, _)[C],
                z = WP({
              "aria-describedby": "notistack-snackbar"
            }, sj(I, u)),
                M = R || v || $P.TransitionComponent,
                L = sj(P, y, $P.transitionDuration),
                U = WP({
              direction: pj(T)
            }, sj(N, b)),
                B = A || m;
            "function" == typeof B && (B = B(S));
            var H = k || g;
            "function" == typeof H && (H = H(S, f.message));
            var V = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"].reduce(function (e, t) {
              var n;
              return WP({}, e, ((n = {})[t] = bj([r.snack[t], r[t]], r.snack.key), n));
            }, {});
            return a.default.createElement(EA, {
              unmountOnExit: !0,
              timeout: 175,
              in: s,
              onExited: V.onExited
            }, a.default.createElement(Sj, Object.assign({}, w, j, {
              open: x,
              className: VC(n.root, n.wrappedRoot, n[rj(T)]),
              onClose: l
            }), a.default.createElement(M, Object.assign({
              appear: !0,
              in: x,
              timeout: L
            }, U, {
              onExit: V.onExit,
              onExiting: V.onExiting,
              onExited: function onExited() {
                i.current = setTimeout(function () {
                  c(!s);
                }, 125);
              },
              onEnter: V.onEnter,
              onEntering: V.onEntering,
              onEntered: bj([V.onEntered, function () {
                r.snack.requestClose && l(null, tj.INSTRCUTED);
              }])
            }), H || a.default.createElement(dj, Object.assign({}, z, {
              role: "alert",
              style: d,
              className: VC(n.contentRoot, n[ij(C)], p, E, !h && D && n.lessPadding)
            }), a.default.createElement("div", {
              id: z["aria-describedby"],
              className: n.message
            }, h ? null : D, O), B && a.default.createElement("div", {
              className: n.action
            }, B)))));
          },
              Cj = Pk(xj)(Ej),
              kj = "& > .MuiCollapse-container, & > .MuiCollapse-root",
              Aj = "& > .MuiCollapse-container > .MuiCollapse-wrapper, & > .MuiCollapse-root > .MuiCollapse-wrapper",
              Ij = Ok(function (e) {
            var t, n, r, i, o;
            return {
              root: (t = {
                boxSizing: "border-box",
                display: "flex",
                maxHeight: "100%",
                position: "fixed",
                zIndex: e.zIndex.snackbar,
                height: "auto",
                width: "auto",
                transition: "top 300ms ease 0ms, right 300ms ease 0ms, bottom 300ms ease 0ms, left 300ms ease 0ms, margin 300ms ease 0ms, max-width 300ms ease 0ms",
                pointerEvents: "none"
              }, t[kj] = {
                pointerEvents: "all"
              }, t[Aj] = {
                padding: JP.default + "px 0px",
                transition: "padding 300ms ease 0ms"
              }, t.maxWidth = "calc(100% - " + 2 * YP.default + "px)", t[e.breakpoints.down("xs")] = {
                width: "100%",
                maxWidth: "calc(100% - 32px)"
              }, t),
              rootDense: (n = {}, n[Aj] = {
                padding: JP.dense + "px 0px"
              }, n),
              top: {
                top: YP.default - JP.default,
                flexDirection: "column"
              },
              bottom: {
                bottom: YP.default - JP.default,
                flexDirection: "column-reverse"
              },
              left: (r = {
                left: YP.default
              }, r[e.breakpoints.up("sm")] = {
                alignItems: "flex-start"
              }, r[e.breakpoints.down("xs")] = {
                left: "16px"
              }, r),
              right: (i = {
                right: YP.default
              }, i[e.breakpoints.up("sm")] = {
                alignItems: "flex-end"
              }, i[e.breakpoints.down("xs")] = {
                right: "16px"
              }, i),
              center: (o = {
                left: "50%",
                transform: "translateX(-50%)"
              }, o[e.breakpoints.up("sm")] = {
                alignItems: "center"
              }, o)
            };
          }),
              Tj = function Tj(e) {
            var t = Ij(),
                n = e.className,
                r = e.anchorOrigin,
                i = e.dense,
                o = GP(e, ["className", "anchorOrigin", "dense"]),
                s = VC(t[r.vertical], t[r.horizontal], t.root, n, i && t.rootDense);
            return a.default.createElement("div", Object.assign({
              className: s
            }, o));
          },
              Oj = a.default.memo(Tj),
              Rj = function (e) {
            var n, r, i, o, s;

            function c(t) {
              var n;
              return (n = e.call(this, t) || this).enqueueSnackbar = function (e, t) {
                void 0 === t && (t = {});

                var r = t,
                    i = r.key,
                    o = r.preventDuplicate,
                    a = GP(r, ["key", "preventDuplicate"]),
                    s = oj(i),
                    c = s ? i : new Date().getTime() + Math.random(),
                    l = function (e, t, n) {
                  return function (r) {
                    return "autoHideDuration" === r ? aj(e.autoHideDuration) ? e.autoHideDuration : aj(t.autoHideDuration) ? t.autoHideDuration : $P.autoHideDuration : e[r] || t[r] || n[r];
                  };
                }(a, n.props, $P),
                    d = WP({
                  key: c
                }, a, {
                  message: e,
                  open: !0,
                  entered: !1,
                  requestClose: !1,
                  variant: l("variant"),
                  anchorOrigin: l("anchorOrigin"),
                  autoHideDuration: l("autoHideDuration")
                });

                return a.persist && (d.autoHideDuration = void 0), n.setState(function (t) {
                  if (void 0 === o && n.props.preventDuplicate || o) {
                    var r = function r(t) {
                      return s ? t.key === i : t.message === e;
                    },
                        a = t.queue.findIndex(r) > -1,
                        c = t.snacks.findIndex(r) > -1;

                    if (a || c) return t;
                  }

                  return n.handleDisplaySnack(WP({}, t, {
                    queue: [].concat(t.queue, [d])
                  }));
                }), c;
              }, n.handleDisplaySnack = function (e) {
                return e.snacks.length >= n.maxSnack ? n.handleDismissOldest(e) : n.processQueue(e);
              }, n.processQueue = function (e) {
                var t = e.queue,
                    n = e.snacks;
                return t.length > 0 ? WP({}, e, {
                  snacks: [].concat(n, [t[0]]),
                  queue: t.slice(1, t.length)
                }) : e;
              }, n.handleDismissOldest = function (e) {
                if (e.snacks.some(function (e) {
                  return !e.open || e.requestClose;
                })) return e;
                var t = !1,
                    r = !1;
                e.snacks.reduce(function (e, t) {
                  return e + (t.open && t.persist ? 1 : 0);
                }, 0) === n.maxSnack && (r = !0);
                var i = e.snacks.map(function (e) {
                  return t || e.persist && !r ? WP({}, e) : (t = !0, e.entered ? (e.onClose && e.onClose(null, tj.MAXSNACK, e.key), n.props.onClose && n.props.onClose(null, tj.MAXSNACK, e.key), WP({}, e, {
                    open: !1
                  })) : WP({}, e, {
                    requestClose: !0
                  }));
                });
                return WP({}, e, {
                  snacks: i
                });
              }, n.handleEnteredSnack = function (e, t, r) {
                if (!oj(r)) throw new Error("handleEnteredSnack Cannot be called with undefined key");
                n.setState(function (e) {
                  return {
                    snacks: e.snacks.map(function (e) {
                      return e.key === r ? WP({}, e, {
                        entered: !0
                      }) : WP({}, e);
                    })
                  };
                });
              }, n.handleCloseSnack = function (e, t, r) {
                if (n.props.onClose && n.props.onClose(e, t, r), t !== tj.CLICKAWAY) {
                  var i = void 0 === r;
                  n.setState(function (e) {
                    var t = e.snacks,
                        n = e.queue;
                    return {
                      snacks: t.map(function (e) {
                        return i || e.key === r ? e.entered ? WP({}, e, {
                          open: !1
                        }) : WP({}, e, {
                          requestClose: !0
                        }) : WP({}, e);
                      }),
                      queue: n.filter(function (e) {
                        return e.key !== r;
                      })
                    };
                  });
                }
              }, n.closeSnackbar = function (e) {
                var t = n.state.snacks.find(function (t) {
                  return t.key === e;
                });
                oj(e) && t && t.onClose && t.onClose(null, tj.INSTRUCTED, e), n.handleCloseSnack(null, tj.INSTRUCTED, e);
              }, n.handleExitedSnack = function (e, t, r) {
                var i = t || r;
                if (!oj(i)) throw new Error("handleExitedSnack Cannot be called with undefined key");
                n.setState(function (e) {
                  var t = n.processQueue(WP({}, e, {
                    snacks: e.snacks.filter(function (e) {
                      return e.key !== i;
                    })
                  }));
                  return 0 === t.queue.length ? t : n.handleDismissOldest(t);
                });
              }, n.state = {
                snacks: [],
                queue: [],
                contextValue: {
                  enqueueSnackbar: n.enqueueSnackbar,
                  closeSnackbar: n.closeSnackbar
                }
              }, n;
            }

            return r = e, (n = c).prototype = Object.create(r.prototype), n.prototype.constructor = n, n.__proto__ = r, c.prototype.render = function () {
              var e = this,
                  n = this.state.contextValue,
                  r = this.props,
                  i = r.iconVariant,
                  o = r.dense,
                  s = void 0 === o ? $P.dense : o,
                  c = r.hideIconVariant,
                  l = void 0 === c ? $P.hideIconVariant : c,
                  d = r.domRoot,
                  u = r.children,
                  p = r.classes,
                  h = void 0 === p ? {} : p,
                  _ = GP(r, ["maxSnack", "preventDuplicate", "variant", "anchorOrigin", "iconVariant", "dense", "hideIconVariant", "domRoot", "children", "classes"]),
                  f = this.state.snacks.reduce(function (e, t) {
                var n,
                    r,
                    i = (r = t.anchorOrigin, "" + XP(r.vertical) + XP(r.horizontal)),
                    o = e[i] || [];
                return WP({}, e, ((n = {})[i] = [].concat(o, [t]), n));
              }, {}),
                  m = Object.keys(f).map(function (t) {
                var n = f[t];
                return a.default.createElement(Oj, {
                  key: t,
                  dense: s,
                  anchorOrigin: n[0].anchorOrigin,
                  className: VC(h.containerRoot, h[nj(t)])
                }, n.map(function (t) {
                  return a.default.createElement(Cj, Object.assign({}, _, {
                    key: t.key,
                    snack: t,
                    dense: s,
                    iconVariant: i,
                    hideIconVariant: l,
                    classes: ej(h),
                    onClose: e.handleCloseSnack,
                    onExited: bj([e.handleExitedSnack, e.props.onExited]),
                    onEntered: bj([e.handleEnteredSnack, e.props.onEntered])
                  }));
                }));
              });

              return a.default.createElement(KP.Provider, {
                value: n
              }, u, d ? t.createPortal(m, d) : m);
            }, i = c, (o = [{
              key: "maxSnack",
              get: function get() {
                return this.props.maxSnack || $P.maxSnack;
              }
            }]) && FP(i.prototype, o), s && FP(i, s), c;
          }(e.Component),
              Nj = function Nj() {
            return e.useContext(KP);
          };

          var Pj = ES({
            mixins: {
              safelyFillAvailableWidth: {
                width: "100%; width: -moz-available; width: -webkit-fill-available; width: fill-available;"
              },
              safelyFillAvailableHeight: {
                height: "100%; height: -moz-available; height: -webkit-fill-available; height: fill-available;"
              },
              toolbar: {
                minHeight: 16
              }
            },
            palette: {
              type: "dark",
              background: {
                default: "rgba(0,0,0,0.8)",
                paper: "#242424"
              },
              primary: {
                main: "#0E71EB",
                contrastText: "rgba(255, 255, 255, 1)"
              },
              secondary: {
                main: "#DE2828",
                contrastText: "rgba(255, 255, 255, 1)"
              },
              text: {
                primary: "#f5f5f5",
                secondary: "rgba(255,255,255,0.8)"
              },
              action: {
                active: "rgba(255, 255, 255, 0.18)",
                hover: "rgba(255, 255, 255, 0.09)"
              },
              toolbar: {
                main: "rgba(255, 255, 255, 0.62)"
              }
            },
            typography: {
              fontFamily: ["-apple-system", "BlinkMacSystemFont", "sans-serif"].join(","),
              h1: {
                fontSize: "1.5rem",
                fontWeight: 700,
                fontStyle: "normal"
              },
              h3: {
                fontSize: "1rem",
                fontWeight: 700,
                fontStyle: "normal"
              },
              h6: {
                fontSize: "0.813rem",
                fontWeight: 700,
                fontStyle: "normal"
              },
              body1: {
                fontFamily: ["Inter", "-apple-system", "BlinkMacSystemFont", "sans-serif"].join(","),
                fontSize: "0.75rem",
                fontWeight: 400,
                fontStyle: "normal"
              },
              subtitle1: {
                fontSize: "0.5rem",
                fontWeight: 500,
                fontStyle: "normal"
              },
              button: {
                fontSize: "0.813rem",
                textTransform: "none"
              }
            },
            shape: {
              borderRadius: 10
            },
            spacing: 4,
            props: {
              MuiButton: {
                disableElevation: !0
              },
              MuiButtonBase: {
                disableRipple: !0
              }
            },
            overrides: {
              MuiButtonBase: {
                root: {
                  "&$focusVisible": {
                    border: "1px solid rgba(255, 255, 255, 1)"
                  },
                  "&:active": {
                    filter: "brightness(0.8)"
                  }
                }
              },
              MuiButton: {
                root: {
                  borderRadius: 6
                },
                contained: {
                  backgroundColor: "rgba(255, 255, 255, 0.09)",
                  color: "rgba(255, 255, 255, 1)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.18)"
                  }
                },
                containedSizeSmall: {
                  padding: "2px 12px"
                },
                outlinedSizeSmall: {
                  padding: "2px 12px"
                }
              },
              MuiMenu: {
                paper: {
                  borderRadius: 8,
                  marginTop: 4
                }
              }
            }
          });
          var jj, Dj, zj;

          function Mj(t) {
            e.useEffect(function () {
              t();
            }, []);
          }

          !function (e) {
            e.Closed = "closed", e.Connected = "connected", e.Reconnecting = "reconnecting", e.Fail = "fail";
          }(jj || (jj = {})), function (e) {
            e.Connected = "Connected", e.Reconnecting = "Reconnecting", e.Closed = "Closed", e.Fail = "Fail";
          }(Dj || (Dj = {})), function (e) {
            e.Recording = "Recording", e.Paused = "Paused", e.Stopped = "Stopped";
          }(zj || (zj = {}));
          var Lj = {
            exports: {}
          };
          !function (e, t) {
            e.exports = function e(t, n, r) {
              function i(a, s) {
                if (!n[a]) {
                  if (!t[a]) {
                    if (!s && Ty) return Ty(a);
                    if (o) return o(a, !0);
                    var c = new Error("Cannot find module '" + a + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                  }

                  var l = n[a] = {
                    exports: {}
                  };
                  t[a][0].call(l.exports, function (e) {
                    return i(t[a][1][e] || e);
                  }, l, l.exports, e, t, n, r);
                }

                return n[a].exports;
              }

              for (var o = Ty, a = 0; a < r.length; a++) {
                i(r[a]);
              }

              return i;
            }({
              1: [function (e, t, n) {
                (function (i) {
                  !function (e) {
                    "object" == typeof n && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                  }(function () {
                    return function t(n, r, i) {
                      function o(s, c) {
                        if (!r[s]) {
                          if (!n[s]) {
                            var l = "function" == typeof e && e;
                            if (!c && l) return l(s, !0);
                            if (a) return a(s, !0);
                            var d = new Error("Cannot find module '" + s + "'");
                            throw d.code = "MODULE_NOT_FOUND", d;
                          }

                          var u = r[s] = {
                            exports: {}
                          };
                          n[s][0].call(u.exports, function (e) {
                            return o(n[s][1][e] || e);
                          }, u, u.exports, t, n, r, i);
                        }

                        return r[s].exports;
                      }

                      for (var a = "function" == typeof e && e, s = 0; s < i.length; s++) {
                        o(i[s]);
                      }

                      return o;
                    }({
                      1: [function (e, t, n) {
                        (function (i) {
                          !function (e) {
                            "object" == typeof n && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                          }(function () {
                            return function t(n, r, i) {
                              function o(s, c) {
                                if (!r[s]) {
                                  if (!n[s]) {
                                    var l = "function" == typeof e && e;
                                    if (!c && l) return l(s, !0);
                                    if (a) return a(s, !0);
                                    var d = new Error("Cannot find module '" + s + "'");
                                    throw d.code = "MODULE_NOT_FOUND", d;
                                  }

                                  var u = r[s] = {
                                    exports: {}
                                  };
                                  n[s][0].call(u.exports, function (e) {
                                    return o(n[s][1][e] || e);
                                  }, u, u.exports, t, n, r, i);
                                }

                                return r[s].exports;
                              }

                              for (var a = "function" == typeof e && e, s = 0; s < i.length; s++) {
                                o(i[s]);
                              }

                              return o;
                            }({
                              1: [function (e, t, n) {
                                (function (i) {
                                  !function (e) {
                                    "object" == typeof n && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                                  }(function () {
                                    return function t(n, r, i) {
                                      function o(s, c) {
                                        if (!r[s]) {
                                          if (!n[s]) {
                                            var l = "function" == typeof e && e;
                                            if (!c && l) return l(s, !0);
                                            if (a) return a(s, !0);
                                            var d = new Error("Cannot find module '" + s + "'");
                                            throw d.code = "MODULE_NOT_FOUND", d;
                                          }

                                          var u = r[s] = {
                                            exports: {}
                                          };
                                          n[s][0].call(u.exports, function (e) {
                                            return o(n[s][1][e] || e);
                                          }, u, u.exports, t, n, r, i);
                                        }

                                        return r[s].exports;
                                      }

                                      for (var a = "function" == typeof e && e, s = 0; s < i.length; s++) {
                                        o(i[s]);
                                      }

                                      return o;
                                    }({
                                      1: [function (e, t, n) {
                                        (function (i) {
                                          !function (e) {
                                            "object" == typeof n && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                                          }(function () {
                                            return function t(n, r, i) {
                                              function o(s, c) {
                                                if (!r[s]) {
                                                  if (!n[s]) {
                                                    var l = "function" == typeof e && e;
                                                    if (!c && l) return l(s, !0);
                                                    if (a) return a(s, !0);
                                                    var d = new Error("Cannot find module '" + s + "'");
                                                    throw d.code = "MODULE_NOT_FOUND", d;
                                                  }

                                                  var u = r[s] = {
                                                    exports: {}
                                                  };
                                                  n[s][0].call(u.exports, function (e) {
                                                    return o(n[s][1][e] || e);
                                                  }, u, u.exports, t, n, r, i);
                                                }

                                                return r[s].exports;
                                              }

                                              for (var a = "function" == typeof e && e, s = 0; s < i.length; s++) {
                                                o(i[s]);
                                              }

                                              return o;
                                            }({
                                              1: [function (e, t, n) {
                                                (function (i) {
                                                  !function (e) {
                                                    "object" == typeof n && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                                                  }(function () {
                                                    return function t(n, r, i) {
                                                      function o(s, c) {
                                                        if (!r[s]) {
                                                          if (!n[s]) {
                                                            var l = "function" == typeof e && e;
                                                            if (!c && l) return l(s, !0);
                                                            if (a) return a(s, !0);
                                                            var d = new Error("Cannot find module '" + s + "'");
                                                            throw d.code = "MODULE_NOT_FOUND", d;
                                                          }

                                                          var u = r[s] = {
                                                            exports: {}
                                                          };
                                                          n[s][0].call(u.exports, function (e) {
                                                            return o(n[s][1][e] || e);
                                                          }, u, u.exports, t, n, r, i);
                                                        }

                                                        return r[s].exports;
                                                      }

                                                      for (var a = "function" == typeof e && e, s = 0; s < i.length; s++) {
                                                        o(i[s]);
                                                      }

                                                      return o;
                                                    }({
                                                      1: [function (e, t, n) {
                                                        var r = e("./utils"),
                                                            i = e("./support"),
                                                            o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                                                        n.encode = function (e) {
                                                          for (var t, n, i, a, s, c, l, d = [], u = 0, p = e.length, h = p, _ = "string" !== r.getTypeOf(e); u < e.length;) {
                                                            h = p - u, i = _ ? (t = e[u++], n = u < p ? e[u++] : 0, u < p ? e[u++] : 0) : (t = e.charCodeAt(u++), n = u < p ? e.charCodeAt(u++) : 0, u < p ? e.charCodeAt(u++) : 0), a = t >> 2, s = (3 & t) << 4 | n >> 4, c = 1 < h ? (15 & n) << 2 | i >> 6 : 64, l = 2 < h ? 63 & i : 64, d.push(o.charAt(a) + o.charAt(s) + o.charAt(c) + o.charAt(l));
                                                          }

                                                          return d.join("");
                                                        }, n.decode = function (e) {
                                                          var t,
                                                              n,
                                                              r,
                                                              a,
                                                              s,
                                                              c,
                                                              l = 0,
                                                              d = 0;
                                                          if ("data:" === e.substr(0, "data:".length)) throw new Error("Invalid base64 input, it looks like a data url.");
                                                          var u,
                                                              p = 3 * (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "")).length / 4;
                                                          if (e.charAt(e.length - 1) === o.charAt(64) && p--, e.charAt(e.length - 2) === o.charAt(64) && p--, p % 1 != 0) throw new Error("Invalid base64 input, bad content length.");

                                                          for (u = i.uint8array ? new Uint8Array(0 | p) : new Array(0 | p); l < e.length;) {
                                                            t = o.indexOf(e.charAt(l++)) << 2 | (a = o.indexOf(e.charAt(l++))) >> 4, n = (15 & a) << 4 | (s = o.indexOf(e.charAt(l++))) >> 2, r = (3 & s) << 6 | (c = o.indexOf(e.charAt(l++))), u[d++] = t, 64 !== s && (u[d++] = n), 64 !== c && (u[d++] = r);
                                                          }

                                                          return u;
                                                        };
                                                      }, {
                                                        "./support": 30,
                                                        "./utils": 32
                                                      }],
                                                      2: [function (e, t, n) {
                                                        var r = e("./external"),
                                                            i = e("./stream/DataWorker"),
                                                            o = e("./stream/Crc32Probe"),
                                                            a = e("./stream/DataLengthProbe");

                                                        function s(e, t, n, r, i) {
                                                          this.compressedSize = e, this.uncompressedSize = t, this.crc32 = n, this.compression = r, this.compressedContent = i;
                                                        }

                                                        s.prototype = {
                                                          getContentWorker: function getContentWorker() {
                                                            var e = new i(r.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),
                                                                t = this;
                                                            return e.on("end", function () {
                                                              if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                                            }), e;
                                                          },
                                                          getCompressedWorker: function getCompressedWorker() {
                                                            return new i(r.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                                          }
                                                        }, s.createWorkerFrom = function (e, t, n) {
                                                          return e.pipe(new o()).pipe(new a("uncompressedSize")).pipe(t.compressWorker(n)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                                                        }, t.exports = s;
                                                      }, {
                                                        "./external": 6,
                                                        "./stream/Crc32Probe": 25,
                                                        "./stream/DataLengthProbe": 26,
                                                        "./stream/DataWorker": 27
                                                      }],
                                                      3: [function (e, t, n) {
                                                        var r = e("./stream/GenericWorker");
                                                        n.STORE = {
                                                          magic: "\0\0",
                                                          compressWorker: function compressWorker(e) {
                                                            return new r("STORE compression");
                                                          },
                                                          uncompressWorker: function uncompressWorker() {
                                                            return new r("STORE decompression");
                                                          }
                                                        }, n.DEFLATE = e("./flate");
                                                      }, {
                                                        "./flate": 7,
                                                        "./stream/GenericWorker": 28
                                                      }],
                                                      4: [function (e, t, n) {
                                                        var r = e("./utils"),
                                                            i = function () {
                                                          for (var e, t = [], n = 0; n < 256; n++) {
                                                            e = n;

                                                            for (var r = 0; r < 8; r++) {
                                                              e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                            }

                                                            t[n] = e;
                                                          }

                                                          return t;
                                                        }();

                                                        t.exports = function (e, t) {
                                                          return void 0 !== e && e.length ? "string" !== r.getTypeOf(e) ? function (e, t, n) {
                                                            var r = i,
                                                                o = 0 + n;
                                                            e ^= -1;

                                                            for (var a = 0; a < o; a++) {
                                                              e = e >>> 8 ^ r[255 & (e ^ t[a])];
                                                            }

                                                            return -1 ^ e;
                                                          }(0 | t, e, e.length) : function (e, t, n) {
                                                            var r = i,
                                                                o = 0 + n;
                                                            e ^= -1;

                                                            for (var a = 0; a < o; a++) {
                                                              e = e >>> 8 ^ r[255 & (e ^ t.charCodeAt(a))];
                                                            }

                                                            return -1 ^ e;
                                                          }(0 | t, e, e.length) : 0;
                                                        };
                                                      }, {
                                                        "./utils": 32
                                                      }],
                                                      5: [function (e, t, n) {
                                                        n.base64 = !1, n.binary = !1, n.dir = !1, n.createFolders = !0, n.date = null, n.compression = null, n.compressionOptions = null, n.comment = null, n.unixPermissions = null, n.dosPermissions = null;
                                                      }, {}],
                                                      6: [function (e, t, n) {
                                                        var r;
                                                        r = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                                                          Promise: r
                                                        };
                                                      }, {
                                                        lie: 37
                                                      }],
                                                      7: [function (e, t, n) {
                                                        var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array,
                                                            i = e("pako"),
                                                            o = e("./utils"),
                                                            a = e("./stream/GenericWorker"),
                                                            s = r ? "uint8array" : "array";

                                                        function c(e, t) {
                                                          a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                                                        }

                                                        n.magic = "\b\0", o.inherits(c, a), c.prototype.processChunk = function (e) {
                                                          this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(o.transformTo(s, e.data), !1);
                                                        }, c.prototype.flush = function () {
                                                          a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                                                        }, c.prototype.cleanUp = function () {
                                                          a.prototype.cleanUp.call(this), this._pako = null;
                                                        }, c.prototype._createPako = function () {
                                                          this._pako = new i[this._pakoAction]({
                                                            raw: !0,
                                                            level: this._pakoOptions.level || -1
                                                          });
                                                          var e = this;

                                                          this._pako.onData = function (t) {
                                                            e.push({
                                                              data: t,
                                                              meta: e.meta
                                                            });
                                                          };
                                                        }, n.compressWorker = function (e) {
                                                          return new c("Deflate", e);
                                                        }, n.uncompressWorker = function () {
                                                          return new c("Inflate", {});
                                                        };
                                                      }, {
                                                        "./stream/GenericWorker": 28,
                                                        "./utils": 32,
                                                        pako: 38
                                                      }],
                                                      8: [function (e, t, n) {
                                                        function r(e, t) {
                                                          var n,
                                                              r = "";

                                                          for (n = 0; n < t; n++) {
                                                            r += String.fromCharCode(255 & e), e >>>= 8;
                                                          }

                                                          return r;
                                                        }

                                                        function i(e, t, n, i, a, d) {
                                                          var u,
                                                              p,
                                                              h = e.file,
                                                              _ = e.compression,
                                                              f = d !== s.utf8encode,
                                                              m = o.transformTo("string", d(h.name)),
                                                              g = o.transformTo("string", s.utf8encode(h.name)),
                                                              v = h.comment,
                                                              b = o.transformTo("string", d(v)),
                                                              y = o.transformTo("string", s.utf8encode(v)),
                                                              w = g.length !== h.name.length,
                                                              S = y.length !== v.length,
                                                              x = "",
                                                              E = "",
                                                              C = "",
                                                              k = h.dir,
                                                              A = h.date,
                                                              I = {
                                                            crc32: 0,
                                                            compressedSize: 0,
                                                            uncompressedSize: 0
                                                          };
                                                          t && !n || (I.crc32 = e.crc32, I.compressedSize = e.compressedSize, I.uncompressedSize = e.uncompressedSize);
                                                          var T = 0;
                                                          t && (T |= 8), f || !w && !S || (T |= 2048);
                                                          var O,
                                                              R = 0,
                                                              N = 0;
                                                          k && (R |= 16), "UNIX" === a ? (N = 798, R |= ((O = h.unixPermissions) || (O = k ? 16893 : 33204), (65535 & O) << 16)) : (N = 20, R |= 63 & (h.dosPermissions || 0)), u = A.getUTCHours(), u <<= 6, u |= A.getUTCMinutes(), u <<= 5, u |= A.getUTCSeconds() / 2, p = A.getUTCFullYear() - 1980, p <<= 4, p |= A.getUTCMonth() + 1, p <<= 5, p |= A.getUTCDate(), w && (x += "up" + r((E = r(1, 1) + r(c(m), 4) + g).length, 2) + E), S && (x += "uc" + r((C = r(1, 1) + r(c(b), 4) + y).length, 2) + C);
                                                          var P = "";
                                                          return P += "\n\0", P += r(T, 2), P += _.magic, P += r(u, 2), P += r(p, 2), P += r(I.crc32, 4), P += r(I.compressedSize, 4), P += r(I.uncompressedSize, 4), P += r(m.length, 2), P += r(x.length, 2), {
                                                            fileRecord: l.LOCAL_FILE_HEADER + P + m + x,
                                                            dirRecord: l.CENTRAL_FILE_HEADER + r(N, 2) + P + r(b.length, 2) + "\0\0\0\0" + r(R, 4) + r(i, 4) + m + x + b
                                                          };
                                                        }

                                                        var o = e("../utils"),
                                                            a = e("../stream/GenericWorker"),
                                                            s = e("../utf8"),
                                                            c = e("../crc32"),
                                                            l = e("../signature");

                                                        function d(e, t, n, r) {
                                                          a.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = n, this.encodeFileName = r, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                                                        }

                                                        o.inherits(d, a), d.prototype.push = function (e) {
                                                          var t = e.meta.percent || 0,
                                                              n = this.entriesCount,
                                                              r = this._sources.length;
                                                          this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, a.prototype.push.call(this, {
                                                            data: e.data,
                                                            meta: {
                                                              currentFile: this.currentFile,
                                                              percent: n ? (t + 100 * (n - r - 1)) / n : 100
                                                            }
                                                          }));
                                                        }, d.prototype.openedSource = function (e) {
                                                          this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                                                          var t = this.streamFiles && !e.file.dir;

                                                          if (t) {
                                                            var n = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                            this.push({
                                                              data: n.fileRecord,
                                                              meta: {
                                                                percent: 0
                                                              }
                                                            });
                                                          } else this.accumulate = !0;
                                                        }, d.prototype.closedSource = function (e) {
                                                          this.accumulate = !1;
                                                          var t,
                                                              n = this.streamFiles && !e.file.dir,
                                                              o = i(e, n, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                          if (this.dirRecords.push(o.dirRecord), n) this.push({
                                                            data: (t = e, l.DATA_DESCRIPTOR + r(t.crc32, 4) + r(t.compressedSize, 4) + r(t.uncompressedSize, 4)),
                                                            meta: {
                                                              percent: 100
                                                            }
                                                          });else for (this.push({
                                                            data: o.fileRecord,
                                                            meta: {
                                                              percent: 0
                                                            }
                                                          }); this.contentBuffer.length;) {
                                                            this.push(this.contentBuffer.shift());
                                                          }
                                                          this.currentFile = null;
                                                        }, d.prototype.flush = function () {
                                                          for (var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++) {
                                                            this.push({
                                                              data: this.dirRecords[t],
                                                              meta: {
                                                                percent: 100
                                                              }
                                                            });
                                                          }

                                                          var n,
                                                              i,
                                                              a,
                                                              s,
                                                              c,
                                                              d,
                                                              u = this.bytesWritten - e,
                                                              p = (n = this.dirRecords.length, i = u, a = e, s = this.zipComment, c = this.encodeFileName, d = o.transformTo("string", c(s)), l.CENTRAL_DIRECTORY_END + "\0\0\0\0" + r(n, 2) + r(n, 2) + r(i, 4) + r(a, 4) + r(d.length, 2) + d);
                                                          this.push({
                                                            data: p,
                                                            meta: {
                                                              percent: 100
                                                            }
                                                          });
                                                        }, d.prototype.prepareNextSource = function () {
                                                          this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                                                        }, d.prototype.registerPrevious = function (e) {
                                                          this._sources.push(e);

                                                          var t = this;
                                                          return e.on("data", function (e) {
                                                            t.processChunk(e);
                                                          }), e.on("end", function () {
                                                            t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                                                          }), e.on("error", function (e) {
                                                            t.error(e);
                                                          }), this;
                                                        }, d.prototype.resume = function () {
                                                          return !!a.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                                                        }, d.prototype.error = function (e) {
                                                          var t = this._sources;
                                                          if (!a.prototype.error.call(this, e)) return !1;

                                                          for (var n = 0; n < t.length; n++) {
                                                            try {
                                                              t[n].error(e);
                                                            } catch (e) {}
                                                          }

                                                          return !0;
                                                        }, d.prototype.lock = function () {
                                                          a.prototype.lock.call(this);

                                                          for (var e = this._sources, t = 0; t < e.length; t++) {
                                                            e[t].lock();
                                                          }
                                                        }, t.exports = d;
                                                      }, {
                                                        "../crc32": 4,
                                                        "../signature": 23,
                                                        "../stream/GenericWorker": 28,
                                                        "../utf8": 31,
                                                        "../utils": 32
                                                      }],
                                                      9: [function (e, t, n) {
                                                        var r = e("../compressions"),
                                                            i = e("./ZipFileWorker");

                                                        n.generateWorker = function (e, t, n) {
                                                          var o = new i(t.streamFiles, n, t.platform, t.encodeFileName),
                                                              a = 0;

                                                          try {
                                                            e.forEach(function (e, n) {
                                                              a++;

                                                              var i = function (e, t) {
                                                                var n = e || t,
                                                                    i = r[n];
                                                                if (!i) throw new Error(n + " is not a valid compression method !");
                                                                return i;
                                                              }(n.options.compression, t.compression),
                                                                  s = n.options.compressionOptions || t.compressionOptions || {},
                                                                  c = n.dir,
                                                                  l = n.date;

                                                              n._compressWorker(i, s).withStreamInfo("file", {
                                                                name: e,
                                                                dir: c,
                                                                date: l,
                                                                comment: n.comment || "",
                                                                unixPermissions: n.unixPermissions,
                                                                dosPermissions: n.dosPermissions
                                                              }).pipe(o);
                                                            }), o.entriesCount = a;
                                                          } catch (e) {
                                                            o.error(e);
                                                          }

                                                          return o;
                                                        };
                                                      }, {
                                                        "../compressions": 3,
                                                        "./ZipFileWorker": 8
                                                      }],
                                                      10: [function (e, t, n) {
                                                        function r() {
                                                          if (!(this instanceof r)) return new r();
                                                          if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                                          this.files = {}, this.comment = null, this.root = "", this.clone = function () {
                                                            var e = new r();

                                                            for (var t in this) {
                                                              "function" != typeof this[t] && (e[t] = this[t]);
                                                            }

                                                            return e;
                                                          };
                                                        }

                                                        (r.prototype = e("./object")).loadAsync = e("./load"), r.support = e("./support"), r.defaults = e("./defaults"), r.version = "3.5.0", r.loadAsync = function (e, t) {
                                                          return new r().loadAsync(e, t);
                                                        }, r.external = e("./external"), t.exports = r;
                                                      }, {
                                                        "./defaults": 5,
                                                        "./external": 6,
                                                        "./load": 11,
                                                        "./object": 15,
                                                        "./support": 30
                                                      }],
                                                      11: [function (e, t, n) {
                                                        var r = e("./utils"),
                                                            i = e("./external"),
                                                            o = e("./utf8"),
                                                            a = e("./zipEntries"),
                                                            s = e("./stream/Crc32Probe"),
                                                            c = e("./nodejsUtils");

                                                        function l(e) {
                                                          return new i.Promise(function (t, n) {
                                                            var r = e.decompressed.getContentWorker().pipe(new s());
                                                            r.on("error", function (e) {
                                                              n(e);
                                                            }).on("end", function () {
                                                              r.streamInfo.crc32 !== e.decompressed.crc32 ? n(new Error("Corrupted zip : CRC32 mismatch")) : t();
                                                            }).resume();
                                                          });
                                                        }

                                                        t.exports = function (e, t) {
                                                          var n = this;
                                                          return t = r.extend(t || {}, {
                                                            base64: !1,
                                                            checkCRC32: !1,
                                                            optimizedBinaryString: !1,
                                                            createFolders: !1,
                                                            decodeFileName: o.utf8decode
                                                          }), c.isNode && c.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : r.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function (e) {
                                                            var n = new a(t);
                                                            return n.load(e), n;
                                                          }).then(function (e) {
                                                            var n = [i.Promise.resolve(e)],
                                                                r = e.files;
                                                            if (t.checkCRC32) for (var o = 0; o < r.length; o++) {
                                                              n.push(l(r[o]));
                                                            }
                                                            return i.Promise.all(n);
                                                          }).then(function (e) {
                                                            for (var r = e.shift(), i = r.files, o = 0; o < i.length; o++) {
                                                              var a = i[o];
                                                              n.file(a.fileNameStr, a.decompressed, {
                                                                binary: !0,
                                                                optimizedBinaryString: !0,
                                                                date: a.date,
                                                                dir: a.dir,
                                                                comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                                                unixPermissions: a.unixPermissions,
                                                                dosPermissions: a.dosPermissions,
                                                                createFolders: t.createFolders
                                                              });
                                                            }

                                                            return r.zipComment.length && (n.comment = r.zipComment), n;
                                                          });
                                                        };
                                                      }, {
                                                        "./external": 6,
                                                        "./nodejsUtils": 14,
                                                        "./stream/Crc32Probe": 25,
                                                        "./utf8": 31,
                                                        "./utils": 32,
                                                        "./zipEntries": 33
                                                      }],
                                                      12: [function (e, t, n) {
                                                        var r = e("../utils"),
                                                            i = e("../stream/GenericWorker");

                                                        function o(e, t) {
                                                          i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                                                        }

                                                        r.inherits(o, i), o.prototype._bindStream = function (e) {
                                                          var t = this;
                                                          (this._stream = e).pause(), e.on("data", function (e) {
                                                            t.push({
                                                              data: e,
                                                              meta: {
                                                                percent: 0
                                                              }
                                                            });
                                                          }).on("error", function (e) {
                                                            t.isPaused ? this.generatedError = e : t.error(e);
                                                          }).on("end", function () {
                                                            t.isPaused ? t._upstreamEnded = !0 : t.end();
                                                          });
                                                        }, o.prototype.pause = function () {
                                                          return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                                                        }, o.prototype.resume = function () {
                                                          return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                                                        }, t.exports = o;
                                                      }, {
                                                        "../stream/GenericWorker": 28,
                                                        "../utils": 32
                                                      }],
                                                      13: [function (e, t, n) {
                                                        var r = e("readable-stream").Readable;

                                                        function i(e, t, n) {
                                                          r.call(this, t), this._helper = e;
                                                          var i = this;
                                                          e.on("data", function (e, t) {
                                                            i.push(e) || i._helper.pause(), n && n(t);
                                                          }).on("error", function (e) {
                                                            i.emit("error", e);
                                                          }).on("end", function () {
                                                            i.push(null);
                                                          });
                                                        }

                                                        e("../utils").inherits(i, r), i.prototype._read = function () {
                                                          this._helper.resume();
                                                        }, t.exports = i;
                                                      }, {
                                                        "../utils": 32,
                                                        "readable-stream": 16
                                                      }],
                                                      14: [function (e, t, n) {
                                                        t.exports = {
                                                          isNode: "undefined" != typeof r,
                                                          newBufferFrom: function newBufferFrom(e, t) {
                                                            if (r.from && r.from !== Uint8Array.from) return r.from(e, t);
                                                            if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                                                            return new r(e, t);
                                                          },
                                                          allocBuffer: function allocBuffer(e) {
                                                            if (r.alloc) return r.alloc(e);
                                                            var t = new r(e);
                                                            return t.fill(0), t;
                                                          },
                                                          isBuffer: function isBuffer(e) {
                                                            return r.isBuffer(e);
                                                          },
                                                          isStream: function isStream(e) {
                                                            return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                                                          }
                                                        };
                                                      }, {}],
                                                      15: [function (e, t, n) {
                                                        function r(e, t, n) {
                                                          var r,
                                                              o = a.getTypeOf(t),
                                                              c = a.extend(n || {}, l);
                                                          c.date = c.date || new Date(), null !== c.compression && (c.compression = c.compression.toUpperCase()), "string" == typeof c.unixPermissions && (c.unixPermissions = parseInt(c.unixPermissions, 8)), c.unixPermissions && 16384 & c.unixPermissions && (c.dir = !0), c.dosPermissions && 16 & c.dosPermissions && (c.dir = !0), c.dir && (e = i(e)), c.createFolders && (r = function (e) {
                                                            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                                                            var t = e.lastIndexOf("/");
                                                            return 0 < t ? e.substring(0, t) : "";
                                                          }(e)) && f.call(this, r, !0);
                                                          var p,
                                                              m = "string" === o && !1 === c.binary && !1 === c.base64;
                                                          n && void 0 !== n.binary || (c.binary = !m), (t instanceof d && 0 === t.uncompressedSize || c.dir || !t || 0 === t.length) && (c.base64 = !1, c.binary = !0, t = "", c.compression = "STORE", o = "string"), p = t instanceof d || t instanceof s ? t : h.isNode && h.isStream(t) ? new _(e, t) : a.prepareContent(e, t, c.binary, c.optimizedBinaryString, c.base64);
                                                          var g = new u(e, p, c);
                                                          this.files[e] = g;
                                                        }

                                                        function i(e) {
                                                          return "/" !== e.slice(-1) && (e += "/"), e;
                                                        }

                                                        var o = e("./utf8"),
                                                            a = e("./utils"),
                                                            s = e("./stream/GenericWorker"),
                                                            c = e("./stream/StreamHelper"),
                                                            l = e("./defaults"),
                                                            d = e("./compressedObject"),
                                                            u = e("./zipObject"),
                                                            p = e("./generate"),
                                                            h = e("./nodejsUtils"),
                                                            _ = e("./nodejs/NodejsStreamInputAdapter"),
                                                            f = function f(e, t) {
                                                          return t = void 0 !== t ? t : l.createFolders, e = i(e), this.files[e] || r.call(this, e, null, {
                                                            dir: !0,
                                                            createFolders: t
                                                          }), this.files[e];
                                                        };

                                                        function m(e) {
                                                          return "[object RegExp]" === Object.prototype.toString.call(e);
                                                        }

                                                        var g = {
                                                          load: function load() {
                                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                                          },
                                                          forEach: function forEach(e) {
                                                            var t, n, r;

                                                            for (t in this.files) {
                                                              this.files.hasOwnProperty(t) && (r = this.files[t], (n = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(n, r));
                                                            }
                                                          },
                                                          filter: function filter(e) {
                                                            var t = [];
                                                            return this.forEach(function (n, r) {
                                                              e(n, r) && t.push(r);
                                                            }), t;
                                                          },
                                                          file: function file(e, t, n) {
                                                            if (1 !== arguments.length) return e = this.root + e, r.call(this, e, t, n), this;

                                                            if (m(e)) {
                                                              var i = e;
                                                              return this.filter(function (e, t) {
                                                                return !t.dir && i.test(e);
                                                              });
                                                            }

                                                            var o = this.files[this.root + e];
                                                            return o && !o.dir ? o : null;
                                                          },
                                                          folder: function folder(e) {
                                                            if (!e) return this;
                                                            if (m(e)) return this.filter(function (t, n) {
                                                              return n.dir && e.test(t);
                                                            });
                                                            var t = this.root + e,
                                                                n = f.call(this, t),
                                                                r = this.clone();
                                                            return r.root = n.name, r;
                                                          },
                                                          remove: function remove(e) {
                                                            e = this.root + e;
                                                            var t = this.files[e];
                                                            if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];else for (var n = this.filter(function (t, n) {
                                                              return n.name.slice(0, e.length) === e;
                                                            }), r = 0; r < n.length; r++) {
                                                              delete this.files[n[r].name];
                                                            }
                                                            return this;
                                                          },
                                                          generate: function generate(e) {
                                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                                          },
                                                          generateInternalStream: function generateInternalStream(e) {
                                                            var t,
                                                                n = {};

                                                            try {
                                                              if ((n = a.extend(e || {}, {
                                                                streamFiles: !1,
                                                                compression: "STORE",
                                                                compressionOptions: null,
                                                                type: "",
                                                                platform: "DOS",
                                                                comment: null,
                                                                mimeType: "application/zip",
                                                                encodeFileName: o.utf8encode
                                                              })).type = n.type.toLowerCase(), n.compression = n.compression.toUpperCase(), "binarystring" === n.type && (n.type = "string"), !n.type) throw new Error("No output type specified.");
                                                              a.checkSupport(n.type), "darwin" !== n.platform && "freebsd" !== n.platform && "linux" !== n.platform && "sunos" !== n.platform || (n.platform = "UNIX"), "win32" === n.platform && (n.platform = "DOS");
                                                              var r = n.comment || this.comment || "";
                                                              t = p.generateWorker(this, n, r);
                                                            } catch (e) {
                                                              (t = new s("error")).error(e);
                                                            }

                                                            return new c(t, n.type || "string", n.mimeType);
                                                          },
                                                          generateAsync: function generateAsync(e, t) {
                                                            return this.generateInternalStream(e).accumulate(t);
                                                          },
                                                          generateNodeStream: function generateNodeStream(e, t) {
                                                            return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                                                          }
                                                        };
                                                        t.exports = g;
                                                      }, {
                                                        "./compressedObject": 2,
                                                        "./defaults": 5,
                                                        "./generate": 9,
                                                        "./nodejs/NodejsStreamInputAdapter": 12,
                                                        "./nodejsUtils": 14,
                                                        "./stream/GenericWorker": 28,
                                                        "./stream/StreamHelper": 29,
                                                        "./utf8": 31,
                                                        "./utils": 32,
                                                        "./zipObject": 35
                                                      }],
                                                      16: [function (e, t, n) {
                                                        t.exports = e("stream");
                                                      }, {
                                                        stream: void 0
                                                      }],
                                                      17: [function (e, t, n) {
                                                        var r = e("./DataReader");

                                                        function i(e) {
                                                          r.call(this, e);

                                                          for (var t = 0; t < this.data.length; t++) {
                                                            e[t] = 255 & e[t];
                                                          }
                                                        }

                                                        e("../utils").inherits(i, r), i.prototype.byteAt = function (e) {
                                                          return this.data[this.zero + e];
                                                        }, i.prototype.lastIndexOfSignature = function (e) {
                                                          for (var t = e.charCodeAt(0), n = e.charCodeAt(1), r = e.charCodeAt(2), i = e.charCodeAt(3), o = this.length - 4; 0 <= o; --o) {
                                                            if (this.data[o] === t && this.data[o + 1] === n && this.data[o + 2] === r && this.data[o + 3] === i) return o - this.zero;
                                                          }

                                                          return -1;
                                                        }, i.prototype.readAndCheckSignature = function (e) {
                                                          var t = e.charCodeAt(0),
                                                              n = e.charCodeAt(1),
                                                              r = e.charCodeAt(2),
                                                              i = e.charCodeAt(3),
                                                              o = this.readData(4);
                                                          return t === o[0] && n === o[1] && r === o[2] && i === o[3];
                                                        }, i.prototype.readData = function (e) {
                                                          if (this.checkOffset(e), 0 === e) return [];
                                                          var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                                          return this.index += e, t;
                                                        }, t.exports = i;
                                                      }, {
                                                        "../utils": 32,
                                                        "./DataReader": 18
                                                      }],
                                                      18: [function (e, t, n) {
                                                        var r = e("../utils");

                                                        function i(e) {
                                                          this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                                                        }

                                                        i.prototype = {
                                                          checkOffset: function checkOffset(e) {
                                                            this.checkIndex(this.index + e);
                                                          },
                                                          checkIndex: function checkIndex(e) {
                                                            if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                                                          },
                                                          setIndex: function setIndex(e) {
                                                            this.checkIndex(e), this.index = e;
                                                          },
                                                          skip: function skip(e) {
                                                            this.setIndex(this.index + e);
                                                          },
                                                          byteAt: function byteAt(e) {},
                                                          readInt: function readInt(e) {
                                                            var t,
                                                                n = 0;

                                                            for (this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--) {
                                                              n = (n << 8) + this.byteAt(t);
                                                            }

                                                            return this.index += e, n;
                                                          },
                                                          readString: function readString(e) {
                                                            return r.transformTo("string", this.readData(e));
                                                          },
                                                          readData: function readData(e) {},
                                                          lastIndexOfSignature: function lastIndexOfSignature(e) {},
                                                          readAndCheckSignature: function readAndCheckSignature(e) {},
                                                          readDate: function readDate() {
                                                            var e = this.readInt(4);
                                                            return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                                                          }
                                                        }, t.exports = i;
                                                      }, {
                                                        "../utils": 32
                                                      }],
                                                      19: [function (e, t, n) {
                                                        var r = e("./Uint8ArrayReader");

                                                        function i(e) {
                                                          r.call(this, e);
                                                        }

                                                        e("../utils").inherits(i, r), i.prototype.readData = function (e) {
                                                          this.checkOffset(e);
                                                          var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                                          return this.index += e, t;
                                                        }, t.exports = i;
                                                      }, {
                                                        "../utils": 32,
                                                        "./Uint8ArrayReader": 21
                                                      }],
                                                      20: [function (e, t, n) {
                                                        var r = e("./DataReader");

                                                        function i(e) {
                                                          r.call(this, e);
                                                        }

                                                        e("../utils").inherits(i, r), i.prototype.byteAt = function (e) {
                                                          return this.data.charCodeAt(this.zero + e);
                                                        }, i.prototype.lastIndexOfSignature = function (e) {
                                                          return this.data.lastIndexOf(e) - this.zero;
                                                        }, i.prototype.readAndCheckSignature = function (e) {
                                                          return e === this.readData(4);
                                                        }, i.prototype.readData = function (e) {
                                                          this.checkOffset(e);
                                                          var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                                          return this.index += e, t;
                                                        }, t.exports = i;
                                                      }, {
                                                        "../utils": 32,
                                                        "./DataReader": 18
                                                      }],
                                                      21: [function (e, t, n) {
                                                        var r = e("./ArrayReader");

                                                        function i(e) {
                                                          r.call(this, e);
                                                        }

                                                        e("../utils").inherits(i, r), i.prototype.readData = function (e) {
                                                          if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                                                          var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                                                          return this.index += e, t;
                                                        }, t.exports = i;
                                                      }, {
                                                        "../utils": 32,
                                                        "./ArrayReader": 17
                                                      }],
                                                      22: [function (e, t, n) {
                                                        var r = e("../utils"),
                                                            i = e("../support"),
                                                            o = e("./ArrayReader"),
                                                            a = e("./StringReader"),
                                                            s = e("./NodeBufferReader"),
                                                            c = e("./Uint8ArrayReader");

                                                        t.exports = function (e) {
                                                          var t = r.getTypeOf(e);
                                                          return r.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new s(e) : i.uint8array ? new c(r.transformTo("uint8array", e)) : new o(r.transformTo("array", e)) : new a(e);
                                                        };
                                                      }, {
                                                        "../support": 30,
                                                        "../utils": 32,
                                                        "./ArrayReader": 17,
                                                        "./NodeBufferReader": 19,
                                                        "./StringReader": 20,
                                                        "./Uint8ArrayReader": 21
                                                      }],
                                                      23: [function (e, t, n) {
                                                        n.LOCAL_FILE_HEADER = "PK\x03\x04", n.CENTRAL_FILE_HEADER = "PK\x01\x02", n.CENTRAL_DIRECTORY_END = "PK\x05\x06", n.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", n.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", n.DATA_DESCRIPTOR = "PK\x07\b";
                                                      }, {}],
                                                      24: [function (e, t, n) {
                                                        var r = e("./GenericWorker"),
                                                            i = e("../utils");

                                                        function o(e) {
                                                          r.call(this, "ConvertWorker to " + e), this.destType = e;
                                                        }

                                                        i.inherits(o, r), o.prototype.processChunk = function (e) {
                                                          this.push({
                                                            data: i.transformTo(this.destType, e.data),
                                                            meta: e.meta
                                                          });
                                                        }, t.exports = o;
                                                      }, {
                                                        "../utils": 32,
                                                        "./GenericWorker": 28
                                                      }],
                                                      25: [function (e, t, n) {
                                                        var r = e("./GenericWorker"),
                                                            i = e("../crc32");

                                                        function o() {
                                                          r.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                                                        }

                                                        e("../utils").inherits(o, r), o.prototype.processChunk = function (e) {
                                                          this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                                                        }, t.exports = o;
                                                      }, {
                                                        "../crc32": 4,
                                                        "../utils": 32,
                                                        "./GenericWorker": 28
                                                      }],
                                                      26: [function (e, t, n) {
                                                        var r = e("../utils"),
                                                            i = e("./GenericWorker");

                                                        function o(e) {
                                                          i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                                                        }

                                                        r.inherits(o, i), o.prototype.processChunk = function (e) {
                                                          if (e) {
                                                            var t = this.streamInfo[this.propName] || 0;
                                                            this.streamInfo[this.propName] = t + e.data.length;
                                                          }

                                                          i.prototype.processChunk.call(this, e);
                                                        }, t.exports = o;
                                                      }, {
                                                        "../utils": 32,
                                                        "./GenericWorker": 28
                                                      }],
                                                      27: [function (e, t, n) {
                                                        var r = e("../utils"),
                                                            i = e("./GenericWorker");

                                                        function o(e) {
                                                          i.call(this, "DataWorker");
                                                          var t = this;
                                                          this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function (e) {
                                                            t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = r.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                                                          }, function (e) {
                                                            t.error(e);
                                                          });
                                                        }

                                                        r.inherits(o, i), o.prototype.cleanUp = function () {
                                                          i.prototype.cleanUp.call(this), this.data = null;
                                                        }, o.prototype.resume = function () {
                                                          return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, r.delay(this._tickAndRepeat, [], this)), !0);
                                                        }, o.prototype._tickAndRepeat = function () {
                                                          this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (r.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                                                        }, o.prototype._tick = function () {
                                                          if (this.isPaused || this.isFinished) return !1;
                                                          var e = null,
                                                              t = Math.min(this.max, this.index + 16384);
                                                          if (this.index >= this.max) return this.end();

                                                          switch (this.type) {
                                                            case "string":
                                                              e = this.data.substring(this.index, t);
                                                              break;

                                                            case "uint8array":
                                                              e = this.data.subarray(this.index, t);
                                                              break;

                                                            case "array":
                                                            case "nodebuffer":
                                                              e = this.data.slice(this.index, t);
                                                          }

                                                          return this.index = t, this.push({
                                                            data: e,
                                                            meta: {
                                                              percent: this.max ? this.index / this.max * 100 : 0
                                                            }
                                                          });
                                                        }, t.exports = o;
                                                      }, {
                                                        "../utils": 32,
                                                        "./GenericWorker": 28
                                                      }],
                                                      28: [function (e, t, n) {
                                                        function r(e) {
                                                          this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                                            data: [],
                                                            end: [],
                                                            error: []
                                                          }, this.previous = null;
                                                        }

                                                        r.prototype = {
                                                          push: function push(e) {
                                                            this.emit("data", e);
                                                          },
                                                          end: function end() {
                                                            if (this.isFinished) return !1;
                                                            this.flush();

                                                            try {
                                                              this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                                            } catch (e) {
                                                              this.emit("error", e);
                                                            }

                                                            return !0;
                                                          },
                                                          error: function error(e) {
                                                            return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                                                          },
                                                          on: function on(e, t) {
                                                            return this._listeners[e].push(t), this;
                                                          },
                                                          cleanUp: function cleanUp() {
                                                            this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                                          },
                                                          emit: function emit(e, t) {
                                                            if (this._listeners[e]) for (var n = 0; n < this._listeners[e].length; n++) {
                                                              this._listeners[e][n].call(this, t);
                                                            }
                                                          },
                                                          pipe: function pipe(e) {
                                                            return e.registerPrevious(this);
                                                          },
                                                          registerPrevious: function registerPrevious(e) {
                                                            if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                            this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                                                            var t = this;
                                                            return e.on("data", function (e) {
                                                              t.processChunk(e);
                                                            }), e.on("end", function () {
                                                              t.end();
                                                            }), e.on("error", function (e) {
                                                              t.error(e);
                                                            }), this;
                                                          },
                                                          pause: function pause() {
                                                            return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                                          },
                                                          resume: function resume() {
                                                            if (!this.isPaused || this.isFinished) return !1;
                                                            var e = this.isPaused = !1;
                                                            return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                                                          },
                                                          flush: function flush() {},
                                                          processChunk: function processChunk(e) {
                                                            this.push(e);
                                                          },
                                                          withStreamInfo: function withStreamInfo(e, t) {
                                                            return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                                                          },
                                                          mergeStreamInfo: function mergeStreamInfo() {
                                                            for (var e in this.extraStreamInfo) {
                                                              this.extraStreamInfo.hasOwnProperty(e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                                                            }
                                                          },
                                                          lock: function lock() {
                                                            if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                            this.isLocked = !0, this.previous && this.previous.lock();
                                                          },
                                                          toString: function toString() {
                                                            var e = "Worker " + this.name;
                                                            return this.previous ? this.previous + " -> " + e : e;
                                                          }
                                                        }, t.exports = r;
                                                      }, {}],
                                                      29: [function (e, t, n) {
                                                        var i = e("../utils"),
                                                            o = e("./ConvertWorker"),
                                                            a = e("./GenericWorker"),
                                                            s = e("../base64"),
                                                            c = e("../support"),
                                                            l = e("../external"),
                                                            d = null;
                                                        if (c.nodestream) try {
                                                          d = e("../nodejs/NodejsStreamOutputAdapter");
                                                        } catch (e) {}

                                                        function u(e, t, n) {
                                                          var r = t;

                                                          switch (t) {
                                                            case "blob":
                                                            case "arraybuffer":
                                                              r = "uint8array";
                                                              break;

                                                            case "base64":
                                                              r = "string";
                                                          }

                                                          try {
                                                            this._internalType = r, this._outputType = t, this._mimeType = n, i.checkSupport(r), this._worker = e.pipe(new o(r)), e.lock();
                                                          } catch (e) {
                                                            this._worker = new a("error"), this._worker.error(e);
                                                          }
                                                        }

                                                        u.prototype = {
                                                          accumulate: function accumulate(e) {
                                                            return t = this, n = e, new l.Promise(function (e, o) {
                                                              var a = [],
                                                                  c = t._internalType,
                                                                  l = t._outputType,
                                                                  d = t._mimeType;
                                                              t.on("data", function (e, t) {
                                                                a.push(e), n && n(t);
                                                              }).on("error", function (e) {
                                                                a = [], o(e);
                                                              }).on("end", function () {
                                                                try {
                                                                  var t = function (e, t, n) {
                                                                    switch (e) {
                                                                      case "blob":
                                                                        return i.newBlob(i.transformTo("arraybuffer", t), n);

                                                                      case "base64":
                                                                        return s.encode(t);

                                                                      default:
                                                                        return i.transformTo(e, t);
                                                                    }
                                                                  }(l, function (e, t) {
                                                                    var n,
                                                                        i = 0,
                                                                        o = null,
                                                                        a = 0;

                                                                    for (n = 0; n < t.length; n++) {
                                                                      a += t[n].length;
                                                                    }

                                                                    switch (e) {
                                                                      case "string":
                                                                        return t.join("");

                                                                      case "array":
                                                                        return Array.prototype.concat.apply([], t);

                                                                      case "uint8array":
                                                                        for (o = new Uint8Array(a), n = 0; n < t.length; n++) {
                                                                          o.set(t[n], i), i += t[n].length;
                                                                        }

                                                                        return o;

                                                                      case "nodebuffer":
                                                                        return r.concat(t);

                                                                      default:
                                                                        throw new Error("concat : unsupported type '" + e + "'");
                                                                    }
                                                                  }(c, a), d);

                                                                  e(t);
                                                                } catch (t) {
                                                                  o(t);
                                                                }

                                                                a = [];
                                                              }).resume();
                                                            });
                                                            var t, n;
                                                          },
                                                          on: function on(e, t) {
                                                            var n = this;
                                                            return "data" === e ? this._worker.on(e, function (e) {
                                                              t.call(n, e.data, e.meta);
                                                            }) : this._worker.on(e, function () {
                                                              i.delay(t, arguments, n);
                                                            }), this;
                                                          },
                                                          resume: function resume() {
                                                            return i.delay(this._worker.resume, [], this._worker), this;
                                                          },
                                                          pause: function pause() {
                                                            return this._worker.pause(), this;
                                                          },
                                                          toNodejsStream: function toNodejsStream(e) {
                                                            if (i.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                                            return new d(this, {
                                                              objectMode: "nodebuffer" !== this._outputType
                                                            }, e);
                                                          }
                                                        }, t.exports = u;
                                                      }, {
                                                        "../base64": 1,
                                                        "../external": 6,
                                                        "../nodejs/NodejsStreamOutputAdapter": 13,
                                                        "../support": 30,
                                                        "../utils": 32,
                                                        "./ConvertWorker": 24,
                                                        "./GenericWorker": 28
                                                      }],
                                                      30: [function (e, t, n) {
                                                        if (n.base64 = !0, n.array = !0, n.string = !0, n.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, n.nodebuffer = "undefined" != typeof r, n.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) n.blob = !1;else {
                                                          var i = new ArrayBuffer(0);

                                                          try {
                                                            n.blob = 0 === new Blob([i], {
                                                              type: "application/zip"
                                                            }).size;
                                                          } catch (e) {
                                                            try {
                                                              var o = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                                                              o.append(i), n.blob = 0 === o.getBlob("application/zip").size;
                                                            } catch (e) {
                                                              n.blob = !1;
                                                            }
                                                          }
                                                        }

                                                        try {
                                                          n.nodestream = !!e("readable-stream").Readable;
                                                        } catch (e) {
                                                          n.nodestream = !1;
                                                        }
                                                      }, {
                                                        "readable-stream": 16
                                                      }],
                                                      31: [function (e, t, n) {
                                                        for (var r = e("./utils"), i = e("./support"), o = e("./nodejsUtils"), a = e("./stream/GenericWorker"), s = new Array(256), c = 0; c < 256; c++) {
                                                          s[c] = 252 <= c ? 6 : 248 <= c ? 5 : 240 <= c ? 4 : 224 <= c ? 3 : 192 <= c ? 2 : 1;
                                                        }

                                                        function l() {
                                                          a.call(this, "utf-8 decode"), this.leftOver = null;
                                                        }

                                                        function d() {
                                                          a.call(this, "utf-8 encode");
                                                        }

                                                        s[254] = s[254] = 1, n.utf8encode = function (e) {
                                                          return i.nodebuffer ? o.newBufferFrom(e, "utf-8") : function (e) {
                                                            var t,
                                                                n,
                                                                r,
                                                                o,
                                                                a,
                                                                s = e.length,
                                                                c = 0;

                                                            for (o = 0; o < s; o++) {
                                                              55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (r = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), o++), c += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
                                                            }

                                                            for (t = i.uint8array ? new Uint8Array(c) : new Array(c), o = a = 0; a < c; o++) {
                                                              55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (r = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), o++), n < 128 ? t[a++] = n : (n < 2048 ? t[a++] = 192 | n >>> 6 : (n < 65536 ? t[a++] = 224 | n >>> 12 : (t[a++] = 240 | n >>> 18, t[a++] = 128 | n >>> 12 & 63), t[a++] = 128 | n >>> 6 & 63), t[a++] = 128 | 63 & n);
                                                            }

                                                            return t;
                                                          }(e);
                                                        }, n.utf8decode = function (e) {
                                                          return i.nodebuffer ? r.transformTo("nodebuffer", e).toString("utf-8") : function (e) {
                                                            var t,
                                                                n,
                                                                i,
                                                                o,
                                                                a = e.length,
                                                                c = new Array(2 * a);

                                                            for (t = n = 0; t < a;) {
                                                              if ((i = e[t++]) < 128) c[n++] = i;else if (4 < (o = s[i])) c[n++] = 65533, t += o - 1;else {
                                                                for (i &= 2 === o ? 31 : 3 === o ? 15 : 7; 1 < o && t < a;) {
                                                                  i = i << 6 | 63 & e[t++], o--;
                                                                }

                                                                1 < o ? c[n++] = 65533 : i < 65536 ? c[n++] = i : (i -= 65536, c[n++] = 55296 | i >> 10 & 1023, c[n++] = 56320 | 1023 & i);
                                                              }
                                                            }

                                                            return c.length !== n && (c.subarray ? c = c.subarray(0, n) : c.length = n), r.applyFromCharCode(c);
                                                          }(e = r.transformTo(i.uint8array ? "uint8array" : "array", e));
                                                        }, r.inherits(l, a), l.prototype.processChunk = function (e) {
                                                          var t = r.transformTo(i.uint8array ? "uint8array" : "array", e.data);

                                                          if (this.leftOver && this.leftOver.length) {
                                                            if (i.uint8array) {
                                                              var o = t;
                                                              (t = new Uint8Array(o.length + this.leftOver.length)).set(this.leftOver, 0), t.set(o, this.leftOver.length);
                                                            } else t = this.leftOver.concat(t);

                                                            this.leftOver = null;
                                                          }

                                                          var a = function (e, t) {
                                                            var n;

                                                            for ((t = t || e.length) > e.length && (t = e.length), n = t - 1; 0 <= n && 128 == (192 & e[n]);) {
                                                              n--;
                                                            }

                                                            return n < 0 || 0 === n ? t : n + s[e[n]] > t ? n : t;
                                                          }(t),
                                                              c = t;

                                                          a !== t.length && (i.uint8array ? (c = t.subarray(0, a), this.leftOver = t.subarray(a, t.length)) : (c = t.slice(0, a), this.leftOver = t.slice(a, t.length))), this.push({
                                                            data: n.utf8decode(c),
                                                            meta: e.meta
                                                          });
                                                        }, l.prototype.flush = function () {
                                                          this.leftOver && this.leftOver.length && (this.push({
                                                            data: n.utf8decode(this.leftOver),
                                                            meta: {}
                                                          }), this.leftOver = null);
                                                        }, n.Utf8DecodeWorker = l, r.inherits(d, a), d.prototype.processChunk = function (e) {
                                                          this.push({
                                                            data: n.utf8encode(e.data),
                                                            meta: e.meta
                                                          });
                                                        }, n.Utf8EncodeWorker = d;
                                                      }, {
                                                        "./nodejsUtils": 14,
                                                        "./stream/GenericWorker": 28,
                                                        "./support": 30,
                                                        "./utils": 32
                                                      }],
                                                      32: [function (e, t, n) {
                                                        var r = e("./support"),
                                                            i = e("./base64"),
                                                            o = e("./nodejsUtils"),
                                                            a = e("set-immediate-shim"),
                                                            s = e("./external");

                                                        function c(e) {
                                                          return e;
                                                        }

                                                        function l(e, t) {
                                                          for (var n = 0; n < e.length; ++n) {
                                                            t[n] = 255 & e.charCodeAt(n);
                                                          }

                                                          return t;
                                                        }

                                                        n.newBlob = function (e, t) {
                                                          n.checkSupport("blob");

                                                          try {
                                                            return new Blob([e], {
                                                              type: t
                                                            });
                                                          } catch (n) {
                                                            try {
                                                              var r = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                                                              return r.append(e), r.getBlob(t);
                                                            } catch (e) {
                                                              throw new Error("Bug : can't construct the Blob.");
                                                            }
                                                          }
                                                        };

                                                        var d = {
                                                          stringifyByChunk: function stringifyByChunk(e, t, n) {
                                                            var r = [],
                                                                i = 0,
                                                                o = e.length;
                                                            if (o <= n) return String.fromCharCode.apply(null, e);

                                                            for (; i < o;) {
                                                              "array" === t || "nodebuffer" === t ? r.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + n, o)))) : r.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + n, o)))), i += n;
                                                            }

                                                            return r.join("");
                                                          },
                                                          stringifyByChar: function stringifyByChar(e) {
                                                            for (var t = "", n = 0; n < e.length; n++) {
                                                              t += String.fromCharCode(e[n]);
                                                            }

                                                            return t;
                                                          },
                                                          applyCanBeUsed: {
                                                            uint8array: function () {
                                                              try {
                                                                return r.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                                              } catch (e) {
                                                                return !1;
                                                              }
                                                            }(),
                                                            nodebuffer: function () {
                                                              try {
                                                                return r.nodebuffer && 1 === String.fromCharCode.apply(null, o.allocBuffer(1)).length;
                                                              } catch (e) {
                                                                return !1;
                                                              }
                                                            }()
                                                          }
                                                        };

                                                        function u(e) {
                                                          var t = 65536,
                                                              r = n.getTypeOf(e),
                                                              i = !0;
                                                          if ("uint8array" === r ? i = d.applyCanBeUsed.uint8array : "nodebuffer" === r && (i = d.applyCanBeUsed.nodebuffer), i) for (; 1 < t;) {
                                                            try {
                                                              return d.stringifyByChunk(e, r, t);
                                                            } catch (e) {
                                                              t = Math.floor(t / 2);
                                                            }
                                                          }
                                                          return d.stringifyByChar(e);
                                                        }

                                                        function p(e, t) {
                                                          for (var n = 0; n < e.length; n++) {
                                                            t[n] = e[n];
                                                          }

                                                          return t;
                                                        }

                                                        n.applyFromCharCode = u;
                                                        var h = {};
                                                        h.string = {
                                                          string: c,
                                                          array: function array(e) {
                                                            return l(e, new Array(e.length));
                                                          },
                                                          arraybuffer: function arraybuffer(e) {
                                                            return h.string.uint8array(e).buffer;
                                                          },
                                                          uint8array: function uint8array(e) {
                                                            return l(e, new Uint8Array(e.length));
                                                          },
                                                          nodebuffer: function nodebuffer(e) {
                                                            return l(e, o.allocBuffer(e.length));
                                                          }
                                                        }, h.array = {
                                                          string: u,
                                                          array: c,
                                                          arraybuffer: function arraybuffer(e) {
                                                            return new Uint8Array(e).buffer;
                                                          },
                                                          uint8array: function uint8array(e) {
                                                            return new Uint8Array(e);
                                                          },
                                                          nodebuffer: function nodebuffer(e) {
                                                            return o.newBufferFrom(e);
                                                          }
                                                        }, h.arraybuffer = {
                                                          string: function string(e) {
                                                            return u(new Uint8Array(e));
                                                          },
                                                          array: function array(e) {
                                                            return p(new Uint8Array(e), new Array(e.byteLength));
                                                          },
                                                          arraybuffer: c,
                                                          uint8array: function uint8array(e) {
                                                            return new Uint8Array(e);
                                                          },
                                                          nodebuffer: function nodebuffer(e) {
                                                            return o.newBufferFrom(new Uint8Array(e));
                                                          }
                                                        }, h.uint8array = {
                                                          string: u,
                                                          array: function array(e) {
                                                            return p(e, new Array(e.length));
                                                          },
                                                          arraybuffer: function arraybuffer(e) {
                                                            return e.buffer;
                                                          },
                                                          uint8array: c,
                                                          nodebuffer: function nodebuffer(e) {
                                                            return o.newBufferFrom(e);
                                                          }
                                                        }, h.nodebuffer = {
                                                          string: u,
                                                          array: function array(e) {
                                                            return p(e, new Array(e.length));
                                                          },
                                                          arraybuffer: function arraybuffer(e) {
                                                            return h.nodebuffer.uint8array(e).buffer;
                                                          },
                                                          uint8array: function uint8array(e) {
                                                            return p(e, new Uint8Array(e.length));
                                                          },
                                                          nodebuffer: c
                                                        }, n.transformTo = function (e, t) {
                                                          if (t = t || "", !e) return t;
                                                          n.checkSupport(e);
                                                          var r = n.getTypeOf(t);
                                                          return h[r][e](t);
                                                        }, n.getTypeOf = function (e) {
                                                          return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : r.nodebuffer && o.isBuffer(e) ? "nodebuffer" : r.uint8array && e instanceof Uint8Array ? "uint8array" : r.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                                                        }, n.checkSupport = function (e) {
                                                          if (!r[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                                                        }, n.MAX_VALUE_16BITS = 65535, n.MAX_VALUE_32BITS = -1, n.pretty = function (e) {
                                                          var t,
                                                              n,
                                                              r = "";

                                                          for (n = 0; n < (e || "").length; n++) {
                                                            r += "\\x" + ((t = e.charCodeAt(n)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                                                          }

                                                          return r;
                                                        }, n.delay = function (e, t, n) {
                                                          a(function () {
                                                            e.apply(n || null, t || []);
                                                          });
                                                        }, n.inherits = function (e, t) {
                                                          function n() {}

                                                          n.prototype = t.prototype, e.prototype = new n();
                                                        }, n.extend = function () {
                                                          var e,
                                                              t,
                                                              n = {};

                                                          for (e = 0; e < arguments.length; e++) {
                                                            for (t in arguments[e]) {
                                                              arguments[e].hasOwnProperty(t) && void 0 === n[t] && (n[t] = arguments[e][t]);
                                                            }
                                                          }

                                                          return n;
                                                        }, n.prepareContent = function (e, t, o, a, c) {
                                                          return s.Promise.resolve(t).then(function (e) {
                                                            return r.blob && (e instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new s.Promise(function (t, n) {
                                                              var r = new FileReader();
                                                              r.onload = function (e) {
                                                                t(e.target.result);
                                                              }, r.onerror = function (e) {
                                                                n(e.target.error);
                                                              }, r.readAsArrayBuffer(e);
                                                            }) : e;
                                                          }).then(function (t) {
                                                            var d,
                                                                u = n.getTypeOf(t);
                                                            return u ? ("arraybuffer" === u ? t = n.transformTo("uint8array", t) : "string" === u && (c ? t = i.decode(t) : o && !0 !== a && (t = l(d = t, r.uint8array ? new Uint8Array(d.length) : new Array(d.length)))), t) : s.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                                          });
                                                        };
                                                      }, {
                                                        "./base64": 1,
                                                        "./external": 6,
                                                        "./nodejsUtils": 14,
                                                        "./support": 30,
                                                        "set-immediate-shim": 54
                                                      }],
                                                      33: [function (e, t, n) {
                                                        var r = e("./reader/readerFor"),
                                                            i = e("./utils"),
                                                            o = e("./signature"),
                                                            a = e("./zipEntry"),
                                                            s = (e("./utf8"), e("./support"));

                                                        function c(e) {
                                                          this.files = [], this.loadOptions = e;
                                                        }

                                                        c.prototype = {
                                                          checkSignature: function checkSignature(e) {
                                                            if (!this.reader.readAndCheckSignature(e)) {
                                                              this.reader.index -= 4;
                                                              var t = this.reader.readString(4);
                                                              throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                                                            }
                                                          },
                                                          isSignature: function isSignature(e, t) {
                                                            var n = this.reader.index;
                                                            this.reader.setIndex(e);
                                                            var r = this.reader.readString(4) === t;
                                                            return this.reader.setIndex(n), r;
                                                          },
                                                          readBlockEndOfCentral: function readBlockEndOfCentral() {
                                                            this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                                            var e = this.reader.readData(this.zipCommentLength),
                                                                t = s.uint8array ? "uint8array" : "array",
                                                                n = i.transformTo(t, e);
                                                            this.zipComment = this.loadOptions.decodeFileName(n);
                                                          },
                                                          readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
                                                            this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};

                                                            for (var e, t, n, r = this.zip64EndOfCentralSize - 44; 0 < r;) {
                                                              e = this.reader.readInt(2), t = this.reader.readInt(4), n = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                                                                id: e,
                                                                length: t,
                                                                value: n
                                                              };
                                                            }
                                                          },
                                                          readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
                                                            if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                                          },
                                                          readLocalFiles: function readLocalFiles() {
                                                            var e, t;

                                                            for (e = 0; e < this.files.length; e++) {
                                                              t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(o.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                                                            }
                                                          },
                                                          readCentralDir: function readCentralDir() {
                                                            var e;

                                                            for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(o.CENTRAL_FILE_HEADER);) {
                                                              (e = new a({
                                                                zip64: this.zip64
                                                              }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                                                            }

                                                            if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                                          },
                                                          readEndOfCentral: function readEndOfCentral() {
                                                            var e = this.reader.lastIndexOfSignature(o.CENTRAL_DIRECTORY_END);
                                                            if (e < 0) throw this.isSignature(0, o.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                                            this.reader.setIndex(e);
                                                            var t = e;

                                                            if (this.checkSignature(o.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                                              if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(o.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                                              if (this.reader.setIndex(e), this.checkSignature(o.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, o.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(o.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                                              this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(o.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                                            }

                                                            var n = this.centralDirOffset + this.centralDirSize;
                                                            this.zip64 && (n += 20, n += 12 + this.zip64EndOfCentralSize);
                                                            var r = t - n;
                                                            if (0 < r) this.isSignature(t, o.CENTRAL_FILE_HEADER) || (this.reader.zero = r);else if (r < 0) throw new Error("Corrupted zip: missing " + Math.abs(r) + " bytes.");
                                                          },
                                                          prepareReader: function prepareReader(e) {
                                                            this.reader = r(e);
                                                          },
                                                          load: function load(e) {
                                                            this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                                          }
                                                        }, t.exports = c;
                                                      }, {
                                                        "./reader/readerFor": 22,
                                                        "./signature": 23,
                                                        "./support": 30,
                                                        "./utf8": 31,
                                                        "./utils": 32,
                                                        "./zipEntry": 34
                                                      }],
                                                      34: [function (e, t, n) {
                                                        var r = e("./reader/readerFor"),
                                                            i = e("./utils"),
                                                            o = e("./compressedObject"),
                                                            a = e("./crc32"),
                                                            s = e("./utf8"),
                                                            c = e("./compressions"),
                                                            l = e("./support");

                                                        function d(e, t) {
                                                          this.options = e, this.loadOptions = t;
                                                        }

                                                        d.prototype = {
                                                          isEncrypted: function isEncrypted() {
                                                            return 1 == (1 & this.bitFlag);
                                                          },
                                                          useUTF8: function useUTF8() {
                                                            return 2048 == (2048 & this.bitFlag);
                                                          },
                                                          readLocalPart: function readLocalPart(e) {
                                                            var t, n;
                                                            if (e.skip(22), this.fileNameLength = e.readInt(2), n = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(n), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                                            if (null === (t = function (e) {
                                                              for (var t in c) {
                                                                if (c.hasOwnProperty(t) && c[t].magic === e) return c[t];
                                                              }

                                                              return null;
                                                            }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
                                                            this.decompressed = new o(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                                                          },
                                                          readCentralPart: function readCentralPart(e) {
                                                            this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                                                            var t = e.readInt(2);
                                                            if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                                            e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                                                          },
                                                          processAttributes: function processAttributes() {
                                                            this.unixPermissions = null, this.dosPermissions = null;
                                                            var e = this.versionMadeBy >> 8;
                                                            this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                                          },
                                                          parseZIP64ExtraField: function parseZIP64ExtraField(e) {
                                                            if (this.extraFields[1]) {
                                                              var t = r(this.extraFields[1].value);
                                                              this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = t.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = t.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = t.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = t.readInt(4));
                                                            }
                                                          },
                                                          readExtraFields: function readExtraFields(e) {
                                                            var t,
                                                                n,
                                                                r,
                                                                i = e.index + this.extraFieldsLength;

                                                            for (this.extraFields || (this.extraFields = {}); e.index + 4 < i;) {
                                                              t = e.readInt(2), n = e.readInt(2), r = e.readData(n), this.extraFields[t] = {
                                                                id: t,
                                                                length: n,
                                                                value: r
                                                              };
                                                            }

                                                            e.setIndex(i);
                                                          },
                                                          handleUTF8: function handleUTF8() {
                                                            var e = l.uint8array ? "uint8array" : "array";
                                                            if (this.useUTF8()) this.fileNameStr = s.utf8decode(this.fileName), this.fileCommentStr = s.utf8decode(this.fileComment);else {
                                                              var t = this.findExtraFieldUnicodePath();
                                                              if (null !== t) this.fileNameStr = t;else {
                                                                var n = i.transformTo(e, this.fileName);
                                                                this.fileNameStr = this.loadOptions.decodeFileName(n);
                                                              }
                                                              var r = this.findExtraFieldUnicodeComment();
                                                              if (null !== r) this.fileCommentStr = r;else {
                                                                var o = i.transformTo(e, this.fileComment);
                                                                this.fileCommentStr = this.loadOptions.decodeFileName(o);
                                                              }
                                                            }
                                                          },
                                                          findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
                                                            var e = this.extraFields[28789];

                                                            if (e) {
                                                              var t = r(e.value);
                                                              return 1 !== t.readInt(1) || a(this.fileName) !== t.readInt(4) ? null : s.utf8decode(t.readData(e.length - 5));
                                                            }

                                                            return null;
                                                          },
                                                          findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
                                                            var e = this.extraFields[25461];

                                                            if (e) {
                                                              var t = r(e.value);
                                                              return 1 !== t.readInt(1) || a(this.fileComment) !== t.readInt(4) ? null : s.utf8decode(t.readData(e.length - 5));
                                                            }

                                                            return null;
                                                          }
                                                        }, t.exports = d;
                                                      }, {
                                                        "./compressedObject": 2,
                                                        "./compressions": 3,
                                                        "./crc32": 4,
                                                        "./reader/readerFor": 22,
                                                        "./support": 30,
                                                        "./utf8": 31,
                                                        "./utils": 32
                                                      }],
                                                      35: [function (e, t, n) {
                                                        function r(e, t, n) {
                                                          this.name = e, this.dir = n.dir, this.date = n.date, this.comment = n.comment, this.unixPermissions = n.unixPermissions, this.dosPermissions = n.dosPermissions, this._data = t, this._dataBinary = n.binary, this.options = {
                                                            compression: n.compression,
                                                            compressionOptions: n.compressionOptions
                                                          };
                                                        }

                                                        var i = e("./stream/StreamHelper"),
                                                            o = e("./stream/DataWorker"),
                                                            a = e("./utf8"),
                                                            s = e("./compressedObject"),
                                                            c = e("./stream/GenericWorker");
                                                        r.prototype = {
                                                          internalStream: function internalStream(e) {
                                                            var t = null,
                                                                n = "string";

                                                            try {
                                                              if (!e) throw new Error("No output type specified.");
                                                              var r = "string" === (n = e.toLowerCase()) || "text" === n;
                                                              "binarystring" !== n && "text" !== n || (n = "string"), t = this._decompressWorker();
                                                              var o = !this._dataBinary;
                                                              o && !r && (t = t.pipe(new a.Utf8EncodeWorker())), !o && r && (t = t.pipe(new a.Utf8DecodeWorker()));
                                                            } catch (e) {
                                                              (t = new c("error")).error(e);
                                                            }

                                                            return new i(t, n, "");
                                                          },
                                                          async: function async(e, t) {
                                                            return this.internalStream(e).accumulate(t);
                                                          },
                                                          nodeStream: function nodeStream(e, t) {
                                                            return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                                                          },
                                                          _compressWorker: function _compressWorker(e, t) {
                                                            if (this._data instanceof s && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();

                                                            var n = this._decompressWorker();

                                                            return this._dataBinary || (n = n.pipe(new a.Utf8EncodeWorker())), s.createWorkerFrom(n, e, t);
                                                          },
                                                          _decompressWorker: function _decompressWorker() {
                                                            return this._data instanceof s ? this._data.getContentWorker() : this._data instanceof c ? this._data : new o(this._data);
                                                          }
                                                        };

                                                        for (var l = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], d = function d() {
                                                          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                                        }, u = 0; u < l.length; u++) {
                                                          r.prototype[l[u]] = d;
                                                        }

                                                        t.exports = r;
                                                      }, {
                                                        "./compressedObject": 2,
                                                        "./stream/DataWorker": 27,
                                                        "./stream/GenericWorker": 28,
                                                        "./stream/StreamHelper": 29,
                                                        "./utf8": 31
                                                      }],
                                                      36: [function (e, t, n) {
                                                        (function (e) {
                                                          var n,
                                                              r,
                                                              i = e.MutationObserver || e.WebKitMutationObserver;

                                                          if (i) {
                                                            var o = 0,
                                                                a = new i(d),
                                                                s = e.document.createTextNode("");
                                                            a.observe(s, {
                                                              characterData: !0
                                                            }), n = function n() {
                                                              s.data = o = ++o % 2;
                                                            };
                                                          } else if (e.setImmediate || void 0 === e.MessageChannel) n = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function () {
                                                            var t = e.document.createElement("script");
                                                            t.onreadystatechange = function () {
                                                              d(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                                                            }, e.document.documentElement.appendChild(t);
                                                          } : function () {
                                                            setTimeout(d, 0);
                                                          };else {
                                                            var c = new e.MessageChannel();
                                                            c.port1.onmessage = d, n = function n() {
                                                              c.port2.postMessage(0);
                                                            };
                                                          }

                                                          var l = [];

                                                          function d() {
                                                            var e, t;
                                                            r = !0;

                                                            for (var n = l.length; n;) {
                                                              for (t = l, l = [], e = -1; ++e < n;) {
                                                                t[e]();
                                                              }

                                                              n = l.length;
                                                            }

                                                            r = !1;
                                                          }

                                                          t.exports = function (e) {
                                                            1 !== l.push(e) || r || n();
                                                          };
                                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                                      }, {}],
                                                      37: [function (e, t, n) {
                                                        var r = e("immediate");

                                                        function i() {}

                                                        var o = {},
                                                            a = ["REJECTED"],
                                                            s = ["FULFILLED"],
                                                            c = ["PENDING"];

                                                        function l(e) {
                                                          if ("function" != typeof e) throw new TypeError("resolver must be a function");
                                                          this.state = c, this.queue = [], this.outcome = void 0, e !== i && h(this, e);
                                                        }

                                                        function d(e, t, n) {
                                                          this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof n && (this.onRejected = n, this.callRejected = this.otherCallRejected);
                                                        }

                                                        function u(e, t, n) {
                                                          r(function () {
                                                            var r;

                                                            try {
                                                              r = t(n);
                                                            } catch (r) {
                                                              return o.reject(e, r);
                                                            }

                                                            r === e ? o.reject(e, new TypeError("Cannot resolve promise with itself")) : o.resolve(e, r);
                                                          });
                                                        }

                                                        function p(e) {
                                                          var t = e && e.then;
                                                          if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function () {
                                                            t.apply(e, arguments);
                                                          };
                                                        }

                                                        function h(e, t) {
                                                          var n = !1;

                                                          function r(t) {
                                                            n || (n = !0, o.reject(e, t));
                                                          }

                                                          function i(t) {
                                                            n || (n = !0, o.resolve(e, t));
                                                          }

                                                          var a = _(function () {
                                                            t(i, r);
                                                          });

                                                          "error" === a.status && r(a.value);
                                                        }

                                                        function _(e, t) {
                                                          var n = {};

                                                          try {
                                                            n.value = e(t), n.status = "success";
                                                          } catch (e) {
                                                            n.status = "error", n.value = e;
                                                          }

                                                          return n;
                                                        }

                                                        (t.exports = l).prototype.finally = function (e) {
                                                          if ("function" != typeof e) return this;
                                                          var t = this.constructor;
                                                          return this.then(function (n) {
                                                            return t.resolve(e()).then(function () {
                                                              return n;
                                                            });
                                                          }, function (n) {
                                                            return t.resolve(e()).then(function () {
                                                              throw n;
                                                            });
                                                          });
                                                        }, l.prototype.catch = function (e) {
                                                          return this.then(null, e);
                                                        }, l.prototype.then = function (e, t) {
                                                          if ("function" != typeof e && this.state === s || "function" != typeof t && this.state === a) return this;
                                                          var n = new this.constructor(i);
                                                          return this.state !== c ? u(n, this.state === s ? e : t, this.outcome) : this.queue.push(new d(n, e, t)), n;
                                                        }, d.prototype.callFulfilled = function (e) {
                                                          o.resolve(this.promise, e);
                                                        }, d.prototype.otherCallFulfilled = function (e) {
                                                          u(this.promise, this.onFulfilled, e);
                                                        }, d.prototype.callRejected = function (e) {
                                                          o.reject(this.promise, e);
                                                        }, d.prototype.otherCallRejected = function (e) {
                                                          u(this.promise, this.onRejected, e);
                                                        }, o.resolve = function (e, t) {
                                                          var n = _(p, t);

                                                          if ("error" === n.status) return o.reject(e, n.value);
                                                          var r = n.value;
                                                          if (r) h(e, r);else {
                                                            e.state = s, e.outcome = t;

                                                            for (var i = -1, a = e.queue.length; ++i < a;) {
                                                              e.queue[i].callFulfilled(t);
                                                            }
                                                          }
                                                          return e;
                                                        }, o.reject = function (e, t) {
                                                          e.state = a, e.outcome = t;

                                                          for (var n = -1, r = e.queue.length; ++n < r;) {
                                                            e.queue[n].callRejected(t);
                                                          }

                                                          return e;
                                                        }, l.resolve = function (e) {
                                                          return e instanceof this ? e : o.resolve(new this(i), e);
                                                        }, l.reject = function (e) {
                                                          var t = new this(i);
                                                          return o.reject(t, e);
                                                        }, l.all = function (e) {
                                                          var t = this;
                                                          if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                                          var n = e.length,
                                                              r = !1;
                                                          if (!n) return this.resolve([]);

                                                          for (var a = new Array(n), s = 0, c = -1, l = new this(i); ++c < n;) {
                                                            d(e[c], c);
                                                          }

                                                          return l;

                                                          function d(e, i) {
                                                            t.resolve(e).then(function (e) {
                                                              a[i] = e, ++s !== n || r || (r = !0, o.resolve(l, a));
                                                            }, function (e) {
                                                              r || (r = !0, o.reject(l, e));
                                                            });
                                                          }
                                                        }, l.race = function (e) {
                                                          if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                                          var t = e.length,
                                                              n = !1;
                                                          if (!t) return this.resolve([]);

                                                          for (var r, a = -1, s = new this(i); ++a < t;) {
                                                            r = e[a], this.resolve(r).then(function (e) {
                                                              n || (n = !0, o.resolve(s, e));
                                                            }, function (e) {
                                                              n || (n = !0, o.reject(s, e));
                                                            });
                                                          }

                                                          return s;
                                                        };
                                                      }, {
                                                        immediate: 36
                                                      }],
                                                      38: [function (e, t, n) {
                                                        var r = {};
                                                        (0, e("./lib/utils/common").assign)(r, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = r;
                                                      }, {
                                                        "./lib/deflate": 39,
                                                        "./lib/inflate": 40,
                                                        "./lib/utils/common": 41,
                                                        "./lib/zlib/constants": 44
                                                      }],
                                                      39: [function (e, t, n) {
                                                        var r = e("./zlib/deflate"),
                                                            i = e("./utils/common"),
                                                            o = e("./utils/strings"),
                                                            a = e("./zlib/messages"),
                                                            s = e("./zlib/zstream"),
                                                            c = Object.prototype.toString,
                                                            l = 0,
                                                            d = -1,
                                                            u = 0,
                                                            p = 8;

                                                        function h(e) {
                                                          if (!(this instanceof h)) return new h(e);
                                                          this.options = i.assign({
                                                            level: d,
                                                            method: p,
                                                            chunkSize: 16384,
                                                            windowBits: 15,
                                                            memLevel: 8,
                                                            strategy: u,
                                                            to: ""
                                                          }, e || {});
                                                          var t = this.options;
                                                          t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
                                                          var n = r.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                                                          if (n !== l) throw new Error(a[n]);

                                                          if (t.header && r.deflateSetHeader(this.strm, t.header), t.dictionary) {
                                                            var _;

                                                            if (_ = "string" == typeof t.dictionary ? o.string2buf(t.dictionary) : "[object ArrayBuffer]" === c.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (n = r.deflateSetDictionary(this.strm, _)) !== l) throw new Error(a[n]);
                                                            this._dict_set = !0;
                                                          }
                                                        }

                                                        function _(e, t) {
                                                          var n = new h(t);
                                                          if (n.push(e, !0), n.err) throw n.msg || a[n.err];
                                                          return n.result;
                                                        }

                                                        h.prototype.push = function (e, t) {
                                                          var n,
                                                              a,
                                                              s = this.strm,
                                                              d = this.options.chunkSize;
                                                          if (this.ended) return !1;
                                                          a = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? s.input = o.string2buf(e) : "[object ArrayBuffer]" === c.call(e) ? s.input = new Uint8Array(e) : s.input = e, s.next_in = 0, s.avail_in = s.input.length;

                                                          do {
                                                            if (0 === s.avail_out && (s.output = new i.Buf8(d), s.next_out = 0, s.avail_out = d), 1 !== (n = r.deflate(s, a)) && n !== l) return this.onEnd(n), !(this.ended = !0);
                                                            0 !== s.avail_out && (0 !== s.avail_in || 4 !== a && 2 !== a) || ("string" === this.options.to ? this.onData(o.buf2binstring(i.shrinkBuf(s.output, s.next_out))) : this.onData(i.shrinkBuf(s.output, s.next_out)));
                                                          } while ((0 < s.avail_in || 0 === s.avail_out) && 1 !== n);

                                                          return 4 === a ? (n = r.deflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === l) : 2 !== a || (this.onEnd(l), !(s.avail_out = 0));
                                                        }, h.prototype.onData = function (e) {
                                                          this.chunks.push(e);
                                                        }, h.prototype.onEnd = function (e) {
                                                          e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                                        }, n.Deflate = h, n.deflate = _, n.deflateRaw = function (e, t) {
                                                          return (t = t || {}).raw = !0, _(e, t);
                                                        }, n.gzip = function (e, t) {
                                                          return (t = t || {}).gzip = !0, _(e, t);
                                                        };
                                                      }, {
                                                        "./utils/common": 41,
                                                        "./utils/strings": 42,
                                                        "./zlib/deflate": 46,
                                                        "./zlib/messages": 51,
                                                        "./zlib/zstream": 53
                                                      }],
                                                      40: [function (e, t, n) {
                                                        var r = e("./zlib/inflate"),
                                                            i = e("./utils/common"),
                                                            o = e("./utils/strings"),
                                                            a = e("./zlib/constants"),
                                                            s = e("./zlib/messages"),
                                                            c = e("./zlib/zstream"),
                                                            l = e("./zlib/gzheader"),
                                                            d = Object.prototype.toString;

                                                        function u(e) {
                                                          if (!(this instanceof u)) return new u(e);
                                                          this.options = i.assign({
                                                            chunkSize: 16384,
                                                            windowBits: 0,
                                                            to: ""
                                                          }, e || {});
                                                          var t = this.options;
                                                          t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new c(), this.strm.avail_out = 0;
                                                          var n = r.inflateInit2(this.strm, t.windowBits);
                                                          if (n !== a.Z_OK) throw new Error(s[n]);
                                                          this.header = new l(), r.inflateGetHeader(this.strm, this.header);
                                                        }

                                                        function p(e, t) {
                                                          var n = new u(t);
                                                          if (n.push(e, !0), n.err) throw n.msg || s[n.err];
                                                          return n.result;
                                                        }

                                                        u.prototype.push = function (e, t) {
                                                          var n,
                                                              s,
                                                              c,
                                                              l,
                                                              u,
                                                              p,
                                                              h = this.strm,
                                                              _ = this.options.chunkSize,
                                                              f = this.options.dictionary,
                                                              m = !1;
                                                          if (this.ended) return !1;
                                                          s = t === ~~t ? t : !0 === t ? a.Z_FINISH : a.Z_NO_FLUSH, "string" == typeof e ? h.input = o.binstring2buf(e) : "[object ArrayBuffer]" === d.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;

                                                          do {
                                                            if (0 === h.avail_out && (h.output = new i.Buf8(_), h.next_out = 0, h.avail_out = _), (n = r.inflate(h, a.Z_NO_FLUSH)) === a.Z_NEED_DICT && f && (p = "string" == typeof f ? o.string2buf(f) : "[object ArrayBuffer]" === d.call(f) ? new Uint8Array(f) : f, n = r.inflateSetDictionary(this.strm, p)), n === a.Z_BUF_ERROR && !0 === m && (n = a.Z_OK, m = !1), n !== a.Z_STREAM_END && n !== a.Z_OK) return this.onEnd(n), !(this.ended = !0);
                                                            h.next_out && (0 !== h.avail_out && n !== a.Z_STREAM_END && (0 !== h.avail_in || s !== a.Z_FINISH && s !== a.Z_SYNC_FLUSH) || ("string" === this.options.to ? (c = o.utf8border(h.output, h.next_out), l = h.next_out - c, u = o.buf2string(h.output, c), h.next_out = l, h.avail_out = _ - l, l && i.arraySet(h.output, h.output, c, l, 0), this.onData(u)) : this.onData(i.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (m = !0);
                                                          } while ((0 < h.avail_in || 0 === h.avail_out) && n !== a.Z_STREAM_END);

                                                          return n === a.Z_STREAM_END && (s = a.Z_FINISH), s === a.Z_FINISH ? (n = r.inflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === a.Z_OK) : s !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), !(h.avail_out = 0));
                                                        }, u.prototype.onData = function (e) {
                                                          this.chunks.push(e);
                                                        }, u.prototype.onEnd = function (e) {
                                                          e === a.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                                        }, n.Inflate = u, n.inflate = p, n.inflateRaw = function (e, t) {
                                                          return (t = t || {}).raw = !0, p(e, t);
                                                        }, n.ungzip = p;
                                                      }, {
                                                        "./utils/common": 41,
                                                        "./utils/strings": 42,
                                                        "./zlib/constants": 44,
                                                        "./zlib/gzheader": 47,
                                                        "./zlib/inflate": 49,
                                                        "./zlib/messages": 51,
                                                        "./zlib/zstream": 53
                                                      }],
                                                      41: [function (e, t, n) {
                                                        var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                                                        n.assign = function (e) {
                                                          for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
                                                            var n = t.shift();

                                                            if (n) {
                                                              if ("object" != typeof n) throw new TypeError(n + "must be non-object");

                                                              for (var r in n) {
                                                                n.hasOwnProperty(r) && (e[r] = n[r]);
                                                              }
                                                            }
                                                          }

                                                          return e;
                                                        }, n.shrinkBuf = function (e, t) {
                                                          return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                                                        };
                                                        var i = {
                                                          arraySet: function arraySet(e, t, n, r, i) {
                                                            if (t.subarray && e.subarray) e.set(t.subarray(n, n + r), i);else for (var o = 0; o < r; o++) {
                                                              e[i + o] = t[n + o];
                                                            }
                                                          },
                                                          flattenChunks: function flattenChunks(e) {
                                                            var t, n, r, i, o, a;

                                                            for (t = r = 0, n = e.length; t < n; t++) {
                                                              r += e[t].length;
                                                            }

                                                            for (a = new Uint8Array(r), t = i = 0, n = e.length; t < n; t++) {
                                                              o = e[t], a.set(o, i), i += o.length;
                                                            }

                                                            return a;
                                                          }
                                                        },
                                                            o = {
                                                          arraySet: function arraySet(e, t, n, r, i) {
                                                            for (var o = 0; o < r; o++) {
                                                              e[i + o] = t[n + o];
                                                            }
                                                          },
                                                          flattenChunks: function flattenChunks(e) {
                                                            return [].concat.apply([], e);
                                                          }
                                                        };
                                                        n.setTyped = function (e) {
                                                          e ? (n.Buf8 = Uint8Array, n.Buf16 = Uint16Array, n.Buf32 = Int32Array, n.assign(n, i)) : (n.Buf8 = Array, n.Buf16 = Array, n.Buf32 = Array, n.assign(n, o));
                                                        }, n.setTyped(r);
                                                      }, {}],
                                                      42: [function (e, t, n) {
                                                        var r = e("./common"),
                                                            i = !0,
                                                            o = !0;

                                                        try {
                                                          String.fromCharCode.apply(null, [0]);
                                                        } catch (e) {
                                                          i = !1;
                                                        }

                                                        try {
                                                          String.fromCharCode.apply(null, new Uint8Array(1));
                                                        } catch (e) {
                                                          o = !1;
                                                        }

                                                        for (var a = new r.Buf8(256), s = 0; s < 256; s++) {
                                                          a[s] = 252 <= s ? 6 : 248 <= s ? 5 : 240 <= s ? 4 : 224 <= s ? 3 : 192 <= s ? 2 : 1;
                                                        }

                                                        function c(e, t) {
                                                          if (t < 65537 && (e.subarray && o || !e.subarray && i)) return String.fromCharCode.apply(null, r.shrinkBuf(e, t));

                                                          for (var n = "", a = 0; a < t; a++) {
                                                            n += String.fromCharCode(e[a]);
                                                          }

                                                          return n;
                                                        }

                                                        a[254] = a[254] = 1, n.string2buf = function (e) {
                                                          var t,
                                                              n,
                                                              i,
                                                              o,
                                                              a,
                                                              s = e.length,
                                                              c = 0;

                                                          for (o = 0; o < s; o++) {
                                                            55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (i - 56320), o++), c += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
                                                          }

                                                          for (t = new r.Buf8(c), o = a = 0; a < c; o++) {
                                                            55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (i - 56320), o++), n < 128 ? t[a++] = n : (n < 2048 ? t[a++] = 192 | n >>> 6 : (n < 65536 ? t[a++] = 224 | n >>> 12 : (t[a++] = 240 | n >>> 18, t[a++] = 128 | n >>> 12 & 63), t[a++] = 128 | n >>> 6 & 63), t[a++] = 128 | 63 & n);
                                                          }

                                                          return t;
                                                        }, n.buf2binstring = function (e) {
                                                          return c(e, e.length);
                                                        }, n.binstring2buf = function (e) {
                                                          for (var t = new r.Buf8(e.length), n = 0, i = t.length; n < i; n++) {
                                                            t[n] = e.charCodeAt(n);
                                                          }

                                                          return t;
                                                        }, n.buf2string = function (e, t) {
                                                          var n,
                                                              r,
                                                              i,
                                                              o,
                                                              s = t || e.length,
                                                              l = new Array(2 * s);

                                                          for (n = r = 0; n < s;) {
                                                            if ((i = e[n++]) < 128) l[r++] = i;else if (4 < (o = a[i])) l[r++] = 65533, n += o - 1;else {
                                                              for (i &= 2 === o ? 31 : 3 === o ? 15 : 7; 1 < o && n < s;) {
                                                                i = i << 6 | 63 & e[n++], o--;
                                                              }

                                                              1 < o ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                                                            }
                                                          }

                                                          return c(l, r);
                                                        }, n.utf8border = function (e, t) {
                                                          var n;

                                                          for ((t = t || e.length) > e.length && (t = e.length), n = t - 1; 0 <= n && 128 == (192 & e[n]);) {
                                                            n--;
                                                          }

                                                          return n < 0 || 0 === n ? t : n + a[e[n]] > t ? n : t;
                                                        };
                                                      }, {
                                                        "./common": 41
                                                      }],
                                                      43: [function (e, t, n) {
                                                        t.exports = function (e, t, n, r) {
                                                          for (var i = 65535 & e | 0, o = e >>> 16 & 65535 | 0, a = 0; 0 !== n;) {
                                                            for (n -= a = 2e3 < n ? 2e3 : n; o = o + (i = i + t[r++] | 0) | 0, --a;) {
                                                              ;
                                                            }

                                                            i %= 65521, o %= 65521;
                                                          }

                                                          return i | o << 16 | 0;
                                                        };
                                                      }, {}],
                                                      44: [function (e, t, n) {
                                                        t.exports = {
                                                          Z_NO_FLUSH: 0,
                                                          Z_PARTIAL_FLUSH: 1,
                                                          Z_SYNC_FLUSH: 2,
                                                          Z_FULL_FLUSH: 3,
                                                          Z_FINISH: 4,
                                                          Z_BLOCK: 5,
                                                          Z_TREES: 6,
                                                          Z_OK: 0,
                                                          Z_STREAM_END: 1,
                                                          Z_NEED_DICT: 2,
                                                          Z_ERRNO: -1,
                                                          Z_STREAM_ERROR: -2,
                                                          Z_DATA_ERROR: -3,
                                                          Z_BUF_ERROR: -5,
                                                          Z_NO_COMPRESSION: 0,
                                                          Z_BEST_SPEED: 1,
                                                          Z_BEST_COMPRESSION: 9,
                                                          Z_DEFAULT_COMPRESSION: -1,
                                                          Z_FILTERED: 1,
                                                          Z_HUFFMAN_ONLY: 2,
                                                          Z_RLE: 3,
                                                          Z_FIXED: 4,
                                                          Z_DEFAULT_STRATEGY: 0,
                                                          Z_BINARY: 0,
                                                          Z_TEXT: 1,
                                                          Z_UNKNOWN: 2,
                                                          Z_DEFLATED: 8
                                                        };
                                                      }, {}],
                                                      45: [function (e, t, n) {
                                                        var r = function () {
                                                          for (var e, t = [], n = 0; n < 256; n++) {
                                                            e = n;

                                                            for (var r = 0; r < 8; r++) {
                                                              e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                            }

                                                            t[n] = e;
                                                          }

                                                          return t;
                                                        }();

                                                        t.exports = function (e, t, n, i) {
                                                          var o = r,
                                                              a = i + n;
                                                          e ^= -1;

                                                          for (var s = i; s < a; s++) {
                                                            e = e >>> 8 ^ o[255 & (e ^ t[s])];
                                                          }

                                                          return -1 ^ e;
                                                        };
                                                      }, {}],
                                                      46: [function (e, t, n) {
                                                        var r,
                                                            i = e("../utils/common"),
                                                            o = e("./trees"),
                                                            a = e("./adler32"),
                                                            s = e("./crc32"),
                                                            c = e("./messages"),
                                                            l = 0,
                                                            d = 0,
                                                            u = -2,
                                                            p = 2,
                                                            h = 8,
                                                            _ = 286,
                                                            f = 30,
                                                            m = 19,
                                                            g = 2 * _ + 1,
                                                            v = 15,
                                                            b = 3,
                                                            y = 258,
                                                            w = y + b + 1,
                                                            S = 42,
                                                            x = 113;

                                                        function E(e, t) {
                                                          return e.msg = c[t], t;
                                                        }

                                                        function C(e) {
                                                          return (e << 1) - (4 < e ? 9 : 0);
                                                        }

                                                        function k(e) {
                                                          for (var t = e.length; 0 <= --t;) {
                                                            e[t] = 0;
                                                          }
                                                        }

                                                        function A(e) {
                                                          var t = e.state,
                                                              n = t.pending;
                                                          n > e.avail_out && (n = e.avail_out), 0 !== n && (i.arraySet(e.output, t.pending_buf, t.pending_out, n, e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, 0 === t.pending && (t.pending_out = 0));
                                                        }

                                                        function I(e, t) {
                                                          o._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, A(e.strm);
                                                        }

                                                        function T(e, t) {
                                                          e.pending_buf[e.pending++] = t;
                                                        }

                                                        function O(e, t) {
                                                          e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                                                        }

                                                        function R(e, t) {
                                                          var n,
                                                              r,
                                                              i = e.max_chain_length,
                                                              o = e.strstart,
                                                              a = e.prev_length,
                                                              s = e.nice_match,
                                                              c = e.strstart > e.w_size - w ? e.strstart - (e.w_size - w) : 0,
                                                              l = e.window,
                                                              d = e.w_mask,
                                                              u = e.prev,
                                                              p = e.strstart + y,
                                                              h = l[o + a - 1],
                                                              _ = l[o + a];
                                                          e.prev_length >= e.good_match && (i >>= 2), s > e.lookahead && (s = e.lookahead);

                                                          do {
                                                            if (l[(n = t) + a] === _ && l[n + a - 1] === h && l[n] === l[o] && l[++n] === l[o + 1]) {
                                                              o += 2, n++;

                                                              do {} while (l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && l[++o] === l[++n] && o < p);

                                                              if (r = y - (p - o), o = p - y, a < r) {
                                                                if (e.match_start = t, s <= (a = r)) break;
                                                                h = l[o + a - 1], _ = l[o + a];
                                                              }
                                                            }
                                                          } while ((t = u[t & d]) > c && 0 != --i);

                                                          return a <= e.lookahead ? a : e.lookahead;
                                                        }

                                                        function N(e) {
                                                          var t,
                                                              n,
                                                              r,
                                                              o,
                                                              c,
                                                              l,
                                                              d,
                                                              u,
                                                              p,
                                                              h,
                                                              _ = e.w_size;

                                                          do {
                                                            if (o = e.window_size - e.lookahead - e.strstart, e.strstart >= _ + (_ - w)) {
                                                              for (i.arraySet(e.window, e.window, _, _, 0), e.match_start -= _, e.strstart -= _, e.block_start -= _, t = n = e.hash_size; r = e.head[--t], e.head[t] = _ <= r ? r - _ : 0, --n;) {
                                                                ;
                                                              }

                                                              for (t = n = _; r = e.prev[--t], e.prev[t] = _ <= r ? r - _ : 0, --n;) {
                                                                ;
                                                              }

                                                              o += _;
                                                            }

                                                            if (0 === e.strm.avail_in) break;
                                                            if (l = e.strm, d = e.window, u = e.strstart + e.lookahead, h = void 0, (p = o) < (h = l.avail_in) && (h = p), n = 0 === h ? 0 : (l.avail_in -= h, i.arraySet(d, l.input, l.next_in, h, u), 1 === l.state.wrap ? l.adler = a(l.adler, d, h, u) : 2 === l.state.wrap && (l.adler = s(l.adler, d, h, u)), l.next_in += h, l.total_in += h, h), e.lookahead += n, e.lookahead + e.insert >= b) for (c = e.strstart - e.insert, e.ins_h = e.window[c], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[c + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[c + b - 1]) & e.hash_mask, e.prev[c & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = c, c++, e.insert--, !(e.lookahead + e.insert < b));) {
                                                              ;
                                                            }
                                                          } while (e.lookahead < w && 0 !== e.strm.avail_in);
                                                        }

                                                        function P(e, t) {
                                                          for (var n, r;;) {
                                                            if (e.lookahead < w) {
                                                              if (N(e), e.lookahead < w && t === l) return 1;
                                                              if (0 === e.lookahead) break;
                                                            }

                                                            if (n = 0, e.lookahead >= b && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + b - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== n && e.strstart - n <= e.w_size - w && (e.match_length = R(e, n)), e.match_length >= b) {
                                                              if (r = o._tr_tally(e, e.strstart - e.match_start, e.match_length - b), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= b) {
                                                                for (e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + b - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;) {
                                                                  ;
                                                                }

                                                                e.strstart++;
                                                              } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                                                            } else r = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                                                            if (r && (I(e, !1), 0 === e.strm.avail_out)) return 1;
                                                          }

                                                          return e.insert = e.strstart < b - 1 ? e.strstart : b - 1, 4 === t ? (I(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (I(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                        }

                                                        function j(e, t) {
                                                          for (var n, r, i;;) {
                                                            if (e.lookahead < w) {
                                                              if (N(e), e.lookahead < w && t === l) return 1;
                                                              if (0 === e.lookahead) break;
                                                            }

                                                            if (n = 0, e.lookahead >= b && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + b - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = b - 1, 0 !== n && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - w && (e.match_length = R(e, n), e.match_length <= 5 && (1 === e.strategy || e.match_length === b && 4096 < e.strstart - e.match_start) && (e.match_length = b - 1)), e.prev_length >= b && e.match_length <= e.prev_length) {
                                                              for (i = e.strstart + e.lookahead - b, r = o._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - b), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + b - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;) {
                                                                ;
                                                              }

                                                              if (e.match_available = 0, e.match_length = b - 1, e.strstart++, r && (I(e, !1), 0 === e.strm.avail_out)) return 1;
                                                            } else if (e.match_available) {
                                                              if ((r = o._tr_tally(e, 0, e.window[e.strstart - 1])) && I(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
                                                            } else e.match_available = 1, e.strstart++, e.lookahead--;
                                                          }

                                                          return e.match_available && (r = o._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < b - 1 ? e.strstart : b - 1, 4 === t ? (I(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (I(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                        }

                                                        function D(e, t, n, r, i) {
                                                          this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
                                                        }

                                                        function z() {
                                                          this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = h, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(2 * g), this.dyn_dtree = new i.Buf16(2 * (2 * f + 1)), this.bl_tree = new i.Buf16(2 * (2 * m + 1)), k(this.dyn_ltree), k(this.dyn_dtree), k(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(v + 1), this.heap = new i.Buf16(2 * _ + 1), k(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(2 * _ + 1), k(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                                                        }

                                                        function M(e) {
                                                          var t;
                                                          return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = p, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? S : x, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, o._tr_init(t), d) : E(e, u);
                                                        }

                                                        function L(e) {
                                                          var t,
                                                              n = M(e);
                                                          return n === d && ((t = e.state).window_size = 2 * t.w_size, k(t.head), t.max_lazy_match = r[t.level].max_lazy, t.good_match = r[t.level].good_length, t.nice_match = r[t.level].nice_length, t.max_chain_length = r[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = b - 1, t.match_available = 0, t.ins_h = 0), n;
                                                        }

                                                        function U(e, t, n, r, o, a) {
                                                          if (!e) return u;
                                                          var s = 1;
                                                          if (-1 === t && (t = 6), r < 0 ? (s = 0, r = -r) : 15 < r && (s = 2, r -= 16), o < 1 || 9 < o || n !== h || r < 8 || 15 < r || t < 0 || 9 < t || a < 0 || 4 < a) return E(e, u);
                                                          8 === r && (r = 9);
                                                          var c = new z();
                                                          return (e.state = c).strm = e, c.wrap = s, c.gzhead = null, c.w_bits = r, c.w_size = 1 << c.w_bits, c.w_mask = c.w_size - 1, c.hash_bits = o + 7, c.hash_size = 1 << c.hash_bits, c.hash_mask = c.hash_size - 1, c.hash_shift = ~~((c.hash_bits + b - 1) / b), c.window = new i.Buf8(2 * c.w_size), c.head = new i.Buf16(c.hash_size), c.prev = new i.Buf16(c.w_size), c.lit_bufsize = 1 << o + 6, c.pending_buf_size = 4 * c.lit_bufsize, c.pending_buf = new i.Buf8(c.pending_buf_size), c.d_buf = 1 * c.lit_bufsize, c.l_buf = 3 * c.lit_bufsize, c.level = t, c.strategy = a, c.method = n, L(e);
                                                        }

                                                        r = [new D(0, 0, 0, 0, function (e, t) {
                                                          var n = 65535;

                                                          for (n > e.pending_buf_size - 5 && (n = e.pending_buf_size - 5);;) {
                                                            if (e.lookahead <= 1) {
                                                              if (N(e), 0 === e.lookahead && t === l) return 1;
                                                              if (0 === e.lookahead) break;
                                                            }

                                                            e.strstart += e.lookahead, e.lookahead = 0;
                                                            var r = e.block_start + n;
                                                            if ((0 === e.strstart || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, I(e, !1), 0 === e.strm.avail_out)) return 1;
                                                            if (e.strstart - e.block_start >= e.w_size - w && (I(e, !1), 0 === e.strm.avail_out)) return 1;
                                                          }

                                                          return e.insert = 0, 4 === t ? (I(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (I(e, !1), e.strm.avail_out), 1);
                                                        }), new D(4, 4, 8, 4, P), new D(4, 5, 16, 8, P), new D(4, 6, 32, 32, P), new D(4, 4, 16, 16, j), new D(8, 16, 32, 32, j), new D(8, 16, 128, 128, j), new D(8, 32, 128, 256, j), new D(32, 128, 258, 1024, j), new D(32, 258, 258, 4096, j)], n.deflateInit = function (e, t) {
                                                          return U(e, t, h, 15, 8, 0);
                                                        }, n.deflateInit2 = U, n.deflateReset = L, n.deflateResetKeep = M, n.deflateSetHeader = function (e, t) {
                                                          return e && e.state ? 2 !== e.state.wrap ? u : (e.state.gzhead = t, d) : u;
                                                        }, n.deflate = function (e, t) {
                                                          var n, i, a, c;
                                                          if (!e || !e.state || 5 < t || t < 0) return e ? E(e, u) : u;
                                                          if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && 4 !== t) return E(e, 0 === e.avail_out ? -5 : u);
                                                          if (i.strm = e, n = i.last_flush, i.last_flush = t, i.status === S) if (2 === i.wrap) e.adler = 0, T(i, 31), T(i, 139), T(i, 8), i.gzhead ? (T(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), T(i, 255 & i.gzhead.time), T(i, i.gzhead.time >> 8 & 255), T(i, i.gzhead.time >> 16 & 255), T(i, i.gzhead.time >> 24 & 255), T(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), T(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (T(i, 255 & i.gzhead.extra.length), T(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = s(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (T(i, 0), T(i, 0), T(i, 0), T(i, 0), T(i, 0), T(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), T(i, 3), i.status = x);else {
                                                            var p = h + (i.w_bits - 8 << 4) << 8;
                                                            p |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (p |= 32), p += 31 - p % 31, i.status = x, O(i, p), 0 !== i.strstart && (O(i, e.adler >>> 16), O(i, 65535 & e.adler)), e.adler = 1;
                                                          }
                                                          if (69 === i.status) if (i.gzhead.extra) {
                                                            for (a = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), A(e), a = i.pending, i.pending !== i.pending_buf_size));) {
                                                              T(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                                                            }

                                                            i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                                                          } else i.status = 73;
                                                          if (73 === i.status) if (i.gzhead.name) {
                                                            a = i.pending;

                                                            do {
                                                              if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), A(e), a = i.pending, i.pending === i.pending_buf_size)) {
                                                                c = 1;
                                                                break;
                                                              }

                                                              c = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, T(i, c);
                                                            } while (0 !== c);

                                                            i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), 0 === c && (i.gzindex = 0, i.status = 91);
                                                          } else i.status = 91;
                                                          if (91 === i.status) if (i.gzhead.comment) {
                                                            a = i.pending;

                                                            do {
                                                              if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), A(e), a = i.pending, i.pending === i.pending_buf_size)) {
                                                                c = 1;
                                                                break;
                                                              }

                                                              c = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, T(i, c);
                                                            } while (0 !== c);

                                                            i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), 0 === c && (i.status = 103);
                                                          } else i.status = 103;

                                                          if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && A(e), i.pending + 2 <= i.pending_buf_size && (T(i, 255 & e.adler), T(i, e.adler >> 8 & 255), e.adler = 0, i.status = x)) : i.status = x), 0 !== i.pending) {
                                                            if (A(e), 0 === e.avail_out) return i.last_flush = -1, d;
                                                          } else if (0 === e.avail_in && C(t) <= C(n) && 4 !== t) return E(e, -5);

                                                          if (666 === i.status && 0 !== e.avail_in) return E(e, -5);

                                                          if (0 !== e.avail_in || 0 !== i.lookahead || t !== l && 666 !== i.status) {
                                                            var _ = 2 === i.strategy ? function (e, t) {
                                                              for (var n;;) {
                                                                if (0 === e.lookahead && (N(e), 0 === e.lookahead)) {
                                                                  if (t === l) return 1;
                                                                  break;
                                                                }

                                                                if (e.match_length = 0, n = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (I(e, !1), 0 === e.strm.avail_out)) return 1;
                                                              }

                                                              return e.insert = 0, 4 === t ? (I(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (I(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                            }(i, t) : 3 === i.strategy ? function (e, t) {
                                                              for (var n, r, i, a, s = e.window;;) {
                                                                if (e.lookahead <= y) {
                                                                  if (N(e), e.lookahead <= y && t === l) return 1;
                                                                  if (0 === e.lookahead) break;
                                                                }

                                                                if (e.match_length = 0, e.lookahead >= b && 0 < e.strstart && (r = s[i = e.strstart - 1]) === s[++i] && r === s[++i] && r === s[++i]) {
                                                                  a = e.strstart + y;

                                                                  do {} while (r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && i < a);

                                                                  e.match_length = y - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                                                }

                                                                if (e.match_length >= b ? (n = o._tr_tally(e, 1, e.match_length - b), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (I(e, !1), 0 === e.strm.avail_out)) return 1;
                                                              }

                                                              return e.insert = 0, 4 === t ? (I(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (I(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                            }(i, t) : r[i.level].func(i, t);

                                                            if (3 !== _ && 4 !== _ || (i.status = 666), 1 === _ || 3 === _) return 0 === e.avail_out && (i.last_flush = -1), d;
                                                            if (2 === _ && (1 === t ? o._tr_align(i) : 5 !== t && (o._tr_stored_block(i, 0, 0, !1), 3 === t && (k(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), A(e), 0 === e.avail_out)) return i.last_flush = -1, d;
                                                          }

                                                          return 4 !== t ? d : i.wrap <= 0 ? 1 : (2 === i.wrap ? (T(i, 255 & e.adler), T(i, e.adler >> 8 & 255), T(i, e.adler >> 16 & 255), T(i, e.adler >> 24 & 255), T(i, 255 & e.total_in), T(i, e.total_in >> 8 & 255), T(i, e.total_in >> 16 & 255), T(i, e.total_in >> 24 & 255)) : (O(i, e.adler >>> 16), O(i, 65535 & e.adler)), A(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? d : 1);
                                                        }, n.deflateEnd = function (e) {
                                                          var t;
                                                          return e && e.state ? (t = e.state.status) !== S && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== x && 666 !== t ? E(e, u) : (e.state = null, t === x ? E(e, -3) : d) : u;
                                                        }, n.deflateSetDictionary = function (e, t) {
                                                          var n,
                                                              r,
                                                              o,
                                                              s,
                                                              c,
                                                              l,
                                                              p,
                                                              h,
                                                              _ = t.length;
                                                          if (!e || !e.state) return u;
                                                          if (2 === (s = (n = e.state).wrap) || 1 === s && n.status !== S || n.lookahead) return u;

                                                          for (1 === s && (e.adler = a(e.adler, t, _, 0)), n.wrap = 0, _ >= n.w_size && (0 === s && (k(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), h = new i.Buf8(n.w_size), i.arraySet(h, t, _ - n.w_size, n.w_size, 0), t = h, _ = n.w_size), c = e.avail_in, l = e.next_in, p = e.input, e.avail_in = _, e.next_in = 0, e.input = t, N(n); n.lookahead >= b;) {
                                                            for (r = n.strstart, o = n.lookahead - (b - 1); n.ins_h = (n.ins_h << n.hash_shift ^ n.window[r + b - 1]) & n.hash_mask, n.prev[r & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = r, r++, --o;) {
                                                              ;
                                                            }

                                                            n.strstart = r, n.lookahead = b - 1, N(n);
                                                          }

                                                          return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = b - 1, n.match_available = 0, e.next_in = l, e.input = p, e.avail_in = c, n.wrap = s, d;
                                                        }, n.deflateInfo = "pako deflate (from Nodeca project)";
                                                      }, {
                                                        "../utils/common": 41,
                                                        "./adler32": 43,
                                                        "./crc32": 45,
                                                        "./messages": 51,
                                                        "./trees": 52
                                                      }],
                                                      47: [function (e, t, n) {
                                                        t.exports = function () {
                                                          this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                                                        };
                                                      }, {}],
                                                      48: [function (e, t, n) {
                                                        t.exports = function (e, t) {
                                                          var n, r, i, o, a, s, c, l, d, u, p, h, _, f, m, g, v, b, y, w, S, x, E, C, k;

                                                          n = e.state, r = e.next_in, C = e.input, i = r + (e.avail_in - 5), o = e.next_out, k = e.output, a = o - (t - e.avail_out), s = o + (e.avail_out - 257), c = n.dmax, l = n.wsize, d = n.whave, u = n.wnext, p = n.window, h = n.hold, _ = n.bits, f = n.lencode, m = n.distcode, g = (1 << n.lenbits) - 1, v = (1 << n.distbits) - 1;

                                                          e: do {
                                                            _ < 15 && (h += C[r++] << _, _ += 8, h += C[r++] << _, _ += 8), b = f[h & g];

                                                            t: for (;;) {
                                                              if (h >>>= y = b >>> 24, _ -= y, 0 == (y = b >>> 16 & 255)) k[o++] = 65535 & b;else {
                                                                if (!(16 & y)) {
                                                                  if (0 == (64 & y)) {
                                                                    b = f[(65535 & b) + (h & (1 << y) - 1)];
                                                                    continue t;
                                                                  }

                                                                  if (32 & y) {
                                                                    n.mode = 12;
                                                                    break e;
                                                                  }

                                                                  e.msg = "invalid literal/length code", n.mode = 30;
                                                                  break e;
                                                                }

                                                                w = 65535 & b, (y &= 15) && (_ < y && (h += C[r++] << _, _ += 8), w += h & (1 << y) - 1, h >>>= y, _ -= y), _ < 15 && (h += C[r++] << _, _ += 8, h += C[r++] << _, _ += 8), b = m[h & v];

                                                                n: for (;;) {
                                                                  if (h >>>= y = b >>> 24, _ -= y, !(16 & (y = b >>> 16 & 255))) {
                                                                    if (0 == (64 & y)) {
                                                                      b = m[(65535 & b) + (h & (1 << y) - 1)];
                                                                      continue n;
                                                                    }

                                                                    e.msg = "invalid distance code", n.mode = 30;
                                                                    break e;
                                                                  }

                                                                  if (S = 65535 & b, _ < (y &= 15) && (h += C[r++] << _, (_ += 8) < y && (h += C[r++] << _, _ += 8)), c < (S += h & (1 << y) - 1)) {
                                                                    e.msg = "invalid distance too far back", n.mode = 30;
                                                                    break e;
                                                                  }

                                                                  if (h >>>= y, _ -= y, (y = o - a) < S) {
                                                                    if (d < (y = S - y) && n.sane) {
                                                                      e.msg = "invalid distance too far back", n.mode = 30;
                                                                      break e;
                                                                    }

                                                                    if (E = p, (x = 0) === u) {
                                                                      if (x += l - y, y < w) {
                                                                        for (w -= y; k[o++] = p[x++], --y;) {
                                                                          ;
                                                                        }

                                                                        x = o - S, E = k;
                                                                      }
                                                                    } else if (u < y) {
                                                                      if (x += l + u - y, (y -= u) < w) {
                                                                        for (w -= y; k[o++] = p[x++], --y;) {
                                                                          ;
                                                                        }

                                                                        if (x = 0, u < w) {
                                                                          for (w -= y = u; k[o++] = p[x++], --y;) {
                                                                            ;
                                                                          }

                                                                          x = o - S, E = k;
                                                                        }
                                                                      }
                                                                    } else if (x += u - y, y < w) {
                                                                      for (w -= y; k[o++] = p[x++], --y;) {
                                                                        ;
                                                                      }

                                                                      x = o - S, E = k;
                                                                    }

                                                                    for (; 2 < w;) {
                                                                      k[o++] = E[x++], k[o++] = E[x++], k[o++] = E[x++], w -= 3;
                                                                    }

                                                                    w && (k[o++] = E[x++], 1 < w && (k[o++] = E[x++]));
                                                                  } else {
                                                                    for (x = o - S; k[o++] = k[x++], k[o++] = k[x++], k[o++] = k[x++], 2 < (w -= 3);) {
                                                                      ;
                                                                    }

                                                                    w && (k[o++] = k[x++], 1 < w && (k[o++] = k[x++]));
                                                                  }

                                                                  break;
                                                                }
                                                              }
                                                              break;
                                                            }
                                                          } while (r < i && o < s);

                                                          r -= w = _ >> 3, h &= (1 << (_ -= w << 3)) - 1, e.next_in = r, e.next_out = o, e.avail_in = r < i ? i - r + 5 : 5 - (r - i), e.avail_out = o < s ? s - o + 257 : 257 - (o - s), n.hold = h, n.bits = _;
                                                        };
                                                      }, {}],
                                                      49: [function (e, t, n) {
                                                        var r = e("../utils/common"),
                                                            i = e("./adler32"),
                                                            o = e("./crc32"),
                                                            a = e("./inffast"),
                                                            s = e("./inftrees"),
                                                            c = 1,
                                                            l = 2,
                                                            d = 0,
                                                            u = -2,
                                                            p = 1,
                                                            h = 852,
                                                            _ = 592;

                                                        function f(e) {
                                                          return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                                                        }

                                                        function m() {
                                                          this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new r.Buf16(320), this.work = new r.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                                                        }

                                                        function g(e) {
                                                          var t;
                                                          return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = p, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new r.Buf32(h), t.distcode = t.distdyn = new r.Buf32(_), t.sane = 1, t.back = -1, d) : u;
                                                        }

                                                        function v(e) {
                                                          var t;
                                                          return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, g(e)) : u;
                                                        }

                                                        function b(e, t) {
                                                          var n, r;
                                                          return e && e.state ? (r = e.state, t < 0 ? (n = 0, t = -t) : (n = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? u : (null !== r.window && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, v(e))) : u;
                                                        }

                                                        function y(e, t) {
                                                          var n, r;
                                                          return e ? (r = new m(), (e.state = r).window = null, (n = b(e, t)) !== d && (e.state = null), n) : u;
                                                        }

                                                        var w,
                                                            S,
                                                            x = !0;

                                                        function E(e) {
                                                          if (x) {
                                                            var t;

                                                            for (w = new r.Buf32(512), S = new r.Buf32(32), t = 0; t < 144;) {
                                                              e.lens[t++] = 8;
                                                            }

                                                            for (; t < 256;) {
                                                              e.lens[t++] = 9;
                                                            }

                                                            for (; t < 280;) {
                                                              e.lens[t++] = 7;
                                                            }

                                                            for (; t < 288;) {
                                                              e.lens[t++] = 8;
                                                            }

                                                            for (s(c, e.lens, 0, 288, w, 0, e.work, {
                                                              bits: 9
                                                            }), t = 0; t < 32;) {
                                                              e.lens[t++] = 5;
                                                            }

                                                            s(l, e.lens, 0, 32, S, 0, e.work, {
                                                              bits: 5
                                                            }), x = !1;
                                                          }

                                                          e.lencode = w, e.lenbits = 9, e.distcode = S, e.distbits = 5;
                                                        }

                                                        function C(e, t, n, i) {
                                                          var o,
                                                              a = e.state;
                                                          return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new r.Buf8(a.wsize)), i >= a.wsize ? (r.arraySet(a.window, t, n - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i < (o = a.wsize - a.wnext) && (o = i), r.arraySet(a.window, t, n - i, o, a.wnext), (i -= o) ? (r.arraySet(a.window, t, n - i, i, 0), a.wnext = i, a.whave = a.wsize) : (a.wnext += o, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += o))), 0;
                                                        }

                                                        n.inflateReset = v, n.inflateReset2 = b, n.inflateResetKeep = g, n.inflateInit = function (e) {
                                                          return y(e, 15);
                                                        }, n.inflateInit2 = y, n.inflate = function (e, t) {
                                                          var n,
                                                              h,
                                                              _,
                                                              m,
                                                              g,
                                                              v,
                                                              b,
                                                              y,
                                                              w,
                                                              S,
                                                              x,
                                                              k,
                                                              A,
                                                              I,
                                                              T,
                                                              O,
                                                              R,
                                                              N,
                                                              P,
                                                              j,
                                                              D,
                                                              z,
                                                              M,
                                                              L,
                                                              U = 0,
                                                              B = new r.Buf8(4),
                                                              H = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

                                                          if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return u;
                                                          12 === (n = e.state).mode && (n.mode = 13), g = e.next_out, _ = e.output, b = e.avail_out, m = e.next_in, h = e.input, v = e.avail_in, y = n.hold, w = n.bits, S = v, x = b, z = d;

                                                          e: for (;;) {
                                                            switch (n.mode) {
                                                              case p:
                                                                if (0 === n.wrap) {
                                                                  n.mode = 13;
                                                                  break;
                                                                }

                                                                for (; w < 16;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                if (2 & n.wrap && 35615 === y) {
                                                                  B[n.check = 0] = 255 & y, B[1] = y >>> 8 & 255, n.check = o(n.check, B, 2, 0), w = y = 0, n.mode = 2;
                                                                  break;
                                                                }

                                                                if (n.flags = 0, n.head && (n.head.done = !1), !(1 & n.wrap) || (((255 & y) << 8) + (y >> 8)) % 31) {
                                                                  e.msg = "incorrect header check", n.mode = 30;
                                                                  break;
                                                                }

                                                                if (8 != (15 & y)) {
                                                                  e.msg = "unknown compression method", n.mode = 30;
                                                                  break;
                                                                }

                                                                if (w -= 4, D = 8 + (15 & (y >>>= 4)), 0 === n.wbits) n.wbits = D;else if (D > n.wbits) {
                                                                  e.msg = "invalid window size", n.mode = 30;
                                                                  break;
                                                                }
                                                                n.dmax = 1 << D, e.adler = n.check = 1, n.mode = 512 & y ? 10 : 12, w = y = 0;
                                                                break;

                                                              case 2:
                                                                for (; w < 16;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                if (n.flags = y, 8 != (255 & n.flags)) {
                                                                  e.msg = "unknown compression method", n.mode = 30;
                                                                  break;
                                                                }

                                                                if (57344 & n.flags) {
                                                                  e.msg = "unknown header flags set", n.mode = 30;
                                                                  break;
                                                                }

                                                                n.head && (n.head.text = y >> 8 & 1), 512 & n.flags && (B[0] = 255 & y, B[1] = y >>> 8 & 255, n.check = o(n.check, B, 2, 0)), w = y = 0, n.mode = 3;

                                                              case 3:
                                                                for (; w < 32;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                n.head && (n.head.time = y), 512 & n.flags && (B[0] = 255 & y, B[1] = y >>> 8 & 255, B[2] = y >>> 16 & 255, B[3] = y >>> 24 & 255, n.check = o(n.check, B, 4, 0)), w = y = 0, n.mode = 4;

                                                              case 4:
                                                                for (; w < 16;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                n.head && (n.head.xflags = 255 & y, n.head.os = y >> 8), 512 & n.flags && (B[0] = 255 & y, B[1] = y >>> 8 & 255, n.check = o(n.check, B, 2, 0)), w = y = 0, n.mode = 5;

                                                              case 5:
                                                                if (1024 & n.flags) {
                                                                  for (; w < 16;) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  n.length = y, n.head && (n.head.extra_len = y), 512 & n.flags && (B[0] = 255 & y, B[1] = y >>> 8 & 255, n.check = o(n.check, B, 2, 0)), w = y = 0;
                                                                } else n.head && (n.head.extra = null);

                                                                n.mode = 6;

                                                              case 6:
                                                                if (1024 & n.flags && (v < (k = n.length) && (k = v), k && (n.head && (D = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Array(n.head.extra_len)), r.arraySet(n.head.extra, h, m, k, D)), 512 & n.flags && (n.check = o(n.check, h, k, m)), v -= k, m += k, n.length -= k), n.length)) break e;
                                                                n.length = 0, n.mode = 7;

                                                              case 7:
                                                                if (2048 & n.flags) {
                                                                  if (0 === v) break e;

                                                                  for (k = 0; D = h[m + k++], n.head && D && n.length < 65536 && (n.head.name += String.fromCharCode(D)), D && k < v;) {
                                                                    ;
                                                                  }

                                                                  if (512 & n.flags && (n.check = o(n.check, h, k, m)), v -= k, m += k, D) break e;
                                                                } else n.head && (n.head.name = null);

                                                                n.length = 0, n.mode = 8;

                                                              case 8:
                                                                if (4096 & n.flags) {
                                                                  if (0 === v) break e;

                                                                  for (k = 0; D = h[m + k++], n.head && D && n.length < 65536 && (n.head.comment += String.fromCharCode(D)), D && k < v;) {
                                                                    ;
                                                                  }

                                                                  if (512 & n.flags && (n.check = o(n.check, h, k, m)), v -= k, m += k, D) break e;
                                                                } else n.head && (n.head.comment = null);

                                                                n.mode = 9;

                                                              case 9:
                                                                if (512 & n.flags) {
                                                                  for (; w < 16;) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  if (y !== (65535 & n.check)) {
                                                                    e.msg = "header crc mismatch", n.mode = 30;
                                                                    break;
                                                                  }

                                                                  w = y = 0;
                                                                }

                                                                n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = 12;
                                                                break;

                                                              case 10:
                                                                for (; w < 32;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                e.adler = n.check = f(y), w = y = 0, n.mode = 11;

                                                              case 11:
                                                                if (0 === n.havedict) return e.next_out = g, e.avail_out = b, e.next_in = m, e.avail_in = v, n.hold = y, n.bits = w, 2;
                                                                e.adler = n.check = 1, n.mode = 12;

                                                              case 12:
                                                                if (5 === t || 6 === t) break e;

                                                              case 13:
                                                                if (n.last) {
                                                                  y >>>= 7 & w, w -= 7 & w, n.mode = 27;
                                                                  break;
                                                                }

                                                                for (; w < 3;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                switch (n.last = 1 & y, w -= 1, 3 & (y >>>= 1)) {
                                                                  case 0:
                                                                    n.mode = 14;
                                                                    break;

                                                                  case 1:
                                                                    if (E(n), n.mode = 20, 6 !== t) break;
                                                                    y >>>= 2, w -= 2;
                                                                    break e;

                                                                  case 2:
                                                                    n.mode = 17;
                                                                    break;

                                                                  case 3:
                                                                    e.msg = "invalid block type", n.mode = 30;
                                                                }

                                                                y >>>= 2, w -= 2;
                                                                break;

                                                              case 14:
                                                                for (y >>>= 7 & w, w -= 7 & w; w < 32;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                if ((65535 & y) != (y >>> 16 ^ 65535)) {
                                                                  e.msg = "invalid stored block lengths", n.mode = 30;
                                                                  break;
                                                                }

                                                                if (n.length = 65535 & y, w = y = 0, n.mode = 15, 6 === t) break e;

                                                              case 15:
                                                                n.mode = 16;

                                                              case 16:
                                                                if (k = n.length) {
                                                                  if (v < k && (k = v), b < k && (k = b), 0 === k) break e;
                                                                  r.arraySet(_, h, m, k, g), v -= k, m += k, b -= k, g += k, n.length -= k;
                                                                  break;
                                                                }

                                                                n.mode = 12;
                                                                break;

                                                              case 17:
                                                                for (; w < 14;) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                if (n.nlen = 257 + (31 & y), y >>>= 5, w -= 5, n.ndist = 1 + (31 & y), y >>>= 5, w -= 5, n.ncode = 4 + (15 & y), y >>>= 4, w -= 4, 286 < n.nlen || 30 < n.ndist) {
                                                                  e.msg = "too many length or distance symbols", n.mode = 30;
                                                                  break;
                                                                }

                                                                n.have = 0, n.mode = 18;

                                                              case 18:
                                                                for (; n.have < n.ncode;) {
                                                                  for (; w < 3;) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  n.lens[H[n.have++]] = 7 & y, y >>>= 3, w -= 3;
                                                                }

                                                                for (; n.have < 19;) {
                                                                  n.lens[H[n.have++]] = 0;
                                                                }

                                                                if (n.lencode = n.lendyn, n.lenbits = 7, M = {
                                                                  bits: n.lenbits
                                                                }, z = s(0, n.lens, 0, 19, n.lencode, 0, n.work, M), n.lenbits = M.bits, z) {
                                                                  e.msg = "invalid code lengths set", n.mode = 30;
                                                                  break;
                                                                }

                                                                n.have = 0, n.mode = 19;

                                                              case 19:
                                                                for (; n.have < n.nlen + n.ndist;) {
                                                                  for (; O = (U = n.lencode[y & (1 << n.lenbits) - 1]) >>> 16 & 255, R = 65535 & U, !((T = U >>> 24) <= w);) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  if (R < 16) y >>>= T, w -= T, n.lens[n.have++] = R;else {
                                                                    if (16 === R) {
                                                                      for (L = T + 2; w < L;) {
                                                                        if (0 === v) break e;
                                                                        v--, y += h[m++] << w, w += 8;
                                                                      }

                                                                      if (y >>>= T, w -= T, 0 === n.have) {
                                                                        e.msg = "invalid bit length repeat", n.mode = 30;
                                                                        break;
                                                                      }

                                                                      D = n.lens[n.have - 1], k = 3 + (3 & y), y >>>= 2, w -= 2;
                                                                    } else if (17 === R) {
                                                                      for (L = T + 3; w < L;) {
                                                                        if (0 === v) break e;
                                                                        v--, y += h[m++] << w, w += 8;
                                                                      }

                                                                      w -= T, D = 0, k = 3 + (7 & (y >>>= T)), y >>>= 3, w -= 3;
                                                                    } else {
                                                                      for (L = T + 7; w < L;) {
                                                                        if (0 === v) break e;
                                                                        v--, y += h[m++] << w, w += 8;
                                                                      }

                                                                      w -= T, D = 0, k = 11 + (127 & (y >>>= T)), y >>>= 7, w -= 7;
                                                                    }

                                                                    if (n.have + k > n.nlen + n.ndist) {
                                                                      e.msg = "invalid bit length repeat", n.mode = 30;
                                                                      break;
                                                                    }

                                                                    for (; k--;) {
                                                                      n.lens[n.have++] = D;
                                                                    }
                                                                  }
                                                                }

                                                                if (30 === n.mode) break;

                                                                if (0 === n.lens[256]) {
                                                                  e.msg = "invalid code -- missing end-of-block", n.mode = 30;
                                                                  break;
                                                                }

                                                                if (n.lenbits = 9, M = {
                                                                  bits: n.lenbits
                                                                }, z = s(c, n.lens, 0, n.nlen, n.lencode, 0, n.work, M), n.lenbits = M.bits, z) {
                                                                  e.msg = "invalid literal/lengths set", n.mode = 30;
                                                                  break;
                                                                }

                                                                if (n.distbits = 6, n.distcode = n.distdyn, M = {
                                                                  bits: n.distbits
                                                                }, z = s(l, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, M), n.distbits = M.bits, z) {
                                                                  e.msg = "invalid distances set", n.mode = 30;
                                                                  break;
                                                                }

                                                                if (n.mode = 20, 6 === t) break e;

                                                              case 20:
                                                                n.mode = 21;

                                                              case 21:
                                                                if (6 <= v && 258 <= b) {
                                                                  e.next_out = g, e.avail_out = b, e.next_in = m, e.avail_in = v, n.hold = y, n.bits = w, a(e, x), g = e.next_out, _ = e.output, b = e.avail_out, m = e.next_in, h = e.input, v = e.avail_in, y = n.hold, w = n.bits, 12 === n.mode && (n.back = -1);
                                                                  break;
                                                                }

                                                                for (n.back = 0; O = (U = n.lencode[y & (1 << n.lenbits) - 1]) >>> 16 & 255, R = 65535 & U, !((T = U >>> 24) <= w);) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                if (O && 0 == (240 & O)) {
                                                                  for (N = T, P = O, j = R; O = (U = n.lencode[j + ((y & (1 << N + P) - 1) >> N)]) >>> 16 & 255, R = 65535 & U, !(N + (T = U >>> 24) <= w);) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  y >>>= N, w -= N, n.back += N;
                                                                }

                                                                if (y >>>= T, w -= T, n.back += T, n.length = R, 0 === O) {
                                                                  n.mode = 26;
                                                                  break;
                                                                }

                                                                if (32 & O) {
                                                                  n.back = -1, n.mode = 12;
                                                                  break;
                                                                }

                                                                if (64 & O) {
                                                                  e.msg = "invalid literal/length code", n.mode = 30;
                                                                  break;
                                                                }

                                                                n.extra = 15 & O, n.mode = 22;

                                                              case 22:
                                                                if (n.extra) {
                                                                  for (L = n.extra; w < L;) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  n.length += y & (1 << n.extra) - 1, y >>>= n.extra, w -= n.extra, n.back += n.extra;
                                                                }

                                                                n.was = n.length, n.mode = 23;

                                                              case 23:
                                                                for (; O = (U = n.distcode[y & (1 << n.distbits) - 1]) >>> 16 & 255, R = 65535 & U, !((T = U >>> 24) <= w);) {
                                                                  if (0 === v) break e;
                                                                  v--, y += h[m++] << w, w += 8;
                                                                }

                                                                if (0 == (240 & O)) {
                                                                  for (N = T, P = O, j = R; O = (U = n.distcode[j + ((y & (1 << N + P) - 1) >> N)]) >>> 16 & 255, R = 65535 & U, !(N + (T = U >>> 24) <= w);) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  y >>>= N, w -= N, n.back += N;
                                                                }

                                                                if (y >>>= T, w -= T, n.back += T, 64 & O) {
                                                                  e.msg = "invalid distance code", n.mode = 30;
                                                                  break;
                                                                }

                                                                n.offset = R, n.extra = 15 & O, n.mode = 24;

                                                              case 24:
                                                                if (n.extra) {
                                                                  for (L = n.extra; w < L;) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  n.offset += y & (1 << n.extra) - 1, y >>>= n.extra, w -= n.extra, n.back += n.extra;
                                                                }

                                                                if (n.offset > n.dmax) {
                                                                  e.msg = "invalid distance too far back", n.mode = 30;
                                                                  break;
                                                                }

                                                                n.mode = 25;

                                                              case 25:
                                                                if (0 === b) break e;

                                                                if (k = x - b, n.offset > k) {
                                                                  if ((k = n.offset - k) > n.whave && n.sane) {
                                                                    e.msg = "invalid distance too far back", n.mode = 30;
                                                                    break;
                                                                  }

                                                                  A = k > n.wnext ? (k -= n.wnext, n.wsize - k) : n.wnext - k, k > n.length && (k = n.length), I = n.window;
                                                                } else I = _, A = g - n.offset, k = n.length;

                                                                for (b < k && (k = b), b -= k, n.length -= k; _[g++] = I[A++], --k;) {
                                                                  ;
                                                                }

                                                                0 === n.length && (n.mode = 21);
                                                                break;

                                                              case 26:
                                                                if (0 === b) break e;
                                                                _[g++] = n.length, b--, n.mode = 21;
                                                                break;

                                                              case 27:
                                                                if (n.wrap) {
                                                                  for (; w < 32;) {
                                                                    if (0 === v) break e;
                                                                    v--, y |= h[m++] << w, w += 8;
                                                                  }

                                                                  if (x -= b, e.total_out += x, n.total += x, x && (e.adler = n.check = n.flags ? o(n.check, _, x, g - x) : i(n.check, _, x, g - x)), x = b, (n.flags ? y : f(y)) !== n.check) {
                                                                    e.msg = "incorrect data check", n.mode = 30;
                                                                    break;
                                                                  }

                                                                  w = y = 0;
                                                                }

                                                                n.mode = 28;

                                                              case 28:
                                                                if (n.wrap && n.flags) {
                                                                  for (; w < 32;) {
                                                                    if (0 === v) break e;
                                                                    v--, y += h[m++] << w, w += 8;
                                                                  }

                                                                  if (y !== (4294967295 & n.total)) {
                                                                    e.msg = "incorrect length check", n.mode = 30;
                                                                    break;
                                                                  }

                                                                  w = y = 0;
                                                                }

                                                                n.mode = 29;

                                                              case 29:
                                                                z = 1;
                                                                break e;

                                                              case 30:
                                                                z = -3;
                                                                break e;

                                                              case 31:
                                                                return -4;

                                                              default:
                                                                return u;
                                                            }
                                                          }

                                                          return e.next_out = g, e.avail_out = b, e.next_in = m, e.avail_in = v, n.hold = y, n.bits = w, (n.wsize || x !== e.avail_out && n.mode < 30 && (n.mode < 27 || 4 !== t)) && C(e, e.output, e.next_out, x - e.avail_out) ? (n.mode = 31, -4) : (S -= e.avail_in, x -= e.avail_out, e.total_in += S, e.total_out += x, n.total += x, n.wrap && x && (e.adler = n.check = n.flags ? o(n.check, _, x, e.next_out - x) : i(n.check, _, x, e.next_out - x)), e.data_type = n.bits + (n.last ? 64 : 0) + (12 === n.mode ? 128 : 0) + (20 === n.mode || 15 === n.mode ? 256 : 0), (0 == S && 0 === x || 4 === t) && z === d && (z = -5), z);
                                                        }, n.inflateEnd = function (e) {
                                                          if (!e || !e.state) return u;
                                                          var t = e.state;
                                                          return t.window && (t.window = null), e.state = null, d;
                                                        }, n.inflateGetHeader = function (e, t) {
                                                          var n;
                                                          return e && e.state ? 0 == (2 & (n = e.state).wrap) ? u : ((n.head = t).done = !1, d) : u;
                                                        }, n.inflateSetDictionary = function (e, t) {
                                                          var n,
                                                              r = t.length;
                                                          return e && e.state ? 0 !== (n = e.state).wrap && 11 !== n.mode ? u : 11 === n.mode && i(1, t, r, 0) !== n.check ? -3 : C(e, t, r, r) ? (n.mode = 31, -4) : (n.havedict = 1, d) : u;
                                                        }, n.inflateInfo = "pako inflate (from Nodeca project)";
                                                      }, {
                                                        "../utils/common": 41,
                                                        "./adler32": 43,
                                                        "./crc32": 45,
                                                        "./inffast": 48,
                                                        "./inftrees": 50
                                                      }],
                                                      50: [function (e, t, n) {
                                                        var r = e("../utils/common"),
                                                            i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
                                                            o = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
                                                            a = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
                                                            s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

                                                        t.exports = function (e, t, n, c, l, d, u, p) {
                                                          var h,
                                                              _,
                                                              f,
                                                              m,
                                                              g,
                                                              v,
                                                              b,
                                                              y,
                                                              w,
                                                              S = p.bits,
                                                              x = 0,
                                                              E = 0,
                                                              C = 0,
                                                              k = 0,
                                                              A = 0,
                                                              I = 0,
                                                              T = 0,
                                                              O = 0,
                                                              R = 0,
                                                              N = 0,
                                                              P = null,
                                                              j = 0,
                                                              D = new r.Buf16(16),
                                                              z = new r.Buf16(16),
                                                              M = null,
                                                              L = 0;

                                                          for (x = 0; x <= 15; x++) {
                                                            D[x] = 0;
                                                          }

                                                          for (E = 0; E < c; E++) {
                                                            D[t[n + E]]++;
                                                          }

                                                          for (A = S, k = 15; 1 <= k && 0 === D[k]; k--) {
                                                            ;
                                                          }

                                                          if (k < A && (A = k), 0 === k) return l[d++] = 20971520, l[d++] = 20971520, p.bits = 1, 0;

                                                          for (C = 1; C < k && 0 === D[C]; C++) {
                                                            ;
                                                          }

                                                          for (A < C && (A = C), x = O = 1; x <= 15; x++) {
                                                            if (O <<= 1, (O -= D[x]) < 0) return -1;
                                                          }

                                                          if (0 < O && (0 === e || 1 !== k)) return -1;

                                                          for (z[1] = 0, x = 1; x < 15; x++) {
                                                            z[x + 1] = z[x] + D[x];
                                                          }

                                                          for (E = 0; E < c; E++) {
                                                            0 !== t[n + E] && (u[z[t[n + E]]++] = E);
                                                          }

                                                          if (v = 0 === e ? (P = M = u, 19) : 1 === e ? (P = i, j -= 257, M = o, L -= 257, 256) : (P = a, M = s, -1), x = C, g = d, T = E = N = 0, f = -1, m = (R = 1 << (I = A)) - 1, 1 === e && 852 < R || 2 === e && 592 < R) return 1;

                                                          for (;;) {
                                                            for (b = x - T, w = u[E] < v ? (y = 0, u[E]) : u[E] > v ? (y = M[L + u[E]], P[j + u[E]]) : (y = 96, 0), h = 1 << x - T, C = _ = 1 << I; l[g + (N >> T) + (_ -= h)] = b << 24 | y << 16 | w | 0, 0 !== _;) {
                                                              ;
                                                            }

                                                            for (h = 1 << x - 1; N & h;) {
                                                              h >>= 1;
                                                            }

                                                            if (0 !== h ? (N &= h - 1, N += h) : N = 0, E++, 0 == --D[x]) {
                                                              if (x === k) break;
                                                              x = t[n + u[E]];
                                                            }

                                                            if (A < x && (N & m) !== f) {
                                                              for (0 === T && (T = A), g += C, O = 1 << (I = x - T); I + T < k && !((O -= D[I + T]) <= 0);) {
                                                                I++, O <<= 1;
                                                              }

                                                              if (R += 1 << I, 1 === e && 852 < R || 2 === e && 592 < R) return 1;
                                                              l[f = N & m] = A << 24 | I << 16 | g - d | 0;
                                                            }
                                                          }

                                                          return 0 !== N && (l[g + N] = x - T << 24 | 64 << 16 | 0), p.bits = A, 0;
                                                        };
                                                      }, {
                                                        "../utils/common": 41
                                                      }],
                                                      51: [function (e, t, n) {
                                                        t.exports = {
                                                          2: "need dictionary",
                                                          1: "stream end",
                                                          0: "",
                                                          "-1": "file error",
                                                          "-2": "stream error",
                                                          "-3": "data error",
                                                          "-4": "insufficient memory",
                                                          "-5": "buffer error",
                                                          "-6": "incompatible version"
                                                        };
                                                      }, {}],
                                                      52: [function (e, t, n) {
                                                        var r = e("../utils/common");

                                                        function i(e) {
                                                          for (var t = e.length; 0 <= --t;) {
                                                            e[t] = 0;
                                                          }
                                                        }

                                                        var o = 15,
                                                            a = 16,
                                                            s = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
                                                            c = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
                                                            l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
                                                            d = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
                                                            u = new Array(576);
                                                        i(u);
                                                        var p = new Array(60);
                                                        i(p);
                                                        var h = new Array(512);
                                                        i(h);

                                                        var _ = new Array(256);

                                                        i(_);
                                                        var f = new Array(29);
                                                        i(f);
                                                        var m,
                                                            g,
                                                            v,
                                                            b = new Array(30);

                                                        function y(e, t, n, r, i) {
                                                          this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
                                                        }

                                                        function w(e, t) {
                                                          this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                                                        }

                                                        function S(e) {
                                                          return e < 256 ? h[e] : h[256 + (e >>> 7)];
                                                        }

                                                        function x(e, t) {
                                                          e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                                                        }

                                                        function E(e, t, n) {
                                                          e.bi_valid > a - n ? (e.bi_buf |= t << e.bi_valid & 65535, x(e, e.bi_buf), e.bi_buf = t >> a - e.bi_valid, e.bi_valid += n - a) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
                                                        }

                                                        function C(e, t, n) {
                                                          E(e, n[2 * t], n[2 * t + 1]);
                                                        }

                                                        function k(e, t) {
                                                          for (var n = 0; n |= 1 & e, e >>>= 1, n <<= 1, 0 < --t;) {
                                                            ;
                                                          }

                                                          return n >>> 1;
                                                        }

                                                        function A(e, t, n) {
                                                          var r,
                                                              i,
                                                              a = new Array(o + 1),
                                                              s = 0;

                                                          for (r = 1; r <= o; r++) {
                                                            a[r] = s = s + n[r - 1] << 1;
                                                          }

                                                          for (i = 0; i <= t; i++) {
                                                            var c = e[2 * i + 1];
                                                            0 !== c && (e[2 * i] = k(a[c]++, c));
                                                          }
                                                        }

                                                        function I(e) {
                                                          var t;

                                                          for (t = 0; t < 286; t++) {
                                                            e.dyn_ltree[2 * t] = 0;
                                                          }

                                                          for (t = 0; t < 30; t++) {
                                                            e.dyn_dtree[2 * t] = 0;
                                                          }

                                                          for (t = 0; t < 19; t++) {
                                                            e.bl_tree[2 * t] = 0;
                                                          }

                                                          e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                                                        }

                                                        function T(e) {
                                                          8 < e.bi_valid ? x(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                                                        }

                                                        function O(e, t, n, r) {
                                                          var i = 2 * t,
                                                              o = 2 * n;
                                                          return e[i] < e[o] || e[i] === e[o] && r[t] <= r[n];
                                                        }

                                                        function R(e, t, n) {
                                                          for (var r = e.heap[n], i = n << 1; i <= e.heap_len && (i < e.heap_len && O(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !O(t, r, e.heap[i], e.depth));) {
                                                            e.heap[n] = e.heap[i], n = i, i <<= 1;
                                                          }

                                                          e.heap[n] = r;
                                                        }

                                                        function N(e, t, n) {
                                                          var r,
                                                              i,
                                                              o,
                                                              a,
                                                              l = 0;
                                                          if (0 !== e.last_lit) for (; r = e.pending_buf[e.d_buf + 2 * l] << 8 | e.pending_buf[e.d_buf + 2 * l + 1], i = e.pending_buf[e.l_buf + l], l++, 0 === r ? C(e, i, t) : (C(e, (o = _[i]) + 256 + 1, t), 0 !== (a = s[o]) && E(e, i -= f[o], a), C(e, o = S(--r), n), 0 !== (a = c[o]) && E(e, r -= b[o], a)), l < e.last_lit;) {
                                                            ;
                                                          }
                                                          C(e, 256, t);
                                                        }

                                                        function P(e, t) {
                                                          var n,
                                                              r,
                                                              i,
                                                              a = t.dyn_tree,
                                                              s = t.stat_desc.static_tree,
                                                              c = t.stat_desc.has_stree,
                                                              l = t.stat_desc.elems,
                                                              d = -1;

                                                          for (e.heap_len = 0, e.heap_max = 573, n = 0; n < l; n++) {
                                                            0 !== a[2 * n] ? (e.heap[++e.heap_len] = d = n, e.depth[n] = 0) : a[2 * n + 1] = 0;
                                                          }

                                                          for (; e.heap_len < 2;) {
                                                            a[2 * (i = e.heap[++e.heap_len] = d < 2 ? ++d : 0)] = 1, e.depth[i] = 0, e.opt_len--, c && (e.static_len -= s[2 * i + 1]);
                                                          }

                                                          for (t.max_code = d, n = e.heap_len >> 1; 1 <= n; n--) {
                                                            R(e, a, n);
                                                          }

                                                          for (i = l; n = e.heap[1], e.heap[1] = e.heap[e.heap_len--], R(e, a, 1), r = e.heap[1], e.heap[--e.heap_max] = n, e.heap[--e.heap_max] = r, a[2 * i] = a[2 * n] + a[2 * r], e.depth[i] = (e.depth[n] >= e.depth[r] ? e.depth[n] : e.depth[r]) + 1, a[2 * n + 1] = a[2 * r + 1] = i, e.heap[1] = i++, R(e, a, 1), 2 <= e.heap_len;) {
                                                            ;
                                                          }

                                                          e.heap[--e.heap_max] = e.heap[1], function (e, t) {
                                                            var n,
                                                                r,
                                                                i,
                                                                a,
                                                                s,
                                                                c,
                                                                l = t.dyn_tree,
                                                                d = t.max_code,
                                                                u = t.stat_desc.static_tree,
                                                                p = t.stat_desc.has_stree,
                                                                h = t.stat_desc.extra_bits,
                                                                _ = t.stat_desc.extra_base,
                                                                f = t.stat_desc.max_length,
                                                                m = 0;

                                                            for (a = 0; a <= o; a++) {
                                                              e.bl_count[a] = 0;
                                                            }

                                                            for (l[2 * e.heap[e.heap_max] + 1] = 0, n = e.heap_max + 1; n < 573; n++) {
                                                              f < (a = l[2 * l[2 * (r = e.heap[n]) + 1] + 1] + 1) && (a = f, m++), l[2 * r + 1] = a, d < r || (e.bl_count[a]++, s = 0, _ <= r && (s = h[r - _]), c = l[2 * r], e.opt_len += c * (a + s), p && (e.static_len += c * (u[2 * r + 1] + s)));
                                                            }

                                                            if (0 !== m) {
                                                              do {
                                                                for (a = f - 1; 0 === e.bl_count[a];) {
                                                                  a--;
                                                                }

                                                                e.bl_count[a]--, e.bl_count[a + 1] += 2, e.bl_count[f]--, m -= 2;
                                                              } while (0 < m);

                                                              for (a = f; 0 !== a; a--) {
                                                                for (r = e.bl_count[a]; 0 !== r;) {
                                                                  d < (i = e.heap[--n]) || (l[2 * i + 1] !== a && (e.opt_len += (a - l[2 * i + 1]) * l[2 * i], l[2 * i + 1] = a), r--);
                                                                }
                                                              }
                                                            }
                                                          }(e, t), A(a, d, e.bl_count);
                                                        }

                                                        function j(e, t, n) {
                                                          var r,
                                                              i,
                                                              o = -1,
                                                              a = t[1],
                                                              s = 0,
                                                              c = 7,
                                                              l = 4;

                                                          for (0 === a && (c = 138, l = 3), t[2 * (n + 1) + 1] = 65535, r = 0; r <= n; r++) {
                                                            i = a, a = t[2 * (r + 1) + 1], ++s < c && i === a || (s < l ? e.bl_tree[2 * i] += s : 0 !== i ? (i !== o && e.bl_tree[2 * i]++, e.bl_tree[32]++) : s <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, o = i, l = (s = 0) === a ? (c = 138, 3) : i === a ? (c = 6, 3) : (c = 7, 4));
                                                          }
                                                        }

                                                        function D(e, t, n) {
                                                          var r,
                                                              i,
                                                              o = -1,
                                                              a = t[1],
                                                              s = 0,
                                                              c = 7,
                                                              l = 4;

                                                          for (0 === a && (c = 138, l = 3), r = 0; r <= n; r++) {
                                                            if (i = a, a = t[2 * (r + 1) + 1], !(++s < c && i === a)) {
                                                              if (s < l) for (; C(e, i, e.bl_tree), 0 != --s;) {
                                                                ;
                                                              } else 0 !== i ? (i !== o && (C(e, i, e.bl_tree), s--), C(e, 16, e.bl_tree), E(e, s - 3, 2)) : s <= 10 ? (C(e, 17, e.bl_tree), E(e, s - 3, 3)) : (C(e, 18, e.bl_tree), E(e, s - 11, 7));
                                                              o = i, l = (s = 0) === a ? (c = 138, 3) : i === a ? (c = 6, 3) : (c = 7, 4);
                                                            }
                                                          }
                                                        }

                                                        i(b);
                                                        var z = !1;

                                                        function M(e, t, n, i) {
                                                          var o, a, s;
                                                          E(e, 0 + (i ? 1 : 0), 3), a = t, s = n, T(o = e), x(o, s), x(o, ~s), r.arraySet(o.pending_buf, o.window, a, s, o.pending), o.pending += s;
                                                        }

                                                        n._tr_init = function (e) {
                                                          z || (function () {
                                                            var e,
                                                                t,
                                                                n,
                                                                r,
                                                                i,
                                                                a = new Array(o + 1);

                                                            for (r = n = 0; r < 28; r++) {
                                                              for (f[r] = n, e = 0; e < 1 << s[r]; e++) {
                                                                _[n++] = r;
                                                              }
                                                            }

                                                            for (_[n - 1] = r, r = i = 0; r < 16; r++) {
                                                              for (b[r] = i, e = 0; e < 1 << c[r]; e++) {
                                                                h[i++] = r;
                                                              }
                                                            }

                                                            for (i >>= 7; r < 30; r++) {
                                                              for (b[r] = i << 7, e = 0; e < 1 << c[r] - 7; e++) {
                                                                h[256 + i++] = r;
                                                              }
                                                            }

                                                            for (t = 0; t <= o; t++) {
                                                              a[t] = 0;
                                                            }

                                                            for (e = 0; e <= 143;) {
                                                              u[2 * e + 1] = 8, e++, a[8]++;
                                                            }

                                                            for (; e <= 255;) {
                                                              u[2 * e + 1] = 9, e++, a[9]++;
                                                            }

                                                            for (; e <= 279;) {
                                                              u[2 * e + 1] = 7, e++, a[7]++;
                                                            }

                                                            for (; e <= 287;) {
                                                              u[2 * e + 1] = 8, e++, a[8]++;
                                                            }

                                                            for (A(u, 287, a), e = 0; e < 30; e++) {
                                                              p[2 * e + 1] = 5, p[2 * e] = k(e, 5);
                                                            }

                                                            m = new y(u, s, 257, 286, o), g = new y(p, c, 0, 30, o), v = new y(new Array(0), l, 0, 19, 7);
                                                          }(), z = !0), e.l_desc = new w(e.dyn_ltree, m), e.d_desc = new w(e.dyn_dtree, g), e.bl_desc = new w(e.bl_tree, v), e.bi_buf = 0, e.bi_valid = 0, I(e);
                                                        }, n._tr_stored_block = M, n._tr_flush_block = function (e, t, n, r) {
                                                          var i,
                                                              o,
                                                              a = 0;
                                                          0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function (e) {
                                                            var t,
                                                                n = 4093624447;

                                                            for (t = 0; t <= 31; t++, n >>>= 1) {
                                                              if (1 & n && 0 !== e.dyn_ltree[2 * t]) return 0;
                                                            }

                                                            if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;

                                                            for (t = 32; t < 256; t++) {
                                                              if (0 !== e.dyn_ltree[2 * t]) return 1;
                                                            }

                                                            return 0;
                                                          }(e)), P(e, e.l_desc), P(e, e.d_desc), a = function (e) {
                                                            var t;

                                                            for (j(e, e.dyn_ltree, e.l_desc.max_code), j(e, e.dyn_dtree, e.d_desc.max_code), P(e, e.bl_desc), t = 18; 3 <= t && 0 === e.bl_tree[2 * d[t] + 1]; t--) {
                                                              ;
                                                            }

                                                            return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                                                          }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = n + 5, n + 4 <= i && -1 !== t ? M(e, t, n, r) : 4 === e.strategy || o === i ? (E(e, 2 + (r ? 1 : 0), 3), N(e, u, p)) : (E(e, 4 + (r ? 1 : 0), 3), function (e, t, n, r) {
                                                            var i;

                                                            for (E(e, t - 257, 5), E(e, n - 1, 5), E(e, r - 4, 4), i = 0; i < r; i++) {
                                                              E(e, e.bl_tree[2 * d[i] + 1], 3);
                                                            }

                                                            D(e, e.dyn_ltree, t - 1), D(e, e.dyn_dtree, n - 1);
                                                          }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), N(e, e.dyn_ltree, e.dyn_dtree)), I(e), r && T(e);
                                                        }, n._tr_tally = function (e, t, n) {
                                                          return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & n, e.last_lit++, 0 === t ? e.dyn_ltree[2 * n]++ : (e.matches++, t--, e.dyn_ltree[2 * (_[n] + 256 + 1)]++, e.dyn_dtree[2 * S(t)]++), e.last_lit === e.lit_bufsize - 1;
                                                        }, n._tr_align = function (e) {
                                                          var t;
                                                          E(e, 2, 3), C(e, 256, u), 16 === (t = e).bi_valid ? (x(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : 8 <= t.bi_valid && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8);
                                                        };
                                                      }, {
                                                        "../utils/common": 41
                                                      }],
                                                      53: [function (e, t, n) {
                                                        t.exports = function () {
                                                          this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                                                        };
                                                      }, {}],
                                                      54: [function (e, t, n) {
                                                        t.exports = "function" == typeof setImmediate ? setImmediate : function () {
                                                          var e = [].slice.apply(arguments);
                                                          e.splice(1, 0, 0), setTimeout.apply(null, e);
                                                        };
                                                      }, {}]
                                                    }, {}, [10])(10);
                                                  });
                                                }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                              }, {}]
                                            }, {}, [1])(1);
                                          });
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                      }, {}]
                                    }, {}, [1])(1);
                                  });
                                }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                              }, {}]
                            }, {}, [1])(1);
                          });
                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                      }, {}]
                    }, {}, [1])(1);
                  });
                }).call(this, void 0 !== Ay ? Ay : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
              }, {}]
            }, {}, [1])(1);
          }(Lj);

          var _Uj = function Uj(e, t) {
            return _Uj = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) {
                t.hasOwnProperty(n) && (e[n] = t[n]);
              }
            }, _Uj(e, t);
          };

          function Bj(e, t) {
            function n() {
              this.constructor = e;
            }

            _Uj(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }

          var Hj,
              _Vj = function Vj() {
            return _Vj = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) {
                for (var i in t = arguments[n]) {
                  Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                }
              }

              return e;
            }, _Vj.apply(this, arguments);
          },
              qj = "/";

          !function (e) {
            e.STRING = "string", e.BLOB = "blob", e.ARRAY_BUFFER = "arraybuffer";
          }(Hj || (Hj = {}));

          var Fj = function Fj(e) {
            return Blob && e instanceof Blob ? "blob" : ArrayBuffer && e instanceof ArrayBuffer ? "arrayBuffer" : typeof e;
          },
              Wj = [],
              Gj = function Gj() {
            for (var e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], t = "", n = 0; n < 32; n++) {
              t += e[Math.round(61 * Math.random())];
            }

            return -1 !== Wj.indexOf(t) ? Gj() : (Wj.push(t), t);
          },
              Kj = function Kj(e) {
            return e.arrayBuffer ? e.arrayBuffer() : new Promise(function (t, n) {
              var r = new FileReader();
              r.readAsArrayBuffer(e), r.onload = function (e) {
                t(e.target && e.target.result);
              }, r.onerror = function (e) {
                n(e);
              };
            });
          },
              Qj = function Qj(e) {
            return e.text ? e.text() : new Promise(function (t, n) {
              var r = new FileReader();
              r.readAsText(e), r.onload = function (e) {
                t(e.target && e.target.result);
              }, r.onerror = function (e) {
                n(e);
              };
            });
          };

          function Zj(e) {
            var t = (e || "").split(".");
            return t[t.length - 1] || "";
          }

          function Yj(e) {
            return ["png", "jpg", "jpeg", "svg"].includes(Zj(e));
          }

          function Jj(e) {
            return "json" === Zj(e.name) ? "string" : Yj(e.name) ? "base64" : function (e) {
              return "version" === Zj(e);
            }(e.name) ? "text" : "blob";
          }

          function $j(e, t) {
            return e.reduce(function (e, n) {
              var r,
                  i = n.data,
                  o = n.file,
                  a = Zj(o.name),
                  s = function (e) {
                var t = (e || "").lastIndexOf(qj);
                return t < 0 ? "" : e.slice(0, t);
              }(o.name),
                  c = function (e) {
                var t = (e || "").lastIndexOf(qj),
                    n = t < 0 ? e : e.slice(t + 1),
                    r = (n || "").lastIndexOf(".");
                return r < 0 ? n : n.slice(0, r);
              }(o.name),
                  l = ((null == t ? void 0 : t.combineExtNames) || []).includes(a) && "string" == typeof i,
                  d = l ? "" + (s ? "" + s + qj + a : a) : o.name;

              return l && e.some(function (e) {
                return e.path === d && (e.data[c] = i, !0);
              }) || e.push({
                path: d,
                extName: a,
                data: l ? (r = {}, r[c] = i, r) : i,
                shouldCombine: l
              }), e;
            }, []).map(function (e) {
              var t = e.data,
                  n = e.shouldCombine,
                  r = function (e, t) {
                var n = {};

                for (var r in e) {
                  Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                }

                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                  var i = 0;

                  for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) {
                    t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
                  }
                }

                return n;
              }(e, ["data", "shouldCombine"]);

              return _Vj(_Vj({}, r), {
                data: n ? JSON.stringify(t) : t
              });
            });
          }

          function Xj(e, t) {
            var n = t || {},
                r = n.encoding,
                i = n.blobType,
                o = n.unZipOptions;
            if (function (e) {
              return "blob" === Fj(e) && (e.type.includes("compressed") || e.type.includes("zip"));
            }(e) && !(null == o ? void 0 : o.disableUnZip)) return function (e, t) {
              return Lj.exports.loadAsync(e).then(function (e) {
                return Promise.all(e.filter(function (e, t) {
                  return !t.dir;
                }).map(function (e) {
                  var n = Jj(e);
                  return (null == t ? void 0 : t.setUnZipFormat) && (n = t.setUnZipFormat(e) || n), e.async(n).then(function (t) {
                    var r = t,
                        i = Zj(e.name),
                        o = "svg" === i ? "svg+xml" : i;
                    return "base64" === n && Yj(e.name) && !t.startsWith("data") && (r = "data:image/" + o + ";base64," + r), {
                      data: r,
                      file: e
                    };
                  });
                }));
              }).then(function (e) {
                return $j(e, t);
              });
            }(e, o);
            if (!r) return Promise.resolve(e);
            var a = Fj(e),
                s = "string" === a,
                c = "blob" === a,
                l = "arrayBuffer" === a;

            if (r === Hj.BLOB) {
              var d = e;
              if (s) return Qj(d);
              if (l) return Kj(d);
            } else if (r === Hj.ARRAY_BUFFER) {
              var u = e;
              if (s) return function (e, t) {
                var n = new Blob([e], {
                  type: t || "text/plain"
                });
                return Qj(n);
              }(u, i);
              if (c) return function (e, t) {
                return Promise.resolve(new Blob([new Uint8Array(e)], {
                  type: t
                }));
              }(u, i);
            } else if (r === Hj.STRING) {
              var p = e;
              if (c) return function (e, t) {
                return Promise.resolve(new Blob([e], {
                  type: t || "text/plain"
                }));
              }(p, i);
              if (l) return function (e, t) {
                return Kj(new Blob([e], {
                  type: t || "text/plain"
                }));
              }(p, i);
            }

            return Promise.resolve(e);
          }

          function eD(e) {
            var t = 0,
                n = !1,
                r = function r() {
              t > 90 || n || (e(t += (100 - t) / 50), requestAnimationFrame(r));
            };

            return r(), {
              finish: function finish() {
                100 === t || n || (t = 100, e(100));
              },
              abort: function abort() {
                100 === t || n || (n = !0);
              },

              get curProgress() {
                return t;
              }

            };
          }

          function tD() {}

          function nD() {
            nD.init.call(this);
          }

          function rD(e) {
            return void 0 === e._maxListeners ? nD.defaultMaxListeners : e._maxListeners;
          }

          function iD(e, t, n) {
            if (t) e.call(n);else for (var r = e.length, i = pD(e, r), o = 0; o < r; ++o) {
              i[o].call(n);
            }
          }

          function oD(e, t, n, r) {
            if (t) e.call(n, r);else for (var i = e.length, o = pD(e, i), a = 0; a < i; ++a) {
              o[a].call(n, r);
            }
          }

          function aD(e, t, n, r, i) {
            if (t) e.call(n, r, i);else for (var o = e.length, a = pD(e, o), s = 0; s < o; ++s) {
              a[s].call(n, r, i);
            }
          }

          function sD(e, t, n, r, i, o) {
            if (t) e.call(n, r, i, o);else for (var a = e.length, s = pD(e, a), c = 0; c < a; ++c) {
              s[c].call(n, r, i, o);
            }
          }

          function cD(e, t, n, r) {
            if (t) e.apply(n, r);else for (var i = e.length, o = pD(e, i), a = 0; a < i; ++a) {
              o[a].apply(n, r);
            }
          }

          function lD(e, t, n, r) {
            var i, o, a;
            if ("function" != typeof n) throw new TypeError('"listener" argument must be a function');

            if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), a = o[t]) : (o = e._events = new tD(), e._eventsCount = 0), a) {
              if ("function" == typeof a ? a = o[t] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), !a.warned && (i = rD(e)) && i > 0 && a.length > i) {
                a.warned = !0;
                var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
                s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, function (e) {
                  "function" == typeof console.warn ? console.warn(e) : console.log(e);
                }(s);
              }
            } else a = o[t] = n, ++e._eventsCount;

            return e;
          }

          function dD(e, t, n) {
            var r = !1;

            function i() {
              e.removeListener(t, i), r || (r = !0, n.apply(e, arguments));
            }

            return i.listener = n, i;
          }

          function uD(e) {
            var t = this._events;

            if (t) {
              var n = t[e];
              if ("function" == typeof n) return 1;
              if (n) return n.length;
            }

            return 0;
          }

          function pD(e, t) {
            for (var n = new Array(t); t--;) {
              n[t] = e[t];
            }

            return n;
          }

          tD.prototype = Object.create(null), nD.EventEmitter = nD, nD.usingDomains = !1, nD.prototype.domain = void 0, nD.prototype._events = void 0, nD.prototype._maxListeners = void 0, nD.defaultMaxListeners = 10, nD.init = function () {
            this.domain = null, nD.usingDomains && (void 0).active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new tD(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
          }, nD.prototype.setMaxListeners = function (e) {
            if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
            return this._maxListeners = e, this;
          }, nD.prototype.getMaxListeners = function () {
            return rD(this);
          }, nD.prototype.emit = function (e) {
            var t,
                n,
                r,
                i,
                o,
                a,
                s,
                c = "error" === e;
            if (a = this._events) c = c && null == a.error;else if (!c) return !1;

            if (s = this.domain, c) {
              if (t = arguments[1], !s) {
                if (t instanceof Error) throw t;
                var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
                throw l.context = t, l;
              }

              return t || (t = new Error('Uncaught, unspecified "error" event')), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t), !1;
            }

            if (!(n = a[e])) return !1;
            var d = "function" == typeof n;

            switch (r = arguments.length) {
              case 1:
                iD(n, d, this);
                break;

              case 2:
                oD(n, d, this, arguments[1]);
                break;

              case 3:
                aD(n, d, this, arguments[1], arguments[2]);
                break;

              case 4:
                sD(n, d, this, arguments[1], arguments[2], arguments[3]);
                break;

              default:
                for (i = new Array(r - 1), o = 1; o < r; o++) {
                  i[o - 1] = arguments[o];
                }

                cD(n, d, this, i);
            }

            return !0;
          }, nD.prototype.addListener = function (e, t) {
            return lD(this, e, t, !1);
          }, nD.prototype.on = nD.prototype.addListener, nD.prototype.prependListener = function (e, t) {
            return lD(this, e, t, !0);
          }, nD.prototype.once = function (e, t) {
            if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
            return this.on(e, dD(this, e, t)), this;
          }, nD.prototype.prependOnceListener = function (e, t) {
            if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
            return this.prependListener(e, dD(this, e, t)), this;
          }, nD.prototype.removeListener = function (e, t) {
            var n, r, i, o, a;
            if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
            if (!(r = this._events)) return this;
            if (!(n = r[e])) return this;
            if (n === t || n.listener && n.listener === t) 0 == --this._eventsCount ? this._events = new tD() : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
              for (i = -1, o = n.length; o-- > 0;) {
                if (n[o] === t || n[o].listener && n[o].listener === t) {
                  a = n[o].listener, i = o;
                  break;
                }
              }

              if (i < 0) return this;

              if (1 === n.length) {
                if (n[0] = void 0, 0 == --this._eventsCount) return this._events = new tD(), this;
                delete r[e];
              } else !function (e, t) {
                for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) {
                  e[n] = e[r];
                }

                e.pop();
              }(n, i);

              r.removeListener && this.emit("removeListener", e, a || t);
            }
            return this;
          }, nD.prototype.removeAllListeners = function (e) {
            var t, n;
            if (!(n = this._events)) return this;
            if (!n.removeListener) return 0 === arguments.length ? (this._events = new tD(), this._eventsCount = 0) : n[e] && (0 == --this._eventsCount ? this._events = new tD() : delete n[e]), this;

            if (0 === arguments.length) {
              for (var r, i = Object.keys(n), o = 0; o < i.length; ++o) {
                "removeListener" !== (r = i[o]) && this.removeAllListeners(r);
              }

              return this.removeAllListeners("removeListener"), this._events = new tD(), this._eventsCount = 0, this;
            }

            if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (t) do {
              this.removeListener(e, t[t.length - 1]);
            } while (t[0]);
            return this;
          }, nD.prototype.listeners = function (e) {
            var t,
                n,
                r = this._events;
            return n = r && (t = r[e]) ? "function" == typeof t ? [t.listener || t] : function (e) {
              for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
                t[n] = e[n].listener || e[n];
              }

              return t;
            }(t) : [], n;
          }, nD.listenerCount = function (e, t) {
            return "function" == typeof e.listenerCount ? e.listenerCount(t) : uD.call(e, t);
          }, nD.prototype.listenerCount = uD, nD.prototype.eventNames = function () {
            return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
          };

          var hD,
              _D = function (e) {
            function t(t) {
              var n = e.call(this) || this;
              return n.timeout = (null == t ? void 0 : t.timeout) || 3e4, n;
            }

            return Bj(t, e), t.prototype.clearTimeoutCheck = function () {
              this.timeoutTimer && (clearTimeout(this.timeoutTimer), this.timeoutTimer = null);
            }, t.prototype.startTimeoutCheck = function () {
              var e = this;
              !this.timeoutTimer && !this.finished && this.timeout > 0 && (this.timeoutTimer = setTimeout(function () {
                e.finished || (e.finished = !0, e.data = null, e.emit("timeout")), e.clearTimeoutCheck();
              }, this.timeout));
            }, t;
          }(nD),
              fD = function (e) {
            function t(t) {
              var n = e.call(this, t) || this;
              return n.uuid = Gj(), n.domParams = t || {}, n;
            }

            return Bj(t, e), t.prototype.jsonp = function () {
              var e = this;

              if (!this.finished) {
                var t = this.domParams,
                    n = t.url,
                    r = t.jsonpCallbackName,
                    i = void 0 === r ? "callback" : r,
                    o = t.body,
                    a = t.integrity;
                this.script = document.createElement("script"), a && (this.script.integrity = a, this.script.crossOrigin = "anonymous");
                var s = "";
                o && Object.entries(o).forEach(function (e) {
                  var t = e[0],
                      n = e[1];
                  s += (s ? "&" : "") + t + "=" + n;
                }), s += (s ? "&" : "") + i + "=" + this.uuid, this.script.src = n + (n.includes("?") ? "" : "?") + s, this.jsonpCallback(), this.progressMonitory = eD(function (t) {
                  e.finished || e.emit("progressUpdated", t);
                }), document.body.appendChild(this.script);
              }
            }, t.prototype.clearSideEffect = function (e) {
              if (void 0 === e && (e = !1), document.body.removeChild(this.script), e) {
                var t = this.uuid;

                window[this.uuid] = function () {
                  window[t] && delete window[t];
                };
              } else delete window[this.uuid];

              this.script = null, this.uuid = null, this.finished = !0, this.data = null, this.clearTimeoutCheck();
            }, t.prototype.jsonpCallback = function () {
              var e = this;
              this.script.onerror = function (t) {
                var n;
                e.finished || (e.clearSideEffect(), null === (n = e.progressMonitory) || void 0 === n || n.abort(), e.emit("error", new Error("string" == typeof t ? t : "load jsonp script failed")));
              }, window[this.uuid] = function (t) {
                var n;

                if (!e.finished) {
                  var r = e.domParams,
                      i = r.encoding,
                      o = r.blobType,
                      a = r.unZipOptions,
                      s = r.beforeTransformData,
                      c = r.afterTransformData;
                  null === (n = e.progressMonitory) || void 0 === n || n.finish(), e.clearSideEffect(), (s ? s(t || "") : Promise.resolve(t || "")).then(function (t) {
                    return Xj(t, {
                      encoding: i,
                      blobType: o,
                      unZipOptions: a
                    }).then(function (t) {
                      return (c ? c(t) : Promise.resolve(t)).then(function (t) {
                        return e.emit("finished", t);
                      });
                    });
                  }).catch(function (t) {
                    return e.emit("error", t);
                  });
                }
              };
            }, t.prototype.abort = function () {
              this.clearSideEffect(!0);
            }, t;
          }(_D),
              mD = function (e) {
            function t(t) {
              var n = e.call(this, t) || this;
              return n.socketParams = t || {}, n;
            }

            return Bj(t, e), t.prototype.write = function (e, t) {
              e && !this.finished && (e instanceof Error ? this.handleError(e) : (this.data ? this.appendData(e) : this.data = e, this.handlePerCentUpdate(t)));
            }, t.prototype.handlePerCentUpdate = function (e) {
              void 0 === e || this.finished || this.emit("progressUpdated", e);
            }, t.prototype.handleError = function (e) {
              this.data = null, this.finished = !0, this.clearTimeoutCheck(), this.emit("error", e);
            }, t.prototype.appendData = function (e) {
              var t, n, r;
              Fj(e) === Fj(this.data) ? "string" == typeof e ? this.data += e : Blob && e instanceof Blob ? this.data = new Blob([this.data, e], {
                type: e.type
              }) : ArrayBuffer && e instanceof ArrayBuffer && (this.data = (t = this.data, n = e, (r = new Uint8Array(t.byteLength + n.byteLength)).set(new Uint8Array(t), 0), r.set(new Uint8Array(n), t.byteLength), r.buffer)) : this.handleError(new Error("every piece of the data format must be the same"));
            }, t.prototype.end = function (e) {
              var t = this;

              if (!this.finished) {
                this.handlePerCentUpdate(100), e && this.write(e);
                var n = this.socketParams,
                    r = n.encoding,
                    i = n.blobType,
                    o = n.unZipOptions,
                    a = n.beforeTransformData,
                    s = n.afterTransformData;
                (a ? a(this.data) : Promise.resolve(this.data)).then(function (e) {
                  return Xj(e, {
                    encoding: r,
                    blobType: i,
                    unZipOptions: o
                  }).then(function (e) {
                    return (s ? s(e) : Promise.resolve(e)).then(function (e) {
                      return t.emit("finished", e);
                    });
                  });
                }).catch(function (e) {
                  return t.emit("error", e);
                }), this.data = null, this.finished = !0, this.clearTimeoutCheck();
              }
            }, t.prototype.abort = function () {
              this.data = null, this.finished = !0, this.clearTimeoutCheck();
            }, t;
          }(_D),
              gD = function (e) {
            function t(t) {
              var n = e.call(this, t) || this;
              return n.xhrParams = t || {}, n.xhrParams.headers = _Vj({}, n.xhrParams.headers || {}), n;
            }

            return Bj(t, e), t.prototype.supportFetch = function () {
              return !!window.fetch && window.AbortController && window.Request;
            }, t.prototype.ajax = function () {
              var e = this;
              if (!this.finished) if (this.xhrParams.url) {
                var t = this.xhrParams,
                    n = t.headers,
                    r = void 0 === n ? {} : n,
                    i = t.url,
                    o = t.body,
                    a = void 0 === o ? {} : o,
                    s = t.method,
                    c = void 0 === s ? "POST" : s,
                    l = t.encoding,
                    d = t.integrity;
                this.controller = this.supportFetch() ? new AbortController() : new XMLHttpRequest();
                var u = this.supportFetch() ? eD(function (t) {
                  e.finished || e.emit("progressUpdated", t);
                }) : null;
                (this.supportFetch() ? fetch(new Request(i, _Vj({
                  method: c,
                  headers: r,
                  body: "GET" === c ? void 0 : JSON.stringify(a),
                  signal: this.controller.signal
                }, d ? {
                  integrity: d,
                  mode: "cors"
                } : {}))).then(function (e) {
                  return e.ok ? l === Hj.STRING ? e.text() : l === Hj.ARRAY_BUFFER ? e.arrayBuffer() : e.blob() : Promise.reject(new Error("xhr download " + i + " failed!"));
                }) : new Promise(function (t, n) {
                  var o = new XMLHttpRequest();
                  e.controller = o, o.open(c, i), o.responseType = l === Hj.STRING ? "text" : l === Hj.ARRAY_BUFFER ? "arraybuffer" : "blob", Object.entries(r).forEach(function (e) {
                    var t = e[0],
                        n = e[1];
                    o.setRequestHeader(t, n);
                  }), o.onload = function () {
                    var e = o.status,
                        r = o.response,
                        i = o.statusText;
                    e >= 200 && e < 300 || 304 === e ? t(r) : n(new Error(e + ": " + i));
                  }, o.onprogress = function (t) {
                    var n = t || {},
                        r = n.total,
                        i = n.loaded;
                    void 0 === i || e.finished || (r ? e.emit("progressUpdated", i / r * 100) : i && !u && (u = eD(function (t) {
                      e.finished || e.emit("progressUpdated", t);
                    })));
                  }, o.onerror = function () {
                    n(new Error("xhr download " + i + " failed!"));
                  }, o.send(JSON.stringify(a));
                })).then(function (t) {
                  if (!e.finished) {
                    var n = e.xhrParams,
                        r = n.encoding,
                        i = n.blobType,
                        o = n.unZipOptions,
                        a = n.beforeTransformData,
                        s = n.afterTransformData;
                    null == u || u.finish(), e.finished = !0, e.clearTimeoutCheck(), (a ? a(t) : Promise.resolve(t)).then(function (t) {
                      return Xj(t, {
                        encoding: r,
                        blobType: i,
                        unZipOptions: o
                      }).then(function (t) {
                        return (s ? s(t) : Promise.resolve(t)).then(function (t) {
                          return e.emit("finished", t);
                        });
                      });
                    }).catch(function (t) {
                      return e.emit("error", t);
                    });
                  }
                }).catch(function (t) {
                  e.finished || (e.finished = !0, e.clearTimeoutCheck(), null == u || u.abort(), e.emit("error", t));
                });
              } else this.emit("error", new Error("xhrDownloader url params invalid!"));
            }, t.prototype.abort = function () {
              this.data = null, this.finished = !0, this.clearTimeoutCheck(), this.controller.abort();
            }, t;
          }(_D),
              vD = 0,
              bD = new nD(),
              yD = "ThreadPoolReady",
              wD = function wD() {
            vD -= 1, bD.emit(yD);
          };

          !function (e) {
            e.XHR = "xhr", e.DOM = "dom", e.SOCKET = "socket";
          }(hD || (hD = {}));

          var SD = function (e) {
            function t(t) {
              var n = e.call(this) || this;
              return n.aborted = !1, n.downloadParmas = _Vj({
                type: hD.XHR
              }, t), n.id = Gj(), n;
            }

            return Bj(t, e), t.prototype.start = function () {
              var e = this;
              vD += 1, this.progress = 0, this.emit("downloadStart"), this.onDownloadStartCallback && this.onDownloadStartCallback();
              var t = this.downloadParmas,
                  n = t.type,
                  r = t.xhrParams,
                  i = t.domParams,
                  o = t.socketParams;

              switch (n) {
                case hD.DOM:
                  this.downloader = new fD(i), this.downloader.jsonp();
                  break;

                case hD.SOCKET:
                  this.downloader = new mD(o);
                  break;

                default:
                  this.downloader = new gD(r), this.downloader.ajax();
              }

              return this.downloader.startTimeoutCheck(), this.downloader.on("error", function (t) {
                e.emit("error", t), e.onErrorCallback && e.onErrorCallback(t), wD();
              }).on("finished", function (t) {
                e.emit("complete", t), e.onCompleteCallback && e.onCompleteCallback(t), wD();
              }).on("progressUpdated", function (t) {
                e.progress = t, e.emit("progressUpdated", t), e.onProgressUpdatedCallback && e.onProgressUpdatedCallback(t);
              }).on("timeout", function () {
                e.emit("timeout"), e.onTimeoutCallback && e.onTimeoutCallback(), wD();
              }), this;
            }, t.prototype.abort = function () {
              if (this.aborted) return this;
              this.aborted = !0, this.downloader && !this.downloader.finished && this.downloader.abort();
              var e = new Error("file download has been aborted");
              return this.emit("abort", e), this.onAbortCallback && this.onAbortCallback(e), wD(), this;
            }, t.prototype.onDownloadStart = function (e) {
              return this.onDownloadStartCallback = e, this;
            }, t.prototype.onProgressUpdated = function (e) {
              return this.onProgressUpdatedCallback = e, this;
            }, t.prototype.onError = function (e) {
              return this.onErrorCallback = e, this;
            }, t.prototype.onComplete = function (e) {
              return this.onCompleteCallback = e, this;
            }, t.prototype.onAbort = function (e) {
              return this.onAbortCallback = e, this;
            }, t.prototype.onTimeout = function (e) {
              return this.onTimeoutCallback = e, this;
            }, t.prototype.isInProgress = function () {
              return void 0 !== this.progress;
            }, t.prototype.isFinished = function () {
              return 100 === this.progress;
            }, t;
          }(nD),
              xD = function () {
            function e(e) {
              this.taskList = [], this.options = e || {};
              var t = this.options.threadLimit;
              if ((void 0 === t ? 6 : t) > 6) throw new Error("threadLimit must be lower than 6");
              bD.on(yD, this.startNextTask.bind(this));
            }

            return e.prototype.download = function (e) {
              var t = new SD(e),
                  n = this.removeTask.bind(this, t);
              return t.on("abort", n), this.taskList.push(t), this.checkTaskReady(t), t;
            }, e.prototype.startNextTask = function () {
              var e = this.taskList.find(function (e) {
                return !e.isInProgress();
              });
              e && this.checkTaskReady(e);
            }, e.prototype.checkTaskReady = function (e) {
              var t = this.options.threadLimit,
                  n = void 0 === t ? 6 : t;

              if (!(this.taskList.findIndex(function (e) {
                return !e.isInProgress();
              }) >= n || vD + 1 > 6)) {
                var r = this.removeTask.bind(this, e);
                e.on("complete", r), e.on("error", r), e.on("timeout", r), setTimeout(function () {
                  return e.start();
                }, 0);
              }
            }, e.prototype.removeTask = function (e) {
              var t = this;
              this.taskList.some(function (n, r) {
                return n === e && (setTimeout(function () {
                  return e.removeAllListeners();
                }, 0), t.taskList.splice(r, 1), !0);
              });
            }, e;
          }(),
              _ED = function ED(e, t) {
            return _ED = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) {
                t.hasOwnProperty(n) && (e[n] = t[n]);
              }
            }, _ED(e, t);
          };

          function CD(e, t) {
            function n() {
              this.constructor = e;
            }

            _ED(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }

          var _kD = function kD() {
            return _kD = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) {
                for (var i in t = arguments[n]) {
                  Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                }
              }

              return e;
            }, _kD.apply(this, arguments);
          };

          function AD() {}

          function ID() {
            ID.init.call(this);
          }

          function TD(e) {
            return void 0 === e._maxListeners ? ID.defaultMaxListeners : e._maxListeners;
          }

          function OD(e, t, n) {
            if (t) e.call(n);else for (var r = e.length, i = LD(e, r), o = 0; o < r; ++o) {
              i[o].call(n);
            }
          }

          function RD(e, t, n, r) {
            if (t) e.call(n, r);else for (var i = e.length, o = LD(e, i), a = 0; a < i; ++a) {
              o[a].call(n, r);
            }
          }

          function ND(e, t, n, r, i) {
            if (t) e.call(n, r, i);else for (var o = e.length, a = LD(e, o), s = 0; s < o; ++s) {
              a[s].call(n, r, i);
            }
          }

          function PD(e, t, n, r, i, o) {
            if (t) e.call(n, r, i, o);else for (var a = e.length, s = LD(e, a), c = 0; c < a; ++c) {
              s[c].call(n, r, i, o);
            }
          }

          function jD(e, t, n, r) {
            if (t) e.apply(n, r);else for (var i = e.length, o = LD(e, i), a = 0; a < i; ++a) {
              o[a].apply(n, r);
            }
          }

          function DD(e, t, n, r) {
            var i, o, a;
            if ("function" != typeof n) throw new TypeError('"listener" argument must be a function');

            if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), a = o[t]) : (o = e._events = new AD(), e._eventsCount = 0), a) {
              if ("function" == typeof a ? a = o[t] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), !a.warned && (i = TD(e)) && i > 0 && a.length > i) {
                a.warned = !0;
                var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
                s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, function (e) {
                  "function" == typeof console.warn ? console.warn(e) : console.log(e);
                }(s);
              }
            } else a = o[t] = n, ++e._eventsCount;

            return e;
          }

          function zD(e, t, n) {
            var r = !1;

            function i() {
              e.removeListener(t, i), r || (r = !0, n.apply(e, arguments));
            }

            return i.listener = n, i;
          }

          function MD(e) {
            var t = this._events;

            if (t) {
              var n = t[e];
              if ("function" == typeof n) return 1;
              if (n) return n.length;
            }

            return 0;
          }

          function LD(e, t) {
            for (var n = new Array(t); t--;) {
              n[t] = e[t];
            }

            return n;
          }

          AD.prototype = Object.create(null), ID.EventEmitter = ID, ID.usingDomains = !1, ID.prototype.domain = void 0, ID.prototype._events = void 0, ID.prototype._maxListeners = void 0, ID.defaultMaxListeners = 10, ID.init = function () {
            this.domain = null, ID.usingDomains && (void 0).active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new AD(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
          }, ID.prototype.setMaxListeners = function (e) {
            if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
            return this._maxListeners = e, this;
          }, ID.prototype.getMaxListeners = function () {
            return TD(this);
          }, ID.prototype.emit = function (e) {
            var t,
                n,
                r,
                i,
                o,
                a,
                s,
                c = "error" === e;
            if (a = this._events) c = c && null == a.error;else if (!c) return !1;

            if (s = this.domain, c) {
              if (t = arguments[1], !s) {
                if (t instanceof Error) throw t;
                var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
                throw l.context = t, l;
              }

              return t || (t = new Error('Uncaught, unspecified "error" event')), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t), !1;
            }

            if (!(n = a[e])) return !1;
            var d = "function" == typeof n;

            switch (r = arguments.length) {
              case 1:
                OD(n, d, this);
                break;

              case 2:
                RD(n, d, this, arguments[1]);
                break;

              case 3:
                ND(n, d, this, arguments[1], arguments[2]);
                break;

              case 4:
                PD(n, d, this, arguments[1], arguments[2], arguments[3]);
                break;

              default:
                for (i = new Array(r - 1), o = 1; o < r; o++) {
                  i[o - 1] = arguments[o];
                }

                jD(n, d, this, i);
            }

            return !0;
          }, ID.prototype.addListener = function (e, t) {
            return DD(this, e, t, !1);
          }, ID.prototype.on = ID.prototype.addListener, ID.prototype.prependListener = function (e, t) {
            return DD(this, e, t, !0);
          }, ID.prototype.once = function (e, t) {
            if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
            return this.on(e, zD(this, e, t)), this;
          }, ID.prototype.prependOnceListener = function (e, t) {
            if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
            return this.prependListener(e, zD(this, e, t)), this;
          }, ID.prototype.removeListener = function (e, t) {
            var n, r, i, o, a;
            if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
            if (!(r = this._events)) return this;
            if (!(n = r[e])) return this;
            if (n === t || n.listener && n.listener === t) 0 == --this._eventsCount ? this._events = new AD() : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
              for (i = -1, o = n.length; o-- > 0;) {
                if (n[o] === t || n[o].listener && n[o].listener === t) {
                  a = n[o].listener, i = o;
                  break;
                }
              }

              if (i < 0) return this;

              if (1 === n.length) {
                if (n[0] = void 0, 0 == --this._eventsCount) return this._events = new AD(), this;
                delete r[e];
              } else !function (e, t) {
                for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) {
                  e[n] = e[r];
                }

                e.pop();
              }(n, i);

              r.removeListener && this.emit("removeListener", e, a || t);
            }
            return this;
          }, ID.prototype.removeAllListeners = function (e) {
            var t, n;
            if (!(n = this._events)) return this;
            if (!n.removeListener) return 0 === arguments.length ? (this._events = new AD(), this._eventsCount = 0) : n[e] && (0 == --this._eventsCount ? this._events = new AD() : delete n[e]), this;

            if (0 === arguments.length) {
              for (var r, i = Object.keys(n), o = 0; o < i.length; ++o) {
                "removeListener" !== (r = i[o]) && this.removeAllListeners(r);
              }

              return this.removeAllListeners("removeListener"), this._events = new AD(), this._eventsCount = 0, this;
            }

            if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (t) do {
              this.removeListener(e, t[t.length - 1]);
            } while (t[0]);
            return this;
          }, ID.prototype.listeners = function (e) {
            var t,
                n,
                r = this._events;
            return n = r && (t = r[e]) ? "function" == typeof t ? [t.listener || t] : function (e) {
              for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
                t[n] = e[n].listener || e[n];
              }

              return t;
            }(t) : [], n;
          }, ID.listenerCount = function (e, t) {
            return "function" == typeof e.listenerCount ? e.listenerCount(t) : MD.call(e, t);
          }, ID.prototype.listenerCount = MD, ID.prototype.eventNames = function () {
            return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
          };
          var UD = "ZipInfo:";

          function BD(e) {
            var t;
            return null === (t = null == e ? void 0 : e.path) || void 0 === t ? void 0 : t.startsWith(UD);
          }

          function HD(e) {
            return "string" == typeof e && e.startsWith(UD);
          }

          function VD(e, t) {
            return (Array.isArray(e) ? e : [e]).some(function (e) {
              if ("number" != typeof e.version) throw new Error("file version must be an int number");
              return e.version < t;
            });
          }

          function qD(e, t) {
            return e.reduce(function (e, n) {
              return e.then(function (e) {
                return t(e, n);
              }).catch(function () {
                return t(void 0, n);
              });
            }, Promise.resolve(void 0));
          }

          var FD,
              WD = function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return CD(t, e), t;
          }(ID),
              GD = "resource",
              KD = function (e) {
            function t(t) {
              var n = e.call(this) || this;

              if (n.ready = !1, n.openError = !1, n.isEnable()) {
                var r = t || {},
                    i = r.nameSpaceId,
                    o = r.indexDbVersion;

                n.dbName = function (e) {
                  return "resource-manager" + (e ? "-" + e : "");
                }(i);

                var a = indexedDB.open(n.dbName, o || 1);
                a.addEventListener("error", function () {
                  n.openError = !0, n.checkReady(), n.emit("error", new Error("failed to open indexedDB"));
                }), a.addEventListener("success", function () {
                  n.db = a.result, n.checkReady();
                }), a.addEventListener("upgradeneeded", function () {
                  n.db = a.result, n.handleSuccess();
                }), setTimeout(function () {
                  n.checkReady();
                }, 5e3);
              } else n.checkReady();

              return n;
            }

            return CD(t, e), t.prototype.checkReady = function () {
              this.ready || (this.ready = !0, this.emit("ready"));
            }, t.prototype.handleSuccess = function () {
              if (!this.db.objectStoreNames || 0 === this.db.objectStoreNames.length || !this.db.objectStoreNames.contains(GD)) {
                var e = this.db.createObjectStore(GD, {
                  keyPath: "path",
                  autoIncrement: !1
                });
                e.createIndex("path", "path"), e.createIndex("sourceURL", "sourceURL", {
                  unique: !1
                });
              }
            }, t.prototype.createAction = function (e) {
              var t = this.db.transaction([GD], e || "readonly");
              return {
                trans: t,
                store: t.objectStore(GD)
              };
            }, t.prototype.handleAction = function (e, t) {
              return new Promise(function (n, r) {
                var i = t();
                e.addEventListener("complete", function () {
                  n(i.result);
                }), e.addEventListener("error", function () {
                  r(e.error || new Error("transaction error"));
                }), e.addEventListener("abort", function () {
                  r(e.error || new Error("transaction aborted"));
                });
              });
            }, t.prototype.put = function () {
              for (var e = [], t = 0; t < arguments.length; t++) {
                e[t] = arguments[t];
              }

              var n = this.createAction("readwrite"),
                  r = n.trans,
                  i = n.store;
              return this.handleAction(r, function () {
                return i.put.apply(i, e);
              });
            }, t.prototype.getAllKeysFromIndex = function (e) {
              for (var t = [], n = 1; n < arguments.length; n++) {
                t[n - 1] = arguments[n];
              }

              if (IDBObjectStore.prototype.getAllKeys) {
                var r = this.createAction(),
                    i = r.trans,
                    o = r.store;
                return this.handleAction(i, function () {
                  var n;
                  return (n = o.index(e)).getAllKeys.apply(n, t);
                });
              }

              return this.openKeyCursor(e);
            }, t.prototype.getAllFromIndex = function (e) {
              for (var t = [], n = 1; n < arguments.length; n++) {
                t[n - 1] = arguments[n];
              }

              var r = this.createAction(),
                  i = r.trans,
                  o = r.store;
              return IDBObjectStore.prototype.getAll ? this.handleAction(i, function () {
                var n;
                return (n = o.index(e)).getAll.apply(n, t);
              }) : this.openCursor(e);
            }, t.prototype.getFromIndex = function (e) {
              for (var t = [], n = 1; n < arguments.length; n++) {
                t[n - 1] = arguments[n];
              }

              var r = this.createAction(),
                  i = r.trans,
                  o = r.store;
              return this.handleAction(i, function () {
                var n;
                return (n = o.index(e)).get.apply(n, t);
              });
            }, t.prototype.deleteKey = function () {
              for (var e = [], t = 0; t < arguments.length; t++) {
                e[t] = arguments[t];
              }

              var n = this.createAction("readwrite"),
                  r = n.trans,
                  i = n.store;
              return this.handleAction(r, function () {
                return i.delete.apply(i, e);
              });
            }, t.prototype.handleCursorAction = function (e, t, n, r) {
              return new Promise(function (i, o) {
                t.addEventListener("success", function () {
                  t.result ? (n(r, t.result), t.result.continue()) : i(r);
                }), t.addEventListener("error", function () {
                  o(e.error || new Error("transaction error"));
                });
              });
            }, t.prototype.openKeyCursor = function (e) {
              for (var t, n = [], r = 1; r < arguments.length; r++) {
                n[r - 1] = arguments[r];
              }

              var i = this.createAction("readwrite"),
                  o = i.trans,
                  a = i.store;
              return this.handleCursorAction(o, (t = a.index(e)).openKeyCursor.apply(t, n), function (e, t) {
                return e.push(t.key), e;
              }, []);
            }, t.prototype.openCursor = function (e) {
              for (var t, n = [], r = 1; r < arguments.length; r++) {
                n[r - 1] = arguments[r];
              }

              var i = this.createAction("readwrite"),
                  o = i.trans,
                  a = i.store;
              return this.handleCursorAction(o, (t = a.index(e)).openCursor.apply(t, n), function (e, t) {
                return e.push(t.value), e;
              }, []);
            }, t.prototype.isEnable = function () {
              return !!window.indexedDB && !this.openError;
            }, t.prototype.saveFile = function (e) {
              return this.db ? this.put(e).then(function () {
                return !0;
              }) : Promise.resolve(!1);
            }, t.prototype.removeFile = function (e) {
              var t = this;
              return this.db ? "string" == typeof e ? this.getAllKeysFromIndex("path").then(function (n) {
                var r = (n || []).filter(function (t) {
                  return t === e || t.startsWith("" + e + qj);
                });
                return Promise.all(r.map(function (e) {
                  return t.deleteKey(e);
                }));
              }).then(function () {
                return !0;
              }) : this.deleteKey(e.path).then(function () {
                return !0;
              }) : Promise.resolve(!1);
            }, t.prototype.clear = function () {
              if (!this.db) return Promise.resolve(!1);
              var e = this.createAction("readwrite"),
                  t = e.trans,
                  n = e.store;
              return this.handleAction(t, function () {
                return n.clear();
              }).then(function () {
                return !0;
              });
            }, t.prototype.findFileByPath = function (e) {
              return this.db && e ? this.getFromIndex("path", e) : Promise.resolve(void 0);
            }, t.prototype.findFileBySourceURL = function (e) {
              return this.db && e ? this.getAllFromIndex("sourceURL", e) : Promise.resolve([]);
            }, t.prototype.isDirectory = function (e) {
              var t = this;
              return this.db ? new Promise(function (n) {
                HD(e) ? n(!1) : t.getAllKeysFromIndex("path").then(function (t) {
                  return (t || []).some(function (t) {
                    return t.startsWith("" + e + qj);
                  });
                }).then(n).catch(function () {
                  return n(!1);
                });
              }) : Promise.resolve(!1);
            }, t.prototype.ls = function (e) {
              var t = this;
              return this.db ? this.getAllKeysFromIndex("path").then(function (n) {
                var r = [];
                return Promise.all((n || []).map(function (n) {
                  if (HD(n)) return Promise.resolve(void 0);

                  if (e) {
                    if (n.startsWith("" + e + qj)) {
                      var i = n.split("" + e + qj)[1] || "";

                      if (i.includes(qj)) {
                        var o = "" + e + qj + i.split(qj)[0];
                        return o && !r.includes(o) ? (r.push(o), Promise.resolve(o)) : Promise.resolve(void 0);
                      }

                      return t.getFromIndex("path", n);
                    }

                    return Promise.resolve(void 0);
                  }

                  if (n.includes(qj)) {
                    var a = n.split(qj)[0] || "";
                    return a && !r.includes(a) ? (r.push(a), Promise.resolve(a)) : Promise.resolve(void 0);
                  }

                  return t.getFromIndex("path", n);
                })).then(function (e) {
                  return e.filter(function (e) {
                    return !!e;
                  });
                });
              }) : Promise.resolve([]);
            }, t;
          }(WD),
              QD = function (e) {
            function t() {
              var t = null !== e && e.apply(this, arguments) || this;
              return t.memoryFiles = [], t;
            }

            return CD(t, e), t.prototype.isEnable = function () {
              return !0;
            }, t.prototype.saveFile = function (e) {
              var t = this;
              return new Promise(function (n) {
                t.memoryFiles.some(function (n, r) {
                  return n.path === e.path && (t.memoryFiles.splice(r, 1, e), !0);
                }) || t.memoryFiles.push(e), n(!0);
              });
            }, t.prototype.removeFile = function (e) {
              var t = this;
              return new Promise(function (n) {
                for (var r = t.memoryFiles.length - 1; r >= 0; r--) {
                  var i = t.memoryFiles[r];
                  ("string" == typeof e && (i.path === e || i.path.startsWith("" + e + qj)) || e.path === i.path) && t.memoryFiles.splice(r, 1);
                }

                n(!0);
              });
            }, t.prototype.clear = function () {
              var e = this;
              return new Promise(function (t) {
                e.memoryFiles = [], t(!0);
              });
            }, t.prototype.findFileByPath = function (e) {
              var t = this;
              return new Promise(function (n) {
                n(t.memoryFiles.filter(function (t) {
                  return t.path === e;
                })[0]);
              });
            }, t.prototype.findFileBySourceURL = function (e) {
              var t = this;
              return new Promise(function (n) {
                n(t.memoryFiles.filter(function (t) {
                  return t.sourceURL === e;
                }));
              });
            }, t.prototype.isDirectory = function (e) {
              var t = this;
              return new Promise(function (n) {
                HD(e) ? n(!1) : n(t.memoryFiles.some(function (t) {
                  return t.path.startsWith("" + e + qj);
                }));
              });
            }, t.prototype.ls = function (e) {
              var t = this;
              return new Promise(function (n) {
                var r = [];
                t.memoryFiles.forEach(function (t) {
                  if (!BD(t)) if (e) {
                    if (t.path.startsWith("" + e + qj)) {
                      var n = t.path.split("" + e + qj)[1] || "";

                      if (n.includes(qj)) {
                        var i = "" + e + qj + n.split(qj)[0];
                        return void (i && !r.includes(i) && r.push(i));
                      }

                      r.push(t);
                    }
                  } else if (t.path.includes(qj)) {
                    var o = t.path.split(qj)[0] || "";
                    o && !r.includes(o) && r.push(o);
                  } else r.push(t);
                }), n(r);
              });
            }, t;
          }(WD),
              ZD = function (e) {
            function t(t) {
              var n = e.call(this) || this;

              if (n.isLocalAvaliable = void 0, n.isEnable()) {
                var r = (t || {}).nameSpaceId;

                n.storageName = function (e) {
                  return "resource-manager" + (e ? "-" + e : "");
                }(r);
              }

              return n;
            }

            return CD(t, e), t.prototype.isEnable = function () {
              if (void 0 !== this.isLocalAvaliable) return this.isLocalAvaliable;

              try {
                this.isLocalAvaliable = !0, localStorage.setItem("privateTest", "");
              } catch (e) {
                this.isLocalAvaliable = !1;
              }

              return this.isLocalAvaliable;
            }, t.prototype.saveFile = function (e) {
              var t = this;
              return this.isEnable() ? new Promise(function (n) {
                var r = t.getLocalFile();
                r.some(function (t, n) {
                  return t.path === e.path && (r.splice(n, 1, e), !0);
                }) || r.push(e), localStorage.setItem(t.storageName, JSON.stringify(r)), n(!0);
              }) : Promise.resolve(!1);
            }, t.prototype.getLocalFile = function () {
              var e = localStorage.getItem(this.storageName),
                  t = [];
              if (e) try {
                t = JSON.parse(e) || "[]";
              } catch (e) {
                console.log(e);
              }
              return t;
            }, t.prototype.removeFile = function (e) {
              var t = this;
              return this.isEnable() ? new Promise(function (n) {
                for (var r = t.getLocalFile(), i = r.length - 1; i >= 0; i--) {
                  var o = r[i];
                  ("string" == typeof e && (o.path === e || o.path.startsWith("" + e + qj)) || e.path === o.path) && r.splice(i, 1);
                }

                localStorage.setItem(t.storageName, JSON.stringify(r)), n(!0);
              }) : Promise.resolve(!1);
            }, t.prototype.clear = function () {
              var e = this;
              return this.isEnable() ? new Promise(function (t) {
                localStorage.removeItem(e.storageName), t(!0);
              }) : Promise.resolve(!1);
            }, t.prototype.findFileByPath = function (e) {
              var t = this;
              return this.isEnable() ? new Promise(function (n) {
                n(t.getLocalFile().filter(function (t) {
                  return t.path === e;
                })[0]);
              }) : Promise.resolve(void 0);
            }, t.prototype.findFileBySourceURL = function (e) {
              var t = this;
              return this.isEnable() ? new Promise(function (n) {
                n(t.getLocalFile().filter(function (t) {
                  return t.sourceURL === e;
                }));
              }) : Promise.resolve([]);
            }, t.prototype.isDirectory = function (e) {
              var t = this;
              return this.isEnable() ? new Promise(function (n) {
                HD(e) ? n(!1) : n(t.getLocalFile().some(function (t) {
                  return t.path.startsWith("" + e + qj);
                }));
              }) : Promise.resolve(!1);
            }, t.prototype.ls = function (e) {
              var t = this;
              return this.isEnable() ? new Promise(function (n) {
                var r = [];
                t.getLocalFile().forEach(function (t) {
                  if (!BD(t)) if (e) {
                    if (t.path.startsWith("" + e + qj)) {
                      var n = t.path.split("" + e + qj)[1] || "";

                      if (n.includes(qj)) {
                        var i = "" + e + qj + n.split(qj)[0];
                        return void (i && !r.includes(i) && r.push(i));
                      }

                      r.push(t);
                    }
                  } else if (t.path.includes(qj)) {
                    var o = t.path.split(qj)[0] || "";
                    o && !r.includes(o) && r.push(o);
                  } else r.push(t);
                }), n(r);
              }) : Promise.resolve([]);
            }, t;
          }(WD);

          !function (e) {
            e.MEMORY = "memoryStore", e.INDEX_DB = "indexedDBStore", e.STORAGE = "storageStore";
          }(FD || (FD = {}));

          var YD = function (e) {
            function t(t) {
              var n = e.call(this) || this;
              return n.indexedDBStore = new KD(t), n.memoryStore = new QD(), n.storageStore = new ZD(t), n;
            }

            return CD(t, e), t.prototype.saveFile = function (e, t, n) {
              var r = this;
              void 0 === t && (t = !0);
              var i = (n || {}).forceSpecifyStore;
              return (t ? this.findFileByPath(e.path, n) : Promise.resolve(void 0)).then(function (t) {
                if ((null == t ? void 0 : t.version) && VD(e, t.version)) throw new Error("there is an higher version file existed already");

                var n = _kD(_kD({}, e), {
                  createTime: t && t.createTime || Date.now(),
                  updateTime: Date.now()
                });

                return i && r[i] && r[i].isEnable() && (i !== FD.STORAGE || r.isLocalStorageAvaliable(n)) ? r[i].saveFile(n) : r[r.saveToTargetStoreRule(n)].saveFile(n);
              });
            }, t.prototype.isLocalStorageAvaliable = function (e) {
              var t = e.data;
              return "string" === Fj(t) && t.length <= 102400 && this.storageStore.isEnable();
            }, t.prototype.saveToTargetStoreRule = function (e) {
              return this.indexedDBStore.isEnable() ? FD.INDEX_DB : this.isLocalStorageAvaliable(e) ? FD.STORAGE : FD.MEMORY;
            }, t.prototype.removeFile = function (e, t) {
              var n = (t || {}).forceSpecifyStore;
              return n && this[n] ? this[n].removeFile(e) : Promise.all([this.indexedDBStore.removeFile(e), this.storageStore.removeFile(e), this.memoryStore.removeFile(e)]).then(function () {
                return !0;
              });
            }, t.prototype.clear = function (e) {
              var t = (e || {}).forceSpecifyStore;
              return t && this[t] ? this[t].clear() : Promise.all([this.indexedDBStore.clear(), this.storageStore.clear(), this.memoryStore.clear()]).then(function () {
                return !0;
              });
            }, t.prototype.findFileByPath = function (e, t) {
              var n = this,
                  r = (t || {}).forceSpecifyStore;
              return r && this[r] ? this[r].findFileByPath(e) : qD(this.searchInTargetStoreRule(), function (t, r) {
                return t ? Promise.resolve(t) : n[r].findFileByPath(e);
              });
            }, t.prototype.findFileBySourceURL = function (e, t) {
              var n = this,
                  r = (t || {}).forceSpecifyStore;
              return r && this[r] ? this[r].findFileBySourceURL(e) : qD(this.searchInTargetStoreRule(), function (t, r) {
                return n[r].findFileBySourceURL(e).then(function (e) {
                  return t ? t.filter(function (t) {
                    return !e.some(function (e) {
                      return e.path === t.path;
                    });
                  }).concat(e || []) : e || [];
                });
              });
            }, t.prototype.searchInTargetStoreRule = function () {
              return [FD.INDEX_DB, FD.STORAGE, FD.MEMORY];
            }, t.prototype.isDirectory = function (e) {
              var t = this;
              return e ? qD(this.searchInTargetStoreRule(), function (n, r) {
                return n ? Promise.resolve(!0) : t[r].isDirectory(e);
              }) : Promise.resolve(!0);
            }, t.prototype.ls = function (e) {
              var t = this;
              return this.isDirectory(e).then(function (n) {
                if (!n) throw new Error("path: " + e + " is an invalid directory path");
                return qD(t.searchInTargetStoreRule(), function (n, r) {
                  return t[r].ls(e).then(function (e) {
                    return n ? (e || []).concat(n.filter(function (t) {
                      return !e.some(function (e) {
                        return "string" == typeof t ? e === t : "string" != typeof e && e.path === t.path;
                      });
                    })) : e;
                  });
                });
              });
            }, t;
          }(ID),
              JD = function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return CD(t, e), t;
          }(ID),
              $D = function (e) {
            function t(t) {
              var n = e.call(this) || this,
                  r = t || {},
                  i = r.storeOptions,
                  o = r.downloadManagerOptions;
              return n.downloadManager = new xD(o), n.store = new YD(i), n.store.indexedDBStore.on("ready", function () {
                return n.emit("ready");
              }), n;
            }

            return CD(t, e), t.prototype.getFile = function (e, t, n) {
              var r = this,
                  i = new JD(),
                  o = Promise.resolve(void 0),
                  a = t || {},
                  s = a.downloadOptions,
                  c = a.forceDownload,
                  l = a.saveRootPath;
              c ? o = Promise.resolve(void 0) : "string" == typeof e ? o = this.store.findFileByPath(e, n) : (null == e ? void 0 : e.sourceURL) ? o = this.store.findFileBySourceURL(e.sourceURL) : s && (s.domParams || s.socketParams || s.xhrParams) && (o = this.store.findFileBySourceURL(this.genSourceURL(s)));
              var d = null,
                  u = new Promise(function (e) {
                d = e;
              });
              return i.getDownloadTask = function () {
                return u;
              }, o = o.then(function (e) {
                if (e && (!Array.isArray(e) || e.length)) {
                  var t = e;

                  if (Array.isArray(t)) {
                    var r = t.find(function (e) {
                      return BD(e);
                    });
                    if (!r) return;
                    t = t.filter(function (e) {
                      return !BD(e);
                    });
                    var o = r.data;
                    if ("string" != typeof o) return;
                    if (!JSON.parse(o || "[]").every(function (e) {
                      return t.some(function (t) {
                        return t.path === e;
                      });
                    })) return;
                  }

                  if (!(null == n ? void 0 : n.targetVersion) || !VD(t, n.targetVersion)) return i.emit("checkExpire", !1), t;
                  i.emit("checkExpire", !0);
                }
              }).then(function (t) {
                if (!t && s) {
                  var o = r.downloadManager.download(s);
                  return d(o), new Promise(function (t, a) {
                    o.on("complete", function (o) {
                      setTimeout(function () {
                        var a = Array.isArray(o) ? o.map(function (e) {
                          var t = e.data,
                              i = e.path,
                              o = e.extName;
                          return {
                            path: r.genFilePath(l, i),
                            sourceURL: r.genSourceURL(s),
                            data: t,
                            fileFormat: o || r.getFileFormat(s),
                            version: (null == n ? void 0 : n.targetVersion) || 1
                          };
                        }) : {
                          path: r.genFilePath(l, void 0),
                          sourceURL: r.genSourceURL(s),
                          data: o,
                          fileFormat: r.getFileFormat(s),
                          version: (null == n ? void 0 : n.targetVersion) || 1
                        };

                        if (Array.isArray(a) && "string" == typeof e && e) {
                          var c = a.find(function (t) {
                            return t.path === e;
                          });
                          t(c || a);
                        } else t(a);

                        i.emit("beforeSet", a), r.beforeWrite(a, n).then(function () {
                          i.emit("afterSet");
                        }).catch(function (e) {
                          return i.emit("afterSet", e);
                        });
                      }, 0);
                    }), o.on("abort", a), o.on("error", a), o.on("timeout", function () {
                      return a(new Error("download timeout"));
                    });
                  });
                }

                return d(void 0), t;
              }).catch(function (e) {
                return d(void 0), Promise.reject(e);
              }), i.getResult = function () {
                return o;
              }, i;
            }, t.prototype.genSourceURL = function (e) {
              var t = e.domParams,
                  n = e.type,
                  r = e.xhrParams;
              if (n === hD.SOCKET) return null;
              var i = (n === hD.DOM ? t : r) || {},
                  o = i.url,
                  a = void 0 === o ? "" : o,
                  s = i.body;
              return s && Object.keys(s).length ? a + (a.includes("?") ? "&" : "?") + "downloadBodyParams=" + JSON.stringify(s) : a;
            }, t.prototype.updateFile = function (e, t) {
              return this.saveStore(e, !0, t);
            }, t.prototype.beforeWrite = function (e, t) {
              var n,
                  r,
                  i = this;
              return Array.isArray(e) ? Promise.all(e.concat((n = e, r = n[0].sourceURL || "", {
                path: "ZipInfo:" + r,
                sourceURL: r,
                data: JSON.stringify(n.map(function (e) {
                  return e.path;
                }))
              })).map(function (e) {
                return i.saveStore(e, !1, t);
              })).then(function (e) {
                return e.filter(function (e) {
                  return !BD(e);
                });
              }) : this.saveStore(e, !0, t);
            }, t.prototype.getFileFormat = function (e) {
              var t = e || {},
                  n = t.xhrParams,
                  r = t.domParams,
                  i = t.socketParams,
                  o = t.type;
              return o === hD.DOM && (null == r ? void 0 : r.fileFormat) ? r.fileFormat : o === hD.SOCKET && (null == i ? void 0 : i.fileFormat) ? i.fileFormat : (null == n ? void 0 : n.fileFormat) ? n.fileFormat : "unknow";
            }, t.prototype.genFilePath = function (e, t) {
              return t ? "" + (e || "") + (e ? qj : "") + t : e || "";
            }, t.prototype.saveStore = function (e, t, n) {
              return void 0 === t && (t = !0), this.store.saveFile(e, t, n).then(function (t) {
                if (t) return e;
                throw new Error("fail to save file in local store");
              });
            }, t.prototype.remove = function (e, t) {
              return this.store.removeFile(e, t);
            }, t.prototype.clear = function (e) {
              return this.store.clear(e);
            }, t.prototype.list = function (e) {
              return this.store.ls(e);
            }, t.prototype.updateVersion = function (e, t) {
              var n = this;
              return this.store.findFileByPath(e).then(function (r) {
                if (r) return n.saveStore(_kD(_kD({}, r), {
                  version: t
                })).then(function () {});
                throw new Error("the target path: " + e + " isn't existed");
              });
            }, t.prototype.updateSourceURL = function (e, t) {
              var n = this;
              return this.store.findFileByPath(e).then(function (r) {
                if (r) return n.saveStore(_kD(_kD({}, r), {
                  sourceURL: t
                })).then(function () {});
                throw new Error("the target path: " + e + " isn't existed");
              });
            }, t;
          }(ID);

          function XD(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? Object(arguments[t]) : {},
                  r = Object.keys(n);
              "function" == typeof Object.getOwnPropertySymbols && r.push.apply(r, Object.getOwnPropertySymbols(n).filter(function (e) {
                return Object.getOwnPropertyDescriptor(n, e).enumerable;
              })), r.forEach(function (t) {
                Py(e, t, n[t]);
              });
            }

            return e;
          }

          var ez = {
            type: "logger",
            log: function log(e) {
              this.output("log", e);
            },
            warn: function warn(e) {
              this.output("warn", e);
            },
            error: function error(e) {
              this.output("error", e);
            },
            output: function output(e, t) {
              console && console[e] && console[e].apply(console, t);
            }
          },
              tz = function () {
            function e(t) {
              var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              BC(this, e), this.init(t, n);
            }

            return RS(e, [{
              key: "init",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                this.prefix = t.prefix || "i18next:", this.logger = e || ez, this.options = t, this.debug = t.debug;
              }
            }, {
              key: "setDebug",
              value: function value(e) {
                this.debug = e;
              }
            }, {
              key: "log",
              value: function value() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                  t[n] = arguments[n];
                }

                return this.forward(t, "log", "", !0);
              }
            }, {
              key: "warn",
              value: function value() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                  t[n] = arguments[n];
                }

                return this.forward(t, "warn", "", !0);
              }
            }, {
              key: "error",
              value: function value() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                  t[n] = arguments[n];
                }

                return this.forward(t, "error", "");
              }
            }, {
              key: "deprecate",
              value: function value() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                  t[n] = arguments[n];
                }

                return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
              }
            }, {
              key: "forward",
              value: function value(e, t, n, r) {
                return r && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(n).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
              }
            }, {
              key: "create",
              value: function value(t) {
                return new e(this.logger, XD({}, {
                  prefix: "".concat(this.prefix, ":").concat(t, ":")
                }, this.options));
              }
            }]), e;
          }(),
              nz = new tz(),
              rz = function () {
            function e() {
              BC(this, e), this.observers = {};
            }

            return RS(e, [{
              key: "on",
              value: function value(e, t) {
                var n = this;
                return e.split(" ").forEach(function (e) {
                  n.observers[e] = n.observers[e] || [], n.observers[e].push(t);
                }), this;
              }
            }, {
              key: "off",
              value: function value(e, t) {
                this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
                  return e !== t;
                }) : delete this.observers[e]);
              }
            }, {
              key: "emit",
              value: function value(e) {
                for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
                  n[r - 1] = arguments[r];
                }

                this.observers[e] && [].concat(this.observers[e]).forEach(function (e) {
                  e.apply(void 0, n);
                }), this.observers["*"] && [].concat(this.observers["*"]).forEach(function (t) {
                  t.apply(t, [e].concat(n));
                });
              }
            }]), e;
          }();

          function iz() {
            var e,
                t,
                n = new Promise(function (n, r) {
              e = n, t = r;
            });
            return n.resolve = e, n.reject = t, n;
          }

          function oz(e) {
            return null == e ? "" : "" + e;
          }

          function az(e, t, n) {
            e.forEach(function (e) {
              t[e] && (n[e] = t[e]);
            });
          }

          function sz(e, t, n) {
            function r(e) {
              return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
            }

            function i() {
              return !e || "string" == typeof e;
            }

            for (var o = "string" != typeof t ? [].concat(t) : t.split("."); o.length > 1;) {
              if (i()) return {};
              var a = r(o.shift());
              !e[a] && n && (e[a] = new n()), e = Object.prototype.hasOwnProperty.call(e, a) ? e[a] : {};
            }

            return i() ? {} : {
              obj: e,
              k: r(o.shift())
            };
          }

          function cz(e, t, n) {
            var r = sz(e, t, Object);
            r.obj[r.k] = n;
          }

          function lz(e, t) {
            var n = sz(e, t),
                r = n.obj,
                i = n.k;
            if (r) return r[i];
          }

          function dz(e, t, n) {
            var r = lz(e, n);
            return void 0 !== r ? r : lz(t, n);
          }

          function uz(e, t, n) {
            for (var r in t) {
              "__proto__" !== r && "constructor" !== r && (r in e ? "string" == typeof e[r] || e[r] instanceof String || "string" == typeof t[r] || t[r] instanceof String ? n && (e[r] = t[r]) : uz(e[r], t[r], n) : e[r] = t[r]);
            }

            return e;
          }

          function pz(e) {
            return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
          }

          var hz = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;"
          };

          function _z(e) {
            return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
              return hz[e];
            }) : e;
          }

          var fz = "undefined" != typeof window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;

          function mz(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";

            if (e) {
              if (e[t]) return e[t];

              for (var r = t.split(n), i = e, o = 0; o < r.length; ++o) {
                if (!i) return;
                if ("string" == typeof i[r[o]] && o + 1 < r.length) return;

                if (void 0 === i[r[o]]) {
                  for (var a = 2, s = r.slice(o, o + a).join(n), c = i[s]; void 0 === c && r.length > o + a;) {
                    a++, c = i[s = r.slice(o, o + a).join(n)];
                  }

                  if (void 0 === c) return;
                  if ("string" == typeof c) return c;
                  if (s && "string" == typeof c[s]) return c[s];
                  var l = r.slice(o + a).join(n);
                  return l ? mz(c, l, n) : void 0;
                }

                i = i[r[o]];
              }

              return i;
            }
          }

          var gz = function (e) {
            function t(e) {
              var n,
                  r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                ns: ["translation"],
                defaultNS: "translation"
              };
              return BC(this, t), n = VR(this, qR(t).call(this)), fz && rz.call(jS(n)), n.data = e || {}, n.options = r, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), void 0 === n.options.ignoreJSONStructure && (n.options.ignoreJSONStructure = !0), n;
            }

            return HR(t, e), RS(t, [{
              key: "addNamespaces",
              value: function value(e) {
                this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
              }
            }, {
              key: "removeNamespaces",
              value: function value(e) {
                var t = this.options.ns.indexOf(e);
                t > -1 && this.options.ns.splice(t, 1);
              }
            }, {
              key: "getResource",
              value: function value(e, t, n) {
                var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                    i = void 0 !== r.keySeparator ? r.keySeparator : this.options.keySeparator,
                    o = void 0 !== r.ignoreJSONStructure ? r.ignoreJSONStructure : this.options.ignoreJSONStructure,
                    a = [e, t];
                n && "string" != typeof n && (a = a.concat(n)), n && "string" == typeof n && (a = a.concat(i ? n.split(i) : n)), e.indexOf(".") > -1 && (a = e.split("."));
                var s = lz(this.data, a);
                return s || !o || "string" != typeof n ? s : mz(this.data && this.data[e] && this.data[e][t], n, i);
              }
            }, {
              key: "addResource",
              value: function value(e, t, n, r) {
                var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
                  silent: !1
                },
                    o = this.options.keySeparator;
                void 0 === o && (o = ".");
                var a = [e, t];
                n && (a = a.concat(o ? n.split(o) : n)), e.indexOf(".") > -1 && (r = t, t = (a = e.split("."))[1]), this.addNamespaces(t), cz(this.data, a, r), i.silent || this.emit("added", e, t, n, r);
              }
            }, {
              key: "addResources",
              value: function value(e, t, n) {
                var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
                  silent: !1
                };

                for (var i in n) {
                  "string" != typeof n[i] && "[object Array]" !== Object.prototype.toString.apply(n[i]) || this.addResource(e, t, i, n[i], {
                    silent: !0
                  });
                }

                r.silent || this.emit("added", e, t, n);
              }
            }, {
              key: "addResourceBundle",
              value: function value(e, t, n, r, i) {
                var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
                  silent: !1
                },
                    a = [e, t];
                e.indexOf(".") > -1 && (r = n, n = t, t = (a = e.split("."))[1]), this.addNamespaces(t);
                var s = lz(this.data, a) || {};
                r ? uz(s, n, i) : s = XD({}, s, n), cz(this.data, a, s), o.silent || this.emit("added", e, t, n);
              }
            }, {
              key: "removeResourceBundle",
              value: function value(e, t) {
                this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
              }
            }, {
              key: "hasResourceBundle",
              value: function value(e, t) {
                return void 0 !== this.getResource(e, t);
              }
            }, {
              key: "getResourceBundle",
              value: function value(e, t) {
                return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? XD({}, {}, this.getResource(e, t)) : this.getResource(e, t);
              }
            }, {
              key: "getDataByLanguage",
              value: function value(e) {
                return this.data[e];
              }
            }, {
              key: "toJSON",
              value: function value() {
                return this.data;
              }
            }]), t;
          }(rz),
              vz = {
            processors: {},
            addPostProcessor: function addPostProcessor(e) {
              this.processors[e.name] = e;
            },
            handle: function handle(e, t, n, r, i) {
              var o = this;
              return e.forEach(function (e) {
                o.processors[e] && (t = o.processors[e].process(t, n, r, i));
              }), t;
            }
          },
              bz = {},
              yz = function (e) {
            function t(e) {
              var n,
                  r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return BC(this, t), n = VR(this, qR(t).call(this)), fz && rz.call(jS(n)), az(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, jS(n)), n.options = r, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), n.logger = nz.create("translator"), n;
            }

            return HR(t, e), RS(t, [{
              key: "changeLanguage",
              value: function value(e) {
                e && (this.language = e);
              }
            }, {
              key: "exists",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                  interpolation: {}
                };
                if (null == e) return !1;
                var n = this.resolve(e, t);
                return n && void 0 !== n.res;
              }
            }, {
              key: "extractFromKey",
              value: function value(e, t) {
                var n = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
                void 0 === n && (n = ":");
                var r = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
                    i = t.ns || this.options.defaultNS;

                if (n && e.indexOf(n) > -1) {
                  var o = e.match(this.interpolator.nestingRegexp);
                  if (o && o.length > 0) return {
                    key: e,
                    namespaces: i
                  };
                  var a = e.split(n);
                  (n !== r || n === r && this.options.ns.indexOf(a[0]) > -1) && (i = a.shift()), e = a.join(r);
                }

                return "string" == typeof i && (i = [i]), {
                  key: e,
                  namespaces: i
                };
              }
            }, {
              key: "translate",
              value: function value(e, n, r) {
                var i = this;
                if ("object" !== Ey(n) && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), n || (n = {}), null == e) return "";
                Array.isArray(e) || (e = [String(e)]);
                var o = void 0 !== n.keySeparator ? n.keySeparator : this.options.keySeparator,
                    a = this.extractFromKey(e[e.length - 1], n),
                    s = a.key,
                    c = a.namespaces,
                    l = c[c.length - 1],
                    d = n.lng || this.language,
                    u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

                if (d && "cimode" === d.toLowerCase()) {
                  if (u) {
                    var p = n.nsSeparator || this.options.nsSeparator;
                    return l + p + s;
                  }

                  return s;
                }

                var h = this.resolve(e, n),
                    _ = h && h.res,
                    f = h && h.usedKey || s,
                    m = h && h.exactUsedKey || s,
                    g = Object.prototype.toString.apply(_),
                    v = ["[object Number]", "[object Function]", "[object RegExp]"],
                    b = void 0 !== n.joinArrays ? n.joinArrays : this.options.joinArrays,
                    y = !this.i18nFormat || this.i18nFormat.handleAsObject;

                if (y && _ && "string" != typeof _ && "boolean" != typeof _ && "number" != typeof _ && v.indexOf(g) < 0 && ("string" != typeof b || "[object Array]" !== g)) {
                  if (!n.returnObjects && !this.options.returnObjects) return this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!"), this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, _, XD({}, n, {
                    ns: c
                  })) : "key '".concat(s, " (").concat(this.language, ")' returned an object instead of string.");

                  if (o) {
                    var w = "[object Array]" === g,
                        S = w ? [] : {},
                        x = w ? m : f;

                    for (var E in _) {
                      if (Object.prototype.hasOwnProperty.call(_, E)) {
                        var C = "".concat(x).concat(o).concat(E);
                        S[E] = this.translate(C, XD({}, n, {
                          joinArrays: !1,
                          ns: c
                        })), S[E] === C && (S[E] = _[E]);
                      }
                    }

                    _ = S;
                  }
                } else if (y && "string" == typeof b && "[object Array]" === g) (_ = _.join(b)) && (_ = this.extendTranslation(_, e, n, r));else {
                  var k = !1,
                      A = !1,
                      I = void 0 !== n.count && "string" != typeof n.count,
                      T = t.hasDefaultValue(n),
                      O = I ? this.pluralResolver.getSuffix(d, n.count) : "",
                      R = n["defaultValue".concat(O)] || n.defaultValue;
                  !this.isValidLookup(_) && T && (k = !0, _ = R), this.isValidLookup(_) || (A = !0, _ = s);
                  var N = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && A ? void 0 : _,
                      P = T && R !== _ && this.options.updateMissing;

                  if (A || k || P) {
                    if (this.logger.log(P ? "updateKey" : "missingKey", d, l, s, P ? R : _), o) {
                      var j = this.resolve(s, XD({}, n, {
                        keySeparator: !1
                      }));
                      j && j.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                    }

                    var D = [],
                        z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
                    if ("fallback" === this.options.saveMissingTo && z && z[0]) for (var M = 0; M < z.length; M++) {
                      D.push(z[M]);
                    } else "all" === this.options.saveMissingTo ? D = this.languageUtils.toResolveHierarchy(n.lng || this.language) : D.push(n.lng || this.language);

                    var L = function L(e, t, r) {
                      i.options.missingKeyHandler ? i.options.missingKeyHandler(e, l, t, P ? r : N, P, n) : i.backendConnector && i.backendConnector.saveMissing && i.backendConnector.saveMissing(e, l, t, P ? r : N, P, n), i.emit("missingKey", e, l, t, _);
                    };

                    this.options.saveMissing && (this.options.saveMissingPlurals && I ? D.forEach(function (e) {
                      i.pluralResolver.getSuffixes(e).forEach(function (t) {
                        L([e], s + t, n["defaultValue".concat(t)] || R);
                      });
                    }) : L(D, s, R));
                  }

                  _ = this.extendTranslation(_, e, n, h, r), A && _ === s && this.options.appendNamespaceToMissingKey && (_ = "".concat(l, ":").concat(s)), (A || k) && this.options.parseMissingKeyHandler && (_ = this.options.parseMissingKeyHandler(_));
                }

                return _;
              }
            }, {
              key: "extendTranslation",
              value: function value(e, t, n, r, i) {
                var o = this;
                if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, n, r.usedLng, r.usedNS, r.usedKey, {
                  resolved: r
                });else if (!n.skipInterpolation) {
                  n.interpolation && this.interpolator.init(XD({}, n, {
                    interpolation: XD({}, this.options.interpolation, n.interpolation)
                  }));
                  var a,
                      s = n.interpolation && n.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;

                  if (s) {
                    var c = e.match(this.interpolator.nestingRegexp);
                    a = c && c.length;
                  }

                  var l = n.replace && "string" != typeof n.replace ? n.replace : n;

                  if (this.options.interpolation.defaultVariables && (l = XD({}, this.options.interpolation.defaultVariables, l)), e = this.interpolator.interpolate(e, l, n.lng || this.language, n), s) {
                    var d = e.match(this.interpolator.nestingRegexp);
                    a < (d && d.length) && (n.nest = !1);
                  }

                  !1 !== n.nest && (e = this.interpolator.nest(e, function () {
                    for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++) {
                      r[a] = arguments[a];
                    }

                    return i && i[0] === r[0] && !n.context ? (o.logger.warn("It seems you are nesting recursively key: ".concat(r[0], " in key: ").concat(t[0])), null) : o.translate.apply(o, r.concat([t]));
                  }, n)), n.interpolation && this.interpolator.reset();
                }
                var u = n.postProcess || this.options.postProcess,
                    p = "string" == typeof u ? [u] : u;
                return null != e && p && p.length && !1 !== n.applyPostProcessor && (e = vz.handle(p, e, t, this.options && this.options.postProcessPassResolved ? XD({
                  i18nResolved: r
                }, n) : n, this)), e;
              }
            }, {
              key: "resolve",
              value: function value(e) {
                var t,
                    n,
                    r,
                    i,
                    o,
                    a = this,
                    s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return "string" == typeof e && (e = [e]), e.forEach(function (e) {
                  if (!a.isValidLookup(t)) {
                    var c = a.extractFromKey(e, s),
                        l = c.key;
                    n = l;
                    var d = c.namespaces;
                    a.options.fallbackNS && (d = d.concat(a.options.fallbackNS));
                    var u = void 0 !== s.count && "string" != typeof s.count,
                        p = void 0 !== s.context && ("string" == typeof s.context || "number" == typeof s.context) && "" !== s.context,
                        h = s.lngs ? s.lngs : a.languageUtils.toResolveHierarchy(s.lng || a.language, s.fallbackLng);
                    d.forEach(function (e) {
                      a.isValidLookup(t) || (o = e, !bz["".concat(h[0], "-").concat(e)] && a.utils && a.utils.hasLoadedNamespace && !a.utils.hasLoadedNamespace(o) && (bz["".concat(h[0], "-").concat(e)] = !0, a.logger.warn('key "'.concat(n, '" for languages "').concat(h.join(", "), '" won\'t get resolved as namespace "').concat(o, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), h.forEach(function (n) {
                        if (!a.isValidLookup(t)) {
                          i = n;
                          var o,
                              c,
                              d = l,
                              h = [d];

                          for (a.i18nFormat && a.i18nFormat.addLookupKeys ? a.i18nFormat.addLookupKeys(h, l, n, e, s) : (u && (o = a.pluralResolver.getSuffix(n, s.count)), u && p && h.push(d + o), p && h.push(d += "".concat(a.options.contextSeparator).concat(s.context)), u && h.push(d += o)); c = h.pop();) {
                            a.isValidLookup(t) || (r = c, t = a.getResource(n, e, c, s));
                          }
                        }
                      }));
                    });
                  }
                }), {
                  res: t,
                  usedKey: n,
                  exactUsedKey: r,
                  usedLng: i,
                  usedNS: o
                };
              }
            }, {
              key: "isValidLookup",
              value: function value(e) {
                return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
              }
            }, {
              key: "getResource",
              value: function value(e, t, n) {
                var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
                return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, n, r) : this.resourceStore.getResource(e, t, n, r);
              }
            }], [{
              key: "hasDefaultValue",
              value: function value(e) {
                var t = "defaultValue";

                for (var n in e) {
                  if (Object.prototype.hasOwnProperty.call(e, n) && t === n.substring(0, t.length) && void 0 !== e[n]) return !0;
                }

                return !1;
              }
            }]), t;
          }(rz);

          function wz(e) {
            return e.charAt(0).toUpperCase() + e.slice(1);
          }

          var Sz = function () {
            function e(t) {
              BC(this, e), this.options = t, this.whitelist = this.options.supportedLngs || !1, this.supportedLngs = this.options.supportedLngs || !1, this.logger = nz.create("languageUtils");
            }

            return RS(e, [{
              key: "getScriptPartFromCode",
              value: function value(e) {
                if (!e || e.indexOf("-") < 0) return null;
                var t = e.split("-");
                return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
              }
            }, {
              key: "getLanguagePartFromCode",
              value: function value(e) {
                if (!e || e.indexOf("-") < 0) return e;
                var t = e.split("-");
                return this.formatLanguageCode(t[0]);
              }
            }, {
              key: "formatLanguageCode",
              value: function value(e) {
                if ("string" == typeof e && e.indexOf("-") > -1) {
                  var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
                      n = e.split("-");
                  return this.options.lowerCaseLng ? n = n.map(function (e) {
                    return e.toLowerCase();
                  }) : 2 === n.length ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = wz(n[1].toLowerCase()))) : 3 === n.length && (n[0] = n[0].toLowerCase(), 2 === n[1].length && (n[1] = n[1].toUpperCase()), "sgn" !== n[0] && 2 === n[2].length && (n[2] = n[2].toUpperCase()), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = wz(n[1].toLowerCase())), t.indexOf(n[2].toLowerCase()) > -1 && (n[2] = wz(n[2].toLowerCase()))), n.join("-");
                }

                return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
              }
            }, {
              key: "isWhitelisted",
              value: function value(e) {
                return this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.'), this.isSupportedCode(e);
              }
            }, {
              key: "isSupportedCode",
              value: function value(e) {
                return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
              }
            }, {
              key: "getBestMatchFromCodes",
              value: function value(e) {
                var t,
                    n = this;
                return e ? (e.forEach(function (e) {
                  if (!t) {
                    var r = n.formatLanguageCode(e);
                    n.options.supportedLngs && !n.isSupportedCode(r) || (t = r);
                  }
                }), !t && this.options.supportedLngs && e.forEach(function (e) {
                  if (!t) {
                    var r = n.getLanguagePartFromCode(e);
                    if (n.isSupportedCode(r)) return t = r;
                    t = n.options.supportedLngs.find(function (e) {
                      if (0 === e.indexOf(r)) return e;
                    });
                  }
                }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
              }
            }, {
              key: "getFallbackCodes",
              value: function value(e, t) {
                if (!e) return [];
                if ("function" == typeof e && (e = e(t)), "string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
                if (!t) return e.default || [];
                var n = e[t];
                return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
              }
            }, {
              key: "toResolveHierarchy",
              value: function value(e, t) {
                var n = this,
                    r = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
                    i = [],
                    o = function o(e) {
                  e && (n.isSupportedCode(e) ? i.push(e) : n.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
                };

                return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && o(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && o(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && o(this.getLanguagePartFromCode(e))) : "string" == typeof e && o(this.formatLanguageCode(e)), r.forEach(function (e) {
                  i.indexOf(e) < 0 && o(n.formatLanguageCode(e));
                }), i;
              }
            }]), e;
          }(),
              xz = [{
            lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
            nr: [1, 2],
            fc: 1
          }, {
            lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
            nr: [1, 2],
            fc: 2
          }, {
            lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
            nr: [1],
            fc: 3
          }, {
            lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
            nr: [1, 2, 5],
            fc: 4
          }, {
            lngs: ["ar"],
            nr: [0, 1, 2, 3, 11, 100],
            fc: 5
          }, {
            lngs: ["cs", "sk"],
            nr: [1, 2, 5],
            fc: 6
          }, {
            lngs: ["csb", "pl"],
            nr: [1, 2, 5],
            fc: 7
          }, {
            lngs: ["cy"],
            nr: [1, 2, 3, 8],
            fc: 8
          }, {
            lngs: ["fr"],
            nr: [1, 2],
            fc: 9
          }, {
            lngs: ["ga"],
            nr: [1, 2, 3, 7, 11],
            fc: 10
          }, {
            lngs: ["gd"],
            nr: [1, 2, 3, 20],
            fc: 11
          }, {
            lngs: ["is"],
            nr: [1, 2],
            fc: 12
          }, {
            lngs: ["jv"],
            nr: [0, 1],
            fc: 13
          }, {
            lngs: ["kw"],
            nr: [1, 2, 3, 4],
            fc: 14
          }, {
            lngs: ["lt"],
            nr: [1, 2, 10],
            fc: 15
          }, {
            lngs: ["lv"],
            nr: [1, 2, 0],
            fc: 16
          }, {
            lngs: ["mk"],
            nr: [1, 2],
            fc: 17
          }, {
            lngs: ["mnk"],
            nr: [0, 1, 2],
            fc: 18
          }, {
            lngs: ["mt"],
            nr: [1, 2, 11, 20],
            fc: 19
          }, {
            lngs: ["or"],
            nr: [2, 1],
            fc: 2
          }, {
            lngs: ["ro"],
            nr: [1, 2, 20],
            fc: 20
          }, {
            lngs: ["sl"],
            nr: [5, 1, 2, 3],
            fc: 21
          }, {
            lngs: ["he", "iw"],
            nr: [1, 2, 20, 21],
            fc: 22
          }],
              Ez = {
            1: function _(e) {
              return Number(e > 1);
            },
            2: function _(e) {
              return Number(1 != e);
            },
            3: function _(e) {
              return 0;
            },
            4: function _(e) {
              return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
            },
            5: function _(e) {
              return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
            },
            6: function _(e) {
              return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
            },
            7: function _(e) {
              return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
            },
            8: function _(e) {
              return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
            },
            9: function _(e) {
              return Number(e >= 2);
            },
            10: function _(e) {
              return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
            },
            11: function _(e) {
              return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
            },
            12: function _(e) {
              return Number(e % 10 != 1 || e % 100 == 11);
            },
            13: function _(e) {
              return Number(0 !== e);
            },
            14: function _(e) {
              return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
            },
            15: function _(e) {
              return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
            },
            16: function _(e) {
              return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
            },
            17: function _(e) {
              return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
            },
            18: function _(e) {
              return Number(0 == e ? 0 : 1 == e ? 1 : 2);
            },
            19: function _(e) {
              return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
            },
            20: function _(e) {
              return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
            },
            21: function _(e) {
              return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
            },
            22: function _(e) {
              return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
            }
          };

          function Cz() {
            var e = {};
            return xz.forEach(function (t) {
              t.lngs.forEach(function (n) {
                e[n] = {
                  numbers: t.nr,
                  plurals: Ez[t.fc]
                };
              });
            }), e;
          }

          var kz = function () {
            function e(t) {
              var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              BC(this, e), this.languageUtils = t, this.options = n, this.logger = nz.create("pluralResolver"), this.rules = Cz();
            }

            return RS(e, [{
              key: "addRule",
              value: function value(e, t) {
                this.rules[e] = t;
              }
            }, {
              key: "getRule",
              value: function value(e) {
                return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
              }
            }, {
              key: "needsPlural",
              value: function value(e) {
                var t = this.getRule(e);
                return t && t.numbers.length > 1;
              }
            }, {
              key: "getPluralFormsOfKey",
              value: function value(e, t) {
                return this.getSuffixes(e).map(function (e) {
                  return t + e;
                });
              }
            }, {
              key: "getSuffixes",
              value: function value(e) {
                var t = this,
                    n = this.getRule(e);
                return n ? n.numbers.map(function (n) {
                  return t.getSuffix(e, n);
                }) : [];
              }
            }, {
              key: "getSuffix",
              value: function value(e, t) {
                var n = this,
                    r = this.getRule(e);

                if (r) {
                  var i = r.noAbs ? r.plurals(t) : r.plurals(Math.abs(t)),
                      o = r.numbers[i];
                  this.options.simplifyPluralSuffix && 2 === r.numbers.length && 1 === r.numbers[0] && (2 === o ? o = "plural" : 1 === o && (o = ""));

                  var a = function a() {
                    return n.options.prepend && o.toString() ? n.options.prepend + o.toString() : o.toString();
                  };

                  return "v1" === this.options.compatibilityJSON ? 1 === o ? "" : "number" == typeof o ? "_plural_".concat(o.toString()) : a() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === r.numbers.length && 1 === r.numbers[0] ? a() : this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
                }

                return this.logger.warn("no plural rule found for: ".concat(e)), "";
              }
            }]), e;
          }(),
              Az = function () {
            function e() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              BC(this, e), this.logger = nz.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
                return e;
              }, this.init(t);
            }

            return RS(e, [{
              key: "init",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                e.interpolation || (e.interpolation = {
                  escapeValue: !0
                });
                var t = e.interpolation;
                this.escape = void 0 !== t.escape ? t.escape : _z, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? pz(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? pz(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? pz(t.nestingPrefix) : t.nestingPrefixEscaped || pz("$t("), this.nestingSuffix = t.nestingSuffix ? pz(t.nestingSuffix) : t.nestingSuffixEscaped || pz(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
              }
            }, {
              key: "reset",
              value: function value() {
                this.options && this.init(this.options);
              }
            }, {
              key: "resetRegExp",
              value: function value() {
                var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(e, "g");
                var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(t, "g");
                var n = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(n, "g");
              }
            }, {
              key: "interpolate",
              value: function value(e, t, n, r) {
                var i,
                    o,
                    a,
                    s = this,
                    c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

                function l(e) {
                  return e.replace(/\$/g, "$$$$");
                }

                var d = function d(e) {
                  if (e.indexOf(s.formatSeparator) < 0) {
                    var i = dz(t, c, e);
                    return s.alwaysFormat ? s.format(i, void 0, n, XD({}, r, t, {
                      interpolationkey: e
                    })) : i;
                  }

                  var o = e.split(s.formatSeparator),
                      a = o.shift().trim(),
                      l = o.join(s.formatSeparator).trim();
                  return s.format(dz(t, c, a), l, n, XD({}, r, t, {
                    interpolationkey: a
                  }));
                };

                this.resetRegExp();
                var u = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler,
                    p = r && r.interpolation && r.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                return [{
                  regex: this.regexpUnescape,
                  safeValue: function safeValue(e) {
                    return l(e);
                  }
                }, {
                  regex: this.regexp,
                  safeValue: function safeValue(e) {
                    return s.escapeValue ? l(s.escape(e)) : l(e);
                  }
                }].forEach(function (t) {
                  for (a = 0; i = t.regex.exec(e);) {
                    if (void 0 === (o = d(i[1].trim()))) {
                      if ("function" == typeof u) {
                        var n = u(e, i, r);
                        o = "string" == typeof n ? n : "";
                      } else {
                        if (p) {
                          o = i[0];
                          continue;
                        }

                        s.logger.warn("missed to pass in variable ".concat(i[1], " for interpolating ").concat(e)), o = "";
                      }
                    } else "string" == typeof o || s.useRawValueToEscape || (o = oz(o));
                    var c = t.safeValue(o);
                    if (e = e.replace(i[0], c), p ? (t.regex.lastIndex += c.length, t.regex.lastIndex -= i[0].length) : t.regex.lastIndex = 0, ++a >= s.maxReplaces) break;
                  }
                }), e;
              }
            }, {
              key: "nest",
              value: function value(e, t) {
                var n,
                    r,
                    i = this,
                    o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    a = XD({}, o);

                function s(e, t) {
                  var n = this.nestingOptionsSeparator;
                  if (e.indexOf(n) < 0) return e;
                  var r = e.split(new RegExp("".concat(n, "[ ]*{"))),
                      i = "{".concat(r[1]);
                  e = r[0], i = (i = this.interpolate(i, a)).replace(/'/g, '"');

                  try {
                    a = JSON.parse(i), t && (a = XD({}, t, a));
                  } catch (t) {
                    return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(n).concat(i);
                  }

                  return delete a.defaultValue, e;
                }

                for (a.applyPostProcessor = !1, delete a.defaultValue; n = this.nestingRegexp.exec(e);) {
                  var c = [],
                      l = !1;

                  if (-1 !== n[0].indexOf(this.formatSeparator) && !/{.*}/.test(n[1])) {
                    var d = n[1].split(this.formatSeparator).map(function (e) {
                      return e.trim();
                    });
                    n[1] = d.shift(), c = d, l = !0;
                  }

                  if ((r = t(s.call(this, n[1].trim(), a), a)) && n[0] === e && "string" != typeof r) return r;
                  "string" != typeof r && (r = oz(r)), r || (this.logger.warn("missed to resolve ".concat(n[1], " for nesting ").concat(e)), r = ""), l && (r = c.reduce(function (e, t) {
                    return i.format(e, t, o.lng, XD({}, o, {
                      interpolationkey: n[1].trim()
                    }));
                  }, r.trim())), e = e.replace(n[0], r), this.regexp.lastIndex = 0;
                }

                return e;
              }
            }]), e;
          }(),
              Iz = function (e) {
            function t(e, n, r) {
              var i,
                  o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
              return BC(this, t), i = VR(this, qR(t).call(this)), fz && rz.call(jS(i)), i.backend = e, i.store = n, i.services = r, i.languageUtils = r.languageUtils, i.options = o, i.logger = nz.create("backendConnector"), i.state = {}, i.queue = [], i.backend && i.backend.init && i.backend.init(r, o.backend, o), i;
            }

            return HR(t, e), RS(t, [{
              key: "queueLoad",
              value: function value(e, t, n, r) {
                var i = this,
                    o = [],
                    a = [],
                    s = [],
                    c = [];
                return e.forEach(function (e) {
                  var r = !0;
                  t.forEach(function (t) {
                    var s = "".concat(e, "|").concat(t);
                    !n.reload && i.store.hasResourceBundle(e, t) ? i.state[s] = 2 : i.state[s] < 0 || (1 === i.state[s] ? a.indexOf(s) < 0 && a.push(s) : (i.state[s] = 1, r = !1, a.indexOf(s) < 0 && a.push(s), o.indexOf(s) < 0 && o.push(s), c.indexOf(t) < 0 && c.push(t)));
                  }), r || s.push(e);
                }), (o.length || a.length) && this.queue.push({
                  pending: a,
                  loaded: {},
                  errors: [],
                  callback: r
                }), {
                  toLoad: o,
                  pending: a,
                  toLoadLanguages: s,
                  toLoadNamespaces: c
                };
              }
            }, {
              key: "loaded",
              value: function value(e, t, n) {
                var r = e.split("|"),
                    i = r[0],
                    o = r[1];
                t && this.emit("failedLoading", i, o, t), n && this.store.addResourceBundle(i, o, n), this.state[e] = t ? -1 : 2;
                var a = {};
                this.queue.forEach(function (n) {
                  !function (e, t, n, r) {
                    var i = sz(e, t, Object),
                        o = i.obj,
                        a = i.k;
                    o[a] = o[a] || [], r && (o[a] = o[a].concat(n)), r || o[a].push(n);
                  }(n.loaded, [i], o), function (e, t) {
                    for (var n = e.indexOf(t); -1 !== n;) {
                      e.splice(n, 1), n = e.indexOf(t);
                    }
                  }(n.pending, e), t && n.errors.push(t), 0 !== n.pending.length || n.done || (Object.keys(n.loaded).forEach(function (e) {
                    a[e] || (a[e] = []), n.loaded[e].length && n.loaded[e].forEach(function (t) {
                      a[e].indexOf(t) < 0 && a[e].push(t);
                    });
                  }), n.done = !0, n.errors.length ? n.callback(n.errors) : n.callback());
                }), this.emit("loaded", a), this.queue = this.queue.filter(function (e) {
                  return !e.done;
                });
              }
            }, {
              key: "read",
              value: function value(e, t, n) {
                var r = this,
                    i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
                    o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 350,
                    a = arguments.length > 5 ? arguments[5] : void 0;
                return e.length ? this.backend[n](e, t, function (s, c) {
                  s && c && i < 5 ? setTimeout(function () {
                    r.read.call(r, e, t, n, i + 1, 2 * o, a);
                  }, o) : a(s, c);
                }) : a(null, {});
              }
            }, {
              key: "prepareLoading",
              value: function value(e, t) {
                var n = this,
                    r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    i = arguments.length > 3 ? arguments[3] : void 0;
                if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i && i();
                "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
                var o = this.queueLoad(e, t, r, i);
                if (!o.toLoad.length) return o.pending.length || i(), null;
                o.toLoad.forEach(function (e) {
                  n.loadOne(e);
                });
              }
            }, {
              key: "load",
              value: function value(e, t, n) {
                this.prepareLoading(e, t, {}, n);
              }
            }, {
              key: "reload",
              value: function value(e, t, n) {
                this.prepareLoading(e, t, {
                  reload: !0
                }, n);
              }
            }, {
              key: "loadOne",
              value: function value(e) {
                var t = this,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                    r = e.split("|"),
                    i = r[0],
                    o = r[1];
                this.read(i, o, "read", void 0, void 0, function (r, a) {
                  r && t.logger.warn("".concat(n, "loading namespace ").concat(o, " for language ").concat(i, " failed"), r), !r && a && t.logger.log("".concat(n, "loaded namespace ").concat(o, " for language ").concat(i), a), t.loaded(e, r, a);
                });
              }
            }, {
              key: "saveMissing",
              value: function value(e, t, n, r, i) {
                var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t) ? this.logger.warn('did not save key "'.concat(n, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != n && "" !== n && (this.backend && this.backend.create && this.backend.create(e, t, n, r, null, XD({}, o, {
                  isUpdate: i
                })), e && e[0] && this.store.addResource(e[0], t, n, r));
              }
            }]), t;
          }(rz);

          function Tz() {
            return {
              debug: !1,
              initImmediate: !0,
              ns: ["translation"],
              defaultNS: ["translation"],
              fallbackLng: ["dev"],
              fallbackNS: !1,
              whitelist: !1,
              nonExplicitWhitelist: !1,
              supportedLngs: !1,
              nonExplicitSupportedLngs: !1,
              load: "all",
              preload: !1,
              simplifyPluralSuffix: !0,
              keySeparator: ".",
              nsSeparator: ":",
              pluralSeparator: "_",
              contextSeparator: "_",
              partialBundledLanguages: !1,
              saveMissing: !1,
              updateMissing: !1,
              saveMissingTo: "fallback",
              saveMissingPlurals: !0,
              missingKeyHandler: !1,
              missingInterpolationHandler: !1,
              postProcess: !1,
              postProcessPassResolved: !1,
              returnNull: !0,
              returnEmptyString: !0,
              returnObjects: !1,
              joinArrays: !1,
              returnedObjectHandler: !1,
              parseMissingKeyHandler: !1,
              appendNamespaceToMissingKey: !1,
              appendNamespaceToCIMode: !1,
              overloadTranslationOptionHandler: function overloadTranslationOptionHandler(e) {
                var t = {};

                if ("object" === Ey(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === Ey(e[2]) || "object" === Ey(e[3])) {
                  var n = e[3] || e[2];
                  Object.keys(n).forEach(function (e) {
                    t[e] = n[e];
                  });
                }

                return t;
              },
              interpolation: {
                escapeValue: !0,
                format: function format(e, t, n, r) {
                  return e;
                },
                prefix: "{{",
                suffix: "}}",
                formatSeparator: ",",
                unescapePrefix: "-",
                nestingPrefix: "$t(",
                nestingSuffix: ")",
                nestingOptionsSeparator: ",",
                maxReplaces: 1e3,
                skipOnVariables: !1
              }
            };
          }

          function Oz(e) {
            return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.whitelist && (e.whitelist && e.whitelist.indexOf("cimode") < 0 && (e.whitelist = e.whitelist.concat(["cimode"])), e.supportedLngs = e.whitelist), e.nonExplicitWhitelist && (e.nonExplicitSupportedLngs = e.nonExplicitWhitelist), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
          }

          function Rz() {}

          var Nz = function (e) {
            function t() {
              var e,
                  n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  r = arguments.length > 1 ? arguments[1] : void 0;

              if (BC(this, t), e = VR(this, qR(t).call(this)), fz && rz.call(jS(e)), e.options = Oz(n), e.services = {}, e.logger = nz, e.modules = {
                external: []
              }, r && !e.isInitialized && !n.isClone) {
                if (!e.options.initImmediate) return e.init(n, r), VR(e, jS(e));
                setTimeout(function () {
                  e.init(n, r);
                }, 0);
              }

              return e;
            }

            return HR(t, e), RS(t, [{
              key: "init",
              value: function value() {
                var e = this,
                    t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    n = arguments.length > 1 ? arguments[1] : void 0;

                function r(e) {
                  return e ? "function" == typeof e ? new e() : e : null;
                }

                if ("function" == typeof t && (n = t, t = {}), t.whitelist && !t.supportedLngs && this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'), t.nonExplicitWhitelist && !t.nonExplicitSupportedLngs && this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'), this.options = XD({}, Tz(), this.options, Oz(t)), this.format = this.options.interpolation.format, n || (n = Rz), !this.options.isClone) {
                  this.modules.logger ? nz.init(r(this.modules.logger), this.options) : nz.init(null, this.options);
                  var i = new Sz(this.options);
                  this.store = new gz(this.options.resources, this.options);
                  var o = this.services;
                  o.logger = nz, o.resourceStore = this.store, o.languageUtils = i, o.pluralResolver = new kz(i, {
                    prepend: this.options.pluralSeparator,
                    compatibilityJSON: this.options.compatibilityJSON,
                    simplifyPluralSuffix: this.options.simplifyPluralSuffix
                  }), o.interpolator = new Az(this.options), o.utils = {
                    hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                  }, o.backendConnector = new Iz(r(this.modules.backend), o.resourceStore, o, this.options), o.backendConnector.on("*", function (t) {
                    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
                      r[i - 1] = arguments[i];
                    }

                    e.emit.apply(e, [t].concat(r));
                  }), this.modules.languageDetector && (o.languageDetector = r(this.modules.languageDetector), o.languageDetector.init(o, this.options.detection, this.options)), this.modules.i18nFormat && (o.i18nFormat = r(this.modules.i18nFormat), o.i18nFormat.init && o.i18nFormat.init(this)), this.translator = new yz(this.services, this.options), this.translator.on("*", function (t) {
                    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
                      r[i - 1] = arguments[i];
                    }

                    e.emit.apply(e, [t].concat(r));
                  }), this.modules.external.forEach(function (t) {
                    t.init && t.init(e);
                  });
                }

                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                  var a = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                  a.length > 0 && "dev" !== a[0] && (this.options.lng = a[0]);
                }

                this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach(function (t) {
                  e[t] = function () {
                    var n;
                    return (n = e.store)[t].apply(n, arguments);
                  };
                }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach(function (t) {
                  e[t] = function () {
                    var n;
                    return (n = e.store)[t].apply(n, arguments), e;
                  };
                });

                var s = iz(),
                    c = function c() {
                  var t = function t(_t139, r) {
                    e.isInitialized && !e.initializedStoreOnce && e.logger.warn("init: i18next is already initialized. You should call init just once!"), e.isInitialized = !0, e.options.isClone || e.logger.log("initialized", e.options), e.emit("initialized", e.options), s.resolve(r), n(_t139, r);
                  };

                  if (e.languages && "v1" !== e.options.compatibilityAPI && !e.isInitialized) return t(null, e.t.bind(e));
                  e.changeLanguage(e.options.lng, t);
                };

                return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), s;
              }
            }, {
              key: "loadResources",
              value: function value(e) {
                var t = this,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Rz,
                    r = "string" == typeof e ? e : this.language;

                if ("function" == typeof e && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
                  if (r && "cimode" === r.toLowerCase()) return n();

                  var i = [],
                      o = function o(e) {
                    e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                      i.indexOf(e) < 0 && i.push(e);
                    });
                  };

                  r ? o(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach(function (e) {
                    return o(e);
                  }), this.options.preload && this.options.preload.forEach(function (e) {
                    return o(e);
                  }), this.services.backendConnector.load(i, this.options.ns, n);
                } else n(null);
              }
            }, {
              key: "reloadResources",
              value: function value(e, t, n) {
                var r = iz();
                return e || (e = this.languages), t || (t = this.options.ns), n || (n = Rz), this.services.backendConnector.reload(e, t, function (e) {
                  r.resolve(), n(e);
                }), r;
              }
            }, {
              key: "use",
              value: function value(e) {
                if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && vz.addPostProcessor(e), "3rdParty" === e.type && this.modules.external.push(e), this;
              }
            }, {
              key: "changeLanguage",
              value: function value(e, t) {
                var n = this;
                this.isLanguageChangingTo = e;
                var r = iz();
                this.emit("languageChanging", e);

                var i = function i(_i28) {
                  e || _i28 || !n.services.languageDetector || (_i28 = []);
                  var o = "string" == typeof _i28 ? _i28 : n.services.languageUtils.getBestMatchFromCodes(_i28);
                  o && (n.language || (n.language = o, n.languages = n.services.languageUtils.toResolveHierarchy(o)), n.translator.language || n.translator.changeLanguage(o), n.services.languageDetector && n.services.languageDetector.cacheUserLanguage(o)), n.loadResources(o, function (e) {
                    !function (e, i) {
                      i ? (n.language = i, n.languages = n.services.languageUtils.toResolveHierarchy(i), n.translator.changeLanguage(i), n.isLanguageChangingTo = void 0, n.emit("languageChanged", i), n.logger.log("languageChanged", i)) : n.isLanguageChangingTo = void 0, r.resolve(function () {
                        return n.t.apply(n, arguments);
                      }), t && t(e, function () {
                        return n.t.apply(n, arguments);
                      });
                    }(e, o);
                  });
                };

                return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(i) : i(e) : i(this.services.languageDetector.detect()), r;
              }
            }, {
              key: "getFixedT",
              value: function value(e, t, n) {
                var r = this,
                    i = function e(t, i) {
                  var o;

                  if ("object" !== Ey(i)) {
                    for (var a = arguments.length, s = new Array(a > 2 ? a - 2 : 0), c = 2; c < a; c++) {
                      s[c - 2] = arguments[c];
                    }

                    o = r.options.overloadTranslationOptionHandler([t, i].concat(s));
                  } else o = XD({}, i);

                  o.lng = o.lng || e.lng, o.lngs = o.lngs || e.lngs, o.ns = o.ns || e.ns;
                  var l = r.options.keySeparator || ".",
                      d = n ? "".concat(n).concat(l).concat(t) : t;
                  return r.t(d, o);
                };

                return "string" == typeof e ? i.lng = e : i.lngs = e, i.ns = t, i.keyPrefix = n, i;
              }
            }, {
              key: "t",
              value: function value() {
                var e;
                return this.translator && (e = this.translator).translate.apply(e, arguments);
              }
            }, {
              key: "exists",
              value: function value() {
                var e;
                return this.translator && (e = this.translator).exists.apply(e, arguments);
              }
            }, {
              key: "setDefaultNamespace",
              value: function value(e) {
                this.options.defaultNS = e;
              }
            }, {
              key: "hasLoadedNamespace",
              value: function value(e) {
                var t = this,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
                if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
                var r = this.languages[0],
                    i = !!this.options && this.options.fallbackLng,
                    o = this.languages[this.languages.length - 1];
                if ("cimode" === r.toLowerCase()) return !0;

                var a = function a(e, n) {
                  var r = t.services.backendConnector.state["".concat(e, "|").concat(n)];
                  return -1 === r || 2 === r;
                };

                if (n.precheck) {
                  var s = n.precheck(this, a);
                  if (void 0 !== s) return s;
                }

                return !!this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || !(!a(r, e) || i && !a(o, e));
              }
            }, {
              key: "loadNamespaces",
              value: function value(e, t) {
                var n = this,
                    r = iz();
                return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
                  n.options.ns.indexOf(e) < 0 && n.options.ns.push(e);
                }), this.loadResources(function (e) {
                  r.resolve(), t && t(e);
                }), r) : (t && t(), Promise.resolve());
              }
            }, {
              key: "loadLanguages",
              value: function value(e, t) {
                var n = iz();
                "string" == typeof e && (e = [e]);
                var r = this.options.preload || [],
                    i = e.filter(function (e) {
                  return r.indexOf(e) < 0;
                });
                return i.length ? (this.options.preload = r.concat(i), this.loadResources(function (e) {
                  n.resolve(), t && t(e);
                }), n) : (t && t(), Promise.resolve());
              }
            }, {
              key: "dir",
              value: function value(e) {
                return e || (e = this.languages && this.languages.length > 0 ? this.languages[0] : this.language), e ? ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e)) >= 0 ? "rtl" : "ltr" : "rtl";
              }
            }, {
              key: "createInstance",
              value: function value() {
                return new t(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, arguments.length > 1 ? arguments[1] : void 0);
              }
            }, {
              key: "cloneInstance",
              value: function value() {
                var e = this,
                    n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Rz,
                    i = XD({}, this.options, n, {
                  isClone: !0
                }),
                    o = new t(i);
                return ["store", "services", "language"].forEach(function (t) {
                  o[t] = e[t];
                }), o.services = XD({}, this.services), o.services.utils = {
                  hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
                }, o.translator = new yz(o.services, o.options), o.translator.on("*", function (e) {
                  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
                    n[r - 1] = arguments[r];
                  }

                  o.emit.apply(o, [e].concat(n));
                }), o.init(i, r), o.translator.options = o.options, o.translator.backendConnector.services.utils = {
                  hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
                }, o;
              }
            }, {
              key: "toJSON",
              value: function value() {
                return {
                  options: this.options,
                  store: this.store,
                  language: this.language,
                  languages: this.languages
                };
              }
            }]), t;
          }(rz),
              Pz = new Nz();

          var jz = "2.8.0";
          var Dz = "https://source.zoom.us/".concat(jz, "/lib/image");

          function zz(e, t, n) {
            var r = [{
              test: function test(e) {
                return e.isHost;
              },
              label: "(".concat(Pz.t("wc_host_1"), ")")
            }, {
              test: function test(e) {
                return e.isCoHost;
              },
              label: Pz.t("wc_co_host")
            }, {
              test: function test(e, t) {
                return e.userId === t;
              },
              label: Pz.t("wc_me")
            }, {
              test: function test(e, t, n) {
                return e.isGuest && e.userId !== t && !n;
              },
              label: Pz.t("wc_guest")
            }],
                i = r.map(function (r) {
              if (r.test(e, t, n)) return r.label;
            }).filter(Boolean).join(", ");
            return i ? "".concat(i).replace("\uFF09, \uFF08", ", ").replace("), (", ", ").replace("\uFF08", "(").replace("\uFF09", ")") : "";
          }

          function Mz(e) {
            var t = "";

            if (e) {
              var _n89 = /^https?:\/\//.test(e) ? e : "https://".concat(e),
                  _URL = new URL(_n89),
                  r = _URL.hostname;

              window.crossOriginIsolated ? r.indexOf("zoom") > -1 && (t = _n89) : t = _n89;
            }

            return t;
          }

          document.getElementById("aria-notify-area");

          var Lz = function Lz() {
            var e;
            return /MacIntel/i.test(navigator.platform) && (null === (e = navigator) || void 0 === e ? void 0 : e.maxTouchPoints) > 2;
          },
              Uz = function Uz() {
            var _navigator3 = navigator,
                e = _navigator3.userAgent;
            return /iPad|iPhone|iPod/i.test(e) || Lz();
          };

          function Bz() {
            return /android/i.test(navigator.userAgent);
          }

          function Hz() {
            return Bz() || "function" == typeof window.OffscreenCanvas;
          }

          var Vz = function Vz(e) {
            var t = e.resourceManager,
                n = e.fileName,
                r = e.folderName;
            if (!n) return {
              previewSmallStatus: "success",
              displayURL: "",
              previewSmallObjectURL: "",
              msg: ""
            };
            var i = "".concat(Dz, "/").concat(n),
                o = {
              forceSpecifyStore: ""
            };
            t.store.indexedDBStore.isEnable() || (o.forceSpecifyStore = "memoryStore");
            var a = t.getFile("".concat(r, "/").concat(n), {
              saveRootPath: "".concat(r, "/").concat(n),
              downloadOptions: {
                xhrParams: {
                  url: i,
                  encoding: 1,
                  method: "GET",
                  body: {
                    type: "blob",
                    fileName: n
                  },
                  timeout: 6e5
                }
              }
            }, o),
                s = new Promise(function (e, t) {
              a.getResult().then(function (t) {
                var n = URL.createObjectURL(t.data);
                e({
                  previewSmallStatus: "success",
                  displayURL: n,
                  previewSmallObjectURL: n,
                  msg: ""
                });
              }).catch(function (t) {
                e({
                  previewSmallStatus: "fail",
                  displayURL: "",
                  previewSmallObjectURL: "",
                  msg: t
                });
              });
            });
            return s;
          },
              qz = function qz(e, t) {
            return function (e) {
              var t,
                  n = e.nameSpaceId,
                  r = e.params;
              return t = n ? new $D({
                storeOptions: {
                  nameSpaceId: n
                }
              }) : new $D(), new Promise(function (e) {
                t.on("ready", function () {
                  e({
                    resourceManager: t,
                    params: r
                  });
                });
              });
            }({}).then(function (n) {
              var r = n.resourceManager;
              var i = t.map(function (t) {
                return Vz({
                  resourceManager: r,
                  fileName: t.fileName,
                  folderName: e
                });
              });
              return Promise.all(i);
            }).then(function (t) {
              var n = t.map(function (t, n) {
                return {
                  previewSmallStatus: t.previewSmallStatus,
                  displayURL: null == t ? void 0 : t.displayURL,
                  previewSmallObjectURL: null == t ? void 0 : t.previewSmallObjectURL,
                  id: null != t && t.displayURL ? "".concat(e).concat(n) : ""
                };
              });
              return new Promise(function (e, t) {
                e(n);
              });
            });
          };

          function Fz(t, n) {
            e.useLayoutEffect(function () {
              if (!t) return function () {};
              var e = new ResizeObserver(function (e) {
                e.forEach(function (e) {
                  n({
                    width: e.target.clientWidth,
                    height: e.target.clientHeight
                  });
                });
              });
              return e.observe(t), function () {
                e.unobserve(t), e.disconnect();
              };
            }, [t, n]);
          }

          function Wz(t) {
            var n = e.useRef(null);
            return e.useEffect(function () {
              n.current = t;
            }, [t]), n.current;
          }

          function Gz(t, n, r) {
            var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
              capture: !1,
              passive: !1
            };
            var o = e.useRef();
            o.current = r, e.useEffect(function () {
              var e;
              var r = null;

              if (r = t ? Object.hasOwnProperty.call(t, "current") ? t.current : t : window, null !== (e = r) && void 0 !== e && e.addEventListener) {
                var _e284 = function _e284(e) {
                  var t;
                  return null === (t = o.current) || void 0 === t ? void 0 : t.call(o, e);
                };

                return r.addEventListener(n, _e284, {
                  capture: i.capture,
                  passive: i.passive
                }), function () {
                  var t;
                  null === (t = r) || void 0 === t || t.removeEventListener(n, _e284, {
                    capture: i.capture
                  });
                };
              }

              return function () {};
            }, [t, n, i]);
          }

          function Kz(t, n) {
            var _e$useState = e.useState(!1),
                _e$useState2 = _slicedToArray(_e$useState, 2),
                r = _e$useState2[0],
                i = _e$useState2[1],
                _ref25 = n || {},
                o = _ref25.onEnter,
                a = _ref25.onLeave;

            return Gz(t, "mouseenter", function () {
              null == o || o(), i(!0);
            }), Gz(t, "mouseleave", function () {
              null == a || a(), i(!1);
            }), r;
          }

          var Qz = {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0
          },
              Zz = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;

          function Yz(e) {
            var t = {
              type: "tag",
              name: "",
              voidElement: !1,
              attrs: {},
              children: []
            },
                n = e.match(/<\/?([^\s]+?)[/\s>]/);

            if (n && (t.name = n[1], (Qz[n[1]] || "/" === e.charAt(e.length - 2)) && (t.voidElement = !0), t.name.startsWith("!--"))) {
              var r = e.indexOf("--\x3e");
              return {
                type: "comment",
                comment: -1 !== r ? e.slice(4, r) : ""
              };
            }

            for (var i = new RegExp(Zz), o = null; null !== (o = i.exec(e));) {
              if (o[0].trim()) if (o[1]) {
                var a = o[1].trim(),
                    s = [a, ""];
                a.indexOf("=") > -1 && (s = a.split("=")), t.attrs[s[0]] = s[1], i.lastIndex--;
              } else o[2] && (t.attrs[o[2]] = o[3].trim().substring(1, o[3].length - 1));
            }

            return t;
          }

          var Jz = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,
              $z = /^\s*$/,
              Xz = Object.create(null),
              eM = function eM(e, t) {
            t || (t = {}), t.components || (t.components = Xz);
            var n,
                r = [],
                i = [],
                o = -1,
                a = !1;

            if (0 !== e.indexOf("<")) {
              var s = e.indexOf("<");
              r.push({
                type: "text",
                content: -1 === s ? e : e.substring(0, s)
              });
            }

            return e.replace(Jz, function (s, c) {
              if (a) {
                if (s !== "</" + n.name + ">") return;
                a = !1;
              }

              var l,
                  d = "/" !== s.charAt(1),
                  u = s.startsWith("\x3c!--"),
                  p = c + s.length,
                  h = e.charAt(p);

              if (u) {
                var _ = Yz(s);

                return o < 0 ? (r.push(_), r) : ((l = i[o]).children.push(_), r);
              }

              if (d && (o++, "tag" === (n = Yz(s)).type && t.components[n.name] && (n.type = "component", a = !0), n.voidElement || a || !h || "<" === h || n.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
              }), 0 === o && r.push(n), (l = i[o - 1]) && l.children.push(n), i[o] = n), (!d || n.voidElement) && (o > -1 && (n.voidElement || n.name === s.slice(2, -1)) && (o--, n = -1 === o ? r : i[o]), !a && "<" !== h && h)) {
                l = -1 === o ? r : i[o].children;
                var f = e.indexOf("<", p),
                    m = e.slice(p, -1 === f ? void 0 : f);
                $z.test(m) && (m = " "), (f > -1 && o + l.length >= 0 || " " !== m) && l.push({
                  type: "text",
                  content: m
                });
              }
            }), r;
          },
              tM = "".replace,
              nM = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g,
              rM = {
            "&amp;": "&",
            "&#38;": "&",
            "&lt;": "<",
            "&#60;": "<",
            "&gt;": ">",
            "&#62;": ">",
            "&apos;": "'",
            "&#39;": "'",
            "&quot;": '"',
            "&#34;": '"'
          };

          function iM(e) {
            return rM[e];
          }

          function oM(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function aM(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? oM(Object(n), !0).forEach(function (t) {
                Py(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oM(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          var sM,
              cM = {
            bindI18n: "languageChanged",
            bindI18nStore: "",
            transEmptyNodeValue: "",
            transSupportBasicHtmlNodes: !0,
            transWrapTextNodes: "",
            transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
            useSuspense: !0
          },
              lM = a.default.createContext();

          function dM() {
            return cM;
          }

          var uM = function () {
            function e() {
              BC(this, e), this.usedNamespaces = {};
            }

            return RS(e, [{
              key: "addUsedNamespaces",
              value: function value(e) {
                var t = this;
                e.forEach(function (e) {
                  t.usedNamespaces[e] || (t.usedNamespaces[e] = !0);
                });
              }
            }, {
              key: "getUsedNamespaces",
              value: function value() {
                return Object.keys(this.usedNamespaces);
              }
            }]), e;
          }();

          function pM() {
            return sM;
          }

          var hM = {
            type: "3rdParty",
            init: function init(e) {
              !function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                cM = aM(aM({}, cM), e);
              }(e.options.react), function (e) {
                sM = e;
              }(e);
            }
          };

          function _M() {
            if (console && console.warn) {
              for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              "string" == typeof n[0] && (n[0] = "react-i18next:: ".concat(n[0])), (e = console).warn.apply(e, n);
            }
          }

          var fM = {};

          function mM() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            "string" == typeof t[0] && fM[t[0]] || ("string" == typeof t[0] && (fM[t[0]] = new Date()), _M.apply(void 0, t));
          }

          function gM(e, t, n) {
            e.loadNamespaces(t, function () {
              e.isInitialized ? n() : e.on("initialized", function t() {
                setTimeout(function () {
                  e.off("initialized", t);
                }, 0), n();
              });
            });
          }

          function vM(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                r = t.languages[0],
                i = !!t.options && t.options.fallbackLng,
                o = t.languages[t.languages.length - 1];
            if ("cimode" === r.toLowerCase()) return !0;

            var a = function a(e, n) {
              var r = t.services.backendConnector.state["".concat(e, "|").concat(n)];
              return -1 === r || 2 === r;
            };

            return !(n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e)) && (!!t.hasResourceBundle(r, e) || !(t.services.backendConnector.backend && (!t.options.resources || t.options.partialBundledLanguages)) || !(!a(r, e) || i && !a(o, e)));
          }

          function bM(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return t.languages && t.languages.length ? void 0 !== t.options.ignoreJSONStructure ? t.hasLoadedNamespace(e, {
              precheck: function precheck(t, r) {
                if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !r(t.isLanguageChangingTo, e)) return !1;
              }
            }) : vM(e, t, n) : (mM("i18n.languages were undefined or empty", t.languages), !0);
          }

          var yM = ["format"],
              wM = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];

          function SM(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function xM(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? SM(Object(n), !0).forEach(function (t) {
                Py(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : SM(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function EM(e, t) {
            if (!e) return !1;
            var n = e.props ? e.props.children : e.children;
            return t ? n.length > 0 : !!n;
          }

          function CM(e) {
            return e ? e && e.children ? e.children : e.props && e.props.children : [];
          }

          function kM(e) {
            return Array.isArray(e) ? e : [e];
          }

          function AM(e, t) {
            if (!e) return "";
            var n = "",
                r = kM(e),
                i = t.transSupportBasicHtmlNodes && t.transKeepBasicHtmlNodesFor ? t.transKeepBasicHtmlNodesFor : [];
            return r.forEach(function (e, r) {
              if ("string" == typeof e) n += "".concat(e);else if (a.default.isValidElement(e)) {
                var o = Object.keys(e.props).length,
                    s = i.indexOf(e.type) > -1,
                    c = e.props.children;
                if (!c && s && 0 === o) n += "<".concat(e.type, "/>");else if (c || s && 0 === o) {
                  if (e.props.i18nIsDynamicList) n += "<".concat(r, "></").concat(r, ">");else if (s && 1 === o && "string" == typeof c) n += "<".concat(e.type, ">").concat(c, "</").concat(e.type, ">");else {
                    var l = AM(c, t);
                    n += "<".concat(r, ">").concat(l, "</").concat(r, ">");
                  }
                } else n += "<".concat(r, "></").concat(r, ">");
              } else if (null === e) _M("Trans: the passed in value is invalid - seems you passed in a null child.");else if ("object" === Ey(e)) {
                var d = e.format,
                    u = bw(e, yM),
                    p = Object.keys(u);

                if (1 === p.length) {
                  var h = d ? "".concat(p[0], ", ").concat(d) : p[0];
                  n += "{{".concat(h, "}}");
                } else _M("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", e);
              } else _M("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", e);
            }), n;
          }

          function IM(e, t, n, r, i, o) {
            if ("" === t) return [];
            var s = r.transKeepBasicHtmlNodesFor || [],
                c = t && new RegExp(s.join("|")).test(t);
            if (!e && !c) return [t];
            var l = {};
            !function e(t) {
              kM(t).forEach(function (t) {
                "string" != typeof t && (EM(t) ? e(CM(t)) : "object" !== Ey(t) || a.default.isValidElement(t) || Object.assign(l, t));
              });
            }(e);
            var d = eM("<0>".concat(t, "</0>")),
                u = xM(xM({}, l), i);

            function p(e, t, n) {
              var r = CM(e),
                  i = _(r, t.children, n);

              return function (e) {
                return "[object Array]" === Object.prototype.toString.call(e) && e.every(function (e) {
                  return a.default.isValidElement(e);
                });
              }(r) && 0 === i.length ? r : i;
            }

            function h(e, t, n, r, i) {
              e.dummy && (e.children = t), n.push(a.default.cloneElement(e, xM(xM({}, e.props), {}, {
                key: r
              }), i ? void 0 : t));
            }

            function _(t, i, l) {
              var d = kM(t);
              return kM(i).reduce(function (t, i, f) {
                var m,
                    g,
                    v,
                    b = i.children && i.children[0] && i.children[0].content && n.services.interpolator.interpolate(i.children[0].content, u, n.language);

                if ("tag" === i.type) {
                  var y = d[parseInt(i.name, 10)];
                  !y && 1 === l.length && l[0][i.name] && (y = l[0][i.name]), y || (y = {});
                  var w = 0 !== Object.keys(i.attrs).length ? (m = {
                    props: i.attrs
                  }, (v = xM({}, g = y)).props = Object.assign(m.props, g.props), v) : y,
                      S = a.default.isValidElement(w),
                      x = S && EM(i, !0) && !i.voidElement,
                      E = c && "object" === Ey(w) && w.dummy && !S,
                      C = "object" === Ey(e) && null !== e && Object.hasOwnProperty.call(e, i.name);

                  if ("string" == typeof w) {
                    var k = n.services.interpolator.interpolate(w, u, n.language);
                    t.push(k);
                  } else if (EM(w) || x) h(w, p(w, i, l), t, f);else if (E) {
                    var A = _(d, i.children, l);

                    t.push(a.default.cloneElement(w, xM(xM({}, w.props), {}, {
                      key: f
                    }), A));
                  } else if (Number.isNaN(parseFloat(i.name))) {
                    if (C) h(w, p(w, i, l), t, f, i.voidElement);else if (r.transSupportBasicHtmlNodes && s.indexOf(i.name) > -1) {
                      if (i.voidElement) t.push(a.default.createElement(i.name, {
                        key: "".concat(i.name, "-").concat(f)
                      }));else {
                        var I = _(d, i.children, l);

                        t.push(a.default.createElement(i.name, {
                          key: "".concat(i.name, "-").concat(f)
                        }, I));
                      }
                    } else if (i.voidElement) t.push("<".concat(i.name, " />"));else {
                      var T = _(d, i.children, l);

                      t.push("<".concat(i.name, ">").concat(T, "</").concat(i.name, ">"));
                    }
                  } else if ("object" !== Ey(w) || S) 1 === i.children.length && b ? t.push(a.default.cloneElement(w, xM(xM({}, w.props), {}, {
                    key: f
                  }), b)) : t.push(a.default.cloneElement(w, xM(xM({}, w.props), {}, {
                    key: f
                  })));else {
                    var O = i.children[0] ? b : null;
                    O && t.push(O);
                  }
                } else if ("text" === i.type) {
                  var R = r.transWrapTextNodes,
                      N = o ? function (e) {
                    return tM.call(e, nM, iM);
                  }(n.services.interpolator.interpolate(i.content, u, n.language)) : n.services.interpolator.interpolate(i.content, u, n.language);
                  R ? t.push(a.default.createElement(R, {
                    key: "".concat(i.name, "-").concat(f)
                  }, N)) : t.push(N);
                }

                return t;
              }, []);
            }

            return CM(_([{
              dummy: !0,
              children: e || []
            }], d, kM(e || []))[0]);
          }

          function TM(t) {
            var n = t.children,
                r = t.count,
                i = t.parent,
                o = t.i18nKey,
                s = t.context,
                c = t.tOptions,
                l = void 0 === c ? {} : c,
                d = t.values,
                u = t.defaults,
                p = t.components,
                h = t.ns,
                _ = t.i18n,
                f = t.t,
                m = t.shouldUnescape,
                g = bw(t, wM),
                v = e.useContext(lM) || {},
                b = v.i18n,
                y = v.defaultNS,
                w = _ || b || pM();
            if (!w) return mM("You will need to pass in an i18next instance by using i18nextReactModule"), n;

            var S = f || w.t.bind(w) || function (e) {
              return e;
            };

            s && (l.context = s);
            var x = xM(xM({}, dM()), w.options && w.options.react),
                E = h || S.ns || y || w.options && w.options.defaultNS;
            E = "string" == typeof E ? [E] : E || ["translation"];
            var C = u || AM(n, x) || x.transEmptyNodeValue || o,
                k = x.hashTransKey,
                A = o || (k ? k(C) : C),
                I = d ? l.interpolation : {
              interpolation: xM(xM({}, l.interpolation), {}, {
                prefix: "#$?",
                suffix: "?$#"
              })
            },
                T = xM(xM(xM(xM({}, l), {}, {
              count: r
            }, d), I), {}, {
              defaultValue: C,
              ns: E
            }),
                O = IM(p || n, A ? S(A, T) : C, w, x, T, m),
                R = void 0 !== i ? i : x.defaultTransParent;
            return R ? a.default.createElement(R, g, O) : O;
          }

          function OM(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function RM(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? OM(Object(n), !0).forEach(function (t) {
                Py(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OM(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function NM(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = n.i18n,
                i = e.useContext(lM) || {},
                o = i.i18n,
                a = i.defaultNS,
                s = r || o || pM();

            if (s && !s.reportNamespaces && (s.reportNamespaces = new uM()), !s) {
              mM("You will need to pass in an i18next instance by using initReactI18next");

              var c = function c(e) {
                return Array.isArray(e) ? e[e.length - 1] : e;
              },
                  l = [c, {}, !1];

              return l.t = c, l.i18n = {}, l.ready = !1, l;
            }

            s.options.react && void 0 !== s.options.react.wait && mM("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
            var d = RM(RM(RM({}, dM()), s.options.react), n),
                u = d.useSuspense,
                p = d.keyPrefix,
                h = t || a || s.options && s.options.defaultNS;
            h = "string" == typeof h ? [h] : h || ["translation"], s.reportNamespaces.addUsedNamespaces && s.reportNamespaces.addUsedNamespaces(h);

            var _ = (s.isInitialized || s.initializedStoreOnce) && h.every(function (e) {
              return bM(e, s, d);
            });

            function f() {
              return s.getFixedT(null, "fallback" === d.nsMode ? h : h[0], p);
            }

            var m = cS(e.useState(f), 2),
                g = m[0],
                v = m[1],
                b = e.useRef(!0);
            e.useEffect(function () {
              var e = d.bindI18n,
                  t = d.bindI18nStore;

              function n() {
                b.current && v(f);
              }

              return b.current = !0, _ || u || gM(s, h, function () {
                b.current && v(f);
              }), e && s && s.on(e, n), t && s && s.store.on(t, n), function () {
                b.current = !1, e && s && e.split(" ").forEach(function (e) {
                  return s.off(e, n);
                }), t && s && t.split(" ").forEach(function (e) {
                  return s.store.off(e, n);
                });
              };
            }, [s, h.join()]);
            var y = e.useRef(!0);
            e.useEffect(function () {
              b.current && !y.current && v(f), y.current = !1;
            }, [s]);
            var w = [g, s, _];
            if (w.t = g, w.i18n = s, w.ready = _, _) return w;
            if (!_ && !u) return w;
            throw new Promise(function (e) {
              gM(s, h, function () {
                e();
              });
            });
          }

          var PM = {
            "en-US": {
              translation: {
                GOT_IT: "Got it",
                account_owner: "account owner",
                allow_to_access: "Allow Zoom to access your camera and microphone",
                "app_signal.approved_by": "Approved by",
                "app_signal.people": "people",
                "app_signal.tip_text_2": "See apps that are accessing your meeting content",
                "app_signal.unable_load2": "Unable to load apps with real-time access to your information.",
                "archiving.chat_1": "chat(public and direct)",
                "archiving.chat_2": "chat(public only)",
                "archiving.chat_disable_content": "Messages sent in chat could not be archived for compliance purposes.",
                "archiving.chat_disable_title": "Chat has been disabled",
                "archiving.content1_sdk": "One or more participants in this meeting are subject to archiving based on their account's policy. Their {{content}} will receive content from this meeting and can share it with apps and others.",
                "archiving.content2_sdk": "By staying in this meeting, you consent to this meeting's {{content}} being archived.",
                "archiving.default_title": "This meeting is being archived",
                "archiving.fail_content_sdk": "This meeting's {{features}} must be archived for compliance purposes.",
                "archiving.fail_title": "Archiving failed",
                "archiving.subjects_combo_2_sdk": "{{0}} and {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}}, and {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}}, and {{3}}",
                "archiving.tips_1_sdk": "This meeting's {{subjects}} is being archived by the host's organization based on their account's policy. Their {{receiver}} will receive content from this meeting and can share it with apps and others.",
                "archiving.tips_2_sdk": "This meeting's {{subjects}} are being archived by the host's organization based on their account's policy. Their {{receiver}} will receive content from this meeting and can share it with apps and others.",
                "archiving.transcription": "transcription",
                "ast.leave_tip": "Assistant has stopped controlling the meeting",
                "ast.tip": "This meeting is being controlled by an assistant",
                background: "Background",
                chat_message_header: "<0>{{senderName}}</0> <1>to</1> <2>{{receiverName}}</2>",
                chat_new_message: "{{counts}} New Message",
                chat_receiver_co_host: "( Co-host )",
                chat_receiver_host: "( Host )",
                chat_receiver_panelist: "( Panelist )",
                chat_receiver_to: "To:",
                choose_background: "Choose Background",
                click_address_bar: "Click the lock icon to the left of your address bar. A pop-up will appear with a list of options.",
                click_microphone_camera_option: "Click the drop-down list to the right of the Camera and Microphone option.",
                "common.cancel": "Cancel",
                "common.connecting": "Connecting",
                delete: "Delete",
                "dialog.btn_cancel": "Cancel",
                "dialog.btn_endconf_webinar": "End Webinar",
                "dialog.btn_leaveconf_meeting": "Leave Meeting",
                "dialog.btn_retry": "Retry",
                "dialog.host_end_meeting": "This meeting has been ended by host",
                "dialog.host_end_webinar": "This webinar has been ended by host",
                "dialog.meeting_ended": "The meeting has been ended",
                "dialog.meeting_locked": "The meeting has been locked",
                "dialog.meeting_removed_by_host": "You have been removed from this meeting by the host.",
                "dialog.newname": "Name",
                "dialog.ok": "OK",
                "dialog.presscode": "Meeting ID",
                "dialog.rename": "Rename",
                "dialog.server_error": "The server encountered an internal error and was unable to process your request.",
                "dialog.webinar_ended": "The webinar has been ended",
                "dialog.webinar_removed_by_host": "You have been removed from this webinar by the host.",
                "dialog.you_are_removed": "You have been removed",
                dialog_make_cohost: "Do you want to make {{displayName}} the co-host of this meeting?",
                dialog_make_host: "Do you want to change the host to {{displayName}} ?",
                dialog_remove_user: "Do you want to remove {{displayName}}?",
                "disclaimer.LT_button_1": "Who can see this transcript?",
                "disclaimer.LT_content_1_1": "The account owner and everyone in the meeting can save this transcript and share with apps and others.",
                "disclaimer.LT_content_2": "Live Transcription (Closed Captioning) has been enabled",
                "disclaimer.QA_button_1": "Who can see your questions?",
                "disclaimer.QA_content_1_1": "The account owner, host, and panelists will be able to see who you are, your contact information (if you're logged in or you provided it), and your question - and can share them with apps and others.",
                "disclaimer.QA_content_2": "If your question is selected, it will be visible to all attendees.",
                "disclaimer.QA_content_3_3": "Unless you submit anonymously, the account owner, host, and panelists will be able to see who you are, your contact information (if you're logged in or you provided it), and your question - and can share them with apps and others.",
                "disclaimer.QA_content_4": "This Q&A is public, so everyone can see your questions.",
                "disclaimer.QA_content_5": "If you submit your questions anonymously, nobody can see who submitted your questions.",
                "disclaimer.chat_button_normal": "Who can see your messages?",
                "disclaimer.chat_button_onArchiving": "Who can see your messages? Archiving on",
                "disclaimer.chat_button_onRecording": "Who can see your messages? Recording On",
                "disclaimer.chat_content_1": "Everyone in the meeting can see and save your messages with Everyone - and can share them with apps and others.",
                "disclaimer.chat_content_2": "Only you and those you chat with can save your direct messages and share them with apps and others.",
                "disclaimer.chat_content_3": "Recording is on, so the account owner and everyone in the meeting can see and save messages sent to Everyone - and can share them with apps and others.",
                "disclaimer.chat_content_4": "Recording is on, so everyone in the meeting can see and save messages sent to Everyone - and can share them with apps and others.",
                "disclaimer.chat_content_5": "Archiving is on, so the account owner can see all your messages \u2014 including your direct messages \u2014 and share them with apps and others.",
                "disclaimer.chat_content_6": "Everyone in the meeting can save and share the messages you send to Everyone.",
                "disclaimer.chat_content_7": "Archiving is on, so the account owner can see all your messages - not including your direct messages - and share them with apps and others.",
                errorcodes_be_removed: "Be removed.",
                errorcodes_denied_email: "Email is blocked by Administrator.",
                errorcodes_denied_register_with_panelist: "Denied register use panelist email.",
                errorcodes_disconnect: "Meeting has been disconnected.",
                errorcodes_email_require: "Email is missing to attend webinar.",
                errorcodes_fail: "Fail to join the meeting.",
                errorcodes_frequent_call: "You have reached the API limit for this call.",
                errorcodes_frequent_join: "You be limit by zoom, need to check recaptcha.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Unable join from browser, please join using the Zoom desktop client or mobile app.",
                errorcodes_not_exist: "Meeting does not exist.",
                errorcodes_not_host: "You are not the meeting host.",
                errorcodes_not_init: "Meeting not initialized.",
                errorcodes_not_start: "Meeting has not started",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "The service is temporarily offline.",
                errorcodes_pac_api_disabled: "The accounts API Key is deactivated.",
                errorcodes_pac_api_wrong: "The accounts API Key is not valid.",
                errorcodes_pac_cant_host_other_mn: "Cannot not host another meeting concurrently.",
                errorcodes_pac_host_not_found: "The meeting host is not found.",
                errorcodes_pac_invalid_signature: "Signature is invalid.",
                errorcodes_pac_mn_not_fount: "The meeting number is not found.",
                errorcodes_pac_mn_wrong: "The meeting number is wrong.",
                errorcodes_pac_no_permission: "No permission.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "Incorrect role.",
                errorcodes_pac_signature_expired: "The signature has expired.",
                errorcodes_re_connect: "Meeting is reconnecting.",
                errorcodes_register: "This meeting requires registration.",
                errorcodes_rwc_empty: "Could not get a response from the web server.",
                errorcodes_rwc_error: "Could not connect to Web Server error.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "Successfully joined the meeting.",
                errorcodes_tk_expired: "Token has expired.",
                errorcodes_wasm_fail: "Download wasm files error, please check your network and firewall.",
                errorcodes_web_has_in_progress: "Already has other meetings in progress.",
                errorcodes_web_host_not_exit: "The meeting host does not exist.",
                errorcodes_web_invalid_id: "Invalid meeting ID.",
                errorcodes_web_not_allow_start_webinar_from_web: "Not allow to start webinar from web.",
                errorcodes_web_not_support_registration_webinar: "Not support registration webinar",
                errorcodes_web_not_support_tsp: "Not support start or join meeting from web, when you chose TSP as his audio in a meeting.",
                errorcodes_web_not_support_webclient: "Not support start or join meeting from web.",
                errorcodes_web_not_support_webinar_pac: "Not support webinar and personal audio conference",
                errorcodes_web_require_email: "User email is required.",
                errorcodes_web_should_support_webinar_with_latest_version: "The current sdk version doesn't support webinar, please upgrade to the latest version.",
                errorcodes_wrong_pass: "Meeting Passcode wrong.",
                gallary_view: "Gallery View",
                invalid_parameter: "Invalid parameter",
                "invite.loading": "Loading...",
                meeting_disconnected: "Meeting Disconnected",
                meeting_info: "Meeting Information",
                meeting_info_network: "You are connected to {{network}} via data centers in {{dc}}",
                meeting_not_start: "The meeting has not started",
                meeting_taking: "Talking:",
                meeting_waiting_for_start: "Waiting for meeting to start",
                meeting_waiting_room: "The host will let you in soon",
                minimized_view: "Minimized View",
                mirror_my_video: "Mirror my video",
                "polling.Back": "Back",
                "promote.cancel": "Stay as Attendee",
                "promote.content_1": "As a panelist, you can unmute and start video which means you will be visible to others in the webinar.",
                "promote.content_2": "If the host or other panelists decide to record, livestream, or archive the webinar after you unmute, your participation will be included.",
                "promote.ok": "Join as Panelist",
                "promote.title": "The host would like to promote you to be a panelist",
                ribbon_view: "Ribbon View",
                "rmc.assistant_exist_warning": "You cannot control the meeting because another assistant is controlling this meeting.",
                "rmc.exist_notification_for_client_host": "This meeting is being controlled by an admin.",
                "rmc.not_exist_notification_for_client_host": "Admin has stopped controlling the meeting.",
                same_as_system: "Same as System",
                "security.allow_participants_to": "Allow participants to:",
                "security.button": "Security",
                "security.waiting_room": "Enable Waiting Room",
                select_allow: "Select the option Allow.",
                "settings.audio_tab_text": "Audio",
                "settings.enable_hd": "Enable HD Video",
                "settings.enable_hd_tip": "Enable all participants to view your video in high resolution (720P). Note that the actual result depends on machine performance and bandwidth.",
                "settings.frame_per_second": "Frame Per Second",
                "settings.frequency": "Frequency",
                "settings.input_level": "Input Level:",
                "settings.item_name": "Item name",
                "settings.jitter": "Jitter",
                "settings.latency": "Latency",
                "settings.maximum_view": "Maximum participants displayed per screen in Gallery View:",
                "settings.output_level": "Output Level:",
                "settings.packet_loss": "Packet loss - Avg(Max)",
                "settings.participants25": "25 participants",
                "settings.participants9": "9 participants",
                "settings.playing": "Playing",
                "settings.receive": "Receive",
                "settings.receiving_video": "Receiving video",
                "settings.receiving_video_tips": "Use hardware video decoder of the graphics card to save CPU usage for receiving video. Refresh the page for this change to take effect.",
                "settings.recording": "Recording",
                "settings.rejoin": "Rejoin",
                "settings.resolution": "Resolution",
                "settings.send": "Send",
                "settings.sending_video": "Sending video",
                "settings.sending_video_tips": "Use hardware video decoder of the graphics card to save CPU usage for sending video. Refresh the page for this change to take effect.",
                "settings.statistics": "Statistics",
                "settings.stop": "Stop",
                "settings.switch_view_mode_text": "You must rejoin the meeting to apply this change",
                "settings.test_mic": "Test Mic",
                "settings.test_speaker": "Test Speaker",
                "settings.unknown_device": "Unknown device",
                "settings.use_hardware_acceleration": "Use hardware acceleration for:",
                "settings.vb_init_10s_tip2": "Virtual Background is taking longer than expected to load.",
                "settings.vb_init_fail2": "Unable to load Virtual Background.",
                "settings.video_tab_text": "Video",
                speaker_view: "Speaker View",
                toolbar_join_audio: "Join Audio",
                toolbar_leave: "Leave",
                toolbar_mute: "Mute",
                toolbar_muteall: "Mute All",
                toolbar_record: "Record",
                toolbar_unmute: "Unmute",
                wait_room_tip1: "{{displayName}} has entered the Waiting Room",
                wait_room_tip2: "{{count}} people entered the Waiting Room",
                "wc.ast_admin_name": "Meeting Assistant",
                "wc.rmc_admin_name": "Meeting Control Admin",
                "wc.rmc_admin_tooltip": "This user has host controls and does not have access to any media content (audio, video, chat and reactions).",
                wc_3rd_cc_copied_api_token: "The API token has been copied to your clipboard",
                wc_3rd_cc_copy_api_token: "Copy the API token",
                wc_3rd_cc_service: "Use a 3rd party CC service",
                wc_3rd_cc_url_help_tips2: "Copy this token and paste it in a 3rd-party Closed Captioning tool",
                wc_admit: "Admit",
                wc_allow_to_talk: "Allow to talk",
                wc_audio: "Audio",
                "wc_audio.muted_notification1": "The host muted you",
                "wc_audio.muted_notification2": "The host muted everyone",
                "wc_audio.unmute_by_host_content_1": "The host would like you to speak",
                "wc_audio.unmute_by_host_content_2": "If you choose to unmute, others in the webinar will be able to hear you. If the host or panelists decide to record, livestream, or archive the webinar after you unmute, your voice will be included.",
                wc_audio_cannot_unmute: "You cannot unmute yourself because the host muted you.",
                wc_audio_connecting_thumbnail: "Connecting to audio",
                wc_broadcasting: "Broadcasting",
                wc_btn_endconf_meeting_all: "End Meeting for All",
                wc_camera_prevent: "Your browser is preventing access to your camera. Please enable it and restart your video",
                "wc_cc.placeholder": "Type here, press Enter to broadcast",
                wc_cc_assign_participant_to_type: "Assign a participant to type",
                wc_cc_assign_to: "Assign to type Closed Caption",
                wc_cc_assign_to_type: "Assign someone to type",
                wc_cc_broadcasting_tip: "Closed Captions are being broadcast to all participants.",
                wc_cc_host_assigned: "The host has assigned you to type Closed Caption",
                wc_cc_type_myself: "I will type",
                wc_cc_withdraw: "Withdraw Closed Caption permission",
                "wc_chat.attendee_chat_with": "Attendee Can Chat with:",
                "wc_chat.chat": "Chat",
                "wc_chat.direct_message": "(Direct Message)",
                "wc_chat.disable_chat": "The host has disabled attendee chat.",
                "wc_chat.disabled": "No one",
                "wc_chat.everyone": "Everyone",
                "wc_chat.everyone_public": "Everyone publicly",
                "wc_chat.everyone_public_private": "Everyone publicly and privately",
                "wc_chat.host_only": "Host only",
                "wc_chat.host_panelists": "Hosts and panelists",
                "wc_chat.me": "Me",
                "wc_chat.panelist_chat_with": "Panelists Can Chat with:",
                "wc_chat.type_msg": "Type message here ...",
                wc_closed_caption_btn: "Closed Caption",
                wc_co_host: "(Co-host)",
                wc_continue: "Continue",
                wc_copied: "Copied",
                wc_copied_to_clipboard: "Invite link has been copied to Clipboard",
                wc_copy_link: "Copy Link",
                wc_data_center2: "You are connected to an on-premise data center.",
                wc_data_center3: "You are connected to the Zoom global network via an on-premise data center.",
                wc_disable_talking: "Disable talking",
                wc_dlg_confirm: "Confirmation",
                wc_enable: "Enabled",
                wc_encryption: "Encryption",
                wc_extra_function_disable_video: "Disable video receiving",
                wc_files: "Files",
                wc_footer_assign_leave: "Assign and Leave",
                wc_footer_assign_new_host: "Assign a New Host",
                wc_guest: "Guest",
                wc_host_1: "Host",
                wc_in_the_meeting: "In the Meeting",
                wc_invite_link: "Invite Link",
                wc_join_media_preview_info_confirm: "Got it",
                wc_join_media_preview_warning_denied_both: "Enable camera and microphone access in your browser's address bar.",
                wc_join_media_preview_warning_denied_camera: "Enable camera access in your browser's address bar.",
                wc_join_media_preview_warning_denied_mic: "Enable microphone access in your browser's address bar.",
                wc_joining: "joining",
                wc_joining_meeting: "Joining Meeting...",
                wc_learn_more: "Learn more",
                wc_leave_computer_audio: "Leave Computer Audio",
                wc_leave_meeting: "Leave Meeting",
                wc_leave_webinar: "Leave Webinar",
                wc_live_transcription_btn: "Live Transcription",
                wc_lock_meeting: "Lock Meeting",
                wc_lower_hand: "Lower Hand",
                wc_lt_disable_transcription: "Disable Auto-Transcription",
                wc_lt_enable_transcription: "Enable Auto-Transcription",
                wc_lt_item_captioner: "(Captioner)",
                wc_lt_live_transcript: "Live Transcription",
                wc_lt_menu_item1: "Show Subtitle",
                wc_lt_menu_item2: "View Full Transcript",
                wc_lt_menu_item3: "Hide Subtitle",
                wc_lt_menu_item4: "Close Full Transcript",
                wc_lt_request_host_ctrl: "Allow participants to request Live Transcription",
                wc_lt_search_text: "Search",
                wc_make_co_host: "Make Co-Host",
                wc_make_host: "Make Host",
                wc_me: "(Me)",
                wc_more: "More",
                wc_no: "No",
                wc_none: "None",
                wc_not_share_pronoun: "Don't Share",
                wc_num_password: "Numeric Password Telephone/Room Systems",
                wc_participant_id: "Participant ID",
                wc_participants: "Participants",
                wc_pc_audio: "Computer Audio",
                wc_prevent_access_mic: "Your browser is preventing access to your microphone.",
                wc_put_in_waiting: "Put in Waiting Room",
                "wc_qa.allQ": "All questions",
                "wc_qa.anonymous_attendee": "Anonymous Attendee",
                "wc_qa.answer_private_type": "Private answer",
                "wc_qa.answeredQ": "Answered",
                "wc_qa.attendee_placeholder": "Questions you ask the host and panelists will show up here.",
                "wc_qa.button_comment": "Comment",
                "wc_qa.button_display_answer": "Type answer",
                "wc_qa.button_live": "Answer live",
                "wc_qa.button_live_done": "Done",
                "wc_qa.button_reopen": "Reopen",
                "wc_qa.collapse_all_answer": "Collapse all",
                "wc_qa.dismissedQ": "Dismissed",
                "wc_qa.display_all_answer": "Show all",
                "wc_qa.dissmis_tips": "Dismiss",
                "wc_qa.input_tips": "Type your question here...",
                "wc_qa.is_anonymous": "Send anonymous",
                "wc_qa.is_privately": "Send privately",
                "wc_qa.live_tips_done": "This question has been answered live",
                "wc_qa.live_tips_start": "would like to answer this question live",
                "wc_qa.most_recent": "Most Recent",
                "wc_qa.most_upvotes": "Most Upvotes",
                "wc_qa.myQ": "My questions",
                "wc_qa.no_answered_questions": "No answered questions",
                "wc_qa.no_dismissed_questions": "No dismissed questions",
                "wc_qa.no_open_questions": "No open questions",
                "wc_qa.no_questions": "No questions",
                "wc_qa.openedQ": "Open",
                "wc_qa.panelist_host_only_placeholder": "Only hosts and panelists can see the questions",
                "wc_qa.panelist_view_all_placehoder": "Everyone in this webinar can see open questions",
                "wc_qa.qa_comp_title": "Q&A",
                "wc_qa.send": "Send",
                "wc_qa.setting_allow_view": "Allow attendees to view",
                "wc_qa.setting_btn_name": "Settings",
                "wc_qa.setting_option_allow_anony_question": "Allow anonymous questions",
                "wc_qa.setting_option_allow_comment": "Attendees can comment",
                "wc_qa.setting_option_allow_view_all": "All questions",
                "wc_qa.setting_option_allow_view_answered": "Answered questions only",
                "wc_qa.setting_option_allow_vote": "Attendees can upvote",
                "wc_qa.welcome_banner": "Feel free to ask the host and panelists questions",
                "wc_qa.welcome_banner_title": "Welcome",
                wc_raise_hand: "Raise Hand",
                wc_reclaim_host: "Reclaim Host",
                wc_record_host_reminder_desc: "By continuing, all faces, conversations, and screen sharing will be recorded to the cloud.",
                wc_record_reminder_desc: "By continuing to be in the meeting, you are consenting to be recorded.",
                wc_record_reminder_desc_2: "The {{accountOwner}} and host can watch Zoom Cloud recordings and any participant with permission can record to their local device. These individuals can share these recordings with apps and others.",
                wc_record_reminder_title: "This meeting is being recorded",
                wc_record_reminder_webinar_title: "This webinar is being recorded",
                wc_record_webinar_reminder_desc: "By continuing to be in the webinar, you are consenting to be recorded.",
                wc_recording_pause: "Pause Recording",
                wc_recording_resume: "Resume Recording",
                wc_recording_stop: "Stop Recording",
                wc_recording_title: "Record this meeting?",
                wc_remove: "Remove",
                wc_select_camera: "Select a Camera",
                wc_select_microphone: "Select a Microphone",
                wc_select_speaker: "Select a Speaker",
                wc_share_muted_while_sharing_audio_tip2: "Your microphone is disabled when sharing computer audio. When you pause or stop sharing audio, your microphone will be reactivated.",
                wc_share_pronoun: "Share",
                wc_share_pronoun_menu: "Share My Pronouns",
                wc_share_pronoun_tip2: "Would you like to share your pronouns in this meeting?",
                wc_sharer_controlbar_container_button3_label: "Stop Share",
                wc_sharer_controlbar_container_rec_status_tip1: "You're sharing the screen",
                wc_sharer_controlbar_container_rec_status_tip2: "Your screen sharing is paused",
                wc_sharer_disabled_share1_desc: "Host disabled attendee screen sharing.",
                wc_sharer_disabled_share2_desc: "You cannot start screen share while the other participant is sharing.",
                wc_sharer_entry_button_label1: "Share Screen",
                wc_sharer_setting_menu_category1_title: "Who can share?",
                wc_sharer_setting_menu_category2_title: "Who can start sharing when someone else is sharing?",
                wc_sharer_setting_menu_category3_title: "How many participants can share at the same time?",
                wc_sharer_setting_menu_category_option1: "Only Host",
                wc_sharer_setting_menu_category_option2: "All Participants",
                wc_sharer_setting_menu_item1: "One participant can share at a time",
                wc_sharer_setting_menu_item2: "Multiple participants can share simultaneously",
                wc_sharing_fit_to_window: "Fit to Window",
                wc_sharing_original_size: "Original Size",
                wc_sharing_shared_screens: "Shared Screens",
                wc_sharing_view_options: "View Options",
                wc_sharing_viewing: "You are viewing {{displayName}}'s screen",
                wc_tel_password: "Passcode",
                wc_unmute_by_host_btn1: "Stay muted",
                wc_unshare_pronoun_menu: "Unshare My Pronouns",
                "wc_video.allow_panelist_start_video": "Allow panelist start video",
                "wc_video.allow_participants_start_video": "Allow participants to start video",
                "wc_video.ask_start_video": "Ask For Start Video",
                "wc_video.model_stop": "You cannot start your video because the host has stopped it",
                "wc_video.start_video": "Start Video",
                "wc_video.stop_video": "Stop Video",
                "wc_video.video": "Video",
                wc_view: "View",
                wc_waiting_room: "Waiting Room",
                "wc_webinar.change_to_attendee": "Change Role to Attendee",
                "wc_webinar.promote_to_panelist": "Promote to panelist",
                wc_webinar_attendees: "Attendees",
                wc_webinar_panelists: "Panelists",
                wc_webinar_putonhold: "Put on hold",
                wc_withdraw_co_host: "Withdraw Co-Host Permission",
                wc_yes: "Yes",
                websdk_enforce_update_content: "Your app version needs to be {0} or higher to join this meeting. Please update to continue.",
                websdk_update_content: "Update WebSDK to the latest version to optimize meeting experience"
              }
            },
            "de-DE": {
              translation: {
                GOT_IT: "Verstanden",
                account_owner: "Kontoinhaber",
                allow_to_access: "Zugriff auf Ihre Kamera und das Mikrofon",
                "app_signal.approved_by": "Genehmigt von",
                "app_signal.hosts_account": "Konto des Hosts",
                "app_signal.people": "Personen",
                "app_signal.tip_text_2": "Sehen Sie Apps mit Zugriff auf Ihre Meetinginhalte.",
                "app_signal.unable_load2": "Apps mit Echtzeit-Zugriff auf Ihre Informationen k\xf6nnen nicht geladen werden.",
                "archiving.chat_1": "Chat (\xf6ffentlich und direkt)",
                "archiving.chat_2": "Chat (nur \xf6ffentlich)",
                "archiving.chat_disable_content": "Nachrichten im Chat konnten zum Zweck der Richtlinienerf\xfcllung nicht archiviert werden.",
                "archiving.chat_disable_title": "Chat ist deaktiviert",
                "archiving.content1_sdk": "Mindestens ein Teilnehmer dieses Meetings wird von der Organisation des Hosts aufgrund der Kontorichtlinien archiviert. Ihr {{content}} erh\xe4lt den Inhalt aus diesem Meeting und kann ihn mit Apps und anderen teilen.",
                "archiving.content2_sdk": "Indem Sie als Teilnehmer in diesem Meeting bleiben, stimmen Sie zu, dass {{content}} von diesem Meeting archiviert wird.",
                "archiving.default_title": "Dieses Meeting wird archiviert",
                "archiving.fail_content_sdk": "{{features}} dieses Meetings muss zum Zweck der Richtlinienerf\xfcllung archiviert werden.",
                "archiving.fail_title": "Archivierung fehlerhaft",
                "archiving.subjects_combo_2_sdk": "{{0}} und {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} and {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} und {{3}}",
                "archiving.tips_1_sdk": "{{subjects}} dieses Meetings wird von der Organisation des Hosts aufgrund der Kontorichtlinien archiviert. Ihr {{receiver}} erh\xe4lt den Inhalt aus diesem Meeting und kann ihn mit Apps und anderen teilen.",
                "archiving.tips_2_sdk": "{{subjects}} dieses Meetings werden von der Organisation des Hosts aufgrund der Kontorichtlinien archiviert. Ihr {{receiver}} erh\xe4lt den Inhalt aus diesem Meeting und kann ihn mit Apps und anderen teilen.",
                "archiving.transcription": "Transkription",
                "ast.leave_tip": "Der Assistenten leitet dieses Meeting nicht mehr.",
                "ast.tip": "Dieses Meeting wird von einem Assistenten geleitet",
                background: "Hintergrund",
                chat_message_header: "<0> {{senderName}} </0> <1> bis </1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}} neue Nachricht",
                chat_receiver_co_host: "(co-host)",
                chat_receiver_host: "(host)",
                chat_receiver_panelist: "(Diskussionsteilnehmer)",
                chat_receiver_to: "Bis:",
                choose_background: "W\xe4hlen Sie einen Hintergrund",
                click_address_bar: "Klicken Sie auf das Symbol Sperren links von Ihrer Adressleiste. Ein Popup wird mit einer Liste von Optionen angezeigt.",
                click_microphone_camera_option: "Klicken Sie auf die Dropdown-Liste rechts neben der Kamera und der Mikrofonoption.",
                "common.cancel": "Abbrechen",
                "common.connecting": "Anschlie\xdfen",
                delete: "L\xf6schen",
                "dialog.btn_cancel": "Abbrechen",
                "dialog.btn_endconf_webinar": "Webinar beenden",
                "dialog.btn_leaveconf_meeting": "Meeting verlassen",
                "dialog.btn_retry": "Erneut versuchen",
                "dialog.host_end_meeting": "Dieses Meeting wurde vom Host beendet.",
                "dialog.host_end_webinar": "Dieses Webinar wurde vom Host beendet.",
                "dialog.meeting_ended": "Das Meeting wurde beendet",
                "dialog.meeting_locked": "Das Meeting wurde gesperrt",
                "dialog.meeting_removed_by_host": "Sie wurden vom Host von diesem Meeting entfernt.",
                "dialog.newname": "Name",
                "dialog.ok": "OK",
                "dialog.presscode": "Meeting ID:",
                "dialog.rename": "Umbenennen",
                "dialog.server_error": "Auf dem Server ist ein interner Fehler aufgetreten und Ihre Anfrage konnte nicht verarbeitet werden.",
                "dialog.webinar_ended": "Das Webinar wurde beendet",
                "dialog.webinar_removed_by_host": "Sie wurden vom Host von diesem Webinar entfernt.",
                "dialog.you_are_removed": "Sie wurden entfernt.",
                dialog_make_cohost: "M\xf6chten Sie {{displayName}}zum Co-Host dieser Meeting machen?",
                dialog_make_host: "M\xf6chten Sie den Host auf {{displayName}}umstellen?",
                dialog_remove_user: "M\xf6chten Sie {{displayName}} entfernen?",
                "disclaimer.LT_button_1": "Wer kann diese Transkription sehen?",
                "disclaimer.LT_content_1_1": "Der Kontoinhaber und alle Personen im Meeting k\xf6nnen diese Transkription speichern und mit Apps und anderen teilen.",
                "disclaimer.LT_content_2": "Die Live-Transkription (Untertitel) ist aktiviert",
                "disclaimer.QA_button_1": "Wer kann Ihre Fragen sehen?",
                "disclaimer.QA_content_1_1": "Der Kontoinhaber, der Host und die Diskussionsteilnehmer k\xf6nnen sehen, wer Sie sind, Ihre Kontaktinformationen (wenn Sie angemeldet sind oder diese angegeben haben) und Ihre Frage - und k\xf6nnen diese mit Apps und anderen teilen.",
                "disclaimer.QA_content_2": "Wenn Ihre Frage ausgew\xe4hlt ist, ist sie f\xfcr alle Zuschauer sichtbar.",
                "disclaimer.QA_content_3_3": "Sofern Sie nicht anonym antworten, k\xf6nnen der Kontoinhaber, der Host und die Diskussionsteilnehmer sehen, wer Sie sind, Ihre Kontaktinformationen (wenn Sie angemeldet sind oder diese angegeben haben) und Ihre Frage - und k\xf6nnen sie mit Apps und anderen teilen.",
                "disclaimer.QA_content_4": "Diese F&A ist \xf6ffentlich, d. h. jeder kann Ihre Fragen sehen.",
                "disclaimer.QA_content_5": "Wenn Sie Ihre Fragen anonym \xfcbertragen, kann keiner Sie als Fragsteller identifizieren.",
                "disclaimer.chat_button_normal": "Wer kann Ihre Nachrichten sehen?",
                "disclaimer.chat_button_onArchiving": "Wer kann Ihre Nachrichten sehen? Archivierung Ein",
                "disclaimer.chat_button_onRecording": "Wer kann Ihre Nachrichten sehen? Aufzeichnung ein",
                "disclaimer.chat_content_1": "Alle Teilnehmer des Meetings k\xf6nnen Ihre Nachrichten an alle sehen und speichern - und sie mit Apps und anderen teilen.",
                "disclaimer.chat_content_2": "Nur Sie und die Personen im Chat k\xf6nnen Ihre Direktnachrichten speichern und sie mit Apps und anderen teilen.",
                "disclaimer.chat_content_3": "Die Aufzeichnung ist eingeschaltet, so dass der Kontoinhaber und alle Teilnehmer des Meetings Ihre Nachrichten an alle sehen und speichern - und sie mit Apps und anderen teilen k\xf6nnen.",
                "disclaimer.chat_content_4": "Die Aufzeichnung ist eingeschaltet, so dass alle Teilnehmer des Meetings die Dinge, die Sie hier teilen, speichern k\xf6nnen - und sie mit Apps und anderen teilen k\xf6nnen.",
                "disclaimer.chat_content_5": "Die Archivierung ist eingeschaltet und erm\xF6glicht es dem Kontoinhaber, alle Ihre Nachrichten \u2014 auch Ihre Direktnachrichten \u2014 zu sehen und f\xFCr Apps und andere freizuschalten.",
                "disclaimer.chat_content_6": "Jeder im Meeting kann die Nachrichten von Ihnen an Alle speichern und freigeben.",
                "disclaimer.chat_content_7": "Die Archivierung ist eingeschaltet und erm\xf6glicht es dem Kontoinhaber, alle Ihre Nachrichten - au\xdfer Ihren Direktnachrichten - zu sehen und mit Apps und anderen zuteilen.",
                errorcodes_be_removed: "Entfernt werden.",
                errorcodes_denied_email: "E-Mail wird durch Administrator gesperrt.",
                errorcodes_denied_register_with_panelist: "Verweigern Register Verwendung Diskussionsteilnehmer E-Mail.",
                errorcodes_disconnect: "Treffen wurde unterbrochen.",
                errorcodes_email_require: "E-Mail fehlt Webinar teilzunehmen.",
                errorcodes_fail: "Scheitert an der Besprechung teilnehmen.",
                errorcodes_frequent_call: "Sie haben das API Limit f\xfcr diesen Anruf erreicht.",
                errorcodes_frequent_join: "Sie sein Limit von Zoom, m\xfcssen recaptcha \xfcberpr\xfcfen.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Unf\xe4hig beitreten aus Browser, verbinden Sie bitte den Zoom-Desktop-Client oder mobile App.",
                errorcodes_not_exist: "Meeting ist nicht vorhanden.",
                errorcodes_not_host: "Sie sind nicht der Meeting-Gastgeber.",
                errorcodes_not_init: "Treffen nicht initialisiert.",
                errorcodes_not_start: "Treffen hat noch nicht begonnen",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "Der Service ist vor\xfcbergehend offline.",
                errorcodes_pac_api_disabled: "Die Konten API-Schl\xfcssel deaktiviert ist.",
                errorcodes_pac_api_wrong: "Die Konten API Key nicht g\xfcltig ist.",
                errorcodes_pac_cant_host_other_mn: "Kann nicht nicht ein weiteres Treffen gleichzeitig hosten.",
                errorcodes_pac_host_not_found: "Das Treffen Host nicht gefunden wird.",
                errorcodes_pac_invalid_signature: "Unterschrift ist ung\xfcltig.",
                errorcodes_pac_mn_not_fount: "Die Meeting-Kennnummer nicht gefunden wird.",
                errorcodes_pac_mn_wrong: "Die Meeting-Kennnummer ist falsch.",
                errorcodes_pac_no_permission: "Keine Erlaubnis.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "Falsche Rolle.",
                errorcodes_pac_signature_expired: "Die Signatur ist abgelaufen.",
                errorcodes_re_connect: "Treffen wird wieder anschlie\xdfen.",
                errorcodes_register: "Dieses Treffen erfordert eine Registrierung.",
                errorcodes_rwc_empty: "Es kann keine Antwort vom Web-Server.",
                errorcodes_rwc_error: "Kann nicht zum Web-Server Fehler verbinden.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "Erfolgreich nahmen an der Sitzung.",
                errorcodes_tk_expired: "Token ist abgelaufen.",
                errorcodes_wasm_fail: "Download wasm Dateien Fehler, \xfcberpr\xfcfen Sie bitte Ihre Netzwerk- und Firewall.",
                errorcodes_web_has_in_progress: "Hat bereits andere laufende Meetings.",
                errorcodes_web_host_not_exit: "Der Meeting-Host ist nicht vorhanden.",
                errorcodes_web_invalid_id: "Ung\xfcltige Meeting-ID.",
                errorcodes_web_not_allow_start_webinar_from_web: "Das Starten eines Webinars vom Internet aus ist nicht zul\xe4ssig.",
                errorcodes_web_not_support_registration_webinar: "Registrierung f\xfcr Webinar wird nicht unterst\xfctzt",
                errorcodes_web_not_support_tsp: "Sie unterst\xfctzen nicht den Start oder die Teilnahme an einem Meeting aus dem Web, wenn Sie den Telefonieanbieter als seinen Audiobeitrag in einem Meeting gew\xe4hlt haben.",
                errorcodes_web_not_support_webclient: "Start nicht unterst\xfctzt bzw. starten Sie das Meeting aus dem Web.",
                errorcodes_web_not_support_webinar_pac: "Unterst\xfctzen Webinar und pers\xf6nliche Audiokonferenz nicht",
                errorcodes_web_require_email: "E-Mail-Adresse von Benutzer erforderlich.",
                errorcodes_web_should_support_webinar_with_latest_version: "Ihre aktuelle SDK-Version unterst\xfctzt keine Webinare. Aktualisieren Sie bitte auf die neueste Version.",
                errorcodes_wrong_pass: "Treffen Passwort falsch.",
                gallary_view: "Galerieansicht",
                invalid_parameter: "Ung\xfcltiger Parameter",
                "invite.loading": "Laden ...",
                meeting_disconnected: "Meeting Disconnected",
                meeting_info: "Meetinginformationen",
                meeting_info_network: "Sie sind \xfcber Rechenzentren mit {{network}} in {{dc} verbunden",
                meeting_not_start: "Das Meeting hat noch nicht begonnen.",
                meeting_taking: "Sprechen:",
                meeting_waiting_for_start: "Warten auf das Treffen, um zu beginnen",
                meeting_waiting_room: "Der Gastgeber l\xe4sst Sie bald",
                minimized_view: "Minimierter Blick",
                mirror_my_video: "Mein Video spiegeln",
                "polling.Back": "Zur\xfcck",
                "promote.cancel": "Als Zuschauer bleiben",
                "promote.content_1": "Als Diskussionsteilnehmer k\xf6nnen Sie die Stummschaltung aufheben und das Video beginnen; das bedeutet, dass Sie f\xfcr andere im Webinar sichtbar sind.",
                "promote.content_2": "Sollten der Host oder andere Diskussionsteilnehmer beschlie\xdfen, das Webinar aufzuzeichnen, per Live-Stream zu \xfcbertragen oder zu archivieren, nachdem Sie die Stummschaltung aufgehoben haben, sind Ihre \xc4u\xdferungen inbegriffen.",
                "promote.ok": "Als Diskussionsteilnehmer teilnehmen",
                "promote.title": "Der Host m\xf6chte Sie zum Diskussionsteilnehmer ernennen",
                ribbon_view: "Ansicht der Schleife.",
                "rmc.assistant_exist_warning": "Sie k\xf6nnen das Meeting nicht leiten, da ein anderer Assistent dies bereits tut.",
                "rmc.exist_notification_for_client_host": "Dieses Meeting wird von einem Admin geleitet.",
                "rmc.not_exist_notification_for_client_host": "Der Admin leitet dieses Meeting nicht mehr.",
                same_as_system: "Dasselbe wie das System",
                "security.allow_participants_to": "Teilnehmern die Erlaubnis geben:",
                "security.button": "Sicherheit",
                "security.waiting_room": "Warteraumfreigabe",
                select_allow: "W\xe4hlen Sie die Option aus.",
                "settings.audio_tab_text": "Audio",
                "settings.enable_hd": "HD-Video aktivieren.",
                "settings.enable_hd_tip": "Aktivieren Sie alle Teilnehmer, um Ihr Video in hoher Aufl\xf6sung (720P) anzuzeigen. Beachten Sie, dass das tats\xe4chliche Ergebnis von der Maschinenleistung und der Bandbreite abh\xe4ngt.",
                "settings.frame_per_second": "Bilder pro Sekunde",
                "settings.frequency": "Frequenz",
                "settings.input_level": "Eingabepegel:",
                "settings.item_name": "Artikelname",
                "settings.jitter": "Jitter",
                "settings.latency": "Latenz",
                "settings.maximum_view": "H\xf6chstzahl der Teilnehmer je Bildschirm in der Galerieansicht:",
                "settings.output_level": "Ausgabepegel:",
                "settings.packet_loss": "Paketverlust - Durchschnitt(Max)",
                "settings.participants25": "25 teilnehmer",
                "settings.participants9": "9 teilnehmer",
                "settings.playing": "Abspielen",
                "settings.receive": "Empfangen",
                "settings.receiving_video": "Video empfangen.",
                "settings.receiving_video_tips": "Verwenden Sie den Hardware-Video-Decoder der Grafikkarte, um die CPU-Nutzung f\xfcr das Empfang von Videos zu speichern. Aktualisieren Sie die Seite, damit diese \xc4nderung wirksam wird.",
                "settings.recording": "Aufnahme",
                "settings.rejoin": "Rejoin",
                "settings.resolution": "Aufl\xf6sung",
                "settings.send": "Senden",
                "settings.sending_video": "Video senden.",
                "settings.sending_video_tips": "Verwenden Sie den Hardware-Video-Decoder der Grafikkarte, um die CPU-Nutzung zum Senden von Video zu speichern. Aktualisieren Sie die Seite, damit diese \xc4nderung wirksam wird.",
                "settings.statistics": "Statistiken",
                "settings.stop": "Beenden",
                "settings.switch_view_mode_text": "Sie m\xfcssen das Treffen erneut anmelden, um diese \xc4nderung anzuwenden",
                "settings.test_mic": "Mikrotest",
                "settings.test_speaker": "Tontest",
                "settings.unknown_device": "Unbekanntes Ger\xe4t",
                "settings.use_hardware_acceleration": "Verwenden Sie die Hardwarebeschleunigung f\xfcr:",
                "settings.vb_init_10s_tip2": "Virtueller Hintergrund dauert l\xe4nger als erwartet, um zu laden.",
                "settings.vb_init_fail2": "Virtueller Hintergrund kann nicht geladen werden.",
                "settings.video_tab_text": "Video",
                speaker_view: "Sprecheransicht",
                toolbar_join_audio: "Audio beitreten",
                toolbar_leave: "Verlassen",
                toolbar_mute: "Stummschalten",
                toolbar_muteall: "Alle stummschalten",
                toolbar_record: "Aufzeichnen",
                toolbar_unmute: "Stummschaltung aufheben",
                wait_room_tip1: "{{displayName}} ist in den Warteraum f\xfcr dieses Meeting eingetreten",
                wait_room_tip2: "{{count}} Personen sind in den Warteraum f\xfcr dieses Meeting eingetreten",
                "wc.ast_admin_name": "Meeting-Assistent",
                "wc.rmc_admin_name": "Administrator der Meetingleitung",
                "wc.rmc_admin_tooltip": "Dieser Benutzer hat Hostrechte und keinen Zugriff auf Medieninhalte (Audio, Video, Chat).",
                wc_3rd_cc_copied_api_token: "API-Token in den Zwischenspeicher kopiert",
                wc_3rd_cc_copy_api_token: "API-Token kopieren",
                wc_3rd_cc_service: "Verwenden Sie den CC-Dienst eines Drittanbieters",
                wc_3rd_cc_url_help_tips2: "Kopieren Sie diesen Token und f\xfcgen Sie ihn an einen Drittanbieters zur Untertitelung ein",
                wc_admit: "Eintreten lassen",
                wc_allow_to_talk: "Sprecherlaubnis",
                wc_audio: "Audio",
                "wc_audio.muted_notification1": "Der Host hat Sie stumm geschaltet",
                "wc_audio.muted_notification2": "Der Host hat alle stumm geschaltet",
                "wc_audio.unmute_by_host_content_1": "Der Host bittet Sie zu sprechen",
                "wc_audio.unmute_by_host_content_2": "Wenn Sie die Stummschaltung aufheben, k\xf6nnen andere Teilnehmer des Webinars Sie h\xf6ren. Wenn der Host oder die Diskussionsteilnehmer beschlie\xdfen, das Webinar aufzuzeichnen, per Livestream zu \xfcbertragen oder zu archivieren, nachdem Sie die Stummschaltung aufgehoben haben, wird Ihre Stimme aufgenommen.",
                wc_audio_cannot_unmute: "Sie k\xf6nnen Ihre eigene Stummschaltung nicht aufheben, weil der Host Sie stummgeschaltet hat.",
                wc_audio_connecting_thumbnail: "Verbindung zum Audiosignal herstellen",
                wc_broadcasting: "Rundfunk",
                wc_btn_endconf_meeting_all: "Das Meeting f\xfcr alle beenden",
                wc_camera_prevent: "Ihr Browser verhindert den Zugriff auf Ihre Kamera. Bitte gestatten Sie den Zugriff und starten Sie Ihr Video erneut.",
                "wc_cc.placeholder": "Hier eingeben und Enter zur \xdcbertragung dr\xfccken",
                wc_cc_assign_participant_to_type: "Teilnehmer einem Typ zuweisen",
                wc_cc_assign_to: "Zur Type Untertitel zuweisen",
                wc_cc_assign_to_type: "Teilnehmer einem Typ zuweisen",
                wc_cc_broadcasting_tip: "Der Untertitel wird an alle Teilnehmer gesendet.",
                wc_cc_host_assigned: "Der Moderator hat Sie dem Untertitel zugewiesen",
                wc_cc_type_myself: "Ich gebe ein",
                wc_cc_withdraw: "Untertitelgenehmigung widerrufen",
                "wc_chat.attendee_chat_with": "Zuschauer kann chatten mit:",
                "wc_chat.chat": "Chat",
                "wc_chat.direct_message": "(Direktnachricht)",
                "wc_chat.disable_chat": "Der Moderator hat den Teilnehmer-Chat deaktiviert.",
                "wc_chat.disabled": "Keine",
                "wc_chat.everyone": "Hallo allerseits!",
                "wc_chat.everyone_public": "Jeder \xf6ffentlich",
                "wc_chat.everyone_public_private": "Jeder \xf6ffentlich und privat",
                "wc_chat.host_only": "Nur Host",
                "wc_chat.host_panelists": "Hosts und Diskussionsteilnehmer",
                "wc_chat.me": "Mich",
                "wc_chat.panelist_chat_with": "Diskussionsteilnehmer k\xf6nnen chatten mit:",
                "wc_chat.type_msg": "Tippen Sie Ihre Nachricht hier?",
                wc_closed_caption_btn: "Untertitel",
                wc_co_host: "(Co-Host)",
                wc_continue: "Fortfahren",
                wc_copied: "Kopiert",
                wc_copied_to_clipboard: "Einladungslink in Zwischenablage kopiert",
                wc_copy_link: "Link kopieren",
                wc_data_center2: "Sie sind mit einem betriebsinternen Rechenzentrum verbunden.",
                wc_data_center3: "Sie sind \xfcber ein betriebsinternes Rechenzentrum mit dem globalen Zoom-Netzwerk verbunden.",
                wc_disable_talking: "Sprechen deaktivieren",
                wc_dlg_confirm: "Best\xe4tigung",
                wc_enable: "Aktiviert",
                wc_encryption: "Verschl\xfcsselung",
                wc_extra_function_disable_video: "Deaktivieren Videoaufnahme",
                wc_files: "Dateien",
                wc_footer_assign_leave: "Zuweisen und Verlassen",
                wc_footer_assign_new_host: "Einen neuen Host zuweisen",
                wc_guest: "Gast",
                wc_host_1: "Host",
                wc_in_the_meeting: "Im Meeting",
                wc_invite_link: "Einladungslink",
                wc_join_media_preview_info_confirm: "Verstanden",
                wc_join_media_preview_warning_denied_both: "Aktivieren Sie den Kamera- und Mikrofonzugriff in der Adressleiste Ihres Browsers.",
                wc_join_media_preview_warning_denied_camera: "Aktivieren Sie den Kamerazugriff in der Adressleiste Ihres Browsers.",
                wc_join_media_preview_warning_denied_mic: "Aktivieren Sie den Mikrofonzugriff in der Adressleiste Ihres Browsers.",
                wc_joining: "Beitritt",
                wc_joining_meeting: "Am Meeting teilnehmen...",
                wc_learn_more: "Mehr erfahren",
                wc_leave_computer_audio: "Computeraudio verlassen",
                wc_leave_meeting: "Meeting verlassen",
                wc_leave_webinar: "Webinar verlassen",
                wc_live_transcription_btn: "Live-Transkription",
                wc_lock_meeting: "Meeting sperren",
                wc_lower_hand: "Unterer Zeiger",
                wc_lt_disable_transcription: "Auto-Transkription deaktivieren",
                wc_lt_enable_transcription: "Auto-Transkription aktivieren",
                wc_lt_item_captioner: "(Untertitelung)",
                wc_lt_live_transcript: "Live-Transkript",
                wc_lt_menu_item1: "Untertitel anzeigen",
                wc_lt_menu_item2: "Vollst\xe4ndiges Transkript anzeigen",
                wc_lt_menu_item3: "Untertitel ausblenden",
                wc_lt_menu_item4: "Vollst\xe4ndiges Transkript schlie\xdfen",
                wc_lt_request_host_ctrl: "Gestatten Sie Teilnehmern, eine Live-Transkription anzufordern",
                wc_lt_search_text: "Suche",
                wc_make_co_host: "Co-Host erstellen",
                wc_make_host: "Zum Host ernennen",
                wc_me: "(Ich)",
                wc_more: "Mehr",
                wc_no: "Nein",
                wc_none: "Keine",
                wc_not_share_pronoun: "Nicht freigeben",
                wc_num_password: "Numerisches Passwort Telefon / Raumsysteme",
                wc_participant_id: "Teilnehmer-ID",
                wc_participants: "Teilnehmer",
                wc_pc_audio: "Computeraudio",
                wc_prevent_access_mic: "Ihr Browser verhindert Zugriff auf Ihr Mikrofon.",
                wc_put_in_waiting: "In Warteraum stellen",
                "wc_qa.allQ": "Alle Fragen",
                "wc_qa.anonymous_attendee": "Anonymer Zuschauer",
                "wc_qa.answer_private_type": "Private Antwort",
                "wc_qa.answeredQ": "Beantwortet",
                "wc_qa.attendee_placeholder": "Ihre Fragen an Host und Diskussionsteilnehmer werden hier angezeigt.",
                "wc_qa.button_comment": "Kommentieren",
                "wc_qa.button_display_answer": "Antwort eingeben",
                "wc_qa.button_live": "Live beantworten",
                "wc_qa.button_live_done": "Fertig",
                "wc_qa.button_reopen": "Erneut \xf6ffnen",
                "wc_qa.collapse_all_answer": "Alle einklappen",
                "wc_qa.dismissedQ": "Ausgeblendet",
                "wc_qa.display_all_answer": "Alle zeigen",
                "wc_qa.dissmis_tips": "Ausblenden",
                "wc_qa.input_tips": "Geben Sie Ihre Frage hier ein...",
                "wc_qa.is_anonymous": "Anonym senden",
                "wc_qa.is_privately": "Privat senden",
                "wc_qa.live_tips_done": "Diese Frage wurde live beantwortet",
                "wc_qa.live_tips_start": "m\xf6chte diese Frage live beantworten",
                "wc_qa.most_recent": "Neuestes",
                "wc_qa.most_upvotes": "Die meisten Stimmen",
                "wc_qa.myQ": "Meine Fragen",
                "wc_qa.no_answered_questions": "Keine beantworteten Fragen",
                "wc_qa.no_dismissed_questions": "Keine abgelehnten Fragen",
                "wc_qa.no_open_questions": "Keine offenen Fragen",
                "wc_qa.no_questions": "Keine Fragen",
                "wc_qa.openedQ": "Offen",
                "wc_qa.panelist_host_only_placeholder": "Nur Hosts und Diskussionsteilnehmer k\xf6nnen die Fragen sehen",
                "wc_qa.panelist_view_all_placehoder": "Jeder in diesem Webinar kann offene Fragen sehen",
                "wc_qa.qa_comp_title": "F&A",
                "wc_qa.send": "Senden",
                "wc_qa.setting_allow_view": "Zuschauern die Erlaubnis zur Ansicht geben",
                "wc_qa.setting_btn_name": "die Einstellungen",
                "wc_qa.setting_option_allow_anony_question": "Anonyme Fragen erlauben",
                "wc_qa.setting_option_allow_comment": "Zuschauer k\xf6nnen kommentieren",
                "wc_qa.setting_option_allow_view_all": "Alle Fragen",
                "wc_qa.setting_option_allow_view_answered": "Nur beantwortete Fragen",
                "wc_qa.setting_option_allow_vote": "Zuschauer k\xf6nnen zustimmen",
                "wc_qa.welcome_banner": "Stellen Sie dem Host und den Diskussionsteilnehmern ruhig Fragen",
                "wc_qa.welcome_banner_title": "Herzlich willkommen",
                wc_raise_hand: "Hand heben",
                wc_reclaim_host: "Host erneut anfordern",
                wc_record_host_reminder_desc: "Wenn Sie fortfahren, werden alle Personen, Gespr\xe4che und geteilten Bildschirme in der Cloud aufgezeichnet.",
                wc_record_reminder_desc: "Durch die fortgesetzte Teilnahme an diesem Meeting stimmen Sie der Aufzeichnung dieses Meetings zu.",
                wc_record_reminder_desc_2: "Der {{accountOwner}} und der Host k\xf6nnen Aufnahmen in der Zoom Cloud ansehen, und jeder Teilnehmer mit der entsprechenden Berechtigung kann auf sein eigenes Ger\xe4t aufnehmen. Diese Personen k\xf6nnen diese Aufnahmen mit Apps und anderen teilen.",
                wc_record_reminder_title: "Dieses Meeting wird aufgezeichnet",
                wc_record_reminder_webinar_title: "Dieses Webinar wird aufgezeichnet",
                wc_record_webinar_reminder_desc: "Durch die fortgesetzte Teilnahme an diesem Webinar stimmen Sie der Aufzeichnung dieses Webinars zu.",
                wc_recording_pause: "Aufnahme anhalten",
                wc_recording_resume: "Aufnahme fortsetzen",
                wc_recording_stop: "Aufnahme anhalten",
                wc_recording_title: "Nehmen Sie dieses Treffen auf?",
                wc_remove: "Entfernen",
                wc_select_camera: "Eine Kamera ausw\xe4hlen",
                wc_select_microphone: "Ein Mikrofon w\xe4hlen",
                wc_select_speaker: "Einen Lautsprecher w\xe4hlen",
                wc_share_muted_while_sharing_audio_tip2: "Ihr Mikrofon ist deaktiviert, wenn Computer-Audio freigibt. Wenn Sie das Teilen von Audio anhalten oder aufh\xf6ren, wird Ihr Mikrofon erneut aktiviert.",
                wc_share_pronoun: "Freigeben",
                wc_share_pronoun_menu: "Meine Pronomen freigeben",
                wc_share_pronoun_tip2: "M\xf6chten Sie Ihre Pronomen in diesem Meeting freigeben?",
                wc_sharer_controlbar_container_button3_label: "Freigabe stoppen",
                wc_sharer_controlbar_container_rec_status_tip1: "Sie geben Ihren Bildschirm frei",
                wc_sharer_controlbar_container_rec_status_tip2: "Ihre Bildschirmfreigabe wurde aufgehoben",
                wc_sharer_disabled_share1_desc: "Der Host hat die Bildschirmfreigabe f\xfcr Besucher deaktiviert.",
                wc_sharer_disabled_share2_desc: "Sie k\xf6nnen die Bildschirmfreigabe nicht starten, w\xe4hrend der andere Teilnehmer seinen Bildschirm freigibt.",
                wc_sharer_entry_button_label1: "Bildschirm freigeben",
                wc_sharer_setting_menu_category1_title: "Wer kann freigeben?",
                wc_sharer_setting_menu_category2_title: "Wer kann die Freigabe starten, wenn eine andere Person die Freigabe verwendet?",
                wc_sharer_setting_menu_category3_title: "Wie viele Teilnehmer k\xf6nnen gleichzeitig freigeben?",
                wc_sharer_setting_menu_category_option1: "Nur Host",
                wc_sharer_setting_menu_category_option2: "Alle Teilnehmer",
                wc_sharer_setting_menu_item1: "Freigabe nur f\xfcr jeweils einen Teilnehmer m\xf6glich",
                wc_sharer_setting_menu_item2: "Freigabe f\xfcr mehrere Teilnehmer gleichzeitig m\xf6glich",
                wc_sharing_fit_to_window: "An Fenster anpassen",
                wc_sharing_original_size: "Originalgr\xf6\xdfe",
                wc_sharing_shared_screens: "Freigegebene Bildschirme",
                wc_sharing_view_options: "Optionen anzeigen",
                wc_sharing_viewing: "Sie sehen {{displayName}} screen",
                wc_tel_password: "Kenncode",
                wc_unmute_by_host_btn1: "Stummschaltung beibehalten",
                wc_unshare_pronoun_menu: "Meine Pronomen nicht mehr freigeben",
                "wc_video.allow_panelist_start_video": "Redner das Starten eines Videos gestatten",
                "wc_video.allow_participants_start_video": "Gestatten Sie Diskussionsteilnehmern, das Video zu starten",
                "wc_video.ask_start_video": "Video starten\u201C anfordern",
                "wc_video.model_stop": "Sie k\xf6nnen Ihr Video nicht starten, da es vom Moderator angehalten wurde",
                "wc_video.start_video": "Video starten",
                "wc_video.stop_video": "Video anhalten",
                "wc_video.video": "Video",
                wc_view: "Anzeigen",
                wc_waiting_room: "Warteraum",
                "wc_webinar.change_to_attendee": "Rolle zu Teilnehmer \xe4ndern",
                "wc_webinar.promote_to_panelist": "Zu Diskussionsteilnehmer bef\xf6rdern",
                wc_webinar_attendees: "Teilnehmer",
                wc_webinar_panelists: "Diskussionsteilnehmer",
                wc_webinar_putonhold: "Halten",
                wc_withdraw_co_host: "Genehmigung des Co-Hosts widerrufen",
                wc_yes: "Ja",
                websdk_enforce_update_content: "Ihre App muss mindestens Version {0} aufweisen, damit Sie an diesem Meeting teilnehmen k\xf6nnen. Bitte Aktualisieren zum Fortfahren.",
                websdk_update_content: "Update WebSDK auf die neueste Version zu optimieren Meeting-Erlebnis"
              }
            },
            "es-ES": {
              translation: {
                GOT_IT: "Entendido",
                account_owner: "propietario de cuenta",
                allow_to_access: "Permitir acceder a su c\xe1mara y micr\xf3fono.",
                "app_signal.approved_by": "Aprobado por",
                "app_signal.hosts_account": "Cuenta del anfitri\xf3n",
                "app_signal.people": "personas",
                "app_signal.tip_text_2": "Ver aplicaciones que est\xe1n accediendo al contenido de su reuni\xf3n",
                "app_signal.unable_load2": "No es posible cargar aplicaciones con acceso en tiempo real a su informaci\xf3n.",
                "archiving.chat_1": "chat (p\xfablico y directo)",
                "archiving.chat_2": "chat (solo p\xfablico)",
                "archiving.chat_disable_content": "Los mensajes enviados en el chat no se han podido archivar por motivos de cumplimiento de normativa.",
                "archiving.chat_disable_title": "El chat se ha deshabilitado",
                "archiving.content1_sdk": "Uno o m\xe1s participantes de esta reuni\xf3n est\xe1n sujetos a un archivado seg\xfan la pol\xedtica de su cuenta. Su {{content}} recibir\xe1 el contenido de esta reuni\xf3n y podr\xe1 compartirlo con aplicaciones y otros.",
                "archiving.content2_sdk": "Al seguir formando parte de esta reuni\xf3n, est\xe1 dando su consentimiento para que {{content}} de esta reuni\xf3n se archive.",
                "archiving.default_title": "La reuni\xf3n se est\xe1 archivando",
                "archiving.fail_content_sdk": "El {{features}} de esta reuni\xf3n se tiene que archivar por motivos de cumplimiento de normativa.",
                "archiving.fail_title": "No se ha podido archivar",
                "archiving.subjects_combo_2_sdk": "{{0}} y {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} y {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} y {{3}}",
                "archiving.tips_1_sdk": "La organizaci\xf3n del anfitri\xf3n est\xe1 archivando {{subjects}} de esta reuni\xf3n con base en la pol\xedtica de su cuenta. Su {{receiver}} recibir\xe1 el contenido de esta reuni\xf3n y podr\xe1 compartirlo con aplicaciones y otros.",
                "archiving.tips_2_sdk": "La organizaci\xf3n del anfitri\xf3n est\xe1 archivando {{subjects}} de esta reuni\xf3n con base en la pol\xedtica de su cuenta. Su {{receiver}} recibir\xe1 el contenido de esta reuni\xf3n y podr\xe1 compartirlo con aplicaciones y otros.",
                "archiving.transcription": "transcripci\xf3n",
                "ast.leave_tip": "El asistente ha dejado de controlar la reuni\xf3n.",
                "ast.tip": "Un asistente est\xe1 controlando esta reuni\xf3n",
                background: "Fondo",
                chat_message_header: "<0> {{senderName}} </0> <1> a </1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}} nuevo mensaje",
                chat_receiver_co_host: "(coanfitri\xf3n)",
                chat_receiver_host: "(hospedador)",
                chat_receiver_panelist: "(Panelista)",
                chat_receiver_to: "Hasta:",
                choose_background: "Elegir un fondo",
                click_address_bar: "Haga clic en el icono de bloqueo a la izquierda de su barra de direcciones. Aparecer\xe1 una ventana emergente con una lista de opciones.",
                click_microphone_camera_option: "Haga clic en la lista desplegable a la derecha de la c\xe1mara y la opci\xf3n de micr\xf3fono.",
                "common.cancel": "Cancelar",
                "common.connecting": "Conexi\xf3n",
                delete: "Eliminar",
                "dialog.btn_cancel": "Cancelar",
                "dialog.btn_endconf_webinar": "Finalizar seminario web",
                "dialog.btn_leaveconf_meeting": "Salir de la reuni\xf3n",
                "dialog.btn_retry": "Reintentar",
                "dialog.host_end_meeting": "El anfitri\xf3n ha finalizado esta reuni\xf3n.",
                "dialog.host_end_webinar": "El anfitri\xf3n ha finalizado este seminario web.",
                "dialog.meeting_ended": "La reuni\xf3n ha finalizado",
                "dialog.meeting_locked": "La reuni\xf3n ha sido bloqueada",
                "dialog.meeting_removed_by_host": "El anfitri\xf3n lo ha retirado de esta reuni\xf3n.",
                "dialog.newname": "Nombrar",
                "dialog.ok": "Aceptar",
                "dialog.presscode": "ID de la reuni\xf3n",
                "dialog.rename": "Renombrar",
                "dialog.server_error": "Se produjo un error interno en el servidor y no pudo procesar su solicitud.",
                "dialog.webinar_ended": "El seminario web ha finalizado",
                "dialog.webinar_removed_by_host": "El anfitri\xf3n lo ha retirado de este seminario web.",
                "dialog.you_are_removed": "Ha sido retirado",
                dialog_make_cohost: "\xbfQuiere hacer a {{displayName}}coanfitri\xf3n de esta reuni\xf3n?",
                dialog_make_host: "\xbfDesea cambiar el anfitri\xf3n a {{displayName}}?",
                dialog_remove_user: "\xbfDesea eliminar a {{displayName}}?",
                "disclaimer.LT_button_1": "\xbfQui\xe9n puede ver esta transcripci\xf3n?",
                "disclaimer.LT_content_1_1": "El propietario de cuenta y todos en la reuni\xf3n pueden guardar esta transcripci\xf3n y compartirla con aplicaciones y otros.",
                "disclaimer.LT_content_2": "Se ha habilitado la transcripci\xf3n en directo (subt\xedtulos)",
                "disclaimer.QA_button_1": "\xbfQui\xe9n puede ver sus preguntas?",
                "disclaimer.QA_content_1_1": "El propietario de cuenta, el anfitri\xf3n y los panelistas podr\xe1n ver qui\xe9n es usted, su informaci\xf3n de contacto (si ha iniciado sesi\xf3n o si la ha proporcionado) y sus preguntas, y pueden compartirlos con aplicaciones y otros.",
                "disclaimer.QA_content_2": "Si su pregunta se selecciona, ser\xe1 visible para todos los asistentes.",
                "disclaimer.QA_content_3_3": "A menos que lo haya enviado de forma an\xf3nima, el propietario de cuenta, el anfitri\xf3n y los panelistas podr\xe1n ver qui\xe9n es usted, su informaci\xf3n de contacto (si ha iniciado sesi\xf3n o si la ha proporcionado) y sus preguntas, y pueden compartirlos con aplicaciones y otros.",
                "disclaimer.QA_content_4": "Esta sesi\xf3n de preguntas y respuestas es p\xfablica, por lo que todos pueden ver sus preguntas.",
                "disclaimer.QA_content_5": "Si realiza las preguntas de forma an\xf3nima, nadie podr\xe1 ver qui\xe9n ha enviado sus preguntas.",
                "disclaimer.chat_button_normal": "\xbfQui\xe9n puede ver sus mensajes?",
                "disclaimer.chat_button_onArchiving": "\xbfQui\xe9n puede ver sus mensajes? El archivado est\xe1 habilitado",
                "disclaimer.chat_button_onRecording": "\xbfQui\xe9n puede ver sus mensajes? Grabaci\xf3n activada",
                "disclaimer.chat_content_1": "Todos los participantes en la reuni\xf3n pueden ver y guardar sus mensajes con Todos y compartirlos con aplicaciones y otros.",
                "disclaimer.chat_content_2": "Solamente usted y aquellos con los que chatee pueden guardar sus mensajes directos y compartirlos con aplicaciones y otros.",
                "disclaimer.chat_content_3": "La grabaci\xf3n est\xe1 activada por lo que el propietario de cuenta y todos los participantes en la reuni\xf3n pueden ver y guardar los mensajes enviados a Todos y compartirlos con aplicaciones y otros.",
                "disclaimer.chat_content_4": "La grabaci\xf3n est\xe1 activada, por lo que todos los participantes en la reuni\xf3n pueden ver y guardar los mensajes enviados a Todos y compartirlos con aplicaciones y otros.",
                "disclaimer.chat_content_5": "El archivado est\xe1 habilitado, por lo que el propietario de cuenta puede ver todos sus mensajes, incluidos sus mensajes directos, y compartirlos con aplicaciones y otros.",
                "disclaimer.chat_content_6": "Todos los que est\xe9n en la reuni\xf3n pueden guardar y compartir los mensajes que usted ha enviado a Todos.",
                "disclaimer.chat_content_7": "El archivado est\xe1 habilitado, por lo que el propietario de cuenta puede ver todos sus mensajes, sin incluir sus mensajes directos, y compartirlos con aplicaciones y otros.",
                errorcodes_be_removed: "Ser eliminado.",
                errorcodes_denied_email: "Correo electr\xf3nico est\xe1 bloqueada por el Administrador.",
                errorcodes_denied_register_with_panelist: "Negado el uso del registro electr\xf3nico de panelista.",
                errorcodes_disconnect: "Reuni\xf3n ha sido desconectado.",
                errorcodes_email_require: "Correo electr\xf3nico no se encuentra para asistir a seminario.",
                errorcodes_fail: "Dejar de unirse a la reuni\xf3n.",
                errorcodes_frequent_call: "Has alcanzado el l\xedmite API para esta llamada.",
                errorcodes_frequent_join: "A ser l\xedmite de zoom, necesita comprobar Reconocer texto.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "No puede unirse desde el navegador, por favor unirse usando el cliente de escritorio Zoom o aplicaci\xf3n m\xf3vil.",
                errorcodes_not_exist: "Reuni\xf3n no existe.",
                errorcodes_not_host: "No eres el anfitri\xf3n de la reuni\xf3n.",
                errorcodes_not_init: "Reuni\xf3n no inicializado.",
                errorcodes_not_start: "Reuni\xf3n no se ha iniciado",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "El servicio est\xe1 temporalmente fuera de l\xednea.",
                errorcodes_pac_api_disabled: "Las cuentas clave de API es desactivado.",
                errorcodes_pac_api_wrong: "Las cuentas clave de API no es v\xe1lido.",
                errorcodes_pac_cant_host_other_mn: "No se puede no celebrar otra reuni\xf3n al mismo tiempo.",
                errorcodes_pac_host_not_found: "no se encuentra el anfitri\xf3n de la reuni\xf3n.",
                errorcodes_pac_invalid_signature: "Firma no es v\xe1lida.",
                errorcodes_pac_mn_not_fount: "no se encuentra el n\xfamero de la reuni\xf3n.",
                errorcodes_pac_mn_wrong: "El n\xfamero de la reuni\xf3n es err\xf3neo.",
                errorcodes_pac_no_permission: "Sin autorizaci\xf3n.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "papel incorrecta.",
                errorcodes_pac_signature_expired: "La firma ha expirado.",
                errorcodes_re_connect: "Reuni\xf3n est\xe1 reconectando.",
                errorcodes_register: "Esta reuni\xf3n requiere registro.",
                errorcodes_rwc_empty: "No se pudo obtener una respuesta del servidor web.",
                errorcodes_rwc_error: "No se puede conectar a un error del servidor Web.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "Asociaci\xf3n correcta a la reuni\xf3n.",
                errorcodes_tk_expired: "Token ha expirado.",
                errorcodes_wasm_fail: "Descargar archivos de WASM error, compruebe su red y cortafuegos.",
                errorcodes_web_has_in_progress: "Ya posee otras reuniones en curso.",
                errorcodes_web_host_not_exit: "El anfitri\xf3n de la reuni\xf3n no existe.",
                errorcodes_web_invalid_id: "ID de reuni\xf3n no v\xe1lida.",
                errorcodes_web_not_allow_start_webinar_from_web: "No se permite comenzar un seminario web desde la web.",
                errorcodes_web_not_support_registration_webinar: "Seminario web que no es compatible con la inscripci\xf3n",
                errorcodes_web_not_support_tsp: "Cuando eligi\xf3 el proveedor de servicios telef\xf3nicos como audio en una reuni\xf3n, no se puede iniciar o unirse una reuni\xf3n desde el sitio web.",
                errorcodes_web_not_support_webclient: "No se puede iniciar ni entrar a una reuni\xf3n desde la web.",
                errorcodes_web_not_support_webinar_pac: "No soporta seminario web o conferencia de audio personal",
                errorcodes_web_require_email: "Se requiere correo electr\xf3nico del usuario.",
                errorcodes_web_should_support_webinar_with_latest_version: "La versi\xf3n actual de sdk no es compatible con el seminario web, actualice a la \xfaltima versi\xf3n.",
                errorcodes_wrong_pass: "Reuni\xf3n contrase\xf1a incorrecta.",
                gallary_view: "Vista de galer\xeda",
                invalid_parameter: "Parametro invalido",
                "invite.loading": "Cargando\u2026",
                meeting_disconnected: "Desconectado reuni\xf3n",
                meeting_info: "Informaci\xf3n sobre la reuni\xf3n",
                meeting_info_network: "Est\xe1s conectado a {{red}} a trav\xe9s de los centros de datos en {{DC}}",
                meeting_not_start: "La reuni\xf3n no ha comenzado",
                meeting_taking: "hablando:",
                meeting_waiting_for_start: "Esperando la reuni\xf3n para comenzar",
                meeting_waiting_room: "El anfitri\xf3n te permitir\xe1 pronto.",
                minimized_view: "Vista minimizada",
                mirror_my_video: "Reflejar mi video",
                "polling.Back": "Atr\xe1s",
                "promote.cancel": "Quedarse como asistente",
                "promote.content_1": "Al ser un panelista, puede reactivar el audio e iniciar el v\xeddeo, lo que significa que ser\xe1 visible para los dem\xe1s en el seminario web.",
                "promote.content_2": "Si el anfitri\xf3n u otros panelistas deciden grabar, transmitir en directo o archivar el seminario web despu\xe9s de que usted reactive el audio, se incluir\xe1 su participaci\xf3n.",
                "promote.ok": "Unirse como panelista",
                "promote.title": "Al anfitri\xf3n le gustar\xeda ascenderle a panelista",
                ribbon_view: "Vista de cinta",
                "rmc.assistant_exist_warning": "No puede controlar la reuni\xf3n porque otro Asistente ya la est\xe1 controlando.",
                "rmc.exist_notification_for_client_host": "Un administrador est\xe1 controlando esta reuni\xf3n.",
                "rmc.not_exist_notification_for_client_host": "El administrador ha dejado de controlar la reuni\xf3n.",
                same_as_system: "Igual que el sistema",
                "security.allow_participants_to": "Permitir que los participantes:",
                "security.button": "Seguridad",
                "security.waiting_room": "Habilitar la sala de espera",
                select_allow: "Seleccione la opci\xf3n Permitir.",
                "settings.audio_tab_text": "Audio",
                "settings.enable_hd": "Habilitar video HD",
                "settings.enable_hd_tip": "Habilite a todos los participantes que vean su video en alta resoluci\xf3n (720P). Tenga en cuenta que el resultado real depende del rendimiento de la m\xe1quina y el ancho de banda.",
                "settings.frame_per_second": "Cuadros por segundo",
                "settings.frequency": "Frecuencia",
                "settings.input_level": "Nivel de entrada:",
                "settings.item_name": "Nombre del elemento",
                "settings.jitter": "Variaci\xf3n de retardo",
                "settings.latency": "Latencia",
                "settings.maximum_view": "M\xe1ximo de participantes mostrados por pantalla en la vista de galer\xeda:",
                "settings.output_level": "Nivel de salida:",
                "settings.packet_loss": "P\xe9rdida de paquetes - promedio(m\xe1x)",
                "settings.participants25": "25 participantes",
                "settings.participants9": "9 participantes",
                "settings.playing": "Reproduciendo",
                "settings.receive": "Recibir",
                "settings.receiving_video": "Recibiendo video",
                "settings.receiving_video_tips": "Use el decodificador de video de hardware de la tarjeta gr\xe1fica para guardar el uso de CPU para recibir video. Actualiza la p\xe1gina para que este cambio surtiera efecto.",
                "settings.recording": "Grabaci\xf3n",
                "settings.rejoin": "Reunirse con",
                "settings.resolution": "Resoluci\xf3n",
                "settings.send": "Enviar",
                "settings.sending_video": "Enviando video",
                "settings.sending_video_tips": "Use el decodificador de video de hardware de la tarjeta gr\xe1fica para guardar el uso de CPU para enviar video. Actualiza la p\xe1gina para que este cambio surtiera efecto.",
                "settings.statistics": "Estad\xedsticas",
                "settings.stop": "Detener",
                "settings.switch_view_mode_text": "Debe reincorporarse a la reuni\xf3n para aplicar este cambio.",
                "settings.test_mic": "Micr\xf3fono",
                "settings.test_speaker": "Probar altavoz",
                "settings.unknown_device": "Dispositivo desconocido",
                "settings.use_hardware_acceleration": "Use aceleraci\xf3n de hardware para:",
                "settings.vb_init_10s_tip2": "El fondo virtual est\xe1 tomando m\xe1s tiempo del esperado que se carga.",
                "settings.vb_init_fail2": "No se puede cargar el fondo virtual.",
                "settings.video_tab_text": "V\xeddeo",
                speaker_view: "Vista del hablante",
                toolbar_join_audio: "Entrar al audio",
                toolbar_leave: "Salir",
                toolbar_mute: "Silenciar",
                toolbar_muteall: "Silenciar a todos",
                toolbar_record: "Grabar",
                toolbar_unmute: "Cancelar silenciar",
                wait_room_tip1: "{{displayName}} ha ingresado a la sala de espera para esta reuni\xf3n",
                wait_room_tip2: "{{count}} personas han ingresado a la sala de espera para esta reuni\xf3n",
                "wc.ast_admin_name": "Asistente de reuni\xf3n",
                "wc.rmc_admin_name": "Administrador del control de reuni\xf3n",
                "wc.rmc_admin_tooltip": "Este usuario tiene controles de anfitri\xf3n y no tiene acceso a ning\xfan contenido multimedia (audio, v\xeddeo, chat y reacciones).",
                wc_3rd_cc_copied_api_token: "Token de API copiado a portapapeles",
                wc_3rd_cc_copy_api_token: "Copiar el token de la API",
                wc_3rd_cc_service: "Utilizar un servicio de subt\xedtulos de terceros",
                wc_3rd_cc_url_help_tips2: "Copie este token y p\xe9guelo en una herramienta de subtitulado de un tercero",
                wc_admit: "Admitir",
                wc_allow_to_talk: "Permitir hablar",
                wc_audio: "Audio",
                "wc_audio.muted_notification1": "El anfitri\xf3n le ha silenciado",
                "wc_audio.muted_notification2": "El anfitri\xf3n ha silenciado a todos",
                "wc_audio.unmute_by_host_content_1": "Al anfitri\xf3n le gustar\xeda que usted hablase",
                "wc_audio.unmute_by_host_content_2": "Si elige reactivar el audio, otros participantes en el seminario web podr\xe1n escucharle. Si el anfitri\xf3n o los panelistas deciden grabar, transmitir en directo o archivar el seminario web despu\xe9s de que usted reactive el audio, se incluir\xe1 su voz.",
                wc_audio_cannot_unmute: "Usted no puede reactivar su propio micr\xf3fono porque el anfitri\xf3n lo silenci\xf3.",
                wc_audio_connecting_thumbnail: "Conectar con el audio",
                wc_broadcasting: "Radiodifusi\xf3n",
                wc_btn_endconf_meeting_all: "Finalizar la reuni\xf3n para todos",
                wc_camera_prevent: "Su navegador no permite el acceso a la c\xe1mara. Habilite el acceso y reinicie el v\xeddeo",
                "wc_cc.placeholder": "Escriba aqu\xed, presione la tecla de Entrada para empezar a transmitir",
                wc_cc_assign_participant_to_type: "Asignar a un participante para escribir",
                wc_cc_assign_to: "Asignar para escribir subt\xedtulos",
                wc_cc_assign_to_type: "Asignar a alguien para que escriba",
                wc_cc_broadcasting_tip: "Los subt\xedtulos se est\xe1n transmitiendo a todos los participantes.",
                wc_cc_host_assigned: "El anfitri\xf3n le ha asignado para que escriba los subt\xedtulos",
                wc_cc_type_myself: "Yo voy a escribir",
                wc_cc_withdraw: "Retirar el permiso de subt\xedtulos",
                "wc_chat.attendee_chat_with": "El espectador puede hablar con:",
                "wc_chat.chat": "Chat",
                "wc_chat.direct_message": "(Mensaje directo)",
                "wc_chat.disable_chat": "El anfitri\xf3n ha inhabilitado el chat de los asistentes.",
                "wc_chat.disabled": "Ninguno",
                "wc_chat.everyone": "Todos",
                "wc_chat.everyone_public": "Todos en p\xfablico",
                "wc_chat.everyone_public_private": "Todos en p\xfablico y en privado",
                "wc_chat.host_only": "Solo el anfitri\xf3n",
                "wc_chat.host_panelists": "Anfitriones y panelistas",
                "wc_chat.me": "Yo",
                "wc_chat.panelist_chat_with": "Los panelistas pueden chatear con:",
                "wc_chat.type_msg": "Escribir mensaje aqu&#237;\u2026",
                wc_closed_caption_btn: "Subt\xedtulos",
                wc_co_host: "(Coanfitri\xf3n)",
                wc_continue: "Continuar",
                wc_copied: "Copiado",
                wc_copied_to_clipboard: "El enlace de invitaci\xf3n se ha copiado al portapapeles",
                wc_copy_link: "Copiar enlace",
                wc_data_center2: "Est\xe1 conectado a un centro de datos in situ.",
                wc_data_center3: "Est\xe1 conectado a la red global de Zoom a trav\xe9s de un centro de datos in situ.",
                wc_disable_talking: "Deshabilitar hablar",
                wc_dlg_confirm: "Confirmaci\xf3n",
                wc_enable: "Habilitado",
                wc_encryption: "Cifrado",
                wc_extra_function_disable_video: "Desactivar recepci\xf3n de v\xeddeo",
                wc_files: "Archivos",
                wc_footer_assign_leave: "Asignar y abandonar",
                wc_footer_assign_new_host: "Asignar un nuevo anfitri\xf3n",
                wc_guest: "Invitado",
                wc_host_1: "Anfitri\xf3n",
                wc_in_the_meeting: "En la reuni\xf3n",
                wc_invite_link: "Enlace de invitaci\xf3n",
                wc_join_media_preview_info_confirm: "Lo tengo",
                wc_join_media_preview_warning_denied_both: "Permita el acceso a la c\xe1mara y al micr\xf3fono en la barra de direcci\xf3n de su explorador.",
                wc_join_media_preview_warning_denied_camera: "Permita el acceso a la c\xe1mara en la barra de direcci\xf3n de su explorador.",
                wc_join_media_preview_warning_denied_mic: "Permita el acceso al micr\xf3fono en la barra de direcci\xf3n de su explorador.",
                wc_joining: "uni\xf3n",
                wc_joining_meeting: "Uni\xe9ndose a la reuni\xf3n...",
                wc_learn_more: "M\xe1s informaci\xf3n",
                wc_leave_computer_audio: "Dejar el audio de la computadora",
                wc_leave_meeting: "Salir de la reuni\xf3n",
                wc_leave_webinar: "Abandonar seminario web",
                wc_live_transcription_btn: "Transcripci\xf3n en directo",
                wc_lock_meeting: "Bloquear reuni\xf3n",
                wc_lower_hand: "Bajar la mano",
                wc_lt_disable_transcription: "Desactivar transcripci\xf3n autom\xe1tica",
                wc_lt_enable_transcription: "Activar transcripci\xf3n autom\xe1tica",
                wc_lt_item_captioner: "(Subtitulador)",
                wc_lt_live_transcript: "Transcripci\xf3n en directo",
                wc_lt_menu_item1: "Mostrar subt\xedtulo",
                wc_lt_menu_item2: "Ver transcripci\xf3n completa",
                wc_lt_menu_item3: "Ocultar subt\xedtulo",
                wc_lt_menu_item4: "Cerrar transcripci\xf3n completa",
                wc_lt_request_host_ctrl: "Permitir que los participantes soliciten la transcripci\xf3n en directo",
                wc_lt_search_text: "Buscar",
                wc_make_co_host: "Convertir en coanfitri\xf3n",
                wc_make_host: "Crear anfitri\xf3n",
                wc_me: "(yo)",
                wc_more: "M\xe1s",
                wc_no: "No",
                wc_none: "Ninguno",
                wc_not_share_pronoun: "No compartir",
                wc_num_password: "Num\xe9rica contrase\xf1a Sistemas Telef\xf3nicos / Habitaci\xf3n",
                wc_participant_id: "ID del participante",
                wc_participants: "Participantes",
                wc_pc_audio: "Audio de la computadora",
                wc_prevent_access_mic: "Su navegador no permite el acceso a su micr\xf3fono.",
                wc_put_in_waiting: "Poner en sala de espera",
                "wc_qa.allQ": "Todas las preguntas",
                "wc_qa.anonymous_attendee": "Espectador an\xf3nimo",
                "wc_qa.answer_private_type": "Respuesta privada",
                "wc_qa.answeredQ": "Respondido",
                "wc_qa.attendee_placeholder": "Las preguntas que realice al anfitri\xf3n y a los panelistas aparecer\xe1n aqu\xed.",
                "wc_qa.button_comment": "Comentar",
                "wc_qa.button_display_answer": "Escriba su respuesta",
                "wc_qa.button_live": "Responder en vivo",
                "wc_qa.button_live_done": "Finalizado",
                "wc_qa.button_reopen": "Volver a abrir",
                "wc_qa.collapse_all_answer": "Comprimir todo",
                "wc_qa.dismissedQ": "Descartado",
                "wc_qa.display_all_answer": "Mostrar todo",
                "wc_qa.dissmis_tips": "Descartar",
                "wc_qa.input_tips": "Escriba su pregunta aqu\xed...",
                "wc_qa.is_anonymous": "Enviar de forma an\xf3nima",
                "wc_qa.is_privately": "Enviar en privado",
                "wc_qa.live_tips_done": "Esta pregunta se respondi\xf3 en vivo",
                "wc_qa.live_tips_start": "desear\xeda responder a esto en directo",
                "wc_qa.most_recent": "M\xe1s recientes",
                "wc_qa.most_upvotes": "Con m\xe1s votos a favor",
                "wc_qa.myQ": "Mis preguntas",
                "wc_qa.no_answered_questions": "No hay preguntas respondidas",
                "wc_qa.no_dismissed_questions": "No hay preguntas descartadas",
                "wc_qa.no_open_questions": "No hay preguntas abiertas",
                "wc_qa.no_questions": "No hay preguntas",
                "wc_qa.openedQ": "Abierto",
                "wc_qa.panelist_host_only_placeholder": "Solo los anfitriones y los panelistas pueden ver las preguntas",
                "wc_qa.panelist_view_all_placehoder": "Todos en este seminario web pueden ver las preguntas abiertas",
                "wc_qa.qa_comp_title": "Preguntas y respuestas",
                "wc_qa.send": "Enviar",
                "wc_qa.setting_allow_view": "Permitir que los espectadores vean",
                "wc_qa.setting_btn_name": "ajustes",
                "wc_qa.setting_option_allow_anony_question": "Permitir preguntas an\xf3nimas",
                "wc_qa.setting_option_allow_comment": "Los espectadores pueden comentar",
                "wc_qa.setting_option_allow_view_all": "Todas las preguntas",
                "wc_qa.setting_option_allow_view_answered": "Solo preguntas respondidas",
                "wc_qa.setting_option_allow_vote": "Los espectadores pueden votar a favor",
                "wc_qa.welcome_banner": "Si\xe9ntase libre de hacerles preguntas al anfitri\xf3n y a los panelistas",
                "wc_qa.welcome_banner_title": "Bienvenido/a",
                wc_raise_hand: "Levantar la mano",
                wc_reclaim_host: "Reclamar el rol de anfitri\xf3n",
                wc_record_host_reminder_desc: "Al continuar, todas las caras, conversaciones y comparticiones de pantalla se grabar\xe1n en la nube.",
                wc_record_reminder_desc: "Al seguir adelante con esta reuni\xf3n est\xe1 dando su consentimiento a ser grabado.",
                wc_record_reminder_desc_2: "El {{accountOwner}} y el anfitri\xf3n pueden ver las grabaciones en la nube de Zoom y cualquier participante con permiso puede grabar en su dispositivo local. Estas personas pueden compartir estas grabaciones con aplicaciones y otros.",
                wc_record_reminder_title: "La reuni\xf3n se est\xe1 grabando",
                wc_record_reminder_webinar_title: "El seminario web se est\xe1 grabando",
                wc_record_webinar_reminder_desc: "Al seguir adelante con este seminario web est\xe1 dando su consentimiento a ser grabado.",
                wc_recording_pause: "Pausar grabaci\xf3n",
                wc_recording_resume: "Reanudar grabaci\xf3n",
                wc_recording_stop: "Detener grabaci\xf3n",
                wc_recording_title: "Grabar esta reuni\xf3n?",
                wc_remove: "Retirar",
                wc_select_camera: "Seleccionar una c\xe1mara",
                wc_select_microphone: "Seleccionar un micr\xf3fono",
                wc_select_speaker: "Seleccionar un altavoz",
                wc_share_muted_while_sharing_audio_tip2: "Su micr\xf3fono est\xe1 deshabilitado al compartir audio por computadora. Cuando pausas o deja de compartir audio, su micr\xf3fono se reactivar\xe1.",
                wc_share_pronoun: "Compartir",
                wc_share_pronoun_menu: "Compartir mis pronombres",
                wc_share_pronoun_tip2: "\xbfDesea compartir sus pronombres en esta reuni\xf3n?",
                wc_sharer_controlbar_container_button3_label: "Detener compartici\xf3n",
                wc_sharer_controlbar_container_rec_status_tip1: "Est\xe1 compartiendo la pantalla",
                wc_sharer_controlbar_container_rec_status_tip2: "Su funci\xf3n de compartir las pantallas est\xe1 en pausa",
                wc_sharer_disabled_share1_desc: "El anfitri\xf3n deshabilit\xf3 la funci\xf3n de compartir las pantallas de los participantes.",
                wc_sharer_disabled_share2_desc: "Usted no puede iniciar la funci\xf3n de compartir pantallas mientras el otro participante est\xe1 compartiendo.",
                wc_sharer_entry_button_label1: "Compartir pantalla",
                wc_sharer_setting_menu_category1_title: "\xbfQui\xe9n puede compartir?",
                wc_sharer_setting_menu_category2_title: "\xbfQui\xe9n puede comenzar a compartir cuando otro est\xe1 compartiendo?",
                wc_sharer_setting_menu_category3_title: "\xbfCu\xe1ntos participantes pueden compartir al mismo tiempo?",
                wc_sharer_setting_menu_category_option1: "Solo anfitri\xf3n",
                wc_sharer_setting_menu_category_option2: "Todos los participantes",
                wc_sharer_setting_menu_item1: "Un participante puede compartir a la vez",
                wc_sharer_setting_menu_item2: "Varios participantes pueden compartir de forma simult\xe1nea",
                wc_sharing_fit_to_window: "Ajustar a la pantalla",
                wc_sharing_original_size: "Tama\xf1o original",
                wc_sharing_shared_screens: "Pantallas compartidas",
                wc_sharing_view_options: "Ver opciones",
                wc_sharing_viewing: "Est\xe1s viendo la pantalla {{spantname}}",
                wc_tel_password: "C\xf3digo de acceso",
                wc_unmute_by_host_btn1: "Permanecer silenciado",
                wc_unshare_pronoun_menu: "Dejar de compartir mis pronombres",
                "wc_video.allow_panelist_start_video": "Permitir que el ponente inicie el v\xeddeo",
                "wc_video.allow_participants_start_video": "Permitir que los participantes inicien el v\xeddeo",
                "wc_video.ask_start_video": "Pedir iniciar el v\xeddeo",
                "wc_video.model_stop": "No se puede iniciar su v\xeddeo porque el anfitri\xf3n lo ha parado",
                "wc_video.start_video": "Iniciar el v\xeddeo",
                "wc_video.stop_video": "Parar el v\xeddeo",
                "wc_video.video": "V\xeddeo",
                wc_view: "Ver",
                wc_waiting_room: "Sala de espera",
                "wc_webinar.change_to_attendee": "Cambiar rol a Asistente",
                "wc_webinar.promote_to_panelist": "Ascender a panelista",
                wc_webinar_attendees: "Asistentes",
                wc_webinar_panelists: "Panelistas",
                wc_webinar_putonhold: "Poner en espera",
                wc_withdraw_co_host: "Retirar permiso de coanfitri\xf3n",
                wc_yes: "S\xed",
                websdk_enforce_update_content: "La versi\xf3n de su aplicaci\xf3n debe ser {0} o superior para unirse a esta reuni\xf3n. Actualice para continuar.",
                websdk_update_content: "Actualizaci\xf3n WebSDK a la \xfaltima versi\xf3n para optimizar la experiencia de la reuni\xf3n"
              }
            },
            "fr-FR": {
              translation: {
                GOT_IT: "J\u2019ai compris",
                account_owner: "propri\xe9taire du compte",
                allow_to_access: "Permettre d'acc\xe9der \xe0 votre appareil photo et \xe0 votre microphone",
                "app_signal.approved_by": "Approuv\xe9 par",
                "app_signal.hosts_account": "Compte de l\u2019h\xF4te",
                "app_signal.people": "personnes",
                "app_signal.tip_text_2": "Voir les applications qui acc\xe8dent au contenu de votre r\xe9union",
                "app_signal.unable_load2": "Impossible de charger des applications avec acc\xe8s en temps r\xe9el \xe0 vos informations.",
                "archiving.chat_1": "discussion (publique et directe)",
                "archiving.chat_2": "discussion (publique uniquement)",
                "archiving.chat_disable_content": "Les messages envoy\xE9s dans la discussion n\u2019ont pas pu \xEAtre archiv\xE9s pour des raisons de conformit\xE9.",
                "archiving.chat_disable_title": "La discussion a \xe9t\xe9 d\xe9sactiv\xe9e",
                "archiving.content1_sdk": "Un ou plusieurs participants \xE0 cette r\xE9union sont soumis \xE0 un archivage d\u2019apr\xE8s la politique de leur compte. Leur {{content}} recevra le contenu de cette r\xE9union et pourra le partager avec des applications et d\u2019autres personnes.",
                "archiving.content2_sdk": "En restant dans cette r\xe9union, vous acceptez que le {{content}} de cette r\xe9union soit archiv\xe9.",
                "archiving.default_title": "Cette r\xe9union est archiv\xe9e",
                "archiving.fail_content_sdk": "Le {{features}} de cette r\xe9union doit \xeatre archiv\xe9 pour des raisons de conformit\xe9.",
                "archiving.fail_title": "Impossible d\u2019archiver",
                "archiving.subjects_combo_2_sdk": "{{0}} et {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} et {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} et {{3}}",
                "archiving.tips_1_sdk": "Le {{subjects}} de cette r\xE9union est archiv\xE9 par l\u2019organisation de l\u2019h\xF4te d\u2019apr\xE8s la politique de son compte. Son {{receiver}} recevra du contenu de cette r\xE9union et pourra le partager avec des applications et d\u2019autres personnes.",
                "archiving.tips_2_sdk": "Les {{subjects}} de cette r\xE9union sont archiv\xE9s par l\u2019organisation de l\u2019h\xF4te d\u2019apr\xE8s la politique de son compte. Leur {{receiver}} recevra du contenu de cette r\xE9union et pourra le partager avec des applications et d\u2019autres personnes.",
                "archiving.transcription": "transcription",
                "ast.leave_tip": "L\u2019assistant a cess\xE9 de contr\xF4ler la r\xE9union.",
                "ast.tip": "Cette r\xe9union est contr\xf4l\xe9e par un assistant",
                background: "Arri\xe8re-plan",
                chat_message_header: "<0> {{senderName}} </0> <1> \xe0 </1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}} nouveau message",
                chat_receiver_co_host: "(co-animateur)",
                chat_receiver_host: "(animateur)",
                chat_receiver_panelist: "(Pan\xe9listes)",
                chat_receiver_to: "\xc0\xa0:",
                choose_background: "Choisir un arri\xe8re-plan",
                click_address_bar: "Cliquez sur l'ic\xf4ne de verrouillage \xe0 gauche de votre barre d'adresse. Une fen\xeatre contextuelle appara\xeetra avec une liste d'options.",
                click_microphone_camera_option: "Cliquez sur la liste d\xe9roulante \xe0 droite de l'option Cam\xe9ra et Microphone.",
                "common.cancel": "Annuler",
                "common.connecting": "De liaison",
                delete: "Supprimer",
                "dialog.btn_cancel": "Annuler",
                "dialog.btn_endconf_webinar": "Terminer le webinaire",
                "dialog.btn_leaveconf_meeting": "Quittez la r\xe9union",
                "dialog.btn_retry": "R\xe9essayer",
                "dialog.host_end_meeting": "Cette r\xe9union a \xe9t\xe9 termin\xe9e par son animateur.",
                "dialog.host_end_webinar": "Ce webinaire a \xe9t\xe9 termin\xe9 par son animateur.",
                "dialog.meeting_ended": "La r\xe9union a \xe9t\xe9 termin\xe9e",
                "dialog.meeting_locked": "La r\xe9union a \xe9t\xe9 verrouill\xe9e",
                "dialog.meeting_removed_by_host": "Vous avez \xE9t\xE9 exclu de cette r\xE9union par l\u2019animateur.",
                "dialog.newname": "Nom",
                "dialog.ok": "OK",
                "dialog.presscode": "N\xba de r\xe9union",
                "dialog.rename": "Renommer",
                "dialog.server_error": "Le serveur a \xE9t\xE9 affect\xE9 par une erreur interne et n\u2019a pas pu traiter votre requ\xEAte.",
                "dialog.webinar_ended": "Le webinaire a \xe9t\xe9 termin\xe9",
                "dialog.webinar_removed_by_host": "Vous avez \xE9t\xE9 exclu de ce webinaire par l\u2019animateur.",
                "dialog.you_are_removed": "Vous avez \xe9t\xe9 exclu",
                dialog_make_cohost: "Voulez-vous nommer {{displayName}}co-animateur de cette r\xe9union\xa0?",
                dialog_make_host: "Voulez-vous changer l\u2019h\xF4te et choisir {{displayName}}?",
                dialog_remove_user: "Voulez-vous supprimer {{displayName}}\xa0?",
                "disclaimer.LT_button_1": "Qui peut voir cette transcription\xa0?",
                "disclaimer.LT_content_1_1": "Le propri\xE9taire du compte et tous les participants \xE0 la r\xE9union peuvent enregistrer cette transcription et la partager avec des applications et d\u2019autres personnes.",
                "disclaimer.LT_content_2": "La transcription en direct (sous-titres) a \xe9t\xe9 activ\xe9e",
                "disclaimer.QA_button_1": "Qui peut voir vos questions\xa0?",
                "disclaimer.QA_content_1_1": "Le propri\xE9taire du compte, l\u2019h\xF4te et les pan\xE9listes pourront voir qui vous \xEAtes, vos informations de contact (si vous \xEAtes connect\xE9(e) ou si vous les avez fournies) et votre question, et pourront les partager avec des applications et d\u2019autres personnes.",
                "disclaimer.QA_content_2": "Si votre question est s\xe9lectionn\xe9e, elle sera visible par tous les spectateurs.",
                "disclaimer.QA_content_3_3": "\xC0 moins de soumettre votre question de mani\xE8re anonyme, le propri\xE9taire du compte, l\u2019h\xF4te et les pan\xE9listes pourront voir qui vous \xEAtes, vos informations de contact (si vous \xEAtes connect\xE9(e) ou si vous les avez fournies) et votre question, et pourront les partager avec des applications et d\u2019autres personnes.",
                "disclaimer.QA_content_4": "Ces questions-r\xe9ponses sont publiques, et ainsi tout le monde peut voir vos questions.",
                "disclaimer.QA_content_5": "Si vous envoyez vos questions de mani\xe8re anonyme, personne ne pourra voir qui les a soumises.",
                "disclaimer.chat_button_normal": "Qui peut voir vos messages\xa0?",
                "disclaimer.chat_button_onArchiving": "Qui peut voir vos messages\xa0? Archivage activ\xe9",
                "disclaimer.chat_button_onRecording": "Qui peut voir vos messages\xa0? Enregistrement activ\xe9",
                "disclaimer.chat_content_1": "Tous les participants \xE0 la r\xE9union peuvent voir et enregistrer vos messages envoy\xE9s \xE0 tout le monde, et peuvent les partager avec des applications et d\u2019autres personnes.",
                "disclaimer.chat_content_2": "Seuls vous et ceux avec qui vous discutez peuvent enregistrer vos messages directs et les partager avec des applications et d\u2019autres personnes.",
                "disclaimer.chat_content_3": "L\u2019enregistrement est activ\xE9, de sorte que le propri\xE9taire du compte et tous les participants \xE0 la r\xE9union peuvent voir et enregistrer les messages envoy\xE9s \xE0 tout le monde, et peuvent les partager avec des applications et d\u2019autres personnes.",
                "disclaimer.chat_content_4": "L\u2019enregistrement est activ\xE9, de sorte que tous les participants \xE0 la r\xE9union peuvent voir et enregistrer les messages envoy\xE9s \xE0 tout le monde, et peuvent les partager avec des applications et d\u2019autres personnes.",
                "disclaimer.chat_content_5": "L\u2019archivage est activ\xE9, de sorte que le propri\xE9taire du compte puisse voir tous vos messages, y compris vos messages directs, et les partager avec des applications et d\u2019autres personnes.",
                "disclaimer.chat_content_6": "Tous les participants \xe0 la r\xe9union peuvent enregistrer et partager les messages que vous envoyez \xe0 tout le monde.",
                "disclaimer.chat_content_7": "L\u2019archivage est activ\xE9, de sorte que le propri\xE9taire du compte peut voir tous vos messages (sauf vos messages directs) et peut les partager avec des applications et d\u2019autres personnes.",
                errorcodes_be_removed: "\xcatre retir\xe9.",
                errorcodes_denied_email: "Le courrier \xe9lectronique est bloqu\xe9 par l'administrateur.",
                errorcodes_denied_register_with_panelist: "l'utilisation du registre Refus\xe9 email pan\xe9liste.",
                errorcodes_disconnect: "R\xe9union a \xe9t\xe9 d\xe9connect\xe9.",
                errorcodes_email_require: "Le courrier \xe9lectronique est absent pour assister webinaire.",
                errorcodes_fail: "D\xe9faut de se joindre \xe0 la r\xe9union.",
                errorcodes_frequent_call: "Vous avez atteint la limite de l'API pour cet appel.",
                errorcodes_frequent_join: "Vous \xeatre limite par le zoom, devez v\xe9rifier recaptcha.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Impossible de rejoindre le navigateur, s'il vous pla\xeet rejoindre en utilisant le client de bureau Zoom ou une application mobile.",
                errorcodes_not_exist: "R\xe9union n'existe pas.",
                errorcodes_not_host: "Vous n'\xeates pas l'h\xf4te de la r\xe9union.",
                errorcodes_not_init: "La non-satisfaction initialis\xe9.",
                errorcodes_not_start: "R\xe9union n'a pas commenc\xe9",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "Le service est temporairement hors ligne.",
                errorcodes_pac_api_disabled: "L'API Key Accounts est d\xe9sactiv\xe9e.",
                errorcodes_pac_api_wrong: "L'API Key Accounts est pas valide.",
                errorcodes_pac_cant_host_other_mn: "Ne peut pas ne pas organiser une autre r\xe9union en m\xeame temps.",
                errorcodes_pac_host_not_found: "L'h\xf4te de la r\xe9union ne se trouve pas.",
                errorcodes_pac_invalid_signature: "La signature est invalide.",
                errorcodes_pac_mn_not_fount: "Le num\xe9ro de la r\xe9union ne se trouve pas.",
                errorcodes_pac_mn_wrong: "Le num\xe9ro de r\xe9union est erron\xe9.",
                errorcodes_pac_no_permission: "Aucune autorisation.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "r\xf4le incorrect.",
                errorcodes_pac_signature_expired: "La signature a expir\xe9.",
                errorcodes_re_connect: "R\xe9union reconnecte.",
                errorcodes_register: "Cette r\xe9union n\xe9cessite une inscription.",
                errorcodes_rwc_empty: "Impossible d'obtenir une r\xe9ponse du serveur Web.",
                errorcodes_rwc_error: "Impossible de se connecter \xe0 une erreur du serveur Web.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "Avec succ\xe8s joint \xe0 la r\xe9union.",
                errorcodes_tk_expired: "Jeton a expir\xe9.",
                errorcodes_wasm_fail: "erreur fichiers T\xe9l\xe9charger wasm, s'il vous pla\xeet v\xe9rifier votre r\xe9seau et pare-feu.",
                errorcodes_web_has_in_progress: "Il a d\xE9j\xE0 d\u2019autres r\xE9unions en cours.",
                errorcodes_web_host_not_exit: "L\u2019animateur de la r\xE9union n\u2019existe pas.",
                errorcodes_web_invalid_id: "N\xba de r\xe9union non valide.",
                errorcodes_web_not_allow_start_webinar_from_web: "Ne pas permettre de d\xe9marrer des webinaires \xe0 partir du Web.",
                errorcodes_web_not_support_registration_webinar: "Ne prend pas en charge le webinaire d\u2019inscription",
                errorcodes_web_not_support_tsp: "Ne peut pas d\xe9marrer ou rejoindre la r\xe9union depuis Internet, lorsque vous s\xe9lectionnez le fournisseur de service en t\xe9l\xe9phonie comma sa sortie audio dans une r\xe9union.",
                errorcodes_web_not_support_webclient: "Ne supporte pas d\xe9marrer ou rejoindre une r\xe9union \xe0 partir du web.",
                errorcodes_web_not_support_webinar_pac: "Ne prend pas en charge le webinaire ni la conf\xe9rence audio personnelle",
                errorcodes_web_require_email: "Le courriel de l\u2019utilisateur est requis.",
                errorcodes_web_should_support_webinar_with_latest_version: "La version actuelle du SDK ne prend pas en charge le webinaire, veuillez passer \xe0 la derni\xe8re version.",
                errorcodes_wrong_pass: "R\xe9union Mot de passe erron\xe9.",
                gallary_view: "Affichage galerie",
                invalid_parameter: "Param\xe8tre invalide",
                "invite.loading": "Chargement en cours...",
                meeting_disconnected: "r\xe9union Disconnected",
                meeting_info: "Renseignements sur la r\xe9union",
                meeting_info_network: "Vous \xeates connect\xe9 \xe0 {{r\xe9seau}} via des centres de donn\xe9es en {{dc}}",
                meeting_not_start: "La r\xE9union n\u2019a pas encore commenc\xE9",
                meeting_taking: "la parole est \xe0\xa0:",
                meeting_waiting_for_start: "En attente de r\xe9union pour commencer",
                meeting_waiting_room: "L'h\xf4te vous laissera bient\xf4t",
                minimized_view: "Vue minimis\xe9e",
                mirror_my_video: "Mettre ma vid\xe9o en miroir",
                "polling.Back": "Retour",
                "promote.cancel": "Rester comme spectateur",
                "promote.content_1": "En tant que pan\xe9liste, vous pouvez r\xe9activer le son et d\xe9marrer la vid\xe9o, ce qui signifie que vous serez visible par les autres participants du webinaire.",
                "promote.content_2": "Si l\u2019h\xF4te ou d\u2019autres pan\xE9listes d\xE9cident d\u2019enregistrer, de diffuser en direct ou d\u2019archiver le webinaire une fois que vous avez r\xE9activ\xE9 le son, votre participation sera incluse.",
                "promote.ok": "Rejoindre comme pan\xe9liste",
                "promote.title": "L\u2019h\xF4te souhaite vous promouvoir comme pan\xE9liste",
                ribbon_view: "Vue du ruban",
                "rmc.assistant_exist_warning": "Vous ne pouvez pas contr\xf4ler la r\xe9union car un autre Assistant la contr\xf4le actuellement.",
                "rmc.exist_notification_for_client_host": "Cette r\xe9union est contr\xf4l\xe9e par un administrateur.",
                "rmc.not_exist_notification_for_client_host": "L\u2019administrateur a cess\xE9 de contr\xF4ler la r\xE9union.",
                same_as_system: "Identique au syst\xe8me",
                "security.allow_participants_to": "Autoriser les participants \xe0\xa0:",
                "security.button": "S\xe9curit\xe9",
                "security.waiting_room": "Activer la salle d\u2019attente",
                select_allow: "S\xe9lectionnez l'option permettre.",
                "settings.audio_tab_text": "Audio",
                "settings.enable_hd": "Activer la vid\xe9o HD",
                "settings.enable_hd_tip": "Activez tous les participants de visualiser votre vid\xe9o en haute r\xe9solution (720P). Notez que le r\xe9sultat r\xe9el d\xe9pend des performances de la machine et de la bande passante.",
                "settings.frame_per_second": "Images/seconde",
                "settings.frequency": "Fr\xe9quence",
                "settings.input_level": "Niveau d'entr\xe9e\xa0:",
                "settings.item_name": "Nom de l\u2019\xE9l\xE9ment",
                "settings.jitter": "Gigue",
                "settings.latency": "Latence",
                "settings.maximum_view": "Nombre maximum de participants affich\xe9s par \xe9cran dans la vue Galerie\xa0:",
                "settings.output_level": "Niveau de sortie\xa0:",
                "settings.packet_loss": "Perte de paquets\xA0\u2013 Moy.(max)",
                "settings.participants25": "25 participants",
                "settings.participants9": "9 participants",
                "settings.playing": "Lecture en cours",
                "settings.receive": "Recevoir",
                "settings.receiving_video": "Recevoir une vid\xe9o",
                "settings.receiving_video_tips": "Utilisez le d\xe9codeur vid\xe9o mat\xe9rielle de la carte graphique pour enregistrer l'utilisation du CPU pour recevoir une vid\xe9o. Actualisez la page pour ce changement pour prendre effet.",
                "settings.recording": "Enregistrement",
                "settings.rejoin": "Rejoindre",
                "settings.resolution": "R\xe9solution",
                "settings.send": "Envoyer",
                "settings.sending_video": "Envoi de vid\xe9os",
                "settings.sending_video_tips": "Utilisez le d\xe9codeur vid\xe9o mat\xe9riel de la carte graphique pour enregistrer l'utilisation du CPU pour l'envoi de la vid\xe9o. Actualisez la page pour ce changement pour prendre effet.",
                "settings.statistics": "Statistiques",
                "settings.stop": "Arr\xeater",
                "settings.switch_view_mode_text": "Vous devez rejoindre la r\xe9union pour appliquer ce changement",
                "settings.test_mic": "Tester le micro",
                "settings.test_speaker": "Tester le haut-parleur",
                "settings.unknown_device": "P\xe9riph\xe9rique inconnu",
                "settings.use_hardware_acceleration": "Utiliser une acc\xe9l\xe9ration mat\xe9rielle pour:",
                "settings.vb_init_10s_tip2": "L'arri\xe8re-plan virtuel prend plus de temps que pr\xe9vu de charger.",
                "settings.vb_init_fail2": "Impossible de charger fond virtuel.",
                "settings.video_tab_text": "Vid\xe9o",
                speaker_view: "Affichage intervenant",
                toolbar_join_audio: "Rejoindre l\u2019audio",
                toolbar_leave: "Quitter",
                toolbar_mute: "Couper le micro",
                toolbar_muteall: "Couper tous les micros",
                toolbar_record: "Enregistrer",
                toolbar_unmute: "R\xe9activer le micro",
                wait_room_tip1: "{{displayName}} est entr\xE9 dans la salle d\u2019attente pour cette r\xE9union",
                wait_room_tip2: "{{count}}\xA0personnes sont entr\xE9es dans la salle d\u2019attente pour cette r\xE9union",
                "wc.ast_admin_name": "Assistant de r\xe9union",
                "wc.rmc_admin_name": "Administrateur de contr\xf4le de la r\xe9union",
                "wc.rmc_admin_tooltip": "Cet utilisateur dispose de commandes h\xF4te et n\u2019a acc\xE8s \xE0 aucun contenu m\xE9dia (audio, vid\xE9o, discussion et r\xE9actions).",
                wc_3rd_cc_copied_api_token: "Jeton API copi\xe9 dans le presse-papiers",
                wc_3rd_cc_copy_api_token: "Copier le jeton API",
                wc_3rd_cc_service: "Utiliser un service de sous-titres tiers",
                wc_3rd_cc_url_help_tips2: "Copiez ce jeton et collez-le dans un outil de sous-titrage de tierce partie",
                wc_admit: "Admettre",
                wc_allow_to_talk: "Permettre de parler",
                wc_audio: "Audio",
                "wc_audio.muted_notification1": "L\u2019h\xF4te a d\xE9sactiv\xE9 votre son",
                "wc_audio.muted_notification2": "L\u2019h\xF4te a d\xE9sactiv\xE9 le son de tout le monde",
                "wc_audio.unmute_by_host_content_1": "L\u2019h\xF4te souhaite que vous parliez",
                "wc_audio.unmute_by_host_content_2": "Si vous choisissez de r\xE9activer le son, les autres personnes du webinaire pourront vous entendre. Si l\u2019h\xF4te ou les pan\xE9listes d\xE9cident d\u2019enregistrer, de diffuser en direct ou d\u2019archiver le webinaire apr\xE8s que vous avez r\xE9activ\xE9 le son, votre voix sera incluse.",
                wc_audio_cannot_unmute: "Vous ne pouvez pas r\xE9activer vous-m\xEAme votre micro, car c\u2019est l\u2019h\xF4te qui vous a mis en sourdine.",
                wc_audio_connecting_thumbnail: "Connexion \xe0 l'audio",
                wc_broadcasting: "Diffusion",
                wc_btn_endconf_meeting_all: "Mettre fin \xe0 la r\xe9union pour tous",
                wc_camera_prevent: "Votre navigateur bloque actuellement l\u2019acc\xE8s \xE0 votre cam\xE9ra. Autorisez l\u2019acc\xE8s et red\xE9marrez votre vid\xE9o",
                "wc_cc.placeholder": "Saisir ici et appuyer sur Retour pour diffuser",
                wc_cc_assign_participant_to_type: "Affecter un participant \xe0 la saisie",
                wc_cc_assign_to: "Affecter \xe0 la saisie des sous-titres",
                wc_cc_assign_to_type: "Affecter quelqu\u2019un \xE0 la saisie",
                wc_cc_broadcasting_tip: "Les sous-titres sont diffus\xe9s \xe0 tous les participants.",
                wc_cc_host_assigned: "L\u2019animateur vous a affect\xE9 \xE0 la saisie des sous-titres",
                wc_cc_type_myself: "Je ferai la saisie",
                wc_cc_withdraw: "Retirer la permission de sous-titrage",
                "wc_chat.attendee_chat_with": "Le participant peut discuter avec\xa0:",
                "wc_chat.chat": "Discuter",
                "wc_chat.direct_message": "(Message direct)",
                "wc_chat.disable_chat": "L\u2019animateur a d\xE9sactiv\xE9 les conversations des participants.",
                "wc_chat.disabled": "Aucun",
                "wc_chat.everyone": "Tout le monde",
                "wc_chat.everyone_public": "Tout le monde en public",
                "wc_chat.everyone_public_private": "Tout le monde en public et en priv\xe9",
                "wc_chat.host_only": "Animateur seulement",
                "wc_chat.host_panelists": "H\xf4tes et pan\xe9listes",
                "wc_chat.me": "Moi",
                "wc_chat.panelist_chat_with": "Les pan\xe9listes peuvent discuter avec\xa0:",
                "wc_chat.type_msg": "Saisir le message ici?",
                wc_closed_caption_btn: "Sous-titres",
                wc_co_host: "(Co-h\xf4te)",
                wc_continue: "Continuer",
                wc_copied: "Copi\xe9",
                wc_copied_to_clipboard: "Le lien d\u2019invitation a \xE9t\xE9 copi\xE9 dans le presse-papiers",
                wc_copy_link: "Copier le lien",
                wc_data_center2: "Vous \xeates connect\xe9 \xe0 un centre de donn\xe9es sur site.",
                wc_data_center3: "Vous \xeates connect\xe9 au r\xe9seau mondial Zoom via un centre de donn\xe9es sur site.",
                wc_disable_talking: "D\xe9sactiver la conversation",
                wc_dlg_confirm: "Confirmation",
                wc_enable: "Activ\xe9",
                wc_encryption: "Chiffrement",
                wc_extra_function_disable_video: "D\xe9sactiver r\xe9ception vid\xe9o",
                wc_files: "Fichiers",
                wc_footer_assign_leave: "Affecter et quitter",
                wc_footer_assign_new_host: "Affecter un nouvel h\xf4te",
                wc_guest: "Invit\xe9",
                wc_host_1: "H\xf4te",
                wc_in_the_meeting: "Dans la r\xe9union",
                wc_invite_link: "Lien d\u2019invitation",
                wc_join_media_preview_info_confirm: "J\u2019ai compris",
                wc_join_media_preview_warning_denied_both: "Autoriser l\u2019acc\xE8s \xE0 la cam\xE9ra et au microphone dans la barre d\u2019adresse de votre navigateur.",
                wc_join_media_preview_warning_denied_camera: "Autoriser l\u2019acc\xE8s \xE0 la cam\xE9ra dans la barre d\u2019adresse de votre navigateur.",
                wc_join_media_preview_warning_denied_mic: "Activer l\u2019acc\xE8s au microphone dans la barre d\u2019adresse de votre navigateur.",
                wc_joining: "joindre",
                wc_joining_meeting: "En train de rejoindre la r\xe9union...",
                wc_learn_more: "En savoir plus",
                wc_leave_computer_audio: "Quitter l\u2019audio de l\u2019ordinateur",
                wc_leave_meeting: "Quittez la r\xe9union",
                wc_leave_webinar: "Quitter le webinaire",
                wc_live_transcription_btn: "Transcription en direct",
                wc_lock_meeting: "Verrouiller la r\xe9union",
                wc_lower_hand: "Baisser la main",
                wc_lt_disable_transcription: "D\xe9sactiver la transcription automatique",
                wc_lt_enable_transcription: "Activer la transcription automatique",
                wc_lt_item_captioner: "(Sous-titreur)",
                wc_lt_live_transcript: "Transcription en direct",
                wc_lt_menu_item1: "Afficher les sous-titres",
                wc_lt_menu_item2: "Afficher la transcription int\xe9grale",
                wc_lt_menu_item3: "Masquer le sous-titrage",
                wc_lt_menu_item4: "Fermer la transcription int\xe9grale",
                wc_lt_request_host_ctrl: "Autoriser les participants \xe0 demander la transcription en direct",
                wc_lt_search_text: "Rechercher",
                wc_make_co_host: "Nommer co-h\xf4te",
                wc_make_host: "Nommer animateur",
                wc_me: "(moi)",
                wc_more: "Plus",
                wc_no: "Non",
                wc_none: "Aucun",
                wc_not_share_pronoun: "Ne pas partager",
                wc_num_password: "Mot de passe num\xe9rique / t\xe9l\xe9phone syst\xe8mes de salle",
                wc_participant_id: "No du participant",
                wc_participants: "Participants",
                wc_pc_audio: "Audio de l\u2019ordinateur",
                wc_prevent_access_mic: "Votre navigateur emp\xEAche l\u2019acc\xE8s \xE0 votre micro.",
                wc_put_in_waiting: "Mettre en salle d\u2019attente",
                "wc_qa.allQ": "Toutes les questions",
                "wc_qa.anonymous_attendee": "Spectateur anonyme",
                "wc_qa.answer_private_type": "R\xe9ponse priv\xe9e",
                "wc_qa.answeredQ": "R\xe9solue",
                "wc_qa.attendee_placeholder": "Les questions que vous posez \xE0 l\u2019h\xF4te et aux pan\xE9listes s\u2019afficheront ici.",
                "wc_qa.button_comment": "Commenter",
                "wc_qa.button_display_answer": "Tapez r\xe9ponse",
                "wc_qa.button_live": "R\xe9pondre en direct",
                "wc_qa.button_live_done": "Termin\xe9",
                "wc_qa.button_reopen": "Rouvrir",
                "wc_qa.collapse_all_answer": "Tout r\xe9duire",
                "wc_qa.dismissedQ": "Rejet\xe9",
                "wc_qa.display_all_answer": "Tout afficher",
                "wc_qa.dissmis_tips": "Rejeter",
                "wc_qa.input_tips": "Saisissez votre question ici\u2026",
                "wc_qa.is_anonymous": "Envoyer anonymement",
                "wc_qa.is_privately": "Envoyer en priv\xe9",
                "wc_qa.live_tips_done": "Cette question a \xe9t\xe9 r\xe9pondue en direct",
                "wc_qa.live_tips_start": "souhaite r\xe9pondre \xe0 cette question en direct",
                "wc_qa.most_recent": "Le plus r\xe9cent",
                "wc_qa.most_upvotes": "Le plus grand nombre de votes favorables",
                "wc_qa.myQ": "Mes questions",
                "wc_qa.no_answered_questions": "Aucune question r\xe9solue",
                "wc_qa.no_dismissed_questions": "Pas de question rejet\xe9e",
                "wc_qa.no_open_questions": "Pas de question ouverte.",
                "wc_qa.no_questions": "Pas de question",
                "wc_qa.openedQ": "Ouvrir",
                "wc_qa.panelist_host_only_placeholder": "Seuls les h\xf4tes et les pan\xe9listes peuvent voir les questions",
                "wc_qa.panelist_view_all_placehoder": "Tous les participants \xe0 ce webinaire peuvent voir les questions ouvertes",
                "wc_qa.qa_comp_title": "Questions-R\xe9ponses",
                "wc_qa.send": "Envoyer",
                "wc_qa.setting_allow_view": "Autoriser les participants \xe0 voir",
                "wc_qa.setting_btn_name": "R\xe9glages",
                "wc_qa.setting_option_allow_anony_question": "Autoriser des questions anonymes",
                "wc_qa.setting_option_allow_comment": "Les participants peuvent commenter",
                "wc_qa.setting_option_allow_view_all": "Toutes les questions",
                "wc_qa.setting_option_allow_view_answered": "Questions r\xe9pondues seulement",
                "wc_qa.setting_option_allow_vote": "Les participants peuvent voter en faveur",
                "wc_qa.welcome_banner": "N\u2019h\xE9sitez pas \xE0 poser des questions \xE0 l\u2019h\xF4te et aux pan\xE9listes",
                "wc_qa.welcome_banner_title": "Bienvenue",
                wc_raise_hand: "Lever la main",
                wc_reclaim_host: "R\xE9cup\xE9rer le r\xF4le d\u2019animateur",
                wc_record_host_reminder_desc: "Si vous continuez, tous les visages, conversations et partages d\u2019\xE9cran seront enregistr\xE9s sur le cloud.",
                wc_record_reminder_desc: "En participant \xe0 cette r\xe9union, vous consentez \xe0 \xeatre enregistr\xe9.",
                wc_record_reminder_desc_2: "Le {{accountOwner}} et l\u2019h\xF4te peuvent visualiser les enregistrements dans le cloud Zoom et chaque participant en ayant l\u2019autorisation peut enregistrer sur son appareil local. Ces personnes peuvent partager les enregistrements avec des applications et d\u2019autres personnes.",
                wc_record_reminder_title: "Cette r\xE9union est en cours d\u2019enregistrement",
                wc_record_reminder_webinar_title: "Ce webinaire est en cours d\u2019enregistrement",
                wc_record_webinar_reminder_desc: "En participant \xe0 ce webinaire, vous consentez \xe0 \xeatre enregistr\xe9.",
                wc_recording_pause: "Suspendre l\u2019enregistrement",
                wc_recording_resume: "Reprendre l\u2019enregistrement",
                wc_recording_stop: "Arr\xEAter l\u2019enregistrement",
                wc_recording_title: "Enregistrer cette r\xe9union?",
                wc_remove: "Supprimer",
                wc_select_camera: "S\xe9lectionner une cam\xe9ra",
                wc_select_microphone: "S\xe9lectionner un micro",
                wc_select_speaker: "S\xe9lectionner un haut-parleur",
                wc_share_muted_while_sharing_audio_tip2: "Votre microphone est d\xe9sactiv\xe9 lors du partage de l'ordinateur audio. Lorsque vous pause ou arr\xeatez de partager audio, votre microphone sera r\xe9activ\xe9.",
                wc_share_pronoun: "Partager",
                wc_share_pronoun_menu: "Partager mes pronoms",
                wc_share_pronoun_tip2: "Voulez-vous partager vos pronoms dans cette r\xe9union\xa0?",
                wc_sharer_controlbar_container_button3_label: "Arr\xeater le partage",
                wc_sharer_controlbar_container_rec_status_tip1: "Vous partagez l\u2019\xE9cran",
                wc_sharer_controlbar_container_rec_status_tip2: "Votre partage d\u2019\xE9cran est en pause",
                wc_sharer_disabled_share1_desc: "L\u2019h\xF4te a d\xE9sactiv\xE9 le partage d\u2019\xE9cran par le participant.",
                wc_sharer_disabled_share2_desc: "Vous ne pouvez pas d\xE9marrer le partage d\u2019\xE9cran pendant qu\u2019un autre participant partage son \xE9cran.",
                wc_sharer_entry_button_label1: "Partager l\u2019\xE9cran",
                wc_sharer_setting_menu_category1_title: "Qui peut partager\xa0?",
                wc_sharer_setting_menu_category2_title: "Qui peut commencer \xE0 partager quand quelqu\u2019un d\u2019autre est en train de partager\xA0?",
                wc_sharer_setting_menu_category3_title: "Combien de participants peuvent partager en m\xeame temps\xa0?",
                wc_sharer_setting_menu_category_option1: "Seulement l\u2019h\xF4te",
                wc_sharer_setting_menu_category_option2: "Tous les participants",
                wc_sharer_setting_menu_item1: "Un participant \xe0 la fois peut partager",
                wc_sharer_setting_menu_item2: "Plusieurs participants peuvent partager simultan\xe9ment",
                wc_sharing_fit_to_window: "Adapter \xe0 la fen\xeatre",
                wc_sharing_original_size: "Format original",
                wc_sharing_shared_screens: "\xc9crans partag\xe9s",
                wc_sharing_view_options: "Options d\u2019affichage",
                wc_sharing_viewing: "Vous visualisez l'\xe9cran {{displayName}}}",
                wc_tel_password: "Code secret",
                wc_unmute_by_host_btn1: "Rester en sourdine",
                wc_unshare_pronoun_menu: "Arr\xeater le partage de mes pronoms",
                "wc_video.allow_panelist_start_video": "Autoriser le pan\xe9liste \xe0 d\xe9marrer la vid\xe9o",
                "wc_video.allow_participants_start_video": "Autoriser les participants \xe0 d\xe9marrer la vid\xe9o",
                "wc_video.ask_start_video": "Demander \xe0 commencer la vid\xe9o",
                "wc_video.model_stop": "Vous ne pouvez pas commencer votre vid\xE9o car l\u2019h\xF4te l\u2019a arr\xEAt\xE9e",
                "wc_video.start_video": "Commencer la vid\xe9o",
                "wc_video.stop_video": "Arr\xeater la vid\xe9o",
                "wc_video.video": "Vid\xe9o",
                wc_view: "Afficher",
                wc_waiting_room: "Salle d\u2019attente",
                "wc_webinar.change_to_attendee": "Changer le r\xf4le au Participant",
                "wc_webinar.promote_to_panelist": "Promouvoir au pan\xe9liste",
                wc_webinar_attendees: "Participants",
                wc_webinar_panelists: "Pan\xe9listes",
                wc_webinar_putonhold: "Mettre en attente",
                wc_withdraw_co_host: "Retirer le privil\xe8ge de co-h\xf4te",
                wc_yes: "Oui",
                websdk_enforce_update_content: "Pour participer \xe0 cette r\xe9union, votre version de l'application doit \xeatre {0} ou une version sup\xe9rieure. Veuillez mettre \xe0 jour pour continuer.",
                websdk_update_content: "Mise \xe0 jour WebSDK \xe0 la derni\xe8re version pour optimiser l'exp\xe9rience de r\xe9union"
              }
            },
            "jp-JP": {
              translation: {
                GOT_IT: "\u4E86\u89E3",
                account_owner: "\u30A2\u30AB\u30A6\u30F3\u30C8 \u30AA\u30FC\u30CA\u30FC",
                allow_to_access: "\u30AB\u30E1\u30E9\u3068\u30DE\u30A4\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059",
                "app_signal.approved_by": "\u306B\u3088\u3063\u3066\u627F\u8A8D\u6E08\u307F",
                "app_signal.hosts_account": "\u30DB\u30B9\u30C8\u306E\u30A2\u30AB\u30A6\u30F3\u30C8",
                "app_signal.people": "\u4EBA",
                "app_signal.tip_text_2": "\u3042\u306A\u305F\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u78BA\u8A8D\u3057\u307E\u3059",
                "app_signal.unable_load2": "\u3042\u306A\u305F\u306E\u60C5\u5831\u306B\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u30A2\u30D7\u30EA\u3092\u30ED\u30FC\u30C9\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002",
                "archiving.chat_1": "\u30C1\u30E3\u30C3\u30C8\uFF08\u516C\u958B\u304A\u3088\u3073\u30C0\u30A4\u30EC\u30AF\u30C8\uFF09",
                "archiving.chat_2": "\u30C1\u30E3\u30C3\u30C8\uFF08\u516C\u958B\u306E\u307F\uFF09",
                "archiving.chat_disable_content": "\u30C1\u30E3\u30C3\u30C8\u3067\u9001\u4FE1\u3055\u308C\u305F\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u30B3\u30F3\u30D7\u30E9\u30A4\u30A2\u30F3\u30B9\u4E0A\u306E\u76EE\u7684\u3067\u30A2\u30FC\u30AB\u30A4\u30D6\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
                "archiving.chat_disable_title": "\u30C1\u30E3\u30C3\u30C8\u304C\u7121\u52B9\u306B\u306A\u308A\u307E\u3057\u305F",
                "archiving.content1_sdk": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E 1 \u4EBA\u4EE5\u4E0A\u306E\u53C2\u52A0\u8005\u304C\u3001\u5F7C\u3089\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30DD\u30EA\u30B7\u30FC\u306B\u57FA\u3065\u304D\u3001\u30A2\u30FC\u30AB\u30A4\u30D6\u306E\u5BFE\u8C61\u3068\u306A\u308A\u307E\u3059\u3002\u5F7C\u3089\u306E {{content}} \u306F\u3001\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u53D7\u3051\u53D6\u308A\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "archiving.content2_sdk": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3078\u306E\u53C2\u52A0\u3092\u7D9A\u884C\u3059\u308B\u3068\u3001\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E {{content}} \u304C\u30A2\u30FC\u30AB\u30A4\u30D6\u3055\u308C\u308B\u3053\u3068\u306B\u540C\u610F\u3057\u305F\u3068\u307F\u306A\u3055\u308C\u307E\u3059\u3002",
                "archiving.default_title": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u30A2\u30FC\u30AB\u30A4\u30D6\u3055\u308C\u307E\u3059",
                "archiving.fail_content_sdk": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E {{features}} \u306F\u3001\u30B3\u30F3\u30D7\u30E9\u30A4\u30A2\u30F3\u30B9\u4E0A\u306E\u76EE\u7684\u3067\u30A2\u30FC\u30AB\u30A4\u30D6\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
                "archiving.fail_title": "\u30A2\u30FC\u30AB\u30A4\u30D6\u304C\u5931\u6557\u3057\u307E\u3057\u305F",
                "archiving.subjects_combo_2_sdk": "{{0}}\u3068{{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}\u3001{{1}}\u3001\u304A\u3088\u3073{{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}\u3001{{1}}\u3001{{2}}\u3001\u304A\u3088\u3073 {{3}}",
                "archiving.tips_1_sdk": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E{{subjects}}\u306F\u3001\u30DB\u30B9\u30C8\u306E\u7D44\u7E54\u306B\u3088\u3063\u3066\u3001\u305D\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30DD\u30EA\u30B7\u30FC\u306B\u57FA\u3065\u304D\u30A2\u30FC\u30AB\u30A4\u30D6\u3055\u308C\u307E\u3059\u3002\u5F7C\u3089\u306E{{receiver}}\u306F\u3001\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u53D7\u3051\u53D6\u308A\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "archiving.tips_2_sdk": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E {{subjects}} \u306F\u3001\u30DB\u30B9\u30C8\u306E\u7D44\u7E54\u306B\u3088\u3063\u3066\u3001\u305D\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30DD\u30EA\u30B7\u30FC\u306B\u57FA\u3065\u304D\u30A2\u30FC\u30AB\u30A4\u30D6\u3055\u308C\u307E\u3059\u3002\u5F7C\u3089\u306E {{receiver}} \u306F\u3001\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u53D7\u3051\u53D6\u308A\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "archiving.transcription": "\u6587\u5B57\u8D77\u3053\u3057",
                "ast.leave_tip": "\u30F3\u30B0\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3059\u308B\u306E\u3092\u505C\u6B62\u3057\u3066\u3044\u307E\u3059\u3002",
                "ast.tip": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306B\u3088\u308A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3055\u308C\u3066\u3044\u307E\u3059",
                background: "\u80CC\u666F",
                chat_message_header: "<0> {{senderName}} </0> <1>\u5B9B\u5148</1> <2> {{receiverName}}",
                chat_new_message: "{{counts}} \u4EF6\u306E\u65B0\u898F\u30E1\u30C3\u30BB\u30FC\u30B8",
                chat_receiver_co_host: "(\u5171\u540C\u30DB\u30B9\u30C8)",
                chat_receiver_host: "(\u30DB\u30B9\u30C8)",
                chat_receiver_panelist: "(\u30D1\u30CD\u30EB\u30EA\u30B9\u30C8)",
                chat_receiver_to: "\u5B9B\u5148:",
                choose_background: "\u80CC\u666F\u3092\u9078\u629E",
                click_address_bar: "\u30A2\u30C9\u30EC\u30B9\u30D0\u30FC\u306E\u5DE6\u5074\u306B\u3042\u308B\u30ED\u30C3\u30AF\u30A2\u30A4\u30B3\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u304C\u30AA\u30D7\u30B7\u30E7\u30F3\u306E\u30EA\u30B9\u30C8\u3092\u6301\u3064\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
                click_microphone_camera_option: "\u30AB\u30E1\u30E9\u3068\u30DE\u30A4\u30AF\u30AA\u30D7\u30B7\u30E7\u30F3\u306E\u53F3\u5074\u306B\u3042\u308B\u30C9\u30ED\u30C3\u30D7\u30C0\u30A6\u30F3\u30EA\u30B9\u30C8\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002",
                "common.cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB",
                "common.connecting": "\u63A5\u7D9A\u4E2D",
                delete: "\u524A\u9664",
                "dialog.btn_cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB",
                "dialog.btn_endconf_webinar": "\u30A6\u30A7\u30D3\u30CA\u30FC\u3092\u7D42\u4E86",
                "dialog.btn_leaveconf_meeting": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u9000\u51FA",
                "dialog.btn_retry": "\u518D\u8A66\u884C",
                "dialog.host_end_meeting": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u30DB\u30B9\u30C8\u306B\u3088\u3063\u3066\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002",
                "dialog.host_end_webinar": "\u3053\u306E\u30A6\u30A7\u30D3\u30CA\u30FC\u306F\u30DB\u30B9\u30C8\u306B\u3088\u3063\u3066\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002",
                "dialog.meeting_ended": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u7D42\u4E86\u3057\u307E\u3057\u305F",
                "dialog.meeting_locked": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u30ED\u30C3\u30AF\u3055\u308C\u307E\u3057\u305F",
                "dialog.meeting_removed_by_host": "\u30DB\u30B9\u30C8\u306B\u3088\u3063\u3066\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
                "dialog.newname": "\u540D\u524D",
                "dialog.ok": "OK",
                "dialog.presscode": "\u4F1A\u8B70ID",
                "dialog.rename": "\u540D\u524D\u306E\u5909\u66F4",
                "dialog.server_error": "\u30B5\u30FC\u30D0\u30FC\u306E\u5185\u90E8\u30A8\u30E9\u30FC\u3067\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u51E6\u7406\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
                "dialog.webinar_ended": "\u30A6\u30A7\u30D3\u30CA\u30FC\u306F\u7D42\u4E86\u3057\u307E\u3057\u305F",
                "dialog.webinar_removed_by_host": "\u30DB\u30B9\u30C8\u306B\u3088\u3063\u3066\u3053\u306E\u30A6\u30A7\u30D3\u30CA\u30FC\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
                "dialog.you_are_removed": "\u524A\u9664\u3055\u308C\u307E\u3057\u305F",
                dialog_make_cohost: "{{displayName}}\u3092\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u5171\u540C\u30DB\u30B9\u30C8\u306B\u3057\u307E\u3059\u304B?",
                dialog_make_host: "\u30DB\u30B9\u30C8\u3092{{displayName}}\u306B\u5909\u66F4\u3057\u307E\u3059\u304B\uFF1F",
                dialog_remove_user: "{{displayName}}\u3092\u524A\u9664\u3057\u307E\u3059\u304B?",
                "disclaimer.LT_button_1": "\u3053\u306E\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8\u306F\u8AB0\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u304B\uFF1F",
                "disclaimer.LT_content_1_1": "\u3053\u306E\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u30AA\u30FC\u30CA\u30FC\u3068\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u53C2\u52A0\u8005\u304C\u4FDD\u5B58\u3057\u3066\u3001\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.LT_content_2": "\u30E9\u30A4\u30D6\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\uFF08\u5B57\u5E55\uFF09\u304C\u6709\u52B9\u306B\u306A\u308A\u307E\u3057\u305F",
                "disclaimer.QA_button_1": "\u8CEA\u554F\u306F\u8AB0\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u304B\uFF1F",
                "disclaimer.QA_content_1_1": "\u30A2\u30AB\u30A6\u30F3\u30C8 \u30AA\u30FC\u30CA\u30FC\u3001\u30DB\u30B9\u30C8\u3001\u30D1\u30CD\u30EA\u30B9\u30C8\u306F\u3042\u306A\u305F\u306E\u540D\u524D\u3001\u9023\u7D61\u5148\u60C5\u5831\uFF08\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u308B\u304B\u3001\u307E\u305F\u306F\u63D0\u4F9B\u3057\u305F\u5834\u5408\uFF09\u304A\u3088\u3073\u8CEA\u554F\u3092\u95B2\u89A7\u3057\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.QA_content_2": "\u8CEA\u554F\u3092\u9078\u629E\u3059\u308B\u3068\u3001\u3059\u3079\u3066\u306E\u51FA\u5E2D\u8005\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
                "disclaimer.QA_content_3_3": "\u533F\u540D\u3067\u63D0\u51FA\u3057\u306A\u3044\u9650\u308A\u3001\u30A2\u30AB\u30A6\u30F3\u30C8 \u30AA\u30FC\u30CA\u30FC\u3001\u30DB\u30B9\u30C8\u3001\u30D1\u30CD\u30EA\u30B9\u30C8\u306F\u3042\u306A\u305F\u306E\u540D\u524D\u3001\u9023\u7D61\u5148\u60C5\u5831\uFF08\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u308B\u304B\u3001\u307E\u305F\u306F\u63D0\u4F9B\u3057\u305F\u5834\u5408\uFF09\u3001\u8CEA\u554F\u306A\u3069\u3092\u95B2\u89A7\u3057\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
                "disclaimer.QA_content_4": "\u3053\u306E Q&A \u306F\u516C\u958B\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u5168\u54E1\u304C\u3042\u306A\u305F\u306E\u8CEA\u554F\u3092\u898B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.QA_content_5": "\u533F\u540D\u3067\u8CEA\u554F\u3092\u9001\u4FE1\u3059\u308B\u3068\u3001\u5168\u54E1\u306B\u306F\u8AB0\u304C\u8CEA\u554F\u3092\u9001\u4FE1\u3057\u305F\u306E\u304B\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002",
                "disclaimer.chat_button_normal": "\u30E1\u30C3\u30BB\u30FC\u30B8\u306F\u8AB0\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u304B\uFF1F",
                "disclaimer.chat_button_onArchiving": "\u30E1\u30C3\u30BB\u30FC\u30B8\u306F\u8AB0\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u304B\uFF1F\u30A2\u30FC\u30AB\u30A4\u30D6\u304C\u6709\u52B9",
                "disclaimer.chat_button_onRecording": "\u30E1\u30C3\u30BB\u30FC\u30B8\u306F\u8AB0\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u304B\uFF1F\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u304C\u6709\u52B9",
                "disclaimer.chat_content_1": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u53C2\u52A0\u8005\u5168\u54E1\u304C\u5168\u54E1\u5B9B\u3066\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u78BA\u8A8D\u3068\u4FDD\u5B58\u304C\u3067\u304D\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.chat_content_2": "\u3042\u306A\u305F\u3068\u30C1\u30E3\u30C3\u30C8\u76F8\u624B\u3060\u3051\u304C\u3001\u30C0\u30A4\u30EC\u30AF\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u4FDD\u5B58\u3057\u3066\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.chat_content_3": "\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u305F\u3081\u3001\u30A2\u30AB\u30A6\u30F3\u30C8 \u30AA\u30FC\u30CA\u30FC\u3068\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u53C2\u52A0\u8005\u5168\u54E1\u304C\u5168\u54E1\u5B9B\u3066\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u78BA\u8A8D\u3068\u4FDD\u5B58\u304C\u3067\u304D\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.chat_content_4": "\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u305F\u3081\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u53C2\u52A0\u8005\u306F\u8AB0\u3067\u3082\u300C\u5168\u54E1\u300D\u5B9B\u3066\u3067\u9001\u4FE1\u3055\u308C\u305F\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u8868\u793A\u3068\u4FDD\u5B58\u304C\u3067\u304D\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.chat_content_5": "\u30A2\u30FC\u30AB\u30A4\u30D6\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u305F\u3081\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u30AA\u30FC\u30CA\u30FC\u306F\u3042\u306A\u305F\u306E\u30C0\u30A4\u30EC\u30AF\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u542B\u3081\u3059\u3079\u3066\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u95B2\u89A7\u3057\u3001\u305D\u308C\u3089\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.chat_content_6": "\u3042\u306A\u305F\u304C\u300C\u5168\u54E1\u300D\u306B\u9001\u4FE1\u3057\u305F\u30E1\u30C3\u30BB\u30FC\u30B8\u306F\u3001\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u3059\u3079\u3066\u306E\u53C2\u52A0\u8005\u304C\u4FDD\u5B58\u304A\u3088\u3073\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                "disclaimer.chat_content_7": "\u30A2\u30FC\u30AB\u30A4\u30D6\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u305F\u3081\u3001\u30A2\u30AB\u30A6\u30F3\u30C8 \u30AA\u30FC\u30CA\u30FC\u306F\u3001\u3042\u306A\u305F\u306E\u30C0\u30A4\u30EC\u30AF\u30C8 \u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u9664\u304F\u3059\u3079\u3066\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u95B2\u89A7\u3057\u3001\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                errorcodes_be_removed: "\u9664\u53BB\u3055\u308C\u308B\u3002",
                errorcodes_denied_email: "\u96FB\u5B50\u30E1\u30FC\u30EB\u306F\u3001\u7BA1\u7406\u8005\u306B\u3088\u3063\u3066\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
                errorcodes_denied_register_with_panelist: "\u62D2\u5426\u3055\u308C\u305F\u30EC\u30B8\u30B9\u30BF\u3092\u4F7F\u7528\u30D1\u30CD\u30EA\u30B9\u30C8\u306E\u30E1\u30FC\u30EB\u3002",
                errorcodes_disconnect: "\u4F1A\u8B70\u306F\u5207\u65AD\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
                errorcodes_email_require: "\u30E1\u30FC\u30EB\u30A6\u30A7\u30D3\u30CA\u30FC\u306B\u51FA\u5E2D\u3059\u308B\u305F\u3081\u306B\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059\u3002",
                errorcodes_fail: "\u4F1A\u8B70\u306B\u53C2\u52A0\u3059\u308B\u305F\u3081\u306B\u5931\u6557\u3057\u307E\u3059\u3002",
                errorcodes_frequent_call: "\u3042\u306A\u305F\u306F\u3053\u306E\u30B3\u30FC\u30EB\u306E\u305F\u3081\u306EAPI\u306E\u4E0A\u9650\u306B\u9054\u3057\u3066\u3044\u307E\u3059\u3002",
                errorcodes_frequent_join: "\u3042\u306A\u305F\u304C\u30BA\u30FC\u30E0\u306B\u3088\u3063\u3066\u5236\u9650\u3059\u308B\u3053\u3068\u3001reCAPTCHA\u306E\u3092\u78BA\u8A8D\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "\u3067\u304D\u307E\u305B\u3093\u304C\u3001\u30D6\u30E9\u30A6\u30B6\u304B\u3089\u53C2\u52A0\u3057\u3001\u30BA\u30FC\u30E0\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3084\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066\u53C2\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                errorcodes_not_exist: "\u4F1A\u8B70\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
                errorcodes_not_host: "\u3042\u306A\u305F\u306F\u4F1A\u8B70\u306E\u30DB\u30B9\u30C8\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
                errorcodes_not_init: "\u4F1A\u8B70\u306E\u521D\u671F\u5316\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
                errorcodes_not_start: "\u4F1A\u8B70\u306F\u958B\u59CB\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "\u30B5\u30FC\u30D3\u30B9\u304C\u4E00\u6642\u7684\u306B\u30AA\u30D5\u30E9\u30A4\u30F3\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002",
                errorcodes_pac_api_disabled: "API\u30AD\u30FC\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u3002",
                errorcodes_pac_api_wrong: "API\u30AD\u30FC\u304C\u6709\u52B9\u3067\u306A\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3002",
                errorcodes_pac_cant_host_other_mn: "\u540C\u6642\u306B\u5225\u306E\u4F1A\u8B70\u3092\u30DB\u30B9\u30C8\u3057\u3066\u3044\u306A\u3044\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
                errorcodes_pac_host_not_found: "\u4F1A\u8B70\u306E\u30DB\u30B9\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
                errorcodes_pac_invalid_signature: "\u7F72\u540D\u306F\u7121\u52B9\u3067\u3059\u3002",
                errorcodes_pac_mn_not_fount: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u756A\u53F7\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
                errorcodes_pac_mn_wrong: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u756A\u53F7\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059\u3002",
                errorcodes_pac_no_permission: "\u5168\u304F\u8A31\u53EF\u3057\u307E\u305B\u3093\u3002",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "\u4E0D\u6B63\u306A\u5F79\u5272\u3002",
                errorcodes_pac_signature_expired: "\u7F72\u540D\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002",
                errorcodes_re_connect: "\u4F1A\u8B70\u304C\u518D\u63A5\u7D9A\u3055\u308C\u307E\u3059\u3002",
                errorcodes_register: "\u3053\u306E\u4F1A\u8B70\u306B\u306F\u767B\u9332\u304C\u5FC5\u8981\u3067\u3059\u3002",
                errorcodes_rwc_empty: "Web\u30B5\u30FC\u30D0\u304B\u3089\u306E\u5FDC\u7B54\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
                errorcodes_rwc_error: "Web\u30B5\u30FC\u30D0\u30FC\u30A8\u30E9\u30FC\u306E\u305F\u3081\u63A5\u7D9A\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "\u6210\u529F\u88CF\u306B\u4F1A\u8B70\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F\u3002",
                errorcodes_tk_expired: "\u30C8\u30FC\u30AF\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002",
                errorcodes_wasm_fail: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9wasm\u30D5\u30A1\u30A4\u30EB\u30A8\u30E9\u30FC\u3001\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3084\u30D5\u30A1\u30A4\u30A2\u30A6\u30A9\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                errorcodes_web_has_in_progress: "\u3059\u3067\u306B\u4ED6\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u304C\u59CB\u307E\u3063\u3066\u3044\u307E\u3059\u3002",
                errorcodes_web_host_not_exit: "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30DB\u30B9\u30C8\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
                errorcodes_web_invalid_id: "\u7121\u52B9\u306A\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0ID\u3067\u3059\u3002",
                errorcodes_web_not_allow_start_webinar_from_web: "\u30A6\u30A7\u30D3\u30CA\u30FC\u3092\u30A6\u30A7\u30D6\u304B\u3089\u958B\u59CB\u3067\u304D\u307E\u305B\u3093\u3002",
                errorcodes_web_not_support_registration_webinar: "\u767B\u9332\u30A6\u30A7\u30D3\u30CA\u30FC\u975E\u5BFE\u5FDC",
                errorcodes_web_not_support_tsp: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30AA\u30FC\u30C7\u30A3\u30AA\u306B\u30C6\u30EC\u30D5\u30A9\u30CB\u30FC\u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0\u3092\u9078\u629E\u3057\u305F\u5834\u5408\u3001\u30A6\u30A7\u30D6\u304B\u3089\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u958B\u59CB\u3057\u305F\u308A\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u53C2\u52A0\u3057\u305F\u308A\u3067\u304D\u307E\u305B\u3093\u3002",
                errorcodes_web_not_support_webclient: "\u30A6\u30A7\u30D6\u304B\u3089\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u958B\u59CB/\u53C2\u52A0\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u307E\u305B\u3093\u3002",
                errorcodes_web_not_support_webinar_pac: "\u30A6\u30A7\u30D3\u30CA\u30FC\u3068\u30D1\u30FC\u30BD\u30CA\u30EB\u97F3\u58F0\u4F1A\u8B70\u304C\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
                errorcodes_web_require_email: "\u30E6\u30FC\u30B6\u30FC\u30E1\u30FC\u30EB\u306F\u5FC5\u8981\u3067\u3059\u3002",
                errorcodes_web_should_support_webinar_with_latest_version: "\u73FE\u5728\u306ESDK\u30D0\u30FC\u30B8\u30E7\u30F3\u306F\u30A6\u30A7\u30D3\u30CA\u30FC\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u6700\u65B0\u30D0\u30FC\u30B8\u30E7\u30F3\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                errorcodes_wrong_pass: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u4F1A\u8B70\u3002",
                gallary_view: "\u30AE\u30E3\u30E9\u30EA\u30FC\u30D3\u30E5\u30FC",
                invalid_parameter: "\u7121\u52B9\u306A\u30D1\u30E9\u30E1\u30FC\u30BF\u30FC",
                "invite.loading": "\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...",
                meeting_disconnected: "\u4F1A\u8B70\u306E\u5207\u65AD",
                meeting_info: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u60C5\u5831",
                meeting_info_network: "{{dc}}\u306E\u30C7\u30FC\u30BF\u30BB\u30F3\u30BF\u30FC\u7D4C\u7531\u3067{{network}}\u306B\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u3059",
                meeting_not_start: "\u305D\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u307E\u3060\u958B\u59CB\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
                meeting_taking: "\u767A\u8A00\u4E2D:",
                meeting_waiting_for_start: "\u4F1A\u8B70\u3092\u958B\u59CB\u3059\u308B\u306E\u3092\u5F85\u3063\u3066\u3044\u307E\u3059",
                meeting_waiting_room: "\u30DB\u30B9\u30C8\u306F\u3082\u3046\u3059\u3050\u3042\u306A\u305F\u3092\u3055\u305B\u307E\u3059",
                minimized_view: "\u6700\u5C0F\u9650\u306E\u30D3\u30E5\u30FC",
                mirror_my_video: "\u30DE\u30A4\u30D3\u30C7\u30AA\u3092\u30DF\u30E9\u30FC\u30EA\u30F3\u30B0",
                "polling.Back": "\u623B\u308B",
                "promote.cancel": "\u51FA\u5E2D\u8005\u3068\u3057\u3066\u3068\u3069\u307E\u308B",
                "promote.content_1": "\u30D1\u30CD\u30EA\u30B9\u30C8\u306F\u3001\u30A6\u30A7\u30D3\u30CA\u30FC\u3067\u81EA\u5206\u304C\u4ED6\u306E\u4EBA\u304B\u3089\u898B\u3048\u308B\u3088\u3046\u306B\u3001\u30DF\u30E5\u30FC\u30C8\u3092\u89E3\u9664\u3057\u3066\u30D3\u30C7\u30AA\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002",
                "promote.content_2": "\u3042\u306A\u305F\u304C\u30DF\u30E5\u30FC\u30C8\u3092\u89E3\u9664\u3057\u305F\u5F8C\u3067\u30DB\u30B9\u30C8\u307E\u305F\u306F\u4ED6\u306E\u30D1\u30CD\u30EA\u30B9\u30C8\u304C\u30A6\u30A7\u30D3\u30CA\u30FC\u306E\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3001\u30E9\u30A4\u30D6\u914D\u4FE1\u3001\u307E\u305F\u306F\u30A2\u30FC\u30AB\u30A4\u30D6\u3092\u884C\u3046\u5834\u5408\u3001\u3042\u306A\u305F\u306E\u53C2\u52A0\u3082\u305D\u308C\u3089\u306B\u542B\u307E\u308C\u307E\u3059\u3002",
                "promote.ok": "\u30D1\u30CD\u30EA\u30B9\u30C8\u3068\u3057\u3066\u53C2\u52A0",
                "promote.title": "\u30DB\u30B9\u30C8\u304C\u3042\u306A\u305F\u3092\u30D1\u30CD\u30EA\u30B9\u30C8\u306B\u6607\u683C\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u307E\u3059",
                ribbon_view: "\u30EA\u30DC\u30F3\u30D3\u30E5\u30FC",
                "rmc.assistant_exist_warning": "\u5225\u306E\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u304D\u307E\u305B\u3093\u3002",
                "rmc.exist_notification_for_client_host": "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u7BA1\u7406\u8005\u306B\u3088\u308A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
                "rmc.not_exist_notification_for_client_host": "\u7BA1\u7406\u8005\u304C\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u505C\u6B62\u3057\u3066\u3044\u307E\u3059\u3002",
                same_as_system: "\u30B7\u30B9\u30C6\u30E0\u3068\u540C\u69D8",
                "security.allow_participants_to": "\u53C2\u52A0\u8005\u306B\u6B21\u3092\u8A31\u53EF\uFF1A",
                "security.button": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3",
                "security.waiting_room": "\u5F85\u6A5F\u5BA4\u3092\u6709\u52B9\u5316",
                select_allow: "\u8A31\u53EF\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u307E\u3059\u3002",
                "settings.audio_tab_text": "\u30AA\u30FC\u30C7\u30A3\u30AA",
                "settings.enable_hd": "HD\u30D3\u30C7\u30AA\u3092\u6709\u52B9\u306B\u3057\u307E\u3059",
                "settings.enable_hd_tip": "\u3059\u3079\u3066\u306E\u53C2\u52A0\u8005\u304C\u3042\u306A\u305F\u306E\u30D3\u30C7\u30AA\u3092\u9AD8\u89E3\u50CF\u5EA6\u3067\u898B\u308B\u3053\u3068\u3092\u53EF\u80FD\u306B\u3057\u307E\u3059[720p\uFF09\u3002\u5B9F\u969B\u306E\u7D50\u679C\u306F\u30DE\u30B7\u30F3\u306E\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9\u3068\u5E2F\u57DF\u5E45\u306B\u3088\u3063\u3066\u7570\u306A\u308A\u307E\u3059\u3002",
                "settings.frame_per_second": "\u30D5\u30EC\u30FC\u30E0/\u79D2",
                "settings.frequency": "\u983B\u5EA6",
                "settings.input_level": "\u5165\u529B\u30EC\u30D9\u30EB:",
                "settings.item_name": "\u30A2\u30A4\u30C6\u30E0\u540D",
                "settings.jitter": "\u30B8\u30C3\u30BF\u30FC",
                "settings.latency": "\u30EC\u30A4\u30C6\u30F3\u30B7",
                "settings.maximum_view": "\u30AE\u30E3\u30E9\u30EA\u30FC \u30D3\u30E5\u30FC\u3067\u753B\u9762\u3042\u305F\u308A\u306B\u8868\u793A\u3059\u308B\u6700\u5927\u306E\u53C2\u52A0\u8005\u6570:",
                "settings.output_level": "\u51FA\u529B\u30EC\u30D9\u30EB:",
                "settings.packet_loss": "\u30D1\u30B1\u30C3\u30C8\u640D\u5931 - \u5E73\u5747\uFF08\u6700\u5927\uFF09",
                "settings.participants25": "25\u53C2\u52A0\u8005",
                "settings.participants9": "9\u53C2\u52A0\u8005",
                "settings.playing": "\u518D\u751F\u4E2D",
                "settings.receive": "\u53D7\u4FE1",
                "settings.receiving_video": "\u30D3\u30C7\u30AA\u3092\u53D7\u4FE1\u3057\u307E\u3059",
                "settings.receiving_video_tips": "\u30B0\u30E9\u30D5\u30A3\u30C3\u30AF\u30B9\u30AB\u30FC\u30C9\u306E\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u30D3\u30C7\u30AA\u30C7\u30B3\u30FC\u30C0\u3092\u4F7F\u7528\u3057\u3066\u3001\u30D3\u30C7\u30AA\u3092\u53D7\u4FE1\u3059\u308B\u305F\u3081\u306ECPU\u4F7F\u7528\u7387\u3092\u4FDD\u5B58\u3057\u307E\u3059\u3002\u3053\u306E\u5909\u66F4\u3092\u6709\u52B9\u306B\u3059\u308B\u305F\u3081\u306B\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                "settings.recording": "\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0",
                "settings.rejoin": "\u3081\u304F\u308B",
                "settings.resolution": "\u89E3\u50CF\u5EA6",
                "settings.send": "\u9001\u4FE1",
                "settings.sending_video": "\u30D3\u30C7\u30AA\u3092\u9001\u4FE1\u3057\u307E\u3059",
                "settings.sending_video_tips": "\u30D3\u30C7\u30AA\u3092\u9001\u4FE1\u3059\u308B\u305F\u3081\u306ECPU\u4F7F\u7528\u7387\u3092\u4FDD\u5B58\u3059\u308B\u306B\u306F\u3001\u30B0\u30E9\u30D5\u30A3\u30C3\u30AF\u30B9\u30AB\u30FC\u30C9\u306E\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u30D3\u30C7\u30AA\u30C7\u30B3\u30FC\u30C0\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u306E\u5909\u66F4\u3092\u6709\u52B9\u306B\u3059\u308B\u305F\u3081\u306B\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                "settings.statistics": "\u7D71\u8A08\u60C5\u5831",
                "settings.stop": "\u505C\u6B62",
                "settings.switch_view_mode_text": "\u3053\u306E\u5909\u66F4\u3092\u9069\u7528\u3059\u308B\u305F\u3081\u306B\u4F1A\u8B70\u306B\u518D\u53C2\u52A0\u3057\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093",
                "settings.test_mic": "\u30DE\u30A4\u30AF\u306E\u30C6\u30B9\u30C8",
                "settings.test_speaker": "\u30B9\u30D4\u30FC\u30AB\u30FC\u306E\u30C6\u30B9\u30C8",
                "settings.unknown_device": "\u672A\u77E5\u306E\u30C7\u30A3\u30D0\u30A4\u30B9",
                "settings.use_hardware_acceleration": "\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u30A2\u30AF\u30BB\u30E9\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                "settings.vb_init_10s_tip2": "\u30D0\u30FC\u30C1\u30E3\u30EB\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u306F\u3001\u4E88\u60F3\u3055\u308C\u308B\u3088\u308A\u3082\u9577\u3044\u6642\u9593\u304C\u304B\u304B\u308A\u307E\u3059\u3002",
                "settings.vb_init_fail2": "\u4EEE\u60F3\u80CC\u666F\u3092\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002",
                "settings.video_tab_text": "\u30D3\u30C7\u30AA",
                speaker_view: "\u30B9\u30D4\u30FC\u30AB\u30FC \u30D3\u30E5\u30FC",
                toolbar_join_audio: "\u97F3\u58F0\u306B\u53C2\u52A0\u3057\u307E\u3059",
                toolbar_leave: "\u9000\u51FA",
                toolbar_mute: "\u30DF\u30E5\u30FC\u30C8",
                toolbar_muteall: "\u5168\u3066\u3092\u30DF\u30E5\u30FC\u30C8",
                toolbar_record: "\u8A18\u9332",
                toolbar_unmute: "\u30DF\u30E5\u30FC\u30C8\u89E3\u9664",
                wait_room_tip1: "{{displayName}}\u304C\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u5F85\u5408\u5BA4\u306B\u5165\u3063\u3066\u3044\u307E\u3059",
                wait_room_tip2: "{{count}}\u540D\u306E\u4EBA\u304C\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u5F85\u5408\u5BA4\u306B\u5165\u3063\u3066\u3044\u307E\u3059",
                "wc.ast_admin_name": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8",
                "wc.rmc_admin_name": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u7BA1\u7406\u8005",
                "wc.rmc_admin_tooltip": "\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u306F\u30DB\u30B9\u30C8 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u6A29\u304C\u3042\u308A\u307E\u3059\u304C\u3001\u3069\u306E\u30E1\u30C7\u30A3\u30A2 \u30B3\u30F3\u30C6\u30F3\u30C4\uFF08\u30AA\u30FC\u30C7\u30A3\u30AA\u3001\u30D3\u30C7\u30AA\u3001\u30C1\u30E3\u30C3\u30C8\u3001\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3\uFF09\u306B\u3064\u3044\u3066\u306F\u30A2\u30AF\u30BB\u30B9\u6A29\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
                wc_3rd_cc_copied_api_token: "API\u30C8\u30FC\u30AF\u30F3\u304C\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3059",
                wc_3rd_cc_copy_api_token: "API\u30C8\u30FC\u30AF\u30F3\u3092\u30B3\u30D4\u30FC",
                wc_3rd_cc_service: "\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306ECC\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B",
                wc_3rd_cc_url_help_tips2: "\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u30B3\u30D4\u30FC\u3057\u3066\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306E\u30AF\u30ED\u30FC\u30BA\u30C9\u30AD\u30E3\u30D7\u30B7\u30E7\u30F3\u30C4\u30FC\u30EB\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3059",
                wc_admit: "\u5165\u5BA4\u3092\u8A31\u53EF\u3059\u308B",
                wc_allow_to_talk: "\u30C8\u30FC\u30AF\u3092\u8A31\u53EF",
                wc_audio: "\u30AA\u30FC\u30C7\u30A3\u30AA",
                "wc_audio.muted_notification1": "\u30DB\u30B9\u30C8\u304C\u3042\u306A\u305F\u3092\u30DF\u30E5\u30FC\u30C8\u306B\u3057\u3066\u3044\u307E\u3059",
                "wc_audio.muted_notification2": "\u30DB\u30B9\u30C8\u304C\u5168\u54E1\u3092\u30DF\u30E5\u30FC\u30C8\u306B\u3057\u3066\u3044\u307E\u3059",
                "wc_audio.unmute_by_host_content_1": "\u30DB\u30B9\u30C8\u304C\u3042\u306A\u305F\u306B\u767A\u8A00\u3092\u6C42\u3081\u3066\u3044\u307E\u3059",
                "wc_audio.unmute_by_host_content_2": "\u30DF\u30E5\u30FC\u30C8\u3092\u89E3\u9664\u3059\u308B\u3068\u3001\u30A6\u30A7\u30D3\u30CA\u30FC\u306B\u53C2\u52A0\u3057\u3066\u3044\u308B\u4ED6\u306E\u4EBA\u3005\u306F\u3042\u306A\u305F\u306E\u58F0\u3092\u805E\u304F\u3053\u3068\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u3042\u306A\u305F\u304C\u30DF\u30E5\u30FC\u30C8\u3092\u89E3\u9664\u3057\u305F\u5F8C\u3067\u30DB\u30B9\u30C8\u307E\u305F\u306F\u30D1\u30CD\u30EA\u30B9\u30C8\u304C\u30A6\u30A7\u30D3\u30CA\u30FC\u306E\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3001\u30E9\u30A4\u30D6\u914D\u4FE1\u3001\u307E\u305F\u306F\u30A2\u30FC\u30AB\u30A4\u30D6\u3092\u884C\u3046\u5834\u5408\u3001\u3042\u306A\u305F\u306E\u58F0\u3082\u305D\u308C\u3089\u306B\u542B\u307E\u308C\u307E\u3059\u3002",
                wc_audio_cannot_unmute: "\u30DB\u30B9\u30C8\u306B\u3088\u308A\u30DF\u30E5\u30FC\u30C8\u306B\u8A2D\u5B9A\u3055\u308C\u305F\u3081\u3001\u30DF\u30E5\u30FC\u30C8\u3092\u81EA\u5206\u3067\u89E3\u9664\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
                wc_audio_connecting_thumbnail: "\u30AA\u30FC\u30C7\u30A3\u30AA\u306B\u63A5\u7D9A\u4E2D\u3067\u3059",
                wc_broadcasting: "\u653E\u9001",
                wc_btn_endconf_meeting_all: "\u5168\u54E1\u306B\u5BFE\u3057\u3066\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u7D42\u4E86",
                wc_camera_prevent: "\u30D6\u30E9\u30A6\u30B6\u304C\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u963B\u6B62\u3057\u3066\u3044\u307E\u3059\u3002\u6709\u52B9\u306B\u3057\u3066\u52D5\u753B\u3092\u518D\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044",
                "wc_cc.placeholder": "\u3053\u3053\u306B\u5165\u529B\u3057\u3066\u30A8\u30F3\u30BF\u30FC\u30AD\u30FC\u3092\u62BC\u3057\u3001\u653E\u9001\u3057\u307E\u3059\u3002",
                wc_cc_assign_participant_to_type: "\u53C2\u52A0\u8005\u3092\u5165\u529B\u306B\u6307\u5B9A\u3057\u307E\u3059\u3002",
                wc_cc_assign_to: "\u5B57\u5E55\u5165\u529B\u306B\u6307\u5B9A\u3057\u307E\u3059\u3002",
                wc_cc_assign_to_type: "\u5165\u529B\u3092\u8AB0\u304B\u306B\u6307\u5B9A\u3057\u307E\u3059\u3002",
                wc_cc_broadcasting_tip: "\u5B57\u5E55\u306F\u3059\u3079\u3066\u306E\u53C2\u52A0\u8005\u306B\u653E\u9001\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
                wc_cc_host_assigned: "\u30DB\u30B9\u30C8\u306F\u3042\u306A\u305F\u3092\u5B57\u5E55\u5165\u529B\u306B\u6307\u5B9A\u3057\u307E\u3057\u305F\u3002",
                wc_cc_type_myself: "\u5165\u529B\u3057\u307E\u3059\u3002",
                wc_cc_withdraw: "\u5B57\u5E55\u8A31\u53EF\u304B\u3089\u9000\u51FA\u3057\u307E\u3059\u3002",
                "wc_chat.attendee_chat_with": "\u51FA\u5E2D\u8005\u30C1\u30E3\u30C3\u30C8\u53EF\u80FD\u5BFE\u8C61:",
                "wc_chat.chat": "\u30C1\u30E3\u30C3\u30C8\u3057\u307E\u3059\u3002",
                "wc_chat.direct_message": "\uFF08\u30C0\u30A4\u30EC\u30AF\u30C8 \u30E1\u30C3\u30BB\u30FC\u30B8\uFF09",
                "wc_chat.disable_chat": "\u30DB\u30B9\u30C8\u304C\u53C2\u52A0\u8005\u30C1\u30E3\u30C3\u30C8\u3092\u7121\u52B9\u306B\u3057\u307E\u3057\u305F\u3002",
                "wc_chat.disabled": "\u306A\u3057",
                "wc_chat.everyone": "\u5168\u54E1",
                "wc_chat.everyone_public": "\u5168\u54E1\u3092\u30D1\u30D6\u30EA\u30C3\u30AF\u304A\u3088\u3073\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306B",
                "wc_chat.everyone_public_private": "\u5168\u54E1\u3092\u30D1\u30D6\u30EA\u30C3\u30AF\u306B",
                "wc_chat.host_only": "\u30DB\u30B9\u30C8\u306E\u307F",
                "wc_chat.host_panelists": "\u30DB\u30B9\u30C8\u3068\u30D1\u30CD\u30EA\u30B9\u30C8",
                "wc_chat.me": "\u81EA\u5206",
                "wc_chat.panelist_chat_with": "\u30C1\u30E3\u30C3\u30C8\u53EF\u80FD\u5BFE\u8C61\uFF08\u30D1\u30CD\u30EA\u30B9\u30C8\uFF09:",
                "wc_chat.type_msg": "\u3053\u3053\u306B\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u3002\u3002",
                wc_closed_caption_btn: "\u5B57\u5E55",
                wc_co_host: "\uFF08\u5171\u540C\u30DB\u30B9\u30C8\uFF09",
                wc_continue: "\u7D9A\u884C",
                wc_copied: "\u30B3\u30D4\u30FC\u6E08\u307F",
                wc_copied_to_clipboard: "\u62DB\u5F85\u30EA\u30F3\u30AF\u304C\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F",
                wc_copy_link: "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
                wc_data_center2: "\u30AA\u30F3\u30D7\u30EC\u30DF\u30B9\u306E\u30C7\u30FC\u30BF\u30BB\u30F3\u30BF\u30FC\u306B\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
                wc_data_center3: "\u30AA\u30F3\u30D7\u30EC\u30DF\u30B9\u306E\u30C7\u30FC\u30BF\u30BB\u30F3\u30BF\u30FC\u3092\u4ECB\u3057\u3066Zoom\u30B0\u30ED\u30FC\u30D0\u30EB\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
                wc_disable_talking: "\u4F1A\u8A71\u3092\u7121\u52B9\u306B\u3059\u308B",
                wc_dlg_confirm: "\u78BA\u8A8D",
                wc_enable: "\u6709\u52B9",
                wc_encryption: "\u6697\u53F7\u5316",
                wc_extra_function_disable_video: "\u30D3\u30C7\u30AA\u53D7\u4FE1\u3092\u7121\u52B9\u306B\u3057\u307E\u3059",
                wc_files: "\u30D5\u30A1\u30A4\u30EB",
                wc_footer_assign_leave: "\u5272\u308A\u5F53\u3066\u3066\u9000\u51FA",
                wc_footer_assign_new_host: "\u65B0\u3057\u3044\u30DB\u30B9\u30C8\u3092\u5272\u308A\u5F53\u3066\u308B",
                wc_guest: "\u30B2\u30B9\u30C8",
                wc_host_1: "\u30DB\u30B9\u30C8",
                wc_in_the_meeting: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u5185",
                wc_invite_link: "\u62DB\u5F85\u30EA\u30F3\u30AF",
                wc_join_media_preview_info_confirm: "\u308F\u304B\u308A\u307E\u3057\u305F",
                wc_join_media_preview_warning_denied_both: "\u30D6\u30E9\u30A6\u30B6\u306E\u30A2\u30C9\u30EC\u30B9\u30D0\u30FC\u3067\u306E\u30AB\u30E1\u30E9\u3068\u30DE\u30A4\u30AF\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                wc_join_media_preview_warning_denied_camera: "\u30D6\u30E9\u30A6\u30B6\u306E\u30A2\u30C9\u30EC\u30B9\u30D0\u30FC\u3067\u306E\u30AB\u30E1\u30E9\u30A2\u30AF\u30BB\u30B9\u3092\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                wc_join_media_preview_warning_denied_mic: "\u30D6\u30E9\u30A6\u30B6\u306E\u30A2\u30C9\u30EC\u30B9\u30D0\u30FC\u3067\u306E\u30DE\u30A4\u30AF\u30A2\u30AF\u30BB\u30B9\u3092\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                wc_joining: "\u63A5\u5408",
                wc_joining_meeting: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u53C2\u52A0\u3057\u3066\u3044\u307E\u3059\u2026",
                wc_learn_more: "\u8A73\u7D30\u60C5\u5831",
                wc_leave_computer_audio: "\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u7D42\u4E86",
                wc_leave_meeting: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u9000\u51FA",
                wc_leave_webinar: "\u30A6\u30A7\u30D3\u30CA\u30FC\u304B\u3089\u9000\u51FA\u3057\u307E\u3059\u3002",
                wc_live_transcription_btn: "\u30E9\u30A4\u30D6\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3",
                wc_lock_meeting: "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u30ED\u30C3\u30AF\u3059\u308B",
                wc_lower_hand: "\u624B\u3092\u4E0B\u3052\u308B",
                wc_lt_disable_transcription: "\u81EA\u52D5\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u3092\u7121\u52B9\u5316",
                wc_lt_enable_transcription: "\u81EA\u52D5\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u3092\u6709\u52B9\u5316",
                wc_lt_item_captioner: "\uFF08\u30AD\u30E3\u30D7\u30B7\u30E7\u30CA\u30FC\uFF09",
                wc_lt_live_transcript: "\u30E9\u30A4\u30D6\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8",
                wc_lt_menu_item1: "\u30B5\u30D6\u30BF\u30A4\u30C8\u30EB\u3092\u8868\u793A",
                wc_lt_menu_item2: "\u30D5\u30EB\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8\u3092\u8868\u793A",
                wc_lt_menu_item3: "\u30B5\u30D6\u30BF\u30A4\u30C8\u30EB\u3092\u975E\u8868\u793A",
                wc_lt_menu_item4: "\u30D5\u30EB\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8\u3092\u9589\u3058\u308B",
                wc_lt_request_host_ctrl: "\u53C2\u52A0\u8005\u306E\u30E9\u30A4\u30D6\u6587\u5B57\u8D77\u3053\u3057\u306E\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u8A31\u53EF\u3059\u308B",
                wc_lt_search_text: "\u691C\u7D22",
                wc_make_co_host: "\u5171\u540C\u30DB\u30B9\u30C8\u306B\u3059\u308B",
                wc_make_host: "\u30DB\u30B9\u30C8\u306B\u3059\u308B\uFF1A",
                wc_me: "(\u81EA\u5206)",
                wc_more: "\u66F4\u306A\u308B\u60C5\u5831",
                wc_no: "\u3044\u3044\u3048",
                wc_none: "\u306A\u3057",
                wc_not_share_pronoun: "\u5171\u6709\u3057\u306A\u3044",
                wc_num_password: "\u6570\u5024\u30D1\u30B9\u30EF\u30FC\u30C9\u96FB\u8A71/\u30EB\u30FC\u30E0\u30B7\u30B9\u30C6\u30E0",
                wc_participant_id: "\u53C2\u52A0\u8005ID",
                wc_participants: "\u53C2\u52A0\u8005",
                wc_pc_audio: "\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30AA\u30FC\u30C7\u30A3\u30AA",
                wc_prevent_access_mic: "\u30D6\u30E9\u30A6\u30B6\u306B\u3088\u308A\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u3067\u304D\u306A\u304F\u306A\u3063\u3066\u3044\u307E\u3059\u3002",
                wc_put_in_waiting: "\u5F85\u6A5F\u5BA4\u306B\u79FB\u3059",
                "wc_qa.allQ": "\u5168\u3066\u306E\u8CEA\u554F",
                "wc_qa.anonymous_attendee": "\u533F\u540D\u51FA\u5E2D\u8005",
                "wc_qa.answer_private_type": "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u56DE\u7B54",
                "wc_qa.answeredQ": "\u56DE\u7B54\u6E08\u307F",
                "wc_qa.attendee_placeholder": "\u30DB\u30B9\u30C8\u3068\u30D1\u30CD\u30EA\u30B9\u30C8\u3078\u306E\u8CEA\u554F\u306F\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
                "wc_qa.button_comment": "\u30B3\u30E1\u30F3\u30C8",
                "wc_qa.button_display_answer": "\u56DE\u7B54\u3092\u5165\u529B",
                "wc_qa.button_live": "\u30E9\u30A4\u30D6\u3067\u56DE\u7B54",
                "wc_qa.button_live_done": "\u5B8C\u4E86",
                "wc_qa.button_reopen": "\u518D\u958B\u3059\u308B",
                "wc_qa.collapse_all_answer": "\u5168\u3066\u6298\u308A\u305F\u305F\u3080",
                "wc_qa.dismissedQ": "\u5374\u4E0B",
                "wc_qa.display_all_answer": "\u5168\u3066\u3092\u8868\u793A",
                "wc_qa.dissmis_tips": "\u5374\u4E0B",
                "wc_qa.input_tips": "\u8CEA\u554F\u3092\u3053\u3053\u306B\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044...",
                "wc_qa.is_anonymous": "\u533F\u540D\u3067\u9001\u4FE1",
                "wc_qa.is_privately": "\u500B\u4EBA\u7684\u306B\u9001\u4FE1",
                "wc_qa.live_tips_done": "\u3053\u306E\u8CEA\u554F\u306F\u30E9\u30A4\u30D6\u3067\u56DE\u7B54\u3055\u308C\u307E\u3057\u305F",
                "wc_qa.live_tips_start": "\u306F\u3053\u306E\u8CEA\u554F\u3092\u30E9\u30A4\u30D6\u3067\u56DE\u7B54\u3059\u308B\u3053\u3068\u3092\u5E0C\u671B\u3057\u3066\u3044\u307E\u3059",
                "wc_qa.most_recent": "\u6700\u3082\u76F4\u8FD1",
                "wc_qa.most_upvotes": "\u6700\u591A\u306E\u8CDB\u6210\u7968",
                "wc_qa.myQ": "\u81EA\u5206\u306E\u8CEA\u554F",
                "wc_qa.no_answered_questions": "\u56DE\u7B54\u6E08\u307F\u306E\u8CEA\u554F\u306F\u3042\u308A\u307E\u305B\u3093",
                "wc_qa.no_dismissed_questions": "\u5374\u4E0B\u3055\u308C\u305F\u8CEA\u554F\u306F\u3042\u308A\u307E\u305B\u3093",
                "wc_qa.no_open_questions": "\u672A\u56DE\u7B54\u306E\u8CEA\u554F\u306F\u3042\u308A\u307E\u305B\u3093",
                "wc_qa.no_questions": "\u8CEA\u554F\u306F\u3042\u308A\u307E\u305B\u3093",
                "wc_qa.openedQ": "\u672A\u56DE\u7B54",
                "wc_qa.panelist_host_only_placeholder": "\u30DB\u30B9\u30C8\u3068\u30D1\u30CD\u30EA\u30B9\u30C8\u306E\u307F\u304C\u8CEA\u554F\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059",
                "wc_qa.panelist_view_all_placehoder": "\u3053\u306E\u30A6\u30A7\u30D3\u30CA\u30FC\u306E\u53C2\u52A0\u8005\u5168\u54E1\u304C\u672A\u56DE\u7B54\u306E\u8CEA\u554F\u3092\u898B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059",
                "wc_qa.qa_comp_title": "Q&A",
                "wc_qa.send": "\u9001\u4FE1",
                "wc_qa.setting_allow_view": "\u51FA\u5E2D\u8005\u306B\u95B2\u89A7\u3092\u8A31\u53EF\u3059\u308B",
                "wc_qa.setting_btn_name": "\u8A2D\u5B9A",
                "wc_qa.setting_option_allow_anony_question": "\u533F\u540D\u3067\u306E\u8CEA\u554F\u3092\u8A31\u53EF\u3059\u308B",
                "wc_qa.setting_option_allow_comment": "\u51FA\u5E2D\u8005\u306F\u30B3\u30E1\u30F3\u30C8\u3067\u304D\u307E\u3059",
                "wc_qa.setting_option_allow_view_all": "\u5168\u3066\u306E\u8CEA\u554F",
                "wc_qa.setting_option_allow_view_answered": "\u56DE\u7B54\u6E08\u307F\u306E\u8CEA\u554F\u306E\u307F",
                "wc_qa.setting_option_allow_vote": "\u51FA\u5E2D\u8005\u306F\u8CDB\u6210\u3067\u304D\u307E\u3059",
                "wc_qa.welcome_banner": "\u30DB\u30B9\u30C8\u3068\u30D1\u30CD\u30EA\u30B9\u30C8\u306B\u6C17\u8EFD\u306B\u8CEA\u554F\u3057\u3066\u304F\u3060\u3055\u3044",
                "wc_qa.welcome_banner_title": "\u3088\u3046\u3053\u305D",
                wc_raise_hand: "\u6319\u624B",
                wc_reclaim_host: "\u30DB\u30B9\u30C8\u3092\u518D\u7533\u8ACB",
                wc_record_host_reminder_desc: "\u7D9A\u884C\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u3059\u3079\u3066\u306E\u9854\u3001\u4F1A\u8A71\u3001\u753B\u9762\u5171\u6709\u304C\u30AF\u30E9\u30A6\u30C9\u306B\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3055\u308C\u307E\u3059\u3002",
                wc_record_reminder_desc: "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u5B58\u5728\u3057\u7D9A\u3051\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u9332\u97F3\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002",
                wc_record_reminder_desc_2: "{{accountOwner}} \u3068\u30DB\u30B9\u30C8\u306F Zoom \u30AF\u30E9\u30A6\u30C9 \u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u8996\u8074\u3067\u304D\u3001\u6A29\u9650\u304C\u4E0E\u3048\u3089\u308C\u3066\u3044\u308B\u53C2\u52A0\u8005\u306F\u8AB0\u3067\u3082\u305D\u306E\u30ED\u30FC\u30AB\u30EB \u30C7\u30D0\u30A4\u30B9\u306B\u8A18\u9332\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u4EBA\u3005\u306F\u3001\u3053\u308C\u3089\u306E\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u30C4\u30FC\u30EB\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
                wc_record_reminder_title: "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306F\u9332\u97F3\u3055\u308C\u3066\u3044\u307E\u3059",
                wc_record_reminder_webinar_title: "\u3053\u306E\u30A6\u30A7\u30D3\u30CA\u30FC\u306F\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3055\u308C\u3066\u3044\u307E\u3059",
                wc_record_webinar_reminder_desc: "\u3053\u306E\u30A6\u30A7\u30D3\u30CA\u30FC\u306B\u53C2\u52A0\u3057\u7D9A\u3051\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002",
                wc_recording_pause: "\u9332\u753B\u3092\u4E00\u6642\u505C\u6B62",
                wc_recording_resume: "\u9332\u753B\u3092\u518D\u958B",
                wc_recording_stop: "\u30EC\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u505C\u6B62",
                wc_recording_title: "\u3053\u306E\u4F1A\u8B70\u3092\u8A18\u9332\u3059\u308B\uFF1F",
                wc_remove: "\u5916\u3059",
                wc_select_camera: "\u30AB\u30E1\u30E9\u3092\u9078\u629E",
                wc_select_microphone: "\u30DE\u30A4\u30AF\u3092\u9078\u629E",
                wc_select_speaker: "\u30B9\u30D4\u30FC\u30AB\u30FC\u3092\u9078\u629E",
                wc_share_muted_while_sharing_audio_tip2: "\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u5171\u6709\u3059\u308B\u3068\u304D\u306B\u30DE\u30A4\u30AF\u30ED\u30D5\u30A9\u30F3\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u30AA\u30FC\u30C7\u30A3\u30AA\u306E\u5171\u6709\u3092\u4E00\u6642\u505C\u6B62\u307E\u305F\u306F\u505C\u6B62\u3059\u308B\u969B\u306B\u306F\u3001\u30DE\u30A4\u30AF\u304C\u518D\u30A2\u30AF\u30C6\u30A3\u30D6\u5316\u3055\u308C\u307E\u3059\u3002",
                wc_share_pronoun: "\u5171\u6709",
                wc_share_pronoun_menu: "\u79C1\u306E\u30D7\u30ED\u30CA\u30A6\u30F3\u3092\u5171\u6709",
                wc_share_pronoun_tip2: "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3067\u4EE3\u540D\u8A5E\u3092\u5171\u6709\u3057\u307E\u3059\u304B\uFF1F",
                wc_sharer_controlbar_container_button3_label: "\u5171\u6709\u306E\u505C\u6B62",
                wc_sharer_controlbar_container_rec_status_tip1: "\u753B\u9762\u3092\u5171\u6709\u3057\u3066\u3044\u307E\u3059",
                wc_sharer_controlbar_container_rec_status_tip2: "\u753B\u9762\u5171\u6709\u306F\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F",
                wc_sharer_disabled_share1_desc: "\u30DB\u30B9\u30C8\u304C\u51FA\u5E2D\u8005\u306E\u753B\u9762\u5171\u6709\u3092\u7121\u52B9\u306B\u3057\u307E\u3057\u305F\u3002",
                wc_sharer_disabled_share2_desc: "\u4ED6\u306E\u53C2\u52A0\u8005\u304C\u5171\u6709\u4E2D\u306F\u3001\u753B\u9762\u5171\u6709\u3092\u958B\u59CB\u3067\u304D\u307E\u305B\u3093\u3002",
                wc_sharer_entry_button_label1: "\u753B\u9762\u3092\u5171\u6709",
                wc_sharer_setting_menu_category1_title: "\u5171\u6709\u3067\u304D\u308B\u306E\u306F\u8AB0\u3067\u3059\u304B\uFF1F",
                wc_sharer_setting_menu_category2_title: "\u4ED6\u306E\u4EBA\u304C\u5171\u6709\u3057\u3066\u3044\u308B\u5834\u5408\u306B\u5171\u6709\u3092\u958B\u59CB\u3067\u304D\u308B\u306E\u306F\u8AB0\u3067\u3059\u304B\uFF1F",
                wc_sharer_setting_menu_category3_title: "\u540C\u6642\u306B\u5171\u6709\u3067\u304D\u308B\u53C2\u52A0\u8005\u306F\u4F55\u540D\u3067\u3059\u304B\uFF1F",
                wc_sharer_setting_menu_category_option1: "\u30DB\u30B9\u30C8\u306E\u307F",
                wc_sharer_setting_menu_category_option2: "\u5168\u53C2\u52A0\u8005",
                wc_sharer_setting_menu_item1: "\u540C\u6642\u306B1\u540D\u306E\u53C2\u52A0\u8005\u304C\u5171\u6709\u53EF\u80FD\u3067\u3059",
                wc_sharer_setting_menu_item2: "\u8907\u6570\u306E\u53C2\u52A0\u8005\u304C\u540C\u6642\u306B\u5171\u6709\u53EF\u80FD\u3067\u3059",
                wc_sharing_fit_to_window: "\u30A6\u30A3\u30F3\u30C9\u30A6\u81EA\u52D5\u8ABF\u6574",
                wc_sharing_original_size: "\u5143\u306E\u30B5\u30A4\u30BA",
                wc_sharing_shared_screens: "\u5171\u6709\u753B\u9762",
                wc_sharing_view_options: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8868\u793A",
                wc_sharing_viewing: "\u3042\u306A\u305F\u306F{{displayName}}\u306E\u753B\u9762\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059",
                wc_tel_password: "\u30D1\u30B9\u30B3\u30FC\u30C9",
                wc_unmute_by_host_btn1: "\u30DF\u30E5\u30FC\u30C8\u306E\u307E\u307E\u306B\u3059\u308B",
                wc_unshare_pronoun_menu: "\u79C1\u306E\u30D7\u30ED\u30CA\u30A6\u30F3\u306E\u5171\u6709\u3092\u89E3\u9664",
                "wc_video.allow_panelist_start_video": "\u30D1\u30CD\u30EA\u30B9\u30C8\u304C\u30D3\u30C7\u30AA\u3092\u958B\u59CB\u3059\u308B\u3053\u3068\u3092\u8A31\u53EF\u3059\u308B",
                "wc_video.allow_participants_start_video": "\u53C2\u52A0\u8005\u306B\u30D3\u30C7\u30AA\u306E\u958B\u59CB\u3092\u8A31\u53EF",
                "wc_video.ask_start_video": "\u30D3\u30C7\u30AA\u306E\u958B\u59CB\u65B9\u6CD5\u3092\u8CEA\u554F\u3059\u308B",
                "wc_video.model_stop": "\u30DB\u30B9\u30C8\u304C\u505C\u6B62\u3057\u305F\u305F\u3081\u3001\u30D3\u30C7\u30AA\u3092\u958B\u59CB\u3067\u304D\u307E\u305B\u3093",
                "wc_video.start_video": "\u30D3\u30C7\u30AA\u3092\u958B\u59CB\u3059\u308B",
                "wc_video.stop_video": "\u30D3\u30C7\u30AA\u3092\u505C\u6B62\u3059\u308B",
                "wc_video.video": "\u30D3\u30C7\u30AA",
                wc_view: "\u8868\u793A",
                wc_waiting_room: "\u5F85\u5408\u5BA4",
                "wc_webinar.change_to_attendee": "\u51FA\u5E2D\u8005\u306B\u5BFE\u3059\u308B\u5F79\u5272\u3092\u5909\u66F4\u3057\u307E\u3059\u3002",
                "wc_webinar.promote_to_panelist": "\u30D1\u30CD\u30EA\u30B9\u30C8\u306B\u6607\u9032",
                wc_webinar_attendees: "\u53C2\u52A0\u8005",
                wc_webinar_panelists: "\u30D1\u30CD\u30EA\u30B9\u30C8",
                wc_webinar_putonhold: "\u4FDD\u7559\u306B\u3059\u308B",
                wc_withdraw_co_host: "\u5171\u540C\u30DB\u30B9\u30C8\u6A29\u9650\u306E\u53D6\u308A\u4E0B\u3052",
                wc_yes: "\u306F\u3044",
                websdk_enforce_update_content: "\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u53C2\u52A0\u3059\u308B\u306B\u306F\u3001{0}\u4EE5\u964D\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u306E\u30A2\u30D7\u30EA\u304C\u5FC5\u8981\u3067\u3059\u3002\u7D9A\u884C\u3059\u308B\u306B\u306F\u66F4\u65B0\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002",
                websdk_update_content: "\u6700\u9069\u5316\u4F1A\u8B70\u306E\u7D4C\u9A13\u3092\u6700\u65B0\u30D0\u30FC\u30B8\u30E7\u30F3\u306B\u66F4\u65B0\u3057WebSDK"
              }
            },
            "pt-PT": {
              translation: {
                GOT_IT: "Entendi",
                account_owner: "propriet\xe1rio da conta",
                allow_to_access: "Permitir acesso sua c\xe2mera e microfone",
                "app_signal.approved_by": "Aprovado por",
                "app_signal.hosts_account": "Conta do anfitri\xe3o",
                "app_signal.people": "pessoas",
                "app_signal.tip_text_2": "Veja aplicativos que acessam o conte\xfado da sua reuni\xe3o",
                "app_signal.unable_load2": "N\xe3o \xe9 poss\xedvel carregar aplicativos com acesso em tempo real \xe0s suas informa\xe7\xf5es.",
                "archiving.chat_1": "chat (p\xfablico e direto)",
                "archiving.chat_2": "chat (apenas p\xfablico)",
                "archiving.chat_disable_content": "As mensagens enviadas no chat n\xe3o puderam ser arquivadas para fins de conformidade.",
                "archiving.chat_disable_title": "O chat foi desativado",
                "archiving.content1_sdk": "Um ou mais participantes desta reuni\xe3o est\xe3o sujeitos a arquivamento com base na pol\xedtica de conta deles. O {{content}} receber\xe1 conte\xfado desta reuni\xe3o e poder\xe1 compartilh\xe1-lo com aplicativos e terceiros.",
                "archiving.content2_sdk": "Ao permanecer nesta reuni\xe3o, voc\xea concorda que o {{content}} dela seja arquivado.",
                "archiving.default_title": "Esta reuni\xe3o est\xe1 sendo arquivada",
                "archiving.fail_content_sdk": "O {{features}} desta reuni\xe3o deve ser arquivado para fins de conformidade.",
                "archiving.fail_title": "O arquivamento falhou",
                "archiving.subjects_combo_2_sdk": "{{0}} e {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} e {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} e {{3}}",
                "archiving.tips_1_sdk": "O {{subjects}} desta reuni\xe3o est\xe1 sendo arquivado pela organiza\xe7\xe3o do anfitri\xe3o com base na pol\xedtica de sua conta. O {{receiver}} receber\xe1 conte\xfado desta reuni\xe3o e poder\xe1 compartilh\xe1-lo com aplicativos e terceiros.",
                "archiving.tips_2_sdk": "Os {{subjects}} desta reuni\xe3o est\xe3o sendo arquivados pela organiza\xe7\xe3o do anfitri\xe3o com base na pol\xedtica de sua conta. O {{receiver}} receber\xe1 conte\xfado desta reuni\xe3o e poder\xe1 compartilh\xe1-lo com aplicativos e terceiros.",
                "archiving.transcription": "transcri\xe7\xe3o",
                "ast.leave_tip": "O assistente interrompeu o controle da reuni\xe3o.",
                "ast.tip": "Esta reuni\xe3o est\xe1 sendo controlada por um assistente",
                background: "Plano de fundo",
                chat_message_header: "<0> {{sendererName}} </0> <1> para </1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}} nova mensagem",
                chat_receiver_co_host: "(Coanfitri\xe3o)",
                chat_receiver_host: "(Anfitri\xe3o)",
                chat_receiver_panelist: "(Palestrante)",
                chat_receiver_to: "At\xe9:",
                choose_background: "Escolher plano de fundo",
                click_address_bar: "Clique no \xedcone de bloqueio \xe0 esquerda da barra de endere\xe7os. Um pop-up aparecer\xe1 com uma lista de op\xe7\xf5es.",
                click_microphone_camera_option: "Clique na lista suspensa \xe0 direita da op\xe7\xe3o C\xe2mera e Microfone.",
                "common.cancel": "Cancelar",
                "common.connecting": "Ligar",
                delete: "Excluir",
                "dialog.btn_cancel": "Cancelar",
                "dialog.btn_endconf_webinar": "Encerrar webinar",
                "dialog.btn_leaveconf_meeting": "Sair da reuni\xe3o",
                "dialog.btn_retry": "Tentar novamente",
                "dialog.host_end_meeting": "Esta reuni\xe3o foi encerrada pelo anfitri\xe3o.",
                "dialog.host_end_webinar": "Este webinar foi encerrado pelo anfitri\xe3o.",
                "dialog.meeting_ended": "A reuni\xe3o foi encerrada",
                "dialog.meeting_locked": "A reuni\xe3o foi bloqueada",
                "dialog.meeting_removed_by_host": "Voc\xea foi removido desta reuni\xe3o pelo anfitri\xe3o.",
                "dialog.newname": "Nome",
                "dialog.ok": "OK",
                "dialog.presscode": "ID da Reuni\xe3o",
                "dialog.rename": "Renomear",
                "dialog.server_error": "O servidor encontrou um erro interno e n\xe3o conseguiu processar sua solicita\xe7\xe3o.",
                "dialog.webinar_ended": "O webinar foi encerrado",
                "dialog.webinar_removed_by_host": "Voc\xea foi removido deste webinar pelo anfitri\xe3o.",
                "dialog.you_are_removed": "Voc\xea foi removido",
                dialog_make_cohost: "Voc\xea deseja tornar {{displayName}}o coanfitri\xe3o desta reuni\xe3o?",
                dialog_make_host: "Deseja alterar o anfitri\xe3o para {{displayName}}?",
                dialog_remove_user: "Deseja remover {{displayName}}?",
                "disclaimer.LT_button_1": "Quem pode ver esta transcri\xe7\xe3o?",
                "disclaimer.LT_content_1_1": "O propriet\xe1rio da conta e todos na reuni\xe3o podem salvar esta transcri\xe7\xe3o e compartilhar com aplicativos e outros.",
                "disclaimer.LT_content_2": "A transcri\xe7\xe3o ao vivo (legenda oculta) foi habilitada",
                "disclaimer.QA_button_1": "Quem pode ver as suas d\xfavidas?",
                "disclaimer.QA_content_1_1": "O propriet\xe1rio da conta, o anfitri\xe3o e os palestrantes poder\xe3o ver quem voc\xea \xe9, suas informa\xe7\xf5es de contato (se voc\xea tiver feito login ou fornecido essas informa\xe7\xf5es) e sua pergunta, al\xe9m de poderem compartilh\xe1-las com aplicativos e terceiros.",
                "disclaimer.QA_content_2": "Se sua pergunta for selecionada, ela ficar\xe1 vis\xedvel para todos os participantes.",
                "disclaimer.QA_content_3_3": "A menos que voc\xea envie anonimamente, o propriet\xe1rio da conta, o anfitri\xe3o e os palestrantes poder\xe3o ver quem voc\xea \xe9, suas informa\xe7\xf5es de contato (se voc\xea tiver feito login ou fornecido essas informa\xe7\xf5es) e sua pergunta, al\xe9m de poderem compartilh\xe1-las com aplicativos e terceiros.",
                "disclaimer.QA_content_4": "Estas perguntas e respostas s\xe3o p\xfablicas, para que todos possam ver suas d\xfavidas.",
                "disclaimer.QA_content_5": "Se voc\xea enviar suas d\xfavidas anonimamente, ningu\xe9m poder\xe1 ver quem as enviou.",
                "disclaimer.chat_button_normal": "Quem pode ver as suas mensagens?",
                "disclaimer.chat_button_onArchiving": "Quem pode ver as suas mensagens? Arquivamento ativado",
                "disclaimer.chat_button_onRecording": "Quem pode ver as suas mensagens? Grava\xe7\xe3o ativada",
                "disclaimer.chat_content_1": "Todos na reuni\xe3o podem ver e salvar suas mensagens com Todos, al\xe9m de poderem compartilh\xe1-las com aplicativos e terceiros.",
                "disclaimer.chat_content_2": "Apenas voc\xea e aqueles com quem voc\xea conversa podem salvar suas mensagens diretas e compartilh\xe1-las com aplicativos e terceiros.",
                "disclaimer.chat_content_3": "A grava\xe7\xe3o est\xe1 ativada para que o propriet\xe1rio da conta e todos na reuni\xe3o possam ver e salvar mensagens enviadas para Todos, al\xe9m de poderem compartilh\xe1-las com aplicativos e terceiros.",
                "disclaimer.chat_content_4": "A grava\xe7\xe3o est\xe1 ativada para que todos na reuni\xe3o possam ver e salvar mensagens enviadas para Todos, al\xe9m de poderem compartilh\xe1-las com aplicativos e terceiros.",
                "disclaimer.chat_content_5": "O arquivamento est\xe1 ativado, de forma que o propriet\xe1rio da conta pode ver todas as suas mensagens - incluindo as mensagens diretas - e compartilh\xe1-las com aplicativos e outros.",
                "disclaimer.chat_content_6": "Todos na reuni\xe3o podem salvar e compartilhar as mensagens que voc\xea envia para Todos.",
                "disclaimer.chat_content_7": "O arquivamento est\xe1 ativado, de forma que o propriet\xe1rio da conta pode ver todas as suas mensagens (n\xe3o incluindo suas mensagens diretas) e compartilh\xe1-las com aplicativos e terceiros.",
                errorcodes_be_removed: "Ser removido.",
                errorcodes_denied_email: "E-mail \xe9 bloqueado pelo administrador.",
                errorcodes_denied_register_with_panelist: "utiliza\xe7\xe3o registro negado email painelista.",
                errorcodes_disconnect: "Reuni\xe3o foi desconectado.",
                errorcodes_email_require: "Email est\xe1 faltando para participar webinar.",
                errorcodes_fail: "Deixar de participar da reuni\xe3o.",
                errorcodes_frequent_call: "Voc\xea alcan\xe7ou o limite de API para esta chamada.",
                errorcodes_frequent_join: "Voc\xea ser limite por zoom, precisa verificar recaptcha.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Incapaz juntar-se a partir do navegador, por favor, junte-se usando o cliente de desktop Zoom ou aplicativo m\xf3vel.",
                errorcodes_not_exist: "O encontro n\xe3o existe.",
                errorcodes_not_host: "Voc\xea n\xe3o \xe9 o anfitri\xe3o da reuni\xe3o.",
                errorcodes_not_init: "Reuni\xe3o n\xe3o inicializado.",
                errorcodes_not_start: "Reuni\xe3o ainda n\xe3o come\xe7ou",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "O servi\xe7o est\xe1 temporariamente offline.",
                errorcodes_pac_api_disabled: "As contas API Key \xe9 desativado.",
                errorcodes_pac_api_wrong: "As contas API Key n\xe3o \xe9 v\xe1lido.",
                errorcodes_pac_cant_host_other_mn: "n\xe3o pode n\xe3o hospedar outra reuni\xe3o simultaneamente.",
                errorcodes_pac_host_not_found: "O anfitri\xe3o da reuni\xe3o n\xe3o foi encontrado.",
                errorcodes_pac_invalid_signature: "Assinatura \xe9 inv\xe1lida.",
                errorcodes_pac_mn_not_fount: "O n\xfamero reuni\xe3o n\xe3o foi encontrado.",
                errorcodes_pac_mn_wrong: "O n\xfamero reuni\xe3o est\xe1 errado.",
                errorcodes_pac_no_permission: "Sem permiss\xe3o.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "papel incorreto.",
                errorcodes_pac_signature_expired: "A assinatura expirou.",
                errorcodes_re_connect: "Reuni\xe3o \xe9 voltar a ligar.",
                errorcodes_register: "Esta reuni\xe3o requer registo.",
                errorcodes_rwc_empty: "N\xe3o foi poss\xedvel obter uma resposta do servidor web.",
                errorcodes_rwc_error: "N\xe3o foi poss\xedvel conectar ao erro Web Server.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "juntou-se com sucesso a reuni\xe3o.",
                errorcodes_tk_expired: "Token expirou.",
                errorcodes_wasm_fail: "Baixar arquivos WASM erro, por favor, verifique a sua rede e firewall.",
                errorcodes_web_has_in_progress: "J\xe1 h\xe1 outras reuni\xf5es em andamento.",
                errorcodes_web_host_not_exit: "O anfitri\xe3o da reuni\xe3o n\xe3o existe.",
                errorcodes_web_invalid_id: "ID da reuni\xe3o inv\xe1lido.",
                errorcodes_web_not_allow_start_webinar_from_web: "N\xe3o \xe9 permitido iniciar o webinar na web.",
                errorcodes_web_not_support_registration_webinar: "O registro do webinar n\xe3o \xe9 compat\xedvel",
                errorcodes_web_not_support_tsp: "N\xe3o \xe9 compat\xedvel iniciar ou ingressar na reuni\xe3o pela web ao escolher o \xe1udio do provedor de servi\xe7os de telefonia em uma reuni\xe3o.",
                errorcodes_web_not_support_webclient: "N\xe3o h\xe1 suporte para iniciar ou entrar na reuni\xe3o pela web.",
                errorcodes_web_not_support_webinar_pac: "N\xe3o h\xe1 suporte para webinar e audioconfer\xeancia pessoal",
                errorcodes_web_require_email: "O e-mail do usu\xe1rio \xe9 obrigat\xf3rio.",
                errorcodes_web_should_support_webinar_with_latest_version: "A vers\xe3o sdk atual n\xe3o oferece suporte para webinar. Atualize para a vers\xe3o mais recente.",
                errorcodes_wrong_pass: "Reuni\xe3o senha errada.",
                gallary_view: "Exibi\xe7\xe3o da Galeria",
                invalid_parameter: "Par\xe2metro inv\xe1lido",
                "invite.loading": "Carregando...",
                meeting_disconnected: "Disconnected reuni\xe3o",
                meeting_info: "Informa\xe7\xf5es da Reuni\xe3o",
                meeting_info_network: "Voc\xea est\xe1 conectado a {{Network}} via data centers em {{dc}}",
                meeting_not_start: "A reuni\xe3o ainda n\xe3o come\xe7ou",
                meeting_taking: "falando:",
                meeting_waiting_for_start: "Esperando pela reuni\xe3o para come\xe7ar",
                meeting_waiting_room: "O anfitri\xe3o ir\xe1 deix\xe1-lo em breve",
                minimized_view: "Vista minimizada",
                mirror_my_video: "Espelhar meu v\xeddeo",
                "polling.Back": "Voltar",
                "promote.cancel": "Ficar como participante",
                "promote.content_1": "Como palestrante, voc\xea pode ativar sons e iniciar o v\xeddeo, o que significa que voc\xea ficar\xe1 vis\xedvel para outras pessoas no webinar.",
                "promote.content_2": "Se o anfitri\xe3o ou outros palestrantes decidirem gravar, transmitir ao vivo ou arquivar o webinar depois de ativar o som, sua participa\xe7\xe3o ser\xe1 inclu\xedda.",
                "promote.ok": "Ingressar como palestrante",
                "promote.title": "O anfitri\xe3o gostaria de promov\xea-lo a palestrante",
                ribbon_view: "Vista da fita",
                "rmc.assistant_exist_warning": "Voc\xea n\xe3o pode controlar a reuni\xe3o porque outro Assistente est\xe1 controlando esta reuni\xe3o.",
                "rmc.exist_notification_for_client_host": "Esta reuni\xe3o est\xe1 sendo controlada por um administrador.",
                "rmc.not_exist_notification_for_client_host": "O administrador interrompeu o controle da reuni\xe3o.",
                same_as_system: "O Mesmo que o Sistema",
                "security.allow_participants_to": "Permitir que os participantes:",
                "security.button": "Seguran\xe7a",
                "security.waiting_room": "Habilitar sala de espera",
                select_allow: "Selecione a op\xe7\xe3o Permitir.",
                "settings.audio_tab_text": "\xc1udio",
                "settings.enable_hd": "Ativar v\xeddeo HD.",
                "settings.enable_hd_tip": "Ativar todos os participantes para visualizar seu v\xeddeo em alta resolu\xe7\xe3o (720P). Observe que o resultado real depende do desempenho da m\xe1quina e da largura de banda.",
                "settings.frame_per_second": "Frames Por Segundo",
                "settings.frequency": "Frequ\xeancia",
                "settings.input_level": "N\xedvel de entrada:",
                "settings.item_name": "Nome do item",
                "settings.jitter": "Jitter",
                "settings.latency": "Lat\xeancia",
                "settings.maximum_view": "M\xe1ximo de participantes exibidos por tela na exibi\xe7\xe3o da galeria:",
                "settings.output_level": "N\xedvel de sa\xedda:",
                "settings.packet_loss": "Perda de pacotes - M\xe9d(Max)",
                "settings.participants25": "25 participantes",
                "settings.participants9": "9 participantes",
                "settings.playing": "Reproduzindo",
                "settings.receive": "Receber",
                "settings.receiving_video": "Recebendo v\xeddeo",
                "settings.receiving_video_tips": "Use o decodificador de v\xeddeo de hardware da placa gr\xe1fica para salvar o uso da CPU para receber v\xeddeos. Atualize a p\xe1gina para que essa altera\xe7\xe3o entra em vigor.",
                "settings.recording": "Grava\xe7\xe3o",
                "settings.rejoin": "Reinger.",
                "settings.resolution": "Resolu\xe7\xe3o",
                "settings.send": "Enviar",
                "settings.sending_video": "Enviando V\xeddeo.",
                "settings.sending_video_tips": "Use o decodificador de v\xeddeo de hardware da placa gr\xe1fica para salvar o uso da CPU para enviar v\xeddeo. Atualize a p\xe1gina para que essa altera\xe7\xe3o entra em vigor.",
                "settings.statistics": "Estat\xedsticas",
                "settings.stop": "Interromper",
                "settings.switch_view_mode_text": "Voc\xea deve se juntar \xe0 reuni\xe3o para aplicar essa mudan\xe7a",
                "settings.test_mic": "Testar Microfone",
                "settings.test_speaker": "Testar Alto-Falante",
                "settings.unknown_device": "Dispositivo desconhecido",
                "settings.use_hardware_acceleration": "Use acelera\xe7\xe3o de hardware para:",
                "settings.vb_init_10s_tip2": "O fundo virtual est\xe1 demorado ao esperado para carregar.",
                "settings.vb_init_fail2": "N\xe3o \xe9 poss\xedvel carregar o fundo virtual.",
                "settings.video_tab_text": "V\xeddeo",
                speaker_view: "Exibi\xe7\xe3o de Orador",
                toolbar_join_audio: "Incluir \xe1udio",
                toolbar_leave: "Sair",
                toolbar_mute: "Desativar som",
                toolbar_muteall: "Desativar som de todos",
                toolbar_record: "Gravar",
                toolbar_unmute: "Ativar som",
                wait_room_tip1: "{{displayName}} entrou na sala de espera para esta reuni\xe3o",
                wait_room_tip2: "{{count}} pessoas entraram na sala de espera para esta reuni\xe3o",
                "wc.ast_admin_name": "Assistente de reuni\xe3o",
                "wc.rmc_admin_name": "Administrador de controle da reuni\xe3o",
                "wc.rmc_admin_tooltip": "Este usu\xe1rio tem controles de anfitri\xe3o e n\xe3o tem acesso a conte\xfado de m\xeddia (\xe1udio, v\xeddeo, chat e rea\xe7\xf5es).",
                wc_3rd_cc_copied_api_token: "Token de API copiado para a \xe1rea de transfer\xeancia",
                wc_3rd_cc_copy_api_token: "Copiar o token de API",
                wc_3rd_cc_service: "Usar um servi\xe7o CC de terceiros",
                wc_3rd_cc_url_help_tips2: "Copie este token e cole-o em uma ferramenta de legenda oculta de terceiros",
                wc_admit: "Admitir",
                wc_allow_to_talk: "Permitir falar",
                wc_audio: "\xc1udio",
                "wc_audio.muted_notification1": "O anfitri\xe3o desativou o seu som",
                "wc_audio.muted_notification2": "O anfitri\xe3o desativou o som de todos",
                "wc_audio.unmute_by_host_content_1": "O anfitri\xe3o gostaria que voc\xea falasse",
                "wc_audio.unmute_by_host_content_2": "Se voc\xea optar por ativar o som, outras pessoas no webinar poder\xe3o ouvi-lo. Se o anfitri\xe3o ou os palestrantes decidirem gravar, transmitir ao vivo ou arquivar o webinar depois de ativar o som, sua voz ser\xe1 inclu\xedda.",
                wc_audio_cannot_unmute: "Voc\xea n\xe3o pode ativar seu som porque o anfitri\xe3o o desativou.",
                wc_audio_connecting_thumbnail: "Conectando ao \xe1udio",
                wc_broadcasting: "Radiodifus\xe3o",
                wc_btn_endconf_meeting_all: "Encerrar a reuni\xe3o para todos",
                wc_camera_prevent: "Seu navegador est\xe1 impedindo o acesso \xe0 sua c\xe2mera. Habilite-a e reinicie seu v\xeddeo",
                "wc_cc.placeholder": "Digite aqui, pressione Enter para transmitir",
                wc_cc_assign_participant_to_type: "Atribuir participante para digitar",
                wc_cc_assign_to: "Atribuir digita\xe7\xe3o de Closed Caption",
                wc_cc_assign_to_type: "Atribuir algu\xe9m para digitar",
                wc_cc_broadcasting_tip: "O Closed Caption est\xe1 sendo transmitido para todos participantes.",
                wc_cc_host_assigned: "O anfitri\xe3o atribuiu a voc\xea a digita\xe7\xe3o do Closed Caption",
                wc_cc_type_myself: "Vou digitar",
                wc_cc_withdraw: "Retirar permiss\xe3o de Closed Caption",
                "wc_chat.attendee_chat_with": "Os participantes podem conversar com:",
                "wc_chat.chat": "Bate-papo",
                "wc_chat.direct_message": "(Mensagem direta)",
                "wc_chat.disable_chat": "O anfitri\xe3o desativou o bate-papo do participante.",
                "wc_chat.disabled": "Nenhum",
                "wc_chat.everyone": "Todos",
                "wc_chat.everyone_public": "Todos em modo p\xfablico",
                "wc_chat.everyone_public_private": "Todos em modo p\xfablico e privado",
                "wc_chat.host_only": "Apenas anfitri\xe3o",
                "wc_chat.host_panelists": "Anfitri\xf5es e palestrantes",
                "wc_chat.me": "Eu",
                "wc_chat.panelist_chat_with": "Os palestrantes podem bater papo com:",
                "wc_chat.type_msg": "Digite a mensagem aqui...",
                wc_closed_caption_btn: "Closed Caption",
                wc_co_host: "(Coanfitri\xe3o)",
                wc_continue: "Continuar",
                wc_copied: "Copiado",
                wc_copied_to_clipboard: "O link do convite foi copiado para a \xe1rea de transfer\xeancia",
                wc_copy_link: "Copiar link",
                wc_data_center2: "Voc\xea est\xe1 conectado a um data center local.",
                wc_data_center3: "Voc\xea est\xe1 conectado \xe0 rede global do Zoom por meio de um data center local.",
                wc_disable_talking: "Desabilitar fala",
                wc_dlg_confirm: "Confirma\xe7\xe3o",
                wc_enable: "Habilitado",
                wc_encryption: "Criptografia",
                wc_extra_function_disable_video: "recep\xe7\xe3o v\xeddeo Disable",
                wc_files: "Arquivos",
                wc_footer_assign_leave: "Atribuir e sair",
                wc_footer_assign_new_host: "Atribuir um novo anfitri\xe3o",
                wc_guest: "Convidado",
                wc_host_1: "Anfitri\xe3o",
                wc_in_the_meeting: "Na reuni\xe3o",
                wc_invite_link: "Link do convite",
                wc_join_media_preview_info_confirm: "Entendi",
                wc_join_media_preview_warning_denied_both: "Habilite o acesso \xe0 c\xe2mera e ao microfone na barra de endere\xe7o do seu navegador.",
                wc_join_media_preview_warning_denied_camera: "Ative o acesso \xe0 c\xe2mera na barra de endere\xe7o do seu navegador.",
                wc_join_media_preview_warning_denied_mic: "Ative o acesso ao microfone na barra de endere\xe7os do seu navegador.",
                wc_joining: "juntando",
                wc_joining_meeting: "Entrando na reuni\xe3o...",
                wc_learn_more: "Saiba mais",
                wc_leave_computer_audio: "Sair do \xe1udio do computador",
                wc_leave_meeting: "Sair da reuni\xe3o",
                wc_leave_webinar: "Sair do webinar",
                wc_live_transcription_btn: "Transcri\xe7\xe3o ao vivo",
                wc_lock_meeting: "Bloquear reuni\xe3o",
                wc_lower_hand: "Abaixar M\xe3o",
                wc_lt_disable_transcription: "Desabilitar transcri\xe7\xe3o autom\xe1tica",
                wc_lt_enable_transcription: "Habilitar transcri\xe7\xe3o autom\xe1tica",
                wc_lt_item_captioner: "(Legendador)",
                wc_lt_live_transcript: "Transcri\xe7\xe3o ao vivo",
                wc_lt_menu_item1: "Mostrar legenda",
                wc_lt_menu_item2: "Visualizar transcri\xe7\xe3o total",
                wc_lt_menu_item3: "Ocultar legenda",
                wc_lt_menu_item4: "Fechar transcri\xe7\xe3o total",
                wc_lt_request_host_ctrl: "Permitir que os participantes solicitem transcri\xe7\xe3o ao vivo",
                wc_lt_search_text: "Pesquisar",
                wc_make_co_host: "Tornar coanfitri\xe3o",
                wc_make_host: "Tornar anfitri\xe3o",
                wc_me: "(Eu)",
                wc_more: "Mais",
                wc_no: "N\xe3o",
                wc_none: "Nenhum",
                wc_not_share_pronoun: "N\xe3o compartilhar",
                wc_num_password: "Num\xe9rico senha Telefone / sistemas de salas",
                wc_participant_id: "ID do participante",
                wc_participants: "Participantes",
                wc_pc_audio: "\xc1udio do Computador",
                wc_prevent_access_mic: "Seu navegador est\xe1 evitando acesso ao microfone.",
                wc_put_in_waiting: "Colocar na sala de espera",
                "wc_qa.allQ": "Todas as perguntas",
                "wc_qa.anonymous_attendee": "Participante an\xf4nimo",
                "wc_qa.answer_private_type": "Resposta privada",
                "wc_qa.answeredQ": "Respondida",
                "wc_qa.attendee_placeholder": "As perguntas que voc\xea faz para o anfitri\xe3o e os palestrantes ser\xe3o mostradas aqui.",
                "wc_qa.button_comment": "Comentar",
                "wc_qa.button_display_answer": "Digitar resposta",
                "wc_qa.button_live": "Responder ao vivo",
                "wc_qa.button_live_done": "Conclu\xeddo",
                "wc_qa.button_reopen": "Abrir novamente",
                "wc_qa.collapse_all_answer": "Fechar todas",
                "wc_qa.dismissedQ": "Descartada",
                "wc_qa.display_all_answer": "Exibir todos",
                "wc_qa.dissmis_tips": "Descartar",
                "wc_qa.input_tips": "Digite sua pergunta aqui...",
                "wc_qa.is_anonymous": "Enviar anonimamente",
                "wc_qa.is_privately": "Enviar reservadamente",
                "wc_qa.live_tips_done": "Esta pergunta foi respondida ao vivo",
                "wc_qa.live_tips_start": "gostaria de responder a esta pergunta ao vivo",
                "wc_qa.most_recent": "Mais recente",
                "wc_qa.most_upvotes": "Mais votos a favor",
                "wc_qa.myQ": "Minhas perguntas",
                "wc_qa.no_answered_questions": "Sem perguntas respondidas",
                "wc_qa.no_dismissed_questions": "Sem perguntas descartadas",
                "wc_qa.no_open_questions": "Sem perguntas abertas",
                "wc_qa.no_questions": "Sem perguntas",
                "wc_qa.openedQ": "Abrir",
                "wc_qa.panelist_host_only_placeholder": "Somente anfitri\xf5es e palestrantes podem ver as perguntas",
                "wc_qa.panelist_view_all_placehoder": "Todos neste webinar podem ver as perguntas abertas",
                "wc_qa.qa_comp_title": "Q&A",
                "wc_qa.send": "Enviar",
                "wc_qa.setting_allow_view": "Permitir que participantes visualizem",
                "wc_qa.setting_btn_name": "Defini\xe7\xf5es",
                "wc_qa.setting_option_allow_anony_question": "Permitir perguntas an\xf4nimas",
                "wc_qa.setting_option_allow_comment": "Participantes podem comentar",
                "wc_qa.setting_option_allow_view_all": "Todas as perguntas",
                "wc_qa.setting_option_allow_view_answered": "Apenas perguntas respondidas",
                "wc_qa.setting_option_allow_vote": "Participantes podem curtir",
                "wc_qa.welcome_banner": "Fique \xe0 vontade para fazer perguntas ao anfitri\xe3o e aos palestrantes",
                "wc_qa.welcome_banner_title": "Bem-vindo!",
                wc_raise_hand: "Levantar a m\xe3o",
                wc_reclaim_host: "Recuperar anfitri\xe3o",
                wc_record_host_reminder_desc: "Ao continuar, todos os rostos, conversas e compartilhamentos de tela ser\xe3o gravados na nuvem.",
                wc_record_reminder_desc: "Ao continuar participando da reuni\xe3o, voc\xea d\xe1 permiss\xe3o para ser gravado.",
                wc_record_reminder_desc_2: "O {{accountOwner}} e o anfitri\xe3o podem assistir \xe0s grava\xe7\xf5es na nuvem do Zoom e qualquer participante com permiss\xe3o pode gravar em seu dispositivo local. Esses indiv\xedduos podem compartilhar essas grava\xe7\xf5es com aplicativos e terceiros.",
                wc_record_reminder_title: "Esta reuni\xe3o est\xe1 sendo gravada",
                wc_record_reminder_webinar_title: "Este webinar est\xe1 sendo gravado",
                wc_record_webinar_reminder_desc: "Ao continuar participando do webinar, voc\xea d\xe1 permiss\xe3o para ser gravado.",
                wc_recording_pause: "Pausar grava\xe7\xe3o",
                wc_recording_resume: "Retomar grava\xe7\xe3o",
                wc_recording_stop: "Parar grava\xe7\xe3o",
                wc_recording_title: "Registre esta reuni\xe3o?",
                wc_remove: "Remover",
                wc_select_camera: "Selecionar uma c\xe2mera",
                wc_select_microphone: "Selecione um microfone",
                wc_select_speaker: "Selecionar um alto-falante",
                wc_share_muted_while_sharing_audio_tip2: "Seu microfone est\xe1 desativado ao compartilhar o \xe1udio do computador. Quando voc\xea pausar ou parar de compartilhar \xe1udio, seu microfone ser\xe1 reativado.",
                wc_share_pronoun: "Compartilhar",
                wc_share_pronoun_menu: "Compartilhar meus pronomes",
                wc_share_pronoun_tip2: "Voc\xea gostaria de compartilhar seus pronomes nesta reuni\xe3o?",
                wc_sharer_controlbar_container_button3_label: "Interromper compartilhamento",
                wc_sharer_controlbar_container_rec_status_tip1: "Voc\xea est\xe1 compartilhando a tela",
                wc_sharer_controlbar_container_rec_status_tip2: "Seu compartilhamento de tela est\xe1 pausado",
                wc_sharer_disabled_share1_desc: "O anfitri\xe3o desabilitou o compartilhamento de tela do participante.",
                wc_sharer_disabled_share2_desc: "Voc\xea n\xe3o pode iniciar o compartilhamento de tela enquanto outro participante estiver compartilhando.",
                wc_sharer_entry_button_label1: "Compartilhar tela",
                wc_sharer_setting_menu_category1_title: "Quem pode compartilhar?",
                wc_sharer_setting_menu_category2_title: "Quem pode come\xe7ar a compartilhar quando algu\xe9m est\xe1 compartilhando?",
                wc_sharer_setting_menu_category3_title: "Quantos participantes podem compartilhar ao mesmo tempo?",
                wc_sharer_setting_menu_category_option1: "Somente anfitri\xe3o",
                wc_sharer_setting_menu_category_option2: "Todos os participantes",
                wc_sharer_setting_menu_item1: "Somente um participante pode compartilhar por vez",
                wc_sharer_setting_menu_item2: "V\xe1rios participantes podem compartilhar simultaneamente",
                wc_sharing_fit_to_window: "Ajuste de janela",
                wc_sharing_original_size: "Tamanho original",
                wc_sharing_shared_screens: "Telas compartilhadas",
                wc_sharing_view_options: "Visualizar Op\xe7\xf5es",
                wc_sharing_viewing: "Voc\xea est\xe1 visualizando a tela {{display}} 's",
                wc_tel_password: "Senha",
                wc_unmute_by_host_btn1: "Permanecer desativado",
                wc_unshare_pronoun_menu: "Cancelar o compartilhamento de meus pronomes",
                "wc_video.allow_panelist_start_video": "Permitir que o palestrante inicie um v\xeddeo",
                "wc_video.allow_participants_start_video": "Permitir que participantes iniciem o v\xeddeo",
                "wc_video.ask_start_video": "Pedir para iniciar v\xeddeo",
                "wc_video.model_stop": "N\xe3o foi poss\xedvel iniciar v\xeddeo porque o host o encerrou",
                "wc_video.start_video": "Iniciar v\xeddeo",
                "wc_video.stop_video": "Parar v\xeddeo",
                "wc_video.video": "V\xeddeo",
                wc_view: "Visualizar",
                wc_waiting_room: "Sala de espera",
                "wc_webinar.change_to_attendee": "Alterar fun\xe7\xe3o do participante",
                "wc_webinar.promote_to_panelist": "Promover a palestrante",
                wc_webinar_attendees: "Participantes",
                wc_webinar_panelists: "Palestrantes",
                wc_webinar_putonhold: "Colocar em espera",
                wc_withdraw_co_host: "Retirar permiss\xe3o de coanfitri\xe3o",
                wc_yes: "Sim",
                websdk_enforce_update_content: "A vers\xe3o do seu aplicativo deve ser {0} ou superior para ingressar nesta reuni\xe3o. Atualize para continuar.",
                websdk_update_content: "Atualiza\xe7\xe3o WebSDK para a vers\xe3o mais recente a experi\xeancia de reuni\xe3o otimizar"
              }
            },
            "ru-RU": {
              translation: {
                GOT_IT: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E",
                account_owner: "\u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438",
                allow_to_access: "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u0439 \u043A\u0430\u043C\u0435\u0440\u0435 \u0438 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443",
                "app_signal.approved_by": "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043E:",
                "app_signal.hosts_account": "\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430",
                "app_signal.people": "\u0447\u0435\u043B.",
                "app_signal.tip_text_2": "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F, \u0443 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u0430\u043D\u043D\u044B\u043C \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                "app_signal.unable_load2": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0441 \u0434\u043E\u0441\u0442\u0443\u043F\u043E\u043C \u043A \u0432\u0430\u0448\u0438\u043C \u0434\u0430\u043D\u043D\u044B\u043C \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438.",
                "archiving.chat_1": "\u0447\u0430\u0442 (\u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0438 \u043B\u0438\u0447\u043D\u044B\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F)",
                "archiving.chat_2": "\u0447\u0430\u0442 (\u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439)",
                "archiving.chat_disable_content": "\u0412 \u0446\u0435\u043B\u044F\u0445 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0437\u0430\u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432 \u0447\u0430\u0442\u0435.",
                "archiving.chat_disable_title": "\u0427\u0430\u0442 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D",
                "archiving.content1_sdk": "\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043E\u0434\u0438\u043D \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043F\u043E\u0434\u043B\u0435\u0436\u0430\u0442 \u0430\u0440\u0445\u0438\u0432\u0430\u0446\u0438\u0438. {{content}} \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u0438 \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "archiving.content2_sdk": "\u041E\u0441\u0442\u0430\u0432\u0430\u044F\u0441\u044C \u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438, \u0432\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0432 \u0430\u0440\u0445\u0438\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438: {{content}}.",
                "archiving.default_title": "\u0418\u0434\u0435\u0442 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                "archiving.fail_content_sdk": "\u0412 \u0446\u0435\u043B\u044F\u0445 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 {{features}}.",
                "archiving.fail_title": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
                "archiving.subjects_combo_2_sdk": "{{0}} \u0438 {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} \u0438 {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} \u0438 {{3}}",
                "archiving.tips_1_sdk": "\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438: {{subjects}}. {{receiver}} \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0437\u0430\u043F\u0438\u0441\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u0438 \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u044D\u0442\u0438\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "archiving.tips_2_sdk": "\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438: {{subjects}}. {{receiver}} \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0437\u0430\u043F\u0438\u0441\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u0438 \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u044D\u0442\u0438\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "archiving.transcription": "\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430",
                "ast.leave_tip": "\u041F\u043E\u043C\u043E\u0449\u043D\u0438\u043A \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u043B \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0435\u0439.",
                "ast.tip": "\u042D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0435\u0439 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u043F\u043E\u043C\u043E\u0449\u043D\u0438\u043A",
                background: "\u0424\u043E\u043D",
                chat_message_header: "<0> {{sendererName}} </0> <1> \u043D\u0430 </1> <2> {{receiverName}}} </2>",
                chat_new_message: "{{counts}} \u043D\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
                chat_receiver_co_host: "(\u0421\u043E\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440)",
                chat_receiver_host: "(\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440)",
                chat_receiver_panelist: "(\u0427\u043B\u0435\u043D \u0433\u0440\u0443\u043F\u043F\u044B)",
                chat_receiver_to: "\u0414\u043E:",
                choose_background: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u043E\u043D",
                click_address_bar: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438 \u0441\u043B\u0435\u0432\u0430 \u043E\u0442 \u0432\u0430\u0448\u0435\u0439 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0438. \u0412\u0441\u043F\u043B\u0435\u043D\u043E\u043A \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0441\u043E \u0441\u043F\u0438\u0441\u043A\u043E\u043C \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432.",
                click_microphone_camera_option: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0440\u0430\u0441\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0438\u0439\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A \u0441\u043F\u0440\u0430\u0432\u0430 \u043E\u0442 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u043A\u0430\u043C\u0435\u0440\u044B \u0438 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0430.",
                "common.cancel": "\u041E\u0442\u043C\u0435\u043D\u0430",
                "common.connecting": "C\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439",
                delete: "\u0443\u0434\u0430\u043B\u044F\u0442\u044C",
                "dialog.btn_cancel": "\u041E\u0442\u043C\u0435\u043D\u0430",
                "dialog.btn_endconf_webinar": "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440",
                "dialog.btn_leaveconf_meeting": "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                "dialog.btn_retry": "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
                "dialog.host_end_meeting": "\u042D\u0442\u043E \u0441\u043E\u0432\u0435\u0449\u0430\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u043C.",
                "dialog.host_end_webinar": "\u042D\u0442\u043E\u0442 \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u043C.",
                "dialog.meeting_ended": "\u0421\u043E\u0432\u0435\u0449\u0430\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
                "dialog.meeting_locked": "\u0421\u043E\u0432\u0435\u0449\u0430\u043D\u0438\u0435 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430",
                "dialog.meeting_removed_by_host": "\u0412\u044B \u0431\u044B\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438\u0437 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u043C.",
                "dialog.newname": "\u0418\u043C\u044F",
                "dialog.ok": "OK",
                "dialog.presscode": "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                "dialog.rename": "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C",
                "dialog.server_error": "\u041D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u0432\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0448\u0438\u0431\u043A\u0430, \u0438 \u043E\u043D \u043D\u0435 \u0432 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441.",
                "dialog.webinar_ended": "\u0412\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D",
                "dialog.webinar_removed_by_host": "\u0412\u044B \u0431\u044B\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u043C.",
                "dialog.you_are_removed": "\u0412\u044B \u0431\u044B\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u044B",
                dialog_make_cohost: "\u0425\u043E\u0442\u0438\u0442\u0435 \u043B\u0438 \u0432\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C {{displayName}}\u0441\u043E\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u043C \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438?",
                dialog_make_host: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430 \u043D\u0430 {{displayName}}?",
                dialog_remove_user: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C {{displayName}}?",
                "disclaimer.LT_button_1": "\u041A\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0432\u0438\u0434\u0435\u0442\u044C \u044D\u0442\u0443 \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0443?",
                "disclaimer.LT_content_1_1": "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438 \u0432\u0441\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043C\u043E\u0433\u0443\u0442 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u044D\u0442\u0443 \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0443 \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0435\u0439 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.LT_content_2": "\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438 (\u0441\u0443\u0431\u0442\u0438\u0442\u0440\u044B \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E) \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
                "disclaimer.QA_button_1": "\u041A\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B?",
                "disclaimer.QA_content_1_1": "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0438 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0433\u0440\u0443\u043F\u043F\u044B \u0443\u0432\u0438\u0434\u044F\u0442, \u043A\u0442\u043E \u0432\u044B, \u0443\u0432\u0438\u0434\u044F\u0442 \u0432\u0430\u0448\u0443 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E (\u0435\u0441\u043B\u0438 \u0432\u044B \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u043B\u0438 \u0432\u0445\u043E\u0434 \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435) \u0438 \u0432\u0430\u0448 \u0432\u043E\u043F\u0440\u043E\u0441, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u044D\u0442\u0438\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.QA_content_2": "\u0415\u0441\u043B\u0438 \u0432\u0430\u0448 \u0432\u043E\u043F\u0440\u043E\u0441 \u0432\u044B\u0431\u0440\u0430\u043D, \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u0432\u0438\u0434\u0435\u043D \u0432\u0441\u0435\u043C \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C.",
                "disclaimer.QA_content_3_3": "\u0415\u0441\u043B\u0438 \u0432\u043E\u043F\u0440\u043E\u0441 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0435 \u0430\u043D\u043E\u043D\u0438\u043C\u043D\u043E, \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0438 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0433\u0440\u0443\u043F\u043F\u044B \u0443\u0432\u0438\u0434\u044F\u0442, \u043A\u0442\u043E \u0432\u044B, \u0443\u0432\u0438\u0434\u044F\u0442 \u0432\u0430\u0448\u0443 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E (\u0435\u0441\u043B\u0438 \u0432\u044B \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u043B\u0438 \u0432\u0445\u043E\u0434 \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435) \u0438 \u0432\u0430\u0448 \u0432\u043E\u043F\u0440\u043E\u0441, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u044D\u0442\u0438\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.QA_content_4": "\u0420\u0430\u0437\u0434\u0435\u043B \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0438 \u043E\u0442\u0432\u0435\u0442\u043E\u0432 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u043C, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0431\u0443\u0434\u0443\u0442 \u0432\u0438\u0434\u043D\u044B \u0432\u0441\u0435\u043C.",
                "disclaimer.QA_content_5": "\u0415\u0441\u043B\u0438 \u0432\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0430\u043D\u043E\u043D\u0438\u043C\u043D\u043E, \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0431\u0443\u0434\u0435\u0442 \u043D\u0435 \u0432\u0438\u0434\u043D\u043E, \u043A\u0442\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B \u044D\u0442\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B.",
                "disclaimer.chat_button_normal": "\u041A\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0430\u0448\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F?",
                "disclaimer.chat_button_onArchiving": "\u041A\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0430\u0448\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F? \u0410\u0440\u0445\u0438\u0432\u0430\u0446\u0438\u044F \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
                "disclaimer.chat_button_onRecording": "\u041A\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0430\u0448\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F? \u0417\u0430\u043F\u0438\u0441\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
                "disclaimer.chat_content_1": "\u0412\u0441\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u0430\u043C\u0438 \u0432\u0441\u0435\u043C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C, \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.chat_content_2": "\u041F\u0440\u0438 \u043E\u0431\u043C\u0435\u043D\u0435 \u043B\u0438\u0447\u043D\u044B\u043C\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u043C\u0438 \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B \u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C, \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u043E\u043D\u0438 \u0430\u0434\u0440\u0435\u0441\u043E\u0432\u0430\u043D\u044B, \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u0438\u0445 \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.chat_content_3": "\u0417\u0430\u043F\u0438\u0441\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438 \u0432\u0441\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u0441\u0435\u043C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C, \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.chat_content_4": "\u0417\u0430\u043F\u0438\u0441\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0432\u0441\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u0441\u0435\u043C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C, \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.chat_content_5": "\u0410\u0440\u0445\u0438\u0432\u0430\u0446\u0438\u044F \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F (\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043B\u0438\u0447\u043D\u044B\u0435) \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                "disclaimer.chat_content_6": "\u0412\u0441\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043C\u043E\u0433\u0443\u0442 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u0430\u043C\u0438 \u0432\u0441\u0435\u043C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C, \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438.",
                "disclaimer.chat_content_7": "\u0410\u0440\u0445\u0438\u0432\u0430\u0446\u0438\u044F \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043A\u0440\u043E\u043C\u0435 \u043B\u0438\u0447\u043D\u044B\u0445, \u0438 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                errorcodes_be_removed: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C.",
                errorcodes_denied_email: "Email \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C.",
                errorcodes_denied_register_with_panelist: "\u041E\u0442\u043A\u0430\u0437\u0430\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A \u0434\u0438\u0441\u043A\u0443\u0441\u0441\u0438\u0438 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435.",
                errorcodes_disconnect: "\u0412\u0441\u0442\u0440\u0435\u0447\u0430 \u0431\u044B\u043B\u0430 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0430.",
                errorcodes_email_require: "E-mail \u043D\u0435 \u0445\u0432\u0430\u0442\u0430\u0435\u0442 \u0434\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u0435.",
                errorcodes_fail: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u0432\u0441\u0442\u0440\u0435\u0447\u0435.",
                errorcodes_frequent_call: "\u0412\u044B \u0434\u043E\u0441\u0442\u0438\u0433\u043B\u0438 \u043B\u0438\u043C\u0438\u0442\u0430 API \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0432\u044B\u0437\u043E\u0432\u0430.",
                errorcodes_frequent_join: "\u0412\u044B \u0431\u044B \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435 \u043D\u0430 \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u0435, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C ReCaptcha.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u0438\u0437 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u0438\u043B\u0438 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435.",
                errorcodes_not_exist: "\u0412\u0441\u0442\u0440\u0435\u0447\u0430 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442.",
                errorcodes_not_host: "\u0412\u044B \u043D\u0435 \u0445\u043E\u0437\u044F\u0438\u043D \u0432\u0441\u0442\u0440\u0435\u0447\u0438.",
                errorcodes_not_init: "\u0412\u0441\u0442\u0440\u0435\u0447\u0430 \u043D\u0435 \u0438\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D.",
                errorcodes_not_start: "\u0412\u0441\u0442\u0440\u0435\u0447\u0430 \u043D\u0435 \u043D\u0430\u0447\u0430\u043B\u0430\u0441\u044C",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442.",
                errorcodes_pac_api_disabled: "\u0421\u0447\u0435\u0442\u0430 API Key \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0443\u0435\u0442\u0441\u044F.",
                errorcodes_pac_api_wrong: "\u0421\u0447\u0435\u0442\u0430 API \u043A\u043B\u044E\u0447 \u043D\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D.",
                errorcodes_pac_cant_host_other_mn: "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0435 \u043F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u0435\u0449\u0435 \u043E\u0434\u043D\u0443 \u0432\u0441\u0442\u0440\u0435\u0447\u0443 \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E.",
                errorcodes_pac_host_not_found: "\u0425\u043E\u0437\u044F\u0438\u043D \u0432\u0441\u0442\u0440\u0435\u0447\u0438 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D.",
                errorcodes_pac_invalid_signature: "\u041F\u043E\u0434\u043F\u0438\u0441\u044C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439.",
                errorcodes_pac_mn_not_fount: "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D.",
                errorcodes_pac_mn_wrong: "\u041D\u043E\u043C\u0435\u0440 \u0432\u0441\u0442\u0440\u0435\u0447\u0430 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E.",
                errorcodes_pac_no_permission: "\u041D\u0435\u0442 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0430\u044F \u0440\u043E\u043B\u044C.",
                errorcodes_pac_signature_expired: "\u041F\u043E\u0434\u043F\u0438\u0441\u0438 \u0438\u0441\u0442\u0435\u043A\u043B\u0438.",
                errorcodes_re_connect: "\u0421\u043E\u0432\u0435\u0449\u0430\u043D\u0438\u0435 \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F.",
                errorcodes_register: "\u042D\u0442\u0430 \u0432\u0441\u0442\u0440\u0435\u0447\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438.",
                errorcodes_rwc_empty: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043E\u0442\u0432\u0435\u0442 \u043E\u0442 \u0432\u0435\u0431-\u0441\u0435\u0440\u0432\u0435\u0440\u0430.",
                errorcodes_rwc_error: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u043E\u0448\u0438\u0431\u043A\u0435 \u0432\u0435\u0431-\u0441\u0435\u0440\u0432\u0435\u0440\u0430.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F \u043A \u0432\u0441\u0442\u0440\u0435\u0447\u0435.",
                errorcodes_tk_expired: "\u0422\u043E\u043A\u0435\u043D \u0438\u0441\u0442\u0435\u043A.",
                errorcodes_wasm_fail: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C wasm \u0444\u0430\u0439\u043B\u044B \u043E\u0448\u0438\u0431\u043A\u0430, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u0435\u0442\u044C \u0438 \u0431\u0440\u0430\u043D\u0434\u043C\u0430\u0443\u044D\u0440.",
                errorcodes_web_has_in_progress: "\u0423\u0436\u0435 \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044F\u0445.",
                errorcodes_web_host_not_exit: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442.",
                errorcodes_web_invalid_id: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438.",
                errorcodes_web_not_allow_start_webinar_from_web: "\u0417\u0430\u043F\u0443\u0441\u043A \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440\u0430 \u0447\u0435\u0440\u0435\u0437 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D.",
                errorcodes_web_not_support_registration_webinar: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0430 \u0432\u0435\u0431\u0438\u043D\u0430\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F",
                errorcodes_web_not_support_tsp: "\u0415\u0441\u043B\u0438 \u0434\u043B\u044F \u0430\u0443\u0434\u0438\u043E\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A \u0441\u043B\u0443\u0436\u0431\u044B \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0438, \u0442\u0430\u043A\u0443\u044E \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0447\u0430\u0442\u044C \u0438\u043B\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u043D\u0435\u0439 \u0447\u0435\u0440\u0435\u0437 \u0431\u0440\u0430\u0443\u0437\u0435\u0440.",
                errorcodes_web_not_support_webclient: "\u0417\u0430\u043F\u0443\u0441\u043A \u0438\u043B\u0438 \u0432\u0445\u043E\u0434 \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0442\u044C \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F.",
                errorcodes_web_not_support_webinar_pac: "\u041D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440 \u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0430\u0443\u0434\u0438\u043E\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E",
                errorcodes_web_require_email: "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0447\u0442\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.",
                errorcodes_web_should_support_webinar_with_latest_version: "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u043F\u0430\u043A\u0435\u0442\u0430 SDK \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u044B. \u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0439 \u0432\u0435\u0440\u0441\u0438\u0438.",
                errorcodes_wrong_pass: "\u0412\u0441\u0442\u0440\u0435\u0447\u0430 \u043F\u0430\u0440\u043E\u043B\u044C \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E.",
                gallary_view: "\u0412\u0438\u0434 \u0433\u0430\u043B\u0435\u0440\u0435\u0438",
                invalid_parameter: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440",
                "invite.loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
                meeting_disconnected: "\u0412\u0441\u0442\u0440\u0435\u0447\u0430 Disconnected",
                meeting_info: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                meeting_info_network: "\u0412\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043A {{Network}} \u0447\u0435\u0440\u0435\u0437 \u0446\u0435\u043D\u0442\u0440\u044B \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 {{dc}}}",
                meeting_not_start: "\u0421\u043E\u0432\u0435\u0449\u0430\u043D\u0438\u0435 \u0435\u0449\u0435 \u043D\u0435 \u043D\u0430\u0447\u0430\u043B\u0430\u0441\u044C",
                meeting_taking: "\u0433\u043E\u0432\u043E\u0440\u0438\u0442:",
                meeting_waiting_for_start: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0432\u0441\u0442\u0440\u0435\u0447\u0438, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C",
                meeting_waiting_room: "\u0425\u043E\u0437\u044F\u0438\u043D \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0432\u0430\u043C \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F",
                minimized_view: "\u041C\u0438\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
                mirror_my_video: "\u041E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u043C\u043E\u0435 \u0432\u0438\u0434\u0435\u043E \u0437\u0435\u0440\u043A\u0430\u043B\u044C\u043D\u043E",
                "polling.Back": "\u041D\u0430\u0437\u0430\u0434",
                "promote.cancel": "\u041E\u0441\u0442\u0430\u0442\u044C\u0441\u044F \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E",
                "promote.content_1": "\u0412 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430 \u0433\u0440\u0443\u043F\u043F\u044B \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u0437\u0432\u0443\u043A \u0438 \u0437\u0430\u043F\u0443\u0441\u043A\u0430\u0442\u044C \u0432\u0438\u0434\u0435\u043E. \u042D\u0442\u043E \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u0430 \u0443\u0432\u0438\u0434\u044F\u0442 \u0432\u0430\u0441.",
                "promote.content_2": "\u0415\u0441\u043B\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0433\u0440\u0443\u043F\u043F\u044B \u0440\u0435\u0448\u0430\u0442 \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432\u0435\u0431\u0438\u043D\u0430\u0440, \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0435\u0433\u043E \u043F\u0440\u044F\u043C\u0443\u044E \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044E \u0438\u043B\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0432 \u0430\u0440\u0445\u0438\u0432 \u043F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u0432\u044B \u0432\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u0437\u0432\u0443\u043A, \u0432\u0430\u0448\u0435 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u043E.",
                "promote.ok": "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430 \u0433\u0440\u0443\u043F\u043F\u044B",
                "promote.title": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0445\u043E\u0447\u0435\u0442 \u043F\u043E\u0432\u044B\u0441\u0438\u0442\u044C \u0432\u0430\u0448\u0443 \u0440\u043E\u043B\u044C \u0434\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430 \u0433\u0440\u0443\u043F\u043F\u044B",
                ribbon_view: "\u0412\u0438\u0434 \u043B\u0435\u043D\u0442\u044B",
                "rmc.assistant_exist_warning": "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0435\u0439, \u0442\u0430\u043A \u043A\u0430\u043A \u0435\u0439 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440.",
                "rmc.exist_notification_for_client_host": "\u042D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0435\u0439 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440.",
                "rmc.not_exist_notification_for_client_host": "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u043B \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0435\u0439.",
                same_as_system: "\u041A\u0430\u043A \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435",
                "security.allow_participants_to": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C:",
                "security.button": "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
                "security.waiting_room": "\u0412\u043A\u043B. \u0437\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F",
                select_allow: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u043F\u0446\u0438\u044E \u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C.",
                "settings.audio_tab_text": "\u0417\u0432\u0443\u043A",
                "settings.enable_hd": "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C HD \u0432\u0438\u0434\u0435\u043E",
                "settings.enable_hd_tip": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0432\u0441\u0435\u043C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0432\u0430\u0448\u0435 \u0432\u0438\u0434\u0435\u043E \u0432 \u0432\u044B\u0441\u043E\u043A\u043E\u043C \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0438 [720P). \u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0447\u0442\u043E \u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043C\u0430\u0448\u0438\u043D \u0438 \u043F\u0440\u043E\u043F\u0443\u0441\u043A\u043D\u043E\u0439 \u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u0438.",
                "settings.frame_per_second": "\u041A\u0430\u0434\u0440\u043E\u0432 \u0432 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
                "settings.frequency": "\u0427\u0430\u0441\u0442\u043E\u0442\u0430",
                "settings.input_level": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043D\u0430 \u0432\u0445\u043E\u0434\u0435:",
                "settings.item_name": "\u0418\u043C\u044F \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
                "settings.jitter": "\u0414\u0436\u0438\u0442\u0442\u0435\u0440",
                "settings.latency": "\u0417\u0430\u0434\u0435\u0440\u0436\u043A\u0430",
                "settings.maximum_view": "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043D\u0430 \u044D\u043A\u0440\u0430\u043D\u0435 \u0432 \u0433\u0430\u043B\u0435\u0440\u0435\u0435:",
                "settings.output_level": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043D\u0430 \u0432\u044B\u0445\u043E\u0434\u0435:",
                "settings.packet_loss": "\u041F\u043E\u0442\u0435\u0440\u044F \u043F\u0430\u043A\u0435\u0442\u043E\u0432 \u2013 \u0441\u0440\u0435\u0434\u043D. (\u043C\u0430\u043A\u0441.)",
                "settings.participants25": "25 \u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
                "settings.participants9": "9 \u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
                "settings.playing": "\u0412\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435",
                "settings.receive": "\u041F\u0440\u0438\u043D\u044F\u0442\u044C",
                "settings.receiving_video": "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0432\u0438\u0434\u0435\u043E",
                "settings.receiving_video_tips": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0430\u043F\u043F\u0430\u0440\u0430\u0442\u043D\u044B\u0439 \u0432\u0438\u0434\u0435\u043E\u043A\u043E\u0434\u0435\u0440 \u0432\u0438\u0434\u0435\u043E\u043A\u0430\u0440\u0442\u044B \u0434\u043B\u044F \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F CPU \u0434\u043B\u044F \u043F\u0440\u0438\u0435\u043C\u0430 \u0432\u0438\u0434\u0435\u043E. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u0447\u0442\u043E\u0431\u044B \u0432\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u0432 \u0441\u0438\u043B\u0443.",
                "settings.recording": "\u0417\u0430\u043F\u0438\u0441\u044C",
                "settings.rejoin": "\u0420\u0430\u0434\u043E\u0441\u0442\u044C",
                "settings.resolution": "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435",
                "settings.send": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
                "settings.sending_video": "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0432\u0438\u0434\u0435\u043E",
                "settings.sending_video_tips": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0430\u043F\u043F\u0430\u0440\u0430\u0442\u043D\u044B\u0439 \u0432\u0438\u0434\u0435\u043E-\u0434\u0435\u043A\u043E\u0434\u0435\u0440 \u0432\u0438\u0434\u0435\u043E\u043A\u0430\u0440\u0442\u044B, \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 CPU \u0434\u043B\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u0432\u0438\u0434\u0435\u043E. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u0447\u0442\u043E\u0431\u044B \u0432\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u0432 \u0441\u0438\u043B\u0443.",
                "settings.statistics": "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
                "settings.stop": "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
                "settings.switch_view_mode_text": "\u0412\u044B \u0434\u043E\u043B\u0436\u043D\u044B \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u0432\u0441\u0442\u0440\u0435\u0447\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u044D\u0442\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
                "settings.test_mic": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D",
                "settings.test_speaker": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0434\u0438\u043D\u0430\u043C\u0438\u043A",
                "settings.unknown_device": "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
                "settings.use_hardware_acceleration": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0430\u043F\u043F\u0430\u0440\u0430\u0442\u043D\u043E\u0435 \u0443\u0441\u043A\u043E\u0440\u0435\u043D\u0438\u0435 \u0434\u043B\u044F:",
                "settings.vb_init_10s_tip2": "\u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u043D \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 \u0431\u043E\u043B\u044C\u0448\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u0438, \u0447\u0435\u043C \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C.",
                "settings.vb_init_fail2": "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u043D.",
                "settings.video_tab_text": "\u0412\u0438\u0434\u0435\u043E",
                speaker_view: "\u0412\u0438\u0434 \u0434\u043E\u043A\u043B\u0430\u0434\u0447\u0438\u043A\u0430",
                toolbar_join_audio: "\u0412\u043E\u0439\u0442\u0438 \u0432 \u0430\u0443\u0434\u0438\u043E\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E",
                toolbar_leave: "\u0412\u044B\u0439\u0442\u0438",
                toolbar_mute: "\u0412\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0437\u0432\u0443\u043A",
                toolbar_muteall: "\u0412\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0437\u0432\u0443\u043A \u0434\u043B\u044F \u0432\u0441\u0435\u0445",
                toolbar_record: "\u0417\u0430\u043F\u0438\u0441\u044C",
                toolbar_unmute: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0437\u0432\u0443\u043A",
                wait_room_tip1: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C {{displayName}} \u0432\u043E\u0448\u0435\u043B \u0432 \u0437\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                wait_room_tip2: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 ({{count}}) \u0432\u043E\u0448\u043B\u0438 \u0432 \u0437\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                "wc.ast_admin_name": "\u041F\u043E\u043C\u043E\u0449\u043D\u0438\u043A \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                "wc.rmc_admin_name": "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043F\u043E \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044F\u043C\u0438",
                "wc.rmc_admin_tooltip": "\u0423 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043C \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430, \u043D\u043E \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043C\u0443\u043B\u044C\u0442\u0438\u043C\u0435\u0434\u0438\u0439\u043D\u043E\u043C\u0443 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u043C\u0443 (\u0437\u0432\u0443\u043A, \u0432\u0438\u0434\u0435\u043E, \u0447\u0430\u0442 \u0438 \u0440\u0435\u0430\u043A\u0446\u0438\u0438).",
                wc_3rd_cc_copied_api_token: "\u0422\u043E\u043A\u0435\u043D API \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
                wc_3rd_cc_copy_api_token: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u043E\u043A\u0435\u043D API",
                wc_3rd_cc_service: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u044E\u044E \u0443\u0441\u043B\u0443\u0433\u0443 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u043E\u0432 \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E",
                wc_3rd_cc_url_help_tips2: "\u0421\u043A\u043E\u043F\u0438\u0440\u0443\u0439\u0442\u0435 \u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u044D\u0442\u043E\u0442 \u0442\u043E\u043A\u0435\u043D \u0432 \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0432\u0432\u043E\u0434\u0430 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u043E\u0432",
                wc_admit: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C",
                wc_allow_to_talk: "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0433\u043E\u0432\u043E\u0440\u0438\u0442\u044C",
                wc_audio: "\u0417\u0432\u0443\u043A",
                "wc_audio.muted_notification1": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u043B \u0432\u0430\u0448 \u0437\u0432\u0443\u043A",
                "wc_audio.muted_notification2": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u043B \u0437\u0432\u0443\u043A \u0434\u043B\u044F \u0432\u0441\u0435\u0445",
                "wc_audio.unmute_by_host_content_1": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0445\u043E\u0447\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0432\u0430\u043C \u0441\u043B\u043E\u0432\u043E",
                "wc_audio.unmute_by_host_content_2": "\u0415\u0441\u043B\u0438 \u0432\u044B \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0437\u0432\u0443\u043A, \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u0430 \u0443\u0441\u043B\u044B\u0448\u0430\u0442 \u0432\u0430\u0441. \u0415\u0441\u043B\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0438\u043B\u0438 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0433\u0440\u0443\u043F\u043F\u044B \u0440\u0435\u0448\u0430\u0442 \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432\u0435\u0431\u0438\u043D\u0430\u0440, \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0435\u0433\u043E \u043F\u0440\u044F\u043C\u0443\u044E \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044E \u0438\u043B\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0432 \u0430\u0440\u0445\u0438\u0432 \u043F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u0432\u044B \u0432\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u0437\u0432\u0443\u043A, \u0432\u0430\u0448 \u0433\u043E\u043B\u043E\u0441 \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0430\u043D.",
                wc_audio_cannot_unmute: "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0437\u0432\u0443\u043A, \u043F\u043E\u0442\u043E\u043C\u0443 \u0447\u0442\u043E \u0437\u0432\u0443\u043A \u0432\u0430\u043C \u0432\u044B\u043A\u043B\u044E\u0447\u0438\u043B \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440.",
                wc_audio_connecting_thumbnail: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0437\u0432\u0443\u043A\u0430",
                wc_broadcasting: "\u0432\u0435\u0449\u0430\u043D\u0438\u044F",
                wc_btn_endconf_meeting_all: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u0434\u043B\u044F \u0432\u0441\u0435\u0445",
                wc_camera_prevent: "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0430 \u0434\u0430\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043C\u0435\u0440\u0435. \u0412\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043C\u0435\u0440\u0435 \u0438 \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0432\u0438\u0434\u0435\u043E \u0441\u043D\u043E\u0432\u0430.",
                "wc_cc.placeholder": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0412\u0432\u043E\u0434 \u0434\u043B\u044F \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438",
                wc_cc_assign_participant_to_type: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430 \u0434\u043B\u044F \u0432\u0432\u043E\u0434\u0430",
                wc_cc_assign_to: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0434\u043B\u044F \u0432\u0432\u043E\u0434\u0430 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u043E\u0432 \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E",
                wc_cc_assign_to_type: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0434\u043B\u044F \u0432\u0432\u043E\u0434\u0430",
                wc_cc_broadcasting_tip: "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044B \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E \u0442\u0440\u0430\u043D\u0441\u043B\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0434\u043B\u044F \u0432\u0441\u0435\u0445 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432.",
                wc_cc_host_assigned: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u043B \u0432\u0430\u0441 \u0434\u043B\u044F \u0432\u0432\u043E\u0434\u0430 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u043E\u0432 \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E",
                wc_cc_type_myself: "\u042F \u0431\u0443\u0434\u0443 \u0432\u0432\u043E\u0434\u0438\u0442\u044C",
                wc_cc_withdraw: "\u041E\u0442\u043E\u0437\u0432\u0430\u0442\u044C \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u043E\u0432 \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E",
                "wc_chat.attendee_chat_with": "\u041F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043C\u043E\u0433\u0443\u0442 \u043E\u0431\u0449\u0430\u0442\u044C\u0441\u044F \u0432 \u0447\u0430\u0442\u0435 \u0441:",
                "wc_chat.chat": "\u0427\u0430\u0442",
                "wc_chat.direct_message": "(\u041B\u0438\u0447\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435)",
                "wc_chat.disable_chat": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u043B \u0447\u0430\u0442 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432.",
                "wc_chat.disabled": "\u041D\u0435\u0442",
                "wc_chat.everyone": "\u0412\u0441\u0435",
                "wc_chat.everyone_public": "\u0412\u0441\u0435: \u043E\u0442\u043A\u0440\u044B\u0442\u043E",
                "wc_chat.everyone_public_private": "\u0412\u0441\u0435: \u043E\u0442\u043A\u0440\u044B\u0442\u043E \u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E",
                "wc_chat.host_only": "\u0422\u043E\u043B\u044C\u043A\u043E \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440",
                "wc_chat.host_panelists": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u044B \u0438 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
                "wc_chat.me": "\u042F",
                "wc_chat.panelist_chat_with": "\u0414\u043E\u043A\u043B\u0430\u0434\u0447\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u043E\u0431\u0449\u0430\u0442\u044C\u0441\u044F \u0432 \u0447\u0430\u0442\u0435 \u0441:",
                "wc_chat.type_msg": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435...",
                wc_closed_caption_btn: "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044B \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E",
                wc_co_host: "(\u0421\u043E\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440)",
                wc_continue: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
                wc_copied: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
                wc_copied_to_clipboard: "\u0421\u0441\u044B\u043B\u043A\u0430 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
                wc_copy_link: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                wc_data_center2: "\u0412\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u043B\u0438\u0441\u044C \u043A \u043C\u0435\u0441\u0442\u043D\u043E\u043C\u0443 \u0446\u0435\u043D\u0442\u0440\u0443 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445.",
                wc_data_center3: "\u0412\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u043B\u0438\u0441\u044C \u043A \u0433\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u0435\u0442\u0438 Zoom \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u0442\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445.",
                wc_disable_talking: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440",
                wc_dlg_confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
                wc_enable: "\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
                wc_encryption: "\u0428\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
                wc_extra_function_disable_video: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432\u0438\u0434\u0435\u043E \u041F\u0440\u0438\u043D\u0438\u043C\u0430\u044E\u0449\u0438\u0439",
                wc_files: "\u0424\u0430\u0439\u043B\u044B",
                wc_footer_assign_leave: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0438 \u0432\u044B\u0439\u0442\u0438",
                wc_footer_assign_new_host: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0433\u043E \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430",
                wc_guest: "\u0413\u043E\u0441\u0442\u044C",
                wc_host_1: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440",
                wc_in_the_meeting: "\u041D\u0430 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                wc_invite_link: "\u0421\u0441\u044B\u043B\u043A\u0430 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
                wc_join_media_preview_info_confirm: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E",
                wc_join_media_preview_warning_denied_both: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043C\u0435\u0440\u0435 \u0438 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443 \u0432 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.",
                wc_join_media_preview_warning_denied_camera: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043C\u0435\u0440\u0435 \u0432 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.",
                wc_join_media_preview_warning_denied_mic: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443 \u0432 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.",
                wc_joining: "\u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435",
                wc_joining_meeting: "\u0412\u0445\u043E\u0434 \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E...",
                wc_learn_more: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
                wc_leave_computer_audio: "\u0412\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0437\u0432\u0443\u043A \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430",
                wc_leave_meeting: "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                wc_leave_webinar: "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u0432\u0435\u0431-\u0441\u0435\u043C\u0438\u043D\u0430\u0440\u0430",
                wc_live_transcription_btn: "\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438",
                wc_lock_meeting: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E",
                wc_lower_hand: "\u041E\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0440\u0443\u043A\u0443",
                wc_lt_disable_transcription: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0443",
                wc_lt_enable_transcription: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0443",
                wc_lt_item_captioner: "(\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u043E\u0432)",
                wc_lt_live_transcript: "\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438",
                wc_lt_menu_item1: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u044B",
                wc_lt_menu_item2: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u043E\u043B\u043D\u0443\u044E \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0443",
                wc_lt_menu_item3: "\u0421\u043A\u0440\u044B\u0442\u044C \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u044B",
                wc_lt_menu_item4: "\u041F\u043E\u043B\u043D\u0430\u044F \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u043E\u0432 \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E",
                wc_lt_request_host_ctrl: "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u0437\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0442\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438",
                wc_lt_search_text: "\u041F\u043E\u0438\u0441\u043A",
                wc_make_co_host: "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u043E\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u043C",
                wc_make_host: "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u043C",
                wc_me: "(\u044F)",
                wc_more: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
                wc_no: "\u041D\u0435\u0442",
                wc_none: "\u041D\u0435\u0442",
                wc_not_share_pronoun: "\u041D\u0435 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                wc_num_password: "\u0427\u0438\u0441\u043B\u043E\u0432\u043E\u0439 \u041F\u0430\u0440\u043E\u043B\u044C \u0422\u0435\u043B\u0435\u0444\u043E\u043D / \u043D\u043E\u043C\u0435\u0440 \u0441\u0438\u0441\u0442\u0435\u043C\u044B",
                wc_participant_id: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430",
                wc_participants: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
                wc_pc_audio: "\u0417\u0432\u0443\u043A \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430",
                wc_prevent_access_mic: "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0437\u0430\u043F\u0440\u0435\u0449\u0430\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443.",
                wc_put_in_waiting: "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0432 \u0437\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F",
                "wc_qa.allQ": "\u0412\u0441\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
                "wc_qa.anonymous_attendee": "\u0410\u043D\u043E\u043D\u0438\u043C\u043D\u044B\u0439 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A",
                "wc_qa.answer_private_type": "\u041E\u0442\u0432\u0435\u0442 \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0438",
                "wc_qa.answeredQ": "\u041E\u0442\u0432\u0435\u0447\u0435\u043D\u043D\u044B\u0435",
                "wc_qa.attendee_placeholder": "\u0417\u0434\u0435\u0441\u044C \u0431\u0443\u0434\u0443\u0442 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u044B \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0443 \u0438 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u0433\u0440\u0443\u043F\u043F\u044B.",
                "wc_qa.button_comment": "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439",
                "wc_qa.button_display_answer": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043E\u0442\u0432\u0435\u0442",
                "wc_qa.button_live": "\u041E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043F\u043E \u0441\u0435\u0442\u0438",
                "wc_qa.button_live_done": "\u0413\u043E\u0442\u043E\u0432\u043E",
                "wc_qa.button_reopen": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
                "wc_qa.collapse_all_answer": "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
                "wc_qa.dismissedQ": "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E",
                "wc_qa.display_all_answer": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
                "wc_qa.dissmis_tips": "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C",
                "wc_qa.input_tips": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C \u0432\u0430\u0448 \u0432\u043E\u043F\u0440\u043E\u0441...",
                "wc_qa.is_anonymous": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0430\u043D\u043E\u043D\u0438\u043C\u043D\u043E",
                "wc_qa.is_privately": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043B\u0438\u0447\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
                "wc_qa.live_tips_done": "\u041D\u0430 \u044D\u0442\u043E\u0442 \u0432\u043E\u043F\u0440\u043E\u0441 \u043F\u043E\u043B\u0443\u0447\u0435\u043D \u043E\u0442\u0432\u0435\u0442 \u043F\u043E \u0441\u0435\u0442\u0438",
                "wc_qa.live_tips_start": "\u0445\u043E\u0447\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043F\u043E \u0441\u0435\u0442\u0438",
                "wc_qa.most_recent": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435",
                "wc_qa.most_upvotes": "\u0411\u043E\u043B\u044C\u0448\u0438\u043D\u0441\u0442\u0432\u043E \u0433\u043E\u043B\u043E\u0441\u043E\u0432",
                "wc_qa.myQ": "\u041C\u043E\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
                "wc_qa.no_answered_questions": "\u041D\u0435\u0442 \u043E\u0442\u0432\u0435\u0447\u0435\u043D\u043D\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
                "wc_qa.no_dismissed_questions": "\u041D\u0435\u0442 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043D\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
                "wc_qa.no_open_questions": "\u041D\u0435\u0442 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
                "wc_qa.no_questions": "\u041D\u0435\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
                "wc_qa.openedQ": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C",
                "wc_qa.panelist_host_only_placeholder": "\u0412\u043E\u043F\u0440\u043E\u0441\u044B \u0431\u0443\u0434\u0443\u0442 \u0432\u0438\u0434\u043D\u044B \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430\u043C \u0438 \u0434\u043E\u043A\u043B\u0430\u0434\u0447\u0438\u043A\u0430\u043C",
                "wc_qa.panelist_view_all_placehoder": "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0432\u0438\u0434\u043D\u044B \u0432\u0441\u0435\u043C \u0432 \u044D\u0442\u043E\u043C \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u0435",
                "wc_qa.qa_comp_title": "\u0412\u043E\u043F\u0440\u043E\u0441\u044B \u0438 \u043E\u0442\u0432\u0435\u0442\u044B",
                "wc_qa.send": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
                "wc_qa.setting_allow_view": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                "wc_qa.setting_btn_name": "\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
                "wc_qa.setting_option_allow_anony_question": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0430\u043D\u043E\u043D\u0438\u043C\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
                "wc_qa.setting_option_allow_comment": "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                "wc_qa.setting_option_allow_view_all": "\u0412\u0441\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
                "wc_qa.setting_option_allow_view_answered": "\u0422\u043E\u043B\u044C\u043A\u043E \u043E\u0442\u0432\u0435\u0447\u0435\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
                "wc_qa.setting_option_allow_vote": "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0442\u044C \u0437\u0430",
                "wc_qa.welcome_banner": "\u0421\u0432\u043E\u0431\u043E\u0434\u043D\u043E \u0437\u0430\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0443 \u0438 \u0447\u043B\u0435\u043D\u0430\u043C \u0433\u0440\u0443\u043F\u043F\u044B",
                "wc_qa.welcome_banner_title": "\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C!",
                wc_raise_hand: "\u041F\u043E\u0434\u043D\u044F\u0442\u044C \u0440\u0443\u043A\u0443",
                wc_reclaim_host: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430",
                wc_record_host_reminder_desc: "\u0415\u0441\u043B\u0438 \u0432\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435, \u0432\u0441\u0435 \u043B\u0438\u0446\u0430, \u0434\u0438\u0430\u043B\u043E\u0433\u0438 \u0438 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u044D\u043A\u0440\u0430\u043D\u043E\u0432 \u0431\u0443\u0434\u0443\u0442 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u044B \u0432 \u043E\u0431\u043B\u0430\u043A\u043E.",
                wc_record_reminder_desc: "\u041E\u0441\u0442\u0430\u0432\u0430\u044F\u0441\u044C \u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438, \u0432\u044B \u0434\u0430\u0435\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0438.",
                wc_record_reminder_desc_2: "{{accountOwner}} \u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u043E\u0431\u043B\u0430\u043A\u0435 Zoom, \u0438 \u043B\u044E\u0431\u043E\u0439 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A, \u043E\u0431\u043B\u0430\u0434\u0430\u044E\u0449\u0438\u0439 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043C, \u043C\u043E\u0436\u0435\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u043D\u0430 \u0441\u0432\u043E\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E. \u042D\u0442\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043C\u043E\u0433\u0443\u0442 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0438\u043C\u0438 \u0437\u0430\u043F\u0438\u0441\u044F\u043C\u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.",
                wc_record_reminder_title: "\u0418\u0434\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u044C \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
                wc_record_reminder_webinar_title: "\u0418\u0434\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u044C \u044D\u0442\u043E\u0433\u043E \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u0430",
                wc_record_webinar_reminder_desc: "\u041E\u0441\u0442\u0430\u0432\u0430\u044F\u0441\u044C \u0432 \u044D\u0442\u043E\u043C \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u0435, \u0432\u044B \u0434\u0430\u0435\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0438.",
                wc_recording_pause: "\u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C",
                wc_recording_resume: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C",
                wc_recording_stop: "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C",
                wc_recording_title: "\u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u044D\u0442\u0443 \u0432\u0441\u0442\u0440\u0435\u0447\u0443?",
                wc_remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                wc_select_camera: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u043C\u0435\u0440\u0443",
                wc_select_microphone: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D",
                wc_select_speaker: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0438\u043D\u0430\u043C\u0438\u043A",
                wc_share_muted_while_sharing_audio_tip2: "\u0412\u0430\u0448 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D \u043F\u0440\u0438 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u043E\u0433\u043E \u0430\u0443\u0434\u0438\u043E. \u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u043F\u0430\u0443\u0437\u044B \u0438\u043B\u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u0435 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0430\u0443\u0434\u0438\u043E, \u0432\u0430\u0448 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D.",
                wc_share_pronoun: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
                wc_share_pronoun_menu: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043C\u0435\u0441\u0442\u043E\u0438\u043C\u0435\u043D\u0438\u044F",
                wc_share_pronoun_tip2: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0430\u0448\u0438 \u043C\u0435\u0441\u0442\u043E\u0438\u043C\u0435\u043D\u0438\u044F \u0432 \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438?",
                wc_sharer_controlbar_container_button3_label: "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u044D\u043A\u0440\u0430\u043D\u0430",
                wc_sharer_controlbar_container_rec_status_tip1: "\u0412\u044B \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0435 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u044D\u043A\u0440\u0430\u043D\u0430",
                wc_sharer_controlbar_container_rec_status_tip2: "\u0412\u0430\u0448\u0430 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u044D\u043A\u0440\u0430\u043D\u0430 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430",
                wc_sharer_disabled_share1_desc: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u043B \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u044D\u043A\u0440\u0430\u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432.",
                wc_sharer_disabled_share2_desc: "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u044D\u043A\u0440\u0430\u043D\u0430, \u043F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u044D\u043A\u0440\u0430\u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u0434\u0440\u0443\u0433\u043E\u0439 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A.",
                wc_sharer_entry_button_label1: "\u0414\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u044D\u043A\u0440\u0430\u043D\u0430",
                wc_sharer_setting_menu_category1_title: "\u041A\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u043A\u0440\u0430\u043D?",
                wc_sharer_setting_menu_category2_title: "\u041A\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044E \u044D\u043A\u0440\u0430\u043D\u0430, \u043A\u043E\u0433\u0434\u0430 \u043A\u0442\u043E-\u0442\u043E \u0443\u0436\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044E?",
                wc_sharer_setting_menu_category3_title: "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043C\u043E\u0433\u0443\u0442 \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435?",
                wc_sharer_setting_menu_category_option1: "\u0422\u043E\u043B\u044C\u043A\u043E \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440",
                wc_sharer_setting_menu_category_option2: "\u0412\u0441\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
                wc_sharer_setting_menu_item1: "\u0422\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044E \u043C\u043E\u0436\u0435\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A",
                wc_sharer_setting_menu_item2: "\u041D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043C\u043E\u0433\u0443\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044E \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E",
                wc_sharing_fit_to_window: "\u041F\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0443 \u043E\u043A\u043D\u0430",
                wc_sharing_original_size: "\u0418\u0441\u0445\u043E\u0434\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440",
                wc_sharing_shared_screens: "\u0422\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438 \u044D\u043A\u0440\u0430\u043D\u043E\u0432",
                wc_sharing_view_options: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
                wc_sharing_viewing: "\u0412\u044B \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0435\u0442\u0435 \u044D\u043A\u0440\u0430\u043D {{displayName}}'s",
                wc_tel_password: "\u041A\u043E\u0434 \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
                wc_unmute_by_host_btn1: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0432\u0443\u043A \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u043C",
                wc_unshare_pronoun_menu: "\u0421\u043A\u0440\u044B\u0442\u044C \u043C\u0435\u0441\u0442\u043E\u0438\u043C\u0435\u043D\u0438\u044F",
                "wc_video.allow_panelist_start_video": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u043F\u043E\u043A\u0430\u0437 \u0432\u0438\u0434\u0435\u043E\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                "wc_video.allow_participants_start_video": "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u0432\u0438\u0434\u0435\u043E",
                "wc_video.ask_start_video": "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u043A\u0430\u0437 \u0432\u0438\u0434\u0435\u043E\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                "wc_video.model_stop": "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u043E\u043A\u0430\u0437 \u0441\u0432\u043E\u0435\u0433\u043E \u0432\u0438\u0434\u0435\u043E\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F, \u0442\u0430\u043A \u043A\u0430\u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u043B \u0435\u0433\u043E",
                "wc_video.start_video": "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u043E\u043A\u0430\u0437 \u0432\u0438\u0434\u0435\u043E\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                "wc_video.stop_video": "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u043E\u043A\u0430\u0437 \u0432\u0438\u0434\u0435\u043E\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                "wc_video.video": "\u0412\u0438\u0434\u0435\u043E",
                wc_view: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C",
                wc_waiting_room: "\u0417\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F",
                "wc_webinar.change_to_attendee": "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0440\u043E\u043B\u044C \u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430",
                "wc_webinar.promote_to_panelist": "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0432 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
                wc_webinar_attendees: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
                wc_webinar_panelists: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
                wc_webinar_putonhold: "\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u0443\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435",
                wc_withdraw_co_host: "\u041E\u0442\u043E\u0437\u0432\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430",
                wc_yes: "\u0414\u0430",
                websdk_enforce_update_content: "\u0427\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u044D\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0432\u0435\u0440\u0441\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F {0} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u043F\u043E\u0437\u0434\u043D\u044F\u044F \u0432\u0435\u0440\u0441\u0438\u044F. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.",
                websdk_update_content: "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 WebSDK \u0434\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0439 \u0432\u0435\u0440\u0441\u0438\u0438, \u0447\u0442\u043E\u0431\u044B \u043E\u043F\u0442\u0438\u043C\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043E\u043F\u044B\u0442 \u0432\u0441\u0442\u0440\u0435\u0447\u0438"
              }
            },
            "zh-CN": {
              translation: {
                GOT_IT: "\u77E5\u9053\u4E86",
                account_owner: "\u8D26\u6237\u6240\u6709\u8005",
                allow_to_access: "\u5141\u8BB8\u8BBF\u95EE\u76F8\u673A\u548C\u9EA6\u514B\u98CE",
                "app_signal.approved_by": "\u5DF2\u7531\u6279\u51C6",
                "app_signal.hosts_account": "\u4E3B\u6301\u4EBA\u7684\u8D26\u6237",
                "app_signal.people": "\u4EBA",
                "app_signal.tip_text_2": "\u67E5\u770B\u6B63\u5728\u8BBF\u95EE\u4F1A\u8BAE\u5185\u5BB9\u7684\u5E94\u7528",
                "app_signal.unable_load2": "\u65E0\u6CD5\u52A0\u8F7D\u53EF\u5B9E\u65F6\u8BBF\u95EE\u4F60\u7684\u4FE1\u606F\u7684\u5E94\u7528\u3002",
                "archiving.chat_1": "\u804A\u5929\uFF08\u516C\u5171\u548C\u79C1\u804A\uFF09",
                "archiving.chat_2": "\u804A\u5929\uFF08\u4EC5\u516C\u5171\u804A\u5929\uFF09",
                "archiving.chat_disable_content": "\u51FA\u4E8E\u5408\u89C4\u6027\u76EE\u7684\uFF0C\u65E0\u6CD5\u5C06\u804A\u5929\u4E2D\u53D1\u9001\u7684\u6D88\u606F\u5B58\u6863\u3002",
                "archiving.chat_disable_title": "\u5DF2\u7981\u7528\u804A\u5929",
                "archiving.content1_sdk": "\u6B64\u4F1A\u8BAE\u4E2D\u7684\u4E00\u4E2A\u6216\u591A\u4E2A\u53C2\u4F1A\u8005\u5C06\u6839\u636E\u5176\u8D26\u6237\u7684\u653F\u7B56\u8FDB\u884C\u5B58\u6863\u3002\u5176{{content}}\u5C06\u6536\u5230\u4F1A\u8BAE\u5185\u5BB9\uFF0C\u5E76\u53EF\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "archiving.content2_sdk": "\u5982\u679C\u7559\u5728\u4F1A\u8BAE\u4E2D\uFF0C\u5373\u8868\u793A\u4F60\u540C\u610F\u5C06\u6B64\u4F1A\u8BAE\u7684{{content}}\u5B58\u6863\u3002",
                "archiving.default_title": "\u6B64\u4F1A\u8BAE\u6B63\u5728\u5B58\u6863\u4E2D",
                "archiving.fail_content_sdk": "\u51FA\u4E8E\u5408\u89C4\u6027\u76EE\u7684\uFF0C\u6B64\u4F1A\u8BAE\u7684{{features}}\u5FC5\u987B\u5B58\u6863\u3002",
                "archiving.fail_title": "\u5B58\u6863\u5931\u8D25",
                "archiving.subjects_combo_2_sdk": "{{0}}\u548C{{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}\u3001{{1}}\u548C{{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}\u3001{{1}}\u3001{{2}}\u548C{{3}}",
                "archiving.tips_1_sdk": "\u6B64\u4F1A\u8BAE\u7684{{subjects}}\u6B63\u5728\u7531\u4E3B\u6301\u4EBA\u6240\u5728\u7EC4\u7EC7\u6839\u636E\u5176\u8D26\u6237\u7684\u653F\u7B56\u8FDB\u884C\u5B58\u6863\u3002\u5176{{receiver}}\u5C06\u6536\u5230\u4F1A\u8BAE\u5185\u5BB9\uFF0C\u5E76\u53EF\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "archiving.tips_2_sdk": "\u6B64\u4F1A\u8BAE\u7684{{subjects}}\u6B63\u5728\u7531\u4E3B\u6301\u4EBA\u6240\u5728\u7EC4\u7EC7\u6839\u636E\u5176\u8D26\u6237\u7684\u653F\u7B56\u8FDB\u884C\u5B58\u6863\u3002\u5176{{receiver}}\u5C06\u6536\u5230\u4F1A\u8BAE\u5185\u5BB9\uFF0C\u5E76\u53EF\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "archiving.transcription": "\u8F6C\u5F55\u6587\u5B57",
                "ast.leave_tip": "\u52A9\u624B\u5DF2\u505C\u6B62\u63A7\u5236\u4F1A\u8BAE\u3002",
                "ast.tip": "\u6B64\u4F1A\u8BAE\u6B63\u7531\u52A9\u624B\u63A7\u5236",
                background: "\u80CC\u666F",
                chat_message_header: "<0> {{senderName}} </0> <1>\u5230</1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}}\u6761\u65B0\u6D88\u606F",
                chat_receiver_co_host: "\uFF08\u8054\u5E2D\u4E3B\u6301\u4EBA\uFF09",
                chat_receiver_host: "\uFF08\u4E3B\u6301\u4EBA\uFF09",
                chat_receiver_panelist: "\uFF08\u5609\u5BBE\uFF09",
                chat_receiver_to: "\u5230\uFF1A",
                choose_background: "\u9009\u62E9\u80CC\u666F",
                click_address_bar: "\u5355\u51FB\u5730\u5740\u680F\u5DE6\u4FA7\u7684\u9501\u5B9A\u56FE\u6807\u3002\u5F39\u51FA\u7A97\u53E3\u5C06\u663E\u793A\u6709\u9009\u9879\u5217\u8868\u3002",
                click_microphone_camera_option: "\u5355\u51FB\u6444\u50CF\u673A\u53F3\u4FA7\u7684\u4E0B\u62C9\u5217\u8868\u548C\u9EA6\u514B\u98CE\u9009\u9879\u3002",
                "common.cancel": "\u53D6\u6D88",
                "common.connecting": "\u8FDE\u63A5\u4E2D",
                delete: "\u5220\u9664",
                "dialog.btn_cancel": "\u53D6\u6D88",
                "dialog.btn_endconf_webinar": "\u7ED3\u675F\u7F51\u7EDC\u7814\u8BA8\u4F1A",
                "dialog.btn_leaveconf_meeting": "\u79BB\u5F00\u4F1A\u8BAE",
                "dialog.btn_retry": "\u91CD\u8BD5",
                "dialog.host_end_meeting": "\u6B64\u4F1A\u8BAE\u5DF2\u7531\u4E3B\u6301\u4EBA\u7ED3\u675F\u3002",
                "dialog.host_end_webinar": "\u6B64\u7F51\u7EDC\u7814\u8BA8\u4F1A\u5DF2\u7531\u4E3B\u6301\u4EBA\u7ED3\u675F\u3002",
                "dialog.meeting_ended": "\u4F1A\u8BAE\u5DF2\u7ED3\u675F",
                "dialog.meeting_locked": "\u4F1A\u8BAE\u5DF2\u9501\u5B9A",
                "dialog.meeting_removed_by_host": "\u4F60\u5DF2\u88AB\u4E3B\u6301\u4EBA\u4ECE\u6B64\u4F1A\u8BAE\u4E2D\u5220\u9664\u3002",
                "dialog.newname": "\u540D\u79F0",
                "dialog.ok": "\u786E\u8BA4",
                "dialog.presscode": "\u4F1A\u8BAE\u53F7",
                "dialog.rename": "\u91CD\u547D\u540D",
                "dialog.server_error": "\u670D\u52A1\u5668\u53D1\u751F\u5185\u90E8\u9519\u8BEF\uFF0C\u65E0\u6CD5\u5904\u7406\u4F60\u7684\u8BF7\u6C42\u3002",
                "dialog.webinar_ended": "\u6B64\u7F51\u7EDC\u7814\u8BA8\u4F1A\u5DF2\u7ED3\u675F",
                "dialog.webinar_removed_by_host": "\u4F60\u5DF2\u88AB\u4E3B\u6301\u4EBA\u4ECE\u6B64\u7F51\u7EDC\u7814\u8BA8\u4F1A\u4E2D\u5220\u9664\u3002",
                "dialog.you_are_removed": "\u4F60\u5DF2\u88AB\u79FB\u9664",
                dialog_make_cohost: "\u662F\u5426\u8981\u5C06{{displayName}}\u8BBE\u4E3A\u672C\u6B21\u4F1A\u8BAE\u7684\u8054\u5E2D\u4E3B\u6301\u4EBA\uFF1F",
                dialog_make_host: "\u662F\u5426\u8981\u5C06\u4E3B\u6301\u4EBA\u66F4\u6539\u4E3A{{displayName}}\uFF1F",
                dialog_remove_user: "\u662F\u5426\u8981\u79FB\u9664{{displayName}}\uFF1F",
                "disclaimer.LT_button_1": "\u8C01\u80FD\u770B\u5230\u6B64\u8F6C\u5F55\u6587\u5B57\uFF1F",
                "disclaimer.LT_content_1_1": "\u8D26\u6237\u6240\u6709\u8005\u548C\u4F1A\u8BAE\u4E2D\u7684\u6BCF\u4E2A\u6210\u5458\u90FD\u53EF\u4EE5\u4FDD\u5B58\u6B64\u8F6C\u5F55\u6587\u5B57\uFF0C\u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "disclaimer.LT_content_2": "\u5DF2\u542F\u7528\u5B9E\u65F6\u8F6C\u5F55\uFF08\u5B57\u5E55\uFF09",
                "disclaimer.QA_button_1": "\u8C01\u80FD\u770B\u5230\u4F60\u7684\u95EE\u9898\uFF1F",
                "disclaimer.QA_content_1_1": "\u8D26\u6237\u6240\u6709\u8005\u3001\u4E3B\u6301\u4EBA\u548C\u5609\u5BBE\u90FD\u80FD\u770B\u5230\u4F60\u7684\u8EAB\u4EFD\u4FE1\u606F\u3001\u8054\u7CFB\u65B9\u5F0F\uFF08\u5982\u5DF2\u767B\u5F55\u6216\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF09\u4EE5\u53CA\u4F60\u7684\u95EE\u9898 - \u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "disclaimer.QA_content_2": "\u5982\u679C\u4F60\u7684\u95EE\u9898\u88AB\u9009\u4E2D\uFF0C\u5219\u6240\u6709\u89C2\u4F17\u90FD\u5C06\u770B\u5230\u8BE5\u95EE\u9898\u3002",
                "disclaimer.QA_content_3_3": "\u9664\u975E\u533F\u540D\u63D0\u4EA4\uFF0C\u5426\u5219\u8D26\u6237\u6240\u6709\u8005\u3001\u4E3B\u6301\u4EBA\u548C\u5609\u5BBE\u90FD\u80FD\u770B\u5230\u4F60\u7684\u8EAB\u4EFD\u4FE1\u606F\u3001\u8054\u7CFB\u65B9\u5F0F\uFF08\u5982\u5DF2\u767B\u5F55\u6216\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF09\u4EE5\u53CA\u4F60\u7684\u95EE\u9898 - \u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "disclaimer.QA_content_4": "\u6B64\u95EE\u7B54\u4E3A\u516C\u5F00\u5F62\u5F0F\uFF0C\u56E0\u6B64\u6240\u6709\u6210\u5458\u90FD\u80FD\u770B\u5230\u4F60\u7684\u95EE\u9898\u3002",
                "disclaimer.QA_content_5": "\u5982\u679C\u533F\u540D\u63D0\u4EA4\u95EE\u9898\uFF0C\u5219\u6CA1\u6709\u4EBA\u80FD\u770B\u5230\u95EE\u9898\u7684\u63D0\u4EA4\u8005\u3002",
                "disclaimer.chat_button_normal": "\u8C01\u80FD\u770B\u5230\u4F60\u7684\u6D88\u606F\uFF1F",
                "disclaimer.chat_button_onArchiving": "\u8C01\u80FD\u770B\u5230\u4F60\u7684\u6D88\u606F\uFF1F\u5B58\u6863\u5DF2\u5F00\u542F",
                "disclaimer.chat_button_onRecording": "\u8C01\u80FD\u770B\u5230\u4F60\u7684\u6D88\u606F\uFF1F\u5F55\u5236\u5DF2\u5F00\u542F",
                "disclaimer.chat_content_1": "\u4F1A\u8BAE\u4E2D\u7684\u6BCF\u4E2A\u6210\u5458\u90FD\u53EF\u4EE5\u770B\u5230\u5E76\u4FDD\u5B58\u4F60\u53D1\u9001\u7ED9\u6240\u6709\u6210\u5458\u7684\u6D88\u606F - \u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "disclaimer.chat_content_2": "\u53EA\u6709\u4F60\u548C\u804A\u5929\u5BF9\u8C61\u80FD\u4FDD\u5B58\u79C1\u804A\uFF0C\u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "disclaimer.chat_content_3": "\u5F55\u5236\u5F00\u542F\u540E\uFF0C\u8D26\u6237\u6240\u6709\u8005\u548C\u4F1A\u8BAE\u4E2D\u7684\u6BCF\u4E2A\u6210\u5458\u90FD\u53EF\u4EE5\u770B\u5230\u5E76\u4FDD\u5B58\u53D1\u9001\u7ED9\u6240\u6709\u6210\u5458\u7684\u6D88\u606F - \u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "disclaimer.chat_content_4": "\u5F55\u5236\u5F00\u542F\u540E\uFF0C\u4F1A\u8BAE\u4E2D\u7684\u6BCF\u4E2A\u6210\u5458\u90FD\u53EF\u4EE5\u770B\u5230\u5E76\u4FDD\u5B58\u53D1\u9001\u7ED9\u6240\u6709\u6210\u5458\u7684\u6D88\u606F - \u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                "disclaimer.chat_content_5": "\u542F\u7528\u5B58\u6863\u540E\uFF0C\u8D26\u6237\u6240\u6709\u8005\u53EF\u4EE5\u770B\u5230\u4F60\u7684\u6240\u6709\u6D88\u606F \u2014 \u5305\u62EC\u79C1\u804A \u2014 \u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u7528\u6237\u3002",
                "disclaimer.chat_content_6": "\u4F1A\u8BAE\u4E2D\u7684\u6BCF\u4E2A\u6210\u5458\u90FD\u53EF\u4EE5\u4FDD\u5B58\u5E76\u5206\u4EAB\u4F60\u53D1\u9001\u7ED9\u6240\u6709\u6210\u5458\u7684\u6D88\u606F\u3002",
                "disclaimer.chat_content_7": "\u542F\u7528\u5B58\u6863\u540E\uFF0C\u8D26\u6237\u6240\u6709\u8005\u53EF\u4EE5\u770B\u5230\u4F60\u7684\u6240\u6709\u6D88\u606F - \u4E0D\u5305\u62EC\u79C1\u804A - \u5E76\u5C06\u5176\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u6210\u5458\u3002",
                errorcodes_be_removed: "\u88AB\u5220\u9664\u3002",
                errorcodes_denied_email: "\u7535\u5B50\u90AE\u4EF6\u662F\u7531\u7BA1\u7406\u5458\u963B\u6B62\u3002",
                errorcodes_denied_register_with_panelist: "\u88AB\u62D2\u7EDD\u767B\u8BB0\u4F7F\u7528\u5C0F\u7EC4\u6210\u5458\u7684\u7535\u5B50\u90AE\u4EF6\u3002",
                errorcodes_disconnect: "\u4F1A\u8BAE\u5DF2\u65AD\u5F00\u3002",
                errorcodes_email_require: "\u7535\u5B50\u90AE\u4EF6\u4E22\u5931\u51FA\u5E2D\u7814\u8BA8\u4F1A\u3002",
                errorcodes_fail: "\u65E0\u6CD5\u52A0\u5165\u4F1A\u8BAE\u3002",
                errorcodes_frequent_call: "\u60A8\u5DF2\u8FBE\u5230\u8BE5\u547C\u53EB\u7684API\u9650\u5236\u3002",
                errorcodes_frequent_join: "\u60A8\u53EF\u4EE5\u901A\u8FC7\u53D8\u7126\u662F\u6781\u9650\uFF0C\u9700\u8981\u68C0\u67E5\u9A8C\u8BC1\u7801\u3002",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "\u4ECE\u6D4F\u89C8\u5668\u65E0\u6CD5\u52A0\u5165\uFF0C\u8BF7\u52A0\u5165\u4F7F\u7528\u7F29\u653E\u684C\u9762\u5BA2\u6237\u7AEF\u6216\u79FB\u52A8\u5E94\u7528\u7A0B\u5E8F\u3002",
                errorcodes_not_exist: "\u4F1A\u8BAE\u4E0D\u5B58\u5728\u3002",
                errorcodes_not_host: "\u4F60\u662F\u4E0D\u662F\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u3002",
                errorcodes_not_init: "\u4F1A\u8BAE\u672A\u521D\u59CB\u5316\u3002",
                errorcodes_not_start: "\u4F1A\u8BAE\u8FD8\u6CA1\u6709\u5F00\u59CB",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "\u8BE5\u670D\u52A1\u6682\u65F6\u5904\u4E8E\u79BB\u7EBF\u72B6\u6001\u3002",
                errorcodes_pac_api_disabled: "\u8BE5\u8D26\u6237\u7684API\u5BC6\u94A5\u65F6\u5904\u4E8E\u5173\u95ED\u72B6\u6001\u3002",
                errorcodes_pac_api_wrong: "\u8BE5\u8D26\u6237API\u5BC6\u94A5\u65E0\u6548\u3002",
                errorcodes_pac_cant_host_other_mn: "\u4E0D\u53EF\u4E0D\u540C\u65F6\u4E3E\u529E\u53E6\u4E00\u6B21\u4F1A\u8BAE\u3002",
                errorcodes_pac_host_not_found: "\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u672A\u627E\u5230\u3002",
                errorcodes_pac_invalid_signature: "\u7B7E\u540D\u662F\u65E0\u6548\u7684\u3002",
                errorcodes_pac_mn_not_fount: "\u4F1A\u8BAE\u53F7\u6CA1\u6709\u627E\u5230\u3002",
                errorcodes_pac_mn_wrong: "\u4F1A\u8BAE\u53F7\u7801\u662F\u9519\u7684\u3002",
                errorcodes_pac_no_permission: "\u65E0\u6743\u9650\u3002",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "\u4E0D\u6B63\u786E\u7684\u89D2\u8272\u3002",
                errorcodes_pac_signature_expired: "\u7B7E\u540D\u5DF2\u8FC7\u671F\u3002",
                errorcodes_re_connect: "\u4F1A\u8BAE\u91CD\u65B0\u8FDE\u63A5\u3002",
                errorcodes_register: "\u672C\u6B21\u4F1A\u8BAE\u9700\u8981\u6CE8\u518C\u3002",
                errorcodes_rwc_empty: "\u65E0\u6CD5\u83B7\u53D6\u6765\u81EAWeb\u670D\u52A1\u5668\u7684\u54CD\u5E94\u3002",
                errorcodes_rwc_error: "\u65E0\u6CD5\u8FDE\u63A5\u5230Web\u670D\u52A1\u5668\u9519\u8BEF\u3002",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "\u6210\u529F\u52A0\u5165\u4F1A\u8BAE\u3002",
                errorcodes_tk_expired: "\u4EE4\u724C\u5DF2\u8FC7\u671F\u3002",
                errorcodes_wasm_fail: "\u4E0B\u8F7D\u6587\u4EF6WASM\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u60A8\u7684\u7F51\u7EDC\u548C\u9632\u706B\u5899\u3002",
                errorcodes_web_has_in_progress: "\u5DF2\u7ECF\u6709\u53E6\u4E00\u573A\u4F1A\u8BAE\u6B63\u5728\u8FDB\u884C\u3002",
                errorcodes_web_host_not_exit: "\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u4E0D\u5B58\u5728\u3002",
                errorcodes_web_invalid_id: "\u65E0\u6548\u7684\u4F1A\u8BAEID\u3002",
                errorcodes_web_not_allow_start_webinar_from_web: "\u4E0D\u5141\u8BB8\u901A\u8FC7\u7F51\u7EDC\u5F00\u59CB\u7F51\u7EDC\u7814\u8BA8\u4F1A",
                errorcodes_web_not_support_registration_webinar: "\u4E0D\u652F\u6301\u6CE8\u518C\u7F51\u7EDC\u7814\u8BA8\u4F1A",
                errorcodes_web_not_support_tsp: "\u5982\u679C\u9009\u62E9\u7535\u8BDD\u8BED\u97F3\u670D\u52A1\u63D0\u4F9B\u5546\u4F5C\u4E3A\u4F1A\u8BAE\u97F3\u9891\uFF0C\u5219\u4E0D\u652F\u6301\u901A\u8FC7\u7F51\u7EDC\u5F00\u59CB\u6216\u52A0\u5165\u4F1A\u8BAE\u3002",
                errorcodes_web_not_support_webclient: "\u4E0D\u652F\u6301\u4ECE Web \u5F00\u59CB\u6216\u52A0\u5165\u4F1A\u8BAE\u3002",
                errorcodes_web_not_support_webinar_pac: "\u975E\u652F\u6301\u7684\u7F51\u7EDC\u7814\u8BA8\u4F1A\u548C\u4E2A\u4EBA\u97F3\u9891\u4F1A\u8BAE",
                errorcodes_web_require_email: "\u5FC5\u987B\u63D0\u4F9B\u7528\u6237\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002",
                errorcodes_web_should_support_webinar_with_latest_version: "\u5F53\u524D sdk \u7248\u672C\u4E0D\u652F\u6301\u7F51\u7EDC\u7814\u8BA8\u4F1A\uFF0C\u8BF7\u5347\u7EA7\u5230\u6700\u65B0\u7248\u672C\u3002",
                errorcodes_wrong_pass: "\u4F1A\u8BAE\u5BC6\u7801\u9519\u8BEF\u3002",
                gallary_view: "\u753B\u5ECA\u89C6\u56FE",
                invalid_parameter: "\u65E0\u6548\u7684\u53C2\u6570",
                "invite.loading": "\u52A0\u8F7D\u4E2D...",
                meeting_disconnected: "\u4F1A\u8BAE\u65AD\u5F00",
                meeting_info: "\u4F1A\u8BAE\u4FE1\u606F",
                meeting_info_network: "\u60A8\u901A\u8FC7{{dc}}\u4E2D\u7684\u6570\u636E\u4E2D\u5FC3\u8FDE\u63A5\u5230{{network}}",
                meeting_not_start: "\u4F1A\u8BAE\u5C1A\u672A\u5F00\u59CB",
                meeting_taking: "\u6B63\u5728\u53D1\u8A00\uFF1A",
                meeting_waiting_for_start: "\u7B49\u5F85\u4F1A\u8BAE\u5F00\u59CB",
                meeting_waiting_room: "\u4E3B\u6301\u4EBA\u4F1A\u5F88\u5FEB\u8BA9\u4F60",
                minimized_view: "\u6700\u5C0F\u5316\u7684\u89C6\u56FE",
                mirror_my_video: "\u89C6\u9891\u955C\u50CF",
                "polling.Back": "\u8FD4\u56DE",
                "promote.cancel": "\u7EE7\u7EED\u4EE5\u89C2\u4F17\u8EAB\u4EFD\u53C2\u4F1A",
                "promote.content_1": "\u4F5C\u4E3A\u5609\u5BBE\uFF0C\u4F60\u53EF\u4EE5\u89E3\u9664\u9759\u97F3\u5E76\u5F00\u542F\u89C6\u9891\uFF0C\u8FD9\u610F\u5473\u7740\uFF0C\u7F51\u7EDC\u7814\u8BA8\u4F1A\u4E2D\u7684\u5176\u4ED6\u6210\u5458\u5C06\u53EF\u4EE5\u770B\u5230\u4F60\u3002",
                "promote.content_2": "\u5982\u679C\u4E3B\u6301\u4EBA\u6216\u5176\u4ED6\u5609\u5BBE\u5728\u4F60\u89E3\u9664\u9759\u97F3\u540E\u51B3\u5B9A\u5F55\u5236\u3001\u76F4\u64AD\u6216\u5B58\u6863\u672C\u6B21\u7F51\u7EDC\u7814\u8BA8\u4F1A\uFF0C\u4F60\u7684\u53C2\u4E0E\u4E5F\u5C06\u5305\u542B\u5728\u5185\u3002",
                "promote.ok": "\u4EE5\u5609\u5BBE\u8EAB\u4EFD\u52A0\u5165",
                "promote.title": "\u4E3B\u6301\u4EBA\u5E0C\u671B\u5C06\u4F60\u8BBE\u4E3A\u5609\u5BBE",
                ribbon_view: "\u4E1D\u5E26\u89C6\u56FE",
                "rmc.assistant_exist_warning": "\u4F60\u65E0\u6CD5\u63A7\u5236\u4F1A\u8BAE\uFF0C\u56E0\u4E3A\u53E6\u4E00\u540D\u52A9\u624B\u6B63\u5728\u63A7\u5236\u6B64\u4F1A\u8BAE\u3002",
                "rmc.exist_notification_for_client_host": "\u6B64\u4F1A\u8BAE\u6B63\u7531\u7BA1\u7406\u5458\u63A7\u5236\u3002",
                "rmc.not_exist_notification_for_client_host": "\u7BA1\u7406\u5458\u5DF2\u505C\u6B62\u63A7\u5236\u4F1A\u8BAE\u3002",
                same_as_system: "\u4E0E\u7CFB\u7EDF\u4E00\u81F4",
                "security.allow_participants_to": "\u5141\u8BB8\u53C2\u4F1A\u8005\uFF1A",
                "security.button": "\u5B89\u5168",
                "security.waiting_room": "\u542F\u7528\u7B49\u5019\u5BA4",
                select_allow: "\u9009\u62E9\u9009\u9879\u5141\u8BB8\u3002",
                "settings.audio_tab_text": "\u97F3\u9891",
                "settings.enable_hd": "\u542F\u7528\u9AD8\u6E05\u89C6\u9891",
                "settings.enable_hd_tip": "\u4F7F\u6240\u6709\u53C2\u4E0E\u8005\u80FD\u591F\u4EE5\u9AD8\u5206\u8FA8\u7387(720P)\u67E5\u770B\u60A8\u7684\u89C6\u9891\u3002\u8BF7\u6CE8\u610F\uFF0C\u5B9E\u9645\u7ED3\u679C\u53D6\u51B3\u4E8E\u673A\u5668\u6027\u80FD\u548C\u5E26\u5BBD\u3002",
                "settings.frame_per_second": "\u5E27\u7387",
                "settings.frequency": "\u9891\u7387",
                "settings.input_level": "\u8F93\u5165\u7EA7\u522B\uFF1A",
                "settings.item_name": "\u7EDF\u8BA1\u9879",
                "settings.jitter": "\u6296\u52A8",
                "settings.latency": "\u5EF6\u8FDF",
                "settings.maximum_view": "\u753B\u5ECA\u89C6\u56FE\u4E0B\u5355\u5C4F\u663E\u793A\u7684\u6700\u5927\u53C2\u4F1A\u8005\u4EBA\u6570\uFF1A",
                "settings.output_level": "\u8F93\u51FA\u7EA7\u522B\uFF1A",
                "settings.packet_loss": "\u4E22\u5305\u7387 - \u5E73\u5747\u503C\uFF08\u6700\u5927\u503C\uFF09",
                "settings.participants25": "25\u53C2\u4F1A\u8005",
                "settings.participants9": "9\u53C2\u4F1A\u8005",
                "settings.playing": "\u64AD\u653E\u4E2D",
                "settings.receive": "\u63A5\u6536",
                "settings.receiving_video": "\u63A5\u6536\u89C6\u9891",
                "settings.receiving_video_tips": "\u4F7F\u7528\u56FE\u5F62\u5361\u7684\u786C\u4EF6\u89C6\u9891\u89E3\u7801\u5668\u6765\u4FDD\u5B58CPU\u4F7F\u7528\u7387\u63A5\u6536\u89C6\u9891\u3002\u5237\u65B0\u9875\u9762\u4EE5\u83B7\u53D6\u6B64\u66F4\u6539\u4EE5\u751F\u6548\u3002",
                "settings.recording": "\u5F55\u5236",
                "settings.rejoin": "rejoin.",
                "settings.resolution": "\u5206\u8FA8\u7387",
                "settings.send": "\u53D1\u9001",
                "settings.sending_video": "\u53D1\u9001\u89C6\u9891",
                "settings.sending_video_tips": "\u4F7F\u7528\u56FE\u5F62\u5361\u7684\u786C\u4EF6\u89C6\u9891\u89E3\u7801\u5668\u6765\u4FDD\u5B58CPU\u4F7F\u7528\u6765\u53D1\u9001\u89C6\u9891\u3002\u5237\u65B0\u9875\u9762\u4EE5\u83B7\u53D6\u6B64\u66F4\u6539\u4EE5\u751F\u6548\u3002",
                "settings.statistics": "\u7EDF\u8BA1\u4FE1\u606F",
                "settings.stop": "\u505C\u6B62",
                "settings.switch_view_mode_text": "\u60A8\u5FC5\u987B\u91CD\u65B0\u52A0\u5165\u4F1A\u8BAE\u4EE5\u5E94\u7528\u6B64\u66F4\u6539",
                "settings.test_mic": "\u6D4B\u8BD5\u9EA6\u514B\u98CE",
                "settings.test_speaker": "\u6D4B\u8BD5\u626C\u58F0\u5668",
                "settings.unknown_device": "\u672A\u77E5\u8BBE\u5907",
                "settings.use_hardware_acceleration": "\u4F7F\u7528\u786C\u4EF6\u52A0\u901F\uFF1A",
                "settings.vb_init_10s_tip2": "\u865A\u62DF\u80CC\u666F\u82B1\u8D39\u7684\u65F6\u95F4\u8D85\u8FC7\u8D1F\u8F7D\u3002",
                "settings.vb_init_fail2": "\u65E0\u6CD5\u52A0\u8F7D\u865A\u62DF\u80CC\u666F\u3002",
                "settings.video_tab_text": "\u89C6\u9891",
                speaker_view: "\u6F14\u8BB2\u8005\u89C6\u56FE",
                toolbar_join_audio: "\u8FDE\u63A5\u8BED\u97F3",
                toolbar_leave: "\u79BB\u5F00",
                toolbar_mute: "\u9759\u97F3",
                toolbar_muteall: "\u5168\u4F53\u9759\u97F3",
                toolbar_record: "\u5F55\u5236",
                toolbar_unmute: "\u89E3\u9664\u9759\u97F3",
                wait_room_tip1: "{{displayName}}\u5DF2\u8FDB\u5165\u672C\u6B21\u4F1A\u8BAE\u7684\u7B49\u5019\u5BA4",
                wait_room_tip2: "{{count}}\u4EBA\u5DF2\u8FDB\u5165\u672C\u6B21\u4F1A\u8BAE\u7684\u7B49\u5019\u5BA4",
                "wc.ast_admin_name": "\u4F1A\u8BAE\u52A9\u624B",
                "wc.rmc_admin_name": "\u4F1A\u8BAE\u63A7\u5236\u7BA1\u7406\u5458",
                "wc.rmc_admin_tooltip": "\u6B64\u7528\u6237\u62E5\u6709\u4E3B\u6301\u4EBA\u63A7\u5236\u6743\u9650\uFF0C\u4F46\u65E0\u6743\u8BBF\u95EE\u4EFB\u4F55\u5A92\u4F53\u5185\u5BB9\uFF08\u97F3\u9891\u3001\u89C6\u9891\u3001\u804A\u5929\u548C\u56DE\u5E94\uFF09\u3002",
                wc_3rd_cc_copied_api_token: "API\u51ED\u8BC1\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
                wc_3rd_cc_copy_api_token: "\u590D\u5236API\u51ED\u8BC1",
                wc_3rd_cc_service: "\u4F7F\u7528\u7B2C\u4E09\u65B9\u5B57\u5E55\u670D\u52A1",
                wc_3rd_cc_url_help_tips2: "\u590D\u5236\u6B64\u51ED\u8BC1\u5E76\u5C06\u5176\u7C98\u8D34\u5230\u7B2C\u4E09\u65B9\u5B57\u5E55\u5DE5\u5177\u4E2D",
                wc_admit: "\u51C6\u5165",
                wc_allow_to_talk: "\u5141\u8BB8\u53D1\u8A00",
                wc_audio: "\u97F3\u9891",
                "wc_audio.muted_notification1": "\u4E3B\u6301\u4EBA\u5DF2\u5C06\u4F60\u9759\u97F3",
                "wc_audio.muted_notification2": "\u4E3B\u6301\u4EBA\u5DF2\u5C06\u6240\u6709\u4EBA\u9759\u97F3",
                "wc_audio.unmute_by_host_content_1": "\u4E3B\u6301\u4EBA\u5E0C\u671B\u4F60\u53D1\u8A00",
                "wc_audio.unmute_by_host_content_2": "\u5982\u679C\u4F60\u9009\u62E9\u89E3\u9664\u9759\u97F3\uFF0C\u7F51\u7EDC\u7814\u8BA8\u4F1A\u4E2D\u7684\u5176\u4ED6\u6210\u5458\u5C06\u53EF\u4EE5\u542C\u5230\u4F60\u7684\u58F0\u97F3\u3002\u5982\u679C\u4E3B\u6301\u4EBA\u6216\u5609\u5BBE\u5728\u4F60\u89E3\u9664\u9759\u97F3\u540E\u51B3\u5B9A\u5F55\u5236\u3001\u76F4\u64AD\u6216\u5B58\u6863\u672C\u6B21\u7F51\u7EDC\u7814\u8BA8\u4F1A\uFF0C\u4F60\u7684\u58F0\u97F3\u4E5F\u5C06\u5305\u542B\u5728\u5185\u3002",
                wc_audio_cannot_unmute: "\u4E3B\u6301\u4EBA\u5DF2\u5C06\u4F60\u9759\u97F3\uFF0C\u56E0\u6B64\u4F60\u65E0\u6CD5\u81EA\u6211\u89E3\u9664\u9759\u97F3\u3002",
                wc_audio_connecting_thumbnail: "\u6B63\u5728\u8FDE\u63A5\u97F3\u9891",
                wc_broadcasting: "\u5E7F\u64AD",
                wc_btn_endconf_meeting_all: "\u7ED3\u675F\u4F1A\u8BAE",
                wc_camera_prevent: "\u4F60\u7684\u6D4F\u89C8\u5668\u7981\u6B62\u8BBF\u95EE\u60A8\u7684\u6444\u50CF\u5934\u3002\u8BF7\u542F\u7528\u8BE5\u529F\u80FD\u5E76\u91CD\u65B0\u542F\u52A8\u89C6\u9891",
                "wc_cc.placeholder": "\u5728\u6B64\u8F93\u5165\uFF0C\u6309\u56DE\u8F66\u952E\u64AD\u653E\u5B57\u5E55",
                wc_cc_assign_participant_to_type: "\u6307\u5B9A\u53C2\u4F1A\u8005\u8F93\u5165",
                wc_cc_assign_to: "\u5206\u914D\u5B57\u5E55\u8F93\u5165\u6743\u9650",
                wc_cc_assign_to_type: "\u5206\u914D\u5B57\u5E55\u8F93\u5165\u8005",
                wc_cc_broadcasting_tip: "\u5DF2\u5411\u6240\u6709\u53C2\u4F1A\u8005\u64AD\u653E\u5B57\u5E55\u3002",
                wc_cc_host_assigned: "\u4E3B\u6301\u4EBA\u5DF2\u6307\u5B9A\u4F60\u8F93\u5165\u5B57\u5E55",
                wc_cc_type_myself: "\u81EA\u884C\u8F93\u5165",
                wc_cc_withdraw: "\u6536\u56DE\u5B57\u5E55\u8F93\u5165\u6743\u9650",
                "wc_chat.attendee_chat_with": "\u89C2\u4F17\u53EF\u4EE5\u4E0E\u4EE5\u4E0B\u4EBA\u5458\u804A\u5929\uFF1A",
                "wc_chat.chat": "\u804A\u5929",
                "wc_chat.direct_message": "\uFF08\u79C1\u804A\uFF09",
                "wc_chat.disable_chat": "\u4E3B\u6301\u4EBA\u5DF2\u7981\u6B62\u89C2\u4F17\u804A\u5929\u3002",
                "wc_chat.disabled": "\u65E0",
                "wc_chat.everyone": "\u6240\u6709\u4EBA",
                "wc_chat.everyone_public": "\u6240\u6709\u4EBA\u516C\u5C4F\u804A\u5929",
                "wc_chat.everyone_public_private": "\u6240\u6709\u4EBA\u516C\u5C4F\u804A\u5929\u548C\u79C1\u804A",
                "wc_chat.host_only": "\u4EC5\u4E3B\u6301\u4EBA",
                "wc_chat.host_panelists": "\u4E3B\u6301\u4EBA\u548C\u5609\u5BBE",
                "wc_chat.me": "\u6211",
                "wc_chat.panelist_chat_with": "\u5609\u5BBE\u53EF\u4EE5\u4E0E\u4EE5\u4E0B\u4EBA\u5458\u804A\u5929\uFF1A",
                "wc_chat.type_msg": "\u5728\u6B64\u5904\u8F93\u5165\u6D88\u606F...",
                wc_closed_caption_btn: "\u5B57\u5E55",
                wc_co_host: "\uFF08\u8054\u5E2D\u4E3B\u6301\u4EBA\uFF09",
                wc_continue: "\u7EE7\u7EED",
                wc_copied: "\u5DF2\u590D\u5236",
                wc_copied_to_clipboard: "\u9080\u8BF7\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
                wc_copy_link: "\u590D\u5236\u94FE\u63A5",
                wc_data_center2: "\u4F60\u5DF2\u8FDE\u63A5\u5230\u4F01\u4E1A\u90E8\u7F72\u6570\u636E\u4E2D\u5FC3\u3002",
                wc_data_center3: "\u4F60\u5DF2\u901A\u8FC7\u4F01\u4E1A\u90E8\u7F72\u6570\u636E\u4E2D\u5FC3\u8FDE\u63A5\u5230Zoom\u5168\u7403\u7F51\u7EDC\u3002",
                wc_disable_talking: "\u7981\u6B62\u53D1\u8A00",
                wc_dlg_confirm: "\u786E\u8BA4",
                wc_enable: "\u5DF2\u542F\u7528",
                wc_encryption: "\u52A0\u5BC6",
                wc_extra_function_disable_video: "\u7981\u7528\u89C6\u9891\u63A5\u6536",
                wc_files: "\u6587\u4EF6",
                wc_footer_assign_leave: "\u6307\u5B9A\u5E76\u79BB\u5F00",
                wc_footer_assign_new_host: "\u6307\u5B9A\u4E00\u540D\u65B0\u4E3B\u6301\u4EBA",
                wc_guest: "\u8BBF\u5BA2",
                wc_host_1: "\u4E3B\u6301\u4EBA",
                wc_in_the_meeting: "\u4F1A\u8BAE\u4E2D",
                wc_invite_link: "\u9080\u8BF7\u94FE\u63A5",
                wc_join_media_preview_info_confirm: "\u77E5\u9053\u4E86",
                wc_join_media_preview_warning_denied_both: "\u5728\u6D4F\u89C8\u5668\u5730\u5740\u680F\u542F\u7528\u6444\u50CF\u5934\u548C\u9EA6\u514B\u98CE\u8BBF\u95EE\u3002",
                wc_join_media_preview_warning_denied_camera: "\u5728\u6D4F\u89C8\u5668\u5730\u5740\u680F\u542F\u7528\u6444\u50CF\u5934\u8BBF\u95EE\u3002",
                wc_join_media_preview_warning_denied_mic: "\u5728\u6D4F\u89C8\u5668\u5730\u5740\u680F\u542F\u7528\u9EA6\u514B\u98CE\u8BBF\u95EE\u3002",
                wc_joining: "\u52A0\u76DF",
                wc_joining_meeting: "\u6B63\u5728\u52A0\u5165\u4F1A\u8BAE...",
                wc_learn_more: "\u4E86\u89E3\u66F4\u591A",
                wc_leave_computer_audio: "\u79BB\u5F00\u8BA1\u7B97\u673A\u97F3\u9891",
                wc_leave_meeting: "\u79BB\u5F00\u4F1A\u8BAE",
                wc_leave_webinar: "\u79BB\u5F00\u7F51\u7EDC\u7814\u8BA8\u4F1A",
                wc_live_transcription_btn: "\u5B9E\u65F6\u8F6C\u5F55",
                wc_lock_meeting: "\u9501\u5B9A\u4F1A\u8BAE",
                wc_lower_hand: "\u624B\u653E\u4E0B",
                wc_lt_disable_transcription: "\u7981\u7528\u81EA\u52A8\u8F6C\u5F55",
                wc_lt_enable_transcription: "\u542F\u7528\u81EA\u52A8\u8F6C\u5F55",
                wc_lt_item_captioner: "\uFF08\u5B57\u5E55\u8F93\u5165\u8005\uFF09",
                wc_lt_live_transcript: "\u5B9E\u65F6\u8F6C\u5F55\u6587\u5B57",
                wc_lt_menu_item1: "\u663E\u793A\u5B57\u5E55",
                wc_lt_menu_item2: "\u67E5\u770B\u5B8C\u6574\u8F6C\u5F55\u6587\u5B57",
                wc_lt_menu_item3: "\u9690\u85CF\u5B57\u5E55",
                wc_lt_menu_item4: "\u5173\u95ED\u5B8C\u6574\u8F6C\u5F55\u6587\u5B57",
                wc_lt_request_host_ctrl: "\u5141\u8BB8\u53C2\u4F1A\u8005\u8BF7\u6C42\u542F\u7528\u5B9E\u65F6\u8F6C\u5F55",
                wc_lt_search_text: "\u641C\u7D22",
                wc_make_co_host: "\u8BBE\u4E3A\u8054\u5E2D\u4E3B\u6301\u4EBA",
                wc_make_host: "\u8BBE\u4E3A\u4E3B\u6301\u4EBA",
                wc_me: "\uFF08\u6211\uFF09",
                wc_more: "\u66F4\u591A",
                wc_no: "\u5426",
                wc_none: "\u65E0",
                wc_not_share_pronoun: "\u4E0D\u516C\u5F00",
                wc_num_password: "\u6570\u5B57\u5BC6\u7801\u7535\u8BDD/\u4F1A\u8BAE\u5BA4\u7CFB\u7EDF",
                wc_participant_id: "\u53C2\u4F1A\u8005ID",
                wc_participants: "\u53C2\u4F1A\u8005",
                wc_pc_audio: "\u8BA1\u7B97\u673A\u97F3\u9891",
                wc_prevent_access_mic: "\u6D4F\u89C8\u5668\u7981\u6B62\u8BBF\u95EE\u4F60\u7684\u9EA6\u514B\u98CE\u3002",
                wc_put_in_waiting: "\u79FB\u81F3\u7B49\u5019\u5BA4",
                "wc_qa.allQ": "\u6240\u6709\u95EE\u9898",
                "wc_qa.anonymous_attendee": "\u533F\u540D\u89C2\u4F17",
                "wc_qa.answer_private_type": "\u79C1\u4E0B\u56DE\u7B54",
                "wc_qa.answeredQ": "\u5DF2\u56DE\u7B54",
                "wc_qa.attendee_placeholder": "\u4F60\u5411\u4E3B\u6301\u4EBA\u548C\u5609\u5BBE\u63D0\u51FA\u7684\u95EE\u9898\u5C06\u663E\u793A\u5728\u6B64\u5904\u3002",
                "wc_qa.button_comment": "\u8BC4\u8BBA",
                "wc_qa.button_display_answer": "\u8F93\u5165\u56DE\u7B54",
                "wc_qa.button_live": "\u5728\u7EBF\u56DE\u7B54",
                "wc_qa.button_live_done": "\u5B8C\u6210",
                "wc_qa.button_reopen": "\u91CD\u65B0\u6253\u5F00",
                "wc_qa.collapse_all_answer": "\u5168\u90E8\u6298\u53E0",
                "wc_qa.dismissedQ": "\u5DF2\u5173\u95ED",
                "wc_qa.display_all_answer": "\u5168\u90E8\u663E\u793A",
                "wc_qa.dissmis_tips": "\u5173\u95ED",
                "wc_qa.input_tips": "\u5728\u8FD9\u91CC\u8F93\u5165\u4F60\u7684\u95EE\u9898...",
                "wc_qa.is_anonymous": "\u533F\u540D\u53D1\u9001",
                "wc_qa.is_privately": "\u79C1\u4E0B\u53D1\u9001",
                "wc_qa.live_tips_done": "\u6B64\u95EE\u9898\u5DF2\u5728\u7EBF\u56DE\u7B54",
                "wc_qa.live_tips_start": "\u5C06\u5728\u7EBF\u56DE\u7B54\u8FD9\u4E2A\u95EE\u9898",
                "wc_qa.most_recent": "\u6700\u8FD1",
                "wc_qa.most_upvotes": "\u6700\u591A\u8D5E\u540C",
                "wc_qa.myQ": "\u6211\u7684\u95EE\u9898",
                "wc_qa.no_answered_questions": "\u6CA1\u6709\u5DF2\u56DE\u7B54\u7684\u95EE\u9898",
                "wc_qa.no_dismissed_questions": "\u6CA1\u6709\u5DF2\u5173\u95ED\u7684\u95EE\u9898",
                "wc_qa.no_open_questions": "\u6CA1\u6709\u672A\u56DE\u7B54\u7684\u95EE\u9898",
                "wc_qa.no_questions": "\u4F60\u5C1A\u672A\u63D0\u51FA\u95EE\u9898",
                "wc_qa.openedQ": "\u672A\u56DE\u7B54",
                "wc_qa.panelist_host_only_placeholder": "\u53EA\u6709\u4E3B\u6301\u4EBA\u548C\u5609\u5BBE\u53EF\u4EE5\u770B\u5230\u95EE\u9898",
                "wc_qa.panelist_view_all_placehoder": "\u7F51\u7EDC\u7814\u8BA8\u4F1A\u4E2D\u7684\u6240\u6709\u4EBA\u90FD\u80FD\u770B\u5230\u672A\u56DE\u7B54\u7684\u95EE\u9898",
                "wc_qa.qa_comp_title": "\u95EE\u7B54",
                "wc_qa.send": "\u53D1\u9001",
                "wc_qa.setting_allow_view": "\u5141\u8BB8\u89C2\u4F17\u67E5\u770B",
                "wc_qa.setting_btn_name": "\u8BBE\u7F6E",
                "wc_qa.setting_option_allow_anony_question": "\u5141\u8BB8\u533F\u540D\u63D0\u95EE",
                "wc_qa.setting_option_allow_comment": "\u89C2\u4F17\u53EF\u4EE5\u8BC4\u8BBA",
                "wc_qa.setting_option_allow_view_all": "\u6240\u6709\u95EE\u9898",
                "wc_qa.setting_option_allow_view_answered": "\u4EC5\u5DF2\u56DE\u7B54\u7684\u95EE\u9898",
                "wc_qa.setting_option_allow_vote": "\u89C2\u4F17\u53EF\u4EE5\u70B9\u51FB\u8D5E\u540C",
                "wc_qa.welcome_banner": "\u53EF\u968F\u65F6\u5411\u4E3B\u6301\u4EBA\u548C\u5609\u5BBE\u63D0\u95EE",
                "wc_qa.welcome_banner_title": "\u6B22\u8FCE",
                wc_raise_hand: "\u4E3E\u624B",
                wc_reclaim_host: "\u6536\u56DE\u4E3B\u6301\u4EBA\u6743\u9650",
                wc_record_host_reminder_desc: "\u5982\u679C\u7EE7\u7EED\uFF0C\u6240\u6709\u9762\u5B54\u3001\u5BF9\u8BDD\u548C\u5C4F\u5E55\u5171\u4EAB\u5C06\u88AB\u5F55\u5236\u5230\u4E91\u7AEF\u3002",
                wc_record_reminder_desc: "\u7EE7\u7EED\u53C2\u52A0\u672C\u6B21\u4F1A\u8BAE\uFF0C\u5373\u8868\u793A\u4F60\u540C\u610F\u8FDB\u884C\u5F55\u5236\u3002",
                wc_record_reminder_desc_2: "{{accountOwner}}\u548C\u4E3B\u6301\u4EBA\u53EF\u4EE5\u89C2\u770BZoom\u4E91\u5F55\u5236\u6587\u4EF6\uFF0C\u4EFB\u4F55\u62E5\u6709\u6743\u9650\u7684\u53C2\u4F1A\u8005\u90FD\u53EF\u4EE5\u5728\u4ED6\u4EEC\u7684\u672C\u5730\u8BBE\u5907\u4E0A\u8FDB\u884C\u5F55\u5236\uFF0C\u5E76\u4E14\u53EF\u4EE5\u5C06\u5F55\u5236\u6587\u4EF6\u5206\u4EAB\u7ED9\u5176\u4ED6\u5E94\u7528\u548C\u7528\u6237\u3002",
                wc_record_reminder_title: "\u6B64\u4F1A\u8BAE\u6B63\u5728\u5F55\u5236\u4E2D",
                wc_record_reminder_webinar_title: "\u6B64\u7F51\u7EDC\u7814\u8BA8\u4F1A\u6B63\u5728\u5F55\u5236\u4E2D",
                wc_record_webinar_reminder_desc: "\u7EE7\u7EED\u53C2\u52A0\u672C\u6B21\u7F51\u7EDC\u7814\u8BA8\u4F1A\uFF0C\u5373\u8868\u793A\u4F60\u540C\u610F\u8FDB\u884C\u5F55\u5236\u3002",
                wc_recording_pause: "\u6682\u505C\u5F55\u5236",
                wc_recording_resume: "\u7EE7\u7EED\u5F55\u5236",
                wc_recording_stop: "\u505C\u6B62\u5F55\u5236",
                wc_recording_title: "\u8BB0\u5F55\u8FD9\u6B21\u4F1A\u8BAE\uFF1F",
                wc_remove: "\u79FB\u9664",
                wc_select_camera: "\u9009\u62E9\u6444\u50CF\u5934",
                wc_select_microphone: "\u9009\u62E9\u9EA6\u514B\u98CE",
                wc_select_speaker: "\u9009\u62E9\u626C\u58F0\u5668",
                wc_share_muted_while_sharing_audio_tip2: "\u5171\u4EAB\u8BA1\u7B97\u673A\u97F3\u9891\u65F6\uFF0C\u60A8\u7684\u9EA6\u514B\u98CE\u88AB\u7981\u7528\u3002\u6682\u505C\u6216\u505C\u6B62\u5171\u4EAB\u97F3\u9891\u65F6\uFF0C\u5C06\u91CD\u65B0\u6FC0\u6D3B\u9EA6\u514B\u98CE\u3002",
                wc_share_pronoun: "\u5171\u4EAB",
                wc_share_pronoun_menu: "\u516C\u5F00\u6211\u7684\u4EE3\u79F0",
                wc_share_pronoun_tip2: "\u662F\u5426\u60F3\u8981\u5728\u6B64\u4F1A\u8BAE\u4E2D\u516C\u5F00\u4F60\u7684\u4EE3\u79F0\uFF1F",
                wc_sharer_controlbar_container_button3_label: "\u505C\u6B62\u5171\u4EAB",
                wc_sharer_controlbar_container_rec_status_tip1: "\u4F60\u6B63\u5728\u5171\u4EAB\u5C4F\u5E55",
                wc_sharer_controlbar_container_rec_status_tip2: "\u4F60\u7684\u5C4F\u5E55\u5171\u4EAB\u5DF2\u6682\u505C",
                wc_sharer_disabled_share1_desc: "\u4E3B\u6301\u4EBA\u5DF2\u7981\u6B62\u89C2\u4F17\u5171\u4EAB\u5C4F\u5E55\u3002",
                wc_sharer_disabled_share2_desc: "\u5176\u4ED6\u53C2\u4F1A\u8005\u6B63\u5728\u5171\u4EAB\uFF0C\u6B64\u65F6\u4F60\u65E0\u6CD5\u8FDB\u884C\u5C4F\u5E55\u5171\u4EAB\u3002",
                wc_sharer_entry_button_label1: "\u5171\u4EAB\u5C4F\u5E55",
                wc_sharer_setting_menu_category1_title: "\u54EA\u4E9B\u4EBA\u53EF\u4EE5\u5171\u4EAB\uFF1F",
                wc_sharer_setting_menu_category2_title: "\u5F53\u5176\u4ED6\u4EBA\u5171\u4EAB\u5C4F\u5E55\u65F6\uFF0C\u54EA\u4E9B\u4EBA\u53EF\u4EE5\u5F00\u59CB\u5171\u4EAB\uFF1F",
                wc_sharer_setting_menu_category3_title: "\u591A\u5C11\u53C2\u4F1A\u8005\u53EF\u4EE5\u540C\u65F6\u5171\u4EAB\uFF1F",
                wc_sharer_setting_menu_category_option1: "\u4EC5\u4E3B\u6301\u4EBA",
                wc_sharer_setting_menu_category_option2: "\u5168\u4F53\u53C2\u4F1A\u8005",
                wc_sharer_setting_menu_item1: "\u6BCF\u6B21\u53EA\u6709\u4E00\u4F4D\u53C2\u4F1A\u8005\u53EF\u4EE5\u5171\u4EAB",
                wc_sharer_setting_menu_item2: "\u591A\u4F4D\u53C2\u4F1A\u8005\u53EF\u4EE5\u540C\u65F6\u5171\u4EAB",
                wc_sharing_fit_to_window: "\u6309\u7A97\u53E3\u5927\u5C0F\u663E\u793A",
                wc_sharing_original_size: "\u539F\u59CB\u5927\u5C0F",
                wc_sharing_shared_screens: "\u5171\u4EAB\u5C4F\u5E55",
                wc_sharing_view_options: "\u67E5\u770B\u9009\u9879",
                wc_sharing_viewing: "\u60A8\u6B63\u5728\u67E5\u770B{{displayName}}\u7684\u5C4F\u5E55",
                wc_tel_password: "\u5BC6\u7801",
                wc_unmute_by_host_btn1: "\u4FDD\u6301\u9759\u97F3",
                wc_unshare_pronoun_menu: "\u53D6\u6D88\u516C\u5F00\u6211\u7684\u4EE3\u79F0",
                "wc_video.allow_panelist_start_video": "\u5141\u8BB8\u5609\u5BBE\u5F00\u542F\u89C6\u9891",
                "wc_video.allow_participants_start_video": "\u5141\u8BB8\u53C2\u4F1A\u8005\u5F00\u542F\u89C6\u9891",
                "wc_video.ask_start_video": "\u8BF7\u6C42\u5F00\u542F\u89C6\u9891",
                "wc_video.model_stop": "\u4E3B\u6301\u4EBA\u4E0D\u5141\u8BB8\u4F60\u5728\u4F1A\u8BAE\u4E2D\u5F00\u542F\u89C6\u9891",
                "wc_video.start_video": "\u5F00\u542F\u89C6\u9891",
                "wc_video.stop_video": "\u505C\u6B62\u89C6\u9891",
                "wc_video.video": "\u89C6\u9891",
                wc_view: "\u67E5\u770B",
                wc_waiting_room: "\u7B49\u5019\u5BA4",
                "wc_webinar.change_to_attendee": "\u5C06\u89D2\u8272\u66F4\u6539\u4E3A\u89C2\u4F17",
                "wc_webinar.promote_to_panelist": "\u8BBE\u4E3A\u5609\u5BBE",
                wc_webinar_attendees: "\u89C2\u4F17",
                wc_webinar_panelists: "\u5609\u5BBE",
                wc_webinar_putonhold: "\u8BBE\u4E3A\u7B49\u5F85\u72B6\u6001",
                wc_withdraw_co_host: "\u64A4\u9500\u8054\u5E2D\u4E3B\u6301\u4EBA",
                wc_yes: "\u662F",
                websdk_enforce_update_content: "\u4F60\u5FC5\u987B\u4F7F\u7528{0}\u6216\u66F4\u9AD8\u7248\u672C\u7684\u5E94\u7528\u624D\u80FD\u52A0\u5165\u672C\u6B21\u4F1A\u8BAE\u3002\u8BF7\u66F4\u65B0\u4EE5\u7EE7\u7EED\u3002",
                websdk_update_content: "\u66F4\u65B0WebSDK\u5230\u6700\u65B0\u7248\u672C\uFF0C\u4EE5\u4F18\u5316\u4F1A\u8BAE\u4F53\u9A8C"
              }
            },
            "zh-TW": {
              translation: {
                GOT_IT: "\u77AD\u89E3",
                account_owner: "\u5E33\u6236\u64C1\u6709\u8005",
                allow_to_access: "\u5141\u8A31\u8A2A\u554F\u76F8\u6A5F\u548C\u9EA5\u514B\u98A8",
                "app_signal.approved_by": "\u5DF2\u7531\u6838\u51C6",
                "app_signal.hosts_account": "\u4E3B\u6301\u4EBA\u7684\u5E33\u6236",
                "app_signal.people": "\u500B\u4EBA",
                "app_signal.tip_text_2": "\u67E5\u770B\u6B63\u5728\u5B58\u53D6\u60A8\u6703\u8B70\u5167\u5BB9\u7684\u61C9\u7528\u7A0B\u5F0F",
                "app_signal.unable_load2": "\u7121\u6CD5\u8F09\u5165\u53EF\u5373\u6642\u5B58\u53D6\u60A8\u7684\u8CC7\u8A0A\u7684\u61C9\u7528\u7A0B\u5F0F\u3002",
                "archiving.chat_1": "\u804A\u5929\uFF08\u516C\u958B\u548C\u4E00\u5C0D\u4E00\uFF09",
                "archiving.chat_2": "\u804A\u5929\uFF08\u50C5\u9650\u516C\u958B\uFF09",
                "archiving.chat_disable_content": "\u70BA\u9075\u5FAA\u5408\u898F\u76EE\u7684\uFF0C\u5728\u804A\u5929\u4E2D\u50B3\u9001\u7684\u8A0A\u606F\u7121\u6CD5\u5C01\u5B58\u3002",
                "archiving.chat_disable_title": "\u5DF2\u505C\u7528\u804A\u5929",
                "archiving.content1_sdk": "\u672C\u6703\u8B70\u6709\u4E00\u540D\u6216\u591A\u540D\u8207\u6703\u8005\u5C07\u4F9D\u64DA\u5176\u5E33\u6236\u653F\u7B56\u9032\u884C\u5C01\u5B58\u3002\u5176{{content}}\u5C07\u6703\u6536\u5230\u6709\u95DC\u672C\u6703\u8B70\u7684\u5167\u5BB9\uFF0C\u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "archiving.content2_sdk": "\u82E5\u7559\u5728\u672C\u6703\u8B70\u5167\uFF0C\u5373\u8868\u793A\u60A8\u540C\u610F\u5C01\u5B58\u672C\u6703\u8B70\u7684{{content}}\u3002",
                "archiving.default_title": "\u6B63\u5728\u5C01\u5B58\u6B64\u6703\u8B70",
                "archiving.fail_content_sdk": "\u70BA\u9075\u5FAA\u5408\u898F\u76EE\u7684\uFF0C\u5FC5\u9808\u5C01\u5B58\u672C\u6703\u8B70\u7684{{features}}\u3002",
                "archiving.fail_title": "\u5C01\u5B58\u5931\u6557",
                "archiving.subjects_combo_2_sdk": "{{0}}\u548C{{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}\u3001{{1}}\u548C{{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}\u3001{{1}}\u3001{{2}}\u548C{{3}}",
                "archiving.tips_1_sdk": "\u4E3B\u6301\u4EBA\u6240\u5728\u7D44\u7E54\u6B63\u4F9D\u64DA\u5176\u5E33\u6236\u653F\u7B56\u4F86\u5C01\u5B58\u672C\u6703\u8B70\u7684{{subjects}}\u3002\u5176{{receiver}}\u5C07\u6703\u6536\u5230\u6709\u95DC\u672C\u6703\u8B70\u7684\u5167\u5BB9\uFF0C\u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "archiving.tips_2_sdk": "\u4E3B\u6301\u4EBA\u6240\u5728\u7D44\u7E54\u6B63\u4F9D\u64DA\u5176\u5E33\u6236\u653F\u7B56\u4F86\u5C01\u5B58\u672C\u6703\u8B70\u7684{{subjects}}\u3002\u5176{{receiver}}\u5C07\u6703\u6536\u5230\u6709\u95DC\u672C\u6703\u8B70\u7684\u5167\u5BB9\uFF0C\u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "archiving.transcription": "\u8F49\u9304\u6587\u5B57",
                "ast.leave_tip": "\u52A9\u7406\u5DF2\u505C\u6B62\u63A7\u5236\u6703\u8B70\u3002",
                "ast.tip": "\u6B64\u6703\u8B70\u6B63\u7531\u52A9\u7406\u63A7\u5236",
                background: "\u80CC\u666F",
                chat_message_header: "<0> {{senderName}} </0> <1>\u5230</1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}}\u5247\u65B0\u8A0A\u606F",
                chat_receiver_co_host: "\uFF08\u806F\u5E2D\u4E3B\u6301\u4EBA\uFF09",
                chat_receiver_host: "\uFF08\u4E3B\u6301\u4EBA\uFF09",
                chat_receiver_panelist: "\uFF08\u5609\u8CD3\uFF09",
                chat_receiver_to: "\u81F3\uFF1A",
                choose_background: "\u9078\u64C7\u80CC\u666F",
                click_address_bar: "\u55AE\u64CA\u5730\u5740\u6B04\u5DE6\u5074\u7684\u9396\u5B9A\u5716\u6A19\u3002\u5F48\u51FA\u7A97\u53E3\u5C07\u986F\u793A\u6709\u9078\u9805\u5217\u8868\u3002",
                click_microphone_camera_option: "\u55AE\u64CA\u651D\u50CF\u6A5F\u53F3\u5074\u7684\u4E0B\u62C9\u5217\u8868\u548C\u9EA5\u514B\u98A8\u9078\u9805\u3002",
                "common.cancel": "\u53D6\u6D88",
                "common.connecting": "\u9023\u63A5\u4E2D",
                delete: "\u522A\u9664",
                "dialog.btn_cancel": "\u53D6\u6D88",
                "dialog.btn_endconf_webinar": "\u7D50\u675F\u7DB2\u8DEF\u7814\u8A0E\u6703",
                "dialog.btn_leaveconf_meeting": "\u96E2\u958B\u6703\u8B70",
                "dialog.btn_retry": "\u91CD\u8A66",
                "dialog.host_end_meeting": "\u4E3B\u6301\u4EBA\u5DF2\u7D50\u675F\u8A72\u6703\u8B70\u3002",
                "dialog.host_end_webinar": "\u4E3B\u6301\u4EBA\u5DF2\u7D50\u675F\u8A72\u7DB2\u8DEF\u7814\u8A0E\u6703\u3002",
                "dialog.meeting_ended": "\u6703\u8B70\u5DF2\u7D50\u675F",
                "dialog.meeting_locked": "\u6703\u8B70\u5DF2\u88AB\u9396\u5B9A",
                "dialog.meeting_removed_by_host": "\u4E3B\u6301\u4EBA\u5DF2\u5C07\u60A8\u5F9E\u8A72\u6703\u8B70\u4E2D\u522A\u9664\u3002",
                "dialog.newname": "\u540D\u7A31",
                "dialog.ok": "\u78BA\u5B9A",
                "dialog.presscode": "\u6703\u8B70\u865F",
                "dialog.rename": "\u91CD\u65B0\u547D\u540D",
                "dialog.server_error": "\u4F3A\u670D\u5668\u9047\u5230\u5167\u90E8\u932F\u8AA4\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8981\u6C42\u3002",
                "dialog.webinar_ended": "\u7DB2\u8DEF\u7814\u8A0E\u6703\u5DF2\u7D50\u675F",
                "dialog.webinar_removed_by_host": "\u4E3B\u6301\u4EBA\u5DF2\u5C07\u60A8\u5F9E\u8A72\u7DB2\u8DEF\u7814\u8A0E\u6703\u4E2D\u522A\u9664\u3002",
                "dialog.you_are_removed": "\u60A8\u5DF2\u88AB\u522A\u9664",
                dialog_make_cohost: "\u60A8\u662F\u5426\u8981\u5C07{{displayName}}\u8A2D\u70BA\u672C\u6B21\u6703\u8B70\u7684\u806F\u5E2D\u4E3B\u6301\u4EBA\uFF1F",
                dialog_make_host: "\u60A8\u662F\u5426\u8981\u5C07\u4E3B\u6301\u4EBA\u8B8A\u66F4\u70BA{{displayName}}\uFF1F",
                dialog_remove_user: "\u662F\u5426\u8981\u79FB\u9664{{displayName}}\uFF1F",
                "disclaimer.LT_button_1": "\u8AB0\u80FD\u5920\u770B\u5230\u6B64\u8F49\u9304\u6587\u5B57\uFF1F",
                "disclaimer.LT_content_1_1": "\u5E33\u6236\u64C1\u6709\u8005\u53CA\u6703\u8B70\u4E2D\u7684\u6240\u6709\u4EBA\u5747\u53EF\u5132\u5B58\u6B64\u8F49\u9304\u6587\u5B57\uFF0C\u4E26\u80FD\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.LT_content_2": "\u5DF2\u555F\u7528\u5373\u6642\u8F49\u9304\u6587\u5B57\uFF08\u5B57\u5E55\uFF09",
                "disclaimer.QA_button_1": "\u8AB0\u80FD\u5920\u770B\u5230\u60A8\u7684\u554F\u984C\uFF1F",
                "disclaimer.QA_content_1_1": "\u5E33\u6236\u64C1\u6709\u8005\u3001\u4E3B\u6301\u4EBA\u4EE5\u53CA\u5609\u8CD3\u5C07\u80FD\u770B\u5230\u60A8\u7684\u8EAB\u5206\u3001\u60A8\u7684\u806F\u7D61\u8CC7\u8A0A\uFF08\u82E5\u60A8\u5DF2\u767B\u5165\u6216\u5DF2\u63D0\u4F9B\u8A72\u8CC7\u8A0A\uFF09\u4EE5\u53CA\u60A8\u7684\u554F\u984C - \u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.QA_content_2": "\u82E5\u60A8\u7684\u554F\u984C\u7372\u9078\uFF0C\u5247\u6240\u6709\u89C0\u773E\u90FD\u80FD\u770B\u898B\u8A72\u554F\u984C\u3002",
                "disclaimer.QA_content_3_3": "\u9664\u975E\u60A8\u4EE5\u533F\u540D\u65B9\u5F0F\u63D0\u4EA4\uFF0C\u5426\u5247\u5E33\u6236\u64C1\u6709\u8005\u3001\u4E3B\u6301\u4EBA\u4EE5\u53CA\u5609\u8CD3\u5C07\u80FD\u770B\u5230\u60A8\u7684\u8EAB\u5206\u3001\u60A8\u7684\u806F\u7D61\u8CC7\u8A0A\uFF08\u82E5\u60A8\u5DF2\u767B\u5165\u6216\u5DF2\u63D0\u4F9B\u8A72\u8CC7\u8A0A\uFF09\u4EE5\u53CA\u60A8\u7684\u554F\u984C - \u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.QA_content_4": "\u6B64\u554F\u8207\u7B54\u5C6C\u516C\u958B\u5F62\u5F0F\uFF0C\u56E0\u6B64\u6240\u6709\u4EBA\u90FD\u80FD\u770B\u898B\u60A8\u7684\u554F\u984C\u3002",
                "disclaimer.QA_content_5": "\u82E5\u60A8\u4EE5\u533F\u540D\u65B9\u5F0F\u63D0\u4EA4\u554F\u984C\uFF0C\u5247\u6C92\u6709\u4EBA\u6703\u77E5\u9053\u662F\u8AB0\u63D0\u4EA4\u7684\u554F\u984C\u3002",
                "disclaimer.chat_button_normal": "\u8AB0\u80FD\u5920\u770B\u5230\u60A8\u7684\u8A0A\u606F\uFF1F",
                "disclaimer.chat_button_onArchiving": "\u8AB0\u80FD\u5920\u770B\u5230\u60A8\u7684\u8A0A\u606F\uFF1F\u5DF2\u555F\u7528\u5C01\u5B58",
                "disclaimer.chat_button_onRecording": "\u8AB0\u80FD\u5920\u770B\u5230\u60A8\u7684\u8A0A\u606F\uFF1F\u555F\u52D5\u9304\u88FD",
                "disclaimer.chat_content_1": "\u6703\u8B70\u4E2D\u7684\u6240\u6709\u4EBA\u5747\u53EF\u770B\u898B\u4E26\u5132\u5B58\u60A8\u8207\u6240\u6709\u4EBA\u4E4B\u9593\u7684\u8A0A\u606F - \u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.chat_content_2": "\u53EA\u6709\u60A8\u8207\u60A8\u7684\u804A\u5929\u5C0D\u8C61\u53EF\u5132\u5B58\u60A8\u7684\u79C1\u5BC6\u8A0A\u606F\uFF0C\u4EE5\u53CA\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.chat_content_3": "\u5DF2\u555F\u7528\u9304\u88FD\uFF0C\u56E0\u6B64\u5E33\u6236\u64C1\u6709\u8005\u53CA\u6703\u8B70\u4E2D\u7684\u6240\u6709\u4EBA\u5747\u53EF\u770B\u898B\u4E26\u5132\u5B58\u50B3\u9001\u7D66\u6240\u6709\u4EBA\u7684\u8A0A\u606F - \u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.chat_content_4": "\u5DF2\u555F\u7528\u9304\u88FD\uFF0C\u56E0\u6B64\u6703\u8B70\u4E2D\u7684\u6240\u6709\u4EBA\u5747\u53EF\u770B\u898B\u4E26\u5132\u5B58\u50B3\u9001\u7D66\u6240\u6709\u4EBA\u7684\u8A0A\u606F - \u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.chat_content_5": "\u5DF2\u555F\u7528\u5C01\u5B58\uFF0C\u56E0\u6B64\u5E33\u6236\u64C1\u6709\u8005\u53EF\u770B\u5230\u60A8\u7684\u6240\u6709\u8A0A\u606F \u2014 \u5305\u62EC\u60A8\u7684\u79C1\u5BC6\u8A0A\u606F \u2014 \u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                "disclaimer.chat_content_6": "\u6703\u8B70\u4E2D\u7684\u6BCF\u500B\u4EBA\u90FD\u80FD\u5132\u5B58\u53CA\u5206\u4EAB\u60A8\u50B3\u9001\u7D66\u6240\u6709\u4EBA\u7684\u8A0A\u606F\u3002",
                "disclaimer.chat_content_7": "\u5DF2\u555F\u7528\u5C01\u5B58\uFF0C\u56E0\u6B64\u5E33\u6236\u64C1\u6709\u8005\u53EF\u770B\u5230\u60A8\u7684\u6240\u6709\u8A0A\u606F - \u4E0D\u5305\u62EC\u60A8\u7684\u79C1\u5BC6\u8A0A\u606F - \u4E26\u53EF\u4EE5\u5C07\u5176\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                errorcodes_be_removed: "\u88AB\u522A\u9664\u3002",
                errorcodes_denied_email: "\u96FB\u5B50\u90F5\u4EF6\u662F\u7531\u7BA1\u7406\u54E1\u963B\u6B62\u3002",
                errorcodes_denied_register_with_panelist: "\u88AB\u62D2\u7D55\u767B\u8A18\u4F7F\u7528\u5C0F\u7D44\u6210\u54E1\u7684\u96FB\u5B50\u90F5\u4EF6\u3002",
                errorcodes_disconnect: "\u6703\u8B70\u5DF2\u65B7\u958B\u3002",
                errorcodes_email_require: "\u96FB\u5B50\u90F5\u4EF6\u4E1F\u5931\u51FA\u5E2D\u7814\u8A0E\u6703\u3002",
                errorcodes_fail: "\u7121\u6CD5\u52A0\u5165\u6703\u8B70\u3002",
                errorcodes_frequent_call: "\u60A8\u5DF2\u9054\u5230\u8A72\u547C\u53EB\u7684API\u9650\u5236\u3002",
                errorcodes_frequent_join: "\u60A8\u53EF\u4EE5\u901A\u904E\u8B8A\u7126\u662F\u6975\u9650\uFF0C\u9700\u8981\u6AA2\u67E5\u9A57\u8B49\u78BC\u3002",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "\u5F9E\u700F\u89BD\u5668\u7121\u6CD5\u52A0\u5165\uFF0C\u8ACB\u52A0\u5165\u4F7F\u7528\u7E2E\u653E\u684C\u9762\u5BA2\u6236\u7AEF\u6216\u79FB\u52D5\u61C9\u7528\u7A0B\u5E8F\u3002",
                errorcodes_not_exist: "\u6703\u8B70\u4E0D\u5B58\u5728\u3002",
                errorcodes_not_host: "\u4F60\u662F\u4E0D\u662F\u6703\u8B70\u4E3B\u6301\u4EBA\u3002",
                errorcodes_not_init: "\u6703\u8B70\u672A\u521D\u59CB\u5316\u3002",
                errorcodes_not_start: "\u6703\u8B70\u9084\u6C92\u6709\u958B\u59CB",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "\u8A72\u670D\u52D9\u66AB\u6642\u8655\u65BC\u96E2\u7DDA\u72C0\u614B\u3002",
                errorcodes_pac_api_disabled: "\u8A72\u8CEC\u6236\u7684API\u5BC6\u9470\u6642\u8655\u65BC\u95DC\u9589\u72C0\u614B\u3002",
                errorcodes_pac_api_wrong: "\u8A72\u8CEC\u6236API\u5BC6\u9470\u7121\u6548\u3002",
                errorcodes_pac_cant_host_other_mn: "\u4E0D\u53EF\u4E0D\u540C\u6642\u8209\u8FA6\u53E6\u4E00\u6B21\u6703\u8B70\u3002",
                errorcodes_pac_host_not_found: "\u6703\u8B70\u4E3B\u6301\u4EBA\u672A\u627E\u5230\u3002",
                errorcodes_pac_invalid_signature: "\u7C3D\u540D\u662F\u7121\u6548\u7684\u3002",
                errorcodes_pac_mn_not_fount: "\u6703\u8B70\u865F\u78BC\u6C92\u6709\u627E\u5230\u3002",
                errorcodes_pac_mn_wrong: "\u6703\u8B70\u865F\u78BC\u662F\u932F\u7684\u3002",
                errorcodes_pac_no_permission: "\u7121\u6B0A\u9650\u3002",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "\u4E0D\u6B63\u78BA\u7684\u89D2\u8272\u3002",
                errorcodes_pac_signature_expired: "\u7C3D\u540D\u5DF2\u904E\u671F\u3002",
                errorcodes_re_connect: "\u6703\u8B70\u91CD\u65B0\u9023\u63A5\u3002",
                errorcodes_register: "\u672C\u6B21\u6703\u8B70\u9700\u8981\u8A3B\u518A\u3002",
                errorcodes_rwc_empty: "\u7121\u6CD5\u7372\u53D6\u4F86\u81EAWeb\u670D\u52D9\u5668\u7684\u97FF\u61C9\u3002",
                errorcodes_rwc_error: "\u7121\u6CD5\u9023\u63A5\u5230Web\u670D\u52D9\u5668\u932F\u8AA4\u3002",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "\u6210\u529F\u52A0\u5165\u6703\u8B70\u3002",
                errorcodes_tk_expired: "\u4EE4\u724C\u5DF2\u904E\u671F\u3002",
                errorcodes_wasm_fail: "\u4E0B\u8F09\u6587\u4EF6WASM\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u60A8\u7684\u7DB2\u7D61\u548C\u9632\u706B\u7246\u3002",
                errorcodes_web_has_in_progress: "\u5DF2\u6709\u5176\u4ED6\u6703\u8B70\u6B63\u5728\u9032\u884C\u4E2D\u3002",
                errorcodes_web_host_not_exit: "\u6703\u8B70\u4E3B\u6301\u4EBA\u4E0D\u5B58\u5728\u3002",
                errorcodes_web_invalid_id: "\u7121\u6548\u7684\u6703\u8B70 ID \u3002",
                errorcodes_web_not_allow_start_webinar_from_web: "\u4E0D\u5141\u8A31\u5F9E Web \u958B\u59CB\u7DB2\u8DEF\u7814\u8A0E\u6703\u3002",
                errorcodes_web_not_support_registration_webinar: "\u4E0D\u652F\u63F4\u8A3B\u518A\u7DB2\u8DEF\u7814\u8A0E\u6703",
                errorcodes_web_not_support_tsp: "\u7576\u60A8\u9078\u64C7\u96FB\u8A71\u8A9E\u97F3\u670D\u52D9\u4F9B\u61C9\u5546\u505A\u70BA\u6703\u8B70\u8A9E\u97F3\u4F7F\u7528\u6642\uFF0C\u4E0D\u652F\u63F4\u7D93\u7531\u7DB2\u9801\u53EC\u958B\u6216\u52A0\u5165\u6703\u8B70\u3002",
                errorcodes_web_not_support_webclient: "\u4E0D\u652F\u63F4\u5F9E Web \u958B\u59CB\u6216\u52A0\u5165\u6703\u8B70\u3002",
                errorcodes_web_not_support_webinar_pac: "\u4E0D\u652F\u63F4\u7DB2\u8DEF\u7814\u8A0E\u6703\u548C\u500B\u4EBA\u97F3\u8A0A\u6703\u8B70",
                errorcodes_web_require_email: "\u5FC5\u9808\u63D0\u4F9B\u4F7F\u7528\u8005\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002",
                errorcodes_web_should_support_webinar_with_latest_version: "\u76EE\u524D\u7684 SDK \u7248\u672C\u4E0D\u652F\u63F4\u7DB2\u8DEF\u7814\u8A0E\u6703\uFF0C\u8ACB\u5347\u7D1A\u81F3\u6700\u65B0\u7248\u672C\u3002",
                errorcodes_wrong_pass: "\u6703\u8B70\u5BC6\u78BC\u932F\u8AA4\u3002",
                gallary_view: "\u5716\u5EAB\u6AA2\u8996",
                invalid_parameter: "\u7121\u6548\u7684\u53C3\u6578",
                "invite.loading": "\u8F09\u5165\u4E2D...",
                meeting_disconnected: "\u6703\u8B70\u65B7\u958B",
                meeting_info: "\u6703\u8B70\u8A0A\u606F",
                meeting_info_network: "\u60A8\u901A\u904E{{dc}}\u4E2D\u7684\u6578\u64DA\u4E2D\u5FC3\u9023\u63A5\u5230{{network}}",
                meeting_not_start: "\u6703\u8B70\u5C1A\u672A\u958B\u59CB",
                meeting_taking: "\u6B63\u5728\u767C\u8A00\uFF1A",
                meeting_waiting_for_start: "\u7B49\u5F85\u6703\u8B70\u958B\u59CB",
                meeting_waiting_room: "\u4E3B\u6301\u4EBA\u6703\u5F88\u5FEB\u8B93\u4F60",
                minimized_view: "\u6700\u5C0F\u5316\u7684\u8996\u5716",
                mirror_my_video: "\u93E1\u5C04\u6211\u7684\u8996\u8A0A",
                "polling.Back": "\u8FD4\u56DE",
                "promote.cancel": "\u7E7C\u7E8C\u4EE5\u89C0\u773E\u8EAB\u5206\u53C3\u6703",
                "promote.content_1": "\u8EAB\u70BA\u5609\u8CD3\uFF0C\u60A8\u53EF\u4EE5\u89E3\u9664\u975C\u97F3\u4E26\u958B\u555F\u8996\u8A0A\uFF0C\u9019\u4E5F\u4EE3\u8868\u8457\u7DB2\u8DEF\u7814\u8A0E\u6703\u5167\u7684\u5176\u4ED6\u4EBA\u5C07\u6703\u770B\u5230\u60A8\u3002",
                "promote.content_2": "\u82E5\u4E3B\u6301\u4EBA\u6216\u5176\u4ED6\u5609\u8CD3\u6C7A\u5B9A\u5728\u60A8\u89E3\u9664\u975C\u97F3\u5F8C\u9304\u88FD\u3001\u76F4\u64AD\u6216\u5C01\u5B58\u8A72\u7DB2\u8DEF\u7814\u8A0E\u6703\uFF0C\u5247\u60A8\u81EA\u8EAB\u7684\u53C3\u8207\u904E\u7A0B\u5C07\u6703\u5305\u62EC\u5728\u5176\u4E2D\u3002",
                "promote.ok": "\u4EE5\u5609\u8CD3\u8EAB\u5206\u52A0\u5165",
                "promote.title": "\u4E3B\u6301\u4EBA\u60F3\u5C07\u60A8\u8A2D\u70BA\u5609\u8CD3",
                ribbon_view: "\u7D72\u5E36\u8996\u5716",
                "rmc.assistant_exist_warning": "\u60A8\u7121\u6CD5\u63A7\u5236\u6B64\u6703\u8B70\uFF0C\u56E0\u70BA\u8A72\u6703\u8B70\u76EE\u524D\u6B63\u7531\u53E6\u4E00\u4F4D\u52A9\u7406\u6240\u63A7\u5236\u3002",
                "rmc.exist_notification_for_client_host": "\u6B64\u6703\u8B70\u6B63\u7531\u7BA1\u7406\u54E1\u63A7\u5236\u3002",
                "rmc.not_exist_notification_for_client_host": "\u7BA1\u7406\u54E1\u5DF2\u505C\u6B62\u63A7\u5236\u6703\u8B70\u3002",
                same_as_system: "\u8207\u7CFB\u7D71\u76F8\u540C",
                "security.allow_participants_to": "\u5141\u8A31\u8207\u6703\u8005\uFF1A",
                "security.button": "\u5B89\u5168\u6027",
                "security.waiting_room": "\u555F\u7528\u7B49\u5019\u5BA4",
                select_allow: "\u9078\u64C7\u9078\u9805\u5141\u8A31\u3002",
                "settings.audio_tab_text": "\u97F3\u8A0A",
                "settings.enable_hd": "\u555F\u7528\u9AD8\u6E05\u8996\u983B",
                "settings.enable_hd_tip": "\u4F7F\u6240\u6709\u53C3\u8207\u8005\u80FD\u5920\u4EE5\u9AD8\u5206\u8FA8\u7387[720p\uFF09\u67E5\u770B\u60A8\u7684\u8996\u983B\u3002\u8ACB\u6CE8\u610F\uFF0C\u5BE6\u969B\u7D50\u679C\u53D6\u6C7A\u65BC\u6A5F\u5668\u6027\u80FD\u548C\u5E36\u5BEC\u3002",
                "settings.frame_per_second": "\u5E40\u7387",
                "settings.frequency": "\u983B\u7387",
                "settings.input_level": "\u8F38\u5165\u7B49\u7D1A\uFF1A",
                "settings.item_name": "\u7D71\u8A08\u9805\u76EE",
                "settings.jitter": "\u6296\u52D5",
                "settings.latency": "\u5EF6\u9072",
                "settings.maximum_view": "\u5728\u5716\u5EAB\u6AA2\u8996\u4E2D\u6BCF\u500B\u756B\u9762\u4E2D\u6700\u591A\u53EF\u986F\u793A\u7684\u8207\u6703\u8005\u4EBA\u6578\uFF1A",
                "settings.output_level": "\u8F38\u51FA\u7B49\u7D1A\uFF1A",
                "settings.packet_loss": "\u5C01\u5305\u907A\u5931\u7387 - \u5E73\u5747\u503C\uFF08\u6700\u5927\u503C\uFF09",
                "settings.participants25": "25\u8207\u6703\u8005",
                "settings.participants9": "9\u8207\u6703\u8005",
                "settings.playing": "\u64AD\u653E\u4E2D",
                "settings.receive": "\u63A5\u6536",
                "settings.receiving_video": "\u63A5\u6536\u8996\u983B",
                "settings.receiving_video_tips": "\u4F7F\u7528\u5716\u5F62\u5361\u7684\u786C\u4EF6\u8996\u983B\u89E3\u78BC\u5668\u4F86\u4FDD\u5B58CPU\u4F7F\u7528\u7387\u63A5\u6536\u8996\u983B\u3002\u5237\u65B0\u9801\u9762\u4EE5\u7372\u53D6\u6B64\u66F4\u6539\u4EE5\u751F\u6548\u3002",
                "settings.recording": "\u9304\u88FD",
                "settings.rejoin": "rejoin.",
                "settings.resolution": "\u89E3\u6790\u5EA6",
                "settings.send": "\u50B3\u9001",
                "settings.sending_video": "\u767C\u9001\u8996\u983B",
                "settings.sending_video_tips": "\u4F7F\u7528\u5716\u5F62\u5361\u7684\u786C\u4EF6\u8996\u983B\u89E3\u78BC\u5668\u4F86\u4FDD\u5B58CPU\u4F7F\u7528\u4F86\u767C\u9001\u8996\u983B\u3002\u5237\u65B0\u9801\u9762\u4EE5\u7372\u53D6\u6B64\u66F4\u6539\u4EE5\u751F\u6548\u3002",
                "settings.statistics": "\u7D71\u8A08\u8CC7\u6599",
                "settings.stop": "\u505C\u6B62",
                "settings.switch_view_mode_text": "\u60A8\u5FC5\u9808\u91CD\u65B0\u52A0\u5165\u6703\u8B70\u4EE5\u61C9\u7528\u6B64\u66F4\u6539",
                "settings.test_mic": "\u6E2C\u8A66\u9EA5\u514B\u98A8",
                "settings.test_speaker": "\u6E2C\u8A66\u5587\u53ED",
                "settings.unknown_device": "\u672A\u77E5\u8A2D\u5099",
                "settings.use_hardware_acceleration": "\u4F7F\u7528\u786C\u4EF6\u52A0\u901F\uFF1A",
                "settings.vb_init_10s_tip2": "\u865B\u64EC\u80CC\u666F\u82B1\u8CBB\u7684\u6642\u9593\u8D85\u904E\u8CA0\u8F09\u3002",
                "settings.vb_init_fail2": "\u7121\u6CD5\u52A0\u8F09\u865B\u64EC\u80CC\u666F\u3002",
                "settings.video_tab_text": "\u8996\u8A0A",
                speaker_view: "\u6F14\u8B1B\u8005\u6AA2\u8996",
                toolbar_join_audio: "\u52A0\u5165\u97F3\u8A0A",
                toolbar_leave: "\u96E2\u958B",
                toolbar_mute: "\u975C\u97F3",
                toolbar_muteall: "\u5168\u9AD4\u975C\u97F3",
                toolbar_record: "\u9304\u88FD",
                toolbar_unmute: "\u89E3\u9664\u975C\u97F3",
                wait_room_tip1: "{{displayName}}\u5DF2\u9032\u5165\u672C\u6703\u8B70\u7684\u7B49\u5019\u5BA4",
                wait_room_tip2: "{{count}}\u500B\u4EBA\u5DF2\u9032\u5165\u672C\u6703\u8B70\u7684\u7B49\u5019\u5BA4",
                "wc.ast_admin_name": "\u6703\u8B70\u52A9\u7406",
                "wc.rmc_admin_name": "\u6703\u8B70\u63A7\u5236\u7BA1\u7406\u54E1",
                "wc.rmc_admin_tooltip": "\u6B64\u4F4D\u4F7F\u7528\u8005\u64C1\u6709\u4E3B\u6301\u4EBA\u63A7\u5236\u6B0A\u9650\uFF0C\u4F46\u7121\u6B0A\u5B58\u53D6\u4EFB\u4F55\u5A92\u9AD4\u5167\u5BB9\uFF08\u97F3\u8A0A\u3001\u8996\u8A0A\u3001\u804A\u5929\u548C\u56DE\u61C9\uFF09\u3002",
                wc_3rd_cc_copied_api_token: "API\u6B0A\u6756\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
                wc_3rd_cc_copy_api_token: "\u8907\u88FDAPI\u6B0A\u6756",
                wc_3rd_cc_service: "\u4F7F\u7528\u7B2C\u4E09\u65B9\u5B57\u5E55\u670D\u52D9",
                wc_3rd_cc_url_help_tips2: "\u8907\u88FD\u6B64\u6B0A\u6756\u4E26\u5C07\u5176\u8CBC\u81F3\u7B2C\u4E09\u65B9\u5B57\u5E55\u5DE5\u5177",
                wc_admit: "\u51C6\u5165",
                wc_allow_to_talk: "\u5141\u8A31\u767C\u8A00",
                wc_audio: "\u97F3\u8A0A",
                "wc_audio.muted_notification1": "\u4E3B\u6301\u4EBA\u5DF2\u5C07\u60A8\u975C\u97F3",
                "wc_audio.muted_notification2": "\u4E3B\u6301\u4EBA\u5DF2\u5C07\u6240\u6709\u4EBA\u975C\u97F3",
                "wc_audio.unmute_by_host_content_1": "\u4E3B\u6301\u4EBA\u60F3\u8B93\u60A8\u767C\u8A00",
                "wc_audio.unmute_by_host_content_2": "\u82E5\u60A8\u9078\u64C7\u89E3\u9664\u975C\u97F3\uFF0C\u5247\u7DB2\u8DEF\u7814\u8A0E\u6703\u5167\u7684\u5176\u4ED6\u4EBA\u5C07\u80FD\u807D\u898B\u60A8\u7684\u8072\u97F3\u3002\u82E5\u4E3B\u6301\u4EBA\u6216\u5609\u8CD3\u6C7A\u5B9A\u5728\u60A8\u89E3\u9664\u975C\u97F3\u5F8C\u9304\u88FD\u3001\u76F4\u64AD\u6216\u5C01\u5B58\u8A72\u7DB2\u8DEF\u7814\u8A0E\u6703\uFF0C\u5247\u60A8\u7684\u8072\u97F3\u5C07\u6703\u5305\u62EC\u5728\u5176\u4E2D\u3002",
                wc_audio_cannot_unmute: "\u7531\u65BC\u4E3B\u6301\u4EBA\u5DF2\u5C07\u60A8\u975C\u97F3\uFF0C\u6240\u4EE5\u60A8\u7121\u6CD5\u81EA\u884C\u89E3\u9664\u975C\u97F3\u3002",
                wc_audio_connecting_thumbnail: "\u6B63\u5728\u9023\u63A5\u81F3\u97F3\u8A0A",
                wc_broadcasting: "\u5EE3\u64AD",
                wc_btn_endconf_meeting_all: "\u7D50\u675F\u6703\u8B70",
                wc_camera_prevent: "\u60A8\u7684\u700F\u89BD\u5668\u963B\u6B62\u60A8\u5B58\u53D6\u60A8\u7684\u651D\u5F71\u6A5F\u3002\u8ACB\u555F\u7528\u8A72\u529F\u80FD\u4E26\u91CD\u65B0\u555F\u52D5\u60A8\u7684\u8996\u8A0A",
                "wc_cc.placeholder": "\u5728\u6B64\u8F38\u5165\uFF0C\u6309Enter\u64AD\u653E\u5B57\u5E55",
                wc_cc_assign_participant_to_type: "\u6307\u6D3E\u8207\u6703\u8005\u8F38\u5165",
                wc_cc_assign_to: "\u6307\u6D3E\u5B57\u5E55\u8F38\u5165\u6B0A\u9650",
                wc_cc_assign_to_type: "\u6307\u6D3E\u5B57\u5E55\u8F38\u5165\u8005",
                wc_cc_broadcasting_tip: "\u5DF2\u5411\u6240\u6709\u8207\u6703\u8005\u64AD\u653E\u5B57\u5E55\u3002",
                wc_cc_host_assigned: "\u4E3B\u6301\u4EBA\u5DF2\u6307\u6D3E\u60A8\u8F38\u5165\u5B57\u5E55",
                wc_cc_type_myself: "\u81EA\u884C\u8F38\u5165",
                wc_cc_withdraw: "\u6536\u56DE\u5B57\u5E55\u8F38\u5165\u6B0A\u9650",
                "wc_chat.attendee_chat_with": "\u89C0\u773E\u53EF\u8207\u4E0B\u5217\u5C0D\u8C61\u804A\u5929\uFF1A",
                "wc_chat.chat": "\u804A\u5929",
                "wc_chat.direct_message": "\uFF08\u79C1\u5BC6\u8A0A\u606F\uFF09",
                "wc_chat.disable_chat": "\u4E3B\u6301\u4EBA\u5DF2\u7981\u6B62\u89C0\u773E\u804A\u5929\u3002",
                "wc_chat.disabled": "\u7121",
                "wc_chat.everyone": "\u6240\u6709\u4EBA",
                "wc_chat.everyone_public": "\u6240\u6709\u4EBA\u4EE5\u516C\u958B\u65B9\u5F0F",
                "wc_chat.everyone_public_private": "\u6240\u6709\u4EBA\u4EE5\u516C\u958B\u6216\u79C1\u4E0B\u65B9\u5F0F",
                "wc_chat.host_only": "\u50C5\u4E3B\u6301\u4EBA",
                "wc_chat.host_panelists": "\u4E3B\u6301\u4EBA\u8207\u5609\u8CD3",
                "wc_chat.me": "\u6211",
                "wc_chat.panelist_chat_with": "\u5609\u8CD3\u53EF\u8207\u4E0B\u5217\u5C0D\u8C61\u804A\u5929\uFF1A",
                "wc_chat.type_msg": "\u5728\u9019\u88E1\u8F38\u5165\u8A0A\u606F...",
                wc_closed_caption_btn: "\u5B57\u5E55",
                wc_co_host: "\uFF08\u806F\u5E2D\u4E3B\u6301\u4EBA\uFF09",
                wc_continue: "\u7E7C\u7E8C",
                wc_copied: "\u5DF2\u8907\u88FD",
                wc_copied_to_clipboard: "\u9080\u8ACB\u9023\u7D50\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
                wc_copy_link: "\u8907\u88FD\u9023\u7D50",
                wc_data_center2: "\u60A8\u5DF2\u9023\u63A5\u81F3\u4F01\u696D\u90E8\u7F72\u8CC7\u6599\u4E2D\u5FC3\u3002",
                wc_data_center3: "\u60A8\u5DF2\u900F\u904E\u4F01\u696D\u90E8\u7F72\u8CC7\u6599\u4E2D\u5FC3\u9023\u63A5\u81F3Zoom\u5168\u7403\u7DB2\u8DEF\u3002",
                wc_disable_talking: "\u7981\u6B62\u767C\u8A00",
                wc_dlg_confirm: "\u78BA\u8A8D",
                wc_enable: "\u5DF2\u555F\u7528",
                wc_encryption: "\u52A0\u5BC6",
                wc_extra_function_disable_video: "\u7981\u7528\u8996\u983B\u63A5\u6536",
                wc_files: "\u6A94\u6848",
                wc_footer_assign_leave: "\u6307\u6D3E\u4E26\u96E2\u958B",
                wc_footer_assign_new_host: "\u6307\u6D3E\u65B0\u7684\u4E3B\u6301\u4EBA",
                wc_guest: "\u4F86\u8CD3",
                wc_host_1: "\u4E3B\u6301\u4EBA",
                wc_in_the_meeting: "\u6703\u8B70\u4E2D",
                wc_invite_link: "\u9080\u8ACB\u9023\u7D50",
                wc_join_media_preview_info_confirm: "\u77AD\u89E3",
                wc_join_media_preview_warning_denied_both: "\u5728\u60A8\u7684\u700F\u89BD\u5668\u7DB2\u5740\u5217\u4E2D\u555F\u7528\u651D\u5F71\u6A5F\u53CA\u9EA5\u514B\u98A8\u5B58\u53D6\u3002",
                wc_join_media_preview_warning_denied_camera: "\u5728\u60A8\u7684\u700F\u89BD\u5668\u7DB2\u5740\u5217\u4E2D\u555F\u7528\u651D\u5F71\u6A5F\u5B58\u53D6\u3002",
                wc_join_media_preview_warning_denied_mic: "\u5728\u60A8\u7684\u700F\u89BD\u5668\u7DB2\u5740\u5217\u4E2D\u555F\u7528\u9EA5\u514B\u98A8\u5B58\u53D6\u3002",
                wc_joining: "\u52A0\u76DF",
                wc_joining_meeting: "\u6B63\u5728\u52A0\u5165\u6703\u8B70...",
                wc_learn_more: "\u6DF1\u5165\u77AD\u89E3",
                wc_leave_computer_audio: "\u96E2\u958B\u96FB\u8166\u97F3\u8A0A",
                wc_leave_meeting: "\u96E2\u958B\u6703\u8B70",
                wc_leave_webinar: "\u96E2\u958B\u7DB2\u8DEF\u7814\u8A0E\u6703",
                wc_live_transcription_btn: "\u5373\u6642\u8F49\u9304\u6587\u5B57",
                wc_lock_meeting: "\u9396\u5B9A\u6703\u8B70",
                wc_lower_hand: "\u624B\u653E\u4E0B",
                wc_lt_disable_transcription: "\u505C\u7528\u81EA\u52D5\u8F49\u9304\u6587\u5B57",
                wc_lt_enable_transcription: "\u555F\u7528\u81EA\u52D5\u8F49\u9304\u6587\u5B57",
                wc_lt_item_captioner: "\uFF08\u5B57\u5E55\u8F38\u5165\u8005\uFF09",
                wc_lt_live_transcript: "\u5373\u6642\u8F49\u9304\u6587\u5B57",
                wc_lt_menu_item1: "\u986F\u793A\u5B57\u5E55",
                wc_lt_menu_item2: "\u6AA2\u8996\u5B8C\u6574\u8F49\u9304\u6587\u5B57",
                wc_lt_menu_item3: "\u96B1\u85CF\u5B57\u5E55",
                wc_lt_menu_item4: "\u95DC\u9589\u5B8C\u6574\u8F49\u9304\u6587\u5B57",
                wc_lt_request_host_ctrl: "\u5141\u8A31\u8207\u6703\u8005\u8981\u6C42\u555F\u7528\u5373\u6642\u8F49\u9304\u6587\u5B57",
                wc_lt_search_text: "\u641C\u5C0B",
                wc_make_co_host: "\u8A2D\u70BA\u806F\u5E2D\u4E3B\u6301\u4EBA",
                wc_make_host: "\u8A2D\u70BA\u4E3B\u6301\u4EBA",
                wc_me: "\uFF08\u6211\uFF09",
                wc_more: "\u66F4\u591A",
                wc_no: "\u5426",
                wc_none: "\u7121",
                wc_not_share_pronoun: "\u4E0D\u516C\u958B",
                wc_num_password: "\u6578\u5B57\u5BC6\u78BC\u96FB\u8A71/\u6703\u8B70\u5BA4\u7CFB\u7D71",
                wc_participant_id: "\u8207\u6703\u8005ID",
                wc_participants: "\u8207\u6703\u8005",
                wc_pc_audio: "\u96FB\u8166\u97F3\u8A0A",
                wc_prevent_access_mic: "\u700F\u89BD\u5668\u7981\u6B62\u5B58\u53D6\u60A8\u7684\u9EA5\u514B\u98A8\u3002",
                wc_put_in_waiting: "\u79FB\u81F3\u7B49\u5019\u5BA4",
                "wc_qa.allQ": "\u6240\u6709\u554F\u984C",
                "wc_qa.anonymous_attendee": "\u533F\u540D\u89C0\u773E",
                "wc_qa.answer_private_type": "\u79C1\u4E0B\u56DE\u7B54",
                "wc_qa.answeredQ": "\u5DF2\u56DE\u7B54",
                "wc_qa.attendee_placeholder": "\u60A8\u5411\u4E3B\u6301\u4EBA\u53CA\u5609\u8CD3\u8A62\u554F\u7684\u554F\u984C\u5C07\u5728\u6B64\u986F\u793A\u3002",
                "wc_qa.button_comment": "\u8A55\u8AD6",
                "wc_qa.button_display_answer": "\u8F38\u5165\u56DE\u7B54",
                "wc_qa.button_live": "\u7DDA\u4E0A\u56DE\u7B54",
                "wc_qa.button_live_done": "\u5B8C\u6210",
                "wc_qa.button_reopen": "\u91CD\u65B0\u958B\u555F",
                "wc_qa.collapse_all_answer": "\u5168\u90E8\u647A\u758A",
                "wc_qa.dismissedQ": "\u5DF2\u95DC\u9589",
                "wc_qa.display_all_answer": "\u5168\u90E8\u986F\u793A",
                "wc_qa.dissmis_tips": "\u95DC\u9589",
                "wc_qa.input_tips": "\u5728\u9019\u88CF\u8F38\u5165\u60A8\u7684\u554F\u984C...",
                "wc_qa.is_anonymous": "\u533F\u540D\u50B3\u9001",
                "wc_qa.is_privately": "\u79C1\u4E0B\u50B3\u9001",
                "wc_qa.live_tips_done": "\u6B64\u554F\u984C\u5DF2\u7DDA\u4E0A\u56DE\u7B54",
                "wc_qa.live_tips_start": "\u5C07\u7DDA\u4E0A\u56DE\u7B54\u9019\u500B\u554F\u984C",
                "wc_qa.most_recent": "\u6700\u8FD1\u7684",
                "wc_qa.most_upvotes": "\u6700\u591A\u9644\u8B70",
                "wc_qa.myQ": "\u6211\u7684\u554F\u984C",
                "wc_qa.no_answered_questions": "\u6C92\u6709\u5DF2\u56DE\u7B54\u7684\u554F\u984C",
                "wc_qa.no_dismissed_questions": "\u6C92\u6709\u5DF2\u95DC\u9589\u7684\u554F\u984C",
                "wc_qa.no_open_questions": "\u6C92\u6709\u672A\u56DE\u7B54\u7684\u554F\u984C",
                "wc_qa.no_questions": "\u6C92\u6709\u554F\u984C",
                "wc_qa.openedQ": "\u672A\u56DE\u7B54",
                "wc_qa.panelist_host_only_placeholder": "\u50C5\u6709\u4E3B\u6301\u4EBA\u8207\u5609\u8CD3\u53EF\u4EE5\u770B\u5230\u554F\u984C",
                "wc_qa.panelist_view_all_placehoder": "\u6B64\u7DB2\u8DEF\u7814\u8A0E\u6703\u5167\u7684\u6240\u6709\u4EBA\u5747\u53EF\u770B\u5230\u672A\u56DE\u7B54\u7684\u554F\u984C",
                "wc_qa.qa_comp_title": "\u554F\u8207\u7B54",
                "wc_qa.send": "\u50B3\u9001",
                "wc_qa.setting_allow_view": "\u5141\u8A31\u89C0\u773E\u6AA2\u8996",
                "wc_qa.setting_btn_name": "\u8A2D\u7F6E",
                "wc_qa.setting_option_allow_anony_question": "\u5141\u8A31\u533F\u540D\u63D0\u554F",
                "wc_qa.setting_option_allow_comment": "\u89C0\u773E\u53EF\u4EE5\u8A55\u8AD6",
                "wc_qa.setting_option_allow_view_all": "\u6240\u6709\u554F\u984C",
                "wc_qa.setting_option_allow_view_answered": "\u50C5\u5DF2\u56DE\u7B54\u7684\u554F\u984C",
                "wc_qa.setting_option_allow_vote": "\u89C0\u773E\u53EF\u4EE5\u9644\u8B70",
                "wc_qa.welcome_banner": "\u53EF\u96A8\u6642\u8A62\u554F\u4E3B\u6301\u4EBA\u548C\u5609\u8CD3\u554F\u984C",
                "wc_qa.welcome_banner_title": "\u6B61\u8FCE",
                wc_raise_hand: "\u8209\u624B",
                wc_reclaim_host: "\u6536\u56DE\u4E3B\u6301\u4EBA\u6B0A\u9650",
                wc_record_host_reminder_desc: "\u4E00\u65E6\u7E7C\u7E8C\uFF0C\u6240\u6709\u81C9\u5B54\u3001\u4EA4\u8AC7\u53CA\u756B\u9762\u5206\u4EAB\u5747\u6703\u9304\u88FD\u5230\u96F2\u7AEF\u3002",
                wc_record_reminder_desc: "\u4E00\u65E6\u7E7C\u7E8C\u53C3\u8207\u6B64\u6703\u8B70\uFF0C\u5373\u8868\u793A\u60A8\u540C\u610F\u9304\u88FD\u3002",
                wc_record_reminder_desc_2: "{{accountOwner}}\u53CA\u4E3B\u6301\u4EBA\u53EF\u89C0\u770BZoom\u96F2\u7AEF\u9304\u88FD\u6A94\u6848\uFF0C\u800C\u4E14\u4EFB\u4F55\u64C1\u6709\u6B0A\u9650\u7684\u8207\u6703\u8005\u5747\u53EF\u9304\u88FD\u5230\u5176\u672C\u6A5F\u88DD\u7F6E\u4E0A\u3002\u4E0A\u8FF0\u5C0D\u8C61\u53EF\u5C07\u9019\u4E9B\u9304\u88FD\u6A94\u6848\u5206\u4EAB\u5230\u61C9\u7528\u7A0B\u5F0F\u53CA\u7D66\u5176\u4ED6\u4EBA\u3002",
                wc_record_reminder_title: "\u6B63\u5728\u9304\u88FD\u672C\u6703\u8B70",
                wc_record_reminder_webinar_title: "\u6B63\u5728\u9304\u88FD\u6B64\u7DB2\u8DEF\u7814\u8A0E\u6703",
                wc_record_webinar_reminder_desc: "\u4E00\u65E6\u7E7C\u7E8C\u53C3\u8207\u6B64\u7DB2\u8DEF\u7814\u8A0E\u6703\uFF0C\u5373\u8868\u793A\u60A8\u540C\u610F\u9304\u88FD\u3002",
                wc_recording_pause: "\u66AB\u505C\u9304\u88FD",
                wc_recording_resume: "\u7E7C\u7E8C\u9304\u88FD",
                wc_recording_stop: "\u505C\u6B62\u9304\u88FD",
                wc_recording_title: "\u8A18\u9304\u9019\u6B21\u6703\u8B70\uFF1F",
                wc_remove: "\u522A\u9664",
                wc_select_camera: "\u9078\u53D6\u651D\u5F71\u6A5F",
                wc_select_microphone: "\u9078\u53D6\u9EA5\u514B\u98A8",
                wc_select_speaker: "\u9078\u53D6\u5587\u53ED",
                wc_share_muted_while_sharing_audio_tip2: "\u5171\u4EAB\u8A08\u7B97\u6A5F\u97F3\u983B\u6642\uFF0C\u60A8\u7684\u9EA5\u514B\u98A8\u88AB\u7981\u7528\u3002\u66AB\u505C\u6216\u505C\u6B62\u5171\u4EAB\u97F3\u983B\u6642\uFF0C\u5C07\u91CD\u65B0\u6FC0\u6D3B\u9EA5\u514B\u98A8\u3002",
                wc_share_pronoun: "\u5206\u4EAB",
                wc_share_pronoun_menu: "\u516C\u958B\u6211\u7684\u4EE3\u7A31",
                wc_share_pronoun_tip2: "\u60A8\u662F\u5426\u8981\u5728\u6B64\u6703\u8B70\u5167\u516C\u958B\u60A8\u7684\u4EE3\u7A31\uFF1F",
                wc_sharer_controlbar_container_button3_label: "\u505C\u6B62\u5206\u4EAB",
                wc_sharer_controlbar_container_rec_status_tip1: "\u60A8\u6B63\u5728\u5206\u4EAB\u756B\u9762",
                wc_sharer_controlbar_container_rec_status_tip2: "\u60A8\u7684\u756B\u9762\u5206\u4EAB\u5DF2\u66AB\u505C",
                wc_sharer_disabled_share1_desc: "\u4E3B\u6301\u4EBA\u7981\u6B62\u89C0\u773E\u756B\u9762\u5206\u4EAB\u3002",
                wc_sharer_disabled_share2_desc: "\u5176\u4ED6\u8207\u6703\u8005\u6B63\u5728\u5206\u4EAB\u756B\u9762\uFF0C\u6B64\u6642\u60A8\u7121\u6CD5\u9032\u884C\u756B\u9762\u5206\u4EAB\u3002",
                wc_sharer_entry_button_label1: "\u5206\u4EAB\u756B\u9762",
                wc_sharer_setting_menu_category1_title: "\u8AB0\u53EF\u4EE5\u5206\u4EAB\uFF1F",
                wc_sharer_setting_menu_category2_title: "\u8AB0\u53EF\u4EE5\u5728\u5225\u4EBA\u5206\u4EAB\u7684\u540C\u6642\u958B\u59CB\u5206\u4EAB\uFF1F",
                wc_sharer_setting_menu_category3_title: "\u591A\u5C11\u8207\u6703\u8005\u53EF\u4EE5\u540C\u6642\u5206\u4EAB\uFF1F",
                wc_sharer_setting_menu_category_option1: "\u50C5\u4E3B\u6301\u4EBA",
                wc_sharer_setting_menu_category_option2: "\u5168\u9AD4\u8207\u6703\u8005",
                wc_sharer_setting_menu_item1: "\u4E00\u6B21\u53EA\u6709\u4E00\u4F4D\u8207\u6703\u8005\u53EF\u4EE5\u5206\u4EAB",
                wc_sharer_setting_menu_item2: "\u5141\u8A31\u591A\u4F4D\u8207\u6703\u8005\u540C\u6642\u5206\u4EAB",
                wc_sharing_fit_to_window: "\u8ABF\u6574\u6210\u8996\u7A97\u5927\u5C0F",
                wc_sharing_original_size: "\u539F\u59CB\u5927\u5C0F",
                wc_sharing_shared_screens: "\u5206\u4EAB\u756B\u9762",
                wc_sharing_view_options: "\u6AA2\u8996\u9078\u9805",
                wc_sharing_viewing: "\u60A8\u6B63\u5728\u67E5\u770B{{displayName}}\u7684\u5C4F\u5E55",
                wc_tel_password: "\u5BC6\u78BC",
                wc_unmute_by_host_btn1: "\u4FDD\u6301\u975C\u97F3",
                wc_unshare_pronoun_menu: "\u53D6\u6D88\u516C\u958B\u6211\u7684\u4EE3\u7A31",
                "wc_video.allow_panelist_start_video": "\u5141\u8A31\u5609\u8CD3\u958B\u555F\u8996\u8A0A",
                "wc_video.allow_participants_start_video": "\u5141\u8A31\u8207\u6703\u8005\u958B\u555F\u8996\u8A0A",
                "wc_video.ask_start_video": "\u8981\u6C42\u958B\u555F\u8996\u8A0A",
                "wc_video.model_stop": "\u4E3B\u6301\u4EBA\u7981\u6B62\u60A8\u5728\u6703\u8B70\u4E2D\u958B\u555F\u8996\u8A0A",
                "wc_video.start_video": "\u958B\u555F\u8996\u8A0A",
                "wc_video.stop_video": "\u505C\u6B62\u8996\u8A0A",
                "wc_video.video": "\u8996\u8A0A",
                wc_view: "\u6AA2\u8996",
                wc_waiting_room: "\u7B49\u5019\u5BA4",
                "wc_webinar.change_to_attendee": "\u5C07\u89D2\u8272\u8B8A\u66F4\u70BA\u89C0\u773E",
                "wc_webinar.promote_to_panelist": "\u8A2D\u7232\u5609\u8CD3",
                wc_webinar_attendees: "\u89C0\u773E",
                wc_webinar_panelists: "\u5609\u8CD3",
                wc_webinar_putonhold: "\u8A2D\u70BA\u7B49\u5F85\u72C0\u614B",
                wc_withdraw_co_host: "\u64A4\u92B7\u806F\u5E2D\u4E3B\u6301\u4EBA",
                wc_yes: "\u662F",
                websdk_enforce_update_content: "\u60A8\u5FC5\u9808\u4F7F\u7528{0}\u6216\u66F4\u9AD8\u7684\u61C9\u7528\u7A0B\u5F0F\u7248\u672C\u624D\u80FD\u52A0\u5165\u6B64\u6703\u8B70\u3002\u8ACB\u66F4\u65B0\u4EE5\u7E7C\u7E8C\u3002",
                websdk_update_content: "\u66F4\u65B0WebSDK\u5230\u6700\u65B0\u7248\u672C\uFF0C\u4EE5\u512A\u5316\u6703\u8B70\u9AD4\u9A57"
              }
            },
            "ko-KO": {
              translation: {
                GOT_IT: "\uD655\uC778",
                account_owner: "\uACC4\uC815 \uC18C\uC720\uC790",
                allow_to_access: "\uCE74\uBA54\uB77C\uC640 \uB9C8\uC774\uD06C\uC5D0 \uC561\uC138\uC2A4 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
                "app_signal.approved_by": "\uC5D0 \uC758\uD574 \uC2B9\uC778\uB428",
                "app_signal.hosts_account": "\uD638\uC2A4\uD2B8\uC758 \uACC4\uC815",
                "app_signal.people": "\uBA85",
                "app_signal.tip_text_2": "\uD68C\uC758 \uCF58\uD150\uCE20\uC5D0 \uC561\uC138\uC2A4\uD558\uB294 \uC571 \uD655\uC778",
                "app_signal.unable_load2": "\uADC0\uD558\uC758 \uC815\uBCF4\uC5D0 \uB300\uD55C \uC2E4\uC2DC\uAC04 \uC561\uC138\uC2A4\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC571\uC744 \uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                "archiving.chat_1": "\uCC44\uD305(\uACF5\uAC1C \uBC0F \uC9C1\uC811)",
                "archiving.chat_2": "\uCC44\uD305(\uACF5\uAC1C\uB9CC)",
                "archiving.chat_disable_content": "\uCC44\uD305\uC73C\uB85C \uC804\uC1A1\uB41C \uBA54\uC2DC\uC9C0\uB294 \uADDC\uC815 \uC900\uC218 \uBAA9\uC801\uC73C\uB85C \uBCF4\uAD00\uB420 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                "archiving.chat_disable_title": "\uCC44\uD305\uC774 \uBE44\uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
                "archiving.content1_sdk": "\uC774 \uD68C\uC758\uC758 \uD55C \uBA85 \uC774\uC0C1\uC758 \uCC38\uAC00\uC790\uB294 \uACC4\uC815\uC758 \uC815\uCC45\uC5D0 \uB530\uB77C \uBCF4\uAD00\uB429\uB2C8\uB2E4. {{content}}\uC740(\uB294) \uC774 \uD68C\uC758\uC5D0\uC11C \uCF58\uD150\uCE20\uB97C \uC218\uC2E0\uD558\uACE0 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "archiving.content2_sdk": "\uC774 \uD68C\uC758\uC5D0 \uBA38\uBB34\uB974\uBA74 \uADC0\uD558\uB294 \uC774 \uD68C\uC758\uC758 {{content}}\uC774(\uAC00) \uBCF4\uAD00\uB418\uB294 \uAC83\uC5D0 \uB3D9\uC758\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4.",
                "archiving.default_title": "\uC774 \uD68C\uC758\uB294 \uBCF4\uAD00\uB418\uB294 \uC911\uC785\uB2C8\uB2E4",
                "archiving.fail_content_sdk": "\uC774 \uD68C\uC758\uC758 {{features}}\uC740(\uB294) \uADDC\uC815 \uC900\uC218\uB97C \uC704\uD574 \uAF2D \uBCF4\uAD00\uB418\uC5B4\uC57C \uD569\uB2C8\uB2E4.",
                "archiving.fail_title": "\uBCF4\uAD00 \uC2E4\uD328",
                "archiving.subjects_combo_2_sdk": "{{0}} \uBC0F {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} \uBC0F {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} \uBC0F {{3}}",
                "archiving.tips_1_sdk": "\uC774 \uD68C\uC758\uC758 {{subjects}}\uC740(\uB294) \uACC4\uC815\uC758 \uC815\uCC45\uC5D0 \uB530\uB77C \uD638\uC2A4\uD2B8\uC758 \uC870\uC9C1\uC5D0\uC11C \uBCF4\uAD00\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4. {{receiver}}\uC740(\uB294) \uC774 \uD68C\uC758\uC5D0\uC11C \uCF58\uD150\uCE20\uB97C \uC218\uC2E0\uD558\uACE0 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "archiving.tips_2_sdk": "\uC774 \uD68C\uC758\uC758 {{subjects}}\uC740(\uB294) \uACC4\uC815\uC758 \uC815\uCC45\uC5D0 \uB530\uB77C \uD638\uC2A4\uD2B8\uC758 \uC870\uC9C1\uC5D0\uC11C \uBCF4\uAD00\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4. {{receiver}}\uC740(\uB294) \uC774 \uD68C\uC758\uC5D0\uC11C \uCF58\uD150\uCE20\uB97C \uC218\uC2E0\uD558\uACE0 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "archiving.transcription": "\uB300\uD654 \uB0B4\uC6A9",
                "ast.leave_tip": "\uB3C4\uC6B0\uBBF8 \uD68C\uC758 \uC81C\uC5B4\uB97C \uC911\uC9C0\uD588\uC2B5\uB2C8\uB2E4.",
                "ast.tip": "\uC774 \uD68C\uC758\uB294 \uB3C4\uC6B0\uBBF8\uAC00 \uC81C\uC5B4\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4",
                background: "\uBC30\uACBD",
                chat_message_header: "<0> {{senderName}} </0> <1> \uC5D0\uC11C </1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}} \uC0C8 \uBA54\uC2DC\uC9C0",
                chat_receiver_co_host: "(\uACF5\uB3D9 \uD638\uC2A4\uD2B8)",
                chat_receiver_host: "(\uD638\uC2A4\uD2B8)",
                chat_receiver_panelist: "(\uD1A0\uB860\uC790)",
                chat_receiver_to: "\uC5D0\uC11C:",
                choose_background: "\uBC30\uACBD \uC120\uD0DD",
                click_address_bar: "\uC8FC\uC18C \uD45C\uC2DC \uC904\uC758 \uC67C\uCABD\uC5D0\uC788\uB294 \uC7A0\uAE08 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624. \uD31D\uC5C5\uC774 \uC635\uC158 \uBAA9\uB85D\uC774 \uB098\uD0C0\uB0A9\uB2C8\uB2E4.",
                click_microphone_camera_option: "\uCE74\uBA54\uB77C \uBC0F \uB9C8\uC774\uD06C \uC624\uB978\uCABD\uC758 \uB4DC\uB86D \uB2E4\uC6B4 \uBAA9\uB85D\uC744 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
                "common.cancel": "\uCDE8\uC18C",
                "common.connecting": "\uC5F0\uACB0",
                delete: "\uC9C0\uC6B0\uB2E4",
                "dialog.btn_cancel": "\uCDE8\uC18C",
                "dialog.btn_endconf_webinar": "\uC6E8\uBE44\uB098 \uC885\uB8CC",
                "dialog.btn_leaveconf_meeting": "\uD68C\uC758 \uB098\uAC00\uAE30",
                "dialog.btn_retry": "\uC7AC\uC2DC\uB3C4",
                "dialog.host_end_meeting": "\uC774 \uD68C\uC758\uB294 \uD638\uC2A4\uD2B8\uC5D0 \uC758\uD574 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                "dialog.host_end_webinar": "\uC774 \uC6E8\uBE44\uB098\uB294 \uD638\uC2A4\uD2B8\uC5D0 \uC758\uD574 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                "dialog.meeting_ended": "\uD68C\uC758\uAC00 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                "dialog.meeting_locked": "\uD68C\uC758\uAC00 \uC7A0\uACBC\uC2B5\uB2C8\uB2E4.",
                "dialog.meeting_removed_by_host": "\uD638\uC2A4\uD2B8\uC5D0 \uC758\uD574 \uC774 \uD68C\uC758\uC5D0\uC11C \uC81C\uC678\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                "dialog.newname": "\uC774\uB984",
                "dialog.ok": "\uD655\uC778",
                "dialog.presscode": "\uD68C\uC758 ID",
                "dialog.rename": "\uC774\uB984 \uBC14\uAFB8\uAE30",
                "dialog.server_error": "\uC11C\uBC84\uC5D0\uC11C \uB0B4\uBD80 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD558\uC5EC \uC694\uCCAD\uC744 \uCC98\uB9AC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                "dialog.webinar_ended": "\uC6E8\uBE44\uB098\uAC00 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                "dialog.webinar_removed_by_host": "\uD638\uC2A4\uD2B8\uC5D0 \uC758\uD574 \uC774 \uC6E8\uBE44\uB098\uC5D0\uC11C \uC81C\uC678\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                "dialog.you_are_removed": "\uADC0\uD558\uB294 \uC81C\uC678\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                dialog_make_cohost: "{{displayName}}\uB2D8\uC744 \uC774 \uD68C\uC758\uC758 \uACF5\uB3D9 \uD638\uC2A4\uD2B8\uB85C \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                dialog_make_host: "\uD638\uC2A4\uD2B8\uB97C {{displayName}}(\uC73C)\uB85C \uBCC0\uACBD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                dialog_remove_user: "{{displayName}}\uC744(\uB97C) \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                "disclaimer.LT_button_1": "\uC774 \uB300\uD654 \uB0B4\uC6A9\uC744 \uBCFC \uC218 \uC788\uB294 \uC0AC\uB78C\uC740 \uB204\uAD6C\uC785\uB2C8\uAE4C?",
                "disclaimer.LT_content_1_1": "\uACC4\uC815 \uC18C\uC720\uC790 \uBC0F \uD68C\uC758\uC5D0 \uCC38\uAC00\uD55C \uBAA8\uB450\uAC00 \uB300\uD654 \uB0B4\uC6A9\uC744 \uC800\uC7A5\uD558\uACE0 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.LT_content_2": "\uC2E4\uC2DC\uAC04 \uB300\uD654 \uB0B4\uC6A9(\uC120\uD0DD \uC790\uB9C9)\uC774 \uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
                "disclaimer.QA_button_1": "\uADC0\uD558\uC758 \uC9C8\uBB38\uC744 \uBCFC \uC218 \uC788\uB294 \uC0AC\uB78C\uC740 \uB204\uAD6C\uC785\uB2C8\uAE4C?",
                "disclaimer.QA_content_1_1": "\uACC4\uC815 \uC18C\uC720\uC790, \uD638\uC2A4\uD2B8 \uBC0F \uD1A0\uB860\uC790\uB294 \uADC0\uD558\uAC00 \uB204\uAD6C\uC778\uC9C0, \uADC0\uD558\uC758 \uC5F0\uB77D\uCC98 \uC815\uBCF4(\uB85C\uADF8\uC778\uD588\uAC70\uB098 \uADC0\uD558\uAC00 \uC81C\uACF5\uD55C \uACBD\uC6B0) \uBC0F \uADC0\uD558\uC758 \uC9C8\uBB38\uC744 \uBCFC \uC218 \uC788\uC73C\uBA70 \uC774\uB97C \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.QA_content_2": "\uADC0\uD558\uC758 \uC9C8\uBB38\uC774 \uC120\uD0DD\uB418\uBA74 \uBAA8\uB4E0 \uCC38\uC11D\uC790\uAC00 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.QA_content_3_3": "\uADC0\uD558\uAC00 \uC775\uBA85\uC73C\uB85C \uC81C\uCD9C\uD558\uC9C0 \uC54A\uB294 \uD55C, \uACC4\uC815 \uC18C\uC720\uC790, \uD638\uC2A4\uD2B8 \uBC0F \uD1A0\uB860\uC790\uB294 \uADC0\uD558\uAC00 \uB204\uAD6C\uC778\uC9C0, \uADC0\uD558\uC758 \uC5F0\uB77D\uCC98 \uC815\uBCF4(\uB85C\uADF8\uC778\uD588\uAC70\uB098 \uADC0\uD558\uAC00 \uC81C\uACF5\uD55C \uACBD\uC6B0) \uBC0F \uADC0\uD558\uC758 \uC9C8\uBB38\uC744 \uBCFC \uC218 \uC788\uC73C\uBA70 \uC774\uB97C \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.QA_content_4": "\uC774 Q&A\uB294 \uACF5\uAC1C\uB418\uBBC0\uB85C \uBAA8\uB4E0 \uC0AC\uB78C\uC774 \uADC0\uD558\uC758 \uC9C8\uBB38\uC744 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.QA_content_5": "\uC775\uBA85\uC73C\uB85C \uC9C8\uBB38\uC744 \uC81C\uCD9C\uD558\uBA74 \uB204\uAC00 \uADC0\uD558\uC758 \uC9C8\uBB38\uC744 \uC81C\uCD9C\uD588\uB294\uC9C0 \uC544\uBB34\uB3C4 \uC54C \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                "disclaimer.chat_button_normal": "\uADC0\uD558\uC758 \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uB294 \uC0AC\uB78C\uC740 \uB204\uAD6C\uC785\uB2C8\uAE4C?",
                "disclaimer.chat_button_onArchiving": "\uADC0\uD558\uC758 \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uB294 \uC0AC\uB78C\uC740 \uB204\uAD6C\uC785\uB2C8\uAE4C? \uBCF4\uAD00\uC774 \uCF1C\uC838 \uC788\uC74C",
                "disclaimer.chat_button_onRecording": "\uADC0\uD558\uC758 \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uB294 \uC0AC\uB78C\uC740 \uB204\uAD6C\uC785\uB2C8\uAE4C? \uAE30\uB85D\uC774 \uCF1C\uC838 \uC788\uC74C",
                "disclaimer.chat_content_1": "\uD68C\uC758\uC758 \uBAA8\uB4E0 \uC0AC\uB78C\uB4E4\uC740 \uADC0\uD558\uC758 \uBAA8\uB450\uC640\uC758 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uACE0 \uC800\uC7A5\uD560 \uC218 \uC788\uC73C\uBA70 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uB78C\uB4E4\uACFC \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.chat_content_2": "\uADC0\uD558 \uBC0F \uADC0\uD558\uC640 \uCC44\uD305\uD558\uB294 \uC0AC\uB78C\uB4E4\uB9CC \uADC0\uD558\uC758 DM\uC744 \uC800\uC7A5\uD558\uACE0 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.chat_content_3": "\uAE30\uB85D\uC774 \uC9C4\uD589 \uC911\uC774\uBBC0\uB85C \uACC4\uC815 \uC18C\uC720\uC790\uC640 \uD68C\uC758\uC758 \uBAA8\uB4E0 \uC0AC\uB78C\uB4E4\uC740 \uBAA8\uB450\uC5D0\uAC8C \uC804\uC1A1\uB41C \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uACE0 \uC800\uC7A5\uD560 \uC218 \uC788\uC73C\uBA70 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.chat_content_4": "\uAE30\uB85D\uC774 \uC9C4\uD589 \uC911\uC774\uBBC0\uB85C \uD68C\uC758\uC758 \uBAA8\uB4E0 \uC0AC\uB78C\uB4E4\uC740 \uBAA8\uB450\uC5D0\uAC8C \uC804\uC1A1\uB41C \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uACE0 \uC800\uC7A5\uD560 \uC218 \uC788\uC73C\uBA70 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC640 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.chat_content_5": "\uBCF4\uAD00\uC774 \uCF1C\uC838 \uC788\uC73C\uBBC0\uB85C \uACC4\uC815 \uC18C\uC720\uC790\uB294 DM\uC744 \uD3EC\uD568\uD558\uC5EC \uADC0\uD558\uC758 \uBAA8\uB4E0 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uACE0 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.chat_content_6": "\uD68C\uC758\uC5D0 \uCC38\uAC00\uD55C \uBAA8\uB450\uAC00 \uADC0\uD558\uAC00 \uBAA8\uB450\uC5D0\uAC8C \uBCF4\uB0B8 \uBA54\uC2DC\uC9C0\uB97C \uC800\uC7A5\uD558\uACE0 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "disclaimer.chat_content_7": "\uBCF4\uAD00\uC774 \uD65C\uC131\uD654\uB418\uC5B4 \uC788\uC73C\uBBC0\uB85C \uACC4\uC815 \uC18C\uC720\uC790\uB294 DM\uC744 \uC81C\uC678\uD55C \uADC0\uD558\uC758 \uBAA8\uB4E0 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uACE0 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                errorcodes_be_removed: "\uC81C\uAC70 \uD560 \uC218.",
                errorcodes_denied_email: "\uC774\uBA54\uC77C\uC740 \uAD00\uB9AC\uC790\uC5D0 \uC758\uD574 \uCC28\uB2E8\uB41C\uB2E4.",
                errorcodes_denied_register_with_panelist: "\uAC70\uBD80 \uB808\uC9C0\uC2A4\uD130 \uC0AC\uC6A9 \uD1A0\uB860\uC790 \uC774\uBA54\uC77C.",
                errorcodes_disconnect: "\uD68C\uC758 \uC5F0\uACB0\uC774 \uB04A\uC5B4\uC84C\uC2B5\uB2C8\uB2E4.",
                errorcodes_email_require: "\uC774\uBA54\uC77C \uC6F9 \uC138\uBBF8\uB098\uC5D0 \uCC38\uC11D\uD558\uAE30 \uC704\uD574\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_fail: "\uD68C\uC758\uC5D0 \uCC38\uAC00\uD558\uC9C0 \uBABB\uD55C\uB2E4.",
                errorcodes_frequent_call: "\uC774 \uD638\uCD9C\uC5D0 \uB300\uD55C API\uC758 \uD55C\uACC4\uC5D0 \uB3C4\uB2EC\uD588\uC2B5\uB2C8\uB2E4.",
                errorcodes_frequent_join: "\uB2F9\uC2E0\uC740 \uC90C\uC5D0 \uC758\uD574 \uC81C\uD55C \uB420 reCAPTCHA\uB97C\uC744 \uD655\uC778\uD574\uC57C\uD569\uB2C8\uB2E4.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "\uC218 \uC5C6\uC2B5\uB2C8\uB2E4 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uC870\uC778 \uC90C \uB370\uC2A4\uD06C\uD1B1 \uD074\uB77C\uC774\uC5B8\uD2B8 \uB610\uB294 \uBAA8\uBC14\uC77C \uC571\uC744 \uC0AC\uC6A9\uD558\uC5EC \uAC00\uC785\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",
                errorcodes_not_exist: "\uD68C\uC758\uAC00 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
                errorcodes_not_host: "\uB2F9\uC2E0\uC740 \uD68C\uC758 \uD638\uC2A4\uD2B8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
                errorcodes_not_init: "\uD68C\uC758 \uCD08\uAE30\uD654\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.",
                errorcodes_not_start: "\uD68C\uC758\uAC00 \uC2DC\uC791\uB418\uC9C0 \uC54A\uC740",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "\uC774 \uC11C\uBE44\uC2A4\uB294 \uC77C\uC2DC\uC801\uC73C\uB85C \uC624\uD504\uB77C\uC778 \uC0C1\uD0DC\uC785\uB2C8\uB2E4.",
                errorcodes_pac_api_disabled: "\uB294 API \uD0A4 \uBE44\uD65C\uC131\uD654\uB97C \uCC28\uC9C0\uD55C\uB2E4.",
                errorcodes_pac_api_wrong: "\uB294 API \uD0A4\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC815.",
                errorcodes_pac_cant_host_other_mn: "\uB3D9\uC2DC\uC5D0 \uB610 \uB2E4\uB978 \uD68C\uC758\uB97C \uD638\uC2A4\uD305\uD558\uC9C0 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_pac_host_not_found: "\uD68C\uC758 \uD638\uC2A4\uD2B8\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_pac_invalid_signature: "\uC11C\uBA85\uC774 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                errorcodes_pac_mn_not_fount: "\uD68C\uC758 \uBC88\uD638\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_pac_mn_wrong: "\uD68C\uC758 \uBC88\uD638\uAC00 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                errorcodes_pac_no_permission: "\uBE44\uD5C8\uAC00.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "\uC798\uBABB\uB41C \uC5ED\uD560.",
                errorcodes_pac_signature_expired: "\uC11C\uBA85\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                errorcodes_re_connect: "\uD68C\uC758\uAC00 \uB2E4\uC2DC \uC5F0\uACB0\uB429\uB2C8\uB2E4.",
                errorcodes_register: "\uC774 \uD68C\uC758\uB294 \uB4F1\uB85D\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.",
                errorcodes_rwc_empty: "\uC6F9 \uC11C\uBC84\uC5D0\uC11C \uC751\uB2F5\uC744 \uAC00\uC838\uC62C \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_rwc_error: "\uC6F9 \uC11C\uBC84 \uC624\uB958\uC5D0 \uC5F0\uACB0\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "\uC131\uACF5\uC801\uC73C\uB85C \uD68C\uC758\uC5D0 \uD569\uB958\uD588\uB2E4.",
                errorcodes_tk_expired: "\uD1A0\uD070\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                errorcodes_wasm_fail: "\uB2E4\uC6B4\uB85C\uB4DC wasm \uD30C\uC77C \uC624\uB958, \uB124\uD2B8\uC6CC\uD06C \uBC0F \uBC29\uD654\uBCBD\uC744 \uD655\uC778\uD558\uC2ED\uC2DC\uC624.",
                errorcodes_web_has_in_progress: "\uC774\uBBF8 \uB2E4\uB978 \uD68C\uC758\uAC00 \uC9C4\uD589 \uC911\uC785\uB2C8\uB2E4.",
                errorcodes_web_host_not_exit: "\uD68C\uC758 \uD638\uC2A4\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_web_invalid_id: "\uD68C\uC758 ID\uAC00 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                errorcodes_web_not_allow_start_webinar_from_web: "\uC6F9\uC5D0\uC11C \uC6E8\uBE44\uB098\uB97C \uC2DC\uC791\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_web_not_support_registration_webinar: "\uB4F1\uB85D \uC6E8\uBE44\uB098\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC74C",
                errorcodes_web_not_support_tsp: "\uD68C\uC758\uC5D0\uC11C Telephony Service Provider\uB97C \uC624\uB514\uC624\uB85C \uC120\uD0DD\uD55C \uACBD\uC6B0 \uC6F9\uC5D0\uC11C \uD68C\uC758\uB97C \uC2DC\uC791\uD558\uAC70\uB098 \uD68C\uC758\uC5D0 \uCC38\uAC00\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                errorcodes_web_not_support_webclient: "\uC6F9\uC5D0\uC11C \uD68C\uC758\uB97C \uC2DC\uC791\uD558\uAC70\uB098 \uCC38\uC5EC\uD558\uB294 \uAC83\uC740 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
                errorcodes_web_not_support_webinar_pac: "\uC6E8\uBE44\uB098 \uBC0F \uAC1C\uC778 \uC624\uB514\uC624 \uC804\uD654 \uD68C\uC758\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC74C",
                errorcodes_web_require_email: "\uC0AC\uC6A9\uC790 \uC774\uBA54\uC77C\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.",
                errorcodes_web_should_support_webinar_with_latest_version: "\uD604\uC7AC SDK \uBC84\uC804\uC740 \uC6E8\uBE44\uB098\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uCD5C\uC2E0 \uBC84\uC804\uC73C\uB85C \uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uC2ED\uC2DC\uC624.",
                errorcodes_wrong_pass: "\uC554\uD638 \uC798\uBABB \uD68C\uC758.",
                gallary_view: "\uAC24\uB7EC\uB9AC \uBCF4\uAE30",
                invalid_parameter: "\uC798\uBABB\uB41C \uB9E4\uAC1C \uBCC0\uC218",
                "invite.loading": "\uB85C\uB4DC \uC911...",
                meeting_disconnected: "\uD68C\uC758 \uC5F0\uACB0 \uB04A\uAE40",
                meeting_info: "\uD68C\uC758 \uC815\uBCF4",
                meeting_info_network: "{{DC}}\uC758 \uB370\uC774\uD130 \uC13C\uD130\uB97C \uD1B5\uD574 {{Network}}\uC5D0 \uC5F0\uACB0\uB429\uB2C8\uB2E4.",
                meeting_not_start: "\uD68C\uC758\uAC00 \uC2DC\uC791\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.",
                meeting_taking: "\uB9D0\uD558\uAE30:",
                meeting_waiting_for_start: "\uC2DC\uC791\uD558\uAE30\uB97C \uAE30\uB2E4\uB9AC\uACE0 \uC788\uC2B5\uB2C8\uB2E4",
                meeting_waiting_room: "\uD638\uC2A4\uD2B8\uB294 \uACE7 \uB2F9\uC2E0\uC744 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
                minimized_view: "\uBCF4\uAE30\uB97C \uCD5C\uC18C\uD654\uD588\uC2B5\uB2C8\uB2E4",
                mirror_my_video: "\uB0B4 \uBE44\uB514\uC624 \uBBF8\uB7EC\uB9C1",
                "polling.Back": "\uB4A4\uB85C",
                "promote.cancel": "\uCC38\uC11D\uC790\uB85C \uBA38\uBB3C\uAE30",
                "promote.content_1": "\uD1A0\uB860\uC790\uB294 \uBE44\uB514\uC624 \uC74C\uC18C\uAC70\uB97C \uD574\uC81C\uD558\uACE0 \uC2DC\uC791\uD560 \uC218 \uC788\uB294\uB370, \uC989 \uC6E8\uBE44\uB098\uC5D0\uC11C \uB2E4\uB978 \uC0AC\uB78C\uC5D0\uAC8C \uBCF4\uC5EC\uC9C8 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "promote.content_2": "\uADC0\uD558\uAC00 \uC74C\uC18C\uAC70\uB97C \uD574\uC81C\uD55C \uD6C4 \uD638\uC2A4\uD2B8 \uB610\uB294 \uB2E4\uB978 \uD1A0\uB860\uC790\uAC00 \uC6E8\uBE44\uB098\uB97C \uAE30\uB85D, \uB77C\uC774\uBE0C \uC2A4\uD2B8\uB9AC\uBC0D \uB610\uB294 \uBCF4\uAD00\uD558\uAE30\uB85C \uACB0\uC815\uD558\uBA74 \uADC0\uD558\uC758 \uCC38\uAC00\uAC00 \uD3EC\uD568\uB429\uB2C8\uB2E4.",
                "promote.ok": "\uD1A0\uB860\uC790\uB85C \uCC38\uAC00",
                "promote.title": "\uD638\uC2A4\uD2B8\uAC00 \uADC0\uD558\uB97C \uD1A0\uB860\uC790\uB85C \uC2B9\uACA9\uD558\uB824 \uD569\uB2C8\uB2E4",
                ribbon_view: "\uB9AC\uBCF8\uBCF4\uAE30",
                "rmc.assistant_exist_warning": "\uB2E4\uB978 \uB3C4\uC6B0\uBBF8\uAC00 \uC774 \uD68C\uC758\uB97C \uC81C\uC5B4\uD558\uACE0 \uC788\uAE30 \uB54C\uBB38\uC5D0 \uD68C\uC758\uB97C \uC81C\uC5B4\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                "rmc.exist_notification_for_client_host": "\uC774 \uD68C\uC758\uB294 \uAD00\uB9AC\uC790\uAC00 \uC81C\uC5B4\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.",
                "rmc.not_exist_notification_for_client_host": "\uAD00\uB9AC\uC790\uAC00 \uD68C\uC758 \uC81C\uC5B4\uB97C \uC911\uC9C0\uD588\uC2B5\uB2C8\uB2E4.",
                same_as_system: "\uC2DC\uC2A4\uD15C\uACFC \uB3D9\uC77C",
                "security.allow_participants_to": "\uCC38\uAC00\uC790\uC5D0\uAC8C \uB2E4\uC74C\uC744 \uD5C8\uC6A9:",
                "security.button": "\uBCF4\uC548",
                "security.waiting_room": "\uB300\uAE30\uC2E4 \uC0AC\uC6A9",
                select_allow: "\uD5C8\uC6A9 \uC635\uC158\uC744 \uC120\uD0DD\uD558\uC2ED\uC2DC\uC624.",
                "settings.audio_tab_text": "\uC624\uB514\uC624",
                "settings.enable_hd": "HD \uBE44\uB514\uC624 \uC0AC\uC6A9",
                "settings.enable_hd_tip": "\uBAA8\uB4E0 \uCC38\uAC00\uC790\uAC00 \uACE0\uD574\uC0C1\uB3C4 [720P)\uC5D0\uC11C \uBE44\uB514\uC624\uB97C \uBCFC \uC218 \uC788\uB3C4\uB85D\uD558\uC2ED\uC2DC\uC624. \uC2E4\uC81C \uACB0\uACFC\uB294 \uAE30\uACC4 \uC131\uB2A5 \uBC0F \uB300\uC5ED\uD3ED\uC5D0 \uB530\uB77C \uB2E4\uB985\uB2C8\uB2E4.",
                "settings.frame_per_second": "\uCD08\uB2F9 \uD504\uB808\uC784",
                "settings.frequency": "\uBE48\uB3C4",
                "settings.input_level": "\uC785\uB825 \uB808\uBCA8:",
                "settings.item_name": "\uD56D\uBAA9 \uC774\uB984",
                "settings.jitter": "\uC9C0\uD130",
                "settings.latency": "\uB300\uAE30 \uC2DC\uAC04",
                "settings.maximum_view": "\uAC24\uB7EC\uB9AC \uBCF4\uAE30\uC5D0\uC11C \uD654\uBA74\uB2F9 \uD45C\uC2DC\uB418\uB294 \uCD5C\uB300 \uCC38\uAC00\uC790:",
                "settings.output_level": "\uCD9C\uB825 \uB808\uBCA8:",
                "settings.packet_loss": "\uD328\uD0B7 \uC190\uC2E4 - \uD3C9\uADE0(\uCD5C\uB300)",
                "settings.participants25": "25\uCC38\uAC00\uC790",
                "settings.participants9": "9\uCC38\uAC00\uC790",
                "settings.playing": "\uC7AC\uC0DD \uC911",
                "settings.receive": "\uC218\uC2E0",
                "settings.receiving_video": "\uBE44\uB514\uC624 \uBC1B\uAE30",
                "settings.receiving_video_tips": "\uADF8\uB798\uD53D \uCE74\uB4DC\uC758 \uD558\uB4DC\uC6E8\uC5B4 \uBE44\uB514\uC624 \uB514\uCF54\uB354\uB97C \uC0AC\uC6A9\uD558\uC5EC \uBE44\uB514\uC624 \uC218\uC2E0\uC744 \uC704\uD574 CPU \uC0AC\uC6A9\uB7C9\uC744 \uC800\uC7A5\uD558\uC2ED\uC2DC\uC624. \uC774 \uBCC0\uACBD \uC0AC\uD56D\uC744 \uC801\uC6A9\uD558\uB824\uBA74\uC774 \uBCC0\uACBD\uC744 \uC704\uD574 \uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uC2ED\uC2DC\uC624.",
                "settings.recording": "\uAE30\uB85D",
                "settings.rejoin": "\uB2E4\uC2DC \uD569\uB958\uD588\uB2E4",
                "settings.resolution": "\uD574\uC0C1\uB3C4",
                "settings.send": "\uC804\uC1A1",
                "settings.sending_video": "\uBE44\uB514\uC624 \uBCF4\uB0B4\uAE30",
                "settings.sending_video_tips": "\uADF8\uB798\uD53D \uCE74\uB4DC\uC758 \uD558\uB4DC\uC6E8\uC5B4 \uBE44\uB514\uC624 \uB514\uCF54\uB354\uB97C \uC0AC\uC6A9\uD558\uC5EC \uBE44\uB514\uC624 \uC804\uC1A1\uC744\uC704\uD55C CPU \uC0AC\uC6A9\uB7C9\uC744 \uC800\uC7A5\uD558\uC2ED\uC2DC\uC624. \uC774 \uBCC0\uACBD \uC0AC\uD56D\uC744 \uC801\uC6A9\uD558\uB824\uBA74\uC774 \uBCC0\uACBD\uC744 \uC704\uD574 \uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uC2ED\uC2DC\uC624.",
                "settings.statistics": "\uD1B5\uACC4",
                "settings.stop": "\uC911\uC9C0",
                "settings.switch_view_mode_text": "\uC774 \uBCC0\uACBD \uC0AC\uD56D\uC744 \uC801\uC6A9\uD558\uAE30 \uC704\uD574 \uD68C\uC758\uB97C \uB2E4\uC2DC \uB9FA\uC5B4\uC57C\uD569\uB2C8\uB2E4",
                "settings.test_mic": "\uB9C8\uC774\uD06C \uD14C\uC2A4\uD2B8",
                "settings.test_speaker": "\uC2A4\uD53C\uCEE4 \uD14C\uC2A4\uD2B8",
                "settings.unknown_device": "\uC54C\uB824\uC9C0\uC9C0 \uC54A\uC740 \uC7A5\uCE58",
                "settings.use_hardware_acceleration": "\uD558\uB4DC\uC6E8\uC5B4 \uAC00\uC18D\uC744 \uC0AC\uC6A9\uD558\uC2ED\uC2DC\uC624.",
                "settings.vb_init_10s_tip2": "\uAC00\uC0C1 \uBC30\uACBD\uC740\uB85C\uB4DC \uD560 \uC608\uC0C1\uBCF4\uB2E4 \uC624\uB798 \uAC78\uB9AC\uACE0 \uC788\uC2B5\uB2C8\uB2E4.",
                "settings.vb_init_fail2": "\uAC00\uC0C1 \uBC30\uACBD\uC744\uB85C\uB4DC \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                "settings.video_tab_text": "\uBE44\uB514\uC624",
                speaker_view: "\uBC1C\uD45C\uC790 \uBCF4\uAE30",
                toolbar_join_audio: "\uC624\uB514\uC624 \uCC38\uAC00",
                toolbar_leave: "\uB098\uAC00\uAE30",
                toolbar_mute: "\uC74C\uC18C\uAC70",
                toolbar_muteall: "\uBAA8\uB450 \uC74C\uC18C\uAC70",
                toolbar_record: "\uAE30\uB85D",
                toolbar_unmute: "\uC74C\uC18C\uAC70 \uD574\uC81C",
                wait_room_tip1: "{{displayName}}\uB2D8\uC774 \uC774 \uD68C\uC758\uC758 \uB300\uAE30\uC2E4\uC5D0 \uC785\uC7A5\uD588\uC2B5\uB2C8\uB2E4",
                wait_room_tip2: "{{count}}\uBA85\uC774 \uC774 \uD68C\uC758\uC758 \uB300\uAE30\uC2E4\uC5D0 \uC785\uC7A5\uD588\uC2B5\uB2C8\uB2E4",
                "wc.ast_admin_name": "\uD68C\uC758 \uB3C4\uC6B0\uBBF8",
                "wc.rmc_admin_name": "\uD68C\uC758 \uCEE8\uD2B8\uB864 \uAD00\uB9AC\uC790",
                "wc.rmc_admin_tooltip": "\uC774 \uC0AC\uC6A9\uC790\uB294 \uD638\uC2A4\uD2B8 \uC81C\uC5B4 \uAD8C\uD55C\uC744 \uAC00\uC9C0\uACE0 \uC788\uC73C\uBA70 \uBBF8\uB514\uC5B4 \uCF58\uD150\uCE20(\uC624\uB514\uC624, \uBE44\uB514\uC624, \uCC44\uD305, \uBC18\uC751)\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                wc_3rd_cc_copied_api_token: "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 API \uD1A0\uD070 \uBCF5\uC0AC\uB428",
                wc_3rd_cc_copy_api_token: "API \uD1A0\uD070 \uBCF5\uC0AC",
                wc_3rd_cc_service: "\uD0C0\uC0AC CC \uC11C\uBE44\uC2A4 \uC0AC\uC6A9",
                wc_3rd_cc_url_help_tips2: "\uC774 \uD1A0\uD070\uC744 \uBCF5\uC0AC\uD558\uC5EC \uD0C0\uC0AC \uC120\uD0DD \uC790\uB9C9 \uB3C4\uAD6C\uC5D0 \uBD99\uC5EC\uB123\uAE30",
                wc_admit: "\uC218\uB77D",
                wc_allow_to_talk: "\uB9D0\uD558\uAE30 \uD5C8\uC6A9",
                wc_audio: "\uC624\uB514\uC624",
                "wc_audio.muted_notification1": "\uD638\uC2A4\uD2B8\uAC00 \uADC0\uD558\uB97C \uC74C\uC18C\uAC70\uD588\uC2B5\uB2C8\uB2E4",
                "wc_audio.muted_notification2": "\uD638\uC2A4\uD2B8\uAC00 \uBAA8\uB450\uB97C \uC74C\uC18C\uAC70\uD588\uC2B5\uB2C8\uB2E4",
                "wc_audio.unmute_by_host_content_1": "\uD638\uC2A4\uD2B8\uAC00 \uADC0\uD558\uAC00 \uB9D0\uD558\uAE30\uB97C \uC6D0\uD569\uB2C8\uB2E4",
                "wc_audio.unmute_by_host_content_2": "\uC74C\uC18C\uAC70\uB97C \uD574\uC81C\uD558\uBA74 \uC6E8\uBE44\uB098\uC5D0 \uC788\uB294 \uB2E4\uB978 \uC0AC\uC6A9\uC790\uAC00 \uADC0\uD558\uC758 \uC18C\uB9AC\uB97C \uB4E4\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uAC00 \uC74C\uC18C\uAC70\uB97C \uD574\uC81C\uD55C \uD6C4 \uD638\uC2A4\uD2B8 \uB610\uB294 \uD1A0\uB860\uC790\uAC00 \uC6E8\uBE44\uB098\uB97C \uAE30\uB85D, \uB77C\uC774\uBE0C \uC2A4\uD2B8\uB9AC\uBC0D \uB610\uB294 \uBCF4\uAD00\uD558\uAE30\uB85C \uACB0\uC815\uD558\uBA74 \uADC0\uD558\uC758 \uC74C\uC131\uC774 \uD3EC\uD568\uB429\uB2C8\uB2E4.",
                wc_audio_cannot_unmute: "\uD638\uC2A4\uD2B8\uAC00 \uADC0\uD558\uB97C \uC74C\uC18C\uAC70\uD588\uC73C\uBBC0\uB85C \uC2A4\uC2A4\uB85C \uC74C\uC18C\uAC70 \uD574\uC81C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                wc_audio_connecting_thumbnail: "\uC624\uB514\uC624 \uC5F0\uACB0",
                wc_broadcasting: "\uBC29\uC1A1",
                wc_btn_endconf_meeting_all: "\uBAA8\uB450\uC5D0 \uB300\uD574 \uD68C\uC758 \uC885\uB8CC",
                wc_camera_prevent: "\uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uCE74\uBA54\uB77C\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4\uB97C \uCC28\uB2E8\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4. \uD65C\uC131\uD654\uD558\uACE0 \uBE44\uB514\uC624\uB97C \uB2E4\uC2DC \uC2DC\uC791\uD558\uC2ED\uC2DC\uC624.",
                "wc_cc.placeholder": "\uC5EC\uAE30\uC5D0 \uC785\uB825\uD558\uACE0 \uBE0C\uB85C\uB4DC\uCE90\uC2A4\uD2B8\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC2ED\uC2DC\uC624.",
                wc_cc_assign_participant_to_type: "\uC785\uB825\uD560 \uCC38\uAC00\uC790 \uC9C0\uC815",
                wc_cc_assign_to: "\uC120\uD0DD \uC790\uB9C9 \uC785\uB825 \uD560\uB2F9",
                wc_cc_assign_to_type: "\uC785\uB825\uD560 \uC0AC\uC6A9\uC790 \uC9C0\uC815",
                wc_cc_broadcasting_tip: "\uC120\uD0DD \uC790\uB9C9\uC774 \uBAA8\uB4E0 \uCC38\uAC00\uC790\uC5D0\uAC8C \uBC29\uC1A1\uB418\uACE0 \uC788\uC2B5\uB2C8\uB2E4.",
                wc_cc_host_assigned: "\uD638\uC2A4\uD2B8\uAC00 \uC120\uD0DD \uC790\uB9C9\uC744 \uC785\uB825\uD558\uB3C4\uB85D \uD560\uB2F9\uD558\uC600\uC2B5\uB2C8\uB2E4.",
                wc_cc_type_myself: "\uB2E4\uC74C \uBC94\uC704\uB97C \uC785\uB825\uD560 \uAC83\uC785\uB2C8\uB2E4.",
                wc_cc_withdraw: "\uC120\uD0DD \uC790\uB9C9 \uC0AC\uC6A9 \uAD8C\uD55C \uD68C\uC218",
                "wc_chat.attendee_chat_with": "\uCC38\uC11D\uC790\uAC00 \uCC44\uD305\uC774 \uAC00\uB2A5\uD55C \uB300\uC0C1:",
                "wc_chat.chat": "\uCC44\uD305",
                "wc_chat.direct_message": "(DM)",
                "wc_chat.disable_chat": "\uD638\uC2A4\uD2B8\uAC00 \uCC38\uC11D\uC790 \uCC44\uD305\uC744 \uBE44\uD65C\uC131\uD654\uD558\uC600\uC2B5\uB2C8\uB2E4.",
                "wc_chat.disabled": "\uC544\uBB34\uB3C4",
                "wc_chat.everyone": "\uBAA8\uB450",
                "wc_chat.everyone_public": "\uBAA8\uB450\uC5D0\uAC8C \uACF5\uAC1C",
                "wc_chat.everyone_public_private": "\uBAA8\uB450\uC5D0\uAC8C \uACF5\uAC1C \uBC0F \uBE44\uACF5\uAC1C",
                "wc_chat.host_only": "\uD638\uC2A4\uD2B8\uB9CC",
                "wc_chat.host_panelists": "\uD638\uC2A4\uD2B8 \uBC0F \uD1A0\uB860\uC790",
                "wc_chat.me": "\uB098",
                "wc_chat.panelist_chat_with": "\uD1A0\uB860\uC790\uAC00 \uCC44\uD305\uC774 \uAC00\uB2A5\uD55C \uB300\uC0C1:",
                "wc_chat.type_msg": "\uC5EC\uAE30\uC5D0 \uBA54\uC2DC\uC9C0 \uC785\uB825...",
                wc_closed_caption_btn: "\uC120\uD0DD \uC790\uB9C9",
                wc_co_host: "(\uACF5\uB3D9 \uD638\uC2A4\uD2B8)",
                wc_continue: "\uACC4\uC18D",
                wc_copied: "\uBCF5\uC0AC\uB428",
                wc_copied_to_clipboard: "\uCD08\uB300 \uB9C1\uD06C\uAC00 \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
                wc_copy_link: "\uB9C1\uD06C \uBCF5\uC0AC",
                wc_data_center2: "\uADC0\uD558\uB294 \uC628\uD504\uB808\uBBF8\uC2A4 \uB370\uC774\uD130 \uC13C\uD130\uC5D0 \uC5F0\uACB0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                wc_data_center3: "\uADC0\uD558\uB294 \uC628\uD504\uB808\uBBF8\uC2A4 \uB370\uC774\uD130 \uC13C\uD130\uB97C \uD1B5\uD574 Zoom \uAE00\uB85C\uBC8C \uB124\uD2B8\uC6CC\uD06C\uC5D0 \uC5F0\uACB0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                wc_disable_talking: "\uB9D0\uD558\uAE30 \uC0AC\uC6A9 \uC548 \uD568",
                wc_dlg_confirm: "\uD655\uC778",
                wc_enable: "\uD65C\uC131\uD654\uB428",
                wc_encryption: "\uC554\uD638\uD654",
                wc_extra_function_disable_video: "\uC548 \uBE44\uB514\uC624 \uC218\uC2E0",
                wc_files: "\uD30C\uC77C",
                wc_footer_assign_leave: "\uC9C0\uC815 \uD6C4 \uB098\uAC00\uAE30",
                wc_footer_assign_new_host: "\uC0C8 \uD638\uC2A4\uD2B8 \uC9C0\uC815",
                wc_guest: "\uAC8C\uC2A4\uD2B8",
                wc_host_1: "\uD638\uC2A4\uD2B8",
                wc_in_the_meeting: "\uD68C\uC758 \uC911",
                wc_invite_link: "\uCD08\uB300 \uB9C1\uD06C",
                wc_join_media_preview_info_confirm: "\uD655\uC778",
                wc_join_media_preview_warning_denied_both: "\uBE0C\uB77C\uC6B0\uC800\uC758 \uC8FC\uC18C \uD45C\uC2DC\uC904\uC5D0\uC11C \uCE74\uBA54\uB77C \uBC0F \uB9C8\uC774\uD06C \uC561\uC138\uC2A4\uB97C \uD65C\uC131\uD654\uD569\uB2C8\uB2E4.",
                wc_join_media_preview_warning_denied_camera: "\uBE0C\uB77C\uC6B0\uC800\uC758 \uC8FC\uC18C \uD45C\uC2DC\uC904\uC5D0\uC11C \uCE74\uBA54\uB77C \uC561\uC138\uC2A4\uB97C \uD65C\uC131\uD654\uD569\uB2C8\uB2E4.",
                wc_join_media_preview_warning_denied_mic: "\uBE0C\uB77C\uC6B0\uC800\uC758 \uC8FC\uC18C \uD45C\uC2DC\uC904\uC5D0\uC11C \uB9C8\uC774\uD06C \uC561\uC138\uC2A4\uB97C \uD65C\uC131\uD654\uD569\uB2C8\uB2E4.",
                wc_joining: "\uD569\uB958",
                wc_joining_meeting: "\uD68C\uC758 \uCC38\uAC00 \uC911...",
                wc_learn_more: "\uB354 \uC54C\uC544\uBCF4\uAE30",
                wc_leave_computer_audio: "\uCEF4\uD4E8\uD130 \uC624\uB514\uC624 \uB098\uAC00\uAE30",
                wc_leave_meeting: "\uD68C\uC758 \uB098\uAC00\uAE30",
                wc_leave_webinar: "\uC6E8\uBE44\uB098 \uB098\uAC00\uAE30",
                wc_live_transcription_btn: "\uC2E4\uC2DC\uAC04 \uB300\uD654 \uB0B4\uC6A9",
                wc_lock_meeting: "\uD68C\uC758 \uC7A0\uAE08",
                wc_lower_hand: "\uC190 \uB0B4\uB9AC\uAE30",
                wc_lt_disable_transcription: "\uC790\uB3D9 \uB300\uD654 \uB0B4\uC6A9 \uC0AC\uC6A9 \uC548 \uD568",
                wc_lt_enable_transcription: "\uC790\uB3D9 \uB300\uD654 \uB0B4\uC6A9 \uC0AC\uC6A9",
                wc_lt_item_captioner: "(\uC790\uB9C9\uAE30)",
                wc_lt_live_transcript: "\uC2E4\uC2DC\uAC04 \uB300\uD654 \uB0B4\uC6A9",
                wc_lt_menu_item1: "\uC790\uB9C9 \uD45C\uC2DC",
                wc_lt_menu_item2: "\uC804\uCCB4 \uB300\uD654 \uB0B4\uC6A9 \uBCF4\uAE30",
                wc_lt_menu_item3: "\uC790\uB9C9 \uC228\uAE30\uAE30",
                wc_lt_menu_item4: "\uC804\uCCB4 \uB300\uD654 \uB0B4\uC6A9 \uB2EB\uAE30",
                wc_lt_request_host_ctrl: "\uCC38\uAC00\uC790\uAC00 \uC2E4\uC2DC\uAC04 \uB300\uD654 \uB0B4\uC6A9\uC744 \uC694\uCCAD\uD558\uB3C4\uB85D \uD5C8\uC6A9",
                wc_lt_search_text: "\uAC80\uC0C9",
                wc_make_co_host: "\uACF5\uB3D9 \uD638\uC2A4\uD2B8 \uB9CC\uB4E4\uAE30",
                wc_make_host: "\uD638\uC2A4\uD2B8 \uB9CC\uB4E4\uAE30",
                wc_me: "(\uB098)",
                wc_more: "\uB354 \uBCF4\uAE30",
                wc_no: "\uC544\uB2C8\uC694",
                wc_none: "\uC5C6\uC74C",
                wc_not_share_pronoun: "\uACF5\uC720 \uC548 \uD568",
                wc_num_password: "\uC22B\uC790 \uC554\uD638 \uC804\uD654 / \uB8F8 \uC2DC\uC2A4\uD15C",
                wc_participant_id: "\uCC38\uAC00\uC790 ID",
                wc_participants: "\uCC38\uAC00\uC790",
                wc_pc_audio: "\uCEF4\uD4E8\uD130 \uC624\uB514\uC624",
                wc_prevent_access_mic: "\uBE0C\uB77C\uC6B0\uC800\uAC00 \uB9C8\uC774\uD06C\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4\uB97C \uCC28\uB2E8\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.",
                wc_put_in_waiting: "\uB300\uAE30\uC2E4\uC5D0 \uBC30\uCE58",
                "wc_qa.allQ": "\uBAA8\uB4E0 \uC9C8\uBB38",
                "wc_qa.anonymous_attendee": "\uC775\uBA85 \uCC38\uC11D\uC790",
                "wc_qa.answer_private_type": "\uBE44\uACF5\uAC1C \uB2F5\uBCC0",
                "wc_qa.answeredQ": "\uB2F5\uBCC0\uB428",
                "wc_qa.attendee_placeholder": "\uD638\uC2A4\uD2B8\uC640 \uD1A0\uB860\uC790\uC5D0\uAC8C \uBB38\uC758\uD558\uC2E0 \uC9C8\uBB38\uC740 \uC5EC\uAE30\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
                "wc_qa.button_comment": "\uC758\uACAC",
                "wc_qa.button_display_answer": "\uB300\uB2F5 \uC785\uB825",
                "wc_qa.button_live": "\uC2E4\uC2DC\uAC04 \uB2F5\uBCC0",
                "wc_qa.button_live_done": "\uC644\uB8CC",
                "wc_qa.button_reopen": "\uB2E4\uC2DC \uC5F4\uAE30",
                "wc_qa.collapse_all_answer": "\uBAA8\uB450 \uCD95\uC18C",
                "wc_qa.dismissedQ": "\uBB34\uC2DC\uB428",
                "wc_qa.display_all_answer": "\uBAA8\uB450 \uD45C\uC2DC",
                "wc_qa.dissmis_tips": "\uBB34\uC2DC",
                "wc_qa.input_tips": "\uC5EC\uAE30\uC5D0 \uC9C8\uBB38 \uC785\uB825...",
                "wc_qa.is_anonymous": "\uC775\uBA85 \uC804\uC1A1",
                "wc_qa.is_privately": "\uBE44\uACF5\uAC1C\uB85C \uC804\uC1A1",
                "wc_qa.live_tips_done": "\uC774 \uC9C8\uBB38\uC740 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uB2F5\uBCC0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                "wc_qa.live_tips_start": "\uC774 \uC9C8\uBB38\uC5D0 \uB300\uD574 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uB2F5\uBCC0\uD558\uB824\uACE0 \uD569\uB2C8\uB2E4.",
                "wc_qa.most_recent": "\uCD5C\uADFC",
                "wc_qa.most_upvotes": "\uCD5C\uB2E4 \uCC2C\uC131",
                "wc_qa.myQ": "\uB0B4 \uC9C8\uBB38",
                "wc_qa.no_answered_questions": "\uB2F5\uBCC0\uB41C \uC9C8\uBB38 \uC5C6\uC74C",
                "wc_qa.no_dismissed_questions": "\uD574\uC81C\uB41C \uC9C8\uBB38 \uC5C6\uC74C",
                "wc_qa.no_open_questions": "\uD574\uACB0\uB418\uC9C0 \uC54A\uC740 \uC9C8\uBB38 \uC5C6\uC74C",
                "wc_qa.no_questions": "\uC9C8\uBB38 \uC5C6\uC74C",
                "wc_qa.openedQ": "\uC5F4\uAE30",
                "wc_qa.panelist_host_only_placeholder": "\uD638\uC2A4\uD2B8\uC640 \uD1A0\uB860\uC790\uB9CC \uC9C8\uBB38\uC744 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
                "wc_qa.panelist_view_all_placehoder": "\uC774 \uC6E8\uBE44\uB098\uC5D0 \uC788\uB294 \uBAA8\uB4E0 \uC0AC\uB78C\uC774 \uD574\uACB0\uB418\uC9C0 \uC54A\uC740 \uC9C8\uBB38\uC744 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
                "wc_qa.qa_comp_title": "Q&A",
                "wc_qa.send": "\uC804\uC1A1",
                "wc_qa.setting_allow_view": "\uCC38\uC11D\uC790\uAC00 \uBCFC \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9",
                "wc_qa.setting_btn_name": "\uC124\uC815",
                "wc_qa.setting_option_allow_anony_question": "\uC775\uBA85 \uC9C8\uBB38 \uD5C8\uC6A9",
                "wc_qa.setting_option_allow_comment": "\uCC38\uC11D\uC790\uAC00 \uC758\uACAC\uC744 \uB9D0\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                "wc_qa.setting_option_allow_view_all": "\uBAA8\uB4E0 \uC9C8\uBB38",
                "wc_qa.setting_option_allow_view_answered": "\uB2F5\uBCC0\uB41C \uC9C8\uBB38\uB9CC",
                "wc_qa.setting_option_allow_vote": "\uCC38\uC11D\uC790\uAC00 \uC5C5\uBCF4\uD2B8 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                "wc_qa.welcome_banner": "\uD638\uC2A4\uD2B8\uC640 \uD1A0\uB860\uC790\uC5D0\uAC8C \uC790\uC720\uB86D\uAC8C \uC9C8\uBB38\uD558\uC2ED\uC2DC\uC624.",
                "wc_qa.welcome_banner_title": "\uD658\uC601\uD569\uB2C8\uB2E4.",
                wc_raise_hand: "\uC190\uB4E4\uAE30",
                wc_reclaim_host: "\uD638\uC2A4\uD2B8 \uD68C\uC218",
                wc_record_host_reminder_desc: "\uACC4\uC18D\uD558\uBA74 \uBAA8\uB4E0 \uC5BC\uAD74, \uB300\uD654 \uBC0F \uD654\uBA74 \uACF5\uC720\uAC00 \uD074\uB77C\uC6B0\uB4DC\uC5D0 \uAE30\uB85D\uB429\uB2C8\uB2E4.",
                wc_record_reminder_desc: "\uACC4\uC18D \uD68C\uC758\uC5D0 \uC788\uC73C\uBA74 \uAE30\uB85D \uD5C8\uC6A9\uC5D0 \uB3D9\uC758\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4.",
                wc_record_reminder_desc_2: "{{accountOwner}}\uB2D8\uACFC \uD638\uC2A4\uD2B8\uB294 Zoom \uD074\uB77C\uC6B0\uB4DC \uB179\uD654\uB97C \uBCFC \uC218 \uC788\uC73C\uBA70 \uAD8C\uD55C\uC774 \uC788\uB294 \uBAA8\uB4E0 \uCC38\uAC00\uC790\uB294 \uADF8\uB4E4\uC758 \uB85C\uCEEC \uC7A5\uCE58\uC5D0 \uAE30\uB85D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC774\uB4E4\uC740 \uC774\uB7F0\uD55C \uAE30\uB85D\uC744 \uC571 \uBC0F \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                wc_record_reminder_title: "\uC774 \uD68C\uC758\uB294 \uAE30\uB85D\uB418\uACE0 \uC788\uC2B5\uB2C8\uB2E4",
                wc_record_reminder_webinar_title: "\uC774 \uC6E8\uBE44\uB098\uB294 \uAE30\uB85D\uB418\uACE0 \uC788\uC2B5\uB2C8\uB2E4",
                wc_record_webinar_reminder_desc: "\uACC4\uC18D \uC6E8\uBE44\uB098\uC5D0 \uC788\uC73C\uBA74 \uAE30\uB85D \uD5C8\uC6A9\uC5D0 \uB3D9\uC758\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4.",
                wc_recording_pause: "\uAE30\uB85D \uC77C\uC2DC \uC911\uC9C0",
                wc_recording_resume: "\uAE30\uB85D \uB2E4\uC2DC \uC2DC\uC791",
                wc_recording_stop: "\uAE30\uB85D \uC911\uC9C0",
                wc_recording_title: "\uC774 \uD68C\uC758\uB97C \uAE30\uB85D \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                wc_remove: "\uC81C\uAC70",
                wc_select_camera: "\uCE74\uBA54\uB77C \uC120\uD0DD",
                wc_select_microphone: "\uB9C8\uC774\uD06C \uC120\uD0DD",
                wc_select_speaker: "\uC2A4\uD53C\uCEE4 \uC120\uD0DD",
                wc_share_muted_while_sharing_audio_tip2: "\uCEF4\uD4E8\uD130 \uC624\uB514\uC624\uB97C \uACF5\uC720 \uD560 \uB54C \uB9C8\uC774\uD06C\uAC00 \uBE44\uD65C\uC131\uD654\uB429\uB2C8\uB2E4. \uC624\uB514\uC624 \uACF5\uC720\uB97C \uC77C\uC2DC \uC911\uC9C0\uD558\uAC70\uB098 \uC911\uC9C0\uD558\uBA74 \uB9C8\uC774\uD06C\uAC00 \uB2E4\uC2DC \uD65C\uC131\uD654\uB429\uB2C8\uB2E4.",
                wc_share_pronoun: "\uACF5\uC720",
                wc_share_pronoun_menu: "\uB0B4 \uB300\uBA85\uC0AC \uACF5\uC720",
                wc_share_pronoun_tip2: "\uC774 \uD68C\uC758\uC5D0\uC11C \uB300\uBA85\uC0AC\uC744(\uB97C) \uACF5\uC720\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                wc_sharer_controlbar_container_button3_label: "\uACF5\uC720 \uC911\uC9C0",
                wc_sharer_controlbar_container_rec_status_tip1: "\uD654\uBA74\uC744 \uACF5\uC720\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4",
                wc_sharer_controlbar_container_rec_status_tip2: "\uD654\uBA74 \uACF5\uC720\uAC00 \uC77C\uC2DC \uC911\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
                wc_sharer_disabled_share1_desc: "\uD638\uC2A4\uD2B8\uAC00 \uCC38\uC11D\uC790 \uD654\uBA74 \uACF5\uC720\uB97C \uBE44\uD65C\uC131\uD654\uD588\uC2B5\uB2C8\uB2E4.",
                wc_sharer_disabled_share2_desc: "\uB2E4\uB978 \uCC38\uAC00\uC790\uAC00 \uACF5\uC720\uD558\uB294 \uB3D9\uC548\uC5D0\uB294 \uD654\uBA74 \uACF5\uC720\uB97C \uC2DC\uC791\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                wc_sharer_entry_button_label1: "\uD654\uBA74 \uACF5\uC720",
                wc_sharer_setting_menu_category1_title: "\uB204\uAC00 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uAE4C?",
                wc_sharer_setting_menu_category2_title: "\uB2E4\uB978 \uC0AC\uC6A9\uC790\uAC00 \uACF5\uC720 \uC911\uC778 \uACBD\uC6B0 \uB204\uAC00 \uACF5\uC720\uB97C \uC2DC\uC791\uD560 \uC218 \uC788\uC2B5\uB2C8\uAE4C?",
                wc_sharer_setting_menu_category3_title: "\uB3D9\uC2DC\uC5D0 \uACF5\uC720\uD560 \uC218 \uC788\uB294 \uCC38\uAC00\uC790\uB294 \uBA87 \uBA85\uC785\uB2C8\uAE4C?",
                wc_sharer_setting_menu_category_option1: "\uD638\uC2A4\uD2B8\uB9CC",
                wc_sharer_setting_menu_category_option2: "\uBAA8\uB4E0 \uCC38\uAC00\uC790",
                wc_sharer_setting_menu_item1: "\uD55C \uBC88\uC5D0 \uD55C \uCC38\uAC00\uC790\uB9CC \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
                wc_sharer_setting_menu_item2: "\uC5EC\uB7EC \uCC38\uAC00\uC790\uAC00 \uB3D9\uC2DC\uC5D0 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                wc_sharing_fit_to_window: "\uCC3D\uC5D0 \uB9DE\uCD94\uAE30",
                wc_sharing_original_size: "\uC6D0\uBCF8 \uC0AC\uC774\uC988",
                wc_sharing_shared_screens: "\uACF5\uC720\uB41C \uD654\uBA74",
                wc_sharing_view_options: "\uC635\uC158 \uBCF4\uAE30",
                wc_sharing_viewing: "{{displayName}}\uC758 \uD654\uBA74\uC744 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                wc_tel_password: "\uC554\uD638",
                wc_unmute_by_host_btn1: "\uC74C\uC18C\uAC70 \uC720\uC9C0",
                wc_unshare_pronoun_menu: "\uB0B4 \uB300\uBA85\uC0AC \uACF5\uC720 \uD574\uC81C",
                "wc_video.allow_panelist_start_video": "\uD1A0\uB860\uC790\uAC00 \uBE44\uB514\uC624\uB97C \uC2DC\uC791\uD558\uB3C4\uB85D \uD5C8\uC6A9",
                "wc_video.allow_participants_start_video": "\uCC38\uAC00\uC790\uAC00 \uBE44\uB514\uC624\uB97C \uC2DC\uC791\uD558\uB3C4\uB85D \uD5C8\uC6A9",
                "wc_video.ask_start_video": "\uBE44\uB514\uC624 \uC2DC\uC791 \uC694\uCCAD",
                "wc_video.model_stop": "\uD638\uC2A4\uD2B8\uAC00 \uBE44\uB514\uC624\uB97C \uC911\uC9C0\uD588\uAE30 \uB54C\uBB38\uC5D0 \uBE44\uB514\uC624\uB97C \uC2DC\uC791\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                "wc_video.start_video": "\uBE44\uB514\uC624 \uC2DC\uC791",
                "wc_video.stop_video": "\uBE44\uB514\uC624 \uC911\uC9C0",
                "wc_video.video": "\uBE44\uB514\uC624",
                wc_view: "\uBCF4\uAE30",
                wc_waiting_room: "\uB300\uAE30\uC2E4",
                "wc_webinar.change_to_attendee": "\uCC38\uC11D\uC790\uB85C \uC5ED\uD560 \uBCC0\uACBD",
                "wc_webinar.promote_to_panelist": "\uD1A0\uB860\uC790 \uC218\uC900 \uC62C\uB9AC\uAE30",
                wc_webinar_attendees: "\uCC38\uC11D\uC790",
                wc_webinar_panelists: "\uD1A0\uB860\uC790",
                wc_webinar_putonhold: "\uB300\uAE30 \uC0C1\uD0DC\uB85C \uC124\uC815",
                wc_withdraw_co_host: "\uACF5\uB3D9 \uD638\uC2A4\uD2B8 \uAD8C\uD55C \uD68C\uC218",
                wc_yes: "\uC608",
                websdk_enforce_update_content: "\uC774 \uD68C\uC758\uC5D0 \uCC38\uAC00\uD558\uB824\uBA74 {0} \uB610\uB294 \uADF8 \uC774\uC0C1 \uC571 \uBC84\uC804\uC774 \uD544\uC694\uD569\uB2C8\uB2E4. \uACC4\uC18D\uD558\uB824\uBA74 \uC5C5\uB370\uC774\uD2B8\uD558\uC2ED\uC2DC\uC624.",
                websdk_update_content: "\uCD5C\uC801\uD654 \uD68C\uC758 \uACBD\uD5D8\uC744 \uCD5C\uC2E0 \uBC84\uC804\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8 WebSDK"
              }
            },
            "vi-VN": {
              translation: {
                GOT_IT: "\u0110\xE3 hi\u1EC3u",
                account_owner: "ch\u1EE7 t\xE0i kho\u1EA3n",
                allow_to_access: "Cho ph\xE9p truy c\u1EADp m\xE1y \u1EA3nh v\xE0 micr\xF4 c\u1EE7a b\u1EA1n",
                "app_signal.approved_by": "\u0110\xE3 ph\xEA duy\u1EC7t b\u1EDFi",
                "app_signal.hosts_account": "T\xE0i kho\u1EA3n c\u1EE7a ng\u01B0\u1EDDi ch\u1EE7 tr\xEC",
                "app_signal.people": "ng\u01B0\u1EDDi",
                "app_signal.tip_text_2": "Xem c\xE1c \u1EE9ng d\u1EE5ng \u0111ang truy c\u1EADp n\u1ED9i dung cu\u1ED9c h\u1ECDp c\u1EE7a b\u1EA1n",
                "app_signal.unable_load2": "Kh\xF4ng th\u1EC3 t\u1EA3i \u1EE9ng d\u1EE5ng v\u1EDBi quy\u1EC1n truy c\u1EADp th\u1EDDi gian th\u1EF1c v\xE0o th\xF4ng tin c\u1EE7a b\u1EA1n.",
                "archiving.chat_1": "cu\u1ED9c tr\xF2 chuy\u1EC7n (c\xF4ng khai v\xE0 tr\u1EF1c ti\u1EBFp)",
                "archiving.chat_2": "cu\u1ED9c tr\xF2 chuy\u1EC7n (ch\u1EC9 c\xF4ng khai)",
                "archiving.chat_disable_content": "Tin nh\u1EAFn \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi trong cu\u1ED9c tr\xF2 chuy\u1EC7n kh\xF4ng th\u1EC3 l\u01B0u tr\u1EEF nh\u1EB1m m\u1EE5c \u0111\xEDch tu\xE2n th\u1EE7.",
                "archiving.chat_disable_title": "Cu\u1ED9c tr\xF2 chuy\u1EC7n \u0111\xE3 t\u1EAFt",
                "archiving.content1_sdk": "M\u1ED9t ho\u1EB7c nhi\u1EC1u ng\u01B0\u1EDDi tham gia cu\u1ED9c h\u1ECDp n\xE0y \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF d\u1EF1a tr\xEAn ch\xEDnh s\xE1ch t\xE0i kho\u1EA3n c\u1EE7a h\u1ECD. {{content}} c\u1EE7a h\u1ECD s\u1EBD nh\u1EADn \u0111\u01B0\u1EE3c n\u1ED9i dung t\u1EEB cu\u1ED9c h\u1ECDp n\xE0y v\xE0 c\xF3 th\u1EC3 chia s\u1EBB n\u1ED9i dung \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "archiving.content2_sdk": "\u1EDE l\u1EA1i cu\u1ED9c h\u1ECDp n\xE0y, ngh\u0129a l\xE0 b\u1EA1n \u0111\u1ED3ng \xFD cho {{content}} c\u1EE7a cu\u1ED9c h\u1ECDp n\xE0y \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF.",
                "archiving.default_title": "Cu\u1ED9c h\u1ECDp n\xE0y \u0111ang \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF",
                "archiving.fail_content_sdk": "{{features}} c\u1EE7a cu\u1ED9c h\u1ECDp n\xE0y ph\u1EA3i \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF nh\u1EB1m m\u1EE5c \u0111\xEDch tu\xE2n th\u1EE7.",
                "archiving.fail_title": "L\u01B0u tr\u1EEF th\u1EA5t b\u1EA1i",
                "archiving.subjects_combo_2_sdk": "{{0}} v\xe0 {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} v\xe0 {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} v\xe0 {{3}}",
                "archiving.tips_1_sdk": "{{subjects}} c\u1EE7a cu\u1ED9c h\u1ECDp n\xE0y \u0111ang \u0111\u01B0\u1EE3c t\u1ED5 ch\u1EE9c c\u1EE7a ng\u01B0\u1EDDi ch\u1EE7 tr\xEC l\u01B0u tr\u1EEF d\u1EF1a tr\xEAn ch\xEDnh s\xE1ch t\xE0i kho\u1EA3n c\u1EE7a h\u1ECD. {{receiver}} c\u1EE7a h\u1ECD s\u1EBD nh\u1EADn \u0111\u01B0\u1EE3c n\u1ED9i dung t\u1EEB cu\u1ED9c h\u1ECDp n\xE0y v\xE0 c\xF3 th\u1EC3 chia s\u1EBB n\u1ED9i dung \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "archiving.tips_2_sdk": "{{subjects}} c\u1EE7a cu\u1ED9c h\u1ECDp n\xE0y \u0111ang \u0111\u01B0\u1EE3c t\u1ED5 ch\u1EE9c c\u1EE7a ng\u01B0\u1EDDi ch\u1EE7 tr\xEC l\u01B0u tr\u1EEF d\u1EF1a tr\xEAn ch\xEDnh s\xE1ch t\xE0i kho\u1EA3n c\u1EE7a h\u1ECD. {{receiver}} c\u1EE7a h\u1ECD s\u1EBD nh\u1EADn \u0111\u01B0\u1EE3c n\u1ED9i dung t\u1EEB cu\u1ED9c h\u1ECDp n\xE0y v\xE0 c\xF3 th\u1EC3 chia s\u1EBB n\u1ED9i dung \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "archiving.transcription": "b\u1EA3n ch\xE9p l\u1EA1i",
                "ast.leave_tip": "ki\u1EC3m so\xE1t vi\xEAn \u0111\xE3 ng\u1EEBng \u0111i\u1EC1u khi\u1EC3n cu\u1ED9c h\u1ECDp.",
                "ast.tip": "Cu\u1ED9c h\u1ECDp n\xE0y \u0111ang \u0111\u01B0\u1EE3c tr\u1EE3 l\xFD ki\u1EC3m so\xE1t",
                background: "N\u1EC1n",
                chat_message_header: "<0> {{senderName}} </0> <1> th\xe0nh </1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}} tin nh\u1EAFn m\u1EDBi",
                chat_receiver_co_host: "(\u0110\u1ED3ng ch\u1EE7 tr\xEC)",
                chat_receiver_host: "(Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC)",
                chat_receiver_panelist: "(Ng\u01B0\u1EDDi tham gia ch\xEDnh)",
                chat_receiver_to: "T\u1EDBi:",
                choose_background: "Ch\u1ECDn n\u1EC1n",
                click_address_bar: "Nh\u1EA5p v\xE0o bi\u1EC3u t\u01B0\u1EE3ng kh\xF3a \u1EDF b\xEAn tr\xE1i c\u1EE7a thanh \u0111\u1ECBa ch\u1EC9 c\u1EE7a b\u1EA1n. M\u1ED9t c\u1EEDa s\u1ED5 b\u1EADt l\xEAn s\u1EBD xu\u1EA5t hi\u1EC7n v\u1EDBi m\u1ED9t danh s\xE1ch c\xE1c t\xF9y ch\u1ECDn.",
                click_microphone_camera_option: "Nh\u1EA5p v\xE0o danh s\xE1ch th\u1EA3 xu\u1ED1ng \u1EDF b\xEAn ph\u1EA3i c\u1EE7a t\xF9y ch\u1ECDn Camera v\xE0 Micr\xF4.",
                "common.cancel": "H\u1EE7y",
                "common.connecting": "\u0110ang k\u1EBFt n\u1ED1i",
                delete: "X\xF3a b\u1ECF",
                "dialog.btn_cancel": "H\u1EE7y",
                "dialog.btn_endconf_webinar": "K\u1EBFt th\xFAc h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn",
                "dialog.btn_leaveconf_meeting": "R\u1EDDi kh\u1ECFi cu\u1ED9c h\u1ECDp",
                "dialog.btn_retry": "Th\u1EED l\u1EA1i",
                "dialog.host_end_meeting": "Cu\u1ED9c h\u1ECDp n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c ng\u01B0\u1EDDi ch\u1EE7 tr\xEC k\u1EBFt th\xFAc.",
                "dialog.host_end_webinar": "H\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c ng\u01B0\u1EDDi ch\u1EE7 tr\xEC k\u1EBFt th\xFAc.",
                "dialog.meeting_ended": "Cu\u1ED9c h\u1ECDp \u0111\xE3 k\u1EBFt th\xFAc",
                "dialog.meeting_locked": "Cu\u1ED9c h\u1ECDp \u0111\xE3 b\u1ECB kh\xF3a",
                "dialog.meeting_removed_by_host": "B\u1EA1n \u0111\xE3 b\u1ECB ng\u01B0\u1EDDi ch\u1EE7 tr\xEC lo\u1EA1i kh\u1ECFi cu\u1ED9c h\u1ECDp n\xE0y.",
                "dialog.newname": "T\xean",
                "dialog.ok": "OK",
                "dialog.presscode": "ID h\u1ED9i ngh\u1ECB",
                "dialog.rename": "\u0110\u1ED5i t\xEAn",
                "dialog.server_error": "M\xE1y ch\u1EE7 g\u1EB7p l\u1ED7i n\u1ED9i b\u1ED9 v\xE0 kh\xF4ng th\u1EC3 x\u1EED l\xFD y\xEAu c\u1EA7u c\u1EE7a b\u1EA1n.",
                "dialog.webinar_ended": "H\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn \u0111\xE3 k\u1EBFt th\xFAc",
                "dialog.webinar_removed_by_host": "B\u1EA1n \u0111\xE3 b\u1ECB ng\u01B0\u1EDDi ch\u1EE7 tr\xEC lo\u1EA1i kh\u1ECFi h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn n\xE0y.",
                "dialog.you_are_removed": "B\u1EA1n \u0111\xE3 b\u1ECB lo\u1EA1i",
                dialog_make_cohost: "B\u1EA1n c\xF3 mu\u1ED1n ph\xE2n c\xF4ng {{displayName}}l\xE0 \u0111\u1ED3ng ch\u1EE7 tr\xEC cu\u1ED9c h\u1ECDp n\xE0y kh\xF4ng?",
                dialog_make_host: "B\u1EA1n c\xF3 mu\u1ED1n thay \u0111\u1ED5i ng\u01B0\u1EDDi ch\u1EE7 tr\xEC th\xE0nh {{displayName}}?",
                dialog_remove_user: "B\u1EA1n c\xF3 mu\u1ED1n lo\u1EA1i {{displayName}}?",
                "disclaimer.LT_button_1": "Ai c\xF3 th\u1EC3 xem b\u1EA3n ch\xE9p n\xE0y?",
                "disclaimer.LT_content_1_1": "Ch\u1EE7 s\u1EDF h\u1EEFu t\xE0i kho\u1EA3n v\xE0 mo\u0323i ng\u01B0\u01A1\u0300i trong cu\u1ED9c h\u1ECDp \u0111\u1EC1u c\xF3 th\u1EC3 l\u01B0u b\u1EA3n ch\xE9p n\xE0y v\xE0 chia s\u1EBB v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 nh\u1EEFng ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.LT_content_2": "Ch\xE9p l\u1EA1i tr\u1EF1c ti\u1EBFp (Ph\u1EE5 \u0111\u1EC1 r\u1EDDi) \u0111\xE3 \u0111\u01B0\u1EE3c b\u1EADt",
                "disclaimer.QA_button_1": "Ai c\xF3 th\u1EC3 xem c\xE2u h\u1ECFi c\u1EE7a b\u1EA1n?",
                "disclaimer.QA_content_1_1": "Ch\u1EE7 t\xE0i kho\u1EA3n, ng\u01B0\u1EDDi ch\u1EE7 tr\xEC, v\xE0 ng\u01B0\u1EDDi tham gia ch\xEDnh s\u1EBD c\xF3 th\u1EC3 bi\u1EBFt b\u1EA1n l\xE0 ai, th\xF4ng tin li\xEAn h\u1EC7 c\u1EE7a b\u1EA1n (n\u1EBFu b\u1EA1n \u0111\xE3 \u0111\u0103ng nh\u1EADp ho\u1EB7c b\u1EA1n \u0111\xE3 cung c\u1EA5p th\xF4ng tin n\xE0y) v\xE0 c\xE2u h\u1ECFi c\u1EE7a b\u1EA1n - \u0111\u1ED3ng th\u1EDDi c\xF3 th\u1EC3 chia s\u1EBB nh\u1EEFng th\xF4ng tin \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.QA_content_2": "N\u1EBFu c\xE2u h\u1ECFi c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c ch\u1ECDn, c\xE2u h\u1ECFi s\u1EBD hi\u1EC3n th\u1ECB cho t\u1EA5t c\u1EA3 nh\u1EEFng ng\u01B0\u1EDDi d\u1EF1 th\xEDnh.",
                "disclaimer.QA_content_3_3": "N\u1EBFu b\u1EA1n kh\xF4ng g\u1EEDi \u1EA9n danh, ch\u1EE7 t\xE0i kho\u1EA3n, ng\u01B0\u1EDDi ch\u1EE7 tr\xEC, v\xE0 ng\u01B0\u1EDDi tham gia ch\xEDnh s\u1EBD c\xF3 th\u1EC3 bi\u1EBFt b\u1EA1n l\xE0 ai, th\xF4ng tin li\xEAn h\u1EC7 c\u1EE7a b\u1EA1n (n\u1EBFu b\u1EA1n \u0111\xE3 \u0111\u0103ng nh\u1EADp ho\u1EB7c b\u1EA1n \u0111\xE3 cung c\u1EA5p th\xF4ng tin n\xE0y) v\xE0 c\xE2u h\u1ECFi c\u1EE7a b\u1EA1n - \u0111\u1ED3ng th\u1EDDi c\xF3 th\u1EC3 chia s\u1EBB nh\u1EEFng th\xF4ng tin \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.QA_content_4": "Ph\u1EA7n H\u1ECFi \u0111\xE1p n\xE0y l\xE0 c\xF4ng khai, v\xEC v\u1EADy m\u1ECDi ng\u01B0\u1EDDi \u0111\u1EC1u c\xF3 th\u1EC3 xem c\xE2u h\u1ECFi c\u1EE7a b\u1EA1n.",
                "disclaimer.QA_content_5": "N\u1EBFu b\u1EA1n g\u1EEDi c\xE2u h\u1ECFi c\u1EE7a m\xECnh theo c\xE1ch \u1EA9n danh, kh\xF4ng ai c\xF3 th\u1EC3 bi\u1EBFt ng\u01B0\u1EDDi \u0111\xE3 g\u1EEDi c\xE2u h\u1ECFi.",
                "disclaimer.chat_button_normal": "Ai c\xF3 th\u1EC3 xem tin nh\u1EAFn c\u1EE7a b\u1EA1n?",
                "disclaimer.chat_button_onArchiving": "Ai c\xF3 th\u1EC3 xem tin nh\u1EAFn c\u1EE7a b\u1EA1n? T\xEDnh n\u0103ng l\u01B0u tr\u1EEF \u0111ang \u0111\u01B0\u1EE3c b\u1EADt",
                "disclaimer.chat_button_onRecording": "Ai c\xF3 th\u1EC3 xem tin nh\u1EAFn c\u1EE7a b\u1EA1n? T\xEDnh n\u0103ng ghi l\u1EA1i \u0111ang \u0111\u01B0\u1EE3c b\u1EADt",
                "disclaimer.chat_content_1": "M\u1ECDi ng\u01B0\u1EDDi trong cu\u1ED9c h\u1ECDp c\xF3 th\u1EC3 xem v\xE0 l\u01B0u nh\u1EEFng tin nh\u1EAFn c\u1EE7a b\u1EA1n v\u1EDBi M\u1ECDi ng\u01B0\u1EDDi - \u0111\u1ED3ng th\u1EDDi c\xF3 th\u1EC3 chia s\u1EBB nh\u1EEFng tin nh\u1EAFn \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.chat_content_2": "Ch\u1EC9 b\u1EA1n v\xE0 nh\u1EEFng ng\u01B0\u1EDDi b\u1EA1n tr\xF2 chuy\u1EC7n c\xF9ng m\u1EDBi c\xF3 th\u1EC3 l\u01B0u tin nh\u1EAFn tr\u1EF1c ti\u1EBFp c\u1EE7a b\u1EA1n v\xE0 chia s\u1EBB ch\xFAng v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.chat_content_3": "T\xEDnh n\u0103ng ghi l\u1EA1i \u0111ang b\u1EADt, v\xEC v\u1EADy, ch\u1EE7 t\xE0i kho\u1EA3n v\xE0 m\u1ECDi ng\u01B0\u1EDDi trong cu\u1ED9c h\u1ECDp c\xF3 th\u1EC3 xem v\xE0 l\u01B0u nh\u1EEFng tin nh\u1EAFn \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi cho M\u1ECDi ng\u01B0\u1EDDi - \u0111\u1ED3ng th\u1EDDi c\xF3 th\u1EC3 chia s\u1EBB nh\u1EEFng tin nh\u1EAFn \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.chat_content_4": "T\xEDnh n\u0103ng ghi l\u1EA1i \u0111ang b\u1EADt, v\xEC v\u1EADy m\u1ECDi ng\u01B0\u1EDDi trong cu\u1ED9c h\u1ECDp c\xF3 th\u1EC3 xem v\xE0 l\u01B0u nh\u1EEFng tin nh\u1EAFn \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi cho M\u1ECDi ng\u01B0\u1EDDi - \u0111\u1ED3ng th\u1EDDi c\xF3 th\u1EC3 chia s\u1EBB nh\u1EEFng tin nh\u1EAFn \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.chat_content_5": "T\xEDnh n\u0103ng l\u01B0u tr\u1EEF \u0111ang \u0111\u01B0\u1EE3c b\u1EADt, v\xEC v\u1EADy ch\u1EE7 s\u1EDF h\u1EEFu t\xE0i kho\u1EA3n c\xF3 th\u1EC3 xem t\u1EA5t c\u1EA3 tin nh\u1EAFn c\u1EE7a b\u1EA1n \u2014 bao g\u1ED3m c\u1EA3 tin nh\u1EAFn tr\u1EF1c ti\u1EBFp \u2014 v\xE0 chia s\u1EBB ch\xFAng v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 nh\u1EEFng ng\u01B0\u1EDDi kh\xE1c.",
                "disclaimer.chat_content_6": "M\u1ECDi ng\u01B0\u1EDDi trong cu\u1ED9c h\u1ECDp c\xF3 th\u1EC3 l\u01B0u v\xE0 chia s\u1EBB tin nh\u1EAFn b\u1EA1n g\u1EEDi cho M\u1ECDi ng\u01B0\u1EDDi.",
                "disclaimer.chat_content_7": "T\xEDnh n\u0103ng l\u01B0u tr\u1EEF \u0111ang \u0111\u01B0\u1EE3c b\u1EADt, v\xEC v\u1EADy ch\u1EE7 t\xE0i kho\u1EA3n c\xF3 th\u1EC3 xem t\u1EA5t c\u1EA3 tin nh\u1EAFn c\u1EE7a b\u1EA1n - kh\xF4ng bao g\u1ED3m tin nh\u1EAFn tr\u1EF1c ti\u1EBFp - v\xE0 chia s\u1EBB nh\u1EEFng tin nh\u1EAFn \u0111\xF3 v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                errorcodes_be_removed: "\u0110\u01B0\u1EE3c g\u1EE1 b\u1ECF.",
                errorcodes_denied_email: "G\u1EEDi email b\u1ECB ch\u1EB7n b\u1EDFi Administrator.",
                errorcodes_denied_register_with_panelist: "T\u1EEB ch\u1ED1i s\u1EED d\u1EE5ng \u0111\u0103ng k\xFD email panelist.",
                errorcodes_disconnect: "H\u1ED9i ngh\u1ECB \u0111\xE3 \u0111\u01B0\u1EE3c ng\u1EAFt k\u1EBFt n\u1ED1i.",
                errorcodes_email_require: "Email l\xE0 m\u1EA5t t\xEDch tham d\u1EF1 h\u1ED9i th\u1EA3o tr\xEAn web.",
                errorcodes_fail: "Kh\xF4ng tham gia cu\u1ED9c h\u1ECDp.",
                errorcodes_frequent_call: "B\u1EA1n \u0111\xE3 \u0111\u1EA1t \u0111\u1EBFn gi\u1EDBi h\u1EA1n API cho cu\u1ED9c g\u1ECDi n\xE0y.",
                errorcodes_frequent_join: "B\u1EA1n \u0111\u01B0\u1EE3c gi\u1EDBi h\u1EA1n b\u1EDFi zoom, c\u1EA7n ph\u1EA3i ki\u1EC3m tra reCAPTCHA.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Kh\xF4ng th\u1EC3 tham gia t\u1EEB tr\xECnh duy\u1EC7t, h\xE3y tham gia b\u1EB1ng c\xE1ch s\u1EED d\u1EE5ng client desktop Ph\xF3ng to ho\u1EB7c \u1EE9ng d\u1EE5ng di \u0111\u1ED9ng.",
                errorcodes_not_exist: "H\u1ED9i ngh\u1ECB kh\xF4ng t\u1ED3n t\u1EA1i.",
                errorcodes_not_host: "B\u1EA1n kh\xF4ng ph\u1EA3i l\xE0 ch\u1EE7 nh\xE0 cu\u1ED9c h\u1ECDp.",
                errorcodes_not_init: "G\u1EB7p g\u1EE1 kh\xF4ng \u0111\u01B0\u1EE3c kh\u1EDFi t\u1EA1o.",
                errorcodes_not_start: "H\u1ED9i ngh\u1ECB \u0111\xE3 kh\xF4ng b\u1EAFt \u0111\u1EA7u",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "D\u1ECBch v\u1EE5 t\u1EA1m th\u1EDDi \u1EA9n.",
                errorcodes_pac_api_disabled: "C\xE1c chi\u1EBFm API Key l\xE0 v\xF4 hi\u1EC7u h\xF3a.",
                errorcodes_pac_api_wrong: "C\xE1c chi\u1EBFm API Key l\xE0 kh\xF4ng h\u1EE3p l\u1EC7.",
                errorcodes_pac_cant_host_other_mn: "kh\xF4ng th\u1EC3 kh\xF4ng t\u1ED5 ch\u1EE9c m\u1ED9t cu\u1ED9c h\u1ECDp kh\xE1c \u0111\u1ED3ng th\u1EDDi.",
                errorcodes_pac_host_not_found: "Ng\u01B0\u1EDDi d\u1EABn ch\u01B0\u01A1ng tr\xECnh cu\u1ED9c h\u1ECDp kh\xF4ng \u0111\u01B0\u1EE3c t\xECm th\u1EA5y.",
                errorcodes_pac_invalid_signature: "Ch\u1EEF k\xFD kh\xF4ng h\u1EE3p l\u1EC7.",
                errorcodes_pac_mn_not_fount: "S\u1ED1 cu\u1ED9c h\u1ECDp kh\xF4ng \u0111\u01B0\u1EE3c t\xECm th\u1EA5y.",
                errorcodes_pac_mn_wrong: "S\u1ED1 cu\u1ED9c h\u1ECDp l\xE0 sai.",
                errorcodes_pac_no_permission: "Kh\xf4ng cho ph\xe9p.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "vai tr\xf2 kh\xf4ng ch\xednh x\xe1c.",
                errorcodes_pac_signature_expired: "Ch\u1EEF k\xFD \u0111\xE3 h\u1EBFt h\u1EA1n.",
                errorcodes_re_connect: "H\u1ED9i ngh\u1ECB \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i l\u1EA1i.",
                errorcodes_register: "Cu\u1ED9c h\u1ECDp n\xE0y y\xEAu c\u1EA7u \u0111\u0103ng k\xFD.",
                errorcodes_rwc_empty: "Kh\xF4ng th\u1EC3 c\xF3 \u0111\u01B0\u1EE3c m\u1ED9t ph\u1EA3n h\u1ED3i t\u1EEB m\xE1y ch\u1EE7 web.",
                errorcodes_rwc_error: "Kh\xF4ng th\u1EC3 k\u1EBFt n\u1ED1i v\u1EDBi l\u1ED7i Web Server.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "tham gia th\xE0nh c\xF4ng cu\u1ED9c h\u1ECDp.",
                errorcodes_tk_expired: "M\xE3 th\xF4ng b\xE1o \u0111\xE3 h\u1EBFt h\u1EA1n.",
                errorcodes_wasm_fail: "file t\u1EA3i v\u1EC1 wasm l\u1ED7i, vui l\xF2ng ki\u1EC3m tra m\u1EA1ng v\xE0 t\u01B0\u1EDDng l\u1EEDa c\u1EE7a b\u1EA1n.",
                errorcodes_web_has_in_progress: "\u0110\xE3 c\xF3 cu\u1ED9c h\u1ECDp kh\xE1c \u0111ang di\u1EC5n ra.",
                errorcodes_web_host_not_exit: "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC cu\u1ED9c h\u1ECDp kh\xF4ng t\u1ED3n t\u1EA1i.",
                errorcodes_web_invalid_id: "ID cu\u1ED9c h\u1ECDp kh\xF4ng h\u1EE3p l\u1EC7.",
                errorcodes_web_not_allow_start_webinar_from_web: "Kh\xF4ng cho ph\xE9p b\u1EAFt \u0111\u1EA7u h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn t\u1EEB web.",
                errorcodes_web_not_support_registration_webinar: "Kh\xF4ng h\u1ED7 tr\u1EE3 \u0111\u0103ng k\xFD h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn",
                errorcodes_web_not_support_tsp: "Kh\xF4ng h\u1ED7 tr\u1EE3 b\u1EAFt \u0111\u1EA7u ho\u1EB7c v\xE0o cu\u1ED9c h\u1ECDp t\u1EEB web, khi b\u1EA1n ch\u1ECDn Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111i\u1EC7n tho\u1EA1i l\xE0m ngu\u1ED3n \xE2m thanh trong cu\u1ED9c h\u1ECDp.",
                errorcodes_web_not_support_webclient: "Kh\xF4ng h\u1ED7 tr\u1EE3 b\u1EAFt \u0111\u1EA7u ho\u1EB7c v\xE0o cu\u1ED9c h\u1ECDp t\u1EEB web.",
                errorcodes_web_not_support_webinar_pac: "Kh\xF4ng h\u1ED7 tr\u1EE3 h\u1ED9i th\u1EA3ovideo v\xE0 h\u1ED9i ngh\u1ECB \xE2m thanh c\xE1 nh\xE2n",
                errorcodes_web_require_email: "Email ng\u01B0\u1EDDi d\xF9ng l\xE0 b\u1EAFt bu\u1ED9c.",
                errorcodes_web_should_support_webinar_with_latest_version: "Phi\xEAn b\u1EA3n sdk hi\u1EC7n t\u1EA1i kh\xF4ng h\u1ED7 tr\u1EE3 h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn, h\xE3y n\xE2ng c\u1EA5p l\xEAn phi\xEAn b\u1EA3n m\u1EDBi nh\u1EA5t.",
                errorcodes_wrong_pass: "G\u1EB7p g\u1EE1 M\u1EADt kh\u1EA9u sai.",
                gallary_view: "Ch\u1EBF \u0111\u1ED9 xem th\u01B0 vi\u1EC7n",
                invalid_parameter: "Tham s\u1ED1 kh\xF4ng h\u1EE3p l\u1EC7",
                "invite.loading": "\u0110ang t\u1EA3i...",
                meeting_disconnected: "h\u1ED9i ngh\u1ECB ng\u1EAFt k\u1EBFt n\u1ED1i",
                meeting_info: "Th\xF4ng tin Cu\u1ED9c h\u1ECDp",
                meeting_info_network: "B\u1EA1n \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i v\u1EDBi {{M\u1EA1ng}} th\xF4ng qua c\xE1c trung t\xE2m d\u1EEF li\u1EC7u trong {{dc}}",
                meeting_not_start: "Cu\u1ED9c h\u1ECDp ch\u01B0a b\u1EAFt \u0111\u1EA7u",
                meeting_taking: "\u0111ang n\xF3i:",
                meeting_waiting_for_start: "Ch\u1EDD \u0111\u1EE3i cu\u1ED9c h\u1ECDp \u0111\u1EC3 b\u1EAFt \u0111\u1EA7u",
                meeting_waiting_room: "M\xE1y ch\u1EE7 s\u1EBD cho ph\xE9p b\u1EA1n s\u1EDBm",
                minimized_view: "T\u1ED1i thi\u1EC3u xem",
                mirror_my_video: "Ph\u1EA3n chi\u1EBFu video c\u1EE7a t\xF4i",
                "polling.Back": "Quay l\u1EA1i",
                "promote.cancel": "\u1EDE l\u1EA1i v\u1EDBi t\u01B0 c\xE1ch ng\u01B0\u1EDDi d\u1EF1 th\xEDnh",
                "promote.content_1": "V\u1EDBi t\u01B0 c\xE1ch l\xE0 m\u1ED9t ng\u01B0\u1EDDi tham gia ch\xEDnh, b\u1EA1n c\xF3 th\u1EC3 b\u1EADt ti\u1EBFng v\xE0 b\u1EAFt \u0111\u1EA7u video, t\u1EE9c l\xE0 ng\u01B0\u1EDDi kh\xE1c c\xF3 th\u1EC3 nh\xECn th\u1EA5y b\u1EA1n trong h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn.",
                "promote.content_2": "N\u1EBFu ng\u01B0\u1EDDi ch\u1EE7 tr\xEC ho\u1EB7c ng\u01B0\u1EDDi tham gia ch\xEDnh kh\xE1c quy\u1EBFt \u0111\u1ECBnh ghi l\u1EA1i, ph\xE1t tr\u1EF1c ti\u1EBFp ho\u1EB7c l\u01B0u tr\u1EEF h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn sau khi b\u1EA1n b\u1EADt ti\u1EBFng, s\u1EBD bao g\u1ED3m c\u1EA3 s\u1EF1 tham gia c\u1EE7a b\u1EA1n.",
                "promote.ok": "Tham gia v\u1EDBi t\u01B0 c\xE1ch l\xE0 ng\u01B0\u1EDDi tham gia ch\xEDnh",
                "promote.title": "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 th\u0103ng h\u1EA1ng b\u1EA1n th\xE0nh ng\u01B0\u1EDDi tham gia ch\xEDnh",
                ribbon_view: "View Ribbon.",
                "rmc.assistant_exist_warning": "B\u1EA1n kh\xF4ng th\u1EC3 \u0111i\u1EC1u khi\u1EC3n cu\u1ED9c h\u1ECDp v\xEC m\u1ED9t qu\u1EA3n tr\u1ECB vi\xEAn kh\xE1c \u0111ang \u0111i\u1EC1u khi\u1EC3n cu\u1ED9c h\u1ECDp n\xE0y.",
                "rmc.exist_notification_for_client_host": "Cu\u1ED9c h\u1ECDp n\xE0y \u0111ang \u0111\u01B0\u1EE3c m\u1ED9t qu\u1EA3n tr\u1ECB vi\xEAn \u0111i\u1EC1u khi\u1EC3n.",
                "rmc.not_exist_notification_for_client_host": "Qu\u1EA3n tr\u1ECB vi\xEAn \u0111\xE3 ng\u1EEBng \u0111i\u1EC1u khi\u1EC3n cu\u1ED9c h\u1ECDp.",
                same_as_system: "T\u01B0\u01A1ng t\u1EF1 nh\u01B0 h\u1EC7 th\u1ED1ng",
                "security.allow_participants_to": "Cho ph\xE9p ng\u01B0\u1EDDi tham gia:",
                "security.button": "B\u1EA3o m\u1EADt",
                "security.waiting_room": "K\xEDch ho\u1EA1t ph\xF2ng ch\u1EDD",
                select_allow: "Ch\u1ECDn t\xF9y ch\u1ECDn cho ph\xE9p.",
                "settings.audio_tab_text": "\xc2m thanh",
                "settings.enable_hd": "K\xEDch ho\u1EA1t video HD",
                "settings.enable_hd_tip": "K\xEDch ho\u1EA1t t\u1EA5t c\u1EA3 nh\u1EEFng ng\u01B0\u1EDDi tham gia \u0111\u1EC3 xem video c\u1EE7a b\u1EA1n \u1EDF \u0111\u1ED9 ph\xE2n gi\u1EA3i cao (720P). L\u01B0u \xFD r\u1EB1ng k\u1EBFt qu\u1EA3 th\u1EF1c t\u1EBF ph\u1EE5 thu\u1ED9c v\xE0o hi\u1EC7u su\u1EA5t m\xE1y v\xE0 b\u0103ng th\xF4ng.",
                "settings.frame_per_second": "Khung h\xECnh m\u1ED7i gi\xE2y",
                "settings.frequency": "T\u1EA7n su\u1EA5t",
                "settings.input_level": "M\u1EE9c \u0111\u1ED9 \u0111\u1EA7u v\xE0o:",
                "settings.item_name": "T\xEAn m\u1EE5c",
                "settings.jitter": "\u0110\u1ED9 tr\u1EC5 Jitter",
                "settings.latency": "\u0110\u1ED9 tr\u1EC5",
                "settings.maximum_view": "S\u1ED1 ng\u01B0\u1EDDi tham gia t\u1ED1i \u0111a \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB tr\xEAn m\u1ED7i m\xE0n h\xECnh trong Ch\u1EBF \u0111\u1ED9 xem th\u01B0 vi\u1EC7n:",
                "settings.output_level": "M\u1EE9c \u0111\u1ED9 \u0111\u1EA7u ra:",
                "settings.packet_loss": "M\u1EA5t g\xF3i d\u1EEF li\u1EC7u - Trung b\xECnh (T\u1ED1i \u0111a)",
                "settings.participants25": "25 Ng\u01B0\u1EDDi tham gia",
                "settings.participants9": "9 Ng\u01B0\u1EDDi tham gia",
                "settings.playing": "\u0110ang ph\xE1t",
                "settings.receive": "Nh\u1EADn",
                "settings.receiving_video": "Nh\u1EADn video",
                "settings.receiving_video_tips": "S\u1EED d\u1EE5ng b\u1ED9 gi\u1EA3i m\xE3 video ph\u1EA7n c\u1EE9ng c\u1EE7a card \u0111\u1ED3 h\u1ECDa \u0111\u1EC3 ti\u1EBFt ki\u1EC7m vi\u1EC7c s\u1EED d\u1EE5ng CPU \u0111\u1EC3 nh\u1EADn video. L\xE0m m\u1EDBi trang \u0111\u1EC3 thay \u0111\u1ED5i n\xE0y \u0111\u1EC3 c\xF3 hi\u1EC7u l\u1EF1c.",
                "settings.recording": "\u0110ang ghi",
                "settings.rejoin": "Tham gia",
                "settings.resolution": "\u0110\u1ED9 ph\xE2n gi\u1EA3i",
                "settings.send": "G\u1EEDi",
                "settings.sending_video": "G\u1EEDi video",
                "settings.sending_video_tips": "S\u1EED d\u1EE5ng b\u1ED9 gi\u1EA3i m\xE3 video ph\u1EA7n c\u1EE9ng c\u1EE7a card \u0111\u1ED3 h\u1ECDa \u0111\u1EC3 ti\u1EBFt ki\u1EC7m vi\u1EC7c s\u1EED d\u1EE5ng CPU \u0111\u1EC3 g\u1EEDi video. L\xE0m m\u1EDBi trang \u0111\u1EC3 thay \u0111\u1ED5i n\xE0y \u0111\u1EC3 c\xF3 hi\u1EC7u l\u1EF1c.",
                "settings.statistics": "S\u1ED1 li\u1EC7u th\u1ED1ng k\xEA",
                "settings.stop": "D\u1EEBng",
                "settings.switch_view_mode_text": "B\u1EA1n ph\u1EA3i tham gia cu\u1ED9c h\u1ECDp \u0111\u1EC3 \xE1p d\u1EE5ng s\u1EF1 thay \u0111\u1ED5i n\xE0y",
                "settings.test_mic": "Ki\u1EC3m tra micr\xF4",
                "settings.test_speaker": "Ki\u1EC3m tra loa",
                "settings.unknown_device": "Thi\u1EBFt b\u1ECB ch\u01B0a bi\u1EBFt",
                "settings.use_hardware_acceleration": "S\u1EED d\u1EE5ng t\u0103ng t\u1ED1c ph\u1EA7n c\u1EE9ng cho:",
                "settings.vb_init_10s_tip2": "Virtual Background is taking longer than expected to load.",
                "settings.vb_init_fail2": "Kh\xF4ng th\u1EC3 t\u1EA3i n\u1EC1n \u1EA3o.",
                "settings.video_tab_text": "Video",
                speaker_view: "Ch\u1EBF \u0111\u1ED9 xem Ng\u01B0\u1EDDi n\xF3i",
                toolbar_join_audio: "K\u1EBFt n\u1ED1i \xE2m thanh",
                toolbar_leave: "R\u1EDDi kh\u1ECFi",
                toolbar_mute: "T\u1EAFt ti\u1EBFng",
                toolbar_muteall: "T\u1EAFt ti\u1EBFng t\u1EA5t c\u1EA3",
                toolbar_record: "Ghi l\u1EA1i",
                toolbar_unmute: "B\u1EADt ti\u1EBFng",
                wait_room_tip1: "{{displayName}} \u0111\xE3 v\xE0o Ph\xF2ng ch\u1EDD cho cu\u1ED9c h\u1ECDp n\xE0y",
                wait_room_tip2: "{{count}} m\u1ECDi ng\u01B0\u1EDDi \u0111\xE3 v\xE0o Ph\xF2ng ch\u1EDD cho cu\u1ED9c h\u1ECDp n\xE0y",
                "wc.ast_admin_name": "Tr\u1EE3 l\xFD cu\u1ED9c h\u1ECDp",
                "wc.rmc_admin_name": "Qu\u1EA3n tr\u1ECB vi\xEAn \u0111i\u1EC1u khi\u1EC3n cu\u1ED9c h\u1ECDp",
                "wc.rmc_admin_tooltip": "Ng\u01B0\u1EDDi d\xF9ng n\xE0y c\xF3 quy\u1EC1n ki\u1EC3m so\xE1t c\u1EE7a ng\u01B0\u1EDDi ch\u1EE7 tr\xEC v\xE0 kh\xF4ng c\xF3 quy\u1EC1n truy c\u1EADp v\xE0o b\u1EA5t k\u1EF3 n\u1ED9i dung ph\u01B0\u01A1ng ti\u1EC7n n\xE0o (\xE2m thanh, video, tr\xF2 chuy\u1EC7n v\xE0 pha\u0309n \u01B0\u0301ng).",
                wc_3rd_cc_copied_api_token: "M\xE3 th\xF4ng b\xE1o API \u0111\u01B0\u1EE3c sao ch\xE9p v\xE0o clipboard",
                wc_3rd_cc_copy_api_token: "Sao ch\xe9p m\xe3 th\xf4ng b\xe1o API",
                wc_3rd_cc_service: "S\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 ph\u1EE5 \u0111\u1EC1 r\u1EDDi c\u1EE7a b\xEAn th\u1EE9 3",
                wc_3rd_cc_url_help_tips2: "Sao ch\xE9p m\xE3 th\xF4ng b\xE1o n\xE0y v\xE0 d\xE1n v\xE0o c\xF4ng c\u1EE5 Ph\u1EE5 \u0111\u1EC1 r\u1EDDi c\u1EE7a b\xEAn th\u1EE9 ba",
                wc_admit: "Th\u1EEBa nh\u1EADn",
                wc_allow_to_talk: "Cho ph\xe9p n\xf3i",
                wc_audio: "\xc2m thanh",
                "wc_audio.muted_notification1": "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 t\u1EAFt ti\u1EBFng b\u1EA1n",
                "wc_audio.muted_notification2": "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 t\u1EAFt ti\u1EBFng m\u1ECDi ng\u01B0\u1EDDi",
                "wc_audio.unmute_by_host_content_1": "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC mu\u1ED1n b\u1EA1n n\xF3i",
                "wc_audio.unmute_by_host_content_2": "N\u1EBFu b\u1EA1n ch\u1ECDn b\u1EADt ti\u1EBFng, nh\u1EEFng ng\u01B0\u1EDDi kh\xE1c trong h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn s\u1EBD c\xF3 th\u1EC3 nghe th\u1EA5y b\u1EA1n. N\u1EBFu ng\u01B0\u1EDDi ch\u1EE7 tr\xEC ho\u1EB7c nh\u1EEFng ng\u01B0\u1EDDi tham gia ch\xEDnh quy\u1EBFt \u0111\u1ECBnh ghi l\u1EA1i, ph\xE1t tr\u1EF1c ti\u1EBFp ho\u1EB7c l\u01B0u tr\u1EEF h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn sau khi b\u1EA1n b\u1EADt ti\u1EBFng, s\u1EBD bao g\u1ED3m c\u1EA3 gi\u1ECDng n\xF3i c\u1EE7a b\u1EA1n.",
                wc_audio_cannot_unmute: "B\u1EA1n kh\xF4ng th\u1EC3 b\u1EADt ti\u1EBFng v\xEC ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 t\u1EAFt ti\u1EBFng b\u1EA1n.",
                wc_audio_connecting_thumbnail: "\u0110ang k\u1EBFt n\u1ED1i \xE2m thanh",
                wc_broadcasting: "Ph\xE1t thanh truy\u1EC1n h\xECnh",
                wc_btn_endconf_meeting_all: "K\u1EBFt th\xFAc cu\u1ED9c h\u1ECDp cho t\u1EA5t c\u1EA3",
                wc_camera_prevent: "Tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n \u0111ang ch\u1EB7n truy c\u1EADp v\xE0o camera c\u1EE7a b\u1EA1n. H\xE3y b\u1EADt r\u1ED3i kh\u1EDFi \u0111\u1ED9ng l\u1EA1i video c\u1EE7a b\u1EA1n",
                "wc_cc.placeholder": "Nh\u1EADp v\xE0o \u0111\xE2y, \u1EA5n Enter \u0111\u1EC3 ph\xE1t",
                wc_cc_assign_participant_to_type: "Ch\u1EC9 \u0111\u1ECBnh ng\u01B0\u1EDDi tham gia nh\u1EADp",
                wc_cc_assign_to: "Ch\u1EC9 \u0111\u1ECBnh nh\u1EADp Ph\u1EE5 \u0111\u1EC1 r\u1EDDi",
                wc_cc_assign_to_type: "Ch\u1EC9 \u0111\u1ECBnh ai \u0111\xF3 nh\u1EADp",
                wc_cc_broadcasting_tip: "Ph\u1EE5 \u0111\u1EC1 r\u1EDDi \u0111ang \u0111\u01B0\u1EE3c ph\xE1t cho t\u1EA5t c\u1EA3 m\u1ECDi ng\u01B0\u1EDDi tham gia.",
                wc_cc_host_assigned: "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 ch\u1EC9 \u0111\u1ECBnh b\u1EA1n nh\u1EADp Ph\u1EE5 \u0111\u1EC1 r\u1EDDi",
                wc_cc_type_myself: "T\xF4i s\u1EBD g\xF5",
                wc_cc_withdraw: "R\xFAt l\u1EA1i quy\u1EC1n ph\u1EE5 \u0111\u1EC1 r\u1EDDi",
                "wc_chat.attendee_chat_with": "Ng\u01B0\u1EDDi tham gia c\xF3 th\u1EC3 tr\xF2 chuy\u1EC7n v\u1EDBi:",
                "wc_chat.chat": "Tr\xF2 chuy\u1EC7n",
                "wc_chat.direct_message": "(Tin nh\u1EAFn tr\u1EF1c ti\u1EBFp)",
                "wc_chat.disable_chat": "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 t\u1EAFt t\xEDnh n\u0103ng tr\xF2 chuy\u1EC7n c\u1EE7a ng\u01B0\u1EDDi d\u1EF1 th\xEDnh.",
                "wc_chat.disabled": "Kh\xF4ng m\u1ED9t ai",
                "wc_chat.everyone": "Mo\u0323i ng\u01B0\u01A1\u0300i",
                "wc_chat.everyone_public": "m\u1ECDi ng\u01B0\u1EDDi \u0111\u1EC1u c\xF4ng khai",
                "wc_chat.everyone_public_private": "M\u1ECDi ng\u01B0\u1EDDi \u0111\u1EC1u c\xF4ng khai v\xE0 k\xEDn \u0111\xE1o",
                "wc_chat.host_only": "Ch\u1EC9 ng\u01B0\u1EDDi ch\u1EE7 tr\xEC",
                "wc_chat.host_panelists": "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC v\xE0 Ng\u01B0\u1EDDi tham gia ch\xEDnh",
                "wc_chat.me": "T\xf4i",
                "wc_chat.panelist_chat_with": "Ng\u01B0\u1EDDi tham gia ch\xEDnh c\xF3 th\u1EC3 tr\xF2 chuy\u1EC7n v\u1EDBi:",
                "wc_chat.type_msg": "Nh\u1EADp tin nh\u1EAFn \u1EDF \u0111\xE2y...",
                wc_closed_caption_btn: "Ph\u1EE5 \u0111\u1EC1 r\u1EDDi",
                wc_co_host: "(\u0110\u1ED3ng ch\u1EE7 tr\xEC)",
                wc_continue: "Ti\u1EBFp t\u1EE5c",
                wc_copied: "\u0110\xE3 sao ch\xE9p",
                wc_copied_to_clipboard: "Li\xEAn k\u1EBFt m\u1EDDi \u0111\xE3 \u0111\u01B0\u1EE3c sao ch\xE9p v\xE0o B\u1EA3ng ghi t\u1EA1m",
                wc_copy_link: "Sao ch\xE9p li\xEAn k\u1EBFt",
                wc_data_center2: "B\u1EA1n \u0111ang k\u1EBFt n\u1ED1i v\u1EDBi m\u1ED9t trung t\xE2m d\u1EEF li\u1EC7u t\u1EA1i ch\u1ED7.",
                wc_data_center3: "B\u1EA1n \u0111ang k\u1EBFt n\u1ED1i v\u1EDBi m\u1EA1ng Zoom to\xE0n c\u1EA7u qua m\u1ED9t trung t\xE2m d\u1EEF li\u1EC7u t\u1EA1i ch\u1ED7.",
                wc_disable_talking: "T\u1EAFt ch\u1EE9c n\u0103ng n\xF3i",
                wc_dlg_confirm: "X\xE1c nh\u1EADn",
                wc_enable: "B\u1EADt",
                wc_encryption: "M\xe3 h\xf3a",
                wc_extra_function_disable_video: "V\xF4 hi\u1EC7u h\xF3a nh\u1EADn phim",
                wc_files: "T\u1EC7p",
                wc_footer_assign_leave: "Ch\u1EC9 \u0111\u1ECBnh v\xE0 r\u1EDDi \u0111i",
                wc_footer_assign_new_host: "Ch\u1EC9 \u0111\u1ECBnh ng\u01B0\u1EDDi ch\u1EE7 tr\xEC m\u1EDBi",
                wc_guest: "Kh\xe1ch",
                wc_host_1: "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC",
                wc_in_the_meeting: "Trong cu\u1ED9c h\u1ECDp",
                wc_invite_link: "Li\xEAn k\u1EBFt m\u1EDDi",
                wc_join_media_preview_info_confirm: "\u0110\xE3 hi\u1EC3u",
                wc_join_media_preview_warning_denied_both: "B\u1EADt quy\u1EC1n truy c\u1EADp camera v\xE0 micr\xF4 trong thanh \u0111\u1ECBa ch\u1EC9 c\u1EE7a tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n.",
                wc_join_media_preview_warning_denied_camera: "B\u1EADt quy\u1EC1n truy c\u1EADp camera trong thanh \u0111\u1ECBa ch\u1EC9 c\u1EE7a tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n.",
                wc_join_media_preview_warning_denied_mic: "B\u1EADt quy\u1EC1n truy c\u1EADp micr\xF4 trong thanh \u0111\u1ECBa ch\u1EC9 c\u1EE7a tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n.",
                wc_joining: "tham gia",
                wc_joining_meeting: "\u0110ang tham gia cu\u1ED9c h\u1ECDp...",
                wc_learn_more: "T\xECm hi\u1EC3u th\xEAm",
                wc_leave_computer_audio: "R\u1EDDi kh\u1ECFi \xE2m thanh m\xE1y t\xEDnh",
                wc_leave_meeting: "R\u1EDDi kh\u1ECFi cu\u1ED9c h\u1ECDp",
                wc_leave_webinar: "R\u1EDDi kh\u1ECFi h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn",
                wc_live_transcription_btn: "B\u1EA3n ch\xE9p l\u1EA1i tr\u1EF1c ti\u1EBFp",
                wc_lock_meeting: "Kh\xF3a cu\u1ED9c h\u1ECDp",
                wc_lower_hand: "Ha\u0323 tay xu\xF4\u0301ng",
                wc_lt_disable_transcription: "T\u1EAFt t\u1EF1 \u0111\u1ED9ng ch\xE9p l\u1EA1i",
                wc_lt_enable_transcription: "B\u1EADt t\u1EF1 \u0111\u1ED9ng ch\xE9p l\u1EA1i",
                wc_lt_item_captioner: "(Ng\u01B0\u1EDDi ghi ph\u1EE5 \u0111\u1EC1)",
                wc_lt_live_transcript: "Ch\xE9p l\u1EA1i tr\u1EF1c ti\u1EBFp",
                wc_lt_menu_item1: "Hi\u1EC3n th\u1ECB Ph\u1EE5 \u0111\u1EC1",
                wc_lt_menu_item2: "Xem B\u1EA3n ch\xE9p l\u1EA1i \u0111\u1EA7y \u0111\u1EE7",
                wc_lt_menu_item3: "\u1EA8n ph\u1EE5 \u0111\u1EC1",
                wc_lt_menu_item4: "\u0110\xF3ng b\u1EA3n ch\xE9p l\u1EA1i \u0111\u1EA7y \u0111\u1EE7",
                wc_lt_request_host_ctrl: "Cho ph\xE9p ng\u01B0\u1EDDi tham gia y\xEAu c\u1EA7u Ch\xE9p l\u1EA1i tr\u1EF1c ti\u1EBFp",
                wc_lt_search_text: "T\xECm ki\u1EBFm",
                wc_make_co_host: "Ch\u1EC9 \u0111\u1ECBnh l\xE0m \u0111\u1ED3ng ch\u1EE7 tr\xEC",
                wc_make_host: "Ch\u1EC9 \u0111\u1ECBnh ng\u01B0\u1EDDi ch\u1EE7 tr\xEC",
                wc_me: "(T\xf4i)",
                wc_more: "Th\xeam",
                wc_no: "Kh\xf4ng",
                wc_none: "Kh\xf4ng c\xf3",
                wc_not_share_pronoun: "Kh\xF4ng chia s\u1EBB",
                wc_num_password: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i Password / H\u1EC7 th\u1ED1ng Ph\xF2ng",
                wc_participant_id: "ID ng\u01B0\u1EDDi tham gia",
                wc_participants: "Ng\u01B0\u1EDDi tham gia",
                wc_pc_audio: "\xc2m thanh m\xe1y t\xednh",
                wc_prevent_access_mic: "Tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n \u0111ang ch\u1EB7n truy c\u1EADp v\xE0o micr\xF4 c\u1EE7a b\u1EA1n.",
                wc_put_in_waiting: "\u0110\u01B0a v\xE0o ph\xF2ng ch\u1EDD",
                "wc_qa.allQ": "T\u1EA5t c\u1EA3 c\xE2u h\u1ECFi",
                "wc_qa.anonymous_attendee": "Ng\u01B0\u1EDDi d\u1EF1 th\xEDnh \u1EA9n danh",
                "wc_qa.answer_private_type": "C\xE2u tr\u1EA3 l\u1EDDi ri\xEAng",
                "wc_qa.answeredQ": "\u0110\xE3 tr\u1EA3 l\u1EDDi",
                "wc_qa.attendee_placeholder": "C\xE2u h\u1ECFi b\u1EA1n \u0111\u1EB7t ra cho ng\u01B0\u1EDDi ch\u1EE7 tr\xEC v\xE0 ng\u01B0\u1EDDi tham gia ch\xEDnh s\u1EBD xu\u1EA5t hi\u1EC7n t\u1EA1i \u0111\xE2y.",
                "wc_qa.button_comment": "B\xECnh lu\u1EADn",
                "wc_qa.button_display_answer": "Nh\u1EADp c\xE2u tr\u1EA3 l\u1EDDi",
                "wc_qa.button_live": "Tr\u1EA3 l\u1EDDi tr\u1EF1c ti\u1EBFp",
                "wc_qa.button_live_done": "Ho\xe0n th\xe0nh",
                "wc_qa.button_reopen": "M\u1EDF l\u1EA1i",
                "wc_qa.collapse_all_answer": "Thu g\u1ECDn t\u1EA5t c\u1EA3",
                "wc_qa.dismissedQ": "\u0110\xE3 b\u1ECF qua",
                "wc_qa.display_all_answer": "Hi\u1EC3n th\u1ECB t\u1EA5t c\u1EA3",
                "wc_qa.dissmis_tips": "B\u1ECF qua",
                "wc_qa.input_tips": "Nh\u1EADp c\xE2u h\u1ECFi c\u1EE7a b\u1EA1n v\xE0o \u0111\xE2y...",
                "wc_qa.is_anonymous": "G\u1EEDi n\u1EB7c danh",
                "wc_qa.is_privately": "G\u1EEDi ri\xEAng",
                "wc_qa.live_tips_done": "C\xE2u h\u1ECFi n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EDDi tr\u1EF1c ti\u1EBFp",
                "wc_qa.live_tips_start": "mu\u1ED1n tr\u1EA3 l\u1EDDi c\xE2u h\u1ECFi n\xE0y tr\u1EF1c ti\u1EBFp",
                "wc_qa.most_recent": "G\u1EA7n \u0111\xE2y nh\u1EA5t",
                "wc_qa.most_upvotes": "L\u01B0\u1EE3t \u1EE7ng h\u1ED9 nhi\u1EC1u nh\u1EA5t",
                "wc_qa.myQ": "C\xE2u h\u1ECFi c\u1EE7a t\xF4i",
                "wc_qa.no_answered_questions": "Kh\xF4ng c\xF3 c\xE2u h\u1ECFi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EDDi",
                "wc_qa.no_dismissed_questions": "Kh\xF4ng c\xF3 c\xE2u h\u1ECFi n\xE0o b\u1ECB b\u1ECF qua",
                "wc_qa.no_open_questions": "Kh\xF4ng c\xF3 c\xE2u h\u1ECFi m\u1EDF",
                "wc_qa.no_questions": "Kh\xF4ng c\xF3 c\xE2u h\u1ECFi",
                "wc_qa.openedQ": "M\u1EDF",
                "wc_qa.panelist_host_only_placeholder": "Ch\u1EC9 ng\u01B0\u1EDDi ch\u1EE7 tr\xEC v\xE0 ng\u01B0\u1EDDi tham gia ch\xEDnh m\u1EDBi th\u1EA5y c\xE2u h\u1ECFi",
                "wc_qa.panelist_view_all_placehoder": "M\u1ECDi ng\u01B0\u1EDDi trong h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn n\xE0y \u0111\u1EC1u c\xF3 th\u1EC3 nh\xECn th\u1EA5y c\xE2u h\u1ECFi m\u1EDF",
                "wc_qa.qa_comp_title": "H\u1ECFi \u0111\xE1p",
                "wc_qa.send": "G\u1EEDi",
                "wc_qa.setting_allow_view": "Cho ph\xE9p ng\u01B0\u1EDDi d\u1EF1 th\xEDnh xem",
                "wc_qa.setting_btn_name": "C\xE0i \u0111\u1EB7t",
                "wc_qa.setting_option_allow_anony_question": "Cho ph\xE9p c\xE2u h\u1ECFi \u1EA9n danh",
                "wc_qa.setting_option_allow_comment": "Ng\u01B0\u1EDDi d\u1EF1 th\xEDnh c\xF3 th\u1EC3 b\xECnh lu\u1EADn",
                "wc_qa.setting_option_allow_view_all": "T\u1EA5t c\u1EA3 c\xE2u h\u1ECFi",
                "wc_qa.setting_option_allow_view_answered": "Ch\u1EC9 nh\u01B0\u0303ng c\xE2u ho\u0309i \u0111a\u0303 \u0111\u01B0\u01A1\u0323c tra\u0309 l\u01A1\u0300i",
                "wc_qa.setting_option_allow_vote": "Ng\u01B0\u1EDDi d\u1EF1 th\xEDnh c\xF3 th\u1EC3 th\xEDch",
                "wc_qa.welcome_banner": "H\xE3y c\u1EE9 \u0111\u1EB7t c\xE2u h\u1ECFi cho ng\u01B0\u1EDDi ch\u1EE7 tr\xEC v\xE0 ng\u01B0\u1EDDi tham gia ch\xEDnh",
                "wc_qa.welcome_banner_title": "Ch\xE0o m\u1EEBng b\u1EA1n",
                wc_raise_hand: "Gi\u01A1 tay",
                wc_reclaim_host: "Nh\u1EADn l\u1EA1i v\u1ECB tr\xED ng\u01B0\u1EDDi ch\u1EE7 tr\xEC",
                wc_record_host_reminder_desc: "Khi ti\u1EBFp t\u1EE5c, t\u1EA5t c\u1EA3 khu\xF4n m\u1EB7t, cu\u1ED9c h\u1ED9i tho\u1EA1i v\xE0 chia s\u1EBB m\xE0n h\xECnh s\u1EBD \u0111\u01B0\u1EE3c ghi l\u1EA1i tr\xEAn \u0111\xE1m m\xE2y.",
                wc_record_reminder_desc: "Khi ti\u1EBFp t\u1EE5c tham gia cu\u1ED9c h\u1ECDp, b\u1EA1n \u0111\u1ED3ng \xFD cho ph\xE9p ghi l\u1EA1i.",
                wc_record_reminder_desc_2: "{{accountOwner}} v\xE0 ng\u01B0\u1EDDi ch\u1EE7 tr\xEC c\xF3 th\u1EC3 xem b\u1EA3n ghi tr\xEAn Zoom Cloud v\xE0 t\u1EA5t c\u1EA3 ng\u01B0\u1EDDi tham gia \u0111\u01B0\u1EE3c cho ph\xE9p \u0111\u1EC1u c\xF3 th\u1EC3 ghi v\xE0o thi\u1EBFt b\u1ECB c\u1EE5c b\u1ED9 c\u1EE7a m\xECnh. Nh\u1EEFng ng\u01B0\u1EDDi n\xE0y c\xF3 th\u1EC3 chia s\u1EBB b\u1EA3n ghi v\u1EDBi c\xE1c \u1EE9ng d\u1EE5ng v\xE0 ng\u01B0\u1EDDi kh\xE1c.",
                wc_record_reminder_title: "Cu\u1ED9c h\u1ECDp n\xE0y \u0111ang \u0111\u01B0\u1EE3c ghi l\u1EA1i",
                wc_record_reminder_webinar_title: "H\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn n\xE0y \u0111ang \u0111\u01B0\u1EE3c ghi l\u1EA1i",
                wc_record_webinar_reminder_desc: "Khi ti\u1EBFp t\u1EE5c tham gia h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn, b\u1EA1n \u0111\u1ED3ng \xFD cho ph\xE9p ghi l\u1EA1i.",
                wc_recording_pause: "T\u1EA1m d\u1EEBng Ghi",
                wc_recording_resume: "Ti\u1EBFp t\u1EE5c Ghi",
                wc_recording_stop: "D\u1EEBng ghi",
                wc_recording_title: "Ghi l\u1EA1i cu\u1ED9c h\u1ECDp n\xE0y?",
                wc_remove: "Lo\u1EA1i b\u1ECF",
                wc_select_camera: "Ch\u1ECDn camera",
                wc_select_microphone: "Ch\u1ECDn micro",
                wc_select_speaker: "Ch\u1ECDn loa",
                wc_share_muted_while_sharing_audio_tip2: "Micr\xF4 c\u1EE7a b\u1EA1n b\u1ECB v\xF4 hi\u1EC7u h\xF3a khi chia s\u1EBB \xE2m thanh m\xE1y t\xEDnh. Khi b\u1EA1n d\u1EEBng ho\u1EB7c d\u1EEBng chia s\u1EBB \xE2m thanh, micr\xF4 c\u1EE7a b\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c k\xEDch ho\u1EA1t l\u1EA1i.",
                wc_share_pronoun: "Chia s\u1EBB",
                wc_share_pronoun_menu: "Chia s\u1EBB danh x\u01B0ng c\u1EE7a t\xF4i",
                wc_share_pronoun_tip2: "B\u1EA1n c\xF3 mu\u1ED1n chia s\u1EBB danh x\u01B0ng c\u1EE7a m\xECnh trong cu\u1ED9c h\u1ECDp n\xE0y kh\xF4ng?",
                wc_sharer_controlbar_container_button3_label: "D\u1EEBng chia s\u1EBB",
                wc_sharer_controlbar_container_rec_status_tip1: "B\u1EA1n \u0111ang chia s\u1EBB m\xE0n h\xECnh",
                wc_sharer_controlbar_container_rec_status_tip2: "Chia s\u1EBB m\xE0n h\xECnh c\u1EE7a b\u1EA1n b\u1ECB t\u1EA1m d\u1EEBng",
                wc_sharer_disabled_share1_desc: "Ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 t\u1EAFt ch\u1EE9c n\u0103ng chia s\u1EBB m\xE0n h\xECnh c\u1EE7a ng\u01B0\u1EDDi d\u1EF1 th\xEDnh.",
                wc_sharer_disabled_share2_desc: "B\u1EA1n kh\xF4ng th\u1EC3 b\u1EAFt \u0111\u1EA7u chia s\u1EBB m\xE0n h\xECnh trong khi ng\u01B0\u1EDDi tham gia kh\xE1c \u0111ang chia s\u1EBB.",
                wc_sharer_entry_button_label1: "Chia s\u1EBB m\xE0n h\xECnh",
                wc_sharer_setting_menu_category1_title: "Ai c\xF3 th\u1EC3 chia s\u1EBB?",
                wc_sharer_setting_menu_category2_title: "Ai c\xF3 th\u1EC3 b\u1EAFt \u0111\u1EA7u chia s\u1EBB khi c\xF3 ng\u01B0\u1EDDi kh\xE1c \u0111ang chia s\u1EBB?",
                wc_sharer_setting_menu_category3_title: "C\xF3 bao nhi\xEAu ng\u01B0\u1EDDi tham gia c\xF3 th\u1EC3 chia s\u1EBB c\xF9ng l\xFAc?",
                wc_sharer_setting_menu_category_option1: "Ch\u1EC9 ng\u01B0\u1EDDi ch\u1EE7 tr\xEC",
                wc_sharer_setting_menu_category_option2: "T\u1EA5t c\u1EA3 ng\u01B0\u1EDDi tham gia",
                wc_sharer_setting_menu_item1: "M\u1ED9t ng\u01B0\u1EDDi tham gia c\xF3 th\u1EC3 chia s\u1EBB m\u1ED9t l\xFAc",
                wc_sharer_setting_menu_item2: "Nhi\u1EC1u ng\u01B0\u1EDDi tham gia c\xF3 th\u1EC3 chia s\u1EBB \u0111\u1ED3ng th\u1EDDi",
                wc_sharing_fit_to_window: "V\u1EEBa v\u1EDBi c\u1EEDa s\u1ED5",
                wc_sharing_original_size: "K\xEDch th\u01B0\u1EDBc g\u1ED1c",
                wc_sharing_shared_screens: "M\xE0n h\xECnh \u0111\u01B0\u1EE3c chia s\u1EBB",
                wc_sharing_view_options: "Xem t\xF9y ch\u1ECDn",
                wc_sharing_viewing: "B\u1EA1n \u0111ang xem m\xE0n h\xECnh {{displayName}}",
                wc_tel_password: "M\u1EADt m\xE3",
                wc_unmute_by_host_btn1: "V\u1EABn t\u1EAFt ti\u1EBFng",
                wc_unshare_pronoun_menu: "B\u1ECF chia s\u1EBB danh x\u01B0ng c\u1EE7a t\xF4i",
                "wc_video.allow_panelist_start_video": "Cho ph\xE9p ng\u01B0\u1EDDi tham gia ch\xEDnh b\u1EAFt \u0111\u1EA7u video",
                "wc_video.allow_participants_start_video": "Cho ph\xE9p ng\u01B0\u1EDDi tham gia b\u1EAFt \u0111\u1EA7u video",
                "wc_video.ask_start_video": "Y\xEAu c\u1EA7u b\u1EAFt \u0111\u1EA7u video",
                "wc_video.model_stop": "B\u1EA1n kh\xF4ng th\u1EC3 b\u1EAFt \u0111\u1EA7u video b\u1EDFi v\xEC ng\u01B0\u1EDDi ch\u1EE7 tr\xEC \u0111\xE3 d\u1EEBng video \u0111\xF3",
                "wc_video.start_video": "B\u1EAFt \u0111\u1EA7u video",
                "wc_video.stop_video": "D\u1EEBng video",
                "wc_video.video": "Video",
                wc_view: "Xem",
                wc_waiting_room: "Ph\xF2ng ch\u1EDD",
                "wc_webinar.change_to_attendee": "Thay \u0111\u1ED5i vai tr\xF2 th\xE0nh ng\u01B0\u1EDDi d\u1EF1 th\xEDnh",
                "wc_webinar.promote_to_panelist": "Th\u0103ng c\u1EA5p th\xE0nh ng\u01B0\u1EDDi tham gia ch\xEDnh",
                wc_webinar_attendees: "Ng\u01B0\u1EDDi d\u1EF1 th\xEDnh",
                wc_webinar_panelists: "Ng\u01B0\u1EDDi tham gia ch\xEDnh",
                wc_webinar_putonhold: "Gi\u1EEF",
                wc_withdraw_co_host: "R\xFAt l\u1EA1i quy\u1EC1n \u0111\u1ED3ng ch\u1EE7 tr\xEC",
                wc_yes: "C\xf3",
                websdk_enforce_update_content: "Phi\xEAn b\u1EA3n \u1EE9ng d\u1EE5ng c\u1EE7a b\u1EA1n c\u1EA7n l\xE0 {0} tr\u1EDF l\xEAn \u0111\u1EC3 tham gia cu\u1ED9c h\u1ECDp n\xE0y. Vui l\xF2ng c\u1EADp nh\u1EADt \u0111\u1EC3 ti\u1EBFp t\u1EE5c.",
                websdk_update_content: "Update WebSDK to the latest version to optimize meeting experience"
              }
            },
            "it-IT": {
              translation: {
                GOT_IT: "OK",
                account_owner: "titolare dell\u2019account",
                allow_to_access: "Permetti di accedere alla tua fotocamera e microfono",
                "app_signal.approved_by": "Approvato da",
                "app_signal.hosts_account": "Account dell'organizzatore",
                "app_signal.people": "persone",
                "app_signal.tip_text_2": "Visualizza le app che accedono al contenuto della riunione",
                "app_signal.unable_load2": "Impossibile caricare le app con accesso in tempo reale alle tue informazioni.",
                "archiving.chat_1": "chat (pubblica e diretta)",
                "archiving.chat_2": "chat (solo pubblica)",
                "archiving.chat_disable_content": "Impossibile archiviare i messaggi inviati nella chat per motivi di conformit\xe0.",
                "archiving.chat_disable_title": "La chat \xe8 stata disattivata",
                "archiving.content1_sdk": "Uno o pi\xF9 partecipanti a questa riunione sono soggetti all\u2019archiviazione in conformit\xE0 alla politica del loro account. Il {{content}} ricever\xE0 il contenuto di questa riunione e potr\xE0 condividerlo con altri.",
                "archiving.content2_sdk": "Restando in questa riunione, acconsenti all\u2019archiviazione di {{content}} della riunione",
                "archiving.default_title": "Questa riunione sar\xe0 archiviata",
                "archiving.fail_content_sdk": "\xc8 necessario archiviare {{features}} di questa riunione per motivi di conformit\xe0.",
                "archiving.fail_title": "Archiviazione non riuscita",
                "archiving.subjects_combo_2_sdk": "{{0}} e {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} e {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} e {{3}}",
                "archiving.tips_1_sdk": "{{subjects}} di questa riunione sar\xE0 archiviato dall\u2019organizzazione sulla base della policy dell\u2019account. Il {{receiver}} ricever\xE0 il contenuto di questa riunione e potr\xE0 condividerlo con altri.",
                "archiving.tips_2_sdk": "{{subjects}} di questa riunione saranno archiviati dall\u2019organizzazione sulla base della policy dell\u2019account Il {{receiver}} ricever\xE0 il contenuto di questa riunione e potr\xE0 condividerlo con altri.",
                "archiving.transcription": "trascrizione",
                "ast.leave_tip": "L'assistenteore ha smesso di controllare la riunione.",
                "ast.tip": "Questa riunione \xe8 controllata da un assistente",
                background: "Sfondo",
                chat_message_header: "<0> {{senderName}} </0> <1> a </1> <2> {{receiverName}} </2>",
                chat_new_message: "{{counts}} nuovo messaggio",
                chat_receiver_co_host: "(Co-organizzatore)",
                chat_receiver_host: "(Organizzatore)",
                chat_receiver_panelist: "(Esperto)",
                chat_receiver_to: "A:",
                choose_background: "Scegli sfondo",
                click_address_bar: "Fare clic sull'icona Blocco a sinistra della barra degli indirizzi. Un pop-up apparir\xe0 con un elenco di opzioni.",
                click_microphone_camera_option: "Fare clic sull'elenco a discesa a destra della fotocamera e sull'opzione del microfono.",
                "common.cancel": "Annulla",
                "common.connecting": "Collegamento",
                delete: "Elimina",
                "dialog.btn_cancel": "Annulla",
                "dialog.btn_endconf_webinar": "Termina webinar",
                "dialog.btn_leaveconf_meeting": "Lascia riunione",
                "dialog.btn_retry": "Riprova",
                "dialog.host_end_meeting": "Questa riunione \xE8 stata terminata dall\u2019organizzatore.",
                "dialog.host_end_webinar": "Questo webinar \xE8 stato terminato dall\u2019organizzatore.",
                "dialog.meeting_ended": "La riunione \xe8 stata terminata",
                "dialog.meeting_locked": "La riunione \xe8 stata bloccata.",
                "dialog.meeting_removed_by_host": "Sei stato rimosso da questa riunione dall\u2019organizzatore.",
                "dialog.newname": "Nome",
                "dialog.ok": "OK",
                "dialog.presscode": "ID Riunione",
                "dialog.rename": "Rinomina",
                "dialog.server_error": "Il server ha rilevato un errore interno e non \xe8 riuscito a elaborare la tua richiesta.",
                "dialog.webinar_ended": "Il webinar \xe8 stato terminato",
                "dialog.webinar_removed_by_host": "Sei stato rimosso da questo webinar dall\u2019organizzatore.",
                "dialog.you_are_removed": "Sei stato rimosso",
                dialog_make_cohost: "Vuoi rendere {{displayName}}co-organizzatore di questa riunione?",
                dialog_make_host: "Vuoi cambiare l'organizzatore in {{displayName}}?",
                dialog_remove_user: "Vuoi rimuovere {{displayName}}?",
                "disclaimer.LT_button_1": "Chi pu\xf2 vedere questa trascrizione?",
                "disclaimer.LT_content_1_1": "Il titolare dell\u2019account e tutti i partecipanti nella riunione possono salvare questa trascrizione e condividerla con altri.",
                "disclaimer.LT_content_2": "La trascrizione dal vivo (sottotitoli) \xe8 stata attivata",
                "disclaimer.QA_button_1": "Chi pu\xf2 vedere le tue domande?",
                "disclaimer.QA_content_1_1": "Il titolare dell\u2019account, l\u2019organizzatore e i relatori potranno vedere chi sei, le tue informazioni di contatto (se sei collegato o le hai fornite) e la tua domanda, e condividerle con altri.",
                "disclaimer.QA_content_2": "Se la tua domanda \xe8 selezionata, sar\xe0 visibile a tutti gli spettatori.",
                "disclaimer.QA_content_3_3": "Se l\u2019invio non \xE8 anonimo, il titolare dell\u2019account, l\u2019organizzatore e i relatori possono vedere chi sei, le tue informazioni di contatto (se sei collegato o le hai fornite) e la tua domanda, e condividerle con altri.",
                "disclaimer.QA_content_4": "Questa sessione di domande e risposte \xe8 pubblica, per cui chiunque pu\xf2 visualizzare le tue domande.",
                "disclaimer.QA_content_5": "Se invii le domande in modo anonimo, nessuno pu\xf2 vedere chi ha inviato le tue domande.",
                "disclaimer.chat_button_normal": "Chi pu\xf2 vedere i tuoi messaggi?",
                "disclaimer.chat_button_onArchiving": "Chi pu\xf2 vedere i tuoi messaggi? Archiviazione su",
                "disclaimer.chat_button_onRecording": "Chi pu\xf2 vedere i tuoi messaggi? Registrazione attiva",
                "disclaimer.chat_content_1": "Tutti i partecipanti nella riunione possono visualizzare, salvare e condividere i tuoi messaggi con altri.",
                "disclaimer.chat_content_2": "I messaggi diretti tra te ed altri possono solo essere salvati e distribuiti da te e da chi li riceve.",
                "disclaimer.chat_content_3": "Registrazione attiva. Il titolare dell\u2019account e i partecipanti alla riunione possono visualizzare, salvare e distribuire ad altri i tuoi messaggi.",
                "disclaimer.chat_content_4": "Registrazione attiva. Tutti i partecipanti alla riunione possono salvare e distribuire ad altri ci\xf2 che condividi qui.",
                "disclaimer.chat_content_5": "L\u2019archiviazione \xE8 attiva, pertanto il titolare dell\u2019account pu\xF2 visualizzare tutti i tuoi messaggi, inclusi i messaggi diretti, e condividerli con app e altri.",
                "disclaimer.chat_content_6": "Tutti i partecipanti nella riunione possono salvare e condividere i messaggi che invii a tutti.",
                "disclaimer.chat_content_7": "L\u2019archiviazione \xE8 attiva. Il titolare dell\u2019account pu\xF2 visualizzare tutti i tuoi messaggi, esclusi i messaggi diretti, e condividerli con altri.",
                errorcodes_be_removed: "Sei stato rimosso.",
                errorcodes_denied_email: "Email bloccata dall\u2019Amministratore.",
                errorcodes_denied_register_with_panelist: "Registrazione negata - Utilizzare l\u2019email del panelista.",
                errorcodes_disconnect: "La riunione \xe8 stata interrotta.",
                errorcodes_email_require: "Manca l\u2019email per partecipare al webinar.",
                errorcodes_fail: "Impossibile unirsi alla Riunione.",
                errorcodes_frequent_call: "Hai raggiunto il limite di API per questa chiamata.",
                errorcodes_frequent_join: "Limite imposto da Zoom. \xc8 necessario verificare Recaptcha.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Impossibile unirsi dal browser, si prega di unirsi con il client desktop Zoom o app mobile.",
                errorcodes_not_exist: "La Riunione non esiste.",
                errorcodes_not_host: "Non sei l\u2019Ospitante della Riunione.",
                errorcodes_not_init: "Riunione non inizializzata.",
                errorcodes_not_start: "La Riunione non \xe8 ancora iniziata",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "Il servizio \xe8 temporaneamente offline.",
                errorcodes_pac_api_disabled: "L\u2019account API Key \xE8 disattivato.",
                errorcodes_pac_api_wrong: "L\u2019account API Key non \xE8 valido.",
                errorcodes_pac_cant_host_other_mn: "Non si pu\xF2 controllare un\u2019altra Riunione contemporaneamente.",
                errorcodes_pac_host_not_found: "L\u2019Ospitante della Riunione non \xE8 stato trovato.",
                errorcodes_pac_invalid_signature: "La firma non \xe8 valida.",
                errorcodes_pac_mn_not_fount: "Il numero Riunione non \xe8 stato trovato.",
                errorcodes_pac_mn_wrong: "Il numero Riunione \xe8 errato.",
                errorcodes_pac_no_permission: "Nessun permesso.",
                errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
                errorcodes_pac_role_error: "Ruolo non corretto.",
                errorcodes_pac_signature_expired: "La firma \xe8 scaduta.",
                errorcodes_re_connect: "Riunione in riconnessione.",
                errorcodes_register: "Questa Riunione richiede la registrazione.",
                errorcodes_rwc_empty: "Impossibile ottenere una risposta dal server web.",
                errorcodes_rwc_error: "Impossibile connettersi al server Web - errore.",
                errorcodes_sign_webinar: "Dont' support sign in webinar",
                errorcodes_success: "Unito con successo alla Riunione.",
                errorcodes_tk_expired: "Token scaduto.",
                errorcodes_wasm_fail: "Scarica file errore wasm, si prega di controllare rete e firewall.",
                errorcodes_web_has_in_progress: "Sta partecipando a un\u2019altra riunione in corso.",
                errorcodes_web_host_not_exit: "L\u2019ospite della riunione non esiste.",
                errorcodes_web_invalid_id: "ID riunione non valido.",
                errorcodes_web_not_allow_start_webinar_from_web: "Non \xe8 consentito avviare il webinar dal Web.",
                errorcodes_web_not_support_registration_webinar: "Non supporta webinar con iscrizione",
                errorcodes_web_not_support_tsp: "In caso che hai selezionato il fornitore di servizio telefonico come l\u2019audio in riunione, non supporta l\u2019avvio o la partecipazione alla riunione dal Web.",
                errorcodes_web_not_support_webclient: "Non supporta l\u2019avvio o la partecipazione alla riunione dal Web.",
                errorcodes_web_not_support_webinar_pac: "Non supporta webinar e conferenza audio personale",
                errorcodes_web_require_email: "\xC8 richiesta l\u2019email dell\u2019utente.",
                errorcodes_web_should_support_webinar_with_latest_version: "La versione sdk corrente non supporta i webinar. Effettua l\u2019aggiornamento alla versione pi\xF9 recente.",
                errorcodes_wrong_pass: "Incontro password sbagliata.",
                gallary_view: "Vista galleria",
                invalid_parameter: "Parametro non valido",
                "invite.loading": "Caricamento in corso...",
                meeting_disconnected: "Riunione interrotta",
                meeting_info: "Informazioni sulla riunione",
                meeting_info_network: "Sei connesso a {{Network}} tramite i data center in {{dc}}",
                meeting_not_start: "La riunione non \xe8 stata avviata",
                meeting_taking: "parlando:",
                meeting_waiting_for_start: "Aspettando la riunione per iniziare",
                meeting_waiting_room: "L'host ti lascer\xe0 presto",
                minimized_view: "Vista minimizzata",
                mirror_my_video: "Abilita l'effetto specchio",
                "polling.Back": "Indietro",
                "promote.cancel": "Resta come spettatore",
                "promote.content_1": "Come relatore, puoi attivare l\u2019audio e avviare il video, diventando cos\xEC visibile ad altri nel webinar.",
                "promote.content_2": "Se l\u2019organizzatore o altri relatori decidono di registrare, trasmettere in diretta streaming o archiviare il webinar dopo che hai attivato l\u2019audio, la tua voce sar\xE0 inclusa.",
                "promote.ok": "Entra come relatore",
                "promote.title": "L\u2019organizzatore desidera promuoverti a relatore",
                ribbon_view: "Vista del nastro",
                "rmc.assistant_exist_warning": "Non puoi controllare questa riunione perch\xe9 \xe8 controllata da un altro Assistente.",
                "rmc.exist_notification_for_client_host": "Questa riunione \xe8 controllata da un amministratore.",
                "rmc.not_exist_notification_for_client_host": "L\u2019amministratore ha smesso di controllare la riunione.",
                same_as_system: "Come il sistema",
                "security.allow_participants_to": "Consenti ai partecipanti di:",
                "security.button": "Sicurezza",
                "security.waiting_room": "Abilita sala d\u2019attesa",
                select_allow: "Seleziona l'opzione Consenti.",
                "settings.audio_tab_text": "Audio",
                "settings.enable_hd": "Abilita video HD",
                "settings.enable_hd_tip": "Abilita tutti i partecipanti di visualizzare il tuo video in alta risoluzione (720P). Si noti che il risultato effettivo dipende dalle prestazioni della macchina e dalla larghezza di banda.",
                "settings.frame_per_second": "Fotogrammi al secondo",
                "settings.frequency": "Frequenza",
                "settings.input_level": "Livello in ingresso:",
                "settings.item_name": "Nome elemento",
                "settings.jitter": "Instabilit\xe0",
                "settings.latency": "Latenza",
                "settings.maximum_view": "Numero massimo di partecipanti visualizzati per schermo nella Vista galleria:",
                "settings.output_level": "Livello in uscita:",
                "settings.packet_loss": "Perdita di pacchetti \u2013 Med. (Max)",
                "settings.participants25": "25 partecipanti",
                "settings.participants9": "9 partecipanti",
                "settings.playing": "Riproduzione in corso",
                "settings.receive": "Ricevi",
                "settings.receiving_video": "Ricevere video.",
                "settings.receiving_video_tips": "Utilizzare il decodificatore video hardware della scheda grafica per salvare l'utilizzo della CPU per ricevere video. Aggiorna la pagina per questo cambiamento per avere effetto.",
                "settings.recording": "Registrazione",
                "settings.rejoin": "Ricongiungere",
                "settings.resolution": "Risoluzione",
                "settings.send": "Invia",
                "settings.sending_video": "Invio di video",
                "settings.sending_video_tips": "Utilizzare il decodificatore video hardware della scheda grafica per salvare l'utilizzo della CPU per l'invio di video. Aggiorna la pagina per questo cambiamento per avere effetto.",
                "settings.statistics": "Statistiche",
                "settings.stop": "Interrompi",
                "settings.switch_view_mode_text": "Devi ricongiungersi alla riunione per applicare questo cambiamento",
                "settings.test_mic": "Verifica microfono",
                "settings.test_speaker": "Verifica altoparlante",
                "settings.unknown_device": "Dispositivo sconosciuto",
                "settings.use_hardware_acceleration": "Utilizzare l'accelerazione hardware per:",
                "settings.vb_init_10s_tip2": "Virtual Background is taking longer than expected to load.",
                "settings.vb_init_fail2": "Impossibile caricare lo sfondo virtuale.",
                "settings.video_tab_text": "Video",
                speaker_view: "Vista oratore",
                toolbar_join_audio: "Accedi all\u2019audio",
                toolbar_leave: "Lascia",
                toolbar_mute: "Disattiva audio",
                toolbar_muteall: "Disattiva audio per tutti",
                toolbar_record: "Registra",
                toolbar_unmute: "Attiva audio",
                wait_room_tip1: "{{displayName}} persona \xE8 entrata nella Sala d\u2019attesa per questa Riunione",
                wait_room_tip2: "{{count}} persone sono entrate nella Sala d\u2019attesa per questa Riunione",
                "wc.ast_admin_name": "Assistente riunione",
                "wc.rmc_admin_name": "Amministratore controlli riunione",
                "wc.rmc_admin_tooltip": "Questo utente dispone dei controlli di organizzatore e non ha accesso ai contenuti multimediali (audio, video, chat e reazioni).",
                wc_3rd_cc_copied_api_token: "Token API copiato negli appunti",
                wc_3rd_cc_copy_api_token: "Copia token API",
                wc_3rd_cc_service: "Usa un servizio sottotitoli di terzi",
                wc_3rd_cc_url_help_tips2: "Copia questo token e incollalo a uno strumento per sottotitoli di terze parti",
                wc_admit: "Ammetti",
                wc_allow_to_talk: "Consenti di parlare",
                wc_audio: "Audio",
                "wc_audio.muted_notification1": "L\u2019organizzatore ha disattivato il tuo audio",
                "wc_audio.muted_notification2": "L\u2019organizzatore ha disattivato l\u2019audio di tutti",
                "wc_audio.unmute_by_host_content_1": "L\u2019organizzatore desidera farti parlare",
                "wc_audio.unmute_by_host_content_2": "Se scegli di attivare l\u2019audio, altri nel webinar potranno ascoltarti. Se l\u2019organizzatore o i relatori decidono di registrare, trasmettere in diretta streaming o archiviare il webinar dopo che hai attivato l\u2019audio, la tua voce sar\xE0 inclusa.",
                wc_audio_cannot_unmute: "Non puoi attivare il tuo audio poich\xE9 l\u2019ospite ti ha disattivato.",
                wc_audio_connecting_thumbnail: "Connessione all'audio in corso",
                wc_broadcasting: "emittente",
                wc_btn_endconf_meeting_all: "Termina riunione per tutti",
                wc_camera_prevent: "Il tuo browser impedisce l\u2019accesso alla tua videocamera. Abilitalo e riavvia il tuo video",
                "wc_cc.placeholder": "Digita qui e premi Invio per trasmettere",
                wc_cc_assign_participant_to_type: "Assegna un partecipante alla scrittura",
                wc_cc_assign_to: "Assegna alla scrittura di sottotitoli",
                wc_cc_assign_to_type: "Assegna qualcuno alla scrittura",
                wc_cc_broadcasting_tip: "Sottotitoli sono in trasmissione a tutti i partecipanti",
                wc_cc_host_assigned: "L\u2019organizzatore ti ha assegnato alla scrittura di sottotitoli",
                wc_cc_type_myself: "Scriver\xf2",
                wc_cc_withdraw: "Ritira permesso sottotitoli",
                "wc_chat.attendee_chat_with": "Lo spettatore pu\xf2 chattare con:",
                "wc_chat.chat": "Chat",
                "wc_chat.direct_message": "(Messaggio diretto)",
                "wc_chat.disable_chat": "L\u2019organizzatore ha disabilitato la chat degli spettatori",
                "wc_chat.disabled": "Nessuno",
                "wc_chat.everyone": "Tutti",
                "wc_chat.everyone_public": "Everyone publicly",
                "wc_chat.everyone_public_private": "Ognuno pubblicamente e privatamente",
                "wc_chat.host_only": "Solo organizzatore",
                "wc_chat.host_panelists": "Organizzatori e relatori",
                "wc_chat.me": "Io",
                "wc_chat.panelist_chat_with": "I relatori possono chattare con:",
                "wc_chat.type_msg": "Digita il messaggio qui...",
                wc_closed_caption_btn: "Sottotitoli",
                wc_co_host: "(Co-organizzatore)",
                wc_continue: "Continua",
                wc_copied: "Copiato",
                wc_copied_to_clipboard: "Il link di invito \xe8 stato copiato negli Appunti",
                wc_copy_link: "Copia link",
                wc_data_center2: "Sei connesso a un data center locale.",
                wc_data_center3: "Sei connesso alla rete globale di Zoom tramite un data center locale.",
                wc_disable_talking: "Disabilita parlato",
                wc_dlg_confirm: "Conferma",
                wc_enable: "Abilitato",
                wc_encryption: "Crittografia",
                wc_extra_function_disable_video: "Disabilitare il video di ricezione",
                wc_files: "File",
                wc_footer_assign_leave: "Assegna ed esci",
                wc_footer_assign_new_host: "Assegna un nuovo organizzatore",
                wc_guest: "Guest",
                wc_host_1: "Organizzatore",
                wc_in_the_meeting: "Nella riunione",
                wc_invite_link: "Link di invito",
                wc_join_media_preview_info_confirm: "OK",
                wc_join_media_preview_warning_denied_both: "Abilita l\u2019accesso alla fotocamera e al microfono nella barra degli indirizzi del browser.",
                wc_join_media_preview_warning_denied_camera: "Abilita l\u2019accesso alla fotocamera nella barra degli indirizzi del browser.",
                wc_join_media_preview_warning_denied_mic: "Abilita l\u2019accesso al microfono nella barra degli indirizzi del browser.",
                wc_joining: "unione",
                wc_joining_meeting: "Ingresso in corso nella riunione...",
                wc_learn_more: "Ulteriori informazioni",
                wc_leave_computer_audio: "Lascia audio computer",
                wc_leave_meeting: "Lascia riunione",
                wc_leave_webinar: "Lascia webinar",
                wc_live_transcription_btn: "Trascrizione dal vivo",
                wc_lock_meeting: "Blocca riunione",
                wc_lower_hand: "Abbassa la mano",
                wc_lt_disable_transcription: "Disabilita trascrizione automatica",
                wc_lt_enable_transcription: "Abilita trascrizione automatica",
                wc_lt_item_captioner: "(Sottotitolista)",
                wc_lt_live_transcript: "Trascrizione dal vivo",
                wc_lt_menu_item1: "Mostra sottotitolo",
                wc_lt_menu_item2: "Visualizza trascrizione completa",
                wc_lt_menu_item3: "Nascondi sottotitolo",
                wc_lt_menu_item4: "Chiudi trascrizione completa",
                wc_lt_request_host_ctrl: "Consenti ai partecipanti di chiedere la trascrizione simultanea",
                wc_lt_search_text: "Cerca",
                wc_make_co_host: "Assegna co-organizzatore",
                wc_make_host: "Rendi organizzatore",
                wc_me: "(Io)",
                wc_more: "Altro",
                wc_no: "No",
                wc_none: "Nessuno",
                wc_not_share_pronoun: "Non condividere",
                wc_num_password: "Password numerica Telefonica/Zoom",
                wc_participant_id: "ID partecipante",
                wc_participants: "Partecipanti",
                wc_pc_audio: "Audio computer",
                wc_prevent_access_mic: "Il tuo browser impedisce l\u2019accesso al tuo microfono.",
                wc_put_in_waiting: "Metti in sala d\u2019attesa",
                "wc_qa.allQ": "Tutte le domande",
                "wc_qa.anonymous_attendee": "Spettatore anonimo",
                "wc_qa.answer_private_type": "Risposta privata",
                "wc_qa.answeredQ": "Risposta fornita",
                "wc_qa.attendee_placeholder": "Le domande che poni all\u2019organizzatore e ai relatori verranno visualizzate qui.",
                "wc_qa.button_comment": "Commento",
                "wc_qa.button_display_answer": "Digita la risposta",
                "wc_qa.button_live": "Risposta dal vivo",
                "wc_qa.button_live_done": "Fatto",
                "wc_qa.button_reopen": "Riapri",
                "wc_qa.collapse_all_answer": "Comprimi tutto",
                "wc_qa.dismissedQ": "Ignorato",
                "wc_qa.display_all_answer": "Mostra tutto",
                "wc_qa.dissmis_tips": "Ignora",
                "wc_qa.input_tips": "Digita la tua domanda qui...",
                "wc_qa.is_anonymous": "Invio anonimo",
                "wc_qa.is_privately": "Invio in privato",
                "wc_qa.live_tips_done": "Questa domanda ha ricevuto una risposta dal vivo",
                "wc_qa.live_tips_start": "desidera rispondere a questa domanda dal vivo",
                "wc_qa.most_recent": "Pi\xf9 recenti",
                "wc_qa.most_upvotes": "Pi\xf9 voti a favore",
                "wc_qa.myQ": "Le mie domande",
                "wc_qa.no_answered_questions": "Nessuna domanda con risposta",
                "wc_qa.no_dismissed_questions": "Nessuna domanda respinta",
                "wc_qa.no_open_questions": "Nessuna domanda aperta",
                "wc_qa.no_questions": "Nessuna domanda",
                "wc_qa.openedQ": "Apri",
                "wc_qa.panelist_host_only_placeholder": "Solo gli organizzatori e i relatori possono visualizzare le domande",
                "wc_qa.panelist_view_all_placehoder": "Tutti in questo webinar possono visualizzare le domande aperte",
                "wc_qa.qa_comp_title": "Domande e risposte",
                "wc_qa.send": "Invia",
                "wc_qa.setting_allow_view": "Consenti agli spettatori di visualizzare",
                "wc_qa.setting_btn_name": "Impostazioni",
                "wc_qa.setting_option_allow_anony_question": "Consenti domande anonime",
                "wc_qa.setting_option_allow_comment": "Gli spettatori possono commentare",
                "wc_qa.setting_option_allow_view_all": "Tutte le domande",
                "wc_qa.setting_option_allow_view_answered": "Solo le domande con risposte",
                "wc_qa.setting_option_allow_vote": "Gli spettatori possono votare a favore",
                "wc_qa.welcome_banner": "Puoi liberamente porre domande all\u2019organizzatore e ai panelisti",
                "wc_qa.welcome_banner_title": "Benvenuto",
                wc_raise_hand: "Alza la mano",
                wc_reclaim_host: "Reclama organizzatore",
                wc_record_host_reminder_desc: "Continuando, tutti i volti, le conversazioni e la condivisione dello schermo verranno registrati sul cloud.",
                wc_record_reminder_desc: "Restando nella riunione, acconsenti ad essere registrato.",
                wc_record_reminder_desc_2: "Il {{accountOwner}} e l\u2019organizzatore possono guardare le registrazioni sul cloud Zoom e tutti i partecipanti autorizzati possono registrare sul proprio dispositivo locale. Questi utenti possono condividere le registrazioni con altri.",
                wc_record_reminder_title: "Questa riunione \xe8 gi\xe0 registrata",
                wc_record_reminder_webinar_title: "Questo webinar viene registrato",
                wc_record_webinar_reminder_desc: "Restando nel webinar, acconsenti ad essere registrato.",
                wc_recording_pause: "Metti in pausa la registrazione",
                wc_recording_resume: "Riprendi la registrazione",
                wc_recording_stop: "Interrompi registrazione",
                wc_recording_title: "Registra questo incontro?",
                wc_remove: "Rimuovi",
                wc_select_camera: "Seleziona una videocamera",
                wc_select_microphone: "Seleziona un microfono",
                wc_select_speaker: "Seleziona un oratore",
                wc_share_muted_while_sharing_audio_tip2: "Il microfono \xe8 disabilitato durante la condivisione dell'audio del computer. Quando si ferma o si interrompe la condivisione dell'audio, il microfono verr\xe0 riattivato.",
                wc_share_pronoun: "Condividi",
                wc_share_pronoun_menu: "Condividi i miei pronomi",
                wc_share_pronoun_tip2: "Condividere i tuoi pronomi in questa riunione?",
                wc_sharer_controlbar_container_button3_label: "Interrompi condivisione",
                wc_sharer_controlbar_container_rec_status_tip1: "Stai condividendo lo schermo",
                wc_sharer_controlbar_container_rec_status_tip2: "La condivisione dello schermo \xe8 sospesa",
                wc_sharer_disabled_share1_desc: "L\u2019organizzatore ha disabilitato la condivisione dello schermo dello spettatore.",
                wc_sharer_disabled_share2_desc: "Impossibile avviare la condivisione schermo mentre l\u2019altro partecipante sta condividendo.",
                wc_sharer_entry_button_label1: "Condividi schermo",
                wc_sharer_setting_menu_category1_title: "Chi pu\xf2 condividere?",
                wc_sharer_setting_menu_category2_title: "Chi pu\xf2 avviare la condivisione quando qualcun altro condivide?",
                wc_sharer_setting_menu_category3_title: "Quanti partecipanti possono condividere contemporaneamente?",
                wc_sharer_setting_menu_category_option1: "Solo l\u2019organizzatore",
                wc_sharer_setting_menu_category_option2: "Tutti i partecipanti",
                wc_sharer_setting_menu_item1: "Un solo partecipante alla volta pu\xf2 condividere",
                wc_sharer_setting_menu_item2: "Pi\xf9 partecipanti possono condividere in contemporanea",
                wc_sharing_fit_to_window: "Adatta alla finestra",
                wc_sharing_original_size: "Dimensione originale",
                wc_sharing_shared_screens: "Schermi condivisi",
                wc_sharing_view_options: "Visualizza opzioni",
                wc_sharing_viewing: "Stai visualizzando {{displayName}} lo schermo",
                wc_tel_password: "Passcode",
                wc_unmute_by_host_btn1: "Resta in silenzio",
                wc_unshare_pronoun_menu: "Non condividere i miei pronomi",
                "wc_video.allow_panelist_start_video": "Consenti al panelista di avviare il video",
                "wc_video.allow_participants_start_video": "Consenti ai partecipanti di avviare il video",
                "wc_video.ask_start_video": "Chiedi di avviare il video",
                "wc_video.model_stop": "Impossibile avviare il video dato che \xE8 stato interrotto dall\u2019organizzatore",
                "wc_video.start_video": "Avvia video",
                "wc_video.stop_video": "Interrompi video",
                "wc_video.video": "Video",
                wc_view: "Visualizza",
                wc_waiting_room: "Sala d\u2019attesa",
                "wc_webinar.change_to_attendee": "Modifica ruolo in spettatore",
                "wc_webinar.promote_to_panelist": "Promuovi a panelista",
                wc_webinar_attendees: "Spettatori",
                wc_webinar_panelists: "Panelisti",
                wc_webinar_putonhold: "Metti in attesa",
                wc_withdraw_co_host: "Ritira permesso co-organizzatore",
                wc_yes: "S\xec",
                websdk_enforce_update_content: "Per partecipare a questa riunione, \xe8 necessario aggiornare l'applicazione alla versione {0} o successiva. Aggiorna per continuare.",
                websdk_update_content: "Aggiornamento WebSDK alla versione pi\xf9 recente per ottimizzare l'esperienza di incontro"
              }
            },
            "pl-PL": {
              translation: {
                GOT_IT: "Rozumiem",
                account_owner: "w\u0142a\u015Bciciel konta",
                allow_to_access: "Allow Zoom to access your camera and microphone",
                "app_signal.approved_by": "Zatwierdzone przez",
                "app_signal.people": "osoby",
                "app_signal.tip_text_2": "Zobacz aplikacje, kt\xF3re uzyskuj\u0105 dost\u0119p do tre\u015Bci Twojego spotkania",
                "app_signal.unable_load2": "Nie mo\u017Cna za\u0142adowa\u0107 aplikacji z dost\u0119pem do Twoich informacji w czasie rzeczywistym.",
                "archiving.chat_1": "czat (publiczny i bezpo\u015Bredni)",
                "archiving.chat_2": "czat (tylko publiczny)",
                "archiving.chat_disable_content": "Wiadomo\u015Bci wys\u0142ane na czacie nie mog\u0142y zosta\u0107 zarchiwizowane ze wzgl\u0119du na zgodno\u015B\u0107 z przepisami.",
                "archiving.chat_disable_title": "Czat zosta\u0142 wy\u0142\u0105czony",
                "archiving.content1_sdk": "Co najmniej jeden uczestnik tego spotkania podlega archiwizacji zgodnie z zasadami swojego konta. {{content}} tych os\xF3b otrzyma tre\u015Bci z tego spotkania i b\u0119dzie w stanie udost\u0119pnia\u0107 je aplikacjom i innym osobom.",
                "archiving.content2_sdk": "Pozostaj\u0105c na spotkaniu, wyra\u017Casz zgod\u0119 na archiwizacj\u0119 {{content}} tego spotkania.",
                "archiving.default_title": "To spotkanie jest archiwizowane",
                "archiving.fail_content_sdk": "{{features}} z tego spotkania wymaga zarchiwizowania ze wzgl\u0119du na zgodno\u015B\u0107 z przepisami.",
                "archiving.fail_title": "Niepowodzenie archiwizacji",
                "archiving.subjects_combo_2_sdk": "{{0}} i {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}} i {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}} i {{3}}",
                "archiving.tips_1_sdk": "{{subjects}} tego spotkania archiwizuje organizacja prowadz\u0105cego zgodnie z zasadami jej konta. {{receiver}} tych os\xF3b otrzyma tre\u015Bci z tego spotkania i b\u0119dzie w stanie udost\u0119pnia\u0107 je aplikacjom i innym osobom.",
                "archiving.tips_2_sdk": "{{subjects}} z tego spotkania s\u0105 archiwizowane przez organizacj\u0119 prowadz\u0105cego zgodnie z zasadami jej konta. {{receiver}} tych os\xF3b otrzyma tre\u015Bci z tego spotkania i b\u0119dzie w stanie udost\u0119pnia\u0107 je aplikacjom i innym osobom.",
                "archiving.transcription": "transkrypcja",
                "ast.leave_tip": "Asystent przesta\u0142 sterowa\u0107 spotkaniem",
                "ast.tip": "Tym spotkaniem steruje asystent",
                background: "T\u0142o",
                chat_message_header: "<0>{{senderName}}</0> <1>to</1> <2>{{receiverName}}</2>",
                chat_new_message: "{{counts}} New Message",
                chat_receiver_co_host: "( Co-host )",
                chat_receiver_host: "( Host )",
                chat_receiver_panelist: "( Panelist )",
                chat_receiver_to: "To:",
                choose_background: "Wybierz t\u0142o",
                click_address_bar: "Click the lock icon to the left of your address bar. A pop-up will appear with a list of options.",
                click_microphone_camera_option: "Click the drop-down list to the right of the Camera and Microphone option.",
                "common.cancel": "Anuluj",
                "common.connecting": "\u0141\u0105czenie",
                delete: "Usu\u0144",
                "dialog.btn_cancel": "Anuluj",
                "dialog.btn_endconf_webinar": "Zako\u0144cz webinar",
                "dialog.btn_leaveconf_meeting": "Opu\u015B\u0107 spotkanie",
                "dialog.btn_retry": "Spr\xf3buj ponownie",
                "dialog.host_end_meeting": "To spotkanie zako\u0144czy\u0142 prowadz\u0105cy.",
                "dialog.host_end_webinar": "Ten webinar zosta\u0142 zako\u0144czony przez prowadz\u0105cego.",
                "dialog.meeting_ended": "Spotkanie zosta\u0142o zako\u0144czone",
                "dialog.meeting_locked": "Spotkanie zosta\u0142o zablokowane",
                "dialog.meeting_removed_by_host": "Prowadz\u0105cy usun\u0105\u0142 Ci\u0119 z tego spotkania.",
                "dialog.newname": "Nazwa u\u017Cytkownika",
                "dialog.ok": "OK",
                "dialog.presscode": "Identyfikator spotkania",
                "dialog.rename": "Zmie\u0144 nazw\u0119",
                "dialog.server_error": "Serwer napotka\u0142 b\u0142\u0105d wewn\u0119trzny i nie by\u0142 w stanie przetworzy\u0107 Twojego \u017C\u0105dania.",
                "dialog.webinar_ended": "Webinar zosta\u0142 zako\u0144czony",
                "dialog.webinar_removed_by_host": "Prowadz\u0105cy usun\u0105\u0142 Ci\u0119 z tego webinaru.",
                "dialog.you_are_removed": "Usuni\u0119to Ci\u0119",
                dialog_make_cohost: "Do you want to make {{displayName}} the co-host of this meeting?",
                dialog_make_host: "Do you want to change the host to {{displayName}} ?",
                dialog_remove_user: "Do you want to remove {{displayName}}?",
                "disclaimer.LT_button_1": "Kto mo\u017Ce zobaczy\u0107 t\u0119 transkrypcj\u0119?",
                "disclaimer.LT_content_1_1": "W\u0142a\u015Bciciel konta i wszyscy uczestnicy spotkania mog\u0105 zapisa\u0107 t\u0119 transkrypcj\u0119 i udost\u0119pni\u0107 j\u0105 aplikacjom i innym osobom.",
                "disclaimer.LT_content_2": "Transkrypcja na \u017Cywo (napisy kodowane) zosta\u0142a w\u0142\u0105czona",
                "disclaimer.QA_button_1": "Kto mo\u017Ce zobaczy\u0107 Twoje pytania?",
                "disclaimer.QA_content_1_1": "W\u0142a\u015Bciciel konta, prowadz\u0105cy i paneli\u015Bci b\u0119d\u0105 w stanie zobaczy\u0107, kim jeste\u015B, sprawdzi\u0107 Twoje dane kontaktowe (w razie zalogowania si\u0119 lub podania ich) oraz Twoje pytanie \u2013 i b\u0119d\u0105 mogli je udost\u0119pni\u0107 aplikacjom i innym osobom.",
                "disclaimer.QA_content_2": "Je\u015Bli Twoje pytanie zostanie wybrane, b\u0119dzie widoczne dla wszystkich uczestnik\xF3w.",
                "disclaimer.QA_content_3_3": "Je\u015Bli nie prze\u015Blesz pytania anonimowo, w\u0142a\u015Bciciel konta i paneli\u015Bci b\u0119d\u0105 w stanie zobaczy\u0107, kim jeste\u015B, sprawdzi\u0107 Twoje dane kontaktowe (w razie zalogowania si\u0119 lub podania ich) oraz Twoje pytanie \u2013 i b\u0119d\u0105 mogli je udost\u0119pni\u0107 aplikacjom i innym osobom.",
                "disclaimer.QA_content_4": "Te pytania i odpowiedzi s\u0105 publiczne, wi\u0119c ka\u017Cdy mo\u017Ce zobaczy\u0107 Twoje pytania.",
                "disclaimer.QA_content_5": "Je\u015Bli przesy\u0142asz pytania anonimowo, nikt nie mo\u017Ce zobaczy\u0107, kto je przes\u0142a\u0142.",
                "disclaimer.chat_button_normal": "Kto mo\u017Ce zobaczy\u0107 Twoje wiadomo\u015Bci?",
                "disclaimer.chat_button_onArchiving": "Kto mo\u017Ce zobaczy\u0107 Twoje wiadomo\u015Bci? Archiwizacja w\u0142\u0105czona",
                "disclaimer.chat_button_onRecording": "Kto mo\u017Ce zobaczy\u0107 Twoje wiadomo\u015Bci? Nagrywanie w\u0142\u0105czone",
                "disclaimer.chat_content_1": "Ka\u017Cdy uczestnik spotkania mo\u017Ce zobaczy\u0107 i zapisa\u0107 Twoje wiadomo\u015Bci wys\u0142ane do wszystkich \u2013 i mo\u017Ce je udost\u0119pnia\u0107 aplikacjom i innym osobom.",
                "disclaimer.chat_content_2": "Tylko Ty i osoby, z kt\xF3rymi rozmawiasz na czacie, mo\u017Cecie zapisywa\u0107 swoje wiadomo\u015Bci bezpo\u015Brednie i udost\u0119pnia\u0107 je aplikacjom oraz innym osobom.",
                "disclaimer.chat_content_3": "Nagrywanie jest w\u0142\u0105czone, wi\u0119c w\u0142a\u015Bciciel konta i wszyscy uczestnicy spotkania mog\u0105 widzie\u0107 i zapisywa\u0107 wiadomo\u015Bci wys\u0142ane do wszystkich \u2013 a tak\u017Ce udost\u0119pnia\u0107 je aplikacjom i innym osobom.",
                "disclaimer.chat_content_4": "Nagrywanie jest w\u0142\u0105czone, wi\u0119c wszyscy uczestnicy spotkania mog\u0105 zobaczy\u0107 i zapisa\u0107 wiadomo\u015Bci wys\u0142ane do wszystkich \u2013 i mog\u0105 je udost\u0119pnia\u0107 aplikacjom i innym osobom.",
                "disclaimer.chat_content_5": "Archiwizacja jest w\u0142\u0105czona, wi\u0119c w\u0142a\u015Bciciel konta mo\u017Ce widzie\u0107 wszystkie Twoje wiadomo\u015Bci \u2013 w tym wiadomo\u015Bci bezpo\u015Brednie \u2013 i udost\u0119pnia\u0107 je aplikacjom oraz innym osobom.",
                "disclaimer.chat_content_6": "Archiwizacja jest w\u0142\u0105czona, wi\u0119c w\u0142a\u015Bciciel konta mo\u017Ce zobaczy\u0107 wszystkie Twoje wiadomo\u015Bci \u2013 nie licz\u0105c wiadomo\u015Bci bezpo\u015Brednich \u2013 i udost\u0119pnia\u0107 je aplikacjom oraz innym osobom.",
                "disclaimer.chat_content_7": "Archiwizacja jest w\u0142\u0105czona, wi\u0119c w\u0142a\u015Bciciel konta mo\u017Ce zobaczy\u0107 wszystkie Twoje wiadomo\u015Bci \u2013 bez wiadomo\u015Bci bezpo\u015Brednich \u2013 i udost\u0119pni\u0107 je aplikacjom i innym osobom.",
                errorcodes_be_removed: "Zosta\u0107 usuni\u0119tym.",
                errorcodes_denied_email: "E-mail jest zablokowany przez administratora.",
                errorcodes_denied_register_with_panelist: "Odmowa rejestracji U\u017Cyj e-maila panelistycznego.",
                errorcodes_disconnect: "Spotkanie zosta\u0142o od\u0142\u0105czone.",
                errorcodes_email_require: "Brak e-maila, aby uczestniczy\u0107 webinarium.",
                errorcodes_fail: "Nie do\u0142\u0105czy do spotkania.",
                errorcodes_frequent_call: "Osi\u0105gn\u0105\u0142e\u015B limit API do tego po\u0142\u0105czenia.",
                errorcodes_frequent_join: "Ograniczasz zoom, musisz sprawdzi\u0107 reCAPTCHA.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Nie mo\u017Cna do\u0142\u0105czy\u0107 z przegl\u0105darki, do\u0142\u0105cz do Klienta Klient Desktop lub Mobile App.",
                errorcodes_not_exist: "Spotkanie nie istnieje.",
                errorcodes_not_host: "Nie jeste\u015B gospodarzem spotkania.",
                errorcodes_not_init: "Spotkanie nie zainicjowane.",
                errorcodes_not_start: "Spotkanie nie rozpocz\u0119\u0142o si\u0119",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "Us\u0142uga jest tymczasowo offline.",
                errorcodes_pac_api_disabled: "Klucz API kont jest dezaktywowany.",
                errorcodes_pac_api_wrong: "Klucz API kont nie jest wa\u017Cny.",
                errorcodes_pac_cant_host_other_mn: "Nie mo\u017Ce odby\u0107 innego spotkania jednocze\u015Bnie.",
                errorcodes_pac_host_not_found: "Host z spotkania nie jest znaleziony.",
                errorcodes_pac_invalid_signature: "Podpis jest nieprawid\u0142owy.",
                errorcodes_pac_mn_not_fount: "Numer spotkania nie zosta\u0142 znaleziony.",
                errorcodes_pac_mn_wrong: "Numer spotkania jest b\u0142\u0119dny.",
                errorcodes_pac_no_permission: "Brak pozwolenia.",
                errorcodes_pac_not_allow_assistant: "Asystent do\u0142\u0105czenia do\u0142\u0105czenia zosta\u0142 wy\u0142\u0105czony",
                errorcodes_pac_role_error: "Nieprawid\u0142owa rola.",
                errorcodes_pac_signature_expired: "Podpis wygas\u0142.",
                errorcodes_re_connect: "Spotkanie \u0142\u0105czy si\u0119 ponownie.",
                errorcodes_register: "To spotkanie wymaga rejestracji.",
                errorcodes_rwc_empty: "Nie m\xF3g\u0142 uzyska\u0107 odpowiedzi z serwera WWW.",
                errorcodes_rwc_error: "Nie m\xF3g\u0142 po\u0142\u0105czy\u0107 si\u0119 z b\u0142\u0119dem serwera WWW.",
                errorcodes_sign_webinar: "Nie wspieraj znak w webinarium",
                errorcodes_success: "Z powodzeniem do\u0142\u0105czy\u0142 do spotkania.",
                errorcodes_tk_expired: "Token wygas\u0142.",
                errorcodes_wasm_fail: "Pobierz b\u0142\u0105d plik\xF3w Wasm, sprawd\u017A swoj\u0105 sie\u0107 i zapor\u0119.",
                errorcodes_web_has_in_progress: "Ma ju\u017C inne spotkania.",
                errorcodes_web_host_not_exit: "Gospodarz spotkania nie istnieje.",
                errorcodes_web_invalid_id: "Nieprawid\u0142owy identyfikator spotkania.",
                errorcodes_web_not_allow_start_webinar_from_web: "Nie pozw\xF3l, aby rozpocz\u0105\u0107 sie\u0107 webinarn\u0105 od sieci.",
                errorcodes_web_not_support_registration_webinar: "Nie wspieraj rejestracji webinarium internetowego",
                errorcodes_web_not_support_tsp: "Nie obs\u0142uguje uruchomienia ani do\u0142\u0105czania do spotkania z Internetu, gdy wybra\u0142e\u015B TSP jako jego audio na spotkaniu.",
                errorcodes_web_not_support_webclient: "Nie obs\u0142uguje uruchomienia ani do\u0142\u0105czania do spotkania z sieci.",
                errorcodes_web_not_support_webinar_pac: "Nie obs\u0142uguje seminarium i osobistej konferencji audio",
                errorcodes_web_require_email: "Wymagany jest e-mail u\u017Cytkownika.",
                errorcodes_web_should_support_webinar_with_latest_version: "Aktualna wersja SDK nie obs\u0142uguje webinarium, prosz\u0119 uaktualni\u0107 do najnowszej wersji.",
                errorcodes_wrong_pass: "Z\u0141O\u017BNIE SPOTKANIE PRZYCZEBNE.",
                gallary_view: "Widok galerii",
                invalid_parameter: "Niew\u0142a\u015Bciwy parametr",
                "invite.loading": "Wczytywanie...",
                meeting_disconnected: "Spotkanie od\u0142\u0105czone",
                meeting_info: "Informacje o spotkaniu",
                meeting_info_network: "You are connected to {{network}} via data centers in {{dc}}",
                meeting_not_start: "The meeting has not started",
                meeting_taking: "m\xf3wi:",
                meeting_waiting_for_start: "Waiting for meeting to start",
                meeting_waiting_room: "The host will let you in soon",
                minimized_view: "Minimized View",
                mirror_my_video: "Dubluj moje wideo",
                "polling.Back": "Wstecz",
                "promote.cancel": "Pozosta\u0144 uczestnikiem",
                "promote.content_1": "Jako panelista mo\u017Cesz wy\u0142\u0105czy\u0107 wyciszenie i uruchomi\u0107 wideo, co znaczy, \u017Ce b\u0119d\u0105 Ci\u0119 widzie\u0107 inni uczestnicy webinaru.",
                "promote.content_2": "Je\u015Bli prowadz\u0105cy lub inny paneli\u015Bci postanowi\u0105 nagrywa\u0107, transmitowa\u0107 strumieniowo na \u017Cywo lub zarchiwizowa\u0107 webinar po wy\u0142\u0105czeniu przez Ciebie wyciszenia, Tw\xF3j udzia\u0142 zostanie uwzgl\u0119dniony.",
                "promote.ok": "Do\u0142\u0105cz jako panelista",
                "promote.title": "Prowadz\u0105cy chce awansowa\u0107 Ci\u0119 na panelist\u0119",
                ribbon_view: "Ribbon View",
                "rmc.assistant_exist_warning": "Nie mo\u017Cesz kontrolowa\u0107 spotkania, poniewa\u017C inny asystent kontroluje to spotkanie.",
                "rmc.exist_notification_for_client_host": "Tym spotkaniem steruje administrator.",
                "rmc.not_exist_notification_for_client_host": "Administrator przesta\u0142 sterowa\u0107 spotkaniem.",
                same_as_system: "Tak jak w systemie",
                "security.allow_participants_to": "Pozw\xf3l uczestnikom na:",
                "security.button": "Zabezpieczenia",
                "security.waiting_room": "W\u0142\u0105cz poczekalni\u0119",
                select_allow: "Select the option Allow.",
                "settings.audio_tab_text": "Audio",
                "settings.enable_hd": "W\u0142\u0105cz wideo HD.",
                "settings.enable_hd_tip": "W\u0142\u0105cz wszystkich uczestnik\xF3w, aby wy\u015Bwietli\u0107 wideo w wysokiej rozdzielczo\u015Bci (720P). Nale\u017Cy pami\u0119ta\u0107, \u017Ce rzeczywisty wynik zale\u017Cy od wydajno\u015Bci maszyny i przepustowo\u015Bci.",
                "settings.frame_per_second": "Ramka na sekund\u0119",
                "settings.frequency": "Cz\u0119stotliwo\u015B\u0107",
                "settings.input_level": "Poziom wej\u015Bciowy:",
                "settings.item_name": "Nazwa elementu",
                "settings.jitter": "Jitter",
                "settings.latency": "Op\xF3\u017Anienie",
                "settings.maximum_view": "Maksymalna liczba uczestnik\xF3w wy\u015Bwietlona na ekran w widoku galerii:",
                "settings.output_level": "Poziom wyj\u015Bciowy:",
                "settings.packet_loss": "Utrata pakiet\xF3w \u2013 \u015Br. (maks.)",
                "settings.participants25": "25 Uczestnicy",
                "settings.participants9": "9 Uczestnicy",
                "settings.playing": "Odtwarzanie",
                "settings.receive": "Otrzymaj",
                "settings.receiving_video": "Otrzymywanie wideo",
                "settings.receiving_video_tips": "U\u017Cyj sprz\u0119towego dekodowania wideo karty graficznej, aby oszcz\u0119dza\u0107 u\u017Cycie procesora do otrzymywania wideo. Od\u015Bwie\u017C stron\u0119, aby wprowadzi\u0107 zmian\u0119.",
                "settings.recording": "Nagranie",
                "settings.rejoin": "Do\u0142\u0105cz ponownie",
                "settings.resolution": "Rozdzielczo\u015B\u0107",
                "settings.send": "Wy\u015Blij",
                "settings.sending_video": "Wysy\u0142anie wideo",
                "settings.sending_video_tips": "U\u017Cyj sprz\u0119towego kodowania wideo karty graficznej, aby oszcz\u0119dzi\u0107 u\u017Cycie procesora do wysy\u0142ania wideo. Od\u015Bwie\u017C stron\u0119, aby wprowadzi\u0107 zmian\u0119.",
                "settings.statistics": "Statystyki",
                "settings.stop": "Zatrzymaj",
                "settings.switch_view_mode_text": "Musisz ponownie do\u0142\u0105czy\u0107 do spotkania, aby zastosowa\u0107 t\u0119 zmian\u0119",
                "settings.test_mic": "Przetestuj mikrofon",
                "settings.test_speaker": "Przetestuj g\u0142o\u015Bnik",
                "settings.unknown_device": "Nieznane urz\u0105dzenie",
                "settings.use_hardware_acceleration": "U\u017Cyj przyspieszenia sprz\u0119towego dla:",
                "settings.vb_init_10s_tip2": "Virtual Background is taking longer than expected to load.",
                "settings.vb_init_fail2": "Nie mo\u017Cna za\u0142adowa\u0107 wirtualnego t\u0142a.",
                "settings.video_tab_text": "Wideo",
                speaker_view: "Prelegent",
                toolbar_join_audio: "Do\u0142\u0105cz do po\u0142\u0105czenia g\u0142osowego",
                toolbar_leave: "Opu\u015B\u0107",
                toolbar_mute: "Wycisz",
                toolbar_muteall: "Wycisz wszystkich",
                toolbar_record: "Nagraj",
                toolbar_unmute: "Wy\u0142\u0105cz wyciszenie",
                wait_room_tip1: "{{displayName}} wszed\u0142 do poczekalni na to spotkanie",
                wait_room_tip2: "{{count}} os\xF3b wesz\u0142o do Poczekalni na to spotkanie",
                "wc.ast_admin_name": "Asystent spotkania",
                "wc.rmc_admin_name": "Administrator sterowania spotkaniem",
                "wc.rmc_admin_tooltip": "Ten u\u017Cytkownik ma sterowanie prowadz\u0105cego i nie ma dost\u0119pu do \u017Cadnych tre\u015Bci multimedialnych (d\u017Awi\u0119ku, wideo, czatu).",
                wc_3rd_cc_copied_api_token: "The API token has been copied to your clipboard",
                wc_3rd_cc_copy_api_token: "Copy the API token",
                wc_3rd_cc_service: "U\u017Cyj zewn\u0119trznej us\u0142ugi napis\xF3w kodowanych",
                wc_3rd_cc_url_help_tips2: "Copy this token and paste it in a 3rd-party Closed Captioning tool",
                wc_admit: "Przyjmij",
                wc_allow_to_talk: "Pozw\xf3l na m\xf3wienie",
                wc_audio: "Audio",
                "wc_audio.muted_notification1": "Prowadz\u0105cy wyciszy\u0142 Ci\u0119",
                "wc_audio.muted_notification2": "Prowadz\u0105cy wyciszy\u0142 wszystkich",
                "wc_audio.unmute_by_host_content_1": "Prowadz\u0105cy oczekuje, \u017Ce zaczniesz m\xF3wi\u0107",
                "wc_audio.unmute_by_host_content_2": "Je\u015Bli wy\u0142\u0105czysz wyciszenie, inni uczestnicy webinaru b\u0119d\u0105 mogli Ci\u0119 us\u0142ysze\u0107. Je\u015Bli prowadz\u0105cy lub paneli\u015Bci postanowi\u0105 nagrywa\u0107, transmitowa\u0107 strumieniowo na \u017Cywo lub zarchiwizowa\u0107 webinar po wy\u0142\u0105czeniu przez Ciebie wyciszenia, Tw\xF3j g\u0142os zostanie uwzgl\u0119dniony.",
                wc_audio_cannot_unmute: "Nie mo\u017Cesz wy\u0142\u0105czy\u0107 wyciszenia, poniewa\u017C wyciszy\u0142 Ci\u0119 prowadz\u0105cy.",
                wc_audio_connecting_thumbnail: "\u0141\u0105czenie z g\u0142osem",
                wc_broadcasting: "Nadawanie",
                wc_btn_endconf_meeting_all: "Zako\u0144cz spotkanie dla wszystkich",
                wc_camera_prevent: "Ta przegl\u0105darka uniemo\u017Cliwia dost\u0119p do kamery. W\u0142\u0105cz go i ponownie uruchom wideo",
                "wc_cc.placeholder": "Wpisz tutaj, naci\u015Bnij klawisz Enter, aby emitowa\u0107",
                wc_cc_assign_participant_to_type: "Przypisz uczestnika do wpisywania",
                wc_cc_assign_to: "Przypisz do typu napisy kodowane",
                wc_cc_assign_to_type: "Przypisz kogo\u015B do wpisywania",
                wc_cc_broadcasting_tip: "Closed Captions are being broadcast to all participants.",
                wc_cc_host_assigned: "Prowadz\u0105cy przypisa\u0142 Ci\u0119 do wpisywania napis\xF3w kodowanych",
                wc_cc_type_myself: "Ja b\u0119d\u0119 wpisywa\u0107",
                wc_cc_withdraw: "Wycofaj pozwolenie na napisy kodowane",
                "wc_chat.attendee_chat_with": "Uczestnicy mog\u0105 rozmawia\u0107 na czacie z",
                "wc_chat.chat": "Czat",
                "wc_chat.direct_message": "Wiadomo\u015B\u0107 bezpo\u015Brednia",
                "wc_chat.disable_chat": "Prowadz\u0105cy wy\u0142\u0105czy\u0142 czat uczestnik\xF3w.",
                "wc_chat.disabled": "Nikt",
                "wc_chat.everyone": "Wszyscy",
                "wc_chat.everyone_public": "Wszyscy publicznie",
                "wc_chat.everyone_public_private": "Wszyscy publicznie i prywatnie",
                "wc_chat.host_only": "Tylko prowadz\u0105cy",
                "wc_chat.host_panelists": "Prowadz\u0105cy i paneli\u015Bci",
                "wc_chat.me": "Ja",
                "wc_chat.panelist_chat_with": "Paneli\u015Bci mog\u0105 rozpocz\u0105\u0107 czat z u\u017Cytkownikiem",
                "wc_chat.type_msg": "Wpisz tutaj wiadomo\u015B\u0107...",
                wc_closed_caption_btn: "Napisy wy\u0142\u0105czone",
                wc_co_host: "(Wsp\xF3\u0142prowadz\u0105cy)",
                wc_continue: "Kontynuuj",
                wc_copied: "Skopiowano",
                wc_copied_to_clipboard: "Link z zaproszeniem skopiowano do schowka",
                wc_copy_link: "Skopiuj link",
                wc_data_center2: "Masz po\u0142\u0105czenie z lokalnym centrum danych.",
                wc_data_center3: "Masz po\u0142\u0105czenie z globaln\u0105 sieci\u0105 Zoom za po\u015Brednictwem lokalnego centrum danych.",
                wc_disable_talking: "Wy\u0142\u0105cz m\xF3wienie",
                wc_dlg_confirm: "Potwierdzenie",
                wc_enable: "W\u0142\u0105czono",
                wc_encryption: "Szyfrowanie",
                wc_extra_function_disable_video: "Disable video receiving",
                wc_files: "Pliki",
                wc_footer_assign_leave: "Przypisz i opu\u015B\u0107",
                wc_footer_assign_new_host: "Przypisz nowego prowadz\u0105cego",
                wc_guest: "Go\u015B\u0107",
                wc_host_1: "Prowadz\u0105cy",
                wc_in_the_meeting: "Na spotkaniu",
                wc_invite_link: "Link z zaproszeniem",
                wc_join_media_preview_info_confirm: "Rozumiem",
                wc_join_media_preview_warning_denied_both: "W\u0142\u0105cz dost\u0119p do kamery i mikrofonu na pasku adresu przegl\u0105darki.",
                wc_join_media_preview_warning_denied_camera: "W\u0142\u0105cz dost\u0119p do kamery na pasku adresu przegl\u0105darki.",
                wc_join_media_preview_warning_denied_mic: "W\u0142\u0105cz dost\u0119p do mikrofonu na pasku adresu przegl\u0105darki.",
                wc_joining: "Do\u0142\u0105cz",
                wc_joining_meeting: "Do\u0142\u0105czanie do spotkania...",
                wc_learn_more: "Dowiedz si\u0119 wi\u0119cej",
                wc_leave_computer_audio: "Opu\u015B\u0107 po\u0142\u0105czenie g\u0142osowe komputera",
                wc_leave_meeting: "Opu\u015B\u0107 spotkanie",
                wc_leave_webinar: "Opu\u015B\u0107 webinar",
                wc_live_transcription_btn: "Transkrypcja na \u017Cywo",
                wc_lock_meeting: "Zablokuj spotkanie",
                wc_lower_hand: "Opu\u015B\u0107 r\u0119k\u0119",
                wc_lt_disable_transcription: "Wy\u0142\u0105cz automatyczn\u0105 transkrypcj\u0119",
                wc_lt_enable_transcription: "W\u0142\u0105cz automatyczn\u0105 transkrypcj\u0119",
                wc_lt_item_captioner: "(osoba transkrybuj\u0105ca)",
                wc_lt_live_transcript: "Transkrypcja na \u017Cywo",
                wc_lt_menu_item1: "Poka\u017C podtytu\u0142",
                wc_lt_menu_item2: "Wy\u015Bwietl pe\u0142n\u0105 transkrypcj\u0119",
                wc_lt_menu_item3: "Ukryj podtytu\u0142",
                wc_lt_menu_item4: "Zamknij pe\u0142n\u0105 transkrypcj\u0119",
                wc_lt_request_host_ctrl: "Zezw\xF3l uczestnikom na poproszenie o w\u0142\u0105czenie transkrypcji na \u017Cywo",
                wc_lt_search_text: "Wyszukaj",
                wc_make_co_host: "Uczy\u0144 wsp\xF3\u0142prowadz\u0105cym",
                wc_make_host: "Uczy\u0144 prowadz\u0105cym",
                wc_me: "(Ja)",
                wc_more: "Wi\u0119cej",
                wc_no: "Nie",
                wc_none: "Brak",
                wc_not_share_pronoun: "Nie udost\u0119pniaj",
                wc_num_password: "Kod numeryczny (telefon / systemy pokoi)",
                wc_participant_id: "Identyfikator uczestnika",
                wc_participants: "Uczestnicy",
                wc_pc_audio: "D\u017Awi\u0119k komputera",
                wc_prevent_access_mic: "Ta przegl\u0105darka uniemo\u017Cliwia dost\u0119p do mikrofonu.",
                wc_put_in_waiting: "Umie\u015B\u0107 w poczekalni",
                "wc_qa.allQ": "Wszystkie pytania",
                "wc_qa.anonymous_attendee": "Anonimowy uczestnik",
                "wc_qa.answer_private_type": "Odpowied\u017A prywatna",
                "wc_qa.answeredQ": "Odpowiedziano",
                "wc_qa.attendee_placeholder": "Pytania zadane prowadz\u0105cemu i panelistom pojawi\u0105 si\u0119 tutaj.",
                "wc_qa.button_comment": "Skomentuj",
                "wc_qa.button_display_answer": "Wpisz odpowied\u017A",
                "wc_qa.button_live": "Odpowiedz na \u017Cywo",
                "wc_qa.button_live_done": "Gotowe",
                "wc_qa.button_reopen": "Otw\xf3rz ponownie",
                "wc_qa.collapse_all_answer": "Zwi\u0144 wszystko",
                "wc_qa.dismissedQ": "Odrzucono",
                "wc_qa.display_all_answer": "Poka\u017C wszystko",
                "wc_qa.dissmis_tips": "Odrzu\u0107",
                "wc_qa.input_tips": "Wpisz pytanie tutaj...",
                "wc_qa.is_anonymous": "Wy\u015Blij anonimowo",
                "wc_qa.is_privately": "Wy\u015Blij prywatnie",
                "wc_qa.live_tips_done": "Odpowied\u017A na to pytanie zosta\u0142a udzielona na \u017Cywo",
                "wc_qa.live_tips_start": "chce odpowiedzie\u0107 na to pytanie na \u017Cywo",
                "wc_qa.most_recent": "Najnowsze",
                "wc_qa.most_upvotes": "Najwi\u0119cej g\u0142os\xF3w poparcia",
                "wc_qa.myQ": "Moje pytania",
                "wc_qa.no_answered_questions": "Brak pyta\u0144, na kt\xF3re udzielono odpowiedzi",
                "wc_qa.no_dismissed_questions": "Brak odrzuconych pyta\u0144",
                "wc_qa.no_open_questions": "Brak otwartych pyta\u0144",
                "wc_qa.no_questions": "Brak pyta\u0144",
                "wc_qa.openedQ": "Otw\xf3rz",
                "wc_qa.panelist_host_only_placeholder": "Tylko prowadz\u0105cy i paneli\u015Bci mog\u0105 zobaczy\u0107 pytania",
                "wc_qa.panelist_view_all_placehoder": "Ka\u017Cdy uczestnik webinaru mo\u017Ce zobaczy\u0107 otwarte pytania",
                "wc_qa.qa_comp_title": "Pytania i odpowiedzi",
                "wc_qa.send": "Wy\u015Blij",
                "wc_qa.setting_allow_view": "Pozw\xF3l uczestnikom wy\u015Bwietla\u0107",
                "wc_qa.setting_btn_name": "Ustawienia",
                "wc_qa.setting_option_allow_anony_question": "Pozw\xf3l na pytania anonimowe",
                "wc_qa.setting_option_allow_comment": "Uczestnicy mog\u0105 komentowa\u0107",
                "wc_qa.setting_option_allow_view_all": "Wszystkie pytania",
                "wc_qa.setting_option_allow_view_answered": "Tylko pytania, na kt\xf3re odpowiedziano",
                "wc_qa.setting_option_allow_vote": "Uczestnicy mog\u0105 dawa\u0107 \u0142apk\u0119 w g\xF3r\u0119",
                "wc_qa.welcome_banner": "Zach\u0119camy do zadawania pyta\u0144 prowadz\u0105cemu i panelistom",
                "wc_qa.welcome_banner_title": "Witamy",
                wc_raise_hand: "Zg\u0142o\u015B si\u0119",
                wc_reclaim_host: "Wycofaj prowadz\u0105cego",
                wc_record_host_reminder_desc: "Wskutek kontynuowania wszystkie twarze, rozmowy i udost\u0119pnianie ekranu b\u0119d\u0105 nagrywane w chmurze.",
                wc_record_reminder_desc: "Kontynuacja uczestnictwa w spotkaniu oznacza zgod\u0119 na nagrywanie.",
                wc_record_reminder_desc_2: "{{accountOwner}} i prowadz\u0105cy mog\u0105 ogl\u0105da\u0107 nagrania w chmurze Zoom, a ka\u017Cdy uczestnik z pozwoleniem mo\u017Ce nagrywa\u0107 na swoim urz\u0105dzeniu lokalnym. Osoby te mog\u0105 udost\u0119pnia\u0107 nagrania aplikacjom i innym osobom.",
                wc_record_reminder_title: "Spotkanie jest nagrywane",
                wc_record_reminder_webinar_title: "Ten webinar jest nagrywany",
                wc_record_webinar_reminder_desc: "Kontynuuj\u0105c udzia\u0142 w webinarze, wyra\u017Casz zgod\u0119 na nagrywanie.",
                wc_recording_pause: "Wstrzymaj nagrywanie",
                wc_recording_resume: "Wzn\xf3w nagrywanie",
                wc_recording_stop: "Zatrzymaj nagrywanie",
                wc_recording_title: "Record this meeting?",
                wc_remove: "Usu\u0144",
                wc_select_camera: "Wybierz kamer\u0119",
                wc_select_microphone: "Wybierz mikrofon",
                wc_select_speaker: "Wybierz prelegenta",
                wc_share_muted_while_sharing_audio_tip2: "Tw\xF3j mikrofon jest tymczasowo wy\u0142\u0105czony w trakcie udost\u0119pniania d\u017Awi\u0119ku. Kiedy wstrzymasz albo zatrzymasz udost\u0119pnienie d\u017Awi\u0119ku, Tw\xF3j mikrofon zostanie ponownie w\u0142\u0105czony.",
                wc_share_pronoun: "Udost\u0119pnij",
                wc_share_pronoun_menu: "Udost\u0119pnij moje zaimki",
                wc_share_pronoun_tip2: "Czy chcesz udost\u0119pni\u0107 swoje zaimki w trakcie tego spotkania?",
                wc_sharer_controlbar_container_button3_label: "Zatrzymaj udost\u0119pnianie",
                wc_sharer_controlbar_container_rec_status_tip1: "Udost\u0119pniasz ekran",
                wc_sharer_controlbar_container_rec_status_tip2: "Udost\u0119pnianie ekranu przez Ciebie jest wstrzymane",
                wc_sharer_disabled_share1_desc: "Prowadz\u0105cy wy\u0142\u0105czy\u0142 uczestnikom udost\u0119pnianie ekranu.",
                wc_sharer_disabled_share2_desc: "Nie mo\u017Cna rozpocz\u0105\u0107 udost\u0119pniania ekranu, gdy udost\u0119pnia go inny uczestnik.",
                wc_sharer_entry_button_label1: "Udost\u0119pnij ekran",
                wc_sharer_setting_menu_category1_title: "Kto mo\u017Ce udost\u0119pnia\u0107?",
                wc_sharer_setting_menu_category2_title: "Kto mo\u017Ce rozpocz\u0105\u0107 udost\u0119pnianie, kiedy udost\u0119pnia kto\u015B inny?",
                wc_sharer_setting_menu_category3_title: "Ilu uczestnik\xF3w naraz mo\u017Ce udost\u0119pnia\u0107?",
                wc_sharer_setting_menu_category_option1: "Tylko prowadz\u0105cy",
                wc_sharer_setting_menu_category_option2: "Wszyscy uczestnicy",
                wc_sharer_setting_menu_item1: "Udost\u0119pnia\u0107 mo\u017Ce jeden uczestnik naraz",
                wc_sharer_setting_menu_item2: "Udost\u0119pnia\u0107 mo\u017Ce wielu uczestnik\xF3w naraz",
                wc_sharing_fit_to_window: "Dopasuj do okna",
                wc_sharing_original_size: "Rozmiar oryginalny",
                wc_sharing_shared_screens: "Ekrany udost\u0119pnione",
                wc_sharing_view_options: "Wy\u015Bwietl opcje",
                wc_sharing_viewing: "Ogl\u0105dasz ekran {{displayName}}",
                wc_tel_password: "Kod dost\u0119pu",
                wc_unmute_by_host_btn1: "Pozostaw wyciszenie",
                wc_unshare_pronoun_menu: "Wy\u0142\u0105cz udost\u0119pnianie moich zaimk\xF3w",
                "wc_video.allow_panelist_start_video": "Pozw\xF3l paneli\u015Bcie na uruchomienie wideo",
                "wc_video.allow_participants_start_video": "Pozw\xf3l uczestnikom na rozpoczynanie wideo",
                "wc_video.ask_start_video": "Za\u017C\u0105daj uruchomienia wideo",
                "wc_video.model_stop": "Nie mo\u017Cna uruchomi\u0107 wideo, poniewa\u017C zatrzyma\u0142 je prowadz\u0105cy",
                "wc_video.start_video": "Uruchom wideo",
                "wc_video.stop_video": "Zatrzymaj wideo",
                "wc_video.video": "Wideo",
                wc_view: "Wy\u015Bwietl",
                wc_waiting_room: "Poczekalnia",
                "wc_webinar.change_to_attendee": "Zmie\u0144 rol\u0119 na uczestnika",
                "wc_webinar.promote_to_panelist": "Awansuj na panelist\u0119",
                wc_webinar_attendees: "Uczestnicy",
                wc_webinar_panelists: "Paneli\u015Bci",
                wc_webinar_putonhold: "Zawieszono na linii",
                wc_withdraw_co_host: "Cofnij pozwolenie na wsp\xF3\u0142prowadzenie",
                wc_yes: "Tak",
                websdk_enforce_update_content: "Twoja wersja aplikacji musi by\u0107 {0} lub nowsza, aby do\u0142\u0105czy\u0107 do tego spotkania. Zaktualizuj, aby kontynuowa\u0107.",
                websdk_update_content: "Zaktualizuj WebSDK do najnowszej wersji, aby optymalizowa\u0107 do\u015Bwiadczenie spotkania"
              }
            },
            "tr-TR": {
              translation: {
                GOT_IT: "Anlad\u0131m",
                account_owner: "hesap sahibi",
                allow_to_access: "Allow Zoom to access your camera and microphone",
                "app_signal.approved_by": "Onaylayan:",
                "app_signal.people": "ki\u015Filer",
                "app_signal.tip_text_2": "Toplant\u0131 i\xE7eri\u011Finize eri\u015Fen uygulamalar\u0131 g\xF6r\xFCn",
                "app_signal.unable_load2": "Bilgilerinize ger\xE7ek zamanl\u0131 eri\u015Fim ile uygulamalar y\xFCklenemiyor.",
                "archiving.chat_1": "sohbet(genel ve do\u011Frudan)",
                "archiving.chat_2": "sohbet(sadece genel)",
                "archiving.chat_disable_content": "Sohbette g\xF6nderilen mesajlar uyumluluk sebeplerinden \xF6t\xFCr\xFC ar\u015Fivlenemedi.",
                "archiving.chat_disable_title": "Sohbet devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131",
                "archiving.content1_sdk": "Bu toplant\u0131daki bir veya daha fazla kat\u0131l\u0131mc\u0131, hesaplar\u0131n\u0131n politikas\u0131na g\xF6re ar\u015Fivlemeye tabidir. Onlar\u0131n {{content}}'si, bu toplant\u0131n\u0131n i\xE7eriklerini alacak ve bunu uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilecek.",
                "archiving.content2_sdk": "Bu toplant\u0131da kalarak, bu {{content}} toplant\u0131n\u0131n \xF6\u011Fesinin ar\u015Fivlenmesine izin vermi\u015F olursunuz.",
                "archiving.default_title": "Bu toplant\u0131 ar\u015Fivleniyor",
                "archiving.fail_content_sdk": "Uyumluluk sebeplerinden \xF6t\xFCr\xFC toplant\u0131n\u0131n {{features}}'sinin ar\u015Fivlenmesi gerekmektedir.",
                "archiving.fail_title": "Ar\u015Fivleme ba\u015Far\u0131s\u0131z",
                "archiving.subjects_combo_2_sdk": "{{0}} ve {{1}}",
                "archiving.subjects_combo_3_sdk": "{{0}}, {{1}}, ve {{2}}",
                "archiving.subjects_combo_4_sdk": "{{0}}, {{1}}, {{2}}, ve {{3}}",
                "archiving.tips_1_sdk": "Bu toplant\u0131n\u0131n {{subjects}}'i, hesap politikas\u0131na ba\u011Fl\u0131 olarak oturum sahibinin kurulu\u015Fu taraf\u0131ndan ar\u015Fivlenir. Onlar\u0131n {{receiver}}'si, bu toplant\u0131n\u0131n i\xE7eriklerini alacak ve bunu uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilecek.",
                "archiving.tips_2_sdk": "Bu toplant\u0131n\u0131n {{subjects}}'i, hesap politikas\u0131na ba\u011Fl\u0131 olarak oturum sahibinin kurulu\u015Fu taraf\u0131ndan ar\u015Fivlenir. Onlar\u0131n {{receiver}}'si, bu toplant\u0131n\u0131n i\xE7eriklerini alacak ve bunu uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilecek.",
                "archiving.transcription": "d\xf6k\xfcm",
                "ast.leave_tip": "Asistan toplant\u0131y\u0131 kontrol etmeyi durdurdu",
                "ast.tip": "Bu toplant\u0131 bir asistan taraf\u0131ndan kontrol ediliyor.",
                background: "Arka Plan",
                chat_message_header: "<0>{{senderName}}</0> <1>to</1> <2>{{receiverName}}</2>",
                chat_new_message: "{{counts}} New Message",
                chat_receiver_co_host: "( Co-host )",
                chat_receiver_host: "( Host )",
                chat_receiver_panelist: "( Panelist )",
                chat_receiver_to: "To:",
                choose_background: "Arka Plan Se\xe7",
                click_address_bar: "Click the lock icon to the left of your address bar. A pop-up will appear with a list of options.",
                click_microphone_camera_option: "Click the drop-down list to the right of the Camera and Microphone option.",
                "common.cancel": "\u0130ptal",
                "common.connecting": "Ba\u011Flan\u0131yor",
                delete: "Sil",
                "dialog.btn_cancel": "\u0130ptal",
                "dialog.btn_endconf_webinar": "Web Seminerini Sonland\u0131r",
                "dialog.btn_leaveconf_meeting": "Toplant\u0131dan \xC7\u0131k",
                "dialog.btn_retry": "Yeniden Dene",
                "dialog.host_end_meeting": "Bu toplant\u0131 oturum sahibi taraf\u0131ndan sonland\u0131r\u0131ld\u0131",
                "dialog.host_end_webinar": "Bu Web Semineri, oturum sahibi taraf\u0131ndan sonland\u0131r\u0131ld\u0131.",
                "dialog.meeting_ended": "Toplant\u0131 sona erdi",
                "dialog.meeting_locked": "Toplant\u0131 kilitlendi",
                "dialog.meeting_removed_by_host": "Oturum sahibi taraf\u0131ndan bu toplant\u0131dan kald\u0131r\u0131ld\u0131n\u0131z.",
                "dialog.newname": "Ad\u0131",
                "dialog.ok": "Tamam",
                "dialog.presscode": "Toplant\u0131 kimli\u011Fi",
                "dialog.rename": "Yeniden adland\u0131r",
                "dialog.server_error": "Sunucu dahili bir hatayla kar\u015F\u0131la\u015Ft\u0131 ve iste\u011Finizi i\u015Fleyemedi.",
                "dialog.webinar_ended": "Web semineri sona erdi",
                "dialog.webinar_removed_by_host": "Oturum sahibi taraf\u0131ndan bu Web Seminerinden kald\u0131r\u0131ld\u0131n\u0131z.",
                "dialog.you_are_removed": "Kald\u0131r\u0131ld\u0131n\u0131z",
                dialog_make_cohost: "Do you want to make {{displayName}} the co-host of this meeting?",
                dialog_make_host: "Do you want to change the host to {{displayName}} ?",
                dialog_remove_user: "Do you want to remove {{displayName}}?",
                "disclaimer.LT_button_1": "Bu d\xf6k\xfcm\xfc kimler g\xf6rebilir?",
                "disclaimer.LT_content_1_1": "Hesap sahibi ve toplant\u0131daki herkes bu d\xF6k\xFCm\xFC kaydedebilir ve uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.LT_content_2": "Canl\u0131 D\xF6k\xFCm (Alt Yaz\u0131) etkinle\u015Ftirildi",
                "disclaimer.QA_button_1": "Sorular\u0131n\u0131z\u0131 kimler g\xF6rebilir?",
                "disclaimer.QA_content_1_1": "Hesap sahibi, oturum sahibi ve panelistler kim oldu\u011Funuzu, ileti\u015Fim bilgilerinizi (giri\u015F yapt\u0131ysan\u0131z veya sa\u011Flad\u0131ysan\u0131z) ve sorunuzu g\xF6rebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.QA_content_2": "Sorunuz se\xE7ildi\u011Finde, t\xFCm rols\xFCz kat\u0131l\u0131mc\u0131lar taraf\u0131ndan g\xF6r\xFClebilir.",
                "disclaimer.QA_content_3_3": "Anonim olarak g\xF6ndermedi\u011Finiz s\xFCrece, hesap sahibi, oturum sahibi ve panelistler kim oldu\u011Funuzu, ileti\u015Fim bilgilerinizi (giri\u015F yapt\u0131ysan\u0131z veya sa\u011Flad\u0131ysan\u0131z) ve sorunuzu g\xF6rebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.QA_content_4": "Soru-Cevap herkese a\xE7\u0131kt\u0131r, bu nedenle sorular\u0131n\u0131z\u0131 herkes g\xF6rebilir.",
                "disclaimer.QA_content_5": "Sorular\u0131n\u0131z\u0131 anonim olarak g\xF6nderirseniz, sorular\u0131n\u0131z\u0131 kimin g\xF6nderdi\u011Fini kimse g\xF6remez.",
                "disclaimer.chat_button_normal": "Mesajlar\u0131n\u0131z\u0131 kimler g\xF6rebilir?",
                "disclaimer.chat_button_onArchiving": "Mesajlar\u0131n\u0131z\u0131 kimler g\xF6rebilir? Ar\u015Fivleme zaman\u0131",
                "disclaimer.chat_button_onRecording": "Mesajlar\u0131n\u0131z\u0131 kimler g\xF6rebilir? Kay\u0131t Zaman\u0131",
                "disclaimer.chat_content_1": "Toplant\u0131daki herkes, herkesle mesajlar\u0131n\u0131z\u0131 g\xF6rebilir ve kaydedebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.chat_content_2": "Sadece siz ve sohbet etti\u011Finiz ki\u015Filer do\u011Frudan mesajlar\u0131n\u0131z\u0131 kaydedebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilirsiniz.",
                "disclaimer.chat_content_3": "Kay\u0131t a\xE7\u0131k oldu\u011Fundan hesap sahibi ve toplant\u0131daki herkes, Herkese g\xF6nderilen mesajlar\u0131 g\xF6nderebilir ve kaydedebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.chat_content_4": "Kay\u0131t a\xE7\u0131k oldu\u011Fundan toplant\u0131daki herkes, Herkese g\xF6nderilen mesajlar\u0131 g\xF6rebilir ve kaydedebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.chat_content_5": "Ar\u015Fivleme a\xE7\u0131k oldu\u011Fundan hesap sahibi do\u011Frudan mesajlar\u0131n\u0131z da dahil olmak \xFCzere t\xFCm mesajlar\u0131n\u0131z\u0131 g\xF6rebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.chat_content_6": "Ar\u015Fivleme a\xE7\u0131k oldu\u011Fundan hesap sahibi do\u011Frudan mesajlar\u0131n\u0131z hari\xE7 olmak \xFCzere t\xFCm mesajlar\u0131n\u0131z\u0131 g\xF6rebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                "disclaimer.chat_content_7": "Ar\u015Fivleme a\xE7\u0131k, b\xF6ylece hesap sahibi do\u011Frudan mesajlar\u0131n\u0131z hari\xE7 t\xFCm mesajlar\u0131n\u0131z\u0131 g\xF6rebilir ve bunlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                errorcodes_be_removed: "Kald\u0131r\u0131lmas\u0131.",
                errorcodes_denied_email: "E-posta y\xF6netici taraf\u0131ndan engellenir.",
                errorcodes_denied_register_with_panelist: "Reddedilen Kay\u0131t Panelist e-postas\u0131n\u0131 kullan\u0131n.",
                errorcodes_disconnect: "Toplant\u0131 ba\u011Flant\u0131s\u0131 kesildi.",
                errorcodes_email_require: "Web seminerine kat\u0131lmak i\xE7in e-posta eksik.",
                errorcodes_fail: "Toplant\u0131ya kat\u0131lamaz.",
                errorcodes_frequent_call: "Bu arama i\xE7in API s\u0131n\u0131r\u0131na ula\u015Ft\u0131n\u0131z.",
                errorcodes_frequent_join: "Yak\u0131nla\u015Ft\u0131rma ile s\u0131n\u0131rland\u0131r\u0131n, reCAPTCHA'y\u0131 kontrol etmeniz gerekir.",
                errorcodes_login_required: "Don't support meeting/webinar authentication",
                errorcodes_need_use_zoom_desktop_or_mobile: "Taray\u0131c\u0131dan kat\u0131lam\u0131yorsan\u0131z, l\xFCtfen Zoom Masa\xFCst\xFC \u0130stemcisi veya Mobil Uygulamay\u0131 kullanarak kat\u0131l\u0131n.",
                errorcodes_not_exist: "Toplant\u0131 yok.",
                errorcodes_not_host: "Toplant\u0131 ev sahibi de\u011Filsin.",
                errorcodes_not_init: "Toplant\u0131 ba\u015Flat\u0131lmad\u0131.",
                errorcodes_not_start: "Toplant\u0131 ba\u015Flamad\u0131",
                errorcodes_not_support_registration: "Don't support meeting/webinar registration",
                errorcodes_offline: "Hizmet ge\xE7ici olarak \xE7evrimd\u0131\u015F\u0131.",
                errorcodes_pac_api_disabled: "Hesaplar API anahtar\u0131 devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131.",
                errorcodes_pac_api_wrong: "Hesaplar API anahtar\u0131 ge\xE7erli de\u011Fil.",
                errorcodes_pac_cant_host_other_mn: "E\u015Fzamanl\u0131 olarak ba\u015Fka bir toplant\u0131ya ev sahipli\u011Fi yapamaz.",
                errorcodes_pac_host_not_found: "Toplant\u0131 ev sahibi bulunamad\u0131.",
                errorcodes_pac_invalid_signature: "\u0130mza ge\xE7ersiz.",
                errorcodes_pac_mn_not_fount: "Toplant\u0131 numaras\u0131 bulunamad\u0131.",
                errorcodes_pac_mn_wrong: "Toplant\u0131 numaras\u0131 yanl\u0131\u015F.",
                errorcodes_pac_no_permission: "\u0130zin yok.",
                errorcodes_pac_not_allow_assistant: "Yard\u0131mc\u0131 Kat\u0131l\u0131m\u0131 Toplant\u0131s\u0131 Engelliler",
                errorcodes_pac_role_error: "Yanl\u0131\u015F rol.",
                errorcodes_pac_signature_expired: "\u0130mzan\u0131n s\xFCresi doldu.",
                errorcodes_re_connect: "Toplant\u0131 yeniden ba\u011Flan\u0131yor.",
                errorcodes_register: "Bu toplant\u0131 kay\u0131t gerektirir.",
                errorcodes_rwc_empty: "Web sunucusundan bir cevap alamad\u0131m.",
                errorcodes_rwc_error: "Web sunucusu hatas\u0131na ba\u011Flan\u0131lamad\u0131.",
                errorcodes_sign_webinar: "DONT 'DE\u011E\u0130\u015ET\u0130REB\u0130L\u0130R",
                errorcodes_success: "Ba\u015Far\u0131yla toplant\u0131ya kat\u0131ld\u0131.",
                errorcodes_tk_expired: "Jeton s\xfcresi doldu.",
                errorcodes_wasm_fail: "WASM Dosyalar\u0131 Hatas\u0131n\u0131 \u0130ndirin, l\xFCtfen a\u011F\u0131n\u0131z\u0131 ve g\xFCvenlik duvar\u0131n\u0131z\u0131 kontrol edin.",
                errorcodes_web_has_in_progress: "Zaten devam eden ba\u015Fka toplant\u0131lara sahip.",
                errorcodes_web_host_not_exit: "Toplant\u0131 ana bilgisayar mevcut de\u011Fil.",
                errorcodes_web_invalid_id: "Ge\xE7ersiz Toplant\u0131 Kimli\u011Fi.",
                errorcodes_web_not_allow_start_webinar_from_web: "Web'in web'den ba\u015Flamas\u0131na izin vermeyin.",
                errorcodes_web_not_support_registration_webinar: "Kay\u0131t web seminerini desteklememek",
                errorcodes_web_not_support_tsp: "TSP'yi bir toplant\u0131da ses olarak se\xE7ti\u011Finizde, web'den toplant\u0131y\u0131 ba\u015Flatmay\u0131n veya kat\u0131lmay\u0131n.",
                errorcodes_web_not_support_webclient: "Desteklemeyi denememek veya web'den toplant\u0131ya kat\u0131l\u0131n.",
                errorcodes_web_not_support_webinar_pac: "Web'in ve ki\u015Fisel ses konferans\u0131n\u0131 desteklememek",
                errorcodes_web_require_email: "Kullan\u0131c\u0131 e-postas\u0131 gereklidir.",
                errorcodes_web_should_support_webinar_with_latest_version: "Mevcut SDK s\xFCr\xFCm\xFC WebInar'\u0131 desteklemiyor, l\xFCtfen en son s\xFCr\xFCme y\xFCkseltin.",
                errorcodes_wrong_pass: "\u0130leti\u015Fim \u015Fifreyi yanl\u0131\u015F.",
                gallary_view: "Galeri G\xf6r\xfcn\xfcm\xfc",
                invalid_parameter: "Ge\xe7ersiz parametre",
                "invite.loading": "Y\xfckleniyor...",
                meeting_disconnected: "Ba\u011Flant\u0131s\u0131 kesildi",
                meeting_info: "Toplant\u0131 Bilgileri",
                meeting_info_network: "You are connected to {{network}} via data centers in {{dc}}",
                meeting_not_start: "The meeting has not started",
                meeting_taking: "konu\u015Fuyor:",
                meeting_waiting_for_start: "Waiting for meeting to start",
                meeting_waiting_room: "The host will let you in soon",
                minimized_view: "Minimized View",
                mirror_my_video: "Videomu Yans\u0131t",
                "polling.Back": "Geri",
                "promote.cancel": "Rols\xFCz Kat\u0131l\u0131mc\u0131 Olarak Kal",
                "promote.content_1": "Bir panelist olarak, videoyu a\xE7abilir ve ba\u015Flatabilirsiniz; bu, Web Seminerinde ba\u015Fkalar\u0131 taraf\u0131ndan g\xF6r\xFClece\u011Finiz anlam\u0131na gelir.",
                "promote.content_2": "Oturum sahibi veya di\u011Fer panelistler, sesi a\xE7t\u0131ktan sonra Web Seminerini kaydetmeye, canl\u0131 yay\u0131nlamaya veya ar\u015Fivlemeye karar verirse kat\u0131l\u0131m\u0131n\u0131z dahil edilecektir.",
                "promote.ok": "Panelist olarak kat\u0131l",
                "promote.title": "Oturum sahibi sizi panelist olarak y\xfckseltmek istiyor",
                ribbon_view: "Ribbon View",
                "rmc.assistant_exist_warning": "Toplant\u0131y\u0131 kontrol edemezsiniz \xE7\xFCnk\xFC ba\u015Fka bir asistan bu toplant\u0131y\u0131 kontrol ediyor.",
                "rmc.exist_notification_for_client_host": "Bu toplant\u0131 bir y\xF6netici taraf\u0131ndan kontrol ediliyor.",
                "rmc.not_exist_notification_for_client_host": "Y\xF6netici, toplant\u0131y\u0131 kontrol etmeyi b\u0131rakt\u0131.",
                same_as_system: "Sistem ile Ayn\u0131",
                "security.allow_participants_to": "Kat\u0131l\u0131mc\u0131lara izin ver:",
                "security.button": "G\xfcvenlik",
                "security.waiting_room": "Bekleme Odas\u0131n\u0131 Etkinle\u015Ftir",
                select_allow: "Select the option Allow.",
                "settings.audio_tab_text": "Ses",
                "settings.enable_hd": "HD video etkinle\u015Ftir",
                "settings.enable_hd_tip": "T\xFCm kat\u0131l\u0131mc\u0131lar\u0131n videonuzu y\xFCksek \xE7\xF6z\xFCn\xFCrl\xFCkte g\xF6r\xFCnt\xFClemelerini sa\u011Flay\u0131n (720P). Ger\xE7ek sonucun makine performans\u0131na ve bant geni\u015Fli\u011Fine ba\u011Fl\u0131 oldu\u011Funu unutmay\u0131n.",
                "settings.frame_per_second": "Saniye Ba\u015F\u0131na Kare",
                "settings.frequency": "S\u0131kl\u0131k",
                "settings.input_level": "Giri\u015F Seviyesi:",
                "settings.item_name": "\xD6\u011Fe ad\u0131",
                "settings.jitter": "Bozukluk",
                "settings.latency": "Gecikme",
                "settings.maximum_view": "Galeri G\xF6r\xFCn\xFCm\xFCnde ekran ba\u015F\u0131na g\xF6r\xFCnt\xFClenen maksimum kat\u0131l\u0131mc\u0131 say\u0131s\u0131:",
                "settings.output_level": "\xC7\u0131k\u0131\u015F Seviyesi:",
                "settings.packet_loss": "Paket kayb\u0131 - Ort (Maks)",
                "settings.participants25": "25 Kat\u0131l\u0131mc\u0131lar",
                "settings.participants9": "9 Kat\u0131l\u0131mc\u0131lar",
                "settings.playing": "Y\xfcr\xfct\xfcl\xfcyor",
                "settings.receive": "Al",
                "settings.receiving_video": "Video alma",
                "settings.receiving_video_tips": "Video al\u0131rken CPU kullan\u0131m\u0131ndan tasarruf etmek i\xE7in grafik kart\u0131n\u0131n video kod \xE7\xF6z\xFCc\xFCs\xFC donan\u0131m\u0131n\u0131 kullan\u0131n. Bu de\u011Fi\u015Fikli\u011Fin uygulanmas\u0131 i\xE7in sayfay\u0131 yenileyin.",
                "settings.recording": "Kaydediyor",
                "settings.rejoin": "Yeniden kat\u0131l",
                "settings.resolution": "\xc7\xf6z\xfcn\xfcrl\xfck",
                "settings.send": "G\xf6nder",
                "settings.sending_video": "Video g\xf6nderme",
                "settings.sending_video_tips": "Video g\xF6ndermek i\xE7in CPU kullan\u0131m\u0131ndan tasarruf etmek i\xE7in grafik kart\u0131n\u0131n donan\u0131m video kodlay\u0131c\u0131s\u0131n\u0131 kullan\u0131n. Bu de\u011Fi\u015Fikli\u011Fin uygulanmas\u0131 i\xE7in sayfay\u0131 yenileyin.",
                "settings.statistics": "\u0130statistikler",
                "settings.stop": "Durdur",
                "settings.switch_view_mode_text": "Bu de\u011Fi\u015Fikli\u011Fin uygulanmas\u0131 i\xE7in toplant\u0131ya yeniden kat\u0131lman\u0131z gerekir",
                "settings.test_mic": "Mikrofonu Test Et",
                "settings.test_speaker": "Hoparl\xf6r\xfc Test Et",
                "settings.unknown_device": "Bilinmeyen ayg\u0131t",
                "settings.use_hardware_acceleration": "\u015Eunun i\xE7in donan\u0131m h\u0131zland\u0131rmay\u0131 kullan\u0131n:",
                "settings.vb_init_10s_tip2": "Sanal arka plan y\xfcklenmesi beklenenden daha uzun s\xfcr\xfcyor.",
                "settings.vb_init_fail2": "Sanal arka plan y\xfcklenemiyor.",
                "settings.video_tab_text": "Video",
                speaker_view: "Aktif Konu\u015Fmac\u0131",
                toolbar_join_audio: "Sese Kat\u0131l",
                toolbar_leave: "\xC7\u0131k",
                toolbar_mute: "Sessize al",
                toolbar_muteall: "T\xfcm\xfcn\xfc Sessize Al",
                toolbar_record: "Kay\u0131t",
                toolbar_unmute: "Sesi a\xe7",
                wait_room_tip1: "{{displayName}} bu toplant\u0131 i\xE7in Bekleme Odas\u0131na girdi",
                wait_room_tip2: "{{count}} ki\u015Fi bu toplant\u0131 i\xE7in Bekleme Odas\u0131na girdi",
                "wc.ast_admin_name": "Toplant\u0131 Asistan\u0131",
                "wc.rmc_admin_name": "Toplant\u0131 Kontrol\xFC Y\xF6neticisi",
                "wc.rmc_admin_tooltip": "Bu kullan\u0131c\u0131n\u0131n oturum sahibi kontrolleri var ve herhangi bir medya i\xE7eri\u011Fine (ses, video, sohbet) eri\u015Fimi yok.",
                wc_3rd_cc_copied_api_token: "The API token has been copied to your clipboard",
                wc_3rd_cc_copy_api_token: "Copy the API token",
                wc_3rd_cc_service: "3. taraf CC hizmeti kullan",
                wc_3rd_cc_url_help_tips2: "Copy this token and paste it in a 3rd-party Closed Captioning tool",
                wc_admit: "Kabul et",
                wc_allow_to_talk: "Konu\u015Fmaya izin ver",
                wc_audio: "Ses",
                "wc_audio.muted_notification1": "Oturum sahibi sizi sessize ald\u0131",
                "wc_audio.muted_notification2": "Oturum sahibi herkesi sessize ald\u0131",
                "wc_audio.unmute_by_host_content_1": "Oturum sahibi konu\u015Fman\u0131z\u0131 istiyor",
                "wc_audio.unmute_by_host_content_2": "Sesi a\xE7arsan\u0131z, Web Seminerindeki di\u011Fer ki\u015Filer sizi duyabilecektir. Oturum sahibi veya panelistler, sesi a\xE7t\u0131ktan sonra Web Seminerini kaydetmeye, canl\u0131 yay\u0131nlamaya veya ar\u015Fivlemeye karar verirse sesiniz dahil edilecektir.",
                wc_audio_cannot_unmute: "Oturum sahibi sizi sessize ald\u0131\u011F\u0131ndan kendi sesinizi a\xE7amazs\u0131n\u0131z.",
                wc_audio_connecting_thumbnail: "Sese ba\u011Flan\u0131yor",
                wc_broadcasting: "Yay\u0131nc\u0131l\u0131k",
                wc_btn_endconf_meeting_all: "Toplant\u0131y\u0131 Herkes i\xE7in Sonland\u0131r",
                wc_camera_prevent: "Taray\u0131c\u0131n\u0131z kameran\u0131za eri\u015Fimi engelliyor. L\xFCtfen etkinle\u015Ftirin ve videonuzu yeniden ba\u015Flat\u0131n",
                "wc_cc.placeholder": "Buraya yaz\u0131n, yay\u0131nlamak i\xE7in Enter'a bas\u0131n",
                wc_cc_assign_participant_to_type: "Yazmak i\xE7in bir kat\u0131l\u0131mc\u0131 ata",
                wc_cc_assign_to: "Alt Yaz\u0131 yazmak i\xE7in ata",
                wc_cc_assign_to_type: "Yazmak i\xe7in birisini ata",
                wc_cc_broadcasting_tip: "Closed Captions are being broadcast to all participants.",
                wc_cc_host_assigned: "Oturum sahibi, sizi Alt Yaz\u0131 yazmaya atad\u0131",
                wc_cc_type_myself: "Yazaca\u011F\u0131m",
                wc_cc_withdraw: "Alt Yaz\u0131 iznini geri \xE7ek",
                "wc_chat.attendee_chat_with": "Rols\xFCz Kat\u0131l\u0131mc\u0131lar \u015Eu Ki\u015Filerle Sohbet Edebilir:",
                "wc_chat.chat": "Sohbet",
                "wc_chat.direct_message": "Do\u011Frudan Mesaj",
                "wc_chat.disable_chat": "Oturum sahibi, rols\xFCz kat\u0131l\u0131mc\u0131 sohbetini devre d\u0131\u015F\u0131 b\u0131rakt\u0131.",
                "wc_chat.disabled": "Hi\xe7 kimse",
                "wc_chat.everyone": "Herkes",
                "wc_chat.everyone_public": "Herkes halka a\xE7\u0131k",
                "wc_chat.everyone_public_private": "Herkes halka a\xE7\u0131k ve \xF6zel olarak",
                "wc_chat.host_only": "Sadece oturum sahibi",
                "wc_chat.host_panelists": "Oturum Sahipleri ve Panelistler",
                "wc_chat.me": "Ben",
                "wc_chat.panelist_chat_with": "Panelistler \u015Eu Ki\u015Filerle Sohbet Edebilir:",
                "wc_chat.type_msg": "Mesaj\u0131 buraya yaz\u0131n ...",
                wc_closed_caption_btn: "Alt Yaz\u0131",
                wc_co_host: "(Ortak oturum sahibi)",
                wc_continue: "Devam",
                wc_copied: "Kopyaland\u0131",
                wc_copied_to_clipboard: "Davet ba\u011Flant\u0131s\u0131 Panoya kopyaland\u0131",
                wc_copy_link: "Ba\u011Flant\u0131y\u0131 Kopyala",
                wc_data_center2: "Yerinde bir veri merkezine ba\u011Fland\u0131n\u0131z.",
                wc_data_center3: "Bir yerinde veri merkezi arac\u0131l\u0131\u011F\u0131yla Zoom global a\u011F\u0131na ba\u011Fland\u0131n\u0131z.",
                wc_disable_talking: "Konu\u015Fmay\u0131 devre d\u0131\u015F\u0131 b\u0131rak",
                wc_dlg_confirm: "Onay",
                wc_enable: "Etkinle\u015Ftirildi",
                wc_encryption: "\u015Eifreleme",
                wc_extra_function_disable_video: "Disable video receiving",
                wc_files: "Dosyalar",
                wc_footer_assign_leave: "Ata ve \xC7\u0131k",
                wc_footer_assign_new_host: "Yeni Oturum Sahibine Ata",
                wc_guest: "Konuk",
                wc_host_1: "Oturum Sahibi",
                wc_in_the_meeting: "Toplant\u0131da",
                wc_invite_link: "Davet Ba\u011Flant\u0131s\u0131",
                wc_join_media_preview_info_confirm: "Anlad\u0131m",
                wc_join_media_preview_warning_denied_both: "Taray\u0131c\u0131n\u0131z\u0131n adres \xE7ubu\u011Funda kamera ve mikrofon eri\u015Fimini etkinle\u015Ftirin.",
                wc_join_media_preview_warning_denied_camera: "Taray\u0131c\u0131n\u0131z\u0131n adres \xE7ubu\u011Funda kamera eri\u015Fimini etkinle\u015Ftirin.",
                wc_join_media_preview_warning_denied_mic: "Taray\u0131c\u0131n\u0131z\u0131n adres \xE7ubu\u011Funda mikrofon eri\u015Fimini etkinle\u015Ftirin.",
                wc_joining: "Kat\u0131l",
                wc_joining_meeting: "Toplant\u0131ya kat\u0131l\u0131n\u0131yor...",
                wc_learn_more: "Daha fazla bilgi edinin",
                wc_leave_computer_audio: "Bilgisayar Sesini B\u0131rak",
                wc_leave_meeting: "Toplant\u0131dan \xC7\u0131k",
                wc_leave_webinar: "Web Seminerinden \xC7\u0131k",
                wc_live_transcription_btn: "Canl\u0131 Transkripsiyon",
                wc_lock_meeting: "Toplant\u0131y\u0131 Kilitle",
                wc_lower_hand: "Parma\u011F\u0131 \u0130ndir",
                wc_lt_disable_transcription: "Otomatik D\xF6k\xFCm\xFC Devre D\u0131\u015F\u0131 B\u0131rak",
                wc_lt_enable_transcription: "Otomatik D\xF6k\xFCm\xFC Etkinle\u015Ftir",
                wc_lt_item_captioner: "(Alt Yaz\u0131 Yazan)",
                wc_lt_live_transcript: "Canl\u0131 D\xF6k\xFCm",
                wc_lt_menu_item1: "Altyaz\u0131 g\xF6ster",
                wc_lt_menu_item2: "Tam D\xf6k\xfcm\xfc G\xf6ster",
                wc_lt_menu_item3: "Altyaz\u0131y\u0131 gizle",
                wc_lt_menu_item4: "Tam D\xf6k\xfcm\xfc Kapat",
                wc_lt_request_host_ctrl: "Kat\u0131l\u0131mc\u0131lar\u0131n Canl\u0131 D\xF6k\xFCm istemelerine izin ver",
                wc_lt_search_text: "Ara",
                wc_make_co_host: "Ortak Oturum Sahibi Yap",
                wc_make_host: "Oturum Sahibi Yap",
                wc_me: "(Ben)",
                wc_more: "Di\u011Fer",
                wc_no: "Hay\u0131r",
                wc_none: "Hi\xe7biri",
                wc_not_share_pronoun: "Payla\u015Fma",
                wc_num_password: "Say\u0131sal Ge\xE7i\u015F Kodu (Telefon/Oda Sistemleri)",
                wc_participant_id: "Kat\u0131l\u0131mc\u0131",
                wc_participants: "Kat\u0131l\u0131mc\u0131lar",
                wc_pc_audio: "Bilgisayar Sesi",
                wc_prevent_access_mic: "Taray\u0131c\u0131n\u0131z mikrofonunuza eri\u015Fimi engelliyor.",
                wc_put_in_waiting: "Bekleme Odas\u0131na Al",
                "wc_qa.allQ": "T\xfcm sorular",
                "wc_qa.anonymous_attendee": "Anonim Rols\xFCz Kat\u0131l\u0131mc\u0131",
                "wc_qa.answer_private_type": "\xd6zel cevap",
                "wc_qa.answeredQ": "Cevapland\u0131r\u0131lan",
                "wc_qa.attendee_placeholder": "Oturum sahibine ve panelistlere sordu\u011Funuz sorular burada g\xF6r\xFCnecek.",
                "wc_qa.button_comment": "Yorum",
                "wc_qa.button_display_answer": "Cevap yaz",
                "wc_qa.button_live": "Canl\u0131 cevapla",
                "wc_qa.button_live_done": "Tamamland\u0131",
                "wc_qa.button_reopen": "Yeniden a\xe7",
                "wc_qa.collapse_all_answer": "T\xfcm\xfcn\xfc daralt",
                "wc_qa.dismissedQ": "Reddedildi",
                "wc_qa.display_all_answer": "T\xfcm\xfcn\xfc g\xf6ster",
                "wc_qa.dissmis_tips": "\xC7\u0131kar",
                "wc_qa.input_tips": "Sorunuzu buraya yaz\u0131n...",
                "wc_qa.is_anonymous": "Anonim olarak g\xf6nder",
                "wc_qa.is_privately": "\xd6zel olarak g\xf6nder",
                "wc_qa.live_tips_done": "Bu soru canl\u0131 olarak cevapland\u0131",
                "wc_qa.live_tips_start": "bu soruyu canl\u0131 olarak cevaplamak istiyor",
                "wc_qa.most_recent": "En Yeni",
                "wc_qa.most_upvotes": "En \xc7ok Oy Alan",
                "wc_qa.myQ": "Sorular\u0131m",
                "wc_qa.no_answered_questions": "Yan\u0131tlanm\u0131\u015F soru yok",
                "wc_qa.no_dismissed_questions": "Reddedilen soru yok",
                "wc_qa.no_open_questions": "A\xE7\u0131k soru yok",
                "wc_qa.no_questions": "Soru yok",
                "wc_qa.openedQ": "A\xe7",
                "wc_qa.panelist_host_only_placeholder": "Sorular\u0131 sadece oturum sahipleri ve panelistler g\xF6rebilir",
                "wc_qa.panelist_view_all_placehoder": "Bu web seminerindeki herkes a\xE7\u0131k sorular\u0131 g\xF6rebilir",
                "wc_qa.qa_comp_title": "Soru-Cevap",
                "wc_qa.send": "G\xf6nder",
                "wc_qa.setting_allow_view": "Rols\xFCz kat\u0131l\u0131mc\u0131lar\u0131n g\xF6rmesine izin ver",
                "wc_qa.setting_btn_name": "Ayarlar",
                "wc_qa.setting_option_allow_anony_question": "Anonim sorulara izin ver",
                "wc_qa.setting_option_allow_comment": "Rols\xFCz kat\u0131l\u0131mc\u0131lar yorum yapabilir",
                "wc_qa.setting_option_allow_view_all": "T\xfcm sorular",
                "wc_qa.setting_option_allow_view_answered": "Sadece cevaplanan sorular",
                "wc_qa.setting_option_allow_vote": "Rols\xFCz kat\u0131l\u0131mc\u0131lar oy verebilir",
                "wc_qa.welcome_banner": "\u0130sterseniz oturum sahibine ve panelistlere sorular sorabilirsiniz",
                "wc_qa.welcome_banner_title": "Ho\u015F Geldiniz",
                wc_raise_hand: "Parmak Kald\u0131r",
                wc_reclaim_host: "Oturum Sahibini Geri Al",
                wc_record_host_reminder_desc: "Devam ederseniz t\xFCm y\xFCzler, konu\u015Fmalar ve ekran payla\u015F\u0131m\u0131 buluta kaydedilecek.",
                wc_record_reminder_desc: "Toplant\u0131ya kat\u0131lmaya devam ederek, kay\u0131t alt\u0131na al\u0131nmas\u0131na izin vermi\u015F say\u0131l\u0131rs\u0131n\u0131z.",
                wc_record_reminder_desc_2: "{{accountOwner}} ve oturum sahibi Zoom Cloud kay\u0131tlar\u0131n\u0131 izleyebilir ve izni olan herhangi bir kat\u0131l\u0131mc\u0131 yerel cihazlar\u0131na kay\u0131t yapabilir. Bu ki\u015Filer, bu kay\u0131tlar\u0131 uygulamalarla ve ba\u015Fkalar\u0131yla payla\u015Fabilir.",
                wc_record_reminder_title: "Bu toplant\u0131 kaydediliyor",
                wc_record_reminder_webinar_title: "Bu Web Semineri kaydediliyor",
                wc_record_webinar_reminder_desc: "Web Seminerine kat\u0131lmaya devam ederek, kay\u0131t alt\u0131na al\u0131nmas\u0131na izin vermi\u015F say\u0131l\u0131rs\u0131n\u0131z.",
                wc_recording_pause: "Kayd\u0131 Duraklat",
                wc_recording_resume: "Kayd\u0131 Devam Ettir",
                wc_recording_stop: "Kayd\u0131 Durdur",
                wc_recording_title: "Record this meeting?",
                wc_remove: "Kald\u0131r",
                wc_select_camera: "Kamera Se\xe7",
                wc_select_microphone: "Mikrofon Se\xe7",
                wc_select_speaker: "Hoparl\xf6r Se\xe7",
                wc_share_muted_while_sharing_audio_tip2: "Bilgisayar sesini payla\u015F\u0131rken mikrofonunuz devre d\u0131\u015F\u0131 b\u0131rak\u0131l\u0131r. Ses payla\u015F\u0131m\u0131n\u0131 duraklatt\u0131\u011F\u0131n\u0131zda veya durdurdu\u011Funuzda mikrofonunuz yeniden etkinle\u015Ftirilecektir.",
                wc_share_pronoun: "Payla\u015F",
                wc_share_pronoun_menu: "Zamirlerimi Payla\u015F",
                wc_share_pronoun_tip2: "Bu toplant\u0131da zamirlerinizi payla\u015Fmak ister misiniz?",
                wc_sharer_controlbar_container_button3_label: "Payla\u015F\u0131m\u0131 Durdur",
                wc_sharer_controlbar_container_rec_status_tip1: "Ekran\u0131 payla\u015F\u0131yorsunuz",
                wc_sharer_controlbar_container_rec_status_tip2: "Ekran payla\u015F\u0131m\u0131n\u0131z duraklat\u0131ld\u0131",
                wc_sharer_disabled_share1_desc: "Oturum sahibi, rols\xFCz kat\u0131l\u0131mc\u0131 ekran payla\u015F\u0131m\u0131n\u0131 devre d\u0131\u015F\u0131 b\u0131rakt\u0131.",
                wc_sharer_disabled_share2_desc: "Di\u011Fer kat\u0131l\u0131mc\u0131 payla\u015F\u0131mda bulunurken ekran payla\u015F\u0131m\u0131n\u0131 ba\u015Flatamazs\u0131n\u0131z.",
                wc_sharer_entry_button_label1: "Ekran\u0131 Payla\u015F",
                wc_sharer_setting_menu_category1_title: "Kimler payla\u015Fabilir?",
                wc_sharer_setting_menu_category2_title: "Ba\u015Fkas\u0131 payla\u015F\u0131mda bulunurken kimler payla\u015Fmaya ba\u015Flayabilir?",
                wc_sharer_setting_menu_category3_title: "Ayn\u0131 anda ka\xE7 kat\u0131l\u0131mc\u0131 payla\u015F\u0131mda bulunabilir?",
                wc_sharer_setting_menu_category_option1: "Sadece Oturum Sahibi",
                wc_sharer_setting_menu_category_option2: "T\xFCm Kat\u0131l\u0131mc\u0131lar",
                wc_sharer_setting_menu_item1: "Ayn\u0131 anda bir kat\u0131l\u0131mc\u0131 payla\u015F\u0131mda bulunabilir",
                wc_sharer_setting_menu_item2: "Ayn\u0131 anda birden fazla kat\u0131l\u0131mc\u0131 payla\u015F\u0131mda bulunabilir",
                wc_sharing_fit_to_window: "Pencereye S\u0131\u011Fd\u0131r",
                wc_sharing_original_size: "Orijinal Boyut",
                wc_sharing_shared_screens: "Payla\u015F\u0131lan Ekranlar",
                wc_sharing_view_options: "Se\xe7enekleri G\xf6ster",
                wc_sharing_viewing: "{{displayName}}'in ekran\u0131n\u0131 g\xF6r\xFCnt\xFCl\xFCyorsunuz",
                wc_tel_password: "Parola",
                wc_unmute_by_host_btn1: "Sessizde kalmaya devam et",
                wc_unshare_pronoun_menu: "Zamirlerimi Payla\u015Fma",
                "wc_video.allow_panelist_start_video": "Panelistlerin video ba\u015Flatmas\u0131na izin ver",
                "wc_video.allow_participants_start_video": "Kat\u0131l\u0131mc\u0131lar\u0131n video ba\u015Flatmas\u0131na izin ver",
                "wc_video.ask_start_video": "Videonun Ba\u015Flat\u0131lmas\u0131n\u0131 \u0130ste",
                "wc_video.model_stop": "Oturum sahibi taraf\u0131ndan durduruldu\u011Fundan videonuzu ba\u015Flatamazs\u0131n\u0131z",
                "wc_video.start_video": "Video Ba\u015Flat",
                "wc_video.stop_video": "Videoyu Durdur",
                "wc_video.video": "Video",
                wc_view: "G\xf6r\xfcnt\xfcle",
                wc_waiting_room: "Bekleme Odas\u0131",
                "wc_webinar.change_to_attendee": "Rol\xFC Rols\xFCz Kat\u0131l\u0131mc\u0131 Olarak De\u011Fi\u015Ftir",
                "wc_webinar.promote_to_panelist": "Panelist olarak y\xfckselt",
                wc_webinar_attendees: "Kat\u0131l\u0131mc\u0131lar",
                wc_webinar_panelists: "Panelistler",
                wc_webinar_putonhold: "Beklemeye al",
                wc_withdraw_co_host: "Ortak Oturum Sahibi \u0130znini Geri \xC7ek",
                wc_yes: "Evet",
                websdk_enforce_update_content: "Uygulaman\u0131z\u0131n s\xFCr\xFCm\xFCn\xFCz\xFCn bu toplant\u0131ya kat\u0131lmak i\xE7in {0} veya daha y\xFCksek olmas\u0131 gerekir. L\xFCtfen devam etmek i\xE7in g\xFCncelleyin.",
                websdk_update_content: "Toplant\u0131 deneyimini optimize etmek i\xE7in WebDK'\u0131 en son s\xFCr\xFCme g\xFCncelleyin"
              }
            }
          };
          Pz.use(hM).init({
            resources: PM,
            lng: "en-US",
            fallbackLng: "en-US",
            interpolation: {
              escapeValue: !1
            }
          });
          var jM = a.default.createContext({
            meetingNumber: 0,
            userId: 0,
            isWebinar: !1,
            isHost: !1,
            isAttendee: !1,
            isOriginHost: !1,
            isCoHost: !1,
            isOnHold: !1,
            isReceiveSharing: !1,
            isStartedVideo: !1,
            isStartedShare: !1,
            isSharePaused: !1,
            isShareAudioMuted: !1,
            isScreenSharingWithAudio: !1,
            isSupportMultipleVideos: !1,
            activeShareId: 0,
            participants: [],
            assistants: [],
            attendees: [],
            onHoldParticipants: [],
            isMuted: !1,
            isStartedAudio: !1,
            status: jj.Closed,
            isDisableReceivingVideo: !1,
            recordingStatus: zj.Stopped,
            isLocalRecording: !1,
            ccStatus: {
              liveTranscriptionStatus: "",
              isLTEnable: !1,
              isCCEnable: !1,
              allowRequestLt: !1,
              askingStartLt: !1,
              isListenClosedCaption: !1,
              isMeetingEnableClosedCaption: !1,
              isMeetingEnableAllowThirdPartyCCToken: !1,
              isMeetingEnabledLiveTranscriptionFeature: !1,
              isMeetingEnableViewFullTranscript: !1
            },
            meetingOptions: {
              isCOHostEnabled: !0,
              allowStopAutoRecording: !0,
              recordingEnable: !0,
              isEnableCustomizeInviteUrl: !1,
              isEnableBreakoutRoom: !1,
              isChatEnabled: !0
            },
            meetingInfo: {},
            activeAppsInfo: void 0,
            promoteConsent: {
              reqId: void 0,
              senderId: void 0
            },
            isLockedMeeting: !1,
            isEnableWaitingRoom: !1,
            isEnableShare: !0,
            isEnableChat: !0,
            isEnableStartVideo: !0,
            isAllowToTalk: !1,
            hasPreconsented: !1,
            archivingStatus: void 0,
            archivingSessionReady: void 0,
            archivingOptions: void 0,
            isEnableQA: !1,
            isSupportVideoEncodeHardwareAcceleration: !1,
            isSupportVideoDecodeHardwareAcceleration: !1,
            userSubscribeQos: {
              audio: !1,
              video: !1
            }
          }),
              DM = a.default.createContext({
            audio: {
              encode: !1,
              decode: !1
            },
            video: {
              encode: !1,
              decode: !1
            },
            share: {
              encode: !1,
              decode: !1
            },
            stream: void 0
          }),
              zM = a.default.createContext(null);
          var MM;
          !function (e) {
            e.Thumbnail = "thumbnail", e.Speaker = "speaker", e.Ribbon = "ribbon", e.Gallery = "gallery";
          }(MM || (MM = {}));

          var LM = {
            Width: 240,
            Height: {
              One: 135,
              Two: 274,
              Three: 411,
              FourPlus: 547
            },
            MaxHeight: 720
          },
              UM = {
            Width: 240,
            Height: 135,
            MaxWidth: 1440,
            MaxHeight: 810
          },
              BM = {
            Width: 720,
            Height: 411,
            LargeWidth: 1200,
            LargeHeight: 685,
            MaxWidth: 1440,
            MaxHeight: 822
          },
              HM = {
            Width: 240,
            Height: 411,
            MaxWidth: 480,
            MaxHeight: 822
          },
              VM = function VM(e) {
            switch (e) {
              case MM.Ribbon:
                return LM;

              case MM.Gallery:
                return BM;

              case MM.Speaker:
                return UM;

              default:
                return HM;
            }
          },
              qM = function qM(e) {
            switch (e) {
              case 1:
                return "One";

              case 2:
                return "Two";

              case 3:
                return "Three";

              default:
                return "FourPlus";
            }
          },
              FM = "ZOOM_WEB_SDK_SHARER_CANVAS",
              WM = "ZOOM_WEB_SDK_SELF_VIDEO";

          var GM, KM, QM;
          !function (e) {
            e[e.HostGrab = 0] = "HostGrab", e[e.OnlyHost = 1] = "OnlyHost", e[e.AnyoneGrab = 2] = "AnyoneGrab", e[e.MultipleShare = 3] = "MultipleShare";
          }(GM || (GM = {})), function (e) {
            e.Active = "Active", e.Inactive = "Inactive";
          }(KM || (KM = {})), function (e) {
            e[e.Video_90P = 0] = "Video_90P", e[e.Video_180P = 1] = "Video_180P", e[e.Video_360P = 2] = "Video_360P", e[e.Video_720P = 3] = "Video_720P";
          }(QM || (QM = {}));
          var ZM = [{
            id: "blur",
            displayName: "blur",
            fileName: "blur.png"
          }, {
            id: "background0",
            displayName: "SanFrancisco",
            fileName: "SanFrancisco.jpg"
          }, {
            id: "background1",
            displayName: "grass",
            fileName: "grass.jpg"
          }, {
            id: "background2",
            displayName: "earth",
            fileName: "earth.jpg"
          }];
          var YM;
          !function (e) {
            e.Loading = "loading", e.Success = "success", e.Fail = "fail", e.Unknow = "unknow";
          }(YM || (YM = {}));
          var JM = a.default.createContext({
            isShowParticipant: !1,
            isShowChat: !1,
            isShowMeetingInfo: !1,
            isShowActiveAppsNotifier: !1,
            isShowLeaveBox: !1,
            isShowAssignHost: !1,
            participantSize: 0,
            isShowSetting: !1,
            activeChatUserId: -1,
            isShowAudioWarning: !1,
            isShowVideoWarning: !1,
            isShowRecording: !1,
            isShowRecordingAlert: !1,
            hasShowRecordingAlert: !1,
            isShowPanelistConsent: !1,
            isShowCC: {
              history: !1,
              input: !1,
              toast: !1,
              setting: !1,
              getty: !1
            },
            viewType: MM.Speaker,
            isShowPromoteConsent: !1,
            numUnreadChat: 0,
            chatMessage: {
              id: "",
              message: "",
              receiver: {
                name: "",
                userId: 0
              },
              sender: {
                avatar: "",
                name: "",
                userId: ""
              },
              timestamp: new Date().getTime()
            },
            isShowChatNotification: !1,
            videoContainerDimensions: {
              width: UM.Width,
              height: UM.Height
            },
            customization: {},
            isShowUnmuteConsent: !1,
            isMirrorVideo: !1,
            virtualBackgroundImageId: "",
            isSupportVB: !0,
            virtualBackgroundImageList: [],
            virtualBackgroundPreloadState: YM.Loading,
            isShowSharePronounNotification: !1,
            isShowQAPanel: !1,
            numOpenQuestions: 0,
            isEnableHardwareAcclerationReceiving: !1,
            isEnableHardwareAcclerationSending: !1,
            isStartedHardwareAccleration: !1,
            maximumVideosInGalleryView: 9,
            isSortMostUpVote: !1
          }),
              $M = a.default.createContext({});

          function XM(e) {
            for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function (e) {
              return "'" + e + "'";
            }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
          }

          function eL(e) {
            return !!e && !!e[UL];
          }

          function tL(e) {
            return !!e && (function (e) {
              if (!e || "object" != typeof e) return !1;
              var t = Object.getPrototypeOf(e);
              if (null === t) return !0;
              var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
              return n === Object || "function" == typeof n && Function.toString.call(n) === BL;
            }(e) || Array.isArray(e) || !!e[LL] || !!e.constructor[LL] || aL(e) || sL(e));
          }

          function nL(e, t, n) {
            void 0 === n && (n = !1), 0 === rL(e) ? (n ? Object.keys : HL)(e).forEach(function (r) {
              n && "symbol" == typeof r || t(r, e[r], e);
            }) : e.forEach(function (n, r) {
              return t(r, n, e);
            });
          }

          function rL(e) {
            var t = e[UL];
            return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : aL(e) ? 2 : sL(e) ? 3 : 0;
          }

          function iL(e, t) {
            return 2 === rL(e) ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
          }

          function oL(e, t, n) {
            var r = rL(e);
            2 === r ? e.set(t, n) : 3 === r ? (e.delete(t), e.add(n)) : e[t] = n;
          }

          function aL(e) {
            return jL && e instanceof Map;
          }

          function sL(e) {
            return DL && e instanceof Set;
          }

          function cL(e) {
            return e.o || e.t;
          }

          function lL(e) {
            if (Array.isArray(e)) return Array.prototype.slice.call(e);
            var t = VL(e);
            delete t[UL];

            for (var n = HL(t), r = 0; r < n.length; r++) {
              var i = n[r],
                  o = t[i];
              !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: e[i]
              });
            }

            return Object.create(Object.getPrototypeOf(e), t);
          }

          function dL(e, t) {
            return void 0 === t && (t = !1), pL(e) || eL(e) || !tL(e) || (rL(e) > 1 && (e.set = e.add = e.clear = e.delete = uL), Object.freeze(e), t && nL(e, function (e, t) {
              return dL(t, !0);
            }, !0)), e;
          }

          function uL() {
            XM(2);
          }

          function pL(e) {
            return null == e || "object" != typeof e || Object.isFrozen(e);
          }

          function hL(e) {
            var t = qL[e];
            return t || XM(18, e), t;
          }

          function _L() {
            return NL;
          }

          function fL(e, t) {
            t && (hL("Patches"), e.u = [], e.s = [], e.v = t);
          }

          function mL(e) {
            gL(e), e.p.forEach(bL), e.p = null;
          }

          function gL(e) {
            e === NL && (NL = e.l);
          }

          function vL(e) {
            return NL = {
              p: [],
              l: NL,
              h: e,
              m: !0,
              _: 0
            };
          }

          function bL(e) {
            var t = e[UL];
            0 === t.i || 1 === t.i ? t.j() : t.O = !0;
          }

          function yL(e, t) {
            t._ = t.p.length;
            var n = t.p[0],
                r = void 0 !== e && e !== n;
            return t.h.g || hL("ES5").S(t, e, r), r ? (n[UL].P && (mL(t), XM(4)), tL(e) && (e = wL(t, e), t.l || xL(t, e)), t.u && hL("Patches").M(n[UL].t, e, t.u, t.s)) : e = wL(t, n, []), mL(t), t.u && t.v(t.u, t.s), e !== ML ? e : void 0;
          }

          function wL(e, t, n) {
            if (pL(t)) return t;
            var r = t[UL];
            if (!r) return nL(t, function (i, o) {
              return SL(e, r, t, i, o, n);
            }, !0), t;
            if (r.A !== e) return t;
            if (!r.P) return xL(e, r.t, !0), r.t;

            if (!r.I) {
              r.I = !0, r.A._--;
              var i = 4 === r.i || 5 === r.i ? r.o = lL(r.k) : r.o;
              nL(3 === r.i ? new Set(i) : i, function (t, o) {
                return SL(e, r, i, t, o, n);
              }), xL(e, i, !1), n && e.u && hL("Patches").R(r, n, e.u, e.s);
            }

            return r.o;
          }

          function SL(e, t, n, r, i, o) {
            if (eL(i)) {
              var a = wL(e, i, o && t && 3 !== t.i && !iL(t.D, r) ? o.concat(r) : void 0);
              if (oL(n, r, a), !eL(a)) return;
              e.m = !1;
            }

            if (tL(i) && !pL(i)) {
              if (!e.h.F && e._ < 1) return;
              wL(e, i), t && t.A.l || xL(e, i);
            }
          }

          function xL(e, t, n) {
            void 0 === n && (n = !1), e.h.F && e.m && dL(t, n);
          }

          function EL(e, t) {
            var n = e[UL];
            return (n ? cL(n) : e)[t];
          }

          function CL(e, t) {
            if (t in e) for (var n = Object.getPrototypeOf(e); n;) {
              var r = Object.getOwnPropertyDescriptor(n, t);
              if (r) return r;
              n = Object.getPrototypeOf(n);
            }
          }

          function kL(e) {
            e.P || (e.P = !0, e.l && kL(e.l));
          }

          function AL(e) {
            e.o || (e.o = lL(e.t));
          }

          function IL(e, t, n) {
            var r = aL(t) ? hL("MapSet").N(t, n) : sL(t) ? hL("MapSet").T(t, n) : e.g ? function (e, t) {
              var n = Array.isArray(e),
                  r = {
                i: n ? 1 : 0,
                A: t ? t.A : _L(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: e,
                k: null,
                o: null,
                j: null,
                C: !1
              },
                  i = r,
                  o = FL;
              n && (i = [r], o = WL);
              var a = Proxy.revocable(i, o),
                  s = a.revoke,
                  c = a.proxy;
              return r.k = c, r.j = s, c;
            }(t, n) : hL("ES5").J(t, n);
            return (n ? n.A : _L()).p.push(r), r;
          }

          function TL(e) {
            return eL(e) || XM(22, e), function e(t) {
              if (!tL(t)) return t;
              var n,
                  r = t[UL],
                  i = rL(t);

              if (r) {
                if (!r.P && (r.i < 4 || !hL("ES5").K(r))) return r.t;
                r.I = !0, n = OL(t, i), r.I = !1;
              } else n = OL(t, i);

              return nL(n, function (t, i) {
                r && function (e, t) {
                  return 2 === rL(e) ? e.get(t) : e[t];
                }(r.t, t) === i || oL(n, t, e(i));
              }), 3 === i ? new Set(n) : n;
            }(e);
          }

          function OL(e, t) {
            switch (t) {
              case 2:
                return new Map(e);

              case 3:
                return Array.from(e);
            }

            return lL(e);
          }

          var RL,
              NL,
              PL = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
              jL = "undefined" != typeof Map,
              DL = "undefined" != typeof Set,
              zL = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
              ML = PL ? Symbol.for("immer-nothing") : ((RL = {})["immer-nothing"] = !0, RL),
              LL = PL ? Symbol.for("immer-draftable") : "__$immer_draftable",
              UL = PL ? Symbol.for("immer-state") : "__$immer_state",
              BL = "" + Object.prototype.constructor,
              HL = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (e) {
            return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
          } : Object.getOwnPropertyNames,
              VL = Object.getOwnPropertyDescriptors || function (e) {
            var t = {};
            return HL(e).forEach(function (n) {
              t[n] = Object.getOwnPropertyDescriptor(e, n);
            }), t;
          },
              qL = {},
              FL = {
            get: function get(e, t) {
              if (t === UL) return e;
              var n = cL(e);
              if (!iL(n, t)) return function (e, t, n) {
                var r,
                    i = CL(t, n);
                return i ? "value" in i ? i.value : null === (r = i.get) || void 0 === r ? void 0 : r.call(e.k) : void 0;
              }(e, n, t);
              var r = n[t];
              return e.I || !tL(r) ? r : r === EL(e.t, t) ? (AL(e), e.o[t] = IL(e.A.h, r, e)) : r;
            },
            has: function has(e, t) {
              return t in cL(e);
            },
            ownKeys: function ownKeys(e) {
              return Reflect.ownKeys(cL(e));
            },
            set: function set(e, t, n) {
              var r = CL(cL(e), t);
              if (null == r ? void 0 : r.set) return r.set.call(e.k, n), !0;

              if (!e.P) {
                var i = EL(cL(e), t),
                    o = null == i ? void 0 : i[UL];
                if (o && o.t === n) return e.o[t] = n, e.D[t] = !1, !0;
                if (function (e, t) {
                  return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
                }(n, i) && (void 0 !== n || iL(e.t, t))) return !0;
                AL(e), kL(e);
              }

              return e.o[t] === n && "number" != typeof n && (void 0 !== n || t in e.o) || (e.o[t] = n, e.D[t] = !0, !0);
            },
            deleteProperty: function deleteProperty(e, t) {
              return void 0 !== EL(e.t, t) || t in e.t ? (e.D[t] = !1, AL(e), kL(e)) : delete e.D[t], e.o && delete e.o[t], !0;
            },
            getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
              var n = cL(e),
                  r = Reflect.getOwnPropertyDescriptor(n, t);
              return r ? {
                writable: !0,
                configurable: 1 !== e.i || "length" !== t,
                enumerable: r.enumerable,
                value: n[t]
              } : r;
            },
            defineProperty: function defineProperty() {
              XM(11);
            },
            getPrototypeOf: function getPrototypeOf(e) {
              return Object.getPrototypeOf(e.t);
            },
            setPrototypeOf: function setPrototypeOf() {
              XM(12);
            }
          },
              WL = {};

          nL(FL, function (e, t) {
            WL[e] = function () {
              return arguments[0] = arguments[0][0], t.apply(this, arguments);
            };
          }), WL.deleteProperty = function (e, t) {
            return WL.set.call(this, e, t, void 0);
          }, WL.set = function (e, t, n) {
            return FL.set.call(this, e[0], t, n, e[0]);
          };

          var GL = function () {
            function e(e) {
              var t = this;
              this.g = zL, this.F = !0, this.produce = function (e, n, r) {
                if ("function" == typeof e && "function" != typeof n) {
                  var i = n;
                  n = e;
                  var o = t;
                  return function (e) {
                    var t = this;
                    void 0 === e && (e = i);

                    for (var r = arguments.length, a = Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++) {
                      a[s - 1] = arguments[s];
                    }

                    return o.produce(e, function (e) {
                      var r;
                      return (r = n).call.apply(r, [t, e].concat(a));
                    });
                  };
                }

                var a;

                if ("function" != typeof n && XM(6), void 0 !== r && "function" != typeof r && XM(7), tL(e)) {
                  var s = vL(t),
                      c = IL(t, e, void 0),
                      l = !0;

                  try {
                    a = n(c), l = !1;
                  } finally {
                    l ? mL(s) : gL(s);
                  }

                  return "undefined" != typeof Promise && a instanceof Promise ? a.then(function (e) {
                    return fL(s, r), yL(e, s);
                  }, function (e) {
                    throw mL(s), e;
                  }) : (fL(s, r), yL(a, s));
                }

                if (!e || "object" != typeof e) {
                  if (void 0 === (a = n(e)) && (a = e), a === ML && (a = void 0), t.F && dL(a, !0), r) {
                    var d = [],
                        u = [];
                    hL("Patches").M(e, a, d, u), r(d, u);
                  }

                  return a;
                }

                XM(21, e);
              }, this.produceWithPatches = function (e, n) {
                if ("function" == typeof e) return function (n) {
                  for (var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
                    i[o - 1] = arguments[o];
                  }

                  return t.produceWithPatches(n, function (t) {
                    return e.apply(void 0, [t].concat(i));
                  });
                };
                var r,
                    i,
                    o = t.produce(e, n, function (e, t) {
                  r = e, i = t;
                });
                return "undefined" != typeof Promise && o instanceof Promise ? o.then(function (e) {
                  return [e, r, i];
                }) : [o, r, i];
              }, "boolean" == typeof (null == e ? void 0 : e.useProxies) && this.setUseProxies(e.useProxies), "boolean" == typeof (null == e ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze);
            }

            var t = e.prototype;
            return t.createDraft = function (e) {
              tL(e) || XM(8), eL(e) && (e = TL(e));
              var t = vL(this),
                  n = IL(this, e, void 0);
              return n[UL].C = !0, gL(t), n;
            }, t.finishDraft = function (e, t) {
              var n = (e && e[UL]).A;
              return fL(n, t), yL(void 0, n);
            }, t.setAutoFreeze = function (e) {
              this.F = e;
            }, t.setUseProxies = function (e) {
              e && !zL && XM(20), this.g = e;
            }, t.applyPatches = function (e, t) {
              var n;

              for (n = t.length - 1; n >= 0; n--) {
                var r = t[n];

                if (0 === r.path.length && "replace" === r.op) {
                  e = r.value;
                  break;
                }
              }

              n > -1 && (t = t.slice(n + 1));
              var i = hL("Patches").$;
              return eL(e) ? i(e, t) : this.produce(e, function (e) {
                return i(e, t);
              });
            }, e;
          }(),
              KL = new GL(),
              QL = KL.produce;

          KL.produceWithPatches.bind(KL), KL.setAutoFreeze.bind(KL), KL.setUseProxies.bind(KL), KL.applyPatches.bind(KL), KL.createDraft.bind(KL), KL.finishDraft.bind(KL);
          var ZL = QL;

          var YL = "SET_MEETING_STATUS",
              JL = "SET_MEETING_OPTIONS",
              $L = "SET_IS_WEBINAR",
              XL = "SET_IS_ORIGIN_HOST",
              eU = "SET_MEETING_IS_ON_HOLD",
              tU = "SET_MEETING_IS_HOST",
              nU = "SET_MEETING_IS_CO_HOST",
              rU = "SET_MEETING_IS_ATTENDEE",
              iU = "SET_MEETING_NUMBER",
              oU = "SET_MEETING_USER_ID",
              aU = "SET_PARTICIPANTS",
              sU = "SET_ASSISTANTS",
              cU = "SET_ATTENDEES",
              lU = "SET_IS_RECEIVE_SHARING",
              dU = "SET_IS_STARTED_VIDEO",
              uU = "SET_IS_STARTED_SHARE",
              pU = "SET_ACTIVE_SHARE_ID",
              hU = "SET_IS_SHARE_PAUSED",
              _U = "SET_IS_SHARE_AUDIO_MUTED",
              fU = "SET_IS_SUPPORT_MULTIPLE_VIDEOS",
              mU = "SET_RECORDING_STATUS",
              gU = "SET_IS_LOCAL_RECORDING",
              vU = "SET_CC_STATUS",
              bU = "SET_IS_DISABLE_RECEIVING_VIDEO",
              yU = "SET_IS_STARTED_AUDIO",
              wU = "SET_IS_MUTED",
              SU = "SET_ACTIVE_APPS_INFO",
              xU = "RESET_MEETING",
              EU = "RESET_MEDIA",
              CU = "SET_MEETING_INFO",
              kU = "SET_PROMOTE_CONSENT",
              AU = "SET_IS_LOCK_MEETING",
              IU = "SET_IS_ENABLE_WATING_ROOM",
              TU = "SET_IS_ENABLE_SHARE",
              OU = "SET_IS_ENABLE_CHAT",
              RU = "SET_IS_ENABLE_START_VIDEO",
              NU = "SET_IS_ALLOW_TO_TALK",
              PU = "SET_IS_SCREEN_SHARING_WITH_AUDIO",
              jU = "SET_ARCHIVING_STATUS",
              DU = "SET_ARCHIVING_SESSION_READY",
              zU = "SET_ARCHIVING_OPTIONS",
              MU = "SET_IS_ENABLE_QA",
              LU = "SET_IS_SUPPORT_VIDEO_ENCODE_HARDWARE_ACCELERATION",
              UU = "SET_IS_SUPPORT_VIDEO_DECODE_HARDWARE_ACCELERATION",
              BU = function BU(e) {
            return {
              type: YL,
              payload: e
            };
          },
              HU = function HU(e) {
            return {
              type: JL,
              payload: e
            };
          },
              VU = function VU(e) {
            return {
              type: pU,
              payload: e
            };
          },
              qU = function qU(e) {
            return {
              type: _U,
              payload: e
            };
          },
              FU = function FU(e) {
            return {
              type: mU,
              payload: e
            };
          },
              WU = function WU(e) {
            return {
              type: vU,
              payload: e
            };
          },
              GU = function GU(e) {
            return {
              type: kU,
              payload: e
            };
          },
              KU = function KU(e) {
            return {
              type: AU,
              payload: e
            };
          },
              QU = function QU(e) {
            return {
              type: IU,
              payload: e
            };
          },
              ZU = function ZU(e) {
            return {
              type: TU,
              payload: e
            };
          },
              YU = function YU(e) {
            return {
              type: OU,
              payload: e
            };
          },
              JU = function JU(e) {
            return {
              type: RU,
              payload: e
            };
          },
              $U = function $U(e) {
            return {
              type: NU,
              payload: e
            };
          },
              XU = function XU(e) {
            return {
              type: PU,
              payload: e
            };
          },
              eB = "SET_VIDEO_CONTAINER_DIMENSIONS",
              tB = "SET_IS_SHOW_PARTICIPANT_PANEL",
              nB = "SET_IS_SHOW_CHAT_PANEL",
              rB = "SET_PARTICIPANT_SIZE",
              iB = "SET_IS_SHOW_MEETING_INFO_PANEL",
              oB = "SET_IS_SHOW_ACTIVE_APP_NOTIFIER",
              aB = "SET_IS_SHOW_ASSIGN_HOST",
              sB = "SET_IS_SHOW_LEAVE_BOX",
              cB = "SET_IS_SHOW_SETTING",
              lB = "SET_IS_SHOW_RECORDING",
              dB = "SET_ACTIVE_CHAT_USER_ID",
              uB = "SET_IS_SHOW_AUDIO_WARNING",
              pB = "SET_IS_SHOW_VIDEO_WARNING",
              hB = "RESET_MEETING_UI",
              _B = "SET_CC",
              fB = "SET_IS_SHOW_RECORDING_ALERT",
              mB = "SET_HAS_SHOW_RECORDING_ALERT",
              gB = "SET_VIEW_TYPE",
              vB = "IS_SHOW_PROMOTE_CONSENT",
              bB = "SET_NUM_UNREAD_CHAT",
              yB = "SET_CHAT_MESSAGE",
              wB = "SET_IS_SHOW_CHAT_NOTIFICATION",
              SB = "SET_CUSTOMIZATION",
              xB = "SET_IS_SHOW_UNMUTE_CONSENT",
              EB = "SET_IS_MIRROR_VIDEO",
              CB = "SET_VIRTUAL_BACKGROUND_IMAGE_ID",
              kB = "SET_IS_SUPPORT_VB",
              AB = "SET_VIRTUAL_BACKGROUND_IMAGE_LIST",
              IB = "SET_VIRTUAL_BACKGROUND_PRELOAD_STATE",
              TB = "SET_IS_SHOW_SHARE_PRONOUN_NOTIFICATION",
              OB = "SET_IS_SHOW_QA_PANEL",
              RB = "SET_NUM_OPEN_QUESTIONS",
              NB = "SET_IS_ENABLE_HARDWARE_ACCLERATION_RECEIVING",
              PB = "SET_IS_ENABLE_HARDWARE_ACCLERATION_SENDING",
              jB = "SET_IS_STARTED_HARDWARE_ACCLERATION",
              DB = "SET_MAXIMUM_VIDEOS_IN_GALLERY_VIEW",
              zB = "SET_IS_SORT_MOST_UP_VOTE",
              MB = function MB(e) {
            return {
              type: tB,
              payload: e
            };
          },
              LB = function LB(e) {
            return {
              type: nB,
              payload: e
            };
          },
              UB = function UB(e) {
            return {
              type: iB,
              payload: e
            };
          },
              BB = function BB(e) {
            return {
              type: aB,
              payload: e
            };
          },
              HB = function HB(e) {
            return {
              type: sB,
              payload: e
            };
          },
              VB = function VB(e) {
            return {
              type: cB,
              payload: e
            };
          },
              qB = function qB(e) {
            return {
              type: dB,
              payload: e
            };
          },
              FB = function FB(e) {
            return {
              type: uB,
              payload: e
            };
          },
              WB = function WB(e) {
            return {
              type: pB,
              payload: e
            };
          },
              GB = function GB(e) {
            return {
              type: _B,
              payload: {
                setting: e
              }
            };
          },
              KB = function KB(e) {
            return {
              type: _B,
              payload: {
                input: e
              }
            };
          },
              QB = function QB(e) {
            return {
              type: _B,
              payload: {
                history: e
              }
            };
          },
              ZB = function ZB(e) {
            return {
              type: _B,
              payload: {
                toast: e
              }
            };
          },
              YB = function YB(e) {
            return {
              type: fB,
              payload: e
            };
          },
              JB = function JB(e) {
            return {
              type: _B,
              payload: {
                getty: e
              }
            };
          },
              $B = function $B(e) {
            return {
              type: vB,
              payload: e
            };
          },
              XB = function XB(e) {
            return {
              type: bB,
              payload: e
            };
          },
              eH = function eH(e) {
            return {
              type: wB,
              payload: e
            };
          },
              tH = function tH(e) {
            return {
              type: eB,
              payload: e
            };
          },
              nH = function nH(e) {
            return {
              type: xB,
              payload: e
            };
          },
              rH = function rH(e) {
            return {
              type: IB,
              payload: e
            };
          },
              iH = function iH(e) {
            return {
              type: TB,
              payload: e
            };
          },
              oH = function oH(e) {
            return {
              type: OB,
              payload: e
            };
          },
              aH = function aH(e) {
            return {
              type: NB,
              payload: e
            };
          },
              sH = function sH(e) {
            return {
              type: PB,
              payload: e
            };
          },
              cH = function cH(e) {
            return {
              type: zB,
              payload: e
            };
          },
              lH = {
            audio: {
              encode: !1,
              decode: !1
            },
            video: {
              encode: !1,
              decode: !1
            },
            share: {
              encode: !1,
              decode: !1
            }
          },
              dH = ZL(function (e, t) {
            switch (t.type) {
              case "audio-encode":
                e.audio.encode = t.payload;
                break;

              case "audio-decode":
                e.audio.decode = t.payload;
                break;

              case "video-encode":
                e.video.encode = t.payload;
                break;

              case "video-decode":
                e.video.decode = t.payload;
                break;

              case "share-encode":
                e.share.encode = t.payload;
                break;

              case "share-decode":
                e.share.decode = t.payload;
                break;

              case EU:
                return lH;
            }

            return e;
          }, lH),
              uH = {
            userId: 0,
            status: jj.Closed,
            isWebinar: !1,
            isHost: !1,
            isAttendee: !1,
            isOriginHost: !1,
            isCoHost: !1,
            isOnHold: !1,
            isReceiveSharing: !1,
            isStartedAudio: !1,
            isStartedVideo: !1,
            isStartedShare: !1,
            isSharePaused: !1,
            isShareAudioMuted: !1,
            isMuted: !0,
            isSupportMultipleVideos: !1,
            isDisableReceivingVideo: !1,
            activeShareId: 0,
            meetingNumber: 0,
            participants: [],
            assistants: [],
            attendees: [],
            onHoldParticipants: [],
            recordingStatus: zj.Stopped,
            isLocalRecording: !1,
            ccStatus: {
              liveTranscriptionStatus: "",
              isLTEnable: !1,
              isCCEnable: !1,
              allowRequestLt: !1,
              askingStartLt: !1,
              isListenClosedCaption: !1,
              isMeetingEnableClosedCaption: !1,
              isMeetingEnableAllowThirdPartyCCToken: !1,
              isMeetingEnabledLiveTranscriptionFeature: !1,
              isMeetingEnableViewFullTranscript: !1
            },
            meetingOptions: {
              isCOHostEnabled: !0,
              allowStopAutoRecording: !0,
              recordingEnable: !0,
              isEnableCustomizeInviteUrl: !1,
              isEnableBreakoutRoom: !1,
              isChatEnabled: !0
            },
            meetingInfo: {},
            activeAppsInfo: void 0,
            promoteConsent: {
              reqId: void 0,
              senderId: void 0
            },
            isLockedMeeting: !1,
            isEnableWaitingRoom: !1,
            isEnableShare: !0,
            isEnableChat: !0,
            isEnableStartVideo: !0,
            isAllowToTalk: !1,
            isScreenSharingWithAudio: !1,
            hasPreconsented: !1,
            archivingStatus: void 0,
            archivingSessionReady: void 0,
            archivingOptions: void 0,
            isEnableQA: !1,
            isSupportVideoEncodeHardwareAcceleration: !1,
            isSupportVideoDecodeHardwareAcceleration: !1,
            userSubscribeQos: {
              audio: !1,
              video: !1
            }
          },
              pH = ZL(function (e, t) {
            switch (t.type) {
              case YL:
                e.status = t.payload;
                break;

              case JL:
                e.meetingOptions = t.payload;
                break;

              case CU:
                e.meetingInfo = t.payload;
                break;

              case eU:
                e.isOnHold = t.payload;
                break;

              case tU:
                e.isHost = t.payload;
                break;

              case $L:
                e.isWebinar = t.payload;
                break;

              case XL:
                e.isOriginHost = t.payload;
                break;

              case nU:
                e.isCoHost = t.payload;
                break;

              case rU:
                e.isAttendee = t.payload;
                break;

              case "SET_MEETING_CURRENT_USER":
                e.currentUser = t.payload;
                break;

              case iU:
                e.meetingNumber = t.payload;
                break;

              case oU:
                e.userId = t.payload;
                break;

              case aU:
                e.participants = t.payload.participants, e.onHoldParticipants = t.payload.onHoldParticipants;
                break;

              case sU:
                e.assistants = t.payload;
                break;

              case cU:
                e.attendees = t.payload;
                break;

              case lU:
                e.isReceiveSharing = t.payload;
                break;

              case dU:
                e.isStartedVideo = t.payload;
                break;

              case uU:
                e.isStartedShare = t.payload;
                break;

              case hU:
                e.isSharePaused = t.payload;
                break;

              case _U:
                e.isShareAudioMuted = t.payload;
                break;

              case pU:
                e.activeShareId = t.payload;
                break;

              case fU:
                e.isSupportMultipleVideos = t.payload;
                break;

              case mU:
                e.recordingStatus = t.payload;
                break;

              case gU:
                e.isLocalRecording = t.payload;
                break;

              case vU:
                e.ccStatus = t.payload;
                break;

              case bU:
                e.isDisableReceivingVideo = t.payload;
                break;

              case yU:
                e.isStartedAudio = t.payload;
                break;

              case wU:
                e.isMuted = t.payload;
                break;

              case SU:
                e.activeAppsInfo = t.payload;
                break;

              case kU:
                e.promoteConsent = t.payload;
                break;

              case AU:
                e.isLockedMeeting = t.payload;
                break;

              case IU:
                e.isEnableWaitingRoom = t.payload;
                break;

              case TU:
                e.isEnableShare = t.payload;
                break;

              case OU:
                e.isEnableChat = t.payload;
                break;

              case RU:
                e.isEnableStartVideo = t.payload;
                break;

              case NU:
                e.isAllowToTalk = t.payload;
                break;

              case PU:
                e.isScreenSharingWithAudio = t.payload;
                break;

              case "SET_HAS_PRECONSENTED":
                e.hasPreconsented = t.payload;
                break;

              case jU:
                e.archivingStatus = t.payload;
                break;

              case DU:
                e.archivingSessionReady = t.payload;
                break;

              case zU:
                e.archivingOptions = t.payload;
                break;

              case MU:
                e.isEnableQA = t.payload;
                break;

              case LU:
                e.isSupportVideoEncodeHardwareAcceleration = t.payload;
                break;

              case UU:
                e.isSupportVideoDecodeHardwareAcceleration = t.payload;
                break;

              case "USER_SUBSCRIBE_QOS":
                e.userSubscribeQos = t.payload;
                break;

              case xU:
                return u(u({}, uH), {}, {
                  status: e.status
                });
            }

            return e;
          }),
              hH = {
            isShowParticipant: !1,
            isShowChat: !1,
            isShowMeetingInfo: !1,
            isShowActiveAppsNotifier: !1,
            isShowLeaveBox: !1,
            isShowCC: {
              history: !1,
              input: !1,
              toast: !1,
              setting: !1,
              getty: !1
            },
            isShowAssignHost: !1,
            isShowSetting: !1,
            isShowRecording: !1,
            participantSize: 0,
            activeChatUserId: -1,
            isShowAudioWarning: !1,
            isShowVideoWarning: !1,
            isShowRecordingAlert: !1,
            hasShowRecordingAlert: !1,
            isShowPanelistConsent: !1,
            viewType: MM.Speaker,
            isShowPromoteConsent: !1,
            numUnreadChat: 0,
            chatMessage: {
              id: "",
              message: "",
              receiver: {
                name: "",
                userId: 0
              },
              sender: {
                avatar: "",
                name: "",
                userId: ""
              },
              timestamp: new Date().getTime()
            },
            isShowChatNotification: !1,
            videoContainerDimensions: {
              width: UM.Width,
              height: UM.Height
            },
            customization: {},
            isShowUnmuteConsent: !1,
            isMirrorVideo: !1,
            virtualBackgroundImageId: "",
            isSupportVB: !0,
            virtualBackgroundImageList: [],
            virtualBackgroundPreloadState: YM.Loading,
            isShowSharePronounNotification: !1,
            isShowQAPanel: !1,
            numOpenQuestions: 0,
            isEnableHardwareAcclerationReceiving: !1,
            isEnableHardwareAcclerationSending: !1,
            isStartedHardwareAccleration: !1,
            maximumVideosInGalleryView: 9,
            isSortMostUpVote: !1
          },
              _H = ZL(function (e, t) {
            switch (t.type) {
              case tB:
                e.isShowParticipant = t.payload;
                break;

              case nB:
                e.isShowChat = t.payload, e.isShowChatNotification = !1;
                break;

              case rB:
                e.participantSize = t.payload;
                break;

              case iB:
                e.isShowMeetingInfo = t.payload;
                break;

              case oB:
                e.isShowActiveAppsNotifier = t.payload;
                break;

              case sB:
                e.isShowLeaveBox = t.payload;
                break;

              case aB:
                e.isShowAssignHost = t.payload;
                break;

              case cB:
                e.isShowSetting = t.payload;
                break;

              case lB:
                e.isShowRecording = t.payload;
                break;

              case dB:
                e.activeChatUserId = t.payload;
                break;

              case uB:
                e.isShowAudioWarning = t.payload;
                break;

              case pB:
                e.isShowVideoWarning = t.payload;
                break;

              case _B:
                e.isShowCC = u(u({}, e.isShowCC), t.payload);
                break;

              case fB:
                e.isShowRecordingAlert = t.payload;
                break;

              case mB:
                e.hasShowRecordingAlert = t.payload;
                break;

              case "SET_IS_SHOW_PANELIST_CONSENT":
                e.isShowPanelistConsent = t.payload;
                break;

              case gB:
                e.viewType = t.payload;
                break;

              case vB:
                e.isShowPromoteConsent = t.payload;
                break;

              case bB:
                e.numUnreadChat = t.payload;
                break;

              case yB:
                e.chatMessage = u({}, t.payload);
                break;

              case wB:
                e.isShowChatNotification = t.payload;
                break;

              case eB:
                e.videoContainerDimensions = u(u({}, e.videoContainerDimensions), t.payload);
                break;

              case SB:
                e.customization = t.payload;
                break;

              case xB:
                e.isShowUnmuteConsent = t.payload;
                break;

              case EB:
                e.isMirrorVideo = t.payload;
                break;

              case CB:
                e.virtualBackgroundImageId = t.payload;
                break;

              case kB:
                e.isSupportVB = t.payload;
                break;

              case AB:
                e.virtualBackgroundImageList = t.payload;
                break;

              case IB:
                e.virtualBackgroundPreloadState = t.payload;
                break;

              case TB:
                e.isShowSharePronounNotification = t.payload;
                break;

              case OB:
                e.isShowQAPanel = t.payload;
                break;

              case RB:
                e.numOpenQuestions = t.payload;
                break;

              case NB:
                e.isEnableHardwareAcclerationReceiving = t.payload;
                break;

              case PB:
                e.isEnableHardwareAcclerationSending = t.payload;
                break;

              case jB:
                e.isStartedHardwareAccleration = t.payload;
                break;

              case DB:
                e.maximumVideosInGalleryView = t.payload;
                break;

              case zB:
                e.isSortMostUpVote = t.payload;
                break;

              case hB:
                return hH;
            }

            return e;
          }, hH);

          function fH(t, n) {
            var r = e.useCallback(function () {
              var e = t.getActiveAppInfo();
              n({
                type: SU,
                payload: e
              });
            }, [n, t]);
            e.useEffect(function () {
              return t.on("active-apps-updated", r), function () {
                t.off("active-apps-updated", r);
              };
            }, [t, r]);
          }

          function mH(t, n, r, i, o) {
            var a = e.useCallback(function (e) {
              e.state === Dj.Reconnecting ? o() : e.state === Dj.Closed ? n(BU(jj.Closed)) : e.state === Dj.Connected ? (n(BU(jj.Connected)), i(), qz("background", ZM).then(function (e) {
                var t = null == e ? void 0 : e.map(function (e) {
                  return "background0" === e.id && (e.displayURL = "blur"), e;
                });
                null == r || r(function (e) {
                  return {
                    type: AB,
                    payload: e
                  };
                }(t));
              })) : e.state === Dj.Fail && n(BU(jj.Fail));
            }, [o, n, i, r]);
            e.useEffect(function () {
              return t.on("connection-change", a), function () {
                t.off("connection-change", a);
              };
            }, [t, a]);
          }

          function gH(t, n) {
            var r = e.useCallback(function (e) {
              n(function (e) {
                return {
                  type: eU,
                  payload: e
                };
              }(e.isOnHold));
            }, [n]);
            e.useEffect(function () {
              return t.on("on-hold-change", r), function () {
                t.off("on-hold-change", r);
              };
            }, [t, r]);
          }

          function vH(t, n, r) {
            var i = e.useCallback( /*#__PURE__*/function () {
              var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(e) {
                var i, o, a, _e285;

                return _regeneratorRuntime.wrap(function _callee27$(_context27) {
                  while (1) {
                    switch (_context27.prev = _context27.next) {
                      case 0:
                        i = e.action, o = e.type, a = e.result;

                        if (!(n({
                          type: "".concat(o, "-").concat(i),
                          payload: "success" === a
                        }), "video" === o && "success" === a)) {
                          _context27.next = 20;
                          break;
                        }

                        _e285 = t.getMediaStream();

                        if (!("encode" === i)) {
                          _context27.next = 12;
                          break;
                        }

                        _context27.next = 6;
                        return _e285.enableHardwareAcceleration({
                          encode: !0
                        });

                      case 6:
                        _context27.t0 = _context27.sent;

                        if (!_context27.t0) {
                          _context27.next = 9;
                          break;
                        }

                        null == r || r(sH(!0));

                      case 9:
                        null == r || r({
                          type: jB,
                          payload: !0
                        });
                        _context27.next = 20;
                        break;

                      case 12:
                        _context27.t1 = "decode" === i;

                        if (!_context27.t1) {
                          _context27.next = 17;
                          break;
                        }

                        _context27.next = 16;
                        return _e285.enableHardwareAcceleration({
                          decode: !0
                        });

                      case 16:
                        _context27.t1 = _context27.sent;

                      case 17:
                        _context27.t2 = _context27.t1;

                        if (!_context27.t2) {
                          _context27.next = 20;
                          break;
                        }

                        null == r || r(aH(!0));

                      case 20:
                      case "end":
                        return _context27.stop();
                    }
                  }
                }, _callee27);
              }));

              return function (_x47) {
                return _ref26.apply(this, arguments);
              };
            }(), [t, r, n]);
            e.useEffect(function () {
              return t.on("media-sdk-change", i), function () {
                t.off("media-sdk-change", i);
              };
            }, [t, i]);
          }

          var bH, yH, wH, SH;
          !function (e) {
            e[e.NoAttendee = 0] = "NoAttendee", e[e.All = 1] = "All", e[e.AllPanelist = 2] = "AllPanelist", e[e.Host = 3] = "Host", e[e.NoOne = 4] = "NoOne", e[e.EveryonePublicly = 5] = "EveryonePublicly";
          }(bH || (bH = {})), function (e) {
            e[e.All = 0] = "All", e[e.Panelist = 1] = "Panelist", e[e.SilentModeUsers = 4] = "SilentModeUsers";
          }(yH || (yH = {})), function (e) {
            e[e.AllPanelist = 1] = "AllPanelist", e[e.Everyone = 2] = "Everyone", e[e.Invalid = 0] = "Invalid";
          }(wH || (wH = {})), function (e) {
            e[e.AllPanelist = 11] = "AllPanelist", e[e.Everyone = 12] = "Everyone";
          }(SH || (SH = {}));
          var xH = (_xH = {}, _defineProperty(_xH, SH.AllPanelist, wH.AllPanelist), _defineProperty(_xH, SH.Everyone, wH.Everyone), _xH);

          function EH(t, n, r) {
            var i = e.useRef(0),
                o = function o() {
              i.current && (clearTimeout(i.current), i.current = 0);
            },
                a = e.useCallback(function (e) {
              e && !1 === e.isReady && (null == r || r(rH(YM.Fail)), o()), e && !0 === e.isReady && (null == r || r(rH(YM.Success)), o());
            }, [r]);

            e.useEffect(function () {
              return i.current = window.setTimeout(function () {
                null == r || r(rH(YM.Unknow));
              }, 15e3), function () {
                o();
              };
            }, [r]), e.useEffect(function () {
              var e;
              n && (null == r || r((e = null == n ? void 0 : n.isSupportVirtualBackground(), {
                type: kB,
                payload: e
              })));
            }, [r, n]), e.useEffect(function () {
              return t.on("video-virtual-background-preload-change", a), function () {
                t.off("video-virtual-background-preload-change", a);
              };
            });
          }

          var CH;
          !function (e) {
            e[e.SharePronounsTypeAsk = 0] = "SharePronounsTypeAsk", e[e.SharePronounsTypeAlways = 1] = "SharePronounsTypeAlways", e[e.SharePronounsTypeNot = 2] = "SharePronounsTypeNot";
          }(CH || (CH = {}));
          var kH = "zmwebsdk";

          function AH(t, n) {
            var r = e.useCallback(function (e) {
              var t = e.status,
                  r = e.sessionReady;
              null == n || n({
                type: jU,
                payload: t
              }), null == n || n(function (e) {
                return {
                  type: DU,
                  payload: e
                };
              }(r));
            }, [n]),
                i = e.useCallback(function (e) {
              var t = e.archivingOptions;
              null == n || n({
                type: zU,
                payload: t
              });
            }, [n]);
            e.useEffect(function () {
              return t.on("archiving-status-update", r), t.on("archiving-options-update", i), function () {
                t.off("archiving-status-update", r), t.off("archiving-options-update", i);
              };
            }, [t, r, i]);
          }

          function IH() {
            var _e$useContext = e.useContext(jM),
                t = _e$useContext.archivingOptions,
                _NM = NM(),
                n = _NM.t,
                _e$useState3 = e.useState(""),
                _e$useState4 = _slicedToArray(_e$useState3, 2),
                r = _e$useState4[0],
                i = _e$useState4[1],
                _e$useState5 = e.useState(0),
                _e$useState6 = _slicedToArray(_e$useState5, 2),
                o = _e$useState6[0],
                a = _e$useState6[1];

            return e.useEffect(function () {
              var _ref27 = t || {},
                  e = _ref27.isAudioArchiveEnabled,
                  r = _ref27.isVideoArchiveEnabled,
                  o = _ref27.isChatArchiveEnabled,
                  s = _ref27.isPrivateChatArchiveEnabled,
                  c = _ref27.isCCArchiveEnabled,
                  l = [];

              r && l.push(n("wc_video.video")), e && l.push(n("wc_audio")), o && (s ? l.push(n("archiving.chat_1")) : l.push(n("archiving.chat_2"))), c && l.push(n("archiving.transcription"));
              var d = l[0],
                  u = l[1],
                  p = l[2],
                  h = l[3];

              switch (l.length) {
                case 1:
                  return i(d), d;

                case 2:
                  i(n("archiving.subjects_combo_2_sdk", {
                    0: d,
                    1: u
                  }));
                  break;

                case 3:
                  i(n("archiving.subjects_combo_3_sdk", {
                    0: d,
                    1: u,
                    2: p
                  }));
                  break;

                case 4:
                  i(n("archiving.subjects_combo_4_sdk", {
                    0: d,
                    1: u,
                    2: p,
                    3: h
                  }));
                  break;

                default:
                  i("");
              }

              a(l.length);
            }, [t, n]), {
              archivedFeaturesString: r,
              numArchivedFeatures: o
            };
          }

          var TH = {
            exports: {}
          },
              OH = {};
          Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable, !function () {
            try {
              if (!Object.assign) return !1;
              var e = new String("abc");
              if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

              for (var t = {}, n = 0; n < 10; n++) {
                t["_" + String.fromCharCode(n)] = n;
              }

              var r = Object.getOwnPropertyNames(t).map(function (e) {
                return t[e];
              });
              if ("0123456789" !== r.join("")) return !1;
              var i = {};
              return "abcdefghijklmnopqrst".split("").forEach(function (e) {
                i[e] = e;
              }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
            } catch (e) {
              return !1;
            }
          }() || Object.assign;
          var RH = a.default,
              NH = 60103;

          if (OH.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
            var PH = Symbol.for;
            NH = PH("react.element"), OH.Fragment = PH("react.fragment");
          }

          var jH = RH.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
              DH = Object.prototype.hasOwnProperty,
              zH = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };

          function MH(e, t, n) {
            var r,
                i = {},
                o = null,
                a = null;

            for (r in void 0 !== n && (o = "" + n), void 0 !== t.key && (o = "" + t.key), void 0 !== t.ref && (a = t.ref), t) {
              DH.call(t, r) && !zH.hasOwnProperty(r) && (i[r] = t[r]);
            }

            if (e && e.defaultProps) for (r in t = e.defaultProps) {
              void 0 === i[r] && (i[r] = t[r]);
            }
            return {
              $$typeof: NH,
              type: e,
              key: o,
              ref: a,
              props: i,
              _owner: jH.current
            };
          }

          OH.jsx = MH, OH.jsxs = MH, TH.exports = OH;
          var LH = Ok(function (e) {
            return {
              info: {
                backgroundColor: "#00000099",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }
            };
          });
          var UH = 0;

          var BH = function BH(t) {
            var n = t.client,
                r = t.children,
                i = t.customization,
                _e$useState7 = e.useState(void 0),
                _e$useState8 = _slicedToArray(_e$useState7, 2),
                o = _e$useState8[0],
                a = _e$useState8[1],
                _ref28 = function () {
              var _e$useReducer = e.useReducer(dH, lH),
                  _e$useReducer2 = _slicedToArray(_e$useReducer, 2),
                  t = _e$useReducer2[0],
                  n = _e$useReducer2[1];

              return {
                streamState: t,
                dispatch: n
              };
            }(),
                s = _ref28.streamState,
                c = _ref28.dispatch,
                _ref29 = function () {
              var _e$useReducer3 = e.useReducer(pH, uH),
                  _e$useReducer4 = _slicedToArray(_e$useReducer3, 2),
                  t = _e$useReducer4[0],
                  n = _e$useReducer4[1];

              return {
                meetingState: t,
                dispatch: n
              };
            }(),
                l = _ref29.meetingState,
                d = _ref29.dispatch,
                _ref30 = function () {
              var _e$useReducer5 = e.useReducer(_H, hH),
                  _e$useReducer6 = _slicedToArray(_e$useReducer5, 2),
                  t = _e$useReducer6[0],
                  n = _e$useReducer6[1];

              return {
                meetingUIState: t,
                dispatch: n
              };
            }(),
                p = _ref30.meetingUIState,
                h = _ref30.dispatch,
                _e$useState9 = e.useState(),
                _e$useState10 = _slicedToArray(_e$useState9, 2),
                _ = _e$useState10[0],
                f = _e$useState10[1],
                _e$useState11 = e.useState(),
                _e$useState12 = _slicedToArray(_e$useState11, 2),
                m = _e$useState12[0],
                g = _e$useState12[1],
                _e$useState13 = e.useState(),
                _e$useState14 = _slicedToArray(_e$useState13, 2),
                v = _e$useState14[0],
                b = _e$useState14[1],
                _e$useState15 = e.useState(),
                _e$useState16 = _slicedToArray(_e$useState15, 2),
                y = _e$useState16[0],
                w = _e$useState16[1],
                S = e.useMemo(function () {
              return u(u({}, s), {}, {
                stream: o
              });
            }, [o, s]),
                x = e.useMemo(function () {
              return u(u({}, p), {}, {
                dispatch: h
              });
            }, [p, h]),
                E = e.useMemo(function () {
              return u(u({}, l), {}, {
                dispatch: d
              });
            }, [l, d]),
                C = e.useMemo(function () {
              return {
                chatClient: _,
                recordingClient: m,
                ccClient: v,
                qaClient: y
              };
            }, [_, m, v, y]),
                k = e.useCallback(function () {
              if (!o) {
                var _t140 = n.getMediaStream();

                a(_t140), d((e = _t140.isSupportMultipleVideos() && !Bz(), {
                  type: fU,
                  payload: e
                }));
              }

              var e;
              var t = n.getMeetingOptions(),
                  r = n.getFeatureModule("chat");
              r && t.isChatEnabled ? f(r) : f(void 0);
              var s = n.getFeatureModule("recording");
              s && (g(s), d(FU(s.getRecordingStatus())));
              var c = n.getFeatureModule("closedCaption");
              c && b(c);
              var l = n.getFeatureModule("QA");
              l && (w(l), d(function (e) {
                return {
                  type: MU,
                  payload: e
                };
              }(l.isQAEnabled()))), h(function (e) {
                return {
                  type: SB,
                  payload: e
                };
              }(i));
              var u = n.getMeetingInfo();
              d(function (e) {
                return {
                  type: oU,
                  payload: e
                };
              }(u.userId)), d(function (e) {
                return {
                  type: iU,
                  payload: e
                };
              }(u.meetingNumber)), d(function (e) {
                return {
                  type: $L,
                  payload: e
                };
              }(n.isWebinar())), d(function (e) {
                return {
                  type: XL,
                  payload: e
                };
              }(n.isOriginHost())), d(function (e) {
                return {
                  type: CU,
                  payload: e
                };
              }(u)), d(HU(t)), "en-US" !== u.lang && Pz.changeLanguage(u.lang);
            }, [n, i, d, h, o]),
                A = e.useCallback(function () {
              d(BU(jj.Reconnecting)), d({
                type: xU
              }), h({
                type: hB
              }), c({
                type: EU
              }), a(void 0), f(void 0), g(void 0);
            }, [d, h, c]);

            mH(n, d, h, k, A), gH(n, d), vH(n, c, h), function (t, n) {
              var r = e.useCallback(function (e) {
                n(FU(e));
              }, [n]);
              e.useEffect(function () {
                return t.on("recording-change", r), function () {
                  t.off("recording-change", r);
                };
              }, [t, r]);
            }(n, d), fH(n, d), function (t, n, r) {
              var i = e.useCallback(function (e) {
                n(GU({
                  reqId: e.reqId,
                  senderId: e.senderId
                })), r($B(!0));
              }, [n, r]);
              e.useEffect(function () {
                return t.on("promote-attendee-consent", i), function () {
                  t.off("promote-attendee-consent", i);
                };
              }, [t, i]);
            }(n, d, h), function (t, n, r, i) {
              Mj(function () {
                t && n && (i(KU(t.isMeetingLocked())), i(QU(t.isEnableWaitingRoom())), i(ZU((null == n ? void 0 : n.getSharePrivilege()) !== GM.OnlyHost)), i(YU((null == r ? void 0 : r.getPrivilege()) !== bH.NoOne)), i(JU(null == n ? void 0 : n.isEnableUnmuteVideo())));
              });
              var o = e.useCallback(function () {
                i(HU(t.getMeetingOptions())), i(KU(t.isMeetingLocked())), i(QU(t.isEnableWaitingRoom())), i(ZU((null == n ? void 0 : n.getSharePrivilege()) !== GM.OnlyHost)), i(YU((null == r ? void 0 : r.getPrivilege()) !== bH.NoOne)), i(JU(!(null == n || !n.isEnableUnmuteVideo())));
              }, [r, t, i, n]);
              e.useEffect(function () {
                return null == t || t.on("meeting-attribute-updated", o), function () {
                  null == t || t.off("meeting-attribute-updated", o);
                };
              }, [t, o]);
            }(n, o, _, d), Mj(function () {
              var e = null == n ? void 0 : n.getMeetingInfo();
              null != e && e.isInMeeting && k(), d(BU(e.isInMeeting ? jj.Connected : jj.Closed));
            }), function (t, n) {
              var r = e.useRef(n);
              r.current = n;
              var i = e.useCallback(function () {
                var e;
                var n = t.getParticipantsList(),
                    i = t.getAssistantsList(),
                    o = t.getOnHoldParticipantsList();
                null === (e = r.current) || void 0 === e || e.call(r, n, i, o);
              }, [t]);
              e.useEffect(function () {
                return t.on("user-added", i), t.on("user-removed", i), t.on("user-updated", i), function () {
                  t.off("user-added", i), t.off("user-removed", i), t.off("user-updated", i);
                };
              }, [t, i]), Mj(function () {
                i();
              });
            }(n, function (e, t, r) {
              var i = n.getCurrentUserInfo();
              var o;
              d((o = !(null == i || !i.isHost), {
                type: tU,
                payload: o
              })), d(function (e) {
                return {
                  type: nU,
                  payload: e
                };
              }(!(null == i || !i.isCoHost))), d(function (e) {
                return {
                  type: aU,
                  payload: e
                };
              }({
                participants: e,
                onHoldParticipants: r
              })), d(function (e) {
                return {
                  type: sU,
                  payload: e
                };
              }(t)), h(function (e) {
                return {
                  type: rB,
                  payload: e
                };
              }(e.length + r.length));
              var a = e.some(function (e) {
                return e.bLocalRecord;
              });
              d(function (e) {
                return {
                  type: gU,
                  payload: e
                };
              }(a)), d(function (e) {
                return {
                  type: rU,
                  payload: e
                };
              }(n.isAttendee()));
            }), function (t, n) {
              var r = e.useRef(n);
              r.current = n;
              var i = e.useCallback(function () {
                if (t.isWebinar()) {
                  var e;

                  var _n90 = t.getWebinarAttendeesList();

                  null === (e = r.current) || void 0 === e || e.call(r, _n90);
                } else {
                  var n;
                  null === (n = r.current) || void 0 === n || n.call(r, []);
                }
              }, [t]);
              e.useEffect(function () {
                return t.on("attendee-updated", i), function () {
                  t.off("attendee-updated", i);
                };
              }, [t, i]), Mj(function () {
                i();
              });
            }(n, function (e) {
              d({
                type: cU,
                payload: e
              });
            }), function (t, n, r) {
              var i = e.useCallback(function (e) {
                null == r || r(nH(!0));
              }, [r]),
                  o = e.useCallback(function (e) {
                e.enabled ? null == n || n($U(!0)) : (null == r || r(nH(!1)), null == n || n($U(!1)));
              }, [n, r]);
              e.useEffect(function () {
                return t.on("unmute-audio-consent", i), t.on("allow-talk-change", o), function () {
                  t.off("unmute-audio-consent", i), t.off("allow-talk-change", o);
                };
              }, [t, o, i]);
            }(n, d, h), EH(n, o, h), function (t, n) {
              var r = e.useCallback(function (e) {
                e && e.userSharePronounType === CH.SharePronounsTypeAsk && (null == n || n(iH(!0)));
              }, [n]);
              e.useEffect(function () {
                return t.on("share-pronoun-type-update", r), function () {
                  t.off("share-pronoun-type-update", r);
                };
              }, [t, r]);
            }(n, h), AH(n, d);
            var I = LH();
            return TH.exports.jsx(zM.Provider, {
              value: n,
              children: TH.exports.jsx(DM.Provider, {
                value: S,
                children: TH.exports.jsx($M.Provider, {
                  value: C,
                  children: TH.exports.jsx(jM.Provider, {
                    value: E,
                    children: TH.exports.jsx(JM.Provider, {
                      value: x,
                      children: TH.exports.jsx(TC, {
                        generateClassName: function generateClassName(e, t) {
                          var n = "".concat(kH, "-").concat(t.options.classNamePrefix, "-").concat(e.key);
                          return "makeStyles" === t.options.classNamePrefix && (n += "-".concat(UH), UH++), n;
                        },
                        children: TH.exports.jsx(Rj, {
                          anchorOrigin: {
                            vertical: "top",
                            horizontal: "center"
                          },
                          classes: {
                            variantInfo: I.info
                          },
                          children: TH.exports.jsx(Ak, {
                            theme: Pj,
                            children: r
                          })
                        })
                      })
                    })
                  })
                })
              })
            });
          };

          function HH() {
            var _e$useState17 = e.useState(!1),
                _e$useState18 = _slicedToArray(_e$useState17, 2),
                t = _e$useState18[0],
                n = _e$useState18[1],
                _e$useState19 = e.useState(!1),
                _e$useState20 = _slicedToArray(_e$useState19, 2),
                r = _e$useState20[0],
                i = _e$useState20[1],
                o = e.useContext(zM);

            Mj(function () {
              o && (n(o.hasAssistant()), i(o.hasRemoteAdmin()));
            });
            var a = e.useCallback(function () {
              n(o.hasAssistant()), i(o.hasRemoteAdmin());
            }, [o]);
            return e.useEffect(function () {
              return null == o || o.on("meeting-attribute-updated", a), function () {
                null == o || o.off("meeting-attribute-updated", a);
              };
            }, [o, a]), {
              hasAst: !!t,
              hasRmc: !!r
            };
          }

          var VH, qH, FH, WH, GH, KH, QH, ZH, YH, JH, $H, XH, eV, tV, nV, rV, iV, oV, aV, sV, cV, lV, dV, uV, pV, hV, _V, fV, mV, gV, vV, bV, yV, wV, SV, xV, EV, CV, kV, AV, IV, TV, OV, RV, NV, PV, jV, DV, zV, MV, LV, UV, BV, HV, VV, qV, FV, WV, GV, KV, QV, ZV, YV, JV, $V, XV, eq, tq, nq, rq, iq, oq, aq, sq, cq, lq, dq, uq, pq, hq, _q, fq, mq, gq;

          function vq() {
            return vq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, vq.apply(this, arguments);
          }

          function bq() {
            return bq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, bq.apply(this, arguments);
          }

          function yq() {
            return yq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, yq.apply(this, arguments);
          }

          function wq() {
            return wq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, wq.apply(this, arguments);
          }

          function Sq() {
            return Sq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Sq.apply(this, arguments);
          }

          function xq() {
            return xq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, xq.apply(this, arguments);
          }

          function Eq() {
            return Eq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Eq.apply(this, arguments);
          }

          function Cq() {
            return Cq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Cq.apply(this, arguments);
          }

          function kq() {
            return kq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, kq.apply(this, arguments);
          }

          function Aq() {
            return Aq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Aq.apply(this, arguments);
          }

          function Iq() {
            return Iq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Iq.apply(this, arguments);
          }

          function Tq(e) {
            return s.createElement("svg", Iq({
              width: 16,
              height: 16,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, e), tV || (tV = s.createElement("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.154 13.038a.625.625 0 10.884-.884L8.884 8l4.154-4.154a.625.625 0 10-.884-.884L8 7.116 3.846 2.962a.625.625 0 10-.884.884L7.116 8l-4.154 4.154a.625.625 0 10.884.884L8 8.884l4.154 4.154z",
              fill: "#747487"
            })));
          }

          function Oq() {
            return Oq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Oq.apply(this, arguments);
          }

          function Rq() {
            return Rq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Rq.apply(this, arguments);
          }

          function Nq() {
            return Nq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Nq.apply(this, arguments);
          }

          function Pq() {
            return Pq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Pq.apply(this, arguments);
          }

          function jq() {
            return jq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, jq.apply(this, arguments);
          }

          function Dq() {
            return Dq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Dq.apply(this, arguments);
          }

          function zq() {
            return zq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, zq.apply(this, arguments);
          }

          function Mq() {
            return Mq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Mq.apply(this, arguments);
          }

          function Lq() {
            return Lq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Lq.apply(this, arguments);
          }

          function Uq() {
            return Uq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Uq.apply(this, arguments);
          }

          function Bq() {
            return Bq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Bq.apply(this, arguments);
          }

          function Hq() {
            return Hq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Hq.apply(this, arguments);
          }

          function Vq() {
            return Vq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Vq.apply(this, arguments);
          }

          function qq() {
            return qq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, qq.apply(this, arguments);
          }

          function Fq() {
            return Fq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Fq.apply(this, arguments);
          }

          function Wq() {
            return Wq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Wq.apply(this, arguments);
          }

          function Gq() {
            return Gq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Gq.apply(this, arguments);
          }

          function Kq() {
            return Kq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Kq.apply(this, arguments);
          }

          function Qq() {
            return Qq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Qq.apply(this, arguments);
          }

          function Zq() {
            return Zq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Zq.apply(this, arguments);
          }

          function Yq() {
            return Yq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Yq.apply(this, arguments);
          }

          function Jq() {
            return Jq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Jq.apply(this, arguments);
          }

          function $q() {
            return $q = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, $q.apply(this, arguments);
          }

          function Xq() {
            return Xq = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, Xq.apply(this, arguments);
          }

          function eF() {
            return eF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, eF.apply(this, arguments);
          }

          function tF() {
            return tF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, tF.apply(this, arguments);
          }

          function nF() {
            return nF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, nF.apply(this, arguments);
          }

          function rF() {
            return rF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, rF.apply(this, arguments);
          }

          function iF() {
            return iF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, iF.apply(this, arguments);
          }

          function oF() {
            return oF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, oF.apply(this, arguments);
          }

          function aF() {
            return aF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, aF.apply(this, arguments);
          }

          function sF() {
            return sF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, sF.apply(this, arguments);
          }

          function cF() {
            return cF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, cF.apply(this, arguments);
          }

          function lF() {
            return lF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, lF.apply(this, arguments);
          }

          function dF() {
            return dF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, dF.apply(this, arguments);
          }

          function uF() {
            return uF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, uF.apply(this, arguments);
          }

          function pF() {
            return pF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, pF.apply(this, arguments);
          }

          function hF() {
            return hF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, hF.apply(this, arguments);
          }

          function _F() {
            return _F = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, _F.apply(this, arguments);
          }

          function fF() {
            return fF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, fF.apply(this, arguments);
          }

          function mF() {
            return mF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, mF.apply(this, arguments);
          }

          function gF() {
            return gF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, gF.apply(this, arguments);
          }

          function vF() {
            return vF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, vF.apply(this, arguments);
          }

          function bF() {
            return bF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, bF.apply(this, arguments);
          }

          function yF() {
            return yF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, yF.apply(this, arguments);
          }

          function wF() {
            return wF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, wF.apply(this, arguments);
          }

          function SF() {
            return SF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, SF.apply(this, arguments);
          }

          function xF() {
            return xF = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, xF.apply(this, arguments);
          }

          var EF = {
            "icon-active-apps": {
              component: function component(e) {
                return s.createElement("svg", vq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), VH || (VH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M4 6c-.48 0-.79 0-1.026-.017-.228-.015-.315-.042-.357-.06a1 1 0 01-.54-.54c-.018-.042-.045-.129-.06-.357A16.911 16.911 0 012 4c0-.48 0-.79.017-1.026.015-.228.042-.315.06-.357a1 1 0 01.54-.54c.042-.018.129-.045.357-.06C3.21 2 3.52 2 4 2s.79 0 1.026.017c.228.015.315.042.357.06a1 1 0 01.54.54c.018.042.045.129.06.357C6 3.21 6 3.52 6 4s0 .79-.017 1.026c-.015.228-.042.315-.06.357a1 1 0 01-.54.54c-.042.018-.129.045-.357.06C4.79 6 4.48 6 4 6zM1 4c0-.932 0-1.398.152-1.765a2 2 0 011.083-1.083C2.602 1 3.068 1 4 1c.932 0 1.398 0 1.765.152a2 2 0 011.083 1.083C7 2.602 7 3.068 7 4c0 .932 0 1.398-.152 1.765a2 2 0 01-1.083 1.083C5.398 7 4.932 7 4 7c-.932 0-1.398 0-1.765-.152a2 2 0 01-1.083-1.083C1 5.398 1 4.932 1 4zm3 10c-.48 0-.79 0-1.026-.017-.228-.015-.315-.042-.357-.06a1 1 0 01-.54-.54c-.018-.042-.045-.129-.06-.357A16.908 16.908 0 012 12c0-.48 0-.79.017-1.026.015-.228.042-.315.06-.357a1 1 0 01.54-.54c.042-.018.129-.045.357-.06C3.21 10 3.52 10 4 10s.79 0 1.026.017c.228.015.315.042.357.06a1 1 0 01.54.54c.018.042.045.129.06.357C6 11.21 6 11.52 6 12s0 .79-.017 1.026c-.015.228-.042.315-.06.357a1 1 0 01-.54.54c-.042.018-.129.045-.357.06C4.79 14 4.48 14 4 14zm-3-2c0-.932 0-1.398.152-1.765a2 2 0 011.083-1.083C2.602 9 3.068 9 4 9c.932 0 1.398 0 1.765.152a2 2 0 011.083 1.083C7 10.602 7 11.068 7 12c0 .932 0 1.398-.152 1.765a2 2 0 01-1.083 1.083C5.398 15 4.932 15 4 15c-.932 0-1.398 0-1.765-.152a2 2 0 01-1.083-1.083C1 13.398 1 12.932 1 12zm9.974-6.017C11.21 6 11.52 6 12 6s.79 0 1.026-.017c.228-.015.315-.042.357-.06a1 1 0 00.54-.54c.018-.042.045-.129.06-.357C14 4.79 14 4.48 14 4s0-.79-.017-1.026c-.015-.228-.042-.315-.06-.357a1 1 0 00-.54-.54c-.042-.018-.129-.045-.357-.06A16.908 16.908 0 0012 2c-.48 0-.79 0-1.026.017-.228.015-.315.042-.357.06a1 1 0 00-.54.54c-.018.042-.045.129-.06.357C10 3.21 10 3.52 10 4s0 .79.017 1.026c.015.228.042.315.06.357a1 1 0 00.54.54c.042.018.129.045.357.06zM9.152 2.235C9 2.602 9 3.068 9 4c0 .932 0 1.398.152 1.765a2 2 0 001.083 1.083C10.602 7 11.068 7 12 7c.932 0 1.398 0 1.765-.152a2 2 0 001.083-1.083C15 5.398 15 4.932 15 4c0-.932 0-1.398-.152-1.765a2 2 0 00-1.083-1.083C13.398 1 12.932 1 12 1c-.932 0-1.398 0-1.765.152a2 2 0 00-1.083 1.083zM12 14c-.48 0-.79 0-1.026-.017-.228-.015-.315-.042-.357-.06a1 1 0 01-.54-.54c-.018-.042-.045-.129-.06-.357A16.885 16.885 0 0110 12c0-.48 0-.79.017-1.026.015-.228.042-.315.06-.357a1 1 0 01.54-.54c.042-.018.129-.045.357-.06C11.21 10 11.52 10 12 10s.79 0 1.026.017c.228.015.315.042.357.06a1 1 0 01.54.54c.018.042.045.129.06.357C14 11.21 14 11.52 14 12s0 .79-.017 1.026c-.015.228-.042.315-.06.357a1 1 0 01-.54.54c-.042.018-.129.045-.357.06C12.79 14 12.48 14 12 14zm-3-2c0-.932 0-1.398.152-1.765a2 2 0 011.083-1.083C10.602 9 11.068 9 12 9c.932 0 1.398 0 1.765.152a2 2 0 011.083 1.083C15 10.602 15 11.068 15 12c0 .932 0 1.398-.152 1.765a2 2 0 01-1.083 1.083C13.398 15 12.932 15 12 15c-.932 0-1.398 0-1.765-.152a2 2 0 01-1.083-1.083C9 13.398 9 12.932 9 12z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 16
            },
            "icon-alert": {
              component: function component(e) {
                return s.createElement("svg", sF({
                  viewBox: "0 0 16 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), QV || (QV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M1.257 11.765A1.5 1.5 0 002.565 14h10.87a1.5 1.5 0 001.308-2.235L9.307 2.102a1.5 1.5 0 00-2.614 0l-5.436 9.663zM7.35 8.6V5.65a.65.65 0 011.3 0V8.6a.65.65 0 01-1.3 0zm-.1 2.65a.75.75 0 111.5 0 .75.75 0 01-1.5 0z",
                  fill: "#FAAC2A"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-arrow-down": {
              component: function component(e) {
                return s.createElement("svg", bq({
                  width: 14,
                  height: 8,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), qH || (qH = s.createElement("path", {
                  d: "M13.707.293a1 1 0 00-1.414 0L7 5.586 1.707.293A1 1 0 00.293 1.707l6 6a1 1 0 001.414 0l6-6a1 1 0 000-1.414z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 14,
              height: 8
            },
            "icon-arrow-up": {
              component: function component(e) {
                return s.createElement("svg", yq({
                  width: 14,
                  height: 8,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), FH || (FH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M.293 7.707a1 1 0 001.414 0L7 2.414l5.293 5.293a1 1 0 101.414-1.414l-6-6a1 1 0 00-1.414 0l-6 6a1 1 0 000 1.414z",
                  fill: "#fff",
                  fillOpacity: .4
                })));
              },
              width: 14,
              height: 8
            },
            "icon-arrow-left": {
              component: function component(e) {
                return s.createElement("svg", wq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), WH || (WH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.442 12.442a.625.625 0 01-.884 0l-4-4a.625.625 0 010-.884l4-4a.625.625 0 11.884.884L6.884 8l3.558 3.558a.625.625 0 010 .884z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 16,
              height: 16
            },
            "icon-audio-muted-outline": {
              component: function component(e) {
                return s.createElement("svg", Sq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), GH || (GH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M8 10c1.1 0 2-.9 2-2V6.7L6.98 9.72c.3.18.65.28 1.02.28zm2-7c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 .37.1.72.28 1.02L10 5.3V3zM.15 15.15l3.98-3.98A4.947 4.947 0 013 8c0-.04 0-.07.01-.1.05-.23.25-.4.49-.4.28 0 .5.22.5.5 0 .92.31 1.77.85 2.45l.71-.71C5.21 9.25 5 8.65 5 8V3c0-1.66 1.34-3 3-3s3 1.34 3 3v1.3L15.15.15c.19-.2.51-.2.7 0 .2.19.2.51 0 .7L11 5.7V8a2.996 2.996 0 01-4.74 2.44l-.71.71c.55.43 1.22.72 1.95.82a4.07 4.07 0 001 0C10.47 11.72 12 10.04 12 8c0-.28.22-.5.5-.5.24 0 .44.17.49.4.01.03.01.06.01.1 0 2.59-1.97 4.72-4.5 4.97V15h2c.28 0 .5.22.5.5s-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2v-2.03c-1-.1-1.92-.5-2.66-1.11L.85 15.85c-.19.2-.51.2-.7 0-.2-.19-.2-.51 0-.7z",
                  fill: "#FF5C5C"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-audio-outline": {
              component: function component(e) {
                return s.createElement("svg", xq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), KH || (KH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M8 10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2zM5 3c0-1.66 1.34-3 3-3s3 1.34 3 3v5c0 1.66-1.34 3-3 3S5 9.66 5 8V3zm7.99 5.1c.01-.03.01-.07.01-.1 0-.28-.22-.5-.5-.5s-.5.22-.5.5c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-.28-.22-.5-.5-.5a.495.495 0 00-.49.6c.04 2.54 1.99 4.62 4.49 4.87V15h-2c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2v-2.03c2.5-.25 4.45-2.33 4.49-4.87z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 16,
              height: 16
            },
            "icon-audio": {
              component: function component(e) {
                return s.createElement("svg", Eq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), QH || (QH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M11 8V3c0-1.66-1.34-3-3-3S5 1.34 5 3v5c0 1.66 1.34 3 3 3s3-1.34 3-3zm1.99.1c.01-.03.01-.07.01-.1 0-.28-.22-.5-.5-.5s-.5.22-.5.5c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-.28-.22-.5-.5-.5a.495.495 0 00-.49.6c.04 2.54 1.99 4.62 4.49 4.87V15h-2c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2v-2.03c2.5-.25 4.45-2.33 4.49-4.87z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 16
            },
            "icon-audio-muted": {
              component: function component(e) {
                return s.createElement("svg", Cq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), ZH || (ZH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.667 3.648v-.315a2.667 2.667 0 10-5.334 0V8c0 .295.048.58.137.845l5.197-5.197zM7.155 10.53l3.512-3.512V8a2.667 2.667 0 01-3.512 2.53zm-2.45-.92A3.652 3.652 0 014.333 8a.5.5 0 10-1 0c0 .856.231 1.659.634 2.348l.738-.738zm.947 2.423l.738-.738A3.667 3.667 0 0011.667 8a.5.5 0 011 0A4.667 4.667 0 018.5 12.64v1.693H10a.5.5 0 110 1H6a.5.5 0 010-1h1.5V12.64a4.637 4.637 0 01-1.848-.607z",
                  fill: "#fff",
                  fillOpacity: .62
                })), YH || (YH = s.createElement("path", {
                  d: "M15.333.667L.667 15.333",
                  stroke: "#FF5C5C",
                  strokeLinecap: "round"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-audio-warning": {
              component: function component(e) {
                return s.createElement("svg", oF({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), FV || (FV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M5.333 3.333a2.667 2.667 0 015.334 0V8a2.667 2.667 0 11-5.334 0V3.333zM8.5 12.64A4.667 4.667 0 0012.667 8a.5.5 0 10-1 0 3.667 3.667 0 11-7.334 0 .5.5 0 10-1 0A4.667 4.667 0 007.5 12.64v1.693H6a.5.5 0 100 1h4a.5.5 0 100-1H8.5V12.64z",
                  fill: "#fff",
                  fillOpacity: .62
                })), WV || (WV = s.createElement("g", {
                  clipPath: "white"
                }, s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M12.27 14.75h6.794a.938.938 0 00.817-1.397l-3.397-6.04a.937.937 0 00-1.634 0l-3.397 6.04a.937.937 0 00.817 1.397zm2.99-3.375V9.531a.406.406 0 11.813 0v1.844a.406.406 0 01-.813 0zm-.062 1.656a.469.469 0 11.937 0 .469.469 0 01-.937 0z",
                  fill: "#FAAC2A"
                }))));
              },
              width: 22,
              height: 20
            },
            "icon-join-audio": {
              component: function component(e) {
                return s.createElement("svg", kq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), JH || (JH = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M8 2a6 6 0 016 6v.667h.333c.92 0 1.667.746 1.667 1.666v1.334c0 .92-.746 1.666-1.667 1.666h-.5a.667.667 0 01-.666-.666V8A5.167 5.167 0 002.833 8v4.666a.667.667 0 01-.666.667h-.5c-.92 0-1.667-.746-1.667-1.666v-1.334c0-.92.746-1.666 1.667-1.666H2V8a6 6 0 016-6z",
                  fill: "#fff",
                  fillOpacity: .62
                })), $H || ($H = s.createElement("path", {
                  d: "M8 8v4.833",
                  stroke: "#23D959",
                  strokeLinecap: "round"
                })), XH || (XH = s.createElement("path", {
                  d: "M10 9.334l-2-2-2 2",
                  stroke: "#23D959",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-checked": {
              component: function component(e) {
                return s.createElement("svg", Aq({
                  width: 10,
                  height: 8,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), eV || (eV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M9.431.547c.25.238.26.634.022.884l-5.715 6a.625.625 0 01-.914-.01L.54 4.922a.625.625 0 01.922-.843l1.834 2.006L8.547.569a.625.625 0 01.884-.022z",
                  fill: "#fff",
                  fillOpacity: .8
                })));
              },
              width: 10,
              height: 8
            },
            "icon-close": {
              component: Tq,
              width: 16,
              height: 16
            },
            "icon-share": {
              component: function component(e) {
                return s.createElement("svg", Dq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), vV || (vV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M0 5.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C1.52 2 2.08 2 3.2 2h9.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C16 3.52 16 4.08 16 5.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C14.48 14 13.92 14 12.8 14H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C0 12.48 0 11.92 0 10.8V5.2zm8.625 1.809l.933.933a.625.625 0 10.884-.884l-2-2a.625.625 0 00-.884 0l-2 2a.625.625 0 10.884.884l.933-.933V10.5a.625.625 0 101.25 0V7.009z",
                  fill: "#23D959"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-copy": {
              component: function component(e) {
                return s.createElement("svg", Oq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), nV || (nV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C3.52 2 4.08 2 5.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874c.205.402.217.92.218 1.908h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C5 7.28 5 8.12 5 9.8v.2c-.988 0-1.506-.013-1.908-.218a2 2 0 01-.874-.874C2 8.48 2 7.92 2 6.8V5.2zm4.218 1.892C6 7.52 6 8.08 6 9.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C7.52 14 8.08 14 9.2 14h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C14 12.48 14 11.92 14 10.8V9.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C12.48 6 11.92 6 10.8 6H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874z",
                  fill: "#4F9AF7"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-loading": {
              component: function component(e) {
                return s.createElement("svg", Rq({
                  width: 25,
                  height: 24,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), rV || (rV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M11.577.923a.923.923 0 011.846 0v4.615a.923.923 0 01-1.846 0V.923z",
                  fill: "#F5F5F5"
                })), iV || (iV = s.createElement("path", {
                  opacity: .4,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M11.577 18.462a.923.923 0 011.846 0v4.615a.923.923 0 01-1.846 0V18.46z",
                  fill: "#F5F5F5"
                })), oV || (oV = s.createElement("path", {
                  opacity: .2,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M23.577 11.077a.923.923 0 010 1.846H18.96a.923.923 0 010-1.846h4.616z",
                  fill: "#F5F5F5"
                })), aV || (aV = s.createElement("path", {
                  opacity: .7,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M6.038 11.077a.923.923 0 010 1.846H1.423a.923.923 0 010-1.846h4.615z",
                  fill: "#F5F5F5"
                })), sV || (sV = s.createElement("path", {
                  opacity: .2,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M21.631 5.662a.923.923 0 11.923 1.599l-3.997 2.308a.923.923 0 01-.923-1.6l3.997-2.307z",
                  fill: "#F5F5F5"
                })), cV || (cV = s.createElement("path", {
                  opacity: .6,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M6.443 14.431a.923.923 0 01.923 1.6l-3.997 2.307a.923.923 0 01-.924-1.599l3.998-2.308z",
                  fill: "#F5F5F5"
                })), lV || (lV = s.createElement("path", {
                  opacity: .2,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M17.24 1.946a.923.923 0 011.598.923L16.53 6.866a.923.923 0 01-1.599-.923l2.308-3.997z",
                  fill: "#F5F5F5"
                })), dV || (dV = s.createElement("path", {
                  opacity: .5,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M8.47 17.134a.923.923 0 111.599.923L7.76 22.054a.923.923 0 11-1.599-.923l2.308-3.997z",
                  fill: "#F5F5F5"
                })), uV || (uV = s.createElement("path", {
                  opacity: .3,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M18.838 21.131a.923.923 0 01-1.599.923l-2.308-3.997a.923.923 0 111.6-.923l2.307 3.997z",
                  fill: "#F5F5F5"
                })), pV || (pV = s.createElement("path", {
                  opacity: .9,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.069 5.943a.923.923 0 11-1.6.923L6.163 2.869a.923.923 0 111.599-.923l2.308 3.997z",
                  fill: "#F5F5F5"
                })), hV || (hV = s.createElement("path", {
                  opacity: .3,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M22.554 16.739a.923.923 0 01-.923 1.599l-3.997-2.308a.923.923 0 11.923-1.599l3.997 2.308z",
                  fill: "#F5F5F5"
                })), _V || (_V = s.createElement("path", {
                  opacity: .8,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M7.366 7.97a.923.923 0 11-.923 1.599L2.446 7.26a.923.923 0 01.923-1.599L7.366 7.97z",
                  fill: "#F5F5F5"
                })));
              },
              width: 25,
              height: 24
            },
            "icon-more": {
              component: function component(e) {
                return s.createElement("svg", Nq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), fV || (fV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M5 8a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 16
            },
            "icon-security": {
              component: function component(e) {
                return s.createElement("svg", jq({
                  width: 12,
                  height: 14,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), gV || (gV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M6 .333a.523.523 0 00-.36.134c-.847.81-3.051 2.703-5.134 2.682-.222-.002-.425.15-.444.361-.015.157-.027.312-.036.465-.372 6.151 3.3 8.946 5.932 9.686a.159.159 0 00.085 0c2.173-.61 5.056-2.624 5.784-6.772.176-.999.226-2.122.111-3.379-.019-.212-.222-.363-.444-.36C9.41 3.17 7.207 1.277 6.36.467A.523.523 0 006 .333zm5.03 6.556c.166-.88.228-1.875.15-2.995-1.157-.074-2.263-.592-3.145-1.142-.85-.53-1.57-1.14-2.035-1.569V6.89H.97c.267 1.41.8 2.53 1.448 3.404C3.463 11.703 4.84 12.52 6 12.884V6.89h5.03z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 12,
              height: 14
            },
            "icon-shield": {
              component: function component(e) {
                return s.createElement("svg", zq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), bV || (bV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M2.269 4.139c-.202-.005-.386.138-.405.34-.633 6.71 3.33 9.73 6.145 10.51.025.006.05.006.074 0 2.815-.78 6.779-3.8 6.146-10.51-.019-.202-.203-.345-.405-.34-2.23.056-4.608-2.006-5.455-2.818a.491.491 0 00-.645 0c-.848.812-3.225 2.874-5.455 2.818zm9.323 2.764a.65.65 0 00-.947-.89L7.123 9.758 5.988 8.505a.65.65 0 10-.963.873l1.607 1.774a.65.65 0 00.955.01l4.005-4.259z",
                  fill: "#23D959"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-video": {
              component: function component(e) {
                return s.createElement("svg", Lq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), wV || (wV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M1.5 3A1.5 1.5 0 000 4.5V10a3 3 0 003 3h7.5a1.5 1.5 0 001.5-1.5V10l2.8 2.1a.75.75 0 001.2-.6v-7a.75.75 0 00-1.2-.6L12 6a3 3 0 00-3-3H1.5z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 16
            },
            "icon-video-muted": {
              component: function component(e) {
                return s.createElement("svg", Uq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), SV || (SV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.338 4.046a2.887 2.887 0 00-1.903-.713H1.45c-.8 0-1.449.65-1.449 1.45v4.986a2.9 2.9 0 001.895 2.72l8.443-8.443zm-5.388 8.62l6.383-6.383v4.935c0 .8-.649 1.449-1.449 1.449H4.95zM16 11.359V4.643a.667.667 0 00-1.059-.54l-2.059 1.498c-.345.25-.549.652-.549 1.078v2.642c0 .427.204.828.55 1.079l2.058 1.497a.667.667 0 001.059-.54z",
                  fill: "#fff",
                  fillOpacity: .62
                })), xV || (xV = s.createElement("path", {
                  d: "M15.333.667L.667 15.333",
                  stroke: "#FF5C5C",
                  strokeLinecap: "round"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-video-warning": {
              component: function component(e) {
                return s.createElement("svg", aF({
                  viewBox: 0,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), GV || (GV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M1.45 3.333c-.801 0-1.45.65-1.45 1.45v4.986c0 1.6 1.298 2.898 2.898 2.898h6.986c.8 0 1.45-.649 1.45-1.45V6.233c0-1.6-1.298-2.899-2.899-2.899H1.45zM16 4.643v6.715c0 .545-.618.86-1.059.54L12.882 10.4a1.333 1.333 0 01-.549-1.078V6.68c0-.427.204-.828.55-1.079l2.058-1.497a.667.667 0 011.059.54z",
                  fill: "#fff",
                  fillOpacity: .62
                })), KV || (KV = s.createElement("g", {
                  clipPath: "white"
                }, s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M16.27 14.75h6.794a.938.938 0 00.817-1.397l-3.397-6.04a.937.937 0 00-1.634 0l-3.397 6.04a.937.937 0 00.817 1.397zm2.99-3.375V9.531a.406.406 0 11.813 0v1.844a.406.406 0 01-.813 0zm-.062 1.656a.469.469 0 11.937 0 .469.469 0 01-.937 0z",
                  fill: "#FAAC2A"
                }))));
              },
              width: 26,
              height: 16
            },
            "icon-video-outline": {
              component: function component(e) {
                return s.createElement("svg", Bq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), EV || (EV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M1.5 4H9a2 2 0 012 2v5.5a.5.5 0 01-.5.5H3a2 2 0 01-2-2V4.5a.5.5 0 01.5-.5zM12 10v1.5a1.5 1.5 0 01-1.5 1.5H3a3 3 0 01-3-3V4.5A1.5 1.5 0 011.5 3H9a3 3 0 013 3l2.8-2.1a.75.75 0 011.2.6v7a.75.75 0 01-1.2.6L12 10zm0-1.25L15 11V5l-3 2.25v1.5z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 16,
              height: 16
            },
            "icon-video-muted-outline": {
              component: function component(e) {
                return s.createElement("svg", Hq({
                  width: 24,
                  height: 24,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), CV || (CV = s.createElement("g", {
                  clipPath: "url(#clip0)",
                  filter: "url(#filter0_d)"
                }, s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M19.146.146a.5.5 0 01.708.708L15.796 4.91c.132.338.204.705.204 1.089l2.8-2.1a.75.75 0 011.2.6v7a.75.75 0 01-1.2.6L16 10v1.5a1.5 1.5 0 01-1.5 1.5H7.707l-2.853 2.854a.5.5 0 01-.708-.708l2.215-2.214A3.001 3.001 0 014 10V4.5A1.5 1.5 0 015.5 3H13c.903 0 1.713.399 2.263 1.03L19.146.146zM14.553 4.74A1.996 1.996 0 0013 4H5.5a.5.5 0 00-.5.5V10a2 2 0 002 2h.293l7.26-7.26zM8.707 12H14.5a.5.5 0 00.5-.5V6c0-.093-.006-.185-.019-.274L8.707 12zM19 11l-3-2.25v-1.5L19 5v6z",
                  fill: "#FF5C5C"
                }))), kV || (kV = s.createElement("defs", null, s.createElement("clipPath", {
                  id: "clip0"
                }, s.createElement("rect", {
                  width: 16,
                  height: 16,
                  fill: "#fff",
                  transform: "translate(4)"
                })), s.createElement("filter", {
                  id: "filter0_d",
                  x: 0,
                  y: 0,
                  width: 24,
                  height: 24,
                  filterUnits: "userSpaceOnUse",
                  colorInterpolationFilters: "sRGB"
                }, s.createElement("feFlood", {
                  floodOpacity: 0,
                  result: "BackgroundImageFix"
                }), s.createElement("feColorMatrix", {
                  in: "SourceAlpha",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }), s.createElement("feOffset", {
                  dy: 4
                }), s.createElement("feGaussianBlur", {
                  stdDeviation: 2
                }), s.createElement("feColorMatrix", {
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                }), s.createElement("feBlend", {
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow"
                }), s.createElement("feBlend", {
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow",
                  result: "shape"
                })))));
              },
              width: 24,
              height: 24
            },
            "icon-participant": {
              component: function component(e) {
                return s.createElement("svg", Vq({
                  width: 17,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), AV || (AV = s.createElement("g", {
                  clipPath: "url(#clip0)"
                }, s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M5.5 7.667a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zm9-1.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM5.5 9c-3 0-5 1.343-5 3a2 2 0 002 2h6a2.01 2.01 0 00.403-.04A2 2 0 0010.5 12c0-.636-.295-1.226-.828-1.711C8.817 9.509 7.348 9 5.5 9zm9.5 5h-4.264c.475-.53.764-1.232.764-2 0-.734-.257-1.387-.68-1.936.364-.042.757-.064 1.18-.064 3 0 4.5 1.12 4.5 2.5A1.5 1.5 0 0115 14z",
                  fill: "#fff",
                  fillOpacity: .62
                }))));
              },
              width: 17,
              height: 16
            },
            "icon-recording": {
              component: function component(e) {
                return s.createElement("svg", qq({
                  width: 6,
                  height: 6,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), IV || (IV = s.createElement("circle", {
                  cx: 3,
                  cy: 3,
                  r: 3,
                  fill: "#FF5C5C"
                })));
              },
              width: 6,
              height: 6
            },
            "icon-recording-text": {
              component: function component(e) {
                return s.createElement("svg", Fq({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), TV || (TV = s.createElement("g", {
                  fill: "#FF5C5C"
                }, s.createElement("circle", {
                  cx: 10,
                  cy: 11,
                  r: 3
                }), s.createElement("path", {
                  d: "M18.475 11.648h1.206l1.313 2.579h1.67l-1.484-2.798c.81-.318 1.279-1.099 1.279-2.002 0-1.392-.952-2.246-2.5-2.246H17v7.046h1.475v-2.579zm0-3.315h1.279c.732 0 1.191.43 1.191 1.113 0 .699-.434 1.104-1.176 1.104h-1.294V8.333zM28.611 13.01h-3.193V11.23h3.013v-1.133h-3.013v-1.7h3.193V7.181h-4.668v7.046h4.668V13.01zM33.157 14.407c1.7 0 2.94-1.03 3.062-2.534h-1.436c-.141.776-.776 1.275-1.62 1.275-1.114 0-1.803-.938-1.803-2.447 0-1.509.689-2.446 1.797-2.446.84 0 1.48.537 1.621 1.352h1.436C36.106 8.094 34.827 7 33.157 7c-2.046 0-3.305 1.411-3.305 3.701s1.264 3.706 3.305 3.706z",
                  fill: "#fff",
                  fillOpacity: .62
                }))));
              },
              width: 45,
              height: 12
            },
            "icon-resume": {
              component: function component(e) {
                return s.createElement("svg", Wq({
                  viewBox: 0,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), OV || (OV = s.createElement("path", {
                  d: "M3 13.26V2.742a1 1 0 011.504-.864l9.015 5.259a1 1 0 010 1.727l-9.015 5.26A1 1 0 013 13.26z"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-pause": {
              component: function component(e) {
                return s.createElement("svg", Pq({
                  width: 12,
                  height: 12,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), mV || (mV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M4 2a1 1 0 00-1 1v10a1 1 0 102 0V3a1 1 0 00-1-1zm8 0a1 1 0 00-1 1v10a1 1 0 102 0V3a1 1 0 00-1-1z"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-stop": {
              component: function component(e) {
                return s.createElement("svg", Mq({
                  viewBox: 0,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), yV || (yV = s.createElement("rect", {
                  x: 3,
                  y: 3,
                  width: 10,
                  height: 10,
                  rx: 1
                })));
              },
              width: 16,
              height: 16
            },
            "icon-thumbnail": {
              component: function component(e) {
                return s.createElement("svg", Gq({
                  width: 16,
                  height: 16,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), RV || (RV = s.createElement("rect", {
                  x: 2,
                  y: 11,
                  width: 12,
                  height: 3,
                  rx: 1
                })));
              },
              width: 16,
              height: 16
            },
            "icon-thumbnail-ribbon": {
              component: function component(e) {
                return s.createElement("svg", Kq({
                  width: 16,
                  height: 16,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), NV || (NV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M3 2a1 1 0 00-1 1v3a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1H3zm0 7a1 1 0 00-1 1v3a1 1 0 001 1h10a1 1 0 001-1v-3a1 1 0 00-1-1H3z"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-thumbnail-speaker": {
              component: function component(e) {
                return s.createElement("svg", Qq({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), PV || (PV = s.createElement("rect", {
                  x: 1.5,
                  y: 4.5,
                  width: 9,
                  height: 6,
                  rx: .75
                })));
              },
              width: 12,
              height: 12
            },
            "icon-thumbnail-gallery": {
              component: function component(e) {
                return s.createElement("svg", Zq({
                  viewBox: 0,
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), jV || (jV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M4.5 1.5a.75.75 0 01.75-.75h1.5a.75.75 0 01.75.75V3a.75.75 0 01-.75.75h-1.5A.75.75 0 014.5 3V1.5zm-3.75 0A.75.75 0 011.5.75H3a.75.75 0 01.75.75V3a.75.75 0 01-.75.75H1.5A.75.75 0 01.75 3V1.5zM9 .75a.75.75 0 00-.75.75V3c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75V1.5a.75.75 0 00-.75-.75H9zM.75 5.25a.75.75 0 01.75-.75H3a.75.75 0 01.75.75v1.5A.75.75 0 013 7.5H1.5a.75.75 0 01-.75-.75v-1.5zm4.5-.75a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75h-1.5zm3 .75A.75.75 0 019 4.5h1.5a.75.75 0 01.75.75v1.5a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v-1.5zm-6.75 3A.75.75 0 00.75 9v1.5c0 .414.336.75.75.75H3a.75.75 0 00.75-.75V9A.75.75 0 003 8.25H1.5zm3 .75a.75.75 0 01.75-.75h1.5A.75.75 0 017.5 9v1.5a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75V9zM9 8.25a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75V9a.75.75 0 00-.75-.75H9z",
                  fillOpacity: .8
                })));
              },
              width: 12,
              height: 12
            },
            "icon-move": {
              component: function component(e) {
                return s.createElement("svg", Yq({
                  width: 17,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), DV || (DV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M6.5 5a1 1 0 100-2 1 1 0 000 2zm4 0a1 1 0 100-2 1 1 0 000 2zm-3 3a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zm-3 3a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 17,
              height: 16
            },
            "icon-down-arrow": {
              component: function component(e) {
                return s.createElement("svg", Jq({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), zV || (zV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M12.442 9.442a.625.625 0 10-.884-.884l-2.933 2.933V3a.625.625 0 10-1.25 0v8.491L4.442 8.558a.625.625 0 10-.884.884l4 4c.244.244.64.244.884 0l4-4z",
                  fill: "#fff"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-search": {
              component: function component(e) {
                return s.createElement("svg", eF({
                  width: 10,
                  height: 10,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), UV || (UV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M7 4a3 3 0 11-6 0 3 3 0 016 0zm-.547 3.16a4 4 0 11.707-.707l2.694 2.693a.5.5 0 01-.708.708L6.453 7.16z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 10,
              height: 10
            },
            "icon-avatar": {
              component: function component(e) {
                return s.createElement("svg", $q({
                  width: 24,
                  height: 24,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), MV || (MV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M12 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 2.25c-4.5 0-7.875 2.015-7.875 4.5 0 1.243 1.163 2.25 2.25 2.25h11.25c1.087 0 2.25-1.007 2.25-2.25 0-2.485-3.375-4.5-7.875-4.5z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 24,
              height: 24
            },
            "icon-avatar-admin": {
              component: function component(e) {
                return s.createElement("svg", Xq({
                  width: 24,
                  height: 24,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  className: "lazy-svg-icon__icon"
                }, e), LV || (LV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M14.5 7.5a4 4 0 11-8 0 4 4 0 018 0zm-3.474 6.01A6.348 6.348 0 0010 17c0 1.537.53 2.939 1.4 4H6a3 3 0 01-3-3c0-.65.205-1.27.592-1.83a4.724 4.724 0 011.23-1.195 6.12 6.12 0 01.24-.157C6.376 14.004 8.25 13.5 10.5 13.5c.178 0 .353.003.526.01zm2.607.03c-.312-.09-.653-.007-.856.246a4.77 4.77 0 00-.727 1.257c-.118.302-.019.639.214.864l.23.224a.895.895 0 010 1.286l-.23.223c-.233.226-.332.563-.214.865.178.457.424.88.727 1.257.203.253.544.336.856.247l.308-.088a.895.895 0 011.113.643l.078.311c.08.315.322.57.643.618a4.813 4.813 0 001.45 0c.321-.049.564-.303.643-.618l.078-.311a.895.895 0 011.113-.643l.308.088c.312.089.653.006.857-.247.302-.376.548-.8.726-1.257.118-.302.019-.639-.214-.864l-.23-.224a.895.895 0 010-1.286l.23-.224c.233-.225.332-.562.214-.864a4.768 4.768 0 00-.726-1.257c-.204-.253-.545-.336-.857-.247l-.308.088a.895.895 0 01-1.113-.643l-.078-.311c-.08-.315-.322-.57-.643-.618a4.812 4.812 0 00-1.45 0c-.321.049-.564.303-.643.618l-.078.311a.895.895 0 01-1.113.643l-.308-.088zm2.866 5.024a1.79 1.79 0 100-3.58 1.79 1.79 0 000 3.58z",
                  fill: "#fff",
                  fillOpacity: .56
                })));
              },
              width: 24,
              height: 24
            },
            "icon-leave": {
              component: function component(e) {
                return s.createElement("svg", tF({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), BV || (BV = s.createElement("path", {
                  d: "M14.847 6.866l.608-.608a1.86 1.86 0 000-2.63C11.338-.49 4.662-.49.545 3.627a1.86 1.86 0 000 2.63l.608.608.09.089a1.86 1.86 0 002.551 0l.09-.089.266-.266c.366-.366.615-.832.717-1.34l.179-.895a.96.96 0 01.597-.709 6.566 6.566 0 014.714 0 .96.96 0 01.597.709l.18.896c.1.507.35.973.716 1.34l.266.265.09.089a1.86 1.86 0 002.641-.089z",
                  fill: "#FF5C5C"
                })));
              },
              width: 16,
              height: 8
            },
            "icon-chat-outline": {
              component: function component(e) {
                return s.createElement("svg", nF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), HV || (HV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M4 11a1 1 0 011 1v1.586l2-2A2 2 0 018.414 11H12a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v3a2 2 0 002 2zM1 6v3a3 3 0 003 3v2.793a.5.5 0 00.854.353l2.853-2.853A1 1 0 018.414 12H12a3 3 0 003-3V6a3 3 0 00-3-3H4a3 3 0 00-3 3z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 16,
              height: 16
            },
            "icon-files-outline": {
              component: function component(e) {
                return s.createElement("svg", rF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), VV || (VV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M3 12V4a2 2 0 012-2h4v2.5A1.5 1.5 0 0010.5 6H13v6a2 2 0 01-2 2H5a2 2 0 01-2-2zm9.586-7L10 2.414V4.5a.5.5 0 00.5.5h2.086zM2 4v8a3 3 0 003 3h6a3 3 0 003-3V5.828a2 2 0 00-.586-1.414l-2.828-2.828A2 2 0 009.172 1H5a3 3 0 00-3 3z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 16,
              height: 16
            },
            "icon-new-window": {
              component: function component(e) {
                return s.createElement("svg", iF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), qV || (qV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M3 5a2 2 0 012-2h1.5a.5.5 0 000-1H5a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V9.5a.5.5 0 00-1 0V11a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm3.646 3.646a.5.5 0 10.708.708L13 3.707V6.5a.5.5 0 001 0v-4a.5.5 0 00-.5-.5h-4a.5.5 0 000 1h2.793L6.646 8.646z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 16,
              height: 16
            },
            "icon-privacy": {
              component: function component(e) {
                return s.createElement("svg", uF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), $V || ($V = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M8 7a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 100-6 3 3 0 000 6zm-4.062 4.832c.134.135.265.168.312.168h4.041a6.2 6.2 0 00.392 1H4.25c-.725 0-1.5-.709-1.5-1.583C2.75 10.667 5 9.25 8 9.25c.137 0 .273.003.406.009-.195.184-.334.439-.364.753l-.02.238H8c-1.354 0-2.478.322-3.228.78-.762.466-1.022.982-1.022 1.387 0 .136.062.288.188.415z",
                  fill: "#fff",
                  fillOpacity: .54
                })), XV || (XV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M9.06 9.902c1.605.218 3.437-1.898 3.44-1.902.003.004 1.835 2.12 3.44 1.902.454 3.875-1.782 5.622-3.384 6.083a.199.199 0 01-.112 0c-1.602-.46-3.838-2.208-3.384-6.083z",
                  fill: "#0E72ED"
                })));
              },
              width: 16,
              height: 16
            },
            "icon-chat": {
              component: function component(e) {
                return s.createElement("svg", pF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), eq || (eq = s.createElement("path", {
                  d: "M1 9V6a3 3 0 013-3h8a3 3 0 013 3v3a3 3 0 01-3 3H8l-3.146 3.146A.5.5 0 014 14.793V12a3 3 0 01-3-3z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 16
            },
            "icon-hand-raise": {
              component: function component(e) {
                return s.createElement("svg", hF({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), tq || (tq = s.createElement("path", {
                  d: "M11.6 7.648c0 .173-.073.322-.22.471a10.9 10.9 0 00-.903.819c-.707.695-1.342 1.513-1.952 2.53C7.574 13.059 5.915 14 4.085 14h-.147A3.72 3.72 0 01.4 10.253v-6.7c0-.397.293-.744.659-.794a.69.69 0 01.561.199.803.803 0 01.244.546v4.094c0 .149.098.248.244.248s.244-.1.244-.248V1.84c0-.397.293-.744.659-.77.22-.049.415.026.561.174a.803.803 0 01.244.546V7.35c0 .149.098.248.244.248s.244-.1.244-.248V.799c0-.397.293-.745.659-.794a.69.69 0 01.561.198.803.803 0 01.244.546v6.353c0 .148.098.248.244.248.147 0 .244-.1.244-.248v-5.36c0-.199.098-.422.244-.546.147-.15.366-.199.561-.199.366.05.66.372.66.794v5.857a.68.68 0 00.39.62.62.62 0 00.707-.1c.805-.719 1.464-1.14 1.88-1.19.463-.05.755.198.853.471.024.025.049.124.049.199z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 12,
              height: 16
            },
            "icon-q&a": {
              component: function component(e) {
                return s.createElement("svg", _F({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), nq || (nq = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M16 7V4c0-1.1-.9-2-2-2H8c-.85 0-1.61.54-1.89 1.33a.502.502 0 00.48.67H8c1.66 0 3 1.34 3 3v1.5c0 .28.29.5.29.5l1.86 1.85c.09.1.22.15.35.15.06 0 .13-.01.19-.04.19-.08.31-.26.31-.46V9c1.1 0 2-.9 2-2zm-6 3V7c0-1.1-.9-2-2-2H2C.9 5 0 5.9 0 7v3.01a2 2 0 002 2v1.49c0 .2.12.38.31.46.06.03.13.04.19.04.13 0 .26-.05.35-.15L4.71 12H8c1.1 0 2-.9 2-2z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 16
            },
            "icon-settings": {
              component: function component(e) {
                return s.createElement("svg", fF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), rq || (rq = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M4.178 3.687c-.416-.119-.871-.008-1.142.33a6.358 6.358 0 00-.97 1.675c-.156.403-.024.852.286 1.153l.308.298a1.193 1.193 0 010 1.714l-.308.298c-.31.301-.442.75-.285 1.153.237.61.566 1.174.969 1.676.27.337.726.448 1.142.329l.41-.117a1.193 1.193 0 011.484.857l.105.415c.105.42.429.759.857.824a6.404 6.404 0 001.933 0c.428-.065.751-.404.857-.824l.104-.415a1.193 1.193 0 011.485-.857l.41.117c.416.119.87.008 1.142-.33a6.36 6.36 0 00.969-1.675c.157-.403.025-.852-.286-1.153l-.307-.298a1.193 1.193 0 010-1.714l.307-.298c.311-.301.443-.75.286-1.153a6.36 6.36 0 00-.97-1.676c-.27-.337-.725-.448-1.141-.33l-.41.118a1.193 1.193 0 01-1.485-.857l-.104-.415c-.106-.42-.43-.76-.857-.824a6.416 6.416 0 00-1.933 0c-.428.065-.752.404-.857.824l-.105.415a1.193 1.193 0 01-1.484.857l-.41-.117zM8 10.387a2.387 2.387 0 100-4.774 2.387 2.387 0 000 4.774z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 16
            },
            "icon-closed-caption": {
              component: function component(e) {
                return s.createElement("svg", cF({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), ZV || (ZV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M3 0a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V3a3 3 0 00-3-3H3zm4.648 6.825c-.085 1.067-.954 1.801-2.143 1.801-1.429 0-2.314-.987-2.314-2.594 0-1.603.882-2.59 2.314-2.59 1.169 0 2.064.775 2.14 1.849H6.64c-.1-.568-.547-.94-1.135-.94-.776 0-1.258.642-1.258 1.681 0 1.04.482 1.685 1.261 1.685.592 0 1.036-.348 1.135-.892h1.005zm5.188 0c-.085 1.067-.953 1.801-2.143 1.801-1.428 0-2.314-.987-2.314-2.594 0-1.603.882-2.59 2.314-2.59 1.17 0 2.065.775 2.14 1.849h-1.005c-.099-.568-.547-.94-1.135-.94-.776 0-1.257.642-1.257 1.681 0 1.04.481 1.685 1.26 1.685.592 0 1.036-.348 1.136-.892h1.004z",
                  fill: "#4793F1"
                })));
              },
              width: 16,
              height: 12
            },
            "icon-closed-caption-btn": {
              component: function component(e) {
                return s.createElement("svg", lF({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), YV || (YV = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M3 0a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V3a3 3 0 00-3-3H3zm4.648 6.825c-.085 1.067-.954 1.801-2.143 1.801-1.429 0-2.314-.987-2.314-2.594 0-1.603.882-2.59 2.314-2.59 1.169 0 2.064.775 2.14 1.849H6.64c-.1-.568-.547-.94-1.135-.94-.776 0-1.258.642-1.258 1.681 0 1.04.482 1.685 1.261 1.685.592 0 1.036-.348 1.135-.892h1.005zm5.188 0c-.085 1.067-.953 1.801-2.143 1.801-1.428 0-2.314-.987-2.314-2.594 0-1.603.882-2.59 2.314-2.59 1.17 0 2.065.775 2.14 1.849h-1.005c-.099-.568-.547-.94-1.135-.94-.776 0-1.257.642-1.257 1.681 0 1.04.481 1.685 1.26 1.685.592 0 1.036-.348 1.136-.892h1.004z",
                  fill: "#fff",
                  fillOpacity: .62
                })));
              },
              width: 16,
              height: 12
            },
            "icon-raise-hand": {
              component: function component(e) {
                return s.createElement("svg", dF({
                  viewBox: 0,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), JV || (JV = s.createElement("path", {
                  d: "M11.6 7.648c0 .173-.073.322-.22.471a10.9 10.9 0 00-.903.819c-.707.695-1.342 1.513-1.952 2.53C7.574 13.059 5.915 14 4.085 14h-.147A3.72 3.72 0 01.4 10.253v-6.7c0-.397.293-.744.659-.794a.69.69 0 01.561.199.803.803 0 01.244.546v4.094c0 .149.098.248.244.248s.244-.1.244-.248V1.84c0-.397.293-.744.659-.77.22-.049.415.026.561.174a.803.803 0 01.244.546V7.35c0 .149.098.248.244.248s.244-.1.244-.248V.799c0-.397.293-.745.659-.794a.69.69 0 01.561.198.803.803 0 01.244.546v6.353c0 .148.098.248.244.248.147 0 .244-.1.244-.248v-5.36c0-.199.098-.422.244-.546.147-.15.366-.199.561-.199.366.05.66.372.66.794v5.857a.68.68 0 00.39.62.62.62 0 00.707-.1c.805-.719 1.464-1.14 1.88-1.19.463-.05.755.198.853.471.024.025.049.124.049.199z",
                  fill: "#4793F1"
                })));
              },
              width: 16,
              height: 17
            },
            "icon-sharing-audio-on": {
              component: function component(e) {
                return s.createElement("svg", mF({
                  width: 17,
                  height: 17,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), iq || (iq = s.createElement("g", {
                  clipPath: "url(#clip0_122_8061)"
                }, s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.22 1.256a.512.512 0 00-.52.05l-3.87 2.9H3a2.5 2.5 0 00-2.5 2.5v3a2.5 2.5 0 002.5 2.5h2.83l3.87 2.9c.09.07.19.1.3.1.08 0 .15-.02.22-.05.17-.09.28-.26.28-.45v-13c0-.19-.11-.36-.28-.45zm6.28 6.95a8.006 8.006 0 01-1.978 5.271.501.501 0 01-.751-.665A6.941 6.941 0 0015.5 8.206 6.946 6.946 0 0013.771 3.6a.501.501 0 01.751-.664A8.006 8.006 0 0116.5 8.206zm-4.101 3.136A5.006 5.006 0 0013.5 8.206a5.006 5.006 0 00-1.101-3.136.482.482 0 00-.719-.044l-.031.03a.489.489 0 00-.028.65c.548.688.879 1.557.879 2.5 0 .943-.331 1.812-.879 2.501a.487.487 0 00.028.648l.031.031a.483.483 0 00.719-.044z",
                  fill: "#F5F5F5"
                }))), oq || (oq = s.createElement("defs", null, s.createElement("clipPath", {
                  id: "clip0_122_8061"
                }, s.createElement("rect", {
                  width: 16,
                  height: 16,
                  fill: "#fff",
                  transform: "translate(.5 .208)"
                })))));
              },
              width: 17,
              height: 17
            },
            "icon-sharing-audio-off": {
              component: function component(e) {
                return s.createElement("svg", gF({
                  width: 17,
                  height: 17,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), aq || (aq = s.createElement("g", {
                  clipPath: "url(#clip0_122_7950)"
                }, s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.22 1.256a.512.512 0 00-.52.05l-3.87 2.9H3a2.5 2.5 0 00-2.5 2.5v3a2.5 2.5 0 002.5 2.5h2.83l3.87 2.9c.09.07.19.1.3.1.08 0 .15-.02.22-.05.17-.09.28-.26.28-.45v-13c0-.19-.11-.36-.28-.45zm1.426 4.598a.5.5 0 01.708 0L14 7.5l1.646-1.646a.5.5 0 01.708.707l-1.647 1.647 1.647 1.646a.5.5 0 01-.708.707L14 8.915l-1.646 1.646a.5.5 0 01-.708-.707l1.647-1.646-1.647-1.647a.5.5 0 010-.707z",
                  fill: "#F5F5F5"
                }))), sq || (sq = s.createElement("defs", null, s.createElement("clipPath", {
                  id: "clip0_122_7950"
                }, s.createElement("rect", {
                  width: 16,
                  height: 16,
                  fill: "#fff",
                  transform: "translate(.5 .208)"
                })))));
              },
              width: 17,
              height: 17
            },
            "icon-help": {
              component: function component(e) {
                return s.createElement("svg", vF({
                  width: 14,
                  height: 14,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), cq || (cq = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M7 1c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm0-1C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 9.804c-.3 0-.6.3-.6.6s.3.6.6.6.6-.3.6-.6-.3-.6-.6-.6zM6.5 8.5c0 .3.2.5.5.5s.5-.2.5-.5c0-.8.3-1.5.8-2 .4-.4.7-.9.7-1.5 0-1.1-.9-2-2-2s-2 .9-2 2c0 .3.2.5.5.5S6 5.3 6 5c0-.6.4-1 1-1s1 .4 1 1c0 .3-.1.6-.3.8-.8.6-1.2 1.6-1.2 2.7z",
                  fill: "#fff",
                  fillOpacity: .54
                })));
              },
              width: 14,
              height: 14
            },
            "icon-new-badge": {
              component: function component(e) {
                return s.createElement("svg", bF({
                  width: 36,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), lq || (lq = s.createElement("path", {
                  d: "M0 3a3 3 0 013-3h27a6 6 0 016 6v7a3 3 0 01-3 3H6a6 6 0 01-6-6V3z",
                  fill: "url(#paint0_linear_2311_53851)"
                })), dq || (dq = s.createElement("path", {
                  d: "M6.287 12V5.443h.094L10.969 12h1.025V3.545h-1.043v6.58h-.094L6.27 3.545H5.244V12h1.043zm13.102-.95h-4.184V8.146h3.967v-.938h-3.967V4.494h4.184v-.95H14.15V12h5.239v-.95zm6.603-5.724h.07L28.009 12h.996l2.303-8.455h-1.102l-1.682 6.873h-.07l-1.892-6.873h-1.067l-1.892 6.873h-.07L21.85 3.545h-1.102L23.051 12h.996l1.945-6.674z",
                  fill: "#fff"
                })), uq || (uq = s.createElement("defs", null, s.createElement("linearGradient", {
                  id: "paint0_linear_2311_53851",
                  x1: 6.545,
                  y1: 0,
                  x2: 30.373,
                  y2: 15.596,
                  gradientUnits: "userSpaceOnUse"
                }, s.createElement("stop", {
                  stopColor: "#0E72ED"
                }), s.createElement("stop", {
                  offset: 1,
                  stopColor: "#E8173D"
                })))));
              },
              width: 36,
              height: 16
            },
            "icon-audio-active-animated": {
              component: function component(e) {
                return s.createElement("svg", yF({
                  width: 24,
                  height: 24,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), pq || (pq = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M8 5a4 4 0 118 0v7a4 4 0 01-8 0V5zm4.75 13.96A7.001 7.001 0 0019 12a.75.75 0 00-1.5 0 5.5 5.5 0 11-11 0A.75.75 0 005 12a7.001 7.001 0 006.25 6.96v2.54H9A.75.75 0 009 23h6a.75.75 0 000-1.5h-2.25v-2.54z",
                  fill: "#fff",
                  fillOpacity: .62
                })), hq || (hq = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M15.465 14h-6.93A3.998 3.998 0 0012 16c1.48 0 2.773-.804 3.465-2z",
                  fill: "#23D959"
                }, s.createElement("animate", {
                  attributeName: "d",
                  values: "M15.4649 14H8.53516C9.22678 15.1956 10.5195 16 12 16C13.4806 16 14.7733 15.1956 15.4649 14Z;M16 12H8C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z;M16 10H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V10Z;M16 7H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V7Z;M8.12602 4C8.04375 4.31962 8 4.6547 8 5V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V5C16 4.6547 15.9562 4.31962 15.874 4H8.12602Z;M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V5Z;M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V5Z;M8.12602 4C8.04375 4.31962 8 4.6547 8 5V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V5C16 4.6547 15.9562 4.31962 15.874 4H8.12602Z;M16 7H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V7Z;M16 10H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V10Z;M16 12H8C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z;M15.4649 14H8.53516C9.22678 15.1956 10.5195 16 12 16C13.4806 16 14.7733 15.1956 15.4649 14Z",
                  calcMode: "linear",
                  dur: "0.8s",
                  repeatCount: "indefinite"
                }))));
              },
              width: 24,
              height: 24
            },
            "icon-archiving-tooltip": {
              component: function component(e) {
                return s.createElement("svg", wF({
                  width: 14,
                  height: 12,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), _q || (_q = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M1.294 1h11.412c.162 0 .294.132.294.294v1.412a.294.294 0 01-.294.294H1.294A.294.294 0 011 2.706V1.294C1 1.132 1.132 1 1.294 1zM1 3.966c-.573-.133-1-.647-1-1.26V1.294C0 .58.58 0 1.294 0h11.412C13.42 0 14 .58 14 1.294v1.412c0 .613-.427 1.127-1 1.26v6.74C13 11.42 12.42 12 11.706 12H2.294C1.58 12 1 11.42 1 10.706v-6.74zM2 4v6.706c0 .162.132.294.294.294h9.412a.294.294 0 00.294-.294V4H2z",
                  fill: "#fff",
                  fillOpacity: .62
                })), fq || (fq = s.createElement("line", {
                  x1: 4.5,
                  y1: 6.5,
                  x2: 9.5,
                  y2: 6.5,
                  stroke: "#fff",
                  strokeOpacity: .62,
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                })));
              },
              width: 14,
              height: 12
            },
            "icon-upvote": {
              component: function component(e) {
                return s.createElement("svg", SF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), mq || (mq = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M13.998 7.915l-.006.076.002.019-.969 4.813a1.595 1.595 0 01-1.537 1.176l-.987.001H10.5L5 13.994v-6.67a4.685 4.685 0 001.648-1.317c.709-.88 1.162-2.022 1.193-3.174l.002-.057-.001-.017v-.032c0-.419.328-.727.696-.727.313 0 .598.223.674.555.083.382.132.76.132 1.139 0 .647-.122 1.562-.296 2.07l-.454 1.323 1.399.001 3.216.004.029.004.057.003c.233.009.457.13.592.352a.776.776 0 01.11.464zM4 7.634c-.108.017-.217.03-.328.038l-.036.003H2v6.318h2V7.634zm7.49 7.365a2.595 2.595 0 002.51-1.95l.978-4.861a.603.603 0 00.017-.2 1.777 1.777 0 00-.254-1.058 1.723 1.723 0 00-1.406-.83.568.568 0 00-.088-.008l-2.209-.003H9.994c.096-.28.174-.632.233-1 .076-.48.117-.988.117-1.395 0-.467-.06-.92-.156-1.357A1.702 1.702 0 008.538 1c-.937 0-1.696.773-1.696 1.727 0 .022-.001.03-.002.037l.002.042c-.05 1.833-1.463 3.74-3.242 3.869H2a1 1 0 00-1 1v6.318a1 1 0 001 1h2.007L10.5 15l.99-.001z",
                  fill: "#fff",
                  fillOpacity: .56
                })));
              },
              width: 16,
              height: 16
            },
            "icon-delete": {
              component: function component(e) {
                return s.createElement("svg", xF({
                  width: 16,
                  height: 16,
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, e), gq || (gq = s.createElement("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M6.67 3.276A.5.5 0 017.119 3h1.764a.5.5 0 01.447.276L9.691 4H6.309l.362-.724zM5.192 4l.585-1.17A1.5 1.5 0 017.118 2h1.764a1.5 1.5 0 011.342.83L10.809 4H13.5a.5.5 0 010 1h-.6l-.765 7.65A1.5 1.5 0 0110.643 14H5.357a1.5 1.5 0 01-1.492-1.35L3.1 5h-.6a.5.5 0 010-1h2.691zM4.105 5h7.79l-.755 7.55a.5.5 0 01-.498.45H5.357a.5.5 0 01-.497-.45L4.105 5zM6 6.5a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zM9.5 6a.5.5 0 00-.5.5v5a.5.5 0 001 0v-5a.5.5 0 00-.5-.5z",
                  fill: "#fff",
                  fillOpacity: .56
                })));
              },
              width: 16,
              height: 16
            }
          },
              CF = function CF(e) {
            var t = e.type,
                n = e.className,
                r = e.iconStyle;
            var _EF$t = EF[t],
                i = _EF$t.component,
                o = _EF$t.width,
                a = _EF$t.height;
            return i ? TH.exports.jsx(Mk, {
              className: n,
              component: i,
              viewBox: "0 0 ".concat(o, " ").concat(a),
              style: r
            }) : null;
          },
              kF = ["iconType", "endIconType"],
              AF = Pk(function (e) {
            return {
              root: _defineProperty({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minWidth: e.spacing(6),
                color: e.palette.toolbar.main,
                textTransform: "none"
              }, "&.".concat(kH, "-MuiButton-root"), {
                "&:hover": {
                  filter: "none",
                  backgroundColor: e.palette.action.hover
                },
                "&:active": {
                  filter: "none",
                  backgroundColor: e.palette.action.active
                },
                "&:disabled": {
                  filter: "opacity(0.6)"
                }
              }),
              startIcon: _defineProperty({
                margin: e.spacing(0)
              }, "&.".concat(kH, "-MuiButton-iconSizeSmall"), {
                margin: e.spacing(0)
              })
            };
          })(a.default.forwardRef(function (e, t) {
            var n = e.iconType,
                r = e.endIconType,
                i = h(e, kF);
            return "icon-audio-warning" === n ? TH.exports.jsx(YA, u({
              size: "small",
              ref: t,
              startIcon: TH.exports.jsx(CF, {
                type: n,
                iconStyle: {
                  fontSize: "27px",
                  transform: "translateY(3px) translateX(-1px)"
                }
              }),
              style: {
                padding: 0,
                width: "28px",
                height: "26px",
                margin: 0
              }
            }, i)) : "icon-video-warning" === n ? TH.exports.jsx(YA, u({
              size: "small",
              ref: t,
              startIcon: TH.exports.jsx(CF, {
                type: n,
                iconStyle: {
                  fontSize: "32px",
                  transform: "translateY(1px) translateX(1px)"
                }
              }),
              style: {
                padding: 0,
                width: "32px",
                height: "26px",
                margin: 0
              }
            }, i)) : "icon-audio-active-animated" === n ? TH.exports.jsx(YA, u({
              size: "small",
              ref: t,
              startIcon: TH.exports.jsx(CF, {
                type: n,
                iconStyle: {
                  fontSize: "18px"
                }
              })
            }, i)) : TH.exports.jsx(YA, u({
              size: "small",
              ref: t,
              startIcon: n && TH.exports.jsx(CF, {
                type: n
              }),
              endIcon: r && TH.exports.jsx(CF, {
                type: r
              })
            }, i));
          })),
              IF = ["text", "icon", "checked", "count", "onClick"],
              TF = ["onClick", "key"],
              OF = ["onClick", "key"],
              RF = Pk(function (e) {
            var _root2;

            return {
              root: (_root2 = {
                color: e.palette.text.secondary,
                fontSize: "13px",
                "&:hover": {
                  background: "rgba(255,255,255,0.1)",
                  color: e.palette.text.primary
                }
              }, _defineProperty(_root2, "& .".concat(kH, "-MuiListItemText-root .").concat(kH, "-MuiTypography-root"), {
                fontSize: "13px"
              }), _defineProperty(_root2, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "13px"
              }), _defineProperty(_root2, "& .".concat(kH, "-MuiListItemIcon-root"), {
                minWidth: "22px"
              }), _root2)
            };
          })(function (e) {
            var t = e.text,
                n = e.icon,
                r = e.checked,
                i = e.count,
                o = e.onClick,
                a = h(e, IF);
            if (n || r) return TH.exports.jsxs(lO, u(u({}, a), {}, {
              onClick: o,
              children: [TH.exports.jsxs(BT, {
                children: [n && TH.exports.jsx(CF, {
                  type: n
                }), r && TH.exports.jsx(CF, {
                  type: "icon-checked"
                })]
              }), TH.exports.jsx(VT, {
                primary: t
              })]
            }));

            if (i) {
              var _e286 = i > 99 ? "99+" : i.toString();

              return TH.exports.jsxs(lO, u(u({
                style: {
                  paddingLeft: "38px",
                  minHeight: "39px"
                },
                onClick: o
              }, a), {}, {
                children: [t, TH.exports.jsx(WA, {
                  style: {
                    marginLeft: "5px",
                    backgroundColor: "#DE2828",
                    minWidth: "14px",
                    height: "14px",
                    borderRadius: "5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFFFFF",
                    padding: "2px"
                  },
                  children: TH.exports.jsx(QA, {
                    variant: "body1",
                    children: TH.exports.jsx("b", {
                      children: _e286
                    })
                  })
                })]
              }));
            }

            return TH.exports.jsx(lO, u(u({
              style: {
                paddingLeft: "38px",
                minHeight: "39px"
              },
              onClick: o
            }, a), {}, {
              children: t
            }));
          }),
              NF = Ok(function () {
            return {
              paper: {
                borderRadius: "8px",
                marginTop: "15px",
                minWidth: "200px",
                border: "1px solid rgba(255,255,255,0.12)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                backdropFilter: "blur(20px)"
              },
              divider: {
                height: "2px"
              }
            };
          }),
              PF = function PF(t) {
            var n = t.iconType,
                r = t.endIconType,
                i = t.disabled,
                o = t.menu,
                s = t.className,
                c = t.wrapClassName,
                l = t.children,
                d = t.placement,
                p = t.title,
                _ = t.onOpen,
                _e$useState21 = e.useState(!1),
                _e$useState22 = _slicedToArray(_e$useState21, 2),
                f = _e$useState22[0],
                m = _e$useState22[1],
                g = e.useRef(null),
                v = NF(),
                b = function b(e) {
              var t;
              null !== (t = g.current) && void 0 !== t && t.contains(e.target) || (m(!1), null == _ || _(!1));
            };

            function y(e) {
              "Tab" === e.key && (e.preventDefault(), null == _ || _(!1), m(!1));
            }

            var w = a.default.useRef(f);
            e.useEffect(function () {
              !0 === w.current && !1 === f && g.current.focus(), w.current = f;
            }, [f]);
            var S = d ? {
              placement: d
            } : {};
            return TH.exports.jsxs("div", {
              children: [TH.exports.jsx(AF, {
                ref: g,
                "aria-controls": f ? "menu-list-".concat(n || r) : void 0,
                "aria-haspopup": "true",
                iconType: n,
                endIconType: r,
                onClick: function onClick() {
                  null == _ || _(!f), m(!f);
                },
                disabled: i,
                className: s,
                title: p,
                children: l
              }), TH.exports.jsx(RR, u(u({
                open: f,
                anchorEl: g.current,
                role: void 0,
                style: {
                  zIndex: 5
                }
              }, S), {}, {
                transition: !0,
                children: function children(e) {
                  var t = e.TransitionProps,
                      i = e.placement;
                  return TH.exports.jsx(yT, u(u({}, t), {}, {
                    style: {
                      transformOrigin: "bottom" === i ? "center top" : "center bottom"
                    },
                    children: TH.exports.jsx(kA, {
                      className: VC(v.paper, c),
                      children: TH.exports.jsx(fI, {
                        onClickAway: b,
                        children: TH.exports.jsx(rO, {
                          autoFocusItem: f,
                          id: "menu-list-".concat(n || r),
                          onKeyDown: y,
                          children: o.map(function (e, t) {
                            if (e.items) {
                              var _n91 = e,
                                  _r59 = _n91.items.map(function (e, t) {
                                var n = e.onClick,
                                    r = e.key,
                                    i = h(e, TF);
                                return TH.exports.jsx(RF, u({
                                  onClick: function onClick(e) {
                                    n(e), b(e);
                                  }
                                }, i), void 0 !== r ? "item-".concat(r) : t);
                              });

                              return [_n91.title && TH.exports.jsx(FT, {
                                style: {
                                  color: "#fff",
                                  fontWeight: "bold"
                                },
                                children: _n91.title
                              }, "header-".concat(_n91.title)), _r59, t < o.length - 1 && TH.exports.jsx(qI, {
                                className: v.divider
                              }, "divider-".concat(t))].filter(Boolean);
                            }

                            var n = e,
                                r = n.onClick,
                                i = n.key,
                                a = h(n, OF);
                            return TH.exports.jsx(RF, u({
                              onClick: function onClick(e) {
                                r(e), b(e);
                              }
                            }, a), void 0 !== i ? "item-".concat(i) : t);
                          })
                        })
                      })
                    })
                  }));
                }
              }))]
            });
          };

          var jF;
          !function (e) {
            e.LOCK = "lock", e.WAITING_ROOM = "waitingRoom", e.SHARE = "share", e.CHAT = "chat", e.START_VIDEO = "startVideo";
          }(jF || (jF = {}));

          var DF = function DF() {
            var _e$useContext2 = e.useContext(jM),
                t = _e$useContext2.status,
                _NM2 = NM(),
                n = _NM2.t,
                r = t !== jj.Connected,
                i = function () {
              var t = e.useContext(zM),
                  _e$useContext3 = e.useContext(DM),
                  n = _e$useContext3.stream,
                  _e$useContext4 = e.useContext($M),
                  r = _e$useContext4.chatClient,
                  _e$useContext5 = e.useContext(jM),
                  i = _e$useContext5.isWebinar,
                  o = _e$useContext5.isLockedMeeting,
                  a = _e$useContext5.isEnableWaitingRoom,
                  s = _e$useContext5.isEnableChat,
                  c = _e$useContext5.isEnableShare,
                  l = _e$useContext5.isEnableStartVideo,
                  _NM3 = NM(),
                  d = _NM3.t,
                  u = e.useCallback(function (e) {
                e === jF.LOCK ? o ? t.unlockMeeting() : t.lockMeeting() : e === jF.WAITING_ROOM ? t.enableWaitingRoom(!a) : e === jF.SHARE ? null == n || n.lockShare(c) : e === jF.CHAT ? null == r || r.lockChat(s) : e === jF.START_VIDEO && (null == n || n.allowUnmuteVideo(!l));
              }, [r, t, s, c, l, a, o, n]);

              return e.useMemo(function () {
                return [{
                  items: [{
                    text: d("wc_lock_meeting"),
                    checked: o,
                    onClick: function onClick() {
                      u(jF.LOCK);
                    }
                  }, !i && {
                    text: d("security.waiting_room"),
                    checked: a,
                    onClick: function onClick() {
                      u(jF.WAITING_ROOM);
                    }
                  }].filter(Boolean)
                }, {
                  title: d("security.allow_participants_to"),
                  items: [{
                    text: d("wc_sharer_entry_button_label1"),
                    checked: c,
                    onClick: function onClick() {
                      u(jF.SHARE);
                    }
                  }, {
                    text: d("wc_chat.chat"),
                    checked: s,
                    onClick: function onClick() {
                      u(jF.CHAT);
                    }
                  }, {
                    text: d("wc_video.start_video"),
                    checked: l,
                    onClick: function onClick() {
                      u(jF.START_VIDEO);
                    }
                  }]
                }];
              }, [s, c, l, a, o, i, u, d]);
            }();

            return TH.exports.jsx(PF, {
              iconType: "icon-security",
              disabled: r,
              menu: i,
              title: n("security.button")
            });
          };

          function zF(t, n) {
            var _e$useState23 = e.useState([]),
                _e$useState24 = _slicedToArray(_e$useState23, 2),
                r = _e$useState24[0],
                i = _e$useState24[1],
                _e$useState25 = e.useState([]),
                _e$useState26 = _slicedToArray(_e$useState25, 2),
                o = _e$useState26[0],
                a = _e$useState26[1],
                _e$useContext6 = e.useContext(jM),
                s = _e$useContext6.isHost,
                c = _e$useContext6.ccStatus,
                l = _e$useContext6.dispatch,
                _e$useState27 = e.useState({}),
                _e$useState28 = _slicedToArray(_e$useState27, 2),
                d = _e$useState28[0],
                p = _e$useState28[1],
                _e$useState29 = e.useState(0),
                _e$useState30 = _slicedToArray(_e$useState29, 2),
                h = _e$useState30[0],
                _ = _e$useState30[1],
                _e$useState31 = e.useState(""),
                _e$useState32 = _slicedToArray(_e$useState31, 2),
                f = _e$useState32[0],
                m = _e$useState32[1],
                g = e.useCallback(function () {
              var e = null == n ? void 0 : n.getCCStatus();
              e && (e.allowRequestLt = !1, null == l || l(WU(e)));
              var t = null == n ? void 0 : n.getEditor();
              t && p(u({}, t));
            }, [n, l, p]),
                v = e.useCallback(function (e) {
              var t = null == n ? void 0 : n.getHistory();
              t && (i(null == t ? void 0 : t.allMessages), a(null == t ? void 0 : t.messagesOrder));
              var r = (null == e ? void 0 : e.text) || (null == n ? void 0 : n.getLatest());
              r && m(r);
            }, [n, m, i]);

            e.useEffect(function () {
              t.on("closed-caption-status", g), t.on("closed-caption-lt-status", g), t.on("closed-caption-message", v), t.on("closed-caption-lt-message", v), null == n || n.setListenClosedCaption(!0);
              var e = setTimeout(function () {
                var e = null == n ? void 0 : n.getCCStatus();
                e && (e.allowRequestLt = !1, null == l || l(WU(e)));
                var t = null == n ? void 0 : n.getEditor();
                t && p(u({}, t));
              }, 5e3);
              return function () {
                null == n || n.setListenClosedCaption(!1), t.on("closed-caption-status", g), t.off("closed-caption-lt-status", g), t.off("closed-caption-message", v), t.off("closed-caption-lt-message", v), clearTimeout(e);
              };
            }, [t, n, v, g, l]), e.useEffect(function () {
              var e = null == n ? void 0 : n.getHistory();
              e && (i(null == e ? void 0 : e.allMessages), a(null == e ? void 0 : e.messagesOrder));
              var t = null == n ? void 0 : n.getCCStatus();
              t && (t.allowRequestLt = !1, null == l || l(WU(t)));
              var r = null == n ? void 0 : n.getEditor();
              return r && p(u({}, r)), function () {};
            }, [n, s, l]);
            var b = e.useCallback(function (e) {
              _(function (t) {
                return Math.max(e, t);
              });
            }, []),
                y = null == o ? void 0 : o.map(function (e) {
              return r[e];
            });
            return {
              readIndex: h,
              latestMsg: f,
              histories: y,
              historiesLength: (null == y ? void 0 : y.length) || 0,
              ccEditor: d,
              markReadIndex: b
            };
          }

          var MF;

          function LF(t) {
            var _e$useContext7 = e.useContext(jM),
                n = _e$useContext7.isAttendee,
                r = _e$useContext7.isHost,
                i = _e$useContext7.isCoHost,
                o = _e$useContext7.recordingStatus,
                a = _e$useContext7.meetingOptions,
                s = _e$useContext7.meetingInfo,
                c = _e$useContext7.userId,
                l = _e$useContext7.isWebinar,
                d = _e$useContext7.isEnableQA,
                _e$useContext8 = e.useContext($M),
                u = _e$useContext8.recordingClient,
                _e$useContext9 = e.useContext(JM),
                p = _e$useContext9.isShowParticipant,
                h = _e$useContext9.isShowChat,
                _ = _e$useContext9.hasShowRecordingAlert,
                f = _e$useContext9.isShowQAPanel,
                _e$useContext9$isShow = _e$useContext9.isShowCC,
                m = _e$useContext9$isShow.setting,
                g = _e$useContext9$isShow.input,
                v = _e$useContext9$isShow.history,
                b = _e$useContext9$isShow.toast,
                y = _e$useContext9.dispatch,
                _e$useContext10 = e.useContext(JM),
                w = _e$useContext10.numUnreadChat,
                S = _e$useContext10.numOpenQuestions,
                x = e.useContext(zM),
                _e$useContext11 = e.useContext($M),
                E = _e$useContext11.ccClient,
                _zF = zF(x, E),
                C = _zF.ccEditor,
                k = _zF.historiesLength,
                A = null == E ? void 0 : E.getCCStatus(),
                _NM4 = NM(),
                I = _NM4.t,
                T = r || i,
                O = o === zj.Recording,
                R = o === zj.Paused,
                N = e.useCallback(function (e) {
              e === MF.PARTICIPANTS ? null == y || y(MB(!p)) : e === MF.CHAT_PANEL ? null == y || y(LB(!h)) : e === MF.SETTING ? null == y || y(VB(!0)) : e === MF.CC_SETTING ? null == y || y(GB(!m)) : e === MF.CC_INPUT ? null == y || y(KB(!g)) : e === MF.CC_HISTORY ? null == y || y(QB(!v)) : e === MF.CC_TOAST ? null == y || y(ZB(!b)) : e === MF.RECORD_START ? (null == y || y({
                type: lB,
                payload: !0
              }), null == u || u.startRecording()) : e === MF.RECORD_RESUME ? null == u || u.startRecording() : e === MF.RECORD_PAUSE ? null == u || u.pauseRecording() : e === MF.REOCRD_STOP ? null == u || u.stopRecording() : e === MF.QA_PANEL && (null == y || y(oH(!f)));
            }, [y, v, g, m, b, h, p, u, f]),
                P = e.useMemo(function () {
              return [T && {
                text: I("wc_participants"),
                onClick: function onClick() {
                  return N(MF.PARTICIPANTS);
                }
              }, a.isChatEnabled && {
                text: I("wc_chat.chat"),
                count: w,
                onClick: function onClick() {
                  return N(MF.CHAT_PANEL);
                }
              }, l && d && {
                text: I("wc_qa.qa_comp_title"),
                count: S,
                onClick: function onClick() {
                  return N(MF.QA_PANEL);
                }
              }, T && a.recordingEnable && !O && !R && {
                text: I("toolbar_record"),
                onClick: function onClick() {
                  var e, t;
                  var n = !(null == s || null === (e = s.recordingInfo) || void 0 === e || null === (t = e.recordingDisclaimerForRecorder) || void 0 === t || !t.isEnableRecordingReminder);
                  _ || !n ? N(MF.RECORD_START) : null == y || y(YB(!0));
                }
              }, T && a.allowStopAutoRecording && O && {
                text: I("wc_recording_pause"),
                onClick: function onClick() {
                  return N(MF.RECORD_PAUSE);
                }
              }, T && a.allowStopAutoRecording && R && {
                text: I("wc_recording_resume"),
                onClick: function onClick() {
                  return N(MF.RECORD_RESUME);
                }
              }, T && a.allowStopAutoRecording && (O || R) && {
                text: I("wc_recording_stop"),
                onClick: function onClick() {
                  return N(MF.REOCRD_STOP);
                }
              }, r && (null == A ? void 0 : A.isMeetingEnableClosedCaption) && {
                text: null != A && A.isMeetingEnabledLiveTranscriptionFeature ? I("wc_lt_live_transcript") : I("wc_closed_caption_btn"),
                onClick: function onClick() {
                  return N(MF.CC_SETTING);
                }
              }, (null == C ? void 0 : C.userId) === c && {
                text: I("wc_cc_type_myself"),
                onClick: function onClick() {
                  N(MF.CC_INPUT);
                }
              }, ((null == A ? void 0 : A.isCCEnable) || (null == A ? void 0 : A.isLTEnable)) && (null == A ? void 0 : A.isMeetingEnableViewFullTranscript) && {
                text: I(v ? "wc_lt_menu_item4" : "wc_lt_menu_item2"),
                onClick: function onClick() {
                  N(MF.CC_HISTORY);
                }
              }, ((null == A ? void 0 : A.isCCEnable) || (null == A ? void 0 : A.isLTEnable)) && k && {
                text: I(b ? "wc_lt_menu_item3" : "wc_lt_menu_item1"),
                onClick: function onClick() {
                  N(MF.CC_TOAST);
                }
              }, {
                text: I("wc_qa.setting_btn_name"),
                onClick: function onClick() {
                  return N(MF.SETTING);
                }
              }].filter(Boolean);
            }, [T, I, w, a.recordingEnable, a.allowStopAutoRecording, a.isChatEnabled, O, R, r, null == A ? void 0 : A.isMeetingEnableClosedCaption, null == A ? void 0 : A.isMeetingEnabledLiveTranscriptionFeature, null == A ? void 0 : A.isCCEnable, null == A ? void 0 : A.isLTEnable, null == A ? void 0 : A.isMeetingEnableViewFullTranscript, null == C ? void 0 : C.userId, c, v, k, b, N, s, _, l, S, d, y]);

            var j;
            return j = t ? n ? _toConsumableArray(t) : [].concat(_toConsumableArray(P), _toConsumableArray(t)) : n ? [] : P, j;
          }

          !function (e) {
            e.PARTICIPANTS = "participants", e.CHAT_PANEL = "chatPanel", e.SETTING = "setting", e.CC_SETTING = "ccSetting", e.CC_INPUT = "ccInput", e.CC_HISTORY = "ccHistory", e.CC_TOAST = "ccToast", e.RECORD_START = "recordStart", e.RECORD_RESUME = "recordResume", e.RECORD_PAUSE = "recordPause", e.REOCRD_STOP = "recordStop", e.QA_PANEL = "qaPanel";
          }(MF || (MF = {}));

          var UF = function UF(t) {
            var _e$useContext12 = e.useContext(jM),
                n = _e$useContext12.status,
                _NM5 = NM(),
                r = _NM5.t,
                i = n !== jj.Connected,
                o = LF(null == t ? void 0 : t.buttons);

            return TH.exports.jsx(PF, {
              iconType: "icon-more",
              disabled: i,
              menu: o,
              title: r("wc_more")
            });
          },
              BF = Ok(function () {
            return {
              container: {
                zIndex: 1,
                borderRadius: 8
              },
              default: {
                color: "#f5f5f5",
                backgroundImage: "linear-gradient(to bottom, #26282a, #1c1e20)",
                "&:hover": {
                  background: "rgba(255, 255, 255, 0.09)"
                },
                borderRadius: "8px",
                textTransform: "none",
                width: "150px",
                maxWidth: "150px",
                margin: "5px 15px"
              },
              danger: {
                background: "#de2828",
                color: "#fff",
                fontSize: "12px",
                fontWeight: "bold",
                "&:hover": {
                  background: "#f00"
                }
              },
              btns: {
                width: 180
              }
            };
          }),
              HF = function HF() {
            var t = e.useContext(zM),
                _e$useContext13 = e.useContext(jM),
                n = _e$useContext13.isHost,
                r = _e$useContext13.participants,
                i = _e$useContext13.userId,
                o = _e$useContext13.isWebinar,
                _e$useContext14 = e.useContext(JM),
                a = _e$useContext14.dispatch,
                s = e.useMemo(function () {
              return r.filter(function (e) {
                return e.userId !== i;
              });
            }, [i, r]),
                c = e.useCallback(function () {
              n && t.end();
            }, [t, n]),
                l = e.useCallback(function () {
              n && s.length > 0 ? (null == a || a(HB(!1)), null == a || a(BB(!0))) : t.leave();
            }, [t, n, s, a]),
                _NM6 = NM(),
                d = _NM6.t,
                u = BF(),
                p = [{
              key: 0,
              name: d(o ? "dialog.btn_endconf_webinar" : "wc_btn_endconf_meeting_all"),
              type: "default",
              className: VC(u.default, u.danger),
              onClick: c,
              display: n
            }, {
              key: 1,
              name: d(o ? "wc_leave_webinar" : "wc_leave_meeting"),
              type: "default",
              className: VC(u.default, !n && u.danger),
              onClick: l,
              display: !0
            }].filter(function (e) {
              return e.display;
            });

            return TH.exports.jsx("div", {
              className: u.container,
              role: "menu",
              children: TH.exports.jsx("div", {
                className: u.btns,
                children: p.map(function (e) {
                  return TH.exports.jsx(YA, {
                    className: e.className,
                    onClick: e.onClick,
                    children: e.name
                  }, e.key);
                })
              })
            });
          };

          function VF(e) {
            var t = e.cellCount,
                n = e.cellSize,
                r = e.computeMetadataCallback,
                i = e.computeMetadataCallbackProps,
                o = e.nextCellsCount,
                a = e.nextCellSize,
                s = e.nextScrollToIndex,
                c = e.scrollToIndex,
                l = e.updateScrollOffsetForScrollToIndex;
            t === o && ("number" != typeof n && "number" != typeof a || n === a) || (r(i), c >= 0 && c === s && l());
          }

          var qF = function () {
            function e(t) {
              var n = t.cellCount,
                  r = t.cellSizeGetter,
                  i = t.estimatedCellSize;
              BC(this, e), Py(this, "_cellSizeAndPositionData", {}), Py(this, "_lastMeasuredIndex", -1), Py(this, "_lastBatchedIndex", -1), Py(this, "_cellCount", void 0), Py(this, "_cellSizeGetter", void 0), Py(this, "_estimatedCellSize", void 0), this._cellSizeGetter = r, this._cellCount = n, this._estimatedCellSize = i;
            }

            return RS(e, [{
              key: "areOffsetsAdjusted",
              value: function value() {
                return !1;
              }
            }, {
              key: "configure",
              value: function value(e) {
                var t = e.cellCount,
                    n = e.estimatedCellSize,
                    r = e.cellSizeGetter;
                this._cellCount = t, this._estimatedCellSize = n, this._cellSizeGetter = r;
              }
            }, {
              key: "getCellCount",
              value: function value() {
                return this._cellCount;
              }
            }, {
              key: "getEstimatedCellSize",
              value: function value() {
                return this._estimatedCellSize;
              }
            }, {
              key: "getLastMeasuredIndex",
              value: function value() {
                return this._lastMeasuredIndex;
              }
            }, {
              key: "getOffsetAdjustment",
              value: function value() {
                return 0;
              }
            }, {
              key: "getSizeAndPositionOfCell",
              value: function value(e) {
                if (e < 0 || e >= this._cellCount) throw Error("Requested index ".concat(e, " is outside of range 0..").concat(this._cellCount));
                if (e > this._lastMeasuredIndex) for (var t = this.getSizeAndPositionOfLastMeasuredCell(), n = t.offset + t.size, r = this._lastMeasuredIndex + 1; r <= e; r++) {
                  var i = this._cellSizeGetter({
                    index: r
                  });

                  if (void 0 === i || isNaN(i)) throw Error("Invalid size returned for cell ".concat(r, " of value ").concat(i));
                  null === i ? (this._cellSizeAndPositionData[r] = {
                    offset: n,
                    size: 0
                  }, this._lastBatchedIndex = e) : (this._cellSizeAndPositionData[r] = {
                    offset: n,
                    size: i
                  }, n += i, this._lastMeasuredIndex = e);
                }
                return this._cellSizeAndPositionData[e];
              }
            }, {
              key: "getSizeAndPositionOfLastMeasuredCell",
              value: function value() {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                  offset: 0,
                  size: 0
                };
              }
            }, {
              key: "getTotalSize",
              value: function value() {
                var e = this.getSizeAndPositionOfLastMeasuredCell();
                return e.offset + e.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
              }
            }, {
              key: "getUpdatedOffsetForIndex",
              value: function value(e) {
                var t = e.align,
                    n = void 0 === t ? "auto" : t,
                    r = e.containerSize,
                    i = e.currentOffset,
                    o = e.targetIndex;
                if (r <= 0) return 0;
                var a,
                    s = this.getSizeAndPositionOfCell(o),
                    c = s.offset,
                    l = c - r + s.size;

                switch (n) {
                  case "start":
                    a = c;
                    break;

                  case "end":
                    a = l;
                    break;

                  case "center":
                    a = c - (r - s.size) / 2;
                    break;

                  default:
                    a = Math.max(l, Math.min(c, i));
                }

                var d = this.getTotalSize();
                return Math.max(0, Math.min(d - r, a));
              }
            }, {
              key: "getVisibleCellRange",
              value: function value(e) {
                var t = e.containerSize,
                    n = e.offset;
                if (0 === this.getTotalSize()) return {};

                var r = n + t,
                    i = this._findNearestCell(n),
                    o = this.getSizeAndPositionOfCell(i);

                n = o.offset + o.size;

                for (var a = i; n < r && a < this._cellCount - 1;) {
                  a++, n += this.getSizeAndPositionOfCell(a).size;
                }

                return {
                  start: i,
                  stop: a
                };
              }
            }, {
              key: "resetCell",
              value: function value(e) {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, e - 1);
              }
            }, {
              key: "_binarySearch",
              value: function value(e, t, n) {
                for (; t <= e;) {
                  var r = t + Math.floor((e - t) / 2),
                      i = this.getSizeAndPositionOfCell(r).offset;
                  if (i === n) return r;
                  i < n ? t = r + 1 : i > n && (e = r - 1);
                }

                return t > 0 ? t - 1 : 0;
              }
            }, {
              key: "_exponentialSearch",
              value: function value(e, t) {
                for (var n = 1; e < this._cellCount && this.getSizeAndPositionOfCell(e).offset < t;) {
                  e += n, n *= 2;
                }

                return this._binarySearch(Math.min(e, this._cellCount - 1), Math.floor(e / 2), t);
              }
            }, {
              key: "_findNearestCell",
              value: function value(e) {
                if (isNaN(e)) throw Error("Invalid offset ".concat(e, " specified"));
                e = Math.max(0, e);
                var t = this.getSizeAndPositionOfLastMeasuredCell(),
                    n = Math.max(0, this._lastMeasuredIndex);
                return t.offset >= e ? this._binarySearch(n, 0, e) : this._exponentialSearch(n, e);
              }
            }]), e;
          }(),
              FF = function FF() {
            return "undefined" != typeof window && window.chrome ? 16777100 : 15e5;
          },
              WF = function () {
            function e(t) {
              var n = t.maxScrollSize,
                  r = void 0 === n ? FF() : n,
                  i = bw(t, ["maxScrollSize"]);
              BC(this, e), Py(this, "_cellSizeAndPositionManager", void 0), Py(this, "_maxScrollSize", void 0), this._cellSizeAndPositionManager = new qF(i), this._maxScrollSize = r;
            }

            return RS(e, [{
              key: "areOffsetsAdjusted",
              value: function value() {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
              }
            }, {
              key: "configure",
              value: function value(e) {
                this._cellSizeAndPositionManager.configure(e);
              }
            }, {
              key: "getCellCount",
              value: function value() {
                return this._cellSizeAndPositionManager.getCellCount();
              }
            }, {
              key: "getEstimatedCellSize",
              value: function value() {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
              }
            }, {
              key: "getLastMeasuredIndex",
              value: function value() {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
              }
            }, {
              key: "getOffsetAdjustment",
              value: function value(e) {
                var t = e.containerSize,
                    n = e.offset,
                    r = this._cellSizeAndPositionManager.getTotalSize(),
                    i = this.getTotalSize(),
                    o = this._getOffsetPercentage({
                  containerSize: t,
                  offset: n,
                  totalSize: i
                });

                return Math.round(o * (i - r));
              }
            }, {
              key: "getSizeAndPositionOfCell",
              value: function value(e) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(e);
              }
            }, {
              key: "getSizeAndPositionOfLastMeasuredCell",
              value: function value() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
              }
            }, {
              key: "getTotalSize",
              value: function value() {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
              }
            }, {
              key: "getUpdatedOffsetForIndex",
              value: function value(e) {
                var t = e.align,
                    n = void 0 === t ? "auto" : t,
                    r = e.containerSize,
                    i = e.currentOffset,
                    o = e.targetIndex;
                i = this._safeOffsetToOffset({
                  containerSize: r,
                  offset: i
                });

                var a = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                  align: n,
                  containerSize: r,
                  currentOffset: i,
                  targetIndex: o
                });

                return this._offsetToSafeOffset({
                  containerSize: r,
                  offset: a
                });
              }
            }, {
              key: "getVisibleCellRange",
              value: function value(e) {
                var t = e.containerSize,
                    n = e.offset;
                return n = this._safeOffsetToOffset({
                  containerSize: t,
                  offset: n
                }), this._cellSizeAndPositionManager.getVisibleCellRange({
                  containerSize: t,
                  offset: n
                });
              }
            }, {
              key: "resetCell",
              value: function value(e) {
                this._cellSizeAndPositionManager.resetCell(e);
              }
            }, {
              key: "_getOffsetPercentage",
              value: function value(e) {
                var t = e.containerSize,
                    n = e.offset,
                    r = e.totalSize;
                return r <= t ? 0 : n / (r - t);
              }
            }, {
              key: "_offsetToSafeOffset",
              value: function value(e) {
                var t = e.containerSize,
                    n = e.offset,
                    r = this._cellSizeAndPositionManager.getTotalSize(),
                    i = this.getTotalSize();

                if (r === i) return n;

                var o = this._getOffsetPercentage({
                  containerSize: t,
                  offset: n,
                  totalSize: r
                });

                return Math.round(o * (i - t));
              }
            }, {
              key: "_safeOffsetToOffset",
              value: function value(e) {
                var t = e.containerSize,
                    n = e.offset,
                    r = this._cellSizeAndPositionManager.getTotalSize(),
                    i = this.getTotalSize();

                if (r === i) return n;

                var o = this._getOffsetPercentage({
                  containerSize: t,
                  offset: n,
                  totalSize: i
                });

                return Math.round(o * (r - t));
              }
            }]), e;
          }();

          function GF() {
            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                t = {};
            return function (n) {
              var r = n.callback,
                  i = n.indices,
                  o = Object.keys(i),
                  a = !e || o.every(function (e) {
                var t = i[e];
                return Array.isArray(t) ? t.length > 0 : t >= 0;
              }),
                  s = o.length !== Object.keys(t).length || o.some(function (e) {
                var n = t[e],
                    r = i[e];
                return Array.isArray(r) ? n.join(",") !== r.join(",") : n !== r;
              });
              t = i, a && s && r(i);
            };
          }

          function KF(e) {
            var t = e.cellSize,
                n = e.cellSizeAndPositionManager,
                r = e.previousCellsCount,
                i = e.previousCellSize,
                o = e.previousScrollToAlignment,
                a = e.previousScrollToIndex,
                s = e.previousSize,
                c = e.scrollOffset,
                l = e.scrollToAlignment,
                d = e.scrollToIndex,
                u = e.size,
                p = e.sizeJustIncreasedFromZero,
                h = e.updateScrollIndexCallback,
                _ = n.getCellCount(),
                f = d >= 0 && d < _;

            f && (u !== s || p || !i || "number" == typeof t && t !== i || l !== o || d !== a) ? h(d) : !f && _ > 0 && (u < s || _ < r) && c > n.getTotalSize() - u && h(_ - 1);
          }

          var QF,
              ZF,
              YF = !("undefined" == typeof window || !window.document || !window.document.createElement);

          function JF() {
            var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
            null != e && this.setState(e);
          }

          function $F(e) {
            this.setState(function (t) {
              var n = this.constructor.getDerivedStateFromProps(e, t);
              return null != n ? n : null;
            }.bind(this));
          }

          function XF(e, t) {
            try {
              var n = this.props,
                  r = this.state;
              this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, r);
            } finally {
              this.props = n, this.state = r;
            }
          }

          JF.__suppressDeprecationWarning = !0, $F.__suppressDeprecationWarning = !0, XF.__suppressDeprecationWarning = !0;

          var eW,
              tW,
              nW = (ZF = "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).requestAnimationFrame || ZF.webkitRequestAnimationFrame || ZF.mozRequestAnimationFrame || ZF.oRequestAnimationFrame || ZF.msRequestAnimationFrame || function (e) {
            return ZF.setTimeout(e, 1e3 / 60);
          },
              rW = ZF.cancelAnimationFrame || ZF.webkitCancelAnimationFrame || ZF.mozCancelAnimationFrame || ZF.oCancelAnimationFrame || ZF.msCancelAnimationFrame || function (e) {
            ZF.clearTimeout(e);
          },
              iW = nW,
              oW = rW,
              aW = function aW(e) {
            return oW(e.id);
          };

          function sW(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function cW(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? sW(n, !0).forEach(function (t) {
                Py(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sW(n).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          var lW,
              dW,
              uW = "observed",
              pW = "requested",
              hW = (tW = eW = function (e) {
            function t(e) {
              var n;
              BC(this, t), Py(jS(n = VR(this, qR(t).call(this, e))), "_onGridRenderedMemoizer", GF()), Py(jS(n), "_onScrollMemoizer", GF(!1)), Py(jS(n), "_deferredInvalidateColumnIndex", null), Py(jS(n), "_deferredInvalidateRowIndex", null), Py(jS(n), "_recomputeScrollLeftFlag", !1), Py(jS(n), "_recomputeScrollTopFlag", !1), Py(jS(n), "_horizontalScrollBarSize", 0), Py(jS(n), "_verticalScrollBarSize", 0), Py(jS(n), "_scrollbarPresenceChanged", !1), Py(jS(n), "_scrollingContainer", void 0), Py(jS(n), "_childrenToDisplay", void 0), Py(jS(n), "_columnStartIndex", void 0), Py(jS(n), "_columnStopIndex", void 0), Py(jS(n), "_rowStartIndex", void 0), Py(jS(n), "_rowStopIndex", void 0), Py(jS(n), "_renderedColumnStartIndex", 0), Py(jS(n), "_renderedColumnStopIndex", 0), Py(jS(n), "_renderedRowStartIndex", 0), Py(jS(n), "_renderedRowStopIndex", 0), Py(jS(n), "_initialScrollTop", void 0), Py(jS(n), "_initialScrollLeft", void 0), Py(jS(n), "_disablePointerEventsTimeoutId", void 0), Py(jS(n), "_styleCache", {}), Py(jS(n), "_cellCache", {}), Py(jS(n), "_debounceScrollEndedCallback", function () {
                n._disablePointerEventsTimeoutId = null, n.setState({
                  isScrolling: !1,
                  needToResetStyleCache: !1
                });
              }), Py(jS(n), "_invokeOnGridRenderedHelper", function () {
                var e = n.props.onSectionRendered;

                n._onGridRenderedMemoizer({
                  callback: e,
                  indices: {
                    columnOverscanStartIndex: n._columnStartIndex,
                    columnOverscanStopIndex: n._columnStopIndex,
                    columnStartIndex: n._renderedColumnStartIndex,
                    columnStopIndex: n._renderedColumnStopIndex,
                    rowOverscanStartIndex: n._rowStartIndex,
                    rowOverscanStopIndex: n._rowStopIndex,
                    rowStartIndex: n._renderedRowStartIndex,
                    rowStopIndex: n._renderedRowStopIndex
                  }
                });
              }), Py(jS(n), "_setScrollingContainerRef", function (e) {
                n._scrollingContainer = e;
              }), Py(jS(n), "_onScroll", function (e) {
                e.target === n._scrollingContainer && n.handleScrollEvent(e.target);
              });
              var r = new WF({
                cellCount: e.columnCount,
                cellSizeGetter: function cellSizeGetter(n) {
                  return t._wrapSizeGetter(e.columnWidth)(n);
                },
                estimatedCellSize: t._getEstimatedColumnSize(e)
              }),
                  i = new WF({
                cellCount: e.rowCount,
                cellSizeGetter: function cellSizeGetter(n) {
                  return t._wrapSizeGetter(e.rowHeight)(n);
                },
                estimatedCellSize: t._getEstimatedRowSize(e)
              });
              return n.state = {
                instanceProps: {
                  columnSizeAndPositionManager: r,
                  rowSizeAndPositionManager: i,
                  prevColumnWidth: e.columnWidth,
                  prevRowHeight: e.rowHeight,
                  prevColumnCount: e.columnCount,
                  prevRowCount: e.rowCount,
                  prevIsScrolling: !0 === e.isScrolling,
                  prevScrollToColumn: e.scrollToColumn,
                  prevScrollToRow: e.scrollToRow,
                  scrollbarSize: 0,
                  scrollbarSizeMeasured: !1
                },
                isScrolling: !1,
                scrollDirectionHorizontal: 1,
                scrollDirectionVertical: 1,
                scrollLeft: 0,
                scrollTop: 0,
                scrollPositionChangeReason: null,
                needToResetStyleCache: !1
              }, e.scrollToRow > 0 && (n._initialScrollTop = n._getCalculatedScrollTop(e, n.state)), e.scrollToColumn > 0 && (n._initialScrollLeft = n._getCalculatedScrollLeft(e, n.state)), n;
            }

            return HR(t, e), RS(t, [{
              key: "getOffsetForCell",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = e.alignment,
                    n = void 0 === t ? this.props.scrollToAlignment : t,
                    r = e.columnIndex,
                    i = void 0 === r ? this.props.scrollToColumn : r,
                    o = e.rowIndex,
                    a = void 0 === o ? this.props.scrollToRow : o,
                    s = cW({}, this.props, {
                  scrollToAlignment: n,
                  scrollToColumn: i,
                  scrollToRow: a
                });
                return {
                  scrollLeft: this._getCalculatedScrollLeft(s),
                  scrollTop: this._getCalculatedScrollTop(s)
                };
              }
            }, {
              key: "getTotalRowsHeight",
              value: function value() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
              }
            }, {
              key: "getTotalColumnsWidth",
              value: function value() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
              }
            }, {
              key: "handleScrollEvent",
              value: function value(e) {
                var t = e.scrollLeft,
                    n = void 0 === t ? 0 : t,
                    r = e.scrollTop,
                    i = void 0 === r ? 0 : r;

                if (!(i < 0)) {
                  this._debounceScrollEnded();

                  var o = this.props,
                      a = o.autoHeight,
                      s = o.autoWidth,
                      c = o.height,
                      l = o.width,
                      d = this.state.instanceProps,
                      u = d.scrollbarSize,
                      p = d.rowSizeAndPositionManager.getTotalSize(),
                      h = d.columnSizeAndPositionManager.getTotalSize(),
                      _ = Math.min(Math.max(0, h - l + u), n),
                      f = Math.min(Math.max(0, p - c + u), i);

                  if (this.state.scrollLeft !== _ || this.state.scrollTop !== f) {
                    var m = {
                      isScrolling: !0,
                      scrollDirectionHorizontal: _ !== this.state.scrollLeft ? _ > this.state.scrollLeft ? 1 : -1 : this.state.scrollDirectionHorizontal,
                      scrollDirectionVertical: f !== this.state.scrollTop ? f > this.state.scrollTop ? 1 : -1 : this.state.scrollDirectionVertical,
                      scrollPositionChangeReason: uW
                    };
                    a || (m.scrollTop = f), s || (m.scrollLeft = _), m.needToResetStyleCache = !1, this.setState(m);
                  }

                  this._invokeOnScrollMemoizer({
                    scrollLeft: _,
                    scrollTop: f,
                    totalColumnsWidth: h,
                    totalRowsHeight: p
                  });
                }
              }
            }, {
              key: "invalidateCellSizeAfterRender",
              value: function value(e) {
                var t = e.columnIndex,
                    n = e.rowIndex;
                this._deferredInvalidateColumnIndex = "number" == typeof this._deferredInvalidateColumnIndex ? Math.min(this._deferredInvalidateColumnIndex, t) : t, this._deferredInvalidateRowIndex = "number" == typeof this._deferredInvalidateRowIndex ? Math.min(this._deferredInvalidateRowIndex, n) : n;
              }
            }, {
              key: "measureAllCells",
              value: function value() {
                var e = this.props,
                    t = e.columnCount,
                    n = e.rowCount,
                    r = this.state.instanceProps;
                r.columnSizeAndPositionManager.getSizeAndPositionOfCell(t - 1), r.rowSizeAndPositionManager.getSizeAndPositionOfCell(n - 1);
              }
            }, {
              key: "recomputeGridSize",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = e.columnIndex,
                    n = void 0 === t ? 0 : t,
                    r = e.rowIndex,
                    i = void 0 === r ? 0 : r,
                    o = this.props,
                    a = o.scrollToColumn,
                    s = o.scrollToRow,
                    c = this.state.instanceProps;
                c.columnSizeAndPositionManager.resetCell(n), c.rowSizeAndPositionManager.resetCell(i), this._recomputeScrollLeftFlag = a >= 0 && (1 === this.state.scrollDirectionHorizontal ? n <= a : n >= a), this._recomputeScrollTopFlag = s >= 0 && (1 === this.state.scrollDirectionVertical ? i <= s : i >= s), this._styleCache = {}, this._cellCache = {}, this.forceUpdate();
              }
            }, {
              key: "scrollToCell",
              value: function value(e) {
                var t = e.columnIndex,
                    n = e.rowIndex,
                    r = this.props.columnCount,
                    i = this.props;
                r > 1 && void 0 !== t && this._updateScrollLeftForScrollToColumn(cW({}, i, {
                  scrollToColumn: t
                })), void 0 !== n && this._updateScrollTopForScrollToRow(cW({}, i, {
                  scrollToRow: n
                }));
              }
            }, {
              key: "componentDidMount",
              value: function value() {
                var e = this.props,
                    n = e.getScrollbarSize,
                    r = e.height,
                    i = e.scrollLeft,
                    o = e.scrollToColumn,
                    a = e.scrollTop,
                    s = e.scrollToRow,
                    c = e.width,
                    l = this.state.instanceProps;

                if (this._initialScrollTop = 0, this._initialScrollLeft = 0, this._handleInvalidatedGridSize(), l.scrollbarSizeMeasured || this.setState(function (e) {
                  var t = cW({}, e, {
                    needToResetStyleCache: !1
                  });
                  return t.instanceProps.scrollbarSize = n(), t.instanceProps.scrollbarSizeMeasured = !0, t;
                }), "number" == typeof i && i >= 0 || "number" == typeof a && a >= 0) {
                  var d = t._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: i,
                    scrollTop: a
                  });

                  d && (d.needToResetStyleCache = !1, this.setState(d));
                }

                this._scrollingContainer && (this._scrollingContainer.scrollLeft !== this.state.scrollLeft && (this._scrollingContainer.scrollLeft = this.state.scrollLeft), this._scrollingContainer.scrollTop !== this.state.scrollTop && (this._scrollingContainer.scrollTop = this.state.scrollTop));
                var u = r > 0 && c > 0;
                o >= 0 && u && this._updateScrollLeftForScrollToColumn(), s >= 0 && u && this._updateScrollTopForScrollToRow(), this._invokeOnGridRenderedHelper(), this._invokeOnScrollMemoizer({
                  scrollLeft: i || 0,
                  scrollTop: a || 0,
                  totalColumnsWidth: l.columnSizeAndPositionManager.getTotalSize(),
                  totalRowsHeight: l.rowSizeAndPositionManager.getTotalSize()
                }), this._maybeCallOnScrollbarPresenceChange();
              }
            }, {
              key: "componentDidUpdate",
              value: function value(e, t) {
                var n = this,
                    r = this.props,
                    i = r.autoHeight,
                    o = r.autoWidth,
                    a = r.columnCount,
                    s = r.height,
                    c = r.rowCount,
                    l = r.scrollToAlignment,
                    d = r.scrollToColumn,
                    u = r.scrollToRow,
                    p = r.width,
                    h = this.state,
                    _ = h.scrollLeft,
                    f = h.scrollPositionChangeReason,
                    m = h.scrollTop,
                    g = h.instanceProps;

                this._handleInvalidatedGridSize();

                var v = a > 0 && 0 === e.columnCount || c > 0 && 0 === e.rowCount;
                f === pW && (!o && _ >= 0 && (_ !== this._scrollingContainer.scrollLeft || v) && (this._scrollingContainer.scrollLeft = _), !i && m >= 0 && (m !== this._scrollingContainer.scrollTop || v) && (this._scrollingContainer.scrollTop = m));
                var b = (0 === e.width || 0 === e.height) && s > 0 && p > 0;

                if (this._recomputeScrollLeftFlag ? (this._recomputeScrollLeftFlag = !1, this._updateScrollLeftForScrollToColumn(this.props)) : KF({
                  cellSizeAndPositionManager: g.columnSizeAndPositionManager,
                  previousCellsCount: e.columnCount,
                  previousCellSize: e.columnWidth,
                  previousScrollToAlignment: e.scrollToAlignment,
                  previousScrollToIndex: e.scrollToColumn,
                  previousSize: e.width,
                  scrollOffset: _,
                  scrollToAlignment: l,
                  scrollToIndex: d,
                  size: p,
                  sizeJustIncreasedFromZero: b,
                  updateScrollIndexCallback: function updateScrollIndexCallback() {
                    return n._updateScrollLeftForScrollToColumn(n.props);
                  }
                }), this._recomputeScrollTopFlag ? (this._recomputeScrollTopFlag = !1, this._updateScrollTopForScrollToRow(this.props)) : KF({
                  cellSizeAndPositionManager: g.rowSizeAndPositionManager,
                  previousCellsCount: e.rowCount,
                  previousCellSize: e.rowHeight,
                  previousScrollToAlignment: e.scrollToAlignment,
                  previousScrollToIndex: e.scrollToRow,
                  previousSize: e.height,
                  scrollOffset: m,
                  scrollToAlignment: l,
                  scrollToIndex: u,
                  size: s,
                  sizeJustIncreasedFromZero: b,
                  updateScrollIndexCallback: function updateScrollIndexCallback() {
                    return n._updateScrollTopForScrollToRow(n.props);
                  }
                }), this._invokeOnGridRenderedHelper(), _ !== t.scrollLeft || m !== t.scrollTop) {
                  var y = g.rowSizeAndPositionManager.getTotalSize(),
                      w = g.columnSizeAndPositionManager.getTotalSize();

                  this._invokeOnScrollMemoizer({
                    scrollLeft: _,
                    scrollTop: m,
                    totalColumnsWidth: w,
                    totalRowsHeight: y
                  });
                }

                this._maybeCallOnScrollbarPresenceChange();
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this._disablePointerEventsTimeoutId && aW(this._disablePointerEventsTimeoutId);
              }
            }, {
              key: "render",
              value: function value() {
                var e = this.props,
                    t = e.autoContainerWidth,
                    n = e.autoHeight,
                    r = e.autoWidth,
                    i = e.className,
                    o = e.containerProps,
                    a = e.containerRole,
                    c = e.containerStyle,
                    l = e.height,
                    d = e.id,
                    u = e.noContentRenderer,
                    p = e.role,
                    h = e.style,
                    _ = e.tabIndex,
                    f = e.width,
                    m = this.state,
                    g = m.instanceProps,
                    v = m.needToResetStyleCache,
                    b = this._isScrolling(),
                    y = {
                  boxSizing: "border-box",
                  direction: "ltr",
                  height: n ? "auto" : l,
                  position: "relative",
                  width: r ? "auto" : f,
                  WebkitOverflowScrolling: "touch",
                  willChange: "transform"
                };

                v && (this._styleCache = {}), this.state.isScrolling || this._resetStyleCache(), this._calculateChildrenToRender(this.props, this.state);
                var w = g.columnSizeAndPositionManager.getTotalSize(),
                    S = g.rowSizeAndPositionManager.getTotalSize(),
                    x = S > l ? g.scrollbarSize : 0,
                    E = w > f ? g.scrollbarSize : 0;
                E === this._horizontalScrollBarSize && x === this._verticalScrollBarSize || (this._horizontalScrollBarSize = E, this._verticalScrollBarSize = x, this._scrollbarPresenceChanged = !0), y.overflowX = w + x <= f ? "hidden" : "auto", y.overflowY = S + E <= l ? "hidden" : "auto";
                var C = this._childrenToDisplay,
                    k = 0 === C.length && l > 0 && f > 0;
                return s.createElement("div", xy({
                  ref: this._setScrollingContainerRef
                }, o, {
                  "aria-label": this.props["aria-label"],
                  "aria-readonly": this.props["aria-readonly"],
                  className: VC("ReactVirtualized__Grid", i),
                  id: d,
                  onScroll: this._onScroll,
                  role: p,
                  style: cW({}, y, {}, h),
                  tabIndex: _
                }), C.length > 0 && s.createElement("div", {
                  className: "ReactVirtualized__Grid__innerScrollContainer",
                  role: a,
                  style: cW({
                    width: t ? "auto" : w,
                    height: S,
                    maxWidth: w,
                    maxHeight: S,
                    overflow: "hidden",
                    pointerEvents: b ? "none" : "",
                    position: "relative"
                  }, c)
                }, C), k && u());
              }
            }, {
              key: "_calculateChildrenToRender",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props,
                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.state,
                    n = e.cellRenderer,
                    r = e.cellRangeRenderer,
                    i = e.columnCount,
                    o = e.deferredMeasurementCache,
                    a = e.height,
                    s = e.overscanColumnCount,
                    c = e.overscanIndicesGetter,
                    l = e.overscanRowCount,
                    d = e.rowCount,
                    u = e.width,
                    p = e.isScrollingOptOut,
                    h = t.scrollDirectionHorizontal,
                    _ = t.scrollDirectionVertical,
                    f = t.instanceProps,
                    m = this._initialScrollTop > 0 ? this._initialScrollTop : t.scrollTop,
                    g = this._initialScrollLeft > 0 ? this._initialScrollLeft : t.scrollLeft,
                    v = this._isScrolling(e, t);

                if (this._childrenToDisplay = [], a > 0 && u > 0) {
                  var b = f.columnSizeAndPositionManager.getVisibleCellRange({
                    containerSize: u,
                    offset: g
                  }),
                      y = f.rowSizeAndPositionManager.getVisibleCellRange({
                    containerSize: a,
                    offset: m
                  }),
                      w = f.columnSizeAndPositionManager.getOffsetAdjustment({
                    containerSize: u,
                    offset: g
                  }),
                      S = f.rowSizeAndPositionManager.getOffsetAdjustment({
                    containerSize: a,
                    offset: m
                  });
                  this._renderedColumnStartIndex = b.start, this._renderedColumnStopIndex = b.stop, this._renderedRowStartIndex = y.start, this._renderedRowStopIndex = y.stop;
                  var x = c({
                    direction: "horizontal",
                    cellCount: i,
                    overscanCellsCount: s,
                    scrollDirection: h,
                    startIndex: "number" == typeof b.start ? b.start : 0,
                    stopIndex: "number" == typeof b.stop ? b.stop : -1
                  }),
                      E = c({
                    direction: "vertical",
                    cellCount: d,
                    overscanCellsCount: l,
                    scrollDirection: _,
                    startIndex: "number" == typeof y.start ? y.start : 0,
                    stopIndex: "number" == typeof y.stop ? y.stop : -1
                  }),
                      C = x.overscanStartIndex,
                      k = x.overscanStopIndex,
                      A = E.overscanStartIndex,
                      I = E.overscanStopIndex;

                  if (o) {
                    if (!o.hasFixedHeight()) for (var T = A; T <= I; T++) {
                      if (!o.has(T, 0)) {
                        C = 0, k = i - 1;
                        break;
                      }
                    }
                    if (!o.hasFixedWidth()) for (var O = C; O <= k; O++) {
                      if (!o.has(0, O)) {
                        A = 0, I = d - 1;
                        break;
                      }
                    }
                  }

                  this._childrenToDisplay = r({
                    cellCache: this._cellCache,
                    cellRenderer: n,
                    columnSizeAndPositionManager: f.columnSizeAndPositionManager,
                    columnStartIndex: C,
                    columnStopIndex: k,
                    deferredMeasurementCache: o,
                    horizontalOffsetAdjustment: w,
                    isScrolling: v,
                    isScrollingOptOut: p,
                    parent: this,
                    rowSizeAndPositionManager: f.rowSizeAndPositionManager,
                    rowStartIndex: A,
                    rowStopIndex: I,
                    scrollLeft: g,
                    scrollTop: m,
                    styleCache: this._styleCache,
                    verticalOffsetAdjustment: S,
                    visibleColumnIndices: b,
                    visibleRowIndices: y
                  }), this._columnStartIndex = C, this._columnStopIndex = k, this._rowStartIndex = A, this._rowStopIndex = I;
                }
              }
            }, {
              key: "_debounceScrollEnded",
              value: function value() {
                var e = this.props.scrollingResetTimeInterval;
                this._disablePointerEventsTimeoutId && aW(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = function (e, t) {
                  var n;
                  Promise.resolve().then(function () {
                    n = Date.now();
                  });
                  var r = {
                    id: iW(function i() {
                      Date.now() - n >= t ? e.call() : r.id = iW(i);
                    })
                  };
                  return r;
                }(this._debounceScrollEndedCallback, e);
              }
            }, {
              key: "_handleInvalidatedGridSize",
              value: function value() {
                if ("number" == typeof this._deferredInvalidateColumnIndex && "number" == typeof this._deferredInvalidateRowIndex) {
                  var e = this._deferredInvalidateColumnIndex,
                      t = this._deferredInvalidateRowIndex;
                  this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
                    columnIndex: e,
                    rowIndex: t
                  });
                }
              }
            }, {
              key: "_invokeOnScrollMemoizer",
              value: function value(e) {
                var t = this,
                    n = e.scrollLeft,
                    r = e.scrollTop,
                    i = e.totalColumnsWidth,
                    o = e.totalRowsHeight;

                this._onScrollMemoizer({
                  callback: function callback(e) {
                    var n = e.scrollLeft,
                        r = e.scrollTop,
                        a = t.props,
                        s = a.height;
                    (0, a.onScroll)({
                      clientHeight: s,
                      clientWidth: a.width,
                      scrollHeight: o,
                      scrollLeft: n,
                      scrollTop: r,
                      scrollWidth: i
                    });
                  },
                  indices: {
                    scrollLeft: n,
                    scrollTop: r
                  }
                });
              }
            }, {
              key: "_isScrolling",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props,
                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.state;
                return Object.hasOwnProperty.call(e, "isScrolling") ? Boolean(e.isScrolling) : Boolean(t.isScrolling);
              }
            }, {
              key: "_maybeCallOnScrollbarPresenceChange",
              value: function value() {
                if (this._scrollbarPresenceChanged) {
                  var e = this.props.onScrollbarPresenceChange;
                  this._scrollbarPresenceChanged = !1, e({
                    horizontal: this._horizontalScrollBarSize > 0,
                    size: this.state.instanceProps.scrollbarSize,
                    vertical: this._verticalScrollBarSize > 0
                  });
                }
              }
            }, {
              key: "scrollToPosition",
              value: function value(e) {
                var n = e.scrollLeft,
                    r = e.scrollTop,
                    i = t._getScrollToPositionStateUpdate({
                  prevState: this.state,
                  scrollLeft: n,
                  scrollTop: r
                });

                i && (i.needToResetStyleCache = !1, this.setState(i));
              }
            }, {
              key: "_getCalculatedScrollLeft",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.state;
                return t._getCalculatedScrollLeft(e, n);
              }
            }, {
              key: "_updateScrollLeftForScrollToColumn",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.state,
                    r = t._getScrollLeftForScrollToColumnStateUpdate(e, n);

                r && (r.needToResetStyleCache = !1, this.setState(r));
              }
            }, {
              key: "_getCalculatedScrollTop",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.state;
                return t._getCalculatedScrollTop(e, n);
              }
            }, {
              key: "_resetStyleCache",
              value: function value() {
                var e = this._styleCache,
                    t = this._cellCache,
                    n = this.props.isScrollingOptOut;
                this._cellCache = {}, this._styleCache = {};

                for (var r = this._rowStartIndex; r <= this._rowStopIndex; r++) {
                  for (var i = this._columnStartIndex; i <= this._columnStopIndex; i++) {
                    var o = "".concat(r, "-").concat(i);
                    this._styleCache[o] = e[o], n && (this._cellCache[o] = t[o]);
                  }
                }
              }
            }, {
              key: "_updateScrollTopForScrollToRow",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.state,
                    r = t._getScrollTopForScrollToRowStateUpdate(e, n);

                r && (r.needToResetStyleCache = !1, this.setState(r));
              }
            }], [{
              key: "getDerivedStateFromProps",
              value: function value(e, n) {
                var r = {};
                0 === e.columnCount && 0 !== n.scrollLeft || 0 === e.rowCount && 0 !== n.scrollTop ? (r.scrollLeft = 0, r.scrollTop = 0) : (e.scrollLeft !== n.scrollLeft && e.scrollToColumn < 0 || e.scrollTop !== n.scrollTop && e.scrollToRow < 0) && Object.assign(r, t._getScrollToPositionStateUpdate({
                  prevState: n,
                  scrollLeft: e.scrollLeft,
                  scrollTop: e.scrollTop
                }));
                var i,
                    o,
                    a = n.instanceProps;
                return r.needToResetStyleCache = !1, e.columnWidth === a.prevColumnWidth && e.rowHeight === a.prevRowHeight || (r.needToResetStyleCache = !0), a.columnSizeAndPositionManager.configure({
                  cellCount: e.columnCount,
                  estimatedCellSize: t._getEstimatedColumnSize(e),
                  cellSizeGetter: t._wrapSizeGetter(e.columnWidth)
                }), a.rowSizeAndPositionManager.configure({
                  cellCount: e.rowCount,
                  estimatedCellSize: t._getEstimatedRowSize(e),
                  cellSizeGetter: t._wrapSizeGetter(e.rowHeight)
                }), 0 !== a.prevColumnCount && 0 !== a.prevRowCount || (a.prevColumnCount = 0, a.prevRowCount = 0), e.autoHeight && !1 === e.isScrolling && !0 === a.prevIsScrolling && Object.assign(r, {
                  isScrolling: !1
                }), VF({
                  cellCount: a.prevColumnCount,
                  cellSize: "number" == typeof a.prevColumnWidth ? a.prevColumnWidth : null,
                  computeMetadataCallback: function computeMetadataCallback() {
                    return a.columnSizeAndPositionManager.resetCell(0);
                  },
                  computeMetadataCallbackProps: e,
                  nextCellsCount: e.columnCount,
                  nextCellSize: "number" == typeof e.columnWidth ? e.columnWidth : null,
                  nextScrollToIndex: e.scrollToColumn,
                  scrollToIndex: a.prevScrollToColumn,
                  updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                    i = t._getScrollLeftForScrollToColumnStateUpdate(e, n);
                  }
                }), VF({
                  cellCount: a.prevRowCount,
                  cellSize: "number" == typeof a.prevRowHeight ? a.prevRowHeight : null,
                  computeMetadataCallback: function computeMetadataCallback() {
                    return a.rowSizeAndPositionManager.resetCell(0);
                  },
                  computeMetadataCallbackProps: e,
                  nextCellsCount: e.rowCount,
                  nextCellSize: "number" == typeof e.rowHeight ? e.rowHeight : null,
                  nextScrollToIndex: e.scrollToRow,
                  scrollToIndex: a.prevScrollToRow,
                  updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                    o = t._getScrollTopForScrollToRowStateUpdate(e, n);
                  }
                }), a.prevColumnCount = e.columnCount, a.prevColumnWidth = e.columnWidth, a.prevIsScrolling = !0 === e.isScrolling, a.prevRowCount = e.rowCount, a.prevRowHeight = e.rowHeight, a.prevScrollToColumn = e.scrollToColumn, a.prevScrollToRow = e.scrollToRow, a.scrollbarSize = e.getScrollbarSize(), void 0 === a.scrollbarSize ? (a.scrollbarSizeMeasured = !1, a.scrollbarSize = 0) : a.scrollbarSizeMeasured = !0, r.instanceProps = a, cW({}, r, {}, i, {}, o);
              }
            }, {
              key: "_getEstimatedColumnSize",
              value: function value(e) {
                return "number" == typeof e.columnWidth ? e.columnWidth : e.estimatedColumnSize;
              }
            }, {
              key: "_getEstimatedRowSize",
              value: function value(e) {
                return "number" == typeof e.rowHeight ? e.rowHeight : e.estimatedRowSize;
              }
            }, {
              key: "_getScrollToPositionStateUpdate",
              value: function value(e) {
                var t = e.prevState,
                    n = e.scrollLeft,
                    r = e.scrollTop,
                    i = {
                  scrollPositionChangeReason: pW
                };
                return "number" == typeof n && n >= 0 && (i.scrollDirectionHorizontal = n > t.scrollLeft ? 1 : -1, i.scrollLeft = n), "number" == typeof r && r >= 0 && (i.scrollDirectionVertical = r > t.scrollTop ? 1 : -1, i.scrollTop = r), "number" == typeof n && n >= 0 && n !== t.scrollLeft || "number" == typeof r && r >= 0 && r !== t.scrollTop ? i : {};
              }
            }, {
              key: "_wrapSizeGetter",
              value: function value(e) {
                return "function" == typeof e ? e : function () {
                  return e;
                };
              }
            }, {
              key: "_getCalculatedScrollLeft",
              value: function value(e, t) {
                var n = e.columnCount,
                    r = e.height,
                    i = e.scrollToAlignment,
                    o = e.scrollToColumn,
                    a = e.width,
                    s = t.scrollLeft,
                    c = t.instanceProps;

                if (n > 0) {
                  var l = n - 1,
                      d = o < 0 ? l : Math.min(l, o),
                      u = c.rowSizeAndPositionManager.getTotalSize(),
                      p = c.scrollbarSizeMeasured && u > r ? c.scrollbarSize : 0;
                  return c.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: i,
                    containerSize: a - p,
                    currentOffset: s,
                    targetIndex: d
                  });
                }

                return 0;
              }
            }, {
              key: "_getScrollLeftForScrollToColumnStateUpdate",
              value: function value(e, n) {
                var r = n.scrollLeft,
                    i = t._getCalculatedScrollLeft(e, n);

                return "number" == typeof i && i >= 0 && r !== i ? t._getScrollToPositionStateUpdate({
                  prevState: n,
                  scrollLeft: i,
                  scrollTop: -1
                }) : {};
              }
            }, {
              key: "_getCalculatedScrollTop",
              value: function value(e, t) {
                var n = e.height,
                    r = e.rowCount,
                    i = e.scrollToAlignment,
                    o = e.scrollToRow,
                    a = e.width,
                    s = t.scrollTop,
                    c = t.instanceProps;

                if (r > 0) {
                  var l = r - 1,
                      d = o < 0 ? l : Math.min(l, o),
                      u = c.columnSizeAndPositionManager.getTotalSize(),
                      p = c.scrollbarSizeMeasured && u > a ? c.scrollbarSize : 0;
                  return c.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: i,
                    containerSize: n - p,
                    currentOffset: s,
                    targetIndex: d
                  });
                }

                return 0;
              }
            }, {
              key: "_getScrollTopForScrollToRowStateUpdate",
              value: function value(e, n) {
                var r = n.scrollTop,
                    i = t._getCalculatedScrollTop(e, n);

                return "number" == typeof i && i >= 0 && r !== i ? t._getScrollToPositionStateUpdate({
                  prevState: n,
                  scrollLeft: -1,
                  scrollTop: i
                }) : {};
              }
            }]), t;
          }(s.PureComponent), Py(eW, "propTypes", null), tW);
          Py(hW, "defaultProps", {
            "aria-label": "grid",
            "aria-readonly": !0,
            autoContainerWidth: !1,
            autoHeight: !1,
            autoWidth: !1,
            cellRangeRenderer: function cellRangeRenderer(e) {
              for (var t = e.cellCache, n = e.cellRenderer, r = e.columnSizeAndPositionManager, i = e.columnStartIndex, o = e.columnStopIndex, a = e.deferredMeasurementCache, s = e.horizontalOffsetAdjustment, c = e.isScrolling, l = e.isScrollingOptOut, d = e.parent, u = e.rowSizeAndPositionManager, p = e.rowStartIndex, h = e.rowStopIndex, _ = e.styleCache, f = e.verticalOffsetAdjustment, m = e.visibleColumnIndices, g = e.visibleRowIndices, v = [], b = r.areOffsetsAdjusted() || u.areOffsetsAdjusted(), y = !c && !b, w = p; w <= h; w++) {
                for (var S = u.getSizeAndPositionOfCell(w), x = i; x <= o; x++) {
                  var E = r.getSizeAndPositionOfCell(x),
                      C = x >= m.start && x <= m.stop && w >= g.start && w <= g.stop,
                      k = "".concat(w, "-").concat(x),
                      A = void 0;
                  y && _[k] ? A = _[k] : a && !a.has(w, x) ? A = {
                    height: "auto",
                    left: 0,
                    position: "absolute",
                    top: 0,
                    width: "auto"
                  } : (A = {
                    height: S.size,
                    left: E.offset + s,
                    position: "absolute",
                    top: S.offset + f,
                    width: E.size
                  }, _[k] = A);
                  var I = {
                    columnIndex: x,
                    isScrolling: c,
                    isVisible: C,
                    key: k,
                    parent: d,
                    rowIndex: w,
                    style: A
                  },
                      T = void 0;
                  !l && !c || s || f ? T = n(I) : (t[k] || (t[k] = n(I)), T = t[k]), null != T && !1 !== T && v.push(T);
                }
              }

              return v;
            },
            containerRole: "rowgroup",
            containerStyle: {},
            estimatedColumnSize: 100,
            estimatedRowSize: 30,
            getScrollbarSize: function getScrollbarSize(e) {
              if ((!QF && 0 !== QF || e) && YF) {
                var t = document.createElement("div");
                t.style.position = "absolute", t.style.top = "-9999px", t.style.width = "50px", t.style.height = "50px", t.style.overflow = "scroll", document.body.appendChild(t), QF = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
              }

              return QF;
            },
            noContentRenderer: function noContentRenderer() {
              return null;
            },
            onScroll: function onScroll() {},
            onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
            onSectionRendered: function onSectionRendered() {},
            overscanColumnCount: 0,
            overscanIndicesGetter: function overscanIndicesGetter(e) {
              var t = e.cellCount,
                  n = e.overscanCellsCount,
                  r = e.scrollDirection,
                  i = e.startIndex,
                  o = e.stopIndex;
              return 1 === r ? {
                overscanStartIndex: Math.max(0, i),
                overscanStopIndex: Math.min(t - 1, o + n)
              } : {
                overscanStartIndex: Math.max(0, i - n),
                overscanStopIndex: Math.min(t - 1, o)
              };
            },
            overscanRowCount: 10,
            role: "grid",
            scrollingResetTimeInterval: 150,
            scrollToAlignment: "auto",
            scrollToColumn: -1,
            scrollToRow: -1,
            style: {},
            tabIndex: 0,
            isScrollingOptOut: !1
          }), function (e) {
            var t = e.prototype;
            if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
            if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
            var n = null,
                r = null,
                i = null;

            if ("function" == typeof t.componentWillMount ? n = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (n = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? r = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (r = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? i = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (i = "UNSAFE_componentWillUpdate"), null !== n || null !== r || null !== i) {
              var o = e.displayName || e.name,
                  a = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
              throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + o + " uses " + a + " but also contains the following legacy lifecycles:" + (null !== n ? "\n  " + n : "") + (null !== r ? "\n  " + r : "") + (null !== i ? "\n  " + i : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
            }

            if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = JF, t.componentWillReceiveProps = $F), "function" == typeof t.getSnapshotBeforeUpdate) {
              if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
              t.componentWillUpdate = XF;
              var s = t.componentDidUpdate;

              t.componentDidUpdate = function (e, t, n) {
                var r = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : n;
                s.call(this, e, t, r);
              };
            }
          }(hW);

          var _W = (dW = lW = function (e) {
            function t() {
              var e, n;
              BC(this, t);

              for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
                i[o] = arguments[o];
              }

              return Py(jS(n = VR(this, (e = qR(t)).call.apply(e, [this].concat(i)))), "Grid", void 0), Py(jS(n), "_cellRenderer", function (e) {
                var t = e.parent,
                    r = e.rowIndex,
                    i = e.style,
                    o = e.isScrolling,
                    a = e.isVisible,
                    s = e.key,
                    c = n.props.rowRenderer,
                    l = Object.getOwnPropertyDescriptor(i, "width");
                return l && l.writable && (i.width = "100%"), c({
                  index: r,
                  style: i,
                  isScrolling: o,
                  isVisible: a,
                  key: s,
                  parent: t
                });
              }), Py(jS(n), "_setRef", function (e) {
                n.Grid = e;
              }), Py(jS(n), "_onScroll", function (e) {
                var t = e.clientHeight,
                    r = e.scrollHeight,
                    i = e.scrollTop;
                (0, n.props.onScroll)({
                  clientHeight: t,
                  scrollHeight: r,
                  scrollTop: i
                });
              }), Py(jS(n), "_onSectionRendered", function (e) {
                var t = e.rowOverscanStartIndex,
                    r = e.rowOverscanStopIndex,
                    i = e.rowStartIndex,
                    o = e.rowStopIndex;
                (0, n.props.onRowsRendered)({
                  overscanStartIndex: t,
                  overscanStopIndex: r,
                  startIndex: i,
                  stopIndex: o
                });
              }), n;
            }

            return HR(t, e), RS(t, [{
              key: "forceUpdateGrid",
              value: function value() {
                this.Grid && this.Grid.forceUpdate();
              }
            }, {
              key: "getOffsetForRow",
              value: function value(e) {
                var t = e.alignment,
                    n = e.index;
                return this.Grid ? this.Grid.getOffsetForCell({
                  alignment: t,
                  rowIndex: n,
                  columnIndex: 0
                }).scrollTop : 0;
              }
            }, {
              key: "invalidateCellSizeAfterRender",
              value: function value(e) {
                var t = e.columnIndex,
                    n = e.rowIndex;
                this.Grid && this.Grid.invalidateCellSizeAfterRender({
                  rowIndex: n,
                  columnIndex: t
                });
              }
            }, {
              key: "measureAllRows",
              value: function value() {
                this.Grid && this.Grid.measureAllCells();
              }
            }, {
              key: "recomputeGridSize",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = e.columnIndex,
                    n = void 0 === t ? 0 : t,
                    r = e.rowIndex,
                    i = void 0 === r ? 0 : r;
                this.Grid && this.Grid.recomputeGridSize({
                  rowIndex: i,
                  columnIndex: n
                });
              }
            }, {
              key: "recomputeRowHeights",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                this.Grid && this.Grid.recomputeGridSize({
                  rowIndex: e,
                  columnIndex: 0
                });
              }
            }, {
              key: "scrollToPosition",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                this.Grid && this.Grid.scrollToPosition({
                  scrollTop: e
                });
              }
            }, {
              key: "scrollToRow",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                this.Grid && this.Grid.scrollToCell({
                  columnIndex: 0,
                  rowIndex: e
                });
              }
            }, {
              key: "render",
              value: function value() {
                var e = this.props,
                    t = e.className,
                    n = e.noRowsRenderer,
                    r = e.scrollToIndex,
                    i = e.width,
                    o = VC("ReactVirtualized__List", t);
                return s.createElement(hW, xy({}, this.props, {
                  autoContainerWidth: !0,
                  cellRenderer: this._cellRenderer,
                  className: o,
                  columnWidth: i,
                  columnCount: 1,
                  noContentRenderer: n,
                  onScroll: this._onScroll,
                  onSectionRendered: this._onSectionRendered,
                  ref: this._setRef,
                  scrollToRow: r
                }));
              }
            }]), t;
          }(s.PureComponent), Py(lW, "propTypes", null), dW);

          Py(_W, "defaultProps", {
            autoHeight: !1,
            estimatedRowSize: 30,
            onScroll: function onScroll() {},
            noRowsRenderer: function noRowsRenderer() {
              return null;
            },
            onRowsRendered: function onRowsRendered() {},
            overscanIndicesGetter: function overscanIndicesGetter(e) {
              var t = e.cellCount,
                  n = e.overscanCellsCount,
                  r = e.scrollDirection,
                  i = e.startIndex,
                  o = e.stopIndex;
              return n = Math.max(1, n), 1 === r ? {
                overscanStartIndex: Math.max(0, i - 1),
                overscanStopIndex: Math.min(t - 1, o + n)
              } : {
                overscanStartIndex: Math.max(0, i - n),
                overscanStopIndex: Math.min(t - 1, o + 1)
              };
            },
            overscanRowCount: 10,
            scrollToAlignment: "auto",
            scrollToIndex: -1,
            style: {}
          });
          var fW = ["children", "label", "labelButtonType", "className"];
          var mW;
          !function (e) {
            e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary", e.Border = "border", e.Transparent = "transparent";
          }(mW || (mW = {}));

          var gW = Ok(function (e) {
            return {
              root: function root(t) {
                var n, r, i;
                var o = t.labelButtonType;
                return _defineProperty({
                  borderRadius: e.spacing(1.5),
                  padding: e.spacing(.5, 3),
                  minWidth: e.spacing(10),
                  color: e.palette.common.white,
                  margin: e.spacing(0, 1),
                  backfaceVisibility: "hidden",
                  transition: e.transitions.create("all", {
                    easing: e.transitions.easing.easeInOut,
                    duration: e.transitions.duration.standard
                  }),
                  border: o === mW.Border ? "1px solid #909096" : "none"
                }, "&.".concat(kH, "-MuiButton-root"), {
                  backgroundColor: o === mW.Border || o === mW.Transparent ? "transparent" : null === (n = e.palette[o]) || void 0 === n ? void 0 : n.main,
                  "&:hover": {
                    backgroundColor: o === mW.Border || o === mW.Transparent ? e.palette.action.hover : null === (r = e.palette[o]) || void 0 === r ? void 0 : r.light
                  },
                  "&:active": {
                    backgroundColor: o === mW.Border || o === mW.Transparent ? e.palette.action.active : null === (i = e.palette[o]) || void 0 === i ? void 0 : i.dark
                  }
                });
              }
            };
          }),
              vW = function vW(e) {
            var t = e.children,
                n = e.label,
                r = e.labelButtonType,
                i = e.className,
                o = h(e, fW);
            var a = gW({
              labelButtonType: r
            });
            return TH.exports.jsx(YA, u(u({
              className: VC(a.root, i),
              size: "small"
            }, o), {}, {
              children: TH.exports.jsx(QA, {
                variant: "button",
                children: n
              })
            }));
          },
              bW = Ok(function () {
            return {
              root: {
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "36px",
                fontSize: "13px",
                cursor: "pointer",
                "&:focus": {
                  outline: "none"
                },
                "&:hover": {
                  borderRadius: "8px",
                  background: "rgba(255, 255, 255, 0.09)"
                }
              },
              active: {
                borderRadius: "8px",
                background: "rgba(255, 255, 255, 0.09)"
              },
              selected: {
                borderRadius: "8px",
                background: "rgba(255, 255, 255, 0.18) !important"
              },
              info: _defineProperty({
                width: "90%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: "13px",
                selected: {
                  width: "calc(100% - 30px)"
                }
              }, "& .".concat(kH, "-MuiTypography-body1"), {
                fontSize: "13px"
              }),
              avatarwrap: {
                flexShrink: 0,
                margin: "0 8px 0 4px"
              },
              avatar: {
                display: "flex",
                alignItems: "center",
                width: "24px",
                height: "24px",
                borderRadius: "8px"
              },
              defaultavatar: _defineProperty({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                borderRadius: "8px",
                background: "rgba(255, 255, 255, 0.09)"
              }, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "20px"
              })
            };
          }),
              yW = function yW(e) {
            var t = e.user,
                n = e.onClick,
                r = e.activeItemIndex,
                i = e.selectedUserId,
                o = e.index,
                a = e.currentUserId,
                s = e.isCurrentUserGuest,
                c = e.style,
                l = t.avatar,
                d = t.displayName,
                u = t.userId,
                p = i === u,
                h = zz(t, a, s),
                _ = bW(),
                f = p ? VC(_.root, _.selected) : VC(_.root),
                m = r === o ? VC(f, _.active) : f;

            return TH.exports.jsxs(zT, {
              className: m,
              onClick: function onClick() {
                n && n(u);
              },
              style: c,
              disableGutters: !0,
              id: "assigned-candidate-list-".concat(o),
              children: [TH.exports.jsxs("div", {
                className: _.info,
                children: [TH.exports.jsxs(WA, {
                  className: _.avatarwrap,
                  children: [l && TH.exports.jsx(XA, {
                    component: "img",
                    className: _.avatar,
                    image: l,
                    alt: "avatar of user"
                  }), !l && TH.exports.jsx(WA, {
                    component: "i",
                    className: _.defaultavatar,
                    children: TH.exports.jsx(CF, {
                      type: "icon-avatar"
                    })
                  })]
                }), d && TH.exports.jsx(QA, {
                  variant: "body1",
                  noWrap: !0,
                  title: h ? d + h : d,
                  children: d
                }), h && TH.exports.jsx(QA, {
                  variant: "body1",
                  noWrap: !0,
                  children: h
                })]
              }), p && TH.exports.jsx(CF, {
                iconStyle: {
                  fontSize: "12px",
                  margin: "0 10px 0 5px"
                },
                type: "icon-checked"
              })]
            });
          },
              wW = Ok(function () {
            return {
              title: {
                fontSize: "13px",
                marginBottom: "8px",
                fontWeight: "bold"
              },
              button: {
                width: "100%",
                marginTop: "8px"
              },
              clear: _defineProperty({}, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "14px"
              }),
              list: {
                "& .ReactVirtualized__List::-webkit-scrollbar": {
                  width: 4,
                  backgroundColor: "#2a2b2e"
                },
                "& .ReactVirtualized__List::-webkit-scrollbar-thumb": {
                  borderRadius: "100px",
                  "background-color": "#3D3D3D"
                }
              },
              input: {
                "&:after": {
                  border: "none !important"
                },
                "&:before": {
                  border: "none !important"
                }
              }
            };
          }),
              SW = function SW(t) {
            var _e$useContext15 = e.useContext(jM),
                n = _e$useContext15.participants,
                r = _e$useContext15.userId,
                i = e.useContext(zM),
                _e$useContext16 = e.useContext(JM),
                o = _e$useContext16.dispatch,
                _e$useState33 = e.useState(""),
                _e$useState34 = _slicedToArray(_e$useState33, 2),
                a = _e$useState34[0],
                s = _e$useState34[1],
                _e$useState35 = e.useState(-1),
                _e$useState36 = _slicedToArray(_e$useState35, 2),
                c = _e$useState36[0],
                l = _e$useState36[1],
                _e$useState37 = e.useState(0),
                _e$useState38 = _slicedToArray(_e$useState37, 2),
                d = _e$useState38[0],
                u = _e$useState38[1],
                _NM7 = NM(),
                p = _NM7.t,
                h = wW(),
                _ = e.useRef(null),
                f = e.useMemo(function () {
              return n.find(function (e) {
                return e.userId === r;
              });
            }, [r, n]),
                m = e.useMemo(function () {
              var e = n.filter(function (e) {
                return e.userId !== r;
              }),
                  _e$reduce = e.reduce(function (e, t) {
                var _e287 = _slicedToArray(e, 2),
                    n = _e287[0],
                    r = _e287[1];

                return t.isCoHost ? n.push(t) : r.push(t), e;
              }, [[], []]),
                  _e$reduce2 = _slicedToArray(_e$reduce, 2),
                  t = _e$reduce2[0],
                  i = _e$reduce2[1];

              t = t.sort(function (e, t) {
                return e.displayName.toUpperCase() < t.displayName.toUpperCase() ? -1 : 1;
              }), i = i.sort(function (e, t) {
                return e.displayName.toUpperCase() < t.displayName.toUpperCase() ? -1 : 1;
              });
              var o = [].concat(_toConsumableArray(t), _toConsumableArray(i));
              return a && "" !== a.trim() ? o.filter(function (e) {
                return e.displayName.toUpperCase().indexOf(a.toUpperCase()) > -1;
              }) : o;
            }, [a, n, r]),
                g = e.useCallback(function (e) {
              s(e.target.value);
            }, []),
                v = e.useCallback(function () {
              s("");
            }, []),
                b = e.useCallback(function (e) {
              u(e);
            }, []),
                y = e.useCallback(function (e) {
              if ("ArrowUp" === e.code || "ArrowLeft" === e.code) {
                var t;
                e.preventDefault();

                var _n92 = c > 0 ? c - 1 : m.length - 1;

                l(_n92), null === (t = _.current) || void 0 === t || t.scrollToRow(_n92);
              } else if ("ArrowDown" === e.code || "ArrowRight" === e.code) {
                var n;
                e.preventDefault();

                var _t141 = c < m.length - 1 ? c + 1 : 0;

                l(_t141), null === (n = _.current) || void 0 === n || n.scrollToRow(_t141);
              } else "Enter" === e.code && (e.preventDefault(), c > -1 && u(m[c].userId));
            }, [c, m]),
                w = e.useCallback(function () {
              d && (i.makeHost(d), i.leave(), null == o || o(BB(!1)));
            }, [i, o, d]),
                S = e.useCallback(function (e) {
              var t = e.index,
                  n = e.key,
                  i = e.style;
              return TH.exports.jsx(yW, {
                user: m[t],
                onClick: b,
                activeItemIndex: c,
                currentUserId: r,
                selectedUserId: d,
                index: t,
                style: i,
                isCurrentUserGuest: !(null == f || !f.isGuest)
              }, n);
            }, [m, c, r, d, f, b]);

            var x = 0;
            return x = m.length > 4 || a ? 144 : 36 * m.length, TH.exports.jsxs(WA, {
              role: "application",
              children: [TH.exports.jsx(QA, {
                variant: "h6",
                className: h.title,
                noWrap: !0,
                children: p("wc_footer_assign_new_host")
              }), TH.exports.jsxs(WA, {
                children: [n.length - 1 > 4 && TH.exports.jsx(WA, {
                  children: TH.exports.jsx(ST, {
                    onChange: g,
                    value: a,
                    className: h.input,
                    startAdornment: TH.exports.jsx(ET, {
                      position: "start",
                      children: TH.exports.jsx(CF, {
                        type: "icon-search",
                        iconStyle: {
                          fontSize: "12px"
                        }
                      })
                    }),
                    endAdornment: TH.exports.jsx(ET, {
                      position: "end",
                      children: TH.exports.jsx(AF, {
                        className: h.clear,
                        "aria-label": "clear input",
                        onClick: v,
                        iconType: "icon-close"
                      })
                    })
                  })
                }), TH.exports.jsx(WA, {
                  tabIndex: 0,
                  "aria-activedescendant": "assigned-candidate-list-".concat(c),
                  onKeyDown: y,
                  className: h.list,
                  role: "listbox",
                  "aria-label": "participants list, please type the enter key to select the new host",
                  children: TH.exports.jsx(_W, {
                    ref: _,
                    width: 208,
                    height: x,
                    rowCount: m.length,
                    rowHeight: 36,
                    rowRenderer: S
                  })
                }), TH.exports.jsx(vW, {
                  className: h.button,
                  onClick: w,
                  disabled: !d,
                  labelButtonType: mW.Secondary,
                  label: p("wc_footer_assign_leave")
                })]
              })]
            });
          },
              xW = ["onClickAway", "anchorEl", "children", "open"],
              EW = function EW(e) {
            var t = e.onClickAway,
                n = e.anchorEl,
                r = e.children,
                i = e.open,
                o = h(e, xW);
            var a = i ? "transition-popper" : void 0;
            return TH.exports.jsx(RR, u(u({
              id: a,
              open: i,
              anchorEl: n,
              transition: !0
            }, o), {}, {
              children: function children(e) {
                var n = e.TransitionProps;
                var i = TH.exports.jsx(HA, u(u({}, n), {}, {
                  timeout: 200,
                  children: TH.exports.jsx(WA, {
                    children: r
                  })
                }));
                return t ? TH.exports.jsx(fI, {
                  onClickAway: t,
                  children: i
                }) : i;
              }
            }));
          },
              CW = Ok(function (e) {
            return {
              container: {
                bottom: 0
              },
              paper: {
                borderRadius: "8px",
                padding: "10px 0px 10px 0px",
                minWidth: "180px",
                backgroundColor: e.palette.background.default
              },
              paper2: {
                borderRadius: "8px",
                padding: "16px",
                width: "240px",
                boxSizing: "border-box",
                backgroundColor: e.palette.background.default
              },
              leave: {
                borderLeft: "1px solid rgba(255, 255, 255, 0.18)",
                paddingLeft: "10px"
              }
            };
          }),
              kW = function kW(t) {
            var n = t.isDisabled,
                r = e.useRef(null),
                _e$useContext17 = e.useContext(jM),
                i = _e$useContext17.isHost,
                _e$useContext18 = e.useContext(JM),
                o = _e$useContext18.isShowLeaveBox,
                a = _e$useContext18.isShowAssignHost,
                s = _e$useContext18.dispatch,
                c = e.useCallback(function () {
              null == s || s(HB(!1)), null == s || s(BB(!1));
            }, [s]),
                l = e.useCallback(function () {
              null == s || s(HB(!0));
            }, [s]);

            e.useEffect(function () {
              i || c();
            }, [i, c]);

            var _NM8 = NM(),
                d = _NM8.t,
                u = CW();

            return TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsx("div", {
                ref: r,
                className: u.container,
                children: o || a ? TH.exports.jsx(vW, {
                  labelButtonType: mW.Transparent,
                  onClick: c,
                  label: d("common.cancel")
                }) : TH.exports.jsx("div", {
                  className: u.leave,
                  children: TH.exports.jsx(AF, {
                    iconType: "icon-leave",
                    onClick: l,
                    disabled: n,
                    title: d("toolbar_leave")
                  })
                })
              }), TH.exports.jsx(EW, {
                open: o || a,
                anchorEl: null == r ? void 0 : r.current,
                modifiers: {
                  offset: {
                    enabled: !0,
                    offset: "0,8"
                  }
                },
                placement: "top-end",
                onClickAway: c,
                children: TH.exports.jsxs(kA, {
                  className: a ? u.paper2 : u.paper,
                  children: [o && TH.exports.jsx(HF, {}), a && TH.exports.jsx(SW, {})]
                })
              })]
            });
          },
              AW = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !Uz();

          function IW() {
            var _e$useContext19 = e.useContext(jM),
                t = _e$useContext19.isHost,
                n = _e$useContext19.isCoHost,
                r = _e$useContext19.userId,
                i = _e$useContext19.isStartedAudio,
                o = _e$useContext19.isAttendee,
                a = _e$useContext19.isMuted,
                s = _e$useContext19.isAllowToTalk,
                c = _e$useContext19.isScreenSharingWithAudio,
                l = _e$useContext19.isSharePaused,
                d = _e$useContext19.isShareAudioMuted,
                u = e.useContext(zM),
                _e$useContext20 = e.useContext(DM),
                p = _e$useContext20.stream,
                _e$useContext20$audio = _e$useContext20.audio,
                h = _e$useContext20$audio.decode,
                _ = _e$useContext20$audio.encode,
                _e$useContext21 = e.useContext(JM),
                f = _e$useContext21.dispatch,
                m = _e$useContext21.isShowAudioWarning,
                g = function (t, n, r) {
              var _e$useState39 = e.useState(0),
                  _e$useState40 = _slicedToArray(_e$useState39, 2),
                  i = _e$useState40[0],
                  o = _e$useState40[1],
                  a = e.useRef(),
                  s = e.useCallback(function (e) {
                !r && Array.isArray(e) && e.length > 0 && (e.some(function (e) {
                  return e.userId === n;
                }) ? o(9) : a.current || o(0));
              }, [n, r]);

              return e.useEffect(function () {
                return i && (a.current = window.setTimeout(function () {
                  o(0), a.current = 0;
                }, 1500)), function () {
                  a.current && window.clearTimeout(a.current);
                };
              }, [i]), e.useEffect(function () {
                return t.on("active-speaker", s), function () {
                  t.off("active-speaker", s);
                };
              }, [t, s]), i;
            }(u, r, a),
                _Nj = Nj(),
                v = _Nj.enqueueSnackbar,
                _NM9 = NM(),
                b = _NM9.t,
                y = t || n;

            return {
              onAudioButtonClick: e.useCallback(function () {
                try {
                  o ? (i ? s ? a ? null != p && p.isAllowToUnmute() || y ? null == p || p.unmuteAudio() : v(b("wc_audio_cannot_unmute"), {
                    variant: "error"
                  }) : null == p || p.muteAudio() : null == p || p.stopAudio() : (AW ? h && (null == p || p.startAudio()) : null == p || p.startAudio(), null == p || p.unmuteAudio(), null != p && p.isAllowToUnmute() || null == p || p.muteAudio()), null == f || f(FB(!1))) : (i ? a ? null != p && p.isAllowToUnmute() || y ? null == p || p.unmuteAudio() : v(b("wc_audio_cannot_unmute"), {
                    variant: "error"
                  }) : null == p || p.muteAudio() : (AW ? h && _ && (null == p || p.startAudio()) : null == p || p.startAudio(), null != p && p.isAllowToUnmute() || null == p || p.muteAudio()), null == f || f(FB(!1)));
                } catch (e) {
                  if ("INSUFFICIENT_PRIVILEGES" !== (null == e ? void 0 : e.type)) throw e;
                  if ("USER_FORBIDDEN_MICROPHONE" !== (null == e ? void 0 : e.reason)) throw e;
                  null == f || f(FB(!0));
                }
              }, [o, i, f, a, p, y, v, b, s, h, _]),
              getAudioButtonIcon: e.useCallback(function () {
                return m ? "icon-audio-warning" : i ? a ? "icon-audio-muted" : g ? "icon-audio-active-animated" : "icon-audio" : "icon-join-audio";
              }, [m, i, g, a]),
              isAudioButtonDisabled: e.useCallback(function () {
                return i && c && !l && !d;
              }, [c, d, l, i])
            };
          }

          var TW = Ok(function (e) {
            return {
              numParticipants: {
                position: "relative",
                top: e.spacing(-.25),
                left: e.spacing(.25)
              }
            };
          }),
              OW = function OW(t) {
            var n;

            var r = t.className,
                i = t.isReassignMode,
                o = TW(),
                _e$useContext22 = e.useContext(jM),
                a = _e$useContext22.status,
                s = _e$useContext22.isHost,
                c = _e$useContext22.isCoHost,
                l = _e$useContext22.isStartedVideo,
                d = _e$useContext22.isStartedAudio,
                u = _e$useContext22.attendees,
                p = _e$useContext22.isMuted,
                h = _e$useContext22.isWebinar,
                _ = _e$useContext22.assistants,
                _HH = HH(),
                f = _HH.hasAst,
                m = _HH.hasRmc,
                _e$useContext23 = e.useContext(JM),
                g = _e$useContext23.isShowParticipant,
                v = _e$useContext23.participantSize,
                b = _e$useContext23.isShowAudioWarning,
                y = _e$useContext23.isShowVideoWarning,
                w = _e$useContext23.customization,
                S = _e$useContext23.dispatch,
                _NM10 = NM(),
                x = _NM10.t,
                _IW = IW(),
                E = _IW.onAudioButtonClick,
                C = _IW.getAudioButtonIcon,
                k = _IW.isAudioButtonDisabled,
                _ref32 = function () {
              var _e$useContext24 = e.useContext(jM),
                  t = _e$useContext24.isHost,
                  n = _e$useContext24.isCoHost,
                  r = _e$useContext24.isStartedVideo,
                  i = _e$useContext24.isSupportMultipleVideos,
                  _e$useContext25 = e.useContext(DM),
                  o = _e$useContext25.stream,
                  _Nj2 = Nj(),
                  a = _Nj2.enqueueSnackbar,
                  _e$useContext26 = e.useContext(JM),
                  s = _e$useContext26.isSupportVB,
                  c = _e$useContext26.virtualBackgroundImageId,
                  l = _e$useContext26.virtualBackgroundImageList,
                  d = _e$useContext26.virtualBackgroundPreloadState,
                  u = _e$useContext26.dispatch,
                  _NM11 = NM(),
                  p = _NM11.t,
                  h = t || n,
                  _ = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
                var e, t, n, _, _o$getHardwareAcceler, _e288, _e289;

                return _regeneratorRuntime.wrap(function _callee28$(_context28) {
                  while (1) {
                    switch (_context28.prev = _context28.next) {
                      case 0:
                        e = "";
                        c && (e = null === (t = l.find(function (e) {
                          return e.id === c;
                        })) || void 0 === t ? void 0 : t.displayURL);
                        n = !1, _ = !1;

                        if (o) {
                          n = o.isSupportHDVideo();
                          _o$getHardwareAcceler = o.getHardwareAccelerationStatus(), _e288 = _o$getHardwareAcceler.encode;
                          _ = _e288;
                        }

                        _context28.prev = 4;

                        if (!r) {
                          _context28.next = 10;
                          break;
                        }

                        _context28.next = 8;
                        return null == o ? void 0 : o.stopVideo();

                      case 8:
                        _context28.next = 29;
                        break;

                      case 10:
                        if (!(h || null != o && o.isEnableUnmuteVideo())) {
                          _context28.next = 28;
                          break;
                        }

                        if (!(i && !Bz() || !Hz())) {
                          _context28.next = 21;
                          break;
                        }

                        if (!(s && d === YM.Success)) {
                          _context28.next = 17;
                          break;
                        }

                        _context28.next = 15;
                        return null == o ? void 0 : o.startVideo({
                          virtualBackground: {
                            imageUrl: e,
                            cropped: !0
                          },
                          hd: n && _
                        });

                      case 15:
                        _context28.next = 19;
                        break;

                      case 17:
                        _context28.next = 19;
                        return null == o ? void 0 : o.startVideo({
                          hd: n && _
                        });

                      case 19:
                        _context28.next = 26;
                        break;

                      case 21:
                        _e289 = document.querySelector("#".concat(WM));
                        _context28.t0 = _e289;

                        if (!_context28.t0) {
                          _context28.next = 26;
                          break;
                        }

                        _context28.next = 26;
                        return null == o ? void 0 : o.startVideo({
                          videoElement: _e289
                        });

                      case 26:
                        _context28.next = 29;
                        break;

                      case 28:
                        a(p("wc_video.model_stop"), {
                          variant: "error"
                        });

                      case 29:
                        null == u || u(WB(!1));
                        _context28.next = 37;
                        break;

                      case 32:
                        _context28.prev = 32;
                        _context28.t1 = _context28["catch"](4);

                        if (!("VIDEO_USER_FORBIDDEN_CAPTURE" !== (null == _context28.t1 ? void 0 : _context28.t1.type))) {
                          _context28.next = 36;
                          break;
                        }

                        throw _context28.t1;

                      case 36:
                        null == u || u(WB(!0));

                      case 37:
                      case "end":
                        return _context28.stop();
                    }
                  }
                }, _callee28, null, [[4, 32]]);
              })), [c, l, r, u, o, h, i, a, s, d, p]);

              return {
                onVideoButtonClick: _
              };
            }(),
                A = _ref32.onVideoButtonClick,
                _ref33 = function () {
              var _e$useContext27 = e.useContext(jM),
                  t = _e$useContext27.isStartedShare,
                  _e$useContext28 = e.useContext(DM),
                  n = _e$useContext28.stream,
                  _Nj3 = Nj(),
                  r = _Nj3.enqueueSnackbar,
                  _NM12 = NM(),
                  i = _NM12.t,
                  o = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
                var _t142, _e290;

                return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                  while (1) {
                    switch (_context29.prev = _context29.next) {
                      case 0:
                        if (t) {
                          _context29.next = 11;
                          break;
                        }

                        _t142 = document.querySelector("#".concat(FM));
                        _t142 || (_t142 = document.createElement("canvas"), _t142.id = FM, _t142.style.display = "none");
                        _context29.prev = 3;
                        _context29.next = 6;
                        return null == n ? void 0 : n.startShareScreen(_t142);

                      case 6:
                        _context29.next = 11;
                        break;

                      case 8:
                        _context29.prev = 8;
                        _context29.t0 = _context29["catch"](3);

                        if ("INSUFFICIENT_PRIVILEGES" === (null == _context29.t0 ? void 0 : _context29.t0.type)) {
                          _e290 = null == n ? void 0 : n.getSharePrivilege();
                          _e290 === GM.OnlyHost ? r(i("wc_sharer_disabled_share1_desc"), {
                            variant: "error"
                          }) : _e290 === GM.HostGrab && r(i("wc_sharer_disabled_share2_desc"), {
                            variant: "error"
                          });
                        }

                      case 11:
                      case "end":
                        return _context29.stop();
                    }
                  }
                }, _callee29, null, [[3, 8]]);
              })), [n, t, i, r]);

              return {
                onShareButtonClick: o
              };
            }(),
                I = _ref33.onShareButtonClick,
                T = a !== jj.Connected,
                O = s || c;

            var R = v;
            return m && (R += 1), _.length && (R += _.length), h && (R += null == u ? void 0 : u.length), TH.exports.jsxs(TH.exports.Fragment, {
              children: [!i && TH.exports.jsxs(TH.exports.Fragment, {
                children: [TH.exports.jsx(AF, {
                  iconType: C(),
                  onClick: E,
                  disabled: T || k(),
                  title: x(b ? "wc_prevent_access_mic" : d ? p ? "toolbar_unmute" : "toolbar_mute" : "wc_audio")
                }), TH.exports.jsx(AF, {
                  iconType: y ? "icon-video-warning" : l ? "icon-video" : "icon-video-muted",
                  onClick: A,
                  disabled: T,
                  title: x(y ? "wc_camera_prevent" : l ? "wc_video.stop_video" : "wc_video.start_video")
                }), TH.exports.jsx(AF, {
                  iconType: "icon-share",
                  onClick: I,
                  disabled: T,
                  title: x("wc_sharer_entry_button_label1")
                }), O && TH.exports.jsx(DF, {}), !O && TH.exports.jsx(AF, {
                  iconType: "icon-participant",
                  onClick: function onClick() {
                    null == S || S(MB(!g));
                  },
                  disabled: T,
                  title: x("wc_participants"),
                  children: R > 0 && TH.exports.jsx(QA, {
                    variant: "subtitle1",
                    className: o.numParticipants,
                    noWrap: !0,
                    children: R
                  })
                }), TH.exports.jsx(UF, {
                  buttons: null == w || null === (n = w.toolbar) || void 0 === n ? void 0 : n.buttons
                })]
              }), TH.exports.jsx(kW, {
                isDisabled: T
              })]
            });
          },
              RW = function RW(t) {
            var _e$useContext29 = e.useContext(jM),
                n = _e$useContext29.status,
                r = _e$useContext29.ccStatus,
                _e$useContext30 = e.useContext(JM),
                _e$useContext30$isSho = _e$useContext30.isShowCC,
                i = _e$useContext30$isSho.history,
                o = _e$useContext30$isSho.toast,
                a = _e$useContext30.dispatch,
                _NM13 = NM(),
                s = _NM13.t,
                c = n !== jj.Connected,
                l = function l(e) {
              "ccHistory" === e ? null == a || a(QB(!i)) : "ccToast" === e && (null == a || a(ZB(!o)));
            },
                d = [(r.isCCEnable || r.isLTEnable) && r.isMeetingEnableViewFullTranscript && {
              text: s(i ? "wc_lt_menu_item4" : "wc_lt_menu_item2"),
              onClick: function onClick() {
                l("ccHistory");
              }
            }, (r.isCCEnable || r.isLTEnable) && {
              text: s(o ? "wc_lt_menu_item3" : "wc_lt_menu_item1"),
              onClick: function onClick() {
                l("ccToast");
              }
            }].filter(Boolean);

            return TH.exports.jsx(PF, {
              iconType: "icon-closed-caption-btn",
              disabled: c,
              menu: d,
              title: r.isMeetingEnabledLiveTranscriptionFeature ? s("wc_lt_live_transcript") : s("wc_closed_caption_btn")
            });
          },
              NW = Ok(function (e) {
            return {
              opened: _defineProperty({}, "&.".concat(kH, "-MuiButton-root"), {
                background: "rgba(255, 255, 255, 0.18)",
                borderRadius: "6px"
              })
            };
          }),
              PW = function PW(t) {
            var n, r;

            var i = t.className,
                o = t.isReassignMode,
                a = NW(),
                _e$useContext31 = e.useContext(jM),
                s = _e$useContext31.status,
                c = _e$useContext31.ccStatus,
                l = _e$useContext31.userId,
                d = _e$useContext31.isStartedAudio,
                u = _e$useContext31.attendees,
                p = _e$useContext31.isMuted,
                h = _e$useContext31.isAllowToTalk,
                _ = _e$useContext31.isEnableQA,
                f = _e$useContext31.meetingOptions.isChatEnabled,
                _e$useContext32 = e.useContext(JM),
                m = _e$useContext32.isShowChat,
                g = _e$useContext32.isShowSetting,
                v = _e$useContext32.isShowAudioWarning,
                b = _e$useContext32.isShowQAPanel,
                y = _e$useContext32.isShowCC.toast,
                w = _e$useContext32.customization,
                S = _e$useContext32.dispatch,
                x = e.useContext(zM),
                _NM14 = NM(),
                E = _NM14.t,
                _IW2 = IW(),
                C = _IW2.onAudioButtonClick,
                k = s !== jj.Connected,
                A = u.find(function (e) {
              return (null == e ? void 0 : e.userId) === l;
            }),
                I = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
              return _regeneratorRuntime.wrap(function _callee30$(_context30) {
                while (1) {
                  switch (_context30.prev = _context30.next) {
                    case 0:
                      _context30.t0 = null != x && x.isAllowToRaiseHand();

                      if (!_context30.t0) {
                        _context30.next = 9;
                        break;
                      }

                      if (!(null != A && A.bRaiseHand)) {
                        _context30.next = 7;
                        break;
                      }

                      _context30.next = 5;
                      return null == x ? void 0 : x.lowerHand();

                    case 5:
                      _context30.next = 9;
                      break;

                    case 7:
                      _context30.next = 9;
                      return null == x ? void 0 : x.raiseHand();

                    case 9:
                    case "end":
                      return _context30.stop();
                  }
                }
              }, _callee30);
            })), [x, A]),
                T = function T() {
              null == S || S(VB(!g));
            };

            return TH.exports.jsxs(TH.exports.Fragment, {
              children: [!o && TH.exports.jsxs(TH.exports.Fragment, {
                children: [h && TH.exports.jsx(AF, {
                  iconType: v ? "icon-audio-warning" : d ? p ? "icon-audio-muted" : "icon-audio" : "icon-join-audio",
                  onClick: C,
                  disabled: k,
                  title: E(v ? "wc_prevent_access_mic" : d ? p ? "toolbar_unmute" : "toolbar_mute" : "wc_audio")
                }), !h && !d && TH.exports.jsx(AF, {
                  iconType: "icon-join-audio",
                  onClick: C,
                  disabled: k,
                  title: E("toolbar_join_audio")
                }), !h && d && TH.exports.jsx(AF, {
                  iconType: "icon-settings",
                  onClick: T,
                  disabled: k
                }), f && TH.exports.jsx(AF, {
                  iconType: "icon-chat",
                  onClick: function onClick() {
                    null == S || S(LB(!m));
                  },
                  disabled: k,
                  title: E("wc_chat.chat")
                }), _ && TH.exports.jsx(AF, {
                  iconType: "icon-q&a",
                  onClick: function onClick() {
                    null == S || S(oH(!b));
                  },
                  disabled: k,
                  title: E("wc_qa.qa_comp_title")
                }), TH.exports.jsx(AF, {
                  iconType: "icon-hand-raise",
                  onClick: I,
                  disabled: k || !x.isAllowToRaiseHand(),
                  title: null != A && A.bRaiseHand ? E("wc_lower_hand") : E("wc_raise_hand"),
                  className: null != A && A.bRaiseHand ? a.opened : ""
                }), x.isAttendee() && ((null == c ? void 0 : c.isCCEnable) || (null == c ? void 0 : c.isLTEnable)) && TH.exports.jsx(RW, {}), h && TH.exports.jsx(AF, {
                  iconType: "icon-settings",
                  onClick: T,
                  disabled: k
                }), (null == w || null === (n = w.toolbar) || void 0 === n ? void 0 : n.buttons) && TH.exports.jsx(UF, {
                  buttons: null == w || null === (r = w.toolbar) || void 0 === r ? void 0 : r.buttons
                })]
              }), TH.exports.jsx(kW, {
                isDisabled: k
              })]
            });
          },
              jW = Ok(function (e) {
            return {
              root: {
                padding: e.spacing(2, 0),
                display: "flex",
                margin: "0 auto",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                "& > button:not(:last-child)": {
                  marginRight: e.spacing(1.5)
                },
                "& > div:not(:last-child)": {
                  marginRight: e.spacing(1.5)
                }
              },
              assignMode: {
                justifyContent: "flex-end"
              }
            };
          }),
              DW = function DW(t) {
            var n = t.className,
                r = jW(),
                _e$useContext33 = e.useContext(jM),
                i = _e$useContext33.isAttendee,
                o = _e$useContext33.isWebinar,
                _e$useContext34 = e.useContext(JM),
                a = _e$useContext34.isShowLeaveBox,
                s = _e$useContext34.isShowAssignHost;

            !function () {
              var t = e.useContext(zM),
                  _Nj4 = Nj(),
                  n = _Nj4.enqueueSnackbar,
                  _NM15 = NM(),
                  r = _NM15.t,
                  i = e.useCallback(function (e) {
                e.action === Pa.Muted && e.source === Na.PassiveByMuteOne && n(r("wc_audio.muted_notification1"), {
                  variant: "info"
                }), e.action === Pa.Muted && e.source === Na.PassiveByMuteAll && n(r("wc_audio.muted_notification2"), {
                  variant: "info"
                });
              }, [n, r]);

              e.useEffect(function () {
                return t.on("current-audio-change", i), function () {
                  t.off("current-audio-change", i);
                };
              }, [t, i]);
            }();
            var c = s || a;
            return TH.exports.jsx(kA, {
              className: VC(r.root, n, _defineProperty({}, r.assignMode, c)),
              children: o && i ? TH.exports.jsx(PW, {
                className: n,
                isReassignMode: c
              }) : TH.exports.jsx(OW, {
                className: n,
                isReassignMode: c
              })
            });
          },
              zW = Ok(function (e) {
            return {
              root: {
                border: "0.5px solid rgba(35,35,51,0.2)",
                boxShadow: "0 8px 24px rgba(35,35,51,0.2)",
                borderRadius: e.shape.borderRadius,
                padding: e.spacing(3),
                width: "480px"
              },
              title: {
                marginLeft: "32px",
                marginRight: "32px",
                marginTop: "32px"
              },
              content: {
                margin: "16px 32px",
                minHeight: "20px"
              },
              buttonGroup: {
                marginLeft: "32px",
                marginRight: "32px",
                marginBottom: "24px",
                display: "flex",
                justifyContent: "flex-end"
              }
            };
          }),
              MW = function MW(t) {
            var n = t.anchorEl,
                r = t.modifiers,
                i = t.placement,
                o = zW(),
                _e$useContext35 = e.useContext(jM),
                a = _e$useContext35.isWebinar,
                _NM16 = NM(),
                s = _NM16.t,
                _IW3 = IW(),
                c = _IW3.onAudioButtonClick,
                _e$useContext36 = e.useContext(JM),
                l = _e$useContext36.isShowUnmuteConsent,
                d = _e$useContext36.dispatch,
                p = TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsx(WA, {
                className: VC(o.title),
                children: TH.exports.jsx(QA, {
                  variant: "h1",
                  children: s("wc_audio.unmute_by_host_content_1")
                })
              }), TH.exports.jsx(WA, {
                className: VC(o.content),
                children: a && TH.exports.jsx(QA, {
                  variant: "body2",
                  children: s("wc_audio.unmute_by_host_content_2")
                })
              }), TH.exports.jsxs(WA, {
                className: VC(o.buttonGroup),
                children: [TH.exports.jsx(vW, {
                  label: s("toolbar_unmute"),
                  labelButtonType: mW.Primary,
                  onClick: function onClick() {
                    c(), null == d || d(nH(!1));
                  }
                }), TH.exports.jsx(vW, {
                  label: s("wc_unmute_by_host_btn1"),
                  labelButtonType: mW.Border,
                  onClick: function onClick() {
                    null == d || d(nH(!1));
                  }
                })]
              })]
            });

            return TH.exports.jsx(RR, {
              open: l,
              anchorEl: n,
              modifiers: r,
              placement: i,
              role: "dialog",
              transition: !0,
              children: function children(e) {
                var t = e.TransitionProps;
                return TH.exports.jsx(HA, u(u({}, t), {}, {
                  timeout: 350,
                  children: TH.exports.jsx(kA, {
                    className: VC(o.root),
                    children: p
                  })
                }));
              }
            });
          },
              LW = ["value", "type", "className", "children"],
              UW = function UW(e) {
            var t = e.value,
                n = e.type,
                r = e.className,
                i = e.children,
                o = h(e, LW);
            return TH.exports.jsx("div", u(u({
              role: "tabpanel",
              className: r,
              hidden: Array.isArray(n) ? !n.includes(t) : t !== n,
              id: "suspension-view-tabpanel-".concat(t),
              "aria-labelledby": "suspension-view-tab-".concat(t)
            }, o), {}, {
              children: a.default.cloneElement(i, {
                visible: Array.isArray(n) ? n.includes(t) : t === n
              })
            }));
          },
              BW = 1,
              HW = 0;

          var VW;

          function qW() {
            return qW = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, qW.apply(this, arguments);
          }

          function FW(e) {
            return s.createElement("svg", qW({
              width: 16,
              height: 16,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, e), VW || (VW = s.createElement("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.154 13.038a.625.625 0 10.884-.884L8.884 8l4.154-4.154a.625.625 0 10-.884-.884L8 7.116 3.846 2.962a.625.625 0 10-.884.884L7.116 8l-4.154 4.154a.625.625 0 10.884.884L8 8.884l4.154 4.154z",
              fill: "#F2F2F2"
            })));
          }

          var WW = ["iconColorType"];
          var GW;
          !function (e) {
            e[e.Gray = 0] = "Gray", e[e.White = 1] = "White";
          }(GW || (GW = {}));

          var KW = Ok(function (e) {
            return {
              closeButton: _defineProperty({
                padding: 0,
                fontSize: e.spacing(4),
                minWidth: "fit-content",
                transition: e.transitions.create("all", {
                  easing: e.transitions.easing.easeOut,
                  duration: e.transitions.duration.shorter
                }),
                "&:hover": {
                  filter: "brightness(0.8)"
                },
                "&:active": {
                  filter: "brightness(0.6)"
                }
              }, "&.".concat(kH, "-MuiButton-root"), {
                backgroundColor: "transparent"
              })
            };
          }),
              QW = function QW(e) {
            var _e$iconColorType = e.iconColorType,
                t = _e$iconColorType === void 0 ? GW.Gray : _e$iconColorType,
                n = h(e, WW);

            var r = KW(),
                i = function () {
              switch (t) {
                case GW.Gray:
                  return TH.exports.jsx(Tq, {
                    fontSize: "inherit"
                  });

                case GW.White:
                  return TH.exports.jsx(FW, {
                    fontSize: "inherit"
                  });

                default:
                  throw Error("Unexpected iconColorType passed to CloseButton");
              }
            }();

            return TH.exports.jsx(YA, u(u({
              className: r.closeButton
            }, n), {}, {
              children: i
            }));
          },
              ZW = ["draggableProps"],
              YW = "zoommtg-drag-handle",
              JW = Ok(function (e) {
            return {
              root: {
                border: "0.5px solid rgba(35,35,51,0.2)",
                boxSizing: "border-box",
                boxShadow: "0 8px 24px rgba(35,35,51,0.2)",
                borderRadius: e.shape.borderRadius,
                padding: e.spacing(3),
                minWidth: "376px"
              },
              wrap: {
                "&:focus-visible": {
                  outline: "none"
                },
                "&:focus": {
                  outline: "none"
                }
              },
              header: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: e.spacing(2)
              },
              titleContainer: {
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1
              },
              isDraggable: {
                cursor: "move"
              },
              emptyDraggableContainer: {
                height: e.spacing(4)
              }
            };
          }),
              $W = function $W(e) {
            var t = e.draggableProps,
                n = h(e, ZW);
            return TH.exports.jsx(qP, u(u({}, t || {}), {}, {
              children: TH.exports.jsx(kA, u({}, n))
            }));
          },
              XW = function XW(t) {
            var n = t.open,
                r = t.anchorElement,
                i = t.placement,
                o = t.title,
                a = t.children,
                s = t.className,
                c = t.wrapperClassName,
                l = t.modifiers,
                d = t.draggable,
                p = t.draggableProps,
                h = t.noCloseButton,
                _ = t.onClose,
                f = t.extraButton,
                m = JW(),
                _e$useState41 = e.useState(!0),
                _e$useState42 = _slicedToArray(_e$useState41, 2),
                g = _e$useState42[0],
                v = _e$useState42[1],
                b = "".concat(YW, " ").concat(m.isDraggable),
                y = TH.exports.jsxs(WA, {
              tabIndex: 0,
              className: m.wrap,
              onFocus: function onFocus() {
                v(!0);
              },
              onBlur: function onBlur() {
                v(!1);
              },
              children: [TH.exports.jsxs(WA, {
                className: VC(m.header),
                children: [TH.exports.jsx(WA, {
                  className: VC(m.titleContainer, _defineProperty({}, b, d)),
                  children: o ? TH.exports.jsx(QA, {
                    variant: "h6",
                    children: o
                  }) : TH.exports.jsx(WA, {
                    className: m.emptyDraggableContainer
                  })
                }), f, !h && TH.exports.jsx(QW, {
                  onClick: _
                })]
              }), TH.exports.jsx(WA, {
                children: a
              })]
            });

            return TH.exports.jsx(RR, {
              open: n,
              anchorEl: r,
              placement: i || "left-start",
              role: "dialog",
              modifiers: d ? l : void 0,
              style: d ? {
                zIndex: g ? 2 : "auto"
              } : void 0,
              className: c,
              transition: !0,
              children: function children(e) {
                var t = e.TransitionProps;
                return TH.exports.jsx(HA, u(u({}, t), {}, {
                  timeout: 350,
                  children: d ? TH.exports.jsx($W, {
                    className: VC(m.root, s),
                    draggableProps: p || {
                      handle: ".".concat(YW)
                    },
                    children: y
                  }) : TH.exports.jsx(kA, {
                    className: VC(m.root, s),
                    children: y
                  })
                }));
              }
            });
          },
              eG = Ok(function (e) {
            return {
              panel: {
                width: "480px",
                boxSizing: "border-box",
                padding: e.spacing(2, 4, 3, 4)
              },
              contentContainer: {
                "& > *": {
                  marginTop: e.spacing(5)
                }
              },
              buttonsContainer: {
                display: "flex",
                justifyContent: "right",
                marginBottom: e.spacing(3),
                "& > button": {
                  marginLeft: e.spacing(3)
                }
              }
            };
          }),
              tG = function tG(t) {
            var n = eG(),
                _NM17 = NM(),
                r = _NM17.t,
                i = e.useContext(zM),
                _e$useContext37 = e.useContext(jM),
                o = _e$useContext37.archivingStatus,
                a = _e$useContext37.archivingSessionReady,
                s = _e$useContext37.archivingOptions,
                _IH = IH(),
                c = _IH.archivedFeaturesString,
                _e$useState43 = e.useState(!1),
                _e$useState44 = _slicedToArray(_e$useState43, 2),
                l = _e$useState44[0],
                d = _e$useState44[1],
                _e$useState45 = e.useState(!1),
                _e$useState46 = _slicedToArray(_e$useState45, 2),
                p = _e$useState46[0],
                h = _e$useState46[1],
                _e$useState47 = e.useState(""),
                _e$useState48 = _slicedToArray(_e$useState47, 2),
                _ = _e$useState48[0],
                f = _e$useState48[1],
                _e$useState49 = e.useState(""),
                _e$useState50 = _slicedToArray(_e$useState49, 2),
                m = _e$useState50[0],
                g = _e$useState50[1],
                _e$useState51 = e.useState(""),
                _e$useState52 = _slicedToArray(_e$useState51, 2),
                v = _e$useState52[0],
                b = _e$useState52[1],
                _ref37 = s || {},
                y = _ref37.isEnabled,
                w = _ref37.isAudioArchiveEnabled,
                S = _ref37.isVideoArchiveEnabled,
                x = _ref37.isMeetingChatDisabledWhenArchiveFail,
                E = _ref37.isUserCanStay,
                C = _ref37.showArchivingNotice;

            return e.useLayoutEffect(function () {
              h(!(!y || !w && !S || "" === _ || l));
            }, [o, a, s, l, y, w, S, _]), e.useLayoutEffect(function () {
              o === HW ? x && E ? (f(r("archiving.chat_disable_title")), g(r("archiving.chat_disable_content")), b("")) : a && (f(r("archiving.fail_title")), g(r("archiving.fail_content_sdk", {
                features: c
              })), b("")) : o === BW && C && (f(r("archiving.default_title")), g(r("archiving.content1_sdk", {
                content: r("account_owner")
              })), b(r("archiving.content2_sdk", {
                content: c
              })));
            }, [c, a, o, x, E, C, r]), TH.exports.jsxs(XW, u(u({
              className: n.panel,
              open: p,
              noCloseButton: !0
            }, t), {}, {
              children: [TH.exports.jsx(QA, {
                variant: "h1",
                children: _
              }), TH.exports.jsxs(WA, {
                className: n.contentContainer,
                children: [TH.exports.jsx(QA, {
                  variant: "body1",
                  children: m
                }), "" !== v && TH.exports.jsx(QA, {
                  variant: "body1",
                  children: v
                }), TH.exports.jsxs(WA, {
                  className: n.buttonsContainer,
                  children: [TH.exports.jsx(YA, {
                    onClick: function onClick() {
                      return i.leave();
                    },
                    variant: "outlined",
                    size: "small",
                    children: r("wc_leave_meeting")
                  }), TH.exports.jsx(YA, {
                    onClick: function onClick() {
                      return d(!0);
                    },
                    variant: "contained",
                    color: "primary",
                    size: "small",
                    children: r("GOT_IT")
                  })]
                })]
              })]
            }));
          };

          function nG(e) {
            return {
              id: "suspension-view-tab-".concat(e),
              "aria-controls": "suspension-view-tabpanel-".concat(e)
            };
          }

          var rG = Ok(function (e) {
            var _$concat, _tabs;

            return {
              root: {
                width: "100%",
                padding: e.spacing(1),
                boxSizing: "border-box",
                overflow: "hidden",
                cursor: "move"
              },
              leftButtonsContainer: {
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
                "& div": {
                  display: "flex",
                  alignItems: "center",
                  flexGrow: 1
                }
              },
              span: {
                fontSize: "14px",
                margin: "0px 5px 0px 5px",
                color: e.palette.toolbar.main
              },
              tabs: (_tabs = {}, _defineProperty(_tabs, "&.".concat(kH, "-MuiTabs-root"), {
                color: e.palette.toolbar.main,
                minHeight: e.spacing(4)
              }), _defineProperty(_tabs, "& .".concat(kH, "-MuiTab-root"), (_$concat = {
                borderRadius: .6 * e.shape.borderRadius,
                padding: e.spacing(1, 1.25),
                minWidth: e.spacing(6),
                minHeight: e.spacing(0),
                transition: e.transitions.create("all", {
                  easing: e.transitions.easing.easeOut,
                  duration: e.transitions.duration.shorter
                })
              }, _defineProperty(_$concat, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: e.spacing(4)
              }), _defineProperty(_$concat, "&:hover", {
                backgroundColor: e.palette.action.hover
              }), _defineProperty(_$concat, "&:active", {
                backgroundColor: e.palette.action.active
              }), _$concat)), _defineProperty(_tabs, "& .".concat(kH, "-MuiTab-selected"), {
                color: "#4F9AF7"
              }), _defineProperty(_tabs, "& .".concat(kH, "-MuiTabs-indicator"), {
                display: "none"
              }), _tabs)
            };
          }),
              iG = Pk(function (e) {
            return {
              tooltip: {
                backgroundColor: e.palette.background.paper,
                borderRadius: e.spacing(2),
                padding: e.spacing(4, 5),
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                boxSizing: "border-box"
              },
              arrow: {
                color: e.palette.background.paper
              }
            };
          })(VN),
              oG = function oG(t) {
            var n = rG(),
                r = t.className,
                i = t.viewType,
                o = t.setViewType,
                _e$useContext38 = e.useContext(JM),
                a = _e$useContext38.isShowMeetingInfo,
                s = _e$useContext38.isShowActiveAppsNotifier,
                c = _e$useContext38.dispatch,
                _e$useContext39 = e.useContext(jM),
                l = _e$useContext39.isHost,
                d = _e$useContext39.isCoHost,
                p = _e$useContext39.isSupportMultipleVideos,
                h = _e$useContext39.recordingStatus,
                _ = _e$useContext39.meetingOptions,
                f = _e$useContext39.isLocalRecording,
                m = _e$useContext39.archivingStatus,
                g = _e$useContext39.archivingOptions,
                _e$useContext40 = e.useContext($M),
                v = _e$useContext40.recordingClient,
                _NM18 = NM(),
                b = _NM18.t,
                _IH2 = IH(),
                y = _IH2.archivedFeaturesString,
                w = _IH2.numArchivedFeatures,
                _e$useState53 = e.useState(!0),
                _e$useState54 = _slicedToArray(_e$useState53, 2),
                S = _e$useState54[0],
                x = _e$useState54[1],
                E = e.useCallback(function () {
              null == v || v.startRecording();
            }, [v]),
                C = e.useCallback(function () {
              null == v || v.pauseRecording();
            }, [v]),
                k = e.useCallback(function () {
              null == v || v.stopRecording();
            }, [v]),
                A = e.useCallback(function (e, t) {
              o(t);
            }, [o]),
                I = e.useCallback(function () {
              null == c || c(UB(!a));
            }, [a, c]),
                T = e.useCallback(function () {
              null == c || c({
                type: oB,
                payload: !s
              }), x(!1);
            }, [s, c]),
                O = h === zj.Recording,
                R = O || f,
                N = h === zj.Paused,
                P = b("app_signal.tip_text_2"),
                j = b(w > 1 ? "archiving.tips_2_sdk" : "archiving.tips_1_sdk", {
              subjects: y,
              receiver: b("account_owner")
            }),
                D = _.recordingEnable && i === MM.Gallery && (l || d) ? TH.exports.jsxs("div", {
              children: [N && TH.exports.jsx("span", {
                className: n.span,
                children: b("wc_recording_pause")
              }), O && TH.exports.jsx(AF, {
                iconType: "icon-pause",
                onClick: C,
                style: {
                  width: 16,
                  height: 24
                },
                title: b("wc_recording_pause")
              }), N && TH.exports.jsx(AF, {
                iconType: "icon-resume",
                onClick: E,
                style: {
                  width: 16,
                  height: 24
                },
                title: b("wc_recording_resume")
              }), (O || N) && TH.exports.jsx(AF, {
                iconType: "icon-stop",
                onClick: k,
                style: {
                  width: 16,
                  height: 24
                },
                title: b("wc_recording_stop")
              })]
            }) : null;

            return e.useEffect(function () {
              var e = setTimeout(function () {
                return x(!1);
              }, 1e4);
              return function () {
                clearTimeout(e);
              };
            }, []), TH.exports.jsxs(gN, {
              disableGutters: !0,
              className: VC(r, n.root, "zoommtg-drag-video"),
              children: [TH.exports.jsxs(WA, {
                className: n.leftButtonsContainer,
                children: [TH.exports.jsx(AF, {
                  iconType: "icon-shield",
                  onTouchEnd: I,
                  onClick: I,
                  title: b("meeting_info")
                }), TH.exports.jsx(iG, {
                  open: S,
                  "aria-label": P,
                  title: P,
                  arrow: !0,
                  children: TH.exports.jsx(AF, {
                    iconType: "icon-active-apps",
                    onTouchEnd: T,
                    onClick: T,
                    onMouseOver: function onMouseOver() {
                      return x(!1);
                    }
                  })
                }), m === BW && (null == g ? void 0 : g.isEnabled) && TH.exports.jsx(iG, {
                  "aria-label": "archiving tooltip",
                  title: j,
                  arrow: !0,
                  children: TH.exports.jsx(AF, {
                    iconType: "icon-archiving-tooltip"
                  })
                }), (R || N) && TH.exports.jsx(CF, {
                  iconStyle: {
                    fontSize: "40px",
                    height: 24,
                    transform: "translateY(-3px)"
                  },
                  type: "icon-recording-text"
                }), D]
              }), TH.exports.jsxs(jN, {
                className: n.tabs,
                value: i,
                onChange: A,
                "aria-label": "view mode tabs",
                children: [TH.exports.jsx(eN, u({
                  icon: TH.exports.jsx(CF, {
                    type: "icon-thumbnail"
                  }),
                  value: MM.Thumbnail,
                  title: b("minimized_view"),
                  "aria-label": "thumbnail-minimized"
                }, nG("thumbnail-minimized"))), TH.exports.jsx(eN, u({
                  icon: TH.exports.jsx(CF, {
                    type: "icon-thumbnail-speaker"
                  }),
                  value: MM.Speaker,
                  title: b("speaker_view"),
                  "aria-label": "thumbnail-speaker"
                }, nG("thumbnail-speaker"))), p && TH.exports.jsx(eN, u({
                  icon: TH.exports.jsx(CF, {
                    type: "icon-thumbnail-ribbon"
                  }),
                  value: MM.Ribbon,
                  title: b("ribbon_view"),
                  "aria-label": "thumbnail-ribbon"
                }, nG("thumbnail-ribbon"))), p && TH.exports.jsx(eN, u({
                  icon: TH.exports.jsx(CF, {
                    type: "icon-thumbnail-gallery"
                  }),
                  value: MM.Gallery,
                  title: b("gallary_view"),
                  "aria-label": "thumbnail-gallery"
                }, nG("thumbnail-gallery")))]
              })]
            });
          };

          var aG, sG, cG, lG, dG;

          function uG() {
            return uG = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, uG.apply(this, arguments);
          }

          function pG(e) {
            return s.createElement("svg", uG({
              width: 16,
              height: 16,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, e), aG || (aG = s.createElement("path", {
              d: "M12 5l-5.5 6L4 8.273",
              stroke: "#fff",
              strokeWidth: 1.333,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })));
          }

          function hG() {
            return hG = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, hG.apply(this, arguments);
          }

          function _G(e) {
            return s.createElement("svg", hG({
              width: 16,
              height: 16,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, e), sG || (sG = s.createElement("path", {
              fillRule: "evenodd",
              d: "M12.154 13.038a.625.625 0 10.884-.884L8.884 8l4.154-4.154a.625.625 0 10-.884-.884L8 7.116 3.846 2.962a.625.625 0 10-.884.884L7.116 8l-4.154 4.154a.625.625 0 10.884.884L8 8.884l4.154 4.154z",
              fill: "#FFF"
            })));
          }

          function fG() {
            return fG = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, fG.apply(this, arguments);
          }

          function mG(e) {
            return s.createElement("svg", fG({
              width: 16,
              height: 16,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, e), cG || (cG = s.createElement("rect", {
              opacity: .8,
              x: 3,
              y: 4,
              width: 2,
              height: 2,
              fill: "#FFF"
            }, s.createElement("animate", {
              attributeName: "y",
              values: "4;6;8;6;4",
              dur: "1s",
              repeatCount: "indefinite"
            }))), lG || (lG = s.createElement("rect", {
              opacity: .8,
              x: 7,
              y: 4,
              width: 2,
              height: 2,
              fill: "#FFF"
            }, s.createElement("animate", {
              attributeName: "y",
              values: "6;8;6;4;6",
              dur: "1s",
              repeatCount: "indefinite"
            }))), dG || (dG = s.createElement("rect", {
              opacity: .8,
              x: 11,
              y: 4,
              width: 2,
              height: 2,
              fill: "#FFF"
            }, s.createElement("animate", {
              attributeName: "y",
              values: "8;6;4;6;8",
              dur: "1s",
              repeatCount: "indefinite"
            }))));
          }

          var gG = Ok(function () {
            return {
              root: {
                position: "absolute",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "6px",
                background: "rgb(26,26,26)"
              },
              actived: {
                outline: "2px solid #22d958",
                outlineOffset: "-1px"
              },
              videoOn: {
                background: "transparent"
              },
              corner: _defineProperty({
                position: "absolute",
                left: "2px",
                bottom: "2px",
                display: "flex",
                padding: "3px 5px",
                alignItems: "center",
                height: "18px",
                fontSize: "12px",
                background: "rgba(0,0,0,0.56)",
                maxWidth: "94%"
              }, "& .".concat(kH, "-MuiSvgIcon-root"), {
                marginRight: "5px",
                fontSize: "12px"
              }),
              center: {
                fontSize: "18px",
                fontWeight: "bold"
              },
              avatar: {
                width: "40%"
              },
              raiseHand: {
                display: "flex",
                position: "absolute",
                top: "10px",
                left: "10px"
              }
            };
          }),
              vG = function vG(t) {
            var _VC3;

            var n = t.participant,
                r = t.style,
                i = t.isActive,
                o = t.isDisableReceivingVideo,
                a = t.participantSize,
                _e$useState55 = e.useState(!1),
                _e$useState56 = _slicedToArray(_e$useState55, 2),
                s = _e$useState56[0],
                c = _e$useState56[1],
                l = gG(),
                _NM19 = NM(),
                d = _NM19.t,
                p = n.displayName,
                h = n.audio,
                _ = n.muted,
                f = n.bVideoOn,
                m = n.avatar,
                g = n.bRaiseHand,
                v = n.strPronoun,
                b = n.audioConnectionStatus;

            var y = m;
            window.crossOriginIsolated && !function (e) {
              if (e) try {
                var _t143 = new URL(e),
                    _n93 = _t143.hostname;

                return _n93.indexOf("zoom") > -1;
              } catch (e) {
                return !1;
              }
              return !1;
            }(m) && (y = "");
            var w = !o && f;
            return e.useEffect(function () {
              b === Ya.Connecting && c(!0), b !== Ya.ConnectSuccess && b !== Ya.ConnectFail || setTimeout(function () {
                c(!1);
              }, 1500);
            }, [b]), TH.exports.jsxs(WA, {
              component: "li",
              className: VC(l.root, (_VC3 = {}, _defineProperty(_VC3, l.actived, i && a > 1), _defineProperty(_VC3, l.videoOn, w), _VC3)),
              style: u({}, r),
              children: [g && TH.exports.jsx(WA, {
                className: l.raiseHand,
                children: TH.exports.jsx(CF, {
                  type: "icon-raise-hand",
                  iconStyle: {
                    fontSize: "18px",
                    margin: "0 4px 0 4px"
                  }
                })
              }), (w || "computer" === h && _ || y || s) && TH.exports.jsxs(WA, {
                className: l.corner,
                children: [s && TH.exports.jsxs(TH.exports.Fragment, {
                  children: [TH.exports.jsx(QA, {
                    noWrap: !0,
                    children: d("wc_audio_connecting_thumbnail")
                  }), b === Ya.Connecting && TH.exports.jsx(mG, {}), b === Ya.ConnectSuccess && TH.exports.jsx(pG, {}), b === Ya.ConnectFail && TH.exports.jsx(_G, {})]
                }), !s && "computer" === h && _ && TH.exports.jsx(CF, {
                  type: "icon-audio-muted-outline"
                }), !s && (w || y) && TH.exports.jsx(QA, {
                  noWrap: !0,
                  children: v ? "".concat(p, " (").concat(v, ")") : p
                })]
              }), !w && (y ? TH.exports.jsx(XA, {
                component: "img",
                alt: "avatar of user",
                image: y,
                className: l.avatar
              }) : TH.exports.jsx(QA, {
                className: l.center,
                noWrap: !0,
                children: v ? "".concat(p, " (").concat(v, ")") : p
              }))]
            });
          };

          var bG = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
              yG = "object" == typeof self && self && self.Object === Object && self,
              wG = bG || yG || Function("return this")(),
              SG = wG.Symbol,
              xG = Object.prototype,
              EG = xG.hasOwnProperty,
              CG = xG.toString,
              kG = SG ? SG.toStringTag : void 0,
              AG = Object.prototype.toString,
              IG = SG ? SG.toStringTag : void 0;

          function TG(e) {
            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : IG && IG in Object(e) ? function (e) {
              var t = EG.call(e, kG),
                  n = e[kG];

              try {
                e[kG] = void 0;
                var r = !0;
              } catch (e) {}

              var i = CG.call(e);
              return r && (t ? e[kG] = n : delete e[kG]), i;
            }(e) : function (e) {
              return AG.call(e);
            }(e);
          }

          var OG = /\s/,
              RG = /^\s+/;

          function NG(e) {
            return e ? e.slice(0, function (e) {
              for (var t = e.length; t-- && OG.test(e.charAt(t));) {
                ;
              }

              return t;
            }(e) + 1).replace(RG, "") : e;
          }

          function PG(e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
          }

          var jG = /^[-+]0x[0-9a-f]+$/i,
              DG = /^0b[01]+$/i,
              zG = /^0o[0-7]+$/i,
              MG = parseInt;

          function LG(e) {
            if ("number" == typeof e) return e;
            if (function (e) {
              return "symbol" == typeof e || function (e) {
                return null != e && "object" == typeof e;
              }(e) && "[object Symbol]" == TG(e);
            }(e)) return NaN;

            if (PG(e)) {
              var t = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = PG(t) ? t + "" : t;
            }

            if ("string" != typeof e) return 0 === e ? e : +e;
            e = NG(e);
            var n = DG.test(e);
            return n || zG.test(e) ? MG(e.slice(2), n ? 2 : 8) : jG.test(e) ? NaN : +e;
          }

          var UG = function UG() {
            return wG.Date.now();
          },
              BG = Math.max,
              HG = Math.min;

          function VG(e, t, n) {
            var r,
                i,
                o,
                a,
                s,
                c,
                l = 0,
                d = !1,
                u = !1,
                p = !0;
            if ("function" != typeof e) throw new TypeError("Expected a function");

            function h(t) {
              var n = r,
                  o = i;
              return r = i = void 0, l = t, a = e.apply(o, n);
            }

            function _(e) {
              return l = e, s = setTimeout(m, t), d ? h(e) : a;
            }

            function f(e) {
              var n = e - c;
              return void 0 === c || n >= t || n < 0 || u && e - l >= o;
            }

            function m() {
              var e = UG();
              if (f(e)) return g(e);
              s = setTimeout(m, function (e) {
                var n = t - (e - c);
                return u ? HG(n, o - (e - l)) : n;
              }(e));
            }

            function g(e) {
              return s = void 0, p && r ? h(e) : (r = i = void 0, a);
            }

            function v() {
              var e = UG(),
                  n = f(e);

              if (r = arguments, i = this, c = e, n) {
                if (void 0 === s) return _(c);
                if (u) return clearTimeout(s), s = setTimeout(m, t), h(c);
              }

              return void 0 === s && (s = setTimeout(m, t)), a;
            }

            return t = LG(t) || 0, PG(n) && (d = !!n.leading, o = (u = "maxWait" in n) ? BG(LG(n.maxWait) || 0, t) : o, p = "trailing" in n ? !!n.trailing : p), v.cancel = function () {
              void 0 !== s && clearTimeout(s), l = 0, r = c = i = s = void 0;
            }, v.flush = function () {
              return void 0 === s ? a : g(UG());
            }, v;
          }

          function qG(t, n) {
            var _e$useState57 = e.useState({
              width: 0,
              height: 0
            }),
                _e$useState58 = _slicedToArray(_e$useState57, 2),
                r = _e$useState58[0],
                i = _e$useState58[1],
                o = e.useCallback(function (e) {
              var t = e.width,
                  r = e.height;
              n && VG(function () {
                i({
                  width: arguments.length <= 0 ? void 0 : arguments[0],
                  height: arguments.length <= 1 ? void 0 : arguments[1]
                });
              }, 300, {
                leading: !0
              })(t, r);
            }, [n]);

            return Fz(n.current, o), e.useEffect(function () {
              var e = r.width,
                  i = r.height;

              try {
                n.current && (n.current.width = e, n.current.height = i);
              } catch (r) {
                null == t || t.updateVideoCanvasDimension(n.current, e, i);
              }
            }, [t, r, n]), r;
          }

          function FG(t, n) {
            var _e$useState59 = e.useState(0),
                _e$useState60 = _slicedToArray(_e$useState59, 2),
                r = _e$useState60[0],
                i = _e$useState60[1],
                _e$useState61 = e.useState(),
                _e$useState62 = _slicedToArray(_e$useState61, 2),
                o = _e$useState62[0],
                a = _e$useState62[1],
                s = e.useCallback(function (e) {
              var t = e.userId;
              i(t);
            }, []),
                c = e.useCallback(function (e) {
              Array.isArray(e) && e.length > 0 && a(e.map(function (e) {
                return e.displayName;
              }));
            }, []);

            return e.useEffect(function () {
              return t.on("video-active-change", s), t.on("active-speaker", c), function () {
                t.off("video-active-change", s), t.off("active-speaker", c);
              };
            }, [t, s, c]), Mj(function () {
              n && i(n.getActiveVideoId());
            }), {
              activeVideo: r,
              activeSpeaker: o
            };
          }

          var WG = new Map();

          function GG(e, t) {
            return {
              maxRows: Math.max(1, Math.floor(t / 136.75)),
              maxColumns: Math.max(1, Math.floor(e / 240))
            };
          }

          function KG(e, t, n, r) {
            if (n > r || n <= 0) return [];

            var _GG = GG(e, t),
                i = _GG.maxRows,
                o = _GG.maxColumns;

            i = Math.min(i, n), o = Math.min(o, n);

            var a = Math.min(n, i * o),
                s = function (e) {
              if (WG.has("".concat(e))) return WG.get("".concat(e));
              {
                var _t144 = Array.from({
                  length: e
                }).map(function (e, t) {
                  var n = t + 1,
                      r = Math.ceil(n / 2),
                      i = Array.from({
                    length: r
                  }).map(function (e, t) {
                    var r = t + 1,
                        i = Math.ceil(n / r);
                    return r < i ? [{
                      row: r,
                      column: i
                    }, {
                      row: i,
                      column: r
                    }] : r === i ? [{
                      row: r,
                      column: i
                    }] : [];
                  }).reduce(function (e, t) {
                    return [].concat(_toConsumableArray(e), _toConsumableArray(t));
                  }, []);
                  return {
                    count: n,
                    candidates: i
                  };
                }).reduce(function (e, t) {
                  return u(u({}, e), {}, _defineProperty({}, t.count, t.candidates));
                }, {});

                return WG.set("".concat(e), _t144), _t144;
              }
            }(r)[a].filter(function (e) {
              return e.row <= i && e.column <= o;
            }),
                c = s.map(function (n) {
              var r = n.column,
                  i = n.row,
                  o = Math.floor(Math.min(e / (16 * r), t / (9 * i))),
                  a = 16 * o - 4,
                  s = 9 * o - 4;
              return {
                cellWidth: a,
                cellHeight: s,
                cellArea: a * s,
                column: r,
                row: i
              };
            }).reduce(function (e, t) {
              return t.cellArea > e.cellArea ? t : e;
            }, {
              cellArea: 0,
              cellHeight: 0,
              cellWidth: 0,
              column: 0,
              row: 0
            }),
                l = c.cellHeight,
                d = c.cellWidth,
                p = c.column,
                h = c.row,
                _ = d + 4,
                f = l + 4,
                m = (e - _ * p) / 2 + 2,
                g = (t - f * h) / 2 + 2,
                v = (e - _ * (p - p * h % a)) / 2 + 2,
                b = function (e, t) {
              var n = QM.Video_180P;
              return t <= 2 && e >= 550 ? n = QM.Video_720P : t <= 4 && e >= 270 ? n = QM.Video_360P : e >= 130 && (n = QM.Video_180P), n;
            }(f, a),
                y = [];

            for (var _u10 = 0; _u10 < h; _u10++) {
              for (var _e291 = 0; _e291 < p; _e291++) {
                var _t145 = _u10 !== h - 1 ? m : v;

                _u10 * p + _e291 < a && y.push({
                  width: d,
                  height: l,
                  x: Math.floor(_t145 + _e291 * _),
                  y: Math.floor(g + (h - _u10 - 1) * f),
                  quality: b
                });
              }
            }

            return y;
          }

          var QG = function QG(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            var r = VM(e);
            return e === MM.Ribbon ? {
              width: r.Width,
              height: r.Height[qM(t)]
            } : {
              width: n ? r.LargeWidth : r.Width,
              height: n ? r.LargeHeight : r.Height
            };
          };

          function ZG(t, n, r, i, o) {
            var _e$useState63 = e.useState(0),
                _e$useState64 = _slicedToArray(_e$useState63, 2),
                a = _e$useState64[0],
                s = _e$useState64[1],
                _e$useState65 = e.useState(0),
                _e$useState66 = _slicedToArray(_e$useState65, 2),
                c = _e$useState66[0],
                l = _e$useState66[1],
                _e$useState67 = e.useState(i),
                _e$useState68 = _slicedToArray(_e$useState67, 2),
                d = _e$useState68[0],
                u = _e$useState68[1];

            return e.useEffect(function () {
              var e = Math.min(i, function (e, t) {
                var _GG2 = GG(e, t),
                    n = _GG2.maxColumns,
                    r = _GG2.maxRows;

                return n * r;
              }(t, n));
              u(e);
            }, [t, n, i]), e.useEffect(function () {
              o === MM.Speaker ? l(1) : l(r.length);
            }, [r, o]), e.useEffect(function () {
              o && s(0);
            }, [o]), {
              page: a,
              totalPage: c < d ? 1 : Math.ceil(c / d),
              pageSize: c < d ? c : d,
              totalSize: c,
              setPage: s
            };
          }

          function YG(t, n, r, i, o, a) {
            var s = Wz(i),
                c = Wz(r),
                l = Wz(o),
                d = Wz(a),
                u = function (t) {
              var n = e.useRef(t);
              n.current = t;
              var r = e.useRef();
              return r.current || (r.current = function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
                  t[r] = arguments[r];
                }

                return n.current.apply(this, t);
              }), r.current;
            }(function (e) {
              i.length > 0 && i.forEach( /*#__PURE__*/function () {
                var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(n) {
                  return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                    while (1) {
                      switch (_context31.prev = _context31.next) {
                        case 0:
                          _context31.prev = 0;
                          _context31.next = 3;
                          return null == t ? void 0 : t.stopRenderVideo(e, n);

                        case 3:
                          _context31.next = 7;
                          break;

                        case 5:
                          _context31.prev = 5;
                          _context31.t0 = _context31["catch"](0);

                        case 7:
                        case "end":
                          return _context31.stop();
                      }
                    }
                  }, _callee31, null, [[0, 5]]);
                }));

                return function (_x48) {
                  return _ref38.apply(this, arguments);
                };
              }());
            });

            e.useEffect(function () {
              if (r && r.length > 0 && n.current && a) {
                var _e292 = i.filter(function (e) {
                  return !(s || []).includes(e);
                }),
                    _a17 = (s || []).filter(function (e) {
                  return !i.includes(e);
                }),
                    _d10 = i.filter(function (e) {
                  return (s || []).includes(e);
                });

                if (_a17.length > 0 && _a17.forEach( /*#__PURE__*/function () {
                  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(e) {
                    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
                      while (1) {
                        switch (_context32.prev = _context32.next) {
                          case 0:
                            _context32.next = 2;
                            return null == t ? void 0 : t.stopRenderVideo(n.current, e);

                          case 2:
                          case "end":
                            return _context32.stop();
                        }
                      }
                    }, _callee32);
                  }));

                  return function (_x49) {
                    return _ref39.apply(this, arguments);
                  };
                }()), _e292.length > 0 && _e292.forEach( /*#__PURE__*/function () {
                  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(e) {
                    var i, _o17, _r60, _i29, _a18, _s21, _c11;

                    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                      while (1) {
                        switch (_context33.prev = _context33.next) {
                          case 0:
                            i = o.findIndex(function (t) {
                              return t.userId === e;
                            });

                            if (!(-1 !== i)) {
                              _context33.next = 9;
                              break;
                            }

                            _o17 = r[i];

                            if (!_o17) {
                              _context33.next = 9;
                              break;
                            }

                            _r60 = _o17.width, _i29 = _o17.height, _a18 = _o17.x, _s21 = _o17.y, _c11 = _o17.quality;
                            _context33.next = 7;
                            return Promise.resolve();

                          case 7:
                            _context33.next = 9;
                            return null == t ? void 0 : t.renderVideo(n.current, e, _r60, _i29, _a18, _s21, _c11);

                          case 9:
                          case "end":
                            return _context33.stop();
                        }
                      }
                    }, _callee33);
                  }));

                  return function (_x50) {
                    return _ref40.apply(this, arguments);
                  };
                }()), _d10.length > 0) {
                  c && !function (e, t) {
                    if (e === t) return !0;
                    if (!e || !t) return !1;
                    var n = Object.keys(e),
                        r = Object.keys(t),
                        i = n.length;
                    if (r.length !== i) return !1;

                    for (var _o18 = 0; _o18 < i; _o18++) {
                      var _r61 = n[_o18];
                      if (e[_r61] !== t[_r61] || !Object.prototype.hasOwnProperty.call(t, _r61)) return !1;
                    }

                    return !0;
                  }(c[0], r[0]) && _d10.forEach( /*#__PURE__*/function () {
                    var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(e) {
                      var i, _o19, a, _r62, _s22, _l12, _d11, _u11;

                      return _regeneratorRuntime.wrap(function _callee34$(_context34) {
                        while (1) {
                          switch (_context34.prev = _context34.next) {
                            case 0:
                              i = o.findIndex(function (t) {
                                return t.userId === e;
                              });

                              if (!(-1 !== i)) {
                                _context34.next = 12;
                                break;
                              }

                              _o19 = r[i];

                              if (!_o19) {
                                _context34.next = 12;
                                break;
                              }

                              _r62 = _o19.width, _s22 = _o19.height, _l12 = _o19.x, _d11 = _o19.y, _u11 = _o19.quality;
                              _context34.t0 = (null == c || null === (a = c[i]) || void 0 === a ? void 0 : a.quality) !== _u11;

                              if (!_context34.t0) {
                                _context34.next = 11;
                                break;
                              }

                              _context34.next = 9;
                              return Promise.resolve();

                            case 9:
                              _context34.next = 11;
                              return null == t ? void 0 : t.renderVideo(n.current, e, _r62, _s22, _l12, _d11, _u11);

                            case 11:
                              null == t || t.adjustRenderedVideoPosition(n.current, e, _r62, _s22, _l12, _d11);

                            case 12:
                            case "end":
                              return _context34.stop();
                          }
                        }
                      }, _callee34);
                    }));

                    return function (_x51) {
                      return _ref41.apply(this, arguments);
                    };
                  }());

                  var _e293 = o.map(function (e) {
                    return e.userId;
                  }),
                      _i30 = null == l ? void 0 : l.map(function (e) {
                    return e.userId;
                  });

                  _e293.join("-") !== (null == _i30 ? void 0 : _i30.join("-")) && _d10.forEach(function (o) {
                    var a = _e293.indexOf(o);

                    if (a !== (null == _i30 ? void 0 : _i30.indexOf(o))) {
                      var _e294 = r[a];

                      if (_e294) {
                        var _r63 = _e294.width,
                            _i31 = _e294.height,
                            _a19 = _e294.x,
                            _s23 = _e294.y;
                        null == t || t.adjustRenderedVideoPosition(n.current, o, _r63, _i31, _a19, _s23);
                      }
                    }
                  });
                }
              }
            }, [t, n, o, l, r, c, i, s, a]), e.useEffect(function () {
              !1 === d && !0 === a && i.length > 0 && i.forEach( /*#__PURE__*/function () {
                var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(e) {
                  var i, _o20, _r64, _i32, _a20, _s24, _c12;

                  return _regeneratorRuntime.wrap(function _callee35$(_context35) {
                    while (1) {
                      switch (_context35.prev = _context35.next) {
                        case 0:
                          i = o.findIndex(function (t) {
                            return t.userId === e;
                          });

                          if (!(-1 !== i)) {
                            _context35.next = 9;
                            break;
                          }

                          _o20 = r[i];

                          if (!_o20) {
                            _context35.next = 9;
                            break;
                          }

                          _r64 = _o20.width, _i32 = _o20.height, _a20 = _o20.x, _s24 = _o20.y, _c12 = _o20.quality;
                          _context35.next = 7;
                          return Promise.resolve();

                        case 7:
                          _context35.next = 9;
                          return null == t ? void 0 : t.renderVideo(n.current, e, _r64, _i32, _a20, _s24, _c12);

                        case 9:
                        case "end":
                          return _context35.stop();
                      }
                    }
                  }, _callee35);
                }));

                return function (_x52) {
                  return _ref42.apply(this, arguments);
                };
              }());
            }, [t, n, a, d, i, r, o]), e.useEffect(function () {
              var e = n.current;
              return function () {
                u(e);
              };
            }, [n, u]);
          }

          var JG = Ok(function () {
            return {
              root: {
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
                boxSizing: "border-box",
                padding: "5px 0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                pointerEvents: "none"
              },
              button: {
                pointerEvents: "auto",
                padding: "3px 24px"
              },
              hidePaginationIcon: {
                visibility: "hidden"
              },
              horizontal: {
                flexDirection: "row"
              },
              horizontalLeft: {
                transform: "translateX(-20px) rotate(-90deg)",
                backgroundColor: "rgba(0, 0, 0, 0.6)"
              },
              horizontalRight: {
                transform: "translateX(20px) rotate(-90deg)",
                backgroundColor: "rgba(0, 0, 0, 0.6)"
              }
            };
          }),
              $G = function $G(e) {
            var _VC5, _VC6;

            var t = e.page,
                n = e.totalPage,
                r = e.setPage,
                i = e.className,
                o = e.horizontal,
                a = JG();
            return TH.exports.jsxs(WA, {
              className: VC(i, a.root, _defineProperty({}, a.horizontal, o)),
              children: [TH.exports.jsx(AF, {
                iconType: "icon-arrow-up",
                className: VC(a.button, (_VC5 = {}, _defineProperty(_VC5, a.hidePaginationIcon, 0 === t), _defineProperty(_VC5, a.horizontalLeft, o), _VC5)),
                onClick: function onClick() {
                  t > 0 && r(t - 1);
                }
              }), TH.exports.jsx(AF, {
                iconType: "icon-arrow-down",
                className: VC(a.button, (_VC6 = {}, _defineProperty(_VC6, a.hidePaginationIcon, t === n - 1), _defineProperty(_VC6, a.horizontalRight, o), _VC6)),
                onClick: function onClick() {
                  t < n - 1 && r(t + 1);
                }
              })]
            });
          };

          function XG(t, n, r, i) {
            var o = Wz(r);
            e.useEffect(function () {
              n.current && o !== r && (r ? null == t || t.startShareView(n.current, i) : !0 === o && !1 === r && (null == t || t.stopShareView()));
            }, [t, n, o, r, i]), function (t) {
              var n = e.useRef(t);
              n.current = t, e.useEffect(function () {
                return function () {
                  n.current && n.current();
                };
              }, []);
            }(function () {
              r && (null == t || t.stopShareView());
            });
          }

          var eK;
          !function (e) {
            e.FitToWindow = "fit", e.OriginalSize = "original";
          }(eK || (eK = {}));

          var tK = Ok(function () {
            var _dropdown;

            return {
              root: {
                position: "absolute",
                top: 0,
                left: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "24px",
                transform: "translateY(-36px)",
                pointerEvents: "none"
              },
              wrap: {
                display: "flex",
                alignItems: "center",
                maxWidth: "420px",
                height: "24px",
                borderRadius: "0 0 6px 6px",
                overflow: "hidden",
                pointerEvents: "auto"
              },
              tip: {
                background: "#23D959",
                color: "#222230",
                flexGrow: 1,
                padding: "0 10px"
              },
              dropdown: (_dropdown = {
                background: "#2e2e2e"
              }, _defineProperty(_dropdown, "& .".concat(kH, "-MuiButton-endIcon"), {
                marginRight: 0
              }), _defineProperty(_dropdown, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "10px"
              }), _dropdown),
              dropdownwrap: {
                marginTop: 0
              }
            };
          }),
              nK = function nK(t) {
            var n = t.activeUser,
                r = t.sharedUserList,
                i = t.viewType,
                o = t.setActiveSharingId,
                a = t.setViewType,
                _NM20 = NM(),
                s = _NM20.t,
                _e$useContext41 = e.useContext(DM),
                c = _e$useContext41.stream,
                l = tK(),
                d = /*#__PURE__*/function () {
              var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(e) {
                var t, r;
                return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                  while (1) {
                    switch (_context36.prev = _context36.next) {
                      case 0:
                        t = e.action, r = e.payload;

                        if (!("view" === t)) {
                          _context36.next = 5;
                          break;
                        }

                        a(r);
                        _context36.next = 10;
                        break;

                      case 5:
                        _context36.t0 = "switch" === t && r !== (null == n ? void 0 : n.userId);

                        if (!_context36.t0) {
                          _context36.next = 10;
                          break;
                        }

                        _context36.next = 9;
                        return null == c ? void 0 : c.switchShareView(r);

                      case 9:
                        o(r);

                      case 10:
                      case "end":
                        return _context36.stop();
                    }
                  }
                }, _callee36);
              }));

              return function d(_x53) {
                return _ref43.apply(this, arguments);
              };
            }(),
                u = [{
              items: [{
                text: s("wc_sharing_fit_to_window"),
                checked: i === eK.FitToWindow,
                onClick: function onClick() {
                  d({
                    action: "view",
                    payload: eK.FitToWindow
                  });
                }
              }, {
                text: s("wc_sharing_original_size"),
                checked: i === eK.OriginalSize,
                onClick: function onClick() {
                  d({
                    action: "view",
                    payload: eK.OriginalSize
                  });
                }
              }]
            }, r.length > 1 && {
              title: s("wc_sharing_shared_screens"),
              items: r.map(function (e) {
                return {
                  text: e.displayName,
                  key: "shared-user-".concat(e.userId),
                  checked: (null == n ? void 0 : n.userId) === e.userId,
                  onClick: function onClick() {
                    d({
                      action: "switch",
                      payload: e.userId
                    });
                  }
                };
              })
            }].filter(Boolean);

            return TH.exports.jsx(WA, {
              component: "div",
              className: l.root,
              children: TH.exports.jsxs(WA, {
                component: "div",
                className: l.wrap,
                children: [TH.exports.jsx(QA, {
                  className: l.tip,
                  title: null == n ? void 0 : n.displayName,
                  noWrap: !0,
                  children: s("wc_sharing_viewing", {
                    displayName: null == n ? void 0 : n.displayName
                  })
                }), TH.exports.jsx(PF, {
                  endIconType: "icon-arrow-down",
                  menu: u,
                  className: l.dropdown,
                  wrapClassName: l.dropdownwrap,
                  children: TH.exports.jsx(QA, {
                    noWrap: !0,
                    children: s("wc_sharing_view_options")
                  })
                })]
              })
            });
          },
              rK = Ok(function () {
            return {
              root: {
                display: "none"
              },
              rootInOriginalSize: {
                display: "block"
              },
              inSharing: {
                display: "flex",
                flexGrow: 1,
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden"
              },
              wrap: {
                maxWidth: "100%"
              },
              wrapInOriginalSize: {
                maxWidth: "initial",
                cursor: "move"
              },
              canvas: {
                width: "100%",
                height: "100%"
              }
            };
          }),
              iK = function iK() {
            var _VC7;

            var t = rK(),
                n = e.useContext(zM),
                _e$useContext42 = e.useContext(DM),
                r = _e$useContext42.stream,
                _e$useContext43 = e.useContext(jM),
                i = _e$useContext43.isReceiveSharing,
                o = _e$useContext43.activeShareId,
                a = _e$useContext43.dispatch,
                _e$useState69 = e.useState(eK.FitToWindow),
                _e$useState70 = _slicedToArray(_e$useState69, 2),
                s = _e$useState70[0],
                c = _e$useState70[1],
                _e$useState71 = e.useState({
              width: 0,
              height: 0
            }),
                _e$useState72 = _slicedToArray(_e$useState71, 2),
                l = _e$useState72[0],
                d = _e$useState72[1],
                _e$useState73 = e.useState({
              width: 0,
              height: 0
            }),
                _e$useState74 = _slicedToArray(_e$useState73, 2),
                p = _e$useState74[0],
                h = _e$useState74[1],
                _e$useState75 = e.useState({
              x: 0,
              y: 0
            }),
                _e$useState76 = _slicedToArray(_e$useState75, 2),
                _ = _e$useState76[0],
                f = _e$useState76[1],
                m = e.useRef(null),
                g = e.useRef(null),
                _ref44 = function (t, n) {
              var _e$useState77 = e.useState({
                width: 0,
                height: 0
              }),
                  _e$useState78 = _slicedToArray(_e$useState77, 2),
                  r = _e$useState78[0],
                  i = _e$useState78[1],
                  _e$useState79 = e.useState([]),
                  _e$useState80 = _slicedToArray(_e$useState79, 2),
                  o = _e$useState80[0],
                  a = _e$useState80[1],
                  _e$useState81 = e.useState(!1),
                  _e$useState82 = _slicedToArray(_e$useState81, 2),
                  s = _e$useState82[0],
                  c = _e$useState82[1],
                  _e$useState83 = e.useState(!1),
                  _e$useState84 = _slicedToArray(_e$useState83, 2),
                  l = _e$useState84[0],
                  d = _e$useState84[1],
                  u = e.useCallback(function (e) {
                var t = e.width,
                    n = e.height;
                i({
                  width: t,
                  height: n
                });
              }, []),
                  p = e.useCallback(function () {
                n && a(n.getShareUserList());
              }, [n]),
                  h = e.useCallback( /*#__PURE__*/function () {
                var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(e) {
                  var _yield$n$getShareAudi, _e295, _t146;

                  return _regeneratorRuntime.wrap(function _callee37$(_context37) {
                    while (1) {
                      switch (_context37.prev = _context37.next) {
                        case 0:
                          if (!n) {
                            _context37.next = 7;
                            break;
                          }

                          _context37.next = 3;
                          return n.getShareAudioStatus();

                        case 3:
                          _yield$n$getShareAudi = _context37.sent;
                          _e295 = _yield$n$getShareAudi.isShareAudioEnabled;
                          _t146 = _yield$n$getShareAudi.isShareAudioMuted;
                          c(_e295), d(_t146);

                        case 7:
                        case "end":
                          return _context37.stop();
                      }
                    }
                  }, _callee37);
                }));

                return function (_x54) {
                  return _ref45.apply(this, arguments);
                };
              }(), [n]);

              return e.useEffect(function () {
                return t.on("share-content-dimension-change", u), t.on("peer-share-state-change", p), t.on("passively-stop-share", p), t.on("share-audio-change", h), function () {
                  t.off("share-content-dimension-change", u), t.off("peer-share-state-change", p), t.off("passively-stop-share", p), t.off("share-audio-change", h);
                };
              }, [t, u, p, h]), {
                sharedContentDimension: r,
                sharedUserList: o,
                isSharingAudio: s,
                isShareAudioMuted: l
              };
            }(n, r),
                v = _ref44.sharedContentDimension,
                b = _ref44.sharedUserList,
                y = _ref44.isSharingAudio,
                w = _ref44.isShareAudioMuted,
                S = e.useMemo(function () {
              return b.find(function (e) {
                return e.userId === o;
              });
            }, [o, b]),
                x = e.useCallback(function (e) {
              null == a || a(VU(e));
            }, [a]);

            XG(r, m, i, o);
            var E = e.useCallback(function (e) {
              var t = e.width,
                  n = e.height;
              !function (e, t, n) {
                var r = !0,
                    i = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                return PG(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), VG(e, t, {
                  leading: r,
                  maxWait: t,
                  trailing: i
                });
              }(function () {
                d({
                  width: t,
                  height: n
                });
              }, 50)();
            }, []),
                C = e.useCallback(function (e, t) {
              var n = t.x,
                  r = t.y;
              var i = v.width,
                  o = v.height,
                  a = l.width,
                  s = l.height;
              f(function (e) {
                var t = e.x,
                    c = e.y;
                return (n < 0 && Math.abs(n) < i - 50 || n > 0 && n < a - 50) && (t = n), (r < 0 && Math.abs(r) < o - 50 || r > 0 && r < s - 50) && (c = r), {
                  x: t,
                  y: c
                };
              });
            }, [v, l]);
            return Fz(g.current, E), Mj(function () {
              if (g.current) {
                var _g$current$getBoundin = g.current.getBoundingClientRect(),
                    _e296 = _g$current$getBoundin.width,
                    _t147 = _g$current$getBoundin.height;

                d({
                  width: _e296,
                  height: _t147
                });
              }
            }), e.useEffect(function () {
              null == a || a(XU(y)), null == a || a(qU(w));
            }, [a, y, w]), e.useEffect(function () {
              s === eK.FitToWindow && f({
                x: 0,
                y: 0
              });
            }, [s]), e.useEffect(function () {
              if (i) if (s === eK.FitToWindow) {
                var _e297 = v.width,
                    _t148 = v.height,
                    _n94 = l.width,
                    _r65 = l.height,
                    _i33 = Math.min(_n94 / _e297, _r65 / _t148);

                h({
                  width: Math.floor(_e297 * _i33),
                  height: Math.floor(_t148 * _i33)
                });
              } else s === eK.OriginalSize && h(u({}, v));
            }, [i, l, s, v]), TH.exports.jsxs("div", {
              className: VC(t.root, (_VC7 = {}, _defineProperty(_VC7, t.inSharing, i), _defineProperty(_VC7, t.rootInOriginalSize, i && s === eK.OriginalSize), _VC7)),
              ref: g,
              children: [TH.exports.jsx(qP, {
                disabled: s === eK.FitToWindow,
                position: u({}, _),
                onDrag: C,
                children: TH.exports.jsx("div", {
                  className: VC(t.wrap, _defineProperty({}, t.wrapInOriginalSize, s === eK.OriginalSize)),
                  style: {
                    width: "".concat(p.width, "px"),
                    height: "".concat(p.height, "px")
                  },
                  children: TH.exports.jsx("canvas", {
                    className: t.canvas,
                    ref: m
                  })
                })
              }), i && TH.exports.jsx(nK, {
                sharedUserList: b,
                activeUser: S,
                setActiveSharingId: x,
                viewType: s,
                setViewType: c
              })]
            });
          },
              oK = function oK() {
            var _e$useContext44 = e.useContext(jM),
                t = _e$useContext44.isWebinar,
                n = _e$useContext44.isAttendee,
                r = _e$useContext44.userId,
                i = _e$useContext44.participants;

            return e.useMemo(function () {
              return t && n ? i.filter(function (e) {
                return e.userId !== r;
              }) : i;
            }, [n, t, i, r]);
          },
              aK = Ok(function () {
            return {
              root: {
                display: "flex",
                justifyContent: "center",
                position: "relative",
                height: function height(e) {
                  var t = e.height;
                  return t;
                }
              },
              wrap: {
                position: "relative",
                width: function width(e) {
                  var t = e.width;
                  return t;
                },
                flexShrink: 0,
                borderLeft: function borderLeft(e) {
                  return e.isReceiveSharing ? "1px solid #333;" : "none";
                }
              },
              canvas: {
                width: "100%",
                height: "100%"
              },
              avatarList: {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                overflow: "hidden",
                padding: 0,
                margin: 0
              }
            };
          }),
              sK = function sK(t) {
            var n = t.visible,
                r = t.viewType,
                i = e.useContext(zM),
                _e$useContext45 = e.useContext(DM),
                o = _e$useContext45.stream,
                _e$useContext46 = e.useContext(jM),
                a = _e$useContext46.isReceiveSharing,
                s = _e$useContext46.isDisableReceivingVideo,
                c = _e$useContext46.isAttendee,
                _e$useContext47 = e.useContext(JM),
                l = _e$useContext47.videoContainerDimensions,
                d = _e$useContext47.maximumVideosInGalleryView,
                p = oK(),
                h = aK({
              isReceiveSharing: a,
              width: l.width,
              height: l.height
            }),
                _ = e.useRef(null),
                f = qG(o, _),
                _FG = FG(i, o),
                m = _FG.activeVideo,
                g = ZG(f.width, f.height, p, d, r),
                v = r === MM.Speaker,
                _ref46 = function (t, n, r, i, o, a, s, c, l, d, u) {
              var _e$useState85 = e.useState([]),
                  _e$useState86 = _slicedToArray(_e$useState85, 2),
                  p = _e$useState86[0],
                  h = _e$useState86[1],
                  _e$useState87 = e.useState([]),
                  _e$useState88 = _slicedToArray(_e$useState87, 2),
                  _ = _e$useState88[0],
                  f = _e$useState88[1],
                  _e$useState89 = e.useState([]),
                  _e$useState90 = _slicedToArray(_e$useState89, 2),
                  m = _e$useState90[0],
                  g = _e$useState90[1],
                  v = s.page,
                  b = s.pageSize,
                  y = s.totalPage,
                  _e$useContext48 = e.useContext(jM),
                  w = _e$useContext48.isDisableReceivingVideo,
                  _e$useContext49 = e.useContext(JM),
                  S = _e$useContext49.maximumVideosInGalleryView,
                  _e$useContext50 = e.useContext(DM),
                  x = _e$useContext50.video.decode;

              return e.useEffect(function () {
                f(KG(i, o, b, S));
              }, [i, o, b, S]), e.useEffect(function () {
                var e = t.getCurrentUserInfo();

                if (e && a.length > 0 && d) {
                  var _t149 = [];
                  if (1 === a.length) _t149 = a;else if (c) _t149 = a.filter(function (e) {
                    return e.userId === l;
                  });else {
                    _t149 = a.filter(function (t) {
                      return t.userId !== e.userId;
                    });

                    var _n96 = _t149.filter(function (e) {
                      return e.bRaiseHand;
                    });

                    var _r66 = _t149.filter(function (e) {
                      return !e.bRaiseHand;
                    });

                    var _i34 = _r66.filter(function (e) {
                      return e.userId === l;
                    });

                    if (_r66 = _r66.filter(function (e) {
                      return e.userId !== l;
                    }).sort(function (e, t) {
                      return Number(t.bVideoOn) - Number(e.bVideoOn);
                    }), _r66 = _i34.concat(_r66), !u) {
                      var _t150 = _n96.length > 0 ? 0 : 1;

                      _r66.splice(_t150, 0, e);
                    }

                    _t149 = _n96.concat(_r66);
                  }

                  var _n95 = _t149.filter(function (e, t) {
                    return Math.floor(t / b) === v;
                  });

                  if (_n95.length < b) {
                    var _e298 = b - _n95.length;

                    _n95 = _t149.filter(function (t, n) {
                      return n >= b * (y - 1) - _e298 && n < b * (y - 1);
                    }).concat(_n95);
                  }

                  if (h(_n95), w) g([]);else {
                    var _e299 = _n95.filter(function (e) {
                      return e.bVideoOn;
                    }).map(function (e) {
                      return e.userId;
                    });

                    g(_e299);
                  }
                } else d || (g([]), h([]));
              }, [t, a, v, b, y, d, w, c, l, u]), YG(n, r, _, m, p, x), {
                visibleParticipants: p,
                videoLayouts: _
              };
            }(i, o, _, f.width, f.height, p, g, v, m, !!n, c),
                b = _ref46.visibleParticipants,
                y = _ref46.videoLayouts;

            return TH.exports.jsxs("div", {
              className: h.root,
              children: [TH.exports.jsx(iK, {}), TH.exports.jsxs("div", {
                className: VC(h.wrap, {
                  "zoommtg-tabpanel-hidden": !n
                }),
                children: [TH.exports.jsx("canvas", {
                  id: "zoom-sdk-video-canvas",
                  width: "256",
                  height: "650",
                  className: h.canvas,
                  ref: _
                }), TH.exports.jsx("ul", {
                  className: h.avatarList,
                  children: b.map(function (e, t) {
                    if (t > y.length - 1) return null;
                    var n = y[t],
                        r = n.width,
                        i = n.height,
                        o = n.x,
                        a = n.y,
                        c = f.height;
                    return TH.exports.jsx(vG, {
                      participant: e,
                      isActive: e.userId === m,
                      style: {
                        width: "".concat(r, "px"),
                        height: "".concat(i, "px"),
                        top: "".concat(c - a - i, "px"),
                        left: "".concat(o, "px")
                      },
                      participantSize: b.length,
                      isDisableReceivingVideo: s
                    }, e.userId);
                  })
                }), !v && g.totalPage > 1 && TH.exports.jsx($G, u({
                  horizontal: r === MM.Gallery
                }, g))]
              })]
            });
          },
              cK = Ok(function (e) {
            return {
              root: {
                maxWidth: "200px",
                height: "40px",
                padding: e.spacing(0, 4),
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                boxSizing: "border-box",
                overflow: "hidden",
                textOverflow: "ellipsis"
              },
              hiddenTabpanel: {
                display: "none"
              }
            };
          }),
              lK = function lK(t) {
            var n = t.visible,
                r = e.useContext(zM),
                _FG2 = FG(r),
                i = _FG2.activeSpeaker,
                _e$useState91 = e.useState(""),
                _e$useState92 = _slicedToArray(_e$useState91, 2),
                o = _e$useState92[0],
                a = _e$useState92[1],
                s = cK(),
                _NM21 = NM(),
                c = _NM21.t,
                l = e.useRef(0);

            return e.useEffect(function () {
              return null != i && i.length && (a(i.join(",")), l.current = window.setTimeout(function () {
                a(""), l.current = 0;
              }, 1e3)), function () {
                l.current && window.clearTimeout(l.current);
              };
            }, [i]), TH.exports.jsx(WA, {
              className: VC(s.root, _defineProperty({}, s.hiddenTabpanel, !n)),
              children: TH.exports.jsx(QA, {
                noWrap: !0,
                children: "".concat(c("meeting_taking"), " ").concat(o)
              })
            });
          },
              dK = Hz(),
              uK = Ok(function () {
            return {
              root: function root(e) {
                return {
                  display: "flex",
                  width: "100%",
                  height: e.height,
                  position: "relative"
                };
              },
              wrap: function wrap(e) {
                return {
                  position: "relative",
                  width: e.width,
                  flexShrink: 0
                };
              },
              inSharing: {
                flexShrink: 0,
                borderLeft: "1px solid #333;"
              },
              canvas: function canvas(e) {
                var t = e.participantsSize;
                return {
                  visibility: dK && 1 === t ? "hidden" : "visible",
                  width: "100%",
                  height: "100%"
                };
              },
              video: function video(e) {
                var t = e.participantsSize;
                return {
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  display: 1 === t ? "block" : "none"
                };
              }
            };
          }),
              pK = function pK(t) {
            var n = t.visible,
                r = e.useContext(zM),
                _e$useContext51 = e.useContext(DM),
                i = _e$useContext51.stream,
                _e$useContext52 = e.useContext(jM),
                o = _e$useContext52.isReceiveSharing,
                a = _e$useContext52.participants,
                s = _e$useContext52.isDisableReceivingVideo,
                _e$useContext53 = e.useContext(JM),
                c = _e$useContext53.videoContainerDimensions,
                l = e.useRef(null),
                d = e.useRef(),
                _FG3 = FG(r, i),
                u = _FG3.activeVideo,
                p = qG(i, l),
                h = uK({
              participantsSize: a.length,
              width: c.width,
              height: c.height
            }),
                _ = e.useMemo(function () {
              return a.find(function (e) {
                return e.userId === u;
              });
            }, [a, u]),
                _e$useMemo = e.useMemo(function () {
              var e = Math.floor(Math.min(p.width / 16, p.height / 9)),
                  t = n ? 16 * e : 0,
                  r = 9 * e;
              return {
                width: t,
                height: r,
                x: p.width / 2 - t / 2,
                y: p.height / 2 - r / 2
              };
            }, [p, n]),
                f = _e$useMemo.width,
                m = _e$useMemo.height,
                g = _e$useMemo.x,
                v = _e$useMemo.y,
                b = Wz(s),
                y = Wz(c);

            return e.useEffect(function () {
              if (i && l.current) if (f > 0 && !s) {
                var e, t, n;
                (null == _ ? void 0 : _.bVideoOn) !== (null === (e = d.current) || void 0 === e ? void 0 : e.bVideoOn) && (null != _ && _.bVideoOn ? i.renderVideo(l.current, _.userId, f, m, g, v, QM.Video_720P) : null !== (n = d.current) && void 0 !== n && n.bVideoOn && i.stopRenderVideo(l.current, d.current.userId)), null != _ && _.bVideoOn && null !== (t = d.current) && void 0 !== t && t.bVideoOn && _.userId !== d.current.userId && (i.stopRenderVideo(l.current, d.current.userId), i.renderVideo(l.current, _.userId, f, m, g, v, QM.Video_720P)), d.current = _;
              } else 0 === f && null != _ && _.bVideoOn && (i.stopRenderVideo(l.current, _.userId), d.current = void 0);
            }, [i, _, d, f, m, g, v, s]), e.useEffect(function () {
              i && _ && c !== y && i.adjustRenderedVideoPosition(l.current, _.userId, f, m, g, v);
            }, [_, m, y, i, c, f, g, v]), e.useEffect(function () {
              i && l.current && (b && !s && null != _ && _.bVideoOn ? i.renderVideo(l.current, _.userId, f, m, g, v, QM.Video_720P) : s && !b && null != _ && _.bVideoOn && i.stopRenderVideo(l.current, _.userId));
            }, [s, b, i, _, f, m, g, v]), TH.exports.jsxs("div", {
              className: h.root,
              children: [TH.exports.jsx(iK, {}), TH.exports.jsxs("div", {
                className: VC(h.wrap, _defineProperty({}, h.inSharing, o)),
                children: [TH.exports.jsx("canvas", {
                  id: "zoom-sdk-video-canvas",
                  width: "256",
                  height: "650",
                  className: h.canvas,
                  ref: l
                }), dK && TH.exports.jsx("video", {
                  id: WM,
                  className: h.video
                }), _ && TH.exports.jsx(vG, {
                  participant: _,
                  isActive: !1,
                  isDisableReceivingVideo: s,
                  style: {
                    width: "".concat(f, "px"),
                    height: "".concat(m, "px"),
                    top: "".concat(p.height - v - m, "px"),
                    left: "".concat(g, "px")
                  },
                  participantSize: 1
                })]
              })]
            });
          };

          function hK() {
            var _e$useContext54 = e.useContext(jM),
                t = _e$useContext54.isReceiveSharing,
                _e$useContext55 = e.useContext(JM),
                n = _e$useContext55.viewType,
                r = _e$useContext55.customization,
                i = _e$useContext55.maximumVideosInGalleryView,
                o = _e$useContext55.dispatch,
                a = oK().length,
                s = Wz(n),
                c = Wz(a),
                l = e.useCallback(function () {
              var e = QG(n, a, 25 === i),
                  s = function (e, t) {
                var n, r, i, o;
                return e === MM.Ribbon ? null === (n = t.video) || void 0 === n || null === (r = n.viewSizes) || void 0 === r ? void 0 : r.ribbon : null === (i = t.video) || void 0 === i || null === (o = i.viewSizes) || void 0 === o ? void 0 : o.default;
              }(n, r);

              if (t && (e.height = 615), s) {
                var _t151 = s.width / e.width,
                    _n97 = e.height * _t151;

                null == o || o(tH({
                  width: s.width,
                  height: Math.max(s.height, _n97)
                }));
              } else null == o || o(tH({
                width: e.width,
                height: e.height
              }));
            }, [o, r, t, a, n, i]);

            e.useLayoutEffect(function () {
              s !== n && l();
            }, [s, n, l]), e.useLayoutEffect(function () {
              (!c || c !== a && a <= 4) && l();
            }, [a, c, l]);
          }

          var _K = Ok(function (e) {
            return {
              root: {
                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.3)"
              },
              rootInSharing: _defineProperty({
                width: "min(80vw,1120px)"
              }, "& .".concat(kH, "-MuiTabs-root"), {
                display: "none"
              }),
              topbar: {
                flexShrink: 0
              }
            };
          }),
              fK = function fK() {
            var t = _K(),
                _ref47 = function () {
              var _e$useState93 = e.useState(!1),
                  _e$useState94 = _slicedToArray(_e$useState93, 2),
                  t = _e$useState94[0],
                  n = _e$useState94[1],
                  _e$useState95 = e.useState(!1),
                  _e$useState96 = _slicedToArray(_e$useState95, 2),
                  r = _e$useState96[0],
                  i = _e$useState96[1],
                  _e$useState97 = e.useState(!0),
                  _e$useState98 = _slicedToArray(_e$useState97, 2),
                  o = _e$useState98[0],
                  a = _e$useState98[1],
                  _e$useState99 = e.useState(!1),
                  _e$useState100 = _slicedToArray(_e$useState99, 2),
                  s = _e$useState100[0],
                  c = _e$useState100[1],
                  _e$useState101 = e.useState(!1),
                  _e$useState102 = _slicedToArray(_e$useState101, 2),
                  l = _e$useState102[0],
                  d = _e$useState102[1],
                  _e$useState103 = e.useState(!1),
                  _e$useState104 = _slicedToArray(_e$useState103, 2),
                  u = _e$useState104[0],
                  p = _e$useState104[1],
                  _e$useState105 = e.useState(0),
                  _e$useState106 = _slicedToArray(_e$useState105, 2),
                  h = _e$useState106[0],
                  _ = _e$useState106[1],
                  _e$useContext56 = e.useContext(jM),
                  f = _e$useContext56.userId,
                  m = _e$useContext56.participants,
                  g = _e$useContext56.isAttendee,
                  v = e.useContext(zM),
                  _e$useContext57 = e.useContext(DM),
                  b = _e$useContext57.stream,
                  y = e.useCallback(function (e) {
                var t = e.userId,
                    r = e.state;
                s || (_(t), n(r === KM.Active));
              }, [s]),
                  w = e.useCallback(function (e) {
                c(!1), p(!1);
              }, []),
                  S = e.useCallback(function (e) {
                var t = e.userId;

                _(t);
              }, []);

              return e.useEffect(function () {
                if (m.length) {
                  var _e300 = m.find(function (e) {
                    return e.userId === f;
                  });

                  g ? (i("computer" === (null == _e300 ? void 0 : _e300.audio)), a(!(null == _e300 || !_e300.muted))) : _e300 && (c(_e300.sharerOn), d(_e300.bVideoOn), p(_e300.sharePause), i("computer" === _e300.audio), a(_e300.muted), _e300.sharerOn && n(!1));
                }
              }, [f, g, m]), e.useEffect(function () {
                return v.on("active-share-change", y), v.on("passively-stop-share", w), v.on("share-content-change", S), function () {
                  v.off("active-share-change", y), v.off("passively-stop-share", w), v.off("share-content-change", S);
                };
              }, [v, y, w, S]), e.useEffect(function () {
                if (b) {
                  var _e301 = b.getActiveShareUserId();

                  _e301 && (_(_e301), n(!0));
                }
              }, [b]), {
                isReceiveSharing: t,
                isStartedShare: s,
                isSharePaused: u,
                isStartedVideo: l,
                isStartedAudio: r,
                muted: o,
                activeShareId: h
              };
            }(),
                n = _ref47.isReceiveSharing,
                r = _ref47.isStartedShare,
                i = _ref47.isStartedVideo,
                o = _ref47.isSharePaused,
                a = _ref47.activeShareId,
                s = _ref47.isStartedAudio,
                c = _ref47.muted;

            hK();

            var _e$useContext58 = e.useContext(jM),
                l = _e$useContext58.isSupportMultipleVideos,
                d = _e$useContext58.dispatch,
                _e$useContext59 = e.useContext(JM),
                u = _e$useContext59.viewType,
                p = _e$useContext59.dispatch,
                h = e.useCallback(function (e) {
              null == p || p(function (e) {
                return {
                  type: gB,
                  payload: e
                };
              }(e));
            }, [p]),
                _ = Wz(u),
                f = Wz(l);

            return e.useEffect(function () {
              null == d || d(VU(a)), null == d || d({
                type: lU,
                payload: n
              }), null == d || d(function (e) {
                return {
                  type: uU,
                  payload: e
                };
              }(r)), null == d || d(function (e) {
                return {
                  type: dU,
                  payload: e
                };
              }(i)), null == d || d(function (e) {
                return {
                  type: hU,
                  payload: e
                };
              }(o)), null == d || d(function (e) {
                return {
                  type: yU,
                  payload: e
                };
              }(s)), null == d || d(function (e) {
                return {
                  type: wU,
                  payload: e
                };
              }(c));
            }, [d, n, r, i, a, o, s, c]), e.useEffect(function () {
              n && h(l ? MM.Ribbon : MM.Speaker), _ !== u && h(u);
            }, [n, _, u, l, h, p]), e.useEffect(function () {
              f !== l && l && h(MM.Ribbon);
            }, [l, h, f]), TH.exports.jsxs(kA, {
              className: VC(t.root, _defineProperty({}, t.rootInSharing, n)),
              children: [TH.exports.jsx(oG, {
                viewType: u,
                setViewType: h,
                className: t.topbar
              }), TH.exports.jsx(UW, {
                value: u,
                type: MM.Thumbnail,
                children: TH.exports.jsx(lK, {})
              }), l ? TH.exports.jsx(UW, {
                value: u,
                type: [MM.Ribbon, MM.Speaker, MM.Gallery],
                children: TH.exports.jsx(sK, {
                  viewType: u
                })
              }) : TH.exports.jsx(UW, {
                value: u,
                type: MM.Speaker,
                children: TH.exports.jsx(pK, {})
              })]
            });
          },
              mK = ["timeout", "className"],
              gK = Ok(function (e) {
            return {
              root: function root() {
                return {
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  borderRadius: e.spacing(3.5),
                  color: e.palette.common.white,
                  padding: e.spacing(2.5, 4),
                  backdropFilter: "blur(48px)"
                };
              }
            };
          }),
              vK = function vK(t) {
            var n = t.timeout,
                r = t.className,
                i = h(t, mK);

            var _e$useState107 = e.useState(!1),
                _e$useState108 = _slicedToArray(_e$useState107, 2),
                o = _e$useState108[0],
                a = _e$useState108[1],
                s = gK(),
                c = e.useRef(0);

            return e.useEffect(function () {
              return n && (c.current = window.setTimeout(function () {
                a(!0);
              }, n)), function () {
                c.current && (clearTimeout(c.current), c.current = 0);
              };
            }, [n]), o ? null : TH.exports.jsx(WA, u({
              className: VC(s.root, r)
            }, i));
          },
              bK = Ok(function (e) {
            return {
              container: {
                margin: e.spacing(2)
              },
              gotItButton: {
                color: "#4F9AF7",
                padding: e.spacing(0, 2),
                marginTop: e.spacing(1)
              }
            };
          }),
              yK = function yK(e) {
            var t = e.onClick;

            var n = bK(),
                _NM22 = NM(),
                r = _NM22.t,
                i = r("GOT_IT", "Got It"),
                o = r("wc_share_muted_while_sharing_audio_tip2", "Your microphone is disabled when sharing computer audio. When you pause or stop sharing audio, your microphone will be reactivated.");

            return TH.exports.jsxs(WA, {
              className: n.container,
              children: [TH.exports.jsx(QA, {
                children: o
              }), TH.exports.jsx(AF, {
                className: n.gotItButton,
                onClick: t,
                children: i
              })]
            });
          },
              wK = "zoommtg-drag-handle",
              SK = Ok(function (e) {
            return {
              root: {
                display: "none",
                position: "fixed",
                maxWidth: "80vw",
                top: "2vh",
                left: 0,
                right: 0,
                margin: "0 auto",
                width: "fit-content"
              },
              isSharing: {
                display: "block"
              },
              contentContainer: {
                overflow: "hidden",
                "& > button": {
                  marginLeft: e.spacing(1.5)
                }
              },
              dragIcon: {
                cursor: "move"
              },
              sharingTextContainer: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: e.spacing(0, 10)
              },
              canvas: {
                width: "47px",
                height: "28px",
                borderRadius: e.shape.borderRadius,
                border: "1px solid #23d959"
              },
              shareBarButton: {
                background: "rgba(255,255,255,0.09)"
              }
            };
          }),
              xK = function xK(t) {
            var n = SK(),
                r = t.className,
                i = t.draggable,
                o = t.draggableProps,
                _e$useState109 = e.useState(null),
                _e$useState110 = _slicedToArray(_e$useState109, 2),
                a = _e$useState110[0],
                s = _e$useState110[1],
                _e$useState111 = e.useState(!1),
                _e$useState112 = _slicedToArray(_e$useState111, 2),
                c = _e$useState112[0],
                l = _e$useState112[1],
                _e$useContext60 = e.useContext(jM),
                d = _e$useContext60.isSharePaused,
                p = _e$useContext60.isShareAudioMuted,
                h = _e$useContext60.isStartedShare,
                _ = _e$useContext60.isScreenSharingWithAudio,
                f = _e$useContext60.isStartedAudio,
                m = _e$useContext60.dispatch,
                _e$useContext61 = e.useContext(DM),
                g = _e$useContext61.stream,
                _NM23 = NM(),
                v = _NM23.t,
                b = v(d ? "wc_sharer_controlbar_container_rec_status_tip2" : "wc_sharer_controlbar_container_rec_status_tip1"),
                y = e.useCallback(function () {
              d ? null == g || g.resumeShareScreen() : h && (null == g || g.pauseShareScreen());
            }, [g, d, h]),
                w = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
              var _ref49, e, t;

              return _regeneratorRuntime.wrap(function _callee38$(_context38) {
                while (1) {
                  switch (_context38.prev = _context38.next) {
                    case 0:
                      if (!p) {
                        _context38.next = 5;
                        break;
                      }

                      _context38.next = 3;
                      return null == g ? void 0 : g.unmuteShareAudio();

                    case 3:
                      _context38.next = 7;
                      break;

                    case 5:
                      _context38.next = 7;
                      return null == g ? void 0 : g.muteShareAudio();

                    case 7:
                      _context38.next = 9;
                      return null == g ? void 0 : g.getShareAudioStatus();

                    case 9:
                      _context38.t0 = _context38.sent;

                      if (_context38.t0) {
                        _context38.next = 12;
                        break;
                      }

                      _context38.t0 = {};

                    case 12:
                      _ref49 = _context38.t0;
                      e = _ref49.isShareAudioEnabled;
                      t = _ref49.isShareAudioMuted;
                      null == m || m(XU(Boolean(e))), null == m || m(qU(Boolean(t)));

                    case 16:
                    case "end":
                      return _context38.stop();
                  }
                }
              }, _callee38);
            })), [m, p, g]),
                S = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
              return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                while (1) {
                  switch (_context39.prev = _context39.next) {
                    case 0:
                      _context39.prev = 0;
                      _context39.next = 3;
                      return null == g ? void 0 : g.stopShareScreen();

                    case 3:
                      _context39.next = 8;
                      break;

                    case 5:
                      _context39.prev = 5;
                      _context39.t0 = _context39["catch"](0);
                      console.log(_context39.t0);

                    case 8:
                    case "end":
                      return _context39.stop();
                  }
                }
              }, _callee39, null, [[0, 5]]);
            })), [g]);

            return TH.exports.jsx(qP, u(u({
              disabled: !i
            }, o), {}, {
              handle: ".".concat(wK),
              children: TH.exports.jsx(WA, {
                className: VC(n.root, r, _defineProperty({}, n.isSharing, h)),
                "aria-label": "Screen share control bar",
                children: TH.exports.jsxs(vK, {
                  className: n.contentContainer,
                  children: [TH.exports.jsx(CF, {
                    className: VC(n.dragIcon, wK),
                    type: "icon-move",
                    "aria-label": "Drag handler"
                  }), TH.exports.jsx(WA, {
                    className: n.sharingTextContainer,
                    children: TH.exports.jsx(QA, {
                      variant: "body1",
                      noWrap: !0,
                      children: b
                    })
                  }), "function" == typeof window.MediaStreamTrackProcessor ? TH.exports.jsx("video", {
                    id: FM,
                    className: n.canvas
                  }) : TH.exports.jsx("canvas", {
                    id: FM,
                    className: n.canvas
                  }), f && _ && TH.exports.jsx(VN, {
                    title: TH.exports.jsx(yK, {
                      onClick: function onClick() {
                        return l(!0);
                      }
                    }),
                    placement: "bottom",
                    open: f && _ && Boolean(a) && !d && !p && !c,
                    arrow: !0,
                    interactive: !0,
                    "aria-label": "Screen share audio tooltip",
                    disableHoverListener: !0,
                    children: TH.exports.jsx(AF, {
                      ref: function ref(e) {
                        return s(e);
                      },
                      className: n.shareBarButton,
                      iconType: p ? "icon-sharing-audio-off" : "icon-sharing-audio-on",
                      onClick: w,
                      "aria-label": p ? "Resume audio share" : "Pause audio share"
                    })
                  }), TH.exports.jsx(AF, {
                    className: n.shareBarButton,
                    iconType: d ? "icon-resume" : "icon-pause",
                    onClick: y,
                    "aria-label": d ? "Resume screen sharing" : "Pause screen sharing"
                  }), TH.exports.jsx(YA, {
                    variant: "contained",
                    size: "small",
                    color: "secondary",
                    onClick: S,
                    startIcon: TH.exports.jsx(CF, {
                      type: "icon-stop"
                    }),
                    children: TH.exports.jsx(QA, {
                      variant: "button",
                      noWrap: !0,
                      children: v("wc_sharer_controlbar_container_button3_label")
                    })
                  })]
                })
              })
            }));
          };

          var EK,
              CK,
              kK = (CK = EK = function (e) {
            function n() {
              var e, t;
              BC(this, n);

              for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
                i[o] = arguments[o];
              }

              return Py(jS(t = VR(this, (e = qR(n)).call.apply(e, [this].concat(i)))), "_child", void 0), Py(jS(t), "_measure", function () {
                var e = t.props,
                    n = e.cache,
                    r = e.columnIndex,
                    i = void 0 === r ? 0 : r,
                    o = e.parent,
                    a = e.rowIndex,
                    s = void 0 === a ? t.props.index || 0 : a,
                    c = t._getCellMeasurements(),
                    l = c.height,
                    d = c.width;

                l === n.getHeight(s, i) && d === n.getWidth(s, i) || (n.set(s, i, d, l), o && "function" == typeof o.recomputeGridSize && o.recomputeGridSize({
                  columnIndex: i,
                  rowIndex: s
                }));
              }), Py(jS(t), "_registerChild", function (e) {
                !e || e instanceof Element || console.warn("CellMeasurer registerChild expects to be passed Element or null"), t._child = e, e && t._maybeMeasureCell();
              }), t;
            }

            return HR(n, e), RS(n, [{
              key: "componentDidMount",
              value: function value() {
                this._maybeMeasureCell();
              }
            }, {
              key: "componentDidUpdate",
              value: function value() {
                this._maybeMeasureCell();
              }
            }, {
              key: "render",
              value: function value() {
                var e = this.props.children;
                return "function" == typeof e ? e({
                  measure: this._measure,
                  registerChild: this._registerChild
                }) : e;
              }
            }, {
              key: "_getCellMeasurements",
              value: function value() {
                var e = this.props.cache,
                    n = this._child || t.findDOMNode(this);

                if (n && n.ownerDocument && n.ownerDocument.defaultView && n instanceof n.ownerDocument.defaultView.HTMLElement) {
                  var r = n.style.width,
                      i = n.style.height;
                  e.hasFixedWidth() || (n.style.width = "auto"), e.hasFixedHeight() || (n.style.height = "auto");
                  var o = Math.ceil(n.offsetHeight),
                      a = Math.ceil(n.offsetWidth);
                  return r && (n.style.width = r), i && (n.style.height = i), {
                    height: o,
                    width: a
                  };
                }

                return {
                  height: 0,
                  width: 0
                };
              }
            }, {
              key: "_maybeMeasureCell",
              value: function value() {
                var e = this.props,
                    t = e.cache,
                    n = e.columnIndex,
                    r = void 0 === n ? 0 : n,
                    i = e.parent,
                    o = e.rowIndex,
                    a = void 0 === o ? this.props.index || 0 : o;

                if (!t.has(a, r)) {
                  var s = this._getCellMeasurements(),
                      c = s.height,
                      l = s.width;

                  t.set(a, r, l, c), i && "function" == typeof i.invalidateCellSizeAfterRender && i.invalidateCellSizeAfterRender({
                    columnIndex: r,
                    rowIndex: a
                  });
                }
              }
            }]), n;
          }(s.PureComponent), Py(EK, "propTypes", null), CK);
          Py(kK, "__internalCellMeasurerFlag", !1);

          var AK,
              IK,
              TK = function () {
            function e() {
              var t = this,
                  n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              BC(this, e), Py(this, "_cellHeightCache", {}), Py(this, "_cellWidthCache", {}), Py(this, "_columnWidthCache", {}), Py(this, "_rowHeightCache", {}), Py(this, "_defaultHeight", void 0), Py(this, "_defaultWidth", void 0), Py(this, "_minHeight", void 0), Py(this, "_minWidth", void 0), Py(this, "_keyMapper", void 0), Py(this, "_hasFixedHeight", void 0), Py(this, "_hasFixedWidth", void 0), Py(this, "_columnCount", 0), Py(this, "_rowCount", 0), Py(this, "columnWidth", function (e) {
                var n = e.index,
                    r = t._keyMapper(0, n);

                return void 0 !== t._columnWidthCache[r] ? t._columnWidthCache[r] : t._defaultWidth;
              }), Py(this, "rowHeight", function (e) {
                var n = e.index,
                    r = t._keyMapper(n, 0);

                return void 0 !== t._rowHeightCache[r] ? t._rowHeightCache[r] : t._defaultHeight;
              });
              var r = n.defaultHeight,
                  i = n.defaultWidth,
                  o = n.fixedHeight,
                  a = n.fixedWidth,
                  s = n.keyMapper,
                  c = n.minHeight,
                  l = n.minWidth;
              this._hasFixedHeight = !0 === o, this._hasFixedWidth = !0 === a, this._minHeight = c || 0, this._minWidth = l || 0, this._keyMapper = s || OK, this._defaultHeight = Math.max(this._minHeight, "number" == typeof r ? r : 30), this._defaultWidth = Math.max(this._minWidth, "number" == typeof i ? i : 100);
            }

            return RS(e, [{
              key: "clear",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                    n = this._keyMapper(e, t);

                delete this._cellHeightCache[n], delete this._cellWidthCache[n], this._updateCachedColumnAndRowSizes(e, t);
              }
            }, {
              key: "clearAll",
              value: function value() {
                this._cellHeightCache = {}, this._cellWidthCache = {}, this._columnWidthCache = {}, this._rowHeightCache = {}, this._rowCount = 0, this._columnCount = 0;
              }
            }, {
              key: "hasFixedHeight",
              value: function value() {
                return this._hasFixedHeight;
              }
            }, {
              key: "hasFixedWidth",
              value: function value() {
                return this._hasFixedWidth;
              }
            }, {
              key: "getHeight",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;

                var n = this._keyMapper(e, t);

                return void 0 !== this._cellHeightCache[n] ? Math.max(this._minHeight, this._cellHeightCache[n]) : this._defaultHeight;
              }
            }, {
              key: "getWidth",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;

                var n = this._keyMapper(e, t);

                return void 0 !== this._cellWidthCache[n] ? Math.max(this._minWidth, this._cellWidthCache[n]) : this._defaultWidth;
              }
            }, {
              key: "has",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                    n = this._keyMapper(e, t);

                return void 0 !== this._cellHeightCache[n];
              }
            }, {
              key: "set",
              value: function value(e, t, n, r) {
                var i = this._keyMapper(e, t);

                t >= this._columnCount && (this._columnCount = t + 1), e >= this._rowCount && (this._rowCount = e + 1), this._cellHeightCache[i] = r, this._cellWidthCache[i] = n, this._updateCachedColumnAndRowSizes(e, t);
              }
            }, {
              key: "_updateCachedColumnAndRowSizes",
              value: function value(e, t) {
                if (!this._hasFixedWidth) {
                  for (var n = 0, r = 0; r < this._rowCount; r++) {
                    n = Math.max(n, this.getWidth(r, t));
                  }

                  var i = this._keyMapper(0, t);

                  this._columnWidthCache[i] = n;
                }

                if (!this._hasFixedHeight) {
                  for (var o = 0, a = 0; a < this._columnCount; a++) {
                    o = Math.max(o, this.getHeight(e, a));
                  }

                  var s = this._keyMapper(e, 0);

                  this._rowHeightCache[s] = o;
                }
              }
            }, {
              key: "defaultHeight",
              get: function get() {
                return this._defaultHeight;
              }
            }, {
              key: "defaultWidth",
              get: function get() {
                return this._defaultWidth;
              }
            }]), e;
          }();

          function OK(e, t) {
            return "".concat(e, "-").concat(t);
          }

          function RK(e, t) {
            var r,
                i = void 0 !== (r = void 0 !== t ? t : "undefined" != typeof window ? window : "undefined" != typeof self ? self : n.g).document && r.document.attachEvent;

            if (!i) {
              var o = function () {
                var e = r.requestAnimationFrame || r.mozRequestAnimationFrame || r.webkitRequestAnimationFrame || function (e) {
                  return r.setTimeout(e, 20);
                };

                return function (t) {
                  return e(t);
                };
              }(),
                  a = function () {
                var e = r.cancelAnimationFrame || r.mozCancelAnimationFrame || r.webkitCancelAnimationFrame || r.clearTimeout;
                return function (t) {
                  return e(t);
                };
              }(),
                  s = function s(e) {
                var t = e.__resizeTriggers__,
                    n = t.firstElementChild,
                    r = t.lastElementChild,
                    i = n.firstElementChild;
                r.scrollLeft = r.scrollWidth, r.scrollTop = r.scrollHeight, i.style.width = n.offsetWidth + 1 + "px", i.style.height = n.offsetHeight + 1 + "px", n.scrollLeft = n.scrollWidth, n.scrollTop = n.scrollHeight;
              },
                  c = function c(e) {
                if (!(e.target.className && "function" == typeof e.target.className.indexOf && e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0)) {
                  var t = this;
                  s(this), this.__resizeRAF__ && a(this.__resizeRAF__), this.__resizeRAF__ = o(function () {
                    (function (e) {
                      return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height;
                    })(t) && (t.__resizeLast__.width = t.offsetWidth, t.__resizeLast__.height = t.offsetHeight, t.__resizeListeners__.forEach(function (n) {
                      n.call(t, e);
                    }));
                  });
                }
              },
                  l = !1,
                  d = "",
                  u = "animationstart",
                  p = "Webkit Moz O ms".split(" "),
                  h = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),
                  _ = r.document.createElement("fakeelement");

              if (void 0 !== _.style.animationName && (l = !0), !1 === l) for (var f = 0; f < p.length; f++) {
                if (void 0 !== _.style[p[f] + "AnimationName"]) {
                  d = "-" + p[f].toLowerCase() + "-", u = h[f], l = !0;
                  break;
                }
              }
              var m = "resizeanim",
                  g = "@" + d + "keyframes " + m + " { from { opacity: 0; } to { opacity: 0; } } ",
                  v = d + "animation: 1ms " + m + "; ";
            }

            return {
              addResizeListener: function addResizeListener(t, n) {
                if (i) t.attachEvent("onresize", n);else {
                  if (!t.__resizeTriggers__) {
                    var o = t.ownerDocument,
                        a = r.getComputedStyle(t);
                    a && "static" == a.position && (t.style.position = "relative"), function (t) {
                      if (!t.getElementById("detectElementResize")) {
                        var n = (g || "") + ".resize-triggers { " + (v || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
                            r = t.head || t.getElementsByTagName("head")[0],
                            i = t.createElement("style");
                        i.id = "detectElementResize", i.type = "text/css", null != e && i.setAttribute("nonce", e), i.styleSheet ? i.styleSheet.cssText = n : i.appendChild(t.createTextNode(n)), r.appendChild(i);
                      }
                    }(o), t.__resizeLast__ = {}, t.__resizeListeners__ = [], (t.__resizeTriggers__ = o.createElement("div")).className = "resize-triggers";
                    var l = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';

                    if (window.trustedTypes) {
                      var d = trustedTypes.createPolicy("react-virtualized-auto-sizer", {
                        createHTML: function createHTML() {
                          return l;
                        }
                      });
                      t.__resizeTriggers__.innerHTML = d.createHTML("");
                    } else t.__resizeTriggers__.innerHTML = l;

                    t.appendChild(t.__resizeTriggers__), s(t), t.addEventListener("scroll", c, !0), u && (t.__resizeTriggers__.__animationListener__ = function (e) {
                      e.animationName == m && s(t);
                    }, t.__resizeTriggers__.addEventListener(u, t.__resizeTriggers__.__animationListener__));
                  }

                  t.__resizeListeners__.push(n);
                }
              },
              removeResizeListener: function removeResizeListener(e, t) {
                if (i) e.detachEvent("onresize", t);else if (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1), !e.__resizeListeners__.length) {
                  e.removeEventListener("scroll", c, !0), e.__resizeTriggers__.__animationListener__ && (e.__resizeTriggers__.removeEventListener(u, e.__resizeTriggers__.__animationListener__), e.__resizeTriggers__.__animationListener__ = null);

                  try {
                    e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__);
                  } catch (e) {}
                }
              }
            };
          }

          function NK(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function PK(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? NK(n, !0).forEach(function (t) {
                Py(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : NK(n).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          var jK = (IK = AK = function (e) {
            function t() {
              var e, n;
              BC(this, t);

              for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
                i[o] = arguments[o];
              }

              return Py(jS(n = VR(this, (e = qR(t)).call.apply(e, [this].concat(i)))), "state", {
                height: n.props.defaultHeight || 0,
                width: n.props.defaultWidth || 0
              }), Py(jS(n), "_parentNode", void 0), Py(jS(n), "_autoSizer", void 0), Py(jS(n), "_window", void 0), Py(jS(n), "_detectElementResize", void 0), Py(jS(n), "_onResize", function () {
                var e = n.props,
                    t = e.disableHeight,
                    r = e.disableWidth,
                    i = e.onResize;

                if (n._parentNode) {
                  var o = n._parentNode.offsetHeight || 0,
                      a = n._parentNode.offsetWidth || 0,
                      s = (n._window || window).getComputedStyle(n._parentNode) || {},
                      c = parseInt(s.paddingLeft, 10) || 0,
                      l = parseInt(s.paddingRight, 10) || 0,
                      d = parseInt(s.paddingTop, 10) || 0,
                      u = parseInt(s.paddingBottom, 10) || 0,
                      p = o - d - u,
                      h = a - c - l;
                  (!t && n.state.height !== p || !r && n.state.width !== h) && (n.setState({
                    height: o - d - u,
                    width: a - c - l
                  }), i({
                    height: o,
                    width: a
                  }));
                }
              }), Py(jS(n), "_setRef", function (e) {
                n._autoSizer = e;
              }), n;
            }

            return HR(t, e), RS(t, [{
              key: "componentDidMount",
              value: function value() {
                var e = this.props.nonce;
                this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && (this._parentNode = this._autoSizer.parentNode, this._window = this._autoSizer.parentNode.ownerDocument.defaultView, this._detectElementResize = RK(e, this._window), this._detectElementResize.addResizeListener(this._parentNode, this._onResize), this._onResize());
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this._detectElementResize && this._parentNode && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
              }
            }, {
              key: "render",
              value: function value() {
                var e = this.props,
                    t = e.children,
                    n = e.className,
                    r = e.disableHeight,
                    i = e.disableWidth,
                    o = e.style,
                    a = this.state,
                    c = a.height,
                    l = a.width,
                    d = {
                  overflow: "visible"
                },
                    u = {};
                return r || (d.height = 0, u.height = c), i || (d.width = 0, u.width = l), s.createElement("div", {
                  className: n,
                  ref: this._setRef,
                  style: PK({}, d, {}, o)
                }, t(u));
              }
            }]), t;
          }(s.Component), Py(AK, "propTypes", null), IK);
          Py(jK, "defaultProps", {
            onResize: function onResize() {},
            disableHeight: !1,
            disableWidth: !1,
            style: {}
          });
          var DK = ["id", "message"],
              zK = ["id", "message"];

          function MK(t) {
            var _e$useContext62 = e.useContext(jM),
                n = _e$useContext62.isWebinar,
                r = _e$useContext62.participants,
                _e$useContext63 = e.useContext(JM),
                i = _e$useContext63.numUnreadChat,
                o = _e$useContext63.isShowChat,
                a = _e$useContext63.dispatch,
                _e$useState113 = e.useState([]),
                _e$useState114 = _slicedToArray(_e$useState113, 2),
                s = _e$useState114[0],
                c = _e$useState114[1],
                _e$useState115 = e.useState(0),
                _e$useState116 = _slicedToArray(_e$useState115, 2),
                l = _e$useState116[0],
                d = _e$useState116[1],
                _e$useState117 = e.useState(new Set()),
                _e$useState118 = _slicedToArray(_e$useState117, 2),
                p = _e$useState118[0],
                _ = _e$useState118[1],
                f = e.useCallback(function (e) {
              -1 === r.findIndex(function (t) {
                return t.userId === e;
              }) && !p.has(e) && _(function (t) {
                return new Set([].concat(_toConsumableArray(t), [e]));
              });
            }, [p, r]),
                m = e.useCallback(function (e) {
              c(ZL(function (t) {
                var n = t.length;

                if (n > 0) {
                  var _r67 = t[n - 1];
                  if (e.sender.userId === _r67.sender.userId && e.receiver.userId === _r67.receiver.userId && e.timestamp - _r67.timestamp < 3e5) Array.isArray(_r67.message) ? _r67.message.push({
                    id: e.id,
                    text: e.message
                  }) : _r67.message = [_r67.message, {
                    id: e.id,
                    text: e.message
                  }];else {
                    var _n98 = e.id,
                        _r68 = e.message,
                        _i35 = h(e, DK);

                    t.push(u({
                      message: [{
                        id: _n98,
                        text: _r68
                      }]
                    }, _i35));
                  }
                } else {
                  var _n99 = e.id,
                      _r69 = e.message,
                      _i36 = h(e, zK);

                  t.push(u({
                    message: [{
                      id: _n99,
                      text: _r69
                    }]
                  }, _i36));
                }
              })), o || (null == a || a(XB(i + 1)), null == a || a(eH(!0))), null == a || a(function (e) {
                return {
                  type: yB,
                  payload: e
                };
              }(e)), n && f(e.sender.userId);
            }, [a, o, n, i, f]);

            e.useEffect(function () {
              return t.on("chat-on-message", m), function () {
                t.off("chat-on-message", m);
              };
            }, [t, m]), e.useEffect(function () {
              o && (null == a || a(XB(0)));
            }, [a, o]);
            var g = e.useMemo(function () {
              return s.reduce(function (e, t) {
                return t.message.length + e;
              }, 0) - l - 1;
            }, [s, l]),
                v = e.useCallback(function (e) {
              d(function (t) {
                return Math.max(e, t);
              });
            }, []);
            return {
              chatRecords: s,
              unreadRecordsCounts: g,
              markReadIndex: v,
              attendeeReceiverIds: p,
              tryAddAttendeeReceiverId: f
            };
          }

          var LK = Ok(function () {
            return {
              root: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "12px"
              },
              topItem: {
                marginTop: "0"
              },
              indicator: {
                display: "flex",
                maxWidth: "100%",
                "&:hover": {
                  maxWidth: "75%"
                },
                alignItems: "center",
                color: "rgba(255,255,255,0.54)",
                fontSize: "13px"
              },
              name: {
                color: "rgba(255,255,255,0.54)",
                "&:hover": {
                  textDecoration: "none",
                  color: "rgba(255,255,255,0.74)"
                },
                "&[disabled]:hover": {
                  cursor: "default",
                  color: "rgba(255,255,255,0.54)"
                },
                minWidth: "19px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              },
              to: _defineProperty({
                margin: "0 4px",
                fontSize: "13px"
              }, "&.".concat(kH, "-MuiTypography-body1"), {
                whiteSpace: "noWrap",
                lineHeight: 0
              }),
              timestamp: {
                display: "flex",
                color: "rgba(255,255,255,0.34)",
                fontSize: "13px",
                marginRight: "5px",
                whiteSpace: "nowrap"
              }
            };
          }),
              UK = function UK(t) {
            var n, r;

            var i = t.sender,
                o = t.receiver,
                a = t.timestamp,
                s = t.className,
                c = t.recordIndex,
                l = t.setChatUser,
                d = t.tryAddAttendeeReceiverId,
                _e$useContext64 = e.useContext(jM),
                u = _e$useContext64.userId,
                p = _e$useContext64.isWebinar,
                h = _e$useContext64.participants,
                _e$useState119 = e.useState(!1),
                _e$useState120 = _slicedToArray(_e$useState119, 2),
                _ = _e$useState120[0],
                f = _e$useState120[1],
                _NM24 = NM(),
                m = _NM24.t,
                g = LK(),
                v = e.useMemo(function () {
              return [{
                key: yH.All,
                label: m("wc_chat.everyone")
              }, {
                key: yH.Panelist,
                label: m("wc_chat.host_panelists")
              }];
            }, [m]),
                b = u === i.userId ? m("wc_chat.me") : i.name,
                y = null === (n = v.find(function (e) {
              return e.key === o.userId;
            })) || void 0 === n ? void 0 : n.label,
                w = y || (u === o.userId ? m("wc_chat.me") : o.name),
                S = p && !y && -1 === h.findIndex(function (e) {
              return e.userId === o.userId;
            }),
                x = null === (r = v.find(function (e) {
              return e.key === yH.Panelist;
            })) || void 0 === r ? void 0 : r.label,
                E = !S && void 0 === y;

            return TH.exports.jsxs(WA, {
              className: VC(g.root, s, _defineProperty({}, g.topItem, 0 === c)),
              onMouseOver: function onMouseOver() {
                return f(!0);
              },
              onMouseOut: function onMouseOut() {
                return f(!1);
              },
              children: [TH.exports.jsxs(WA, {
                className: g.indicator,
                children: [TH.exports.jsxs(TM, {
                  i18nKey: "chat_message_header",
                  children: [TH.exports.jsx(OT, {
                    component: "button",
                    disabled: u === i.userId,
                    className: g.name,
                    onClick: function onClick() {
                      l(i.userId), p && d(i.userId);
                    },
                    children: {
                      senderName: b
                    }
                  }), TH.exports.jsx(WA, {
                    className: g.to,
                    children: TH.exports.jsx(QA, {
                      variant: "body1",
                      children: "to"
                    })
                  }), TH.exports.jsx(OT, {
                    component: "button",
                    disabled: u === o.userId,
                    className: g.name,
                    onClick: function onClick() {
                      l(o.userId), p && d(o.userId);
                    },
                    children: {
                      receiverName: w
                    }
                  })]
                }), S && TH.exports.jsx(OT, {
                  component: "button",
                  className: g.name,
                  onClick: function onClick() {
                    return l(yH.Panelist);
                  },
                  children: ", ".concat(x)
                }), E && TH.exports.jsx(QA, {
                  className: g.to,
                  variant: "body1",
                  children: m("wc_chat.direct_message")
                })]
              }), _ && TH.exports.jsx(QA, {
                className: g.timestamp,
                children: new Date(a).toLocaleTimeString()
              })]
            });
          },
              BK = Ok(function (e) {
            var _receiverlist;

            return {
              root: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              },
              receiver: _defineProperty({
                display: "flex",
                alignItems: "center",
                color: "rgba(255,255,255,0.54)"
              }, "& .".concat(kH, "-MuiTypography-root"), {
                fontSize: "13px"
              }),
              receiverlist: (_receiverlist = {
                background: "rgba(255,255,255,0.09)",
                color: "#f5f5f5",
                padding: "0 8px",
                marginLeft: "6px",
                borderRadius: e.spacing(1)
              }, _defineProperty(_receiverlist, "& .".concat(kH, "-MuiButton-endIcon"), {
                marginRight: 0
              }), _defineProperty(_receiverlist, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "10px"
              }), _receiverlist),
              privilegelist: {
                border: "1px solid rgba(255,255,255,0.54)"
              },
              caption: {
                marginLeft: "3px",
                color: "#999"
              }
            };
          }),
              HK = function HK(t) {
            var n;

            var r = BK(),
                i = t.chatUsers,
                o = t.selectedChatUser,
                a = t.chatPrivilege,
                s = t.panelistChatPrivilege,
                c = t.className,
                l = t.setChatUser,
                d = t.attendeeReceiverIds,
                _e$useContext65 = e.useContext(jM),
                p = _e$useContext65.isCoHost,
                h = _e$useContext65.isHost,
                _ = _e$useContext65.isWebinar,
                f = _e$useContext65.participants,
                m = p || h,
                _e$useContext66 = e.useContext($M),
                g = _e$useContext66.chatClient,
                _NM25 = NM(),
                v = _NM25.t,
                b = e.useCallback(function (e) {
              l(e);
            }, [l]),
                y = e.useCallback(function (e) {
              null == g || g.setPrivilege(e);
            }, [g]),
                w = e.useCallback(function (e) {
              _ && (null == g || g.setPanelistPrivilege(e));
            }, [g, _]);

            var S = [];
            var x = e.useMemo(function () {
              return [{
                key: yH.All,
                label: v("wc_chat.everyone")
              }, {
                key: yH.Panelist,
                label: v("wc_chat.host_panelists")
              }];
            }, [v]);

            if (_) {
              var _e302 = i.filter(function (e) {
                return x.findIndex(function (t) {
                  return t.key === e.userId;
                }) >= 0;
              }),
                  _t152 = i.filter(function (e) {
                return -1 === x.findIndex(function (t) {
                  return t.key === e.userId;
                });
              }),
                  _n100 = [],
                  _a21 = [];

              _t152.forEach(function (e) {
                e.isHost || e.isCoHost || f.findIndex(function (t) {
                  return t.userId === e.userId;
                }) > -1 ? _n100.push(e) : _a21.push(e);
              }), S.push({
                items: _e302.map(function (e) {
                  var t;
                  return {
                    text: (null === (t = x.find(function (t) {
                      return t.key === e.userId;
                    })) || void 0 === t ? void 0 : t.label) || e.displayName,
                    key: e.userId,
                    checked: e.userId === (null == o ? void 0 : o.userId),
                    onClick: function onClick() {
                      b(e.userId);
                    }
                  };
                })
              }), S.push({
                items: _n100.map(function (e) {
                  var t = "";
                  if (e.isHost) t = v("chat_receiver_host");else if (e.isCoHost) t = v("chat_receiver_co_host");else if (_) {
                    var _n101 = f.findIndex(function (t) {
                      return t.userId === e.userId;
                    }) > -1;

                    _n101 && (t = v("chat_receiver_panelist"));
                  }
                  return {
                    text: TH.exports.jsxs(QA, {
                      noWrap: !0,
                      children: [e.displayName, TH.exports.jsx(QA, {
                        variant: "caption",
                        className: r.caption,
                        children: t
                      })]
                    }),
                    key: e.userId,
                    checked: e.userId === (null == o ? void 0 : o.userId),
                    onClick: function onClick() {
                      b(e.userId);
                    }
                  };
                })
              });

              var _s25 = _a21.filter(function (e) {
                return d.has(e.userId);
              });

              _s25.length > 0 && S.push({
                items: _s25.map(function (e) {
                  return {
                    text: e.displayName,
                    key: e.userId,
                    checked: e.userId === (null == o ? void 0 : o.userId),
                    onClick: function onClick() {
                      b(e.userId);
                    }
                  };
                })
              });
            } else S = i.map(function (e) {
              var t = "";
              return e.isHost ? t = v("chat_receiver_host") : e.isCoHost && (t = v("chat_receiver_co_host")), "Everyone" === e.displayName && (e.displayName = v("wc_chat.everyone")), {
                text: TH.exports.jsxs(QA, {
                  noWrap: !0,
                  children: [e.displayName, TH.exports.jsx(QA, {
                    variant: "caption",
                    className: r.caption,
                    children: t
                  })]
                }),
                key: e.userId,
                checked: e.userId === (null == o ? void 0 : o.userId),
                onClick: function onClick() {
                  b(e.userId);
                }
              };
            });

            var E = e.useMemo(function () {
              return m ? _ ? [{
                title: v("wc_chat.panelist_chat_with"),
                items: [{
                  text: v("wc_chat.host_panelists"),
                  key: SH.AllPanelist
                }, {
                  text: v("wc_chat.everyone"),
                  key: SH.Everyone
                }].map(function (e) {
                  return u(u({}, e), {}, {
                    checked: s === xH[e.key],
                    onClick: function onClick() {
                      w(e.key);
                    }
                  });
                })
              }, {
                title: v("wc_chat.attendee_chat_with"),
                items: [{
                  text: v("wc_chat.disabled"),
                  key: bH.NoOne
                }, {
                  text: v("wc_chat.host_panelists"),
                  key: bH.AllPanelist
                }, {
                  text: v("wc_chat.everyone"),
                  key: bH.All
                }].map(function (e) {
                  return u(u({}, e), {}, {
                    checked: a === e.key,
                    onClick: function onClick() {
                      y(e.key);
                    }
                  });
                })
              }] : [{
                text: v("wc_chat.disabled"),
                key: bH.NoOne
              }, {
                text: v("wc_chat.host_only"),
                key: bH.Host
              }, {
                text: v("wc_chat.everyone_public"),
                key: bH.EveryonePublicly
              }, {
                text: v("wc_chat.everyone_public_private"),
                key: bH.All
              }].map(function (e) {
                return u(u({}, e), {}, {
                  checked: a === e.key,
                  onClick: function onClick() {
                    y(e.key);
                  }
                });
              }) : [];
            }, [m, _, v, s, w, a, y]);
            return TH.exports.jsxs(WA, {
              className: VC(r.root, c),
              children: [TH.exports.jsxs(WA, {
                className: r.receiver,
                children: [TH.exports.jsx(QA, {
                  children: v("chat_receiver_to")
                }), TH.exports.jsx(PF, {
                  menu: S,
                  className: r.receiverlist,
                  endIconType: "icon-arrow-down",
                  placement: "top-start",
                  children: (null === (n = x.find(function (e) {
                    return e.key === (null == o ? void 0 : o.userId);
                  })) || void 0 === n ? void 0 : n.label) || (null == o ? void 0 : o.displayName)
                })]
              }), m && TH.exports.jsx(PF, {
                iconType: "icon-more",
                placement: "top-end",
                className: r.privilegelist,
                menu: E
              })]
            });
          },
              VK = function VK() {
            var _e$useContext67 = e.useContext(jM),
                t = _e$useContext67.recordingStatus,
                n = _e$useContext67.isLocalRecording,
                r = _e$useContext67.archivingStatus,
                i = _e$useContext67.archivingOptions,
                o = _e$useContext67.isOnHold,
                _NM26 = NM(),
                a = _NM26.t,
                _e$useState121 = e.useState(""),
                _e$useState122 = _slicedToArray(_e$useState121, 2),
                s = _e$useState122[0],
                c = _e$useState122[1],
                _e$useState123 = e.useState(""),
                _e$useState124 = _slicedToArray(_e$useState123, 2),
                l = _e$useState124[0],
                d = _e$useState124[1],
                _ref51 = i || {},
                u = _ref51.isChatArchiveEnabled,
                p = _ref51.isPrivateChatArchiveEnabled,
                h = _ref51.isEnabled;

            return e.useLayoutEffect(function () {
              u && h && r === BW && !o ? (c(a(p ? "disclaimer.chat_content_7" : "disclaimer.chat_content_5")), d(a("disclaimer.chat_content_6"))) : t === zj.Recording ? (c(a("disclaimer.chat_content_3")), d(a("disclaimer.chat_content_2"))) : n ? (c(a("disclaimer.chat_content_4")), d(a("disclaimer.chat_content_2"))) : (c(a("disclaimer.chat_content_1")), d(a("disclaimer.chat_content_2")));
            }, [r, u, h, n, o, p, t, a]), TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsx(QA, {
                variant: "body1",
                children: s
              }), TH.exports.jsx("br", {}), TH.exports.jsx(QA, {
                variant: "body1",
                children: l
              })]
            });
          },
              qK = Ok(function (e) {
            var _textarea;

            return {
              list: {
                height: "min(90vh - 178px , 484px)",
                position: "relative",
                scrollbarColor: "#707070 #282828",
                scrollbarWidth: "thin",
                "& .ReactVirtualized__List::-webkit-scrollbar": {
                  width: "8px"
                },
                "& .ReactVirtualized__List::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: "100px"
                }
              },
              disabled: {
                marginTop: "10px",
                height: "113px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              },
              message: {
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "0"
              },
              messagetext: _defineProperty({
                whiteSpace: "normal",
                background: "rgba(255,255,255,0.09)",
                padding: "12px 14px",
                borderRadius: "16px"
              }, "'& .".concat(kH, "-MuiListItemText-primary'"), {
                fontSize: "13px",
                wordBreak: "break-all"
              }),
              selfMsg: {
                background: "#282f38"
              },
              receiver: {
                marginTop: "10px"
              },
              textarea: (_textarea = {}, _defineProperty(_textarea, "& .".concat(kH, "-MuiInput-underline:after"), {
                border: "none !important"
              }), _defineProperty(_textarea, "& .".concat(kH, "-MuiInput-underline:before"), {
                border: "none !important"
              }), _defineProperty(_textarea, "& textarea", {
                fontSize: "13px",
                scrollbarColor: "#707070 #282828",
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "8px"
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: "100px"
                }
              }), _defineProperty(_textarea, "& textarea::placeholder", {
                fontSize: "13px"
              }), _textarea),
              newmessage: {
                position: "absolute",
                right: 0,
                bottom: 0,
                background: "#de2828",
                color: "#fff",
                fontSize: "12px",
                "&:hover": {
                  background: "#f00"
                }
              },
              chatGettyNoticeBox: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                height: "24px",
                marginLeft: -e.spacing(3),
                marginRight: -e.spacing(3),
                color: "rgba(255, 255, 255, 0.54)",
                background: "rgba(255, 255, 255, 0.18)",
                "&:hover": {
                  background: "#383838"
                }
              },
              gettyTooltip: {
                background: "#4B4B4B",
                color: "rgba(255, 255, 255, 0.54)"
              },
              gettyTooltipArrow: {
                color: "#4B4B4B"
              }
            };
          }),
              FK = function FK(t) {
            var _NM27 = NM(),
                n = _NM27.t,
                r = qK(),
                i = e.useContext(zM),
                _e$useContext68 = e.useContext($M),
                o = _e$useContext68.chatClient,
                _e$useContext69 = e.useContext(JM),
                a = _e$useContext69.isShowChat,
                s = _e$useContext69.activeChatUserId,
                c = _e$useContext69.dispatch,
                _e$useContext70 = e.useContext(jM),
                l = _e$useContext70.isCoHost,
                d = _e$useContext70.isHost,
                p = _e$useContext70.userId,
                h = _e$useContext70.recordingStatus,
                _ = _e$useContext70.isLocalRecording,
                f = _e$useContext70.archivingStatus,
                m = _e$useContext70.archivingOptions,
                _MK = MK(i),
                g = _MK.chatRecords,
                v = _MK.unreadRecordsCounts,
                b = _MK.markReadIndex,
                y = _MK.attendeeReceiverIds,
                w = _MK.tryAddAttendeeReceiverId,
                _ref52 = function () {
              var t = e.useContext(zM),
                  _e$useContext71 = e.useContext($M),
                  n = _e$useContext71.chatClient,
                  _e$useContext72 = e.useContext(jM),
                  r = _e$useContext72.participants,
                  i = _e$useContext72.attendees,
                  _e$useState129 = e.useState([]),
                  _e$useState130 = _slicedToArray(_e$useState129, 2),
                  o = _e$useState130[0],
                  a = _e$useState130[1],
                  _e$useState131 = e.useState(bH.All),
                  _e$useState132 = _slicedToArray(_e$useState131, 2),
                  s = _e$useState132[0],
                  c = _e$useState132[1],
                  _e$useState133 = e.useState(wH.AllPanelist),
                  _e$useState134 = _slicedToArray(_e$useState133, 2),
                  l = _e$useState134[0],
                  d = _e$useState134[1],
                  u = e.useCallback(function (e) {
                var t = e.chatPrivilege,
                    r = e.panelistChatPrivilege;
                t && c(t), r && d(r), n && a(n.getReceivers());
              }, [n]);

              return e.useEffect(function () {
                return t.on("chat-privilege-change", u), function () {
                  t.off("chat-privilege-change", u);
                };
              }, [t, u]), e.useEffect(function () {
                n && a(n.getReceivers());
              }, [n, r, i]), e.useEffect(function () {
                n && a(n.getReceivers());
              }, [n, r, i]), {
                chatPrivilege: s,
                panelistChatPrivilege: l,
                chatReceivers: o
              };
            }(),
                S = _ref52.chatPrivilege,
                x = _ref52.panelistChatPrivilege,
                E = _ref52.chatReceivers,
                _e$useState125 = e.useState(""),
                _e$useState126 = _slicedToArray(_e$useState125, 2),
                C = _e$useState126[0],
                k = _e$useState126[1],
                _e$useState127 = e.useState(!1),
                _e$useState128 = _slicedToArray(_e$useState127, 2),
                A = _e$useState128[0],
                I = _e$useState128[1],
                T = e.useRef(null),
                O = e.useRef(new TK({
              defaultHeight: 40,
              fixedWidth: !0
            })),
                R = e.useRef(!0),
                N = e.useMemo(function () {
              return E.find(function (e) {
                return (null == e ? void 0 : e.userId) === s;
              });
            }, [s, E]),
                P = e.useCallback(function () {
              null == c || c(LB(!1));
            }, [c]),
                j = e.useMemo(function () {
              return g.map(function (e) {
                return e.message.length;
              }).reduce(function (e, t, n) {
                if (0 === e.length) return [t];
                {
                  var _r70 = e[n - 1];
                  return e.push(_r70 + t), e;
                }
              }, []);
            }, [g]),
                D = e.useCallback(function (e) {
              E.find(function (t) {
                return t.userId === e;
              }) && (null == c || c(qB(e)));
            }, [E, c]),
                z = e.useCallback(function (e) {
              var t = e.index,
                  n = e.key,
                  i = e.style,
                  o = e.parent;
              var a = j.findIndex(function (e) {
                return e > t;
              });
              var s = 0;
              a > 0 && (s = j[a - 1]);
              var c = t - s,
                  l = g[a],
                  d = l.message[c],
                  u = p === l.sender.userId;
              return TH.exports.jsx(kK, {
                cache: O.current,
                columnIndex: 0,
                parent: o,
                rowIndex: t,
                children: TH.exports.jsxs(zT, {
                  style: i,
                  className: r.message,
                  children: [0 === c && TH.exports.jsx(UK, {
                    sender: l.sender,
                    receiver: l.receiver,
                    timestamp: l.timestamp,
                    recordIndex: a,
                    setChatUser: D,
                    tryAddAttendeeReceiverId: w
                  }), TH.exports.jsx(VT, {
                    primary: d.text,
                    className: VC(r.messagetext, _defineProperty({}, r.selfMsg, u))
                  })]
                }, t)
              }, d.id || n);
            }, [j, g, p, r, D, w]),
                M = e.useCallback(function (e) {
              var t = e.stopIndex;
              b(t);
            }, [b]),
                L = e.useCallback(function () {
              var e;
              var t = j[j.length - 1];
              null === (e = T.current) || void 0 === e || e.scrollToRow(t);
            }, [j]),
                U = e.useCallback(function (e) {
              k(e.target.value);
            }, []),
                B = e.useCallback(VG(function (e) {
              var t = e.clientHeight,
                  n = e.scrollHeight,
                  r = e.scrollTop;
              R.current = n - t - r <= 50;
            }, 200), []),
                H = e.useCallback(function (e) {
              "Enter" === e.key && (e.preventDefault(), -1 !== s && C && (null == o || o.send(C, s), R.current = !0, k("")));
            }, [C, s, o]);

            e.useEffect(function () {
              var e, t;
              -1 !== s ? -1 === E.findIndex(function (e) {
                return (null == e ? void 0 : e.userId) === s;
              }) && (null == c || c(qB(null === (e = E[0]) || void 0 === e ? void 0 : e.userId))) : E.length > 0 && (null == c || c(qB(null === (t = E[0]) || void 0 === t ? void 0 : t.userId)));
            }, [s, c, E]), e.useEffect(function () {
              if (R.current) {
                var e;
                var _t153 = j[j.length - 1];
                null === (e = T.current) || void 0 === e || e.scrollToRow(_t153);
              }
            }, [j]);

            var V = function V() {
              I(!1);
            },
                q = !(l || d) && [bH.NoAttendee, bH.NoOne].includes(S),
                F = (null == m ? void 0 : m.isEnabled) && f === BW;

            return TH.exports.jsxs(XW, u(u({
              title: n("wc_chat.chat"),
              open: a,
              onClose: P
            }, t), {}, {
              children: [TH.exports.jsxs(WA, {
                className: r.list,
                children: [TH.exports.jsx(jK, {
                  children: function children(e) {
                    var t = e.width,
                        n = e.height;
                    return TH.exports.jsx(_W, {
                      ref: T,
                      width: t,
                      height: n,
                      rowHeight: O.current.rowHeight,
                      deferredMeasurementCache: O.current,
                      rowRenderer: z,
                      rowCount: j.length > 0 ? j[j.length - 1] : 0,
                      onRowsRendered: M,
                      onScroll: B
                    });
                  }
                }), v > 0 && !R.current && TH.exports.jsx(AF, {
                  className: r.newmessage,
                  endIconType: "icon-down-arrow",
                  onClick: L,
                  children: n("chat_new_message", {
                    counts: v
                  })
                })]
              }), TH.exports.jsx(fI, {
                onClickAway: V,
                children: TH.exports.jsx(VN, {
                  classes: {
                    tooltip: r.gettyTooltip,
                    arrow: r.gettyTooltipArrow
                  },
                  title: TH.exports.jsx(VK, {}),
                  placement: "top",
                  open: A,
                  onClose: V,
                  PopperProps: {
                    disablePortal: !0
                  },
                  arrow: !0,
                  "aria-label": "chat-privacy-notice",
                  disableHoverListener: !0,
                  children: TH.exports.jsxs(WA, {
                    className: r.chatGettyNoticeBox,
                    onClick: function onClick() {
                      I(!A);
                    },
                    children: [TH.exports.jsx(CF, {
                      type: "icon-privacy",
                      iconStyle: {
                        transform: "scale(0.7)"
                      }
                    }), TH.exports.jsx(QA, {
                      variant: "body1",
                      style: {
                        margin: 5
                      },
                      children: F && null != m && m.isChatArchiveEnabled ? n("disclaimer.chat_button_onArchiving") : h === zj.Recording || _ ? n("disclaimer.chat_button_onRecording") : n("disclaimer.chat_button_normal")
                    })]
                  })
                })
              }), q ? TH.exports.jsx(WA, {
                className: r.disabled,
                children: TH.exports.jsx(QA, {
                  children: n("wc_chat.disable_chat")
                })
              }) : TH.exports.jsxs(TH.exports.Fragment, {
                children: [TH.exports.jsx(HK, {
                  chatUsers: E,
                  selectedChatUser: N,
                  chatPrivilege: S,
                  panelistChatPrivilege: x,
                  className: r.receiver,
                  setChatUser: D,
                  attendeeReceiverIds: y
                }), TH.exports.jsx(WA, {
                  children: TH.exports.jsx(MN, {
                    rows: 4,
                    className: r.textarea,
                    fullWidth: !0,
                    multiline: !0,
                    onChange: U,
                    onKeyPress: H,
                    value: C,
                    placeholder: n("wc_chat.type_msg")
                  })
                })]
              })]
            }));
          },
              WK = ["value", "type", "className", "children"],
              GK = function GK(e) {
            var t = e.value,
                n = e.type,
                r = e.className,
                i = e.children,
                o = h(e, WK);
            return TH.exports.jsx("div", u(u({
              role: "tabpanel",
              className: r,
              id: "suspension-view-tabpanel-".concat(n),
              "aria-labelledby": "suspension-view-tab-".concat(n)
            }, o), {}, {
              children: t === n && i
            }));
          },
              KK = Pk(function (e) {
            return {
              root: {
                "label + &": {
                  marginTop: e.spacing(1)
                }
              },
              input: {
                width: "-webkit-fill-available",
                borderRadius: .8 * e.shape.borderRadius,
                border: "1px solid rgba(255, 255, 255, 0.56)",
                padding: e.spacing(1.5),
                transition: e.transitions.create(["border-color", "box-shadow"]),
                "&:focus": {
                  borderRadius: 4,
                  borderColor: "#80bdff",
                  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
                },
                "&:placeholder": {
                  padding: e.spacing(0, 3)
                }
              }
            };
          })(iT),
              QK = Ok(function (e) {
            return {
              formControl: function formControl(t) {
                return _defineProperty({
                  width: t.isForAudio ? "243px" : "100%",
                  boxSizing: "border-box",
                  padding: e.spacing(3, 0),
                  marginTop: e.spacing(4)
                }, "& .".concat(kH, "-MuiFormLabel-focused"), {
                  color: "white"
                });
              },
              label: {
                color: "rgba(255, 255, 255, 0.56)"
              }
            };
          });

          function ZK(e) {
            var t = e.isForAudio,
                n = e.label,
                r = e.active,
                i = e.onChange,
                o = e.list,
                a = QK({
              isForAudio: t
            }),
                _NM28 = NM(),
                s = _NM28.t;

            return TH.exports.jsx("div", {
              children: TH.exports.jsxs(cT, {
                className: a.formControl,
                children: [TH.exports.jsx(kT, {
                  className: a.label,
                  children: n
                }), TH.exports.jsx($R, {
                  labelId: "customized-select-label",
                  value: r,
                  onChange: i,
                  input: TH.exports.jsx(KK, {}),
                  children: o.map(function (e) {
                    return TH.exports.jsx(lO, {
                      style: {
                        width: "inherit"
                      },
                      value: e.deviceId,
                      title: e.label,
                      disabled: !e.label,
                      children: TH.exports.jsx(QA, {
                        variant: "body1",
                        noWrap: !0,
                        children: e.label ? e.label : s("settings.unknown_device")
                      })
                    }, e.deviceId);
                  })
                })]
              })
            });
          }

          function YK(e) {
            return -1 === e.findIndex(function (e) {
              return "default" === e.deviceId;
            }) ? [].concat(_toConsumableArray(e), [{
              label: Pz.t("same_as_system"),
              deviceId: "default"
            }]) : e;
          }

          function JK(t) {
            var _e$useState135 = e.useState([]),
                _e$useState136 = _slicedToArray(_e$useState135, 2),
                n = _e$useState136[0],
                r = _e$useState136[1],
                _e$useState137 = e.useState([]),
                _e$useState138 = _slicedToArray(_e$useState137, 2),
                i = _e$useState138[0],
                o = _e$useState138[1],
                _e$useState139 = e.useState([]),
                _e$useState140 = _slicedToArray(_e$useState139, 2),
                a = _e$useState140[0],
                s = _e$useState140[1],
                c = e.useContext(zM),
                _e$useContext73 = e.useContext(DM),
                l = _e$useContext73.stream,
                d = e.useRef(t),
                u = e.useCallback(function () {
              var e;
              l && (r(YK(l.getCameraList())), o(YK(l.getSpeakerList())), s(YK(l.getMicList()))), null === (e = d.current) || void 0 === e || e.call(d);
            }, [l]);

            return e.useEffect(function () {
              return c.on("device-change", u), function () {
                c.off("device-change", u);
              };
            }, [c, u]), Mj(function () {
              var e;
              l && (r(YK(l.getCameraList())), o(YK(l.getSpeakerList())), s(YK(l.getMicList()))), null === (e = d.current) || void 0 === e || e.call(d);
            }), {
              cameraList: n,
              speakerList: i,
              microphoneList: a
            };
          }

          var $K = {
            audio: !1,
            video: !1
          };

          var XK = function XK(e) {
            $K = e;
          },
              eQ = function eQ() {
            return $K;
          };

          var tQ;
          !function (e) {
            e.AudioData = "AUDIO_QOS_DATA", e.VideoData = "VIDEO_QOS_DATA";
          }(tQ || (tQ = {}));
          var nQ = {
            avg_loss: 0,
            encoding: !1,
            jitter: 0,
            max_loss: 0,
            rtt: 0,
            sample_rate: 0
          },
              rQ = {
            avg_loss: 0,
            encoding: !1,
            fps: 0,
            height: 0,
            jitter: 0,
            max_loss: 0,
            rtt: 0,
            width: 0
          },
              iQ = Ok(function (e) {
            var _icon;

            return {
              root: _defineProperty({
                padding: e.spacing(1.75),
                "&:hover": {
                  backgroundColor: "transparent"
                }
              }, "&.".concat(kH, "-Mui-focusVisible"), {
                border: "none"
              }),
              icon: (_icon = {
                borderRadius: "50%",
                width: 16,
                height: 16,
                border: "1px solid#6e7680",
                boxSizing: "border-box"
              }, _defineProperty(_icon, "$root.".concat(kH, "-Mui-focusVisible &"), {
                outline: "2px auto rgba(19,124,189,.6)",
                outlineOffset: 2
              }), _defineProperty(_icon, "input:hover ~ &", {
                backgroundColor: e.palette.action.hover
              }), _defineProperty(_icon, "input:disabled ~ &", {
                boxShadow: "none",
                background: "rgba(206,217,224,.5)"
              }), _icon),
              checkedIcon: {
                border: "none",
                backgroundColor: "#0e72ed",
                backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
                "&:before": {
                  display: "block",
                  width: 16,
                  height: 16,
                  backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
                  content: '""'
                },
                "input:hover ~ &": {
                  backgroundColor: "#106ba3"
                }
              }
            };
          });

          function oQ(e) {
            var t = iQ();
            return TH.exports.jsx(UR, u({
              className: t.root,
              disableRipple: !0,
              color: "default",
              checkedIcon: TH.exports.jsx("span", {
                className: VC(t.icon, t.checkedIcon)
              }),
              icon: TH.exports.jsx("span", {
                className: t.icon
              })
            }, e));
          }

          var aQ = Ok(function (e) {
            return {
              checkboxGroup: {
                display: "flex",
                alignItems: "center"
              },
              sectionTitle: {
                marginTop: e.spacing(2)
              },
              tooltip: {
                background: "#2E2E2E",
                borderRadius: "8px",
                maxWidth: "200px",
                border: "1px solid rgba(255, 255, 255, 0.09)"
              },
              tooltipArrow: {
                color: "#2E2E2E",
                "&:before": {
                  border: "1px solid rgba(255, 255, 255, 0.09)"
                }
              },
              checkboxForm: {
                marginRight: 0
              },
              radioButton: {
                marginLeft: "2px"
              }
            };
          }),
              sQ = Pk({
            paper: {
              minWidth: 480,
              padding: "16px 8px",
              borderRadius: 12
            }
          })(PI);

          function cQ() {
            var _NM29 = NM(),
                t = _NM29.t,
                _e$useContext74 = e.useContext(DM),
                n = _e$useContext74.stream,
                _e$useContext75 = e.useContext(jM),
                r = _e$useContext75.isDisableReceivingVideo,
                i = _e$useContext75.isSupportVideoDecodeHardwareAcceleration,
                o = _e$useContext75.isSupportVideoEncodeHardwareAcceleration,
                a = _e$useContext75.dispatch,
                _e$useContext76 = e.useContext(JM),
                s = _e$useContext76.maximumVideosInGalleryView,
                _e$useState141 = e.useState(""),
                _e$useState142 = _slicedToArray(_e$useState141, 2),
                c = _e$useState142[0],
                l = _e$useState142[1],
                _e$useState143 = e.useState({
              visible: !1
            }),
                _e$useState144 = _slicedToArray(_e$useState143, 2),
                d = _e$useState144[0],
                u = _e$useState144[1],
                p = e.useRef(null),
                h = e.useRef(null),
                _ = e.useRef(null),
                f = aQ(),
                m = e.useCallback(function () {
              n && l(n.getActiveCamera());
            }, [n]),
                _JK = JK(m),
                g = _JK.cameraList,
                v = e.useCallback( /*#__PURE__*/function () {
              var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(e) {
                var _t154;

                return _regeneratorRuntime.wrap(function _callee40$(_context40) {
                  while (1) {
                    switch (_context40.prev = _context40.next) {
                      case 0:
                        if (!n) {
                          _context40.next = 5;
                          break;
                        }

                        _t154 = e.target.value;
                        _context40.next = 4;
                        return n.switchCamera(_t154);

                      case 4:
                        l(_t154);

                      case 5:
                      case "end":
                        return _context40.stop();
                    }
                  }
                }, _callee40);
              }));

              return function (_x55) {
                return _ref55.apply(this, arguments);
              };
            }(), [n]),
                b = e.useCallback(function () {
              null == a || a({
                type: bU,
                payload: !r
              });
            }, [a, r]),
                _ref54 = function (t) {
              var _e$useContext77 = e.useContext(JM),
                  n = _e$useContext77.isEnableHardwareAcclerationReceiving,
                  r = _e$useContext77.isEnableHardwareAcclerationSending,
                  i = _e$useContext77.isStartedHardwareAccleration,
                  o = _e$useContext77.dispatch,
                  a = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
                return _regeneratorRuntime.wrap(function _callee41$(_context41) {
                  while (1) {
                    switch (_context41.prev = _context41.next) {
                      case 0:
                        _context41.t0 = t;

                        if (!_context41.t0) {
                          _context41.next = 5;
                          break;
                        }

                        _context41.next = 4;
                        return t.enableHardwareAcceleration({
                          decode: !n
                        });

                      case 4:
                        _context41.t0 = _context41.sent;

                      case 5:
                        _context41.t1 = _context41.t0;

                        if (!_context41.t1) {
                          _context41.next = 8;
                          break;
                        }

                        null == o || o(aH(!n));

                      case 8:
                      case "end":
                        return _context41.stop();
                    }
                  }
                }, _callee41);
              })), [o, n, t]),
                  s = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
                return _regeneratorRuntime.wrap(function _callee42$(_context42) {
                  while (1) {
                    switch (_context42.prev = _context42.next) {
                      case 0:
                        _context42.t0 = t;

                        if (!_context42.t0) {
                          _context42.next = 5;
                          break;
                        }

                        _context42.next = 4;
                        return t.enableHardwareAcceleration({
                          encode: !r
                        });

                      case 4:
                        _context42.t0 = _context42.sent;

                      case 5:
                        _context42.t1 = _context42.t0;

                        if (!_context42.t1) {
                          _context42.next = 8;
                          break;
                        }

                        null == o || o(sH(!r));

                      case 8:
                      case "end":
                        return _context42.stop();
                    }
                  }
                }, _callee42);
              })), [o, r, t]);

              return {
                isEnableHardwareAcclerationReceiving: n,
                isEnableHardwareAcclerationSending: r,
                isStartedHardwareAccleration: i,
                onHardwareAccelerationReceivingCheck: a,
                onHardwareAccelerationSendingCheck: s
              };
            }(n),
                y = _ref54.isEnableHardwareAcclerationReceiving,
                w = _ref54.isEnableHardwareAcclerationSending,
                S = _ref54.isStartedHardwareAccleration,
                x = _ref54.onHardwareAccelerationReceivingCheck,
                E = _ref54.onHardwareAccelerationSendingCheck,
                C = null == n ? void 0 : n.isSupportHDVideo(),
                k = e.useMemo(function () {
              var e;
              return (null == n ? void 0 : n.isSupportMultipleVideos()) && (null === (e = navigator) || void 0 === e ? void 0 : e.hardwareConcurrency) >= 4;
            }, [n]);

            return TH.exports.jsxs("div", {
              children: [TH.exports.jsx(ZK, {
                list: g,
                active: c,
                label: t("wc_select_camera"),
                onChange: v
              }), TH.exports.jsx(dT, {
                control: TH.exports.jsx(hI, {
                  checked: r,
                  name: "checkedDisableVideo",
                  color: "primary",
                  size: "small",
                  onChange: b
                }),
                label: TH.exports.jsx(QA, {
                  variant: "body1",
                  noWrap: !0,
                  children: t("wc_extra_function_disable_video")
                })
              }), C && w && TH.exports.jsxs("div", {
                children: [TH.exports.jsx(QA, {
                  variant: "body1",
                  noWrap: !0,
                  className: f.sectionTitle,
                  children: t("wc_video.video")
                }), TH.exports.jsxs("div", {
                  className: f.checkboxGroup,
                  children: [TH.exports.jsx(dT, {
                    control: TH.exports.jsx(hI, {
                      checked: C && w,
                      name: "checkEnableVideo",
                      color: "primary",
                      size: "small",
                      disabled: !0
                    }),
                    label: TH.exports.jsx(QA, {
                      variant: "body1",
                      noWrap: !0,
                      children: t("settings.enable_hd")
                    }),
                    className: f.checkboxForm
                  }), TH.exports.jsx(VN, {
                    classes: {
                      tooltip: f.tooltip,
                      arrow: f.tooltipArrow
                    },
                    title: t("settings.enable_hd_tip"),
                    placement: "top",
                    arrow: !0,
                    children: TH.exports.jsx("div", {
                      ref: p,
                      children: TH.exports.jsx(CF, {
                        type: "icon-help",
                        iconStyle: {
                          transform: "scale(0.6)"
                        }
                      })
                    })
                  })]
                })]
              }), TH.exports.jsxs("div", {
                children: [TH.exports.jsx(QA, {
                  variant: "body1",
                  noWrap: !0,
                  className: f.sectionTitle,
                  children: t("settings.use_hardware_acceleration")
                }), TH.exports.jsxs("div", {
                  className: f.checkboxGroup,
                  children: [TH.exports.jsxs("div", {
                    className: f.checkboxGroup,
                    children: [TH.exports.jsx(dT, {
                      control: TH.exports.jsx(hI, {
                        checked: y,
                        name: "checkRecevingVideoHardwareAccleration",
                        color: "primary",
                        size: "small",
                        onChange: x,
                        disabled: !i || !S
                      }),
                      label: TH.exports.jsx(QA, {
                        variant: "body1",
                        noWrap: !0,
                        children: t("settings.receiving_video")
                      }),
                      className: f.checkboxForm
                    }), TH.exports.jsx(VN, {
                      classes: {
                        tooltip: f.tooltip,
                        arrow: f.tooltipArrow
                      },
                      title: t("settings.receiving_video_tips"),
                      placement: "top",
                      arrow: !0,
                      children: TH.exports.jsx("div", {
                        ref: h,
                        children: TH.exports.jsx(CF, {
                          type: "icon-help",
                          iconStyle: {
                            transform: "scale(0.6)"
                          }
                        })
                      })
                    })]
                  }), TH.exports.jsxs("div", {
                    className: f.checkboxGroup,
                    children: [TH.exports.jsx(dT, {
                      control: TH.exports.jsx(hI, {
                        checked: w,
                        name: "checkSendingVideoHardwareAccleration",
                        color: "primary",
                        size: "small",
                        onChange: E,
                        disabled: !C || !o || !S
                      }),
                      label: TH.exports.jsx(QA, {
                        variant: "body1",
                        noWrap: !0,
                        children: t("settings.sending_video")
                      }),
                      className: f.checkboxForm,
                      style: {
                        marginLeft: "5px"
                      }
                    }), TH.exports.jsx(VN, {
                      classes: {
                        tooltip: f.tooltip,
                        arrow: f.tooltipArrow
                      },
                      title: t("settings.sending_video_tips"),
                      placement: "top",
                      arrow: !0,
                      children: TH.exports.jsx("div", {
                        ref: _,
                        children: TH.exports.jsx(CF, {
                          type: "icon-help",
                          iconStyle: {
                            transform: "scale(0.6)"
                          }
                        })
                      })
                    })]
                  })]
                })]
              }), k && TH.exports.jsxs("div", {
                children: [TH.exports.jsx(QA, {
                  variant: "body1",
                  noWrap: !0,
                  className: f.sectionTitle,
                  children: t("settings.maximum_view")
                }), TH.exports.jsx("div", {
                  className: f.checkboxGroup,
                  children: TH.exports.jsxs(BR, {
                    "aria-label": "maximun numbers of gallery view",
                    name: "maximunView",
                    style: {
                      flexDirection: "row"
                    },
                    value: "".concat(s),
                    onChange: function onChange(e) {
                      d.visible || u({
                        visible: !0,
                        participants: Number(e.target.value)
                      });
                    },
                    children: [TH.exports.jsx(dT, {
                      value: "9",
                      control: TH.exports.jsx(oQ, {
                        className: f.radioButton
                      }),
                      label: TH.exports.jsx(QA, {
                        variant: "body1",
                        noWrap: !0,
                        children: t("settings.participants9")
                      })
                    }), TH.exports.jsx(dT, {
                      value: "25",
                      control: TH.exports.jsx(oQ, {
                        className: f.radioButton
                      }),
                      label: TH.exports.jsx(QA, {
                        variant: "body1",
                        noWrap: !0,
                        children: t("settings.participants25")
                      })
                    })]
                  })
                })]
              }), TH.exports.jsx(sQ, {
                open: d.visible,
                onClose: function onClose() {
                  u({
                    visible: !1
                  });
                },
                "aria-labelledby": "rejoin-dialog-title",
                "aria-describedby": "rejoin-dialog-descption",
                maxWidth: "md",
                transitionDuration: 300,
                children: TH.exports.jsxs(MI, {
                  children: [TH.exports.jsx(UI, {
                    id: "rejoin-dialog-descption",
                    children: t("settings.switch_view_mode_text")
                  }), TH.exports.jsxs(DI, {
                    children: [TH.exports.jsx(YA, {
                      onClick: function onClick() {
                        sessionStorage.setItem("WEB_SDK_COMPONENT_VIEW_MAXIMUM_VIDEOS", "".concat(d.participants)), setTimeout(function () {
                          window.location.reload();
                        }, 0);
                      },
                      variant: "contained",
                      color: "primary",
                      size: "small",
                      children: t("settings.rejoin")
                    }), TH.exports.jsx(YA, {
                      onClick: function onClick() {
                        u({
                          visible: !1
                        });
                      },
                      variant: "outlined",
                      size: "small",
                      children: t("dialog.btn_cancel")
                    })]
                  })]
                })
              })]
            });
          }

          var lQ = Ok(function () {
            return {
              leave: {
                "& button": {
                  color: "#FF5C5C",
                  background: "#FF5C5C17"
                },
                textAlign: "center",
                margin: "10px auto",
                "&:hover": {
                  color: "white",
                  cursor: "pointer"
                }
              },
              selectWrapper: {
                display: "flex",
                alignItems: "flex-end"
              },
              testButon: {
                height: "32px",
                minWidth: "100px",
                marginRight: Pj.spacing(2),
                marginBottom: Pj.spacing(3),
                border: "1px solid rgba(255, 255, 255, 0.56)",
                padding: Pj.spacing(2)
              },
              buttonText: {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              },
              levelWrapper: {
                display: "flex",
                alignItems: "center",
                width: "100%"
              },
              label: {
                width: "100px",
                marginRight: Pj.spacing(2)
              },
              progressbar: _defineProperty({
                backgroundColor: "rgba(255,255,255)",
                width: "243px",
                borderRadius: 5
              }, "& .".concat(kH, "-MuiLinearProgress-barColorPrimary"), {
                borderRadius: 5
              })
            };
          });

          function dQ() {
            var t = e.useContext(zM),
                _e$useState145 = e.useState(""),
                _e$useState146 = _slicedToArray(_e$useState145, 2),
                n = _e$useState146[0],
                r = _e$useState146[1],
                _e$useState147 = e.useState(""),
                _e$useState148 = _slicedToArray(_e$useState147, 2),
                i = _e$useState148[0],
                o = _e$useState148[1],
                _e$useState149 = e.useState(!0),
                _e$useState150 = _slicedToArray(_e$useState149, 2),
                a = _e$useState150[0],
                s = _e$useState150[1],
                _e$useContext78 = e.useContext(DM),
                c = _e$useContext78.stream,
                _e$useContext79 = e.useContext(jM),
                l = _e$useContext79.isStartedAudio,
                d = _e$useContext79.isWebinar,
                _e$useContext80 = e.useContext(JM),
                u = _e$useContext80.dispatch,
                _NM30 = NM(),
                p = _NM30.t,
                h = e.useCallback(function () {
              c && (r(c.getActiveMicrophone()), o(c.getActiveSpeaker()));
            }, [c]),
                _JK2 = JK(h),
                _ = _JK2.microphoneList,
                f = _JK2.speakerList,
                _ref58 = function (t, n) {
              var _e$useState151 = e.useState(!1),
                  _e$useState152 = _slicedToArray(_e$useState151, 2),
                  r = _e$useState152[0],
                  i = _e$useState152[1],
                  _e$useState153 = e.useState(!1),
                  _e$useState154 = _slicedToArray(_e$useState153, 2),
                  o = _e$useState154[0],
                  a = _e$useState154[1],
                  _e$useState155 = e.useState(!1),
                  _e$useState156 = _slicedToArray(_e$useState155, 2),
                  s = _e$useState156[0],
                  c = _e$useState156[1],
                  _e$useState157 = e.useState(0),
                  _e$useState158 = _slicedToArray(_e$useState157, 2),
                  l = _e$useState158[0],
                  d = _e$useState158[1],
                  _e$useState159 = e.useState(0),
                  _e$useState160 = _slicedToArray(_e$useState159, 2),
                  u = _e$useState160[0],
                  p = _e$useState160[1],
                  _NM31 = NM(),
                  h = _NM31.t,
                  _e$useState161 = e.useState(h("settings.test_mic")),
                  _e$useState162 = _slicedToArray(_e$useState161, 2),
                  _ = _e$useState162[0],
                  f = _e$useState162[1],
                  _e$useState163 = e.useState(h("settings.test_speaker")),
                  _e$useState164 = _slicedToArray(_e$useState163, 2),
                  m = _e$useState164[0],
                  g = _e$useState164[1],
                  v = e.useRef(),
                  b = e.useRef(),
                  y = _y.createLocalAudioTrack(),
                  w = e.useCallback(function () {
                var e;

                if (v.current && (v.current.destroy(), v.current = void 0, p(0), c(!1), g(h("settings.test_speaker"))), o || r) {
                  if (r) null === (e = b.current) || void 0 === e || e.stopRecording(), i(!1);else if (o) {
                    var s;
                    null === (s = b.current) || void 0 === s || s.stop(), a(!1), d(0);
                  }
                } else b.current = y.testMicrophone({
                  microphoneId: n,
                  speakerId: t,
                  recordAndPlay: !0,
                  onAnalyseFrequency: function onAnalyseFrequency(e) {
                    d(Math.min(100, e));
                  },
                  onStartRecording: function onStartRecording() {
                    i(!0), f(h("settings.recording"));
                  },
                  onStartPlayRecording: function onStartPlayRecording() {
                    i(!1), a(!0), f(h("settings.playing"));
                  },
                  onStopPlayRecording: function onStopPlayRecording() {
                    a(!1), f(h("settings.test_mic"));
                  }
                });
              }, [n, t, o, r, y, h]),
                  S = e.useCallback(function () {
                var e;
                b.current && (b.current.destroy(), b.current = void 0, f(h("settings.test_mic")), d(0), i(!1), a(!1)), s ? (null === (e = v.current) || void 0 === e || e.stop(), c(!1), p(0), g(h("settings.test_speaker"))) : (v.current = y.testSpeaker({
                  speakerId: t,
                  onAnalyseFrequency: function onAnalyseFrequency(e) {
                    p(Math.min(100, e));
                  }
                }), c(!0), g(h("settings.stop")));
              }, [t, s, y, h]);

              return e.useEffect(function () {
                return function () {
                  b.current && (b.current.destroy(), b.current = void 0), v.current && (v.current.destroy(), v.current = void 0);
                };
              }, []), {
                testSpeakerButtonText: m,
                testMicButtonText: _,
                inputLevel: l,
                outputLevel: u,
                onTestSpeakerClick: S,
                onTestMicrophoneClick: w
              };
            }(i, n),
                m = _ref58.testSpeakerButtonText,
                g = _ref58.testMicButtonText,
                v = _ref58.inputLevel,
                b = _ref58.outputLevel,
                y = _ref58.onTestSpeakerClick,
                w = _ref58.onTestMicrophoneClick,
                S = e.useCallback( /*#__PURE__*/function () {
              var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(e) {
                var _t155;

                return _regeneratorRuntime.wrap(function _callee43$(_context43) {
                  while (1) {
                    switch (_context43.prev = _context43.next) {
                      case 0:
                        if (!c) {
                          _context43.next = 5;
                          break;
                        }

                        _t155 = e.target.value;
                        _context43.next = 4;
                        return c.switchSpeaker(_t155);

                      case 4:
                        o(_t155);

                      case 5:
                      case "end":
                        return _context43.stop();
                    }
                  }
                }, _callee43);
              }));

              return function (_x56) {
                return _ref59.apply(this, arguments);
              };
            }(), [c]),
                x = e.useCallback( /*#__PURE__*/function () {
              var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(e) {
                var _t156;

                return _regeneratorRuntime.wrap(function _callee44$(_context44) {
                  while (1) {
                    switch (_context44.prev = _context44.next) {
                      case 0:
                        if (!c) {
                          _context44.next = 5;
                          break;
                        }

                        _t156 = e.target.value;
                        _context44.next = 4;
                        return c.switchMicrophone(_t156);

                      case 4:
                        r(_t156);

                      case 5:
                      case "end":
                        return _context44.stop();
                    }
                  }
                }, _callee44);
              }));

              return function (_x57) {
                return _ref60.apply(this, arguments);
              };
            }(), [c]),
                E = lQ(),
                C = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
              return _regeneratorRuntime.wrap(function _callee45$(_context45) {
                while (1) {
                  switch (_context45.prev = _context45.next) {
                    case 0:
                      _context45.prev = 0;

                      if (!l) {
                        _context45.next = 6;
                        break;
                      }

                      _context45.next = 4;
                      return null == c ? void 0 : c.stopAudio();

                    case 4:
                      _context45.next = 8;
                      break;

                    case 6:
                      _context45.next = 8;
                      return null == c ? void 0 : c.startAudio();

                    case 8:
                      null == u || u(FB(!1));
                      _context45.next = 14;
                      break;

                    case 11:
                      _context45.prev = 11;
                      _context45.t0 = _context45["catch"](0);
                      "INSUFFICIENT_PRIVILEGES" === (null == _context45.t0 ? void 0 : _context45.t0.type) && (null == u || u(FB(!0)));

                    case 14:
                    case "end":
                      return _context45.stop();
                  }
                }
              }, _callee45, null, [[0, 11]]);
            })), [c, l, u]);

            return e.useEffect(function () {
              var e = t.getCurrentUserInfo();
              !d || !t.isAttendee() || null != e && e.isAllowToTalk || s(!1);
            }, [d, s, t]), TH.exports.jsxs("div", {
              children: [TH.exports.jsxs("div", {
                className: E.selectWrapper,
                children: [TH.exports.jsx(YA, {
                  variant: "outlined",
                  className: E.testButon,
                  children: TH.exports.jsx(QA, {
                    variant: "body1",
                    className: E.buttonText,
                    onClick: y,
                    children: m
                  })
                }), TH.exports.jsx(ZK, {
                  isForAudio: !0,
                  list: f,
                  active: i,
                  label: p("wc_select_speaker"),
                  onChange: S
                })]
              }), TH.exports.jsxs("div", {
                className: E.levelWrapper,
                children: [TH.exports.jsx(QA, {
                  variant: "body1",
                  className: E.label,
                  children: p("settings.output_level")
                }), TH.exports.jsx(IT, {
                  className: E.progressbar,
                  variant: "determinate",
                  value: b,
                  color: "primary"
                })]
              }), a && TH.exports.jsxs(TH.exports.Fragment, {
                children: [TH.exports.jsxs("div", {
                  className: E.selectWrapper,
                  children: [TH.exports.jsx(YA, {
                    variant: "outlined",
                    className: E.testButon,
                    onClick: w,
                    children: TH.exports.jsx(QA, {
                      variant: "body1",
                      className: E.buttonText,
                      children: g
                    })
                  }), TH.exports.jsx(ZK, {
                    isForAudio: !0,
                    list: _,
                    active: n,
                    label: p("wc_select_microphone"),
                    onChange: x
                  })]
                }), TH.exports.jsxs("div", {
                  className: E.levelWrapper,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    className: E.label,
                    children: p("settings.input_level")
                  }), TH.exports.jsx(IT, {
                    className: E.progressbar,
                    variant: "determinate",
                    value: v,
                    color: "primary"
                  })]
                })]
              }), TH.exports.jsx(QA, {
                variant: "body1",
                className: E.leave,
                onClick: C,
                noWrap: !0,
                children: TH.exports.jsx(YA, {
                  children: p(l ? "wc_leave_computer_audio" : "wc_pc_audio")
                })
              })]
            });
          }

          var uQ = Ok(function (e) {
            return {
              groupLabel: _defineProperty({
                fontSize: 14,
                fontWeight: "bold",
                color: "white",
                margin: e.spacing(4, 0, 1, 0)
              }, "&.".concat(kH, "-Mui-focused"), {
                color: "white"
              }),
              radioGroup: {
                fontWeight: "normal",
                "& div": {
                  fontSize: 14
                }
              },
              label: {
                color: "#F5F5F5",
                "& span": {
                  fontSize: "14px"
                }
              }
            };
          });

          var pQ, hQ, _Q;

          function fQ(t) {
            var n = t.isWebinar,
                _NM32 = NM(),
                r = _NM32.t,
                i = uQ(),
                _e$useContext81 = e.useContext(DM),
                o = _e$useContext81.stream,
                a = function () {
              var _e$useState171 = e.useState(GM.HostGrab),
                  _e$useState172 = _slicedToArray(_e$useState171, 2),
                  t = _e$useState172[0],
                  n = _e$useState172[1],
                  r = e.useContext(zM),
                  _e$useContext82 = e.useContext(DM),
                  i = _e$useContext82.stream,
                  o = e.useCallback(function (e) {
                var t = e.privilege;
                n(t);
              }, []);

              return e.useEffect(function () {
                return r.on("share-privilege-change", o), function () {
                  r.off("share-privilege-change", o);
                };
              }, [r, o]), Mj(function () {
                i && n(i.getSharePrivilege());
              }), t;
            }(),
                _e$useState165 = e.useState(a === GM.MultipleShare ? pQ.Multiple : pQ.Single),
                _e$useState166 = _slicedToArray(_e$useState165, 2),
                s = _e$useState166[0],
                c = _e$useState166[1],
                _e$useState167 = e.useState(a === GM.OnlyHost ? hQ.Host : hQ.AllParticipants),
                _e$useState168 = _slicedToArray(_e$useState167, 2),
                l = _e$useState168[0],
                d = _e$useState168[1],
                _e$useState169 = e.useState(a === GM.HostGrab ? _Q.Host : _Q.AllParticipants),
                _e$useState170 = _slicedToArray(_e$useState169, 2),
                u = _e$useState170[0],
                p = _e$useState170[1],
                h = e.useCallback(function (e) {
              var t = e.target.value;
              var n;
              n = t === pQ.Single ? l === hQ.Host ? GM.OnlyHost : u === _Q.Host ? GM.HostGrab : GM.AnyoneGrab : GM.MultipleShare, null == o || o.setSharePrivilege(n);
            }, [o, l, u]),
                _ = e.useCallback(function (e) {
              var t = e.target.value;
              var n;
              n = t === hQ.Host ? GM.OnlyHost : u === _Q.Host ? GM.HostGrab : GM.AnyoneGrab, null == o || o.setSharePrivilege(n);
            }, [o, u]),
                f = e.useCallback(function (e) {
              var t = e.target.value,
                  n = t === _Q.Host ? GM.HostGrab : GM.AnyoneGrab;
              null == o || o.setSharePrivilege(n);
            }, [o]);

            return e.useEffect(function () {
              c(a === GM.MultipleShare ? pQ.Multiple : pQ.Single), d(a === GM.OnlyHost ? hQ.Host : hQ.AllParticipants), p(a === GM.HostGrab ? _Q.Host : _Q.AllParticipants);
            }, [a]), TH.exports.jsxs(cT, {
              component: "fieldset",
              children: [!n && TH.exports.jsx(mT, {
                className: i.groupLabel,
                children: r("wc_sharer_setting_menu_category3_title")
              }), !n && TH.exports.jsxs(BR, {
                className: i.radioGroup,
                id: "category",
                value: s,
                onChange: h,
                children: [TH.exports.jsx(pT, {
                  "aria-label": "position",
                  row: !0,
                  children: TH.exports.jsx(dT, {
                    className: i.label,
                    value: pQ.Single,
                    control: TH.exports.jsx(oQ, {}),
                    label: r("wc_sharer_setting_menu_item1"),
                    labelPlacement: "end"
                  }, "1")
                }), TH.exports.jsx(pT, {
                  "aria-label": "position",
                  row: !0,
                  children: TH.exports.jsx(dT, {
                    className: i.label,
                    value: pQ.Multiple,
                    control: TH.exports.jsx(oQ, {}),
                    label: r("wc_sharer_setting_menu_item2"),
                    labelPlacement: "end"
                  }, "2")
                })]
              }, "category"), TH.exports.jsx(mT, {
                className: i.groupLabel,
                children: r("wc_sharer_setting_menu_category1_title")
              }), TH.exports.jsxs(BR, {
                className: i.radioGroup,
                id: "ability",
                value: l,
                onChange: _,
                children: [TH.exports.jsx(pT, {
                  "aria-label": "position",
                  row: !0,
                  children: TH.exports.jsx(dT, {
                    className: i.label,
                    value: hQ.Host,
                    control: TH.exports.jsx(oQ, {}),
                    label: r("wc_sharer_setting_menu_category_option1"),
                    labelPlacement: "end",
                    disabled: s === pQ.Multiple
                  }, "1")
                }), TH.exports.jsx(pT, {
                  "aria-label": "position",
                  row: !0,
                  children: TH.exports.jsx(dT, {
                    className: i.label,
                    value: hQ.AllParticipants,
                    control: TH.exports.jsx(oQ, {}),
                    label: r("wc_sharer_setting_menu_category_option2"),
                    labelPlacement: "end",
                    disabled: s === pQ.Multiple
                  }, "2")
                })]
              }, "ability"), TH.exports.jsx(mT, {
                className: i.groupLabel,
                children: r("wc_sharer_setting_menu_category2_title")
              }), TH.exports.jsxs(BR, {
                className: i.radioGroup,
                id: "grab",
                value: u,
                onChange: f,
                children: [TH.exports.jsx(pT, {
                  "aria-label": "position",
                  row: !0,
                  children: TH.exports.jsx(dT, {
                    className: i.label,
                    value: _Q.Host,
                    control: TH.exports.jsx(oQ, {}),
                    label: r("wc_sharer_setting_menu_category_option1"),
                    labelPlacement: "end",
                    disabled: s === pQ.Multiple || l === hQ.Host
                  }, "1")
                }), TH.exports.jsx(pT, {
                  "aria-label": "position",
                  row: !0,
                  children: TH.exports.jsx(dT, {
                    className: i.label,
                    value: _Q.AllParticipants,
                    control: TH.exports.jsx(oQ, {}),
                    label: r("wc_sharer_setting_menu_category_option2"),
                    labelPlacement: "end",
                    disabled: s === pQ.Multiple || l === hQ.Host
                  }, "2")
                })]
              }, "grab")]
            });
          }

          var mQ;
          !function (e) {
            e.Single = "single", e.Multiple = "multiple";
          }(pQ || (pQ = {})), function (e) {
            e.Host = "host", e.AllParticipants = "allParticipants";
          }(hQ || (hQ = {})), function (e) {
            e.Host = "host", e.AllParticipants = "allParticipants";
          }(_Q || (_Q = {})), function (e) {
            e.Video = "video", e.Audio = "audio", e.ShareScreen = "share", e.Background = "background", e.Statistics = "statistics";
          }(mQ || (mQ = {}));
          var gQ = Ok(function (e) {
            return {
              backgroundSettingContainer: {
                position: "relative",
                height: "390px"
              },
              checkBoxWrapper: {
                position: "absolute",
                display: "flex",
                alignItems: "center",
                bottom: 0
              },
              chooseContainer: {
                marginTop: "16px"
              },
              avatarPlaceHoder: {
                height: "203px",
                width: "360px",
                borderRadius: "12px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              },
              canvas: {
                borderRadius: "12px"
              },
              virtualBackgroundOptionWrapper: {
                display: "flex",
                flexWrap: "wrap",
                marginTop: "16px",
                height: "80px",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  width: "5px"
                },
                "&::-webkit-scrollbar-thumb": {
                  width: "4px",
                  background: "#707070",
                  borderRadius: "5px"
                }
              },
              virtualBackgroundOptionsBox: {
                height: "49.5px",
                width: "80px",
                border: "1px solid rgba(255, 255, 255, 0.09)",
                borderRadius: "8px",
                margin: "3px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer"
              },
              virtualBackgroundOptionsImage: {
                height: "49.5px",
                width: "80px",
                borderRadius: "8px",
                border: "1px solid black",
                margin: "3px",
                cursor: "pointer",
                objectFit: "fill"
              },
              spinner: {
                display: "flex",
                animation: "$spinAnimation 1000ms infinite linear"
              },
              "@keyframes spinAnimation": {
                "0%": {
                  transform: "rotate(0deg)"
                },
                "100%": {
                  transform: "rotate(360deg)"
                }
              }
            };
          });

          function vQ() {
            var _e$useState173 = e.useState(!0),
                _e$useState174 = _slicedToArray(_e$useState173, 2),
                t = _e$useState174[0],
                n = _e$useState174[1],
                r = e.useRef(null),
                _e$useContext83 = e.useContext(DM),
                i = _e$useContext83.stream,
                _e$useContext84 = e.useContext(JM),
                o = _e$useContext84.isMirrorVideo,
                a = _e$useContext84.virtualBackgroundImageId,
                s = _e$useContext84.virtualBackgroundImageList,
                c = _e$useContext84.virtualBackgroundPreloadState,
                l = _e$useContext84.dispatch,
                d = gQ(),
                _NM33 = NM(),
                u = _NM33.t,
                p = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
              return _regeneratorRuntime.wrap(function _callee46$(_context46) {
                while (1) {
                  switch (_context46.prev = _context46.next) {
                    case 0:
                      if (!i) {
                        _context46.next = 10;
                        break;
                      }

                      _context46.prev = 1;
                      _context46.next = 4;
                      return i.mirrorVideo(!o);

                    case 4:
                      null == l || l({
                        type: EB,
                        payload: !o
                      });
                      _context46.next = 10;
                      break;

                    case 7:
                      _context46.prev = 7;
                      _context46.t0 = _context46["catch"](1);
                      console.log(_context46.t0);

                    case 10:
                    case "end":
                      return _context46.stop();
                  }
                }
              }, _callee46, null, [[1, 7]]);
            })), [l, o, i]),
                h = e.useCallback(function (e, n) {
              i && !t && c === YM.Success && ("background0" === n ? i.updateVirtualBackgroundImage("blur") : i.updateVirtualBackgroundImage(e), null == l || l({
                type: CB,
                payload: n
              }));
            }, [l, t, i, c]);

            e.useEffect(function () {
              return i && r.current && i.previewVirtualBackground(r.current, "", !0).then(function () {
                n(!1);
              }), function () {
                null == i || i.stopPreviewVirtualBackground();
              };
            }, [i]);

            var _ = u("choose_background"),
                f = u("mirror_my_video"),
                m = u("wc_none");

            return TH.exports.jsxs(WA, {
              className: d.backgroundSettingContainer,
              children: [t && TH.exports.jsx(WA, {
                className: d.avatarPlaceHoder,
                children: TH.exports.jsx(WA, {
                  className: d.spinner,
                  children: TH.exports.jsx("img", {
                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIwSURBVHgBtZVJSxxRFIXv63QSzGgIJKTBFjcZyN5MGyORZJEfkEUTCGSbfxBIFvkHIdlHgoIuFFyIbhwQXIgiuFHolQOo4MIBtQe7/K7vVtNqtdJ2eeD0rar37jnvvltdz8kZCIKggfAWPoEP4EN4BebhEpyGU8659WoarorwPcIn+BgmTbQyJivulWOwK8rIRYi/JryDt2ylMzALVxDYsDnNVtEL2GEmOfifOX1VDUhsI7RbwiwcIGFfzgA5apSBHyyvk5x/pwyY2Ep4DxNwmEmTUgPI/0z4Yvl/yO8Ru9HBu4Q38ACO1Cp+tFLnOgl/xffmK5qPygbglQ3MMnFcLghyewkTUBf888gApzvEp7Bog/XiF9yDrWjf1gpaTHyOFWxJnUBjm6C7oA3PqIG+crr3WYkPo2bwUg0azWBb4sOC+J6mE+ZUCP9EcQCtFTNo1p8DuRyodqAVaGOLdPymxAS0npvBrhpsin+LGiU+pMVv/bwarIrfpvsSHz6Kr2BIDbJmkKK0pNQJNHT1GTMYTNDxAhdr4j8bz6R+fBe/Pd1oL4auDbAddsAmuSDI/QHzcNXOjGODaTNpszJrFW8JPErwW/i8vOdaDgO6TSreZP1Y5nn+HGFnOjvij85+cn6XdSMSUoSUjWnz9ZzVVzlPYs7mhGfxVfG9K4l/1fWLUKrUq3boXyfogRF+p4rG8Lpg1+G9VrmPeHBSK9KgwugaQc+LG7bakonmTFTjXpRwiEMoVuKpm03GhAAAAABJRU5ErkJggg=="
                  })
                })
              }), TH.exports.jsx("canvas", {
                id: "zoom-sdk-vb-preview",
                width: "360",
                height: "203",
                className: d.canvas,
                ref: r,
                hidden: t
              }), TH.exports.jsxs(WA, {
                className: d.chooseContainer,
                children: [TH.exports.jsx(QA, {
                  variant: "subtitle2",
                  children: _
                }), TH.exports.jsxs(WA, {
                  className: d.virtualBackgroundOptionWrapper,
                  children: [TH.exports.jsx(WA, {
                    className: d.virtualBackgroundOptionsBox,
                    style: {
                      background: "#2E2E2E",
                      outline: "" === a ? "2px solid #4E9AF7" : "none"
                    },
                    onClick: function onClick() {
                      return h("", "");
                    },
                    children: TH.exports.jsx(QA, {
                      variant: "body1",
                      children: m
                    })
                  }), s.map(function (e) {
                    return TH.exports.jsx("img", {
                      className: d.virtualBackgroundOptionsImage,
                      src: "".concat(e.previewSmallObjectURL),
                      onClick: function onClick() {
                        return h(e.displayURL, e.id);
                      },
                      style: {
                        outline: a === e.id ? "2px solid #4E9AF7" : "none"
                      }
                    }, e.id);
                  })]
                })]
              }), TH.exports.jsx(WA, {
                className: d.checkBoxWrapper,
                children: TH.exports.jsx(dT, {
                  control: TH.exports.jsx(hI, {
                    checked: o,
                    name: "checkedMirrorVideo",
                    color: "primary",
                    size: "small",
                    onChange: p
                  }),
                  label: TH.exports.jsx(QA, {
                    variant: "body1",
                    noWrap: !0,
                    children: f
                  })
                })
              })]
            });
          }

          var bQ = "-",
              yQ = function yQ(e) {
            return 0 === e || !!e;
          },
              wQ = function wQ(e) {
            if (!yQ(e)) return null;

            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            return n.reduce(function (e, t) {
              return t(e);
            }, e);
          },
              SQ = function SQ(e, t) {
            var n = bQ;
            return void 0 !== e && (n = "".concat(e, " ").concat(t)), n;
          },
              xQ = function xQ(e) {
            return SQ(e, "ms");
          },
              EQ = function EQ(e) {
            return SQ(e, "khz");
          },
              CQ = function CQ(e) {
            var t = e;
            return e !== bQ && (t = "".concat((e / 1e3 * 100).toFixed(1), "%")), t;
          },
              kQ = function kQ(e, t) {
            var n = wQ(e.avg_loss, CQ),
                r = wQ(t.avg_loss, CQ),
                i = wQ(e.max_loss, CQ),
                o = wQ(t.max_loss, CQ),
                a = yQ(n) && yQ(i),
                s = yQ(r) && yQ(o);
            return [a ? wQ(n, function () {
              return "".concat(n, " (").concat(i, ")");
            }) : null, s ? wQ(r, function () {
              return "".concat(r, " (").concat(o, ")");
            }) : null];
          },
              AQ = Ok(function (e) {
            var _table;

            return {
              tabs: _defineProperty({
                marginTop: 16,
                minHeight: 24,
                height: 24,
                borderRadius: 8
              }, "& .".concat(kH, "-MuiTabs-indicator"), {
                backgroundColor: "rgba(255, 255, 255, 0.18)",
                height: 22,
                borderRadius: 7,
                top: 1
              }),
              tab: {
                minHeight: 24,
                maxHeight: 24
              },
              table: (_table = {}, _defineProperty(_table, "& .".concat(kH, "-MuiTableCell-root"), {
                borderBottom: "none",
                fontWeight: "normal"
              }), _defineProperty(_table, "& .".concat(kH, "-MuiTableBody-root"), {
                boxShadow: "0 0 0 1px ".concat(e.palette.action.hover),
                borderRadius: e.spacing(4)
              }), _table),
              titleCell: {
                color: "rgba(255, 255, 255, 0.54)",
                fontSize: 11
              },
              dataCell: {
                fontSize: 10
              }
            };
          });

          function IQ() {
            var _e$useState175 = e.useState(!0),
                _e$useState176 = _slicedToArray(_e$useState175, 2),
                t = _e$useState176[0],
                n = _e$useState176[1],
                _e$useState177 = e.useState(0),
                _e$useState178 = _slicedToArray(_e$useState177, 2),
                r = _e$useState178[0],
                i = _e$useState178[1],
                o = AQ(),
                _ref63 = function () {
              var _e$useState179 = e.useState(nQ),
                  _e$useState180 = _slicedToArray(_e$useState179, 2),
                  t = _e$useState180[0],
                  n = _e$useState180[1],
                  _e$useState181 = e.useState(nQ),
                  _e$useState182 = _slicedToArray(_e$useState181, 2),
                  r = _e$useState182[0],
                  i = _e$useState182[1],
                  _e$useState183 = e.useState(rQ),
                  _e$useState184 = _slicedToArray(_e$useState183, 2),
                  o = _e$useState184[0],
                  a = _e$useState184[1],
                  _e$useState185 = e.useState(rQ),
                  _e$useState186 = _slicedToArray(_e$useState185, 2),
                  s = _e$useState186[0],
                  c = _e$useState186[1],
                  l = e.useContext(zM),
                  _e$useContext85 = e.useContext(DM),
                  d = _e$useContext85.stream,
                  _e$useContext86 = e.useContext(jM),
                  u = _e$useContext86.isMuted,
                  p = _e$useContext86.isStartedVideo,
                  h = e.useRef(0),
                  _ = e.useRef(0),
                  f = function f() {
                h.current && (clearTimeout(h.current), h.current = 0);
              },
                  m = function m() {
                _.current && (clearTimeout(_.current), _.current = 0);
              },
                  g = e.useCallback(function (e) {
                (null == e ? void 0 : e.type) === tQ.AudioData && (e.data && !0 === e.data.encoding && n(e.data), e.data && !1 === e.data.encoding && (i(e.data), f(), h.current = window.setTimeout(function () {
                  i(nQ);
                }, 2e3)));
              }, []),
                  v = e.useCallback(function (e) {
                (null == e ? void 0 : e.type) === tQ.VideoData && (e.data && !0 === e.data.encoding && a(e.data), e.data && !1 === e.data.encoding && (c(e.data), m(), _.current = window.setTimeout(function () {
                  c(rQ);
                }, 2e3)));
              }, []);

              return e.useEffect(function () {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
                  return _regeneratorRuntime.wrap(function _callee47$(_context47) {
                    while (1) {
                      switch (_context47.prev = _context47.next) {
                        case 0:
                          _context47.t0 = d;

                          if (!_context47.t0) {
                            _context47.next = 6;
                            break;
                          }

                          _context47.next = 4;
                          return d.subscribeAudioStatisticData();

                        case 4:
                          _context47.next = 6;
                          return d.subscribeVideoStatisticData();

                        case 6:
                        case "end":
                          return _context47.stop();
                      }
                    }
                  }, _callee47);
                }))(), function () {
                  !_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
                    var _e303;

                    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
                      while (1) {
                        switch (_context48.prev = _context48.next) {
                          case 0:
                            if (!d) {
                              _context48.next = 10;
                              break;
                            }

                            _e303 = eQ();
                            _context48.t0 = _e303.audio;

                            if (_context48.t0) {
                              _context48.next = 6;
                              break;
                            }

                            _context48.next = 6;
                            return d.unsubscribeAudioStatisticData();

                          case 6:
                            _context48.t1 = _e303.video;

                            if (_context48.t1) {
                              _context48.next = 10;
                              break;
                            }

                            _context48.next = 10;
                            return d.unsubscribeVideoStatisticData();

                          case 10:
                          case "end":
                            return _context48.stop();
                        }
                      }
                    }, _callee48);
                  }))(), f(), m();
                };
              }, [d]), e.useEffect(function () {
                return l.on("audio-statistic-data-change", g), l.on("video-statistic-data-change", v), function () {
                  l.off("audio-statistic-data-change", g), l.off("video-statistic-data-change", v);
                };
              }, [l, g, v]), e.useEffect(function () {
                !0 === u && n(nQ), !1 === p && a(rQ);
              }, [u, p]), {
                audioStatisticsEncodeData: t,
                audioStatisticsDecodeData: r,
                videoStatisticsEncodeData: o,
                videoStatisticsDecodeData: s
              };
            }(),
                a = _ref63.audioStatisticsEncodeData,
                s = _ref63.audioStatisticsDecodeData,
                c = _ref63.videoStatisticsEncodeData,
                l = _ref63.videoStatisticsDecodeData,
                _kQ = kQ(a, s),
                _kQ2 = _slicedToArray(_kQ, 2),
                d = _kQ2[0],
                u = _kQ2[1],
                _kQ3 = kQ(c, l),
                _kQ4 = _slicedToArray(_kQ3, 2),
                p = _kQ4[0],
                h = _kQ4[1],
                _NM34 = NM(),
                _ = _NM34.t,
                f = _("settings.item_name"),
                m = _("settings.send"),
                g = _("settings.receive"),
                v = _("settings.audio_tab_text"),
                b = _("settings.video_tab_text"),
                y = function y(e) {
              return 0 !== e;
            },
                w = [{
              name: _("settings.frequency"),
              send: y(a.sample_rate) ? wQ(a.sample_rate, EQ) : bQ,
              receive: y(s.sample_rate) ? wQ(s.sample_rate, function (e) {
                return "".concat(e, " | 24khz");
              }) : bQ
            }, {
              name: _("settings.latency"),
              send: y(a.rtt) ? wQ(a.rtt, xQ) : bQ,
              receive: y(s.rtt) ? wQ(s.rtt, xQ) : bQ
            }, {
              name: _("settings.jitter"),
              send: y(a.jitter) ? wQ(a.jitter, xQ) : bQ,
              receive: y(s.jitter) ? wQ(s.jitter, xQ) : bQ
            }, {
              name: _("settings.packet_loss"),
              send: y(a.max_loss) && y(a.avg_loss) ? d : bQ,
              receive: y(s.max_loss) && y(s.avg_loss) ? u : bQ
            }],
                S = [{
              name: _("settings.latency"),
              send: y(c.rtt) ? wQ(c.rtt, xQ) : bQ,
              receive: y(l.rtt) ? wQ(l.rtt, xQ) : bQ
            }, {
              name: _("settings.jitter"),
              send: y(c.jitter) ? wQ(c.jitter, xQ) : bQ,
              receive: y(l.jitter) ? wQ(l.jitter, xQ) : bQ
            }, {
              name: _("settings.packet_loss"),
              send: y(c.max_loss) && y(c.avg_loss) ? p : bQ,
              receive: y(l.max_loss) && y(l.avg_loss) ? h : bQ
            }, {
              name: _("settings.resolution"),
              send: y(c.width) ? wQ(c.width, function (e) {
                return "".concat(e).concat("\xd7").concat(c.height);
              }) : bQ,
              receive: y(l.width) ? wQ(l.width, function (e) {
                return "".concat(e).concat("\xd7").concat(l.height);
              }) : bQ
            }, {
              name: _("settings.frame_per_second"),
              send: y(c.fps) ? wQ(c.fps, function (e) {
                return "".concat(e, " fps");
              }) : bQ,
              receive: y(l.fps) ? wQ(l.fps, function (e) {
                return "".concat(e, " fps");
              }) : bQ
            }],
                x = w.map(function (e, t) {
              return TH.exports.jsxs(wN, {
                children: [TH.exports.jsx(uN, {
                  className: o.titleCell,
                  children: e.name
                }), TH.exports.jsx(uN, {
                  className: o.dataCell,
                  children: e.send
                }), TH.exports.jsx(uN, {
                  className: o.dataCell,
                  children: e.receive
                })]
              }, t);
            }),
                E = S.map(function (e, t) {
              return TH.exports.jsxs(wN, {
                children: [TH.exports.jsx(uN, {
                  className: o.titleCell,
                  children: e.name
                }), TH.exports.jsx(uN, {
                  className: o.dataCell,
                  children: e.send
                }), TH.exports.jsx(uN, {
                  className: o.dataCell,
                  children: e.receive
                })]
              }, t);
            });

            return TH.exports.jsxs(WA, {
              children: [TH.exports.jsxs(jN, {
                className: o.tabs,
                value: r,
                onChange: function onChange(e, t) {
                  return i(t);
                },
                centered: !0,
                children: [TH.exports.jsx(eN, {
                  className: o.tab,
                  label: v,
                  onClick: function onClick() {
                    return n(!0);
                  }
                }), TH.exports.jsx(eN, {
                  className: o.tab,
                  label: b,
                  onClick: function onClick() {
                    return n(!1);
                  }
                })]
              }), TH.exports.jsxs(iN, {
                className: o.table,
                children: [TH.exports.jsx(fN, {
                  children: TH.exports.jsxs(wN, {
                    children: [TH.exports.jsx(uN, {
                      className: o.titleCell,
                      children: f
                    }), TH.exports.jsx(uN, {
                      className: o.titleCell,
                      children: m
                    }), TH.exports.jsx(uN, {
                      className: o.titleCell,
                      children: g
                    })]
                  })
                }), TH.exports.jsx(lN, {
                  children: t ? x : E
                })]
              })]
            });
          }

          var TQ = Ok(function (e) {
            var _tabs3;

            return {
              panel: {
                height: "500px",
                width: "400px"
              },
              bodyContainer: {
                padding: e.spacing(3)
              },
              tabs: (_tabs3 = {}, _defineProperty(_tabs3, "&.".concat(kH, "-MuiTabs-root"), {
                minHeight: e.spacing(4),
                margin: e.spacing(1, 0),
                borderBottom: "1px solid ".concat(e.palette.action.hover)
              }), _defineProperty(_tabs3, "& .".concat(kH, "-MuiTab-root"), {
                minWidth: 0,
                minHeight: e.spacing(10),
                width: "fit-content",
                padding: e.spacing(0),
                margin: e.spacing(0, 4, 0, 0)
              }), _defineProperty(_tabs3, "& .".concat(kH, "-MuiTabs-indicator"), {
                backgroundColor: "white"
              }), _defineProperty(_tabs3, "& .".concat(kH, "-Mui-focused"), {
                backgroundColor: "white"
              }), _defineProperty(_tabs3, "& .MuiTabs-scrollButtons.Mui-disabled", {
                opacity: .3
              }), _tabs3)
            };
          });

          function OQ(e) {
            return {
              id: "setting-tab-".concat(e),
              "aria-controls": "setting-tabpanel-".concat(e)
            };
          }

          var RQ = function RQ(t) {
            var n = e.useContext(zM),
                _e$useContext87 = e.useContext(JM),
                r = _e$useContext87.isShowSetting,
                i = _e$useContext87.isSupportVB,
                o = _e$useContext87.dispatch,
                _e$useContext88 = e.useContext(jM),
                a = _e$useContext88.isSupportMultipleVideos,
                s = _e$useContext88.isHost,
                c = _e$useContext88.isCoHost,
                l = _e$useContext88.isWebinar,
                d = _e$useContext88.dispatch,
                _e$useState187 = e.useState(mQ.Video),
                _e$useState188 = _slicedToArray(_e$useState187, 2),
                p = _e$useState188[0],
                h = _e$useState188[1],
                _NM35 = NM(),
                _ = _NM35.t,
                f = TQ(),
                m = e.useCallback(function () {
              null == o || o(VB(!1));
            }, [o]),
                g = e.useCallback(function (e, t) {
              h(t);
            }, []);

            e.useEffect(function () {
              a && 0 === JsMediaSDK_Instance.util.AdapterWhiteListCheckForEncoder() && JsMediaSDK_Instance.util.IsSupportVideoEncodeHardwareAcceleration().then(function (e) {
                return null == d ? void 0 : d(function (e) {
                  return {
                    type: LU,
                    payload: e
                  };
                }(e));
              }), JsMediaSDK_Instance.util.IsSupportVideoDecodeHardwareAcceleration().then(function (e) {
                return null == d ? void 0 : d(function (e) {
                  return {
                    type: UU,
                    payload: e
                  };
                }(e));
              });
            }, [d, a]), e.useEffect(function () {
              r && null != n && n.isWebinar() && null != n && n.isAttendee() && h(mQ.Audio);
            }, [r, n]);
            var v = TH.exports.jsxs(WA, {
              className: f.bodyContainer,
              children: [TH.exports.jsxs(jN, {
                className: f.tabs,
                value: p,
                onChange: g,
                "aria-label": "setting tab",
                children: [TH.exports.jsx(eN, u(u({
                  value: mQ.Video
                }, OQ("video")), {}, {
                  label: _("wc_video.video")
                })), TH.exports.jsx(eN, u(u({
                  value: mQ.Audio
                }, OQ("audio")), {}, {
                  label: _("wc_audio")
                })), (s || c) && TH.exports.jsx(eN, u(u({
                  value: mQ.ShareScreen
                }, OQ("share")), {}, {
                  label: _("wc_sharer_entry_button_label1")
                })), i && TH.exports.jsx(eN, u(u({
                  value: mQ.Background
                }, OQ("background")), {}, {
                  label: _("background")
                })), TH.exports.jsx(eN, u(u({
                  value: mQ.Statistics
                }, OQ("statistics")), {}, {
                  label: _("settings.statistics")
                }))]
              }), TH.exports.jsx(GK, {
                value: p,
                type: mQ.Video,
                children: TH.exports.jsx(cQ, {})
              }), TH.exports.jsx(GK, {
                value: p,
                type: mQ.Audio,
                children: TH.exports.jsx(dQ, {})
              }), (s || c) && TH.exports.jsx(GK, {
                value: p,
                type: mQ.ShareScreen,
                children: TH.exports.jsx(fQ, {
                  isWebinar: l
                })
              }), TH.exports.jsx(GK, {
                value: p,
                type: mQ.Background,
                children: TH.exports.jsx(vQ, {})
              }), TH.exports.jsx(GK, {
                value: p,
                type: mQ.Statistics,
                children: TH.exports.jsx(IQ, {})
              })]
            });
            return TH.exports.jsx(XW, u(u({
              title: _("wc_qa.setting_btn_name"),
              open: r,
              onClose: m,
              placement: "right-start",
              className: f.panel
            }, t), {}, {
              children: n.isAttendee() ? TH.exports.jsxs(WA, {
                className: f.bodyContainer,
                children: [TH.exports.jsxs(jN, {
                  className: f.tabs,
                  value: p,
                  onChange: g,
                  "aria-label": "setting tab",
                  children: [TH.exports.jsx(eN, u(u({
                    value: mQ.Audio
                  }, OQ("audio")), {}, {
                    label: _("wc_audio")
                  })), TH.exports.jsx(eN, u(u({
                    value: mQ.Statistics
                  }, OQ("statistics")), {}, {
                    label: _("settings.statistics")
                  }))]
                }), TH.exports.jsx(GK, {
                  value: p,
                  type: mQ.Audio,
                  children: TH.exports.jsx(dQ, {})
                }), TH.exports.jsx(GK, {
                  value: p,
                  type: mQ.Statistics,
                  children: TH.exports.jsx(IQ, {})
                })]
              }) : v
            }));
          };

          var NQ = {},
              PQ = function PQ() {
            var e = document.getSelection();
            if (!e.rangeCount) return function () {};

            for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) {
              n.push(e.getRangeAt(r));
            }

            switch (t.tagName.toUpperCase()) {
              case "INPUT":
              case "TEXTAREA":
                t.blur();
                break;

              default:
                t = null;
            }

            return e.removeAllRanges(), function () {
              "Caret" === e.type && e.removeAllRanges(), e.rangeCount || n.forEach(function (t) {
                e.addRange(t);
              }), t && t.focus();
            };
          },
              jQ = {
            "text/plain": "Text",
            "text/html": "Url",
            default: "Text"
          },
              DQ = function DQ(e, t) {
            var n,
                r,
                i,
                o,
                a,
                s,
                c = !1;
            t || (t = {}), n = t.debug || !1;

            try {
              if (i = PQ(), o = document.createRange(), a = document.getSelection(), (s = document.createElement("span")).textContent = e, s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function (r) {
                if (r.stopPropagation(), t.format) if (r.preventDefault(), void 0 === r.clipboardData) {
                  n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
                  var i = jQ[t.format] || jQ.default;
                  window.clipboardData.setData(i, e);
                } else r.clipboardData.clearData(), r.clipboardData.setData(t.format, e);
                t.onCopy && (r.preventDefault(), t.onCopy(r.clipboardData));
              }), document.body.appendChild(s), o.selectNodeContents(s), a.addRange(o), !document.execCommand("copy")) throw new Error("copy command was unsuccessful");
              c = !0;
            } catch (i) {
              n && console.error("unable to copy using execCommand: ", i), n && console.warn("trying IE specific stuff");

              try {
                window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), c = !0;
              } catch (i) {
                n && console.error("unable to copy using clipboardData: ", i), n && console.error("falling back to prompt"), r = function (e) {
                  var t = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
                  return e.replace(/#{\s*key\s*}/g, t);
                }("message" in t ? t.message : "Copy to clipboard: #{key}, Enter"), window.prompt(r, e);
              }
            } finally {
              a && ("function" == typeof a.removeRange ? a.removeRange(o) : a.removeAllRanges()), s && document.body.removeChild(s), i();
            }

            return c;
          };

          function zQ(e) {
            return zQ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, zQ(e);
          }

          Object.defineProperty(NQ, "__esModule", {
            value: !0
          }), NQ.CopyToClipboard = void 0;
          var MQ = BQ(a.default),
              LQ = BQ(DQ),
              UQ = ["text", "onCopy", "options", "children"];

          function BQ(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          function HQ(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function VQ(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? HQ(Object(n), !0).forEach(function (t) {
                JQ(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HQ(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function qQ(e, t) {
            if (null == e) return {};

            var n,
                r,
                i = function (e, t) {
              if (null == e) return {};
              var n,
                  r,
                  i = {},
                  o = Object.keys(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
              }

              return i;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
              }
            }

            return i;
          }

          function FQ(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }

          function WQ(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          function GQ(e, t) {
            return GQ = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e;
            }, GQ(e, t);
          }

          function KQ(e) {
            var t = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;

              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }();

            return function () {
              var n,
                  r = YQ(e);

              if (t) {
                var i = YQ(this).constructor;
                n = Reflect.construct(r, arguments, i);
              } else n = r.apply(this, arguments);

              return QQ(this, n);
            };
          }

          function QQ(e, t) {
            if (t && ("object" === zQ(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return ZQ(e);
          }

          function ZQ(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }

          function YQ(e) {
            return YQ = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, YQ(e);
          }

          function JQ(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          var $Q = function (e) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), Object.defineProperty(e, "prototype", {
                writable: !1
              }), t && GQ(e, t);
            }(o, e);
            var t,
                n,
                r,
                i = KQ(o);

            function o() {
              var e;
              FQ(this, o);

              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              return JQ(ZQ(e = i.call.apply(i, [this].concat(n))), "onClick", function (t) {
                var n = e.props,
                    r = n.text,
                    i = n.onCopy,
                    o = n.children,
                    a = n.options,
                    s = MQ.default.Children.only(o),
                    c = (0, LQ.default)(r, a);
                i && i(r, c), s && s.props && "function" == typeof s.props.onClick && s.props.onClick(t);
              }), e;
            }

            return t = o, (n = [{
              key: "render",
              value: function value() {
                var e = this.props;
                e.text, e.onCopy, e.options;
                var t = e.children,
                    n = qQ(e, UQ),
                    r = MQ.default.Children.only(t);
                return MQ.default.cloneElement(r, VQ(VQ({}, n), {}, {
                  onClick: this.onClick
                }));
              }
            }]) && WQ(t.prototype, n), r && WQ(t, r), Object.defineProperty(t, "prototype", {
              writable: !1
            }), o;
          }(MQ.default.PureComponent);

          NQ.CopyToClipboard = $Q, JQ($Q, "defaultProps", {
            onCopy: void 0,
            options: void 0
          });
          var XQ = NQ.CopyToClipboard;
          XQ.CopyToClipboard = XQ;
          var eZ,
              tZ = XQ;
          !function (e) {
            e.HYBRID = "HYBRID", e.ONPREM = "ONPREM";
          }(eZ || (eZ = {}));

          var nZ = Ok(function (e) {
            return {
              panel: {
                width: 400
              },
              listWrapper: _defineProperty({
                overflow: "auto",
                padding: e.spacing(0, 3, 6, 3)
              }, "& .".concat(kH, "-MuiListItem-root"), {
                paddingTop: 0,
                paddingBottom: e.spacing(1),
                alignItems: "flex-start"
              }),
              draggableWrapper: {
                cursor: "move",
                display: "inline-flex",
                width: "-webkit-fill-available"
              },
              topic: _defineProperty({
                width: 350,
                fontSize: "16px",
                lineHeight: "22px",
                paddingBottom: e.spacing(3)
              }, "& .".concat(kH, "-MuiListItemText-primary"), {
                fontSize: "16px",
                fontWeight: "bold"
              }),
              label: _defineProperty({
                color: "rgba(255, 255, 255, 0.54)",
                width: "30%"
              }, "& .".concat(kH, "-MuiListItemText-primary"), {
                fontSize: "13px",
                lineHeight: "18px"
              }),
              text: _defineProperty({
                color: "#F5F5F5",
                width: "70%"
              }, "& .".concat(kH, "-MuiListItemText-primary"), {
                fontSize: "13px",
                lineHeight: "18px",
                wordBreak: "break-all"
              }),
              copy: {
                color: "#4F9AF7",
                "&:hover": {
                  cursor: "pointer"
                },
                padding: e.spacing(0, 2),
                margin: 0
              },
              copied: {
                color: "#23D959",
                padding: e.spacing(0, 2)
              }
            };
          }),
              rZ = function rZ(t) {
            var _NM36 = NM(),
                n = _NM36.t,
                r = e.useContext(zM),
                _e$useContext89 = e.useContext(jM),
                i = _e$useContext89.participants,
                _e$useContext90 = e.useContext(JM),
                o = _e$useContext90.isShowMeetingInfo,
                a = _e$useContext90.customization,
                s = _e$useContext90.dispatch,
                c = r.getMeetingInfo(),
                _r$getMeetingOptions = r.getMeetingOptions(),
                l = _r$getMeetingOptions.isEnableCustomizeInviteUrl,
                d = (null == a ? void 0 : a.meetingInfo) || [],
                p = (null == a ? void 0 : a.inviteUrlFormat) || "",
                h = nZ(),
                _ = i.find(function (e) {
              return e.isHost;
            }),
                _ref66 = function (e) {
              var t = "";

              var _NM37 = NM(),
                  n = _NM37.t;

              return (null == e ? void 0 : e.region) === eZ.HYBRID ? t = n("wc_data_center3") : (null == e ? void 0 : e.region) === eZ.ONPREM ? t = n("wc_data_center2") : null !== (null == e ? void 0 : e.region) && "" !== (null == e ? void 0 : e.region) && (t = n("meeting_info_network", {
                network: null == e ? void 0 : e.network,
                dc: null == e ? void 0 : e.region
              })), {
                dcText: t
              };
            }(c),
                f = _ref66.dcText,
                _ref67 = function () {
              var _e$useState189 = e.useState(!1),
                  _e$useState190 = _slicedToArray(_e$useState189, 2),
                  t = _e$useState190[0],
                  n = _e$useState190[1];

              return e.useEffect(function () {
                t && setTimeout(function () {
                  n(!1);
                }, 5e3);
              }, [t]), {
                isCopied: t,
                setIsCopied: n
              };
            }(),
                m = _ref67.isCopied,
                g = _ref67.setIsCopied,
                _ref68 = function (e, t, n, r, i) {
              var _s$split, _s$split2;

              var o = /(?!:\/\/)([a-zA-Z0-9]+\.)?([a-zA-Z0-9]+\.)?([a-zA-Z0-9][a-zA-Z0-9-]+)\.([a-zA-Z]{2,6})\/[j,m]\/([\d,\w]+)\??(pwd=[\w,\d,-]+)?/;
              var a = "",
                  s = "",
                  c = "";
              return t.match(o) ? (s = "https://".concat(null == t ? void 0 : t.match(o)[0]), (_s$split = s.split("?pwd="), _s$split2 = _slicedToArray(_s$split, 2), a = _s$split2[0], c = _s$split2[1], _s$split)) : (a = "https://".concat(e, "/j/").concat(n), s = a), r && i ? (s = c ? r.replace("{0}", n.toString()).replace("{1}", c) : s.replace("{1}", ""), {
                joinURL: s,
                invitePwd: c
              }) : {
                joinURL: s,
                invitePwd: c
              };
            }(c.webEndpoint, c.inviteEmail, c.meetingNumber, p, l),
                v = _ref68.joinURL,
                b = e.useCallback(function () {
              null == s || s(UB(!1));
            }, [s]);

            return TH.exports.jsx(XW, u(u({
              open: o,
              className: h.panel,
              onClose: b
            }, t), {}, {
              children: TH.exports.jsxs(WA, {
                className: h.listWrapper,
                children: [d.includes("topic") && TH.exports.jsx(zT, {
                  disableGutters: !0,
                  children: TH.exports.jsx(VT, {
                    primaryTypographyProps: {
                      variant: "h1",
                      noWrap: !0
                    },
                    className: h.topic,
                    title: c.meetingTopic,
                    children: c.meetingTopic
                  })
                }), d.includes("mn") && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label,
                    children: n("dialog.presscode")
                  }), TH.exports.jsx(VT, {
                    className: h.text,
                    children: c.meetingNumber
                  })]
                }), d.includes("host") && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label,
                    children: n("wc_host_1")
                  }), TH.exports.jsx(VT, {
                    className: h.text,
                    title: null == _ ? void 0 : _.displayName,
                    children: null == _ ? void 0 : _.displayName
                  })]
                }), d.includes("pwd") && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label,
                    children: n("wc_tel_password")
                  }), TH.exports.jsx(VT, {
                    className: h.text,
                    children: null == c ? void 0 : c.password
                  })]
                }), d.includes("telPwd") && (null == c ? void 0 : c.telPwd) && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label,
                    children: n("wc_num_password")
                  }), TH.exports.jsx(VT, {
                    className: h.text,
                    children: null == c ? void 0 : c.telPwd
                  })]
                }), d.includes("invite") && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label,
                    children: n("wc_invite_link")
                  }), TH.exports.jsx(VT, {
                    className: h.text,
                    children: v
                  })]
                }), d.includes("invite") && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label
                  }), TH.exports.jsxs(VT, {
                    className: h.text,
                    children: [!m && TH.exports.jsx(tZ, {
                      text: v || "",
                      children: TH.exports.jsx(AF, {
                        iconType: "icon-copy",
                        className: h.copy,
                        onClick: function onClick() {
                          return g(!0);
                        },
                        children: n("wc_copy_link")
                      })
                    }), m && TH.exports.jsx(AF, {
                      className: h.copied,
                      children: n("wc_copied_to_clipboard")
                    })]
                  })]
                }), d.includes("participant") && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label,
                    children: n("wc_participant_id")
                  }), TH.exports.jsx(VT, {
                    className: h.text,
                    children: c.participantId
                  })]
                }), d.includes("enctype") && TH.exports.jsxs(zT, {
                  disableGutters: !0,
                  children: [TH.exports.jsx(VT, {
                    className: h.label,
                    children: n("wc_encryption")
                  }), TH.exports.jsx(VT, {
                    className: h.text,
                    children: "AES GCM" === c.encryptionType ? n("wc_enable") : n("wc_no")
                  })]
                }), d.includes("dc") && TH.exports.jsx(zT, {
                  disableGutters: !0,
                  children: TH.exports.jsx(VT, {
                    className: h.label,
                    children: f
                  })
                })]
              })
            }));
          };

          var iZ = a.default.createContext({
            dialog: {
              visible: !1
            }
          });

          var oZ = Ok(function (e) {
            return {
              button: {
                border: "1px solid #707070",
                padding: "2px 12px",
                color: "#f5f5f5",
                "&:hover": {
                  color: "#fff"
                }
              },
              wrapPaper: _defineProperty({
                marginTop: 3
              }, "& .".concat(kH, "-MuiList-root"), _defineProperty({
                padding: "0"
              }, "& .".concat(kH, "-MuiListItem-root"), {
                paddingLeft: "16px !important"
              }))
            };
          }),
              aZ = function aZ(t) {
            var _t$user = t.user,
                n = _t$user.userId,
                r = _t$user.displayName,
                i = _t$user.isCoHost,
                o = _t$user.bVideoOn,
                a = _t$user.isHost,
                s = _t$user.strPronoun,
                c = t.isHost,
                l = t.isCoHost,
                d = t.currentUserId,
                u = t.isWebinar,
                p = t.isAttendee,
                h = t.isCCEditor,
                _ = t.onDropdownChange,
                _NM38 = NM(),
                f = _NM38.t,
                _e$useContext91 = e.useContext(JM),
                m = _e$useContext91.isShowSharePronounNotification,
                g = _e$useContext91.dispatch,
                _e$useContext92 = e.useContext(jM),
                v = _e$useContext92.meetingOptions,
                b = _e$useContext92.attendees,
                _e$useContext93 = e.useContext(DM),
                y = _e$useContext93.stream,
                w = e.useContext(zM),
                _e$useContext94 = e.useContext(iZ),
                S = _e$useContext94.setDialog,
                _e$useContext95 = e.useContext($M),
                x = _e$useContext95.ccClient,
                E = e.useRef(null),
                C = oZ(),
                k = b.find(function (e) {
              return (null == e ? void 0 : e.userId) === n;
            }),
                A = e.useCallback(function (e) {
              if ("chat" === e) null == g || g(qB(n)), null == g || g(LB(!0));else if ("startVideo" === e) o ? null == y || y.muteVideo(n) : null == y || y.unmuteVideo(n);else if ("makeHost" === e) null == S || S({
                visible: !0,
                content: f("dialog_make_host", {
                  displayName: r
                }),
                onOk: function onOk() {
                  w.makeHost(n);
                }
              });else if ("makeCoHost" === e) i ? w.revokeCoHost(n) : null == S || S({
                visible: !0,
                content: f("dialog_make_cohost", {
                  displayName: r
                }),
                onOk: function onOk() {
                  w.makeCoHost(n);
                }
              });else if ("rename" === e) null == S || S({
                visible: !0,
                title: f("dialog.rename"),
                content: TH.exports.jsxs(cT, {
                  fullWidth: !0,
                  children: [TH.exports.jsx(kT, {
                    htmlFor: "participant-dialog-new-name",
                    children: f("dialog.newname")
                  }), TH.exports.jsx(ST, {
                    id: "participant-dialog-new-name",
                    defaultValue: r,
                    autoFocus: !0,
                    inputRef: E
                  })]
                }),
                okText: f("dialog.rename"),
                cancelText: f("dialog.btn_cancel"),
                onOk: function onOk() {
                  var e;
                  var t = null === (e = E.current) || void 0 === e ? void 0 : e.value;
                  t && t !== r && w.changeName(t, n);
                }
              });else if ("waitingRoom" === e) w.putOnHold(n);else if ("remove" === e) null == S || S({
                visible: !0,
                content: f("dialog_remove_user", {
                  displayName: r
                }),
                okText: f("wc_remove"),
                onOk: function onOk() {
                  w.removeUser(n);
                }
              });else if ("assignCC" === e) {
                if (h) {
                  var t;

                  var _e304 = null === (t = w.getMeetingHost()) || void 0 === t ? void 0 : t.userId;

                  null == x || x.assignClosedCaptionEditor(_e304);
                } else null == x || x.assignClosedCaptionEditor(n);
              } else "promote" === e ? w.promoteToPanelist(n) : "depromote" === e ? w.changeToAttendee(n) : "allowToTalk" === e ? null == y || y.allowAttendeeToTalk(n, !(null != k && k.isAllowToTalk)) : "changeSharePronoun" === e && (s ? w.shareUserPronoun(!1) : w.shareUserPronoun(!0), m && (null == g || g(iH(!1))));
            }, [g, n, o, y, S, f, r, w, i, h, x, k, s, m]),
                I = [{
              text: f("wc_webinar.promote_to_panelist"),
              onClick: function onClick() {
                A("promote");
              }
            }, {
              text: null != k && k.isAllowToTalk ? f("wc_disable_talking") : f("wc_allow_to_talk"),
              onClick: function onClick() {
                return A("allowToTalk");
              }
            }],
                T = [{
              text: f("wc_chat.chat"),
              onClick: function onClick() {
                A("chat");
              }
            }, {
              text: f(o ? "wc_video.stop_video" : "wc_video.ask_start_video"),
              onClick: function onClick() {
                A("startVideo");
              }
            }],
                O = [{
              items: p ? I : T
            }, {
              items: [c && !p && {
                text: f("wc_make_host"),
                onClick: function onClick() {
                  A("makeHost");
                }
              }, c && !p && v.isCOHostEnabled && {
                text: f(i ? "wc_withdraw_co_host" : "wc_make_co_host"),
                onClick: function onClick() {
                  A("makeCoHost");
                }
              }, (c || l) && !(a || i) && u && !p && {
                text: f("wc_webinar.change_to_attendee"),
                onClick: function onClick() {
                  A("depromote");
                }
              }, c && !p && {
                text: f(h ? "wc_cc_withdraw" : "wc_cc_assign_to"),
                onClick: function onClick() {
                  A("assignCC");
                }
              }, !a && {
                text: f("dialog.rename"),
                onClick: function onClick() {
                  A("rename");
                }
              }, !(i || a) && !p && {
                text: f(u ? "wc_webinar_putonhold" : "wc_put_in_waiting"),
                onClick: function onClick() {
                  A("waitingRoom");
                }
              }].filter(Boolean)
            }, !(i || a) && {
              items: [{
                text: f("wc_remove"),
                onClick: function onClick() {
                  A("remove");
                }
              }]
            }].filter(Boolean),
                R = [w.isAllowToRename() && {
              text: f("dialog.rename"),
              onClick: function onClick() {
                A("rename");
              }
            }, void 0 !== s && s && {
              text: f("wc_unshare_pronoun_menu"),
              onClick: function onClick() {
                A("changeSharePronoun");
              }
            }, void 0 !== s && "" === s && {
              text: f("wc_share_pronoun_menu"),
              onClick: function onClick() {
                A("changeSharePronoun");
              }
            }].filter(Boolean),
                N = [{
              text: f("wc_chat.chat"),
              onClick: function onClick() {
                A("chat");
              }
            }],
                P = d === n ? R : l || c ? O : N;

            return P.length > 0 ? TH.exports.jsx(PF, {
              menu: P,
              className: C.button,
              wrapClassName: C.wrapPaper,
              placement: "bottom-end",
              onOpen: _,
              children: f("wc_more")
            }) : null;
          },
              sZ = Ok(function (e) {
            return {
              root: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              },
              avatarWrap: {
                flexShrink: 0,
                margin: "0 8px 0 4px"
              },
              avatar: {
                display: "flex",
                alignItems: "center",
                width: "32px",
                height: "32px",
                borderRadius: "8px"
              },
              defaultAvatar: _defineProperty({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                background: "rgba(255, 255, 255, 0.09)"
              }, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "20px"
              }),
              name: {
                fontSize: "12px"
              },
              nameSuffix: {
                marginLeft: 3,
                fontSize: "12px",
                flexShrink: 0
              },
              infoWrap: {
                display: "flex",
                alignItems: "center"
              },
              actionWrap: _defineProperty({
                display: "flex",
                alignItems: "center"
              }, "& .".concat(kH, "-MuiButton-label"), {
                whiteSpace: "nowrap"
              }),
              actions: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 0, 0, 2)
                }
              },
              status: {
                display: "flex",
                alignItems: "center"
              },
              admin: {
                fontSize: "12px"
              }
            };
          }),
              cZ = function cZ(t) {
            var n = t.user,
                r = t.currentUserId,
                i = t.style,
                o = t.isCurrentUserGuest,
                a = t.isHost,
                s = t.isCoHost,
                c = t.astAdmin,
                l = t.rmcAdmin,
                d = t.isWebinar,
                u = t.isAttendee,
                p = t.isCCEditor,
                h = t.isCloudRecord,
                _ = n.avatar,
                f = n.muted,
                m = n.audio,
                g = n.bVideoOn,
                v = n.bHold,
                b = n.displayName,
                y = n.bRaiseHand,
                w = n.sharerOn,
                S = n.bLocalRecord,
                x = n.userId,
                E = n.strPronoun,
                C = null == n ? void 0 : n.isNewAst,
                _e$useState191 = e.useState(!1),
                _e$useState192 = _slicedToArray(_e$useState191, 2),
                k = _e$useState192[0],
                A = _e$useState192[1],
                _e$useState193 = e.useState(!1),
                _e$useState194 = _slicedToArray(_e$useState193, 2),
                I = _e$useState194[0],
                T = _e$useState194[1],
                _e$useState195 = e.useState(368),
                _e$useState196 = _slicedToArray(_e$useState195, 2),
                O = _e$useState196[0],
                R = _e$useState196[1],
                N = e.useRef(null),
                P = e.useRef(null),
                j = e.useRef(null),
                _e$useContext96 = e.useContext(DM),
                D = _e$useContext96.stream,
                z = e.useContext(zM),
                M = sZ(),
                _NM39 = NM(),
                L = _NM39.t,
                U = Kz(N),
                B = Mz(_);

            var H = zz(n, r, o);
            var V = c || l || C;
            (c || l || C) && (H = L("wc.rmc_admin_tooltip"));
            var q = e.useCallback(function () {
              n.muted ? null == D || D.unmuteAudio(n.userId) : null == D || D.muteAudio(n.userId);
            }, [D, n]),
                F = e.useCallback(function () {
              y && z.putDownHand(x);
            }, [z, x, y]),
                W = e.useCallback(function () {
              T(!0), z.admit(n.userId);
            }, [z, n]),
                G = e.useCallback(function () {
              z.removeUser(n.userId);
            }, [z, n]),
                K = a || s || r === n.userId;
            e.useLayoutEffect(function () {
              var e, t, n;
              if (V) return;
              var r = (null === (e = N.current) || void 0 === e ? void 0 : e.getBoundingClientRect().width) || 0,
                  i = (null === (t = j.current) || void 0 === t ? void 0 : t.getBoundingClientRect().width) || 0,
                  o = (null === (n = P.current) || void 0 === n ? void 0 : n.getBoundingClientRect().width) || 0;
              R(Math.max(r - i - o - 50, 0));
            }, [U, n, V]);
            var Q = S || (n.isCoHost || n.isHost) && h,
                Z = V ? null : TH.exports.jsxs(WA, {
              className: M.status,
              children: [Q && TH.exports.jsx(CF, {
                type: "icon-recording-text",
                iconStyle: {
                  fontSize: "50px",
                  transform: "translateY(-5px)",
                  margin: "0 3px 0 4px"
                }
              }), w && TH.exports.jsx(CF, {
                type: "icon-share",
                iconStyle: {
                  fontSize: "18px",
                  margin: "0 8px 0 4px"
                }
              }), y && TH.exports.jsx(CF, {
                type: "icon-raise-hand",
                iconStyle: {
                  fontSize: "18px",
                  margin: "0 4px 0 4px"
                }
              }), p && TH.exports.jsx(CF, {
                type: "icon-closed-caption",
                iconStyle: {
                  fontSize: "18px",
                  margin: "0 8px 0 4px"
                }
              }), m && (f ? TH.exports.jsx(CF, {
                type: "icon-audio-muted-outline",
                iconStyle: {
                  fontSize: "18px",
                  marginRight: "5px"
                }
              }) : TH.exports.jsx(CF, {
                type: "icon-audio-outline",
                iconStyle: {
                  fontSize: "18px",
                  marginRight: "5px"
                }
              })), g ? TH.exports.jsx(CF, {
                type: "icon-video-outline",
                iconStyle: {
                  fontSize: "18px",
                  margin: "0 4px 0 4px"
                }
              }) : TH.exports.jsx(CF, {
                type: "icon-video-muted-outline",
                iconStyle: {
                  fontSize: "26px",
                  marginTop: "7px"
                }
              })]
            });
            return TH.exports.jsxs(zT, {
              className: M.root,
              disableGutters: !0,
              style: i,
              ref: N,
              children: [TH.exports.jsxs(WA, {
                className: M.infoWrap,
                children: [TH.exports.jsx(WA, {
                  className: M.avatarWrap,
                  children: B ? TH.exports.jsx(XA, {
                    component: "img",
                    className: M.avatar,
                    image: B,
                    alt: "avatar of user"
                  }) : TH.exports.jsx(WA, {
                    component: "i",
                    className: M.defaultAvatar,
                    children: V ? TH.exports.jsx(CF, {
                      type: "icon-avatar-admin"
                    }) : TH.exports.jsx(CF, {
                      type: "icon-avatar"
                    })
                  })
                }), V && TH.exports.jsx(VN, {
                  title: H,
                  arrow: !0,
                  children: TH.exports.jsx(QA, {
                    className: M.admin,
                    children: b
                  })
                }), !V && b && TH.exports.jsx(QA, {
                  variant: "body1",
                  title: V ? H : b,
                  className: M.name,
                  noWrap: !0,
                  style: {
                    maxWidth: "".concat(O, "px")
                  },
                  children: E ? "".concat(b, " (").concat(E, ")") : b
                }), !V && H && TH.exports.jsx(QA, {
                  variant: "body1",
                  className: M.nameSuffix,
                  ref: P,
                  noWrap: !0,
                  children: H
                })]
              }), TH.exports.jsx("div", {
                className: M.actionWrap,
                ref: j,
                children: v ? I ? TH.exports.jsx(QA, {
                  style: {
                    fontSize: "12px"
                  },
                  children: "".concat(L("wc_joining"), "...")
                }) : TH.exports.jsxs(WA, {
                  className: M.actions,
                  children: [TH.exports.jsx(YA, {
                    onClick: W,
                    variant: "contained",
                    color: "primary",
                    size: "small",
                    children: L("wc_admit")
                  }), TH.exports.jsx(YA, {
                    onClick: G,
                    variant: "outlined",
                    size: "small",
                    children: L("wc_remove")
                  })]
                }) : (U || k) && K && !V ? TH.exports.jsxs(WA, {
                  className: M.actions,
                  children: [m && TH.exports.jsx(YA, {
                    onClick: q,
                    variant: "contained",
                    size: "small",
                    color: "primary",
                    children: L(f ? "toolbar_unmute" : "toolbar_mute")
                  }), r !== n.userId && (a || s) && y && TH.exports.jsx(YA, {
                    onClick: F,
                    variant: "contained",
                    size: "small",
                    color: "primary",
                    children: L("wc_lower_hand")
                  }), TH.exports.jsx(aZ, {
                    user: n,
                    isHost: a,
                    isCoHost: s,
                    currentUserId: r,
                    onDropdownChange: function onDropdownChange(e) {
                      A(e);
                    },
                    isCCEditor: p,
                    isWebinar: d,
                    isAttendee: u
                  })]
                }) : Z
              })]
            });
          },
              lZ = Pk({
            paper: {
              minWidth: 480,
              padding: "16px 8px",
              borderRadius: 12
            }
          })(PI),
              dZ = function dZ(t) {
            var n = t.visible,
                r = t.onClose,
                i = t.onOk,
                o = t.okText,
                a = t.cancelText,
                s = t.title,
                c = t.content,
                _NM40 = NM(),
                l = _NM40.t,
                d = e.useCallback(function () {
              r();
            }, [r]),
                u = e.useCallback(function () {
              null == i || i(), r();
            }, [i, r]);

            return TH.exports.jsxs(lZ, {
              open: n,
              onClose: d,
              "aria-labelledby": "participant-dialog-title",
              "aria-describedby": "participant-dialog-descption",
              maxWidth: "md",
              transitionDuration: 300,
              children: [TH.exports.jsx(HI, {
                id: "participant-dialog-title",
                children: n ? s || l("wc_dlg_confirm") : ""
              }), TH.exports.jsx(MI, {
                children: "string" == typeof c ? TH.exports.jsx(UI, {
                  id: "participant-dialog-descption",
                  children: c
                }) : c
              }), TH.exports.jsxs(DI, {
                children: [TH.exports.jsx(YA, {
                  onClick: u,
                  variant: "contained",
                  color: "primary",
                  size: "small",
                  children: o || l("wc_yes")
                }), TH.exports.jsx(YA, {
                  onClick: d,
                  variant: "outlined",
                  size: "small",
                  children: a || l("wc_no")
                })]
              })]
            });
          };

          var uZ;
          !function (e) {
            e.LOCK = "lock", e.WAITING_ROOM = "waitingRoom", e.START_VIDEO = "startVideo";
          }(uZ || (uZ = {}));

          var pZ = Ok(function (e) {
            return {
              panel: {
                width: "400px",
                boxSizing: "border-box",
                paddingBottom: 12
              },
              clear: _defineProperty({}, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "14px"
              }),
              list: {
                "& .ReactVirtualized__List::-webkit-scrollbar": {
                  width: 4,
                  backgroundColor: "#2a2b2e"
                },
                "& .ReactVirtualized__List::-webkit-scrollbar-thumb": {
                  borderRadius: "100px",
                  "background-color": "#3D3D3D"
                }
              },
              input: {
                "&:after": {
                  border: "none !important"
                },
                "&:before": {
                  border: "none !important"
                }
              },
              sectionHeader: {
                padding: e.spacing(3, 0)
              },
              tabs: _defineProperty({
                minHeight: 24,
                height: 24,
                borderRadius: 8
              }, "& .".concat(kH, "-MuiTabs-indicator"), {
                backgroundColor: "rgba(255, 255, 255, 0.18)",
                height: 22,
                borderRadius: 7,
                top: 1
              }),
              tab: {
                minHeight: 24,
                maxHeight: 24
              },
              footer: {
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
                "& button": {
                  marginLeft: "10px",
                  marginRight: "10px",
                  height: "24px"
                }
              },
              moreButton: {
                color: "#f5f5f5"
              },
              footerButton: {
                whiteSpace: "nowrap"
              }
            };
          }),
              hZ = {
            displayName: "",
            audio: void 0,
            avatar: "",
            bHold: !1,
            bRaiseHand: !1,
            bVideoOn: !1,
            feedback: 0,
            isCoHost: !1,
            isGuest: !1,
            isHost: !1,
            isPhoneUser: !1,
            muted: !1,
            sharePause: !1,
            sharerOn: !1,
            userId: 0,
            sdkKey: "",
            isRaisedHand: !1
          },
              _Z = function _Z(t) {
            var _e$useContext97 = e.useContext(jM),
                n = _e$useContext97.isHost,
                r = _e$useContext97.isWebinar,
                i = _e$useContext97.isOriginHost,
                o = _e$useContext97.isCoHost,
                a = _e$useContext97.userId,
                s = _e$useContext97.participants,
                c = _e$useContext97.assistants,
                l = _e$useContext97.attendees,
                d = _e$useContext97.onHoldParticipants,
                p = _e$useContext97.recordingStatus,
                _e$useState197 = e.useState(!0),
                _e$useState198 = _slicedToArray(_e$useState197, 2),
                h = _e$useState198[0],
                _ = _e$useState198[1],
                _e$useState199 = e.useState(0),
                _e$useState200 = _slicedToArray(_e$useState199, 2),
                f = _e$useState200[0],
                m = _e$useState200[1],
                _e$useContext98 = e.useContext(JM),
                g = _e$useContext98.participantSize,
                v = _e$useContext98.isShowParticipant,
                b = _e$useContext98.dispatch,
                y = e.useContext(zM),
                _e$useContext99 = e.useContext($M),
                w = _e$useContext99.ccClient,
                _zF2 = zF(y, w),
                S = _zF2.ccEditor,
                _e$useState201 = e.useState(""),
                _e$useState202 = _slicedToArray(_e$useState201, 2),
                x = _e$useState202[0],
                E = _e$useState202[1],
                _e$useState203 = e.useState(-1),
                _e$useState204 = _slicedToArray(_e$useState203, 2),
                C = _e$useState204[0],
                k = _e$useState204[1],
                _e$useState205 = e.useState({
              visible: !1
            }),
                _e$useState206 = _slicedToArray(_e$useState205, 2),
                A = _e$useState206[0],
                I = _e$useState206[1],
                _HH2 = HH(),
                T = _HH2.hasAst,
                O = _HH2.hasRmc,
                _NM41 = NM(),
                R = _NM41.t,
                N = pZ(),
                P = e.useRef(null),
                _e$useContext100 = e.useContext(DM),
                j = _e$useContext100.stream,
                D = e.useMemo(function () {
              return s.find(function (e) {
                return e.userId === a;
              });
            }, [a, s]),
                z = e.useMemo(function () {
              var e = [];
              return e = r && !h ? _toConsumableArray(l) : _toConsumableArray(s), c.length > 0 && (e = [].concat(_toConsumableArray(e), _toConsumableArray(c))), T && 0 === c.length ? e.push(u(u({}, hZ), {}, {
                displayName: R("wc.ast_admin_name"),
                astAdmin: !0
              })) : O && e.push(u(u({}, hZ), {}, {
                displayName: R("wc.rmc_admin_name"),
                rmcAdmin: !0
              })), x && "" !== x.trim() && (e = e.filter(function (e) {
                return e.displayName.toUpperCase().indexOf(x.toUpperCase()) > -1;
              })), function (e, t) {
                var n = e.reduce(function (e, n) {
                  return n.userId === (null == t ? void 0 : t.userId) ? e.me.push(n) : n.isHost ? e.host.push(n) : n.isCoHost ? e.coHost.push(n) : n.bRaiseHand ? e.raiseHands.push(n) : e.other.push(n), e;
                }, {
                  me: [],
                  host: [],
                  coHost: [],
                  raiseHands: [],
                  other: []
                });
                return Object.keys(n).reduce(function (e, t) {
                  return e.concat(n[t]);
                }, []);
              }(e, D);
            }, [r, h, T, O, x, D, l, s, c, R]),
                M = e.useCallback(function (e) {
              var t = e.index,
                  i = e.key,
                  s = e.style;
              return TH.exports.jsx(cZ, {
                user: d[t],
                isHost: n,
                isCoHost: o,
                currentUserId: a,
                style: s,
                isCurrentUserGuest: !(null == D || !D.isGuest),
                isWebinar: r,
                isAttendee: !h
              }, i);
            }, [d, a, D, n, o, r, h]),
                L = e.useCallback(function (e) {
              var t, i, s;
              var c = e.index,
                  l = e.key,
                  d = e.style;
              return TH.exports.jsx(cZ, {
                user: z[c],
                isHost: n,
                isCoHost: o,
                currentUserId: a,
                style: d,
                isCurrentUserGuest: !(null == D || !D.isGuest),
                astAdmin: null === (t = z[c]) || void 0 === t ? void 0 : t.astAdmin,
                rmcAdmin: null === (i = z[c]) || void 0 === i ? void 0 : i.rmcAdmin,
                isCCEditor: (null === (s = z[c]) || void 0 === s ? void 0 : s.userId) === (null == S ? void 0 : S.userId),
                isCloudRecord: p === zj.Recording || p === zj.Paused,
                isWebinar: r,
                isAttendee: !h
              }, l);
            }, [z, a, D, n, o, r, p, h, S]),
                U = e.useCallback(function (e) {
              E(e.target.value);
            }, []),
                B = e.useCallback(function () {
              E("");
            }, []),
                H = e.useCallback(function (e) {
              if ("ArrowUp" === e.code || "ArrowLeft" === e.code) {
                var t;
                e.preventDefault();

                var _n102 = C > 0 ? C - 1 : s.length - 1;

                k(_n102), null === (t = P.current) || void 0 === t || t.scrollToRow(_n102);
              } else if ("ArrowDown" === e.code || "ArrowRight" === e.code) {
                var n;
                e.preventDefault();

                var _t157 = C < s.length - 1 ? C + 1 : 0;

                k(_t157), null === (n = P.current) || void 0 === n || n.scrollToRow(_t157);
              }
            }, [C, s]),
                V = 48 * Math.min(d.length, 4),
                q = (n || o) && d.length > 0,
                F = e.useCallback(function () {
              null == b || b(MB(!1));
            }, [b]),
                W = e.useCallback(function () {
              I({
                visible: !1
              });
            }, []),
                G = e.useMemo(function () {
              return {
                dialog: A,
                setDialog: I
              };
            }, [A]),
                K = null == D ? void 0 : D.bRaiseHand,
                Q = e.useCallback(function () {
              y.reclaimHost();
            }, [y]),
                Z = e.useCallback(function () {
              null == j || j.muteAllAudio();
            }, [j]),
                Y = e.useCallback(function () {
              n || o ? y.lowerAllHands() : K ? y.lowerHand() : y.raiseHand();
            }, [y, n, o, K]),
                J = function () {
              var t = e.useContext(zM),
                  _e$useContext101 = e.useContext(DM),
                  n = _e$useContext101.stream,
                  _e$useContext102 = e.useContext(jM),
                  r = _e$useContext102.isWebinar,
                  i = _e$useContext102.isLockedMeeting,
                  o = _e$useContext102.isEnableWaitingRoom,
                  a = _e$useContext102.isEnableStartVideo,
                  _NM42 = NM(),
                  s = _NM42.t,
                  c = e.useCallback(function (e) {
                e === uZ.LOCK ? i ? t.unlockMeeting() : t.lockMeeting() : e === uZ.WAITING_ROOM ? t.enableWaitingRoom(!o) : e === uZ.START_VIDEO && (null == n || n.allowUnmuteVideo(!a));
              }, [t, a, o, i, n]);

              return e.useMemo(function () {
                return [{
                  text: s("wc_lock_meeting"),
                  checked: i,
                  onClick: function onClick() {
                    return c(uZ.LOCK);
                  }
                }, !r && {
                  text: s("security.waiting_room"),
                  checked: o,
                  onClick: function onClick() {
                    return c(uZ.WAITING_ROOM);
                  }
                }, {
                  text: s(r ? "wc_video.allow_panelist_start_video" : "wc_video.allow_participants_start_video"),
                  checked: a,
                  onClick: function onClick() {
                    return c(uZ.START_VIDEO);
                  }
                }].filter(Boolean);
              }, [a, o, i, r, c, s]);
            }();

            return TH.exports.jsxs(XW, u(u({
              open: v,
              title: "".concat(R("wc_participants"), " (").concat(g + l.length + c.length, ")"),
              className: N.panel,
              onClose: F
            }, t), {}, {
              children: [TH.exports.jsxs(iZ.Provider, {
                value: G,
                children: [q && TH.exports.jsxs(TH.exports.Fragment, {
                  children: [TH.exports.jsx(QA, {
                    variant: "h6",
                    className: N.sectionHeader,
                    children: R("wc_waiting_room") + " (".concat(d.length, ")")
                  }), TH.exports.jsx(WA, {
                    tabIndex: 0,
                    className: N.list,
                    role: "listbox",
                    children: TH.exports.jsx(_W, {
                      ref: P,
                      width: 375,
                      height: V,
                      rowCount: d.length,
                      rowHeight: 48,
                      rowRenderer: M
                    })
                  })]
                }), q && TH.exports.jsx(QA, {
                  variant: "h6",
                  className: N.sectionHeader,
                  children: R("wc_in_the_meeting") + " (".concat(s.length, ")")
                }), s.length > 8 && TH.exports.jsx(WA, {
                  children: TH.exports.jsx(vO, {
                    onChange: U,
                    value: x,
                    className: N.input,
                    fullWidth: !0,
                    margin: "dense",
                    startAdornment: TH.exports.jsx(ET, {
                      position: "start",
                      children: TH.exports.jsx(CF, {
                        type: "icon-search",
                        iconStyle: {
                          fontSize: "12px"
                        }
                      })
                    }),
                    endAdornment: TH.exports.jsx(ET, {
                      position: "end",
                      children: TH.exports.jsx(AF, {
                        className: N.clear,
                        "aria-label": "clear input",
                        onClick: B,
                        iconType: "icon-close"
                      })
                    })
                  })
                }), r && TH.exports.jsxs(jN, {
                  className: N.tabs,
                  value: f,
                  onChange: function onChange(e, t) {
                    return m(t);
                  },
                  centered: !0,
                  children: [TH.exports.jsx(eN, {
                    className: N.tab,
                    label: "".concat(R("wc_webinar_panelists"), " (").concat(s.length, ")"),
                    onClick: function onClick() {
                      return _(!0);
                    }
                  }), TH.exports.jsx(eN, {
                    className: N.tab,
                    label: "".concat(R("wc_webinar_attendees"), " (").concat(l.length, ")"),
                    onClick: function onClick() {
                      return _(!1);
                    }
                  })]
                }), TH.exports.jsx(WA, {
                  tabIndex: 0,
                  className: N.list,
                  role: "listbox",
                  "aria-activedescendant": "assigned-candidate-list-".concat(C),
                  onKeyDown: H,
                  "aria-label": "participants list",
                  children: TH.exports.jsx(_W, {
                    ref: P,
                    width: 368,
                    height: 374,
                    rowCount: z.length,
                    rowHeight: 48,
                    rowRenderer: L
                  })
                }), TH.exports.jsxs(WA, {
                  tabIndex: 0,
                  className: N.footer,
                  onKeyDown: H,
                  "aria-label": "participants list footer",
                  children: [!n && !o && TH.exports.jsx(YA, {
                    onClick: Y,
                    className: N.footerButton,
                    children: R(K ? "wc_lower_hand" : "wc_raise_hand")
                  }), (n || o) && !r && TH.exports.jsx(YA, {
                    onClick: Y,
                    className: N.footerButton,
                    children: R("wc_lower_hand")
                  }), (n || o) && TH.exports.jsx(YA, {
                    onClick: Z,
                    className: N.footerButton,
                    children: R("toolbar_muteall")
                  }), !n && i && TH.exports.jsx(YA, {
                    onClick: Q,
                    className: N.footerButton,
                    children: R("wc_reclaim_host")
                  }), (n || o) && TH.exports.jsx(PF, {
                    menu: J,
                    placement: "top",
                    className: N.moreButton,
                    children: R("wc_more")
                  })]
                })]
              }), TH.exports.jsx(dZ, u({
                onClose: W
              }, A))]
            }));
          },
              fZ = Ok(function (e) {
            return {
              contentContainer: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 1)
                }
              },
              title: {
                maxWidth: "60vw",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }
            };
          }),
              mZ = function mZ(t) {
            var n = fZ(),
                _e$useContext103 = e.useContext(jM),
                r = _e$useContext103.onHoldParticipants,
                i = _e$useContext103.isCoHost,
                o = _e$useContext103.isHost,
                _e$useContext104 = e.useContext(JM),
                a = _e$useContext104.isShowParticipant,
                s = _e$useContext104.dispatch,
                c = e.useContext(zM),
                _ref69 = r[0] || {},
                l = _ref69.userId,
                d = _ref69.displayName,
                p = r.length,
                _NM43 = NM(),
                h = _NM43.t,
                _e$useState207 = e.useState(!1),
                _e$useState208 = _slicedToArray(_e$useState207, 2),
                _ = _e$useState208[0],
                f = _e$useState208[1],
                m = e.useCallback(function () {
              c.admit(l), f(!1);
            }, [c, l]);

            return e.useEffect(function () {
              f(!!(p > 0 && (o || i)));
            }, [p, i, o]), a ? TH.exports.jsx("div", {}) : TH.exports.jsx(EW, u(u({
              open: _
            }, t || {}), {}, {
              children: TH.exports.jsx(vK, {
                children: TH.exports.jsxs(WA, {
                  className: n.contentContainer,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    className: n.title,
                    noWrap: !0,
                    children: 1 === p ? h("wait_room_tip1", {
                      displayName: d
                    }) : h("wait_room_tip2", {
                      count: p
                    })
                  }), TH.exports.jsx(YA, {
                    variant: "contained",
                    size: "small",
                    onClick: function onClick() {
                      null == s || s(MB(!0)), f(!1);
                    },
                    children: h("wc_view")
                  }), 1 === p && TH.exports.jsx(YA, {
                    onClick: m,
                    color: "primary",
                    size: "small",
                    variant: "contained",
                    children: h("wc_admit")
                  }), TH.exports.jsx(QW, {
                    iconColorType: GW.White,
                    onClick: function onClick() {
                      return f(!1);
                    }
                  })]
                })
              })
            }));
          };

          var gZ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAnFBMVEUAAABQm/dPmvhTnvxOm/hOmvhPmvdNmvhPmPZOnPdKkPVbku5Pm/hOmvdPm/dOmvZNmvZOnfxPm/dPmfhPmvdRmvhOk/tPmvhPmvdPmvdQmvhPm/dQm/hPmvdPm/dPmvhPmvhPmfhOmvhQmvhOmfdQmvZTm/hTlu9Pm/dQmvdPmvhPmvdPmvhPmvZPmvhPnPlPm/hPm/dPmfZPm/frRnTzAAAANHRSTlMAIEAJf0pxLB0aBgSGY14zFg3AaVg3E/Lp4dzGu6uhmo5tT0Q8IxEP+9SvnpeUeFLMtbKlkXSxIQAAAOtJREFUKM9tkFeOwzAMBZ9kyb333kt6ttz/bhsEXsOwMp8zAEESKxKXzWvdMu5izxy091tzrX+r6iLv0shM01JigDjdz3f1/PeUmfaMFVcuSxtvIsYodti+H+LFIj9efo9VlBoA/uA4YBYN4Mnycgya/+VB6QYItOcAfUDEQM81QisWg5b7sCx8IM9h259ClqEPJdErWQEaamLg6QXKMxLDPQ1g9FyYRZJEBSLuHEOT3ABIw3A4kZ3St1EpVffeYKduHTmOk7553TDo9gEnclRPAgzd8yTdwIZOHEWZiKq58XLYUY8JmVR33vQf/cIOkn0GcfgAAAAASUVORK5CYII=";

          var vZ = ["width", "height", "disableShadow", "disablePadding"],
              bZ = Ok(function (e) {
            return {
              root: function root(t) {
                var n = t.width,
                    r = t.height,
                    i = t.disableShadow,
                    o = t.disablePadding;
                return {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundColor: e.palette.background.default,
                  borderRadius: e.shape.borderRadius,
                  color: e.palette.common.white,
                  boxShadow: i ? "none" : e.shadows[6],
                  padding: o ? e.spacing(0) : e.spacing(1),
                  backdropFilter: "blur(".concat(e.spacing(12), "px)"),
                  width: n ? "".concat(n, "px") : "-webkit-fill-available",
                  height: r ? "".concat(r, "px") : "-webkit-fill-available"
                };
              }
            };
          }),
              yZ = e.forwardRef(function (e, t) {
            var n = e.width,
                r = e.height,
                i = e.disableShadow,
                o = e.disablePadding,
                a = h(e, vZ);
            var s = bZ({
              width: n,
              height: r,
              disableShadow: i,
              disablePadding: o
            });
            return TH.exports.jsx(WA, u({
              ref: t,
              className: s.root
            }, a));
          }),
              wZ = Ok(function (e) {
            return {
              spinner: {
                display: "flex",
                animation: "$spinAnimation 1000ms infinite linear"
              },
              "@keyframes spinAnimation": {
                "0%": {
                  transform: "rotate(0deg)"
                },
                "100%": {
                  transform: "rotate(360deg)"
                }
              },
              typography: {
                paddingTop: e.spacing(5),
                fontSize: "0.875rem",
                width: 200,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                textAlign: "center"
              },
              toolbar: {
                padding: e.spacing(2, 0),
                width: "240px",
                display: "flex",
                margin: "0 auto",
                alignItems: "center",
                justifyContent: "center"
              },
              customImgContainer: {
                width: 368,
                height: 208,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "12px",
                backgroundColor: "#F1F4F6",
                color: "#000000",
                paddingTop: e.spacing(3),
                paddingBottom: e.spacing(3),
                marginTop: e.spacing(5),
                marginBottom: e.spacing(2)
              },
              image: {
                width: 120,
                height: 67.5,
                objectFit: "scale-down"
              },
              descWrapper: function descWrapper(t) {
                return {
                  width: "90%",
                  height: t.hasImage ? "50%" : "80%",
                  textAlign: "center",
                  marginTop: e.spacing(3),
                  overflowY: "auto",
                  scrollbarColor: "#707070 transparent",
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    width: "5px"
                  },
                  "&::-webkit-scrollbar-thumb": {
                    width: "4px",
                    background: "#707070",
                    borderRadius: "5px"
                  }
                };
              },
              leaveBtn: {
                position: "absolute",
                bottom: e.spacing(5)
              },
              topicWrapper: {
                margin: e.spacing(3),
                width: "80%",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                textAlign: "center"
              },
              titleWrapper: {
                margin: e.spacing(3),
                width: "80%",
                textAlign: "center"
              },
              spinnerWrapper: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: e.spacing(2)
              },
              videoContainer: {
                width: 368,
                height: 208,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "12px",
                backgroundColor: e.palette.action.hover,
                marginTop: e.spacing(5),
                marginBottom: e.spacing(2)
              }
            };
          }),
              SZ = function SZ(t) {
            var n, r, i, o;

            var a = t.isJoined,
                s = t.errorStatus,
                c = t.onRetry,
                l = t.setMeetingStart,
                _e$useContext105 = e.useContext(jM),
                d = _e$useContext105.meetingInfo,
                u = null == d || null === (n = d.wrInfo) || void 0 === n ? void 0 : n.desc,
                p = null == d || null === (r = d.wrInfo) || void 0 === r ? void 0 : r.fullLogoUrl,
                h = null == d || null === (i = d.wrInfo) || void 0 === i ? void 0 : i.title,
                _ = null == d || null === (o = d.wrInfo) || void 0 === o ? void 0 : o.videoUrl,
                f = wZ({
              hasImage: !!p
            }),
                m = e.useContext(zM),
                g = e.useRef(0),
                v = e.useRef(null),
                b = 3008 === (null == s ? void 0 : s.errorCode),
                _ref70 = function (t, n, r) {
              var _NM45 = NM(),
                  i = _NM45.t,
                  _e$useContext106 = e.useContext(jM),
                  o = _e$useContext106.status,
                  a = _e$useContext106.isOnHold,
                  _e$useState209 = e.useState(i("meeting_waiting_for_start")),
                  _e$useState210 = _slicedToArray(_e$useState209, 2),
                  s = _e$useState210[0],
                  c = _e$useState210[1];

              return e.useEffect(function () {
                a ? c(r || i("meeting_waiting_room")) : o === jj.Reconnecting ? c("".concat(i("common.connecting"), "...")) : c(i(t ? "meeting_waiting_for_start" : "wc_joining_meeting")), n.errorCode && 3008 === n.errorCode && c(i("meeting_not_start"));
              }, [a, o, t, i, n, r]), {
                displayText: s
              };
            }(a, s, h),
                y = _ref70.displayText,
                _NM44 = NM(),
                w = _NM44.t,
                S = function S() {
              g.current && (clearInterval(g.current), g.current = 0);
            };

            e.useEffect(function () {
              return 3008 === (null == s ? void 0 : s.errorCode) && (g.current = window.setInterval(function () {
                c();
              }, 3e4)), function () {
                S();
              };
            }, [s, c]);
            var x = e.useCallback(function () {
              m.leave();
            }, [m]);
            return _ || p || u ? TH.exports.jsx(kA, {
              children: TH.exports.jsxs(yZ, {
                width: 400,
                height: 483,
                children: [!_ && TH.exports.jsxs("div", {
                  className: f.customImgContainer,
                  children: [p && TH.exports.jsx("img", {
                    className: f.image,
                    src: p
                  }), u && TH.exports.jsx("div", {
                    className: f.descWrapper,
                    children: TH.exports.jsx(QA, {
                      variant: "body1",
                      children: u
                    })
                  })]
                }), _ && TH.exports.jsx("video", {
                  className: f.videoContainer,
                  ref: v,
                  autoPlay: !0,
                  muted: !0,
                  controls: !0,
                  onEnded: function onEnded() {
                    var e;
                    return null === (e = v.current) || void 0 === e ? void 0 : e.play();
                  },
                  children: TH.exports.jsx("source", {
                    src: _,
                    type: "video/mp4"
                  })
                }), TH.exports.jsx("div", {
                  className: f.topicWrapper,
                  children: TH.exports.jsx(QA, {
                    variant: "inherit",
                    children: TH.exports.jsx("b", {
                      children: null == d ? void 0 : d.meetingTopic
                    })
                  })
                }), TH.exports.jsxs("div", {
                  className: f.titleWrapper,
                  children: [TH.exports.jsx("div", {
                    className: f.spinnerWrapper,
                    children: TH.exports.jsx("div", {
                      className: f.spinner,
                      children: TH.exports.jsx("img", {
                        src: gZ
                      })
                    })
                  }), TH.exports.jsx(QA, {
                    variant: "inherit",
                    children: y
                  })]
                }), TH.exports.jsx(YA, {
                  variant: "outlined",
                  onClick: x,
                  className: f.leaveBtn,
                  children: w("wc_leave_meeting")
                })]
              })
            }) : TH.exports.jsxs(kA, {
              children: [TH.exports.jsxs(yZ, {
                width: 240,
                height: 154,
                justifyContent: "center",
                children: [TH.exports.jsx("div", {
                  className: f.spinner,
                  children: TH.exports.jsx("img", {
                    src: gZ
                  })
                }), TH.exports.jsx(QA, {
                  className: f.typography,
                  variant: "body1",
                  noWrap: !0,
                  children: y
                })]
              }), b && TH.exports.jsx(kA, {
                className: f.toolbar,
                children: TH.exports.jsx(AF, {
                  iconType: "icon-leave",
                  onClick: function onClick() {
                    S(), l(!1);
                  },
                  title: w("toolbar_leave")
                })
              })]
            });
          },
              xZ = {
            errorcodes_another_running: "Another meeting running",
            errorcodes_be_removed: "Be removed.",
            errorcodes_denied_email: "Email is blocked by Administrator.",
            errorcodes_panelist_tk: "require tk parameter to join as a panelist",
            errorcodes_denied_register_with_panelist: "Denied register use panelist email.",
            errorcodes_disconnect: "Meeting has been disconnected.",
            errorcodes_email_require: "Email is missing to attend webinar.",
            errorcodes_fail: "Fail to join the meeting.",
            errorcodes_frequent_call: "You have reached the API limit for this call.",
            errorcodes_frequent_join: "You be limit by zoom, need to check recaptcha.",
            errorcodes_login_required: "Require login",
            errorcodes_need_use_zoom_desktop_or_mobile: "Unable join from browser, please join using the Zoom desktop client or mobile app.",
            errorcodes_not_exist: "Meeting does not exist.",
            errorcodes_not_host: "You are not the meeting host.",
            errorcodes_not_init: "Meeting not initialized.",
            errorcodes_not_start: "Meeting has not started",
            errorcodes_not_start_webinar: "Webinar has not started",
            errorcodes_offline: "The service is temporarily offline.",
            errorcodes_pac_api_disabled: "The accounts API Key is deactivated.",
            errorcodes_pac_api_wrong: "The accounts API Key is not valid.",
            errorcodes_pac_cant_host_other_mn: "Cannot not host another meeting concurrently.",
            errorcodes_pac_host_not_found: "The meeting host is not found.",
            errorcodes_pac_invalid_signature: "Signature is invalid.",
            errorcodes_pac_mn_not_fount: "The meeting number is not found.",
            errorcodes_pac_mn_wrong: "The meeting number is wrong.",
            errorcodes_pac_no_permission: "No permission.",
            errorcodes_pac_role_error: "Incorrect role.",
            errorcodes_pac_signature_expired: "The signature has expired.",
            errorcodes_re_connect: "Meeting is reconnecting.",
            errorcodes_register: "This meeting requires registration.",
            errorcodes_rwc_empty: "Could not get a response from the web server.",
            errorcodes_rwc_error: "Could not connect to Web Server error.",
            errorcodes_sign_webinar: "Dont' support sign in webinar",
            errorcodes_success: "Successfully joined the meeting.",
            errorcodes_tk_expired: "Token has expired.",
            errorcodes_update: "You cant join, you need update lastest WebSDK version",
            errorcodes_wasm_fail: "Download wasm files error, please check your network and firewall.",
            errorcodes_web_has_in_progress: "Already has other meetings in progress.",
            errorcodes_web_host_not_exit: "The meeting host does not exist.",
            errorcodes_web_invalid_id: "Invalid meeting ID.",
            errorcodes_web_not_allow_start_webinar_from_web: "Not allow to start webinar from web.",
            errorcodes_web_not_support_registration_webinar: "Not support registration webinar",
            errorcodes_web_not_support_tsp: "Not support start or join meeting from web, when you chose TSP as his audio in a meeting.",
            errorcodes_web_not_support_webclient: "Not support start or join meeting from web.",
            errorcodes_web_not_support_webinar_pac: "Not support webinar and personal audio conference",
            errorcodes_web_require_email: "User email is required.",
            errorcodes_web_should_support_webinar_with_latest_version: "The current sdk version doesn't support webinar, please upgrade to the latest version.",
            errorcodes_wrong_pass: "Meeting Passcode wrong.",
            "apac.rmc.assistant_exist_warning": "You cannot control the meeting because another assistant is controlling this meeting.",
            "apac.websdk_enforce_update_content": "Your app version needs to be {0} or higher to join this meeting. Please update to continue.",
            "apac.invalid_parameter": "Invalid parameter",
            errorcodes_pac_not_allow_assistant: "Assistant join meeting been disabled",
            errorcodes_participant_exist: "participant exist",
            errorcodes_reject_barriers: "reject for information barriers",
            "apac.dialog.meeting_capacity_reached": "Meeting capacity has been reached",
            "apac.dialog.meeting_locked": "The meeting has been locked",
            "apac.dialog.meeting_ended": "The meeting has been ended",
            "apac.websdk_update_content": "Update WebSDK to the latest version to optimize meeting experience",
            errorcodes_need_token: "Join fail because you email no token",
            "apac.dialog.server_error": "The server encountered an internal error and was unable to process your request.",
            errorcodes_not_allow_assistant_join: "dont support assisnt join through widget",
            errorcodes_not_support_registration: "This webinar requires registration."
          };

          function EZ(e, t) {
            return Object.keys(e).find(function (n) {
              return e[n] === t;
            });
          }

          var CZ = function CZ(t) {
            var _NM46 = NM(),
                n = _NM46.t,
                r = t.reason,
                i = Wz(r),
                _e$useContext107 = e.useContext(jM),
                o = _e$useContext107.isWebinar,
                _Nj5 = Nj(),
                a = _Nj5.enqueueSnackbar;

            var s = "error";
            return r !== i && "" !== r && a(function () {
              var e;
              var t = "";

              switch (r) {
                case void 0:
                  return s = "info", o ? "".concat(n("meeting_disconnected"), ": ").concat(n("wc_leave_webinar")) : "".concat(n("meeting_disconnected"), ": ").concat(n("wc_leave_meeting"));

                case "ended by host":
                  return s = "info", n(o ? "dialog.host_end_webinar" : "dialog.host_end_meeting");

                default:
                  t = (null === (e = EZ(xZ, r || "")) || void 0 === e ? void 0 : e.toString()) || "errorcodes_fail";
              }

              return n(t);
            }(), {
              variant: s
            }), TH.exports.jsx("div", {});
          },
              kZ = Rk(PI)(function (e) {
            var _ref71;

            var t = e.theme;
            return _ref71 = {}, _defineProperty(_ref71, "& .".concat(kH, "-MuDialogContent-root"), {
              padding: t.spacing(2)
            }), _defineProperty(_ref71, "& .".concat(kH, "-MuDialogActions-root"), {
              padding: t.spacing(1)
            }), _ref71;
          }),
              AZ = function AZ(e) {
            var t = e.open,
                n = e.handleClose,
                _NM47 = NM(),
                r = _NM47.t;

            return TH.exports.jsxs(kZ, {
              onClose: n,
              "aria-labelledby": "customized-dialog-title",
              open: t,
              children: [TH.exports.jsx(HI, {
                sx: {
                  m: 0,
                  p: 2
                },
                children: TH.exports.jsxs(WA, {
                  children: [r("allow_to_access"), TH.exports.jsx(QW, {
                    onClick: n,
                    style: {
                      position: "absolute",
                      right: 8
                    }
                  })]
                })
              }), TH.exports.jsxs(MI, {
                children: [TH.exports.jsxs(QA, {
                  variant: "body1",
                  gutterBottom: !0,
                  children: ["1. ", r("click_address_bar")]
                }), TH.exports.jsxs(QA, {
                  variant: "body1",
                  gutterBottom: !0,
                  children: ["2. ", r("click_microphone_camera_option")]
                }), TH.exports.jsxs(QA, {
                  variant: "body1",
                  gutterBottom: !0,
                  children: ["3. ", r("select_allow")]
                }), TH.exports.jsx("img", {
                  src: "https://us05st1.zoom.us/static/5.2.1818/image/webclient/chrome-operation.jpg",
                  style: {
                    width: 400,
                    height: "auto"
                  },
                  alt: "permission instruction"
                })]
              })]
            });
          },
              IZ = Ok(function (e) {
            return {
              contentContainer: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 1)
                }
              },
              title: {
                maxWidth: "60vw",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }
            };
          }),
              TZ = function TZ(t) {
            var n = IZ(),
                _e$useContext108 = e.useContext(JM),
                r = _e$useContext108.isShowAudioWarning,
                i = _e$useContext108.isShowVideoWarning,
                o = _e$useContext108.dispatch,
                _NM48 = NM(),
                a = _NM48.t,
                _e$useState211 = e.useState(!1),
                _e$useState212 = _slicedToArray(_e$useState211, 2),
                s = _e$useState212[0],
                c = _e$useState212[1];

            return TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsx(EW, u(u({
                open: r || i
              }, t || {}), {}, {
                children: TH.exports.jsxs(vK, {
                  children: [TH.exports.jsx(CF, {
                    type: "icon-alert"
                  }), TH.exports.jsx(QA, {
                    variant: "body1",
                    className: n.title,
                    noWrap: !0,
                    style: {
                      marginLeft: 8,
                      marginRight: 8
                    },
                    children: a(r && i ? "wc_join_media_preview_warning_denied_both" : r ? "wc_join_media_preview_warning_denied_mic" : "wc_join_media_preview_warning_denied_camera")
                  }), TH.exports.jsx(YA, {
                    onClick: function onClick() {
                      c(!0);
                    },
                    color: "primary",
                    size: "small",
                    variant: "contained",
                    children: TH.exports.jsx(QA, {
                      variant: "body1",
                      className: n.title,
                      noWrap: !0,
                      children: a("wc_learn_more")
                    })
                  })]
                })
              })), TH.exports.jsx(AZ, {
                open: s,
                handleClose: function handleClose() {
                  c(!1);
                }
              })]
            });
          },
              OZ = Ok(function (e) {
            return {
              root: {
                display: "none",
                position: "fixed",
                maxWidth: "80vw",
                top: "2vh",
                left: 0,
                right: 0,
                margin: "0 auto",
                width: "fit-content"
              },
              isShowWarning: {
                display: "block"
              }
            };
          }),
              RZ = function RZ() {
            var _e$useState213 = e.useState(!1),
                _e$useState214 = _slicedToArray(_e$useState213, 2),
                t = _e$useState214[0],
                n = _e$useState214[1],
                _e$useState215 = e.useState(""),
                _e$useState216 = _slicedToArray(_e$useState215, 2),
                r = _e$useState216[0],
                i = _e$useState216[1],
                o = e.useRef(0),
                _e$useContext109 = e.useContext(jM),
                a = _e$useContext109.isAttendee,
                _e$useContext110 = e.useContext(JM),
                s = _e$useContext110.virtualBackgroundPreloadState,
                c = _e$useContext110.isSupportVB,
                l = OZ(),
                _NM49 = NM(),
                d = _NM49.t,
                u = d("settings.vb_init_fail2"),
                p = d("settings.vb_init_10s_tip2");

            return e.useEffect(function () {
              return c && !a && s === YM.Fail && (i(u), n(!0)), c && !a && s === YM.Unknow && (i(p), n(!0)), o.current = window.setTimeout(function () {
                n(!1);
              }, 5e3), function () {
                o.current && (clearTimeout(o.current), o.current = 0);
              };
            }, [u, p, a, c, s]), TH.exports.jsx(WA, {
              className: VC(l.root, _defineProperty({}, l.isShowWarning, t)),
              children: TH.exports.jsx(vK, {
                children: TH.exports.jsx(QA, {
                  variant: "body1",
                  children: r
                })
              })
            });
          },
              NZ = Ok(function (e) {
            return {
              root: {
                border: "0.5px solid rgba(35,35,51,0.2)",
                boxShadow: "0 8px 24px rgba(35,35,51,0.2)",
                borderRadius: e.shape.borderRadius,
                padding: e.spacing(3),
                width: "480px"
              },
              title: {
                marginLeft: "32px",
                marginRight: "32px",
                marginTop: "32px"
              },
              content: {
                margin: "16px 32px"
              },
              buttonGroup: {
                marginLeft: "32px",
                marginRight: "32px",
                marginBottom: "24px",
                display: "flex",
                justifyContent: "flex-end"
              },
              disclaimerLinkWrapper: {
                marginRight: "12px",
                color: "rgba(255, 255, 255, 0.54)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }
            };
          }),
              PZ = function PZ(t) {
            var n, r, i, o, a, s, c, l, d, p, h, _, f, m, g, v, b, y, w, S;

            var x = t.anchorEl,
                E = t.modifiers,
                C = t.placement,
                k = NZ(),
                _e$useContext111 = e.useContext(jM),
                A = _e$useContext111.isCoHost,
                I = _e$useContext111.isHost,
                T = _e$useContext111.isWebinar,
                O = _e$useContext111.recordingStatus,
                R = _e$useContext111.isLocalRecording,
                N = _e$useContext111.meetingInfo,
                P = _e$useContext111.hasPreconsented,
                j = _e$useContext111.isAttendee,
                D = e.useContext(zM),
                _e$useContext112 = e.useContext($M),
                z = _e$useContext112.recordingClient,
                _e$useContext113 = e.useContext(JM),
                M = _e$useContext113.isShowRecordingAlert,
                L = _e$useContext113.hasShowRecordingAlert,
                U = _e$useContext113.isShowPanelistConsent,
                B = _e$useContext113.dispatch,
                _NM50 = NM(),
                H = _NM50.t,
                V = null != N && null !== (n = N.recordingInfo) && void 0 !== n && null !== (r = n.recordingDisclaimer) && void 0 !== r && r.disableDefSection ? "" : H("wc_record_reminder_desc_2", {
              accountOwner: H("account_owner")
            }),
                q = H("wc_recording_title"),
                F = !(null == N || null === (i = N.recordingInfo) || void 0 === i || null === (o = i.recordingDisclaimer) || void 0 === o || !o.disableLeave),
                W = null != N && null !== (a = N.recordingInfo) && void 0 !== a && null !== (s = a.recordingDisclaimerForRecorder) && void 0 !== s && s.linkText ? null == N || null === (c = N.recordingInfo) || void 0 === c || null === (l = c.recordingDisclaimerForRecorder) || void 0 === l ? void 0 : l.linkText : "",
                G = null != N && null !== (d = N.recordingInfo) && void 0 !== d && null !== (p = d.recordingDisclaimerForRecorder) && void 0 !== p && p.linkUrl ? null == N || null === (h = N.recordingInfo) || void 0 === h || null === (_ = h.recordingDisclaimerForRecorder) || void 0 === _ ? void 0 : _.linkUrl : "#",
                K = null != N && null !== (f = N.recordingInfo) && void 0 !== f && null !== (m = f.recordingDisclaimer) && void 0 !== m && m.linkText ? null == N || null === (g = N.recordingInfo) || void 0 === g || null === (v = g.recordingDisclaimer) || void 0 === v ? void 0 : v.linkText : "",
                Q = null != N && null !== (b = N.recordingInfo) && void 0 !== b && null !== (y = b.recordingDisclaimer) && void 0 !== y && y.linkUrl ? null == N || null === (w = N.recordingInfo) || void 0 === w || null === (S = w.recordingDisclaimer) || void 0 === S ? void 0 : S.linkUrl : "#",
                Z = function Z() {
              (I || A) && (null == z || z.startRecording()), null == B || B(YB(!1)), null == B || B({
                type: mB,
                payload: !0
              });
            },
                Y = /*#__PURE__*/function () {
              var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
                return _regeneratorRuntime.wrap(function _callee49$(_context49) {
                  while (1) {
                    switch (_context49.prev = _context49.next) {
                      case 0:
                        if (!(I || A)) {
                          _context49.next = 4;
                          break;
                        }

                        null == B || B(YB(!1));
                        _context49.next = 13;
                        break;

                      case 4:
                        _context49.prev = 4;
                        _context49.next = 7;
                        return D.leave();

                      case 7:
                        null == B || B(YB(!1));
                        _context49.next = 13;
                        break;

                      case 10:
                        _context49.prev = 10;
                        _context49.t0 = _context49["catch"](4);
                        console.log(_context49.t0);

                      case 13:
                      case "end":
                        return _context49.stop();
                    }
                  }
                }, _callee49, null, [[4, 10]]);
              }));

              return function Y() {
                return _ref72.apply(this, arguments);
              };
            }(),
                J = D.getCurrentUserInfo();

            e.useLayoutEffect(function () {
              var e = T && J && !U && !P && !I && !A && !j;

              if (!T || e) {
                var t, n;

                var _e305 = !(null == N || null === (t = N.recordingInfo) || void 0 === t || null === (n = t.recordingDisclaimer) || void 0 === n || !n.isEnableRecordingReminder);

                L || I || A || !_e305 || (O === zj.Recording || R) && (null == B || B(YB(!0)));
              } else e || null == B || B(YB(!1));
            }, [I, A, O, R, L, N, B, T, U, P, j, J]);
            var $ = TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsx(WA, {
                className: VC(k.title),
                children: TH.exports.jsx(QA, {
                  variant: "h1",
                  children: I || A ? null != N && null !== (le = N.recordingInfo) && void 0 !== le && null !== (de = le.recordingDisclaimerForRecorder) && void 0 !== de && de.title ? null == N || null === (ue = N.recordingInfo) || void 0 === ue || null === (pe = ue.recordingDisclaimerForRecorder) || void 0 === pe ? void 0 : pe.title : q : null != N && null !== (se = N.recordingInfo) && void 0 !== se && null !== (ce = se.recordingDisclaimer) && void 0 !== ce && ce.title ? null == N || null === (he = N.recordingInfo) || void 0 === he || null === (_e = he.recordingDisclaimer) || void 0 === _e ? void 0 : _e.title : H(T ? "wc_record_reminder_webinar_title" : "wc_record_reminder_title")
                })
              }), TH.exports.jsxs(WA, {
                className: VC(k.content),
                children: [TH.exports.jsx(QA, {
                  variant: "body2",
                  children: I || A ? null != N && null !== (te = N.recordingInfo) && void 0 !== te && null !== (ne = te.recordingDisclaimerForRecorder) && void 0 !== ne && ne.description ? null == N || null === (re = N.recordingInfo) || void 0 === re || null === (ie = re.recordingDisclaimerForRecorder) || void 0 === ie ? void 0 : ie.description : H("wc_record_host_reminder_desc") : null != N && null !== (X = N.recordingInfo) && void 0 !== X && null !== (ee = X.recordingDisclaimer) && void 0 !== ee && ee.description ? null == N || null === (oe = N.recordingInfo) || void 0 === oe || null === (ae = oe.recordingDisclaimer) || void 0 === ae ? void 0 : ae.description : H(T ? "wc_record_webinar_reminder_desc" : "wc_record_reminder_desc")
                }), TH.exports.jsx("br", {}), !I && !A && TH.exports.jsx(QA, {
                  variant: "body2",
                  children: V
                })]
              }), TH.exports.jsx(WA, {
                className: VC(k.buttonGroup),
                children: I || A ? TH.exports.jsxs(TH.exports.Fragment, {
                  children: [TH.exports.jsx(WA, {
                    className: k.disclaimerLinkWrapper,
                    children: TH.exports.jsx(OT, {
                      href: G,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      variant: "body1",
                      underline: "always",
                      style: {
                        color: "rgba(255, 255, 255, 0.54)"
                      },
                      children: W
                    })
                  }), TH.exports.jsx(vW, {
                    label: H("wc_continue"),
                    labelButtonType: mW.Primary,
                    onClick: Z
                  }), TH.exports.jsx(vW, {
                    label: H("dialog.btn_cancel"),
                    labelButtonType: mW.Border,
                    onClick: Y
                  })]
                }) : TH.exports.jsxs(TH.exports.Fragment, {
                  children: [TH.exports.jsx(WA, {
                    className: k.disclaimerLinkWrapper,
                    children: TH.exports.jsx(OT, {
                      href: Q,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      variant: "body1",
                      underline: "always",
                      style: {
                        color: "rgba(255, 255, 255, 0.54)"
                      },
                      children: K
                    })
                  }), TH.exports.jsx(vW, {
                    label: H("wc_join_media_preview_info_confirm"),
                    labelButtonType: mW.Primary,
                    onClick: Z
                  }), !F && TH.exports.jsx(vW, {
                    label: H("dialog.btn_leaveconf_meeting"),
                    labelButtonType: mW.Border,
                    onClick: Y
                  })]
                })
              })]
            });

            var X, ee, te, ne, re, ie, oe, ae, se, ce, le, de, ue, pe, he, _e;

            return TH.exports.jsx(RR, {
              open: M,
              anchorEl: x,
              modifiers: E,
              placement: C,
              role: "dialog",
              transition: !0,
              children: function children(e) {
                var t = e.TransitionProps;
                return TH.exports.jsx(HA, u(u({}, t), {}, {
                  timeout: 350,
                  children: TH.exports.jsx(kA, {
                    className: VC(k.root),
                    children: $
                  })
                }));
              }
            });
          },
              jZ = Ok(function (e) {
            return {
              panel: {
                width: "480px",
                boxSizing: "border-box",
                padding: e.spacing(2, 4, 3, 4)
              },
              contentContainer: {
                "& > *": {
                  marginTop: e.spacing(5)
                }
              },
              buttonsContainer: {
                display: "flex",
                justifyContent: "right",
                marginBottom: e.spacing(3),
                "& > button": {
                  marginLeft: e.spacing(3)
                }
              }
            };
          }),
              DZ = function DZ(t) {
            var n = jZ(),
                _NM51 = NM(),
                r = _NM51.t,
                i = e.useContext(zM),
                _e$useContext114 = e.useContext(jM),
                o = _e$useContext114.promoteConsent,
                a = _e$useContext114.dispatch,
                _e$useContext115 = e.useContext(JM),
                s = _e$useContext115.isShowPromoteConsent,
                c = _e$useContext115.dispatch,
                _e$useState217 = e.useState(!1),
                _e$useState218 = _slicedToArray(_e$useState217, 2),
                l = _e$useState218[0],
                d = _e$useState218[1],
                p = e.useCallback(function (e) {
              i && null != o && o.reqId && (null == i || i.givePromoteConsent(e, o.reqId), null == a || a(GU({
                reqId: void 0,
                senderId: void 0
              })), null == c || c($B(!1)), d(!1));
            }, [a, c, o.reqId, i]);

            return e.useEffect(function () {
              s && d(!0);
            }, [s]), e.useEffect(function () {
              var e = null;
              return l && p && (e = setTimeout(function () {
                return p(!1);
              }, 25e3)), function () {
                e && clearTimeout(e);
              };
            }, [l, p]), TH.exports.jsxs(XW, u(u({
              className: n.panel,
              open: s,
              noCloseButton: !0
            }, t), {}, {
              children: [TH.exports.jsx(QA, {
                variant: "h1",
                children: r("promote.title")
              }), TH.exports.jsxs(WA, {
                className: n.contentContainer,
                children: [TH.exports.jsx(QA, {
                  variant: "body1",
                  children: r("promote.content_1")
                }), TH.exports.jsx(QA, {
                  variant: "body1",
                  children: r("promote.content_2")
                }), TH.exports.jsxs(WA, {
                  className: n.buttonsContainer,
                  children: [TH.exports.jsx(YA, {
                    onClick: function onClick() {
                      return p(!0);
                    },
                    variant: "contained",
                    color: "primary",
                    size: "small",
                    children: r("promote.ok")
                  }), TH.exports.jsx(YA, {
                    onClick: function onClick() {
                      return p(!1);
                    },
                    variant: "outlined",
                    size: "small",
                    children: r("promote.cancel")
                  })]
                })]
              })]
            }));
          };

          Ok(function (e) {
            return {
              panel: {
                width: "480px",
                boxSizing: "border-box",
                padding: e.spacing(2, 4, 3, 4)
              },
              contentContainer: {
                "& > *": {
                  marginTop: e.spacing(5)
                }
              },
              buttonsContainer: {
                display: "flex",
                justifyContent: "right",
                marginBottom: e.spacing(3),
                "& > button": {
                  marginLeft: e.spacing(3)
                }
              }
            };
          });

          var zZ = Ok(function (e) {
            return {
              contentContainer: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 1)
                }
              },
              title: {
                maxWidth: "60vw",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }
            };
          }),
              MZ = function MZ(t) {
            var n = e.useContext(zM),
                _e$useContext116 = e.useContext(JM),
                r = _e$useContext116.isShowSharePronounNotification,
                i = _e$useContext116.dispatch,
                o = zZ(),
                _NM52 = NM(),
                a = _NM52.t,
                s = e.useCallback(function () {
              n.shareUserPronoun(!0), null == i || i(iH(!1));
            }, [i, n]),
                c = e.useCallback(function () {
              n.shareUserPronoun(!1), null == i || i(iH(!1));
            }, [i, n]),
                l = a("wc_share_pronoun_tip2"),
                d = a("wc_not_share_pronoun"),
                p = a("wc_share_pronoun");

            return TH.exports.jsx(EW, u(u({
              open: r
            }, t || {}), {}, {
              children: TH.exports.jsx(vK, {
                children: TH.exports.jsxs("div", {
                  className: o.contentContainer,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    children: l
                  }), TH.exports.jsx(YA, {
                    variant: "contained",
                    size: "small",
                    onClick: c,
                    children: d
                  }), TH.exports.jsx(YA, {
                    color: "primary",
                    size: "small",
                    variant: "contained",
                    onClick: s,
                    children: p
                  })]
                })
              })
            }));
          },
              LZ = Ok(function (e) {
            return {
              container: {
                display: "flex",
                marginTop: e.spacing(2),
                marginBottom: e.spacing(2)
              },
              answerHeader: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "300px"
              },
              senderInfo: {
                display: "flex",
                width: "200px"
              },
              name: {
                display: "flex",
                color: "rgba(255,255,255,0.54)",
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                alignItems: "center"
              },
              timestamp: {
                display: "flex",
                color: "rgba(255,255,255,0.34)",
                fontSize: "13px",
                marginLeft: "5px",
                whiteSpace: "nowrap",
                alignItems: "center"
              },
              senderWraper: {
                display: "flex",
                alignItems: "center"
              },
              avatarWrap: {
                flexShrink: 0,
                margin: "0 8px 0 4px"
              },
              defaultAvatar: _defineProperty({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                background: "rgba(255, 255, 255, 0.09)"
              }, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "20px"
              }),
              privateAnswer: {
                color: "#FF742E",
                fontSize: "10px"
              },
              deleteButtonPlaceholder: {
                width: "28px",
                height: "26px"
              }
            };
          }),
              UZ = function UZ(t) {
            var _e$useState219 = e.useState(!1),
                _e$useState220 = _slicedToArray(_e$useState219, 2),
                n = _e$useState220[0],
                r = _e$useState220[1],
                i = t.answer,
                o = t.questionId,
                _e$useContext117 = e.useContext(jM),
                a = _e$useContext117.isHost,
                s = _e$useContext117.isCoHost,
                _e$useContext118 = e.useContext($M),
                c = _e$useContext118.qaClient,
                _NM53 = NM(),
                l = _NM53.t,
                d = i.displayName,
                u = i.time,
                p = i.text,
                h = i.privately,
                _ = i.id,
                f = e.useCallback(function () {
              r(!0);
            }, []),
                m = e.useCallback(function () {
              r(!1);
            }, []),
                g = e.useCallback(function () {
              null == c || c.deleteComment(o, _);
            }, [_, c, o]),
                v = LZ();

            return TH.exports.jsxs("div", {
              className: v.container,
              onMouseOver: f,
              onMouseLeave: m,
              children: [TH.exports.jsx("div", {
                className: v.avatarWrap,
                children: TH.exports.jsx("div", {
                  className: v.defaultAvatar,
                  children: TH.exports.jsx(CF, {
                    type: "icon-avatar"
                  })
                })
              }), TH.exports.jsxs("div", {
                children: [TH.exports.jsxs("div", {
                  className: v.answerHeader,
                  children: [TH.exports.jsxs("div", {
                    className: v.senderWraper,
                    children: [TH.exports.jsx(QA, {
                      variant: "body1",
                      className: v.name,
                      children: TH.exports.jsx("b", {
                        children: d
                      })
                    }), TH.exports.jsx(QA, {
                      variant: "body1",
                      className: v.timestamp,
                      children: new Date(1e3 * u).toLocaleTimeString()
                    })]
                  }), n && (a || s) ? TH.exports.jsx(AF, {
                    iconType: "icon-delete",
                    onClick: g
                  }) : TH.exports.jsx("div", {
                    className: v.deleteButtonPlaceholder
                  })]
                }), h && TH.exports.jsx("div", {
                  children: TH.exports.jsx(QA, {
                    variant: "body1",
                    className: v.privateAnswer,
                    children: l("wc_qa.answer_private_type")
                  })
                }), TH.exports.jsx("div", {
                  children: TH.exports.jsx(QA, {
                    variant: "body1",
                    children: p
                  })
                })]
              })]
            });
          },
              BZ = Ok(function (e) {
            var _textarea2;

            return {
              container: {
                margin: e.spacing(2),
                borderTop: "1px solid ".concat(e.palette.action.active)
              },
              contentHeader: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: e.spacing(2)
              },
              senderInfo: {
                display: "flex",
                width: "300px"
              },
              name: {
                display: "flex",
                color: "rgba(255,255,255,0.54)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                alignItems: "center"
              },
              timestamp: {
                display: "flex",
                color: "rgba(255,255,255,0.34)",
                fontSize: "13px",
                marginLeft: "5px",
                whiteSpace: "nowrap",
                alignItems: "center"
              },
              dissmissButton: {
                height: "20px",
                color: "rgba(255,255,255,0.54)"
              },
              liveAnswerNotice: {
                display: "flex",
                alignItems: "center",
                margin: 0,
                marginTop: e.spacing(2),
                marginBottom: e.spacing(2),
                color: "rgba(255,255,255,0.54)"
              },
              showAllButton: {
                height: "20px",
                color: "rgba(255,255,255,0.54)"
              },
              contentFooter: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              },
              footerButton: {
                color: "rgba(255,255,255,0.54)",
                height: "30px",
                padding: e.spacing(1),
                marginLeft: e.spacing(2)
              },
              textarea: (_textarea2 = {}, _defineProperty(_textarea2, "& .".concat(kH, "-MuiInput-underline:after"), {
                border: "none !important"
              }), _defineProperty(_textarea2, "& .".concat(kH, "-MuiInput-underline:before"), {
                border: "none !important"
              }), _defineProperty(_textarea2, "& textarea", {
                fontSize: "13px",
                scrollbarColor: "#707070 #282828",
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "8px"
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: "100px"
                }
              }), _defineProperty(_textarea2, "& textarea::placeholder", {
                fontSize: "13px"
              }), _defineProperty(_textarea2, "padding", e.spacing(1)), _textarea2),
              fullModeControlWrapper: {
                display: "flex",
                alignContent: "center",
                justifyContent: "space-between",
                marginTop: e.spacing(1)
              },
              inputBoxWrapper: {
                border: "1px solid ".concat(e.palette.action.hover),
                borderRadius: e.shape.borderRadius,
                padding: e.spacing(1)
              },
              upvote: {
                padding: "0 2px",
                minWidth: "25px"
              },
              upvoteText: {
                color: "rgba(255,255,255,0.54)"
              },
              checkbox: {
                "&&:hover": {
                  backgroundColor: "transparent"
                }
              }
            };
          }),
              HZ = function HZ(t) {
            var _e$useState221 = e.useState(!1),
                _e$useState222 = _slicedToArray(_e$useState221, 2),
                n = _e$useState222[0],
                r = _e$useState222[1],
                _e$useState223 = e.useState(!1),
                _e$useState224 = _slicedToArray(_e$useState223, 2),
                i = _e$useState224[0],
                o = _e$useState224[1],
                _e$useState225 = e.useState(!1),
                _e$useState226 = _slicedToArray(_e$useState225, 2),
                a = _e$useState226[0],
                s = _e$useState226[1],
                c = t.style,
                l = t.index,
                d = t.questionData,
                u = t.qaSetting,
                p = t.currentTypingIndex,
                h = t.currentMessage,
                _ = t.currentChecked,
                f = t.handleInput,
                m = t.handleChecked,
                g = t.handleRowTouched,
                v = t.hasAnswered,
                b = t.measure,
                y = BZ(),
                _NM54 = NM(),
                w = _NM54.t,
                _e$useContext119 = e.useContext(jM),
                S = _e$useContext119.isHost,
                x = _e$useContext119.isCoHost,
                E = _e$useContext119.isAttendee,
                _e$useContext120 = e.useContext($M),
                C = _e$useContext120.qaClient,
                _e$useState227 = e.useState(h),
                _e$useState228 = _slicedToArray(_e$useState227, 2),
                k = _e$useState228[0],
                A = _e$useState228[1],
                _e$useState229 = e.useState(_),
                _e$useState230 = _slicedToArray(_e$useState229, 2),
                I = _e$useState230[0],
                T = _e$useState230[1],
                _e$useState231 = e.useState([]),
                _e$useState232 = _slicedToArray(_e$useState231, 2),
                O = _e$useState232[0],
                R = _e$useState232[1],
                N = d.liveAnswerStatus,
                P = d.voteCount,
                j = d.time,
                D = d.id,
                z = d.voted,
                M = d.displayName,
                L = d.text,
                U = d.dismissed,
                B = d.answers,
                H = d.isAnonymous,
                V = new Date(1e3 * j).toLocaleTimeString(),
                q = H ? w("wc_qa.anonymous_attendee") : M,
                F = w(E ? "wc_qa.button_comment" : "wc_qa.button_display_answer");

            e.useEffect(function () {
              d.answers ? d.answers.length > 2 ? (s(!0), R([])) : (s(!1), R(_toConsumableArray(d.answers))) : (s(!1), R([])), o(!1);
            }, [d]), e.useEffect(function () {
              b();
            }, [b, u, O, i, n, d]), e.useEffect(function () {
              p !== l && r(!1);
            }, [p, l]), e.useEffect(function () {
              f(k);
            }, [k, f]), e.useEffect(function () {
              m(I);
            }, [m, I]), e.useEffect(function () {
              p === l && (A(h), T(_));
            }, [h, _, p, l]);
            var W = e.useCallback(function () {
              i ? d.answers && R([]) : d.answers && R(_toConsumableArray(d.answers)), o(!i);
            }, [i, d]),
                G = e.useCallback(function () {
              g(l), r(!0);
            }, [g, l]),
                K = e.useCallback(function (e) {
              A(e.target.value);
            }, []),
                Q = e.useCallback(function () {
              T(!I);
            }, [I]),
                Z = e.useCallback(function () {
              A(""), T(!1), r(!1), g(-1);
            }, [g]),
                Y = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
              return _regeneratorRuntime.wrap(function _callee50$(_context50) {
                while (1) {
                  switch (_context50.prev = _context50.next) {
                    case 0:
                      A("");
                      T(!1);
                      g(l);
                      r(!1);

                      if (!E) {
                        _context50.next = 9;
                        break;
                      }

                      _context50.next = 7;
                      return null == C ? void 0 : C.commentQuestion(D, k);

                    case 7:
                      _context50.next = 11;
                      break;

                    case 9:
                      _context50.next = 11;
                      return null == C ? void 0 : C.answerQuestion(D, k, I);

                    case 11:
                    case "end":
                      return _context50.stop();
                  }
                }
              }, _callee50);
            })), [k, g, l, I, D, C, E]),
                J = e.useCallback(function () {
              g(l), f(k), m(I);
            }, [k, m, f, g, l, I]),
                $ = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
              return _regeneratorRuntime.wrap(function _callee51$(_context51) {
                while (1) {
                  switch (_context51.prev = _context51.next) {
                    case 0:
                      _context51.t0 = U;

                      if (_context51.t0) {
                        _context51.next = 4;
                        break;
                      }

                      _context51.next = 4;
                      return null == C ? void 0 : C.upvoteQuestion(D, !z);

                    case 4:
                    case "end":
                      return _context51.stop();
                  }
                }
              }, _callee51);
            })), [U, C, D, z]),
                X = e.useCallback(function () {
              null == C || C.reopenQuestion(D);
            }, [C, D]),
                ee = e.useCallback(function () {
              void 0 === N ? null == C || C.answerLive(D) : N === ds.LiveStart && (null == C || C.answerLive(D, !0));
            }, [N, C, D]),
                te = e.useCallback(function (e) {
              "delete" === e && (null == C || C.deleteQuestion(D)), "dismiss" === e && (null == C || C.dismissQuestion(D));
            }, [C, D]),
                ne = e.useMemo(function () {
              return [!U && {
                text: w("wc_qa.dissmis_tips"),
                onClick: function onClick() {
                  return te("dismiss");
                }
              }, {
                text: w("delete"),
                onClick: function onClick() {
                  return te("delete");
                }
              }].filter(Boolean);
            }, [U, te, w]);
            return TH.exports.jsx("div", {
              style: c,
              children: TH.exports.jsxs("div", {
                className: y.container,
                children: [TH.exports.jsxs("div", {
                  className: y.contentHeader,
                  children: [TH.exports.jsxs("div", {
                    className: y.senderInfo,
                    children: [TH.exports.jsx("div", {
                      className: y.name,
                      children: TH.exports.jsx(QA, {
                        variant: "body1",
                        children: TH.exports.jsx("b", {
                          children: q
                        })
                      })
                    }), TH.exports.jsx("div", {
                      className: y.timestamp,
                      children: TH.exports.jsx(QA, {
                        variant: "body1",
                        children: V
                      })
                    })]
                  }), E ? TH.exports.jsx("div", {}) : TH.exports.jsx(PF, {
                    iconType: "icon-more",
                    menu: ne
                  })]
                }), TH.exports.jsx(QA, {
                  variant: "body1",
                  children: L
                }), N === ds.LiveStart && TH.exports.jsxs("div", {
                  className: y.liveAnswerNotice,
                  children: [TH.exports.jsx(CF, {
                    type: "icon-audio-outline",
                    iconStyle: {
                      transform: "scale(0.5)"
                    }
                  }), TH.exports.jsx(QA, {
                    variant: "body1",
                    children: w("wc_qa.live_tips_start")
                  })]
                }), N === ds.LiveEnd && TH.exports.jsxs("div", {
                  className: y.liveAnswerNotice,
                  children: [TH.exports.jsx(CF, {
                    type: "icon-audio-outline",
                    iconStyle: {
                      transform: "scale(0.5)"
                    }
                  }), TH.exports.jsx(QA, {
                    variant: "body1",
                    children: w("wc_qa.live_tips_done")
                  })]
                }), a && TH.exports.jsx(YA, {
                  className: y.showAllButton,
                  onClick: W,
                  children: i ? TH.exports.jsxs(TH.exports.Fragment, {
                    children: [TH.exports.jsx(QA, {
                      variant: "body1",
                      children: "".concat(w("wc_qa.collapse_all_answer"), " (").concat(null == B ? void 0 : B.length, ")")
                    }), TH.exports.jsx(CF, {
                      type: "icon-arrow-up",
                      iconStyle: {
                        transform: "scale(0.4)"
                      }
                    })]
                  }) : TH.exports.jsxs(TH.exports.Fragment, {
                    children: [TH.exports.jsx(QA, {
                      variant: "body1",
                      children: "".concat(w("wc_qa.display_all_answer"), " (").concat(null == B ? void 0 : B.length, ")")
                    }), TH.exports.jsx(CF, {
                      type: "icon-arrow-down",
                      iconStyle: {
                        transform: "scale(0.4)"
                      }
                    })]
                  })
                }), B && TH.exports.jsx("div", {
                  children: O.map(function (e, t) {
                    return TH.exports.jsx(UZ, {
                      answer: e,
                      questionId: D
                    }, e.id);
                  })
                }), !n && TH.exports.jsxs("div", {
                  className: y.contentFooter,
                  children: [u.allowAttendeeVote ? TH.exports.jsxs(YA, {
                    className: y.upvote,
                    onClick: $,
                    children: [TH.exports.jsx(CF, {
                      type: "icon-upvote",
                      iconStyle: {
                        transform: "scale(0.7)"
                      }
                    }), TH.exports.jsx(QA, {
                      variant: "body1",
                      className: y.upvoteText,
                      children: P || " "
                    })]
                  }) : TH.exports.jsx("div", {}), !E || u.allowAttendeeComment ? TH.exports.jsxs("div", {
                    children: [!E && !v && !U && TH.exports.jsxs(YA, {
                      variant: "outlined",
                      className: y.footerButton,
                      onClick: ee,
                      children: [N === ds.LiveStart && w("wc_qa.button_live_done"), !N && w("wc_qa.button_live")]
                    }), (E || !U && N !== ds.LiveStart) && TH.exports.jsx(YA, {
                      variant: "outlined",
                      className: y.footerButton,
                      onClick: G,
                      children: F
                    }), !E && U && TH.exports.jsx(YA, {
                      variant: "outlined",
                      className: y.footerButton,
                      onClick: X,
                      children: w("wc_qa.button_reopen")
                    })]
                  }) : TH.exports.jsx("div", {})]
                }), n && TH.exports.jsx("div", {
                  children: TH.exports.jsxs("div", {
                    className: y.inputBoxWrapper,
                    children: [TH.exports.jsx(MN, {
                      rows: 4,
                      className: y.textarea,
                      fullWidth: !0,
                      multiline: !0,
                      onChange: K,
                      value: k,
                      placeholder: w("wc_chat.type_msg"),
                      onFocus: J
                    }), TH.exports.jsxs("div", {
                      className: y.fullModeControlWrapper,
                      children: [E ? TH.exports.jsx("div", {}) : TH.exports.jsx(dT, {
                        control: TH.exports.jsx(hI, {
                          checked: I,
                          name: "checkedIsPrivate",
                          color: "primary",
                          size: "small",
                          onChange: Q,
                          className: y.checkbox
                        }),
                        label: TH.exports.jsx(QA, {
                          variant: "body1",
                          noWrap: !0,
                          children: w("wc_qa.is_privately")
                        })
                      }), TH.exports.jsxs("div", {
                        children: [TH.exports.jsx(YA, {
                          onClick: Z,
                          children: w("common.cancel")
                        }), TH.exports.jsx(YA, {
                          onClick: Y,
                          disabled: "" === k,
                          children: w("wc_qa.send")
                        })]
                      })]
                    })]
                  })
                })]
              })
            });
          };

          function VZ() {
            var _e$useState233 = e.useState(""),
                _e$useState234 = _slicedToArray(_e$useState233, 2),
                t = _e$useState234[0],
                n = _e$useState234[1],
                _e$useState235 = e.useState(!1),
                _e$useState236 = _slicedToArray(_e$useState235, 2),
                r = _e$useState236[0],
                i = _e$useState236[1],
                _e$useState237 = e.useState(-1),
                _e$useState238 = _slicedToArray(_e$useState237, 2),
                o = _e$useState238[0],
                a = _e$useState238[1];

            return {
              currentTypingRowIndex: o,
              currentMessage: t,
              currentChecked: r,
              handleRowInput: e.useCallback(function (e) {
                n(e);
              }, []),
              handleChecked: e.useCallback(function (e) {
                i(e);
              }, []),
              handleRowTouched: e.useCallback(function (e) {
                a(e);
              }, [])
            };
          }

          var qZ = {
            allowAnonymousQuestion: !1,
            allowAttendeeViewAllQuestion: !1,
            allowAttendeeVote: !1,
            allowAttendeeComment: !1
          };

          function FZ(t, n) {
            var _e$useState239 = e.useState([]),
                _e$useState240 = _slicedToArray(_e$useState239, 2),
                r = _e$useState240[0],
                i = _e$useState240[1],
                _e$useContext121 = e.useContext(JM),
                o = _e$useContext121.isSortMostUpVote,
                a = _e$useContext121.dispatch,
                s = e.useCallback(function (e) {
              if (n) {
                var _e306 = n.getQuestionsList();

                var _t158;

                _t158 = o ? _e306.sort(function (e, t) {
                  return void 0 !== e.voteCount && void 0 !== t.voteCount ? e.voteCount > t.voteCount ? -1 : e.voteCount < t.voteCount ? 1 : e.time - t.time : void 0 !== e.voteCount && void 0 === t.voteCount ? -1 : void 0 === e.voteCount && void 0 !== t.voteCount ? 1 : e.time - t.time;
                }) : _toConsumableArray(_e306);

                var _r71 = _e306.filter(function (e) {
                  var t = !1;
                  return e.answers && e.answers.length > 0 && (t = e.answers.reduce(function (e, t) {
                    return e || !!t.isFromHostOrPanelist;
                  }, !1)), e.liveAnswerStatus !== ds.LiveEnd && !t && !e.dismissed;
                });

                null == a || a(function (e) {
                  return {
                    type: RB,
                    payload: e
                  };
                }(_r71.length)), i(_toConsumableArray(_t158));
              }
            }, [a, n, o]);

            return e.useEffect(function () {
              if (n) {
                var _e307 = n.getQuestionsList();

                if (o) {
                  var _t159 = _e307.sort(function (e, t) {
                    return void 0 !== e.voteCount && void 0 !== t.voteCount ? e.voteCount > t.voteCount ? -1 : e.voteCount < t.voteCount ? 1 : e.time - t.time : void 0 !== e.voteCount && void 0 === t.voteCount ? -1 : void 0 === e.voteCount && void 0 !== t.voteCount ? 1 : e.time - t.time;
                  });

                  i(_toConsumableArray(_t159));
                } else i(_toConsumableArray(_e307));
              }
            }, [o, n]), e.useEffect(function () {
              return t.on("qa-action-change", s), function () {
                t.off("qa-action-change", s);
              };
            }, [t, s]), {
              questions: r
            };
          }

          var WZ, GZ;

          function KZ() {
            var _e$useContext122 = e.useContext(JM),
                t = _e$useContext122.isSortMostUpVote,
                n = _e$useContext122.dispatch,
                _NM55 = NM(),
                r = _NM55.t,
                i = e.useCallback(function (e) {
              e === WZ.MOST_RECENT ? null == n || n(cH(!1)) : e === WZ.MOST_UPVOTE && (null == n || n(cH(!0)));
            }, [n]);

            return e.useMemo(function () {
              return [{
                text: r("wc_qa.most_recent"),
                checked: !t,
                onClick: function onClick() {
                  return i(WZ.MOST_RECENT);
                }
              }, {
                text: r("wc_qa.most_upvotes"),
                checked: t,
                onClick: function onClick() {
                  return i(WZ.MOST_UPVOTE);
                }
              }];
            }, [t, i, r]);
          }

          !function (e) {
            e.MOST_RECENT = "mostRecent", e.MOST_UPVOTE = "mostUpvote";
          }(WZ || (WZ = {})), function (e) {
            e.OPEN = "open", e.ANSWERED = "answered", e.DISMISSED = "dismissed";
          }(GZ || (GZ = {}));

          var QZ = Ok(function (e) {
            return {
              tabs: _defineProperty({
                marginTop: 16,
                minHeight: 24,
                height: 24,
                borderRadius: 8
              }, "& .".concat(kH, "-MuiTabs-indicator"), {
                backgroundColor: "rgba(255, 255, 255, 0.18)",
                height: 22,
                borderRadius: 7,
                top: 1
              }),
              tab: {
                minHeight: 24,
                maxHeight: 24,
                minWidth: 110
              },
              questionList: function questionList(t) {
                return {
                  height: t.isShowSortButton ? "400px" : "430px",
                  marginTop: e.spacing(2),
                  scrollbarColor: "#707070 #282828",
                  scrollbarWidth: "thin",
                  "& .ReactVirtualized__List::-webkit-scrollbar": {
                    width: "8px"
                  },
                  "& .ReactVirtualized__List::-webkit-scrollbar-thumb": {
                    backgroundColor: "#707070",
                    borderRadius: "100px"
                  }
                };
              },
              emptyPanelText: {
                color: "rgba(255,255,255,0.54)"
              },
              noQuestionPlaceholder: function noQuestionPlaceholder(e) {
                return {
                  height: e.isShowSortButton ? "400px" : "430px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: "0 60px",
                  textAlign: "center"
                };
              },
              sortButtonContainer: {
                display: "flex",
                margin: e.spacing(2),
                alignContent: "center",
                justifyContent: "flex-end"
              },
              sortButton: {
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row"
              }
            };
          }),
              ZZ = function ZZ(t) {
            var n = t.questions,
                r = t.qaSetting,
                _e$useState241 = e.useState(0),
                _e$useState242 = _slicedToArray(_e$useState241, 2),
                i = _e$useState242[0],
                o = _e$useState242[1],
                _e$useState243 = e.useState(GZ.OPEN),
                _e$useState244 = _slicedToArray(_e$useState243, 2),
                a = _e$useState244[0],
                s = _e$useState244[1],
                _e$useState245 = e.useState([]),
                _e$useState246 = _slicedToArray(_e$useState245, 2),
                c = _e$useState246[0],
                l = _e$useState246[1],
                _e$useState247 = e.useState("0"),
                _e$useState248 = _slicedToArray(_e$useState247, 2),
                d = _e$useState248[0],
                u = _e$useState248[1],
                _e$useState249 = e.useState("0"),
                _e$useState250 = _slicedToArray(_e$useState249, 2),
                p = _e$useState250[0],
                h = _e$useState250[1],
                _e$useState251 = e.useState("0"),
                _e$useState252 = _slicedToArray(_e$useState251, 2),
                _ = _e$useState252[0],
                f = _e$useState252[1],
                _e$useContext123 = e.useContext(JM),
                m = _e$useContext123.isSortMostUpVote,
                g = e.useRef(new TK({
              defaultHeight: 60,
              fixedWidth: !0
            })),
                v = e.useRef(null),
                _VZ = VZ(),
                b = _VZ.currentTypingRowIndex,
                y = _VZ.currentMessage,
                w = _VZ.currentChecked,
                S = _VZ.handleRowInput,
                x = _VZ.handleChecked,
                E = _VZ.handleRowTouched,
                _NM56 = NM(),
                C = _NM56.t,
                k = KZ(),
                A = r.allowAttendeeViewAllQuestion,
                I = QZ({
              isShowSortButton: !(null == r || !r.allowAttendeeVote)
            });

            e.useLayoutEffect(function () {
              var e = n.filter(function (e) {
                var t = !1;
                return e.answers && e.answers.length > 0 && (t = e.answers.reduce(function (e, t) {
                  return e || !!t.isFromHostOrPanelist;
                }, !1)), e.liveAnswerStatus !== ds.LiveEnd && !t && !e.dismissed;
              });
              e.length <= 99 ? u(e.length.toString()) : u("99+"), a === GZ.OPEN && l(_toConsumableArray(e));
              var t = n.filter(function (e) {
                var t = !1;
                return e.answers && e.answers.length > 0 && (t = e.answers.reduce(function (e, t) {
                  return e || !!t.isFromHostOrPanelist;
                }, !1)), (e.liveAnswerStatus === ds.LiveEnd || t) && !e.dismissed;
              });
              t.length <= 99 ? h(t.length.toString()) : h("99+"), a === GZ.ANSWERED && l(_toConsumableArray(t));
              var r = n.filter(function (e) {
                return !!e.dismissed;
              });
              r.length <= 99 ? f(r.length.toString()) : f("99+"), a === GZ.DISMISSED && l(_toConsumableArray(r));
            }, [a, n]);
            var T = e.useCallback(function (e) {
              if (s(e), e === GZ.OPEN) {
                var _e308 = n.filter(function (e) {
                  var t = !1;
                  return e.answers && e.answers.length > 0 && (t = e.answers.reduce(function (e, t) {
                    return e || !!t.isFromHostOrPanelist;
                  }, !1)), e.liveAnswerStatus !== ds.LiveEnd && !t && !e.dismissed;
                });

                l(_toConsumableArray(_e308));
              } else if (e === GZ.ANSWERED) {
                var _e309 = n.filter(function (e) {
                  var t = !1;
                  return e.answers && e.answers.length > 0 && (t = e.answers.reduce(function (e, t) {
                    return e || !!t.isFromHostOrPanelist;
                  }, !1)), (e.liveAnswerStatus === ds.LiveEnd || t) && !e.dismissed;
                });

                l(_toConsumableArray(_e309));
              } else if (e === GZ.DISMISSED) {
                var _e310 = n.filter(function (e) {
                  return !!e.dismissed;
                });

                l(_toConsumableArray(_e310));
              }
            }, [n]),
                O = e.useCallback(function (e) {
              var t = e.index,
                  n = e.key,
                  i = e.style,
                  o = e.parent;
              return TH.exports.jsx(kK, {
                cache: g.current,
                columnIndex: 0,
                parent: o,
                rowIndex: t,
                children: function children(e) {
                  var n = e.measure;
                  return TH.exports.jsx(HZ, {
                    style: i,
                    index: t,
                    questionData: c[t],
                    qaSetting: r,
                    currentTypingIndex: b,
                    currentMessage: y,
                    currentChecked: w,
                    handleInput: S,
                    handleChecked: x,
                    handleRowTouched: E,
                    hasAnswered: a === GZ.ANSWERED,
                    measure: n
                  });
                }
              }, n);
            }, [w, y, b, c, x, S, E, r, a]),
                R = TH.exports.jsx("div", {
              className: I.questionList,
              children: TH.exports.jsx(jK, {
                children: function children(e) {
                  var t = e.width,
                      n = e.height;
                  return TH.exports.jsx(_W, {
                    width: t,
                    height: n,
                    rowHeight: g.current.rowHeight,
                    deferredMeasurementCache: g.current,
                    rowCount: c.length,
                    rowRenderer: O,
                    ref: v
                  });
                }
              })
            }),
                N = C("wc_qa.no_open_questions"),
                P = C("wc_qa.no_answered_questions"),
                j = C("wc_qa.no_dismissed_questions"),
                D = C("wc_qa.panelist_view_all_placehoder"),
                z = C("wc_qa.panelist_host_only_placeholder"),
                M = TH.exports.jsxs("div", {
              className: I.noQuestionPlaceholder,
              children: [TH.exports.jsx(QA, {
                variant: "body1",
                children: TH.exports.jsxs("b", {
                  children: [a === GZ.OPEN && N, a === GZ.ANSWERED && P, a === GZ.DISMISSED && j]
                })
              }), a === GZ.OPEN && TH.exports.jsx(QA, {
                variant: "body1",
                className: I.emptyPanelText,
                children: A ? D : z
              })]
            });
            return TH.exports.jsxs("div", {
              children: [TH.exports.jsxs(jN, {
                className: I.tabs,
                value: i,
                onChange: function onChange(e, t) {
                  return o(t);
                },
                centered: !0,
                children: [TH.exports.jsx(eN, {
                  className: I.tab,
                  label: "".concat(C("wc_qa.openedQ"), " (").concat(d, ")"),
                  onClick: function onClick() {
                    return T(GZ.OPEN);
                  }
                }), TH.exports.jsx(eN, {
                  className: I.tab,
                  label: "".concat(C("wc_qa.answeredQ"), " (").concat(p, ")"),
                  onClick: function onClick() {
                    return T(GZ.ANSWERED);
                  }
                }), TH.exports.jsx(eN, {
                  className: I.tab,
                  label: "".concat(C("wc_qa.dismissedQ"), " (").concat(_, ")"),
                  onClick: function onClick() {
                    return T(GZ.DISMISSED);
                  }
                })]
              }), !(null == r || !r.allowAttendeeVote) && TH.exports.jsx("div", {
                className: I.sortButtonContainer,
                children: TH.exports.jsxs(PF, {
                  menu: k,
                  className: I.sortButton,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    children: C(m ? "wc_qa.most_upvotes" : "Most Recent")
                  }), TH.exports.jsx(CF, {
                    type: "icon-arrow-down",
                    iconStyle: {
                      transform: "scale(0.3)"
                    }
                  })]
                })
              }), 0 === c.length ? M : R]
            });
          };

          var YZ;
          !function (e) {
            e.ALL_QUESTION = "allQuestions", e.MY_QUESTION = "myQuestions";
          }(YZ || (YZ = {}));

          var JZ = Ok(function (e) {
            return {
              tabs: _defineProperty({
                marginTop: 16,
                minHeight: 24,
                height: 24,
                borderRadius: 8
              }, "& .".concat(kH, "-MuiTabs-indicator"), {
                backgroundColor: "rgba(255, 255, 255, 0.18)",
                height: 22,
                borderRadius: 7,
                top: 1
              }),
              tab: {
                minHeight: 24,
                maxHeight: 24
              },
              questionList: function questionList(t) {
                return {
                  height: t.isShowSortButton ? "350px" : "380px",
                  marginTop: e.spacing(2),
                  scrollbarColor: "#707070 #282828",
                  scrollbarWidth: "thin",
                  "& .ReactVirtualized__List::-webkit-scrollbar": {
                    width: "8px"
                  },
                  "& .ReactVirtualized__List::-webkit-scrollbar-thumb": {
                    backgroundColor: "#707070",
                    borderRadius: "100px"
                  }
                };
              },
              emptyPanel: {
                height: "430px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                padding: "0 60px",
                textAlign: "center"
              },
              emptyPanelText: {
                color: "rgba(255,255,255,0.54)"
              },
              myQestionPlaceholder: function myQestionPlaceholder(e) {
                return {
                  height: e.isShowSortButton ? "350px" : "380px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: "0 60px",
                  textAlign: "center"
                };
              },
              sortButtonContainer: {
                display: "flex",
                margin: e.spacing(2),
                alignContent: "center",
                justifyContent: "flex-end"
              },
              sortButton: {
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row"
              }
            };
          }),
              $Z = function $Z(t) {
            var n = t.questions,
                r = t.qaSetting,
                _e$useState253 = e.useState(0),
                _e$useState254 = _slicedToArray(_e$useState253, 2),
                i = _e$useState254[0],
                o = _e$useState254[1],
                _e$useState255 = e.useState(YZ.ALL_QUESTION),
                _e$useState256 = _slicedToArray(_e$useState255, 2),
                a = _e$useState256[0],
                s = _e$useState256[1],
                _e$useState257 = e.useState([]),
                _e$useState258 = _slicedToArray(_e$useState257, 2),
                c = _e$useState258[0],
                l = _e$useState258[1],
                _e$useState259 = e.useState("0"),
                _e$useState260 = _slicedToArray(_e$useState259, 2),
                d = _e$useState260[0],
                u = _e$useState260[1],
                _e$useState261 = e.useState("0"),
                _e$useState262 = _slicedToArray(_e$useState261, 2),
                p = _e$useState262[0],
                h = _e$useState262[1],
                _e$useContext124 = e.useContext(jM),
                _ = _e$useContext124.userId,
                _e$useContext125 = e.useContext(JM),
                f = _e$useContext125.isSortMostUpVote,
                m = e.useRef(new TK({
              defaultHeight: 60,
              fixedWidth: !0
            })),
                g = e.useRef(null),
                _NM57 = NM(),
                v = _NM57.t,
                b = JZ({
              isShowSortButton: !(null == r || !r.allowAttendeeVote)
            }),
                _VZ2 = VZ(),
                y = _VZ2.currentTypingRowIndex,
                w = _VZ2.currentMessage,
                S = _VZ2.currentChecked,
                x = _VZ2.handleRowInput,
                E = _VZ2.handleChecked,
                C = _VZ2.handleRowTouched,
                k = KZ();

            e.useLayoutEffect(function () {
              var e = n.filter(function (e) {
                return e.userId === _ || void 0 === e.dismissed || !1 === e.dismissed;
              });
              e.length <= 99 ? u(e.length.toString()) : u("99+"), a === YZ.ALL_QUESTION && l(_toConsumableArray(e));
              var t = n.filter(function (e) {
                return e.userId === _;
              });
              t.length <= 99 ? h(t.length.toString()) : h("99+"), a === YZ.MY_QUESTION && l(_toConsumableArray(t));
            }, [a, n, _]);
            var A = e.useCallback(function (e) {
              if (s(e), e === YZ.ALL_QUESTION) {
                var _e311 = n.filter(function (e) {
                  return e.userId === _ || void 0 === e.dismissed || !1 === e.dismissed;
                });

                l(_toConsumableArray(_e311));
              } else if (e === YZ.MY_QUESTION) {
                var _e312 = n.filter(function (e) {
                  return e.userId === _;
                });

                l(_toConsumableArray(_e312));
              }
            }, [n, _]),
                I = e.useCallback(function (e) {
              var t = e.index,
                  n = e.key,
                  i = e.style,
                  o = e.parent;
              return TH.exports.jsx(kK, {
                cache: m.current,
                columnIndex: 0,
                parent: o,
                rowIndex: t,
                children: function children(e) {
                  var n = e.measure;
                  return TH.exports.jsx(HZ, {
                    style: i,
                    index: t,
                    questionData: c[t],
                    qaSetting: r,
                    currentTypingIndex: y,
                    currentMessage: w,
                    currentChecked: S,
                    handleInput: x,
                    handleChecked: E,
                    handleRowTouched: C,
                    measure: n
                  });
                }
              }, n);
            }, [S, w, y, c, E, x, C, r]),
                T = TH.exports.jsx("div", {
              className: b.questionList,
              children: TH.exports.jsx(jK, {
                children: function children(e) {
                  var t = e.width,
                      n = e.height;
                  return TH.exports.jsx(_W, {
                    width: t,
                    height: n,
                    rowHeight: m.current.rowHeight,
                    deferredMeasurementCache: m.current,
                    rowCount: c.length,
                    rowRenderer: I,
                    ref: g
                  });
                }
              })
            }),
                O = v("wc_qa.no_questions"),
                R = v("wc_qa.attendee_placeholder"),
                N = TH.exports.jsxs("div", {
              className: b.myQestionPlaceholder,
              children: [TH.exports.jsx(QA, {
                variant: "body1",
                children: TH.exports.jsx("b", {
                  children: O
                })
              }), TH.exports.jsx(QA, {
                variant: "body1",
                className: b.emptyPanelText,
                children: R
              })]
            });
            return 0 === n.length ? TH.exports.jsxs("div", {
              className: b.emptyPanel,
              children: [TH.exports.jsx(QA, {
                variant: "body1",
                children: TH.exports.jsx("b", {
                  children: v("wc_qa.welcome_banner_title")
                })
              }), TH.exports.jsx(QA, {
                variant: "body1",
                className: b.emptyPanelText,
                children: v("wc_qa.welcome_banner")
              })]
            }) : TH.exports.jsxs("div", {
              children: [TH.exports.jsxs(jN, {
                className: b.tabs,
                value: i,
                onChange: function onChange(e, t) {
                  return o(t);
                },
                centered: !0,
                children: [TH.exports.jsx(eN, {
                  className: b.tab,
                  label: "".concat(v("wc_qa.allQ"), " (").concat(d, ")"),
                  onClick: function onClick() {
                    return A(YZ.ALL_QUESTION);
                  }
                }), TH.exports.jsx(eN, {
                  className: b.tab,
                  label: "".concat(v("wc_qa.myQ"), " (").concat(p, ")"),
                  onClick: function onClick() {
                    return A(YZ.MY_QUESTION);
                  }
                })]
              }), !(null == r || !r.allowAttendeeVote) && TH.exports.jsx("div", {
                className: b.sortButtonContainer,
                children: TH.exports.jsxs(PF, {
                  menu: k,
                  className: b.sortButton,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    children: v(f ? "wc_qa.most_upvotes" : "Most Recent")
                  }), TH.exports.jsx(CF, {
                    type: "icon-arrow-down",
                    iconStyle: {
                      transform: "scale(0.3)"
                    }
                  })]
                })
              }), a === YZ.MY_QUESTION && 0 === c.length ? N : T]
            });
          },
              XZ = Ok(function (e) {
            return {
              tooltip: {
                background: "#2E2E2E",
                borderRadius: "8px",
                padding: 0
              },
              tooltipArrow: {
                color: "#2E2E2E"
              },
              qaSettingRow: {
                marginLeft: "2px"
              },
              divider: {
                backgroundColor: "grey",
                borderColor: "grey"
              },
              settingText: {
                color: "white",
                margin: "10px",
                fontSize: "12px"
              },
              radioGroup: {
                marginTop: 0,
                marginLeft: "10px"
              },
              radioCheckbox: {
                marginLeft: "20px"
              },
              checkbox: {
                "&&:hover": {
                  backgroundColor: "transparent"
                }
              },
              radioButton: {
                marginLeft: "4px",
                "&&:hover": {
                  backgroundColor: "transparent"
                }
              }
            };
          }),
              eY = function eY(t) {
            var n = t.qaSetting,
                _e$useState263 = e.useState(!1),
                _e$useState264 = _slicedToArray(_e$useState263, 2),
                r = _e$useState264[0],
                i = _e$useState264[1],
                _e$useState265 = e.useState(!1),
                _e$useState266 = _slicedToArray(_e$useState265, 2),
                o = _e$useState266[0],
                a = _e$useState266[1],
                _e$useState267 = e.useState("answered"),
                _e$useState268 = _slicedToArray(_e$useState267, 2),
                s = _e$useState268[0],
                c = _e$useState268[1],
                _e$useState269 = e.useState(!1),
                _e$useState270 = _slicedToArray(_e$useState269, 2),
                l = _e$useState270[0],
                d = _e$useState270[1],
                _e$useState271 = e.useState(!1),
                _e$useState272 = _slicedToArray(_e$useState271, 2),
                u = _e$useState272[0],
                p = _e$useState272[1],
                _e$useContext126 = e.useContext($M),
                h = _e$useContext126.qaClient,
                _NM58 = NM(),
                _ = _NM58.t,
                f = XZ();

            e.useEffect(function () {
              void 0 !== n.allowAnonymousQuestion && a(n.allowAnonymousQuestion), void 0 !== n.allowAttendeeComment && p(n.allowAttendeeComment), void 0 !== n.allowAttendeeViewAllQuestion && (n.allowAttendeeViewAllQuestion ? c("all") : c("answered")), void 0 !== n.allowAttendeeVote && d(n.allowAttendeeVote);
            }, [n]);
            var m = e.useCallback(function () {
              i(!1);
            }, []),
                g = e.useCallback(function () {
              i(!r);
            }, [r]),
                v = e.useCallback(function () {
              h && h.configureQASetting({
                allowAnonymousQuestion: !o
              });
            }, [o, h]),
                b = e.useCallback(function (e, t) {
              h && ("all" === t ? h.configureQASetting({
                allowAttendeeViewAllQuestion: !0
              }) : h.configureQASetting({
                allowAttendeeViewAllQuestion: !1
              }));
            }, [h]),
                y = e.useCallback(function () {
              h && h.configureQASetting({
                allowAttendeeVote: !l
              });
            }, [l, h]),
                w = e.useCallback(function () {
              h && h.configureQASetting({
                allowAttendeeComment: !u
              });
            }, [u, h]),
                S = TH.exports.jsxs("div", {
              children: [TH.exports.jsx(dT, {
                className: f.qaSettingRow,
                control: TH.exports.jsx(hI, {
                  checked: o,
                  name: "checkedIsAllowAnonymous",
                  color: "primary",
                  size: "small",
                  onChange: v,
                  className: f.checkbox
                }),
                label: TH.exports.jsx(QA, {
                  variant: "body1",
                  noWrap: !0,
                  children: _("wc_qa.setting_option_allow_anony_question")
                })
              }), TH.exports.jsx("hr", {
                className: f.divider
              }), TH.exports.jsxs(cT, {
                children: [TH.exports.jsx(mT, {
                  children: TH.exports.jsx(QA, {
                    className: f.settingText,
                    variant: "h1",
                    noWrap: !0,
                    children: _("wc_qa.setting_allow_view")
                  })
                }), TH.exports.jsxs(BR, {
                  className: f.radioGroup,
                  onChange: b,
                  value: s,
                  children: [TH.exports.jsx(dT, {
                    value: "answered",
                    control: TH.exports.jsx(oQ, {
                      className: f.radioButton
                    }),
                    label: TH.exports.jsx(QA, {
                      variant: "body1",
                      noWrap: !0,
                      children: _("wc_qa.setting_option_allow_view_answered")
                    })
                  }), TH.exports.jsx(dT, {
                    value: "all",
                    control: TH.exports.jsx(oQ, {
                      className: f.radioButton
                    }),
                    label: TH.exports.jsx(QA, {
                      variant: "body1",
                      noWrap: !0,
                      children: _("wc_qa.setting_option_allow_view_all")
                    })
                  })]
                }), TH.exports.jsx(dT, {
                  className: f.radioCheckbox,
                  control: TH.exports.jsx(hI, {
                    checked: l,
                    name: "checkedIsAllowUpvote",
                    color: "primary",
                    size: "small",
                    onChange: y,
                    disabled: "answered" === s,
                    className: f.checkbox
                  }),
                  label: TH.exports.jsx(QA, {
                    variant: "body1",
                    noWrap: !0,
                    children: _("wc_qa.setting_option_allow_vote")
                  })
                }), TH.exports.jsx(dT, {
                  className: f.radioCheckbox,
                  control: TH.exports.jsx(hI, {
                    checked: u,
                    name: "checkedIsAllowComment",
                    color: "primary",
                    size: "small",
                    onChange: w,
                    disabled: "answered" === s,
                    className: f.checkbox
                  }),
                  label: TH.exports.jsx(QA, {
                    variant: "body1",
                    noWrap: !0,
                    children: _("wc_qa.setting_option_allow_comment")
                  })
                })]
              })]
            });
            return TH.exports.jsx(VN, {
              classes: {
                tooltip: f.tooltip,
                arrow: f.tooltipArrow
              },
              PopperProps: {
                disablePortal: !0
              },
              onClose: m,
              arrow: !0,
              open: r,
              disableFocusListener: !0,
              disableHoverListener: !0,
              disableTouchListener: !0,
              title: TH.exports.jsx(fI, {
                onClickAway: m,
                children: S
              }),
              placement: "bottom-end",
              interactive: !0,
              children: TH.exports.jsx(AF, {
                iconType: "icon-settings",
                onClick: g
              })
            });
          },
              tY = Ok(function (e) {
            return {
              textarea: function textarea(t) {
                var _ref75;

                return _ref75 = {}, _defineProperty(_ref75, "& .".concat(kH, "-MuiInput-underline:after"), {
                  border: "none !important"
                }), _defineProperty(_ref75, "& .".concat(kH, "-MuiInput-underline:before"), {
                  border: "none !important"
                }), _defineProperty(_ref75, "& textarea", {
                  fontSize: "13px",
                  scrollbarColor: "#707070 #282828",
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    width: "8px"
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#707070",
                    borderRadius: "100px"
                  }
                }), _defineProperty(_ref75, "& textarea::placeholder", {
                  fontSize: "13px"
                }), _defineProperty(_ref75, "border", t.isFullMode ? "" : "1px solid ".concat(e.palette.action.hover)), _defineProperty(_ref75, "borderRadius", e.shape.borderRadius), _defineProperty(_ref75, "padding", e.spacing(1)), _ref75;
              },
              fullModeControlWrapper: {
                display: "flex",
                alignContent: "center",
                justifyContent: "space-between",
                marginTop: e.spacing(1)
              },
              inputBoxWrapper: function inputBoxWrapper(t) {
                return {
                  border: t.isFullMode ? "1px solid ".concat(e.palette.action.hover) : "",
                  borderRadius: t.isFullMode ? e.shape.borderRadius : "",
                  padding: e.spacing(1)
                };
              },
              checkbox: {
                "&&:hover": {
                  backgroundColor: "transparent"
                }
              }
            };
          }),
              nY = function nY(t) {
            var n = t.textAreaStyle,
                r = t.isAllowAnonymous,
                _e$useState273 = e.useState(""),
                _e$useState274 = _slicedToArray(_e$useState273, 2),
                i = _e$useState274[0],
                o = _e$useState274[1],
                _e$useState275 = e.useState(!1),
                _e$useState276 = _slicedToArray(_e$useState275, 2),
                a = _e$useState276[0],
                s = _e$useState276[1],
                _e$useState277 = e.useState(!1),
                _e$useState278 = _slicedToArray(_e$useState277, 2),
                c = _e$useState278[0],
                l = _e$useState278[1],
                d = tY({
              isFullMode: a
            }),
                _NM59 = NM(),
                u = _NM59.t,
                _e$useContext127 = e.useContext($M),
                p = _e$useContext127.qaClient,
                h = e.useCallback(function (e) {
              o(e.target.value);
            }, []),
                _ = e.useCallback(function () {
              s(!0);
            }, []),
                f = e.useCallback(function () {
              l(!c);
            }, [c]),
                m = e.useCallback(function () {
              s(!1), o(""), l(!1);
            }, []),
                g = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
              return _regeneratorRuntime.wrap(function _callee52$(_context52) {
                while (1) {
                  switch (_context52.prev = _context52.next) {
                    case 0:
                      _context52.prev = 0;
                      _context52.t0 = p;

                      if (!_context52.t0) {
                        _context52.next = 10;
                        break;
                      }

                      if (!r) {
                        _context52.next = 8;
                        break;
                      }

                      _context52.next = 6;
                      return p.askQuestion(i, c);

                    case 6:
                      _context52.next = 10;
                      break;

                    case 8:
                      _context52.next = 10;
                      return p.askQuestion(i);

                    case 10:
                      _context52.next = 15;
                      break;

                    case 12:
                      _context52.prev = 12;
                      _context52.t1 = _context52["catch"](0);
                      console.log(_context52.t1);

                    case 15:
                      s(!1), o(""), l(!1);

                    case 16:
                    case "end":
                      return _context52.stop();
                  }
                }
              }, _callee52, null, [[0, 12]]);
            })), [c, p, i, r]);

            return TH.exports.jsx("div", {
              className: n,
              children: TH.exports.jsxs("div", {
                className: d.inputBoxWrapper,
                children: [TH.exports.jsx(MN, {
                  rows: a ? 4 : 1,
                  className: d.textarea,
                  fullWidth: !0,
                  multiline: !0,
                  onChange: h,
                  onFocus: _,
                  value: i,
                  placeholder: u("wc_qa.input_tips")
                }), a && TH.exports.jsxs("div", {
                  className: d.fullModeControlWrapper,
                  children: [r ? TH.exports.jsx(dT, {
                    control: TH.exports.jsx(hI, {
                      checked: c,
                      name: "checkedIsAllowAnonymous",
                      color: "primary",
                      size: "small",
                      onChange: f,
                      className: d.checkbox
                    }),
                    label: TH.exports.jsx(QA, {
                      variant: "body1",
                      noWrap: !0,
                      children: u("wc_qa.is_anonymous")
                    })
                  }) : TH.exports.jsx("div", {}), TH.exports.jsxs("div", {
                    children: [TH.exports.jsx(YA, {
                      onClick: m,
                      children: u("common.cancel")
                    }), TH.exports.jsx(YA, {
                      onClick: g,
                      disabled: "" === i,
                      children: u("wc_qa.send")
                    })]
                  })]
                })]
              })
            });
          },
              rY = function rY(t) {
            var n = t.qaSetting,
                r = n.allowAnonymousQuestion,
                i = n.allowAttendeeViewAllQuestion,
                _e$useState279 = e.useState(""),
                _e$useState280 = _slicedToArray(_e$useState279, 2),
                o = _e$useState280[0],
                a = _e$useState280[1],
                _e$useState281 = e.useState(""),
                _e$useState282 = _slicedToArray(_e$useState281, 2),
                s = _e$useState282[0],
                c = _e$useState282[1],
                _e$useState283 = e.useState(""),
                _e$useState284 = _slicedToArray(_e$useState283, 2),
                l = _e$useState284[0],
                d = _e$useState284[1],
                _NM60 = NM(),
                u = _NM60.t;

            return e.useEffect(function () {
              r ? i ? (a(u("disclaimer.QA_content_4")), c(u("disclaimer.QA_content_1_1")), d(u("disclaimer.QA_content_5"))) : (a(""), c(u("disclaimer.QA_content_3_3")), d(u("disclaimer.QA_content_2"))) : i ? (a(""), c(u("disclaimer.QA_content_4")), d(u("disclaimer.QA_content_1_1"))) : (a(""), c(u("disclaimer.QA_content_1_1")), d(u("disclaimer.QA_content_2")));
            }, [r, i, u]), TH.exports.jsxs(TH.exports.Fragment, {
              children: [o && TH.exports.jsxs(TH.exports.Fragment, {
                children: [TH.exports.jsx(QA, {
                  variant: "body1",
                  children: o
                }), TH.exports.jsx("br", {})]
              }), TH.exports.jsx(QA, {
                variant: "body1",
                children: s
              }), TH.exports.jsx("br", {}), TH.exports.jsx(QA, {
                variant: "body1",
                children: l
              })]
            });
          },
              iY = Ok(function (e) {
            return {
              panel: {
                height: "550px",
                width: "400px"
              },
              qaGettyNoticeBox: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                height: "24px",
                marginLeft: -e.spacing(3),
                marginRight: -e.spacing(3),
                color: "rgba(255, 255, 255, 0.54)",
                background: "rgba(255, 255, 255, 0.18)",
                "&:hover": {
                  background: "#383838",
                  borderBottomLeftRadius: e.shape.borderRadius,
                  borderBottomRightRadius: e.shape.borderRadius
                },
                width: "100%",
                position: "absolute",
                bottom: 0
              },
              gettyTooltip: {
                background: "#4B4B4B",
                color: "rgba(255, 255, 255, 0.54)"
              },
              gettyTooltipArrow: {
                color: "#4B4B4B"
              },
              textAreaWrapper: {
                position: "absolute",
                bottom: e.spacing(8),
                width: "100%",
                marginLeft: -e.spacing(3),
                marginRight: -e.spacing(3),
                paddingLeft: e.spacing(3),
                paddingRight: e.spacing(3),
                backgroundColor: "#242424"
              }
            };
          }),
              oY = function oY(t) {
            var _e$useState285 = e.useState(!1),
                _e$useState286 = _slicedToArray(_e$useState285, 2),
                n = _e$useState286[0],
                r = _e$useState286[1],
                _e$useContext128 = e.useContext(JM),
                i = _e$useContext128.isShowQAPanel,
                o = _e$useContext128.dispatch,
                _e$useContext129 = e.useContext(jM),
                a = _e$useContext129.isAttendee,
                s = _e$useContext129.isHost,
                c = _e$useContext129.isCoHost,
                l = e.useContext(zM),
                _e$useContext130 = e.useContext($M),
                d = _e$useContext130.qaClient,
                _NM61 = NM(),
                p = _NM61.t,
                h = iY(),
                _ = s || c,
                f = e.useCallback(function () {
              null == o || o(oH(!1));
            }, [o]),
                m = e.useCallback(function () {
              r(!1);
            }, []),
                g = e.useCallback(function () {
              r(!n);
            }, [n]),
                _FZ = FZ(l, d),
                v = _FZ.questions,
                b = function (t, n) {
              var _e$useState287 = e.useState(qZ),
                  _e$useState288 = _slicedToArray(_e$useState287, 2),
                  r = _e$useState288[0],
                  i = _e$useState288[1],
                  _e$useContext131 = e.useContext(JM),
                  o = _e$useContext131.dispatch,
                  a = e.useCallback(function (e) {
                if (n) {
                  var _e313 = n.getQASetting();

                  null != _e313 && _e313.allowAttendeeVote || null == o || o(cH(!1)), i(u({}, _e313));
                }
              }, [o, n]);

              return e.useEffect(function () {
                return t.on("qa-setting-change", a), function () {
                  t.off("qa-setting-change", a);
                };
              }, [t, a]), r;
            }(l, d);

            return TH.exports.jsxs(XW, u(u({
              title: p("wc_qa.qa_comp_title"),
              open: i,
              onClose: f,
              placement: "right-start",
              className: h.panel,
              extraButton: _ ? TH.exports.jsx(eY, {
                qaSetting: b
              }) : void 0
            }, t), {}, {
              children: [a ? TH.exports.jsx($Z, {
                questions: v,
                qaSetting: b
              }) : TH.exports.jsx(ZZ, {
                questions: v,
                qaSetting: b
              }), a && TH.exports.jsx(nY, {
                textAreaStyle: h.textAreaWrapper,
                isAllowAnonymous: b.allowAnonymousQuestion
              }), a && TH.exports.jsx(fI, {
                onClickAway: m,
                children: TH.exports.jsx(VN, {
                  classes: {
                    tooltip: h.gettyTooltip,
                    arrow: h.gettyTooltipArrow
                  },
                  title: TH.exports.jsx(rY, {
                    qaSetting: b
                  }),
                  placement: "top",
                  open: n,
                  onClose: m,
                  PopperProps: {
                    disablePortal: !0
                  },
                  arrow: !0,
                  "aria-label": "chat-privacy-notice",
                  disableHoverListener: !0,
                  children: TH.exports.jsxs(WA, {
                    className: h.qaGettyNoticeBox,
                    onClick: g,
                    children: [TH.exports.jsx(CF, {
                      type: "icon-privacy",
                      iconStyle: {
                        transform: "scale(0.7)"
                      }
                    }), TH.exports.jsx(QA, {
                      variant: "body1",
                      style: {
                        margin: 5
                      },
                      children: p("disclaimer.QA_button_1")
                    })]
                  })
                })
              })]
            }));
          },
              aY = ["text"],
              sY = Ok(function (e) {
            return {
              linkButton: {
                fontSize: e.spacing(2.75)
              }
            };
          }),
              cY = function cY(e) {
            var t = e.text,
                n = h(e, aY);
            var r = sY();
            return TH.exports.jsx(YA, u(u({
              className: r.linkButton,
              variant: "contained",
              size: "small",
              endIcon: TH.exports.jsx(CF, {
                type: "icon-new-window"
              })
            }, n), {}, {
              children: TH.exports.jsx(QA, {
                variant: "body1",
                noWrap: !0,
                children: t
              })
            }));
          },
              lY = Ok(function (e) {
            return {
              spinner: {
                animation: "$spinAnimation 1250ms infinite linear"
              },
              "@keyframes spinAnimation": {
                "0%": {
                  transform: "rotate(0deg)"
                },
                "100%": {
                  transform: "rotate(360deg)"
                }
              }
            };
          }),
              dY = function dY(e) {
            var t = e.className;
            var n = lY();
            return TH.exports.jsx(CF, {
              className: VC(n.spinner, t),
              type: "icon-loading"
            });
          },
              uY = Ok(function (e) {
            return {
              listItem: {
                padding: e.spacing(2)
              },
              text: {
                color: "rgba(255, 255, 255, 0.52)",
                fontSize: e.spacing(2.75)
              },
              textClick: {
                cursor: "pointer"
              },
              highlight: {
                backgroundColor: e.palette.action.hover
              },
              learnMoreContainer: {
                position: "absolute",
                right: 0,
                top: 0
              },
              scopesContainer: {
                display: "flex",
                alignItems: "center",
                marginTop: e.spacing(3),
                "& > svg": {
                  marginRight: e.spacing(1.25)
                },
                "& > p": {
                  marginRight: e.spacing(3)
                }
              },
              scopeIcon: {
                fontSize: "1rem"
              }
            };
          }),
              pY = function pY() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                t = arguments.length > 1 ? arguments[1] : void 0,
                n = arguments.length > 2 ? arguments[2] : void 0;
            return 0 === e.length ? t : 1 === e.length ? e[0].displayName : e.length > 1 ? "".concat(e.length, " ").concat(n) : "";
          },
              hY = function hY(e) {
            var t = e.iconType,
                n = e.label;
            var r = uY();
            return TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsx(CF, {
                className: r.scopeIcon,
                type: t
              }), TH.exports.jsx(QA, {
                className: r.text,
                variant: "body1",
                children: n
              })]
            });
          },
              _Y = function _Y(t) {
            var n = uY(),
                r = t.appId,
                i = t.link,
                o = t.icon,
                a = t.appName,
                s = t.scopes,
                c = t.sdkUsers,
                l = t.onClick,
                d = e.useContext(zM),
                u = e.useRef(null),
                p = e.useRef(null),
                h = Kz(u),
                _ = Kz(p),
                _e$useState289 = e.useState(!1),
                _e$useState290 = _slicedToArray(_e$useState289, 2),
                f = _e$useState290[0],
                m = _e$useState290[1],
                _e$useState291 = e.useState(!1),
                _e$useState292 = _slicedToArray(_e$useState291, 2),
                g = _e$useState292[0],
                v = _e$useState292[1],
                _e$useState293 = e.useState(!1),
                _e$useState294 = _slicedToArray(_e$useState293, 2),
                b = _e$useState294[0],
                y = _e$useState294[1],
                w = e.useCallback(function () {
              _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
                return _regeneratorRuntime.wrap(function _callee53$(_context53) {
                  while (1) {
                    switch (_context53.prev = _context53.next) {
                      case 0:
                        _context53.prev = 0;
                        m(!0);
                        _context53.next = 4;
                        return d.getActiveAppLink(r);

                      case 4:
                        m(!1);
                        y(!0);
                        v(!1);
                        _context53.next = 12;
                        break;

                      case 9:
                        _context53.prev = 9;
                        _context53.t0 = _context53["catch"](0);
                        m(!1), y(!1), v(!0);

                      case 12:
                      case "end":
                        return _context53.stop();
                    }
                  }
                }, _callee53, null, [[0, 9]]);
              }))();
            }, [r, d]),
                S = e.useCallback(function () {
              i ? window.open(i, "_blank") : w();
            }, [w, i]);

            e.useEffect(function () {
              i && b && (y(!1), window.open(i, "_blank"));
            }, [i, b]);

            var _NM62 = NM(),
                x = _NM62.t,
                E = x("app_signal.approved_by"),
                C = x("app_signal.hosts_account"),
                k = x("app_signal.people"),
                A = x("wc_learn_more"),
                I = x("dialog.btn_retry"),
                T = [{
              scope: "audio",
              iconType: "icon-audio-outline",
              label: x("wc_audio")
            }, {
              scope: "video",
              iconType: "icon-video-outline",
              label: x("wc_video.video")
            }, {
              scope: "chat",
              iconType: "icon-chat-outline",
              label: x("wc_chat.chat")
            }, {
              scope: "files",
              iconType: "icon-files-outline",
              label: x("wc_files")
            }];

            return TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsxs(zT, {
                className: VC(n.listItem, _defineProperty({}, n.highlight, h)),
                alignItems: "flex-start",
                disableGutters: !0,
                ref: u,
                onClick: function onClick() {
                  return !_ && l();
                },
                children: [TH.exports.jsx(LT, {
                  children: TH.exports.jsx(MA, {
                    variant: "rounded",
                    src: "".concat(o)
                  })
                }), TH.exports.jsx(VT, {
                  disableTypography: !0,
                  primary: TH.exports.jsxs(WA, {
                    position: "relative",
                    children: [TH.exports.jsx(QA, {
                      display: "inline",
                      variant: "body1",
                      noWrap: !0,
                      children: a
                    }), h && TH.exports.jsx("div", {
                      ref: p,
                      className: n.learnMoreContainer,
                      children: f ? TH.exports.jsx(dY, {}) : g ? TH.exports.jsx(YA, {
                        onClick: w,
                        variant: "contained",
                        color: "primary",
                        size: "small",
                        "aria-label": "Retry fetching link for ".concat(a),
                        children: I
                      }) : TH.exports.jsx(cY, {
                        onClick: S,
                        text: A,
                        "aria-label": "".concat(A, " about ").concat(a)
                      })
                    })]
                  }),
                  secondary: TH.exports.jsxs(WA, {
                    children: [TH.exports.jsx(QA, {
                      className: VC(n.text, n.textClick),
                      variant: "body1",
                      children: "".concat(E, " ").concat(pY(c, C, k))
                    }), (null == s ? void 0 : s.length) > 0 && TH.exports.jsx(WA, {
                      className: n.scopesContainer,
                      children: T.map(function (e) {
                        return -1 !== s.indexOf(e.scope) ? TH.exports.jsx(hY, {
                          iconType: e.iconType,
                          label: e.label
                        }, "".concat(r, "-").concat(e.scope)) : null;
                      })
                    })]
                  })
                })]
              }), TH.exports.jsx(qI, {
                component: "li"
              })]
            });
          },
              fY = Ok(function (e) {
            return {
              rootContainer: {
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                minHeight: "240px",
                maxHeight: "640px",
                overflow: "hidden auto",
                scrollbarColor: "#707070 transparent",
                "&::-webkit-scrollbar": {
                  width: e.spacing(1.5)
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: 100
                }
              },
              appInfoContainer: {
                display: "flex"
              },
              appIcon: {
                marginRight: e.spacing(2)
              },
              divider: {
                margin: e.spacing(3, 0)
              },
              approvedBy: {
                color: "rgba(255, 255, 255, 0.52)",
                fontSize: e.spacing(2.75)
              },
              participantList: {
                padding: 0,
                flexGrow: 1
              },
              backButton: _defineProperty({
                backgroundColor: "transparent",
                marginTop: e.spacing(3),
                padding: e.spacing(.5, 2, .5, .5),
                minWidth: e.spacing(6),
                color: "rgba(255, 255, 255, 0.52)"
              }, "& .".concat(kH, "-MuiButton-startIcon"), {
                margin: 0
              })
            };
          }),
              mY = function mY(e) {
            var t = e.name,
                n = e.icon,
                r = e.sdkUsers,
                i = e.onClickBack;

            var _NM63 = NM(),
                o = _NM63.t,
                a = o("app_signal.approved_by"),
                s = o("app_signal.people"),
                c = o("polling.Back"),
                l = fY();

            return TH.exports.jsxs(WA, {
              className: l.rootContainer,
              children: [TH.exports.jsxs(WA, {
                className: l.appInfoContainer,
                children: [TH.exports.jsx(MA, {
                  className: l.appIcon,
                  variant: "rounded",
                  src: "".concat(n)
                }), TH.exports.jsxs(WA, {
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    noWrap: !0,
                    children: t
                  }), TH.exports.jsx(QA, {
                    className: l.approvedBy,
                    variant: "body1",
                    noWrap: !0,
                    children: "".concat(a, " ").concat(null == r ? void 0 : r.length, " ").concat(s)
                  })]
                })]
              }), TH.exports.jsx(qI, {
                className: l.divider
              }), TH.exports.jsx(PT, {
                className: l.participantList,
                children: null == r ? void 0 : r.map(function (e) {
                  var t = e.userId,
                      n = e.avatar,
                      r = e.displayName;
                  return TH.exports.jsxs(zT, {
                    disableGutters: !0,
                    children: [TH.exports.jsx(LT, {
                      children: TH.exports.jsx(MA, {
                        variant: "rounded",
                        src: n
                      })
                    }), TH.exports.jsx(VT, {
                      primary: r
                    })]
                  }, t);
                })
              }), TH.exports.jsx(WA, {
                role: "button",
                children: TH.exports.jsx(YA, {
                  className: l.backButton,
                  variant: "contained",
                  size: "small",
                  startIcon: TH.exports.jsx(CF, {
                    type: "icon-arrow-left"
                  }),
                  onClick: i,
                  children: TH.exports.jsx(QA, {
                    variant: "body1",
                    noWrap: !0,
                    children: c
                  })
                })
              })]
            });
          },
              gY = Ok(function (e) {
            return {
              panel: {
                width: "420px",
                boxSizing: "border-box",
                padding: e.spacing(2, 4, 3, 4)
              },
              loadingOrErrorContainer: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "200px"
              },
              contentContainer: {
                maxHeight: "600px",
                overflow: "hidden auto",
                scrollbarColor: "#707070 transparent",
                "&::-webkit-scrollbar": {
                  width: e.spacing(1)
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: 100
                }
              },
              bottomMargin: {
                marginBottom: e.spacing(3)
              },
              text: {
                color: "rgba(255, 255, 255, 0.52)"
              },
              summary: {
                padding: e.spacing(3, 0)
              }
            };
          }),
              vY = function vY() {
            return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").split("\n").map(function (e, t) {
              var n = e.match(/<a.+?>.+?a>/g);
              if (!n) return e;
              var r = n.map(function (e) {
                var _e$match = e.match(/href='(.+)'.?>(.+?)</i),
                    _e$match2 = _slicedToArray(_e$match, 3),
                    n = _e$match2[0],
                    r = _e$match2[1],
                    i = _e$match2[2];

                return TH.exports.jsx(cY, {
                  onClick: function onClick() {
                    return window.open(r, "_blank");
                  },
                  text: i
                }, "".concat(t, "-linkbutton"));
              }),
                  i = e.split(/<a.+?>.+?a>/g);
              return i.map(function (e, t) {
                return t < i.length - 1 ? [e, r[t]] : e;
              }).reduce(function (e, t) {
                return e.concat(t);
              }, []);
            });
          },
              bY = function bY(t) {
            var n;

            var r = gY(),
                _e$useContext132 = e.useContext(jM),
                i = _e$useContext132.participants,
                o = _e$useContext132.activeAppsInfo,
                a = _e$useContext132.isWebinar,
                s = _e$useContext132.attendees,
                _e$useContext133 = e.useContext(JM),
                c = _e$useContext133.isShowActiveAppsNotifier,
                l = e.useContext(zM),
                _e$useState295 = e.useState(new Map()),
                _e$useState296 = _slicedToArray(_e$useState295, 2),
                d = _e$useState296[0],
                p = _e$useState296[1],
                _e$useState297 = e.useState(!1),
                _e$useState298 = _slicedToArray(_e$useState297, 2),
                h = _e$useState298[0],
                _ = _e$useState298[1],
                _e$useState299 = e.useState(!0),
                _e$useState300 = _slicedToArray(_e$useState299, 2),
                f = _e$useState300[0],
                m = _e$useState300[1],
                _e$useState301 = e.useState(null),
                _e$useState302 = _slicedToArray(_e$useState301, 2),
                g = _e$useState302[0],
                v = _e$useState302[1],
                _ref78 = o || {},
                b = _ref78.title,
                y = _ref78.summary,
                w = _ref78.status,
                S = _ref78.list,
                x = e.useCallback(function () {
              _(!1), m(!0);
            }, []);

            e.useEffect(function () {
              c && v(null);
            }, [c]), e.useEffect(function () {
              var e = i.map(function (e) {
                return {
                  displayName: e.displayName,
                  userId: e.userId,
                  avatar: e.avatar,
                  sdkKey: e.sdkKey
                };
              });
              a && (e = e.concat(s.map(function (e) {
                return {
                  displayName: e.displayName,
                  userId: e.userId,
                  avatar: "",
                  sdkKey: e.sdkKey
                };
              })));
              var t = e.reduce(function (e, t) {
                return t.sdkKey && (e.has(t.sdkKey) || e.set(t.sdkKey, new Array()), e.get(t.sdkKey).push(t)), e;
              }, new Map());
              p(t);
            }, [s, a, i]), e.useEffect(function () {
              m(!w || "loading" === w), _("fail" === w);
            }, [w]), e.useEffect(function () {
              c && f && (null == l || l.refreshActiveAppInfo());
            }, [c, f, l]);

            var _NM64 = NM(),
                E = _NM64.t,
                C = E("app_signal.unable_load2"),
                k = E("invite.loading"),
                A = E("dialog.btn_retry");

            return TH.exports.jsx(XW, u(u({
              open: c,
              className: r.panel,
              noCloseButton: !0
            }, t), {}, {
              children: f || h ? TH.exports.jsx(WA, {
                className: r.loadingOrErrorContainer,
                children: h ? TH.exports.jsxs(TH.exports.Fragment, {
                  children: [TH.exports.jsx(QA, {
                    className: VC(r.text, r.bottomMargin),
                    variant: "body1",
                    children: C
                  }), TH.exports.jsx(YA, {
                    onClick: x,
                    variant: "contained",
                    color: "primary",
                    size: "small",
                    children: A
                  })]
                }) : f && TH.exports.jsxs(TH.exports.Fragment, {
                  children: [TH.exports.jsx(dY, {
                    className: r.bottomMargin
                  }), TH.exports.jsx(QA, {
                    className: r.text,
                    variant: "body1",
                    noWrap: !0,
                    children: k
                  })]
                })
              }) : g ? TH.exports.jsx(mY, {
                name: g.name,
                icon: g.icon,
                sdkUsers: g.sdkUsers,
                onClickBack: function onClickBack() {
                  return v(null);
                }
              }) : TH.exports.jsxs(WA, {
                className: r.contentContainer,
                children: [TH.exports.jsx(QA, {
                  variant: "h3",
                  children: b
                }), null === (n = vY(y)) || void 0 === n ? void 0 : n.map(function (t, n) {
                  return TH.exports.jsx(e.Fragment, {
                    children: "string" == typeof t ? TH.exports.jsx(QA, {
                      className: VC(r.text, r.summary),
                      variant: "body1",
                      children: t
                    }) : t
                  }, n);
                }), TH.exports.jsx(PT, {
                  children: null == S ? void 0 : S.map(function (e) {
                    var t = e.icon,
                        n = e.appName,
                        r = e.link,
                        i = e.scopes,
                        o = e.sdkKey,
                        a = e.appId,
                        s = e.hideWhenNoUser;
                    var c = d.get(o);
                    return !s || c && 0 !== c.length ? TH.exports.jsx(_Y, {
                      appId: a,
                      link: r,
                      icon: t,
                      appName: n,
                      scopes: i,
                      sdkUsers: c,
                      onClick: function onClick() {
                        return (null == c ? void 0 : c.length) > 0 && v({
                          icon: t,
                          name: n,
                          sdkUsers: c
                        });
                      }
                    }, a) : null;
                  })
                })]
              })
            }));
          },
              yY = Ok(function (e) {
            return {
              contentContainer: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 1)
                }
              },
              title: {
                maxWidth: "60vw"
              }
            };
          }),
              wY = function wY(t) {
            var _NM65 = NM(),
                n = _NM65.t,
                _HH3 = HH(),
                r = _HH3.hasAst,
                i = _HH3.hasRmc,
                _e$useContext134 = e.useContext(jM),
                o = _e$useContext134.assistants,
                _e$useState303 = e.useState(""),
                _e$useState304 = _slicedToArray(_e$useState303, 2),
                a = _e$useState304[0],
                s = _e$useState304[1],
                _e$useState305 = e.useState(""),
                _e$useState306 = _slicedToArray(_e$useState305, 2),
                c = _e$useState306[0],
                l = _e$useState306[1],
                _e$useState307 = e.useState(!1),
                _e$useState308 = _slicedToArray(_e$useState307, 2),
                d = _e$useState308[0],
                u = _e$useState308[1],
                p = o.length > 0,
                h = Wz(r),
                _ = Wz(p),
                f = Wz(i);

            var m = "";
            "join" === a ? m = n("ast.tip") : "leave" === a && (m = n("ast.leave_tip")), "join" === c ? m = n("rmc.exist_notification_for_client_host") : "leave" === c && (m = n("rmc.not_exist_notification_for_client_host")), e.useEffect(function () {
              h !== r && r && !h || _ !== p && p && !_ ? (s("join"), u(!0)) : (h !== r && !r && h || _ !== p && !p && _) && (s("leave"), u(!0)), f !== i && i && !f ? (l("join"), u(!0)) : f !== i && !i && f && (l("leave"), u(!0));
            }, [i, o, s, l, u, r, p, h, _, f]);
            var g = yY();
            return m ? TH.exports.jsx(EW, {
              open: d,
              anchorEl: t.anchorElement,
              placement: "right-start",
              children: TH.exports.jsx(vK, {
                children: TH.exports.jsxs(WA, {
                  className: g.contentContainer,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    className: g.title,
                    noWrap: !0,
                    children: m
                  }), TH.exports.jsx(AF, {
                    iconType: "icon-close",
                    onClick: function onClick() {
                      return u(!1);
                    }
                  })]
                })
              })
            }) : TH.exports.jsx("div", {});
          },
              SY = Ok(function () {
            return {
              root: _defineProperty({
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginTop: "12px"
              }, "&:hover>p.".concat(kH, "-MuiTypography-root"), {
                visibility: "visible"
              }),
              topItem: {
                marginTop: "0"
              },
              indicator: {
                display: "flex",
                alignItems: "center",
                color: "rgba(255,255,255,0.54)",
                fontSize: "13px"
              },
              avatarWrap: {
                flexShrink: 0,
                margin: "0 8px 0 4px"
              },
              avatar: {
                display: "flex",
                alignItems: "center",
                width: "32px",
                height: "32px",
                borderRadius: "8px"
              },
              defaultAvatar: _defineProperty({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                background: "rgba(255, 255, 255, 0.09)"
              }, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "20px"
              }),
              name: {
                fontSize: "12px",
                alignItems: "start"
              },
              nameSuffix: {
                marginLeft: 3,
                fontSize: "12px",
                flexShrink: 0
              },
              infoWrap: {
                display: "flex",
                alignItems: "center"
              }
            };
          }),
              xY = function xY(e) {
            var t = e.sender,
                n = e.className,
                r = e.recordIndex,
                i = e.isSelfMsg,
                o = e.isLt,
                a = e.user,
                _NM66 = NM(),
                s = _NM66.t,
                c = SY(),
                l = i ? s("wc_chat.me") : t.name;

            return TH.exports.jsxs(WA, {
              className: VC(c.root, n, _defineProperty({}, c.topItem, 0 === r)),
              children: [TH.exports.jsx(WA, {
                className: c.avatarWrap,
                children: null != a && a.avatarUrl ? TH.exports.jsx(XA, {
                  component: "img",
                  className: c.avatar,
                  image: null == a ? void 0 : a.avatarUrl,
                  alt: ""
                }) : TH.exports.jsx(WA, {
                  component: "i",
                  className: c.defaultAvatar,
                  children: TH.exports.jsx(CF, {
                    type: "icon-avatar"
                  })
                })
              }), TH.exports.jsx(QA, {
                variant: "body1",
                title: l,
                className: c.name,
                noWrap: !0,
                children: l
              }), !o && TH.exports.jsx(QA, {
                variant: "body1",
                noWrap: !0,
                children: "".concat(s("wc_lt_item_captioner"))
              })]
            });
          };

          var EY = {},
              CY = "",
              kY = "";

          var AY = Ok(function (e) {
            return {
              ccHistoryPannel: {},
              list: {
                position: "relative",
                scrollbarColor: "#4c4545 #282828",
                scrollbarWidth: "thin",
                "& .ReactVirtualized__List::-webkit-scrollbar": {
                  width: "8px"
                },
                "& .ReactVirtualized__List::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: "100px"
                },
                height: "525px",
                marginTop: "10px"
              },
              message: {
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "0"
              },
              messagetext: _defineProperty({
                padding: "2px 14px",
                borderRadius: "4px"
              }, "& .".concat(kH, "-MuiListItemText-primary"), {
                fontSize: "13px"
              }),
              input: {
                "&:after": {
                  border: "none !important"
                },
                "&:before": {
                  border: "none !important"
                },
                "& input": {
                  paddingTop: "9px",
                  paddingBottom: "9px"
                }
              },
              sectionHeader: {
                padding: e.spacing(3, 0)
              },
              clear: _defineProperty({}, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "13px"
              }),
              powered: {
                fontSize: "11px",
                lineHeight: "12px",
                color: "#FFFFFF8A",
                textAlign: "end"
              },
              timestamp: {
                color: "rgba(255,255,255,0.34)",
                fontSize: "13px",
                marginRight: "5px"
              }
            };
          }),
              IY = function IY(t) {
            var _NM67 = NM(),
                n = _NM67.t,
                r = AY(),
                i = e.useContext(zM),
                _e$useContext135 = e.useContext($M),
                o = _e$useContext135.ccClient;

            e.useState(0);

            var _e$useState309 = e.useState(""),
                _e$useState310 = _slicedToArray(_e$useState309, 2),
                a = _e$useState310[0],
                s = _e$useState310[1],
                _e$useContext136 = e.useContext(JM),
                c = _e$useContext136.isShowCC.history,
                l = _e$useContext136.dispatch,
                _e$useContext137 = e.useContext(jM),
                d = _e$useContext137.userId,
                p = _e$useContext137.participants,
                h = _e$useContext137.ccStatus,
                _zF3 = zF(i, o),
                _ = _zF3.histories,
                f = _zF3.markReadIndex,
                m = e.useRef(null),
                g = e.useRef(new TK({
              defaultHeight: 40,
              fixedWidth: !0
            })),
                v = e.useRef(!0),
                b = e.useCallback(function (e) {
              s(e.target.value);
            }, []),
                y = e.useCallback(function () {
              s("");
            }, []),
                w = e.useCallback(function () {
              null == l || l(GB(!1)), null == l || l(QB(!1)), null == l || l(KB(!1));
            }, [l]),
                S = e.useMemo(function () {
              var e = _toConsumableArray(_);

              return a && "" !== a.trim() && (e = _.filter(function (e) {
                return e.text.toUpperCase().indexOf(a.toUpperCase()) > -1;
              })), e.filter(function (e) {
                return e.finished && e.text;
              });
            }, [a, _]),
                x = Wz(_),
                E = _.length;

            if (null != x && x.length && E) {
              var _e314 = x[x.length - 1],
                  _t160 = _[E - 1];

              var _n103 = !1;

              if (_t160 && _e314 && (_e314.srcMsgID !== _t160.srcMsgID || _t160.finished !== _e314.finished || _e314.text !== _t160.text) && (_n103 = !0), _n103) g.current.clearAll();else for (var _r72 = 0; _r72 < x.length; _r72++) {
                if (_[_r72] && x[_r72].srcMsgID !== _[_r72].srcMsgID) {
                  g.current.clearAll();
                  break;
                }
              }
            }

            var C = e.useCallback(function (e) {
              var t, n, i;
              var o = e.index,
                  a = e.key,
                  s = e.style,
                  c = e.parent;
              var l = S[o];
              if (null == l || !l.text) return null;

              var u = (null === (t = EY) || void 0 === t ? void 0 : t.userId) !== (null == l || null === (n = l.sender) || void 0 === n ? void 0 : n.userId) || 0 === o || !(null != l && l.srcMsgID) !== kY,
                  h = d === (null == l || null === (i = l.sender) || void 0 === i ? void 0 : i.userId),
                  _ = function (e) {
                var t = new Date(e);
                return t.setMinutes(t.getMinutes() - t.getTimezoneOffset()), t.toJSON().slice(11, 19);
              }(l.timeStamp),
                  f = CY !== _ || l.srcMsgID;

              return CY = _, EY = p.find(function (e) {
                return e.userId === l.sender.userId;
              }), kY = !(null != l && l.srcMsgID), TH.exports.jsx(kK, {
                cache: g.current,
                columnIndex: 0,
                parent: c,
                rowIndex: o,
                children: TH.exports.jsxs(zT, {
                  style: s,
                  className: r.message,
                  children: [u && TH.exports.jsx(xY, {
                    sender: l.sender,
                    isSelfMsg: h,
                    currentUserId: d,
                    recordIndex: o,
                    isLt: !(null == l || !l.srcMsgID),
                    user: EY
                  }), f && TH.exports.jsx(VT, {
                    children: TH.exports.jsx(QA, {
                      className: r.timestamp,
                      children: _
                    })
                  }), TH.exports.jsx(VT, {
                    primary: l.text,
                    className: r.messagetext
                  })]
                }, o)
              }, l.id || l.srcMsgID || a);
            }, [S, d, r, p]),
                k = e.useCallback(function (e) {
              var t = e.stopIndex;
              f(t);
            }, [f]),
                A = e.useCallback(VG(function (e) {
              var t = e.clientHeight,
                  n = e.scrollHeight,
                  r = e.scrollTop;
              v.current = n - t - r <= 50;
            }, 200), []);
            var I;
            return e.useEffect(function () {
              if (v.current) {
                var e;

                var _t161 = S.length - 1;

                null === (e = m.current) || void 0 === e || e.scrollToRow(_t161);
              }
            }, [S]), I = h.isMeetingEnabledLiveTranscriptionFeature ? n("wc_lt_live_transcript") : n("wc_closed_caption_btn"), TH.exports.jsxs(XW, u(u({
              title: I,
              open: c,
              onClose: w,
              className: r.ccHistoryPannel
            }, t), {}, {
              children: [TH.exports.jsx(WA, {
                children: TH.exports.jsx(vO, {
                  onChange: b,
                  value: a,
                  className: r.input,
                  fullWidth: !0,
                  placeholder: n("wc_lt_search_text"),
                  margin: "dense",
                  startAdornment: TH.exports.jsx(ET, {
                    position: "start",
                    children: TH.exports.jsx(CF, {
                      type: "icon-search",
                      iconStyle: {
                        fontSize: "12px"
                      }
                    })
                  }),
                  endAdornment: TH.exports.jsx(ET, {
                    position: "end",
                    children: TH.exports.jsx(AF, {
                      className: r.clear,
                      "aria-label": "clear input",
                      onClick: y,
                      iconType: "icon-close"
                    })
                  })
                })
              }), TH.exports.jsx(WA, {
                className: r.list,
                children: TH.exports.jsx(jK, {
                  children: function children(e) {
                    var t = e.width,
                        n = e.height;
                    return TH.exports.jsx(_W, {
                      ref: m,
                      width: t,
                      height: n,
                      rowHeight: g.current.rowHeight,
                      deferredMeasurementCache: g.current,
                      rowRenderer: C,
                      rowCount: _.length,
                      onRowsRendered: k,
                      onScroll: A
                    });
                  }
                })
              }), h.isLTEnable && TH.exports.jsxs("div", {
                className: r.powered,
                children: [n("Powered by Otter.ai"), "\u2122"]
              })]
            }));
          };

          var TY = {
            exports: {}
          };
          !function (e, t) {
            (function () {
              var n,
                  r = "Expected a function",
                  i = "__lodash_hash_undefined__",
                  o = "__lodash_placeholder__",
                  a = 16,
                  s = 32,
                  c = 64,
                  l = 128,
                  d = 256,
                  u = 1 / 0,
                  p = 9007199254740991,
                  h = NaN,
                  _ = 4294967295,
                  f = [["ary", l], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", a], ["flip", 512], ["partial", s], ["partialRight", c], ["rearg", d]],
                  m = "[object Arguments]",
                  g = "[object Array]",
                  v = "[object Boolean]",
                  b = "[object Date]",
                  y = "[object Error]",
                  w = "[object Function]",
                  S = "[object GeneratorFunction]",
                  x = "[object Map]",
                  E = "[object Number]",
                  C = "[object Object]",
                  k = "[object Promise]",
                  A = "[object RegExp]",
                  I = "[object Set]",
                  T = "[object String]",
                  O = "[object Symbol]",
                  R = "[object WeakMap]",
                  N = "[object ArrayBuffer]",
                  P = "[object DataView]",
                  j = "[object Float32Array]",
                  D = "[object Float64Array]",
                  z = "[object Int8Array]",
                  M = "[object Int16Array]",
                  L = "[object Int32Array]",
                  U = "[object Uint8Array]",
                  B = "[object Uint8ClampedArray]",
                  H = "[object Uint16Array]",
                  V = "[object Uint32Array]",
                  q = /\b__p \+= '';/g,
                  F = /\b(__p \+=) '' \+/g,
                  W = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
                  G = /&(?:amp|lt|gt|quot|#39);/g,
                  K = /[&<>"']/g,
                  Q = RegExp(G.source),
                  Z = RegExp(K.source),
                  Y = /<%-([\s\S]+?)%>/g,
                  J = /<%([\s\S]+?)%>/g,
                  $ = /<%=([\s\S]+?)%>/g,
                  X = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
                  ee = /^\w*$/,
                  te = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
                  ne = /[\\^$.*+?()[\]{}|]/g,
                  re = RegExp(ne.source),
                  ie = /^\s+/,
                  oe = /\s/,
                  ae = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
                  se = /\{\n\/\* \[wrapped with (.+)\] \*/,
                  ce = /,? & /,
                  le = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
                  de = /[()=,{}\[\]\/\s]/,
                  ue = /\\(\\)?/g,
                  pe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
                  he = /\w*$/,
                  _e = /^[-+]0x[0-9a-f]+$/i,
                  fe = /^0b[01]+$/i,
                  me = /^\[object .+?Constructor\]$/,
                  ge = /^0o[0-7]+$/i,
                  ve = /^(?:0|[1-9]\d*)$/,
                  be = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
                  ye = /($^)/,
                  we = /['\n\r\u2028\u2029\\]/g,
                  Se = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
                  xe = "a-z\\xdf-\\xf6\\xf8-\\xff",
                  Ee = "A-Z\\xc0-\\xd6\\xd8-\\xde",
                  Ce = "\\ufe0e\\ufe0f",
                  ke = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
                  Ae = "['\u2019]",
                  Ie = "[\\ud800-\\udfff]",
                  Te = "[" + ke + "]",
                  Oe = "[" + Se + "]",
                  Re = "\\d+",
                  Ne = "[\\u2700-\\u27bf]",
                  Pe = "[" + xe + "]",
                  je = "[^\\ud800-\\udfff" + ke + Re + "\\u2700-\\u27bf" + xe + Ee + "]",
                  De = "\\ud83c[\\udffb-\\udfff]",
                  ze = "[^\\ud800-\\udfff]",
                  Me = "(?:\\ud83c[\\udde6-\\uddff]){2}",
                  Le = "[\\ud800-\\udbff][\\udc00-\\udfff]",
                  Ue = "[" + Ee + "]",
                  Be = "(?:" + Pe + "|" + je + ")",
                  He = "(?:" + Ue + "|" + je + ")",
                  Ve = "(?:['\u2019](?:d|ll|m|re|s|t|ve))?",
                  qe = "(?:['\u2019](?:D|LL|M|RE|S|T|VE))?",
                  Fe = "(?:" + Oe + "|" + De + ")?",
                  We = "[\\ufe0e\\ufe0f]?",
                  Ge = We + Fe + "(?:\\u200d(?:" + [ze, Me, Le].join("|") + ")" + We + Fe + ")*",
                  Ke = "(?:" + [Ne, Me, Le].join("|") + ")" + Ge,
                  Qe = "(?:" + [ze + Oe + "?", Oe, Me, Le, Ie].join("|") + ")",
                  Ze = RegExp(Ae, "g"),
                  Ye = RegExp(Oe, "g"),
                  Je = RegExp(De + "(?=" + De + ")|" + Qe + Ge, "g"),
                  $e = RegExp([Ue + "?" + Pe + "+" + Ve + "(?=" + [Te, Ue, "$"].join("|") + ")", He + "+" + qe + "(?=" + [Te, Ue + Be, "$"].join("|") + ")", Ue + "?" + Be + "+" + Ve, Ue + "+" + qe, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Re, Ke].join("|"), "g"),
                  Xe = RegExp("[\\u200d\\ud800-\\udfff" + Se + Ce + "]"),
                  et = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
                  tt = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
                  nt = -1,
                  rt = {};
              rt[j] = rt[D] = rt[z] = rt[M] = rt[L] = rt[U] = rt[B] = rt[H] = rt[V] = !0, rt[m] = rt[g] = rt[N] = rt[v] = rt[P] = rt[b] = rt[y] = rt[w] = rt[x] = rt[E] = rt[C] = rt[A] = rt[I] = rt[T] = rt[R] = !1;
              var it = {};
              it[m] = it[g] = it[N] = it[P] = it[v] = it[b] = it[j] = it[D] = it[z] = it[M] = it[L] = it[x] = it[E] = it[C] = it[A] = it[I] = it[T] = it[O] = it[U] = it[B] = it[H] = it[V] = !0, it[y] = it[w] = it[R] = !1;

              var ot = {
                "\\": "\\",
                "'": "'",
                "\n": "n",
                "\r": "r",
                "\u2028": "u2028",
                "\u2029": "u2029"
              },
                  at = parseFloat,
                  st = parseInt,
                  ct = "object" == typeof Ay && Ay && Ay.Object === Object && Ay,
                  lt = "object" == typeof self && self && self.Object === Object && self,
                  dt = ct || lt || Function("return this")(),
                  ut = t && !t.nodeType && t,
                  pt = ut && e && !e.nodeType && e,
                  ht = pt && pt.exports === ut,
                  _t = ht && ct.process,
                  ft = function () {
                try {
                  return pt && pt.require && pt.require("util").types || _t && _t.binding && _t.binding("util");
                } catch (e) {}
              }(),
                  mt = ft && ft.isArrayBuffer,
                  gt = ft && ft.isDate,
                  vt = ft && ft.isMap,
                  bt = ft && ft.isRegExp,
                  yt = ft && ft.isSet,
                  wt = ft && ft.isTypedArray;

              function St(e, t, n) {
                switch (n.length) {
                  case 0:
                    return e.call(t);

                  case 1:
                    return e.call(t, n[0]);

                  case 2:
                    return e.call(t, n[0], n[1]);

                  case 3:
                    return e.call(t, n[0], n[1], n[2]);
                }

                return e.apply(t, n);
              }

              function xt(e, t, n, r) {
                for (var i = -1, o = null == e ? 0 : e.length; ++i < o;) {
                  var a = e[i];
                  t(r, a, n(a), e);
                }

                return r;
              }

              function Et(e, t) {
                for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
                  ;
                }

                return e;
              }

              function Ct(e, t) {
                for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e);) {
                  ;
                }

                return e;
              }

              function kt(e, t) {
                for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
                  if (!t(e[n], n, e)) return !1;
                }

                return !0;
              }

              function At(e, t) {
                for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
                  var a = e[n];
                  t(a, n, e) && (o[i++] = a);
                }

                return o;
              }

              function It(e, t) {
                return !(null == e || !e.length) && Lt(e, t, 0) > -1;
              }

              function Tt(e, t, n) {
                for (var r = -1, i = null == e ? 0 : e.length; ++r < i;) {
                  if (n(t, e[r])) return !0;
                }

                return !1;
              }

              function Ot(e, t) {
                for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) {
                  i[n] = t(e[n], n, e);
                }

                return i;
              }

              function Rt(e, t) {
                for (var n = -1, r = t.length, i = e.length; ++n < r;) {
                  e[i + n] = t[n];
                }

                return e;
              }

              function Nt(e, t, n, r) {
                var i = -1,
                    o = null == e ? 0 : e.length;

                for (r && o && (n = e[++i]); ++i < o;) {
                  n = t(n, e[i], i, e);
                }

                return n;
              }

              function Pt(e, t, n, r) {
                var i = null == e ? 0 : e.length;

                for (r && i && (n = e[--i]); i--;) {
                  n = t(n, e[i], i, e);
                }

                return n;
              }

              function jt(e, t) {
                for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
                  if (t(e[n], n, e)) return !0;
                }

                return !1;
              }

              var Dt = Vt("length");

              function zt(e, t, n) {
                var r;
                return n(e, function (e, n, i) {
                  if (t(e, n, i)) return r = n, !1;
                }), r;
              }

              function Mt(e, t, n, r) {
                for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) {
                  if (t(e[o], o, e)) return o;
                }

                return -1;
              }

              function Lt(e, t, n) {
                return t == t ? function (e, t, n) {
                  for (var r = n - 1, i = e.length; ++r < i;) {
                    if (e[r] === t) return r;
                  }

                  return -1;
                }(e, t, n) : Mt(e, Bt, n);
              }

              function Ut(e, t, n, r) {
                for (var i = n - 1, o = e.length; ++i < o;) {
                  if (r(e[i], t)) return i;
                }

                return -1;
              }

              function Bt(e) {
                return e != e;
              }

              function Ht(e, t) {
                var n = null == e ? 0 : e.length;
                return n ? Wt(e, t) / n : h;
              }

              function Vt(e) {
                return function (t) {
                  return null == t ? n : t[e];
                };
              }

              function qt(e) {
                return function (t) {
                  return null == e ? n : e[t];
                };
              }

              function Ft(e, t, n, r, i) {
                return i(e, function (e, i, o) {
                  n = r ? (r = !1, e) : t(n, e, i, o);
                }), n;
              }

              function Wt(e, t) {
                for (var r, i = -1, o = e.length; ++i < o;) {
                  var a = t(e[i]);
                  a !== n && (r = r === n ? a : r + a);
                }

                return r;
              }

              function Gt(e, t) {
                for (var n = -1, r = Array(e); ++n < e;) {
                  r[n] = t(n);
                }

                return r;
              }

              function Kt(e) {
                return e ? e.slice(0, pn(e) + 1).replace(ie, "") : e;
              }

              function Qt(e) {
                return function (t) {
                  return e(t);
                };
              }

              function Zt(e, t) {
                return Ot(t, function (t) {
                  return e[t];
                });
              }

              function Yt(e, t) {
                return e.has(t);
              }

              function Jt(e, t) {
                for (var n = -1, r = e.length; ++n < r && Lt(t, e[n], 0) > -1;) {
                  ;
                }

                return n;
              }

              function $t(e, t) {
                for (var n = e.length; n-- && Lt(t, e[n], 0) > -1;) {
                  ;
                }

                return n;
              }

              function Xt(e, t) {
                for (var n = e.length, r = 0; n--;) {
                  e[n] === t && ++r;
                }

                return r;
              }

              var en = qt({
                "\xc0": "A",
                "\xc1": "A",
                "\xc2": "A",
                "\xc3": "A",
                "\xc4": "A",
                "\xc5": "A",
                "\xe0": "a",
                "\xe1": "a",
                "\xe2": "a",
                "\xe3": "a",
                "\xe4": "a",
                "\xe5": "a",
                "\xc7": "C",
                "\xe7": "c",
                "\xd0": "D",
                "\xf0": "d",
                "\xc8": "E",
                "\xc9": "E",
                "\xca": "E",
                "\xcb": "E",
                "\xe8": "e",
                "\xe9": "e",
                "\xea": "e",
                "\xeb": "e",
                "\xcc": "I",
                "\xcd": "I",
                "\xce": "I",
                "\xcf": "I",
                "\xec": "i",
                "\xed": "i",
                "\xee": "i",
                "\xef": "i",
                "\xd1": "N",
                "\xf1": "n",
                "\xd2": "O",
                "\xd3": "O",
                "\xd4": "O",
                "\xd5": "O",
                "\xd6": "O",
                "\xd8": "O",
                "\xf2": "o",
                "\xf3": "o",
                "\xf4": "o",
                "\xf5": "o",
                "\xf6": "o",
                "\xf8": "o",
                "\xd9": "U",
                "\xda": "U",
                "\xdb": "U",
                "\xdc": "U",
                "\xf9": "u",
                "\xfa": "u",
                "\xfb": "u",
                "\xfc": "u",
                "\xdd": "Y",
                "\xfd": "y",
                "\xff": "y",
                "\xc6": "Ae",
                "\xe6": "ae",
                "\xde": "Th",
                "\xfe": "th",
                "\xdf": "ss",
                "\u0100": "A",
                "\u0102": "A",
                "\u0104": "A",
                "\u0101": "a",
                "\u0103": "a",
                "\u0105": "a",
                "\u0106": "C",
                "\u0108": "C",
                "\u010A": "C",
                "\u010C": "C",
                "\u0107": "c",
                "\u0109": "c",
                "\u010B": "c",
                "\u010D": "c",
                "\u010E": "D",
                "\u0110": "D",
                "\u010F": "d",
                "\u0111": "d",
                "\u0112": "E",
                "\u0114": "E",
                "\u0116": "E",
                "\u0118": "E",
                "\u011A": "E",
                "\u0113": "e",
                "\u0115": "e",
                "\u0117": "e",
                "\u0119": "e",
                "\u011B": "e",
                "\u011C": "G",
                "\u011E": "G",
                "\u0120": "G",
                "\u0122": "G",
                "\u011D": "g",
                "\u011F": "g",
                "\u0121": "g",
                "\u0123": "g",
                "\u0124": "H",
                "\u0126": "H",
                "\u0125": "h",
                "\u0127": "h",
                "\u0128": "I",
                "\u012A": "I",
                "\u012C": "I",
                "\u012E": "I",
                "\u0130": "I",
                "\u0129": "i",
                "\u012B": "i",
                "\u012D": "i",
                "\u012F": "i",
                "\u0131": "i",
                "\u0134": "J",
                "\u0135": "j",
                "\u0136": "K",
                "\u0137": "k",
                "\u0138": "k",
                "\u0139": "L",
                "\u013B": "L",
                "\u013D": "L",
                "\u013F": "L",
                "\u0141": "L",
                "\u013A": "l",
                "\u013C": "l",
                "\u013E": "l",
                "\u0140": "l",
                "\u0142": "l",
                "\u0143": "N",
                "\u0145": "N",
                "\u0147": "N",
                "\u014A": "N",
                "\u0144": "n",
                "\u0146": "n",
                "\u0148": "n",
                "\u014B": "n",
                "\u014C": "O",
                "\u014E": "O",
                "\u0150": "O",
                "\u014D": "o",
                "\u014F": "o",
                "\u0151": "o",
                "\u0154": "R",
                "\u0156": "R",
                "\u0158": "R",
                "\u0155": "r",
                "\u0157": "r",
                "\u0159": "r",
                "\u015A": "S",
                "\u015C": "S",
                "\u015E": "S",
                "\u0160": "S",
                "\u015B": "s",
                "\u015D": "s",
                "\u015F": "s",
                "\u0161": "s",
                "\u0162": "T",
                "\u0164": "T",
                "\u0166": "T",
                "\u0163": "t",
                "\u0165": "t",
                "\u0167": "t",
                "\u0168": "U",
                "\u016A": "U",
                "\u016C": "U",
                "\u016E": "U",
                "\u0170": "U",
                "\u0172": "U",
                "\u0169": "u",
                "\u016B": "u",
                "\u016D": "u",
                "\u016F": "u",
                "\u0171": "u",
                "\u0173": "u",
                "\u0174": "W",
                "\u0175": "w",
                "\u0176": "Y",
                "\u0177": "y",
                "\u0178": "Y",
                "\u0179": "Z",
                "\u017B": "Z",
                "\u017D": "Z",
                "\u017A": "z",
                "\u017C": "z",
                "\u017E": "z",
                "\u0132": "IJ",
                "\u0133": "ij",
                "\u0152": "Oe",
                "\u0153": "oe",
                "\u0149": "'n",
                "\u017F": "s"
              }),
                  tn = qt({
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;"
              });

              function nn(e) {
                return "\\" + ot[e];
              }

              function rn(e) {
                return Xe.test(e);
              }

              function on(e) {
                var t = -1,
                    n = Array(e.size);
                return e.forEach(function (e, r) {
                  n[++t] = [r, e];
                }), n;
              }

              function an(e, t) {
                return function (n) {
                  return e(t(n));
                };
              }

              function sn(e, t) {
                for (var n = -1, r = e.length, i = 0, a = []; ++n < r;) {
                  var s = e[n];
                  s !== t && s !== o || (e[n] = o, a[i++] = n);
                }

                return a;
              }

              function cn(e) {
                var t = -1,
                    n = Array(e.size);
                return e.forEach(function (e) {
                  n[++t] = e;
                }), n;
              }

              function ln(e) {
                var t = -1,
                    n = Array(e.size);
                return e.forEach(function (e) {
                  n[++t] = [e, e];
                }), n;
              }

              function dn(e) {
                return rn(e) ? function (e) {
                  for (var t = Je.lastIndex = 0; Je.test(e);) {
                    ++t;
                  }

                  return t;
                }(e) : Dt(e);
              }

              function un(e) {
                return rn(e) ? function (e) {
                  return e.match(Je) || [];
                }(e) : function (e) {
                  return e.split("");
                }(e);
              }

              function pn(e) {
                for (var t = e.length; t-- && oe.test(e.charAt(t));) {
                  ;
                }

                return t;
              }

              var hn = qt({
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&#39;": "'"
              }),
                  _n = function e(t) {
                var oe,
                    Se = (t = null == t ? dt : _n.defaults(dt.Object(), t, _n.pick(dt, tt))).Array,
                    xe = t.Date,
                    Ee = t.Error,
                    Ce = t.Function,
                    ke = t.Math,
                    Ae = t.Object,
                    Ie = t.RegExp,
                    Te = t.String,
                    Oe = t.TypeError,
                    Re = Se.prototype,
                    Ne = Ce.prototype,
                    Pe = Ae.prototype,
                    je = t["__core-js_shared__"],
                    De = Ne.toString,
                    ze = Pe.hasOwnProperty,
                    Me = 0,
                    Le = (oe = /[^.]+$/.exec(je && je.keys && je.keys.IE_PROTO || "")) ? "Symbol(src)_1." + oe : "",
                    Ue = Pe.toString,
                    Be = De.call(Ae),
                    He = dt._,
                    Ve = Ie("^" + De.call(ze).replace(ne, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
                    qe = ht ? t.Buffer : n,
                    Fe = t.Symbol,
                    We = t.Uint8Array,
                    Ge = qe ? qe.allocUnsafe : n,
                    Ke = an(Ae.getPrototypeOf, Ae),
                    Qe = Ae.create,
                    Je = Pe.propertyIsEnumerable,
                    Xe = Re.splice,
                    ot = Fe ? Fe.isConcatSpreadable : n,
                    ct = Fe ? Fe.iterator : n,
                    lt = Fe ? Fe.toStringTag : n,
                    ut = function () {
                  try {
                    var e = _o(Ae, "defineProperty");

                    return e({}, "", {}), e;
                  } catch (e) {}
                }(),
                    pt = t.clearTimeout !== dt.clearTimeout && t.clearTimeout,
                    _t = xe && xe.now !== dt.Date.now && xe.now,
                    ft = t.setTimeout !== dt.setTimeout && t.setTimeout,
                    Dt = ke.ceil,
                    qt = ke.floor,
                    fn = Ae.getOwnPropertySymbols,
                    mn = qe ? qe.isBuffer : n,
                    gn = t.isFinite,
                    vn = Re.join,
                    bn = an(Ae.keys, Ae),
                    yn = ke.max,
                    wn = ke.min,
                    Sn = xe.now,
                    xn = t.parseInt,
                    En = ke.random,
                    Cn = Re.reverse,
                    kn = _o(t, "DataView"),
                    An = _o(t, "Map"),
                    In = _o(t, "Promise"),
                    Tn = _o(t, "Set"),
                    On = _o(t, "WeakMap"),
                    Rn = _o(Ae, "create"),
                    Nn = On && new On(),
                    Pn = {},
                    jn = Ho(kn),
                    Dn = Ho(An),
                    zn = Ho(In),
                    Mn = Ho(Tn),
                    Ln = Ho(On),
                    Un = Fe ? Fe.prototype : n,
                    Bn = Un ? Un.valueOf : n,
                    Hn = Un ? Un.toString : n;

                function Vn(e) {
                  if (is(e) && !Ka(e) && !(e instanceof Gn)) {
                    if (e instanceof Wn) return e;
                    if (ze.call(e, "__wrapped__")) return Vo(e);
                  }

                  return new Wn(e);
                }

                var qn = function () {
                  function e() {}

                  return function (t) {
                    if (!rs(t)) return {};
                    if (Qe) return Qe(t);
                    e.prototype = t;
                    var r = new e();
                    return e.prototype = n, r;
                  };
                }();

                function Fn() {}

                function Wn(e, t) {
                  this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
                }

                function Gn(e) {
                  this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = _, this.__views__ = [];
                }

                function Kn(e) {
                  var t = -1,
                      n = null == e ? 0 : e.length;

                  for (this.clear(); ++t < n;) {
                    var r = e[t];
                    this.set(r[0], r[1]);
                  }
                }

                function Qn(e) {
                  var t = -1,
                      n = null == e ? 0 : e.length;

                  for (this.clear(); ++t < n;) {
                    var r = e[t];
                    this.set(r[0], r[1]);
                  }
                }

                function Zn(e) {
                  var t = -1,
                      n = null == e ? 0 : e.length;

                  for (this.clear(); ++t < n;) {
                    var r = e[t];
                    this.set(r[0], r[1]);
                  }
                }

                function Yn(e) {
                  var t = -1,
                      n = null == e ? 0 : e.length;

                  for (this.__data__ = new Zn(); ++t < n;) {
                    this.add(e[t]);
                  }
                }

                function Jn(e) {
                  var t = this.__data__ = new Qn(e);
                  this.size = t.size;
                }

                function $n(e, t) {
                  var n = Ka(e),
                      r = !n && Ga(e),
                      i = !n && !r && Ja(e),
                      o = !n && !r && !i && ps(e),
                      a = n || r || i || o,
                      s = a ? Gt(e.length, Te) : [],
                      c = s.length;

                  for (var l in e) {
                    !t && !ze.call(e, l) || a && ("length" == l || i && ("offset" == l || "parent" == l) || o && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || wo(l, c)) || s.push(l);
                  }

                  return s;
                }

                function Xn(e) {
                  var t = e.length;
                  return t ? e[Yr(0, t - 1)] : n;
                }

                function er(e, t) {
                  return Lo(Ri(e), lr(t, 0, e.length));
                }

                function tr(e) {
                  return Lo(Ri(e));
                }

                function nr(e, t, r) {
                  (r !== n && !qa(e[t], r) || r === n && !(t in e)) && sr(e, t, r);
                }

                function rr(e, t, r) {
                  var i = e[t];
                  ze.call(e, t) && qa(i, r) && (r !== n || t in e) || sr(e, t, r);
                }

                function ir(e, t) {
                  for (var n = e.length; n--;) {
                    if (qa(e[n][0], t)) return n;
                  }

                  return -1;
                }

                function or(e, t, n, r) {
                  return _r(e, function (e, i, o) {
                    t(r, e, n(e), o);
                  }), r;
                }

                function ar(e, t) {
                  return e && Ni(t, js(t), e);
                }

                function sr(e, t, n) {
                  "__proto__" == t && ut ? ut(e, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: n,
                    writable: !0
                  }) : e[t] = n;
                }

                function cr(e, t) {
                  for (var r = -1, i = t.length, o = Se(i), a = null == e; ++r < i;) {
                    o[r] = a ? n : Ts(e, t[r]);
                  }

                  return o;
                }

                function lr(e, t, r) {
                  return e == e && (r !== n && (e = e <= r ? e : r), t !== n && (e = e >= t ? e : t)), e;
                }

                function dr(e, t, r, i, o, a) {
                  var s,
                      c = 1 & t,
                      l = 2 & t,
                      d = 4 & t;
                  if (r && (s = o ? r(e, i, o, a) : r(e)), s !== n) return s;
                  if (!rs(e)) return e;
                  var u = Ka(e);

                  if (u) {
                    if (s = function (e) {
                      var t = e.length,
                          n = new e.constructor(t);
                      return t && "string" == typeof e[0] && ze.call(e, "index") && (n.index = e.index, n.input = e.input), n;
                    }(e), !c) return Ri(e, s);
                  } else {
                    var p = go(e),
                        h = p == w || p == S;
                    if (Ja(e)) return Ci(e, c);

                    if (p == C || p == m || h && !o) {
                      if (s = l || h ? {} : bo(e), !c) return l ? function (e, t) {
                        return Ni(e, mo(e), t);
                      }(e, function (e, t) {
                        return e && Ni(t, Ds(t), e);
                      }(s, e)) : function (e, t) {
                        return Ni(e, fo(e), t);
                      }(e, ar(s, e));
                    } else {
                      if (!it[p]) return o ? e : {};

                      s = function (e, t, n) {
                        var r,
                            i = e.constructor;

                        switch (t) {
                          case N:
                            return ki(e);

                          case v:
                          case b:
                            return new i(+e);

                          case P:
                            return function (e, t) {
                              var n = t ? ki(e.buffer) : e.buffer;
                              return new e.constructor(n, e.byteOffset, e.byteLength);
                            }(e, n);

                          case j:
                          case D:
                          case z:
                          case M:
                          case L:
                          case U:
                          case B:
                          case H:
                          case V:
                            return Ai(e, n);

                          case x:
                            return new i();

                          case E:
                          case T:
                            return new i(e);

                          case A:
                            return function (e) {
                              var t = new e.constructor(e.source, he.exec(e));
                              return t.lastIndex = e.lastIndex, t;
                            }(e);

                          case I:
                            return new i();

                          case O:
                            return r = e, Bn ? Ae(Bn.call(r)) : {};
                        }
                      }(e, p, c);
                    }
                  }

                  a || (a = new Jn());

                  var _ = a.get(e);

                  if (_) return _;
                  a.set(e, s), ls(e) ? e.forEach(function (n) {
                    s.add(dr(n, t, r, n, e, a));
                  }) : os(e) && e.forEach(function (n, i) {
                    s.set(i, dr(n, t, r, i, e, a));
                  });
                  var f = u ? n : (d ? l ? ao : oo : l ? Ds : js)(e);
                  return Et(f || e, function (n, i) {
                    f && (n = e[i = n]), rr(s, i, dr(n, t, r, i, e, a));
                  }), s;
                }

                function ur(e, t, r) {
                  var i = r.length;
                  if (null == e) return !i;

                  for (e = Ae(e); i--;) {
                    var o = r[i],
                        a = t[o],
                        s = e[o];
                    if (s === n && !(o in e) || !a(s)) return !1;
                  }

                  return !0;
                }

                function pr(e, t, i) {
                  if ("function" != typeof e) throw new Oe(r);
                  return jo(function () {
                    e.apply(n, i);
                  }, t);
                }

                function hr(e, t, n, r) {
                  var i = -1,
                      o = It,
                      a = !0,
                      s = e.length,
                      c = [],
                      l = t.length;
                  if (!s) return c;
                  n && (t = Ot(t, Qt(n))), r ? (o = Tt, a = !1) : t.length >= 200 && (o = Yt, a = !1, t = new Yn(t));

                  e: for (; ++i < s;) {
                    var d = e[i],
                        u = null == n ? d : n(d);

                    if (d = r || 0 !== d ? d : 0, a && u == u) {
                      for (var p = l; p--;) {
                        if (t[p] === u) continue e;
                      }

                      c.push(d);
                    } else o(t, u, r) || c.push(d);
                  }

                  return c;
                }

                Vn.templateSettings = {
                  escape: Y,
                  evaluate: J,
                  interpolate: $,
                  variable: "",
                  imports: {
                    _: Vn
                  }
                }, Vn.prototype = Fn.prototype, Vn.prototype.constructor = Vn, Wn.prototype = qn(Fn.prototype), Wn.prototype.constructor = Wn, Gn.prototype = qn(Fn.prototype), Gn.prototype.constructor = Gn, Kn.prototype.clear = function () {
                  this.__data__ = Rn ? Rn(null) : {}, this.size = 0;
                }, Kn.prototype.delete = function (e) {
                  var t = this.has(e) && delete this.__data__[e];
                  return this.size -= t ? 1 : 0, t;
                }, Kn.prototype.get = function (e) {
                  var t = this.__data__;

                  if (Rn) {
                    var r = t[e];
                    return r === i ? n : r;
                  }

                  return ze.call(t, e) ? t[e] : n;
                }, Kn.prototype.has = function (e) {
                  var t = this.__data__;
                  return Rn ? t[e] !== n : ze.call(t, e);
                }, Kn.prototype.set = function (e, t) {
                  var r = this.__data__;
                  return this.size += this.has(e) ? 0 : 1, r[e] = Rn && t === n ? i : t, this;
                }, Qn.prototype.clear = function () {
                  this.__data__ = [], this.size = 0;
                }, Qn.prototype.delete = function (e) {
                  var t = this.__data__,
                      n = ir(t, e);
                  return !(n < 0) && (n == t.length - 1 ? t.pop() : Xe.call(t, n, 1), --this.size, !0);
                }, Qn.prototype.get = function (e) {
                  var t = this.__data__,
                      r = ir(t, e);
                  return r < 0 ? n : t[r][1];
                }, Qn.prototype.has = function (e) {
                  return ir(this.__data__, e) > -1;
                }, Qn.prototype.set = function (e, t) {
                  var n = this.__data__,
                      r = ir(n, e);
                  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
                }, Zn.prototype.clear = function () {
                  this.size = 0, this.__data__ = {
                    hash: new Kn(),
                    map: new (An || Qn)(),
                    string: new Kn()
                  };
                }, Zn.prototype.delete = function (e) {
                  var t = po(this, e).delete(e);
                  return this.size -= t ? 1 : 0, t;
                }, Zn.prototype.get = function (e) {
                  return po(this, e).get(e);
                }, Zn.prototype.has = function (e) {
                  return po(this, e).has(e);
                }, Zn.prototype.set = function (e, t) {
                  var n = po(this, e),
                      r = n.size;
                  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
                }, Yn.prototype.add = Yn.prototype.push = function (e) {
                  return this.__data__.set(e, i), this;
                }, Yn.prototype.has = function (e) {
                  return this.__data__.has(e);
                }, Jn.prototype.clear = function () {
                  this.__data__ = new Qn(), this.size = 0;
                }, Jn.prototype.delete = function (e) {
                  var t = this.__data__,
                      n = t.delete(e);
                  return this.size = t.size, n;
                }, Jn.prototype.get = function (e) {
                  return this.__data__.get(e);
                }, Jn.prototype.has = function (e) {
                  return this.__data__.has(e);
                }, Jn.prototype.set = function (e, t) {
                  var n = this.__data__;

                  if (n instanceof Qn) {
                    var r = n.__data__;
                    if (!An || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
                    n = this.__data__ = new Zn(r);
                  }

                  return n.set(e, t), this.size = n.size, this;
                };

                var _r = Di(Sr),
                    fr = Di(xr, !0);

                function mr(e, t) {
                  var n = !0;
                  return _r(e, function (e, r, i) {
                    return n = !!t(e, r, i);
                  }), n;
                }

                function gr(e, t, r) {
                  for (var i = -1, o = e.length; ++i < o;) {
                    var a = e[i],
                        s = t(a);
                    if (null != s && (c === n ? s == s && !us(s) : r(s, c))) var c = s,
                        l = a;
                  }

                  return l;
                }

                function vr(e, t) {
                  var n = [];
                  return _r(e, function (e, r, i) {
                    t(e, r, i) && n.push(e);
                  }), n;
                }

                function br(e, t, n, r, i) {
                  var o = -1,
                      a = e.length;

                  for (n || (n = yo), i || (i = []); ++o < a;) {
                    var s = e[o];
                    t > 0 && n(s) ? t > 1 ? br(s, t - 1, n, r, i) : Rt(i, s) : r || (i[i.length] = s);
                  }

                  return i;
                }

                var yr = zi(),
                    wr = zi(!0);

                function Sr(e, t) {
                  return e && yr(e, t, js);
                }

                function xr(e, t) {
                  return e && wr(e, t, js);
                }

                function Er(e, t) {
                  return At(t, function (t) {
                    return es(e[t]);
                  });
                }

                function Cr(e, t) {
                  for (var r = 0, i = (t = wi(t, e)).length; null != e && r < i;) {
                    e = e[Bo(t[r++])];
                  }

                  return r && r == i ? e : n;
                }

                function kr(e, t, n) {
                  var r = t(e);
                  return Ka(e) ? r : Rt(r, n(e));
                }

                function Ar(e) {
                  return null == e ? e === n ? "[object Undefined]" : "[object Null]" : lt && lt in Ae(e) ? function (e) {
                    var t = ze.call(e, lt),
                        r = e[lt];

                    try {
                      e[lt] = n;
                      var i = !0;
                    } catch (e) {}

                    var o = Ue.call(e);
                    return i && (t ? e[lt] = r : delete e[lt]), o;
                  }(e) : function (e) {
                    return Ue.call(e);
                  }(e);
                }

                function Ir(e, t) {
                  return e > t;
                }

                function Tr(e, t) {
                  return null != e && ze.call(e, t);
                }

                function Or(e, t) {
                  return null != e && t in Ae(e);
                }

                function Rr(e, t, r) {
                  for (var i = r ? Tt : It, o = e[0].length, a = e.length, s = a, c = Se(a), l = 1 / 0, d = []; s--;) {
                    var u = e[s];
                    s && t && (u = Ot(u, Qt(t))), l = wn(u.length, l), c[s] = !r && (t || o >= 120 && u.length >= 120) ? new Yn(s && u) : n;
                  }

                  u = e[0];
                  var p = -1,
                      h = c[0];

                  e: for (; ++p < o && d.length < l;) {
                    var _ = u[p],
                        f = t ? t(_) : _;

                    if (_ = r || 0 !== _ ? _ : 0, !(h ? Yt(h, f) : i(d, f, r))) {
                      for (s = a; --s;) {
                        var m = c[s];
                        if (!(m ? Yt(m, f) : i(e[s], f, r))) continue e;
                      }

                      h && h.push(f), d.push(_);
                    }
                  }

                  return d;
                }

                function Nr(e, t, r) {
                  var i = null == (e = Oo(e, t = wi(t, e))) ? e : e[Bo(Xo(t))];
                  return null == i ? n : St(i, e, r);
                }

                function Pr(e) {
                  return is(e) && Ar(e) == m;
                }

                function jr(e, t, r, i, o) {
                  return e === t || (null == e || null == t || !is(e) && !is(t) ? e != e && t != t : function (e, t, r, i, o, a) {
                    var s = Ka(e),
                        c = Ka(t),
                        l = s ? g : go(e),
                        d = c ? g : go(t),
                        u = (l = l == m ? C : l) == C,
                        p = (d = d == m ? C : d) == C,
                        h = l == d;

                    if (h && Ja(e)) {
                      if (!Ja(t)) return !1;
                      s = !0, u = !1;
                    }

                    if (h && !u) return a || (a = new Jn()), s || ps(e) ? ro(e, t, r, i, o, a) : function (e, t, n, r, i, o, a) {
                      switch (n) {
                        case P:
                          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                          e = e.buffer, t = t.buffer;

                        case N:
                          return !(e.byteLength != t.byteLength || !o(new We(e), new We(t)));

                        case v:
                        case b:
                        case E:
                          return qa(+e, +t);

                        case y:
                          return e.name == t.name && e.message == t.message;

                        case A:
                        case T:
                          return e == t + "";

                        case x:
                          var s = on;

                        case I:
                          var c = 1 & r;
                          if (s || (s = cn), e.size != t.size && !c) return !1;
                          var l = a.get(e);
                          if (l) return l == t;
                          r |= 2, a.set(e, t);
                          var d = ro(s(e), s(t), r, i, o, a);
                          return a.delete(e), d;

                        case O:
                          if (Bn) return Bn.call(e) == Bn.call(t);
                      }

                      return !1;
                    }(e, t, l, r, i, o, a);

                    if (!(1 & r)) {
                      var _ = u && ze.call(e, "__wrapped__"),
                          f = p && ze.call(t, "__wrapped__");

                      if (_ || f) {
                        var w = _ ? e.value() : e,
                            S = f ? t.value() : t;
                        return a || (a = new Jn()), o(w, S, r, i, a);
                      }
                    }

                    return !!h && (a || (a = new Jn()), function (e, t, r, i, o, a) {
                      var s = 1 & r,
                          c = oo(e),
                          l = c.length;
                      if (l != oo(t).length && !s) return !1;

                      for (var d = l; d--;) {
                        var u = c[d];
                        if (!(s ? u in t : ze.call(t, u))) return !1;
                      }

                      var p = a.get(e),
                          h = a.get(t);
                      if (p && h) return p == t && h == e;

                      var _ = !0;

                      a.set(e, t), a.set(t, e);

                      for (var f = s; ++d < l;) {
                        var m = e[u = c[d]],
                            g = t[u];
                        if (i) var v = s ? i(g, m, u, t, e, a) : i(m, g, u, e, t, a);

                        if (!(v === n ? m === g || o(m, g, r, i, a) : v)) {
                          _ = !1;
                          break;
                        }

                        f || (f = "constructor" == u);
                      }

                      if (_ && !f) {
                        var b = e.constructor,
                            y = t.constructor;
                        b == y || !("constructor" in e) || !("constructor" in t) || "function" == typeof b && b instanceof b && "function" == typeof y && y instanceof y || (_ = !1);
                      }

                      return a.delete(e), a.delete(t), _;
                    }(e, t, r, i, o, a));
                  }(e, t, r, i, jr, o));
                }

                function Dr(e, t, r, i) {
                  var o = r.length,
                      a = o,
                      s = !i;
                  if (null == e) return !a;

                  for (e = Ae(e); o--;) {
                    var c = r[o];
                    if (s && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
                  }

                  for (; ++o < a;) {
                    var l = (c = r[o])[0],
                        d = e[l],
                        u = c[1];

                    if (s && c[2]) {
                      if (d === n && !(l in e)) return !1;
                    } else {
                      var p = new Jn();
                      if (i) var h = i(d, u, l, e, t, p);
                      if (!(h === n ? jr(u, d, 3, i, p) : h)) return !1;
                    }
                  }

                  return !0;
                }

                function zr(e) {
                  return !(!rs(e) || (t = e, Le && Le in t)) && (es(e) ? Ve : me).test(Ho(e));
                  var t;
                }

                function Mr(e) {
                  return "function" == typeof e ? e : null == e ? ac : "object" == typeof e ? Ka(e) ? qr(e[0], e[1]) : Vr(e) : fc(e);
                }

                function Lr(e) {
                  if (!ko(e)) return bn(e);
                  var t = [];

                  for (var n in Ae(e)) {
                    ze.call(e, n) && "constructor" != n && t.push(n);
                  }

                  return t;
                }

                function Ur(e) {
                  if (!rs(e)) return function (e) {
                    var t = [];
                    if (null != e) for (var n in Ae(e)) {
                      t.push(n);
                    }
                    return t;
                  }(e);
                  var t = ko(e),
                      n = [];

                  for (var r in e) {
                    ("constructor" != r || !t && ze.call(e, r)) && n.push(r);
                  }

                  return n;
                }

                function Br(e, t) {
                  return e < t;
                }

                function Hr(e, t) {
                  var n = -1,
                      r = Za(e) ? Se(e.length) : [];
                  return _r(e, function (e, i, o) {
                    r[++n] = t(e, i, o);
                  }), r;
                }

                function Vr(e) {
                  var t = ho(e);
                  return 1 == t.length && t[0][2] ? Io(t[0][0], t[0][1]) : function (n) {
                    return n === e || Dr(n, e, t);
                  };
                }

                function qr(e, t) {
                  return xo(e) && Ao(t) ? Io(Bo(e), t) : function (r) {
                    var i = Ts(r, e);
                    return i === n && i === t ? Os(r, e) : jr(t, i, 3);
                  };
                }

                function Fr(e, t, r, i, o) {
                  e !== t && yr(t, function (a, s) {
                    if (o || (o = new Jn()), rs(a)) !function (e, t, r, i, o, a, s) {
                      var c = No(e, r),
                          l = No(t, r),
                          d = s.get(l);
                      if (d) nr(e, r, d);else {
                        var u = a ? a(c, l, r + "", e, t, s) : n,
                            p = u === n;

                        if (p) {
                          var h = Ka(l),
                              _ = !h && Ja(l),
                              f = !h && !_ && ps(l);

                          u = l, h || _ || f ? Ka(c) ? u = c : Ya(c) ? u = Ri(c) : _ ? (p = !1, u = Ci(l, !0)) : f ? (p = !1, u = Ai(l, !0)) : u = [] : ss(l) || Ga(l) ? (u = c, Ga(c) ? u = ys(c) : rs(c) && !es(c) || (u = bo(l))) : p = !1;
                        }

                        p && (s.set(l, u), o(u, l, i, a, s), s.delete(l)), nr(e, r, u);
                      }
                    }(e, t, s, r, Fr, i, o);else {
                      var c = i ? i(No(e, s), a, s + "", e, t, o) : n;
                      c === n && (c = a), nr(e, s, c);
                    }
                  }, Ds);
                }

                function Wr(e, t) {
                  var r = e.length;
                  if (r) return wo(t += t < 0 ? r : 0, r) ? e[t] : n;
                }

                function Gr(e, t, n) {
                  t = t.length ? Ot(t, function (e) {
                    return Ka(e) ? function (t) {
                      return Cr(t, 1 === e.length ? e[0] : e);
                    } : e;
                  }) : [ac];
                  var r = -1;
                  t = Ot(t, Qt(uo()));
                  var i = Hr(e, function (e, n, i) {
                    var o = Ot(t, function (t) {
                      return t(e);
                    });
                    return {
                      criteria: o,
                      index: ++r,
                      value: e
                    };
                  });
                  return function (e, t) {
                    var n = e.length;

                    for (e.sort(t); n--;) {
                      e[n] = e[n].value;
                    }

                    return e;
                  }(i, function (e, t) {
                    return function (e, t, n) {
                      for (var r = -1, i = e.criteria, o = t.criteria, a = i.length, s = n.length; ++r < a;) {
                        var c = Ii(i[r], o[r]);
                        if (c) return r >= s ? c : c * ("desc" == n[r] ? -1 : 1);
                      }

                      return e.index - t.index;
                    }(e, t, n);
                  });
                }

                function Kr(e, t, n) {
                  for (var r = -1, i = t.length, o = {}; ++r < i;) {
                    var a = t[r],
                        s = Cr(e, a);
                    n(s, a) && ti(o, wi(a, e), s);
                  }

                  return o;
                }

                function Qr(e, t, n, r) {
                  var i = r ? Ut : Lt,
                      o = -1,
                      a = t.length,
                      s = e;

                  for (e === t && (t = Ri(t)), n && (s = Ot(e, Qt(n))); ++o < a;) {
                    for (var c = 0, l = t[o], d = n ? n(l) : l; (c = i(s, d, c, r)) > -1;) {
                      s !== e && Xe.call(s, c, 1), Xe.call(e, c, 1);
                    }
                  }

                  return e;
                }

                function Zr(e, t) {
                  for (var n = e ? t.length : 0, r = n - 1; n--;) {
                    var i = t[n];

                    if (n == r || i !== o) {
                      var o = i;
                      wo(i) ? Xe.call(e, i, 1) : hi(e, i);
                    }
                  }

                  return e;
                }

                function Yr(e, t) {
                  return e + qt(En() * (t - e + 1));
                }

                function Jr(e, t) {
                  var n = "";
                  if (!e || t < 1 || t > p) return n;

                  do {
                    t % 2 && (n += e), (t = qt(t / 2)) && (e += e);
                  } while (t);

                  return n;
                }

                function $r(e, t) {
                  return Do(To(e, t, ac), e + "");
                }

                function Xr(e) {
                  return Xn(qs(e));
                }

                function ei(e, t) {
                  var n = qs(e);
                  return Lo(n, lr(t, 0, n.length));
                }

                function ti(e, t, r, i) {
                  if (!rs(e)) return e;

                  for (var o = -1, a = (t = wi(t, e)).length, s = a - 1, c = e; null != c && ++o < a;) {
                    var l = Bo(t[o]),
                        d = r;
                    if ("__proto__" === l || "constructor" === l || "prototype" === l) return e;

                    if (o != s) {
                      var u = c[l];
                      (d = i ? i(u, l, c) : n) === n && (d = rs(u) ? u : wo(t[o + 1]) ? [] : {});
                    }

                    rr(c, l, d), c = c[l];
                  }

                  return e;
                }

                var ni = Nn ? function (e, t) {
                  return Nn.set(e, t), e;
                } : ac,
                    ri = ut ? function (e, t) {
                  return ut(e, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: rc(t),
                    writable: !0
                  });
                } : ac;

                function ii(e) {
                  return Lo(qs(e));
                }

                function oi(e, t, n) {
                  var r = -1,
                      i = e.length;
                  t < 0 && (t = -t > i ? 0 : i + t), (n = n > i ? i : n) < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;

                  for (var o = Se(i); ++r < i;) {
                    o[r] = e[r + t];
                  }

                  return o;
                }

                function ai(e, t) {
                  var n;
                  return _r(e, function (e, r, i) {
                    return !(n = t(e, r, i));
                  }), !!n;
                }

                function si(e, t, n) {
                  var r = 0,
                      i = null == e ? r : e.length;

                  if ("number" == typeof t && t == t && i <= 2147483647) {
                    for (; r < i;) {
                      var o = r + i >>> 1,
                          a = e[o];
                      null !== a && !us(a) && (n ? a <= t : a < t) ? r = o + 1 : i = o;
                    }

                    return i;
                  }

                  return ci(e, t, ac, n);
                }

                function ci(e, t, r, i) {
                  var o = 0,
                      a = null == e ? 0 : e.length;
                  if (0 === a) return 0;

                  for (var s = (t = r(t)) != t, c = null === t, l = us(t), d = t === n; o < a;) {
                    var u = qt((o + a) / 2),
                        p = r(e[u]),
                        h = p !== n,
                        _ = null === p,
                        f = p == p,
                        m = us(p);

                    if (s) var g = i || f;else g = d ? f && (i || h) : c ? f && h && (i || !_) : l ? f && h && !_ && (i || !m) : !_ && !m && (i ? p <= t : p < t);
                    g ? o = u + 1 : a = u;
                  }

                  return wn(a, 4294967294);
                }

                function li(e, t) {
                  for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
                    var a = e[n],
                        s = t ? t(a) : a;

                    if (!n || !qa(s, c)) {
                      var c = s;
                      o[i++] = 0 === a ? 0 : a;
                    }
                  }

                  return o;
                }

                function di(e) {
                  return "number" == typeof e ? e : us(e) ? h : +e;
                }

                function ui(e) {
                  if ("string" == typeof e) return e;
                  if (Ka(e)) return Ot(e, ui) + "";
                  if (us(e)) return Hn ? Hn.call(e) : "";
                  var t = e + "";
                  return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }

                function pi(e, t, n) {
                  var r = -1,
                      i = It,
                      o = e.length,
                      a = !0,
                      s = [],
                      c = s;
                  if (n) a = !1, i = Tt;else if (o >= 200) {
                    var l = t ? null : Ji(e);
                    if (l) return cn(l);
                    a = !1, i = Yt, c = new Yn();
                  } else c = t ? [] : s;

                  e: for (; ++r < o;) {
                    var d = e[r],
                        u = t ? t(d) : d;

                    if (d = n || 0 !== d ? d : 0, a && u == u) {
                      for (var p = c.length; p--;) {
                        if (c[p] === u) continue e;
                      }

                      t && c.push(u), s.push(d);
                    } else i(c, u, n) || (c !== s && c.push(u), s.push(d));
                  }

                  return s;
                }

                function hi(e, t) {
                  return null == (e = Oo(e, t = wi(t, e))) || delete e[Bo(Xo(t))];
                }

                function _i(e, t, n, r) {
                  return ti(e, t, n(Cr(e, t)), r);
                }

                function fi(e, t, n, r) {
                  for (var i = e.length, o = r ? i : -1; (r ? o-- : ++o < i) && t(e[o], o, e);) {
                    ;
                  }

                  return n ? oi(e, r ? 0 : o, r ? o + 1 : i) : oi(e, r ? o + 1 : 0, r ? i : o);
                }

                function mi(e, t) {
                  var n = e;
                  return n instanceof Gn && (n = n.value()), Nt(t, function (e, t) {
                    return t.func.apply(t.thisArg, Rt([e], t.args));
                  }, n);
                }

                function gi(e, t, n) {
                  var r = e.length;
                  if (r < 2) return r ? pi(e[0]) : [];

                  for (var i = -1, o = Se(r); ++i < r;) {
                    for (var a = e[i], s = -1; ++s < r;) {
                      s != i && (o[i] = hr(o[i] || a, e[s], t, n));
                    }
                  }

                  return pi(br(o, 1), t, n);
                }

                function vi(e, t, r) {
                  for (var i = -1, o = e.length, a = t.length, s = {}; ++i < o;) {
                    var c = i < a ? t[i] : n;
                    r(s, e[i], c);
                  }

                  return s;
                }

                function bi(e) {
                  return Ya(e) ? e : [];
                }

                function yi(e) {
                  return "function" == typeof e ? e : ac;
                }

                function wi(e, t) {
                  return Ka(e) ? e : xo(e, t) ? [e] : Uo(ws(e));
                }

                var Si = $r;

                function xi(e, t, r) {
                  var i = e.length;
                  return r = r === n ? i : r, !t && r >= i ? e : oi(e, t, r);
                }

                var Ei = pt || function (e) {
                  return dt.clearTimeout(e);
                };

                function Ci(e, t) {
                  if (t) return e.slice();
                  var n = e.length,
                      r = Ge ? Ge(n) : new e.constructor(n);
                  return e.copy(r), r;
                }

                function ki(e) {
                  var t = new e.constructor(e.byteLength);
                  return new We(t).set(new We(e)), t;
                }

                function Ai(e, t) {
                  var n = t ? ki(e.buffer) : e.buffer;
                  return new e.constructor(n, e.byteOffset, e.length);
                }

                function Ii(e, t) {
                  if (e !== t) {
                    var r = e !== n,
                        i = null === e,
                        o = e == e,
                        a = us(e),
                        s = t !== n,
                        c = null === t,
                        l = t == t,
                        d = us(t);
                    if (!c && !d && !a && e > t || a && s && l && !c && !d || i && s && l || !r && l || !o) return 1;
                    if (!i && !a && !d && e < t || d && r && o && !i && !a || c && r && o || !s && o || !l) return -1;
                  }

                  return 0;
                }

                function Ti(e, t, n, r) {
                  for (var i = -1, o = e.length, a = n.length, s = -1, c = t.length, l = yn(o - a, 0), d = Se(c + l), u = !r; ++s < c;) {
                    d[s] = t[s];
                  }

                  for (; ++i < a;) {
                    (u || i < o) && (d[n[i]] = e[i]);
                  }

                  for (; l--;) {
                    d[s++] = e[i++];
                  }

                  return d;
                }

                function Oi(e, t, n, r) {
                  for (var i = -1, o = e.length, a = -1, s = n.length, c = -1, l = t.length, d = yn(o - s, 0), u = Se(d + l), p = !r; ++i < d;) {
                    u[i] = e[i];
                  }

                  for (var h = i; ++c < l;) {
                    u[h + c] = t[c];
                  }

                  for (; ++a < s;) {
                    (p || i < o) && (u[h + n[a]] = e[i++]);
                  }

                  return u;
                }

                function Ri(e, t) {
                  var n = -1,
                      r = e.length;

                  for (t || (t = Se(r)); ++n < r;) {
                    t[n] = e[n];
                  }

                  return t;
                }

                function Ni(e, t, r, i) {
                  var o = !r;
                  r || (r = {});

                  for (var a = -1, s = t.length; ++a < s;) {
                    var c = t[a],
                        l = i ? i(r[c], e[c], c, r, e) : n;
                    l === n && (l = e[c]), o ? sr(r, c, l) : rr(r, c, l);
                  }

                  return r;
                }

                function Pi(e, t) {
                  return function (n, r) {
                    var i = Ka(n) ? xt : or,
                        o = t ? t() : {};
                    return i(n, e, uo(r, 2), o);
                  };
                }

                function ji(e) {
                  return $r(function (t, r) {
                    var i = -1,
                        o = r.length,
                        a = o > 1 ? r[o - 1] : n,
                        s = o > 2 ? r[2] : n;

                    for (a = e.length > 3 && "function" == typeof a ? (o--, a) : n, s && So(r[0], r[1], s) && (a = o < 3 ? n : a, o = 1), t = Ae(t); ++i < o;) {
                      var c = r[i];
                      c && e(t, c, i, a);
                    }

                    return t;
                  });
                }

                function Di(e, t) {
                  return function (n, r) {
                    if (null == n) return n;
                    if (!Za(n)) return e(n, r);

                    for (var i = n.length, o = t ? i : -1, a = Ae(n); (t ? o-- : ++o < i) && !1 !== r(a[o], o, a);) {
                      ;
                    }

                    return n;
                  };
                }

                function zi(e) {
                  return function (t, n, r) {
                    for (var i = -1, o = Ae(t), a = r(t), s = a.length; s--;) {
                      var c = a[e ? s : ++i];
                      if (!1 === n(o[c], c, o)) break;
                    }

                    return t;
                  };
                }

                function Mi(e) {
                  return function (t) {
                    var r = rn(t = ws(t)) ? un(t) : n,
                        i = r ? r[0] : t.charAt(0),
                        o = r ? xi(r, 1).join("") : t.slice(1);
                    return i[e]() + o;
                  };
                }

                function Li(e) {
                  return function (t) {
                    return Nt(ec(Gs(t).replace(Ze, "")), e, "");
                  };
                }

                function Ui(e) {
                  return function () {
                    var t = arguments;

                    switch (t.length) {
                      case 0:
                        return new e();

                      case 1:
                        return new e(t[0]);

                      case 2:
                        return new e(t[0], t[1]);

                      case 3:
                        return new e(t[0], t[1], t[2]);

                      case 4:
                        return new e(t[0], t[1], t[2], t[3]);

                      case 5:
                        return new e(t[0], t[1], t[2], t[3], t[4]);

                      case 6:
                        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

                      case 7:
                        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }

                    var n = qn(e.prototype),
                        r = e.apply(n, t);
                    return rs(r) ? r : n;
                  };
                }

                function Bi(e) {
                  return function (t, r, i) {
                    var o = Ae(t);

                    if (!Za(t)) {
                      var a = uo(r, 3);
                      t = js(t), r = function r(e) {
                        return a(o[e], e, o);
                      };
                    }

                    var s = e(t, r, i);
                    return s > -1 ? o[a ? t[s] : s] : n;
                  };
                }

                function Hi(e) {
                  return io(function (t) {
                    var i = t.length,
                        o = i,
                        a = Wn.prototype.thru;

                    for (e && t.reverse(); o--;) {
                      var s = t[o];
                      if ("function" != typeof s) throw new Oe(r);
                      if (a && !c && "wrapper" == co(s)) var c = new Wn([], !0);
                    }

                    for (o = c ? o : i; ++o < i;) {
                      var l = co(s = t[o]),
                          d = "wrapper" == l ? so(s) : n;
                      c = d && Eo(d[0]) && 424 == d[1] && !d[4].length && 1 == d[9] ? c[co(d[0])].apply(c, d[3]) : 1 == s.length && Eo(s) ? c[l]() : c.thru(s);
                    }

                    return function () {
                      var e = arguments,
                          n = e[0];
                      if (c && 1 == e.length && Ka(n)) return c.plant(n).value();

                      for (var r = 0, o = i ? t[r].apply(this, e) : n; ++r < i;) {
                        o = t[r].call(this, o);
                      }

                      return o;
                    };
                  });
                }

                function Vi(e, t, r, i, o, a, s, c, d, u) {
                  var p = t & l,
                      h = 1 & t,
                      _ = 2 & t,
                      f = 24 & t,
                      m = 512 & t,
                      g = _ ? n : Ui(e);

                  return function n() {
                    for (var l = arguments.length, v = Se(l), b = l; b--;) {
                      v[b] = arguments[b];
                    }

                    if (f) var y = lo(n),
                        w = Xt(v, y);

                    if (i && (v = Ti(v, i, o, f)), a && (v = Oi(v, a, s, f)), l -= w, f && l < u) {
                      var S = sn(v, y);
                      return Zi(e, t, Vi, n.placeholder, r, v, S, c, d, u - l);
                    }

                    var x = h ? r : this,
                        E = _ ? x[e] : e;
                    return l = v.length, c ? v = Ro(v, c) : m && l > 1 && v.reverse(), p && d < l && (v.length = d), this && this !== dt && this instanceof n && (E = g || Ui(E)), E.apply(x, v);
                  };
                }

                function qi(e, t) {
                  return function (n, r) {
                    return function (e, t, n, r) {
                      return Sr(e, function (e, i, o) {
                        t(r, n(e), i, o);
                      }), r;
                    }(n, e, t(r), {});
                  };
                }

                function Fi(e, t) {
                  return function (r, i) {
                    var o;
                    if (r === n && i === n) return t;

                    if (r !== n && (o = r), i !== n) {
                      if (o === n) return i;
                      "string" == typeof r || "string" == typeof i ? (r = ui(r), i = ui(i)) : (r = di(r), i = di(i)), o = e(r, i);
                    }

                    return o;
                  };
                }

                function Wi(e) {
                  return io(function (t) {
                    return t = Ot(t, Qt(uo())), $r(function (n) {
                      var r = this;
                      return e(t, function (e) {
                        return St(e, r, n);
                      });
                    });
                  });
                }

                function Gi(e, t) {
                  var r = (t = t === n ? " " : ui(t)).length;
                  if (r < 2) return r ? Jr(t, e) : t;
                  var i = Jr(t, Dt(e / dn(t)));
                  return rn(t) ? xi(un(i), 0, e).join("") : i.slice(0, e);
                }

                function Ki(e) {
                  return function (t, r, i) {
                    return i && "number" != typeof i && So(t, r, i) && (r = i = n), t = ms(t), r === n ? (r = t, t = 0) : r = ms(r), function (e, t, n, r) {
                      for (var i = -1, o = yn(Dt((t - e) / (n || 1)), 0), a = Se(o); o--;) {
                        a[r ? o : ++i] = e, e += n;
                      }

                      return a;
                    }(t, r, i = i === n ? t < r ? 1 : -1 : ms(i), e);
                  };
                }

                function Qi(e) {
                  return function (t, n) {
                    return "string" == typeof t && "string" == typeof n || (t = bs(t), n = bs(n)), e(t, n);
                  };
                }

                function Zi(e, t, r, i, o, a, l, d, u, p) {
                  var h = 8 & t;
                  t |= h ? s : c, 4 & (t &= ~(h ? c : s)) || (t &= -4);
                  var _ = [e, t, o, h ? a : n, h ? l : n, h ? n : a, h ? n : l, d, u, p],
                      f = r.apply(n, _);
                  return Eo(e) && Po(f, _), f.placeholder = i, zo(f, e, t);
                }

                function Yi(e) {
                  var t = ke[e];
                  return function (e, n) {
                    if (e = bs(e), (n = null == n ? 0 : wn(gs(n), 292)) && gn(e)) {
                      var r = (ws(e) + "e").split("e");
                      return +((r = (ws(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
                    }

                    return t(e);
                  };
                }

                var Ji = Tn && 1 / cn(new Tn([, -0]))[1] == u ? function (e) {
                  return new Tn(e);
                } : uc;

                function $i(e) {
                  return function (t) {
                    var n = go(t);
                    return n == x ? on(t) : n == I ? ln(t) : function (e, t) {
                      return Ot(t, function (t) {
                        return [t, e[t]];
                      });
                    }(t, e(t));
                  };
                }

                function Xi(e, t, i, u, p, h, _, f) {
                  var m = 2 & t;
                  if (!m && "function" != typeof e) throw new Oe(r);
                  var g = u ? u.length : 0;

                  if (g || (t &= -97, u = p = n), _ = _ === n ? _ : yn(gs(_), 0), f = f === n ? f : gs(f), g -= p ? p.length : 0, t & c) {
                    var v = u,
                        b = p;
                    u = p = n;
                  }

                  var y = m ? n : so(e),
                      w = [e, t, i, u, p, v, b, h, _, f];
                  if (y && function (e, t) {
                    var n = e[1],
                        r = t[1],
                        i = n | r,
                        a = i < 131,
                        s = r == l && 8 == n || r == l && n == d && e[7].length <= t[8] || 384 == r && t[7].length <= t[8] && 8 == n;
                    if (!a && !s) return e;
                    1 & r && (e[2] = t[2], i |= 1 & n ? 0 : 4);
                    var c = t[3];

                    if (c) {
                      var u = e[3];
                      e[3] = u ? Ti(u, c, t[4]) : c, e[4] = u ? sn(e[3], o) : t[4];
                    }

                    (c = t[5]) && (u = e[5], e[5] = u ? Oi(u, c, t[6]) : c, e[6] = u ? sn(e[5], o) : t[6]), (c = t[7]) && (e[7] = c), r & l && (e[8] = null == e[8] ? t[8] : wn(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = i;
                  }(w, y), e = w[0], t = w[1], i = w[2], u = w[3], p = w[4], !(f = w[9] = w[9] === n ? m ? 0 : e.length : yn(w[9] - g, 0)) && 24 & t && (t &= -25), t && 1 != t) S = 8 == t || t == a ? function (e, t, r) {
                    var i = Ui(e);
                    return function o() {
                      for (var a = arguments.length, s = Se(a), c = a, l = lo(o); c--;) {
                        s[c] = arguments[c];
                      }

                      var d = a < 3 && s[0] !== l && s[a - 1] !== l ? [] : sn(s, l);
                      return (a -= d.length) < r ? Zi(e, t, Vi, o.placeholder, n, s, d, n, n, r - a) : St(this && this !== dt && this instanceof o ? i : e, this, s);
                    };
                  }(e, t, f) : t != s && 33 != t || p.length ? Vi.apply(n, w) : function (e, t, n, r) {
                    var i = 1 & t,
                        o = Ui(e);
                    return function t() {
                      for (var a = -1, s = arguments.length, c = -1, l = r.length, d = Se(l + s), u = this && this !== dt && this instanceof t ? o : e; ++c < l;) {
                        d[c] = r[c];
                      }

                      for (; s--;) {
                        d[c++] = arguments[++a];
                      }

                      return St(u, i ? n : this, d);
                    };
                  }(e, t, i, u);else var S = function (e, t, n) {
                    var r = 1 & t,
                        i = Ui(e);
                    return function t() {
                      return (this && this !== dt && this instanceof t ? i : e).apply(r ? n : this, arguments);
                    };
                  }(e, t, i);
                  return zo((y ? ni : Po)(S, w), e, t);
                }

                function eo(e, t, r, i) {
                  return e === n || qa(e, Pe[r]) && !ze.call(i, r) ? t : e;
                }

                function to(e, t, r, i, o, a) {
                  return rs(e) && rs(t) && (a.set(t, e), Fr(e, t, n, to, a), a.delete(t)), e;
                }

                function no(e) {
                  return ss(e) ? n : e;
                }

                function ro(e, t, r, i, o, a) {
                  var s = 1 & r,
                      c = e.length,
                      l = t.length;
                  if (c != l && !(s && l > c)) return !1;
                  var d = a.get(e),
                      u = a.get(t);
                  if (d && u) return d == t && u == e;

                  var p = -1,
                      h = !0,
                      _ = 2 & r ? new Yn() : n;

                  for (a.set(e, t), a.set(t, e); ++p < c;) {
                    var f = e[p],
                        m = t[p];
                    if (i) var g = s ? i(m, f, p, t, e, a) : i(f, m, p, e, t, a);

                    if (g !== n) {
                      if (g) continue;
                      h = !1;
                      break;
                    }

                    if (_) {
                      if (!jt(t, function (e, t) {
                        if (!Yt(_, t) && (f === e || o(f, e, r, i, a))) return _.push(t);
                      })) {
                        h = !1;
                        break;
                      }
                    } else if (f !== m && !o(f, m, r, i, a)) {
                      h = !1;
                      break;
                    }
                  }

                  return a.delete(e), a.delete(t), h;
                }

                function io(e) {
                  return Do(To(e, n, Qo), e + "");
                }

                function oo(e) {
                  return kr(e, js, fo);
                }

                function ao(e) {
                  return kr(e, Ds, mo);
                }

                var so = Nn ? function (e) {
                  return Nn.get(e);
                } : uc;

                function co(e) {
                  for (var t = e.name + "", n = Pn[t], r = ze.call(Pn, t) ? n.length : 0; r--;) {
                    var i = n[r],
                        o = i.func;
                    if (null == o || o == e) return i.name;
                  }

                  return t;
                }

                function lo(e) {
                  return (ze.call(Vn, "placeholder") ? Vn : e).placeholder;
                }

                function uo() {
                  var e = Vn.iteratee || sc;
                  return e = e === sc ? Mr : e, arguments.length ? e(arguments[0], arguments[1]) : e;
                }

                function po(e, t) {
                  var n,
                      r,
                      i = e.__data__;
                  return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                }

                function ho(e) {
                  for (var t = js(e), n = t.length; n--;) {
                    var r = t[n],
                        i = e[r];
                    t[n] = [r, i, Ao(i)];
                  }

                  return t;
                }

                function _o(e, t) {
                  var r = function (e, t) {
                    return null == e ? n : e[t];
                  }(e, t);

                  return zr(r) ? r : n;
                }

                var fo = fn ? function (e) {
                  return null == e ? [] : (e = Ae(e), At(fn(e), function (t) {
                    return Je.call(e, t);
                  }));
                } : vc,
                    mo = fn ? function (e) {
                  for (var t = []; e;) {
                    Rt(t, fo(e)), e = Ke(e);
                  }

                  return t;
                } : vc,
                    go = Ar;

                function vo(e, t, n) {
                  for (var r = -1, i = (t = wi(t, e)).length, o = !1; ++r < i;) {
                    var a = Bo(t[r]);
                    if (!(o = null != e && n(e, a))) break;
                    e = e[a];
                  }

                  return o || ++r != i ? o : !!(i = null == e ? 0 : e.length) && ns(i) && wo(a, i) && (Ka(e) || Ga(e));
                }

                function bo(e) {
                  return "function" != typeof e.constructor || ko(e) ? {} : qn(Ke(e));
                }

                function yo(e) {
                  return Ka(e) || Ga(e) || !!(ot && e && e[ot]);
                }

                function wo(e, t) {
                  var n = typeof e;
                  return !!(t = null == t ? p : t) && ("number" == n || "symbol" != n && ve.test(e)) && e > -1 && e % 1 == 0 && e < t;
                }

                function So(e, t, n) {
                  if (!rs(n)) return !1;
                  var r = typeof t;
                  return !!("number" == r ? Za(n) && wo(t, n.length) : "string" == r && t in n) && qa(n[t], e);
                }

                function xo(e, t) {
                  if (Ka(e)) return !1;
                  var n = typeof e;
                  return !("number" != n && "symbol" != n && "boolean" != n && null != e && !us(e)) || ee.test(e) || !X.test(e) || null != t && e in Ae(t);
                }

                function Eo(e) {
                  var t = co(e),
                      n = Vn[t];
                  if ("function" != typeof n || !(t in Gn.prototype)) return !1;
                  if (e === n) return !0;
                  var r = so(n);
                  return !!r && e === r[0];
                }

                (kn && go(new kn(new ArrayBuffer(1))) != P || An && go(new An()) != x || In && go(In.resolve()) != k || Tn && go(new Tn()) != I || On && go(new On()) != R) && (go = function go(e) {
                  var t = Ar(e),
                      r = t == C ? e.constructor : n,
                      i = r ? Ho(r) : "";
                  if (i) switch (i) {
                    case jn:
                      return P;

                    case Dn:
                      return x;

                    case zn:
                      return k;

                    case Mn:
                      return I;

                    case Ln:
                      return R;
                  }
                  return t;
                });
                var Co = je ? es : bc;

                function ko(e) {
                  var t = e && e.constructor;
                  return e === ("function" == typeof t && t.prototype || Pe);
                }

                function Ao(e) {
                  return e == e && !rs(e);
                }

                function Io(e, t) {
                  return function (r) {
                    return null != r && r[e] === t && (t !== n || e in Ae(r));
                  };
                }

                function To(e, t, r) {
                  return t = yn(t === n ? e.length - 1 : t, 0), function () {
                    for (var n = arguments, i = -1, o = yn(n.length - t, 0), a = Se(o); ++i < o;) {
                      a[i] = n[t + i];
                    }

                    i = -1;

                    for (var s = Se(t + 1); ++i < t;) {
                      s[i] = n[i];
                    }

                    return s[t] = r(a), St(e, this, s);
                  };
                }

                function Oo(e, t) {
                  return t.length < 2 ? e : Cr(e, oi(t, 0, -1));
                }

                function Ro(e, t) {
                  for (var r = e.length, i = wn(t.length, r), o = Ri(e); i--;) {
                    var a = t[i];
                    e[i] = wo(a, r) ? o[a] : n;
                  }

                  return e;
                }

                function No(e, t) {
                  if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
                }

                var Po = Mo(ni),
                    jo = ft || function (e, t) {
                  return dt.setTimeout(e, t);
                },
                    Do = Mo(ri);

                function zo(e, t, n) {
                  var r = t + "";
                  return Do(e, function (e, t) {
                    var n = t.length;
                    if (!n) return e;
                    var r = n - 1;
                    return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(ae, "{\n/* [wrapped with " + t + "] */\n");
                  }(r, function (e, t) {
                    return Et(f, function (n) {
                      var r = "_." + n[0];
                      t & n[1] && !It(e, r) && e.push(r);
                    }), e.sort();
                  }(function (e) {
                    var t = e.match(se);
                    return t ? t[1].split(ce) : [];
                  }(r), n)));
                }

                function Mo(e) {
                  var t = 0,
                      r = 0;
                  return function () {
                    var i = Sn(),
                        o = 16 - (i - r);

                    if (r = i, o > 0) {
                      if (++t >= 800) return arguments[0];
                    } else t = 0;

                    return e.apply(n, arguments);
                  };
                }

                function Lo(e, t) {
                  var r = -1,
                      i = e.length,
                      o = i - 1;

                  for (t = t === n ? i : t; ++r < t;) {
                    var a = Yr(r, o),
                        s = e[a];
                    e[a] = e[r], e[r] = s;
                  }

                  return e.length = t, e;
                }

                var Uo = function (e) {
                  var t = Ma(e, function (e) {
                    return 500 === n.size && n.clear(), e;
                  }),
                      n = t.cache;
                  return t;
                }(function (e) {
                  var t = [];
                  return 46 === e.charCodeAt(0) && t.push(""), e.replace(te, function (e, n, r, i) {
                    t.push(r ? i.replace(ue, "$1") : n || e);
                  }), t;
                });

                function Bo(e) {
                  if ("string" == typeof e || us(e)) return e;
                  var t = e + "";
                  return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }

                function Ho(e) {
                  if (null != e) {
                    try {
                      return De.call(e);
                    } catch (e) {}

                    try {
                      return e + "";
                    } catch (e) {}
                  }

                  return "";
                }

                function Vo(e) {
                  if (e instanceof Gn) return e.clone();
                  var t = new Wn(e.__wrapped__, e.__chain__);
                  return t.__actions__ = Ri(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
                }

                var qo = $r(function (e, t) {
                  return Ya(e) ? hr(e, br(t, 1, Ya, !0)) : [];
                }),
                    Fo = $r(function (e, t) {
                  var r = Xo(t);
                  return Ya(r) && (r = n), Ya(e) ? hr(e, br(t, 1, Ya, !0), uo(r, 2)) : [];
                }),
                    Wo = $r(function (e, t) {
                  var r = Xo(t);
                  return Ya(r) && (r = n), Ya(e) ? hr(e, br(t, 1, Ya, !0), n, r) : [];
                });

                function Go(e, t, n) {
                  var r = null == e ? 0 : e.length;
                  if (!r) return -1;
                  var i = null == n ? 0 : gs(n);
                  return i < 0 && (i = yn(r + i, 0)), Mt(e, uo(t, 3), i);
                }

                function Ko(e, t, r) {
                  var i = null == e ? 0 : e.length;
                  if (!i) return -1;
                  var o = i - 1;
                  return r !== n && (o = gs(r), o = r < 0 ? yn(i + o, 0) : wn(o, i - 1)), Mt(e, uo(t, 3), o, !0);
                }

                function Qo(e) {
                  return null != e && e.length ? br(e, 1) : [];
                }

                function Zo(e) {
                  return e && e.length ? e[0] : n;
                }

                var Yo = $r(function (e) {
                  var t = Ot(e, bi);
                  return t.length && t[0] === e[0] ? Rr(t) : [];
                }),
                    Jo = $r(function (e) {
                  var t = Xo(e),
                      r = Ot(e, bi);
                  return t === Xo(r) ? t = n : r.pop(), r.length && r[0] === e[0] ? Rr(r, uo(t, 2)) : [];
                }),
                    $o = $r(function (e) {
                  var t = Xo(e),
                      r = Ot(e, bi);
                  return (t = "function" == typeof t ? t : n) && r.pop(), r.length && r[0] === e[0] ? Rr(r, n, t) : [];
                });

                function Xo(e) {
                  var t = null == e ? 0 : e.length;
                  return t ? e[t - 1] : n;
                }

                var ea = $r(ta);

                function ta(e, t) {
                  return e && e.length && t && t.length ? Qr(e, t) : e;
                }

                var na = io(function (e, t) {
                  var n = null == e ? 0 : e.length,
                      r = cr(e, t);
                  return Zr(e, Ot(t, function (e) {
                    return wo(e, n) ? +e : e;
                  }).sort(Ii)), r;
                });

                function ra(e) {
                  return null == e ? e : Cn.call(e);
                }

                var ia = $r(function (e) {
                  return pi(br(e, 1, Ya, !0));
                }),
                    oa = $r(function (e) {
                  var t = Xo(e);
                  return Ya(t) && (t = n), pi(br(e, 1, Ya, !0), uo(t, 2));
                }),
                    aa = $r(function (e) {
                  var t = Xo(e);
                  return t = "function" == typeof t ? t : n, pi(br(e, 1, Ya, !0), n, t);
                });

                function sa(e) {
                  if (!e || !e.length) return [];
                  var t = 0;
                  return e = At(e, function (e) {
                    if (Ya(e)) return t = yn(e.length, t), !0;
                  }), Gt(t, function (t) {
                    return Ot(e, Vt(t));
                  });
                }

                function ca(e, t) {
                  if (!e || !e.length) return [];
                  var r = sa(e);
                  return null == t ? r : Ot(r, function (e) {
                    return St(t, n, e);
                  });
                }

                var la = $r(function (e, t) {
                  return Ya(e) ? hr(e, t) : [];
                }),
                    da = $r(function (e) {
                  return gi(At(e, Ya));
                }),
                    ua = $r(function (e) {
                  var t = Xo(e);
                  return Ya(t) && (t = n), gi(At(e, Ya), uo(t, 2));
                }),
                    pa = $r(function (e) {
                  var t = Xo(e);
                  return t = "function" == typeof t ? t : n, gi(At(e, Ya), n, t);
                }),
                    ha = $r(sa),
                    _a = $r(function (e) {
                  var t = e.length,
                      r = t > 1 ? e[t - 1] : n;
                  return r = "function" == typeof r ? (e.pop(), r) : n, ca(e, r);
                });

                function fa(e) {
                  var t = Vn(e);
                  return t.__chain__ = !0, t;
                }

                function ma(e, t) {
                  return t(e);
                }

                var ga = io(function (e) {
                  var t = e.length,
                      r = t ? e[0] : 0,
                      i = this.__wrapped__,
                      o = function o(t) {
                    return cr(t, e);
                  };

                  return !(t > 1 || this.__actions__.length) && i instanceof Gn && wo(r) ? ((i = i.slice(r, +r + (t ? 1 : 0))).__actions__.push({
                    func: ma,
                    args: [o],
                    thisArg: n
                  }), new Wn(i, this.__chain__).thru(function (e) {
                    return t && !e.length && e.push(n), e;
                  })) : this.thru(o);
                }),
                    va = Pi(function (e, t, n) {
                  ze.call(e, n) ? ++e[n] : sr(e, n, 1);
                }),
                    ba = Bi(Go),
                    ya = Bi(Ko);

                function wa(e, t) {
                  return (Ka(e) ? Et : _r)(e, uo(t, 3));
                }

                function Sa(e, t) {
                  return (Ka(e) ? Ct : fr)(e, uo(t, 3));
                }

                var xa = Pi(function (e, t, n) {
                  ze.call(e, n) ? e[n].push(t) : sr(e, n, [t]);
                }),
                    Ea = $r(function (e, t, n) {
                  var r = -1,
                      i = "function" == typeof t,
                      o = Za(e) ? Se(e.length) : [];
                  return _r(e, function (e) {
                    o[++r] = i ? St(t, e, n) : Nr(e, t, n);
                  }), o;
                }),
                    Ca = Pi(function (e, t, n) {
                  sr(e, n, t);
                });

                function ka(e, t) {
                  return (Ka(e) ? Ot : Hr)(e, uo(t, 3));
                }

                var Aa = Pi(function (e, t, n) {
                  e[n ? 0 : 1].push(t);
                }, function () {
                  return [[], []];
                }),
                    Ia = $r(function (e, t) {
                  if (null == e) return [];
                  var n = t.length;
                  return n > 1 && So(e, t[0], t[1]) ? t = [] : n > 2 && So(t[0], t[1], t[2]) && (t = [t[0]]), Gr(e, br(t, 1), []);
                }),
                    Ta = _t || function () {
                  return dt.Date.now();
                };

                function Oa(e, t, r) {
                  return t = r ? n : t, t = e && null == t ? e.length : t, Xi(e, l, n, n, n, n, t);
                }

                function Ra(e, t) {
                  var i;
                  if ("function" != typeof t) throw new Oe(r);
                  return e = gs(e), function () {
                    return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
                  };
                }

                var Na = $r(function (e, t, n) {
                  var r = 1;

                  if (n.length) {
                    var i = sn(n, lo(Na));
                    r |= s;
                  }

                  return Xi(e, r, t, n, i);
                }),
                    Pa = $r(function (e, t, n) {
                  var r = 3;

                  if (n.length) {
                    var i = sn(n, lo(Pa));
                    r |= s;
                  }

                  return Xi(t, r, e, n, i);
                });

                function ja(e, t, i) {
                  var o,
                      a,
                      s,
                      c,
                      l,
                      d,
                      u = 0,
                      p = !1,
                      h = !1,
                      _ = !0;

                  if ("function" != typeof e) throw new Oe(r);

                  function f(t) {
                    var r = o,
                        i = a;
                    return o = a = n, u = t, c = e.apply(i, r);
                  }

                  function m(e) {
                    return u = e, l = jo(v, t), p ? f(e) : c;
                  }

                  function g(e) {
                    var r = e - d;
                    return d === n || r >= t || r < 0 || h && e - u >= s;
                  }

                  function v() {
                    var e = Ta();
                    if (g(e)) return b(e);
                    l = jo(v, function (e) {
                      var n = t - (e - d);
                      return h ? wn(n, s - (e - u)) : n;
                    }(e));
                  }

                  function b(e) {
                    return l = n, _ && o ? f(e) : (o = a = n, c);
                  }

                  function y() {
                    var e = Ta(),
                        r = g(e);

                    if (o = arguments, a = this, d = e, r) {
                      if (l === n) return m(d);
                      if (h) return Ei(l), l = jo(v, t), f(d);
                    }

                    return l === n && (l = jo(v, t)), c;
                  }

                  return t = bs(t) || 0, rs(i) && (p = !!i.leading, s = (h = "maxWait" in i) ? yn(bs(i.maxWait) || 0, t) : s, _ = "trailing" in i ? !!i.trailing : _), y.cancel = function () {
                    l !== n && Ei(l), u = 0, o = d = a = l = n;
                  }, y.flush = function () {
                    return l === n ? c : b(Ta());
                  }, y;
                }

                var Da = $r(function (e, t) {
                  return pr(e, 1, t);
                }),
                    za = $r(function (e, t, n) {
                  return pr(e, bs(t) || 0, n);
                });

                function Ma(e, t) {
                  if ("function" != typeof e || null != t && "function" != typeof t) throw new Oe(r);

                  var n = function n() {
                    var r = arguments,
                        i = t ? t.apply(this, r) : r[0],
                        o = n.cache;
                    if (o.has(i)) return o.get(i);
                    var a = e.apply(this, r);
                    return n.cache = o.set(i, a) || o, a;
                  };

                  return n.cache = new (Ma.Cache || Zn)(), n;
                }

                function La(e) {
                  if ("function" != typeof e) throw new Oe(r);
                  return function () {
                    var t = arguments;

                    switch (t.length) {
                      case 0:
                        return !e.call(this);

                      case 1:
                        return !e.call(this, t[0]);

                      case 2:
                        return !e.call(this, t[0], t[1]);

                      case 3:
                        return !e.call(this, t[0], t[1], t[2]);
                    }

                    return !e.apply(this, t);
                  };
                }

                Ma.Cache = Zn;
                var Ua = Si(function (e, t) {
                  var n = (t = 1 == t.length && Ka(t[0]) ? Ot(t[0], Qt(uo())) : Ot(br(t, 1), Qt(uo()))).length;
                  return $r(function (r) {
                    for (var i = -1, o = wn(r.length, n); ++i < o;) {
                      r[i] = t[i].call(this, r[i]);
                    }

                    return St(e, this, r);
                  });
                }),
                    Ba = $r(function (e, t) {
                  var r = sn(t, lo(Ba));
                  return Xi(e, s, n, t, r);
                }),
                    Ha = $r(function (e, t) {
                  var r = sn(t, lo(Ha));
                  return Xi(e, c, n, t, r);
                }),
                    Va = io(function (e, t) {
                  return Xi(e, d, n, n, n, t);
                });

                function qa(e, t) {
                  return e === t || e != e && t != t;
                }

                var Fa = Qi(Ir),
                    Wa = Qi(function (e, t) {
                  return e >= t;
                }),
                    Ga = Pr(function () {
                  return arguments;
                }()) ? Pr : function (e) {
                  return is(e) && ze.call(e, "callee") && !Je.call(e, "callee");
                },
                    Ka = Se.isArray,
                    Qa = mt ? Qt(mt) : function (e) {
                  return is(e) && Ar(e) == N;
                };

                function Za(e) {
                  return null != e && ns(e.length) && !es(e);
                }

                function Ya(e) {
                  return is(e) && Za(e);
                }

                var Ja = mn || bc,
                    $a = gt ? Qt(gt) : function (e) {
                  return is(e) && Ar(e) == b;
                };

                function Xa(e) {
                  if (!is(e)) return !1;
                  var t = Ar(e);
                  return t == y || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !ss(e);
                }

                function es(e) {
                  if (!rs(e)) return !1;
                  var t = Ar(e);
                  return t == w || t == S || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                }

                function ts(e) {
                  return "number" == typeof e && e == gs(e);
                }

                function ns(e) {
                  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= p;
                }

                function rs(e) {
                  var t = typeof e;
                  return null != e && ("object" == t || "function" == t);
                }

                function is(e) {
                  return null != e && "object" == typeof e;
                }

                var os = vt ? Qt(vt) : function (e) {
                  return is(e) && go(e) == x;
                };

                function as(e) {
                  return "number" == typeof e || is(e) && Ar(e) == E;
                }

                function ss(e) {
                  if (!is(e) || Ar(e) != C) return !1;
                  var t = Ke(e);
                  if (null === t) return !0;
                  var n = ze.call(t, "constructor") && t.constructor;
                  return "function" == typeof n && n instanceof n && De.call(n) == Be;
                }

                var cs = bt ? Qt(bt) : function (e) {
                  return is(e) && Ar(e) == A;
                },
                    ls = yt ? Qt(yt) : function (e) {
                  return is(e) && go(e) == I;
                };

                function ds(e) {
                  return "string" == typeof e || !Ka(e) && is(e) && Ar(e) == T;
                }

                function us(e) {
                  return "symbol" == typeof e || is(e) && Ar(e) == O;
                }

                var ps = wt ? Qt(wt) : function (e) {
                  return is(e) && ns(e.length) && !!rt[Ar(e)];
                },
                    hs = Qi(Br),
                    _s = Qi(function (e, t) {
                  return e <= t;
                });

                function fs(e) {
                  if (!e) return [];
                  if (Za(e)) return ds(e) ? un(e) : Ri(e);
                  if (ct && e[ct]) return function (e) {
                    for (var t, n = []; !(t = e.next()).done;) {
                      n.push(t.value);
                    }

                    return n;
                  }(e[ct]());
                  var t = go(e);
                  return (t == x ? on : t == I ? cn : qs)(e);
                }

                function ms(e) {
                  return e ? (e = bs(e)) === u || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
                }

                function gs(e) {
                  var t = ms(e),
                      n = t % 1;
                  return t == t ? n ? t - n : t : 0;
                }

                function vs(e) {
                  return e ? lr(gs(e), 0, _) : 0;
                }

                function bs(e) {
                  if ("number" == typeof e) return e;
                  if (us(e)) return h;

                  if (rs(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = rs(t) ? t + "" : t;
                  }

                  if ("string" != typeof e) return 0 === e ? e : +e;
                  e = Kt(e);
                  var n = fe.test(e);
                  return n || ge.test(e) ? st(e.slice(2), n ? 2 : 8) : _e.test(e) ? h : +e;
                }

                function ys(e) {
                  return Ni(e, Ds(e));
                }

                function ws(e) {
                  return null == e ? "" : ui(e);
                }

                var Ss = ji(function (e, t) {
                  if (ko(t) || Za(t)) Ni(t, js(t), e);else for (var n in t) {
                    ze.call(t, n) && rr(e, n, t[n]);
                  }
                }),
                    xs = ji(function (e, t) {
                  Ni(t, Ds(t), e);
                }),
                    Es = ji(function (e, t, n, r) {
                  Ni(t, Ds(t), e, r);
                }),
                    Cs = ji(function (e, t, n, r) {
                  Ni(t, js(t), e, r);
                }),
                    ks = io(cr),
                    As = $r(function (e, t) {
                  e = Ae(e);
                  var r = -1,
                      i = t.length,
                      o = i > 2 ? t[2] : n;

                  for (o && So(t[0], t[1], o) && (i = 1); ++r < i;) {
                    for (var a = t[r], s = Ds(a), c = -1, l = s.length; ++c < l;) {
                      var d = s[c],
                          u = e[d];
                      (u === n || qa(u, Pe[d]) && !ze.call(e, d)) && (e[d] = a[d]);
                    }
                  }

                  return e;
                }),
                    Is = $r(function (e) {
                  return e.push(n, to), St(Ms, n, e);
                });

                function Ts(e, t, r) {
                  var i = null == e ? n : Cr(e, t);
                  return i === n ? r : i;
                }

                function Os(e, t) {
                  return null != e && vo(e, t, Or);
                }

                var Rs = qi(function (e, t, n) {
                  null != t && "function" != typeof t.toString && (t = Ue.call(t)), e[t] = n;
                }, rc(ac)),
                    Ns = qi(function (e, t, n) {
                  null != t && "function" != typeof t.toString && (t = Ue.call(t)), ze.call(e, t) ? e[t].push(n) : e[t] = [n];
                }, uo),
                    Ps = $r(Nr);

                function js(e) {
                  return Za(e) ? $n(e) : Lr(e);
                }

                function Ds(e) {
                  return Za(e) ? $n(e, !0) : Ur(e);
                }

                var zs = ji(function (e, t, n) {
                  Fr(e, t, n);
                }),
                    Ms = ji(function (e, t, n, r) {
                  Fr(e, t, n, r);
                }),
                    Ls = io(function (e, t) {
                  var n = {};
                  if (null == e) return n;
                  var r = !1;
                  t = Ot(t, function (t) {
                    return t = wi(t, e), r || (r = t.length > 1), t;
                  }), Ni(e, ao(e), n), r && (n = dr(n, 7, no));

                  for (var i = t.length; i--;) {
                    hi(n, t[i]);
                  }

                  return n;
                }),
                    Us = io(function (e, t) {
                  return null == e ? {} : function (e, t) {
                    return Kr(e, t, function (t, n) {
                      return Os(e, n);
                    });
                  }(e, t);
                });

                function Bs(e, t) {
                  if (null == e) return {};
                  var n = Ot(ao(e), function (e) {
                    return [e];
                  });
                  return t = uo(t), Kr(e, n, function (e, n) {
                    return t(e, n[0]);
                  });
                }

                var Hs = $i(js),
                    Vs = $i(Ds);

                function qs(e) {
                  return null == e ? [] : Zt(e, js(e));
                }

                var Fs = Li(function (e, t, n) {
                  return t = t.toLowerCase(), e + (n ? Ws(t) : t);
                });

                function Ws(e) {
                  return Xs(ws(e).toLowerCase());
                }

                function Gs(e) {
                  return (e = ws(e)) && e.replace(be, en).replace(Ye, "");
                }

                var Ks = Li(function (e, t, n) {
                  return e + (n ? "-" : "") + t.toLowerCase();
                }),
                    Qs = Li(function (e, t, n) {
                  return e + (n ? " " : "") + t.toLowerCase();
                }),
                    Zs = Mi("toLowerCase"),
                    Ys = Li(function (e, t, n) {
                  return e + (n ? "_" : "") + t.toLowerCase();
                }),
                    Js = Li(function (e, t, n) {
                  return e + (n ? " " : "") + Xs(t);
                }),
                    $s = Li(function (e, t, n) {
                  return e + (n ? " " : "") + t.toUpperCase();
                }),
                    Xs = Mi("toUpperCase");

                function ec(e, t, r) {
                  return e = ws(e), (t = r ? n : t) === n ? function (e) {
                    return et.test(e);
                  }(e) ? function (e) {
                    return e.match($e) || [];
                  }(e) : function (e) {
                    return e.match(le) || [];
                  }(e) : e.match(t) || [];
                }

                var tc = $r(function (e, t) {
                  try {
                    return St(e, n, t);
                  } catch (e) {
                    return Xa(e) ? e : new Ee(e);
                  }
                }),
                    nc = io(function (e, t) {
                  return Et(t, function (t) {
                    t = Bo(t), sr(e, t, Na(e[t], e));
                  }), e;
                });

                function rc(e) {
                  return function () {
                    return e;
                  };
                }

                var ic = Hi(),
                    oc = Hi(!0);

                function ac(e) {
                  return e;
                }

                function sc(e) {
                  return Mr("function" == typeof e ? e : dr(e, 1));
                }

                var cc = $r(function (e, t) {
                  return function (n) {
                    return Nr(n, e, t);
                  };
                }),
                    lc = $r(function (e, t) {
                  return function (n) {
                    return Nr(e, n, t);
                  };
                });

                function dc(e, t, n) {
                  var r = js(t),
                      i = Er(t, r);
                  null != n || rs(t) && (i.length || !r.length) || (n = t, t = e, e = this, i = Er(t, js(t)));
                  var o = !(rs(n) && "chain" in n && !n.chain),
                      a = es(e);
                  return Et(i, function (n) {
                    var r = t[n];
                    e[n] = r, a && (e.prototype[n] = function () {
                      var t = this.__chain__;

                      if (o || t) {
                        var n = e(this.__wrapped__);
                        return (n.__actions__ = Ri(this.__actions__)).push({
                          func: r,
                          args: arguments,
                          thisArg: e
                        }), n.__chain__ = t, n;
                      }

                      return r.apply(e, Rt([this.value()], arguments));
                    });
                  }), e;
                }

                function uc() {}

                var pc = Wi(Ot),
                    hc = Wi(kt),
                    _c = Wi(jt);

                function fc(e) {
                  return xo(e) ? Vt(Bo(e)) : function (e) {
                    return function (t) {
                      return Cr(t, e);
                    };
                  }(e);
                }

                var mc = Ki(),
                    gc = Ki(!0);

                function vc() {
                  return [];
                }

                function bc() {
                  return !1;
                }

                var yc,
                    wc = Fi(function (e, t) {
                  return e + t;
                }, 0),
                    Sc = Yi("ceil"),
                    xc = Fi(function (e, t) {
                  return e / t;
                }, 1),
                    Ec = Yi("floor"),
                    Cc = Fi(function (e, t) {
                  return e * t;
                }, 1),
                    kc = Yi("round"),
                    Ac = Fi(function (e, t) {
                  return e - t;
                }, 0);
                return Vn.after = function (e, t) {
                  if ("function" != typeof t) throw new Oe(r);
                  return e = gs(e), function () {
                    if (--e < 1) return t.apply(this, arguments);
                  };
                }, Vn.ary = Oa, Vn.assign = Ss, Vn.assignIn = xs, Vn.assignInWith = Es, Vn.assignWith = Cs, Vn.at = ks, Vn.before = Ra, Vn.bind = Na, Vn.bindAll = nc, Vn.bindKey = Pa, Vn.castArray = function () {
                  if (!arguments.length) return [];
                  var e = arguments[0];
                  return Ka(e) ? e : [e];
                }, Vn.chain = fa, Vn.chunk = function (e, t, r) {
                  t = (r ? So(e, t, r) : t === n) ? 1 : yn(gs(t), 0);
                  var i = null == e ? 0 : e.length;
                  if (!i || t < 1) return [];

                  for (var o = 0, a = 0, s = Se(Dt(i / t)); o < i;) {
                    s[a++] = oi(e, o, o += t);
                  }

                  return s;
                }, Vn.compact = function (e) {
                  for (var t = -1, n = null == e ? 0 : e.length, r = 0, i = []; ++t < n;) {
                    var o = e[t];
                    o && (i[r++] = o);
                  }

                  return i;
                }, Vn.concat = function () {
                  var e = arguments.length;
                  if (!e) return [];

                  for (var t = Se(e - 1), n = arguments[0], r = e; r--;) {
                    t[r - 1] = arguments[r];
                  }

                  return Rt(Ka(n) ? Ri(n) : [n], br(t, 1));
                }, Vn.cond = function (e) {
                  var t = null == e ? 0 : e.length,
                      n = uo();
                  return e = t ? Ot(e, function (e) {
                    if ("function" != typeof e[1]) throw new Oe(r);
                    return [n(e[0]), e[1]];
                  }) : [], $r(function (n) {
                    for (var r = -1; ++r < t;) {
                      var i = e[r];
                      if (St(i[0], this, n)) return St(i[1], this, n);
                    }
                  });
                }, Vn.conforms = function (e) {
                  return function (e) {
                    var t = js(e);
                    return function (n) {
                      return ur(n, e, t);
                    };
                  }(dr(e, 1));
                }, Vn.constant = rc, Vn.countBy = va, Vn.create = function (e, t) {
                  var n = qn(e);
                  return null == t ? n : ar(n, t);
                }, Vn.curry = function e(t, r, i) {
                  var o = Xi(t, 8, n, n, n, n, n, r = i ? n : r);
                  return o.placeholder = e.placeholder, o;
                }, Vn.curryRight = function e(t, r, i) {
                  var o = Xi(t, a, n, n, n, n, n, r = i ? n : r);
                  return o.placeholder = e.placeholder, o;
                }, Vn.debounce = ja, Vn.defaults = As, Vn.defaultsDeep = Is, Vn.defer = Da, Vn.delay = za, Vn.difference = qo, Vn.differenceBy = Fo, Vn.differenceWith = Wo, Vn.drop = function (e, t, r) {
                  var i = null == e ? 0 : e.length;
                  return i ? oi(e, (t = r || t === n ? 1 : gs(t)) < 0 ? 0 : t, i) : [];
                }, Vn.dropRight = function (e, t, r) {
                  var i = null == e ? 0 : e.length;
                  return i ? oi(e, 0, (t = i - (t = r || t === n ? 1 : gs(t))) < 0 ? 0 : t) : [];
                }, Vn.dropRightWhile = function (e, t) {
                  return e && e.length ? fi(e, uo(t, 3), !0, !0) : [];
                }, Vn.dropWhile = function (e, t) {
                  return e && e.length ? fi(e, uo(t, 3), !0) : [];
                }, Vn.fill = function (e, t, r, i) {
                  var o = null == e ? 0 : e.length;
                  return o ? (r && "number" != typeof r && So(e, t, r) && (r = 0, i = o), function (e, t, r, i) {
                    var o = e.length;

                    for ((r = gs(r)) < 0 && (r = -r > o ? 0 : o + r), (i = i === n || i > o ? o : gs(i)) < 0 && (i += o), i = r > i ? 0 : vs(i); r < i;) {
                      e[r++] = t;
                    }

                    return e;
                  }(e, t, r, i)) : [];
                }, Vn.filter = function (e, t) {
                  return (Ka(e) ? At : vr)(e, uo(t, 3));
                }, Vn.flatMap = function (e, t) {
                  return br(ka(e, t), 1);
                }, Vn.flatMapDeep = function (e, t) {
                  return br(ka(e, t), u);
                }, Vn.flatMapDepth = function (e, t, r) {
                  return r = r === n ? 1 : gs(r), br(ka(e, t), r);
                }, Vn.flatten = Qo, Vn.flattenDeep = function (e) {
                  return null != e && e.length ? br(e, u) : [];
                }, Vn.flattenDepth = function (e, t) {
                  return null != e && e.length ? br(e, t = t === n ? 1 : gs(t)) : [];
                }, Vn.flip = function (e) {
                  return Xi(e, 512);
                }, Vn.flow = ic, Vn.flowRight = oc, Vn.fromPairs = function (e) {
                  for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;) {
                    var i = e[t];
                    r[i[0]] = i[1];
                  }

                  return r;
                }, Vn.functions = function (e) {
                  return null == e ? [] : Er(e, js(e));
                }, Vn.functionsIn = function (e) {
                  return null == e ? [] : Er(e, Ds(e));
                }, Vn.groupBy = xa, Vn.initial = function (e) {
                  return null != e && e.length ? oi(e, 0, -1) : [];
                }, Vn.intersection = Yo, Vn.intersectionBy = Jo, Vn.intersectionWith = $o, Vn.invert = Rs, Vn.invertBy = Ns, Vn.invokeMap = Ea, Vn.iteratee = sc, Vn.keyBy = Ca, Vn.keys = js, Vn.keysIn = Ds, Vn.map = ka, Vn.mapKeys = function (e, t) {
                  var n = {};
                  return t = uo(t, 3), Sr(e, function (e, r, i) {
                    sr(n, t(e, r, i), e);
                  }), n;
                }, Vn.mapValues = function (e, t) {
                  var n = {};
                  return t = uo(t, 3), Sr(e, function (e, r, i) {
                    sr(n, r, t(e, r, i));
                  }), n;
                }, Vn.matches = function (e) {
                  return Vr(dr(e, 1));
                }, Vn.matchesProperty = function (e, t) {
                  return qr(e, dr(t, 1));
                }, Vn.memoize = Ma, Vn.merge = zs, Vn.mergeWith = Ms, Vn.method = cc, Vn.methodOf = lc, Vn.mixin = dc, Vn.negate = La, Vn.nthArg = function (e) {
                  return e = gs(e), $r(function (t) {
                    return Wr(t, e);
                  });
                }, Vn.omit = Ls, Vn.omitBy = function (e, t) {
                  return Bs(e, La(uo(t)));
                }, Vn.once = function (e) {
                  return Ra(2, e);
                }, Vn.orderBy = function (e, t, r, i) {
                  return null == e ? [] : (Ka(t) || (t = null == t ? [] : [t]), Ka(r = i ? n : r) || (r = null == r ? [] : [r]), Gr(e, t, r));
                }, Vn.over = pc, Vn.overArgs = Ua, Vn.overEvery = hc, Vn.overSome = _c, Vn.partial = Ba, Vn.partialRight = Ha, Vn.partition = Aa, Vn.pick = Us, Vn.pickBy = Bs, Vn.property = fc, Vn.propertyOf = function (e) {
                  return function (t) {
                    return null == e ? n : Cr(e, t);
                  };
                }, Vn.pull = ea, Vn.pullAll = ta, Vn.pullAllBy = function (e, t, n) {
                  return e && e.length && t && t.length ? Qr(e, t, uo(n, 2)) : e;
                }, Vn.pullAllWith = function (e, t, r) {
                  return e && e.length && t && t.length ? Qr(e, t, n, r) : e;
                }, Vn.pullAt = na, Vn.range = mc, Vn.rangeRight = gc, Vn.rearg = Va, Vn.reject = function (e, t) {
                  return (Ka(e) ? At : vr)(e, La(uo(t, 3)));
                }, Vn.remove = function (e, t) {
                  var n = [];
                  if (!e || !e.length) return n;
                  var r = -1,
                      i = [],
                      o = e.length;

                  for (t = uo(t, 3); ++r < o;) {
                    var a = e[r];
                    t(a, r, e) && (n.push(a), i.push(r));
                  }

                  return Zr(e, i), n;
                }, Vn.rest = function (e, t) {
                  if ("function" != typeof e) throw new Oe(r);
                  return $r(e, t = t === n ? t : gs(t));
                }, Vn.reverse = ra, Vn.sampleSize = function (e, t, r) {
                  return t = (r ? So(e, t, r) : t === n) ? 1 : gs(t), (Ka(e) ? er : ei)(e, t);
                }, Vn.set = function (e, t, n) {
                  return null == e ? e : ti(e, t, n);
                }, Vn.setWith = function (e, t, r, i) {
                  return i = "function" == typeof i ? i : n, null == e ? e : ti(e, t, r, i);
                }, Vn.shuffle = function (e) {
                  return (Ka(e) ? tr : ii)(e);
                }, Vn.slice = function (e, t, r) {
                  var i = null == e ? 0 : e.length;
                  return i ? (r && "number" != typeof r && So(e, t, r) ? (t = 0, r = i) : (t = null == t ? 0 : gs(t), r = r === n ? i : gs(r)), oi(e, t, r)) : [];
                }, Vn.sortBy = Ia, Vn.sortedUniq = function (e) {
                  return e && e.length ? li(e) : [];
                }, Vn.sortedUniqBy = function (e, t) {
                  return e && e.length ? li(e, uo(t, 2)) : [];
                }, Vn.split = function (e, t, r) {
                  return r && "number" != typeof r && So(e, t, r) && (t = r = n), (r = r === n ? _ : r >>> 0) ? (e = ws(e)) && ("string" == typeof t || null != t && !cs(t)) && !(t = ui(t)) && rn(e) ? xi(un(e), 0, r) : e.split(t, r) : [];
                }, Vn.spread = function (e, t) {
                  if ("function" != typeof e) throw new Oe(r);
                  return t = null == t ? 0 : yn(gs(t), 0), $r(function (n) {
                    var r = n[t],
                        i = xi(n, 0, t);
                    return r && Rt(i, r), St(e, this, i);
                  });
                }, Vn.tail = function (e) {
                  var t = null == e ? 0 : e.length;
                  return t ? oi(e, 1, t) : [];
                }, Vn.take = function (e, t, r) {
                  return e && e.length ? oi(e, 0, (t = r || t === n ? 1 : gs(t)) < 0 ? 0 : t) : [];
                }, Vn.takeRight = function (e, t, r) {
                  var i = null == e ? 0 : e.length;
                  return i ? oi(e, (t = i - (t = r || t === n ? 1 : gs(t))) < 0 ? 0 : t, i) : [];
                }, Vn.takeRightWhile = function (e, t) {
                  return e && e.length ? fi(e, uo(t, 3), !1, !0) : [];
                }, Vn.takeWhile = function (e, t) {
                  return e && e.length ? fi(e, uo(t, 3)) : [];
                }, Vn.tap = function (e, t) {
                  return t(e), e;
                }, Vn.throttle = function (e, t, n) {
                  var i = !0,
                      o = !0;
                  if ("function" != typeof e) throw new Oe(r);
                  return rs(n) && (i = "leading" in n ? !!n.leading : i, o = "trailing" in n ? !!n.trailing : o), ja(e, t, {
                    leading: i,
                    maxWait: t,
                    trailing: o
                  });
                }, Vn.thru = ma, Vn.toArray = fs, Vn.toPairs = Hs, Vn.toPairsIn = Vs, Vn.toPath = function (e) {
                  return Ka(e) ? Ot(e, Bo) : us(e) ? [e] : Ri(Uo(ws(e)));
                }, Vn.toPlainObject = ys, Vn.transform = function (e, t, n) {
                  var r = Ka(e),
                      i = r || Ja(e) || ps(e);

                  if (t = uo(t, 4), null == n) {
                    var o = e && e.constructor;
                    n = i ? r ? new o() : [] : rs(e) && es(o) ? qn(Ke(e)) : {};
                  }

                  return (i ? Et : Sr)(e, function (e, r, i) {
                    return t(n, e, r, i);
                  }), n;
                }, Vn.unary = function (e) {
                  return Oa(e, 1);
                }, Vn.union = ia, Vn.unionBy = oa, Vn.unionWith = aa, Vn.uniq = function (e) {
                  return e && e.length ? pi(e) : [];
                }, Vn.uniqBy = function (e, t) {
                  return e && e.length ? pi(e, uo(t, 2)) : [];
                }, Vn.uniqWith = function (e, t) {
                  return t = "function" == typeof t ? t : n, e && e.length ? pi(e, n, t) : [];
                }, Vn.unset = function (e, t) {
                  return null == e || hi(e, t);
                }, Vn.unzip = sa, Vn.unzipWith = ca, Vn.update = function (e, t, n) {
                  return null == e ? e : _i(e, t, yi(n));
                }, Vn.updateWith = function (e, t, r, i) {
                  return i = "function" == typeof i ? i : n, null == e ? e : _i(e, t, yi(r), i);
                }, Vn.values = qs, Vn.valuesIn = function (e) {
                  return null == e ? [] : Zt(e, Ds(e));
                }, Vn.without = la, Vn.words = ec, Vn.wrap = function (e, t) {
                  return Ba(yi(t), e);
                }, Vn.xor = da, Vn.xorBy = ua, Vn.xorWith = pa, Vn.zip = ha, Vn.zipObject = function (e, t) {
                  return vi(e || [], t || [], rr);
                }, Vn.zipObjectDeep = function (e, t) {
                  return vi(e || [], t || [], ti);
                }, Vn.zipWith = _a, Vn.entries = Hs, Vn.entriesIn = Vs, Vn.extend = xs, Vn.extendWith = Es, dc(Vn, Vn), Vn.add = wc, Vn.attempt = tc, Vn.camelCase = Fs, Vn.capitalize = Ws, Vn.ceil = Sc, Vn.clamp = function (e, t, r) {
                  return r === n && (r = t, t = n), r !== n && (r = (r = bs(r)) == r ? r : 0), t !== n && (t = (t = bs(t)) == t ? t : 0), lr(bs(e), t, r);
                }, Vn.clone = function (e) {
                  return dr(e, 4);
                }, Vn.cloneDeep = function (e) {
                  return dr(e, 5);
                }, Vn.cloneDeepWith = function (e, t) {
                  return dr(e, 5, t = "function" == typeof t ? t : n);
                }, Vn.cloneWith = function (e, t) {
                  return dr(e, 4, t = "function" == typeof t ? t : n);
                }, Vn.conformsTo = function (e, t) {
                  return null == t || ur(e, t, js(t));
                }, Vn.deburr = Gs, Vn.defaultTo = function (e, t) {
                  return null == e || e != e ? t : e;
                }, Vn.divide = xc, Vn.endsWith = function (e, t, r) {
                  e = ws(e), t = ui(t);
                  var i = e.length,
                      o = r = r === n ? i : lr(gs(r), 0, i);
                  return (r -= t.length) >= 0 && e.slice(r, o) == t;
                }, Vn.eq = qa, Vn.escape = function (e) {
                  return (e = ws(e)) && Z.test(e) ? e.replace(K, tn) : e;
                }, Vn.escapeRegExp = function (e) {
                  return (e = ws(e)) && re.test(e) ? e.replace(ne, "\\$&") : e;
                }, Vn.every = function (e, t, r) {
                  var i = Ka(e) ? kt : mr;
                  return r && So(e, t, r) && (t = n), i(e, uo(t, 3));
                }, Vn.find = ba, Vn.findIndex = Go, Vn.findKey = function (e, t) {
                  return zt(e, uo(t, 3), Sr);
                }, Vn.findLast = ya, Vn.findLastIndex = Ko, Vn.findLastKey = function (e, t) {
                  return zt(e, uo(t, 3), xr);
                }, Vn.floor = Ec, Vn.forEach = wa, Vn.forEachRight = Sa, Vn.forIn = function (e, t) {
                  return null == e ? e : yr(e, uo(t, 3), Ds);
                }, Vn.forInRight = function (e, t) {
                  return null == e ? e : wr(e, uo(t, 3), Ds);
                }, Vn.forOwn = function (e, t) {
                  return e && Sr(e, uo(t, 3));
                }, Vn.forOwnRight = function (e, t) {
                  return e && xr(e, uo(t, 3));
                }, Vn.get = Ts, Vn.gt = Fa, Vn.gte = Wa, Vn.has = function (e, t) {
                  return null != e && vo(e, t, Tr);
                }, Vn.hasIn = Os, Vn.head = Zo, Vn.identity = ac, Vn.includes = function (e, t, n, r) {
                  e = Za(e) ? e : qs(e), n = n && !r ? gs(n) : 0;
                  var i = e.length;
                  return n < 0 && (n = yn(i + n, 0)), ds(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && Lt(e, t, n) > -1;
                }, Vn.indexOf = function (e, t, n) {
                  var r = null == e ? 0 : e.length;
                  if (!r) return -1;
                  var i = null == n ? 0 : gs(n);
                  return i < 0 && (i = yn(r + i, 0)), Lt(e, t, i);
                }, Vn.inRange = function (e, t, r) {
                  return t = ms(t), r === n ? (r = t, t = 0) : r = ms(r), function (e, t, n) {
                    return e >= wn(t, n) && e < yn(t, n);
                  }(e = bs(e), t, r);
                }, Vn.invoke = Ps, Vn.isArguments = Ga, Vn.isArray = Ka, Vn.isArrayBuffer = Qa, Vn.isArrayLike = Za, Vn.isArrayLikeObject = Ya, Vn.isBoolean = function (e) {
                  return !0 === e || !1 === e || is(e) && Ar(e) == v;
                }, Vn.isBuffer = Ja, Vn.isDate = $a, Vn.isElement = function (e) {
                  return is(e) && 1 === e.nodeType && !ss(e);
                }, Vn.isEmpty = function (e) {
                  if (null == e) return !0;
                  if (Za(e) && (Ka(e) || "string" == typeof e || "function" == typeof e.splice || Ja(e) || ps(e) || Ga(e))) return !e.length;
                  var t = go(e);
                  if (t == x || t == I) return !e.size;
                  if (ko(e)) return !Lr(e).length;

                  for (var n in e) {
                    if (ze.call(e, n)) return !1;
                  }

                  return !0;
                }, Vn.isEqual = function (e, t) {
                  return jr(e, t);
                }, Vn.isEqualWith = function (e, t, r) {
                  var i = (r = "function" == typeof r ? r : n) ? r(e, t) : n;
                  return i === n ? jr(e, t, n, r) : !!i;
                }, Vn.isError = Xa, Vn.isFinite = function (e) {
                  return "number" == typeof e && gn(e);
                }, Vn.isFunction = es, Vn.isInteger = ts, Vn.isLength = ns, Vn.isMap = os, Vn.isMatch = function (e, t) {
                  return e === t || Dr(e, t, ho(t));
                }, Vn.isMatchWith = function (e, t, r) {
                  return r = "function" == typeof r ? r : n, Dr(e, t, ho(t), r);
                }, Vn.isNaN = function (e) {
                  return as(e) && e != +e;
                }, Vn.isNative = function (e) {
                  if (Co(e)) throw new Ee("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
                  return zr(e);
                }, Vn.isNil = function (e) {
                  return null == e;
                }, Vn.isNull = function (e) {
                  return null === e;
                }, Vn.isNumber = as, Vn.isObject = rs, Vn.isObjectLike = is, Vn.isPlainObject = ss, Vn.isRegExp = cs, Vn.isSafeInteger = function (e) {
                  return ts(e) && e >= -9007199254740991 && e <= p;
                }, Vn.isSet = ls, Vn.isString = ds, Vn.isSymbol = us, Vn.isTypedArray = ps, Vn.isUndefined = function (e) {
                  return e === n;
                }, Vn.isWeakMap = function (e) {
                  return is(e) && go(e) == R;
                }, Vn.isWeakSet = function (e) {
                  return is(e) && "[object WeakSet]" == Ar(e);
                }, Vn.join = function (e, t) {
                  return null == e ? "" : vn.call(e, t);
                }, Vn.kebabCase = Ks, Vn.last = Xo, Vn.lastIndexOf = function (e, t, r) {
                  var i = null == e ? 0 : e.length;
                  if (!i) return -1;
                  var o = i;
                  return r !== n && (o = (o = gs(r)) < 0 ? yn(i + o, 0) : wn(o, i - 1)), t == t ? function (e, t, n) {
                    for (var r = n + 1; r--;) {
                      if (e[r] === t) return r;
                    }

                    return r;
                  }(e, t, o) : Mt(e, Bt, o, !0);
                }, Vn.lowerCase = Qs, Vn.lowerFirst = Zs, Vn.lt = hs, Vn.lte = _s, Vn.max = function (e) {
                  return e && e.length ? gr(e, ac, Ir) : n;
                }, Vn.maxBy = function (e, t) {
                  return e && e.length ? gr(e, uo(t, 2), Ir) : n;
                }, Vn.mean = function (e) {
                  return Ht(e, ac);
                }, Vn.meanBy = function (e, t) {
                  return Ht(e, uo(t, 2));
                }, Vn.min = function (e) {
                  return e && e.length ? gr(e, ac, Br) : n;
                }, Vn.minBy = function (e, t) {
                  return e && e.length ? gr(e, uo(t, 2), Br) : n;
                }, Vn.stubArray = vc, Vn.stubFalse = bc, Vn.stubObject = function () {
                  return {};
                }, Vn.stubString = function () {
                  return "";
                }, Vn.stubTrue = function () {
                  return !0;
                }, Vn.multiply = Cc, Vn.nth = function (e, t) {
                  return e && e.length ? Wr(e, gs(t)) : n;
                }, Vn.noConflict = function () {
                  return dt._ === this && (dt._ = He), this;
                }, Vn.noop = uc, Vn.now = Ta, Vn.pad = function (e, t, n) {
                  e = ws(e);
                  var r = (t = gs(t)) ? dn(e) : 0;
                  if (!t || r >= t) return e;
                  var i = (t - r) / 2;
                  return Gi(qt(i), n) + e + Gi(Dt(i), n);
                }, Vn.padEnd = function (e, t, n) {
                  e = ws(e);
                  var r = (t = gs(t)) ? dn(e) : 0;
                  return t && r < t ? e + Gi(t - r, n) : e;
                }, Vn.padStart = function (e, t, n) {
                  e = ws(e);
                  var r = (t = gs(t)) ? dn(e) : 0;
                  return t && r < t ? Gi(t - r, n) + e : e;
                }, Vn.parseInt = function (e, t, n) {
                  return n || null == t ? t = 0 : t && (t = +t), xn(ws(e).replace(ie, ""), t || 0);
                }, Vn.random = function (e, t, r) {
                  if (r && "boolean" != typeof r && So(e, t, r) && (t = r = n), r === n && ("boolean" == typeof t ? (r = t, t = n) : "boolean" == typeof e && (r = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = ms(e), t === n ? (t = e, e = 0) : t = ms(t)), e > t) {
                    var i = e;
                    e = t, t = i;
                  }

                  if (r || e % 1 || t % 1) {
                    var o = En();
                    return wn(e + o * (t - e + at("1e-" + ((o + "").length - 1))), t);
                  }

                  return Yr(e, t);
                }, Vn.reduce = function (e, t, n) {
                  var r = Ka(e) ? Nt : Ft,
                      i = arguments.length < 3;
                  return r(e, uo(t, 4), n, i, _r);
                }, Vn.reduceRight = function (e, t, n) {
                  var r = Ka(e) ? Pt : Ft,
                      i = arguments.length < 3;
                  return r(e, uo(t, 4), n, i, fr);
                }, Vn.repeat = function (e, t, r) {
                  return t = (r ? So(e, t, r) : t === n) ? 1 : gs(t), Jr(ws(e), t);
                }, Vn.replace = function () {
                  var e = arguments,
                      t = ws(e[0]);
                  return e.length < 3 ? t : t.replace(e[1], e[2]);
                }, Vn.result = function (e, t, r) {
                  var i = -1,
                      o = (t = wi(t, e)).length;

                  for (o || (o = 1, e = n); ++i < o;) {
                    var a = null == e ? n : e[Bo(t[i])];
                    a === n && (i = o, a = r), e = es(a) ? a.call(e) : a;
                  }

                  return e;
                }, Vn.round = kc, Vn.runInContext = e, Vn.sample = function (e) {
                  return (Ka(e) ? Xn : Xr)(e);
                }, Vn.size = function (e) {
                  if (null == e) return 0;
                  if (Za(e)) return ds(e) ? dn(e) : e.length;
                  var t = go(e);
                  return t == x || t == I ? e.size : Lr(e).length;
                }, Vn.snakeCase = Ys, Vn.some = function (e, t, r) {
                  var i = Ka(e) ? jt : ai;
                  return r && So(e, t, r) && (t = n), i(e, uo(t, 3));
                }, Vn.sortedIndex = function (e, t) {
                  return si(e, t);
                }, Vn.sortedIndexBy = function (e, t, n) {
                  return ci(e, t, uo(n, 2));
                }, Vn.sortedIndexOf = function (e, t) {
                  var n = null == e ? 0 : e.length;

                  if (n) {
                    var r = si(e, t);
                    if (r < n && qa(e[r], t)) return r;
                  }

                  return -1;
                }, Vn.sortedLastIndex = function (e, t) {
                  return si(e, t, !0);
                }, Vn.sortedLastIndexBy = function (e, t, n) {
                  return ci(e, t, uo(n, 2), !0);
                }, Vn.sortedLastIndexOf = function (e, t) {
                  if (null != e && e.length) {
                    var n = si(e, t, !0) - 1;
                    if (qa(e[n], t)) return n;
                  }

                  return -1;
                }, Vn.startCase = Js, Vn.startsWith = function (e, t, n) {
                  return e = ws(e), n = null == n ? 0 : lr(gs(n), 0, e.length), t = ui(t), e.slice(n, n + t.length) == t;
                }, Vn.subtract = Ac, Vn.sum = function (e) {
                  return e && e.length ? Wt(e, ac) : 0;
                }, Vn.sumBy = function (e, t) {
                  return e && e.length ? Wt(e, uo(t, 2)) : 0;
                }, Vn.template = function (e, t, r) {
                  var i = Vn.templateSettings;
                  r && So(e, t, r) && (t = n), e = ws(e), t = Es({}, t, i, eo);

                  var o,
                      a,
                      s = Es({}, t.imports, i.imports, eo),
                      c = js(s),
                      l = Zt(s, c),
                      d = 0,
                      u = t.interpolate || ye,
                      p = "__p += '",
                      h = Ie((t.escape || ye).source + "|" + u.source + "|" + (u === $ ? pe : ye).source + "|" + (t.evaluate || ye).source + "|$", "g"),
                      _ = "//# sourceURL=" + (ze.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++nt + "]") + "\n";

                  e.replace(h, function (t, n, r, i, s, c) {
                    return r || (r = i), p += e.slice(d, c).replace(we, nn), n && (o = !0, p += "' +\n__e(" + n + ") +\n'"), s && (a = !0, p += "';\n" + s + ";\n__p += '"), r && (p += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), d = c + t.length, t;
                  }), p += "';\n";
                  var f = ze.call(t, "variable") && t.variable;

                  if (f) {
                    if (de.test(f)) throw new Ee("Invalid `variable` option passed into `_.template`");
                  } else p = "with (obj) {\n" + p + "\n}\n";

                  p = (a ? p.replace(q, "") : p).replace(F, "$1").replace(W, "$1;"), p = "function(" + (f || "obj") + ") {\n" + (f ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (o ? ", __e = _.escape" : "") + (a ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + p + "return __p\n}";
                  var m = tc(function () {
                    return Ce(c, _ + "return " + p).apply(n, l);
                  });
                  if (m.source = p, Xa(m)) throw m;
                  return m;
                }, Vn.times = function (e, t) {
                  if ((e = gs(e)) < 1 || e > p) return [];
                  var n = _,
                      r = wn(e, _);
                  t = uo(t), e -= _;

                  for (var i = Gt(r, t); ++n < e;) {
                    t(n);
                  }

                  return i;
                }, Vn.toFinite = ms, Vn.toInteger = gs, Vn.toLength = vs, Vn.toLower = function (e) {
                  return ws(e).toLowerCase();
                }, Vn.toNumber = bs, Vn.toSafeInteger = function (e) {
                  return e ? lr(gs(e), -9007199254740991, p) : 0 === e ? e : 0;
                }, Vn.toString = ws, Vn.toUpper = function (e) {
                  return ws(e).toUpperCase();
                }, Vn.trim = function (e, t, r) {
                  if ((e = ws(e)) && (r || t === n)) return Kt(e);
                  if (!e || !(t = ui(t))) return e;
                  var i = un(e),
                      o = un(t);
                  return xi(i, Jt(i, o), $t(i, o) + 1).join("");
                }, Vn.trimEnd = function (e, t, r) {
                  if ((e = ws(e)) && (r || t === n)) return e.slice(0, pn(e) + 1);
                  if (!e || !(t = ui(t))) return e;
                  var i = un(e);
                  return xi(i, 0, $t(i, un(t)) + 1).join("");
                }, Vn.trimStart = function (e, t, r) {
                  if ((e = ws(e)) && (r || t === n)) return e.replace(ie, "");
                  if (!e || !(t = ui(t))) return e;
                  var i = un(e);
                  return xi(i, Jt(i, un(t))).join("");
                }, Vn.truncate = function (e, t) {
                  var r = 30,
                      i = "...";

                  if (rs(t)) {
                    var o = "separator" in t ? t.separator : o;
                    r = "length" in t ? gs(t.length) : r, i = "omission" in t ? ui(t.omission) : i;
                  }

                  var a = (e = ws(e)).length;

                  if (rn(e)) {
                    var s = un(e);
                    a = s.length;
                  }

                  if (r >= a) return e;
                  var c = r - dn(i);
                  if (c < 1) return i;
                  var l = s ? xi(s, 0, c).join("") : e.slice(0, c);
                  if (o === n) return l + i;

                  if (s && (c += l.length - c), cs(o)) {
                    if (e.slice(c).search(o)) {
                      var d,
                          u = l;

                      for (o.global || (o = Ie(o.source, ws(he.exec(o)) + "g")), o.lastIndex = 0; d = o.exec(u);) {
                        var p = d.index;
                      }

                      l = l.slice(0, p === n ? c : p);
                    }
                  } else if (e.indexOf(ui(o), c) != c) {
                    var h = l.lastIndexOf(o);
                    h > -1 && (l = l.slice(0, h));
                  }

                  return l + i;
                }, Vn.unescape = function (e) {
                  return (e = ws(e)) && Q.test(e) ? e.replace(G, hn) : e;
                }, Vn.uniqueId = function (e) {
                  var t = ++Me;
                  return ws(e) + t;
                }, Vn.upperCase = $s, Vn.upperFirst = Xs, Vn.each = wa, Vn.eachRight = Sa, Vn.first = Zo, dc(Vn, (yc = {}, Sr(Vn, function (e, t) {
                  ze.call(Vn.prototype, t) || (yc[t] = e);
                }), yc), {
                  chain: !1
                }), Vn.VERSION = "4.17.21", Et(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
                  Vn[e].placeholder = Vn;
                }), Et(["drop", "take"], function (e, t) {
                  Gn.prototype[e] = function (r) {
                    r = r === n ? 1 : yn(gs(r), 0);
                    var i = this.__filtered__ && !t ? new Gn(this) : this.clone();
                    return i.__filtered__ ? i.__takeCount__ = wn(r, i.__takeCount__) : i.__views__.push({
                      size: wn(r, _),
                      type: e + (i.__dir__ < 0 ? "Right" : "")
                    }), i;
                  }, Gn.prototype[e + "Right"] = function (t) {
                    return this.reverse()[e](t).reverse();
                  };
                }), Et(["filter", "map", "takeWhile"], function (e, t) {
                  var n = t + 1,
                      r = 1 == n || 3 == n;

                  Gn.prototype[e] = function (e) {
                    var t = this.clone();
                    return t.__iteratees__.push({
                      iteratee: uo(e, 3),
                      type: n
                    }), t.__filtered__ = t.__filtered__ || r, t;
                  };
                }), Et(["head", "last"], function (e, t) {
                  var n = "take" + (t ? "Right" : "");

                  Gn.prototype[e] = function () {
                    return this[n](1).value()[0];
                  };
                }), Et(["initial", "tail"], function (e, t) {
                  var n = "drop" + (t ? "" : "Right");

                  Gn.prototype[e] = function () {
                    return this.__filtered__ ? new Gn(this) : this[n](1);
                  };
                }), Gn.prototype.compact = function () {
                  return this.filter(ac);
                }, Gn.prototype.find = function (e) {
                  return this.filter(e).head();
                }, Gn.prototype.findLast = function (e) {
                  return this.reverse().find(e);
                }, Gn.prototype.invokeMap = $r(function (e, t) {
                  return "function" == typeof e ? new Gn(this) : this.map(function (n) {
                    return Nr(n, e, t);
                  });
                }), Gn.prototype.reject = function (e) {
                  return this.filter(La(uo(e)));
                }, Gn.prototype.slice = function (e, t) {
                  e = gs(e);
                  var r = this;
                  return r.__filtered__ && (e > 0 || t < 0) ? new Gn(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== n && (r = (t = gs(t)) < 0 ? r.dropRight(-t) : r.take(t - e)), r);
                }, Gn.prototype.takeRightWhile = function (e) {
                  return this.reverse().takeWhile(e).reverse();
                }, Gn.prototype.toArray = function () {
                  return this.take(_);
                }, Sr(Gn.prototype, function (e, t) {
                  var r = /^(?:filter|find|map|reject)|While$/.test(t),
                      i = /^(?:head|last)$/.test(t),
                      o = Vn[i ? "take" + ("last" == t ? "Right" : "") : t],
                      a = i || /^find/.test(t);
                  o && (Vn.prototype[t] = function () {
                    var t = this.__wrapped__,
                        s = i ? [1] : arguments,
                        c = t instanceof Gn,
                        l = s[0],
                        d = c || Ka(t),
                        u = function u(e) {
                      var t = o.apply(Vn, Rt([e], s));
                      return i && p ? t[0] : t;
                    };

                    d && r && "function" == typeof l && 1 != l.length && (c = d = !1);

                    var p = this.__chain__,
                        h = !!this.__actions__.length,
                        _ = a && !p,
                        f = c && !h;

                    if (!a && d) {
                      t = f ? t : new Gn(this);
                      var m = e.apply(t, s);
                      return m.__actions__.push({
                        func: ma,
                        args: [u],
                        thisArg: n
                      }), new Wn(m, p);
                    }

                    return _ && f ? e.apply(this, s) : (m = this.thru(u), _ ? i ? m.value()[0] : m.value() : m);
                  });
                }), Et(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
                  var t = Re[e],
                      n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                      r = /^(?:pop|shift)$/.test(e);

                  Vn.prototype[e] = function () {
                    var e = arguments;

                    if (r && !this.__chain__) {
                      var i = this.value();
                      return t.apply(Ka(i) ? i : [], e);
                    }

                    return this[n](function (n) {
                      return t.apply(Ka(n) ? n : [], e);
                    });
                  };
                }), Sr(Gn.prototype, function (e, t) {
                  var n = Vn[t];

                  if (n) {
                    var r = n.name + "";
                    ze.call(Pn, r) || (Pn[r] = []), Pn[r].push({
                      name: t,
                      func: n
                    });
                  }
                }), Pn[Vi(n, 2).name] = [{
                  name: "wrapper",
                  func: n
                }], Gn.prototype.clone = function () {
                  var e = new Gn(this.__wrapped__);
                  return e.__actions__ = Ri(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ri(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ri(this.__views__), e;
                }, Gn.prototype.reverse = function () {
                  if (this.__filtered__) {
                    var e = new Gn(this);
                    e.__dir__ = -1, e.__filtered__ = !0;
                  } else (e = this.clone()).__dir__ *= -1;

                  return e;
                }, Gn.prototype.value = function () {
                  var e = this.__wrapped__.value(),
                      t = this.__dir__,
                      n = Ka(e),
                      r = t < 0,
                      i = n ? e.length : 0,
                      o = function (e, t, n) {
                    for (var r = -1, i = n.length; ++r < i;) {
                      var o = n[r],
                          a = o.size;

                      switch (o.type) {
                        case "drop":
                          e += a;
                          break;

                        case "dropRight":
                          t -= a;
                          break;

                        case "take":
                          t = wn(t, e + a);
                          break;

                        case "takeRight":
                          e = yn(e, t - a);
                      }
                    }

                    return {
                      start: e,
                      end: t
                    };
                  }(0, i, this.__views__),
                      a = o.start,
                      s = o.end,
                      c = s - a,
                      l = r ? s : a - 1,
                      d = this.__iteratees__,
                      u = d.length,
                      p = 0,
                      h = wn(c, this.__takeCount__);

                  if (!n || !r && i == c && h == c) return mi(e, this.__actions__);
                  var _ = [];

                  e: for (; c-- && p < h;) {
                    for (var f = -1, m = e[l += t]; ++f < u;) {
                      var g = d[f],
                          v = g.iteratee,
                          b = g.type,
                          y = v(m);
                      if (2 == b) m = y;else if (!y) {
                        if (1 == b) continue e;
                        break e;
                      }
                    }

                    _[p++] = m;
                  }

                  return _;
                }, Vn.prototype.at = ga, Vn.prototype.chain = function () {
                  return fa(this);
                }, Vn.prototype.commit = function () {
                  return new Wn(this.value(), this.__chain__);
                }, Vn.prototype.next = function () {
                  this.__values__ === n && (this.__values__ = fs(this.value()));
                  var e = this.__index__ >= this.__values__.length;
                  return {
                    done: e,
                    value: e ? n : this.__values__[this.__index__++]
                  };
                }, Vn.prototype.plant = function (e) {
                  for (var t, r = this; r instanceof Fn;) {
                    var i = Vo(r);
                    i.__index__ = 0, i.__values__ = n, t ? o.__wrapped__ = i : t = i;
                    var o = i;
                    r = r.__wrapped__;
                  }

                  return o.__wrapped__ = e, t;
                }, Vn.prototype.reverse = function () {
                  var e = this.__wrapped__;

                  if (e instanceof Gn) {
                    var t = e;
                    return this.__actions__.length && (t = new Gn(this)), (t = t.reverse()).__actions__.push({
                      func: ma,
                      args: [ra],
                      thisArg: n
                    }), new Wn(t, this.__chain__);
                  }

                  return this.thru(ra);
                }, Vn.prototype.toJSON = Vn.prototype.valueOf = Vn.prototype.value = function () {
                  return mi(this.__wrapped__, this.__actions__);
                }, Vn.prototype.first = Vn.prototype.head, ct && (Vn.prototype[ct] = function () {
                  return this;
                }), Vn;
              }();

              pt ? ((pt.exports = _n)._ = _n, ut._ = _n) : dt._ = _n;
            }).call(Ay);
          }(TY, TY.exports);

          var OY = ("scrollBehavior" in document.documentElement.style),
              RY = function RY(e, t) {
            var n = e.x,
                r = e.y,
                i = {
              x: 0,
              y: 0
            };
            return i.x = n < 0 ? t.left * -n : t.right * n, i.y = r < 0 ? t.top * -r : t.bottom * r, i;
          },
              NY = Ok(function (e) {
            return {
              root: function root() {
                return {
                  display: "flex",
                  alignItems: "center",
                  color: e.palette.common.white,
                  maxHeight: "30px",
                  background: "transparent",
                  maxWidth: "80%",
                  position: "absolute",
                  bottom: "150px",
                  left: 0,
                  right: 0,
                  margin: "0 auto",
                  textAlign: "left",
                  "& div": {
                    backgroundColor: "#242424",
                    borderRadius: "5px",
                    fontSize: "16px",
                    lineHeight: "150%",
                    padding: e.spacing(.5, 2),
                    display: "flex",
                    alignTtems: "left",
                    margin: "0 auto",
                    wordBreak: "break-word",
                    fontFamily: ["Inter", "-apple-system", "BlinkMacSystemFont", "sans-serif"].join(","),
                    color: "#fff",
                    width: "396px",
                    overflowWrap: "break-word",
                    wordWrap: "break-word",
                    "-ms-word-break": "break-word",
                    "word-break": "break-word"
                  }
                };
              },
              content: {}
            };
          }),
              PY = function PY(t) {
            var _e$useContext138 = e.useContext(JM),
                n = _e$useContext138.isShowCC.toast,
                r = _e$useContext138.dispatch,
                i = e.useContext(zM),
                _e$useContext139 = e.useContext($M),
                o = _e$useContext139.ccClient,
                _zF4 = zF(i, o),
                a = _zF4.latestMsg,
                _e$useState311 = e.useState(a),
                _e$useState312 = _slicedToArray(_e$useState311, 2),
                s = _e$useState312[0],
                c = _e$useState312[1],
                _e$useState313 = e.useState({
              width: 0,
              height: 0
            }),
                _e$useState314 = _slicedToArray(_e$useState313, 2),
                d = _e$useState314[0],
                u = _e$useState314[1];

            NM();
            var p = NY();
            e.useCallback(function () {
              null == r || r(ZB(!1));
            }, [r]);

            var _e$useState315 = e.useState({
              x: 0,
              y: 0
            }),
                _e$useState316 = _slicedToArray(_e$useState315, 2),
                h = _e$useState316[0],
                _ = _e$useState316[1],
                _e$useState317 = e.useState({
              left: 0,
              top: 0,
              right: 0,
              bottom: 0
            }),
                _e$useState318 = _slicedToArray(_e$useState317, 2),
                f = _e$useState318[0],
                m = _e$useState318[1],
                g = e.useRef(null),
                v = g.current ? g.current.offsetHeight : 0,
                b = e.useRef(null),
                y = Wz(d),
                w = s.trim().length > 0 && n,
                S = e.useCallback(function () {
              var e, t, n;
              g.current && parseInt(null == g || null === (e = g.current) || void 0 === e || null === (t = e.parentNode) || void 0 === t || null === (n = t.style) || void 0 === n ? void 0 : n.zIndex, 10);
            }, []);

            RY(h, f);
            var x = e.useCallback(function () {
              var e = g.current;

              if (null !== e) {
                var _t162 = null == e ? void 0 : e.offsetHeight,
                    _n104 = d.width / 2 - 198 - 16,
                    _r73 = d.width / 2 + 198 - 396 - 16,
                    _i37 = d.height - 68 - 16 - _t162;

                m({
                  left: -_n104 < 0 ? -_n104 : 0,
                  top: -_i37 < 0 ? -_i37 : 0,
                  right: _r73 > 0 ? _r73 : 0,
                  bottom: 52
                });
              }
            }, [d]);
            e.useEffect(function () {
              c(a);
              var e = setTimeout(function () {
                c("");
              }, 1e4);
              return function () {
                clearTimeout(e);
              };
            }, [a, c]), e.useEffect(function () {
              null !== y && d.width === y.width && d.height === y.height || x();
            }, [d, y, x]), e.useEffect(function () {
              w && (x(), S());
            }, [w, s, x, S]), e.useEffect(function () {
              var e = requestAnimationFrame(function () {
                var e = g.current;
                e && e.offsetHeight !== v && x();
              });
              return function () {
                cancelAnimationFrame(e);
              };
            }, [s, x, v]), e.useEffect(function () {
              var e = requestAnimationFrame(function () {
                var e = b.current,
                    t = g.current;

                if (t && e && e.offsetHeight > 80) {
                  var _n105 = e.offsetHeight - 76;

                  OY ? t.scrollTo({
                    left: 0,
                    top: _n105,
                    behavior: "smooth"
                  }) : t.scrollTop = _n105;
                }
              });
              return function () {
                cancelAnimationFrame(e);
              };
            }, [s]);
            var E = e.useCallback(function (e) {
              var t = e.width,
                  n = e.height;
              TY.exports.debounce(function () {
                u({
                  width: arguments.length <= 0 ? void 0 : arguments[0],
                  height: arguments.length <= 1 ? void 0 : arguments[1]
                });
              }, 300, {
                leading: !0
              })(t, n);
            }, []);
            var C;
            C = E, e.useLayoutEffect(function () {
              var e = new ResizeObserver(function (e) {
                e.forEach(function (e) {
                  var t = {
                    width: window.innerWidth,
                    height: window.innerHeight
                  };
                  (Lz() || Uz()) && (t = {
                    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
                  }), C(t);
                });
              }),
                  t = document.getElementsByTagName("body")[0];
              return e.observe(t), function () {
                e.unobserve(t), e.disconnect();
              };
            }, [C]);
            var k = TH.exports.jsx("div", {
              children: w && TH.exports.jsx(qP, {
                bounds: f,
                children: TH.exports.jsx("div", {
                  className: p.root,
                  ref: g,
                  style: {
                    zIndex: 999,
                    bottom: 68
                  },
                  onClick: S,
                  children: TH.exports.jsx("div", {
                    ref: b,
                    children: s
                  })
                })
              })
            });
            return l.default.createPortal(k, document.body);
          },
              jY = Ok(function () {
            return {
              panel: {
                width: "360px"
              },
              height1: {
                height: "180"
              },
              height2: {
                height: "215"
              },
              height3: {
                height: "320px"
              },
              label: {
                "& span": {
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "13px",
                  lineHeight: "16px",
                  color: "#F5F5F5"
                }
              },
              button: {
                "& button": _defineProperty({
                  border: "1px solid #707070",
                  boxSizing: "border-box",
                  borderRadius: "6px",
                  width: "200px"
                }, "& .".concat(kH, "-MuiButton-text"), {
                  padding: "2px 5px 2px 5px"
                })
              },
              button2: {
                "& button": {
                  width: "150px",
                  marginLeft: "10px"
                }
              },
              button3: {
                "& button": {
                  width: "200px"
                }
              },
              button4: {
                "& button": {
                  width: "auto"
                }
              },
              copied: {
                color: "#23D959"
              },
              listWrapper: {
                "& li": {
                  padding: "2px"
                }
              },
              content: {
                width: "80%"
              },
              split: {
                height: "2px",
                padding: 0,
                background: "rgba(255, 255, 255, 0.09)"
              },
              checked: {
                "& svg": {
                  color: "#0E71EB"
                }
              }
            };
          }),
              DY = function DY(t) {
            var _VC18;

            var n = e.useContext(zM),
                _e$useContext140 = e.useContext($M),
                r = _e$useContext140.ccClient,
                _zF5 = zF(n, r),
                i = _zF5.ccEditor,
                _e$useContext141 = e.useContext(jM),
                o = _e$useContext141.ccStatus,
                a = _e$useContext141.userId,
                s = _e$useContext141.dispatch,
                _e$useState319 = e.useState(!1),
                _e$useState320 = _slicedToArray(_e$useState319, 2),
                c = _e$useState320[0],
                l = _e$useState320[1],
                _e$useState321 = e.useState(""),
                _e$useState322 = _slicedToArray(_e$useState321, 2),
                d = _e$useState322[0],
                p = _e$useState322[1],
                _e$useContext142 = e.useContext(JM),
                h = _e$useContext142.isShowCC.setting,
                _ = _e$useContext142.dispatch,
                _NM68 = NM(),
                f = _NM68.t,
                m = jY(),
                g = e.useCallback(function () {
              null == _ || _(GB(!1));
            }, [_]),
                v = e.useCallback(function () {
              null == r || r.startLiveTranscription(!o.isLTEnable);
            }, [r, o.isLTEnable]),
                b = (e.useCallback(function () {
              null == r || r.allowAskLiveTranscription(!o.allowRequestLt);
            }, [r, o.allowRequestLt]), e.useCallback(function () {
              null == r || r.assignClosedCaptionEditor(a), null == _ || _(GB(!1)), null == _ || _(KB(!0));
            }, [_, r, a])),
                y = e.useCallback(function () {
              null == _ || _(GB(!1)), null == _ || _(MB(!0));
            }, [_]);

            return e.useEffect(function () {
              p(null == r ? void 0 : r.getCCUrl());
            }, []), e.useEffect(function () {
              c && setTimeout(function () {
                l(!1);
              }, 5e3);
            }, [c]), TH.exports.jsx(XW, u(u({
              title: "",
              open: h,
              onClose: g,
              placement: "right-start",
              className: VC(m.panel, (_VC18 = {}, _defineProperty(_VC18, m.height1, o.isMeetingEnableClosedCaption), _defineProperty(_VC18, m.height2, o.isMeetingEnableClosedCaption && o.isMeetingEnableAllowThirdPartyCCToken), _defineProperty(_VC18, m.height3, o.isMeetingEnableClosedCaption && o.isMeetingEnableAllowThirdPartyCCToken && o.isMeetingEnabledLiveTranscriptionFeature), _VC18))
            }, t), {}, {
              children: TH.exports.jsxs(WA, {
                className: m.listWrapper,
                children: [TH.exports.jsx(zT, {
                  children: TH.exports.jsx(VT, {
                    primaryTypographyProps: {
                      noWrap: !0
                    },
                    className: m.label,
                    children: f("wc_cc_assign_to_type")
                  })
                }), TH.exports.jsxs(zT, {
                  children: [TH.exports.jsx(VT, {
                    className: m.button,
                    children: TH.exports.jsx(YA, {
                      onClick: y,
                      children: f("wc_cc_assign_participant_to_type")
                    })
                  }), TH.exports.jsx(VT, {
                    className: VC(m.button, m.button2),
                    children: TH.exports.jsx(YA, {
                      onClick: b,
                      children: f("wc_cc_type_myself")
                    })
                  })]
                }), o.isMeetingEnableAllowThirdPartyCCToken && TH.exports.jsxs("div", {
                  children: [TH.exports.jsx(zT, {
                    children: TH.exports.jsx(VT, {
                      primaryTypographyProps: {
                        noWrap: !0
                      },
                      className: m.label,
                      children: f("wc_3rd_cc_service")
                    })
                  }), TH.exports.jsx(zT, {
                    children: TH.exports.jsxs(VT, {
                      primaryTypographyProps: {
                        noWrap: !0
                      },
                      className: VC(m.button, m.button3),
                      children: [!c && TH.exports.jsx(tZ, {
                        text: d || "",
                        children: TH.exports.jsx(AF, {
                          iconType: "",
                          className: VC(m.button, m.button2),
                          onClick: function onClick() {
                            l(!0);
                          },
                          children: f("wc_3rd_cc_copy_api_token")
                        })
                      }), c && TH.exports.jsx(AF, {
                        className: VC(m.button, m.button2, m.copied),
                        children: f("wc_copied")
                      })]
                    })
                  }), TH.exports.jsx(zT, {
                    children: TH.exports.jsx(VT, {
                      primaryTypographyProps: {
                        noWrap: !0
                      },
                      className: m.content,
                      children: f("wc_3rd_cc_url_help_tips2")
                    })
                  })]
                }), o.isMeetingEnabledLiveTranscriptionFeature && TH.exports.jsxs("div", {
                  children: [TH.exports.jsx("div", {
                    className: m.split
                  }), TH.exports.jsx(zT, {
                    children: TH.exports.jsx(VT, {
                      primaryTypographyProps: {
                        noWrap: !0
                      },
                      className: m.label,
                      children: f("wc_live_transcription_btn")
                    })
                  }), TH.exports.jsx(zT, {
                    children: TH.exports.jsx(VT, {
                      primaryTypographyProps: {
                        noWrap: !0
                      },
                      className: VC(m.button, m.button4),
                      children: TH.exports.jsx(YA, {
                        onClick: v,
                        children: o.isLTEnable ? f("wc_lt_disable_transcription") : f("wc_lt_enable_transcription")
                      })
                    })
                  })]
                }), o.isMeetingEnabledLiveTranscriptionFeature && !(null != i && i.userId) && !1]
              })
            }));
          },
              zY = Ok(function (e) {
            return {
              contentContainer: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 1)
                }
              },
              title: {
                maxWidth: "60vw"
              }
            };
          }),
              MY = function MY(t) {
            var _e$useState323 = e.useState(!0),
                _e$useState324 = _slicedToArray(_e$useState323, 2),
                n = _e$useState324[0],
                r = _e$useState324[1],
                i = zY();

            return e.useEffect(function () {
              n && setTimeout(function () {
                r(!1);
              }, 5e3);
            }, [n, r]), TH.exports.jsx(EW, {
              open: n,
              anchorEl: t.anchorElement,
              placement: "right-start",
              children: TH.exports.jsx(vK, {
                children: TH.exports.jsxs(WA, {
                  className: i.contentContainer,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    className: i.title,
                    noWrap: !0,
                    children: t.text
                  }), TH.exports.jsx(AF, {
                    iconType: "icon-close",
                    onClick: function onClick() {
                      return r(!1);
                    }
                  })]
                })
              })
            });
          },
              LY = function LY() {
            var _NM69 = NM(),
                e = _NM69.t;

            return TH.exports.jsx(QA, {
              variant: "body1",
              children: e("disclaimer.LT_content_1_1")
            });
          },
              UY = Ok(function (e) {
            var _textarea3;

            return {
              ccHistoryPannel: {},
              list: {
                position: "relative",
                scrollbarColor: "#4c4545 #282828",
                scrollbarWidth: "thin",
                "& .ReactVirtualized__List::-webkit-scrollbar": {
                  width: "8px"
                },
                "& .ReactVirtualized__List::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: "100px"
                }
              },
              ccUrlCopy: {
                height: "424px"
              },
              noCCurlCopy: {
                height: "458px"
              },
              ccUrl: {
                height: "30px",
                position: "relative"
              },
              disabled: {
                marginTop: "10px",
                height: "113px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              },
              message: {
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "0"
              },
              messagetext: _defineProperty({
                padding: "2px 14px",
                borderRadius: "4px"
              }, "& .".concat(kH, "-MuiListItemText-primary"), {
                fontSize: "13px"
              }),
              textarea: (_textarea3 = {
                paddingTop: "5px"
              }, _defineProperty(_textarea3, "& .".concat(kH, "-MuiInput-underline:after"), {
                border: "none !important"
              }), _defineProperty(_textarea3, "& .".concat(kH, "-MuiInput-underline:before"), {
                border: "none !important"
              }), _defineProperty(_textarea3, "& textarea", {
                fontSize: "13px",
                scrollbarColor: "#707070 #282828",
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "8px"
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#707070",
                  borderRadius: "100px"
                }
              }), _defineProperty(_textarea3, "& textarea::placeholder", {
                fontSize: "13px"
              }), _defineProperty(_textarea3, "height", "75px"), _textarea3),
              textareaBorder: {
                display: "flex",
                borderWidth: "1px",
                color: "rgba(255, 255, 255, 0.18)",
                borderTop: "solid",
                cursor: "pointer",
                marginLeft: -e.spacing(3),
                marginRight: -e.spacing(3)
              },
              button: {
                width: "95%",
                height: "28px",
                lineHeight: "28px",
                margin: "4px auto",
                textAlign: "center",
                "& a": {
                  "&:hover": {
                    cursor: "pointer"
                  },
                  color: "#4F9AF7"
                },
                fontSize: "13px"
              },
              copied: {
                background: "#268543",
                borderRadius: "8px",
                fontSize: "13px",
                width: "95%",
                height: "28px",
                lineHeight: "28px",
                margin: "4px auto",
                textAlign: "center",
                color: "white"
              },
              input: {
                "&:after": {
                  border: "none !important"
                },
                "&:before": {
                  border: "none !important"
                }
              },
              sectionHeader: {
                padding: e.spacing(3, 0)
              },
              clear: _defineProperty({}, "& .".concat(kH, "-MuiSvgIcon-root"), {
                fontSize: "14px"
              }),
              timestamp: {
                color: "rgba(255,255,255,0.34)",
                fontSize: "13px",
                marginRight: "5px"
              },
              gettyNoticeBox: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                height: "24px",
                marginLeft: -e.spacing(3),
                marginRight: -e.spacing(3),
                color: "rgba(255, 255, 255, 0.54)",
                background: "rgba(255, 255, 255, 0.18)",
                "&:hover": {
                  background: "#383838",
                  borderRadius: "0px 0px 8px 8px"
                },
                marginBottom: "-12px"
              },
              gettyTooltip: {
                background: "#383838",
                color: "rgba(255, 255, 255, 0.54)"
              },
              gettyTooltipArrow: _defineProperty({}, "&.".concat(kH, "-MuiTooltip-arrow"), {
                color: "#383838"
              })
            };
          }),
              BY = function BY(t) {
            var _VC19;

            var _NM70 = NM(),
                n = _NM70.t,
                r = UY(),
                i = e.useContext(zM),
                _e$useContext143 = e.useContext($M),
                o = _e$useContext143.ccClient,
                _e$useContext144 = e.useContext(JM),
                _e$useContext144$isSh = _e$useContext144.isShowCC,
                a = _e$useContext144$isSh.setting,
                s = _e$useContext144$isSh.history,
                c = _e$useContext144$isSh.toast,
                l = _e$useContext144$isSh.input,
                d = _e$useContext144.dispatch,
                _e$useContext145 = e.useContext(jM),
                p = _e$useContext145.isCoHost,
                h = _e$useContext145.isHost,
                _ = _e$useContext145.userId,
                f = _e$useContext145.participants,
                m = _e$useContext145.ccStatus,
                _e$useState325 = e.useState(""),
                _e$useState326 = _slicedToArray(_e$useState325, 2),
                g = _e$useState326[0],
                v = _e$useState326[1],
                _e$useState327 = e.useState(!1),
                _e$useState328 = _slicedToArray(_e$useState327, 2),
                b = _e$useState328[0],
                y = _e$useState328[1],
                _e$useState329 = e.useState(!1),
                _e$useState330 = _slicedToArray(_e$useState329, 2),
                w = _e$useState330[0],
                S = _e$useState330[1],
                _e$useState331 = e.useState(""),
                _e$useState332 = _slicedToArray(_e$useState331, 2),
                x = _e$useState332[0],
                E = _e$useState332[1],
                _e$useState333 = e.useState(!1),
                _e$useState334 = _slicedToArray(_e$useState333, 2),
                C = _e$useState334[0],
                k = _e$useState334[1],
                _zF6 = zF(i, o),
                A = _zF6.histories,
                I = _zF6.historiesLength,
                T = _zF6.ccEditor,
                O = _zF6.markReadIndex,
                R = e.useRef(null),
                N = e.useRef(new TK({
              defaultHeight: 40,
              fixedWidth: !0
            })),
                P = e.useRef(!0),
                j = e.useCallback(function () {
              null == d || d(GB(!1)), null == d || d(KB(!1));
            }, [d]),
                D = e.useMemo(function () {
              return A.filter(function (e) {
                return !e.srcMsgID;
              });
            }, [A]),
                z = Wz(D.length),
                M = e.useCallback(function (e) {
              var t = e.index,
                  n = e.key,
                  i = e.style,
                  o = e.parent;
              var a = D[t];
              return null != a && a.text ? TH.exports.jsx(kK, {
                cache: N.current,
                columnIndex: 0,
                parent: o,
                rowIndex: t,
                children: TH.exports.jsx(zT, {
                  style: i,
                  className: r.message,
                  children: TH.exports.jsx(VT, {
                    primary: a.text,
                    className: r.messagetext
                  })
                }, t)
              }, a.id || a.srcMsgID || n) : null;
            }, [D, _, r]),
                L = e.useCallback(function (e) {
              var t = e.stopIndex;
              O(t);
            }, [O]),
                U = e.useCallback(function (e) {
              v(e.target.value), e.target.value && (null == o || o.sendClosedCaptionText(e.target.value, !0).then(function () {}));
            }, []),
                B = e.useCallback(VG(function (e) {
              var t = e.clientHeight,
                  n = e.scrollHeight,
                  r = e.scrollTop;
              P.current = n - t - r <= 50;
            }, 200), []),
                H = e.useCallback(function (e) {
              "Enter" === e.key && (e.preventDefault(), g) && (null == o || o.sendClosedCaptionText(g, !1).then(function () {
                P.current = !0, v("");
              }));
            }, [g, o]),
                V = function V() {
              S(!1);
            };

            e.useEffect(function () {
              b && setTimeout(function () {
                y(!1);
              }, 5e3);
            }, [b]), e.useEffect(function () {
              0 === z && D.length && (k(!0), setTimeout(function () {
                k(!1);
              }, 5e3));
            }, [z, D]), e.useEffect(function () {
              h && E(null == o ? void 0 : o.getCCUrl());
            }, [h, o]), e.useEffect(function () {
              if (P.current) {
                var e;

                var _t163 = D.length - 1;

                null === (e = R.current) || void 0 === e || e.scrollToRow(_t163);
              }
            }, [D]);
            var q = m.isMeetingEnableAllowThirdPartyCCToken || C || !m.isMeetingEnableAllowThirdPartyCCToken && C,
                F = VC(r.list, (_VC19 = {}, _defineProperty(_VC19, r.ccUrlCopy, q), _defineProperty(_VC19, r.noCCurlCopy, !q), _VC19)),
                W = n("wc_closed_caption_btn") + " - " + n("wc_broadcasting");
            return TH.exports.jsxs(XW, u(u({
              title: W,
              open: l,
              onClose: j,
              className: r.ccHistoryPannel
            }, t), {}, {
              children: [m.isMeetingEnableAllowThirdPartyCCToken && !C && TH.exports.jsxs(WA, {
                className: r.ccUrl,
                children: [!b && !C && TH.exports.jsx(tZ, {
                  text: x || "",
                  children: TH.exports.jsx(WA, {
                    className: VC(r.button),
                    children: TH.exports.jsx("a", {
                      onClick: function onClick() {
                        y(!0);
                      },
                      children: n("wc_3rd_cc_service")
                    })
                  })
                }), b && !C && TH.exports.jsx(WA, {
                  className: VC(r.copied),
                  children: n("wc_3rd_cc_copied_api_token")
                })]
              }), C && TH.exports.jsx(WA, {
                className: r.ccUrl,
                children: TH.exports.jsx(WA, {
                  className: VC(r.copied),
                  children: n("wc_cc_broadcasting_tip")
                })
              }), TH.exports.jsx(WA, {
                className: F,
                children: TH.exports.jsx(jK, {
                  children: function children(e) {
                    var t = e.width,
                        n = e.height;
                    return TH.exports.jsx(_W, {
                      ref: R,
                      width: t,
                      height: n,
                      rowHeight: N.current.rowHeight,
                      deferredMeasurementCache: N.current,
                      rowRenderer: M,
                      rowCount: A.length,
                      onRowsRendered: L,
                      onScroll: B
                    });
                  }
                })
              }), TH.exports.jsx(WA, {
                className: r.textareaBorder
              }), TH.exports.jsx(WA, {
                children: TH.exports.jsx(MN, {
                  rows: 4,
                  className: r.textarea,
                  fullWidth: !0,
                  multiline: !0,
                  onChange: U,
                  onKeyPress: H,
                  value: g,
                  placeholder: n("wc_cc.placeholder")
                })
              }), TH.exports.jsx(fI, {
                onClickAway: V,
                children: TH.exports.jsx(VN, {
                  classes: {
                    tooltip: r.gettyTooltip,
                    arrow: r.gettyTooltipArrow
                  },
                  title: TH.exports.jsx(LY, {}),
                  placement: "top",
                  open: w,
                  onClose: V,
                  PopperProps: {
                    disablePortal: !0
                  },
                  arrow: !0,
                  "aria-label": "chat-privacy-notice",
                  disableHoverListener: !0,
                  children: TH.exports.jsxs(WA, {
                    className: r.gettyNoticeBox,
                    onClick: function onClick() {
                      S(!w);
                    },
                    children: [TH.exports.jsx(CF, {
                      type: "icon-privacy",
                      iconStyle: {
                        transform: "scale(0.7)"
                      }
                    }), TH.exports.jsx(QA, {
                      variant: "body1",
                      style: {
                        margin: 5
                      },
                      children: n("disclaimer.LT_button_1")
                    })]
                  })
                })
              })]
            }));
          },
              HY = Ok(function (e) {
            return {
              contentContainer: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 1)
                }
              },
              title: {
                marginRight: "5px"
              },
              gettyNoticeBox: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                height: "24px",
                width: "210px",
                color: "#F5F5F5",
                background: "rgba(255, 255, 255, 0.09)",
                borderRadius: "6px"
              },
              gettyTooltip: {
                background: "#383838",
                color: "rgba(255, 255, 255, 0.54)"
              },
              gettyTooltipArrow: _defineProperty({}, "&.".concat(kH, "-MuiTooltip-arrow"), {
                color: "#383838"
              })
            };
          }),
              VY = function VY(t) {
            var _e$useState335 = e.useState(!1),
                _e$useState336 = _slicedToArray(_e$useState335, 2),
                n = _e$useState336[0],
                r = _e$useState336[1],
                _e$useContext146 = e.useContext(JM),
                i = _e$useContext146.isShowCC.getty,
                o = _e$useContext146.dispatch,
                a = HY(),
                s = function s() {
              r(!1);
            },
                _NM71 = NM(),
                c = _NM71.t;

            return e.useRef(null), TH.exports.jsx(EW, {
              open: i,
              placement: "right-start",
              style: {
                position: "absolute",
                top: "8px",
                left: "50%",
                margin: "0 auto",
                transform: "translateX(-50%)",
                backdropFilter: "blur(48px)",
                borderRadius: "14px",
                background: "#242424"
              },
              children: TH.exports.jsx(vK, {
                children: TH.exports.jsxs(WA, {
                  className: a.contentContainer,
                  children: [TH.exports.jsx(QA, {
                    variant: "body1",
                    className: a.title,
                    noWrap: !0,
                    children: t.text
                  }), TH.exports.jsx(fI, {
                    onClickAway: s,
                    children: TH.exports.jsx(VN, {
                      classes: {
                        tooltip: a.gettyTooltip,
                        arrow: a.gettyTooltipArrow
                      },
                      title: TH.exports.jsx(LY, {}),
                      placement: "top",
                      open: n,
                      onClose: s,
                      PopperProps: {
                        disablePortal: !0
                      },
                      arrow: !0,
                      "aria-label": "cc-getty-notice",
                      disableHoverListener: !0,
                      children: TH.exports.jsxs(WA, {
                        className: a.gettyNoticeBox,
                        onClick: function onClick() {
                          r(!n);
                        },
                        children: [TH.exports.jsx(CF, {
                          type: "icon-privacy",
                          iconStyle: {
                            transform: "scale(0.7)"
                          }
                        }), TH.exports.jsx(QA, {
                          variant: "body1",
                          style: {
                            margin: 5
                          },
                          children: c("disclaimer.LT_button_1")
                        })]
                      })
                    })
                  }), TH.exports.jsx(AF, {
                    iconType: "icon-close",
                    onClick: function onClick() {
                      var e;
                      null === (e = t.closeCCGety) || void 0 === e || e.call(t), null == o || o(JB(!1));
                    }
                  })]
                })
              })
            });
          },
              qY = function qY(t) {
            var _e$useState337 = e.useState(!1),
                _e$useState338 = _slicedToArray(_e$useState337, 2),
                n = _e$useState338[0],
                r = _e$useState338[1],
                _e$useState339 = e.useState(!1),
                _e$useState340 = _slicedToArray(_e$useState339, 2),
                i = _e$useState340[0],
                o = _e$useState340[1],
                _e$useState341 = e.useState(""),
                _e$useState342 = _slicedToArray(_e$useState341, 2),
                a = _e$useState342[0],
                s = _e$useState342[1],
                c = e.useContext(zM),
                _e$useContext147 = e.useContext(jM),
                l = _e$useContext147.userId,
                d = _e$useContext147.isHost,
                p = _e$useContext147.ccStatus,
                _e$useContext148 = e.useContext($M),
                h = _e$useContext148.ccClient,
                _zF7 = zF(c, h),
                _ = _zF7.ccEditor,
                f = _zF7.historiesLength,
                _e$useContext149 = e.useContext(JM),
                _e$useContext149$isSh = _e$useContext149.isShowCC,
                m = _e$useContext149$isSh.setting,
                g = _e$useContext149$isSh.history,
                v = _e$useContext149$isSh.toast,
                b = _e$useContext149$isSh.input,
                y = _e$useContext149$isSh.getty,
                w = _e$useContext149.dispatch,
                S = Wz(p),
                x = Wz(_),
                _NM72 = NM(),
                E = _NM72.t;

            return e.useEffect(function () {
              (null != p && p.isCCEnable && null != _ && _.userId || null != p && p.isLTEnable) && (null == w || w(JB(!0)));
            }, [w, null == _ ? void 0 : _.userId, null == p ? void 0 : p.isCCEnable, null == p ? void 0 : p.isLTEnable]), e.useEffect(function () {
              null != S && S.isCCEnable || !p.isCCEnable || i || null == _ || !_.userId || null == w || w(JB(!0)), null != S && S.isLTEnable || !p.isLTEnable || i || null == _ || !_.userId || null == w || w(JB(!0)), (null == x ? void 0 : x.userId) !== (null == _ ? void 0 : _.userId) && (null == _ ? void 0 : _.userId) === l && (i || null == w || w(JB(!0)), d || (r(!0), s(E("wc_cc_host_assigned")))), (null == x ? void 0 : x.userId) === l && (null == _ ? void 0 : _.userId) !== l && (null == w || w(KB(!1)));
            }, [S, p, n, l, d, f, null == x ? void 0 : x.userId, null == _ ? void 0 : _.userId, y, i, r, s, E, w]), TH.exports.jsxs("div", {
              children: [m && d && TH.exports.jsx(DY, u({}, t)), g && TH.exports.jsx(IY, u({}, t)), b && TH.exports.jsx(BY, u({}, t)), v && TH.exports.jsx(PY, u({}, t)), n && TH.exports.jsx(MY, u({
                text: a
              }, t)), y && TH.exports.jsx(VY, u({
                text: E("disclaimer.LT_content_2"),
                closeCCGety: function closeCCGety() {
                  o(!0);
                }
              }, t))]
            });
          },
              FY = Pk({
            paper: {
              minWidth: 480,
              padding: "16px 8px",
              borderRadius: 12
            }
          })(PI),
              WY = function WY(t) {
            var n = t.visible,
                r = t.onClose,
                i = t.onOk,
                o = t.okText,
                a = t.cancelText,
                s = t.title,
                c = t.content,
                _NM73 = NM(),
                l = _NM73.t,
                d = e.useCallback(function () {
              r();
            }, [r]),
                u = e.useCallback(function () {
              null == i || i();
            }, [i]);

            return TH.exports.jsxs(FY, {
              open: n,
              onClose: d,
              "aria-labelledby": "error-dialog-title",
              "aria-describedby": "error-dialog-descption",
              maxWidth: "md",
              transitionDuration: 300,
              children: [TH.exports.jsx(HI, {
                id: "error-dialog-title",
                children: n ? s || l("wc_dlg_confirm") : ""
              }), TH.exports.jsx(MI, {
                children: "string" == typeof c ? TH.exports.jsx(UI, {
                  id: "error-dialog-descption",
                  style: {
                    fontSize: "13px"
                  },
                  children: c
                }) : c
              }), TH.exports.jsxs(DI, {
                children: [o && TH.exports.jsx(YA, {
                  onClick: u,
                  variant: "contained",
                  color: "primary",
                  size: "small",
                  children: o || l("wc_yes")
                }), a && TH.exports.jsx(YA, {
                  onClick: d,
                  variant: "outlined",
                  size: "small",
                  children: a || l("wc_no")
                })]
              })]
            });
          },
              GY = function GY(t) {
            var n = t.onRetry,
                _t$errorStatus = t.errorStatus,
                r = _t$errorStatus.errorCode,
                i = _t$errorStatus.reason,
                o = _t$errorStatus.result,
                _e$useContext150 = e.useContext(jM),
                a = _e$useContext150.isWebinar,
                _e$useState343 = e.useState(!0),
                _e$useState344 = _slicedToArray(_e$useState343, 2),
                s = _e$useState344[0],
                c = _e$useState344[1],
                _NM74 = NM(),
                l = _NM74.t,
                d = function d() {
              return l("kicked by host" === i || "expeled by host" === i ? "dialog.you_are_removed" : "ended by host" === i ? a ? "dialog.webinar_ended" : "dialog.meeting_ended" : "errorcodes_fail");
            };

            var p = !1;

            var h = function h() {
              var e;
              var t = (null === (e = EZ(xZ, i)) || void 0 === e ? void 0 : e.toString()) || "errorcodes_fail";
              return "kicked by host" === i || "expeled by host" === i ? (p = !0, l(a ? "dialog.webinar_removed_by_host" : "dialog.meeting_removed_by_host")) : l(t);
            },
                _ = function _() {
              c(!1);
            };

            var f = {
              visible: s,
              onOk: function onOk() {
                n();
              },
              onClose: _,
              okText: l("dialog.btn_retry"),
              cancelText: l("dialog.ok"),
              title: d(),
              content: h()
            };
            return (p || 3707 === r || 3004 === r || 3620 === r || 3051 === r || 3099 === r || 3110 === r) && (f = {
              visible: s,
              onClose: _,
              cancelText: l("dialog.ok"),
              title: d(),
              content: h()
            }), 3 === r && (f = {
              visible: s,
              onClose: _,
              cancelText: l("dialog.ok"),
              title: d(),
              content: o
            }), TH.exports.jsx(WY, u({}, f));
          },
              KY = function KY() {
            var t, n, r, i, o, a, s, c;

            var _e$useContext151 = e.useContext(JM),
                l = _e$useContext151.isShowChat,
                d = _e$useContext151.chatMessage,
                u = _e$useContext151.isShowChatNotification,
                p = _e$useContext151.customization,
                h = _e$useContext151.dispatch,
                _ = null == p || null === (t = p.chat) || void 0 === t || null === (n = t.notificationCls) || void 0 === n ? void 0 : n.top,
                f = null == p || null === (r = p.chat) || void 0 === r || null === (i = r.notificationCls) || void 0 === i ? void 0 : i.left,
                m = null == p || null === (o = p.chat) || void 0 === o || null === (a = o.notificationCls) || void 0 === a ? void 0 : a.right,
                g = null == p || null === (s = p.chat) || void 0 === s || null === (c = s.notificationCls) || void 0 === c ? void 0 : c.bottom,
                v = Ok(function (e) {
              return {
                root: {
                  display: "none",
                  position: "fixed",
                  top: _ || "2vh",
                  right: m || "8px",
                  bottom: g || "auto",
                  left: f || "auto",
                  width: "fit-content"
                },
                isShowNotification: {
                  display: "block"
                },
                contentWrap: {
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer"
                },
                messageWrap: {
                  display: "flex",
                  alignItems: "center",
                  "& > *": {
                    margin: e.spacing(0, 1)
                  },
                  width: "260px",
                  height: "56px"
                },
                message: {
                  width: "180px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  marginBottom: "5px"
                },
                textWrap: {
                  width: "180px"
                },
                avatarWrap: {
                  flexShrink: 0,
                  margin: "0 8px 0 4px"
                },
                avatar: {
                  display: "flex",
                  alignItems: "center",
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px"
                },
                defaultAvatar: _defineProperty({
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  background: "rgba(255, 255, 255, 0.09)"
                }, "& .".concat(kH, "-MuiSvgIcon-root"), {
                  fontSize: "20px"
                }),
                notification: {
                  padding: "2px 10px"
                }
              };
            }),
                b = v(),
                y = e.useRef(0),
                w = Mz(d.sender.avatar);

            return e.useEffect(function () {
              return u && (y.current = window.setTimeout(function () {
                null == h || h(eH(!1));
              }, 1e4)), function () {
                y.current && (clearTimeout(y.current), y.current = 0);
              };
            }, [h, u, d]), TH.exports.jsx(WA, {
              className: VC(b.root, _defineProperty({}, b.isShowNotification, !l && u)),
              children: TH.exports.jsx(vK, {
                className: b.notification,
                children: TH.exports.jsxs(WA, {
                  className: b.contentWrap,
                  children: [TH.exports.jsxs(WA, {
                    className: b.messageWrap,
                    onClick: function onClick() {
                      return null == h ? void 0 : h(LB(!0));
                    },
                    children: [TH.exports.jsx(WA, {
                      className: b.avatarWrap,
                      children: w ? TH.exports.jsx(XA, {
                        component: "img",
                        className: b.avatar,
                        image: w,
                        alt: "avatar of user"
                      }) : TH.exports.jsx(WA, {
                        component: "i",
                        className: b.defaultAvatar,
                        children: TH.exports.jsx(CF, {
                          type: "icon-avatar"
                        })
                      })
                    }), TH.exports.jsxs(WA, {
                      className: b.textWrap,
                      children: [TH.exports.jsx(QA, {
                        variant: "body1",
                        className: b.message,
                        children: TH.exports.jsx("b", {
                          children: d.sender.name
                        })
                      }), TH.exports.jsx(QA, {
                        variant: "body1",
                        className: b.message,
                        children: d.message
                      })]
                    })]
                  }), TH.exports.jsx(QW, {
                    iconColorType: GW.White,
                    onClick: function onClick() {
                      return null == h ? void 0 : h(eH(!1));
                    }
                  })]
                })
              })
            });
          };

          var QY,
              ZY = {
            exports: {}
          },
              YY = {},
              JY = {
            __esModule: !0,
            cloneElement: function cloneElement(e, t) {
              return t.style && e.props.style && (t.style = eJ(eJ({}, e.props.style), t.style)), t.className && e.props.className && (t.className = e.props.className + " " + t.className), $Y.default.cloneElement(e, t);
            }
          },
              $Y = (QY = a.default) && QY.__esModule ? QY : {
            default: QY
          };

          function XY(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function eJ(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? XY(Object(n), !0).forEach(function (t) {
                tJ(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : XY(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function tJ(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          var nJ = {
            __esModule: !0,
            resizableProps: void 0
          },
              rJ = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(Oy.exports),
              iJ = {
            axis: rJ.default.oneOf(["both", "x", "y", "none"]),
            className: rJ.default.string,
            children: rJ.default.element.isRequired,
            draggableOpts: rJ.default.shape({
              allowAnyClick: rJ.default.bool,
              cancel: rJ.default.string,
              children: rJ.default.node,
              disabled: rJ.default.bool,
              enableUserSelectHack: rJ.default.bool,
              offsetParent: rJ.default.node,
              grid: rJ.default.arrayOf(rJ.default.number),
              handle: rJ.default.string,
              nodeRef: rJ.default.object,
              onStart: rJ.default.func,
              onDrag: rJ.default.func,
              onStop: rJ.default.func,
              onMouseDown: rJ.default.func,
              scale: rJ.default.number
            }),
            height: rJ.default.number.isRequired,
            handle: rJ.default.oneOfType([rJ.default.node, rJ.default.func]),
            handleSize: rJ.default.arrayOf(rJ.default.number),
            lockAspectRatio: rJ.default.bool,
            maxConstraints: rJ.default.arrayOf(rJ.default.number),
            minConstraints: rJ.default.arrayOf(rJ.default.number),
            onResizeStop: rJ.default.func,
            onResizeStart: rJ.default.func,
            onResize: rJ.default.func,
            resizeHandles: rJ.default.arrayOf(rJ.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
            transformScale: rJ.default.number,
            width: rJ.default.number.isRequired
          };

          nJ.resizableProps = iJ, YY.__esModule = !0, YY.default = void 0;

          var oJ = function (e, t) {
            if (!t && e && e.__esModule) return e;
            if (null === e || "object" != typeof e && "function" != typeof e) return {
              default: e
            };
            var n = dJ(t);
            if (n && n.has(e)) return n.get(e);
            var r = {},
                i = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var o in e) {
              if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
                a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
              }
            }

            return r.default = e, n && n.set(e, r), r;
          }(a.default),
              aJ = qN.exports,
              sJ = JY,
              cJ = nJ,
              lJ = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];

          function dJ(e) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap(),
                n = new WeakMap();
            return (dJ = function dJ(e) {
              return e ? n : t;
            })(e);
          }

          function uJ() {
            return uJ = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, uJ.apply(this, arguments);
          }

          function pJ(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function hJ(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? pJ(Object(n), !0).forEach(function (t) {
                _J(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pJ(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function _J(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          function fJ(e, t) {
            return fJ = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e;
            }, fJ(e, t);
          }

          var mJ = function (e) {
            var t, n;

            function r() {
              for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
                r[i] = arguments[i];
              }

              return (t = e.call.apply(e, [this].concat(r)) || this).handleRefs = {}, t.lastHandleRect = null, t.slack = null, t;
            }

            n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, fJ(t, n);
            var i = r.prototype;
            return i.componentWillUnmount = function () {
              this.resetData();
            }, i.resetData = function () {
              this.lastHandleRect = this.slack = null;
            }, i.runConstraints = function (e, t) {
              var n = this.props,
                  r = n.minConstraints,
                  i = n.maxConstraints,
                  o = n.lockAspectRatio;
              if (!r && !i && !o) return [e, t];

              if (o) {
                var a = this.props.width / this.props.height,
                    s = e - this.props.width,
                    c = t - this.props.height;
                Math.abs(s) > Math.abs(c * a) ? t = e / a : e = t * a;
              }

              var l = e,
                  d = t,
                  u = this.slack || [0, 0],
                  p = u[0],
                  h = u[1];
              return e += p, t += h, r && (e = Math.max(r[0], e), t = Math.max(r[1], t)), i && (e = Math.min(i[0], e), t = Math.min(i[1], t)), this.slack = [p + (l - e), h + (d - t)], [e, t];
            }, i.resizeHandler = function (e, t) {
              var n = this;
              return function (r, i) {
                var o = i.node,
                    a = i.deltaX,
                    s = i.deltaY;
                "onResizeStart" === e && n.resetData();
                var c = ("both" === n.props.axis || "x" === n.props.axis) && "n" !== t && "s" !== t,
                    l = ("both" === n.props.axis || "y" === n.props.axis) && "e" !== t && "w" !== t;

                if (c || l) {
                  var d = t[0],
                      u = t[t.length - 1],
                      p = o.getBoundingClientRect();
                  null != n.lastHandleRect && ("w" === u && (a += p.left - n.lastHandleRect.left), "n" === d && (s += p.top - n.lastHandleRect.top)), n.lastHandleRect = p, "w" === u && (a = -a), "n" === d && (s = -s);

                  var h = n.props.width + (c ? a / n.props.transformScale : 0),
                      _ = n.props.height + (l ? s / n.props.transformScale : 0),
                      f = n.runConstraints(h, _);

                  h = f[0], _ = f[1];
                  var m = h !== n.props.width || _ !== n.props.height,
                      g = "function" == typeof n.props[e] ? n.props[e] : null;
                  g && !("onResize" === e && !m) && (null == r.persist || r.persist(), g(r, {
                    node: o,
                    size: {
                      width: h,
                      height: _
                    },
                    handle: t
                  })), "onResizeStop" === e && n.resetData();
                }
              };
            }, i.renderResizeHandle = function (e, t) {
              var n = this.props.handle;
              if (!n) return oJ.createElement("span", {
                className: "react-resizable-handle react-resizable-handle-" + e,
                ref: t
              });
              if ("function" == typeof n) return n(e, t);
              var r = hJ({
                ref: t
              }, "string" == typeof n.type ? {} : {
                handleAxis: e
              });
              return oJ.cloneElement(n, r);
            }, i.render = function () {
              var e = this,
                  t = this.props,
                  n = t.children,
                  r = t.className,
                  i = t.draggableOpts;
              t.width, t.height, t.handle, t.handleSize, t.lockAspectRatio, t.axis, t.minConstraints, t.maxConstraints, t.onResize, t.onResizeStop, t.onResizeStart;
              var o = t.resizeHandles;
              t.transformScale;

              var a = function (e, t) {
                if (null == e) return {};
                var n,
                    r,
                    i = {},
                    o = Object.keys(e);

                for (r = 0; r < o.length; r++) {
                  n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
                }

                return i;
              }(t, lJ);

              return (0, sJ.cloneElement)(n, hJ(hJ({}, a), {}, {
                className: (r ? r + " " : "") + "react-resizable",
                children: [].concat(n.props.children, o.map(function (t) {
                  var n,
                      r = null != (n = e.handleRefs[t]) ? n : e.handleRefs[t] = oJ.createRef();
                  return oJ.createElement(aJ.DraggableCore, uJ({}, i, {
                    nodeRef: r,
                    key: "resizableHandle-" + t,
                    onStop: e.resizeHandler("onResizeStop", t),
                    onStart: e.resizeHandler("onResizeStart", t),
                    onDrag: e.resizeHandler("onResize", t)
                  }), e.renderResizeHandle(t, r));
                }))
              }));
            }, r;
          }(oJ.Component);

          YY.default = mJ, mJ.propTypes = cJ.resizableProps, mJ.defaultProps = {
            axis: "both",
            handleSize: [20, 20],
            lockAspectRatio: !1,
            minConstraints: [20, 20],
            maxConstraints: [1 / 0, 1 / 0],
            resizeHandles: ["se"],
            transformScale: 1
          };

          var gJ = {
            __esModule: !0,
            default: void 0
          },
              vJ = function (e, t) {
            if (!t && e && e.__esModule) return e;
            if (null === e || "object" != typeof e && "function" != typeof e) return {
              default: e
            };
            var n = EJ(t);
            if (n && n.has(e)) return n.get(e);
            var r = {},
                i = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var o in e) {
              if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
                a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
              }
            }

            return r.default = e, n && n.set(e, r), r;
          }(a.default),
              bJ = xJ(Oy.exports),
              yJ = xJ(YY),
              wJ = nJ,
              SJ = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];

          function xJ(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          function EJ(e) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap(),
                n = new WeakMap();
            return (EJ = function EJ(e) {
              return e ? n : t;
            })(e);
          }

          function CJ() {
            return CJ = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            }, CJ.apply(this, arguments);
          }

          function kJ(e, t) {
            var n = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function AJ(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? kJ(Object(n), !0).forEach(function (t) {
                IJ(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kJ(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }

          function IJ(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          function TJ(e, t) {
            return TJ = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e;
            }, TJ(e, t);
          }

          var OJ = function (e) {
            var t, n;

            function r() {
              for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
                r[i] = arguments[i];
              }

              return (t = e.call.apply(e, [this].concat(r)) || this).state = {
                width: t.props.width,
                height: t.props.height,
                propsWidth: t.props.width,
                propsHeight: t.props.height
              }, t.onResize = function (e, n) {
                var r = n.size;
                t.props.onResize ? (null == e.persist || e.persist(), t.setState(r, function () {
                  return t.props.onResize && t.props.onResize(e, n);
                })) : t.setState(r);
              }, t;
            }

            return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, TJ(t, n), r.getDerivedStateFromProps = function (e, t) {
              return t.propsWidth !== e.width || t.propsHeight !== e.height ? {
                width: e.width,
                height: e.height,
                propsWidth: e.width,
                propsHeight: e.height
              } : null;
            }, r.prototype.render = function () {
              var e = this.props,
                  t = e.handle,
                  n = e.handleSize;
              e.onResize;
              var r = e.onResizeStart,
                  i = e.onResizeStop,
                  o = e.draggableOpts,
                  a = e.minConstraints,
                  s = e.maxConstraints,
                  c = e.lockAspectRatio,
                  l = e.axis;
              e.width, e.height;

              var d = e.resizeHandles,
                  u = e.style,
                  p = e.transformScale,
                  h = function (e, t) {
                if (null == e) return {};
                var n,
                    r,
                    i = {},
                    o = Object.keys(e);

                for (r = 0; r < o.length; r++) {
                  n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
                }

                return i;
              }(e, SJ);

              return vJ.createElement(yJ.default, {
                axis: l,
                draggableOpts: o,
                handle: t,
                handleSize: n,
                height: this.state.height,
                lockAspectRatio: c,
                maxConstraints: s,
                minConstraints: a,
                onResizeStart: r,
                onResize: this.onResize,
                onResizeStop: i,
                resizeHandles: d,
                transformScale: p,
                width: this.state.width
              }, vJ.createElement("div", CJ({}, h, {
                style: AJ(AJ({}, u), {}, {
                  width: this.state.width + "px",
                  height: this.state.height + "px"
                })
              })));
            }, r;
          }(vJ.Component);

          gJ.default = OJ, OJ.propTypes = AJ(AJ({}, wJ.resizableProps), {}, {
            children: bJ.default.element
          }), ZY.exports = function () {
            throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
          };
          var RJ = ZY.exports.Resizable = YY.default;
          ZY.exports.ResizableBox = gJ.default;

          var NJ = Ok(function () {
            return {
              resizable: {
                position: "relative",
                color: "white",
                "& .react-resizable-handle": {
                  position: "absolute",
                  width: 14,
                  height: 14,
                  bottom: 0,
                  right: 0,
                  background: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PC9zdmc+')",
                  backgroundPosition: "bottom right",
                  padding: 3,
                  backgroundRepeat: "no-repeat",
                  backgroundOrigin: "content-box",
                  backgroundSize: "cover",
                  boxSizing: "border-box",
                  cursor: "se-resize"
                }
              }
            };
          }),
              PJ = function PJ(t) {
            var n = t.children;

            var _e$useContext152 = e.useContext(JM),
                r = _e$useContext152.videoContainerDimensions,
                i = _e$useContext152.viewType,
                o = _e$useContext152.customization,
                a = _e$useContext152.dispatch,
                _ref79 = o.video || {},
                s = _ref79.isResizable,
                c = NJ(),
                l = oK().length,
                _e$useState345 = e.useState([0, 0]),
                _e$useState346 = _slicedToArray(_e$useState345, 2),
                d = _e$useState346[0],
                u = _e$useState346[1],
                _e$useState347 = e.useState([0, 0]),
                _e$useState348 = _slicedToArray(_e$useState347, 2),
                p = _e$useState348[0],
                h = _e$useState348[1];

            e.useEffect(function () {
              var e = QG(i, l),
                  t = function (e, t) {
                var n = VM(e);
                return e === MM.Ribbon ? {
                  width: n.Width * (n.MaxHeight / n.Height[qM(t)]),
                  height: n.MaxHeight
                } : {
                  width: n.MaxWidth,
                  height: n.MaxHeight
                };
              }(i, l);

              u([e.width, e.height]), h([t.width, t.height]);
            }, [l, i]);

            var _ = function _(e, t) {
              var n = t.size;
              null == a || a(tH({
                width: n.width,
                height: n.height
              }));
            };

            return s ? TH.exports.jsx(RJ, {
              width: r.width,
              height: r.height,
              minConstraints: d,
              maxConstraints: p,
              onResize: _,
              lockAspectRatio: i === MM.Ribbon,
              className: c.resizable,
              children: n
            }) : TH.exports.jsxs(TH.exports.Fragment, {
              children: [" ", n, " "]
            });
          },
              jJ = Ok(function (e) {
            return {
              parent: {
                transform: "translateY(1%)"
              },
              contentContainer: {
                display: "flex",
                alignItems: "center",
                "& > *": {
                  margin: e.spacing(0, 1)
                }
              }
            };
          }),
              DJ = function DJ(t) {
            var n = t.anchorEl,
                r = t.modifiers,
                i = t.placement;

            var o = jJ(),
                _NM75 = NM(),
                a = _NM75.t,
                _e$useState349 = e.useState(!1),
                _e$useState350 = _slicedToArray(_e$useState349, 2),
                s = _e$useState350[0],
                c = _e$useState350[1],
                l = e.useRef(0),
                _e$useContext153 = e.useContext(jM),
                d = _e$useContext153.isCoHost,
                u = _e$useContext153.isHost,
                p = _e$useContext153.isWebinar,
                h = _e$useContext153.recordingStatus,
                _ = _e$useContext153.isLocalRecording,
                f = _e$useContext153.hasPreconsented,
                m = _e$useContext153.isAttendee,
                _e$useContext154 = e.useContext(JM),
                g = _e$useContext154.hasShowRecordingAlert,
                v = h === zj.Recording || _,
                b = p && !u && !d && !m && (f || g) && !s && v;

            return e.useEffect(function () {
              h !== zj.Stopped || _ || c(!1);
            }, [_, h]), e.useEffect(function () {
              return b && (l.current = window.setTimeout(function () {
                c(!0);
              }, 5e3)), function () {
                l.current && (clearTimeout(l.current), l.current = 0);
              };
            }, [b]), TH.exports.jsx(YT, {
              anchorOrigin: {
                vertical: "top",
                horizontal: "center"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "center"
              },
              open: b,
              anchorEl: n,
              className: o.parent,
              children: TH.exports.jsx(vK, {
                children: TH.exports.jsx("div", {
                  className: o.contentContainer,
                  children: TH.exports.jsx(QA, {
                    variant: "body1",
                    children: a("wc_record_reminder_webinar_title")
                  })
                })
              })
            });
          },
              zJ = function zJ(e) {
            return "anchorPosition" === (null == e ? void 0 : e.anchorReference) && null != e && e.anchorPosition ? ["left", "top", "right", "bottom"].reduce(function (t, n) {
              var r = (null == e ? void 0 : e.anchorPosition)[n];
              return void 0 !== r && (t[n] = "".concat("number" == typeof r ? "".concat(r, "px") : r, " !important")), t;
            }, {}) : {};
          },
              MJ = Ok(function (e) {
            return {
              singleView: function singleView(t) {
                var n, r;
                return {
                  boxSizing: "border-box",
                  padding: e.spacing(.5),
                  boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.3)",
                  "& .zoommtg-drag-video": {
                    cursor: null != t && null !== (n = t.video) && void 0 !== n && null !== (r = n.popper) && void 0 !== r && r.disableDraggable ? "default" : "move"
                  }
                };
              },
              videoCustomize: function videoCustomize(e) {
                var t, n, r, i;
                return u({
                  position: null !== (t = e.video) && void 0 !== t && null !== (n = t.popper) && void 0 !== n && n.disableDraggable ? "absolute" : "static"
                }, (null === (r = e.video) || void 0 === r || null === (i = r.popper) || void 0 === i ? void 0 : i.anchorPosition) || {});
              },
              participantsCustomize: function participantsCustomize(e) {
                var t;
                return u({}, zJ(null === (t = e.participants) || void 0 === t ? void 0 : t.popper));
              },
              chatCustomize: function chatCustomize(e) {
                var t;
                return u({}, zJ(null === (t = e.chat) || void 0 === t ? void 0 : t.popper));
              },
              settingCustomize: function settingCustomize(e) {
                var t;
                return u({}, zJ(null === (t = e.setting) || void 0 === t ? void 0 : t.popper));
              },
              meetingCustomize: function meetingCustomize(e) {
                var t;
                return u({}, zJ(null === (t = e.meeting) || void 0 === t ? void 0 : t.popper));
              },
              activeAppCustomize: function activeAppCustomize(e) {
                var t;
                return u({}, zJ(null === (t = e.activeApps) || void 0 === t ? void 0 : t.popper));
              }
            };
          }),
              LJ = {
            offset: {
              enabled: !0,
              offset: "0,8"
            }
          },
              UJ = function UJ(e, t) {
            return "anchorPosition" === (null == e ? void 0 : e.anchorReference) ? {
              getBoundingClientRect: function getBoundingClientRect() {
                return {
                  left: 0,
                  x: 0,
                  top: 0,
                  y: 0,
                  width: 0,
                  height: 0
                };
              },
              clientWidth: 0,
              clientHeight: 0
            } : (null == e ? void 0 : e.anchorElement) || t;
          };

          function BJ(e) {
            var t = document.documentElement.offsetWidth,
                n = Math.ceil((t - 240) / 400);
            var r = 0,
                i = e;
            return e > n && (r = Math.floor(e / n), i = e - n * r), {
              offset: {
                enabled: !0,
                offset: "".concat(8 + 200 * r, ",").concat(8 + 400 * i)
              }
            };
          }

          var HJ = function HJ(t) {
            var n, r, i, o, a, s, c, l, d, u, p, h, _, f, m, g, v, b, y;

            var w = t.client,
                S = t.joinArgs,
                x = t.isJoining,
                E = t.customization,
                C = t.maximumVideosInGalleryView;

            var k = MJ(E),
                _e$useContext155 = e.useContext(jM),
                A = _e$useContext155.status,
                I = _e$useContext155.isOnHold,
                _e$useContext156 = e.useContext(JM),
                T = _e$useContext156.dispatch,
                _e$useState351 = e.useState({}),
                _e$useState352 = _slicedToArray(_e$useState351, 2),
                O = _e$useState352[1],
                R = e.useCallback(function () {
              return O({});
            }, []),
                _e$useState353 = e.useState({
              errorCode: "",
              reason: "",
              result: ""
            }),
                _e$useState354 = _slicedToArray(_e$useState353, 2),
                N = _e$useState354[0],
                P = _e$useState354[1],
                _e$useState355 = e.useState(!1),
                _e$useState356 = _slicedToArray(_e$useState355, 2),
                j = _e$useState356[0],
                D = _e$useState356[1],
                z = e.useRef(null),
                _e$useState357 = e.useState(!0),
                _e$useState358 = _slicedToArray(_e$useState357, 2),
                M = _e$useState358[0],
                L = _e$useState358[1];

            e.useEffect(function () {
              switch (A) {
                case jj.Connected:
                  R(), D(!0);
                  break;

                case jj.Reconnecting:
                case jj.Fail:
                  D(!1);
                  break;

                case jj.Closed:
                  setTimeout(function () {
                    return D(!1);
                  }, 5e3);
                  break;

                default:
                  console.log("Unknown connection status: ", A);
              }
            }, [A, w, R]), e.useEffect(function () {
              Pz.changeLanguage(null == S ? void 0 : S.language);
            }, [S]), Mj(function () {
              var e = sessionStorage.getItem("WEB_SDK_COMPONENT_VIEW_MAXIMUM_VIDEOS");
              var t;
              var n;
              e && Number(e) ? t = Number(e) : C && (t = C), t && (null == T || T((n = Math.min(t, 25), {
                type: DB,
                payload: n
              })));
            });
            var U = e.useCallback(function (e) {
              var t = e.state;
              t === Dj.Fail ? P({
                errorCode: e.errorCode,
                reason: null == e ? void 0 : e.reason,
                result: e.result
              }) : t === Dj.Closed && P({
                errorCode: "",
                reason: null == e ? void 0 : e.reason,
                result: ""
              });
            }, []);
            e.useEffect(function () {
              return w.on("connection-change", U), function () {
                return w.off("connection-change", U);
              };
            }, [w, U]);
            var B = e.useCallback(function (e) {
              P({
                errorCode: "",
                reason: "",
                result: ""
              }), null == w || w.join(null == S ? void 0 : S.meetingNumber, null == S ? void 0 : S.userName, null == S ? void 0 : S.password, null == S ? void 0 : S.userEmail, null == S ? void 0 : S.customerKey, null == S ? void 0 : S.zak).then(function (e) {
                return Promise.resolve(e);
              }).catch(function (e) {
                return Promise.reject(e);
              });
            }, [w, S]),
                H = TH.exports.jsx(qP, {
              children: TH.exports.jsx("div", {
                children: TH.exports.jsx(SZ, {
                  isJoined: j,
                  errorStatus: N,
                  onRetry: B,
                  setMeetingStart: L
                })
              })
            }),
                V = TH.exports.jsxs(kA, {
              ref: z,
              className: k.singleView,
              children: [TH.exports.jsx(fK, {}), TH.exports.jsx(DW, {})]
            });
            if (j && A === jj.Closed) return "kicked by host" === N.reason || "expeled by host" === N.reason ? TH.exports.jsx(GY, {
              errorStatus: N,
              onRetry: B
            }) : TH.exports.jsx(CZ, {
              reason: N.reason
            });
            if (A === jj.Fail && null != E && E.isShowJoiningErrorDialog && N.errorCode && 3008 !== N.errorCode) return TH.exports.jsx(GY, {
              errorStatus: N,
              onRetry: B
            });

            var _ref80 = E || {},
                q = _ref80.chat,
                F = _ref80.video,
                W = _ref80.meeting,
                G = _ref80.participants,
                K = _ref80.activeApps,
                Q = _ref80.setting;

            return M ? A !== jj.Connected || I ? A !== jj.Closed || x ? H : TH.exports.jsx("div", {}) : TH.exports.jsxs(TH.exports.Fragment, {
              children: [TH.exports.jsx(qP, {
                handle: ".zoommtg-drag-video",
                disabled: null == F || null === (n = F.popper) || void 0 === n ? void 0 : n.disableDraggable,
                children: TH.exports.jsx("div", {
                  className: k.videoCustomize,
                  children: TH.exports.jsx(PJ, {
                    children: V
                  })
                })
              }), z.current && TH.exports.jsxs(TH.exports.Fragment, {
                children: [TH.exports.jsx(xK, {
                  draggable: !0
                }), TH.exports.jsx(FK, {
                  anchorElement: UJ(null == q ? void 0 : q.popper, z.current),
                  modifiers: (null == q || null === (r = q.popper) || void 0 === r ? void 0 : r.modifiers) || BJ(1),
                  draggable: !(null != q && null !== (i = q.popper) && void 0 !== i && i.disableDraggable),
                  placement: null == q || null === (o = q.popper) || void 0 === o ? void 0 : o.placement,
                  wrapperClassName: k.chatCustomize
                }), TH.exports.jsx(RQ, {
                  anchorElement: UJ(null == Q ? void 0 : Q.popper, z.current),
                  modifiers: (null == Q || null === (a = Q.popper) || void 0 === a ? void 0 : a.modifiers) || BJ(2),
                  draggable: !(null != Q && null !== (s = Q.popper) && void 0 !== s && s.disableDraggable),
                  placement: null == Q || null === (c = Q.popper) || void 0 === c ? void 0 : c.placement,
                  wrapperClassName: k.settingCustomize
                }), TH.exports.jsx(rZ, {
                  anchorElement: UJ(null == W ? void 0 : W.popper, z.current),
                  modifiers: (null == W || null === (l = W.popper) || void 0 === l ? void 0 : l.modifiers) || BJ(0),
                  placement: (null == W || null === (d = W.popper) || void 0 === d ? void 0 : d.placement) || "left-start",
                  draggable: !(null != W && null !== (u = W.popper) && void 0 !== u && u.disableDraggable),
                  wrapperClassName: k.meetingCustomize
                }), TH.exports.jsx(_Z, {
                  anchorElement: UJ(null == G ? void 0 : G.popper, z.current),
                  modifiers: (null == G || null === (p = G.popper) || void 0 === p ? void 0 : p.modifiers) || BJ(0),
                  placement: (null == G || null === (h = G.popper) || void 0 === h ? void 0 : h.placement) || "left-start",
                  draggable: !(null != G && null !== (_ = G.popper) && void 0 !== _ && _.disableDraggable),
                  wrapperClassName: k.participantsCustomize
                }), TH.exports.jsx(mZ, {
                  anchorEl: z.current,
                  modifiers: LJ,
                  placement: "left-start"
                }), TH.exports.jsx(bY, {
                  anchorElement: UJ(null == K ? void 0 : K.popper, z.current),
                  modifiers: (null == K || null === (f = K.popper) || void 0 === f ? void 0 : f.modifiers) || BJ(0),
                  draggable: !(null != K && null !== (m = K.popper) && void 0 !== m && m.disableDraggable),
                  placement: (null == K || null === (g = K.popper) || void 0 === g ? void 0 : g.placement) || "left-start",
                  wrapperClassName: k.activeAppCustomize
                }), TH.exports.jsx(TZ, {
                  anchorEl: z.current,
                  modifiers: LJ,
                  placement: "left-start"
                }), TH.exports.jsx(wY, {
                  anchorElement: z.current
                }), TH.exports.jsx(qY, {
                  anchorElement: z.current,
                  modifiers: LJ,
                  draggable: !0
                }), TH.exports.jsx(PZ, {
                  anchorEl: z.current,
                  modifiers: LJ,
                  placement: "left-start"
                }), TH.exports.jsx(DJ, {
                  anchorEl: z.current
                }), TH.exports.jsx(DZ, {
                  anchorElement: z.current,
                  modifiers: LJ,
                  placement: "left-start"
                }), TH.exports.jsx(tG, {
                  anchorElement: z.current,
                  modifiers: LJ,
                  placement: "left-start"
                }), TH.exports.jsx(KY, {}), TH.exports.jsx(MW, {
                  anchorEl: z.current,
                  modifiers: LJ,
                  placement: "left-start"
                }), TH.exports.jsx(RZ, {}), TH.exports.jsx(MZ, {
                  anchorEl: z.current,
                  modifiers: LJ,
                  placement: "left-start"
                }), TH.exports.jsx(oY, {
                  anchorElement: UJ(null == Q ? void 0 : Q.popper, z.current),
                  modifiers: (null == Q || null === (v = Q.popper) || void 0 === v ? void 0 : v.modifiers) || BJ(0),
                  draggable: !(null != Q && null !== (b = Q.popper) && void 0 !== b && b.disableDraggable),
                  placement: null == Q || null === (y = Q.popper) || void 0 === y ? void 0 : y.placement,
                  wrapperClassName: k.settingCustomize
                })]
              })]
            }) : TH.exports.jsx("div", {});
          },
              VJ = function VJ(e) {
            return TH.exports.jsx(BH, {
              client: e.client,
              customization: e.customization || {},
              children: TH.exports.jsx(HJ, u({}, e))
            });
          },
              qJ = "https://source.zoom.us/".concat("2.8.0", "/lib/av"),
              FJ = {
            meetingInfo: ["topic", "host", "mn", "pwd", "telPwd", "invite", "participant", "dc", "enctype"],
            isShowJoiningErrorDialog: !0,
            video: {
              isResizable: !0
            }
          };

          var WJ = function WJ() {
            _classCallCheck(this, WJ);

            p(this, "init", void 0), p(this, "join", void 0), p(this, "getCurrentUser", void 0), p(this, "getCurrentMeetingInfo", void 0), p(this, "getAttendeeslist", void 0), p(this, "stopAudio", void 0), p(this, "mute", void 0), p(this, "muteAll", void 0), p(this, "rename", void 0), p(this, "admit", void 0), p(this, "admitAll", void 0), p(this, "expel", void 0), p(this, "record", void 0), p(this, "lockMeeting", void 0), p(this, "on", void 0), p(this, "off", void 0), p(this, "leaveMeeting", void 0), p(this, "endMeeting", void 0), p(this, "putOnHold", void 0), p(this, "checkSystemRequirements", void 0), p(this, "allowAttendeeToTalk", void 0), p(this, "subscribeStatisticData", void 0), p(this, "unSubscribeStatisticData", void 0);

            var t = _y.createClient();

            var n,
                r,
                i,
                o,
                a,
                s,
                c,
                d = !1,
                h = FJ,
                _ = function _(t) {
              var _e$useState359 = e.useState(!1),
                  _e$useState360 = _slicedToArray(_e$useState359, 2),
                  n = _e$useState360[0],
                  r = _e$useState360[1];

              return s = r, TH.exports.jsx(VJ, u(u({}, t), {}, {
                isJoining: n
              }));
            };

            this.join = /*#__PURE__*/function () {
              var _ref81 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(e) {
                var c, p, f, m, g, v, b, y, w, S, _n106, _e315, _e316;

                return _regeneratorRuntime.wrap(function _callee54$(_context54) {
                  while (1) {
                    switch (_context54.prev = _context54.next) {
                      case 0:
                        c = e.apiKey, p = e.sdkKey, f = e.signature, m = e.meetingNumber, g = e.userName, v = e.password, b = e.userEmail, y = e.customerKey, w = e.tk, S = e.zak;

                        if (!d) {
                          d = !0;
                          _n106 = TH.exports.jsx(_, {
                            client: t,
                            customization: h,
                            maximumVideosInGalleryView: a,
                            joinArgs: u(u({}, e), {}, {
                              language: i || "en-US"
                            })
                          });
                          l.default.render(_n106, o);
                        }

                        if (!c) {
                          _context54.next = 5;
                          break;
                        }

                        _e315 = TH.exports.jsx(Ak, {
                          theme: Pj,
                          children: TH.exports.jsx(GY, {
                            errorStatus: {
                              errorCode: 3,
                              reason: "",
                              result: "Error Code: 3"
                            },
                            onRetry: function onRetry() {}
                          })
                        });
                        return _context54.abrupt("return", (l.default.render(_e315, o), Promise.reject(new Error("Using a Zoom JWT App type API Key (apiKey) is no longer available in version 2.7.0+ of the SDK. Please use an SDK App type SDK Key (sdkKey) instead and the SDK JWT Auth flow. \nhttps://marketplace.zoom.us/docs/sdk/native-sdks/auth#generate-the-sdk-jwt"))));

                      case 5:
                        if (p) {
                          _context54.next = 7;
                          break;
                        }

                        return _context54.abrupt("return", Promise.reject(new Error("sdkKey can not empty")));

                      case 7:
                        _context54.prev = 7;
                        s(!0);
                        _e316 = {
                          dependentAssets: n || qJ,
                          constraints: {
                            audio: !0,
                            video: !0,
                            screen: !0
                          },
                          webEndpoint: r || "zoom.us",
                          language: i || "en-US",
                          fileWithVersion: !0
                        };
                        "string" == typeof n && function (e) {
                          switch (e) {
                            case "CDN":
                              Dz = "https://dmogdx0jrul3u.cloudfront.net/".concat(jz, "/lib/image");
                              break;

                            case "Global":
                              break;

                            case "CN":
                              Dz = "https://jssdk.zoomus.cn/".concat(jz, "/lib/image");
                              break;

                            default:
                              Dz = e + "/../image";
                          }
                        }(n);
                        _context54.t0 = p;

                        if (!_context54.t0) {
                          _context54.next = 15;
                          break;
                        }

                        _context54.next = 15;
                        return null == t ? void 0 : t.initWithSDK(p, f, u(u({}, _e316), {}, {
                          additionalFeatures: ["chat", "closedCaption", "recording", "archiving", "QA"]
                        }));

                      case 15:
                        _context54.next = 17;
                        return null == t ? void 0 : t.join(m, g, v, b, y, w, S);

                      case 17:
                        s(!1);
                        return _context54.abrupt("return", Promise.resolve(""));

                      case 21:
                        _context54.prev = 21;
                        _context54.t1 = _context54["catch"](7);
                        return _context54.abrupt("return", (s(!1), Promise.reject(_context54.t1)));

                      case 24:
                      case "end":
                        return _context54.stop();
                    }
                  }
                }, _callee54, null, [[7, 21]]);
              }));

              return function (_x58) {
                return _ref81.apply(this, arguments);
              };
            }(), this.init = function (e) {
              var t;
              var s = e.debug,
                  l = e.zoomAppRoot,
                  d = e.assetPath,
                  p = e.webEndpoint,
                  _ = e.language,
                  f = e.maximumVideosInGalleryView;
              return l ? ("flex" !== (null == l || null === (t = l.style) || void 0 === t ? void 0 : t.display) && (l.style.display = "flex"), n = d, r = p, i = _, o = l, a = f, c = ["connection-change", "audio-statistic-data-change", "video-statistic-data-change"], null != e && e.customize && Object.entries(e.customize).forEach(function (e) {
                var _e317 = _slicedToArray(e, 2),
                    t = _e317[0],
                    n = _e317[1];

                h[t] = n instanceof Array || "inviteUrlFormat" === t ? n : u(u({}, h[t]), n);
              }), Promise.resolve("")) : Promise.reject({
                type: "INIT_MEETING_FAILED",
                reason: "zoomAppRoot can't be falsy ",
                errorCode: -1
              });
            }, this.getCurrentUser = function () {
              return t.getCurrentUserInfo();
            }, this.getCurrentMeetingInfo = function () {
              return t.getMeetingInfo();
            }, this.getAttendeeslist = function () {
              return t.getParticipantsList();
            }, this.stopAudio = function () {
              var e = t.getMediaStream();
              return null == e ? void 0 : e.stopAudio();
            }, this.mute = /*#__PURE__*/function () {
              var _ref82 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(e, n) {
                var r;
                return _regeneratorRuntime.wrap(function _callee55$(_context55) {
                  while (1) {
                    switch (_context55.prev = _context55.next) {
                      case 0:
                        r = t.getMediaStream();
                        return _context55.abrupt("return", e ? null == r ? void 0 : r.muteAudio(n) : null == r ? void 0 : r.unmuteAudio(n));

                      case 2:
                      case "end":
                        return _context55.stop();
                    }
                  }
                }, _callee55);
              }));

              return function (_x59, _x60) {
                return _ref82.apply(this, arguments);
              };
            }(), this.muteAll = /*#__PURE__*/function () {
              var _ref83 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(e) {
                var n;
                return _regeneratorRuntime.wrap(function _callee56$(_context56) {
                  while (1) {
                    switch (_context56.prev = _context56.next) {
                      case 0:
                        n = t.getMediaStream();
                        return _context56.abrupt("return", e ? null == n ? void 0 : n.muteAllAudio() : null == n ? void 0 : n.unmuteAllAudio());

                      case 2:
                      case "end":
                        return _context56.stop();
                    }
                  }
                }, _callee56);
              }));

              return function (_x61) {
                return _ref83.apply(this, arguments);
              };
            }(), this.rename = /*#__PURE__*/function () {
              var _ref84 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(e, n) {
                return _regeneratorRuntime.wrap(function _callee57$(_context57) {
                  while (1) {
                    switch (_context57.prev = _context57.next) {
                      case 0:
                        return _context57.abrupt("return", t.changeName(e, n));

                      case 1:
                      case "end":
                        return _context57.stop();
                    }
                  }
                }, _callee57);
              }));

              return function (_x62, _x63) {
                return _ref84.apply(this, arguments);
              };
            }(), this.expel = /*#__PURE__*/function () {
              var _ref85 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(e) {
                return _regeneratorRuntime.wrap(function _callee58$(_context58) {
                  while (1) {
                    switch (_context58.prev = _context58.next) {
                      case 0:
                        return _context58.abrupt("return", t.removeUser(e));

                      case 1:
                      case "end":
                        return _context58.stop();
                    }
                  }
                }, _callee58);
              }));

              return function (_x64) {
                return _ref85.apply(this, arguments);
              };
            }(), this.record = /*#__PURE__*/function () {
              var _ref86 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(e) {
                var n;
                return _regeneratorRuntime.wrap(function _callee59$(_context59) {
                  while (1) {
                    switch (_context59.prev = _context59.next) {
                      case 0:
                        n = t.getFeatureModule("recording");
                        _context59.t0 = e;
                        _context59.next = _context59.t0 === "start" ? 4 : _context59.t0 === "pause" ? 5 : _context59.t0 === "stop" ? 6 : 7;
                        break;

                      case 4:
                        return _context59.abrupt("return", n.startRecording());

                      case 5:
                        return _context59.abrupt("return", n.pauseRecording());

                      case 6:
                        return _context59.abrupt("return", n.stopRecording());

                      case 7:
                        return _context59.abrupt("return", Promise.reject(new Error("Invalid parameter for 'record': ".concat(e))));

                      case 8:
                      case "end":
                        return _context59.stop();
                    }
                  }
                }, _callee59);
              }));

              return function (_x65) {
                return _ref86.apply(this, arguments);
              };
            }(), this.lockMeeting = /*#__PURE__*/function () {
              var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(e) {
                return _regeneratorRuntime.wrap(function _callee60$(_context60) {
                  while (1) {
                    switch (_context60.prev = _context60.next) {
                      case 0:
                        return _context60.abrupt("return", e ? t.lockMeeting() : t.unlockMeeting());

                      case 1:
                      case "end":
                        return _context60.stop();
                    }
                  }
                }, _callee60);
              }));

              return function (_x66) {
                return _ref87.apply(this, arguments);
              };
            }(), this.leaveMeeting = /*#__PURE__*/function () {
              var _ref88 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(e) {
                return _regeneratorRuntime.wrap(function _callee61$(_context61) {
                  while (1) {
                    switch (_context61.prev = _context61.next) {
                      case 0:
                        _context61.prev = 0;
                        _context61.t0 = e && t.isHost();

                        if (!_context61.t0) {
                          _context61.next = 5;
                          break;
                        }

                        _context61.next = 5;
                        return t.makeHost(e);

                      case 5:
                        _context61.next = 7;
                        return t.leave();

                      case 7:
                        return _context61.abrupt("return", Promise.resolve(""));

                      case 10:
                        _context61.prev = 10;
                        _context61.t1 = _context61["catch"](0);
                        return _context61.abrupt("return", Promise.reject(_context61.t1));

                      case 13:
                      case "end":
                        return _context61.stop();
                    }
                  }
                }, _callee61, null, [[0, 10]]);
              }));

              return function (_x67) {
                return _ref88.apply(this, arguments);
              };
            }(), this.endMeeting = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
              return _regeneratorRuntime.wrap(function _callee62$(_context62) {
                while (1) {
                  switch (_context62.prev = _context62.next) {
                    case 0:
                      _context62.prev = 0;
                      _context62.next = 3;
                      return t.end();

                    case 3:
                      return _context62.abrupt("return", Promise.resolve(""));

                    case 6:
                      _context62.prev = 6;
                      _context62.t0 = _context62["catch"](0);
                      return _context62.abrupt("return", Promise.reject(_context62.t0));

                    case 9:
                    case "end":
                      return _context62.stop();
                  }
                }
              }, _callee62, null, [[0, 6]]);
            })), this.putOnHold = /*#__PURE__*/function () {
              var _ref90 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(e) {
                return _regeneratorRuntime.wrap(function _callee63$(_context63) {
                  while (1) {
                    switch (_context63.prev = _context63.next) {
                      case 0:
                        return _context63.abrupt("return", t.putOnHold(e));

                      case 1:
                      case "end":
                        return _context63.stop();
                    }
                  }
                }, _callee63);
              }));

              return function (_x68) {
                return _ref90.apply(this, arguments);
              };
            }(), this.admit = /*#__PURE__*/function () {
              var _ref91 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(e) {
                return _regeneratorRuntime.wrap(function _callee64$(_context64) {
                  while (1) {
                    switch (_context64.prev = _context64.next) {
                      case 0:
                        return _context64.abrupt("return", t.admit(e));

                      case 1:
                      case "end":
                        return _context64.stop();
                    }
                  }
                }, _callee64);
              }));

              return function (_x69) {
                return _ref91.apply(this, arguments);
              };
            }(), this.admitAll = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
              return _regeneratorRuntime.wrap(function _callee65$(_context65) {
                while (1) {
                  switch (_context65.prev = _context65.next) {
                    case 0:
                      return _context65.abrupt("return", t.admitAll());

                    case 1:
                    case "end":
                      return _context65.stop();
                  }
                }
              }, _callee65);
            })), this.checkSystemRequirements = function () {
              return _y.checkSystemRequirements();
            }, this.allowAttendeeToTalk = /*#__PURE__*/function () {
              var _ref93 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(e, n) {
                var r;
                return _regeneratorRuntime.wrap(function _callee66$(_context66) {
                  while (1) {
                    switch (_context66.prev = _context66.next) {
                      case 0:
                        r = t.getMediaStream();
                        return _context66.abrupt("return", null == r ? void 0 : r.allowAttendeeToTalk(e, n));

                      case 2:
                      case "end":
                        return _context66.stop();
                    }
                  }
                }, _callee66);
              }));

              return function (_x70, _x71) {
                return _ref93.apply(this, arguments);
              };
            }(), this.subscribeStatisticData = /*#__PURE__*/function () {
              var _ref94 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(e) {
                var n, r, i, o;
                return _regeneratorRuntime.wrap(function _callee67$(_context67) {
                  while (1) {
                    switch (_context67.prev = _context67.next) {
                      case 0:
                        n = t.getMediaStream(), r = t.getCurrentUserInfo();
                        i = !0, o = !0;
                        e && (i = null == e ? void 0 : e.audio, o = null == e ? void 0 : e.video);

                        if (!(i && o)) {
                          _context67.next = 17;
                          break;
                        }

                        if (!("computer" !== (null == r ? void 0 : r.audio))) {
                          _context67.next = 8;
                          break;
                        }

                        _context67.t1 = Promise.reject(new Error("you don't join computer audio"));
                        _context67.next = 14;
                        break;

                      case 8:
                        _context67.next = 10;
                        return null == n ? void 0 : n.subscribeAudioStatisticData();

                      case 10:
                        _context67.next = 12;
                        return null == n ? void 0 : n.subscribeVideoStatisticData();

                      case 12:
                        XK({
                          audio: !0,
                          video: !0
                        });
                        _context67.t1 = Promise.resolve(JSON.stringify(e));

                      case 14:
                        _context67.t0 = _context67.t1;
                        _context67.next = 18;
                        break;

                      case 17:
                        _context67.t0 = i && !o ? "computer" === (null == r ? void 0 : r.audio) ? (XK({
                          audio: !0,
                          video: !1
                        }), null == n ? void 0 : n.subscribeAudioStatisticData()) : Promise.reject(new Error("you dont join computer audio")) : !i && o ? (XK({
                          audio: !1,
                          video: !0
                        }), null == n ? void 0 : n.subscribeVideoStatisticData()) : Promise.resolve("");

                      case 18:
                        return _context67.abrupt("return", _context67.t0);

                      case 19:
                      case "end":
                        return _context67.stop();
                    }
                  }
                }, _callee67);
              }));

              return function (_x72) {
                return _ref94.apply(this, arguments);
              };
            }(), this.unSubscribeStatisticData = /*#__PURE__*/function () {
              var _ref95 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(e) {
                var n, r, i;
                return _regeneratorRuntime.wrap(function _callee68$(_context68) {
                  while (1) {
                    switch (_context68.prev = _context68.next) {
                      case 0:
                        n = t.getMediaStream();
                        r = !0, i = !0;
                        e && (r = null == e ? void 0 : e.audio, i = null == e ? void 0 : e.video);

                        if (!(r && i)) {
                          _context68.next = 11;
                          break;
                        }

                        _context68.next = 6;
                        return null == n ? void 0 : n.unsubscribeAudioStatisticData();

                      case 6:
                        _context68.next = 8;
                        return null == n ? void 0 : n.unsubscribeVideoStatisticData();

                      case 8:
                        _context68.t0 = Promise.resolve("");
                        _context68.next = 12;
                        break;

                      case 11:
                        _context68.t0 = r && !i ? null == n ? void 0 : n.unsubscribeAudioStatisticData() : !r && i ? null == n ? void 0 : n.unsubscribeVideoStatisticData() : Promise.resolve("");

                      case 12:
                        return _context68.abrupt("return", _context68.t0);

                      case 13:
                      case "end":
                        return _context68.stop();
                    }
                  }
                }, _callee68);
              }));

              return function (_x73) {
                return _ref95.apply(this, arguments);
              };
            }(), this.on = function (e, n) {
              c.includes(e) && t.on(e, n);
            }, this.off = function (e, n) {
              c.includes(e) && t.off(e, n);
            };
          };

          var GJ = /*#__PURE__*/function () {
            function GJ() {
              _classCallCheck(this, GJ);
            }

            _createClass(GJ, null, [{
              key: "createClient",
              value: function createClient() {
                return this.embeddedClient || (this.embeddedClient = new WJ()), this.embeddedClient;
              }
            }]);

            return GJ;
          }();

          return p(GJ, "embeddedClient", void 0), GJ;
        }(n(45840), n(78768));
      },
      79742: function _(e, t) {
        "use strict";

        t.byteLength = function (e) {
          var t = c(e),
              n = t[0],
              r = t[1];
          return 3 * (n + r) / 4 - r;
        }, t.toByteArray = function (e) {
          var t,
              n,
              o = c(e),
              a = o[0],
              s = o[1],
              l = new i(function (e, t, n) {
            return 3 * (t + n) / 4 - n;
          }(0, a, s)),
              d = 0,
              u = s > 0 ? a - 4 : a;

          for (n = 0; n < u; n += 4) {
            t = r[e.charCodeAt(n)] << 18 | r[e.charCodeAt(n + 1)] << 12 | r[e.charCodeAt(n + 2)] << 6 | r[e.charCodeAt(n + 3)], l[d++] = t >> 16 & 255, l[d++] = t >> 8 & 255, l[d++] = 255 & t;
          }

          2 === s && (t = r[e.charCodeAt(n)] << 2 | r[e.charCodeAt(n + 1)] >> 4, l[d++] = 255 & t);
          1 === s && (t = r[e.charCodeAt(n)] << 10 | r[e.charCodeAt(n + 1)] << 4 | r[e.charCodeAt(n + 2)] >> 2, l[d++] = t >> 8 & 255, l[d++] = 255 & t);
          return l;
        }, t.fromByteArray = function (e) {
          for (var t, r = e.length, i = r % 3, o = [], a = 16383, s = 0, c = r - i; s < c; s += a) {
            o.push(l(e, s, s + a > c ? c : s + a));
          }

          1 === i ? (t = e[r - 1], o.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], o.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
          return o.join("");
        };

        for (var n = [], r = [], i = "undefined" !== typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, s = o.length; a < s; ++a) {
          n[a] = o[a], r[o.charCodeAt(a)] = a;
        }

        function c(e) {
          var t = e.length;
          if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var n = e.indexOf("=");
          return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
        }

        function l(e, t, r) {
          for (var i, o, a = [], s = t; s < r; s += 3) {
            i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
          }

          return a.join("");
        }

        r["-".charCodeAt(0)] = 62, r["_".charCodeAt(0)] = 63;
      },
      48764: function _(e, t, n) {
        "use strict";

        var r = n(79742),
            i = n(80645),
            o = n(5826);

        function a() {
          return c.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }

        function s(e, t) {
          if (a() < t) throw new RangeError("Invalid typed array length");
          return c.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = c.prototype : (null === e && (e = new c(t)), e.length = t), e;
        }

        function c(e, t, n) {
          if (!c.TYPED_ARRAY_SUPPORT && !(this instanceof c)) return new c(e, t, n);

          if ("number" === typeof e) {
            if ("string" === typeof t) throw new Error("If encoding is specified then the first argument must be a string");
            return u(this, e);
          }

          return l(this, e, t, n);
        }

        function l(e, t, n, r) {
          if ("number" === typeof t) throw new TypeError('"value" argument must not be a number');
          return "undefined" !== typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
            if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
            if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
            t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
            c.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = c.prototype : e = p(e, t);
            return e;
          }(e, t, n, r) : "string" === typeof t ? function (e, t, n) {
            "string" === typeof n && "" !== n || (n = "utf8");
            if (!c.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');

            var r = 0 | _(t, n),
                i = (e = s(e, r)).write(t, n);

            i !== r && (e = e.slice(0, i));
            return e;
          }(e, t, n) : function (e, t) {
            if (c.isBuffer(t)) {
              var n = 0 | h(t.length);
              return 0 === (e = s(e, n)).length || t.copy(e, 0, 0, n), e;
            }

            if (t) {
              if ("undefined" !== typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" !== typeof t.length || (r = t.length) !== r ? s(e, 0) : p(e, t);
              if ("Buffer" === t.type && o(t.data)) return p(e, t.data);
            }

            var r;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(e, t);
        }

        function d(e) {
          if ("number" !== typeof e) throw new TypeError('"size" argument must be a number');
          if (e < 0) throw new RangeError('"size" argument must not be negative');
        }

        function u(e, t) {
          if (d(t), e = s(e, t < 0 ? 0 : 0 | h(t)), !c.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) {
            e[n] = 0;
          }
          return e;
        }

        function p(e, t) {
          var n = t.length < 0 ? 0 : 0 | h(t.length);
          e = s(e, n);

          for (var r = 0; r < n; r += 1) {
            e[r] = 255 & t[r];
          }

          return e;
        }

        function h(e) {
          if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
          return 0 | e;
        }

        function _(e, t) {
          if (c.isBuffer(e)) return e.length;
          if ("undefined" !== typeof ArrayBuffer && "function" === typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
          "string" !== typeof e && (e = "" + e);
          var n = e.length;
          if (0 === n) return 0;

          for (var r = !1;;) {
            switch (t) {
              case "ascii":
              case "latin1":
              case "binary":
                return n;

              case "utf8":
              case "utf-8":
              case void 0:
                return H(e).length;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * n;

              case "hex":
                return n >>> 1;

              case "base64":
                return V(e).length;

              default:
                if (r) return H(e).length;
                t = ("" + t).toLowerCase(), r = !0;
            }
          }
        }

        function f(e, t, n) {
          var r = !1;
          if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
          if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
          if ((n >>>= 0) <= (t >>>= 0)) return "";

          for (e || (e = "utf8");;) {
            switch (e) {
              case "hex":
                return O(this, t, n);

              case "utf8":
              case "utf-8":
                return k(this, t, n);

              case "ascii":
                return I(this, t, n);

              case "latin1":
              case "binary":
                return T(this, t, n);

              case "base64":
                return C(this, t, n);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return R(this, t, n);

              default:
                if (r) throw new TypeError("Unknown encoding: " + e);
                e = (e + "").toLowerCase(), r = !0;
            }
          }
        }

        function m(e, t, n) {
          var r = e[t];
          e[t] = e[n], e[n] = r;
        }

        function g(e, t, n, r, i) {
          if (0 === e.length) return -1;

          if ("string" === typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
            if (i) return -1;
            n = e.length - 1;
          } else if (n < 0) {
            if (!i) return -1;
            n = 0;
          }

          if ("string" === typeof t && (t = c.from(t, r)), c.isBuffer(t)) return 0 === t.length ? -1 : v(e, t, n, r, i);
          if ("number" === typeof t) return t &= 255, c.TYPED_ARRAY_SUPPORT && "function" === typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : v(e, [t], n, r, i);
          throw new TypeError("val must be string, number or Buffer");
        }

        function v(e, t, n, r, i) {
          var o,
              a = 1,
              s = e.length,
              c = t.length;

          if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
            if (e.length < 2 || t.length < 2) return -1;
            a = 2, s /= 2, c /= 2, n /= 2;
          }

          function l(e, t) {
            return 1 === a ? e[t] : e.readUInt16BE(t * a);
          }

          if (i) {
            var d = -1;

            for (o = n; o < s; o++) {
              if (l(e, o) === l(t, -1 === d ? 0 : o - d)) {
                if (-1 === d && (d = o), o - d + 1 === c) return d * a;
              } else -1 !== d && (o -= o - d), d = -1;
            }
          } else for (n + c > s && (n = s - c), o = n; o >= 0; o--) {
            for (var u = !0, p = 0; p < c; p++) {
              if (l(e, o + p) !== l(t, p)) {
                u = !1;
                break;
              }
            }

            if (u) return o;
          }

          return -1;
        }

        function b(e, t, n, r) {
          n = Number(n) || 0;
          var i = e.length - n;
          r ? (r = Number(r)) > i && (r = i) : r = i;
          var o = t.length;
          if (o % 2 !== 0) throw new TypeError("Invalid hex string");
          r > o / 2 && (r = o / 2);

          for (var a = 0; a < r; ++a) {
            var s = parseInt(t.substr(2 * a, 2), 16);
            if (isNaN(s)) return a;
            e[n + a] = s;
          }

          return a;
        }

        function y(e, t, n, r) {
          return q(H(t, e.length - n), e, n, r);
        }

        function w(e, t, n, r) {
          return q(function (e) {
            for (var t = [], n = 0; n < e.length; ++n) {
              t.push(255 & e.charCodeAt(n));
            }

            return t;
          }(t), e, n, r);
        }

        function S(e, t, n, r) {
          return w(e, t, n, r);
        }

        function x(e, t, n, r) {
          return q(V(t), e, n, r);
        }

        function E(e, t, n, r) {
          return q(function (e, t) {
            for (var n, r, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
              r = (n = e.charCodeAt(a)) >> 8, i = n % 256, o.push(i), o.push(r);
            }

            return o;
          }(t, e.length - n), e, n, r);
        }

        function C(e, t, n) {
          return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
        }

        function k(e, t, n) {
          n = Math.min(e.length, n);

          for (var r = [], i = t; i < n;) {
            var o,
                a,
                s,
                c,
                l = e[i],
                d = null,
                u = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
            if (i + u <= n) switch (u) {
              case 1:
                l < 128 && (d = l);
                break;

              case 2:
                128 === (192 & (o = e[i + 1])) && (c = (31 & l) << 6 | 63 & o) > 127 && (d = c);
                break;

              case 3:
                o = e[i + 1], a = e[i + 2], 128 === (192 & o) && 128 === (192 & a) && (c = (15 & l) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (c < 55296 || c > 57343) && (d = c);
                break;

              case 4:
                o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 === (192 & o) && 128 === (192 & a) && 128 === (192 & s) && (c = (15 & l) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && c < 1114112 && (d = c);
            }
            null === d ? (d = 65533, u = 1) : d > 65535 && (d -= 65536, r.push(d >>> 10 & 1023 | 55296), d = 56320 | 1023 & d), r.push(d), i += u;
          }

          return function (e) {
            var t = e.length;
            if (t <= A) return String.fromCharCode.apply(String, e);
            var n = "",
                r = 0;

            for (; r < t;) {
              n += String.fromCharCode.apply(String, e.slice(r, r += A));
            }

            return n;
          }(r);
        }

        t.Buffer = c, t.SlowBuffer = function (e) {
          +e != e && (e = 0);
          return c.alloc(+e);
        }, t.INSPECT_MAX_BYTES = 50, c.TYPED_ARRAY_SUPPORT = void 0 !== n.g.TYPED_ARRAY_SUPPORT ? n.g.TYPED_ARRAY_SUPPORT : function () {
          try {
            var e = new Uint8Array(1);
            return e.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function foo() {
                return 42;
              }
            }, 42 === e.foo() && "function" === typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
          } catch (t) {
            return !1;
          }
        }(), t.kMaxLength = a(), c.poolSize = 8192, c._augment = function (e) {
          return e.__proto__ = c.prototype, e;
        }, c.from = function (e, t, n) {
          return l(null, e, t, n);
        }, c.TYPED_ARRAY_SUPPORT && (c.prototype.__proto__ = Uint8Array.prototype, c.__proto__ = Uint8Array, "undefined" !== typeof Symbol && Symbol.species && c[Symbol.species] === c && Object.defineProperty(c, Symbol.species, {
          value: null,
          configurable: !0
        })), c.alloc = function (e, t, n) {
          return function (e, t, n, r) {
            return d(t), t <= 0 ? s(e, t) : void 0 !== n ? "string" === typeof r ? s(e, t).fill(n, r) : s(e, t).fill(n) : s(e, t);
          }(null, e, t, n);
        }, c.allocUnsafe = function (e) {
          return u(null, e);
        }, c.allocUnsafeSlow = function (e) {
          return u(null, e);
        }, c.isBuffer = function (e) {
          return !(null == e || !e._isBuffer);
        }, c.compare = function (e, t) {
          if (!c.isBuffer(e) || !c.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
          if (e === t) return 0;

          for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) {
            if (e[i] !== t[i]) {
              n = e[i], r = t[i];
              break;
            }
          }

          return n < r ? -1 : r < n ? 1 : 0;
        }, c.isEncoding = function (e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;

            default:
              return !1;
          }
        }, c.concat = function (e, t) {
          if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === e.length) return c.alloc(0);
          var n;
          if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) {
            t += e[n].length;
          }
          var r = c.allocUnsafe(t),
              i = 0;

          for (n = 0; n < e.length; ++n) {
            var a = e[n];
            if (!c.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
            a.copy(r, i), i += a.length;
          }

          return r;
        }, c.byteLength = _, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
          var e = this.length;
          if (e % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

          for (var t = 0; t < e; t += 2) {
            m(this, t, t + 1);
          }

          return this;
        }, c.prototype.swap32 = function () {
          var e = this.length;
          if (e % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

          for (var t = 0; t < e; t += 4) {
            m(this, t, t + 3), m(this, t + 1, t + 2);
          }

          return this;
        }, c.prototype.swap64 = function () {
          var e = this.length;
          if (e % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

          for (var t = 0; t < e; t += 8) {
            m(this, t, t + 7), m(this, t + 1, t + 6), m(this, t + 2, t + 5), m(this, t + 3, t + 4);
          }

          return this;
        }, c.prototype.toString = function () {
          var e = 0 | this.length;
          return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : f.apply(this, arguments);
        }, c.prototype.equals = function (e) {
          if (!c.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          return this === e || 0 === c.compare(this, e);
        }, c.prototype.inspect = function () {
          var e = "",
              n = t.INSPECT_MAX_BYTES;
          return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
        }, c.prototype.compare = function (e, t, n, r, i) {
          if (!c.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
          if (r >= i && t >= n) return 0;
          if (r >= i) return -1;
          if (t >= n) return 1;
          if (this === e) return 0;

          for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), s = Math.min(o, a), l = this.slice(r, i), d = e.slice(t, n), u = 0; u < s; ++u) {
            if (l[u] !== d[u]) {
              o = l[u], a = d[u];
              break;
            }
          }

          return o < a ? -1 : a < o ? 1 : 0;
        }, c.prototype.includes = function (e, t, n) {
          return -1 !== this.indexOf(e, t, n);
        }, c.prototype.indexOf = function (e, t, n) {
          return g(this, e, t, n, !0);
        }, c.prototype.lastIndexOf = function (e, t, n) {
          return g(this, e, t, n, !1);
        }, c.prototype.write = function (e, t, n, r) {
          if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" === typeof t) r = t, n = this.length, t = 0;else {
            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
          }
          var i = this.length - t;
          if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          r || (r = "utf8");

          for (var o = !1;;) {
            switch (r) {
              case "hex":
                return b(this, e, t, n);

              case "utf8":
              case "utf-8":
                return y(this, e, t, n);

              case "ascii":
                return w(this, e, t, n);

              case "latin1":
              case "binary":
                return S(this, e, t, n);

              case "base64":
                return x(this, e, t, n);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return E(this, e, t, n);

              default:
                if (o) throw new TypeError("Unknown encoding: " + r);
                r = ("" + r).toLowerCase(), o = !0;
            }
          }
        }, c.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        var A = 4096;

        function I(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);

          for (var i = t; i < n; ++i) {
            r += String.fromCharCode(127 & e[i]);
          }

          return r;
        }

        function T(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);

          for (var i = t; i < n; ++i) {
            r += String.fromCharCode(e[i]);
          }

          return r;
        }

        function O(e, t, n) {
          var r = e.length;
          (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);

          for (var i = "", o = t; o < n; ++o) {
            i += B(e[o]);
          }

          return i;
        }

        function R(e, t, n) {
          for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) {
            i += String.fromCharCode(r[o] + 256 * r[o + 1]);
          }

          return i;
        }

        function N(e, t, n) {
          if (e % 1 !== 0 || e < 0) throw new RangeError("offset is not uint");
          if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
        }

        function P(e, t, n, r, i, o) {
          if (!c.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
          if (n + r > e.length) throw new RangeError("Index out of range");
        }

        function j(e, t, n, r) {
          t < 0 && (t = 65535 + t + 1);

          for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) {
            e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
          }
        }

        function D(e, t, n, r) {
          t < 0 && (t = 4294967295 + t + 1);

          for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) {
            e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
          }
        }

        function z(e, t, n, r, i, o) {
          if (n + r > e.length) throw new RangeError("Index out of range");
          if (n < 0) throw new RangeError("Index out of range");
        }

        function M(e, t, n, r, o) {
          return o || z(e, 0, n, 4), i.write(e, t, n, r, 23, 4), n + 4;
        }

        function L(e, t, n, r, o) {
          return o || z(e, 0, n, 8), i.write(e, t, n, r, 52, 8), n + 8;
        }

        c.prototype.slice = function (e, t) {
          var n,
              r = this.length;
          if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), c.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = c.prototype;else {
            var i = t - e;
            n = new c(i, void 0);

            for (var o = 0; o < i; ++o) {
              n[o] = this[o + e];
            }
          }
          return n;
        }, c.prototype.readUIntLE = function (e, t, n) {
          e |= 0, t |= 0, n || N(e, t, this.length);

          for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
            r += this[e + o] * i;
          }

          return r;
        }, c.prototype.readUIntBE = function (e, t, n) {
          e |= 0, t |= 0, n || N(e, t, this.length);

          for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) {
            r += this[e + --t] * i;
          }

          return r;
        }, c.prototype.readUInt8 = function (e, t) {
          return t || N(e, 1, this.length), this[e];
        }, c.prototype.readUInt16LE = function (e, t) {
          return t || N(e, 2, this.length), this[e] | this[e + 1] << 8;
        }, c.prototype.readUInt16BE = function (e, t) {
          return t || N(e, 2, this.length), this[e] << 8 | this[e + 1];
        }, c.prototype.readUInt32LE = function (e, t) {
          return t || N(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
        }, c.prototype.readUInt32BE = function (e, t) {
          return t || N(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
        }, c.prototype.readIntLE = function (e, t, n) {
          e |= 0, t |= 0, n || N(e, t, this.length);

          for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
            r += this[e + o] * i;
          }

          return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
        }, c.prototype.readIntBE = function (e, t, n) {
          e |= 0, t |= 0, n || N(e, t, this.length);

          for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) {
            o += this[e + --r] * i;
          }

          return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
        }, c.prototype.readInt8 = function (e, t) {
          return t || N(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
        }, c.prototype.readInt16LE = function (e, t) {
          t || N(e, 2, this.length);
          var n = this[e] | this[e + 1] << 8;
          return 32768 & n ? 4294901760 | n : n;
        }, c.prototype.readInt16BE = function (e, t) {
          t || N(e, 2, this.length);
          var n = this[e + 1] | this[e] << 8;
          return 32768 & n ? 4294901760 | n : n;
        }, c.prototype.readInt32LE = function (e, t) {
          return t || N(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
        }, c.prototype.readInt32BE = function (e, t) {
          return t || N(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
        }, c.prototype.readFloatLE = function (e, t) {
          return t || N(e, 4, this.length), i.read(this, e, !0, 23, 4);
        }, c.prototype.readFloatBE = function (e, t) {
          return t || N(e, 4, this.length), i.read(this, e, !1, 23, 4);
        }, c.prototype.readDoubleLE = function (e, t) {
          return t || N(e, 8, this.length), i.read(this, e, !0, 52, 8);
        }, c.prototype.readDoubleBE = function (e, t) {
          return t || N(e, 8, this.length), i.read(this, e, !1, 52, 8);
        }, c.prototype.writeUIntLE = function (e, t, n, r) {
          (e = +e, t |= 0, n |= 0, r) || P(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
          var i = 1,
              o = 0;

          for (this[t] = 255 & e; ++o < n && (i *= 256);) {
            this[t + o] = e / i & 255;
          }

          return t + n;
        }, c.prototype.writeUIntBE = function (e, t, n, r) {
          (e = +e, t |= 0, n |= 0, r) || P(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
          var i = n - 1,
              o = 1;

          for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
            this[t + i] = e / o & 255;
          }

          return t + n;
        }, c.prototype.writeUInt8 = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 1, 255, 0), c.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
        }, c.prototype.writeUInt16LE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : j(this, e, t, !0), t + 2;
        }, c.prototype.writeUInt16BE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : j(this, e, t, !1), t + 2;
        }, c.prototype.writeUInt32LE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : D(this, e, t, !0), t + 4;
        }, c.prototype.writeUInt32BE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : D(this, e, t, !1), t + 4;
        }, c.prototype.writeIntLE = function (e, t, n, r) {
          if (e = +e, t |= 0, !r) {
            var i = Math.pow(2, 8 * n - 1);
            P(this, e, t, n, i - 1, -i);
          }

          var o = 0,
              a = 1,
              s = 0;

          for (this[t] = 255 & e; ++o < n && (a *= 256);) {
            e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
          }

          return t + n;
        }, c.prototype.writeIntBE = function (e, t, n, r) {
          if (e = +e, t |= 0, !r) {
            var i = Math.pow(2, 8 * n - 1);
            P(this, e, t, n, i - 1, -i);
          }

          var o = n - 1,
              a = 1,
              s = 0;

          for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) {
            e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
          }

          return t + n;
        }, c.prototype.writeInt8 = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 1, 127, -128), c.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
        }, c.prototype.writeInt16LE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : j(this, e, t, !0), t + 2;
        }, c.prototype.writeInt16BE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : j(this, e, t, !1), t + 2;
        }, c.prototype.writeInt32LE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 4, 2147483647, -2147483648), c.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : D(this, e, t, !0), t + 4;
        }, c.prototype.writeInt32BE = function (e, t, n) {
          return e = +e, t |= 0, n || P(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : D(this, e, t, !1), t + 4;
        }, c.prototype.writeFloatLE = function (e, t, n) {
          return M(this, e, t, !0, n);
        }, c.prototype.writeFloatBE = function (e, t, n) {
          return M(this, e, t, !1, n);
        }, c.prototype.writeDoubleLE = function (e, t, n) {
          return L(this, e, t, !0, n);
        }, c.prototype.writeDoubleBE = function (e, t, n) {
          return L(this, e, t, !1, n);
        }, c.prototype.copy = function (e, t, n, r) {
          if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
          if (0 === e.length || 0 === this.length) return 0;
          if (t < 0) throw new RangeError("targetStart out of bounds");
          if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
          if (r < 0) throw new RangeError("sourceEnd out of bounds");
          r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
          var i,
              o = r - n;
          if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) {
            e[i + t] = this[i + n];
          } else if (o < 1e3 || !c.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
            e[i + t] = this[i + n];
          } else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
          return o;
        }, c.prototype.fill = function (e, t, n, r) {
          if ("string" === typeof e) {
            if ("string" === typeof t ? (r = t, t = 0, n = this.length) : "string" === typeof n && (r = n, n = this.length), 1 === e.length) {
              var i = e.charCodeAt(0);
              i < 256 && (e = i);
            }

            if (void 0 !== r && "string" !== typeof r) throw new TypeError("encoding must be a string");
            if ("string" === typeof r && !c.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
          } else "number" === typeof e && (e &= 255);

          if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
          if (n <= t) return this;
          var o;
          if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" === typeof e) for (o = t; o < n; ++o) {
            this[o] = e;
          } else {
            var a = c.isBuffer(e) ? e : H(new c(e, r).toString()),
                s = a.length;

            for (o = 0; o < n - t; ++o) {
              this[o + t] = a[o % s];
            }
          }
          return this;
        };
        var U = /[^+\/0-9A-Za-z-_]/g;

        function B(e) {
          return e < 16 ? "0" + e.toString(16) : e.toString(16);
        }

        function H(e, t) {
          var n;
          t = t || 1 / 0;

          for (var r = e.length, i = null, o = [], a = 0; a < r; ++a) {
            if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
              if (!i) {
                if (n > 56319) {
                  (t -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }

                if (a + 1 === r) {
                  (t -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }

                i = n;
                continue;
              }

              if (n < 56320) {
                (t -= 3) > -1 && o.push(239, 191, 189), i = n;
                continue;
              }

              n = 65536 + (i - 55296 << 10 | n - 56320);
            } else i && (t -= 3) > -1 && o.push(239, 191, 189);

            if (i = null, n < 128) {
              if ((t -= 1) < 0) break;
              o.push(n);
            } else if (n < 2048) {
              if ((t -= 2) < 0) break;
              o.push(n >> 6 | 192, 63 & n | 128);
            } else if (n < 65536) {
              if ((t -= 3) < 0) break;
              o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
            } else {
              if (!(n < 1114112)) throw new Error("Invalid code point");
              if ((t -= 4) < 0) break;
              o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
            }
          }

          return o;
        }

        function V(e) {
          return r.toByteArray(function (e) {
            if ((e = function (e) {
              return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
            }(e).replace(U, "")).length < 2) return "";

            for (; e.length % 4 !== 0;) {
              e += "=";
            }

            return e;
          }(e));
        }

        function q(e, t, n, r) {
          for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) {
            t[i + n] = e[i];
          }

          return i;
        }
      },
      78249: function _(e, t) {
        e.exports = function () {
          var e = e || function (e, t) {
            var n = Object.create || function () {
              function e() {}

              return function (t) {
                var n;
                return e.prototype = t, n = new e(), e.prototype = null, n;
              };
            }(),
                r = {},
                i = r.lib = {},
                o = i.Base = {
              extend: function extend(e) {
                var t = n(this);
                return e && t.mixIn(e), t.hasOwnProperty("init") && this.init !== t.init || (t.init = function () {
                  t.$super.init.apply(this, arguments);
                }), t.init.prototype = t, t.$super = this, t;
              },
              create: function create() {
                var e = this.extend();
                return e.init.apply(e, arguments), e;
              },
              init: function init() {},
              mixIn: function mixIn(e) {
                for (var t in e) {
                  e.hasOwnProperty(t) && (this[t] = e[t]);
                }

                e.hasOwnProperty("toString") && (this.toString = e.toString);
              },
              clone: function clone() {
                return this.init.prototype.extend(this);
              }
            },
                a = i.WordArray = o.extend({
              init: function init(e, n) {
                e = this.words = e || [], this.sigBytes = n != t ? n : 4 * e.length;
              },
              toString: function toString(e) {
                return (e || c).stringify(this);
              },
              concat: function concat(e) {
                var t = this.words,
                    n = e.words,
                    r = this.sigBytes,
                    i = e.sigBytes;
                if (this.clamp(), r % 4) for (var o = 0; o < i; o++) {
                  var a = n[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                  t[r + o >>> 2] |= a << 24 - (r + o) % 4 * 8;
                } else for (o = 0; o < i; o += 4) {
                  t[r + o >>> 2] = n[o >>> 2];
                }
                return this.sigBytes += i, this;
              },
              clamp: function clamp() {
                var t = this.words,
                    n = this.sigBytes;
                t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = e.ceil(n / 4);
              },
              clone: function clone() {
                var e = o.clone.call(this);
                return e.words = this.words.slice(0), e;
              },
              random: function random(t) {
                for (var n, r = [], i = function i(t) {
                  var n = 987654321,
                      r = 4294967295;
                  return function () {
                    var i = ((n = 36969 * (65535 & n) + (n >> 16) & r) << 16) + (t = 18e3 * (65535 & t) + (t >> 16) & r) & r;
                    return i /= 4294967296, (i += .5) * (e.random() > .5 ? 1 : -1);
                  };
                }, o = 0; o < t; o += 4) {
                  var s = i(4294967296 * (n || e.random()));
                  n = 987654071 * s(), r.push(4294967296 * s() | 0);
                }

                return new a.init(r, t);
              }
            }),
                s = r.enc = {},
                c = s.Hex = {
              stringify: function stringify(e) {
                for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
                  var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                  r.push((o >>> 4).toString(16)), r.push((15 & o).toString(16));
                }

                return r.join("");
              },
              parse: function parse(e) {
                for (var t = e.length, n = [], r = 0; r < t; r += 2) {
                  n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
                }

                return new a.init(n, t / 2);
              }
            },
                l = s.Latin1 = {
              stringify: function stringify(e) {
                for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
                  var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                  r.push(String.fromCharCode(o));
                }

                return r.join("");
              },
              parse: function parse(e) {
                for (var t = e.length, n = [], r = 0; r < t; r++) {
                  n[r >>> 2] |= (255 & e.charCodeAt(r)) << 24 - r % 4 * 8;
                }

                return new a.init(n, t);
              }
            },
                d = s.Utf8 = {
              stringify: function stringify(e) {
                try {
                  return decodeURIComponent(escape(l.stringify(e)));
                } catch (t) {
                  throw new Error("Malformed UTF-8 data");
                }
              },
              parse: function parse(e) {
                return l.parse(unescape(encodeURIComponent(e)));
              }
            },
                u = i.BufferedBlockAlgorithm = o.extend({
              reset: function reset() {
                this._data = new a.init(), this._nDataBytes = 0;
              },
              _append: function _append(e) {
                "string" == typeof e && (e = d.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes;
              },
              _process: function _process(t) {
                var n = this._data,
                    r = n.words,
                    i = n.sigBytes,
                    o = this.blockSize,
                    s = i / (4 * o),
                    c = (s = t ? e.ceil(s) : e.max((0 | s) - this._minBufferSize, 0)) * o,
                    l = e.min(4 * c, i);

                if (c) {
                  for (var d = 0; d < c; d += o) {
                    this._doProcessBlock(r, d);
                  }

                  var u = r.splice(0, c);
                  n.sigBytes -= l;
                }

                return new a.init(u, l);
              },
              clone: function clone() {
                var e = o.clone.call(this);
                return e._data = this._data.clone(), e;
              },
              _minBufferSize: 0
            }),
                p = (i.Hasher = u.extend({
              cfg: o.extend(),
              init: function init(e) {
                this.cfg = this.cfg.extend(e), this.reset();
              },
              reset: function reset() {
                u.reset.call(this), this._doReset();
              },
              update: function update(e) {
                return this._append(e), this._process(), this;
              },
              finalize: function finalize(e) {
                return e && this._append(e), this._doFinalize();
              },
              blockSize: 16,
              _createHelper: function _createHelper(e) {
                return function (t, n) {
                  return new e.init(n).finalize(t);
                };
              },
              _createHmacHelper: function _createHmacHelper(e) {
                return function (t, n) {
                  return new p.HMAC.init(e, n).finalize(t);
                };
              }
            }), r.algo = {});

            return r;
          }(Math);

          return e;
        }();
      },
      98269: function _(e, t, n) {
        !function (t, r) {
          var i;
          e.exports = (i = n(78249), function () {
            var e = i,
                t = e.lib.WordArray;

            function n(e, n, r) {
              for (var i = [], o = 0, a = 0; a < n; a++) {
                if (a % 4) {
                  var s = r[e.charCodeAt(a - 1)] << a % 4 * 2,
                      c = r[e.charCodeAt(a)] >>> 6 - a % 4 * 2;
                  i[o >>> 2] |= (s | c) << 24 - o % 4 * 8, o++;
                }
              }

              return t.create(i, o);
            }

            e.enc.Base64 = {
              stringify: function stringify(e) {
                var t = e.words,
                    n = e.sigBytes,
                    r = this._map;
                e.clamp();

                for (var i = [], o = 0; o < n; o += 3) {
                  for (var a = (t[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (t[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | t[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, s = 0; s < 4 && o + .75 * s < n; s++) {
                    i.push(r.charAt(a >>> 6 * (3 - s) & 63));
                  }
                }

                var c = r.charAt(64);
                if (c) for (; i.length % 4;) {
                  i.push(c);
                }
                return i.join("");
              },
              parse: function parse(e) {
                var t = e.length,
                    r = this._map,
                    i = this._reverseMap;

                if (!i) {
                  i = this._reverseMap = [];

                  for (var o = 0; o < r.length; o++) {
                    i[r.charCodeAt(o)] = o;
                  }
                }

                var a = r.charAt(64);

                if (a) {
                  var s = e.indexOf(a);
                  -1 !== s && (t = s);
                }

                return n(e, t, i);
              },
              _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
            };
          }(), i.enc.Base64);
        }();
      },
      88010: function _(e, t, n) {
        !function (t, r, i) {
          var o;
          e.exports = (o = n(78249), n(52153), n(89824), o.HmacSHA256);
        }();
      },
      89824: function _(e, t, n) {
        !function (t, r) {
          var i;
          e.exports = (i = n(78249), void function () {
            var e = i,
                t = e.lib.Base,
                n = e.enc.Utf8;
            e.algo.HMAC = t.extend({
              init: function init(e, t) {
                e = this._hasher = new e.init(), "string" == typeof t && (t = n.parse(t));
                var r = e.blockSize,
                    i = 4 * r;
                t.sigBytes > i && (t = e.finalize(t)), t.clamp();

                for (var o = this._oKey = t.clone(), a = this._iKey = t.clone(), s = o.words, c = a.words, l = 0; l < r; l++) {
                  s[l] ^= 1549556828, c[l] ^= 909522486;
                }

                o.sigBytes = a.sigBytes = i, this.reset();
              },
              reset: function reset() {
                var e = this._hasher;
                e.reset(), e.update(this._iKey);
              },
              update: function update(e) {
                return this._hasher.update(e), this;
              },
              finalize: function finalize(e) {
                var t = this._hasher,
                    n = t.finalize(e);
                return t.reset(), t.finalize(this._oKey.clone().concat(n));
              }
            });
          }());
        }();
      },
      52153: function _(e, t, n) {
        !function (t, r) {
          var i;
          e.exports = (i = n(78249), function (e) {
            var t = i,
                n = t.lib,
                r = n.WordArray,
                o = n.Hasher,
                a = t.algo,
                s = [],
                c = [];
            !function () {
              function t(t) {
                for (var n = e.sqrt(t), r = 2; r <= n; r++) {
                  if (!(t % r)) return !1;
                }

                return !0;
              }

              function n(e) {
                return 4294967296 * (e - (0 | e)) | 0;
              }

              for (var r = 2, i = 0; i < 64;) {
                t(r) && (i < 8 && (s[i] = n(e.pow(r, .5))), c[i] = n(e.pow(r, 1 / 3)), i++), r++;
              }
            }();
            var l = [],
                d = a.SHA256 = o.extend({
              _doReset: function _doReset() {
                this._hash = new r.init(s.slice(0));
              },
              _doProcessBlock: function _doProcessBlock(e, t) {
                for (var n = this._hash.words, r = n[0], i = n[1], o = n[2], a = n[3], s = n[4], d = n[5], u = n[6], p = n[7], h = 0; h < 64; h++) {
                  if (h < 16) l[h] = 0 | e[t + h];else {
                    var _ = l[h - 15],
                        f = (_ << 25 | _ >>> 7) ^ (_ << 14 | _ >>> 18) ^ _ >>> 3,
                        m = l[h - 2],
                        g = (m << 15 | m >>> 17) ^ (m << 13 | m >>> 19) ^ m >>> 10;
                    l[h] = f + l[h - 7] + g + l[h - 16];
                  }
                  var v = r & i ^ r & o ^ i & o,
                      b = (r << 30 | r >>> 2) ^ (r << 19 | r >>> 13) ^ (r << 10 | r >>> 22),
                      y = p + ((s << 26 | s >>> 6) ^ (s << 21 | s >>> 11) ^ (s << 7 | s >>> 25)) + (s & d ^ ~s & u) + c[h] + l[h];
                  p = u, u = d, d = s, s = a + y | 0, a = o, o = i, i = r, r = y + (b + v) | 0;
                }

                n[0] = n[0] + r | 0, n[1] = n[1] + i | 0, n[2] = n[2] + o | 0, n[3] = n[3] + a | 0, n[4] = n[4] + s | 0, n[5] = n[5] + d | 0, n[6] = n[6] + u | 0, n[7] = n[7] + p | 0;
              },
              _doFinalize: function _doFinalize() {
                var t = this._data,
                    n = t.words,
                    r = 8 * this._nDataBytes,
                    i = 8 * t.sigBytes;
                return n[i >>> 5] |= 128 << 24 - i % 32, n[14 + (i + 64 >>> 9 << 4)] = e.floor(r / 4294967296), n[15 + (i + 64 >>> 9 << 4)] = r, t.sigBytes = 4 * n.length, this._process(), this._hash;
              },
              clone: function clone() {
                var e = o.clone.call(this);
                return e._hash = this._hash.clone(), e;
              }
            });
            t.SHA256 = o._createHelper(d), t.HmacSHA256 = o._createHmacHelper(d);
          }(Math), i.SHA256);
        }();
      },
      80645: function _(e, t) {
        t.read = function (e, t, n, r, i) {
          var o,
              a,
              s = 8 * i - r - 1,
              c = (1 << s) - 1,
              l = c >> 1,
              d = -7,
              u = n ? i - 1 : 0,
              p = n ? -1 : 1,
              h = e[t + u];

          for (u += p, o = h & (1 << -d) - 1, h >>= -d, d += s; d > 0; o = 256 * o + e[t + u], u += p, d -= 8) {
            ;
          }

          for (a = o & (1 << -d) - 1, o >>= -d, d += r; d > 0; a = 256 * a + e[t + u], u += p, d -= 8) {
            ;
          }

          if (0 === o) o = 1 - l;else {
            if (o === c) return a ? NaN : 1 / 0 * (h ? -1 : 1);
            a += Math.pow(2, r), o -= l;
          }
          return (h ? -1 : 1) * a * Math.pow(2, o - r);
        }, t.write = function (e, t, n, r, i, o) {
          var a,
              s,
              c,
              l = 8 * o - i - 1,
              d = (1 << l) - 1,
              u = d >> 1,
              p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              h = r ? 0 : o - 1,
              _ = r ? 1 : -1,
              f = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

          for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = d) : (a = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), (t += a + u >= 1 ? p / c : p * Math.pow(2, 1 - u)) * c >= 2 && (a++, c /= 2), a + u >= d ? (s = 0, a = d) : a + u >= 1 ? (s = (t * c - 1) * Math.pow(2, i), a += u) : (s = t * Math.pow(2, u - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + h] = 255 & s, h += _, s /= 256, i -= 8) {
            ;
          }

          for (a = a << i | s, l += i; l > 0; e[n + h] = 255 & a, h += _, a /= 256, l -= 8) {
            ;
          }

          e[n + h - _] |= 128 * f;
        };
      },
      5826: function _(e) {
        var t = {}.toString;

        e.exports = Array.isArray || function (e) {
          return "[object Array]" == t.call(e);
        };
      },
      19575: function _(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__, global, factory;

        global = "undefined" !== typeof self ? self : "undefined" !== typeof window ? window : "undefined" !== typeof __webpack_require__.g ? __webpack_require__.g : this, factory = function factory(global) {
          "use strict";

          global = global || {};
          var _Base64 = global.Base64,
              version = "2.5.1",
              buffer;
          if (module.exports) try {
            buffer = eval("require('buffer').Buffer");
          } catch (err) {
            buffer = void 0;
          }

          var b64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
              b64tab = function (e) {
            for (var t = {}, n = 0, r = e.length; n < r; n++) {
              t[e.charAt(n)] = n;
            }

            return t;
          }(b64chars),
              fromCharCode = String.fromCharCode,
              cb_utob = function cb_utob(e) {
            if (e.length < 2) return (t = e.charCodeAt(0)) < 128 ? e : t < 2048 ? fromCharCode(192 | t >>> 6) + fromCharCode(128 | 63 & t) : fromCharCode(224 | t >>> 12 & 15) + fromCharCode(128 | t >>> 6 & 63) + fromCharCode(128 | 63 & t);
            var t = 65536 + 1024 * (e.charCodeAt(0) - 55296) + (e.charCodeAt(1) - 56320);
            return fromCharCode(240 | t >>> 18 & 7) + fromCharCode(128 | t >>> 12 & 63) + fromCharCode(128 | t >>> 6 & 63) + fromCharCode(128 | 63 & t);
          },
              re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g,
              utob = function utob(e) {
            return e.replace(re_utob, cb_utob);
          },
              cb_encode = function cb_encode(e) {
            var t = [0, 2, 1][e.length % 3],
                n = e.charCodeAt(0) << 16 | (e.length > 1 ? e.charCodeAt(1) : 0) << 8 | (e.length > 2 ? e.charCodeAt(2) : 0);
            return [b64chars.charAt(n >>> 18), b64chars.charAt(n >>> 12 & 63), t >= 2 ? "=" : b64chars.charAt(n >>> 6 & 63), t >= 1 ? "=" : b64chars.charAt(63 & n)].join("");
          },
              btoa = global.btoa ? function (e) {
            return global.btoa(e);
          } : function (e) {
            return e.replace(/[\s\S]{1,3}/g, cb_encode);
          },
              _encode = buffer ? buffer.from && Uint8Array && buffer.from !== Uint8Array.from ? function (e) {
            return (e.constructor === buffer.constructor ? e : buffer.from(e)).toString("base64");
          } : function (e) {
            return (e.constructor === buffer.constructor ? e : new buffer(e)).toString("base64");
          } : function (e) {
            return btoa(utob(e));
          },
              encode = function encode(e, t) {
            return t ? _encode(String(e)).replace(/[+\/]/g, function (e) {
              return "+" == e ? "-" : "_";
            }).replace(/=/g, "") : _encode(String(e));
          },
              encodeURI = function encodeURI(e) {
            return encode(e, !0);
          },
              re_btou = new RegExp(["[\xc0-\xdf][\x80-\xbf]", "[\xe0-\xef][\x80-\xbf]{2}", "[\xf0-\xf7][\x80-\xbf]{3}"].join("|"), "g"),
              cb_btou = function cb_btou(e) {
            switch (e.length) {
              case 4:
                var t = ((7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3)) - 65536;
                return fromCharCode(55296 + (t >>> 10)) + fromCharCode(56320 + (1023 & t));

              case 3:
                return fromCharCode((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));

              default:
                return fromCharCode((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
            }
          },
              btou = function btou(e) {
            return e.replace(re_btou, cb_btou);
          },
              cb_decode = function cb_decode(e) {
            var t = e.length,
                n = t % 4,
                r = (t > 0 ? b64tab[e.charAt(0)] << 18 : 0) | (t > 1 ? b64tab[e.charAt(1)] << 12 : 0) | (t > 2 ? b64tab[e.charAt(2)] << 6 : 0) | (t > 3 ? b64tab[e.charAt(3)] : 0),
                i = [fromCharCode(r >>> 16), fromCharCode(r >>> 8 & 255), fromCharCode(255 & r)];
            return i.length -= [0, 0, 2, 1][n], i.join("");
          },
              _atob = global.atob ? function (e) {
            return global.atob(e);
          } : function (e) {
            return e.replace(/\S{1,4}/g, cb_decode);
          },
              atob = function atob(e) {
            return _atob(String(e).replace(/[^A-Za-z0-9\+\/]/g, ""));
          },
              _decode = buffer ? buffer.from && Uint8Array && buffer.from !== Uint8Array.from ? function (e) {
            return (e.constructor === buffer.constructor ? e : buffer.from(e, "base64")).toString();
          } : function (e) {
            return (e.constructor === buffer.constructor ? e : new buffer(e, "base64")).toString();
          } : function (e) {
            return btou(_atob(e));
          },
              decode = function decode(e) {
            return _decode(String(e).replace(/[-_]/g, function (e) {
              return "-" == e ? "+" : "/";
            }).replace(/[^A-Za-z0-9\+\/]/g, ""));
          },
              noConflict = function noConflict() {
            var e = global.Base64;
            return global.Base64 = _Base64, e;
          };

          if (global.Base64 = {
            VERSION: version,
            atob: atob,
            btoa: btoa,
            fromBase64: decode,
            toBase64: encode,
            utob: utob,
            encode: encode,
            encodeURI: encodeURI,
            btou: btou,
            decode: decode,
            noConflict: noConflict,
            __buffer__: buffer
          }, "function" === typeof Object.defineProperty) {
            var noEnum = function noEnum(e) {
              return {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              };
            };

            global.Base64.extendString = function () {
              Object.defineProperty(String.prototype, "fromBase64", noEnum(function () {
                return decode(this);
              })), Object.defineProperty(String.prototype, "toBase64", noEnum(function (e) {
                return encode(this, e);
              })), Object.defineProperty(String.prototype, "toBase64URI", noEnum(function () {
                return encode(this, !0);
              }));
            };
          }

          return global.Meteor && (Base64 = global.Base64), module.exports ? module.exports.Base64 = global.Base64 : (__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return global.Base64;
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), void 0 === __WEBPACK_AMD_DEFINE_RESULT__ || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)), {
            Base64: global.Base64
          };
        }, module.exports = factory(global);
      },
      45840: function _(e) {
        "use strict";

        e.exports = __WEBPACK_EXTERNAL_MODULE__45840__;
      },
      78768: function _(e) {
        "use strict";

        e.exports = __WEBPACK_EXTERNAL_MODULE__78768__;
      }
    },
        __webpack_module_cache__ = {};

    function __webpack_require__(e) {
      var t = __webpack_module_cache__[e];
      if (void 0 !== t) return t.exports;
      var n = __webpack_module_cache__[e] = {
        exports: {}
      };
      return __webpack_modules__[e].call(n.exports, n, n.exports, __webpack_require__), n.exports;
    }

    __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return __webpack_require__.d(t, {
        a: t
      }), t;
    }, __webpack_require__.d = function (e, t) {
      for (var n in t) {
        __webpack_require__.o(t, n) && !__webpack_require__.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, __webpack_require__.g = function () {
      if ("object" === typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" === typeof window) return window;
      }
    }(), __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var __webpack_exports__ = {};
    return function () {
      "use strict";

      __webpack_require__.r(__webpack_exports__);

      __webpack_require__(19575), __webpack_require__(88010), __webpack_require__(98269);

      var e = __webpack_require__(35859),
          t = __webpack_require__.n(e);

      "undefined" !== typeof window && (window.ZoomMtgEmbedded = t()), __webpack_exports__.default = t();
    }(), __webpack_exports__;
  }();
});